(function () {
    angular.module("burWood", [
        "ngTimeline",
        "envConfig",
        "ngCookies",
        "ngAnimate",
        "ui.router",
        "ui.bootstrap",
        "anim-in-out",
        "datatables",
        "datatables.columnfilter",
        "ngFileUpload",
        "ngFileSaver",
        "720kb.tooltips",
        "daterangepicker",
        "angulartics",
        "angulartics.google.analytics",
        "duScroll",
        "ui.sortable",
        "dualmultiselect",
        "angularMoment",
        "ui.toggle",
        "underscore",
        "datatables.buttons",
        "ui.bootstrap",
        "ui.bootstrap.datetimepicker",
        "rzSlider",
        "moment-picker",
        "ui.calendar",
        "ngDropdowns",
        "hc.marked",
        "ngIdle"
    ]);

    let initInjector = angular.injector(["ng"]);
    let $http = initInjector.get("$http");

    let userEndpoint;
    let options;
    if (window.location.hostname === "localhost") {
        userEndpoint = "/user_info";
        options = {
            withCredentials: true
        };
    } else {
        userEndpoint = "https://api." + window.location.hostname + "/user_info";
        options = {
            withCredentials: true
        };
    }

    $http.get(userEndpoint, options).then((response) => {
        angular.module("burWood").constant("user_info", response.data);
        angular.element(document).ready(() => {
            angular.bootstrap(document, ["burWood"]);
        });
    });
})();

(function () {
    angular.module("burWood").factory("Alerts", Alerts);

    function Alerts(Server) {
        return {
            storeAlert: (alert, callback) => {
                Server.postData(alert, "/store_alert", callback);
            }
        };
    }
})();

(function () {
    angular.module("burWood").factory("util", util);

    /** @ngInject */
    function util(_, moment) {
        let utilFunctions = {
            searchArrayOfObjects: (array, value) => {
                let returnObj;
                array.forEach((item) => {
                    let foundObj = utilFunctions.searchObject(item, value);
                    if (foundObj) {
                        returnObj = foundObj;
                    }
                });
                return returnObj;
            },
            searchObject: (item, value) => {
                let foundObj;
                if (!item) {
                    return;
                }
                Object.keys(item).forEach((key) => {
                    if (angular.isObject(item[key])) {
                        utilFunctions.searchObject(item[key], value);
                    }
                    if (item[key] === value) {
                        foundObj = item;
                    }
                });
                return foundObj;
            },
            compare: (field) => {
                return (a, b) => {
                    if (a[field] && b[field]) {
                        if (a[field].toLowerCase() < b[field].toLowerCase()) {
                            return -1;
                        }
                        if (a[field].toLowerCase() > b[field].toLowerCase()) {
                            return 1;
                        }
                    }
                    return 0;
                };
            },
            getDaysInMonth: (year, month) => {
                return new Date(year, month, 0).getDate();
            },
            addMonths: (input, months) => {
                let date = new Date(input);
                date.setDate(1);
                date.setMonth(date.getMonth() + months);
                date.setDate(
                    Math.min(input.getDate(), utilFunctions.getDaysInMonth(date.getFullYear(), date.getMonth() + 1))
                );
                return moment(date).format("YYYY-MM-DD");
            },
            capitalizeFirstLetter: (string) => {
                if (string && angular.isString(string)) {
                    return string.replace(/\b\w/g, (l) => {
                        return l.toUpperCase();
                    });
                } else {
                    return "";
                }
            },
            formatPercent: (percent) => {
                percent ? (percent = percent.replace(/[^\d\.]*/g, "") + "%") : null;
                return percent;
            },
            formatCurrencyAsNumber: (currency) => {
                let formattedCurrency;
                currency && angular.isString(currency) && (formattedCurrency = Number(currency.replace(/ |\$|,/g, "")));
                return formattedCurrency || 0;
            },
            numberWithCommas: (x) => {
                if (x && isNaN(x) === false) {
                    return Number(x)
                        .toFixed(2)
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    return x;
                }
            },
            findItem: (value, list, key) => {
                let query = {};
                query[key] = value;
                return _.findWhere(list, query);
            },
            padNumbers: (num, size) => {
                let s = num + "";
                while (s.length < size) s = "0" + s;
                return s;
            },
            getMonthList: () => {
                return [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ];
            },
            getYearList: () => {
                let d = new Date("01 " + "January 2019");
                let first = d.getFullYear();

                let s = new Date();
                let second = s.getFullYear();
                let arr = Array();

                for (let i = first; i <= second; i++) arr.push(i);

                return arr;
            },
            sortItems: (items, field, order, date) => {
                if (!items) {
                    return [];
                }
                order === "ASC" ? (order = -1) : (order = 1);
                items.sort((a, b) => {
                    if (a && b) {
                        let aField = a[field];
                        let bField = b[field];

                        if (aField && bField) {
                            if (date) {
                                aField = new Date(aField);
                                bField = new Date(bField);
                            } else {
                                aField = aField.toLowerCase();
                                bField = bField.toLowerCase();
                            }
                            if (aField < bField) {
                                return order;
                            }
                            if (aField > bField) {
                                return -order;
                            }
                        }
                    }

                    return 0;
                });
                return items;
            }
        };
        return utilFunctions;
    }
})();

(function () {
    "use strict";

    angular.module("burWood").factory("mircoserviceUtil", mircoserviceUtil);

    /** @ngInject */
    function mircoserviceUtil(
        reactEndpoint,
        $sce,
        user_info,
        $window,
        $document,
        $timeout,
        $log,
        $state,
        $transitions
    ) {
        let microserviceFunctions = {
            trustSRC: (src) => {
                return $sce.trustAsResourceUrl(src);
            },
            addReactListener: (callback) => {
                return (e) => {
                    const key = e.message ? "message" : "data";
                    let data = e[key];
                    callback(data);
                };
            },
            loadReactIframe: (iframe) => {
                iframe.contentWindow.postMessage(
                    {
                        data: "Message Loaded From AngularJS"
                    },
                    reactEndpoint
                );
            },
            initIframeConnection: (state, callback) => {
                var eventMethod = $window.addEventListener ? "addEventListener" : "attachEvent";
                var eventer = $window[eventMethod];
                var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

                var iframe = $document[0].getElementById("micro-frontend-container");

                iframe.addEventListener("load", () => {
                    $timeout(() => {
                        microserviceFunctions.loadReactIframe(iframe);
                        eventer(messageEvent, microserviceFunctions.addReactListener(callback), false);
                    }, 10);
                });

                microserviceFunctions.windowIframeUnload(state, messageEvent, callback);
                microserviceFunctions.transitionIframeUnload(messageEvent, callback);
            },
            windowIframeUnload: (state, messageEvent, callback) => {
                return $window.addEventListener(
                    "beforeunload",
                    () => {
                        if ($state.current.name === state) {
                            $window.removeEventListener(
                                messageEvent,
                                microserviceFunctions.addReactListener(callback),
                                false
                            );
                            return;
                        }
                    },
                    false
                );
            },
            transitionIframeUnload: (messageEvent, callback) => {
                $transitions.onBefore({}, () => {
                    $window.removeEventListener(messageEvent, microserviceFunctions.addReactListener(callback), false);
                });
            }
        };
        return microserviceFunctions;
    }
})();

(function () {
    "use strict";

    angular.module("burWood").directive("multiCheckbox", function () {
        return {
            restrict: "A",
            require: ["^^multiCheckboxContainer", "ngModel"],
            link: function (scope, element, attrs, controllers) {
                var containerCtrl = controllers[0];
                var ngModelCtrl = controllers[1];
                containerCtrl.addCheckbox(element, ngModelCtrl);

                element.on("click", function (ev) {
                    containerCtrl.onCheckboxClick(element, ev.shiftKey, ev.ctrlKey);
                });
            }
        };
    });
})();

(function () {
  'use strict';

  angular
    .module('burWood')
    .directive('loading', loading)

  /** @ngInject */
  function loading() {
    return {
      replace: true,
      restrict: 'E',
      templateUrl: 'app/shared/html/loading.html'
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('burWood')
        .directive('downloadFile', downloadFile)

    /** @ngInject */
    function downloadFile() {
        return {
            restrict: 'E',
            templateUrl: 'app/shared/html/downloadfile.html',
            scope: true,
            controller: function($stateParams, $scope, $http, $window, $q, FileSaver, Blob, Status, $log) {
                var vm = this;
                var statusID = $stateParams.statusID;
                vm.download = function() {
                    Status.getHistory(statusID, function(data){
                        vm.related_loading = false;
                        var statusObj = {
                          info:  angular.fromJson($window.sessionStorage.getItem("jsonData")),
                          activity: data.result
                        };
                        $scope.$emit('download-start');
                        $http(
                            {
                              method: 'POST',
                              cache: false,
                              url: '/download',
                              responseType:'arraybuffer',
                              data: statusObj
                            })
                            .then(function(response) {
                              $log("Success: " + response.data);
                              FileSaver.saveAs(new Blob([response.data],{type:"application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8"}), "report.docx");
                        });
                    }, 300, 0);
                };
            },
            controllerAs: 'vm',
            bindToController: true
        }
    }
})();

// Custom directive for autocompleter on forms utilizing devbridgeAutocomplete library

(function () {
    "use strict";

    angular.module("burWood").directive("autocompleter", autocomplete);

    /** @ngInject */
    function autocomplete() {
        return {
            restrict: "A",
            require: "ngModel",
            scope: {
                suggestions: "=",
                suggestionclass: "=",
                suggestionsclass: "=",
                notice: "="
            },
            link: function (scope, elem, attrs, ctrl) {
                angular.element(elem).devbridgeAutocomplete({
                    lookup: scope.suggestions,
                    minChars: 0,
                    // showNoSuggestionNotice: true,
                    // noSuggestionNotice: '<div class="autocomplete-suggestion">' + scope.notice + '</div>',
                    triggerSelectOnValidInput: true,
                    width: "150px",
                    onSelect: function () {
                        update();
                    },
                    beforeRender: function () {
                        if (scope.suggestionclass) {
                            angular.element(".autocomplete-suggestion").addClass(scope.suggestionclass);
                        }
                        if (scope.suggestionsclass) {
                            angular.element(".autocomplete-suggestions").addClass(scope.suggestionsclass);
                        }
                    },
                    onSearchStart: function () {
                        angular.element(".fa.fa-search").addClass("blinking");
                    },
                    onSearchComplete: function () {
                        angular.element(".fa.fa-search").removeClass("blinking");
                    }
                });

                elem.on("blur", function () {
                    update();
                });

                var update = function () {
                    var value = elem[0].value;

                    scope.$apply(function () {
                        ctrl.$setViewValue(value);
                        ctrl.$render();
                    });
                };
            }
        };
    }
})();

(function () {
    angular.module("burWood").controller("TicketRedirectController", TicketRedirectController);

    /** @ngInject */
    function TicketRedirectController($uibModalInstance, $state, ticket, field, route) {
        let vm = this;
        vm.number = ticket.number;
        let query = {};
        query[field] = ticket.sys_id;
        vm.close = () => {
            $uibModalInstance.dismiss("cancel");
            $state.go(`index.${route}`, query);
        };
    }
})();

(function () {

    angular.module("burWood").controller("DeviceListController", DeviceListController);

    /** @ngInject */
    function DeviceListController(user_info, $uibModalInstance, Devices, DTOptionsBuilder) {
        let vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions().withOption("responsive", true);
        vm.loading = true;
        vm.addtolist = (name, device_id) => {
            let data = {
                name: name,
                device_id: device_id
            };
            $uibModalInstance.close(data);
        };
        vm.close = () => {
            $uibModalInstance.dismiss("cancel");
        };
        Devices.getDeviceView((data) => {
            vm.loading = false;
            if (data.error) {
                vm.total_result = 0;
                vm.devices = [];
            } else {
                vm.total_result = data.count;
                vm.devices = data.results;
            }
        }, user_info.company);
    }

})();
(function () {
    "use strict";

    angular.module("burWood").controller("ContactController", ContactController);

    /** @ngInject */
    function ContactController(user_info, $uibModalInstance, BoH, DTOptionsBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions().withOption("responsive", true);
        vm.loading = true;
        vm.current_page = parseInt(offset) / 10 + 1;

        var offset = 0,
            page = 1000;
        // var user_info = angular.fromJson($cookies.get("user_info"));

        vm.addtolist = function (name, caller_id, email) {
            var data = {
                name: name,
                email: email,
                caller_id: caller_id
            };
            $uibModalInstance.close(data);
        };

        vm.page_changed = function () {
            vm.loading = true;
            vm.offset = parseInt(vm.current_page - 1) * page;
            BoH.getCompanyUser(
                function (data) {
                    vm.loading = false;
                    if (data.error) {
                        vm.total_result = 0;
                        vm.users = [];
                    } else {
                        vm.total_result = data.count;
                        vm.users = data.results;
                    }
                },
                user_info.company,
                page,
                vm.offset,
                "sys_user|userListSlim"
            );
        };

        vm.close = function () {
            $uibModalInstance.dismiss("cancel");
        };

        BoH.getCompanyUser(
            function (data) {
                vm.loading = false;
                if (data.error) {
                    vm.total_result = 0;
                    vm.users = [];
                } else {
                    vm.total_result = data.count;
                    vm.users = data.results;
                }
            },
            user_info.company,
            page,
            offset
        );
    }

})();
(function () {
    angular.module("burWood").controller("ConfirmationController", ConfirmationController);

    /** @ngInject */
    function ConfirmationController($uibModalInstance, message) {
        let vm = this;
        vm.heading = message.heading || "";
        vm.message = message.message || "";
        vm.loading = message.loading || false;
        vm.confirmMessage = "Yes";
        vm.denyMessage = "No";
        vm.close = () => {
            $uibModalInstance.dismiss("cancel");
        };
    }
})();

(function () {

    angular.module("burWood").controller("CompanyListController", CompanyListController);

    /** @ngInject */
    function CompanyListController($uibModalInstance, Navbar, _) {
        let vm = this;
        vm.loading = true;
        vm.searchTerm = "";
        vm.options = {};
        vm.options.items = [];

        vm.select = (company) => {
            vm.searchTerm = company;
        };

        //get list of avaialable companies by querying contracts - add Burwood and BCS after
        Navbar.getCompanyList((companies) => {
            let companyArr = [];
            let unsorted = [];
            for (let x = 0; x < companies.results.length; x++) {
                companyArr.push({
                    company: companies.results[x]["company.name"],
                    sys_id: companies.results[x]["company.sys_id"]
                });
            }
            companyArr.push(
                {
                    company: "Burwood Group",
                    sys_id: "c94993314a362312005cfc20c1aa15d2"
                },
                {
                    company: "Burwood Cloud Services",
                    sys_id: "8d8073014f8d0300d227d48e5210c785"
                }
            );
            unsorted = _.uniq(companyArr, (p) => {
                return p.sys_id;
            });
            vm.options.items = _.sortBy(unsorted, (o) => {
                return o.company.toLowerCase();
            });
        });

        vm.close = () => {
            $uibModalInstance.close(vm.searchTerm);
        };
    }

})();
(function () {
    angular.module("burWood").controller("AttachmentController", AttachmentController);

    /** @ngInject */
    function AttachmentController($uibModalInstance, ServiceNow, $stateParams, $state, list, params, FileSaver, Blob) {
        let vm = this;

        if ($state.current.name === `index.${params.newTable}`) {
            vm.newTicket = true;
        }
        let ticketID = $stateParams[params.fieldID];
        var page_size = 10;

        vm.attachments = list;
        vm.uploading = false;
        vm.loading = false;

        let reloadData = () => {
            vm.loading = true;
            ServiceNow.getAllAttachment(ticketID, params.table, page_size, page_size, (data) => {
                vm.attachments = data.result;
                vm.loading = false;
            });
        };

        vm.downloadAttachment = (attachment) => {
            vm.loading = true;
            ServiceNow.getAttachment(attachment.sys_id, (data) => {
                if (data) {
                    let blobData = new Blob([data], {
                        type: attachment.content_type
                    });
                    FileSaver.saveAs(blobData, attachment.file_name);
                }
                vm.loading = false;
            });
        };

        vm.addAttachment = () => {
            if (!vm.newTicket) {
                vm.uploading = true;
                if (vm.upload_file != undefined && vm.upload_file != null) {
                    ServiceNow.addAttachment(ticketID, params.table, [vm.upload_file], () => {
                        vm.upload_file = null;
                        vm.uploading = false;
                        reloadData();
                    });
                }
            } else if (vm.newTicket) {
                vm.attachments.push(vm.upload_file);
            }
        };

        vm.deleteAttachment = (attachment) => {
            if (confirm("Are you sure want to delete " + attachment.file_name + " ?")) {
                if (!vm.newTicket) {
                    if (attachment && attachment["sys_id"]) {
                        ServiceNow.deleteAttachment(attachment.sys_id, () => {
                            reloadData();
                        });
                    }
                } else if (vm.newTicket) {
                    for (let x = 0; x < vm.attachments.length; x++) {
                        if (vm.attachments[x].name === attachment.name) {
                            vm.attachments.splice(x, 1);
                        }
                    }
                }
            }
        };

        vm.close = () => {
            if (!vm.newTicket) {
                $uibModalInstance.dismiss("cancel");
            } else if (vm.newTicket) {
                $uibModalInstance.close(vm.attachments);
            }
        };

        if (!vm.newTicket) {
            reloadData();
        }
    }
})();

(function () {

    angular.module("burWood").controller("AssignmentGroupController", AssignmentGroupController);

    /** @ngInject */
    function AssignmentGroupController($uibModalInstance, BoH, DTOptionsBuilder, util) {
        let vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions().withOption("responsive", true);
        vm.loading = true;

        vm.addtolist = (name, id) => {
            let data = {
                name: name,
                id: id
            };
            $uibModalInstance.close(data);
        };

        vm.close = () => {
            $uibModalInstance.dismiss("cancel");
        };

        BoH.getUserGroup((data) => {
            vm.loading = false;
            if (data.error) {
                vm.total_result = 0;
                vm.groups = [];
            } else {
                vm.total_result = data.count;
                vm.groups = util.sortItems(data.results, "name", "ASC");
            }
        });
    }

})();
(function () {
    "use strict";

    angular.module("burWood").component("multiCheckboxContainer", {
        controller: function () {
            var ctrl = this;
            var checkboxes = [];
            var checkboxModels = [];
            var previousClickedCheckbox = null;

            ctrl.addCheckbox = addCheckbox;
            ctrl.onCheckboxClick = onCheckboxClick;

            function addCheckbox(checkbox, checkboxModelCtrl) {
                checkboxes.push(checkbox);
                checkboxModels.push(checkboxModelCtrl);
            }

            function onCheckboxClick(checkbox, shiftKey, ctrlKey) {
                var start, end, i, checking;
                if ((shiftKey || ctrlKey) && previousClickedCheckbox) {
                    checking = checkbox.prop("checked");
                    start = checkboxes.indexOf(previousClickedCheckbox);
                    end = checkboxes.indexOf(checkbox);
                    if (start > end) {
                        start = start + end;
                        end = start - end;
                        start = start - end;
                    }
                    for (i = start; i <= end; i++) {
                        checkboxes[i].prop("checked", checking);
                        checkboxModels[i].$setViewValue(checking);
                    }
                }
                previousClickedCheckbox = checkbox;
            }
        }
    });
})();

(function () {

    angular.module("burWood").controller("LogoController", LogoController);

    /** @ngInject */
    function LogoController($uibModalInstance, account, FileSaver, Blob, Server, BCSServer) {
        let vm = this;

        vm.uploading = false;
        vm.loading = false;
        vm.logo = account.logo;

        if (vm.logo) {
            vm.downloadFile =
                "data:" + vm.logo.contentType + ";base64," + btoa(String.fromCharCode.apply(null, vm.logo.data.data));
        }

        // vm.downloadAttachment = (attachment) => {
        //     if (attachment && attachment.data && attachment.data.data) {
        //         let downloadFile =
        //             "data:image/png;base64," + btoa(String.fromCharCode.apply(null, attachment.data.data));
        //         let blobData = new Blob([downloadFile], {
        //             type: attachment.contentType
        //         });
        //         FileSaver.saveAs(blobData, attachment.fileName);
        //     }
        // };

        vm.addAttachment = () => {
            vm.uploading = true;
            if (
                vm.upload_file != undefined &&
                vm.upload_file != null &&
                (vm.upload_file.type === "image/png" || vm.upload_file.type === "image/jpg") &&
                vm.upload_file.size < 5000000
            ) {
                vm.uploadFail = false;
                let fileObj = {
                    companyCode: account.companyCode,
                    companyAccounts: account,
                    image: vm.upload_file
                };
                Server.addAttachment(fileObj, "/upload_logo", (account) => {
                    if (account && account.logo) {
                        account = account;
                        vm.logo = account.logo;
                        vm.downloadFile =
                            "data:" +
                            vm.logo.contentType +
                            ";base64," +
                            btoa(String.fromCharCode.apply(null, vm.logo.data.data));
                    }
                    vm.upload_file = null;
                    vm.uploading = false;
                });
            } else {
                vm.uploadFail = true;
            }
        };

        vm.deleteAttachment = (attachment) => {
            if (confirm("Are you sure want to delete " + attachment.fileName + " ?")) {
                vm.loading = true;
                delete account._id;
                delete account.__v;
                account.logo = undefined;
                BCSServer.postData(
                    {
                        companyCode: account.companyCode,
                        companyAccounts: account
                    },
                    "/update_cloud_accounts",
                    () => {
                        vm.logo = null;
                        vm.loading = false;
                    }
                );
            }
        };

        vm.close = () => {
            account.logo = vm.logo;
            $uibModalInstance.close(account);
        };
    }

})();
(function () {

    angular.module("burWood").controller("EmailContactController", EmailContactController);

    /** @ngInject */
    function EmailContactController($uibModalInstance, emailContacts, util, $uibModal) {
        let vm = this;

        let cacheList;

        let originalContacts = angular.copy(emailContacts);

        vm.emailContacts = emailContacts;

        vm.openProjectUsers = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "CloudContactController",
                controllerAs: "vm",
                resolve: {
                    cache: () => {
                        return cacheList;
                    }
                }
            });
            modalInst.result.then((payload) => {
                if (payload) {
                    cacheList = payload.cache;
                    let foundUser = util.findItem(payload.email, vm.emailContacts, "email");
                    if (payload.email && !foundUser) {
                        vm.emailContacts.push({
                            email: payload.email,
                            alerts: true,
                            weeklySummary: true
                        });
                    }
                }
            });
        };

        vm.add_user = () => {
            vm.emailContacts.push({
                email: null,
                alerts: true,
                weeklySummary: true
            });
        };

        vm.delete_user = (index) => {
            vm.emailContacts.splice(index, 1);
        };

        vm.close = () => {
            $uibModalInstance.close(vm.emailContacts);
        };

        vm.cancel = () => {
            angular.copy(originalContacts, vm.emailContacts);
            $uibModalInstance.dismiss("cancel");
        };
    }

})();
(function () {
    "use strict";

    angular.module("burWood").controller("DownloadingController", DownloadingController);

    /** @ngInject */
    function DownloadingController($uibModalInstance, message) {
        let vm = this;
        vm.message = message.message;
        vm.close = () => {
            $uibModalInstance.dismiss("cancel");
        };
    }
})();

(function () {
    angular.module("burWood").factory("cloudProcessor", cloudProcessor);

    /** @ngInject */
    function cloudProcessor(_, cloud, util, moment) {
        let cloudProcessorMethods = {
            processAlertData: (alerts) => {
                let chartData = {
                    series: [],
                    categories: []
                };

                let companyAlerts = {};
                let tableData = [];

                alerts.forEach((alert) => {
                    if (!companyAlerts[alert.company]) {
                        let companyName = alert.company;
                        delete alert.company;
                        alert.tags = alert.tags.join(", ");
                        companyAlerts[companyName] = [alert];
                        chartData.categories.push(companyName);
                    } else {
                        let companyName = alert.company;
                        delete alert.company;
                        alert.tags = alert.tags.join(", ");
                        companyAlerts[companyName].push(alert);
                    }
                });

                chartData.categories.sort();
                chartData.series = Array.apply(null, Array(chartData.categories.length)).map(
                    Number.prototype.valueOf,
                    0
                );

                for (let company in companyAlerts) {
                    const seriesIndex = chartData.categories.indexOf(company);
                    chartData.series[seriesIndex] = companyAlerts[company].length;

                    tableData.push({
                        company: company,
                        alerts: companyAlerts[company].length,
                        breakdown: companyAlerts[company]
                    });
                }

                tableData.sort(util.compare("company"));

                return {
                    tableData: tableData,
                    chartData: chartData
                };
            },
            processRateData: (data, accountList, rateConfig) => {
                let chartData = {
                    series: [],
                    categories: []
                };

                let currentConsumptions = [];

                data.forEach((item) => {
                    let consonsumptionCost = item.subtotal;
                    let ratePeriod = item.breakdown.filter((breakdown) => {
                        return moment(rateConfig.dateStart).diff(moment(breakdown.date), "days") <= 0;
                    });
                    let ratePeriodCost = ratePeriod
                        .map((x) => {
                            return x.subtotal;
                        })
                        .reduce((a, b) => {
                            return a + b;
                        }, 0);

                    let consumptionRate = ratePeriodCost / rateConfig.rate;

                    let project = accountList.find((account) => {
                        return account.projectID === item.project_id;
                    });

                    if (project && project.allowances && project.allowances.length > 0) {
                        let availableAllowances = project.allowances.filter((allowance) => {
                            return allowance.state === "Active" || allowance.state === "Future";
                        });
                        let activeAllowance = project.allowances.find((allowance) => {
                            return allowance.state === "Active";
                        });

                        if (activeAllowance) {
                            project.consumption =
                                cloud.getLatestBudgetConsumption(item.breakdown, activeAllowance.dateActivated) || 0;

                            project.totalBudget = availableAllowances
                                .map((x) => {
                                    return util.formatCurrencyAsNumber(x.amount);
                                })
                                .reduce((a, b) => {
                                    return a + b;
                                }, 0);

                            project.budgetRemaining = project.totalBudget - project.consumption;

                            project.percentage = (project.consumption / project.totalBudget) * 100;

                            project.percentage = cloudProcessorMethods.formatNaNPercentage(project.percentage);

                            project.daysRemaining = project.budgetRemaining / consumptionRate;

                            project.totalBudget = "$" + util.numberWithCommas(project.totalBudget);
                            project.consumption = util.numberWithCommas(project.consumption);
                            project.budgetRemaining = "$" + util.numberWithCommas(project.budgetRemaining);
                            project.daysRemaining = Math.round(project.daysRemaining);

                            if (
                                isNaN(project.daysRemaining) ||
                                project.daysRemaining === Infinity ||
                                project.daysRemaining === -Infinity
                            ) {
                                project.daysRemaining = "N/A";
                            }
                        } else {
                            project = {
                                projectID: item.project_id,
                                consumption: consonsumptionCost || 0,
                                percentage: "N/A",
                                totalBudget: "N/A",
                                budgetRemaining: "N/A",
                                daysRemaining: "N/A"
                            };
                        }
                    } else {
                        project = {
                            projectID: item.project_id,
                            consumption: consonsumptionCost || 0,
                            percentage: "N/A",
                            totalBudget: "N/A",
                            budgetRemaining: "N/A",
                            daysRemaining: "N/A"
                        };
                    }

                    if (isNaN(consumptionRate) || consumptionRate === Infinity || consumptionRate === -Infinity) {
                        project.rate = "N/A";
                    } else {
                        project.rate = "$" + util.numberWithCommas(consumptionRate);
                    }

                    currentConsumptions.push(project);

                    chartData.categories.push(project.projectID);
                    chartData.series.push(consumptionRate);
                });

                return {
                    tableData: currentConsumptions,
                    chartData: chartData
                };
            },
            formatNaNPercentage: (percentageToFormat) => {
                let formattedPercent = "";
                if (isNaN(percentageToFormat) || percentageToFormat === Infinity || percentageToFormat === -Infinity) {
                    formattedPercent = "N/A";
                } else if (angular.isNumber(percentageToFormat)) {
                    formattedPercent = percentageToFormat.toFixed(2) + "%";
                }
                return formattedPercent;
            },
            processCurrentBudgets: (data, accountList) => {
                let chartData = {
                    series: [],
                    remaining: [],
                    categories: []
                };

                let currentConsumptions = [];

                data.forEach((item) => {
                    let project = accountList.find((account) => {
                        return account.projectID === item.project_id;
                    });

                    if (project && project.totalBudget) {
                        let budgetCost = util.formatCurrencyAsNumber(project.totalBudget);
                        let consonsumptionCost = item.subtotal;
                        let percentage = (consonsumptionCost / budgetCost) * 100;

                        project.consumption = consonsumptionCost || 0;
                        project.totalBudget = util.formatCurrencyAsNumber(project.totalBudget);

                        let latestAllowance = project.allowances.find((allowance) => {
                            return allowance.state === "Active";
                        });

                        if (latestAllowance && latestAllowance.accountNum === item.billing_account_id) {
                            chartData.categories.push(project.projectID);
                            project.currentAllowanceConsumption =
                                cloud.getLatestBudgetConsumption(item.breakdown, latestAllowance.dateActivated) || 0;
                            project.currentAllowance = latestAllowance.type;
                            project.currentAllowanceAmount = util.formatCurrencyAsNumber(latestAllowance.amount) || 0;
                            project.currentAllowanceRemaining =
                                project.currentAllowanceAmount - project.currentAllowanceConsumption;
                            let currentPercentage =
                                (project.currentAllowanceConsumption /
                                    util.formatCurrencyAsNumber(latestAllowance.amount)) *
                                100;

                            project.currentPercentage = cloudProcessorMethods.formatNaNPercentage(currentPercentage);
                            project.percentage = cloudProcessorMethods.formatNaNPercentage(percentage);

                            chartData.series.push(project.currentAllowanceConsumption);
                            chartData.remaining.push(project.currentAllowanceRemaining);

                            project.currentAllowanceConsumption = util.numberWithCommas(
                                project.currentAllowanceConsumption
                            );
                            project.currentAllowanceAmount = util.numberWithCommas(project.currentAllowanceAmount);
                            project.totalBudget = util.numberWithCommas(project.totalBudget);
                            project.consumption = util.numberWithCommas(project.consumption);
                            project.currentAllowanceRemaining = util.numberWithCommas(
                                project.currentAllowanceRemaining
                            );

                            currentConsumptions.push(project);
                        }
                    }
                });

                return {
                    tableData: currentConsumptions,
                    chartData: chartData
                };
            },
            processPOConsumptions: (data, poList) => {
                let chartData = {
                    series: [],
                    remaining: [],
                    categories: []
                };

                let currentConsumptions = [];

                for (let po in poList) {
                    poList[po].consumption = 0;

                    if (!poList[po].budgets || poList[po].budgets.length === 0) {
                        return;
                    }
                    poList[po].budgets.forEach((budget) => {
                        if (!budget.dateActivated || !budget.projects) {
                            return;
                        }

                        let foundItems = data.filter((prj) => {
                            return (
                                budget.accountNum === prj.billing_account_id && budget.projects.includes(prj.project_id)
                            );
                        });

                        if (foundItems) {
                            foundItems.forEach((foundItem) => {
                                poList[po].consumption +=
                                    cloud.getLatestBudgetConsumption(foundItem.breakdown, budget.dateActivated) || 0;
                            });
                        }
                    });
                }

                for (let key in poList) {
                    let perc = (poList[key].consumption / poList[key].poAmount) * 100;
                    isNaN(perc) && (perc = 0);
                    perc = perc.toFixed(2);

                    currentConsumptions.push({
                        po: key,
                        currentAllowanceConsumption: poList[key].consumption || 0,
                        currentAllowanceAmount: poList[key].poAmount || 0,
                        currentAllowanceRemaining: poList[key].poAmount - poList[key].consumption || 0,
                        currentPercentage: perc || 0
                    });

                    chartData.categories.push(key);
                    chartData.series.push(poList[key].consumption);
                    chartData.remaining.push(poList[key].poAmount - poList[key].consumption);
                }

                return {
                    tableData: currentConsumptions,
                    chartData: chartData
                };
            },
            processInvoiceExportData: (data) => {
                let chartData = {
                    series: [],
                    categories: []
                };

                let totalConsumption = 0;

                data.forEach((item) => {
                    totalConsumption += item.subtotal;

                    let prjIndex = chartData.categories.indexOf(item.project_id);

                    if (item && prjIndex == -1) {
                        chartData.categories.push(item.project_id);
                        chartData.series.push(item.subtotal);
                    } else {
                        chartData.series[prjIndex] += item.subtotal;
                    }
                });

                return {
                    totalConsumption: totalConsumption,
                    tableData: data,
                    chartData: chartData
                };
            },
            formatPermissions: (companies, disabledProjects) => {
                let chartData = {
                    series: [],
                    categories: []
                };

                let tableData = [];

                companies.forEach((company) => {
                    chartData.categories.push(company.companyName);
                    chartData.series.push(company.missingProjectList.length);

                    let projectFormat = [];
                    company.missingProjectList.forEach((prj) => {
                        projectFormat.push({
                            projectID: prj.project_id,
                            missingProjectPermissions: prj.missing,
                            disabled: disabledProjects.includes(prj.project_id)
                        });
                    });

                    company.missingAccountList.forEach((acct) => {
                        projectFormat.push({
                            projectID: acct.acct,
                            missingAccountPermissions: acct.missing
                        });
                    });

                    tableData.push({
                        companyName: company.companyName,
                        missingProjectPermissions: company.missingProjectList.length,
                        missingAccountPermissions: company.missingAccountList.length,
                        breakdown: projectFormat
                    });
                });

                return {
                    tableData: tableData,
                    chartData: chartData
                };
            },
            reformatUsers: (data, analytics) => {
                let chartData = {
                    series: [],
                    categories: []
                };

                if (!data || !data.departments || data.departments.length === 0) {
                    return {
                        tableData: [],
                        chartData: chartData
                    };
                }

                let tableData = [];
                let groupObj = {};

                // Preps group contact map
                if (data.groups && data.groups.length > 0) {
                    data.groups.forEach((group) => {
                        if (
                            group &&
                            group.contactList &&
                            group.contactList.length > 0 &&
                            group.departments &&
                            group.departments.length > 0
                        ) {
                            group.departments.forEach((department) => {
                                groupObj[department] = group.contactList;
                            });
                        }
                    });
                }

                data.departments.forEach((depo) => {
                    let depoContacts = depo.contactList || [];

                    depo.projects.forEach((prj) => {
                        chartData.categories.push(prj.projectID);

                        let contacts = prj.contactList || [];

                        contacts = contacts.concat(depoContacts);

                        if (groupObj[depo.departmentID]) {
                            contacts = contacts.concat(groupObj[depo.departmentID]);
                        }

                        if (contacts && contacts.length > 0) {
                            chartData.series.push(prj.contactList.length);

                            contacts.forEach((usr) => {
                                var invoiceAnalytic, sessionAnalytic;
                                try {
                                    invoiceAnalytic = analytics.invoice.find((analytic) => {
                                        return analytic[0].toLowerCase() === usr.email.toLowerCase();
                                    });

                                    invoiceAnalytic ? (invoiceAnalytic = invoiceAnalytic[1]) : (invoiceAnalytic = "0");

                                    sessionAnalytic = analytics.users.find((analytic) => {
                                        return analytic[0].toLowerCase() === usr.email.toLowerCase();
                                    });

                                    sessionAnalytic ? (sessionAnalytic = sessionAnalytic[1]) : (sessionAnalytic = "0");
                                } catch (e) {
                                    invoiceAnalytic = "0";
                                    sessionAnalytic = "0";
                                }

                                tableData.push({
                                    project_id: prj.projectID,
                                    email: usr.email,
                                    alerts: usr.alerts,
                                    weeklySummary: usr.weeklySummary,
                                    sessions: sessionAnalytic,
                                    invoices: invoiceAnalytic
                                });
                            });
                        } else {
                            chartData.series.push(0);
                        }
                    });
                });

                return {
                    tableData: tableData,
                    chartData: chartData
                };
            },
            // Runs through all the invoice data to begin processing PO consumption for each project
            matchPOInvoiceData: (budgets, poData, invoiceStart, client) => {
                let poProjects = [];
                for (let x = 0; x < poData.length; x++) {
                    let budgetAmounts = cloudProcessorMethods.getBudgetItemConsumption(
                        budgets,
                        poData[x],
                        poData,
                        invoiceStart,
                        client
                    );
                    if (budgetAmounts.length > 0) {
                        let poProject = {
                            project_id: poData[x].project_id,
                            pos: budgetAmounts
                        };
                        poProjects.push(poProject);
                    }
                }

                return poProjects;
            },
            // Processes PO consumptions for each projects for the current invoice period
            getBudgetItemConsumption: (budgets, singlePO, poData, invoiceStart, client) => {
                let budgetConsumptions = [];

                let prj = budgets.find((o) => o.projectID === singlePO.project_id);

                if (!prj) {
                    return [];
                }

                // Calculating the PO consumption of an afterCredits account
                try {
                    if (prj.afterCredits === "Bill" && prj.afterCreditsPO) {
                        let dateRange = {
                            startDate: moment("2018-01-01"),
                            endDate: moment()
                        };
                        const centralTax = client.centralTax * 0.01 || 0;
                        let consumptionDetail = poData.find(
                            (o) => o.project_id === prj.projectID && o.billing_account_id === prj.afterCreditsAccount
                        );
                        if (prj.allowances && prj.allowances.length > 0) {
                            let act = prj.allowances.find((o) => o.state === "Active");
                            let conIndex = prj.allowances.map((el) => el.state).lastIndexOf("Consumed");
                            let con;
                            if (conIndex !== -1) {
                                con = prj.allowances[conIndex];
                            }
                            if (act) {
                                // do nothing
                            } else {
                                if (!consumptionDetail) {
                                    return [];
                                }
                                if (con && con.dateSuspended) {
                                    dateRange.startDate = con.dateSuspended;
                                }
                                let invoiceTotal = cloudProcessorMethods.getConsumptionPeriod(
                                    consumptionDetail.breakdown,
                                    dateRange
                                );
                                budgetConsumptions.push({
                                    po: `${client.purchaseOrderTerm || "Purchase Order"}: ${prj.afterCreditsPO}`,
                                    markup: invoiceTotal * centralTax,
                                    subtotal: Number(invoiceTotal),
                                    project_id: prj.projectID
                                });
                                return budgetConsumptions;
                            }
                        } else {
                            if (!consumptionDetail) {
                                return [];
                            }
                            let invoiceTotal = cloudProcessorMethods.getConsumptionPeriod(
                                consumptionDetail.breakdown,
                                dateRange
                            );
                            budgetConsumptions.push({
                                po: `${client.purchaseOrderTerm}: ${prj.afterCreditsPO}`,
                                markup: invoiceTotal * centralTax,
                                subtotal: Number(invoiceTotal),
                                project_id: prj.projectID
                            });
                            return budgetConsumptions;
                        }
                    }
                } catch (e) {
                    console.log(e);
                }

                if (
                    (!prj.allowances || prj.allowances.length === 0) &&
                    (!prj.currentDepoAllowances || prj.currentDepoAllowances.length === 0)
                ) {
                    return [];
                }

                let availableAllowances = prj.allowances;

                if (prj.budgetingDepo) {
                    availableAllowances = prj.currentDepoAllowances;
                }

                // Used allowances are allowances that have consumption during the current invoice period
                let usedAllowances = availableAllowances
                    .filter((allowance, index) => {
                        return (
                            allowance.state === "Active" ||
                            (availableAllowances[index + 1] &&
                                availableAllowances[index + 1].state === "Active" &&
                                availableAllowances[index + 1].dateActivated &&
                                moment(availableAllowances[index + 1].dateActivated) > moment(new Date(invoiceStart)))
                        );
                    })
                    .map((allowance, index) => {
                        if (allowance[index + 1]) {
                            allowance.dateSuspended = allowance[index + 1].dateActivated;
                        }
                        return allowance;
                    });

                if (usedAllowances.length === 0) {
                    return [];
                }

                usedAllowances.forEach((allowance) => {
                    if (!allowance) {
                        return;
                    }

                    let consumptionDetail = poData.find(
                        (o) => o.project_id === prj.projectID && o.billing_account_id === allowance.accountNum
                    );

                    if (!consumptionDetail) {
                        return;
                    }

                    let dateRange = {
                        startDate: allowance.dateActivated,
                        endDate: allowance.dateSuspended || moment()
                    };

                    if (!allowance.poNumber) {
                        return;
                    }

                    budgetConsumptions.push({
                        po: `${client.purchaseOrderTerm}: ${allowance.poNumber}`,
                        subtotal: Number(
                            cloudProcessorMethods.getConsumptionPeriod(consumptionDetail.breakdown, dateRange)
                        ),
                        project_id: prj.projectID
                    });
                });

                return budgetConsumptions;
            },
            // Get the consumption for the given period in string form from a given consumption array
            getConsumptionPeriod: (consumptionArray, dateRange) => {
                let consumption = 0;
                consumptionArray.forEach((item) => {
                    if (
                        moment(dateRange.startDate).diff(moment(item.date), "days") <= 0 &&
                        moment(dateRange.endDate).diff(moment(item.date), "days") >= 0
                    ) {
                        consumption += item.invoice_total;
                    }
                });

                consumption = consumption.toFixed(2);
                return consumption;
            }
        };
        return cloudProcessorMethods;
    }
})();

(function () {
    angular.module("burWood").factory("CloudBilling", CloudBilling);

    function CloudBilling($http, $q, apiBasePath) {
        let deferred = $q.defer();
        return {
            getTable: (table_name, query_obj, callback) => {
                let cb = callback || angular.noop;
                query_obj.tableName = table_name;
                $http.post(apiBasePath + "/cloudbilling/get_tables", query_obj).then(
                    (data) => {
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            },
            getReportData: (query_obj, callback) => {
                let cb = callback || angular.noop;
                $http
                    .get(
                        apiBasePath +
                            "/cloudbilling/billingdata/" +
                            query_obj.companyCode +
                            "?date_range=" +
                            query_obj.dateRange
                    )
                    .then(
                        (data) => {
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            getCreditData: (query_obj, callback) => {
                let cb = callback || angular.noop;
                $http
                    .get(
                        apiBasePath +
                            "/cloudbilling/creditdata/" +
                            query_obj.companyCode +
                            "?date_range=" +
                            query_obj.dateRange
                    )
                    .then((data) => {
                        deferred.resolve(data.data);
                        return cb(data.data);
                    })
                    .error((err) => {
                        deferred.reject(err);
                        return cb(err);
                    });
            },
            getInvoiceData: (company_code, callback) => {
                let cb = callback || angular.noop;
                $http.get(apiBasePath + "/cloudbilling/invoices/" + company_code).then(
                    (data) => {
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            },
            getCustomer: (company_code, callback) => {
                let cb = callback || angular.noop;
                $http.get(apiBasePath + "/cloudbilling/customers/" + company_code).then(
                    (data) => {
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            },
            getProjects: (company_code, callback) => {
                let cb = callback || angular.noop;
                $http.get(apiBasePath + "/cloudbilling/projects/" + company_code).then(
                    (data) => {
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            }
        };
    }
})();

(function () {
    angular.module("burWood").factory("cloud", cloud);

    /** @ngInject */
    function cloud(_, moment, util) {
        const basicTooltip = (context) => {
            let total = context.total || context.y;
            let key = context.key;
            if (key === "Slice") {
                let sliceIndex = context.point.index;
                key = context.series.chart.axes[0].categories[sliceIndex];
            }
            let tooltip = "<div><p>" + key + "</p><br><p>Consumption: $" + total.toFixed(2) + "</p></div>";
            return tooltip;
        };

        const budgetConsumptionTooltip = (context) => {
            let tooltipTitle = context.key || context.x;
            let tooltip =
                "<div><p>" +
                tooltipTitle +
                "</p><br><p>Budget: $" +
                context.total +
                "</p>" +
                "</p><br><p>" +
                context.series.name +
                ": </p><p>$" +
                context.y.toFixed(2) +
                "</p></div>";
            if (context.percentage) {
                tooltip = tooltip + "<br><p>Percentage: </p><p>" + context.percentage.toFixed(2) + "%</p>";
            }
            return tooltip;
        };

        const overTimeTooltip = (context, subtotal) => {
            let tooltipTitle = context.key || context.x;
            if (tooltipTitle === "Slice") {
                let sliceIndex = context.point.index;
                tooltipTitle = context.series.chart.axes[0].categories[sliceIndex];
            }
            let tooltip =
                "<div><p>" +
                tooltipTitle +
                "</p><br><p>" +
                context.series.name +
                ": </p><p>$" +
                context.y.toFixed(2) +
                "</p></div>";
            if (context.series.name === "Consumption") {
                tooltip = tooltip + "<br><p>Daily Consumption: $" + subtotal + "</p>";
            }
            return tooltip;
        };

        const burwoodAdminTooltip = (context) => {
            let tooltip = "";

            if (context.series.options.type === "pie") {
                tooltip = "<div><p>" + context.key + ": $" + context.y + "<br>Total: $" + context.total + "</p></div>";
            } else {
                let company = context.series.userOptions.stack;
                let type = context.series.userOptions.name;
                tooltip =
                    "<div>" +
                    "<p>Client Type: " +
                    company +
                    "<p><br>" +
                    "<p>Consumption Type: " +
                    type +
                    "<p><br>" +
                    "<p>Consumption: $" +
                    context.y.toFixed(2) +
                    "</p><br>" +
                    "<p>Total: $" +
                    context.total.toFixed(2) +
                    "</p></div>";
            }

            return tooltip;
        };

        let toolTipFormatters = {
            consumptionOverTime: overTimeTooltip,
            consumptionOverTimeAll: overTimeTooltip,
            serviceConsumptionOverTime: overTimeTooltip,
            entityConsumptionOverTime: overTimeTooltip,
            consumptionByProject: budgetConsumptionTooltip,
            invoiceExport: budgetConsumptionTooltip,
            currentBudgetStatus: budgetConsumptionTooltip,
            consumptionByPO: budgetConsumptionTooltip,
            consumptionByDepartment: budgetConsumptionTooltip,
            consumptionRateByProject: (context) => {
                let tooltip =
                    "<div><p>" +
                    context.key +
                    "</p><br><p>Rate of Spend<br>$" +
                    context.total.toFixed("2") +
                    "</p></div>";
                return tooltip;
            },
            consumptionByLabel: basicTooltip,
            yearConsumptionByMonth: basicTooltip,
            yearConsumptionByMonthAll: basicTooltip,
            yearConsumptionByMonthAccount: overTimeTooltip,
            consumptionByEntity: basicTooltip,
            consumptionByProduct: basicTooltip,
            consumptionByCompany: basicTooltip,
            stridesByCompany: basicTooltip,
            marginByCompany: burwoodAdminTooltip,
            consumptionByCompanyType: burwoodAdminTooltip,
            consumptionByAccount: basicTooltip,
            invoiceCostByAccount: basicTooltip,
            userReport: (context) => {
                let total = context.total || context.y;
                let key = context.key;
                if (key === "Slice") {
                    let sliceIndex = context.point.index;
                    key = context.series.chart.axes[0].categories[sliceIndex];
                }
                let tooltip = "<div><p>" + key + "</p><br><p>Users: " + total.toFixed(2) + "</p></div>";
                return tooltip;
            },
            permissionReport: (context) => {
                let total = context.total || context.y;
                let key = context.key;
                if (key === "Slice") {
                    let sliceIndex = context.point.index;
                    key = context.series.chart.axes[0].categories[sliceIndex];
                }
                let tooltip = "<div><p>" + key + "</p><br><p>Missing Permissions: " + total.toFixed(2) + "</p></div>";
                return tooltip;
            },
            alertReport: (context) => {
                let total = context.total || context.y;
                let key = context.key;
                if (key === "Slice") {
                    let sliceIndex = context.point.index;
                    key = context.series.chart.axes[0].categories[sliceIndex];
                }
                let tooltip = "<div><p>" + key + "</p><br><p>Failed Alerts: " + total.toFixed(2) + "</p></div>";
                return tooltip;
            }
        };

        let cloudfunctions = {
            mapPOLevel: (level, poBudgets, projects, fundingType) => {
                if (level.allowances) {
                    level.allowances.forEach((levelAllow) => {
                        if (
                            ((levelAllow && levelAllow.type === "PO") || levelAllow.type === "Prepaid") &&
                            levelAllow[fundingType]
                        ) {
                            levelAllow.projects = projects;
                            if (!poBudgets[levelAllow[fundingType]]) {
                                poBudgets[levelAllow[fundingType]] = {
                                    budgets: [levelAllow]
                                };
                            } else {
                                poBudgets[levelAllow[fundingType]].budgets.push(levelAllow);
                            }
                        }
                    });
                }
            },
            flattenOrg: (foundBudget) => {
                let flat = {
                    department: [],
                    project: []
                };

                if (foundBudget && foundBudget.departments && foundBudget.departments.length > 0) {
                    foundBudget.departments.forEach((depo) => {
                        flat.department.push(depo.departmentName);
                        if (depo && depo.projects && depo.projects.length > 0) {
                            depo.projects.forEach((prj) => {
                                flat.project.push(prj.projectID);
                            });
                        }
                    });
                }
                flat.department.sort();
                flat.project.sort();
                return flat;
            },
            flattenProjectUserOrg: (foundBudget, user_info, groupDepartments) => {
                let flat = {
                    group: [],
                    department: [],
                    project: []
                };

                if (foundBudget && foundBudget.departments && foundBudget.departments.length > 0) {
                    foundBudget.departments.forEach((depo) => {
                        let userDepo = util.findItem(user_info.email, depo.contactList, "email");

                        if (userDepo || groupDepartments.includes(depo.departmentID)) {
                            flat.department.push(depo.departmentName);
                            if (depo && depo.projects && depo.projects.length > 0) {
                                depo.projects.forEach((prj) => {
                                    flat.project.push(prj.projectID);
                                });
                            }
                            return;
                        }

                        if (depo && depo.projects && depo.projects.length > 0) {
                            depo.projects.forEach((prj) => {
                                let userProject = util.findItem(user_info.email, prj.contactList, "email");

                                if (userProject) {
                                    flat.project.push(prj.projectID);
                                }
                            });
                        }
                    });
                }
                return flat;
            },
            listAssociatedGroups: (groups, groupDepartments) => {
                let userGroups = [];

                groups.forEach((group) => {
                    if (group && group.departments && group.departments.length > 0) {
                        group.departments.forEach((depo) => {
                            if (groupDepartments.includes(depo) && !userGroups.includes(group.groupName)) {
                                userGroups.push(group.groupName);
                            }
                        });
                    }
                });

                return userGroups;
            },
            createIDString: (length) => {
                let result = "";
                let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
                let charactersLength = characters.length;
                for (let i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return result;
            },
            formatAfterCreditsAllowance: (level) => {
                let afterCreditAllowance;
                if (level.allowances && level.allowances.length > 0) {
                    let act = level.allowances.find((o) => {
                        return o.state === "Active";
                    });
                    let reversedAllowances = level.allowances.reverse();
                    let con = reversedAllowances.find((o) => {
                        return o.state === "Consumed";
                    });
                    if (act) {
                        // do nothing
                    } else {
                        if (con && con.dateSuspended) {
                            afterCreditAllowance = {};
                            afterCreditAllowance.dateActivated = con.dateSuspended;
                            afterCreditAllowance.accountNum = level.afterCreditsAccount;
                            afterCreditAllowance.state = "Active";
                            afterCreditAllowance.type = "Pay As You Go";
                            afterCreditAllowance.poNumber = level.afterCreditsPO;
                        }
                    }
                } else {
                    afterCreditAllowance = {};
                    afterCreditAllowance.dateActivated = moment("2018-01-01");
                    afterCreditAllowance.accountNum = level.afterCreditsAccount;
                    afterCreditAllowance.state = "Active";
                    afterCreditAllowance.type = "Pay As You Go";
                    afterCreditAllowance.poNumber = level.afterCreditsPO;
                }
                return afterCreditAllowance;
            },
            findPOBudgets: (budget, fundType) => {
                let poBudgets = {};

                let fundingType = fundType || "poNumber";

                if (!budget.departments) {
                    return;
                }
                budget.departments.forEach((depo) => {
                    if (!depo.projects) {
                        return;
                    }

                    if (depo.budgetType === "Budgeting") {
                        let projectIDs = depo.projects.map((proj) => {
                            return proj.projectID;
                        });

                        if (depo && depo.afterCredits === "Bill" && depo.afterCreditsPO) {
                            let afterCreditsAllowance = cloudfunctions.formatAfterCreditsAllowance(depo);
                            if (afterCreditsAllowance) {
                                depo.allowances.push(afterCreditsAllowance);
                            }
                        }
                        cloudfunctions.mapPOLevel(depo, poBudgets, projectIDs, fundingType);
                    } else {
                        depo.projects.forEach((prj) => {
                            if (prj && prj.afterCredits === "Bill" && prj.afterCreditsPO) {
                                let afterCreditsAllowance = cloudfunctions.formatAfterCreditsAllowance(prj);
                                if (afterCreditsAllowance) {
                                    prj.allowances.push(afterCreditsAllowance);
                                }
                            }
                            cloudfunctions.mapPOLevel(prj, poBudgets, prj.projectID, fundingType);
                        });
                    }
                });
                return poBudgets;
            },
            createPOList: (pos) => {
                return pos
                    .map((po) => {
                        if (po && po.state !== "Retired") {
                            return {
                                value: po.number,
                                data: po
                            };
                        } else {
                            return null;
                        }
                    })
                    .filter((po) => po);
            },
            mapInvoicePO: (data, projectData, invoiceStart, invoiceEnd, poTerm) => {
                poTerm = poTerm || "Purchase Order";
                data.forEach((billing_account) => {
                    if (billing_account && billing_account.breakdown && billing_account.breakdown.length > 0) {
                        // let newBreakdown = angular.copy(billing_account.breakdown);
                        let newBreakdown = [];
                        let poProjects = [];
                        billing_account.breakdown.forEach((project) => {
                            if (project && project.project_id && !poProjects.includes(project.project_id)) {
                                // This is matching project ID's with the projectData param (from the function)
                                let foundProject = projectData.find((prj) => {
                                    return prj.projectID === project.project_id;
                                });
                                let foundAllowances,
                                    foundActive = false;

                                // This takes the "found" project and pulls the active budget allowance
                                if (foundProject && foundProject.allowances && foundProject.allowances.length > 0) {
                                    foundAllowances = true;
                                    foundActive = foundProject.allowances.find((all) => {
                                        return all.state === "Active";
                                    });
                                }
                                if (foundAllowances && foundActive) {
                                    // If there is an active allowance for the project,
                                    // loop through the allowances again?
                                    foundProject.allowances.forEach((allowance, index) => {
                                        if (
                                            allowance.state !== "Consumed" &&
                                            allowance.state !== "Active" &&
                                            allowance.accountNum !== billing_account.billing_account_id
                                        ) {
                                            // Do nothing if it's not a consumed or active budget.
                                            return;
                                        }

                                        // This block puts together allowance start and end times
                                        let invStart = new Date(invoiceStart).getTime();
                                        let invEnd = new Date(invoiceEnd).getTime();
                                        let allowanceStart, allowanceEnd;
                                        if (allowance.dateActivated && (allowance.poNumber || allowance.grant)) {
                                            allowanceStart = new Date(allowance.dateActivated).getTime();
                                            if (allowance.dateSuspended) {
                                                allowanceEnd = new Date(allowance.dateSuspended).getTime();
                                            } else if (
                                                foundProject.allowances[index + 1] &&
                                                foundProject.allowances[index + 1].dateActivated
                                            ) {
                                                // Sets the current allowance end time to the activation time of the next allowance
                                                allowanceEnd = new Date(
                                                    foundProject.allowances[index + 1].dateActivated
                                                ).getTime();
                                            } else {
                                                allowanceEnd = new Date().getTime();
                                            }
                                        } else {
                                            return;
                                        }
                                        // If the invoice allowances fall within the date range,
                                        // do stuff with them
                                        if (allowanceEnd >= invStart && allowanceStart <= invEnd) {
                                            let newServicePo = angular.copy(project);
                                            // Iterate through all of the fields in the current project
                                            // (remember we're in a for loop)
                                            for (let field in newServicePo) {
                                                // For the billing account field,
                                                // sum up all of the totals if they fall within the invoice date range
                                                if (angular.isNumber(newServicePo[field])) {
                                                    newServicePo[field] = billing_account.breakdown.reduce(function (
                                                        total,
                                                        service
                                                    ) {
                                                        if (
                                                            service.project_id === foundProject.projectID
                                                        ) {
                                                            return total + service[field];
                                                        } else {
                                                            return total;
                                                        }
                                                    },
                                                    0);
                                                }
                                            }
                                            if (allowance.grant && !allowance.poNumber) {
                                                newServicePo.po = `Grant: ${allowance.grant}`;
                                            } else {
                                                newServicePo.po = `${poTerm}: ${allowance.poNumber || allowance.grant}`;
                                            }
                                            // Keep the project ID's and cost breakdowns in parllel arrays
                                            poProjects.push(foundProject.projectID);
                                            newBreakdown.push(newServicePo);
                                        }
                                    });
                                } else {
                                    // No active allowances
                                    let newServicePo = angular.copy(project);
                                    for (let field in newServicePo) {
                                        // Simply tally up the billing account costs when no active allowance exist.
                                        if (angular.isNumber(newServicePo[field])) {
                                            newServicePo[field] = billing_account.breakdown.reduce(function (
                                                total,
                                                service
                                            ) {
                                                if (service.project_id === project.project_id) {
                                                    return total + service[field];
                                                } else {
                                                    return total;
                                                }
                                            },
                                            0);
                                        }
                                    }
                                    if (
                                        foundProject &&
                                        foundProject.afterCreditsPO &&
                                        foundProject.afterCreditsAccount === billing_account.billing_account_id
                                    ) {
                                        newServicePo.po = foundProject.afterCreditsPO;
                                    } else {
                                        newServicePo.po = ``;
                                    }
                                    // Keep track in parallel arrays
                                    poProjects.push(project.project_id);
                                    newBreakdown.push(newServicePo);
                                }
                            }
                        });
                        // The final new breakdown
                        // This mutates the data object.
                        // Thus the data object is returned a couple lines below.
                        console.log(newBreakdown);
                        billing_account.breakdown = newBreakdown;
                    }
                });

                
                return data;
            },
            composeProjectListFromDatabase: (account) => {
                let databaseProjectList = [];
                account.departments.forEach((department) => {
                    department.projects.forEach((project) => {
                        databaseProjectList.push(project);
                    });
                });
                return databaseProjectList;
            },
            alignPOBudgets: (budgets, pos) => {
                if (!pos) {
                    return budgets;
                }
                for (let key in budgets) {
                    let foundaccount = pos.find((po) => {
                        return po.number === key;
                    });
                    if (foundaccount) {
                        budgets[key].poAmount = foundaccount.amount;
                    }
                }
                return budgets;
            },
            determineDataSource: (dashboards, reportID, returnField) => {
                let dataSource = _.findWhere(dashboards, {
                    id: reportID
                });
                if (returnField) {
                    return dataSource[returnField];
                } else {
                    return dataSource;
                }
            },
            composeReportParameters: (parameters) => {
                let reportParameters, dateParameter;

                !parameters.toDate && (dateParameter = parameters.date);

                if (
                    parameters.dateType === "invoiceMonth" &&
                    parameters.date.startDate &&
                    moment(parameters.date.startDate) > moment("2020-09-30")
                ) {
                    dateParameter = {
                        startDate: moment(parameters.date.startDate).format("YYYYMM"),
                        endDate: moment(parameters.date.endDate).format("YYYYMM")
                    };
                } else {
                    parameters.dateType = "dateRange";
                }

                switch (parameters.report.id) {
                    case "permissionReport":
                        reportParameters = {
                            projects: parameters.projects
                        };
                        break;
                    case "consumptionOverTime":
                    case "serviceConsumptionOverTime":
                    case "entityConsumptionOverTime":
                    case "yearConsumptionByMonth":
                        if (parameters.reportType === "report") {
                            reportParameters = {
                                sourceType: parameters.source,
                                view: parameters.report.view,
                                parameters: {
                                    projects: parameters.projects
                                }
                            };

                            if (parameters.report.id === "serviceConsumptionOverTime") {
                                reportParameters.parameters.addField = "service_description";
                            }

                            if (parameters.report.id === "entityConsumptionOverTime") {
                                reportParameters.parameters.addField = "sku_description";
                            }
                        } else {
                            reportParameters = {
                                sourceType: parameters.source,
                                view: parameters.report.view,
                                parameters: {
                                    projects: [parameters.selectedProject]
                                }
                            };
                        }

                        reportParameters.parameters[parameters.dateType] = dateParameter;
                        reportParameters.parameters.groupBy = "project_id";

                        break;
                    case "yearConsumptionByMonthAccount":
                    case "yearConsumptionByMonthAll":
                    case "consumptionByAccount":
                    case "invoiceCostByAccount":
                        reportParameters = {
                            sourceType: parameters.source,
                            view: parameters.report.view,
                            parameters: {
                                projects: parameters.projects
                            }
                        };

                        reportParameters.parameters[parameters.dateType] = dateParameter;
                        reportParameters.parameters.groupBy = "project_id";

                        break;
                    case "consumptionByEntity":
                    case "currentBudgetConsumptions":
                    case "consumptionByProduct":
                        !parameters.admin && (parameters.projects = [parameters.selectedProject]);

                        reportParameters = {
                            sourceType: parameters.source,
                            view: parameters.report.view,
                            parameters: {
                                projects: parameters.projects
                            }
                        };

                        reportParameters.parameters[parameters.dateType] = dateParameter;
                        reportParameters.parameters.groupBy = "project_id";

                        break;
                    case "consumptionOverTimeAll":
                    case "consumptionByProject":
                    case "invoiceExport":
                    case "consumptionByDepartment":
                    case "consumptionByLabel":
                    case "consumptionRateByProject":
                    case "creditStatus":
                    case "trendStats":
                    case "thresholdAlerts75":
                    case "currentBudgetStatus":
                    case "consumptionByPO":
                        parameters.report.id === "consumptionOverTimeAll" &&
                            parameters.cummulative === "Cummulative" &&
                            (dateParameter = null);

                        reportParameters = {
                            multi: true,
                            sourceType: parameters.source,
                            view: parameters.report.view,
                            parameters: {
                                projects: parameters.projects
                            }
                        };

                        reportParameters.parameters[parameters.dateType] = dateParameter;

                        if (parameters.report.id === "trendStats") {
                            let dateParam = {
                                startDate: moment().subtract(15, "days").format("YYYY-MM-DD").toString(),
                                endDate: moment().format("YYYY-MM-DD").toString()
                            };
                            reportParameters.parameters.dateRange = dateParam;
                        }

                        (parameters.report.id === "creditStatus" ||
                            parameters.report.id === "consumptionRateByProject") &&
                            (reportParameters.parameters.dateRange = null);

                        if (parameters.report.id === "consumptionByLabel") {
                            reportParameters.multi = false;
                        }

                        if (
                            parameters.report.id === "consumptionOverTimeAll" ||
                            parameters.report.id === "consumptionRateByProject" ||
                            parameters.report.id === "consumptionByDepartment"
                        ) {
                            reportParameters.parameters.removeField = "billing_account_id";
                        }

                        break;
                    default:
                        break;
                }

                parameters.dateType === "invoiceMonth" && (reportParameters.parameters.dateRange = null);

                return reportParameters;
            },
            getRawProjectArray: (projects, field) => {
                return projects.map((item) => {
                    return item[field];
                });
            },
            composeAvailableDepartments: (groups) => {
                let groupDepartments = groups.map((group) => {
                    return group.departments;
                });
                groupDepartments = [].concat.apply([], groupDepartments);
                return groupDepartments;
            },
            findGroupDepartments: (email, groups) => {
                let groupDepartments = [];
                if (groups && groups.length > 0) {
                    groups.forEach((group) => {
                        if (group && group.contactList && group.contactList.length > 0) {
                            group.contactList.forEach((contact) => {
                                if (contact && contact.email === email) {
                                    groupDepartments = groupDepartments.concat(group.departments);
                                }
                            });
                        }
                    });
                }
                return groupDepartments;
            },
            getDateArray: (data, single, dateObj) => {
                let beginningDate, today;

                if (dateObj && dateObj.startDate) {
                    beginningDate = moment(dateObj.startDate);
                } else {
                    if (!single) {
                        data.forEach((project) => {
                            project.breakdown.forEach((date) => {
                                !beginningDate && (beginningDate = moment(date.date));
                                beginningDate > moment(date.date) && (beginningDate = moment(date.date));
                            });
                        });
                    } else {
                        beginningDate = moment(data[0].date);
                    }
                }

                if (dateObj && dateObj.endDate) {
                    today = moment(dateObj.endDate);
                    today > moment() && (today = moment());
                } else {
                    today = moment(new Date());
                }

                let dateArray = cloudfunctions.getDates(beginningDate, today);
                return dateArray;
            },
            getDates: (currentDate, stopDate) => {
                let dateArray = [];
                while (currentDate <= stopDate) {
                    dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
                    currentDate = moment(currentDate).add(1, "days");
                }
                return dateArray;
            },
            findUserProjects: (user_info, accounts, department, groupDepartment) => {
                let tempAccountList = [];
                let tempProjectList = [];
                let groupDepo = groupDepartment || [];
                if (accounts && accounts.length > 0) {
                    accounts.forEach((item) => {
                        if (item) {
                            let userProject = util.findItem(user_info.email, item.contactList, "email");
                            if (
                                (userProject || groupDepo.includes(item.departmentID)) &&
                                department &&
                                item.projects &&
                                item.projects.length > 0
                            ) {
                                tempAccountList = tempAccountList.concat(item.projects);
                                tempProjectList = tempProjectList.concat(
                                    item.projects.map((project) => {
                                        return {
                                            project_id: project.projectID
                                        };
                                    })
                                );
                            } else if (userProject) {
                                tempAccountList.push(item);
                                tempProjectList.push({
                                    project_id: item.projectID
                                });
                            }
                        }
                    });
                }
                return {
                    accountList: tempAccountList,
                    projectList: tempProjectList
                };
            },
            // conversion of dates for UI dislay
            convertDates(allowances) {
                allowances.forEach((allowance) => {
                    allowance.dateIssued && (allowance.dateIssued = moment(allowance.dateIssued));
                    allowance.dateActivated && (allowance.dateActivated = moment(allowance.dateActivated));
                    allowance.dateSuspended && (allowance.dateSuspended = moment(allowance.dateSuspended));
                    allowance.expirationDate && (allowance.expirationDate = moment(allowance.expirationDate));
                });
            },
            convertActivityDates(activities) {
                activities.forEach((activity) => {
                    activity.date &&
                        (activity.date = moment(activity.date)
                            .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                            .format("ddd MMM DD YYYY hh:mm:mm A z"));
                });
            },
            convertDatesUTC(account) {
                if (!account || !account.departments) {
                    return;
                }
                account.departments.forEach((depo) => {
                    depo.allowances.forEach((depoAllow) => {
                        depoAllow.dateIssued && (depoAllow.dateIssued = moment(depoAllow.dateIssued).utc());
                        depoAllow.dateActivated && (depoAllow.dateActivated = moment(depoAllow.dateActivated).utc());
                        depoAllow.dateSuspended && (depoAllow.dateSuspended = moment(depoAllow.dateSuspended).utc());
                        depoAllow.expirationDate && (depoAllow.expirationDate = moment(depoAllow.expirationDate).utc());
                    });
                    depo.projects.forEach((project) => {
                        project.allowances.forEach((allowance) => {
                            allowance.dateIssued && (allowance.dateIssued = moment(allowance.dateIssued).utc());
                            allowance.dateActivated &&
                                (allowance.dateActivated = moment(allowance.dateActivated).utc());
                            allowance.dateSuspended &&
                                (allowance.dateSuspended = moment(allowance.dateSuspended).utc());
                            allowance.expirationDate &&
                                (allowance.expirationDate = moment(allowance.expirationDate).utc());
                        });
                        project.activity.forEach((activity) => {
                            activity.date && (activity.date = moment(activity.date).utc());
                        });
                    });
                });
            },
            alignBudgetType(accounts, accountNum) {
                let foundAcct = accounts.find((account) => {
                    return account.account === accountNum;
                });
                if (foundAcct) {
                    return foundAcct.type;
                } else {
                    return "";
                }
            },
            sortGroups(groups, companyName) {
                groups.sort((a, b) => {
                    if (a && b) {
                        if (a.groupName.toLowerCase() < b.groupName.toLowerCase()) {
                            return -1;
                        }
                        if (a.groupName.toLowerCase() < b.groupName.toLowerCase()) {
                            return 1;
                        }
                    }

                    return 0;
                });

                let unaffiliatedExists = _.findIndex(groups, {
                    groupName: companyName
                });

                groups.splice(groups.length - 1, 0, groups.splice(unaffiliatedExists, 1)[0]);

                return groups;
            },
            sortDepartments(departments) {
                departments.sort((a, b) => {
                    if (a && b) {
                        if (a.departmentName.toLowerCase() < b.departmentName.toLowerCase()) {
                            return -1;
                        }
                        if (a.departmentName.toLowerCase() < b.departmentName.toLowerCase()) {
                            return 1;
                        }
                    }

                    return 0;
                });

                let unaffiliatedExists = _.findIndex(departments, {
                    departmentName: "Unaffiliated Projects"
                });

                departments.splice(departments.length - 1, 0, departments.splice(unaffiliatedExists, 1)[0]);

                let disabledExists = _.findIndex(departments, {
                    departmentName: "Disabled Projects"
                });

                departments.splice(departments.length - 1, 0, departments.splice(disabledExists, 1)[0]);

                return departments;
            },
            totalCreditsPO: (accountDetails, categoryLength) => {
                let creditBudgets = [];
                let budgetTotal = 0;
                accountDetails.allowances.forEach((item) => {
                    if (item.amount && item.amount != "N/A") {
                        budgetTotal += util.formatCurrencyAsNumber(item.amount);
                        let type = item.type;
                        type === "PO" && (type = "Paid");
                        creditBudgets.push({
                            budgetData: {
                                label: type,
                                data: new Array(categoryLength).fill(budgetTotal)
                            }
                        });
                    }
                });
                return creditBudgets;
            },
            getSelectedProjectTotal: (data, selectedProject) => {
                let projectIndex = data.categories.indexOf(selectedProject);
                return util.numberWithCommas(data.series[projectIndex]);
            },
            formEntityTableData: (data) => {
                let tableObj = {};
                let tableData = [];
                data.series.forEach((item) => {
                    item.data.forEach((point) => {
                        if (tableObj[item.name]) {
                            tableObj[item.name] += point;
                        } else {
                            tableObj[item.name] = point;
                        }
                    });
                });

                for (let service in tableObj) {
                    tableData.push({
                        service_desc: service,
                        subtotal: tableObj[service]
                    });
                }
                return tableData;
            },
            convertNegativeCredits: (data, field) => {
                data.forEach((item) => {
                    item[field] && (item[field] = Math.abs(item[field]));
                });
                return data;
            },
            totalAllocatedCredits: (budgets) => {
                let totalAllocatedCredits = 0;
                budgets.forEach((item) => {
                    item.totalBudget && (totalAllocatedCredits += util.formatCurrencyAsNumber(item.totalBudget));
                });
                return util.numberWithCommas(totalAllocatedCredits);
            },
            getTotalBudget: (projects) => {
                let totalBudget = 0;
                projects.forEach((project) => {
                    if (project.allowances && project.allowances.length > 0) {
                        project.allowances.forEach((item) => {
                            if (item.amount) {
                                totalBudget += util.formatCurrencyAsNumber(item.amount);
                            }
                        });
                    }
                });
                return totalBudget;
            },
            getFirstBudgetDate: (projects) => {
                let firstBudgetDate = moment(new Date()).format("YYYY-MM-DD");
                if (projects) {
                    projects.forEach((project) => {
                        if (
                            project &&
                            project.currentProjectBudget &&
                            project.currentProjectBudget.dateActivated &&
                            moment(project.currentProjectBudget.dateActivated).isBefore(moment(firstBudgetDate))
                        ) {
                            firstBudgetDate = moment(project.currentProjectBudget.dateActivated).format("YYYY-MM-DD");
                        }
                    });
                }
                return firstBudgetDate;
            },
            extractAllProjects: (company) => {
                let projects = [];
                company.departments.forEach((depo) => {
                    if (company.groups) {
                        var foundGroup = company.groups.find((group) => {
                            return group.departments.includes(depo.departmentID);
                        });
                    }
                    if (depo && depo.projects && depo.projects.length > 0) {
                        let currentBudget = 0;
                        if (depo && depo.budgetType === "Budgeting") {
                            if (depo.allowances && depo.allowances.length > 0) {
                                currentBudget =
                                    depo.allowances.find((o) => {
                                        return o.state === "Active";
                                    }) || {};
                            }
                            depo.projects.forEach((project) => {
                                if (project) {
                                    project.allowances = depo.allowances;
                                    project.department = depo.departmentName;
                                    project.departmentBudget = currentBudget || 0;
                                    project.currentProjectBudget = currentBudget || 0;
                                    if (foundGroup) {
                                        project.group = foundGroup.groupName;
                                    }
                                }
                            });
                        } else {
                            depo.projects.forEach((project) => {
                                if (project) {
                                    let currentProjectBudget = 0;
                                    if (project.allowances && project.allowances.length > 0) {
                                        currentProjectBudget =
                                            project.allowances.find((o) => {
                                                return o.state === "Active";
                                            }) || {};
                                    }

                                    if (foundGroup) {
                                        project.group = foundGroup.groupName;
                                    }

                                    project.department = depo.departmentName;
                                    project.departmentBudget = currentBudget || 0;
                                    (project.depoType = depo.budgetType),
                                        (project.currentProjectBudget = currentProjectBudget || 0);
                                }
                            });
                        }
                        projects = projects.concat(depo.projects);
                    }
                });
                return projects;
            },
            getServiceOrEntityList: (data, report) => {
                let serviceList = [];
                let fieldVar;
                report === "serviceConsumptionOverTime" ? (fieldVar = "service_desc") : (fieldVar = "entity");
                data.forEach((item) => {
                    item.breakdown.forEach((breakdown) => {
                        serviceList.indexOf(breakdown[fieldVar]) == -1 && serviceList.push(breakdown[fieldVar]);
                    });
                });
                return serviceList;
            },
            generateChartColors: (dataLength, colors) => {
                let iterations = Math.floor(dataLength / colors.length);
                let colorList = colors;
                for (let x = 0; x < iterations; x++) {
                    colorList = colorList.concat(colors);
                }
                return colorList;
            },
            createChart: (chartOptions, report, width, height, table) => {
                console.log(chartOptions,report, width, height, table,"chart options")
                return {
                    chart: {
                        type: chartOptions.chartType,
                        zoomType: "x",
                        width: width,
                        height: height
                    },
                    colors: ["rgb(87,156,139)"],
                    boost: {
                        useGPUTranslations: true
                    },
                    title: {
                        text: chartOptions.title,
                        style: {
                            fontSize: "32px"
                        }
                    },
                    subtitle: {
                        text: chartOptions.zoomSubtitle ? "CLICK AND DRAG TO ZOOM" : ""
                    },
                    xAxis: {
                        categories: chartOptions.categories
                    },
                    yAxis: {
                        min: chartOptions.yMin,
                        visible: chartOptions.yVisible,
                        title: {
                            text: chartOptions.yText
                        },
                        allowDecimals: false,
                        gridLineColor: "rgba(255, 255, 255, .15)"
                    },
                    tooltip: {
                        formatter: function () {
                            let totalVar;
                            if (
                                report === "consumptionOverTimeAll" ||
                                report === "consumptionByEntity" ||
                                report === "consumptionByProduct" ||
                                report === "entityConsumptionOverTime" ||
                                report === "userReport" ||
                                report === "serviceConsumptionOverTime"
                            ) {
                                totalVar = this.y;
                            } else {
                                totalVar = table[this.point.index].subtotal;
                            }
                            if (chartOptions.basic) {
                                return basicTooltip(this);
                            } else {
                                return toolTipFormatters[report](this, totalVar);
                            }
                        }
                    },
                    plotOptions: {
                        column: {
                            stacking: "normal"
                        },
                        pie: {
                            dataLabels: {
                                enabled: true,
                                formatter: function () {
                                    let sliceIndex = this.point.index;
                                    let sliceName = this.series.chart.axes[0].categories[sliceIndex];
                                    return sliceName;
                                }
                            }
                        },
                        // areaspline: {
                        // 	stacking: chartOptions.stacking
                        // },
                        series: {
                            cursor: "pointer",
                            marker: {
                                enabled: false
                            },
                            dataLabels: {
                                enabled: chartOptions.dataLabels,
                                style: {
                                    fontSize: "14px"
                                },
                                formatter: function () {
                                    return cloudfunctions.formatCreditLabel(
                                        this,
                                        chartOptions.categories,
                                        chartOptions.series
                                    );
                                }
                            }
                        }
                    },
                    legend: {
                        enabled: chartOptions.legend,
                        maxHeight: 150
                    },
                    exporting: {
                        buttons: {
                            contextButton: {
                                menuItems: ["downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG"]
                            }
                        },
                        chartOptions: {
                            subtitle: {
                                text: ""
                            }
                        }
                    },
                    series: chartOptions.series
                };
            },
            formatCreditLabel: (properties, categories, series) => {
                let returnLabel;
                if (properties.x === categories[0] && properties.color != "#41A14E") {
                    returnLabel = cloudfunctions.getWidgetProperty(properties.color, series);
                }
                return returnLabel;
            },
            getWidgetProperty: (color, series) => {
                let selectedBudget;
                series.forEach((item) => {
                    item.color === color && (selectedBudget = item.name);
                });
                return selectedBudget;
            },
            removeExportProjects: (projects, companyCode, fieldName) => {
                let field = fieldName ? fieldName : "project_id";
                let selectedProjects = [];
                // Regex is used to determine which projects are billing export projects
                // Regex will match a billing id => ex. 123456-abcdef-123456
                // If a billing id is caught, it means it is a billing export project and will be stripped
                const regex = /^[a-z0-9]+-[a-z0-9]{6}-[a-z0-9]{6}-[a-z0-9]{6}$/;
                projects.forEach((item) => {
                    let regexMatch = item[field].match(regex)
                    // item[field] &&
                    //     !item[field].includes(companyCode.toLowerCase() + "-01") &&
                    //     selectedProjects.push(item);
                    item[field] &&
                        !regexMatch &&
                        selectedProjects.push(item);
                });
                return selectedProjects;
            },
            removeDisabledProjects: (projects, departments) => {
                let selectedProjects = [];

                if (!departments || !projects) {
                    return projects;
                }

                let disabledDepartment = departments.find((depo) => {
                    return depo.departmentName === "Disabled Projects";
                });

                if (!disabledDepartment || !disabledDepartment.projects || disabledDepartment.projects.length === 0) {
                    return projects;
                }

                let disabledList = disabledDepartment.projects.map((prj) => {
                    return prj.projectID;
                });

                projects.forEach((item) => {
                    if (item.project_id && disabledList.includes(item.project_id)) {
                        return;
                    } else {
                        selectedProjects.push(item);
                    }
                });
                return selectedProjects;
            },
            identifyExportProjects: (project, companyCode, report) => {
                if (
                    report === "consumptionByEntity" ||
                    report === "consumptionByProduct" ||
                    report === "yearConsumptionByMonthAccount"
                ) {
                    return true;
                } else {
                    return project.project_id && !project.project_id.includes(companyCode.toLowerCase() + "-0");
                }
            },
            populateBudgetSeries: (length) => {
                let budSeries = [];
                let title, allowanceColor;
                for (let x = 0; x < 30; x++) {
                    if (x % 2 != 1) {
                        title = "Credit";
                        allowanceColor = "rgba(255, 255, 255, 0.4)";
                    } else {
                        title = "Paid";
                        allowanceColor = "rgba(128, 128, 128, 0.50)";
                    }
                    budSeries.push({
                        name: title,
                        color: allowanceColor,
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        stack: "1",
                        data: new Array(length).fill(0),
                        lineWidth: 5,
                        showInLegend: x < 2
                    });
                }
                return budSeries;
            },
            formatGCPAccounts: (accounts) => {
                let formattedAccounts = [];
                accounts.forEach((account) => {
                    formattedAccounts.push({
                        name: account.displayName,
                        account: account.name.replace("billingAccounts/", "")
                    });
                });
                formattedAccounts = util.sortItems(formattedAccounts, "name", "ASC");
                return formattedAccounts;
            },
            sortAllowancesByDate: (allowances) => {
                if (!allowances) {
                    return [];
                }
                allowances.sort((a, b) => {
                    if (new Date(a.dateActivated) < new Date(b.dateActivated)) {
                        return -1;
                    }
                    if (new Date(a.dateActivated) > new Date(b.dateActivated)) {
                        return 1;
                    }
                    return 0;
                });
                return allowances;
            },
            getLatestBudgetConsumption: (consumptionArray, dateStart) => {
                let consumption = 0;
                consumptionArray.forEach((item) => {
                    if (moment(dateStart).diff(moment(item.date), "days") <= 0) {
                        consumption += item.subtotal;
                    }
                });
                return consumption;
            },
            getCurrentAndFutureBudget: (allowances) => {
                let budgetInfo = {
                    budget: 0,
                    types: [],
                    dateActivated: "2019/01/01"
                };
                allowances.forEach((allowance) => {
                    if (allowance.state != "Consumed") {
                        allowance.state === "Active" && (budgetInfo.dateActivated = allowance.dateActivated);
                        budgetInfo.budget += util.formatCurrencyAsNumber(allowance.amount);
                        let type = allowance.type;
                        type === "PO" && (type = "Paid");
                        budgetInfo.types.push(type);
                    }
                });
                return budgetInfo;
            },
            getCreditAccountsFromBudget: (accounts) => {
                let creditAccounts = [];
                accounts.forEach((account) => {
                    account.allowances.forEach((allowance) => {
                        allowance.type === "Credit" &&
                            !creditAccounts.includes(allowance.accountNum) &&
                            creditAccounts.push(allowance.accountNum);
                    });
                });
                return creditAccounts;
            },
            getBudgetTotals: (accounts, billingAccounts) => {
                let budgets = {
                    credit: 0,
                    creditMaster: 0,
                    po: 0
                };

                if (accounts && accounts.length > 0 && billingAccounts && billingAccounts.length > 0) {
                    accounts.forEach((account) => {
                        account.allowances.forEach((allowance) => {
                            if (!allowance) {
                                return;
                            }

                            let foundAccount = billingAccounts.find((account) => {
                                return account.account === allowance.accountNum;
                            });

                            if (!foundAccount) {
                                return;
                            }

                            if (foundAccount.type === "Credit") {
                                budgets.credit += util.formatCurrencyAsNumber(allowance.amount);

                                if (foundAccount.levelType === "master") {
                                    budgets.creditMaster += util.formatCurrencyAsNumber(allowance.amount);
                                }
                            } else {
                                budgets.po += util.formatCurrencyAsNumber(allowance.amount);
                            }
                        });
                    });
                }

                return budgets;
            },
            assignIDs(scopes, id) {
                scopes.forEach((scope) => {
                    if (scope && !scope[id]) {
                        scope[id] = cloudfunctions.createIDString(12);
                    }
                });
            },
            findGroupIndex(accounts, department) {
                let groupIndex = 0;

                if (accounts && accounts.groups) {
                    accounts.groups.forEach((group, gIndex) => {
                        if (group.departments.includes(department)) {
                            groupIndex = gIndex;
                        }
                    });
                }

                return groupIndex;
            },
            findDepartmentIndex(department, account) {
                let depIndex;

                if (account && account.departments) {
                    account.departments.forEach((item, index) => {
                        item.departmentName === department && (depIndex = index);
                    });
                }
                return depIndex;
            },
            reduceRecentProjects(projects) {
                let reducedProjects = [];
                projects.forEach((prj) => {
                    let foundIndex = _.findIndex(reducedProjects, {
                        project_id: prj.project_id
                    });
                    if (foundIndex == -1) {
                        reducedProjects.push(prj);
                    } else {
                        reducedProjects.splice(foundIndex, 1);
                        reducedProjects.push(prj);
                    }
                });
                return reducedProjects;
            },
            processDepartmentTotalData: (data, accountList) => {
                let chartData = {
                    series: [],
                    remaining: [],
                    categories: []
                };

                let tableData = [];

                data.forEach((item) => {
                    let projectBudget = util.findItem(item.project_id, accountList, "projectID");

                    if (projectBudget) {
                        let budget = {
                            dateActivated: "1969-01-01",
                            amount: "$0"
                        };

                        if (projectBudget.depoType === "Budgeting") {
                            budget = projectBudget.departmentBudget;
                        } else if (projectBudget.currentProjectBudget) {
                            budget = projectBudget.currentProjectBudget;
                        }

                        let projectSubtotal = 0;

                        if (item.breakdown && item.breakdown.length > 0) {
                            item.breakdown.forEach((day) => {
                                if (moment(budget.dateActivated).diff(moment(day.date), "days") <= 0) {
                                    projectSubtotal += day.subtotal;
                                }
                            });
                        }

                        item.department = projectBudget.department;
                        let categoryIndex = chartData.categories.indexOf(item.department);

                        if (categoryIndex !== -1) {
                            if (projectBudget.depoType != "Budgeting") {
                                tableData[categoryIndex].budget += util.formatCurrencyAsNumber(budget.amount);
                            }

                            chartData.series[categoryIndex] += projectSubtotal;
                            tableData[categoryIndex].subtotal += projectSubtotal;

                            tableData[categoryIndex].breakdown.push({
                                project_id: item.project_id,
                                budget: util.formatCurrencyAsNumber(budget.amount),
                                subtotal: projectSubtotal
                            });
                        } else {
                            chartData.categories.push(item.department);
                            chartData.series.push(projectSubtotal);
                            tableData.push({
                                departmentName: item.department,
                                type: projectBudget.depoType,
                                budget: util.formatCurrencyAsNumber(budget.amount),
                                subtotal: projectSubtotal,
                                breakdown: [
                                    {
                                        project_id: item.project_id,
                                        budget: util.formatCurrencyAsNumber(budget.amount),
                                        subtotal: projectSubtotal
                                    }
                                ]
                            });
                        }
                    }
                });

                tableData.forEach((tableItem) => {
                    let parentBudget = tableItem.budget;
                    let parentSubtotal = tableItem.subtotal;
                    let parentRemainging = parentBudget - parentSubtotal;

                    chartData.remaining.push(parentRemainging);
                    tableItem.remaining = util.numberWithCommas(parentRemainging);
                    tableItem.subtotal = util.numberWithCommas(tableItem.subtotal);
                    tableItem.budget = util.numberWithCommas(tableItem.budget);
                    tableItem.percentage = (parentSubtotal / parentBudget) * 100;
                    if (isNaN(tableItem.percentage)) {
                        tableItem.percentage = 0.0;
                    }
                    tableItem.percentage = tableItem.percentage.toFixed(2);

                    tableItem.breakdown.forEach((childItem) => {
                        let childBudget = childItem.budget;
                        let childSubtotal = childItem.subtotal;
                        let childRemainging = childBudget - childSubtotal;

                        if (tableItem.type !== "Budgeting") {
                            childItem.remaining = util.numberWithCommas(childRemainging);
                            childItem.budget = util.numberWithCommas(childBudget);
                            childItem.percentage = (childSubtotal / childBudget) * 100;
                            if (isNaN(childItem.percentage)) {
                                childItem.percentage = 0.0;
                            }
                            childItem.percentage = childItem.percentage.toFixed(2);
                        } else {
                            childItem.budget = "Department Budget";
                            childItem.remaining = "N/A";
                            childItem.percentage = "N/A";
                        }
                        childItem.subtotal = util.numberWithCommas(childSubtotal);
                    });
                });

                return {
                    chartData: chartData,
                    tableData: tableData
                };
            },
            deepDiffMapper: () => {
                let mapping = {
                    VALUE_CREATED: "created",
                    VALUE_UPDATED: "updated",
                    VALUE_DELETED: "deleted",
                    VALUE_UNCHANGED: "unchanged",
                    map: function (obj1, obj2) {
                        if (mapping.isFunction(obj1) || mapping.isFunction(obj2)) {
                            throw "Invalid argument. Function given, object expected.";
                        }
                        if (mapping.isValue(obj1) || mapping.isValue(obj2)) {
                            return {
                                status: mapping.compareValues(obj1, obj2),
                                to: obj1 === undefined ? obj2 : obj1,
                                from: obj1 === undefined ? obj1 : obj2
                            };
                        }

                        let diff = {};
                        for (let key in obj1) {
                            if (mapping.isFunction(obj1[key])) {
                                continue;
                            }

                            let value2 = undefined;
                            if (obj2[key] !== undefined) {
                                value2 = obj2[key];
                            }

                            diff[key] = mapping.map(obj1[key], value2);
                        }
                        for (let key2 in obj2) {
                            if (mapping.isFunction(obj2[key2]) || diff[key2] !== undefined) {
                                continue;
                            }

                            diff[key2] = mapping.map(undefined, obj2[key2]);
                        }

                        return diff;
                    },
                    compareValues: function (value1, value2) {
                        if (value1 === value2) {
                            return mapping.VALUE_UNCHANGED;
                        }
                        if (mapping.isDate(value1) && mapping.isDate(value2) && value1.getTime() === value2.getTime()) {
                            return mapping.VALUE_UNCHANGED;
                        }
                        if (value1 === undefined) {
                            return mapping.VALUE_DELETED;
                        }
                        if (value2 === undefined) {
                            return mapping.VALUE_CREATED;
                        }
                        return mapping.VALUE_UPDATED;
                    },
                    isFunction: (x) => {
                        return angular.isFunction(x);
                    },
                    isArray: (x) => {
                        return angular.isArray(x);
                    },
                    isDate: (x) => {
                        return angular.isDate(x);
                    },
                    isObject: (x) => {
                        return angular.isObject(x);
                    },
                    isValue: (x) => {
                        return !mapping.isObject(x) && !mapping.isArray(x);
                    }
                };
                return mapping;
            }
        };
        return cloudfunctions;
    }
})();

(function () {

    angular.module("burWood").controller("CloudContactController", CloudContactController);

    /** @ngInject */
    function CloudContactController(user_info, $uibModalInstance, Service, DTOptionsBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions().withOption("responsive", true);
        vm.loading = true;

        vm.addtolist = function (name, caller_id, email) {
            $uibModalInstance.close(email);
        };

        vm.close = function () {
            $uibModalInstance.dismiss("cancel");
        };

        Service.getQuery(
            {
                company: user_info.company,
                active_status: true
            },
            "sys_user",
            function (data) {
                vm.loading = false;
                if (data.error) {
                    vm.total_result = 0;
                    vm.users = [];
                } else {
                    vm.total_result = data.count;
                    vm.users = data.results;
                }
            }
        );
    }

})();
(function () {
    angular.module("burWood").controller("CloudBillingReportController", CloudBillingReportController);
    
    /** @ngInject */
    function CloudBillingReportController(
        _,
        $log,
        user_info,
        DTOptionsBuilder,
        $timeout,
        $uibModal,
        $scope,
        BCSServer,
        moment,
        apiBasePath,
        cloud,
        util,
        cloudProcessor,
        $http,
        FileSaver,
        Blob,
        Service,
        Alerts,
        $state
    ) {
        let vm = this;
        vm.capitalizeFirstLetter = util.capitalizeFirstLetter;
        vm.enterprise = user_info.cloudEnterprise;
        vm.noInvoiceData = true;
        vm.toDate = true;
        vm.dtInstance = {};
        vm.invoiceReady = false;
        vm.alerts = [];

        vm.invoiceSelectOptions = [
            {
                text: "PDF",
                value: "pdf",
                mime: "application/pdf"
            },
            {
                text: "Excel",
                value: "xlsx",
                mime: "application/vnd.openxmlformats-officedocument.spreadsheetml"
            },
            {
                text: "CSV",
                value: "csv",
                mime: "text/x-csv"
            }
        ];
        
        vm.invoiceYears = util.getYearList();
        vm.selectedInvoiceYear = vm.invoiceYears[vm.invoiceYears.length - 1];

        vm.invoiceLevels = [
            {
                name: "Company",
                id: "company"
            }
        ];

        vm.selectedInvoiceLevel = vm.invoiceLevels[0].id;
        vm.invoiceSelected = {}; // Must be an object

        vm.reportProjects = [];
        vm.selectedReportLevel = vm.invoiceLevels[0].id;

        let width = angular.element(".report-height .panel-body").width();
        let height = 665;

        vm.datePlaceholder = "Select Custom Date Range";

        //checking if user is admin
        if (
            user_info.group &&
            (user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins Read Only") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins") != -1)
        ) {
            vm.isAdmin = true;
        }

        if (user_info.group && user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") != -1) {
            vm.burwoodAdmin = true;
        }

        user_info.company === "61a4a1401bdd8810beaec9176e4bcbef" && (vm.mit = true);

        vm.years = util.getYearList();
        vm.months = util.getMonthList();

        vm.selectedYear = vm.years[vm.years.length - 1];
        vm.selectedMonth = moment().subtract(1, "month").startOf("month").format("MMMM");

        vm.rates = [
            {
                id: 7,
                name: "1 Week"
            },
            {
                id: 14,
                name: "2 Weeks"
            },
            {
                id: 30,
                name: "1 Month"
            }
        ];

        vm.selectedRate = vm.rates[0].id;

        vm.companySelect = ["All"];
        vm.selectedAlertLevel = vm.companySelect[0];

        vm.rateConfig = {
            rate: 7,
            dateStart: moment().subtract(7, "d").format("YYYY-MM-DD")
        };

        $timeout(() => {
            vm.chartLoading = true;
            vm.loading = true;
        }, 10);

        vm.close_notice = (alert, index) => {
            vm[alert.type].splice(index, 1);
        };

        vm.createAlertMessage = (alert) => {
            vm[alert.type].push({
                status: alert.status,
                msg: alert.msg,
                class: alert.class
            });
            Alerts.storeAlert({
                type: alert.status,
                message: alert.msg,
                user: user_info.email,
                company: user_info.company_name,
                location: $state.current.name,
                tags: ["Cloud Reports"]
            });
        };

        vm.changeRate = (rate) => {
            vm.rateConfig = {
                rate: rate,
                dateStart: moment().subtract(rate, "d").format("YYYY-MM-DD")
            };
        };

        //configuration for column filter
        let columnFilter = {
            aoColumns: [
                null,
                null,
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                }
            ]
        };

        vm.setupDatatables = (sourceReport) => {
            //datatable configurations

            let copyColumnFilter = angular.copy(columnFilter);
            if (sourceReport && sourceReport.basicTable) {
                copyColumnFilter.aoColumns[1] = {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                };
                copyColumnFilter.aoColumns[3] = null;
            }

            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM("fBrtip")
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    },
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withButtons(vm.setupDatableButtons())
                .withColumnFilter(copyColumnFilter)
                .withOption("iDisplayLength", 300)
                .withOption("responsive", true);
        };

        vm.setupDatableButtons = () => {
            //button export configurations
            return [
                {
                    extend: "colvis",
                    text: "Toggle Columns"
                },
                {
                    extend: "collection",
                    text: "Export",
                    buttons: [
                        {
                            extend: "excel",
                            title: () => {
                                return vm.customTitle;
                            },
                            filename: () => {
                                return vm.customTitle.replace(/ /g, "_");
                            },
                            exportOptions: {
                                columns: ":not(.nosort)",
                                format: {
                                    body: function (data) {
                                        // Strip $ from salary column to make it numeric
                                        return data.replace(/[$,]/g, "");
                                    }
                                }
                            }
                        },
                        {
                            extend: "pdf",
                            title: () => {
                                return vm.customTitle;
                            },
                            filename: () => {
                                return vm.customTitle.replace(/ /g, "_");
                            },
                            customize: (doc) => {
                                doc.pageMargins = [5, 5, 5, 5];
                                doc.styles.tableHeader.fontSize = 10;
                                doc.defaultStyle.fontSize = 6;
                            },
                            exportOptions: {
                                columns: ":not(.nosort)"
                            }
                        },
                        {
                            extend: "csv",
                            title: () => {
                                return vm.customTitle;
                            },
                            filename: () => {
                                return vm.customTitle.replace(/ /g, "_");
                            },
                            exportOptions: {
                                columns: ":not(.nosort)"
                            }
                        }
                    ]
                }
            ];
        };

        vm.defaultChartTypes = [
            {
                name: "Column",
                id: "column"
            },
            {
                name: "Bar",
                id: "bar"
            },
            {
                name: "Line",
                id: "line"
            },
            {
                name: "Stream",
                id: "streamgraph"
            },
            {
                name: "Pie",
                id: "pie"
            }
        ];

        vm.chartType = vm.defaultChartTypes[0].id;

        vm.cummulativeSelect = ["Cumulative", "Daily"];

        vm.cummulative = vm.cummulativeSelect[1];

        vm.standardReports = [
            {
                id: "consumptionOverTimeAll",
                view: "project_cost_by_day_minimal",
                dataSource: "bigQuery",
                defaultChart: "line",
                chartIndexes: [2],
                noDate: false,
                widgets: true,
                projectSelect: false,
                name: "Consumption Over Time"
            },
            {
                id: "yearConsumptionByMonthAll",
                view: "project_cost_by_month_breakdown",
                dataSource: "bigQuery",
                defaultChart: "column",
                chartIndexes: [0, 1, 2, 3, 4],
                noDate: false,
                widgets: true,
                projectSelect: false,
                name: "Consumption By Month"
            },
            {
                id: "serviceConsumptionOverTime",
                view: "project_cost_by_day_service",
                dataSource: "bigQuery",
                defaultChart: "line",
                chartIndexes: [2],
                noDate: false,
                widgets: true,
                projectSelect: true,
                name: "Service Consumption Over Time"
            },
            {
                id: "entityConsumptionOverTime",
                view: "project_cost_by_day_service",
                dataSource: "bigQuery",
                defaultChart: "line",
                chartIndexes: [2],
                noDate: false,
                widgets: true,
                projectSelect: true,
                name: "Entity Consumption Over Time"
            },
            {
                id: "consumptionByProject",
                view: "project_cost_total",
                dataSource: "bigQuery",
                defaultChart: "column",
                chartIndexes: [0, 1, 2, 3, 4],
                noDate: false,
                widgets: true,
                projectSelect: false,
                name: "Consumption By Project"
            },
            {
                id: "consumptionRateByProject",
                view: "project_cost_by_day_minimal",
                dataSource: "bigQuery",
                defaultChart: "column",
                chartIndexes: [0, 1, 2, 3, 4],
                noDate: true,
                widgets: true,
                projectSelect: false,
                name: "Consumption Rate By Project"
            },
            {
                id: "currentBudgetStatus",
                view: "project_cost_by_day_minimal",
                dataSource: "bigQuery",
                defaultChart: "column",
                chartIndexes: [0, 1],
                noDate: true,
                widgets: false,
                projectSelect: false,
                name: "Current Budget Status"
            },
            {
                id: "consumptionByEntity",
                defaultChart: "column",
                view: "project_cost_by_entity",
                dataSource: "bigQuery",
                chartIndexes: [0, 1, 4],
                noDate: false,
                widgets: true,
                projectSelect: false,
                name: "Consumption By Entity"
            },
            {
                id: "consumptionByProduct",
                defaultChart: "column",
                view: "project_cost_by_service_desc",
                dataSource: "bigQuery",
                chartIndexes: [0, 1, 4],
                noDate: false,
                widgets: true,
                projectSelect: false,
                name: "Consumption By Service"
            },
            {
                id: "consumptionByLabel",
                view: "project_cost_by_label",
                dataSource: "bigQuery",
                defaultChart: "column",
                chartIndexes: [0, 1, 4],
                noDate: false,
                widgets: true,
                projectSelect: false,
                name: "Consumption By Label"
            },
            {
                id: "consumptionByAccount",
                view: "invoice_cost_by_account",
                dataSource: "bigQuery",
                defaultChart: "column",
                chartIndexes: [0, 1, 4],
                noDate: false,
                widgets: true,
                projectSelect: false,
                name: "Consumption By Account"
            },
            {
                id: "invoiceCostByAccount",
                view: "invoice_cost_by_account_date",
                dataSource: "bigQuery",
                // dataSource: "gcpStorage",
                defaultChart: "column",
                chartIndexes: [0, 1, 4],
                noDate: true,
                widgets: true,
                invoiceMonth: true,
                projectSelect: false,
                name: "Invoice Cost By Account"
            },
            {
                id: "invoiceExport",
                view: "invoice_export",
                dataSource: "bigQuery",
                defaultChart: "column",
                chartIndexes: [0, 1, 4],
                noDate: true,
                widgets: true,
                invoiceMonth: true,
                projectSelect: false,
                name: "Invoice Export"
            }
        ];

        vm.adminReports = [
            {
                id: "userReport",
                dataSource: "ga",
                defaultChart: "column",
                chartIndexes: [0, 1, 4],
                noDate: false,
                basicTable: true,
                widgets: false,
                projectSelect: false,
                name: "User Analytics"
            },
            {
                id: "permissionReport",
                dataSource: "gcp",
                defaultChart: "column",
                chartIndexes: [0, 1, 4],
                noDate: true,
                widgets: false,
                projectSelect: false,
                name: "GCP Permission Report"
            }
        ];

        vm.burwoodReports = [
            {
                id: "alertReport",
                dataSource: "mongo",
                defaultChart: "column",
                chartIndexes: [0, 1, 4],
                noDate: false,
                widgets: false,
                projectSelect: false,
                name: "Alert Log Report"
            }
        ];

        if (vm.isAdmin) {
            vm.standardReports = vm.standardReports.concat(vm.adminReports);
        }

        if (vm.burwoodAdmin) {
            vm.standardReports = vm.standardReports.concat(vm.burwoodReports);
        }

        vm.selectedReport = vm.standardReports[0];

        vm.tabView = "report";

        let defaultConfig = {
            chart: {
                zoomType: "x",
                type: "column",
                width: width,
                height: height
            },
            exporting: {
                enabled: true
            },
            title: {
                text: " "
            },
            yAxis: {
                min: 0
            },
            series: []
        };

        // intial config for all highcharts
        vm.chartConfig = Object.assign({}, defaultConfig);

        let toggleReport = sessionStorage.getItem("toggleReport");
        if (toggleReport) {
            console.log(toggleReport, "toggle reports")
            toggleReport = angular.fromJson(toggleReport);
            vm.toggleConfig = toggleReport.toggleConfig;
        } else {
            vm.toggleConfig = {
                reportDate: true,
                reportStandard: true,
                reportOptions: true,
                dateRangeShow: true
            };
        }

        vm.sourceType = "All";

        vm.date = {
            startDate: null,
            endDate: null
        };
        vm.datePicker = {
            startDate: null,
            endDate: null
        };

        vm.dateHolder = {};
        vm.timeRangeHolder;

        vm.changeButtonClassed = (selectedClass) => {
            angular.element(".thisMonth").removeClass("btn-clicked");
            angular.element(".lastMonth").removeClass("btn-clicked");
            angular.element(".date-picker").removeClass("btn-clicked");
            angular.element(".to-date").removeClass("btn-clicked");
            if (selectedClass !== ".date-picker") {
                angular.element(selectedClass).addClass("btn-clicked");
            }
        };

        // main handler for time method selection
        vm.toggleTime = (range) => {
            vm.toDate = false;
            vm.timeRange = range;
            let month = new Date().getMonth();
            let year = new Date().getFullYear();
            if (range === "This Month") {
                vm.changeButtonClassed(".thisMonth");

                vm.date.startDate = moment([year, month]).format("YYYY-MM-DD");
                vm.date.endDate = moment(vm.date.startDate).endOf("month").format("YYYY-MM-DD");
            } else if (range === "Last Month") {
                vm.changeButtonClassed(".lastMonth");

                if (month === 0) {
                    vm.date.startDate = moment([year - 1, 11]).format("YYYY-MM-DD");
                } else {
                    vm.date.startDate = moment([year, month - 1]).format("YYYY-MM-DD");
                }
                vm.date.endDate = moment(vm.date.startDate).endOf("month").format("YYYY-MM-DD");
            } else if (range === "To Date") {
                vm.toDate = true;
                vm.date = {
                    startDate: null,
                    endDate: null
                };
                vm.changeButtonClassed(".to-date");
            } else {
                vm.changeButtonClassed(".date-picker");
            }

            if (range === "rate") {
                vm.changeButtonClassed(".to-date");
            }
        };

        vm.toggleTime("This Month");

        vm.changeReport = (report) => {
            let sourceReport = cloud.determineDataSource(vm.standardReports, report);

            vm.chartType = sourceReport.defaultChart;
            vm.chartTypes = sourceReport.chartIndexes.map((item) => {
                return vm.defaultChartTypes[item];
            });

            if (report === "consumptionRateByProject" || report === "currentBudgetStatus") {
                vm.toDate = false;
                vm.dateHolder = angular.copy(vm.date);
                vm.date.endDate = moment().format("YYYY-MM-DD");
                vm.date.startDate = moment().subtract(7, "days").format("YYYY-MM-DD");
                vm.date.startDate = vm.date.startDate.toString();
                vm.date.endDate = vm.date.endDate.toString();
                vm.timeRangeHolder = vm.timeRange;
                vm.toggleTime("rate");
            } else if (report === "invoiceCostByAccount" || report === "invoiceExport") {
                vm.toDate = false;
                vm.dateHolder = angular.copy(vm.date);
                vm.date.startDate = moment(
                    vm.selectedYear + "-" + util.padNumbers(vm.months.indexOf(vm.selectedMonth) + 1, 2) + "-01"
                ).format("YYYY-MM-DD");
                vm.date.endDate = moment(vm.date.startDate).endOf("month").format("YYYY-MM-DD");
                vm.date.startDate = vm.date.startDate.toString();
                vm.date.endDate = vm.date.endDate.toString();
                vm.timeRangeHolder = vm.timeRange;
                vm.toggleTime();
            } else {
                if (!angular.equals(vm.dateHolder, {})) {
                    vm.date = vm.dateHolder;
                    vm.timeRange = vm.timeRangeHolder;
                }
                vm.toggleTime(vm.timeRange);
            }
        };

        // jquery handlers for UI table resizing
        angular.element("body").on("click", "button.applyBtn", () => {
            vm.date.startDate = moment(vm.datePicker.startDate).format("YYYY-MM-DD");
            vm.date.startDate = vm.date.startDate.toString();
            vm.date.endDate = moment(vm.datePicker.endDate).format("YYYY-MM-DD");
            vm.date.endDate = vm.date.endDate.toString();
            vm.toggleTime(vm.date.startDate + " - " + vm.date.endDate);
        });

        vm.fetchAllAccounts = () => {
            BCSServer.postData({}, "/cloud_companies_all", (response) => {
                if (response) {
                    const companies = response.map((company) => company.companyName);
                    companies.sort();
                    vm.companySelect = vm.companySelect.concat(companies);
                }
            });
        };
        if (vm.burwoodAdmin) {
            vm.fetchAllAccounts();
        }

        vm.getProjectList = () => {
            vm.projectListLoading = true;
            BCSServer.postData(
                {
                    view: "project_list"
                },
                "/big_query/get_query",
                (response) => {
                    vm.projectList = response;
                    vm.projectListLoading = false;
                    if (vm.projectList && vm.projectList.length > 0) {
                        vm.noInvoiceData = false;
                        vm.projectList = cloud.removeExportProjects(vm.projectList, user_info.company_code);
                        vm.projectList = cloud.removeDisabledProjects(vm.projectList, vm.departments);
                        vm.getProjectBudget();
                        vm.fetchFirstConsumption();
                    } else {
                        vm.projectList = [];
                        vm.createNoDataChart();
                        vm.noInvoiceData = true;
                        vm.chartLoading = false;
                    }
                }
            );
        };
        vm.getProjectList();

        vm.projectsLoading = true;
        vm.fetchAccountProjects = (accounts) => {
            BCSServer.postData(
                {
                    accounts: accounts
                },
                "/gcp_billing_projects",
                (response) => {
                    let projectList = [];
                    if (response && response.success) {
                        projectList = cloud.removeExportProjects(
                            response.accountProjects,
                            user_info.company_code,
                            "projectId"
                        );
                    }
                    vm.recentProjectList = projectList.map((project) => {
                        return project.projectId;
                    });
                    vm.projectsLoading = false;
                }
            );
        };

        // Fetches project list from GCP
        vm.fetchGCPProjectList = (orgID) => {
            BCSServer.postData(
                {
                    orgID: orgID
                },
                "/cloud_org_structure",
                (response) => {
                    vm.projectNames = {};
                    if (response && response.success) {
                        response.data.forEach((project) => {
                            vm.projectNames[project.projectId] = project.name;
                        });
                    }
                }
            );
        };

        if (user_info.gcpOrgID) {
            vm.fetchGCPProjectList(user_info.gcpOrgID);
        }

        vm.fetchFirstConsumption = () => {
            let queryProjects = !vm.isAdmin ? cloud.getRawProjectArray(vm.projectList, "project_id") : null;

            let composeParameters = {
                view: "first_consumption",
                parameters: {
                    dateRange: {
                        startDate: null,
                        endDate: null
                    },
                    projects: queryProjects
                }
            };

            BCSServer.postData(composeParameters, "/big_query/get_query", (response) => {
                if (response && response.length > 0) {
                    vm.formatInvoiceRanges(response[0].date);
                } else {
                    vm.noInvoiceData = true;
                }
            });
        };

        vm.formatInvoiceRanges = (beginDate) => {
            let dateStart = moment(beginDate);
            let dateEnd = moment();
            let timeValues = [];

            while (dateEnd > dateStart || dateStart.format("M") === dateEnd.format("M")) {
                timeValues.push({
                    startDate: dateStart.startOf("month").format("YYYY-MM-DD"),
                    endDate: dateStart.endOf("month").format("YYYY-MM-DD")
                });
                dateStart.add(1, "month");
            }

            timeValues.pop();
            vm.invoiceRanges = timeValues;
        };

        vm.fetchAccounts = () => {
            vm.company = {};
            BCSServer.postData(
                {
                    companyCode: user_info.company_code
                },
                "/cloud_accounts",
                (response) => {
                    if (response) {
                        vm.company = response;
                        vm.companyPO = response.companyPO;
                        vm.invoicingGroup = vm.company.invoicingRole === "group";
                        if (response.providedDiscount && response.providedDiscount > 0) {
                            vm.providedDiscount = true;
                        }
                        vm.centralTax = response.centralTax * 0.01 || 0;
                        if (response.accounts && response.accounts.length > 0) {
                            vm.billingAccounts = response.accounts;
                            vm.stridesAccountExists = vm.billingAccounts.find((account) => {
                                return account.pricebook === "strides";
                            });
                        }
                        vm.pos = response.pos || [];
                        if (user_info.company_code !== "UNIAME") {
                            vm.fetchAccountProjects(vm.company.accounts);
                        } else {
                            vm.recentProjectList = [];
                            vm.projectsLoading = false;
                        }
                    } else {
                        vm.billingAccounts = [];
                    }
                }
            );
        };

        vm.fetchAccounts();

        vm.getProjectBudget = () => {
            BCSServer.postData(
                {
                    method: "get",
                    company: user_info.company,
                    role: "IT"
                },
                "/cloud_budgets",
                (response) => {
                    vm.invoiceReady = true;
                    let groupDepartments = [];
                    if (response && response.length > 0) {
                        if (response[0].company && response[0].company === user_info.company) {
                            vm.rawBudgets = angular.copy(response[0]);
                            vm.groups = response[0].groups;
                            vm.departments = response[0].departments;
                            vm.accountList = cloud.extractAllProjects(response[0]);
                            // vm.firstBudgetDate = cloud.getFirstBudgetDate(vm.accountList);
                        } else {
                            vm.rawBudgets = [];
                            vm.accountList = [];
                            // vm.firstBudgetDate = moment(new Date()).format("YYYY-MM-DD");
                        }

                        let disabledDepo = response[0].departments.find((depo) => {
                            return depo.departmentName === "Disabled Projects";
                        });
                        if (disabledDepo) {
                            vm.disabledProjects = disabledDepo.projects.map((prj) => {
                                return prj.projectID;
                            });
                        } else {
                            vm.disabledProjects = [];
                        }

                        if (!vm.isAdmin) {
                            groupDepartments = cloud.findGroupDepartments(user_info.email, vm.rawBudgets.groups);
                            let depoAccounts = cloud.findUserProjects(
                                user_info,
                                response[0].departments,
                                true,
                                groupDepartments
                            );
                            let accounts = cloud.findUserProjects(user_info, vm.accountList);
                            accounts.accountList = accounts.accountList.concat(depoAccounts.accountList);
                            accounts.projectList = accounts.projectList.concat(depoAccounts.projectList);
                            vm.accountList = accounts.accountList;
                            vm.projectList = accounts.projectList;
                            vm.flatCompany = cloud.flattenProjectUserOrg(response[0], user_info, groupDepartments);
                        } else {
                            vm.flatCompany = cloud.flattenOrg(response[0]);
                            if (vm.rawBudgets.groups) {
                                vm.flatCompany.group = vm.rawBudgets.groups.map((group) => {
                                    return group.groupName;
                                });
                            } else {
                                vm.flatCompany.group = [];
                            }
                        }
                        vm.totalAllocatedCredits = util.numberWithCommas(cloud.getTotalBudget(vm.accountList));
                        if (vm.projectList.length > 0) {
                            vm.selectedProject = vm.projectList[0].project_id;
                            vm.runReport(vm.selectedReport.id);
                        } else {
                            vm.createNoDataChart(vm.selectedReport.id);
                        }
                    } else {
                        vm.accountList = [];
                        // vm.firstBudgetDate = moment(new Date()).format("YYYY-MM-DD");
                        vm.removeReportsWithNoAccount();
                        vm.selectedProject = vm.projectList[0].project_id;
                        vm.runReport(vm.selectedReport.id);
                        vm.chartLoading = false;
                        vm.departments = [];
                        vm.disabledProjects = [];
                        vm.flatCompany = {
                            group: [],
                            department: [],
                            project: []
                        };
                        vm.rawBudgets = {
                            groups: [],
                            departments: []
                        };
                    }

                    if (!vm.isAdmin) {
                        vm.flatCompany.group = cloud.listAssociatedGroups(vm.rawBudgets.groups, groupDepartments);
                    }

                    if (vm.flatCompany.group.length > 0) {
                        vm.invoiceLevels.push({
                            name: "Group",
                            id: "group"
                        });
                    }
                    if (vm.flatCompany.department.length > 0) {
                        vm.invoiceLevels.push({
                            name: "Department",
                            id: "department"
                        });
                    }

                    vm.invoiceLevels.push({
                        name: "Project",
                        id: "project"
                    });

                    if (vm.isAdmin) {
                        if (vm.pos && vm.pos.length > 0) {
                            vm.invoicePOs = vm.pos.filter((po) => {
                                return po.invoicePO;
                            });
                        } else {
                            vm.invoicePOs = [];
                        }
                        if (vm.invoicePOs.length > 0 && !vm.invoicingGroup) {
                            vm.invoiceLevels.push({
                                name: vm.company.purchaseOrderTerm || "Purchase Order",
                                id: "po"
                            });
                            vm.flatCompany.po = vm.invoicePOs.map((po) => {
                                return po.number;
                            });
                        }
                    }

                    vm.reportLevels = angular.copy(vm.invoiceLevels);

                    if (vm.invoicingGroup) {
                        vm.invoiceLevels.shift();
                        vm.selectedInvoiceLevel = vm.invoiceLevels[0].id;
                    }

                    vm.changeReport(vm.selectedReport.id);
                    vm.fetchInvoices();
                }
            );
        };

        vm.hideReportPOScope = (scope) => {
            return scope.id !== "po";
        };

        vm.removeReportsWithNoAccount = () => {
            let reportsToRemove = ["currentBudgetStatus"];
            reportsToRemove.forEach((report) => {
                let index = _.findIndex(vm.standardReports, {
                    id: report
                });
                vm.standardReports.splice(index, 1);
            });
        };

        vm.selectBudget = () => {
            vm.accountDetails = {};
            vm.accountList.forEach((item) => {
                if (item.projectID === vm.selectedProject) {
                    vm.accountDetails = item;
                }
            });
        };

        vm.selectChartChange = () => {
            vm.chartConfig.chart.type = vm.chartType;
            vm.chartConfig.series.forEach((item) => {
                item.type = vm.chartType;
            });
        };

        //toggle minimizing of sections
        vm.minimizeSection = (section) => {
            vm.toggleConfig[section] = !vm.toggleConfig[section];
            let toggleReport = sessionStorage.getItem("toggleReport");
            if (toggleReport) {
                toggleReport = angular.fromJson(toggleReport);
                toggleReport.toggleConfig = vm.toggleConfig;
            } else {
                toggleReport = {
                    toggleConfig: vm.toggleConfig
                };
            }
            sessionStorage.setItem("toggleReport", angular.toJson(toggleReport));
        };

        // clears any filtering applied to the datatable
        vm.clearFilter = () => {
            vm.filter = false;
            let table = angular.element(".table").DataTable();
            table.search("").columns().search("").draw();
        };

        vm.determineDataSource = (reportID, returnField) => {
            let dataSource = _.findWhere(vm.standardReports, {
                id: reportID
            });
            if (returnField) {
                return dataSource[returnField];
            } else {
                return dataSource;
            }
        };

        vm.checkAccountIAM = (accounts, company, report) => {
            let queryAccounts = accounts.map((account) => {
                return account.account;
            });
            BCSServer.postData(
                {
                    accounts: queryAccounts
                },
                "/cloud_check_accounts_iam",
                (response) => {
                    if (response.error) {
                        vm.createAlertMessage({
                            type: "alerts",
                            class: "danger",
                            msg: response.error,
                            status: "fail"
                        });
                        vm.createNoDataChart(report);
                    } else {
                        response.msg.forEach((account) => {
                            let billingID = Object.keys(account)[0];
                            if (account[billingID].length === 0) {
                                company.missingAccountList.push({
                                    acct: billingID,
                                    missing: response.permissions.join()
                                });
                            }
                        });
                    }
                    return chartProcessors[report](report);
                }
            );
        };

        vm.checkProjectIAM = (projects, company, report) => {
            BCSServer.postData(
                {
                    projects: projects
                },
                "/cloud_check_projects_iam",
                (response) => {
                    if (response.error) {
                        vm.createAlertMessage({
                            type: "alerts",
                            class: "danger",
                            msg: response.error,
                            status: "fail"
                        });
                    } else {
                        response.msg.forEach((project) => {
                            let projectID = Object.keys(project)[0];
                            if (project[projectID].length === 0) {
                                company.missingProjectList.push({
                                    project_id: projectID,
                                    missing: response.permissions.join()
                                });
                            }
                        });
                    }
                    vm.checkAccountIAM(company.accounts, company, report);
                }
            );
        };

        vm.invoiceExportData = null;

        vm.reports = {
            //BigQuery Fetch
            bigQuery: (reportParameters, reportID) => {
                $log.info("BQ REPORT ID: " + reportID);
                // Cut the report ID to the new endpoints for invoice cost by account reports.
                if(reportID == "invoiceCostByAccount") {
                    $log.info("HITTING NEW BIGQUERY SERVICE"  + reportID);
                    chartProcessors[reportID]({}, reportID);
                    vm.parentColumns = null;
                } else {
                    BCSServer.postData(reportParameters, "/big_query/get_query", (response) => {
                        $log.info("HITTING LEGACY ENDPOINT " + reportID);
                        if (response && angular.isArray(response) && response.length > 0) {
                            if (reportParameters.multi) {
                                response = cloud.removeExportProjects(response, user_info.company_code);
                            }
                            if (reportID === "invoiceExport" && !vm.invoiceExportData) {
                                let modifiedParameters = angular.copy(reportParameters);
                                modifiedParameters.view = "invoice_by_po";
                                modifiedParameters.parameters.dateBreakdown = true;
                                vm.invoiceExportData = response;
                                vm.reports.bigQuery(modifiedParameters, "invoiceExport");
                            } else {
                                chartProcessors[reportID](response, reportID);
                                vm.parentColumns = null;
                            }
                        } else {
                            vm.createNoDataChart(reportID);
                        }
                    });
                }
            },
            //GCP Fetch
            gcp: (reportParameters, report) => {
                let company = vm.company;
                company.projectList = [...new Set(vm.recentProjectList)];
                company.missingProjectList = [];
                company.missingAccountList = [];
                vm.checkProjectIAM(company.projectList, company, report);
            },
            //Google Analytics Fetch
            ga: (reportParameters, reportID) => {
                BCSServer.postData(reportParameters, "/google_analytics/get_query", (response) => {
                    if (response && response.invoice && response.users) {
                        chartProcessors[reportID](response, reportID);
                    } else {
                        vm.createNoDataChart(reportID);
                    }
                });
            },
            //Google Storage Fetch
            gcpStorage: (reportParameters, reportID) => {
                BCSServer.postData(reportParameters, "/google_storage/get_invoice", (response) => {
                    if (response && response.length > 0) {
                        chartProcessors[reportID](response, reportID);
                    } else {
                        vm.createNoDataChart(reportID);
                    }
                });
            },
            //MongoDB Fetch
            mongo: (reportParameters, reportID) => {
                BCSServer.postData(reportParameters, "/get_alerts", (response) => {
                    if (response && !response.error) {
                        chartProcessors[reportID](response, reportID);
                    } else {
                        vm.createNoDataChart(reportID);
                    }
                });
            }
        };

        vm.composeReportLevels = (composeType) => {
            let reportProjects = [];
            switch (vm["selected" + composeType + "Level"]) {
                case "company":
                    reportProjects = cloud.getRawProjectArray(vm.projectList, "project_id");
                    break;
                case "group":
                    if (vm.rawBudgets.groups) {
                        let reportGroup = vm.rawBudgets.groups.find((group) => {
                            return group.groupName === vm["selected" + composeType + "Name"];
                        });
                        if (reportGroup) {
                            reportGroup.departments.forEach((depo) => {
                                let reportDepo = vm.rawBudgets.departments.find(function (depo2) {
                                    return depo2.departmentID === depo;
                                });
                                if (reportDepo && reportDepo.projects && reportDepo.projects.length > 0) {
                                    reportDepo.projects.forEach((prj) => {
                                        reportProjects.push(prj.projectID);
                                    });
                                }
                            });
                        }
                    }
                    break;
                case "department":
                    let reportDepartment = util.findItem(
                        vm["selected" + composeType + "Name"],
                        vm.rawBudgets.departments,
                        "departmentName"
                    );
                    if (reportDepartment && reportDepartment.projects && reportDepartment.projects.length > 0) {
                        reportDepartment.projects.forEach((prj) => {
                            reportProjects.push(prj.projectID);
                        });
                    }
                    break;
                case "project":
                    reportProjects = [vm["selected" + composeType + "Name"]];
                    break;
                case "po":
                    reportProjects = null;
                    break;
                default:
                    reportProjects = cloud.getRawProjectArray(vm.projectList, "project_id");
                    break;
            }
            return reportProjects;
        };

        // Determine if report needs to fetch from Orbitera or BigQuery
        vm.runReport = (report) => {
            vm.chartLoading = true;
            vm.selectedReportRun = report;
            vm.alerts = [];

            vm.resetWidgets();
            vm.selectBudget();

            vm.sourceReport = cloud.determineDataSource(vm.standardReports, report);

            // let queryProjects = !vm.isAdmin ? cloud.getRawProjectArray(vm.projectList, "project_id") : null;
            let queryProjects = vm.composeReportLevels("Report");

            if (queryProjects.length === 0) {
                vm.createNoDataChart(report);
                return;
            }

            vm.setupDatatables(vm.sourceReport);

            vm.customTitle = vm.sourceReport.name;

            if (vm.sourceReport.dataSource === "mongo") {
                const mongoParameters = {
                    date: vm.date,
                    company: vm.selectedAlertLevel
                };
                return vm.reports[vm.sourceReport.dataSource](mongoParameters, report);
            } else if (vm.sourceReport.dataSource === "gcpStorage") {
                let storageParameters = {
                    invoiceBegin: moment(vm.date.startDate).format("MM-DD-YY"),
                    invoiceEnd: moment(vm.date.endDate).format("MM-DD-YY"),
                    companyCode: user_info.company_code
                };
                vm.reports[vm.sourceReport.dataSource](storageParameters, report);
                return;
            } else if (vm.sourceReport.dataSource === "ga") {
                let gaParameters = {
                    dateRange: {
                        startDate: moment(vm.date.startDate).format("YYYY-MM-DD"),
                        endDate: moment(vm.date.endDate).format("YYYY-MM-DD")
                    },
                    company: user_info.company_name
                };
                vm.reports[vm.sourceReport.dataSource](gaParameters, report);
                return;
            }

            let composeParameters = {
                selectedProject: vm.selectedProject,
                report: vm.sourceReport,
                toDate: vm.toDate,
                date: vm.date,
                projects: queryProjects,
                source: vm.sourceType,
                cummulative: vm.cummulative,
                admin: vm.isAdmin,
                dateType: vm.sourceReport.invoiceMonth ? "invoiceMonth" : "dateRange",
                reportType: "report"
            };

            if (report === "currentBudgetStatus") {
                composeParameters.toDate = null;
                composeParameters.date = {
                    // startDate: vm.firstBudgetDate,
                    startDate: moment(new Date("2018-01-01")).format("YYYY-MM-DD"),
                    endDate: moment(new Date()).format("YYYY-MM-DD")
                };
            }

            let reportParameters = cloud.composeReportParameters(composeParameters);

            vm.sourceReport.dataSource && vm.reports[vm.sourceReport.dataSource](reportParameters, report);
        };

        let colors = ["#f4ba30", "#db5760", "#579c8b", "#536794", "#9e5d9c", "#8870b3"];

        let chartProcessors = {
            consumptionRateByProject: (data, report) => {
                let processedData = cloudProcessor.processRateData(data, vm.accountList, vm.rateConfig);
                console.log(processedData,"processed data")
                vm.tableData = processedData.tableData;
                let chartData = processedData.chartData;
                let seriesTotal = chartData.series.reduce((a, b) => {
                    return a + b;
                }, 0);
                vm.widget1 = {
                    title: "Average Spend Rate (All Projects)",
                    value: "$ " + util.numberWithCommas(seriesTotal / chartData.series.length)
                };

                let series = [
                    {
                        name: "Consumption Rate",
                        color: "#db5760",
                        stack: "0",
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        data: chartData.series,
                        lineWidth: 5
                    }
                ];

                vm.setUpChart(
                    {
                        series: series,
                        categories: chartData.categories,
                        chartType: "column",
                        title: cloud.determineDataSource(vm.standardReports, report, "name").toUpperCase(),
                        dataLabels: false,
                        yMin: 0,
                        yVisible: true,
                        yText: "Daily Average Spend ($) / Rate",
                        legend: true
                    },
                    report
                );
            },
            currentBudgetStatus: (data, report) => {
                let processedData = cloudProcessor.processCurrentBudgets(data, vm.accountList);
                vm.tableData = processedData.tableData;
                let chartData = processedData.chartData;

                let series = [
                    {
                        name: "Remaining Budget",
                        color: "#579c8b",
                        stack: "0",
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        data: chartData.remaining
                    },
                    {
                        name: "Consumption",
                        color: "#db5760",
                        stack: "0",
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        data: chartData.series,
                        lineWidth: 5
                    }
                ];

                vm.setUpChart(
                    {
                        series: series,
                        categories: chartData.categories,
                        chartType: "column",
                        title: cloud.determineDataSource(vm.standardReports, report, "name").toUpperCase(),
                        dataLabels: false,
                        yMin: 0,
                        yVisible: true,
                        yText: "Dollars ($)",
                        legend: true
                    },
                    report
                );
            },
            consumptionOverTimeAll: (data, report) => {
                let processedData = vm.processDataForChart(data, "date", report);
                vm.prepWidgets(report);
                vm.setUpChart(
                    {
                        series: processedData.series,
                        categories: processedData.categories,
                        chartType: "line",
                        title: cloud.determineDataSource(vm.standardReports, report, "name").toUpperCase(),
                        dataLabels: false,
                        yMin: 0,
                        yVisible: true,
                        yText: "Dollars ($)",
                        legend: true,
                        zoomSubtitle: true
                    },
                    report
                );
            },
            serviceConsumptionOverTime: function (data, report) {
                this.consumptionOverTimeAll(data, report);
            },
            entityConsumptionOverTime: function (data, report) {
                this.consumptionOverTimeAll(data, report);
            },
            yearConsumptionByMonthAll: (data, report) => {
                let processedData = vm.processDataForChart(data, "month", report);
                vm.prepWidgets(report);
                let series = [
                    {
                        name: "Consumption",
                        color: "#db5760",
                        stack: "0",
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        data: processedData.series,
                        lineWidth: 5
                    }
                ];
                vm.setUpChart(
                    {
                        series: series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: cloud.determineDataSource(vm.standardReports, report, "name").toUpperCase(),
                        dataLabels: false,
                        yMin: 0,
                        yVisible: true,
                        yText: "Dollars ($)",
                        legend: true
                    },
                    report
                );
            },
            consumptionByAccount: (data, report) => {
                let processedData = vm.processDataForChart(data, "billing_account_id", report);
                vm.prepWidgets(report);
                let series = [
                    {
                        name: "Consumption",
                        color: "#db5760",
                        stack: "0",
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        data: processedData.series,
                        lineWidth: 5
                    }
                ];

                vm.setUpChart(
                    {
                        series: series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: cloud.determineDataSource(vm.standardReports, report, "name").toUpperCase(),
                        dataLabels: false,
                        yMin: 0,
                        yVisible: true,
                        yText: "Dollars ($)",
                        legend: true
                    },
                    report
                );
            },
            consumptionByProject: (data, report) => {
                let processedData = vm.processDataForChart(data, "project_id", report);
                vm.prepWidgets(report);
                let series = [
                    {
                        name: "Consumption",
                        color: "#db5760",
                        stack: "0",
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        data: processedData.series,
                        lineWidth: 5
                    }
                ];

                let remainingSeries = {
                    name: "Remaining Budget",
                    color: "#579c8b",
                    stack: "0",
                    borderColor: "rgba(128, 128, 128, 0.0)",
                    data: processedData.budget
                };

                vm.toDate ? series.unshift(remainingSeries) : null;

                vm.sourceType === "All" && vm.toDate ? (series = series.concat(processedData.budgetSeries)) : null;

                vm.setUpChart(
                    {
                        series: series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: cloud.determineDataSource(vm.standardReports, report, "name").toUpperCase(),
                        dataLabels: false,
                        yMin: 0,
                        yVisible: true,
                        yText: "Dollars ($)",
                        legend: true
                    },
                    report
                );
            },
            consumptionByLabel: (data, report) => {
                let processedData = vm.processDataForChart(data, "billing_label", report);
                vm.prepWidgets(report);
                let series = [
                    {
                        name: "Consumption",
                        color: "#db5760",
                        data: processedData.series,
                        lineWidth: 5
                    }
                ];
                vm.setUpChart(
                    {
                        series: series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: cloud.determineDataSource(vm.standardReports, report, "name").toUpperCase(),
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true,
                        legend: false
                    },
                    report
                );
            },
            consumptionByEntity: (data, report) => {
                let processedData = vm.processDataForChart(data, "entity", report);
                vm.prepWidgets(report);
                let series = [
                    {
                        name: "Consumption",
                        color: "#db5760",
                        data: processedData.series,
                        lineWidth: 5
                    }
                ];
                vm.setUpChart(
                    {
                        series: series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: cloud.determineDataSource(vm.standardReports, report, "name").toUpperCase(),
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true,
                        legend: false
                    },
                    report
                );
            },
            consumptionByProduct: (data, report) => {
                let processedData = vm.processDataForChart(data, "service_desc", report);
                vm.prepWidgets(report);
                let series = [
                    {
                        name: "Consumption",
                        color: "#db5760",
                        data: processedData.series,
                        lineWidth: 5
                    }
                ];
                vm.setUpChart(
                    {
                        series: series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: cloud.determineDataSource(vm.standardReports, report, "name").toUpperCase(),
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true,
                        legend: false
                    },
                    report
                );
            },
            invoiceCostByAccount: (data, report) => {
                // TODO: Refactor code to decouple it from the calling function
                // Currently this is resulting in two BQ queries:
                // one from the calling function (passing in the data param), and one in here.


               // vm.rawBudgets contains the response from the cloudBudgets endpoint.
               // This can be used to get PO's from projects.
               // ProjectData is an array of project objects with data related to the project.
               // Pass this to the backend to map projects to PO's.
               // TODO: Refactor to perform this data manipulation in the backend.
               let projectData = cloud.extractAllProjects(vm.rawBudgets);
               $log.info("PROJECT DATA");
               $log.info(projectData);
                

                // Extract billing accounts from billing account objectsin viewmodel.
                let billingAccountList = vm.billingAccounts.map(accountObject => accountObject.account);
 
                // Send billing accounts and invoice date range to the backend.
                BCSServer.postData(
                    {   
                        projectData: projectData,
                        billingAccounts: billingAccountList,
                        startDate: vm.date.startDate,
                        endDate:  vm.date.endDate,
                        sourceType: vm.sourceType,
                        reportLevel: vm.selectedReportLevel,
                        reportLevelName: vm.selectedReportName
                    }, "/big_query/costs_billing_account_breakdown_table", (response) => {
                    let mappedBudgets = response;
                    $log.info("mapped budgets");
                    $log.info(mappedBudgets);
                    let processedData = vm.processDataForChart(mappedBudgets, "billing_account_id", report);
                    $log.info("data processed for chart");
                    $log.info(processedData);
                    // let processedData = processDataForChart(data, "billing_account_id", report);
                    vm.prepWidgets(report);
                    let series = [
                        {
                            name: "Consumption",
                            color: "#db5760",
                            stack: "0",
                            borderColor: "rgba(128, 128, 128, 0.0)",
                            data: processedData.series,
                            lineWidth: 5
                        }
                    ];

                    vm.setUpChart(
                        {
                            series: series,
                            categories: processedData.categories,
                            chartType: "column",
                            title: cloud.determineDataSource(vm.standardReports, report, "name").toUpperCase(),
                            dataLabels: false,
                            yMin: 0,
                            yVisible: true,
                            yText: "Dollars ($)",
                            legend: false
                        },
                        report
                    );
                });
            },
            invoiceExport: (data, report) => {
                let projectData = cloud.extractAllProjects(vm.rawBudgets);
                let composedPOData = cloudProcessor.matchPOInvoiceData(
                    projectData,
                    data,
                    vm.date.startDate,
                    vm.company
                );

                let invoiceExportProcessed = cloudProcessor.processInvoiceExportData(vm.invoiceExportData);

                composedPOData.forEach((item) => {
                    const foundIndex = invoiceExportProcessed.tableData.findIndex(
                        (prj) => prj.project_id === item.project_id
                    );
                    if (foundIndex !== -1) {
                        item.pos.forEach((po) => {
                            invoiceExportProcessed.tableData.splice(foundIndex, 0, po);
                        });
                    }
                });

                vm.tableData = invoiceExportProcessed.tableData;
                vm.totalConsumption = invoiceExportProcessed.totalConsumption;

                vm.prepWidgets(report);

                let series = [
                    {
                        name: "Consumption",
                        color: "#db5760",
                        stack: "0",
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        data: invoiceExportProcessed.chartData.series,
                        lineWidth: 5
                    }
                ];

                vm.setUpChart(
                    {
                        series: series,
                        categories: invoiceExportProcessed.chartData.categories,
                        chartType: "column",
                        title: cloud.determineDataSource(vm.standardReports, report, "name").toUpperCase(),
                        dataLabels: false,
                        yMin: 0,
                        yVisible: true,
                        yText: "Dollars ($)",
                        legend: true
                    },
                    report
                );
                vm.invoiceExportData = null;
            },
            userReport: (data, report) => {
                let usersPrepped = cloudProcessor.reformatUsers(vm.rawBudgets, data);

                vm.tableData = usersPrepped.tableData;

                let series = [
                    {
                        name: "Projects",
                        color: "#579c8b",
                        stack: "0",
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        data: usersPrepped.chartData.series,
                        lineWidth: 5
                    }
                ];

                vm.setUpChart(
                    {
                        series: series,
                        categories: usersPrepped.chartData.categories,
                        chartType: "column",
                        title: cloud.determineDataSource(vm.standardReports, report, "name").toUpperCase(),
                        dataLabels: false,
                        yMin: 0,
                        yVisible: true,
                        yText: "Users",
                        legend: true
                    },
                    report
                );
            },
            permissionReport: (report) => {
                // let permissionsFormatted = cloudProcessor.formatPermissions(vm.companies);
                let permissionsFormatted = cloudProcessor.formatPermissions([vm.company], vm.disabledProjects);

                vm.processDataForChart(permissionsFormatted.tableData, "user", report);

                let series = [
                    {
                        name: "Projects",
                        color: "#579c8b",
                        stack: "0",
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        data: permissionsFormatted.chartData.series,
                        lineWidth: 5
                    }
                ];

                vm.setUpChart(
                    {
                        series: series,
                        categories: permissionsFormatted.chartData.categories,
                        chartType: "column",
                        title: cloud.determineDataSource(vm.standardReports, report, "name").toUpperCase(),
                        dataLabels: false,
                        yMin: 0,
                        yVisible: true,
                        yText: "Missing Permissions",
                        legend: true
                    },
                    report
                );
            },
            alertReport: (data, report) => {
                let alerts = cloudProcessor.processAlertData(data);

                vm.processDataForChart(alerts.tableData, "user", report);

                let series = [
                    {
                        name: "Alerts",
                        color: "#579c8b",
                        stack: "0",
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        data: alerts.chartData.series,
                        lineWidth: 5
                    }
                ];

                vm.setUpChart(
                    {
                        series: series,
                        categories: alerts.chartData.categories,
                        chartType: "column",
                        title: "Failed Alert Logs",
                        dataLabels: false,
                        yMin: 0,
                        yVisible: true,
                        yText: "# of Failed Alerts",
                        legend: true
                    },
                    report
                );
            }
        };

        vm.processAllProjectsOverTime = (dateArray, data, fieldID) => {
            let projectObj = {};
            let projectObjDaily = {};
            data.forEach((project) => {
                vm.totalConsumption += project.subtotal;

                project.breakdown.forEach((date, dateIndex) => {
                    if (dateIndex === 0) {
                        date.cummulative = date.subtotal;
                    } else {
                        date.cummulative = project.breakdown[dateIndex - 1].cummulative + date.subtotal;
                    }

                    if (projectObj[project[fieldID]]) {
                        projectObj[project[fieldID]][dateArray.indexOf(date.date)] = date.cummulative;
                        projectObjDaily[project[fieldID]][dateArray.indexOf(date.date)] = date.subtotal;
                    } else {
                        projectObj[project[fieldID]] = new Array(dateArray.length).fill(0);
                        projectObjDaily[project[fieldID]] = new Array(dateArray.length).fill(0);
                        projectObj[project[fieldID]][dateArray.indexOf(date.date)] = date.subtotal;
                        projectObjDaily[project[fieldID]][dateArray.indexOf(date.date)] = date.subtotal;
                    }
                });
            });
            vm.dailyConsumption = vm.totalConsumption / Object.keys(projectObj).length / dateArray.length;
            return {
                cummulative: projectObj,
                daily: projectObjDaily
            };
        };

        vm.truncateDateData = (dateArray, projectObj, data) => {
            let dateArraySlice = [];
            let indexDateArray = [];

            dateArray.forEach((item, index) => {
                if (new Date(item) >= new Date(vm.date.startDate) && new Date(item) <= new Date(vm.date.endDate)) {
                    dateArraySlice.push(item);
                    indexDateArray.push(index);
                }
            });

            dateArray = dateArraySlice;

            for (var project in projectObj.cummulative) {
                let indexedDate = [];
                let indexedDateDaily = [];
                indexDateArray.forEach((item) => {
                    indexedDate.push(projectObj.cummulative[project][item]);
                    indexedDateDaily.push(projectObj.daily[project][item]);
                });
                projectObj.cummulative[project] = indexedDate;
                projectObj.daily[project] = indexedDateDaily;
            }

            data.forEach((item) => {
                let newBreakdown = [];
                item.breakdown.forEach(function (item2) {
                    if (
                        new Date(item2.date) >= new Date(vm.date.startDate) &&
                        new Date(item2.date) <= new Date(vm.date.endDate)
                    ) {
                        newBreakdown.push(item2);
                    }
                });
                item.breakdown = newBreakdown;
            });

            return dateArray;
        };

        vm.processProjectTotalData = (report, tableItem, processedData, index) => {
            report === "consumptionByProject" && processedData.series.push(tableItem.subtotal || 0);

            let projectbudget = util.findItem(tableItem.project_id, vm.accountList, "projectID");
            let budgetExists;
            let poBudget = 0;
            let creditBudget = 0;

            if (projectbudget) {
                vm.singleBudgetExists = true;
                budgetExists = true;
                let allowanceCount = {
                    po: 0,
                    credit: 0
                };

                projectbudget.allowances = cloud.sortAllowancesByDate(projectbudget.allowances);
                projectbudget.allowances.reverse();

                if (!vm.enterprise) {
                    projectbudget.allowances.forEach((item) => {
                        if (item.state !== "Active" && item.state !== "Future") {
                            return;
                        }
                        let factor;
                        if (item.type === "Credit") {
                            factor = allowanceCount.credit * 2;
                            allowanceCount.credit++;
                            creditBudget += util.formatCurrencyAsNumber(item.amount);
                        } else {
                            factor = allowanceCount.po * 2 + 1;
                            allowanceCount.po++;
                            allowanceCount.credit++;
                            poBudget += util.formatCurrencyAsNumber(item.amount);
                        }
                        processedData.budgetSeries[factor].data[index] = util.formatCurrencyAsNumber(item.amount);
                    });
                    projectbudget = cloud.getTotalBudget([projectbudget]);
                } else {
                    if (projectbudget.allowances.length > 0) {
                        let item = projectbudget.allowances[projectbudget.allowances.length - 1];
                        creditBudget += util.formatCurrencyAsNumber(item.amount);
                        processedData.budgetSeries[0].data[index] = util.formatCurrencyAsNumber(item.amount);
                        projectbudget = projectbudget.monthlyBudget || 0;
                    }
                }
            } else {
                budgetExists = false;
                projectbudget = tableItem.subtotal;
            }

            vm.sourceType === "PO" && (projectbudget = poBudget);
            vm.sourceType === "Credit" && (projectbudget = creditBudget);

            let remaining;
            if (projectbudget) {
                remaining = projectbudget - tableItem.subtotal;
                processedData.budget.push(remaining);
            } else {
                remaining = 0;
                processedData.budget.push(remaining);
            }

            tableItem.budget = projectbudget || 0;
            tableItem.remaining = remaining;
            budgetExists
                ? (tableItem.percentage = (tableItem.subtotal / projectbudget) * 100)
                : (tableItem.percentage = 100);
            (tableItem.percentage === Infinity || isNaN(tableItem.percentage)) && (tableItem.percentage = 0);
        };

        vm.processMonthData = (data, processedData) => {
            vm.totalConsumption = 0;

            data.sort((a, b) => {
                if (new Date(a.year, a.month) < new Date(b.year, a.month)) {
                    return -1;
                }
                if (new Date(a.year, a.month) > new Date(b.year, a.month)) {
                    return 1;
                }
                return 0;
            });

            data.forEach((tableItem) => {
                vm.totalConsumption += tableItem.subtotal;

                let categoryName = vm.months[tableItem["month"] - 1] + " 20" + tableItem["year"];

                tableItem.month = categoryName;

                let monthIndex = processedData.categories.indexOf(categoryName);

                if (monthIndex === -1) {
                    processedData.categories.push(categoryName);
                    processedData.series.push({
                        y: tableItem["subtotal"],
                        name: categoryName
                    });
                } else {
                    processedData.series[monthIndex].y += tableItem["subtotal"];
                }
            });

            return processedData;
        };

        vm.processDataForChart = (data, categoryField, report) => {

            $log.info(data);

            // initializes series and category object for Highcahrts
            let processedData = {
                categories: [],
                series: [],
                budget: [],
                budgetSeries: cloud.populateBudgetSeries(data.length)
            };

            let dateArray = [];

            let serviceList;
            vm.totalConsumption = 0;
            vm.singleBudgetExists = false;
            vm.tableData = [];
            vm.dailyData = [];
            vm.storedCummulative = null;
            vm.projectMultiTimeData = {};

            if (report === "serviceConsumptionOverTime" || report === "entityConsumptionOverTime") {
                //creating a series for each etity type
                serviceList = cloud.getServiceOrEntityList(data, report);
                serviceList.forEach((service, index) => {
                    processedData.series.push({
                        name: service,
                        color: colors[index % 6],
                        data: new Array(data.length).fill(0)
                    });
                });
            }

            //Getting date array for over time reports then processing data against that array
            if (report === "yearConsumptionByMonthAll") {
                processedData = vm.processMonthData(data, processedData);

                vm.tableData = data;
            } else if (
                report === "consumptionOverTimeAll" ||
                report === "serviceConsumptionOverTime" ||
                report === "entityConsumptionOverTime"
            ) {
                let fieldID = "project_id";

                report === "serviceConsumptionOverTime" && (fieldID = "service_description");
                report === "entityConsumptionOverTime" && (fieldID = "sku_description");

                // composes date array base on total possible date ranges of data
                dateArray = cloud.getDateArray(data, false, vm.date);

                // sorts all data into dataArray structure
                vm.projectMultiTimeData = vm.processAllProjectsOverTime(dateArray, data, fieldID);
                // projectObj = vm.projectMultiTimeData.cummulative;

                // if daterange is selected, truncates the toDate data in order to maintain consumption totals for beginning point
                !vm.toDate && (dateArray = vm.truncateDateData(dateArray, vm.projectMultiTimeData, data));

                // sets chart categories to dateArray
                processedData.categories = dateArray;

                // assigns the table data to the newly composed data
                vm.tableData = data;
            } else if (report === "userReport" || report === "permissionReport" || report === "alertReport") {
                //do nothing
            } else {
                data.forEach((item, index) => {
                    if (
                        report != "consumptionByLabel" &&
                        report != "invoiceCostByAccount" &&
                        report != "consumptionByAccount" &&
                        report != "invoiceExport" &&
                        !cloud.identifyExportProjects(item, user_info.company_code, report)
                    ) {
                        return;
                    }

                    let tableItem = angular.copy(item);

                    tableItem.date && tableItem.date.value && (tableItem.date = tableItem.date.value);

                    //Processes data for charts by report type
                    switch (report) {
                        case "consumptionByProduct":
                        case "consumptionByEntity":
                            processedData.categories.push(tableItem[categoryField]);
                            break;
                        case "consumptionByProject":
                            processedData.categories.push(tableItem[categoryField]);
                            vm.processProjectTotalData(report, tableItem, processedData, index);
                            break;
                        case "consumptionByLabel":
                            processedData.categories.push(tableItem[categoryField]);
                            break;
                        case "consumptionByAccount":
                        case "invoiceCostByAccount":
                            let account = vm.billingAccounts.find((account) => {
                                return account.account === tableItem[categoryField];
                            });

                            let accountName;

                            if (account.name) {
                                accountName = account.name + " (" + account.account + ")";
                            } else {
                                accountName = account.account;
                            }

                            tableItem.billing_account_id = accountName;

                            processedData.categories.push(accountName);
                            break;
                        default:
                            break;
                    }

                    vm.tableData.push(tableItem);
                    vm.totalConsumption += tableItem.subtotal;
                });
                $log.info("TABLE DATA");
                $log.info(vm.tableData);
                vm.dailyConsumption = vm.totalConsumption / data.length;
            }

            let dataFields;
            let costFields;
            let percentageFields;
            let staticFieldParent;
            let staticFieldChild;
            let childField;
            let grandchildField;
            let sortField;
            let sortOrder;
            let parentSortFields;

            switch (report) {
                case "consumptionByAccount":
                case "invoiceCostByAccount":
                    vm.colorList = cloud.generateChartColors(data.length, colors);
                    vm.totalConsumption = 0;

                    let subTotalField = report === "invoiceCostByAccount" ? "consumption" : "subtotal";
                    data.forEach((item, index) => {
                        vm.totalConsumption += item[subTotalField];
                        processedData.series.push({
                            y: item[subTotalField],
                            color: vm.colorList[index]
                        });
                    });

                    dataFields = ["billing_account_id"];
                    costFields = [];
                    percentageFields = [];
                    staticFieldParent = [
                        "cost_total",
                        "contract_cost",
                        "discount_total",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal",
                        "user_subtotal"
                    ];
                    staticFieldChild = [
                        "cost_total",
                        "contract_cost",
                        "discount_total",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal",
                        "user_subtotal"
                    ];
                    childField = "project_id";
                    grandchildField = "po";
                    parentSortFields = ["subtotal", "user_subtotal"];
                    sortField = "subtotal";
                    sortOrder = "DESC";
                    break;
                case "consumptionByProject":
                    report === "consumptionByProject" && (vm.projectTotals = angular.copy(vm.tableData));
                    dataFields = ["budget", "remaining", "percentage", "dailyAverage", "daysLeftAtRate", "project_id"];
                    costFields = ["budget", "remaining"];
                    percentageFields = ["percentage"];
                    staticFieldParent = [
                        "cost_total",
                        "contract_cost",
                        "discount_total",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal"
                    ];
                    staticFieldChild = [
                        "cost",
                        "contract_cost",
                        "discount",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal"
                    ];
                    childField = "service_desc";
                    grandchildField = "entity";
                    parentSortFields = [
                        "cost_total",
                        "contract_cost",
                        "discount_total",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal"
                    ];
                    sortField = "cost_total";
                    sortOrder = "DESC";
                    break;
                case "yearConsumptionByMonthAll":
                    dataFields = ["month"];
                    costFields = [];
                    percentageFields = [];
                    staticFieldParent = [
                        "cost_total",
                        "contract_cost",
                        "discount_total",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal"
                    ];
                    staticFieldChild = [
                        "cost",
                        "contract_cost",
                        "discount",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal"
                    ];
                    childField = "project_id";
                    grandchildField = "service_desc";
                    parentSortFields = ["cost_total"];
                    sortField = "project_id";
                    sortOrder = "ASC";
                    break;
                case "consumptionOverTimeAll":
                    vm.colorList = cloud.generateChartColors(data.length, colors);
                    let colorIndex = 0;

                    for (var project in vm.projectMultiTimeData.cummulative) {
                        processedData.series.push({
                            name: project,
                            color: vm.colorList[colorIndex],
                            data: vm.projectMultiTimeData.cummulative[project],
                            fillOpacity: 0.05,
                            type: "areaspline"
                        });
                        colorIndex++;
                    }

                    dataFields = ["project_id"];
                    costFields = [];
                    percentageFields = [];
                    staticFieldParent = ["subtotal"];
                    staticFieldChild = ["subtotal"];
                    childField = "date";
                    grandchildField = null;
                    parentSortFields = [
                        "cost_total",
                        "contract_cost",
                        "discount_total",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal"
                    ];
                    sortField = "date";
                    sortOrder = "ASC";
                    break;
                case "serviceConsumptionOverTime":
                case "entityConsumptionOverTime":
                    vm.colorList = cloud.generateChartColors(data.length, colors);
                    let colorIndexService = 0;

                    for (var service in vm.projectMultiTimeData.cummulative) {
                        processedData.series.push({
                            name: service,
                            color: vm.colorList[colorIndexService],
                            data: vm.projectMultiTimeData.cummulative[service],
                            fillOpacity: 0.05,
                            type: "areaspline"
                        });
                        colorIndexService++;
                    }

                    dataFields = ["project_id"];
                    costFields = [];
                    percentageFields = [];
                    staticFieldParent = ["subtotal"];
                    staticFieldChild = ["subtotal"];
                    childField = "date";
                    grandchildField = null;
                    parentSortFields = [
                        "cost_total",
                        "contract_cost",
                        "discount_total",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal"
                    ];
                    sortField = "date";
                    sortOrder = "ASC";
                    break;
                case "consumptionByLabel":
                    vm.colorList = cloud.generateChartColors(data.length, colors);
                    vm.totalConsumption = 0;

                    data.forEach((item, index) => {
                        vm.totalConsumption += item.subtotal;
                        processedData.series.push({
                            y: item.subtotal,
                            color: vm.colorList[index]
                        });
                    });

                    dataFields = ["billing_label"];
                    costFields = [];
                    percentageFields = [];
                    staticFieldParent = [
                        "cost_total",
                        "contract_cost",
                        "discount_total",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal"
                    ];
                    staticFieldChild = [
                        "cost",
                        "contract_cost",
                        "discount",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal"
                    ];
                    childField = "service_desc";
                    grandchildField = "entity";
                    parentSortFields = ["cost_total"];
                    sortField = "cost_total";
                    sortOrder = "DESC";
                    break;
                case "consumptionByEntity":
                    vm.colorList = cloud.generateChartColors(data.length, colors);
                    vm.totalConsumption = 0;

                    data.forEach((item, index) => {
                        vm.totalConsumption += item.subtotal;
                        processedData.series.push({
                            y: item.subtotal,
                            color: vm.colorList[index]
                        });
                    });

                    $log.info(data);

                    dataFields = ["entity"];
                    costFields = [];
                    percentageFields = [];
                    staticFieldParent = [
                        "cost_total",
                        "contract_cost",
                        "discount_total",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal"
                    ];
                    staticFieldChild = [
                        "cost",
                        "contract_cost",
                        "discount",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal"
                    ];
                    childField = "service_desc";
                    grandchildField = null;
                    parentSortFields = ["cost_total"];
                    sortField = "cost_total";
                    sortOrder = "DESC";
                    break;
                case "consumptionByProduct":
                    vm.colorList = cloud.generateChartColors(data.length, colors);
                    vm.totalConsumption = 0;

                    data.forEach((item, index) => {
                        vm.totalConsumption += item.subtotal;
                        processedData.series.push({
                            y: item.subtotal,
                            color: vm.colorList[index]
                        });
                    });

                    dataFields = ["service_desc"];
                    costFields = [];
                    percentageFields = [];
                    staticFieldParent = [
                        "cost_total",
                        "contract_cost",
                        "discount_total",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal"
                    ];
                    staticFieldChild = [
                        "cost",
                        "contract_cost",
                        "discount",
                        "consumption",
                        "gcp_invoice_cost",
                        "stride_discount",
                        "i2_discount",
                        "general_discount",
                        "markup",
                        "adjustments",
                        "subtotal"
                    ];
                    childField = "entity";
                    grandchildField = null;
                    parentSortFields = ["cost_total"];
                    sortField = "cost_total";
                    sortOrder = "DESC";
                    break;
                case "userReport":
                    dataFields = ["project_id"];
                    costFields = [];
                    percentageFields = [];
                    staticFieldParent = ["email", "weeklySummary", "alerts"];
                    staticFieldChild = ["email", "weeklySummary", "alerts"];
                    childField = "email";
                    grandchildField = null;
                    parentSortFields = [];
                    sortField = "email";
                    sortOrder = "DESC";

                    vm.tableData = data;
                    break;
                case "permissionReport":
                    dataFields = ["companyName"];
                    costFields = [];
                    percentageFields = [];
                    staticFieldParent = ["companyName", "missingAccountPermissions"];
                    staticFieldChild = ["missingProjectPermissions", "disabled"];
                    childField = "projectID";
                    grandchildField = null;
                    parentSortFields = [];
                    sortField = "projectID";
                    sortOrder = "DESC";

                    vm.tableData = data;
                    break;
                case "alertReport":
                    dataFields = ["alerts"];
                    costFields = [];
                    percentageFields = [];
                    staticFieldParent = ["company", "alerts"];
                    staticFieldChild = ["location", "tags"];
                    childField = "message";
                    grandchildField = null;
                    parentSortFields = [];
                    sortField = "message";
                    sortOrder = "DESC";

                    vm.tableData = data;

                    break;
                default:
                    break;
            }

            let formattedTable = restructureTable(
                vm.tableData,
                dataFields,
                costFields,
                percentageFields,
                staticFieldParent,
                staticFieldChild,
                childField,
                grandchildField,
                sortField,
                sortOrder,
                parentSortFields
            );

            if (formattedTable.length > 2000) {
                let slimTable = [];
                vm.slimTable = true;
                formattedTable.forEach((item) => {
                    item.parent && slimTable.push(item);
                });
                vm.tableData = slimTable;
            } else {
                vm.slimTable = false;
                vm.tableData = formattedTable;
            }
            return processedData;
        };

        function restructureTable(
            data,
            dataFields,
            costFields,
            percentageFields,
            staticFieldParent,
            staticFieldChild,
            childField,
            grandchildField,
            sortField,
            sortOrder,
            parentSortFields
        ) {
            let flattenedData = [];
            if (data.length === 0) {
                return [];
            }
            data.forEach((parent) => {
                let referenceArray = [];
                let breakdown = [];
                parent.show = true;
                parent.parent = true;
                parentSortFields.forEach((parentSort) => {
                    parent["parent_" + parentSort] = parent[parentSort];
                });
                costFields.forEach((costField) => {
                    typeof parent[costField] == "number"
                        ? (parent[costField] = "$" + parent[costField].toFixed(2))
                        : (parent[costField] = "$0.00");
                });
                percentageFields.forEach((percentageField) => {
                    typeof parent[percentageField] == "number"
                        ? (parent[percentageField] = parent[percentageField].toFixed(2) + "%")
                        : (parent[percentageField] = "0%");
                });
                parent.breakdown.forEach((child) => {
                    if (!child) {
                        return;
                    }
                    let referenceIndex = referenceArray.indexOf(child[childField]);
                    parentSortFields.forEach((parentSort) => {
                        child["parent_" + parentSort] = parent["parent_" + parentSort];
                    });
                    staticFieldParent.forEach((staticParent, childIndex) => {
                        child[staticParent] = child[staticFieldChild[childIndex]];
                    });
                    dataFields.forEach((dataField) => {
                        parent[dataField] && (child[dataField] = parent[dataField]);
                    });
                    costFields.forEach((costField) => {
                        parent[costField] && (child[costField] = parent[costField]);
                    });
                    percentageFields.forEach((percentageField) => {
                        parent[percentageField] && (child[percentageField] = parent[percentageField]);
                    });
                    if (referenceIndex === -1) {
                        referenceArray.push(child[childField]);

                        let breakdownChild = child;
                        child.child = true;
                        parentSortFields.forEach((parentSort) => {
                            child["parent_" + parentSort] = parent["parent_" + parentSort];
                        });
                        child.show = false;

                        dataFields.forEach((dataField) => {
                            breakdownChild[dataField] = parent[dataField];
                        });
                        costFields.forEach((costField) => {
                            breakdownChild[costField] = parent[costField];
                        });
                        percentageFields.forEach((percentageField) => {
                            breakdownChild[percentageField] = parent[percentageField];
                        });
                        breakdownChild[childField] = child[childField];
                        staticFieldParent.forEach((staticParent, childIndex) => {
                            breakdownChild[staticParent] = child[staticFieldChild[childIndex]];
                        });
                        if (grandchildField) {
                            let grandchildBreakdown = [
                                {
                                    grandchild: true,
                                    show: false
                                }
                            ];
                            parentSortFields.forEach((parentSort) => {
                                grandchildBreakdown[0]["parent_" + parentSort] = parent["parent_" + parentSort];
                            });
                            grandchildBreakdown[0][grandchildField] = child[grandchildField];
                            staticFieldParent.forEach((staticParent, childIndex) => {
                                grandchildBreakdown[0][staticParent] = child[staticFieldChild[childIndex]];
                            });
                            dataFields.forEach((dataField) => {
                                grandchildBreakdown[0][dataField] = parent[dataField];
                            });
                            costFields.forEach((costField) => {
                                grandchildBreakdown[0][costField] = parent[costField];
                            });
                            percentageFields.forEach((percentageField) => {
                                grandchildBreakdown[0][percentageField] = parent[percentageField];
                            });
                            breakdownChild.breakdown = grandchildBreakdown;
                        }
                        breakdown.push(breakdownChild);
                    } else {
                        staticFieldParent.forEach((staticParent, childIndex) => {
                            breakdown[referenceIndex][staticParent] += child[staticFieldChild[childIndex]];
                        });
                        if (grandchildField) {
                            let grandchildBreakdownAdd = {
                                grandchild: true,
                                show: false
                            };
                            parentSortFields.forEach((parentSort) => {
                                grandchildBreakdownAdd["parent_" + parentSort] = parent["parent_" + parentSort];
                            });
                            grandchildBreakdownAdd[grandchildField] = child[grandchildField];
                            staticFieldParent.forEach((staticParent, childIndex) => {
                                grandchildBreakdownAdd[staticParent] = child[staticFieldChild[childIndex]];
                            });
                            dataFields.forEach((dataField) => {
                                grandchildBreakdownAdd[dataField] = parent[dataField];
                            });
                            costFields.forEach((costField) => {
                                grandchildBreakdownAdd[costField] = parent[costField];
                            });
                            percentageFields.forEach((percentageField) => {
                                grandchildBreakdownAdd[percentageField] = parent[percentageField];
                            });
                            breakdown[referenceIndex].breakdown.push(grandchildBreakdownAdd);
                        }
                    }
                });
                breakdown = util.sortItems(breakdown, sortField, sortOrder, true);
                parent.breakdown = breakdown;
                flattenedData.push(parent);
                parent.breakdown.forEach((child) => {
                    child.breakdown = util.sortItems(child.breakdown, sortField, sortOrder, true);
                    flattenedData.push(child);
                    child.breakdown.forEach((grandchild) => {
                        flattenedData.push(grandchild);
                    });
                });
            });
            return flattenedData;
        }

        vm.prepWidgets = () => {
            vm.widget1 = {
                title: "TOTAL CONSUMPTION",
                value: "$ " + util.numberWithCommas(vm.totalConsumption)
            };
            vm.widget1Daily = {
                title: "CONSUMPTION (DAILY AVERAGE)",
                value: "$ " + util.numberWithCommas(vm.dailyConsumption)
            };
        };

        vm.resetWidgets = () => {
            vm.widget1 = {
                title: "",
                value: ""
            };
            vm.widget1Daily = {
                title: "",
                value: ""
            };
            vm.widget2 = {
                title: "",
                value: ""
            };
            vm.widget3 = {
                title: "",
                value: ""
            };
        };

        vm.changeCummulativeChart = () => {
            !vm.storedCummulative && (vm.storedCummulative = angular.copy(vm.chartConfig.series));
            if (vm.cummulative === "Daily") {
                if (
                    vm.selectedReport.id === "consumptionOverTimeAll" ||
                    vm.selectedReport.id === "serviceConsumptionOverTime" ||
                    vm.selectedReport.id === "entityConsumptionOverTime"
                ) {
                    vm.switchMultiTimeReportData();
                }
            } else {
                vm.chartConfig.series = angular.copy(vm.storedCummulative);
                vm.chartConfig.plotOptions.series.dataLabels.formatter = function () {
                    return cloud.formatCreditLabel(this, vm.chartConfig.xAxis.categories, vm.chartConfig.series);
                };
            }
        };

        vm.switchMultiTimeReportData = () => {
            vm.chartConfig.series = [];
            let colorIndex = 0;
            for (var project in vm.projectMultiTimeData.daily) {
                vm.chartConfig.series.push({
                    name: project,
                    color: vm.colorList[colorIndex],
                    data: vm.projectMultiTimeData.daily[project],
                    fillOpacity: 0.05,
                    type: "areaspline"
                });
                colorIndex++;
            }
        };

        // vm.switchSingleTimeReportData = () => {
        //     vm.chartConfig.series = [vm.chartConfig.series[vm.chartConfig.series.length - 1]];
        //     vm.chartConfig.series[0].data = vm.dailyData;
        //     // vm.chartConfig.series[0].name = 'Consumption (Daily)';
        // }

        vm.setUpChart = (chartOptions, report) => {
            vm.chartTitle = chartOptions.title;
            vm.chartConfig = cloud.createChart(chartOptions, report, width, height, vm.tableData);
            vm.chartConfig.plotOptions.series.trackByArea = true;
            vm.chartConfig.plotOptions.series.marker = {
                enabled: false
            };
            console.log(vm.chartConfig.plotOptions.series,"chartconfig plot ")
            vm.chartConfig.plotOptions.series.point = {
                events: {
                    click: function () {
                        vm.seriesSelected(this.category, chartOptions.title, this.series.name);
                    }
                }
            };

            console.log(vm, "CHART")
            
            vm.chartConfig.plotOptions.areaspline = {
                events: {
                    legendItemClick: function () {
                        let series = this.chart.series;
                        if (this.visible && this.chart.restIsHidden) {
                            angular.element(series).each(() => {
                                
                                this.setVisible(true, false);
                            });
                            this.chart.restIsHidden = false;
                        } else {
                            angular.element(series).each(() => {
                                this.setVisible(false, false);
                            });
                            this.show();
                            this.chart.restIsHidden = true;
                        }
                        this.chart.redraw();
                        return false;
                    }
                },
                showInLegend: true
            };
            if (vm.cummulative === "Daily") {
                vm.changeCummulativeChart(vm.selectedReport);
            }
            if (!vm.tableData || vm.tableData.length === 0) {
                vm.createNoDataChart(report);
            }
            if (report === "userReport" || report === "permissionReport" || report === "alertReport") {
                $timeout(() => {
                    vm.chartLoading = false;
                }, 100);
            } else {
                vm.chartLoading = false;
            }
        };

        vm.createNoDataChart = (report) => {
            vm.chartConfig = Object.assign({}, defaultConfig);
            let title;

            if (report) {
                title = cloud.determineDataSource(vm.standardReports, report, "name");
                title = title.toUpperCase();
            }

            vm.chartConfig.title = {
                text: title,
                style: {
                    fontSize: "32px"
                }
            };
            vm.chartConfig.subtitle = {
                text: "NO REPORT DATA",
                style: {
                    fontSize: "18px"
                }
            };
            vm.widget1 = {
                title: "Consumption",
                value: "$ 0"
            };
            vm.widget2 = {
                title: "Budget",
                value: "$ 0"
            };
            vm.widget3 = {
                title: "Total Credits Budget",
                value: "$ 0"
            };
            vm.chartTitle = "No report data.";
            vm.tableData = [];
            vm.chartLoading = false;
        };

        //main function for handling the selection of data points on highcharts.  Then filters datatable based on selection
        vm.seriesSelected = (item, type, name) => {
            vm.clearFilter();
            vm.filter = true;
            $scope.$apply();
            // $document.scrollToElement(angular.element('#creditTable'), 0, 1000);
            let table = angular.element(".table").DataTable();
            switch (type) {
                case "CURRENT BUDGET STATUS":
                    table.column(1).search(item).draw();
                    break;
                case "CONSUMPTION OVER TIME":
                case "CONSUMPTION BY MONTH":
                case "CONSUMPTION BY PROJECT":
                case "CONSUMPTION BY ENTITY":
                case "CONSUMPTION BY SERVICE":
                case "CONSUMPTION RATE BY PROJECT":
                case "ENTITY CONSUMPTION OVER TIME":
                case "SERVICE CONSUMPTION OVER TIME":
                case "CONSUMPTION BY DEPARTMENT":
                    table.column(2).search(item).draw();
                    break;
                case "CONSUMPTION OVER TIME (ALL PROJECTS)":
                    table.column(2).search(name).draw();
                    break;
                default:
                    break;
            }
        };

        vm.expandParent = (breakdownArray) => {
            breakdownArray.forEach((child) => {
                child.show = !child.show;
                child.click = false;
                if (!child.show && child.breakdown && child.breakdown.length > 0) {
                    child.breakdown.forEach((grandchild) => {
                        grandchild.click = false;
                        grandchild.show = false;
                    });
                }
            });
        };

        //resize charts to be responsive
        $timeout(() => {
            angular.element(window).resize(() => {
                angular.element(".highcharts").each(function () {
                    let chart = angular.element(this).highcharts();
                    let w = angular.element(this).closest(".panel-body").width();
                    chart.setSize(w * 0.975, height, false);
                });
            });
        }, 1000);

        //---------INVOICES-----------------

        // Fettch SNOW company details
        Service.getQuery(
            {
                sys_id: user_info.company,
                assertDisplay: true
            },
            "core_company",
            (company) => {
                if (company && company.results) {
                    vm.companyDetails = company.results;
                    vm.companyDetails.name = vm.companyDetails.name || "";
                    vm.companyDetails.phone = company.phone || "";
                    vm.companyDetails.street = company.street || "";
                    vm.companyDetails.contact && vm.companyDetails.contact.display_value
                        ? (vm.companyDetails.contact = vm.companyDetails.contact.display_value)
                        : (vm.companyDetails.contact = "");
                    let address = "";
                    if (vm.companyDetails.city) {
                        address = vm.companyDetails.city;
                        if (vm.companyDetails.zip) {
                            address += ", " + vm.companyDetails.zip;
                        }
                    }
                    vm.companyDetails.address = address;
                } else {
                    vm.companyDetails = {};
                }
            }
        );

        vm.user_info = user_info;

        //----------Download GCS Invoices --------------

        vm.fetchInvoices = () => {
            BCSServer.postData(
                {
                    companyCode: user_info.company_code
                },
                "/cloud_invoice_list",
                (response) => {
                    if (response) {
                        vm.groupPOInvoices = vm.allignPOGroupInvoices(response, vm.groups);
                        vm.invoices = response;
                    } else {
                        vm.invoices = [];
                    }
                    let uniqueDates = [];
                    vm.invoices = vm.sortInvoicesByDate(vm.invoices);
                    vm.invoices.reverse();
                    vm.invoices = vm.invoices
                        .map((file) => {
                            let downloadFile = file.split(".")[0];
                            let dateFile = file.split("_");
                            let invoiceGroup = false;
                            if (dateFile.length === 3) {
                                dateFile = dateFile[1];
                            } else {
                                dateFile = dateFile[2];
                                invoiceGroup = true;
                            }

                            if (uniqueDates.includes(dateFile)) {
                                return;
                            } else {
                                uniqueDates.push(dateFile);
                            }

                            return {
                                file: downloadFile,
                                invoiceGroup: invoiceGroup,
                                name: moment(dateFile, "MM-DD-YY").format("MMM YYYY"),
                                type: ""
                            };
                        })
                        .filter((item) => item);

                    if (vm.mit && !vm.isAdmin) {
                        vm.invoices = vm.invoices.filter((invoice) => {
                            return moment(invoice.name).isAfter("2020-10-31", "day");
                        });
                    }
                }
            );
        };

        vm.allignPOGroupInvoices = (invoices, groups) => {
            return invoices
                .map((inv) => {
                    let invArray = inv.split("_");
                    if (invArray.length === 4) {
                        let invPO = invArray[1];
                        let foundGroup = groups.find(
                            (group) => group && group.invoicePOs && group.invoicePOs.includes(invPO)
                        );
                        if (foundGroup) {
                            let dateFile = inv.split("_");
                            return {
                                group: foundGroup.groupName,
                                invoiceGroup: true,
                                name: moment(dateFile[2], "MM-DD-YY").format("MMM YYYY"),
                                type: "",
                                file: inv.split(".")[0]
                            };
                        }
                    } else {
                        return "";
                    }
                })
                .filter((item) => item);
        };

        vm.sortInvoicesByDate = (invoices) => {
            return (invoices = invoices.sort((a, b) => {
                let index = 1;
                let dateFile = a.split("_");
                if (dateFile.length === 4) {
                    index = 2;
                }
                return moment(a.split("_")[index]) - moment(b.split("_")[index]);
            }));
        };

        vm.getInvoiceID = (invoiceLevel, invoiceName) => {
            let invoiceID = "";
            switch (invoiceLevel) {
                case "group":
                    let foundGroup = vm.groups.find((group) => {
                        return group.groupName === invoiceName;
                    });
                    foundGroup ? (invoiceID = foundGroup.groupID) : "";
                    break;
                case "department":
                    let foundDepartment = vm.departments.find((depo) => {
                        return depo.departmentName === invoiceName;
                    });
                    foundDepartment ? (invoiceID = foundDepartment.departmentID) : "";
                    break;
                case "po":
                    invoiceID = invoiceName;
                    break;
                default:
                    break;
            }
            return invoiceID;
        };

        vm.findGroupPOFile = (invoice, level, name, accountList, allInvoices, rawBudgets) => {
            let invoiceDate = invoice.file.split("_");
            invoiceDate = invoiceDate[invoiceDate.length - 1];
            switch (level) {
                case "group":
                    const foundInv = allInvoices.find((inv) => inv.group === name && inv.name === invoice.name);
                    if (foundInv) {
                        invoice.file = foundInv.file;
                    }
                    break;
                case "department":
                    const foundDepartment = rawBudgets.departments.find((budget) => budget.departmentName === name);
                    if (foundDepartment) {
                        const foundGroup = rawBudgets.groups.find((group) =>
                            group.departments.includes(foundDepartment.departmentID)
                        );
                        if (foundGroup) {
                            const foundInv = allInvoices.find(
                                (inv) => inv.group === foundGroup.groupName && inv.name === invoice.name
                            );
                            if (foundInv) {
                                invoice.file = foundInv.file;
                            }
                        }
                    }
                    break;
                case "project":
                    const foundPrj = accountList.find((prj) => prj.projectID === name);
                    if (foundPrj) {
                        const foundInv = allInvoices.find(
                            (inv) => inv.group === foundPrj.group && inv.name === invoice.name
                        );
                        if (foundInv) {
                            invoice.file = foundInv.file;
                        }
                    }
                    break;
                default:
                    break;
            }
            return invoice;
        };

        vm.downloadGCSInvoice = (invoice) => {
            if (vm.invoicingGroup) {
                invoice = vm.findGroupPOFile(
                    invoice,
                    vm.selectedInvoiceLevel,
                    vm.selectedInvoiceName,
                    vm.accountList,
                    vm.groupPOInvoices,
                    vm.rawBudgets
                );
            }




            if (apiBasePath === "https://api.bcs.burwood.com") {
                /* eslint-disable */
                ga("send", {
                    hitType: "event",
                    eventCategory: "invoice",
                    eventAction: "download",
                    eventLabel: invoice.file
                });
                /* eslint-enable */
            }

            let invoiceProjects = [];

            if (vm.isAdmin) {
                invoiceProjects = vm.composeReportLevels("Invoice");
            } else {
                vm.selectedInvoiceLevel = vm.invoiceLevels[1].id;
                invoiceProjects = cloud.getRawProjectArray(vm.projectList, "project_id");
            }

            vm.companyDetails.poNumber = vm.companyPO;
            vm.companyDetails.groupPO = null;
            if(vm.selectedInvoiceLevel === "group") {
                const foundSelectedGroup = vm.groups.find(group => {
                    return group.groupName === vm.selectedInvoiceName;
                });
                vm.companyDetails.groupPO = foundSelectedGroup && foundSelectedGroup.invoicePO;
            }


            if (vm.selectedInvoiceLevel !== "company" && !vm.selectedInvoiceName && vm.isAdmin) {
                $uibModal.open({
                    resolve: {
                        message: () => {
                            return {
                                heading: "Report Error",
                                message: `Please select ${vm.selectedInvoiceLevel} to download invoice`,
                                loading: false
                            };
                        }
                    },
                    templateUrl: "app/shared/html/downloading.html",
                    ariaLabelledBy: "modal-title",
                    ariaDescribedBy: "modal-body",
                    controller: "DownloadingController",
                    controllerAs: "vm"
                });
                return;
            }

            $timeout(() => {
                let route = apiBasePath + "/cloud_invoice_single";
                vm.summaryLoading = true;

                let modalInst = $uibModal.open({
                    resolve: {
                        message: () => {
                            return {
                                heading: "Processing Invoice",
                                message: "Your Invoice is downloading.",
                                loading: true
                            };
                        }
                    },
                    templateUrl: "app/shared/html/downloading.html",
                    ariaLabelledBy: "modal-title",
                    ariaDescribedBy: "modal-body",
                    controller: "DownloadingController",
                    controllerAs: "vm"
                });
                $scope.$emit("download-start");
                $http({
                    method: "POST",
                    cache: false,
                    url: route,
                    data: {
                        file: invoice.file,
                        type: invoice.type.value,
                        company: user_info.company_code,
                        admin: vm.isAdmin,
                        invoiceLevel: vm.selectedInvoiceLevel,
                        invoiceID: vm.getInvoiceID(vm.selectedInvoiceLevel, vm.selectedInvoiceName),
                        projects: invoiceProjects,
                        invoicePO: vm.selectedInvoiceLevel === "po" ? vm.selectedInvoiceName : null,
                        markup: vm.centralTax,
                        client: vm.companyDetails
                    },
                    responseType: "arraybuffer"
                }).then(
                    (response) => {
                        modalInst.close();
                        vm.summaryLoading = false;
                        FileSaver.saveAs(
                            new Blob([response.data], {
                                type: invoice.type.mime
                            }),
                            invoice.file + "." + invoice.type.value
                        );
                    },
                    () => {
                        modalInst.close();
                        vm.summaryLoading = false;
                        $uibModal.open({
                            resolve: {
                                message: () => {
                                    return {
                                        heading: "Report Error",
                                        message:
                                            "Failed To Download Invoice. Please Contact Support for Further Assistance.",
                                        loading: false
                                    };
                                }
                            },
                            templateUrl: "app/shared/html/downloading.html",
                            ariaLabelledBy: "modal-title",
                            ariaDescribedBy: "modal-body",
                            controller: "DownloadingController",
                            controllerAs: "vm"
                        });
                    }
                );
            }, 1);
        };

        //----------Download Summary ---------------

        vm.downloadSummary = () => {
            let route = apiBasePath + "/cloud_summary";
            let filename = user_info.company_name + "_cloud_summary.xlsx";
            vm.summaryLoading = true;

            let modalInst = $uibModal.open({
                resolve: {
                    message: () => {
                        return {
                            heading: "Processing Report",
                            message: "Your summary is processing.",
                            loading: true
                        };
                    }
                },
                templateUrl: "app/shared/html/downloading.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "DownloadingController",
                controllerAs: "vm"
            });
            $scope.$emit("download-start");
            $http({
                method: "POST",
                cache: false,
                url: route,
                data: {
                    company: user_info.company_code,
                    sys_id: user_info.company
                },
                responseType: "arraybuffer"
            }).then(
                (response) => {
                    modalInst.close();
                    vm.summaryLoading = false;
                    FileSaver.saveAs(
                        new Blob([response.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        }),
                        filename
                    );
                },
                () => {
                    modalInst.close();
                    vm.summaryLoading = false;
                    $uibModal.open({
                        resolve: {
                            message: () => {
                                return {
                                    heading: "Report Error",
                                    message:
                                        "Failed To Download Summary. Please Contact Support for Further Assistance.",
                                    loading: false
                                };
                            }
                        },
                        templateUrl: "app/shared/html/downloading.html",
                        ariaLabelledBy: "modal-title",
                        ariaDescribedBy: "modal-body",
                        controller: "DownloadingController",
                        controllerAs: "vm"
                    });
                }
            );
        };

        //----------Download Budget Report ---------------

        vm.downloadBudgetReport = () => {
            let route = apiBasePath + "/budget_report";
            let filename = user_info.company_name + "_budget_report.csv";
            vm.adminReportLoading = true;

            let modalInst = $uibModal.open({
                resolve: {
                    message: () => {
                        return {
                            heading: "Processing Report",
                            message: "Your report is processing.",
                            loading: true
                        };
                    }
                },
                templateUrl: "app/shared/html/downloading.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "DownloadingController",
                controllerAs: "vm"
            });
            $scope.$emit("download-start");
            $http({
                method: "POST",
                cache: false,
                url: route,
                data: {
                    company: user_info.company_code,
                    sys_id: user_info.company
                },
                responseType: "arraybuffer"
            }).then(
                (response) => {
                    if (response && response.data) {
                        modalInst.close();
                        vm.adminReportLoading = false;
                        FileSaver.saveAs(
                            new Blob([response.data], {
                                type: "text/x-csv"
                            }),
                            filename
                        );
                    } else {
                        vm.failedToDownload(modalInst);
                    }
                },
                () => {
                    vm.failedToDownload(modalInst);
                }
            );
        };

        vm.failedToDownload = (modalInst) => {
            modalInst.close();
            vm.adminReportLoading = false;
            $uibModal.open({
                resolve: {
                    message: () => {
                        return {
                            heading: "Report Error",
                            message: "Failed To Download Report. Please Contact Support for Further Assistance.",
                            loading: false
                        };
                    }
                },
                templateUrl: "app/shared/html/downloading.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "DownloadingController",
                controllerAs: "vm"
            });
        };
    }
})();

(function () {
    angular.module("burWood").controller("CloudbillingPOController", CloudbillingPOController);

    /** @ngInject */
    function CloudbillingPOController(
        _,
        user_info,
        BCSServer,
        cloud,
        util,
        $timeout,
        moment,
        cloudProcessor,
        Alerts,
        $state
    ) {
        let vm = this;

        vm.loading = true;
        vm.accountLoading = true;
        vm.alerts = [];

        // checking if user is admin
        if (user_info.group) {
            if (user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") != -1) {
                vm.burwoodAdmin = true;
            }
        }

        //sets width of charts based on dashbaords
        let dashWidth = angular.element("#poPage").width();
        let width = dashWidth - dashWidth * 0.085;
        let height = 500;

        vm.poStates = ["Retired", "Active", "Future"];

        vm.poTypes = [
            {
                name: "Standard",
                id: "standard"
            },
            {
                name: "STRIDES Grant",
                id: "strides"
            },
            {
                name: "Group Purchase Order",
                id: "burwoodPO",
                disabled: !vm.burwoodAdmin
            }
        ];

        vm.reportFilter = ["All", "Standard", "Strides"];
        vm.selectedReportFilter = vm.reportFilter[0];

        vm.poLevels = [
            {
                name: "Company",
                id: "company"
            },
            {
                name: "Department",
                id: "department"
            },
            {
                name: "Project",
                id: "project"
            }
        ];

        let defaultConfig = {
            chart: {
                zoomType: "x",
                type: "column",
                width: width,
                height: height
            },
            exporting: {
                enabled: true
            },
            title: {
                text: " "
            },
            yAxis: {
                min: 0
            },
            series: []
        };

        let dashboards = [
            {
                id: "consumptionByPO",
                exportColumns: [0, 1, 2],
                defaultChart: "column",
                alterTime: false,
                view: "project_cost_by_day_minimal",
                dataSource: "bigQuery",
                name: "Purchase Order Consumption"
            }
        ];

        vm.fetchAccount = () => {
            BCSServer.postData(
                {
                    companyCode: user_info.company_code
                },
                "/cloud_accounts",
                (response) => {
                    vm.loading = false;
                    vm.accountLoading = false;
                    if (response) {
                        vm.selectedCompany = response;
                        vm.convertDates(vm.selectedCompany);
                        vm.poTypes[0].name = vm.selectedCompany.purchaseOrderTerm || "Purchase Order";
                        vm.reportFilter[1] = vm.selectedCompany.purchaseOrderTerm || "Purchase Order";
                        vm.selectedCompany.accounts = util.sortItems(vm.selectedCompany.accounts, "name", "ASC");
                        vm.stridesAccounts = vm.selectedCompany.accounts.filter((account) => {
                            return account.pricebook === "strides";
                        });
                        vm.selectedCompany.pos = vm.initPOInvoice(vm.selectedCompany.pos);
                        if (vm.selectedCompany.invoicingRole === "group" && !vm.burwoodAdmin) {
                            vm.disabledGroup = true;
                        }
                        vm.fetchProjectMap();
                    } else {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Cannot Locate Client Information",
                            status: "fail"
                        });
                        vm.selectedCompany = {};
                    }
                }
            );
        };

        vm.fetchAccount();

        vm.fetchProjectMap = () => {
            BCSServer.postData(
                {
                    method: "get",
                    company: user_info.company,
                    role: "IT"
                },
                "/cloud_budgets",
                (budget) => {
                    if (budget && budget.length > 0) {
                        vm.companyBudget = budget[0];
                        vm.flattenOrg(vm.selectedCompany, budget);
                        // vm.firstBudgetDate = cloud.getFirstBudgetDate(cloud.extractAllProjects(budget[0]));
                        var reportParameters = {
                            multi: true,
                            view: "project_cost_by_day_minimal",
                            parameters: {
                                projects: [],
                                dateRange: {
                                    // startDate: vm.firstBudgetDate,
                                    startDate: moment(new Date("2018-01-01")).format("YYYY-MM-DD"),
                                    endDate: moment(new Date()).format("YYYY-MM-DD")
                                }
                            }
                        };
                    }
                    vm.fetchReportData(reportParameters, "consumptionByPO");
                }
            );
        };

        vm.initPOInvoice = (pos) => {
            pos.forEach((po) => {
                if (!po.billingContactEmail || po.billingContactEmail.length === 0) {
                    po.billingContactEmail = [""];
                }
            });
            return pos;
        };

        vm.convertDates = (account) => {
            if (account && account.pos && account.pos.length > 0) {
                account.pos = account.pos.map((po) => {
                    if (po.expirationDate) {
                        po.expirationDate = moment(po.expirationDate);
                    }
                    return po;
                });
            }
        };

        vm.convertDatesUTC = (account) => {
            if (account && account.pos && account.pos.length > 0) {
                account.pos = account.pos.map((po) => {
                    if (po.expirationDate) {
                        po.expirationDate = moment(po.expirationDate).utc();
                    }
                    return po;
                });
            }
        };

        vm.flattenOrg = (company, budgets) => {
            company.flat = {
                department: [],
                project: []
            };
            let foundBudget = budgets.find((budget) => {
                return budget.company === company.company;
            });
            if (foundBudget && foundBudget.departments && foundBudget.departments.length > 0) {
                foundBudget.departments.forEach((depo) => {
                    company.flat.department.push(depo.departmentName);
                    if (depo && depo.projects && depo.projects.length > 0) {
                        depo.projects.forEach((prj) => {
                            company.flat.project.push(prj.projectID);
                        });
                    }
                });
            }
        };

        vm.update = () => {
            vm.loading = true;
            vm.updatePOs();
        };

        vm.setUpDashboards = () => {
            vm.dash = {};

            dashboards.forEach((item) => {
                vm.dash[item.id] = true;
                vm[item.id + "Loading"] = true;
                vm[item.id + "Config"] = Object.assign({}, defaultConfig);
                vm[item.id + "ChartSelect"] = item.defaultChart;
                vm[item.id + "Date"] = angular.copy(vm.defaultDate);
                vm[item.id + "toDate"] = false;
            });

            vm.thresholdAlerts75Table = [0];
        };

        vm.setUpDashboards();

        vm.addBillingContact = (index) => {
            vm.selectedCompany.pos[index].billingContactEmail.unshift("");
        };

        vm.removeBillingContact = (index, contactIndex) => {
            vm.selectedCompany.pos[index].billingContactEmail.splice(contactIndex, 1);
        };

        //BigQuery Fetch
        vm.fetchReportData = (reportParameters, report) => {
            BCSServer.postData(reportParameters, "/big_query/get_query", (response) => {
                if (response && angular.isArray(response) && response.length > 0) {
                    vm.reportData = response;
                    vm.processPOReport(vm.reportData, report, "All");
                } else {
                    vm.reportData = [];
                    vm.createNoDataChart(report);
                }
            });
        };

        vm.changeReportFilter = (reportFilter) => {
            vm.processPOReport(vm.reportData, "consumptionByPO", reportFilter);
        };

        vm.processPOReport = (data, report, fundingType) => {
            let poBudgets = [];

            let selectedFunding = [];

            if (vm.selectedCompany && vm.selectedCompany.pos && vm.selectedCompany.pos.length > 0) {
                if (fundingType === "Strides") {
                    poBudgets = cloud.findPOBudgets(vm.companyBudget, "grant");
                    selectedFunding = vm.selectedCompany.pos.filter((funding) => {
                        return funding.type === "strides";
                    });
                } else if (fundingType === vm.selectedCompany.purchaseOrderTerm) {
                    poBudgets = cloud.findPOBudgets(vm.companyBudget);
                    selectedFunding = vm.selectedCompany.pos.filter((funding) => {
                        return funding.type !== "strides";
                    });
                } else {
                    poBudgets = cloud.findPOBudgets(vm.companyBudget);
                    let grantBudgets = cloud.findPOBudgets(vm.companyBudget, "grant");
                    for (var grant in grantBudgets) {
                        poBudgets[grant] = grantBudgets[grant];
                    }
                    selectedFunding = vm.selectedCompany.pos;
                }
            }

            poBudgets = cloud.alignPOBudgets(poBudgets, selectedFunding);

            let processedData = cloudProcessor.processPOConsumptions(data, poBudgets);
            vm[report + "Table"] = processedData.tableData;
            let chartData = processedData.chartData;

            let series = [
                {
                    name: "Remaining Budget",
                    color: "#579c8b",
                    stack: "0",
                    borderColor: "rgba(128, 128, 128, 0.0)",
                    data: chartData.remaining
                },
                {
                    name: "Consumption",
                    color: "#db5760",
                    stack: "0",
                    borderColor: "rgba(128, 128, 128, 0.0)",
                    data: chartData.series,
                    lineWidth: 5
                }
            ];

            vm.setUpChart(
                {
                    series: series,
                    categories: chartData.categories,
                    chartType: "column",
                    title: null,
                    dataLabels: false,
                    yMin: 0,
                    yVisible: true,
                    yText: "Dollars ($)",
                    legend: true
                },
                report
            );
        };

        vm.setUpChart = (chartOptions, report) => {
            vm[report + "Title"] = chartOptions.title;
            vm[report + "Config"] = cloud.createChart(chartOptions, report, width, height, vm[report + "Table"]);
            vm[report + "Loading"] = false;
        };

        vm.createNoDataChart = (report) => {
            vm[report + "Config"] = Object.assign({}, defaultConfig);
            vm[report + "Table"] = [];
            let title = "No Data";
            vm[report + "Config"].title = {
                text: title,
                style: {
                    fontSize: "32px"
                }
            };
            vm[report + "Config"].subtitle = {
                text: "NO REPORT DATA",
                style: {
                    fontSize: "18px"
                }
            };
            vm[report + "Title"] = "No report data.";
            vm[report + "TableData"] = [];
            vm[report + "Loading"] = false;
        };

        vm.updatePOs = () => {
            vm.accountLoading = true;
            delete vm.selectedCompany._id;
            delete vm.selectedCompany.__v;

            let dumpData = angular.copy(vm.selectedCompany);
            vm.convertDatesUTC(dumpData);

            BCSServer.postData(
                {
                    companyCode: dumpData.companyCode,
                    companyAccounts: dumpData
                },
                "/update_cloud_accounts",
                (response) => {
                    vm.accountLoading = false;
                    vm.loading = false;
                    if (response.error || !response) {
                        let error = response || "";
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Failed To Update POs. Please Contact Support For Further Assistance.  ${angular.toString(
                                error
                            )}`,
                            status: "fail"
                        });
                    } else {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Successfully Updated PO Information.",
                            status: "success"
                        });
                        vm.selectedCompanySetting = angular.copy(vm.selectedCompany);
                    }
                }
            );
        };

        vm.createAlertMessage = (alert) => {
            vm[alert.type].push({
                status: alert.status,
                msg: alert.msg
            });
            Alerts.storeAlert({
                type: alert.status,
                message: alert.msg,
                user: user_info.email,
                company: user_info.company_name,
                location: $state.current.name,
                tags: ["Cloud Funding Configuration"]
            });
            $timeout(() => {
                vm[alert.type] = [];
            }, 5000);
        };

        let defaultItems = {
            pos: {
                amount: null,
                type: null,
                state: "Active",
                details: {},
                invoicePO: false,
                billingContactEmail: []
            }
        };

        vm.addItem = (level, itemType) => {
            if (vm[level][itemType] && vm[level][itemType].length > 0) {
                vm[level][itemType].push(angular.copy(defaultItems[itemType]));
            } else {
                vm[level][itemType] = [angular.copy(defaultItems[itemType])];
            }
        };

        vm.removeItem = (level, itemType, budgetIndex) => {
            let prompt = confirm("Are you sure you wish to delete this item?");
            if (!prompt) {
                return;
            }
            vm[level][itemType].splice(budgetIndex, 1);
        };

        vm.close_notice = (type, index) => {
            vm[type].splice(index, 1);
        };
    }
})();

(function () {

    angular.module("burWood").controller("DashboardConfigController", DashboardConfigController);

    /** @ngInject */
    function DashboardConfigController($uibModalInstance, list, $scope) {
        let vm = this;
        vm.loading = true;
        vm.error = false;

        vm.dualListOptions = {
            // title: 'Dashboards',
            filterPlaceHolder: "Start typing to filter the lists below.",
            labelAll: "All Dashboards",
            labelSelected: "Selected Dashboards",
            helpMessage:
                "Choose up to 6 Dashboards.  Click items to transfer them between fields.  Drag selected items to reorder.",
            /* angular will use this to filter your lists */
            orderProperty: "name",
            /* this contains the initial list of all items (i.e. the left side) */
            items: list.unselected,
            /* this list should be initialized as empty or with any pre-selected items */
            selectedItems: list.selected
        };

        vm.toggleDash = false;
        $scope.$watch("vm.toggleDash", (newValue, oldValue) => {
            if (newValue !== oldValue) {
                let newArray = [];
                vm.dualListOptions.selectedItems.forEach((item) => {
                    newArray.push(item.name);
                });
                let parent = angular.element(".all-dashboards");
                let dashes = parent.children();
                dashes.each((index, element) => {
                    angular.element(element).addClass("opaque dash-contain");
                });
                dashes.sort((a, b) => {
                    return (
                        newArray.indexOf(angular.element(a).data("dash")) -
                        newArray.indexOf(angular.element(b).data("dash"))
                    );
                });
                parent.append(dashes);
            }
        });

        vm.close = () => {
            $uibModalInstance.close(vm.dualListOptions.selectedItems);
        };
    }

})();
(function () {
    angular.module("burWood").controller("CloudBillingDashboardController", CloudBillingDashboardController);

    /** @ngInject */
    function CloudBillingDashboardController(
        _,
        user_info,
        DTOptionsBuilder,
        $timeout,
        BCSServer,
        cloud,
        util,
        cloudProcessor,
        $state,
        $uibModal,
        $scope,
        $window,
        moment
    ) {
        let vm = this;
        vm.reports = {};
        vm.yearTable =
            vm.quarterTable =
            vm.monthTable =
            vm.yearByProjectTable =
            vm.quarterByProjectTable =
            vm.monthByProjectTable =
                [];
        vm.toggleControl = false;

        //checking if user is admin
        if (
            user_info.group &&
            (user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins Read Only") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins") != -1)
        ) {
            vm.isAdmin = true;
            vm.isAdminOrigin = true;
        }

        if (
            $state.current.name !== "index.cloudbilling_dashboard_admin" &&
            $state.current.name !== "index.cloudbilling_dashboard_burwood_admin"
        ) {
            vm.isAdmin = false;
        }

        // check if MIT for displaying total credits budget
        if (
            user_info.company === "61a4a1401bdd8810beaec9176e4bcbef" ||
            user_info.company === "b32295ebdb388010f6ba00b5ca961985"
        ) {
            vm.mit = true;
        }

        vm.enterprise = user_info.cloudEnterprise;

        vm.moment = moment;

        //sets width of charts based on dashbaords
        let dashWidth = angular.element(".sample-width").width();
        let width = dashWidth - dashWidth * 0.075;
        let height = 270;

        let defaultConfig = {
            chart: {
                zoomType: "x",
                type: "column",
                width: width,
                height: height
            },
            exporting: {
                enabled: true
            },
            title: {
                text: " "
            },
            yAxis: {
                min: 0
            },
            series: []
        };

        //configuration for column filter
        let columnFilter = {
            aoColumns: [
                null,
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                }
            ]
        };

        vm.setupDatableButtons = (title, exportColumns) => {
            //button export configurations
            return [
                {
                    extend: "collection",
                    text: "Export",
                    buttons: [
                        {
                            extend: "excel",
                            title: () => {
                                return title;
                            },
                            filename: () => {
                                return title.replace(/ /g, "_");
                            },
                            exportOptions: {
                                columns: exportColumns
                            }
                        },
                        {
                            extend: "pdf",
                            title: () => {
                                return title;
                            },
                            filename: () => {
                                return title.replace(/ /g, "_");
                            },
                            customize: (doc) => {
                                doc.pageMargins = [5, 5, 5, 5];
                                doc.styles.tableHeader.fontSize = 10;
                                doc.defaultStyle.fontSize = 6;
                            },
                            exportOptions: {
                                columns: exportColumns
                            }
                        },
                        {
                            extend: "csv",
                            title: () => {
                                return title;
                            },
                            filename: () => {
                                return title.replace(/ /g, "_");
                            },
                            exportOptions: {
                                columns: exportColumns
                            }
                        }
                    ]
                }
            ];
        };

        vm.setupDatatables = (title, exportColumns) => {
            //datatable configurations
            return DTOptionsBuilder.newOptions()
                .withDOM("fBrtip")
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withButtons(vm.setupDatableButtons(title, exportColumns))
                .withColumnFilter(columnFilter)
                .withOption("iDisplayLength", 10)
                .withOption("responsive", true);
        };

        vm.dtOptionsAlerts = DTOptionsBuilder.newOptions()
            .withDOM("fBrtip")
            .withOption("aoColumnDefs", [
                {
                    bSortable: false,
                    aTargets: ["nosort"]
                }
            ])
            .withOption("order", [["6", "des"]])
            .withButtons(vm.setupDatableButtons("Projects Threshold Alerts", [1, 2, 3, 4, 5, 6]))
            .withColumnFilter(columnFilter)
            .withOption("iDisplayLength", 7)
            .withOption("responsive", true);

        let colors = ["#f4ba30", "#db5760", "#579c8b", "#536794", "#9e5d9c", "#8870b3"];

        let creditColors = ["rgb(219, 87, 96)", "#ff1ff4", "#9e1fff"];

        vm.chartTypes = [
            {
                name: "Line",
                id: "line"
            },
            {
                name: "Bar",
                id: "bar"
            },
            {
                name: "Column",
                id: "column"
            },
            {
                name: "Pie",
                id: "pie"
            }
        ];

        vm.chartTypesTime = angular.copy(vm.chartTypes);
        vm.chartTypesTime.splice(-1, 2);
        vm.chartTypesTotals = angular.copy(vm.chartTypes);
        vm.chartTypesTotals.splice(0, 2);
        vm.chartTypesStacked = angular.copy(vm.chartTypes);
        vm.chartTypesStacked = vm.chartTypesStacked.splice(2, 2);

        vm.cummulativeSelect = ["Cumulative", "Daily"];

        vm.defaultDate = {
            startDate: util.addMonths(new Date(new Date().setDate(1)), -2),
            endDate: moment(new Date()).format("YYYY-MM-DD")
        };
        vm.toDate = null;

        vm.chartTimes = [
            {
                id: "thisMonth",
                name: "This Month"
            },
            {
                id: "last3Months",
                name: "Last 3 Months"
            }
            // , {
            //     id: 'toDate',
            //     name: 'All time'
            // }
        ];

        vm.timeSelect = vm.chartTimes[1].id;

        vm.years = util.getYearList();
        vm.months = util.getMonthList();

        vm.yearConsumptionByMonthAccountMonthSelect = vm.months[new Date().getMonth()];
        vm.yearConsumptionByMonthAccountYearSelect = new Date().getFullYear();

        vm.standardDashboards = [
            {
                id: "consumptionByEntity",
                exportColumns: [0, 1],
                defaultChart: "column",
                alterTime: true,
                invoiceMonth: true,
                view: "project_cost_by_entity",
                dataSource: "bigQuery",
                name: "Consumption By Entity",
                showControl: true
            },
            {
                id: "consumptionByProduct",
                exportColumns: [0, 1],
                defaultChart: "column",
                alterTime: true,
                invoiceMonth: true,
                view: "project_cost_by_service_desc",
                dataSource: "bigQuery",
                name: "Consumption By Service",
                showControl: true
            },
            {
                id: "consumptionByProject",
                exportColumns: [0, 1],
                defaultChart: "column",
                alterTime: true,
                invoiceMonth: true,
                view: "project_cost_total",
                dataSource: "bigQuery",
                name: "Consumption By Project",
                showControl: false
            }
        ];

        vm.projectDashboards = [
            {
                id: "yearConsumptionByMonth",
                exportColumns: [0, 1],
                defaultChart: "column",
                alterTime: false,
                invoiceMonth: true,
                view: "project_cost_by_month",
                dataSource: "bigQuery",
                name: "Consumption By Month",
                showControl: true
            },
            {
                id: "consumptionOverTime",
                exportColumns: [0, 1, 2, 3, 4],
                defaultChart: "line",
                alterTime: true,
                view: "project_cost_by_day",
                dataSource: "bigQuery",
                name: "Consumption Over Time",
                showControl: true
            },
            {
                id: "serviceConsumptionOverTime",
                exportColumns: [0, 1, 2],
                defaultChart: "line",
                alterTime: true,
                view: "project_cost_by_day",
                dataSource: "bigQuery",
                name: "Service Consumption Over Time",
                showControl: true
            },
            {
                id: "entityConsumptionOverTime",
                exportColumns: [0, 1, 2],
                defaultChart: "line",
                alterTime: true,
                view: "project_cost_by_day",
                dataSource: "bigQuery",
                name: "Entity Consumption Over Time",
                showControl: true
            },
            {
                id: "currentBudgetConsumptions",
                exportColumns: [],
                defaultChart: "",
                alterTime: false,
                view: "project_cost_total",
                dataSource: "bigQuery",
                name: "Current Budget Consumptions",
                showControl: false
            }
        ];

        vm.adminDashboards = [
            {
                id: "yearConsumptionByMonthAll",
                exportColumns: [0, 1],
                defaultChart: "column",
                alterTime: false,
                invoiceMonth: true,
                view: "project_cost_by_month_all",
                dataSource: "bigQuery",
                name: "Consumption By Month (All Projects)",
                showControl: true
            },
            {
                id: "thresholdAlerts75",
                exportColumns: [1, 2, 3, 4, 5, 6],
                defaultChart: "",
                alterTime: false,
                view: "project_cost_by_day_minimal",
                dataSource: "bigQuery",
                name: "Projects Threshold Alerts",
                showControl: true
            },
            {
                id: "trendStats",
                exportColumns: [],
                defaultChart: "",
                alterTime: false,
                view: "project_cost_by_day_minimal",
                dataSource: "bigQuery",
                name: "Trend Summary",
                showControl: true
            },
            {
                id: "creditStatus",
                exportColumns: [],
                defaultChart: "",
                alterTime: false,
                view: "project_cost_total_by_account",
                dataSource: "bigQuery",
                name: "Credit Status",
                showControl: true
            },
            {
                id: "consumptionByDepartment",
                exportColumns: [0, 1],
                defaultChart: "column",
                alterTime: true,
                invoiceMonth: true,
                view: "project_cost_total_minimal",
                dataSource: "bigQuery",
                name: "Consumption By Department",
                showControl: true
            },
            {
                id: "consumptionByLabel",
                exportColumns: [0, 1],
                defaultChart: "column",
                view: "project_cost_by_label",
                dataSource: "bigQuery",
                alterTime: true,
                invoiceMonth: true,
                name: "Consumption By Label",
                showControl: true
            },
            {
                id: "currentBudgetStatus",
                view: "project_cost_by_day_minimal",
                dataSource: "bigQuery",
                defaultChart: "column",
                chartIndexes: [0, 1],
                noDate: true,
                name: "Current Budget Status"
            },
            {
                id: "yearConsumptionByMonthAccount",
                exportColumns: [0, 1, 2],
                defaultChart: "column",
                alterTime: true,
                invoiceMonth: true,
                view: "project_cost_total_by_account_admin",
                dataSource: "bigQuery",
                name: "Account Consumption"
            },
            {
                id: "consumptionByPO",
                exportColumns: [0, 1, 2],
                defaultChart: "column",
                alterTime: false,
                view: "project_cost_by_day_minimal",
                dataSource: "bigQuery",
                name: "Purchase Order Consumption"
            }
        ];

        vm.higherEdDashboards = [];

        vm.higherEdAdminDashboards = [];

        if (!vm.isAdmin) {
            vm.availableDashboards = angular.copy(vm.standardDashboards);
            vm.availableDashboards = vm.availableDashboards.concat(vm.projectDashboards);
        } else {
            vm.availableDashboards = angular.copy(vm.standardDashboards);
            vm.availableDashboards = vm.availableDashboards.concat(vm.adminDashboards);
        }

        vm.isAdmin &&
            !vm.enterprise &&
            (vm.availableDashboards = vm.availableDashboards.concat(vm.higherEdAdminDashboards));

        let overTimeReports = ["consumptionOverTime", "serviceConsumptionOverTime", "entityConsumptionOverTime"];

        vm.alterTimeReports = [];

        vm.fadeInDash = () => {
            let dashCount = 0;
            angular
                .element(".all-dashboards")
                .children()
                .each((index, element) => {
                    dashCount += 50;
                    $timeout(() => {
                        angular.element(element).addClass("opaque");
                    }, dashCount);
                });
        };

        vm.setUpDashboards = () => {
            vm.dash = {};

            vm.availableDashboards.forEach((item) => {
                vm.dash[item.id] = true;
                vm[item.id + "Loading"] = true;
                vm[item.id + "Config"] = Object.assign({}, defaultConfig);
                vm[item.id + "ChartSelect"] = item.defaultChart;
                item.alterTime ? vm.alterTimeReports.push(item) : null;
                vm[item.id + "Date"] = angular.copy(vm.defaultDate);
                vm[item.id + "toDate"] = false;
            });

            vm.thresholdAlerts75Table = [0];
        };

        vm.setUpDashboards();

        //BigQuery Fetch
        vm.reports.bigQuery = (reportParameters, reportID) => {
            BCSServer.postData(reportParameters, "/big_query/get_query", (response) => {
                if (reportID !== "consumptionOvertimeAll") {
                    if (response && angular.isArray(response) && response.length > 0) {
                        chartProcessors[reportID](response, reportID);
                    } else {
                        vm.createNoDataChart(reportID);
                    }
                }
            });
        };

        // Determine if report needs to fetch from Orbitera or BigQuery
        vm.runReport = (report) => {
            vm[report + "Loading"] = true;
            vm[report + "Run"] = report;
            vm[report + "DTInstance"] = {};

            vm.currentConsumption = null;
            vm.currentConsumptionRemaining = null;

            let queryProjects = !vm.isAdmin ? cloud.getRawProjectArray(vm.projectList, "project_id") : null;
            let sourceReport = cloud.determineDataSource(vm.availableDashboards, report);

            if (report != "thresholdAlerts75") {
                vm[report + "DTOptions"] = vm.setupDatatables(sourceReport.name, sourceReport.exportColumns);
            }

            let composeParameters = {
                selectedProject: vm.selectedProject,
                report: sourceReport,
                toDate: vm[report + "toDate"],
                date: vm[report + "Date"],
                projects: queryProjects,
                admin: vm.isAdmin,
                dateType: sourceReport.invoiceMonth ? "invoiceMonth" : "dateRange"
            };

            if (report === "currentBudgetConsumptions") {
                if (vm.accountDetails && vm.accountDetails.allowances && vm.accountDetails.allowances.length > 0) {
                    vm.currentConsumptionBudget = vm.accountDetails.allowances.find((allowance) => {
                        return allowance.state === "Active";
                    });
                } else {
                    vm.projectHasBudget = false;
                }

                if (vm.currentConsumptionBudget) {
                    composeParameters.toDate = null;
                    composeParameters.date = {
                        startDate: moment(vm.currentConsumptionBudget.dateActivated).format("YYYY-MM-DD"),
                        endDate: moment(new Date()).format("YYYY-MM-DD")
                    };
                    composeParameters.byPassHistory = true;
                    composeParameters.isAdmin = false;
                    vm.projectHasBudget = true;
                } else {
                    vm.projectHasBudget = false;
                }
            }

            if (report === "currentBudgetStatus" || report === "consumptionByPO" || report === "thresholdAlerts75") {
                composeParameters.toDate = null;
                composeParameters.date = {
                    startDate: vm.firstBudgetDate,
                    endDate: moment(new Date()).format("YYYY-MM-DD")
                };
            }

            let reportParameters = cloud.composeReportParameters(composeParameters);

            report === "currentBudgetConsumptions" &&
                vm.currentConsumptionBudget &&
                (reportParameters.account = vm.currentConsumptionBudget.accountNum);

            sourceReport.dataSource && vm.reports[sourceReport.dataSource](reportParameters, report);
        };

        vm.prepReportPage = (projects) => {
            var startDate, endDate;
            startDate = new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-01";
            if (new Date().getMonth() === 11) {
                endDate = new Date().getFullYear() + 1 + "-" + 1 + "-01";
            } else {
                endDate = new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 2)).slice(-2) + "-01";
            }

            let reportID = "consumptionOvertimeAll";

            let reportParams = {
                multi: true,
                sourceType: "All",
                view: "project_cost_by_day_minimal",
                parameters: {
                    dateRange: {
                        startDate: startDate,
                        endDate: endDate
                    },
                    projects: projects
                }
            };

            vm.reports.bigQuery(reportParams, reportID);
        };

        vm.getThisMonthDates = () => {
            vm.date = {};

            vm.date.startDate = new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-01";
            if (new Date().getMonth() === 11) {
                vm.date.endDate = new Date().getFullYear() + 1 + "-" + 1 + "-01";
            } else {
                vm.date.endDate =
                    new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 2)).slice(-2) + "-01";
            }
        };

        if (vm.enterprise) {
            vm.getThisMonthDates();
        }

        vm.changeProject = (projectsToRun) => {
            let accountDetailsExist = false;

            vm.accountList.forEach((item) => {
                if (item.projectID === vm.selectedProject) {
                    vm.accountDetails = item;
                    accountDetailsExist = true;
                    if (vm.accountDetails.allowances && vm.accountDetails.allowances.length > 0) {
                        vm.accountDetails.allowances.forEach((allowance) => {
                            if (allowance.type !== "Pay As You Go") {
                                let accountType = util.findItem(allowance.accountNum, vm.billingAccounts, "account");
                                if (accountType) {
                                    allowance.type = accountType.type;
                                }
                            }
                            allowance.type === "PO" && (allowance.type = "Paid");
                        });
                    }
                }
            });

            projectsToRun.forEach((item) => {
                vm[item.id + "ChartSelect"] = item.defaultChart;

                if (item.alterTime) {
                    vm.setNewDates(item.id);
                }
                vm.runReport(item.id);
            });

            vm.projectTotals &&
                (vm.selectedProjectConsumption = cloud.getSelectedProjectTotal(vm.projectTotals, vm.selectedProject));
            !accountDetailsExist && (vm.accountDetails = {});

            $timeout(() => {
                vm.fadeInDash();
            }, 10);
        };

        vm.setNewDates = (report) => {
            vm[report + "Date"] = {};

            if (vm.timeSelect === "thisMonth") {
                vm[report + "Date"].startDate = util.addMonths(new Date(new Date().setDate(1)), 0);
                vm[report + "Date"].endDate = moment(new Date()).format("YYYY-MM-DD");
                vm[report + "toDate"] = false;
            } else if (vm.timeSelect === "last3Months") {
                vm[report + "Date"].startDate = util.addMonths(new Date(new Date().setDate(1)), -2);
                vm[report + "Date"].endDate = moment(new Date()).format("YYYY-MM-DD");
                vm[report + "toDate"] = false;
            }

            return;
        };

        vm.getProjectBudget = () => {
            BCSServer.postData(
                {
                    method: "get",
                    company: user_info.company,
                    role: "IT"
                },
                "/cloud_budgets",
                (response) => {
                    if (
                        response &&
                        response.length > 0 &&
                        response[0].company &&
                        response[0].company === user_info.company
                    ) {
                        vm.company = response[0];
                        vm.departments = response[0].departments;
                        vm.projectList = cloud.removeDisabledProjects(vm.projectList, vm.departments);
                        vm.accountList = cloud.extractAllProjects(response[0]);
                        vm.poBudgets = cloud.findPOBudgets(response[0]);
                        vm.poBudgets = cloud.alignPOBudgets(vm.poBudgets, vm.poAccounts);
                        vm.firstBudgetDate = cloud.getFirstBudgetDate(vm.accountList);
                    } else {
                        vm.accountList = [];
                        vm.departments = [];
                        vm.company = {};
                        vm.firstBudgetDate = moment(new Date()).format("YYYY-MM-DD");
                    }

                    let groupDepartments = cloud.findGroupDepartments(user_info.email, vm.company.groups);

                    if (!vm.isAdmin && !vm.isAdminOrigin) {
                        let depoAccounts = cloud.findUserProjects(user_info, vm.departments, true, groupDepartments);
                        let accounts = cloud.findUserProjects(user_info, vm.accountList);
                        accounts.accountList = accounts.accountList.concat(depoAccounts.accountList);
                        accounts.projectList = accounts.projectList.concat(depoAccounts.projectList);
                        vm.accountList = accounts.accountList;
                        vm.projectList = accounts.projectList;
                        vm.projectSelectList = angular.copy(vm.projectList);
                        if (vm.projectList.length > 1) {
                            vm.multipleProjectUser = true;
                            vm.setUpDashboards();
                        }

                        vm.prepReportPage(cloud.getRawProjectArray(vm.projectList, "project_id"));
                    }
                    vm.accountList &&
                        vm.accountList.length > 0 &&
                        (vm.totalAllocatedCredits = cloud.totalAllocatedCredits(vm.accountList));
                    vm.accountList && vm.accountList.length === 0 && (vm.noBudgetData = true);

                    if (vm.projectSelectList.length > 0) {
                        vm.selectedProject = vm.projectSelectList[0].project_id;
                        vm.changeProject(vm.availableDashboards);
                    } else {
                        vm.availableDashboards.forEach((item) => {
                            vm.createNoDataChart(item.id);
                        });
                    }
                }
            );

            if (vm.isAdmin) {
                vm.fetchAccountNumbers();
            }
        };

        vm.getProjectList = () => {
            if (vm.isAdmin || vm.isAdminOrigin) {
                vm.projectListLoading = true;

                BCSServer.postData(
                    {
                        view: "project_list"
                    },
                    "/big_query/get_query",
                    (response) => {
                        vm.projectList = response;
                        vm.projectListLoading = false;

                        if (vm.projectList && vm.projectList.length > 0) {
                            vm.projectList = cloud.removeExportProjects(vm.projectList, user_info.company_code);
                            vm.projectSelectList = angular.copy(vm.projectList);
                            // vm.projectSelectList = vm.projectSelectList.filter((e) => {
                            //     return (
                            //         e.project_id !== "[Charges not specified to a project]" &&
                            //         e.project_id !== "Unknown"
                            //     );
                            // });
                            vm.getProjectBudget();
                        } else {
                            vm.projectList = [];
                            vm.availableDashboards.forEach((item) => {
                                vm.createNoDataChart(item.id);
                            });
                        }
                    }
                );
            } else {
                vm.getProjectBudget();
            }
        };
        vm.getProjectList();

        vm.fetchAccounts = () => {
            BCSServer.postData(
                {
                    companyCode: user_info.company_code
                },
                "/cloud_accounts",
                (response) => {
                    if (response) {
                        vm.billingAccounts = response.accounts || [];
                        vm.poAccounts = response.pos || [];
                    } else {
                        vm.billingAccounts = [];
                        vm.poAccounts = [];
                    }
                }
            );
        };

        vm.fetchAccounts();

        vm.fetchAccountNumbers = () => {
            vm.accounts = [];
            vm.creditAccounts = [];
            vm.paidAccounts = [];

            BCSServer.postData({ companyCode: user_info.company_code }, "/cloud_accounts", (response) => {
                if (response && response.accounts && response.accounts.length > 0) {
                    vm.accounts = response.accounts;

                    vm.accounts.forEach((item) => {
                        if (item.type === "Credit") {
                            vm.creditAccounts.push(item.account);
                        } else {
                            vm.paidAccounts.push(item.account);
                        }
                    });
                }
            });
        };

        // Fetches project list from GCP
        vm.fetchGCPProjectList = (orgID) => {
            BCSServer.postData(
                {
                    orgID: orgID
                },
                "/cloud_org_structure",
                (response) => {
                    vm.projectNames = {};
                    if (response && response.success) {
                        response.data.forEach((project) => {
                            vm.projectNames[project.projectId] = project.name;
                        });
                    }
                }
            );
        };

        if (user_info.gcpOrgID) {
            vm.fetchGCPProjectList(user_info.gcpOrgID);
        }

        let chartProcessors = {
            currentBudgetConsumptions: (data) => {
                if (data && data[0] && data[0].subtotal && vm.currentConsumptionBudget) {
                    vm.currentConsumption = util.numberWithCommas(data[0].subtotal);
                    vm.currentConsumptionRemaining = util.numberWithCommas(
                        util.formatCurrencyAsNumber(vm.currentConsumptionBudget.amount) - data[0].subtotal
                    );
                }
            },
            currentBudgetStatus: (data, report) => {
                let processedData = cloudProcessor.processCurrentBudgets(data, vm.accountList);
                vm[report + "Table"] = processedData.tableData;
                let chartData = processedData.chartData;

                let series = [
                    {
                        name: "Remaining Budget",
                        color: "#579c8b",
                        stack: "0",
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        data: chartData.remaining,
                        connectNulls: true
                    },
                    {
                        name: "Consumption",
                        color: "#db5760",
                        stack: "0",
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        data: chartData.series,
                        lineWidth: 5,
                        connectNulls: true
                    }
                    
                ];

                vm.setUpChart(
                    {
                        series: series,
                        categories: chartData.categories,
                        chartType: "column",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yVisible: true,
                        yText: "Dollars ($)",
                        legend: true
                    },
                    report
                );
            },
            consumptionByPO: (data, report) => {
                let processedData = cloudProcessor.processPOConsumptions(data, vm.poBudgets);
                vm[report + "Table"] = processedData.tableData;
                let chartData = processedData.chartData;

                let series = [
                    {
                        name: "Remaining Budget",
                        color: "#579c8b",
                        stack: "0",
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        data: chartData.remaining
                    },
                    {
                        name: "Consumption",
                        color: "#db5760",
                        stack: "0",
                        borderColor: "rgba(128, 128, 128, 0.0)",
                        data: chartData.series,
                        lineWidth: 5
                    }
                ];

                vm.setUpChart(
                    {
                        series: series,
                        categories: chartData.categories,
                        chartType: "column",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yVisible: true,
                        yText: "Dollars ($)",
                        legend: true
                    },
                    report
                );
            },
            consumptionOverTime: (data, report) => {
                let processedData = vm.processDataForChart(data, "date", "subtotal", report);

                vm.accountDetails.allowances = cloud.sortAllowancesByDate(vm.accountDetails.allowances);
                let creditBudgets = cloud.totalCreditsPO(vm.accountDetails, processedData.categories.length);

                vm[report + "BudgetLimitProperties"] = [];

                creditBudgets.forEach((item, index) => {
                    vm[report + "BudgetLimitProperties"].push({
                        name: item.budgetData.label,
                        color: creditColors[index],
                        data: item.budgetData.data,
                        fillOpacity: 0.05,
                        type: "area"
                    });
                });

                vm[report + "BudgetLimitProperties"].push({
                    name: "Consumption",
                    color: "rgb(87, 156, 139)",
                    data: processedData.series,
                    fillOpacity: 0.2,
                    type: "area"
                });

                vm.setUpChart(
                    {
                        series: vm[report + "BudgetLimitProperties"],
                        categories: processedData.categories,
                        chartType: "area",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true,
                        zoomSubtitle: true
                    },
                    report
                );
            },
            serviceConsumptionOverTime: (data, report) => {
                let processedData = vm.processDataForChart(data, "date", "subtotal", report);
                vm[report + "Table"] = cloud.formEntityTableData(processedData);
                processedData.series.sort((a, b) => {
                    return (
                        a.data.reduce((c, d) => {
                            return c + d;
                        }, 0) -
                        b.data.reduce((e, f) => {
                            return e + f;
                        }, 0)
                    );
                });
                vm.setUpChart(
                    {
                        series: processedData.series,
                        categories: processedData.categories,
                        chartType: "line",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true,
                        zoomSubtitle: true
                    },
                    report
                );
            },
            entityConsumptionOverTime: function (data, report) {
                this.serviceConsumptionOverTime(data, report);
            },
            yearConsumptionByMonth: (data, report) => {
                let processedData = vm.processDataForChart(data, "month", "subtotal", report);
                let series = [
                    {
                        name: "Consumption",
                        data: processedData.series,
                        lineWidth: 5
                    }
                ];
                vm.setUpChart(
                    {
                        series: series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true
                    },
                    report
                );
            },
            yearConsumptionByMonthAll: (data, report) => {
                let processedData = vm.processDataForChart(data, "month", "subtotal", report);
                let series = [
                    {
                        name: "Consumption",
                        data: processedData.series,
                        lineWidth: 5
                    }
                ];
                vm.setUpChart(
                    {
                        series: series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true
                    },
                    report
                );
            },
            yearConsumptionByMonthAccount: (data, report) => {
                let processedData = vm.processDataForChart(data, "billing_account_id", "subtotal", report);
                let series = [
                    {
                        name: "Consumption",
                        color: "#db5760",
                        data: processedData.series,
                        lineWidth: 5
                    }
                ];
                vm.setUpChart(
                    {
                        series: series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true
                    },
                    report
                );
            },
            consumptionByProject: (data, report) => {
                let processedData = vm.processDataForChart(data, "project_id", "subtotal", report);
                vm.projectTotals = processedData;
                vm.selectedProjectConsumption = cloud.getSelectedProjectTotal(vm.projectTotals, vm.selectedProject);
                let series = [
                    {
                        name: "Consumption",
                        color: "#db5760",
                        data: processedData.series,
                        lineWidth: 5
                    }
                ];
                vm.setUpChart(
                    {
                        series: series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true,
                        legend: true,
                        basic: true
                    },
                    report
                );
            },
            consumptionByDepartment: (data, report) => {
                let processedData = vm.processDataForChart(data, "department", "subtotal", report);
                let series = [
                    {
                        name: "Consumption",
                        color: "#db5760",
                        data: processedData.series,
                        lineWidth: 5
                    }
                ];
                vm.setUpChart(
                    {
                        series: series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true,
                        legend: false
                    },
                    report
                );
            },
            consumptionByLabel: (data, report) => {
                let processedData = vm.processDataForChart(data, "billing_label", "subtotal", report);
                let series = [
                    {
                        name: "Consumption",
                        color: "#db5760",
                        data: processedData.series,
                        lineWidth: 5
                    }
                ];
                vm.setUpChart(
                    {
                        series: series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true,
                        legend: false
                    },
                    report
                );
            },
            thresholdAlerts75: (data, report) => {
                vm.processDataForChart(data, "alert", "subtotal", report);
                vm[report + "Loading"] = false;
            },
            consumptionByEntity: (data, report) => {
                let processedData = vm.processDataForChart(data, "entity", "cost", report);
                let series = [
                    {
                        name: "Consumption",
                        data: processedData.series,
                        lineWidth: 5,
                        connectNulls: true
                    }
                ];
                vm.setUpChart(
                    {
                        series: series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true
                    },
                    report
                );
            },
            consumptionByProduct: (data, report) => {
                let processedData = vm.processDataForChart(data, "service_desc", "cost", report);
                let series = [
                    {
                        name: "Consumption",
                        data: processedData.series,
                        lineWidth: 5,
                        connectNulls: true
                    }
                ];
                vm.setUpChart(
                    {
                        series: series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true
                    },
                    report
                );
            },
            trendStats: (data, report) => {
                data = cloud.removeExportProjects(data, user_info.company_code);
                vm.processTrends(data, report);
            },
            creditStatus: (data, report) => {
                vm.processWidgetTotals(data, report);
                !vm.isAdmin &&
                    !vm.multipleProjectUser &&
                    (vm.totalAllocatedCredits = util.numberWithCommas(cloud.getTotalBudget([vm.accountDetails])));
            }
        };

        vm.processTrends = (data, report) => {
            vm[report] = {
                weekly: {
                    last: 0,
                    this: 0,
                    gain: false
                },
                daily: {
                    yesterday: 0,
                    today: 0,
                    gain: false
                },
                lowProject: {
                    name: "",
                    rate: 100000000
                },
                highProject: {
                    name: "",
                    rate: 0
                }
            };

            if (data && data.length > 0) {
                data.forEach((project) => {
                    if (project.subtotal && project.subtotal / 15 > vm[report].highProject.rate) {
                        vm[report].highProject.rate = project.subtotal / 15;
                        vm[report].highProject.name = project.project_id;
                    }
                    if (project.subtotal && project.subtotal / 15 < vm[report].lowProject.rate) {
                        vm[report].lowProject.rate = project.subtotal / 15;
                        vm[report].lowProject.name = project.project_id;
                    }

                    if (project.breakdown && project.breakdown.length > 0) {
                        project.breakdown.reverse();

                        project.breakdown.forEach((dateCost, index) => {
                            index === 1 && (vm[report].daily.today += dateCost.subtotal);
                            index === 2 && (vm[report].daily.yesterday += dateCost.subtotal);
                            index !== 0 && index < 9
                                ? (vm[report].weekly.this += dateCost.subtotal)
                                : (vm[report].weekly.last += dateCost.subtotal);
                        });
                    }
                });

                vm[report].weekly.gain = vm[report].weekly.last < vm[report].weekly.this;
                vm[report].daily.gain = vm[report].daily.last < vm[report].daily.this;

                vm[report].weekly.last = util.numberWithCommas(vm[report].weekly.last / data.length);
                vm[report].weekly.this = util.numberWithCommas(vm[report].weekly.this / data.length);
                vm[report].daily.yesterday = util.numberWithCommas(vm[report].daily.yesterday / data.length);
                vm[report].daily.today = util.numberWithCommas(vm[report].daily.today / data.length);

                vm[report].lowProject.rate = util.numberWithCommas(vm[report].lowProject.rate);
                vm[report].highProject.rate = util.numberWithCommas(vm[report].highProject.rate);
            }

            vm[report + "Loading"] = false;
        };

        vm.processWidgetTotals = (data, report) => {
            let adjustment = vm.mit ? 59929 : 0;
            vm[report + "TotalConsumption"] = adjustment;
            vm[report + "CreditTotalConsumption"] = adjustment;
            vm[report + "POTotalConsumption"] = 0;
            vm[report + "MasterCreditTotalConsumption"] = adjustment;
            vm.budgetTotals = cloud.getBudgetTotals(vm.accountList, vm.billingAccounts);
            data.forEach((item) => {
                if (vm.isAdmin || vm.multipleProjectUser) {
                    vm[report + "TotalConsumption"] += item.subtotal;
                    vm[report + "CreditTotalConsumption"] += item.subtotal_credit;
                    vm[report + "POTotalConsumption"] += item.subtotal_paid;

                    let masterAccount = vm.billingAccounts.find((account) => {
                        return (
                            account.levelType === "master" &&
                            account.type === "Credit" &&
                            account.account === item.billing_account_id
                        );
                    });

                    if (masterAccount) {
                        vm[report + "MasterCreditTotalConsumption"] += item.subtotal_credit;
                    }
                } else if (item.project_id === vm.accountDetails.projectID) {
                    vm[report + "TotalConsumption"] += Math.abs(item.subtotal);
                }
            });

            vm[report + "CreditTotalConsumption"] =
                vm[report + "CreditTotalConsumption"] - Math.abs(vm[report + "MasterCreditTotalConsumption"]);

            vm[report + "TotalConsumption"] = util.numberWithCommas(vm[report + "TotalConsumption"]);
            vm[report + "CreditTotalConsumption"] = util.numberWithCommas(
                Math.abs(vm[report + "CreditTotalConsumption"])
            );
            vm[report + "POTotalConsumption"] = util.numberWithCommas(vm[report + "POTotalConsumption"]);
            vm[report + "MasterCreditTotalConsumption"] = util.numberWithCommas(
                Math.abs(vm[report + "MasterCreditTotalConsumption"])
            );

            vm.allocatedFundingBudget = util.numberWithCommas(vm.budgetTotals.credit + vm.budgetTotals.po);
            vm.allocatedCreditBudget = util.numberWithCommas(vm.budgetTotals.credit);
            vm.allocatedPOBudget = util.numberWithCommas(vm.budgetTotals.po);

            vm.allocatedMasterCreditBudget = util.numberWithCommas(vm.budgetTotals.creditMaster);
            vm.totalMasterCreditBudget = "1,000,000";

            vm.totalCreditBudget = "1,000,000";
            vm.totalPOBudget = vm.allocatedPOBudget;
            vm.totalFundingBudget = util.numberWithCommas(1000000 + vm.budgetTotals.po);

            vm[report + "Loading"] = false;
        };

        vm.processAlertData = (tableItem) => {
            let project = util.findItem(tableItem.project_id, vm.accountList, "projectID");
            if (project) {
                let availableBudgetInfo = cloud.getCurrentAndFutureBudget(project.allowances);
                let daysOfSpend = moment(availableBudgetInfo.dateActivated).diff(moment(new Date()), "days");
                tableItem.budgetTypes = availableBudgetInfo.types.toString();
                tableItem.budget = availableBudgetInfo.budget;
                tableItem.subtotal = cloud.getLatestBudgetConsumption(
                    tableItem.breakdown,
                    availableBudgetInfo.dateActivated
                );
                let rateOfSpend = tableItem.subtotal / daysOfSpend;
                tableItem.remaining = tableItem.budget - tableItem.subtotal;
                tableItem.daysLeft = tableItem.remaining / rateOfSpend;
                tableItem.daysLeft > 0
                    ? (tableItem.daysLeft = -Math.abs(tableItem.daysLeft))
                    : (tableItem.daysLeft = Math.abs(tableItem.daysLeft));
                tableItem.percentage = (tableItem.subtotal / tableItem.budget) * 100;
                (tableItem.percentage === Infinity || isNaN(tableItem.percentage)) && (tableItem.percentage = 0);
                tableItem.afterCredits = project.afterCredits;
            } else {
                tableItem.budget = 0;
                tableItem.subtotal = 0;
                tableItem.remaining = 0;
                tableItem.percentage = 0;
            }
        };

        vm.processDateData = (report, tableItem, cummulativeCost, processedData, serviceList, index) => {
            tableItem.cummulative = cummulativeCost.toFixed(2);

            if (report === "serviceConsumptionOverTime" || report === "entityConsumptionOverTime") {
                let fieldVar;
                report === "serviceConsumptionOverTime" ? (fieldVar = "service_desc") : (fieldVar = "entity");
                tableItem.breakdown.forEach((breakdown) => {
                    let seriesIndex = serviceList.indexOf(breakdown[fieldVar]);
                    processedData.series[seriesIndex].data[index] +=
                        Number(Math.abs(breakdown.subtotal).toFixed(2)) || 0;
                });
                processedData.series.forEach((ser, serIndex) => {
                    !processedData.series[serIndex].data[index] && (processedData.series[serIndex].data[index] = 0);
                });
            } else {
                processedData.series.push(cummulativeCost);
                let budget;
                if (vm.accountDetails.totalBudget) {
                    budget = util.formatCurrencyAsNumber(vm.accountDetails.totalBudget);
                    vm.singleBudgetExists = true;
                } else {
                    vm.singleBudgetExists = false;
                    budget = tableItem.cummulative;
                }

                tableItem.remaining = budget - cummulativeCost;
                vm.singleBudgetExists
                    ? (tableItem.percentage = (cummulativeCost / budget) * 100)
                    : (tableItem.percentage = 100);
            }
        };

        vm.processProjectTotalData = (report, tableItem, processedData, index, valueField, colorList) => {
            if (report === "consumptionByProject") {
                processedData.series.push(tableItem[valueField]);
            } else {
                processedData.series.push({
                    y: tableItem[valueField],
                    color: colorList[index]
                });
            }

            let singleBudgetExists = true;

            let budget = util.findItem(tableItem.project_id, vm.accountList, "projectID");
            if (budget) {
                budget = cloud.getTotalBudget([budget]);
            } else {
                singleBudgetExists = false;
                budget = tableItem[valueField];
            }

            let remaining = budget - tableItem[valueField];
            vm[report + "RemainingBudget"].push(remaining);
            tableItem.budget = budget;
            tableItem.remaining = remaining;
            singleBudgetExists
                ? (tableItem.percentage = (tableItem[valueField] / budget) * 100)
                : (tableItem.percentage = 100);
        };

        vm.processDepartmentTotalData = (tableItem, processedData, valueField) => {
            vm.departments.forEach((department) => {
                let depoIndex = processedData.categories.indexOf(department.departmentName);
                if (depoIndex === -1) {
                    processedData.categories.push(department.departmentName);
                    processedData.series.push({
                        y: 0,
                        name: department.departmentName
                    });
                }
                let projectDepo = util.findItem(tableItem.project_id, department.projects, "projectID");
                if (projectDepo) {
                    depoIndex != -1 && (processedData.series[depoIndex].y += tableItem[valueField]);
                }
            });
        };

        vm.processMonthData = (report, processedData, tableItem, valueField, index, colorList, categoryName) => {
            if (report === "yearConsumptionByMonth" || report === "yearConsumptionByMonthAll") {
                processedData.series.push({
                    y: tableItem[valueField],
                    name: categoryName
                });
            } else {
                processedData.series.push({
                    y: tableItem[valueField],
                    color: colorList[index],
                    name: categoryName
                });
            }
        };

        vm.processDataForChart = (data, categoryField, valueField, report) => {
            let processedData = {
                categories: [],
                color: [],
                series: []
            };

            vm[report + "Cummulative"] = vm.cummulativeSelect[1];
            // vm.enterprise ? vm[report + 'Cummulative'] = vm.cummulativeSelect[1] : vm[report + 'Cummulative'] = vm.cummulativeSelect[0];

            vm[report + "StoredCummulative"] = null;
            vm[report + "DailyData"] = [];

            let colorList = cloud.generateChartColors(data.length, colors);

            let cummulativeCost = 0;
            vm[report + "TotalConsumption"] = 0;
            vm[report + "Table"] = [];
            let serviceList;

            //TEMPORARY
            vm[report + "RemainingBudget"] = [];

            if (categoryField !== "month") {
                data.sort((a, b) => {
                    if (a[categoryField] < b[categoryField]) {
                        return -1;
                    }
                    if (a[categoryField] > b[categoryField]) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                data.sort((a, b) => {
                    if (new Date(a.year, a.month) < new Date(b.year, a.month)) {
                        return -1;
                    }
                    if (new Date(a.year, a.month) > new Date(b.year, a.month)) {
                        return 1;
                    }
                    return 0;
                });
            }

            if (report === "serviceConsumptionOverTime" || report === "entityConsumptionOverTime") {
                //creating a series for each etity type
                serviceList = cloud.getServiceOrEntityList(data, report);
                serviceList.forEach((service, index) => {
                    processedData.series.push({
                        name: service,
                        color: colors[index % 6],
                        data: new Array(data.length).fill(0)
                    });
                });
            }

            cloud.convertNegativeCredits(data, "subtotal");
            cloud.convertNegativeCredits(data, "cost");

            data.forEach((item, index) => {
                if (
                    report != "yearConsumptionByMonthAll" &&
                    report != "consumptionByLabel" &&
                    !cloud.identifyExportProjects(item, user_info.company_code, report)
                ) {
                    return;
                }

                let tableItem = angular.copy(item);

                item.breakdown && cloud.convertNegativeCredits(item.breakdown, "cost");

                tableItem.date && tableItem.date.value && (tableItem.date = tableItem.date.value);

                let categoryName;
                categoryField === "month"
                    ? (categoryName = vm.months[tableItem[categoryField] - 1])
                    : (categoryName = tableItem[categoryField]);

                report != "consumptionByEntity" &&
                    report != "consumptionByProduct" &&
                    report != "consumptionByDepartment" &&
                    report != "yearConsumptionByMonthAccount" &&
                    processedData.categories.push(categoryName);

                switch (categoryField) {
                    case "alert":
                        vm.processAlertData(tableItem);
                        break;
                    case "date":
                        cummulativeCost += tableItem.subtotal;
                        vm[report + "DailyData"].push(tableItem.subtotal);
                        vm.processDateData(report, tableItem, cummulativeCost, processedData, serviceList, index);
                        break;
                    case "billing_account_id":
                        let account = vm.billingAccounts.find((account) => {
                            return account.account === tableItem[categoryField];
                        });
                        tableItem.accountName = account.name;
                        let accountName = account.name || account.account;
                        processedData.categories.push(accountName);
                        processedData.series.push(tableItem[valueField]);
                        break;
                    case "project_id":
                        vm.processProjectTotalData(report, tableItem, processedData, index, valueField, colorList);
                        break;
                    case "department":
                        vm.processDepartmentTotalData(tableItem, processedData, valueField);
                        break;
                    case "month":
                    case "billing_label":
                        vm.processMonthData(
                            report,
                            processedData,
                            tableItem,
                            valueField,
                            index,
                            colorList,
                            categoryName
                        );
                        break;
                    default:
                        break;
                }

                if (report === "thresholdAlerts75") {
                    tableItem.percentage > 75 &&
                        tableItem.percentage != Infinity &&
                        tableItem.percentage != -Infinity &&
                        vm[report + "Table"].push(tableItem);
                } else {
                    vm[report + "Table"].push(tableItem);
                    vm[report + "TotalConsumption"] += tableItem[valueField];
                }
            });

            if (report === "consumptionByDepartment") {
                vm[report + "Table"] = [];
                processedData.categories.forEach((category, index) => {
                    let productItem = {};
                    productItem[categoryField] = category;
                    productItem.subtotal = processedData.series[index].y;
                    vm[report + "Table"].push(productItem);
                });

                processedData.series = util.sortItems(processedData.series, "name", "ASC", false);

                colorList = cloud.generateChartColors(processedData.series.length, colors);

                processedData.series.forEach((series, index) => {
                    series.color = colorList[index];
                });

                processedData.categories.sort();
            }

            if (report === "consumptionByEntity" || report === "consumptionByProduct") {
                vm.colorList = cloud.generateChartColors(data.length, colors);
                processedData.categories = [];
                data.forEach((item, index) => {
                    vm.totalConsumption += item.subtotal;
                    processedData.categories.push(item[categoryField]);
                    processedData.series.push({
                        y: item.subtotal,
                        color: vm.colorList[index]
                    });
                });
            }

            return processedData;
        };

        vm.setUpChart = (chartOptions, report) => {
            vm[report + "Title"] = chartOptions.title;
            vm[report + "Config"] = cloud.createChart(chartOptions, report, width, height, vm[report + "Table"]);
            vm[report + "Loading"] = false;

            overTimeReports.includes(report) && vm.changeCummulativeChart(report);
        };

        vm.createNoDataChart = (report) => {
            vm[report + "Config"] = Object.assign({}, defaultConfig);
            vm[report + "Table"] = [];
            let title = cloud.determineDataSource(vm.availableDashboards, report, "name");
            title = title.toUpperCase();
            vm[report + "Config"].title = {
                text: title,
                style: {
                    fontSize: "32px"
                }
            };
            vm[report + "Config"].subtitle = {
                text: "NO REPORT DATA",
                style: {
                    fontSize: "18px"
                }
            };
            vm[report + "Title"] = "No report data.";
            vm[report + "TableData"] = [];
            vm[report + "Loading"] = false;
        };

        vm.selectChartChange = (chartName) => {
            vm[chartName + "Config"].chart.type = vm[chartName + "ChartSelect"];
            vm[chartName + "Config"].series.forEach((item) => {
                item.type = vm[chartName + "ChartSelect"];
            });
        };

        vm.changeCummulativeChart = function (chartName) {
            !vm[chartName + "StoredCummulative"] &&
                (vm[chartName + "StoredCummulative"] = angular.copy(vm[chartName + "Config"].series));
            if (vm[chartName + "Cummulative"] === "Daily") {
                chartName === "consumptionOverTime" && vm.switchSingleTimeReportData(chartName);
            } else {
                vm[chartName + "Config"].series = angular.copy(vm[chartName + "StoredCummulative"]);
                if (vm[chartName + "Config"].plotOptions) {
                    vm[chartName + "Config"].plotOptions.series.dataLabels.formatter = () => {
                        return cloud.formatCreditLabel(
                            this,
                            vm[chartName + "Config"].xAxis.categories,
                            vm[chartName + "Config"].series
                        );
                    };
                }
            }
        };

        vm.switchSingleTimeReportData = (chartName) => {
            vm[chartName + "Config"].series = [
                vm[chartName + "Config"].series[vm[chartName + "Config"].series.length - 1]
            ];
            vm[chartName + "Config"].series[0].data = vm[chartName + "DailyData"];
            vm[chartName + "Config"].series[0].name = "Consumption (Daily)";
        };

        vm.expandReport = (report) => {
            vm.modalLoading = false;
            vm.configModal = angular.copy(vm[report + "Config"]);
            vm.configModal.chart.width = $window.innerWidth * 0.86;
            vm.configModal.chart.height = $window.innerHeight * 0.82;
            vm.configModal.xAxis.minRange = 1;
            vm.configModal.subtitle = {
                text: "CLICK AND DRAG TO ZOOM"
            };
            vm.chartHeight = {
                height: vm.configModal.chart.height * 1.025 + "px"
            };
            vm.destroyChart = true;

            $timeout(() => {
                vm.destroyChart = false;
                vm.modalLoading = false;
            }, 100);

            vm.modalInst = $uibModal.open({
                templateUrl: "app/cloudbilling/expandReport.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                windowClass: "device-report-modal",
                scope: $scope
            });
            vm.modalInst.result.then(function () {}).catch(function () {});

            vm.close = () => {
                vm.modalInst.dismiss("cancel");
            };
        };

        //resize charts to be responsive
        $timeout(() => {
            angular.element(window).resize(() => {
                angular.element(".highcharts").each(function () {
                    let chart = angular.element(this).highcharts();
                    let w = angular.element(this).closest(".dashboard-panel").width();
                    chart.setSize(w * 0.975, height, false);
                });
            });
        }, 1000);

        vm.dashControl = {};
        let dashboardList = [];
        vm.chosenDashboards = [];

        let storedDashboards = angular.copy(vm.availableDashboards);

        if ($state.current.name === "index.cloudbilling_dashboard") {
            storedDashboards = storedDashboards.filter((dash) => {
                return dash.id !== "consumptionByProject" && dash.id !== "currentBudgetConsumptions";
            });
        }

        $scope.$watch(
            "vm.chosenDashboards",
            (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    for (let x = 0; x < vm.chosenDashboards.length; x++) {
                        vm.dashControl[vm.chosenDashboards[x].name] = true;
                    }
                    for (let y = 0; y < dashboardList.length; y++) {
                        vm.dashControl[dashboardList[y].name] = false;
                    }
                    vm.fadeInDash();
                }
            },
            true
        );

        vm.selectDashboards = () => {
            let modalInst = $uibModal.open({
                resolve: {
                    list: () => {
                        let options = {
                            unselected: dashboardList,
                            selected: vm.chosenDashboards
                        };
                        return options;
                    }
                },
                templateUrl: "app/main/dashboard_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "DashboardConfigController",
                controllerAs: "vm"
            });
            modalInst.result.then(() => {
                vm.dashboardDatabase("post");
            });
        };

        let dashType = "project";
        if ($state.current.name === "index.cloudbilling_dashboard_admin") {
            dashType = "admin";
        }

        vm.dashboardDatabase = (type) => {
            vm.calendarLoading = true;
            BCSServer.postData(
                {
                    method: type,
                    user: user_info.email,
                    dashboardList: vm.chosenDashboards
                },
                "/dashboard_" + dashType + "_cloud",
                (response) => {
                    if (type === "get") {
                        if (response.length === 0) {
                            //if user dashboard list doesnt exist in database - need to use predefined one
                            vm.chosenDashboards = storedDashboards;
                        } else {
                            vm.chosenDashboards = response[0].dashboardList;
                            dashboardList = storedDashboards;
                            for (let x = 0; x < vm.chosenDashboards.length; x++) {
                                for (let y = 0; y < dashboardList.length; y++) {
                                    if (vm.chosenDashboards[x].name === dashboardList[y].name) {
                                        dashboardList.splice(y, 1);
                                    }
                                }
                            }
                        }
                    }
                }
            );
        };
        vm.dashboardDatabase("get");
    }
})();

(function () {
    angular.module("burWood").controller("CloudConfigController", CloudConfigController);

    /** @ngInject */
    function CloudConfigController(user_info, util, $timeout, BCSServer, $uibModal, _, $scope, moment, Alerts, $state, Service) {
        let vm = this;
        vm.accountLoading = true;
        vm.alerts = [];
        vm.budgetAlerts = [];
        vm.v2Alerts = [];
        vm.disabled = false;
        vm.fixUsersOnly = false;
        vm.fixUsersOnlyLoading = false;

        if (user_info.group && user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") !== -1) {
            vm.burwoodManager = true;
        } else {
            vm.burwoodManager = false;
        }

        let defaultDepartment = {
            departmentName: "",
            contactList: [],
            alertThreshold: 90,
            alerts: [],
            allowances: [],
            totalBudget: 0,
            afterCredits: null,
            afterCreditsAccount: null,
            paidBillingAccounts: null,
            budgetType: "Reporting",
            activity: [],
            projects: []
        };

        let accountQuery = {
            company: user_info.company,
            method: "get",
            role: "IT"
        };


        let snowGroupsSysIdMap = {
            "2eeae8df1b800890268dc8415b4bcb59": "Admin User",
            "aba8f15e1bd51c505c267591dd4bcb48": "Admin User - Read Only"
        }

        vm.fetchProjectMap = () => {
            BCSServer.postData(accountQuery, "/cloud_budgets", (response) => {
                if (response && angular.isArray(response) && response.length > 0 && response[0].departments) {
                    vm.account = response[0];
                    if (vm.account.budget && vm.account.dateActivated) {
                        vm.prepCompanyConsumption();
                    }
                } else {
                    let projectDepartment = angular.copy(defaultDepartment);
                    projectDepartment.departmentName = "Projects";
                    vm.account = vm.initAccountBudget();
                    vm.account.departments.push(projectDepartment);
                }
                vm.account.dateActivated && (vm.account.dateActivated = moment(vm.account.dateActivated).utc());
                !vm.account.alerts && (vm.account.alerts = []);
            });
        };
        vm.fetchProjectMap();

        vm.prepCompanyConsumption = () => {
            vm.companyConsumption = "Calculating...";
            vm.getCurrentCompanyConsumption({
                view: "company_cost_total",
                parameters: {
                    dateRange: {
                        startDate: moment(vm.account.dateActivated).format("YYYY-MM-DD"),
                        endDate: moment(new Date()).format("YYYY-MM-DD")
                    }
                }
            });
        };

        vm.getCurrentCompanyConsumption = (reportParameters) => {
            BCSServer.postData(reportParameters, "/big_query/get_query", (response) => {
                if (response && response[0]) {
                    vm.companyConsumption = "$" + util.numberWithCommas(response[0].subtotal);
                } else {
                    vm.companyConsumption = "$0.00";
                }
            });
        };


        vm.initiateV2Migration = () => {
            Service.getQuery(
                {
                    company: user_info.company
                },
                "sys_user|userList",
                (data) => {
                    if (data.error || !data.results || (data.results && data.results.legnth === 0)) {
                        vm.createAlertMessage({
                            type: "v2Alerts",
                            msg: "Failed To Initiate Migration To V2",
                            status: "fail"
                        });
                    } 
                    let users = data.results;


                    //Query groups for all users and add "groups" field to users object
                    const userPromises = users.map((user) => {
                        return new Promise((resolve, reject) => {
                            user.groups = [];
                            Service.getQuery(
                                {
                                    user: user.sys_id
                                },
                                "sys_user_grmember",
                                (data) => {
                                    if (data.error) {
                                        reject(new Error("Failed To Fetch User Groups"));
                                    } else {
                                        data.results.forEach((item) => {
                                            user.groups.push(
                                                snowGroupsSysIdMap[item.group.value]
                                            );
                                        });
                                        resolve();
                                    }
                                }
                            );
                        });
                    });

                    Promise.all(userPromises)
                        .then(() => {
                            
                            // Make the BCSServer call after all user group queries are done
                            BCSServer.postData({
                                users: users
                            }, "/broadcast_data_to_v2_pubsub", (response) => {
                                if (response && response.success) {
                                    vm.createAlertMessage({
                                        type: "v2Alerts",
                                        msg: "Successfully Initiated Migration To V2",
                                        status: "success"
                                    });
                                    // vm.cloudAccount.automationEnabled = false
                                    // vm.toggleV1Automation()
                                } else {
                                    vm.createAlertMessage({
                                        type: "v2Alerts",
                                        msg: "Failed To Initiate Migration To V2",
                                        status: "fail"
                                    });
                                }
                            });
                        })
                        .catch((error) => {
                            console.error(error.message);
                            vm.createAlertMessage({
                                type: "v2Alerts",
                                msg: error.message,
                                status: "fail"
                            });
                        });

                
                }

            );
            
        };

        
        vm.initiateFixProjectUsersOnly = () => {
            if (!vm.cloudAccount || !vm.account) {
                vm.createAlertMessage({
                    type: "v2Alerts",
                    msg: "Account and budget data must be loaded before running fix.",
                    status: "fail"
                });
                return;
            }
            vm.fixUsersOnlyLoading = true;
            const cloudAccounts = {
                companyName: vm.cloudAccount.companyName || user_info.company_name,
                company: user_info.company
            };
            const cloudBudget = angular.copy(vm.account);
            delete cloudBudget._id;
            delete cloudBudget.__v;
            BCSServer.postData(
                {
                    fix_users_only: true,
                    cloudAccounts: cloudAccounts,
                    cloudBudget: cloudBudget
                },
                "/client_data_migration",
                (response) => {
                    vm.fixUsersOnlyLoading = false;
                    if (response && response.success) {
                        vm.createAlertMessage({
                            type: "v2Alerts",
                            msg: response.message || "Successfully ran fix project users only",
                            status: "success"
                        });
                    } else {
                        vm.createAlertMessage({
                            type: "v2Alerts",
                            msg: (response && response.error) || "Failed to run fix project users only",
                            status: "fail"
                        });
                    }
                }
            );
        };

        vm.toggleV1Automation = () => {
            vm.cloudAccount.automationEnabled = !vm.cloudAccount.automationEnabled;
            console.log("Toggling V1 Automation");

            BCSServer.postData(
                {
                    automationEnabled: vm.cloudAccount.automationEnabled
                },
                "/toggle_v1_automation",
                (response) => {
                    if (response && response.success) {
                        const message = vm.cloudAccount.automationEnabled ? "Successfully Enabled Automation for V1" : "Successfully Disabled Automation for V1";
                        vm.createAlertMessage({
                            type: "v2Alerts",
                            msg: message,
                            status: "success"
                        });
                    } else {
                        vm.createAlertMessage({
                            type: "v2Alerts",
                            msg: "Failed To Toggle V1 Automation",
                            status: "fail"
                        });
                    }
                }
            );
            
        };


        vm.formatCurrency = (budget, formattedField) => {
            budget[formattedField] = "$" + util.numberWithCommas(util.formatCurrencyAsNumber(budget[formattedField]));
        };

        vm.initAccountBudget = () => {
            return {
                company: user_info.company,
                activity: [],
                departments: [],
                groups: [
                    {
                        groupName: user_info.company_name,
                        contactList: [],
                        billingContactEmail: [],
                        departments: ["Projects", "Unaffiliated Projects", "Disabled Projects"]
                    }
                ]
            };
        };

        vm.thresh = {
            units: {
                floor: 0,
                ceil: 100,
                step: 5,
                disabled: vm.disabled
            },
            unitsVelocity: {
                floor: 0,
                ceil: 10000,
                step: 10,
                disabled: vm.disabled
            }
        };

        let defaultItems = {
            allowances: {
                type: "",
                poNumber: "",
                amount: "",
                dateActivated: "",
                dateIssued: "",
                state: "",
                next: ""
            },
            alerts: {
                alertThreshold: "90",
                enabled: true,
                expired: false
            },
            accounts: {
                account: "",
                type: ""
            }
        };

        vm.openProjectUsers = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "CloudContactController",
                controllerAs: "vm",
                resolve: {
                    cache: () => {
                        return null;
                    }
                }
            });
            modalInst.result.then((payload) => {
                if (payload) {
                    let foundUser = util.findItem(payload.email, vm.account.contactList, "email");
                    if (payload.email && !foundUser) {
                        vm.account.contactList.push({
                            email: payload.email,
                            alerts: true,
                            weeklySummary: true
                        });
                    }
                }
            });
        };

        vm.userPreferences = (user) => {
            let modalInst = $uibModal.open({
                resolve: {
                    user: () => {
                        return user;
                    },
                    disabled: () => {
                        return vm.disabled;
                    }
                },
                templateUrl: "app/cloudbilling/singleUser.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "UserAdminController",
                size: "lg",
                controllerAs: "vm"
            });
            modalInst.result.then((user) => {
                if (user.delete) {
                    let index = _.findIndex(vm.account.contactList, {
                        email: user.email
                    });
                    vm.deparaccounttment.contactList.splice(index, 1);
                }
                user.update = false;
                user.delete = false;
            });
        };

        vm.delete_watchlist = (index) => {
            vm.account.contactList.splice(index, 1);
        };

        vm.addProjectUserEmail = (userEmail) => {
            if (userEmail == null || userEmail == "") {
                return;
            }
            vm.addProjectUser(userEmail);
        };

        vm.addProjectUser = (userEmail) => {
            if (vm.account.contactList.length > 0) {
                vm.account.contactList.push({
                    email: userEmail,
                    weeklySummary: true,
                    alerts: true
                });
            } else {
                vm.account.contactList = [
                    {
                        email: userEmail,
                        weeklySummary: true,
                        alerts: true
                    }
                ];
            }
            vm.projectUsersEmail = null;
        };

        vm.switch_watchlist = () => {
            vm.projectUsersShow = !vm.projectUsersShow;
        };

        vm.addItem = (level, itemType) => {
            if (vm[level][itemType] && vm[level][itemType].length > 0) {
                vm[level][itemType].push(angular.copy(defaultItems[itemType]));
            } else {
                vm[level][itemType] = [angular.copy(defaultItems[itemType])];
            }
        };

        vm.removeItem = (level, itemType, budgetIndex) => {
            vm[level][itemType].splice(budgetIndex, 1);
        };

        $timeout(() => {
            $scope.$broadcast("rzSliderForceRender");
        });

        vm.fetchAccount = () => {
            BCSServer.postData(
                {
                    companyCode: user_info.company_code
                },
                "/cloud_accounts",
                (response) => {
                    vm.accountLoading = false;
                    if (response) {
                        vm.cloudAccount = response;
                        if (vm.cloudAccount.automationEnabled === undefined) {
                            vm.cloudAccount.automationEnabled = true; // Default to true if undefined
                        }
                        if (vm.cloudAccount.logo) {
                            vm.downloadFile =
                                "data:" +
                                vm.cloudAccount.logo.contentType +
                                ";base64," +
                                btoa(String.fromCharCode.apply(null, vm.cloudAccount.logo.data.data));
                        }
                        if (!vm.cloudAccount.billingContactEmail) {
                            vm.cloudAccount.billingContactEmail = [];
                        }
                    } else {
                        vm.noAccount = true;
                        vm.cloudAccount = {};
                    }
                }
            );
        };
        vm.fetchAccount();

        vm.updateAccount = () => {
            vm.accountLoading = true;
            delete vm.cloudAccount._id;
            delete vm.cloudAccount.__v;
            BCSServer.postData(
                {
                    companyCode: vm.cloudAccount.companyCode,
                    companyAccounts: vm.cloudAccount
                },
                "/update_cloud_accounts",
                (response) => {
                    vm.accountLoading = false;
                    if (response.error || !response) {
                        let error = response || "";
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Failed To Update Notification Settings. Please Contact Support For Further Assistance.  ${angular.toString(
                                error
                            )}`,
                            status: "fail"
                        });
                    } else {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Successfully Updated Notification Settings",
                            status: "success"
                        });
                    }
                }
            );
        };

        vm.updateBudget = () => {
            vm.budgetLoading = true;
            delete vm.account._id;
            delete vm.account.__v;

            vm.account.dateActivated && (vm.account.dateActivated = moment(vm.account.dateActivated).utc());

            let accountQueryUpdate = {
                company: user_info.company,
                method: "post",
                account: vm.account
            };

            BCSServer.postData(accountQueryUpdate, "/cloud_budgets", (response) => {
                vm.budgetLoading = false;
                if (response && response._id) {
                    vm.createAlertMessage({
                        type: "budgetAlerts",
                        msg: "Successfully Updated Project Mapping",
                        status: "success"
                    });
                    vm.prepCompanyConsumption();
                } else {
                    let error = response.error || "";
                    vm.createAlertMessage({
                        type: "budgetAlerts",
                        msg: `Failed To Update Project Mapping.  ${angular.toString(error)}`,
                        status: "fail"
                    });
                }
            });
        };

        vm.addBillingContact = () => {
            vm.cloudAccount.billingContactEmail.unshift("");
        };

        vm.removeBillingContact = (index) => {
            vm.cloudAccount.billingContactEmail.splice(index, 1);
        };

        vm.createAlertMessage = (alert) => {
            vm[alert.type].push({
                status: alert.status,
                msg: alert.msg
            });
            Alerts.storeAlert({
                type: alert.status,
                message: alert.msg,
                user: user_info.email,
                company: user_info.company_name,
                location: $state.current.name,
                tags: ["Cloud Company Configuration"]
            });
            $timeout(() => {
                vm[alert.type] = [];
            }, 5000);
        };

        vm.close_notice = (index, type) => {
            vm[type].splice(index, 1);
        };

        vm.openEmailContacts = () => {
            let modalInst = $uibModal.open({
                resolve: {
                    emailContacts: () => {
                        return vm.cloudAccount.emailContacts;
                    }
                },
                templateUrl: "app/cloudbilling/company/adminContacts.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "EmailContactController",
                controllerAs: "vm"
            });
            modalInst.result.then((emailContacts) => {
                vm.cloudAccount.emailContacts = emailContacts;
                vm.updateAccount();
            });
        };

        vm.attachmentList = [];
        vm.attachment = () => {
            let modalInst = $uibModal.open({
                resolve: {
                    account: () => {
                        return vm.cloudAccount;
                    }
                },
                templateUrl: "app/userAdmin/logoAttachment.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "LogoController",
                controllerAs: "vm"
            });
            modalInst.result.then(
                (data) => {
                    vm.cloudAccount = data;
                    if (vm.cloudAccount.logo) {
                        vm.downloadFile =
                            "data:" +
                            vm.cloudAccount.logo.contentType +
                            ";base64," +
                            btoa(String.fromCharCode.apply(null, vm.cloudAccount.logo.data.data));
                    }
                },
                function () {}
            );
        };
    }
})();

(function () {
    angular.module("burWood").controller("BurwoodAdminController", BurwoodAdminController);

    /** @ngInject */
    function BurwoodAdminController(
        _,
        user_info,
        $timeout,
        BCSServer,
        cloud,
        util,
        ServiceNow,
        DTColumnDefBuilder,
        DTOptionsBuilder,
        moment,
        $uibModal,
        $log,
        apiBasePath,
        Alerts,
        $state,
        $scope,
        $http,
        FileSaver
    ) {
        let vm = this;
        
        vm.loading = true;
        vm.alerts = [];
        vm.accountAlerts = [];
        vm.knownCreditsAlerts = [];
        vm.account = {
            activity: []
        };

        vm.years = util.getYearList();
        vm.months = util.getMonthList();

        vm.selectedYear = vm.years[vm.years.length - 1];
        vm.selectedMonth = moment().subtract(1, "month").startOf("month").format("MMMM");

        vm.tabView = "account";

        vm.sourceTypes = [
            {
                name: "Credit",
                id: "Credit"
            },
            {
                name: "Paid",
                id: "PO"
            }
        ];

        vm.budgetTypes = [
            {
                name: "Main",
                id: "master"
            },
            {
                name: "Individual",
                id: "individual"
            }
        ];

        vm.pricebooks = [
            {
                name: "List",
                id: "list"
            },
            {
                name: "I2",
                id: "i2"
            },
            {
                name: "Strides",
                id: "strides"
            }
        ];

        vm.poTypes = [
            {
                name: "Standard",
                id: "standard"
            },
            {
                name: "STRIDES Grant",
                id: "strides"
            }
        ];

        vm.invoicingRoles = [
            {
                name: "Company",
                id: "company"
            },
            {
                name: "Group",
                id: "group"
            }
        ];

        vm.poLevels = [
            {
                name: "Company",
                id: "company"
            },
            {
                name: "Department",
                id: "department"
            },
            {
                name: "Project",
                id: "project"
            }
        ];

        vm.departmentInvoiceTemplate = [
            {
                name: "Payable",
                id: "payable"
            },
            {
                name: "Non-Payable",
                id: "nonpayable"
            }
        ];

        let columnFilter = {
            aoColumns: [
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                }
            ]
        };

        let defaultDepartment = {
            departmentName: "",
            contactList: [],
            alertThreshold: 90,
            alerts: [],
            allowances: [],
            totalBudget: 0,
            afterCredits: null,
            afterCreditsAccount: null,
            paidBillingAccounts: null,
            budgetType: "Reporting",
            activity: [],
            projects: []
        };

        vm.dtActivityOptions = DTOptionsBuilder.newOptions()
            .withOption("order", [["3", "des"]])
            .withColumnFilter(columnFilter)
            .withOption("responsive", true);
        vm.dtColumnDefsActivity = [
            DTColumnDefBuilder.newColumnDef(3).withOption("type", "date"),
            DTColumnDefBuilder.newColumnDef([2]).withClass("max-size-activity"),
            DTColumnDefBuilder.newColumnDef([0, 1, 3]).withClass("vert-align-activity")
        ];

        let init = true;

        //checking if user is admin
        if (user_info.group) {
            user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") != -1 && (vm.burwoodManager = true);
        }

        if (window.location.hostname === 'bcs.burwood.com' && user_info.email === 'kponto@Burwood.com') {
            vm.confirmUser = true
        }

        if (
            window.location.hostname !== 'bcs.burwood.com' &&
            user_info.sys_id === "359412d31b22fc5478eebeef034bcb2c" ||
            user_info.sys_id === "df7b01fc1b8ff89078eebeef034bcbd9" ||
            user_info.sys_id === "1ad7cddb4fbd6340b9c57fe24210c769" ||
            user_info.sys_id === "4522002f1bf6ec9078eebeef034bcbd8" ||
            user_info.sys_id === "cada8878db89c510163905d2ca961975" ||
            user_info.sys_id === "163acccc1bb45d1078eebeef034bcbb0" ||
            user_info.sys_id === "359412d31b22fc5478eebeef034bcb2c" ||
            user_info.sys_id === "5ff71ec41bc8f154e7594336dc4bcb95" ||
            user_info.sys_id === "e7fb92051b1721104003631e6e4bcb60"
        ) {
            vm.confirmUser = true;
        }

        vm.gcpBillingAccounts = () => {
            BCSServer.postData({}, "/gcp_billing_accounts", (response) => {
                if (response) {
                    vm.formattedAccounts = cloud.formatGCPAccounts(response);
                } else {
                    vm.formattedAccounts = [];
                }
            });
        };
        vm.gcpBillingAccounts();

        vm.gcpBillingSubaccounts = (account) => {
            BCSServer.postData({ mainAccount: account.account }, "/gcp_billing_subaccounts", (response) => {
                let subAccountsToAdd = [];
                if (response && response.success) {
                    subAccountsToAdd = cloud.formatGCPAccounts(response.subaccounts);
                    vm.addSubaccounts(subAccountsToAdd, account);
                } else {
                    vm.createAlertMessage({
                        type: "alerts",
                        msg: "Cannot Locate Subaccount Information",
                        status: "fail"
                    });
                }
            });
        };

        vm.addSubaccounts = (accounts, parentAccount) => {
            accounts.forEach((account) => {
                let foundAccount = vm.selectedCompany.accounts.find((gcpAccount) => {
                    return account.account === gcpAccount.account;
                });

                if (foundAccount) {
                    return;
                }

                vm.selectedCompany.accounts.push({
                    type: parentAccount.type,
                    account: account.account,
                    name: account.name,
                    levelType: "individual",
                    pricebook: parentAccount.pricebook
                });
            });
        };

        vm.matchAccountNamesToDB = () => {
            vm.selectedCompany.accounts.forEach((account) => {
                if (!account || !vm.formattedAccounts) {
                    return;
                }
                let foundAccount = vm.formattedAccounts.find((gcpAccount) => {
                    return account.account === gcpAccount.account;
                });
                if (foundAccount) {
                    account.name = foundAccount.name;
                }
            });
        };

        vm.fetchAccountNumbers = () => {
            BCSServer.postData({}, "/cloud_companies_all", (response) => {
                if (response && angular.isArray(response) && response.length > 0) {
                    vm.companies = response;
                    util.sortItems(vm.companies, "companyName", "ASC");
                    vm.companies.forEach((company) => {
                        if (company.activity) {
                            vm.account.activity = vm.account.activity.concat(company.activity);
                        }
                        company.accounts = util.sortItems(company.accounts, "name", "ASC");
                        vm.fillUndefinedValues(company);
                    });
                    vm.fetchProjectMap();
                } else {
                    vm.createAlertMessage({
                        type: "alerts",
                        msg: "Cannot Locate Client Information",
                        status: "fail"
                    });
                    vm.loading = false;
                    vm.companies = [];
                }
            });
        };

        vm.fetchProjectMap = () => {
            BCSServer.postData({}, "/cloud_budgets_all", (budgets) => {
                vm.allBudgets = budgets || [];
                vm.companies.forEach((company) => {
                    let foundBudget = budgets.find((budget) => {
                        return budget.company === company.company;
                    });

                    if (foundBudget) {
                        company.budgets = foundBudget;
                        company.flat = cloud.flattenOrg(foundBudget);
                        if (!foundBudget.groups || foundBudget.groups.length === 0) {
                            foundBudget.groups = [
                                {
                                    groupName: company.companyName,
                                    contactList: [],
                                    billingContactEmail: [""],
                                    departments: []
                                }
                            ];
                        }
                    } else {
                        company.budgets = {
                            company: company.company,
                            activity: [],
                            departments: [],
                            groups: [
                                {
                                    groupName: company.companyName,
                                    contactList: [],
                                    billingContactEmail: [""],
                                    departments: []
                                }
                            ]
                        };
                        let projectDepartment = angular.copy(defaultDepartment);
                        projectDepartment.departmentName = "Projects";
                        projectDepartment.departmentID = cloud.createIDString(12);
                        company.budgets.departments.push(projectDepartment);

                        let unAffiliatedDepartment = angular.copy(defaultDepartment);
                        unAffiliatedDepartment.departmentName = "Unaffiliated Projects";
                        unAffiliatedDepartment.departmentID = cloud.createIDString(12);
                        company.budgets.departments.push(unAffiliatedDepartment);

                        company.budgets.groups[0].departments.push(unAffiliatedDepartment.departmentID);
                        company.budgets.groups[0].departments.push(projectDepartment.departmentID);
                        vm.groupDepartments = angular.copy(company.budgets.departments);
                        company.flat = {
                            department: [],
                            project: []
                        };
                    }
                });
                console.log("AM I GETTING CALLED")
                vm.findServicenowCloudCompanies();
            });
        };

        if (vm.burwoodManager) {
            // On Burwood admin page init, fetch companies_report and log the results.
            BCSServer.getData("/companies_report", (response) => {
                $log.info("companies_report response:", response);
            });
            vm.fetchAccountNumbers();
        }

        vm.fillUndefinedValues = (company) => {
            if (company) {
                company.providedDiscount = company.providedDiscount || 0;
                company.centralTax = company.centralTax || 0;

                if (company.accounts) {
                    company.accounts.forEach((account) => {
                        angular.isUndefined(account.name) && (account.name = "");
                    });
                }
            }
        };

        vm.fetchKnownCredits = (companyCode) => {
            vm.knownCredits = {};
            vm.knownCreditsLoading = true;
            BCSServer.postData(
                {
                    companyCode: companyCode
                },
                "/known_credits",
                (response) => {
                    vm.knownCreditsLoading = false;
                    if (response && response.credits && response.credits.length > 0) {
                        vm.knownCredits = response;
                    } else {
                        vm.knownCredits.credits = [];
                    }
                    vm.knownCreditsSetting = angular.copy(vm.knownCredits);
                }
            );
        };

        vm.confirmInvoices = (validation) => {
            let prompt;

            if (validation) {
                prompt = confirm("This action will validate latest invoices.  Continue?");
            } else {
                prompt = confirm("This action will process latest invoice month CSV to PDF.  Continue?");
            }

            if (prompt) {
                BCSServer.postData({ validation: validation }, "/confirm_invoices", (response) => {
                    $log.info(response);
                });
            }
        };

        vm.accountPageIndex = 0;
        vm.switchPage = (direction) => {
            vm.accountPageMax = vm.accountPages;

            switch (direction) {
                case 'next':
                    if(vm.accountPageIndex < vm.accountPageMax) vm.accountPageIndex++;
                    break;
                case 'previous':
                    if(vm.accountPageIndex > 0) vm.accountPageIndex--;
                    break;
                default:
                    vm.accountPageIndex = 0
            }
        };

        vm.chooseContent = (company, index, bypass) => {
            let prompt = true;

            if (
                !bypass &&
                (!angular.equals(vm.selectedCompany, vm.selectedCompanySetting) ||
                    !angular.equals(vm.knownCredits, vm.knownCreditsSetting))
            ) {
                prompt = confirm("You have made changes to this company, do you wish to leave?");
            }

            if (prompt) {
                vm.companyIndex = index;
                vm.selectedCompany = company;
                vm.accountPageIndex = 0;
                vm.accountPages = vm.getAccountPages();
                vm.selectedCompanySetting = angular.copy(vm.selectedCompany);
                vm.selectedCompany.invoicingRole = vm.selectedCompany.invoicingRole
                    ? vm.selectedCompany.invoicingRole
                    : "company";
                vm.selectedCompany.departmentInvoiceTemplate = vm.selectedCompany.departmentInvoiceTemplate
                    ? vm.selectedCompany.departmentInvoiceTemplate
                    : "Payable";
                
                !vm.selectedCompany.emailContacts && (vm.selectedCompany.emailContacts = []);

                vm.switchFeed("selectedCompany");
                vm.fetchKnownCredits(company.companyCode);
                vm.fillUndefinedValues();
                vm.matchAccountNamesToDB();

                if (vm.selectedCompany.accounts && vm.selectedCompany.accounts.length > 0) {
                    vm.syncSNContract(vm.selectedCompany.company);
                }

                if (init) {
                    $timeout(() => {
                        angular.element(".sku-title").removeClass("toggle-border");
                        angular.element("#cloud-company-" + index.toString()).addClass("toggle-border");
                        init = false;
                    }, 100);
                } else {
                    angular.element(".sku-title").removeClass("toggle-border");
                    angular.element("#cloud-company-" + index.toString()).addClass("toggle-border");
                }
            }
        };

        vm.revertServiceFees = (accounts, role) => {
            if (role !== "group") {
                accounts.forEach((account) => {
                    if (account) account.invoicingGroup = false;
                });
            }
        };

        vm.applyGroupAccounts = (company) => {
            if (
                company &&
                company.accounts &&
                company.accounts.length > 0 &&
                company.budgets &&
                company.budgets.groups
            ) {
                company.budgets.groups.forEach((group) => {
                    let foundAccounts = company.accounts.filter((account) => group.groupID === account.group);
                    foundAccounts.forEach((account) => {
                        account.centralTax = group.centralTax || 0;
                        account.invoicingGroup = true;
                    });
                    group.billingAccounts = foundAccounts.map((fAccount) => fAccount.account);
                });
            }
        };

        vm.checkSubaccounts = (accountObj) => {
            let prompt = false;

            if (accountObj.levelType === "master") {
                prompt = confirm("Would to like to add all subaccounts of this main account?");
            }

            if (prompt) {
                vm.gcpBillingSubaccounts(accountObj);
            }
        };

        vm.update = () => {
            if (!vm.selectedCompany.companyCode) {
                vm.createAlertMessage({
                    type: "alerts",
                    msg: 'Please fill out "Company Code"',
                    status: "fail"
                });
                return;
            } else {
                vm.loading = true;
                vm.composeActivity();
                vm.applyGroupAccounts(vm.selectedCompany);
                vm.updateAccountNames();
                vm.updateAccountNumbers();
                vm.updateBudgets();
                if (vm.selectedCompany.accounts && vm.selectedCompany.accounts.length > 0) {
                    vm.syncSNContract(vm.selectedCompany.company);
                }
            }
        };

        vm.updateAccountNames = () => {
            if (
                vm.selectedCompany &&
                vm.selectedCompany.accounts &&
                vm.selectedCompany.accounts.length > 0 &&
                vm.formattedAccounts &&
                vm.formattedAccounts.length > 0
            ) {
                vm.selectedCompany.accounts.forEach((account) => {
                    if (!account) {
                        return;
                    }
                    let foundAccount = vm.formattedAccounts.find((gcpAccount) => {
                        return account.account === gcpAccount.account;
                    });
                    if (foundAccount) {
                        account.name = foundAccount.name;
                    }
                });
            }
        };

        vm.delete = (company, index, bypass) => {
            if (!bypass) {
                let prompt = confirm("Are you sure you wish to delete this account?");
                if (!prompt) {
                    return;
                }
            }
            vm.loading = true;
            BCSServer.postData(
                {
                    companyCode: company.companyCode
                },
                "/delete_cloud_account",
                (response) => {
                    vm.loading = false;
                    if (response && response === "Success") {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Successfully Deleted Account.",
                            status: "success"
                        });
                        vm.companies.splice(index, 1);
                        vm.chooseContent(vm.companies[0], 0, true);
                    } else {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Failed to delete account. Please contact support for assistance.  ${angular.toString(
                                response
                            )}`,
                            status: "fail"
                        });
                    }
                }
            );
        };

        vm.matchCompanyName = (account) => {
            vm.formattedAccounts.forEach((item) => {
                if (item.account === account.account) {
                    account.name = item.name;
                }
            });
        };

        vm.fetchBMSContracts = (cloudSysIDs) => {
            ServiceNow.getQuery(
                {
                    companyIN: cloudSysIDs.join(","),
                    bypassCompany: true
                },
                "u_bms_contracts|bmsContractSys",
                (contracts) => {
                    if (contracts && contracts.results && contracts.results.length > 0) {
                        vm.contractObj = vm.formatContractMap(contracts.results);
                    } else {
                        vm.contractObj = {};
                    }
                    vm.loading = false;
                    vm.chooseContent(vm.companies[0], 0);
                }
            );
        };

        vm.formatContractMap = (contracts) => {
            let contractObj = {};
            contracts.forEach((contract) => {
                contractObj[contract["company.sys_id"]] = contract.sys_id;
            });
            return contractObj;
        };

        vm.syncSNContract = (companySys) => {
            if (apiBasePath !== "https://api.bcs.burwood.com") {
                return;
            }
            if (vm.contractObj[companySys]) {
                ServiceNow.getQuery({ u_contract_id: vm.contractObj[companySys] }, "u_cloud_account", (results) => {
                    let portalMappedAccounts = vm.mapSNCloudAccount(
                        vm.selectedCompany.accounts,
                        vm.contractObj[companySys]
                    );
                    if (results && results.results && results.results.length > 0) {
                        let snContractAccounts = results.results;
                        // check for accounts no longer in portal
                        snContractAccounts.forEach((snAccount) => {
                            let foundAccount = portalMappedAccounts.find((portalAccount) => {
                                return portalAccount.u_account_id === snAccount.u_account_id;
                            });
                            if (!foundAccount) {
                                vm.deleteSNCloudAccounts(snAccount.sys_id);
                            } else {
                                // check for changed accounts
                                let accountChanged = vm.checkChangedAccount(snAccount, foundAccount);
                                if (accountChanged) {
                                    vm.updateSNCloudAccounts(snAccount.sys_id, foundAccount);
                                }
                            }
                        });

                        // check for missing sn accounts
                        portalMappedAccounts.forEach((portalAccount) => {
                            let foundAccount = snContractAccounts.find((snAccount) => {
                                return portalAccount.u_account_id === snAccount.u_account_id;
                            });
                            if (!foundAccount) {
                                vm.postSNCloudAccounts(portalAccount);
                            }
                        });
                    } else {
                        vm.loading = false;
                        portalMappedAccounts.forEach((account) => {
                            vm.postSNCloudAccounts(account);
                        });
                    }
                });
            }
        };

        vm.checkChangedAccount = (snAccount, portalAccount) => {
            if (snAccount["u_type"] !== portalAccount["type"]) {
                return true;
            } else if (snAccount["u_source"] !== portalAccount["source"]) {
                return true;
            } else if (snAccount["u_pricebook"] !== portalAccount["pricebook"]) {
                return true;
            } else if (snAccount["u_margin"] !== portalAccount["margin"]) {
                return true;
            }
            return false;
        };

        vm.mapSNCloudAccount = (accounts, contractID) => {
            let snAccounts = [];
            accounts.forEach((account) => {
                let accountObj = {
                    u_contract_id: contractID,
                    u_account_id: account.account,
                    u_account_name: account.name,
                    u_type: account.type,
                    u_source: account.levelType,
                    u_pricebook: account.pricebook,
                    u_margin: account.margin
                };
                snAccounts.push(accountObj);
            });
            return snAccounts;
        };

        vm.postSNCloudAccounts = (account) => {
            ServiceNow.createItem("u_cloud_account", account, (results) => {
                if (results && results.result) {
                    // success
                } else {
                    $log.info("Failed to sync billing account");
                }
            });
        };

        vm.deleteSNCloudAccounts = (account_sys) => {
            ServiceNow.deleteItem("u_cloud_account", account_sys, () => {});
        };

        vm.updateSNCloudAccounts = (account_sys, account) => {
            ServiceNow.updateItem("u_cloud_account", account_sys, account, () => {});
        };

        vm.findServicenowCloudCompanies = () => {
            console.log("INSIDE FIND SERVICE NOW")
            ServiceNow.getQuery(
                {
                    u_service: "GCP Reseller^ORu_service=GCP Admin Services^ORu_service=GCP Billing Portal SaaS", //GCP Reseller OR GCP Admin or SaaS
                    bypassCompany: true,
                    u_installed: true
                },
                "u_provided_services|serviceList",
                (results) => {
                    console.log("THIS IS MY RESULTS")
                    console.log(results)
                    if (results && results.results && results.results.length > 0) {
                        console.log("INSIDE RESULTS")
                        vm.matchServicenowCompanies(results.results);
                        console.log(results.results)
                        let cloudSysIDs = results.results.map((company) => {
                            return company["u_company.sys_id"];
                        });
                        vm.fetchBMSContracts(cloudSysIDs);
                    } else {
                        vm.loading = false;
                    }
                }
            );
        };

        vm.matchServicenowCompanies = (companies) => {
            console.log("=== MATCH SERVICENOW COMPANIES START ===");
            console.log("Incoming SNOW companies count:", companies.length);
            console.log("Existing vm.companies count (from MongoDB):", vm.companies.length);
            
            let addedCount = 0;
            let skippedFoundCount = 0;
            let skippedNoCodeCount = 0;
            
            companies.forEach((company) => {
                const sysId = company["u_company.sys_id"];
                const custCode = company["u_company.u_customer_code"];
                const displayName = company.u_company ? company.u_company.display_value : "NO_DISPLAY_VALUE";

                let foundCompany = vm.companies.find((existingCompany) => {
                    return sysId === existingCompany.company;
                });

                console.log("Processing:", custCode, "|", displayName, "| sys_id:", sysId);
                console.log("  Found in vm.companies?", !!foundCompany);
                
                if (!foundCompany && custCode) {
                    console.log("  --> ADDING to vm.companies");
                    addedCount++;
                    let newCompany = {
                        company: sysId,
                        companyCode: custCode,
                        companyName: displayName,
                        enterprise: "",
                        providedDiscount: 0,
                        centralTax: 0,
                        companyPO: "",
                        accounts: [],
                        emailContacts: [],
                        pos: [],
                        activity: []
                    };
                    vm.companies.push(newCompany);
                    vm.addFoundCompany(newCompany);
                } else {
                    if (foundCompany) {
                        console.log("  --> SKIPPED: Already exists in vm.companies");
                        skippedFoundCount++;
                    } else {
                        console.log("  --> SKIPPED: No customer code. custCode:", custCode);
                        skippedNoCodeCount++;
                    }
                }
            });
            
            console.log("=== MATCH SERVICENOW COMPANIES SUMMARY ===");
            console.log("Added:", addedCount);
            console.log("Skipped (already exists):", skippedFoundCount);
            console.log("Skipped (no customer code):", skippedNoCodeCount);
            console.log("Final vm.companies count:", vm.companies.length);
            console.log("Final vm.companies codes:", vm.companies.map(c => c.companyCode));
            
            /*
            Code that deletes companies if they don't match a provided service in ServiceNOW
            
            for (let i = vm.companies.length - 1; i >= 0; i--) {
                let company = vm.companies[i];
                let foundCompany = companies.find((existingCompany) => {
                    return existingCompany["u_company.u_customer_code"] === company.companyCode;
                });
                if (!foundCompany) {
                    $log.info("Company Not Found in SNOW");
                    $log.info(company);
                }
            }
            */
            
            vm.companies = util.sortItems(vm.companies, "companyName", "ASC");
        };

        vm.addFoundCompany = (newCompany) => {
            BCSServer.postData(
                {
                    companyCode: newCompany.companyCode,
                    companyAccounts: newCompany
                },
                "/update_cloud_accounts",
                () => {
                    $log.info(newCompany.companyCode + ": Added");
                }
            );
        };

        vm.updateAccountNumbers = () => {
            vm.loading = true;
            delete vm.selectedCompany._id;
            delete vm.selectedCompany.__v;
            BCSServer.postData(
                {
                    companyCode: vm.selectedCompany.companyCode,
                    companyAccounts: vm.selectedCompany
                },
                "/update_cloud_accounts",
                (response) => {
                    vm.loading = false;
                    if (response.error || !response) {
                        let error = response || "";
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Failed to update accounts. Please contact support for assistance.  ${angular.toString(
                                error
                            )}`,
                            status: "fail"
                        });
                    } else {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Successfully Updated Account Information.",
                            status: "success"
                        });
                        vm.selectedCompanySetting = angular.copy(vm.selectedCompany);
                    }
                }
            );
        };

        vm.updateBudgets = () => {
            let accountQueryUpdate = {
                company: vm.selectedCompany.budgets.company,
                method: "post",
                account: vm.selectedCompany.budgets
            };

            BCSServer.postData(accountQueryUpdate, "/cloud_budgets", (response) => {
                vm.loading = false;
                if (response && response._id) {
                    vm.createAlertMessage({
                        type: "alerts",
                        msg: "Successfully Updated Group Configuration.",
                        status: "success"
                    });
                } else {
                    let error = response.error || "";
                    vm.createAlertMessage({
                        type: "alerts",
                        msg: `Failed To Update Groups. Please Contact Support For Further Assistance.  ${angular.toString(
                            error
                        )}`,
                        status: "fail"
                    });
                }
            });
        };

        vm.formatPercent = (percObject, field) => {
            percObject[field] = util.formatPercent(percObject[field]);
        };

        vm.createAlertMessage = (alert) => {
            vm[alert.type].push({
                status: alert.status,
                msg: alert.msg
            });
            Alerts.storeAlert({
                type: alert.status,
                message: alert.msg,
                user: user_info.email,
                company: user_info.company_name,
                location: $state.current.name,
                tags: ["Burwood Cloud Admin"]
            });
            $timeout(() => {
                vm[alert.type] = [];
            }, 5000);
        };

        let defaultItems = {
            allowances: {
                type: "",
                poNumber: "",
                amount: "",
                dateActivated: "",
                dateIssued: "",
                state: "",
                next: ""
            },
            alerts: {
                alertThreshold: "90",
                enabled: true,
                expired: false
            },
            accounts: {
                margin: "12"
            }
        };

        vm.addItem = (level, itemType) => {
            if (vm[level][itemType] && vm[level][itemType].length > 0) {
                vm[level][itemType].push(angular.copy(defaultItems[itemType]));
            } else {
                vm[level][itemType] = [angular.copy(defaultItems[itemType])];
            }

        };

    
        vm.addAccount = () => {
            vm.selectedCompany.accounts.push(angular.copy(defaultItems["accounts"]));
            // Select the index of the last billing account page.
            vm.accountPages = vm.getAccountPages();
            vm.accountPageIndex = vm.accountPages;
        }


        vm.getAccountPages = () => {
            // Returns the number of pages.
            // Divide by 10 because there are 10 items per page.
            return Math.floor((vm.selectedCompany.accounts.length - 1)/ 10);
        }

        vm.removeAccount  = (accountIndex) => {
            let prompt = confirm("Are you sure you wish to delete this item?");
            if (!prompt) {
                return;
            }
            vm.selectedCompany.accounts.splice(accountIndex, 1);
            vm.accountPages = vm.getAccountPages();

            // If the current page is beyond the new page count,
            // go back one page.
            // Occurs when you remove all items from the last page.
            if (vm.accountPageIndex > vm.accountPages) {
                vm.accountPageIndex = vm.accountPages
            }

        };

        vm.close_notice = (type, index) => {
            vm[type].splice(index, 1);
        };

        let deepDiffMapper = cloud.deepDiffMapper();

        let activityFormat = {
            companyCode: "Company Code",
            company: "Company",
            invoicingRole: "Invoicing Role",
            supportEmail: "Support Email",
            companyName: "Company Name",
            enterprise: "Enterprise",
            providedDiscount: "Burwood Discount",
            centralTax: "Service Fee",
            emailContacts: "Contacts",
            accounts: "Accounts",
            pos: "PO"
        };

        vm.composeActivity = () => {
            if (!vm.selectedCompany.activity) {
                vm.selectedCompany.activity = [];
            }

            if (vm.selectedCompany.comments) {
                let commentActvity = {
                    user: user_info.u_name_id,
                    type: "Note",
                    value: vm.selectedCompany.comments,
                    date: moment().format("MMM DD YYYY h:mm A"),
                    company: vm.selectedCompany.companyName || vm.selectedCompany.companyCode || ""
                };

                vm.selectedCompany.activity.push(commentActvity);
                vm.account.activity.push(commentActvity);
            }

            vm.selectedCompany.comments = "";

            let originalObject = angular.copy(vm.selectedCompanySetting);

            let currentObject = angular.copy(vm.selectedCompany);

            let changeMap = deepDiffMapper.map(currentObject, originalObject);
            let projectChanges = vm.checkProjectChanges(changeMap);

            vm.composeChangeActivity(projectChanges);
        };

        vm.composeChangeActivity = (projectChanges) => {
            projectChanges.forEach((change) => {
                let changeStatus = {
                    user: user_info.u_name_id,
                    type: "Change",
                    date: moment().format("MMM DD YYYY h:mm A"),
                    company: vm.selectedCompany.companyName || vm.selectedCompany.companyCode || ""
                };

                let changeTo;

                if (angular.isObject(change.to)) {
                    changeTo = change.to.emailContacts || change.to.accounts;
                } else {
                    changeTo = change.to;
                }

                !changeTo && (changeTo = "false");
                !change.from && (change.from = "false");

                switch (change.status) {
                    case "created":
                        changeStatus.value = activityFormat[change.parent] + " Created:   " + changeTo;
                        break;
                    case "updated":
                        changeStatus.value =
                            activityFormat[change.parent] + " Changed From:   " + change.from + ",   To:   " + changeTo;
                        break;
                    case "deleted":
                        changeStatus.value = activityFormat[change.parent] + " Deleted:   " + changeTo;
                        break;
                    default:
                        break;
                }
                vm.selectedCompany.activity.push(changeStatus);
                vm.account.activity.push(changeStatus);
            });
        };

        vm.checkProjectChanges = (changeMap) => {
            let projectChanges = [];
            for (var field in changeMap) {
                if (field !== "comments" && field !== "$$hashKey" && field !== "activity") {
                    if (changeMap[field] && changeMap[field][0]) {
                        for (var childField in changeMap[field]) {
                            if (childField !== "dateActivated" && childField !== "dateIssued") {
                                let child = changeMap[field][childField];
                                if (!child.status) {
                                    for (var grandchildField in child) {
                                        if (grandchildField !== "dateActivated" && grandchildField !== "dateIssued") {
                                            let grandChild = child[grandchildField];
                                            if (grandChild.status && grandChild.status !== "unchanged") {
                                                grandChild.parent = field;
                                                projectChanges.push(grandChild);
                                            }
                                        }
                                    }
                                } else {
                                    if (child.status && child.status !== "unchanged") {
                                        child.parent = field;
                                        projectChanges.push(child);
                                    }
                                }
                            }
                        }
                    } else {
                        if (changeMap[field] && changeMap[field].status && changeMap[field].status !== "unchanged") {
                            changeMap[field].parent = field;
                            projectChanges.push(changeMap[field]);
                        }
                    }
                }
            }
            return projectChanges;
        };

        vm.switchFeed = (feed) => {
            vm.tableLoading = true;
            $timeout(() => {
                vm.tableLoading = false;
                vm.selectedFeed = feed;
                vm[feed] ? (vm.activityFeed = vm[feed].activity) : (vm[feed] = []);
            }, 100);
        };

        vm.editGroups = (event, account) => {
            event.preventDefault();
            event.stopPropagation();
            let originalCompany = angular.copy(account);
            let modalInst = $uibModal.open({
                resolve: {
                    account: () => {
                        return account;
                    },
                    company: () => {
                        return vm.selectedCompany;
                    },
                    groupIndex: () => {
                        return null;
                    }
                },
                templateUrl: "app/cloudbilling/budget/groupConfig.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "GroupConfigController",
                controllerAs: "vm"
            });
            modalInst.result.then(
                (data) => {
                    vm.loading = true;
                    vm.selectedCompany = data;
                    vm.update();
                },
                () => {
                    //if user clicks outside to cancel modal, revert to original depo
                    angular.copy(originalCompany, vm.selectedCompany.budgets);
                }
            );
        };

        vm.batchDownloadInvoice = (month, year) => {
            const startDate = moment([year, vm.months.indexOf(month)])
                .startOf("month")
                .format("MM-DD-YY");
            const endDate = moment([year, vm.months.indexOf(month)])
                .endOf("month")
                .format("MM-DD-YY");
            const formattedInvoiceDate = `${startDate}_${endDate}`;

            $timeout(() => {
                const route = apiBasePath + "/batch_invoice_download";
                vm.invoiceLoading = true;

                let modalInst = $uibModal.open({
                    resolve: {
                        message: () => {
                            return {
                                heading: "Processing Invoices",
                                message: "Your Invoices are downloading.",
                                loading: true
                            };
                        }
                    },
                    templateUrl: "app/shared/html/downloading.html",
                    ariaLabelledBy: "modal-title",
                    ariaDescribedBy: "modal-body",
                    controller: "DownloadingController",
                    controllerAs: "vm"
                });
                $scope.$emit("download-start");
                $http({
                    method: "POST",
                    cache: false,
                    url: route,
                    data: {
                        date: formattedInvoiceDate
                    },
                    responseType: "arraybuffer"
                }).then(
                    (response) => {
                        modalInst.close();
                        vm.invoiceLoading = false;
                        FileSaver.saveAs(
                            new Blob([response.data], {
                                type: "	application/zip"
                            }),
                            `invoices_${formattedInvoiceDate}.zip`
                        );
                    },
                    () => {
                        modalInst.close();
                        vm.invoiceLoading = false;
                        $uibModal.open({
                            resolve: {
                                message: () => {
                                    return {
                                        heading: "Report Error",
                                        message:
                                            "Failed To Download Invoices. Please Contact Support for Further Assistance.",
                                        loading: false
                                    };
                                }
                            },
                            templateUrl: "app/shared/html/downloading.html",
                            ariaLabelledBy: "modal-title",
                            ariaDescribedBy: "modal-body",
                            controller: "DownloadingController",
                            controllerAs: "vm"
                        });
                    }
                );
            }, 1);
        };
    }
})();

//Dashboard controller for Burwood Admins
//Related state = dashboard.cloudbilling_burwood_admin

(function () {
    angular.module("burWood").controller("AdminDashboardController", AdminDashboardController);

    /** @ngInject */
    function AdminDashboardController(_, DTOptionsBuilder, $timeout, BCSServer, cloud, util, Service, moment, $log) {
        let vm = this;
        vm.reports = {};
        vm.yearTable =
            vm.quarterTable =
            vm.monthTable =
            vm.yearByProjectTable =
            vm.quarterByProjectTable =
            vm.monthByProjectTable =
                [];
        vm.toggleControl = false;

        //sets width of charts based on dashbaords
        const width = angular.element(".show-dash:eq(1)").width();
        const height = 270;

        const defaultConfig = {
            chart: {
                zoomType: "x",
                type: "column",
                width: width,
                height: height
            },
            exporting: {
                enabled: true
            },
            title: {
                text: " "
            },
            yAxis: {
                min: 0
            },
            series: []
        };

        //configuration for column filter
        const columnFilter = {
            aoColumns: [
                null,
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                }
            ]
        };

        vm.setupDatableButtons = (title, exportColumns) => {
            //button export configurations
            return [
                {
                    extend: "collection",
                    text: "Export",
                    buttons: [
                        {
                            extend: "excel",
                            title: () => {
                                return title;
                            },
                            filename: () => {
                                return title.replace(/ /g, "_");
                            },
                            exportOptions: {
                                columns: exportColumns
                            }
                        },
                        {
                            extend: "pdf",
                            title: () => {
                                return title;
                            },
                            filename: () => {
                                return title.replace(/ /g, "_");
                            },
                            customize: (doc) => {
                                doc.pageMargins = [5, 5, 5, 5];
                                doc.styles.tableHeader.fontSize = 10;
                                doc.defaultStyle.fontSize = 6;
                            },
                            exportOptions: {
                                columns: exportColumns
                            }
                        },
                        {
                            extend: "csv",
                            title: () => {
                                return title;
                            },
                            filename: () => {
                                return title.replace(/ /g, "_");
                            },
                            exportOptions: {
                                columns: exportColumns
                            }
                        }
                    ]
                }
            ];
        };

        vm.setupDatatables = (title, exportColumns, withOrder) => {
            return DTOptionsBuilder.newOptions()
                .withDOM("fBrtip")
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withButtons(vm.setupDatableButtons(title, exportColumns))
                .withColumnFilter(columnFilter)
                .withOption("iDisplayLength", 10)
                .withOption("order", withOrder)
                .withOption("responsive", true);
        };

        vm.colors = ["#f4ba30", "#db5760", "#579c8b", "#536794", "#9e5d9c", "#8870b3"];

        vm.chartTypes = [
            {
                name: "Line",
                id: "line"
            },
            {
                name: "Bar",
                id: "bar"
            },
            {
                name: "Column",
                id: "column"
            },
            {
                name: "Pie",
                id: "pie"
            }
        ];

        vm.sourceType = "All";

        vm.chartTypesTime = angular.copy(vm.chartTypes);
        vm.chartTypesTime.splice(-1, 2);
        vm.chartTypesTotals = angular.copy(vm.chartTypes);
        vm.chartTypesTotals.splice(0, 2);
        vm.chartTypesStacked = angular.copy(vm.chartTypes);
        vm.chartTypesStacked = vm.chartTypesStacked.splice(2, 2);

        vm.cummulativeSelect = ["Cumulative", "Daily"];

        vm.years = util.getYearList();
        vm.months = util.getMonthList();

        vm.defaultDate = {
            startDate: util.addMonths(new Date(new Date().setDate(1)), -2),
            endDate: moment(new Date()).format("YYYY-MM-DD")
        };

        vm.defaultYearToDate = {
            startDate: moment().startOf("year").format("YYYY-MM-DD"),
            endDate: moment(new Date()).format("YYYY-MM-DD")
        };

        vm.default12MonthDate = {
            startDate: moment().subtract(1, "years").format("YYYY-MM-DD"),
            endDate: moment(new Date()).format("YYYY-MM-DD")
        };

        vm.toDate = null;

        vm.providedServices = [
            {
                id: "originalAccounts",
                name: "All Services"
            },
            {
                id: "resellerAccounts",
                name: "GCP Reseller"
            },
            {
                id: "adminAccounts",
                name: "GCP Admin Services"
            }
        ];

        vm.consumptionTypes = ["Consumption", "Margin"];

        vm.consumptionType = vm.consumptionTypes[0];

        vm.serviceSelect = vm.providedServices[0].id;

        vm.timeSelect = "thisMonth";

        vm.yearConsumptionByMonthAccountMonthSelect = vm.months[new Date().getMonth()];
        vm.yearConsumptionByMonthAccountYearSelect = new Date().getFullYear();

        vm.availableDashboards = [
            {
                id: "consumptionOverTime",
                exportColumns: [0, 1],
                defaultChart: "line",
                alterTime: true,
                view: "project_cost_by_day_admin",
                dataSource: "bigQuery",
                selectedAccounts: true,
                sourceTypes: true,
                name: "Consumption Over Time Total"
            },
            {
                id: "consumptionOverTimeAll",
                exportColumns: [0, 1],
                defaultChart: "line",
                alterTime: true,
                view: "project_cost_by_day_minimal",
                dataSource: "bigQuery",
                sourceTypes: true,
                name: "Consumption Over Time"
            },
            {
                id: "consumptionByCompanyType",
                exportColumns: [0, 1, 2, 3, 4, 5, 6, 7],
                defaultChart: "column",
                view: "project_cost_total_by_account_admin",
                dataSource: "bigQuery",
                applyMonth: true,
                date12Month: true,
                name: "Consumption By Company"
            },
            {
                id: "consumptionByCompany",
                exportColumns: [0, 1],
                defaultChart: "column",
                view: "project_cost_total_by_account_admin",
                dataSource: "bigQuery",
                invoiceMonth: true,
                applyMonth: true,
                alterTime: true,
                sourceTypes: true,
                withOrder: [["1", "des"]],
                name: "Consumption By Company"
            },
            {
                id: "marginByCompany",
                exportColumns: [0, 1, 2, 3, 4],
                defaultChart: "column",
                view: "project_cost_total_by_account_admin",
                dataSource: "bigQuery",
                applyMonth: true,
                date12Month: true,
                name: "Margin By Company"
            },
            {
                id: "stridesByCompany",
                exportColumns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                defaultChart: "column",
                view: "project_cost_total_by_account_admin",
                dataSource: "bigQuery",
                applyMonth: false,
                date12Month: false,
                selectedAccounts: true,
                alterTime: true,
                sourceTypes: true,
                accountType: "strides",
                addField: "project_id",
                name: "STRIDES Consumption By Company"
            },
            {
                id: "totalConsumption",
                exportColumns: [0, 1],
                defaultChart: "column",
                view: "project_cost_total_by_account_admin",
                dataSource: "bigQuery",
                yearToDate: true,
                name: "Total Consumption/Margin"
            },
            {
                id: "month12Consumption",
                exportColumns: [0, 1],
                defaultChart: "column",
                view: "project_cost_total_by_account_admin",
                dataSource: "bigQuery",
                date12Month: true,
                sourceTypes: true,
                name: "Total Consumption/Margin"
            },
            {
                id: "accountReport",
                exportColumns: [0, 1],
                dataSource: "gcp",
                withOrder: [["0", "ASC"]],
                name: "Account Report"
            },
            {
                id: "noAccountClients",
                exportColumns: [0],
                dataSource: "database",
                withOrder: [["0", "ASC"]],
                name: "Clients With No Accounts"
            }
        ];

        vm.alterTimeReports = [];

        vm.setUpDashboards = () => {
            vm.dash = {};

            vm.availableDashboards.forEach((item) => {
                vm.dash[item.id] = true;
                vm[item.id + "Loading"] = true;
                vm[item.id + "Config"] = Object.assign({}, defaultConfig);
                vm[item.id + "ChartSelect"] = item.defaultChart;
                vm[item.id + "Date"] = angular.copy(vm.defaultDate);
                item.alterTime ? vm.alterTimeReports.push(item) : null;
                vm[item.id + "toDate"] = false;
            });
        };

        vm.setUpDashboards();

        vm.filterAccountServices = (data, accountList) => {
            let filteredData = [];
            data.forEach((item) => {
                if (accountList.includes(item.billing_account_id)) {
                    filteredData.push(item);
                }
            });
            return filteredData;
        };

        //BigQuery Fetch
        vm.reports.bigQuery = (reportParameters, reportID) => {
            BCSServer.postData(reportParameters, "/big_query/get_query", (response) => {
                if (response && angular.isArray(response) && response.length > 0) {
                    let data;
                    if (reportParameters.selectedAccounts) {
                        data = response;
                    } else {
                        data = vm.filterAccountServices(response, vm.accountList);
                    }
                    chartProcessors[reportID](data, reportID);
                } else {
                    vm.createNoDataChart(reportID);
                }
            });
        };

        //GCP Fetch
        vm.reports.gcp = (reportID) => {
            BCSServer.postData({}, "/gcp_billing_accounts", (response) => {
                if (response) {
                    vm.gcpAccountsNames = cloud.formatGCPAccounts(response);
                    vm.gcpAccounts = vm.gcpAccountsNames.map((account) => {
                        return account.account;
                    });
                } else {
                    vm.gcpAccounts = [];
                }
                chartProcessors[reportID](vm.gcpAccounts, reportID);
            });
        };

        //GCP Fetch
        vm.reports.database = (reportID) => {
            chartProcessors[reportID](vm.gcpAccounts, reportID);
        };

        // Determine if report needs to fetch from GCP or BigQuery
        vm.runReport = (report) => {
            vm[report + "Loading"] = true;
            vm[report + "Run"] = report;
            vm[report + "DTInstance"] = {};

            let sourceReport = cloud.determineDataSource(vm.availableDashboards, report);

            vm[report + "DTOptions"] = vm.setupDatatables(
                sourceReport.name,
                sourceReport.exportColumns,
                sourceReport.withOrder || []
            );

            if (sourceReport.dataSource !== "bigQuery") {
                vm.reports[sourceReport.dataSource](report);
                return;
            }

            let composeParameters = {
                sourceType: vm.sourceType,
                burwoodAdmin: true,
                view: sourceReport.view,
                parameters: {
                    projects: [],
                    applyMonth: sourceReport.applyMonth,
                    dateRange: vm[report + "Date"]
                }
            };

            if (sourceReport.addField) {
                composeParameters.parameters.addField = sourceReport.addField;
            }

            if (sourceReport.removeField) {
                composeParameters.parameters.removeField = sourceReport.removeField;
            }

            if (sourceReport.selectedAccounts) {
                if (sourceReport.accountType === "strides") {
                    composeParameters.selectedAccounts = {
                        accounts: vm.stridesAccounts.map((account) => {
                            return {
                                account: account
                            };
                        })
                    };
                } else {
                    composeParameters.selectedAccounts = {
                        accounts: vm.accountList.map((account) => {
                            return {
                                account: account
                            };
                        })
                    };
                }
            }

            if (sourceReport.toYearDate) {
                composeParameters.parameters.dateRange = vm.defaultYearToDate;
            }

            if (sourceReport.date12Month) {
                composeParameters.parameters.dateRange = vm.default12MonthDate;
            }

            if (sourceReport.invoiceMonth && moment(vm[report + "Date"].startDate) > moment("2020-09-30")) {
                composeParameters.parameters.invoiceMonth = {
                    startDate: moment(vm[report + "Date"].startDate).format("YYYYMM"),
                    endDate: moment(vm[report + "Date"].endDate).format("YYYYMM")
                };
                composeParameters.parameters.dateRange = null;
            }

            sourceReport.dataSource && vm.reports[sourceReport.dataSource](composeParameters, report);
        };

        vm.changeButtonClassed = (selectedClass) => {
            angular.element(".thisMonth").removeClass("btn-clicked");
            angular.element(".lastMonth").removeClass("btn-clicked");
            angular.element(".date-picker").removeClass("btn-clicked");
            angular.element(".to-date").removeClass("btn-clicked");
            if (selectedClass !== ".date-picker") {
                angular.element(selectedClass).addClass("btn-clicked");
            }
        };

        vm.date = {
            startDate: null,
            endDate: null
        };

        vm.datePicker = {
            startDate: null,
            endDate: null
        };

        // jquery handlers for UI table resizing
        angular.element("body").on("click", "button.applyBtn", () => {
            vm.date.startDate = moment(vm.datePicker.startDate).format("YYYY-MM-DD");
            vm.date.startDate = vm.date.startDate.toString();
            vm.date.endDate = moment(vm.datePicker.endDate).format("YYYY-MM-DD");
            vm.date.endDate = vm.date.endDate.toString();
            vm.prepReports(false, "Custom");
            // vm.toggleTime(vm.date.startDate + " - " + vm.date.endDate);
        });

        vm.setNewDates = (report) => {
            vm[report + "Date"] = {};

            if (vm.timeSelect === "thisMonth") {
                vm[report + "Date"].startDate = util.addMonths(new Date(new Date().setDate(1)), 0);
                vm[report + "Date"].endDate = moment(new Date()).format("YYYY-MM-DD");
                vm[report + "toDate"] = false;
                vm.changeButtonClassed(".thisMonth");
            } else if (vm.timeSelect === "lastMonth") {
                vm[report + "Date"].startDate = util.addMonths(new Date(new Date().setDate(1)), -1);
                vm[report + "Date"].endDate = moment(vm[report + "Date"].startDate)
                    .endOf("month")
                    .format("YYYY-MM-DD");
                vm[report + "toDate"] = false;
                vm.changeButtonClassed(".lastMonth");
            } else if (vm.timeSelect === "toDate") {
                vm[report + "Date"].startDate = null;
                vm[report + "Date"].endDate = null;
                vm[report + "toDate"] = true;
                vm.changeButtonClassed(".to-date");
            } else {
                vm[report + "Date"].startDate = moment(vm.date.startDate).format("YYYY-MM-DD");
                vm[report + "Date"].endDate = moment(vm.date.endDate).format("YYYY-MM-DD");
                vm.changeButtonClassed(".date-picker");
            }

            return;
        };

        vm.fetchProvidedServices = () => {
            Service.getQuery(
                {
                    u_service: "14^ORu_service=12^ORu_service=16", //GCP Reseller OR GCP Admin
                    bypassCompany: true,
                    u_installed: true
                },
                "u_provided_services|serviceList",
                (response) => {
                    let resellerServices = [];
                    let adminServices = [];
                    if (response && response.results && response.results.length > 0) {
                        resellerServices = response.results
                            .filter((service) => {
                                return service.u_service === "GCP Reseller";
                            })
                            .map((service) => {
                                return service["u_company.sys_id"];
                            });
                        adminServices = response.results
                            .filter((service) => {
                                return service.u_service === "GCP Admin Services";
                            })
                            .map((service) => {
                                return service["u_company.sys_id"];
                            });
                    }
                    vm.fetchAccountNumbers(resellerServices, adminServices);
                }
            );
        };
        vm.fetchProvidedServices();

        vm.fetchAccountNumbers = (resellerServices, adminServices) => {
            vm.accounts = {};
            vm.creditAccounts = {};
            vm.paidAccounts = {};
            vm.enterpriseAccounts = [];
            vm.i2Accounts = [];
            vm.clientNames = [];
            vm.resellerAccounts = [];
            vm.adminAccounts = [];
            vm.originalAccounts = [];
            vm.noAccountClients = [];
            vm.stridesAccounts = [];
            vm.pos = [];
            vm.stridesGrants = [];

            BCSServer.postData({}, "/cloud_companies_all", (response) => {
                let accounts = response || {};

                accounts.forEach((company) => {
                    if (
                        company.companyCode === "UNIAME" ||
                        company.companyCode === "BURGRO" ||
                        company.companyCode === "BURCLO"
                    ) {
                        return;
                    }
                    let companyName = company.companyName || company.companyCode;
                    vm.clientNames.push(companyName);
                    vm.pos = vm.pos.concat(company.pos || []);
                    if (company && company.accounts && company.accounts.length > 0) {
                        company.accounts.forEach((account) => {
                            vm.originalAccounts.push(account.account);
                            if (resellerServices.includes(company.company)) {
                                vm.resellerAccounts.push(account.account);
                            }
                            if (account.pricebook === "strides") {
                                vm.stridesAccounts.push(account.account);
                            }
                            if (adminServices.includes(company.company)) {
                                vm.adminAccounts.push(account.account);
                            }
                            vm.accounts[account.account] = companyName;
                            if (account.type === "Credit") {
                                vm.creditAccounts[account.account] = companyName;
                            } else {
                                vm.paidAccounts[account.account] = companyName;
                            }
                            company.enterprise === "true"
                                ? vm.enterpriseAccounts.push(account.account)
                                : vm.i2Accounts.push(account.account);
                        });
                    } else {
                        vm.noAccountClients.push(company);
                    }
                });

                vm.stridesGrants = vm.pos.filter((po) => {
                    return po.type === "strides";
                });

                vm.accountList = angular.copy(vm.originalAccounts);

                vm.fetchBudgets();
            });
        };

        vm.fetchBudgets = () => {
            vm.stridesBudgets = [];

            BCSServer.postData({}, "/cloud_budgets_all", (response) => {
                let budgets = response || {};

                budgets.forEach((company) => {
                    if (company && company.departments && company.departments.length > 0) {
                        company.departments.forEach((depo) => {
                            if (
                                depo &&
                                depo.budgetType === "Budgeting" &&
                                depo.allowances &&
                                depo.allowances.length > 0
                            ) {
                                depo.allowances.forEach((depoAllow) => {
                                    if (vm.stridesAccounts.includes(depoAllow.accountNum)) {
                                        if (depo.projects && depo.projects.length > 0) {
                                            depo.projects.forEach((prj) => {
                                                let depoBudget = angular.copy(depoAllow);
                                                depoBudget.project = prj.projectID;
                                                vm.stridesBudgets.push(depoBudget);
                                            });
                                        }
                                    }
                                });
                            } else {
                                if (depo && depo.projects && depo.projects.length > 0) {
                                    depo.projects.forEach((prj) => {
                                        if (prj && prj.allowances && prj.allowances.length > 0) {
                                            prj.allowances.forEach((prjAllow) => {
                                                if (vm.stridesAccounts.includes(prjAllow.accountNum)) {
                                                    let projectBudget = prjAllow;
                                                    projectBudget.project = prj.projectID;
                                                    vm.stridesBudgets.push(projectBudget);
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                        });
                    }
                });
                vm.prepReports("init", vm.timeSelect);
            });
        };

        vm.switchConsumptionType = () => {
            if (vm.consumptionType === "Consumption") {
                vm.consumptionTypeConfig = vm.consumptionByCompanyTypeConfig;
                vm.consumptionTypeTable = vm.consumptionByCompanyTypeTable;
            } else {
                vm.consumptionTypeConfig = vm.marginByCompanyConfig;
                vm.consumptionTypeTable = vm.marginByCompanyTable;
            }
        };

        vm.changeServices = () => {
            vm.accountList = angular.copy(vm[vm.serviceSelect]);

            vm.prepReports("init");
        };

        // fetchAccountNumbers();

        vm.prepReports = (init, timeSelect, batchAll) => {
            vm.timeSelect = timeSelect;
            vm.availableDashboards.forEach((item) => {
                if (!timeSelect) {
                    vm[item.id + "ChartSelect"] = item.defaultChart;
                } else {
                    if (!batchAll) {
                        if (item.alterTime) {
                            vm.setNewDates(item.id);
                            !init && vm.runReport(item.id);
                        }
                    } else {
                        if (item.sourceTypes) {
                            vm.runReport(item.id);
                        }
                    }
                }
                init && vm.runReport(item.id);
            });
        };

        let chartProcessors = {
            consumptionOverTime: (data, report) => {
                let processedData = vm.processDataForChart(data, report);
                
                vm.setUpChart(
                    {
                        series: processedData.series,
                        categories: processedData.categories,
                        chartType: "line",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true,
                        zoomSubtitle: true
                    },
                    report
                );
            },
            consumptionOverTimeAll: (data, report) => {
                let processedData = vm.processDataForChart(data, report);
                console.log(report, "REPORT")
                vm.setUpChart(
                    {
                        series: processedData.series,
                        categories: processedData.categories,
                        chartType: "line",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true,
                        zoomSubtitle: true
                    },
                    report
                );
            },
            consumptionByCompany: (data, report) => {
                let processedData = vm.processDataForChart(data, report);
                
                vm.setUpChart(
                    {
                        series: processedData.series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true,
                        legend: true
                    },
                    report
                );
            },
            consumptionByCompanyType: (data, report) => {
                let processedData = vm.processDataForChart(data, report);

                vm.setUpChart(
                    {
                        series: processedData.series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true,
                        legend: true
                    },
                    report
                );
            },
            marginByCompany: function (data, report) {
                this.consumptionByCompanyType(data, report);
            },
            stridesByCompany: (data, report) => {
                let processedData = vm.processDataForChart(data, report);

                vm.setUpChart(
                    {
                        series: processedData.series,
                        categories: processedData.categories,
                        chartType: "column",
                        title: null,
                        dataLabels: false,
                        yMin: 0,
                        yText: "Dollars ($)",
                        yVisible: true,
                        legend: true
                    },
                    report
                );
            },
            totalConsumption: (data, report) => {
                let totals = {
                    consumptionYTD: 0,
                    paidYTD: 0,
                    marginYTD: 0
                };

                data.forEach((item) => {
                    if (!vm.adminAccounts.includes(item.billing_account_id)) {
                        totals.consumptionYTD += Math.abs(item.subtotal_credit) + item.subtotal_paid;
                        totals.paidYTD += item.subtotal_paid;

                        if (vm.enterpriseAccounts.includes(item.billing_account_id)) {
                            totals.marginYTD += item.subtotal_paid * 0.1;
                        } else {
                            totals.marginYTD += item.subtotal_paid * 0.09;
                        }
                    }
                });

                totals.consumptionYTD = util.numberWithCommas(totals.consumptionYTD);
                totals.paidYTD = util.numberWithCommas(totals.paidYTD);
                totals.marginYTD = util.numberWithCommas(totals.marginYTD);

                vm[report + "Totals"] = totals;

                vm[report + "Loading"] = false;
            },
            month12Consumption: (data, report) => {
                let totals = {
                    paid12Month: 0
                };

                data.forEach((item) => {
                    totals.paid12Month += item.subtotal_paid;
                });

                totals.paid12Month = util.numberWithCommas(totals.paid12Month);

                vm[report + "Totals"] = totals;
            },
            accountReport: (data, report) => {
                let tableData = vm.mapUnusedAccounts(data);

                vm[report + "Table"] = tableData;
                vm[report + "Loading"] = false;
            },
            noAccountClients: (data, report) => {
                let tableData = vm.noAccountClients.map((client) => {
                    return {
                        client: client.companyName
                    };
                });

                vm[report + "Table"] = tableData;
                vm[report + "Loading"] = false;
            }
        };

        vm.processDataForChart = (data, report) => {
            let processedData = {
                categories: [],
                color: [],
                series: []
            };

            switch (report) {
                case "consumptionOverTime":
                    processedData.series.push({
                        name: "Consumption",
                        color: vm.colors[0],
                        data: []
                    });
                    data.forEach((item) => {
                        processedData.categories.push(item.date);
                        processedData.series[0].data.push(item.subtotal);
                    });
                    break;
                case "consumptionOverTimeAll":
                    let dateArray = cloud.getDateArray(data, false, vm[report + "Date"]);
                    processedData = vm.processTimeData(data, dateArray);
                    data = processedData.tableData;
                    break;
                case "consumptionByCompany":
                    let returnData = vm.processCompanyConsumption(data);
                    processedData = returnData.processedData;
                    data = returnData.tableData;
                    break;
                case "consumptionByCompanyType":
                    let returnDataType = vm.processCompanyTotals(data);
                    processedData = returnDataType.processedData;
                    data = returnDataType.tableData;
                    break;
                case "marginByCompany":
                    let marginData = vm.processCompanyTotals(data, true);
                    processedData = marginData.processedData;
                    data = marginData.tableData;
                    break;
                case "stridesByCompany":
                    let stridesData = vm.processStridesConsumption(data);
                    processedData = stridesData.processedData;
                    data = stridesData.tableData;
                    break;
                default:
                    break;
            }

            vm[report + "Table"] = data;

            return processedData;
        };

        vm.mapUnusedAccounts = (data) => {
            let missingAccounts = [];
            data.forEach((account, index) => {
                if (!vm.originalAccounts.includes(account)) {
                    missingAccounts.push(vm.gcpAccountsNames[index]);
                }
            });
            return missingAccounts;
        };

        vm.processTimeData = (data, dates) => {
            let processedData = {
                series: [],
                categories: dates,
                tableData: []
            };

            let companyObj = {};

            data.forEach((item) => {
                if (vm.accounts[item.billing_account_id]) {
                    let company = vm.accounts[item.billing_account_id];
                    if (!companyObj[company]) {
                        companyObj[company] = Array.apply(null, Array(dates.length)).map(Number.prototype.valueOf, 0);
                    }

                    dates.forEach((date, index) => {
                        let foundTotal = item.breakdown.find((breakdown) => {
                            return breakdown.date === date;
                        });
                        if (foundTotal) {
                            companyObj[company][index] += foundTotal.subtotal;
                        }
                    });
                }
            });

            let colorList = cloud.generateChartColors(data.length, vm.colors);
            let colorIndex = 0;

            for (var company in companyObj) {
                processedData.series.push({
                    data: companyObj[company],
                    name: company,
                    color: colorList[colorIndex]
                });
                processedData.tableData.push({
                    company: company,
                    subtotal: companyObj[company].reduce((a, b) => {
                        return a + b;
                    }, 0)
                });
                colorIndex++;
            }

            return processedData;
        };

        vm.processStridesConsumption = (data) => {
            let processedData = {
                series: [
                    {
                        name: "Consumption",
                        data: new Array(vm.clientNames.length).fill(0),
                        lineWidth: 5
                    }
                ],
                categories: vm.clientNames
            };

            let tableData = vm.clientNames.map((client) => {
                return {
                    client: client,
                    subtotal: 0
                };
            });

            data.forEach((item) => {
                let clientID = vm.accounts[item.billing_account_id];

                let stridesBudgets = vm.stridesBudgets.filter((budget) => {
                    return budget.project === item.project_id;
                });

                let stridesGrants = [];

                stridesBudgets.forEach((budget) => {
                    let singleStride = vm.stridesGrants.find((single) => {
                        return budget.grant === single.number && budget.accountNum === single.account;
                    });
                    if (singleStride) {
                        stridesGrants.push(singleStride);
                    }
                });

                if (clientID) {
                    let clientIndex = vm.clientNames.indexOf(clientID);
                    let parentIndex = _.findIndex(tableData, {
                        client: clientID
                    });
                    processedData.series[0].data[clientIndex] += item.subtotal;
                    tableData[parentIndex].subtotal += item.subtotal;
                    try {
                        if (stridesGrants && stridesGrants.length > 0) {
                            stridesGrants.forEach((sbudget) => {
                                item.number = item.number
                                    ? (item.number += ", " + sbudget.number)
                                    : (item.number = sbudget.number);
                                item.amount = item.amount
                                    ? (item.amount += ", " + sbudget.amount)
                                    : (item.amount = sbudget.amount);
                                item.expirationDate = item.expirationDate
                                    ? (item.expirationDate += ", " + sbudget.expirationDate)
                                    : (item.expirationDate = sbudget.expirationDate);
                                for (var attrname in sbudget.details) {
                                    item[attrname]
                                        ? (item[attrname] += ", " + sbudget.details[attrname])
                                        : (item[attrname] = sbudget.details[attrname]);
                                }
                            });
                        }
                    } catch (e) {
                        $log.info(e);
                    }
                    tableData.splice(parentIndex + 1, 0, item);
                }
            });

            let dataIndexes = [];

            tableData = tableData.filter((data) => {
                return data.subtotal;
            });

            processedData.series[0].data.forEach((item, index) => {
                if (item) {
                    dataIndexes.push(index);
                }
            });

            processedData.series[0].data = processedData.series[0].data.filter((data) => {
                return data;
            });

            processedData.categories = processedData.categories.filter((data, index) => {
                return dataIndexes.includes(index);
            });

            return {
                processedData: processedData,
                tableData: tableData
            };
        };

        vm.processCompanyConsumption = (data) => {
            let processedData = {
                series: [
                    {
                        name: "Consumption",
                        // dataSorting: {
                        //     enabled: true,
                        //     matchByName: true
                        // },
                        data: new Array(vm.clientNames.length).fill(0),
                        lineWidth: 5
                    }
                ],
                categories: vm.clientNames
            };

            let tableData = vm.clientNames.map((client) => {
                return {
                    client: client,
                    subtotal: 0
                };
            });

            data.forEach((item) => {
                let clientID = vm.accounts[item.billing_account_id];

                if (clientID) {
                    let clientIndex = vm.clientNames.indexOf(clientID);
                    processedData.series[0].data[clientIndex] += item.subtotal;
                    tableData[clientIndex].subtotal += item.subtotal;
                }
            });

            return {
                processedData: processedData,
                tableData: tableData
            };
        };

        vm.processCompanyTotals = (data, margin) => {
            let tableData = [];

            let monthCategories = [];

            for (let x = 0; x < 12; x++) {
                monthCategories.unshift(vm.months[moment().subtract(x, "months").month()]);
            }

            let processedData = {
                categories: monthCategories,

                series: [
                    {
                        name: "Credit",
                        color: "#579c8b",
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                        showInLegend: !margin,
                        stack: "Enterprise"
                    },
                    {
                        name: "Paid",
                        color: "#db5760",
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                        showInLegend: !margin,
                        stack: "Enterprise"
                    },
                    {
                        name: "Credit",
                        color: "#579c8b",
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                        showInLegend: false,
                        stack: "Internet2"
                    },
                    {
                        name: "Paid",
                        color: "#db5760",
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                        showInLegend: false,
                        stack: "Internet2"
                    }
                ]
            };

            data.forEach((item) => {
                let dataIndex = monthCategories.indexOf(vm.months[Number(item.month) - 1]);

                if (vm.enterpriseAccounts.includes(item.billing_account_id)) {
                    let creditTotal = margin ? item.subtotal_credit * 0.1 : item.subtotal_credit;
                    let paidTotal = margin ? item.subtotal_paid * 0.1 : item.subtotal_paid;

                    processedData.series[0].data[dataIndex] += Math.abs(creditTotal);
                    processedData.series[1].data[dataIndex] += Math.abs(paidTotal);
                } else {
                    var creditTotalI2 = margin ? item.subtotal_credit * 0.1 : item.subtotal_credit;
                    var paidTotalI2 = margin ? item.subtotal_paid * 0.09 : item.subtotal_paid;

                    processedData.series[2].data[dataIndex] += Math.abs(creditTotalI2);
                    processedData.series[3].data[dataIndex] += Math.abs(paidTotalI2);
                }
            });

            let totals = {
                total: {
                    credit: 0,
                    paid: 0
                }
            };

            processedData.categories.forEach((item, index) => {
                totals.total.credit += processedData.series[0].data[index];
                totals.total.credit += processedData.series[2].data[index];
                totals.total.paid += processedData.series[1].data[index];
                totals.total.paid += processedData.series[3].data[index];

                let tableItem = {
                    month: item,
                    enterpriseCredit: processedData.series[0].data[index],
                    enterprisePaid: processedData.series[1].data[index],
                    enterpriseTotal: processedData.series[0].data[index] + processedData.series[1].data[index],
                    i2Credit: processedData.series[2].data[index],
                    i2Paid: processedData.series[3].data[index],
                    i2Total: processedData.series[2].data[index] + processedData.series[3].data[index],
                    total:
                        processedData.series[0].data[index] +
                        processedData.series[1].data[index] +
                        processedData.series[2].data[index] +
                        processedData.series[3].data[index],
                    totalPaid: processedData.series[1].data[index] + processedData.series[3].data[index]
                };

                tableData.push(tableItem);
            });

            if (!margin) {
                processedData.series.push({
                    name: "Total Consumption",
                    type: "pie",
                    data: [
                        {
                            name: "Total Credit Consumption",
                            y: Number(totals.total.credit.toFixed(2)),
                            color: "#579c8b"
                        },
                        {
                            name: "Total Paid Consumption",
                            y: Number(totals.total.paid.toFixed(2)),
                            color: "#db5760"
                        }
                    ],
                    center: ["93%", 20],
                    size: "50%",
                    showInLegend: false
                });
            } else {
                processedData.series.push({
                    name: "Total Margin",
                    type: "pie",
                    data: [
                        {
                            name: "Total Credit Margin",
                            y: Number(totals.total.credit.toFixed(2)),
                            color: "#579c8b"
                        },
                        {
                            name: "Total Paid Margin",
                            y: Number(totals.total.paid.toFixed(2)),
                            color: "#db5760"
                        }
                    ],
                    center: ["93%", 20],
                    size: "40%",
                    showInLegend: false
                });
            }

            return {
                processedData: processedData,
                tableData: tableData
            };
        };

        vm.setUpChart = (chartOptions, report) => {
            vm[report + "Title"] = chartOptions.title;
            vm[report + "Config"] = cloud.createChart(chartOptions, report, width, height, vm[report + "Table"]);

            if (report !== "consumptionOverTime") {
                vm[report + "Config"].plotOptions.series.dataLabels = {
                    enabled: true,
                    color: "#000",
                    style: { fontWeight: "lighter" },
                    formatter: function () {
                        if (this.series.userOptions.name === "Credit") {
                            return this.series.userOptions.stack;
                        }
                    },
                    inside: false
                };
            }

            vm[report + "Config"].plotOptions.pie.dataLabels = {
                enabled: false
            };

            if (
                report === "consumptionByCompany" ||
                report === "marginByCompany" ||
                report === "consumptionByCompanyType" ||
                report === "stridesByCompany" ||
                report === "consumptionOverTimeAll"
            ) {
                vm[report + "Config"].chart.width = width * 2;
            }

            if (report === "consumptionOverTimeAll") {
                vm[report + "Config"].chart.height = height * 2;
                vm[report + "Config"].legend = {
                    enabled: true,
                    maxHeight: 150
                };
                vm[report + "Config"].chart.plotOptions = {};
                vm[report + "Config"].chart.plotOptions.line = {
                    events: {
                        legendItemClick: function () {
                            let series = this.chart.series;
                            if (this.visible && this.chart.restIsHidden) {
                                angular.element(series).each(() => {
                                    this.setVisible(true, false);
                                });
                                this.chart.restIsHidden = false;
                            } else {
                                angular.element(series).each(() => {
                                    this.setVisible(false, false);
                                });
                                this.show();
                                this.chart.restIsHidden = true;
                            }
                            this.chart.redraw();
                            return false;
                        }
                    },
                    showInLegend: true
                };
            }

            vm.switchConsumptionType();

            vm[report + "Loading"] = false;
        };

        vm.createNoDataChart = (report) => {
            vm[report + "Config"] = Object.assign({}, defaultConfig);
            vm[report + "Table"] = [];
            let title = cloud.determineDataSource(vm.availableDashboards, report, "name");
            title = title.toUpperCase();
            vm[report + "Config"].title = {
                text: title,
                style: {
                    fontSize: "32px"
                }
            };
            vm[report + "Config"].subtitle = {
                text: "NO REPORT DATA",
                style: {
                    fontSize: "18px"
                }
            };
            vm[report + "Title"] = "No report data.";
            vm[report + "TableData"] = [];
            vm[report + "Loading"] = false;
        };

        vm.selectChartChange = (chartName) => {
            vm[chartName + "Config"].chart.type = vm[chartName + "ChartSelect"];
            vm[chartName + "Config"].series.forEach((item) => {
                item.type = vm[chartName + "ChartSelect"];
            });
        };

        //resize charts to be responsive
        $timeout(() => {
            angular.element(window).resize(() => {
                angular.element(".highcharts").each(function () {
                    let chart = angular.element(this).highcharts();
                    let w = angular.element(this).closest(".dashboard-panel").width();
                    chart.setSize(w * 0.975, height, false);
                });
            });
        }, 1000);
    }
})();

// Cloud Billing Project/Budget Configuration Module


(function () {
    angular.module("burWood").controller("ProjectMappingController", ProjectMappingController);

    /** @ngInject */
    function ProjectMappingController(
        _,
        $log,
        user_info,
        $timeout,
        BCSServer,
        cloud,
        util,
        $uibModal,
        moment,
        $scope,
        DTOptionsBuilder,
        DTColumnDefBuilder,
        $interval,
        $transitions,
        $state,
        Alerts,
        $window
    ) {
        let vm = this;

        vm.companyName = user_info.company_name;
        vm.loading = true;
        vm.newProjectsLoading = true;
        vm.accountLoading = true;
        vm.alerts = [];
        vm.iamAlerts = [];
        vm.occupiedAlert = [];
        // Initialize from local storage or set default to false
        vm.hideDisabled = $window.localStorage.getItem('hideDisabled') !== null ? $window.localStorage.getItem('hideDisabled') === 'true' : true;
        vm.hideIdle = $window.localStorage.getItem('hideIdle') === 'true';
        vm.automationEnabled = true;

        // Watch for changes in hideDisabled and update local storage
        $scope.$watch(function() {
            return vm.hideDisabled;
        }, function(newValue) {
            $window.localStorage.setItem('hideDisabled', newValue);
        });

        // Watch for changes in hideIdle and update local storage
        $scope.$watch(function() {
            return vm.hideIdle;
        }, function(newValue) {
            $window.localStorage.setItem('hideIdle', newValue);
        });

        // Variable for type of invoice client
        vm.invoiceGroup = false;

        vm.budgetTypes = [
            {
                name: "Credit",
                id: "Credit"
            },
            {
                name: "Paid",
                id: "PO"
            }
        ];

        vm.departmentTypes = [
            {
                name: "Reporting",
                id: "Reporting"
            },
            {
                name: "Budgeting",
                id: "Budgeting"
            }
        ];

        vm.dateSelections = ["Date Activated", "Date Issued", "Date Suspended", "Expiration Date"];
        vm.dateSelection = vm.dateSelections[0];
        // vm.minDate = moment()

        vm.newAccount = {
            companyCode: "",
            accounts: []
        };

        vm.boolean = [false, true];

        vm.companyCode = user_info.company_code;
        vm.disabled = true;
        vm.projectNameToggle = false;
        vm.projectToggleOff = {
            color:'#2d2e2e'
        }
        vm.projectToggleOn = {
            color:'white'
        }
        vm.budgetStates = ["Consumed", "Active", "Future"];
        vm.afterCreditsOptions = ["Bill", "Suspend"];

        // checking if user is admin
        if (user_info.group) {
            if (user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") != -1) {
                vm.burwoodManager = true;
                vm.isAdmin = true;
            } else if (user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins") != -1) {
                vm.isAdmin = true;
            } else if (user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins Read Only") != -1) {
                vm.adminReadOnly = true;
            } else if (user_info.group.indexOf("BCS Portal - Cloudbilling - Group Admins") != -1) {
                vm.groupAdmin = true;
            } else if (user_info.group.indexOf("BCS Portal - Cloudbilling - Department Admins") != -1) {
                vm.depoAdmin = true;
            } else {
                vm.projectUser = true;
            }
        }

        vm.enterprise = user_info.cloudEnterprise;

        vm.findProjectItem = util.findItem;
        vm.user_info = user_info;
        // Set up Alerting Threashold Config
        vm.setUpThresh = () => {
            vm.thresh = {
                units: {
                    floor: 0,
                    ceil: 100,
                    step: 5,
                    disabled: vm.disabled && !vm.projectUser
                },
                unitsVelocity: {
                    floor: 0,
                    ceil: 10000,
                    step: 10,
                    disabled: vm.disabled && !vm.projectUser
                }
            };
        };
        vm.createAlertMessage = (alert) => {
            vm[alert.type].push({
                status: alert.status,
                msg: alert.msg
            });

            Alerts.storeAlert({
                type: alert.status,
                message: alert.msg,
                user: user_info.email,
                company: user_info.company_name,
                location: $state.current.name,
                tags: ["Cloud Project Page"]
            });

            if (!alert.permanent) {
                $timeout(() => {
                    vm[alert.type] = [];
                }, 5000);
            }
        };

        vm.checkIfMapOccupied = () => {


            BCSServer.postData(
                {
                    user: user_info.name,
                    email: user_info.email,
                    company: user_info.company
                },
                "/cloud_map_occupied",
                (response) => {
                    let alert;

                    if (response && response.occupied === false) {
                        vm.projectUser ? (vm.mapOccupied = false) : (vm.disabled = false);

                        alert = {
                            type: "occupiedAlert",
                            msg: response.msg,
                            status: "success",
                            permanent: true
                        };

                        vm.createAlertMessage(alert);

                        vm.startOccupiedPing();
                    } else if (response && response.occupied) {
                        vm.projectUser ? (vm.mapOccupied = true) : (vm.disabled = true);
                        
                        const responseMessage = response.body ? response.msg + ": " + response.body.email : response.msg
                        alert = {
                            type: "occupiedAlert",
                            msg: responseMessage,
                            status: "fail",
                            permanent: true
                        };

                        vm.createAlertMessage(alert);
                    } else {
                        vm.projectUser ? (vm.mapOccupied = false) : (vm.disabled = false);

                        alert = {
                            type: "occupiedAlert",
                            msg: "You are in editing mode. Only one editor is allowed at a time.",
                            status: "success",
                            permanent: true
                        };

                        vm.createAlertMessage(alert);

                        vm.startOccupiedPing();
                    }

                    vm.setUpThresh();
                }
            );
        };

        !vm.adminReadOnly ? vm.checkIfMapOccupied() : vm.setUpThresh();


        // Start Ping so only one user can occupy the map at a time
        vm.startOccupiedPing = () => {
            // Initialize the Timer to run every 1000 milliseconds i.e. one second.
            vm.occupiedPing = $interval(() => {
                vm.sendOccupiedPing();
            }, 10000);

            $transitions.onBefore({}, (trans) => {
                let transTo = trans.$to().name;
                if (
                    $state.current.name === "index.cloudbilling_projects" &&
                    transTo !== "index.cloudbilling_projects" &&
                    transTo !== "logout"
                ) {
                    let recordchanges = vm.composeActivity(vm.selectedProject, vm.selectedProjectOriginal);
                    if (recordchanges.length > 0) {
                        let prompt = confirm("You have made changes to this record, do you wish to leave?");
                        if (!prompt) {
                            return false;
                        }
                        window.onbeforeunload = null;
                        $interval.cancel(vm.occupiedPing);
                    } else {
                        window.onbeforeunload = null;
                        $interval.cancel(vm.occupiedPing);
                    }
                }

                if ($state.current.name === "index.cloudbilling_projects" && transTo === "logout") {
                    // If the user logs out or is timed out while on the projects page,
                    // the occupied ping should be canceled
                    window.onbeforeunload = null
                    $interval.cancel(vm.occupiedPing)
                }
            });
        };

        // Check if unsaved changes to the project configuration
        window.onbeforeunload = (event) => {
            if ($state.current.name === "index.cloudbilling_projects") {
                let recordchanges = vm.composeActivity(vm.selectedProject, vm.selectedProjectOriginal);

                if (recordchanges.length > 0) {
                    let message = "You have made changes to this record, do you wish to leave?";

                    if (typeof event == "undefined") {
                        event = window.event;
                    }

                    if (event) {
                        event.returnValue = message;
                    }

                    return message;
                }
            }
        };

        // Send occuopied ping signal to server
        vm.sendOccupiedPing = () => {
            BCSServer.postData(
                {
                    user: user_info.name,
                    email: user_info.email,
                    company: user_info.company
                },
                "/cloud_occupied_update",
                function () {}
            );
        };

        let accountQuery = {
            company: user_info.company,
            method: "get",
            role: "IT"
        };

        // restructure groups on any update and load
        vm.structureGroups = () => {
            vm.account.departments = cloud.sortDepartments(vm.account.departments);
            vm.account.groups = cloud.sortGroups(vm.account.groups, user_info.company_name);
            vm.utilizedDepartments = cloud.composeAvailableDepartments(vm.account.groups);
        };

        // Switch from legacy naming convention
        vm.findOldGroup = () => {
            let unaffiliatedGroup = vm.account.groups.find((group) => {
                return group.groupName === "Unaffiliated Departments";
            });
            if (unaffiliatedGroup) {
                unaffiliatedGroup.groupName = user_info.company_name;
            }
        };

        // Main inititation of project configuratin map - COMPLEX
        // TODO - Refactor Code
        vm.fetchProjectMap = () => {
            BCSServer.postData(accountQuery, "/cloud_budgets", (response) => {
                let projectUserIndex = [null, null, null];

                $log.info("INITIAL RESPONSE");
                $log.info(response);
                vm.projectDepoIndexes = [];
                vm.depoUserIndexes = [];
                vm.groupUserIndexes = [];
                vm.departmentList = [];
                vm.groupDepartments = [];

                if (response && angular.isArray(response) && response.length > 0 && response[0].departments) {
                    vm.account = response[0];
                    vm.account.activity = [];


                    // check is any groups have missing ID's then assigns if not
                    cloud.assignIDs(vm.account.departments, "departmentID");

                    if (!vm.account.groups || vm.account.groups.length === 0) {
                        vm.account.groups = [
                            {
                                groupName: user_info.company_name,
                                contactList: [],
                                billingContactEmail: [""],
                                departments: ["Unaffiliated Projects", "Disabled Projects"]
                            }
                        ];
                    } else {
                        vm.findOldGroup();
                    }

                    // check is any groups have missing ID's then assigns if not
                    cloud.assignIDs(vm.account.groups, "groupID");

                    vm.structureGroups();

                    if (vm.burwoodManager || vm.isAdmin || vm.adminReadOnly) {
                        vm.groupDepartments = angular.copy(vm.account.departments);
                    } else {
                        vm.departmentList = cloud.findGroupDepartments(user_info.email, vm.account.groups);
                        if (vm.departmentList.length > 0) {
                            vm.groupAdmin = true;
                        }
                    }

                    vm.account.departments.forEach((department, index) => {
                        vm.sortProjects(index);
                        department.projects = cloud.removeExportProjects(department.projects, "", "projectID");

                        if (!vm.utilizedDepartments.includes(department.departmentID)) {
                            let unaffiliatedDepartment = vm.account.groups.find((group) => {
                                return group.groupName === user_info.company_name;
                            });
                            if (!unaffiliatedDepartment) {
                                vm.account.groups.push({
                                    groupName: user_info.company_name,
                                    contactList: [],
                                    billingContactEmail: [],
                                    departments: ["Unaffiliated Projects", "Disabled Projects"]
                                });
                                vm.account.groups[vm.account.groups.length - 1].departments.unshift(
                                    department.departmentID
                                );
                            } else {
                                unaffiliatedDepartment.departments.unshift(department.departmentID);
                            }
                        }

                        !department.budgetType && (department.budgetType = "Reporting");

                        !department.activity && (department.activity = []);

                        if (vm.groupAdmin) {
                            if (vm.departmentList.includes(department.departmentID)) {
                                vm.account.activity = vm.account.activity.concat(department.activity);
                            }
                        } else {
                            vm.account.activity = vm.account.activity.concat(department.activity);
                        }

                        if (
                            department.budgetType === "Budgeting" &&
                            department.allowances &&
                            department.allowances.length > 0
                        ) {
                            let currentBudget = department.allowances.find((allowance) => {
                                return allowance.state === "Active";
                            });
                            if (!currentBudget && department.afterCredits === "Suspend") {
                                department.suspended = true;
                            }
                        }

                        if (vm.groupAdmin || vm.depoAdmin) {
                            if (
                                department.departmentName === "Unaffiliated Projects" ||
                                department.departmentName === "Disabled Projects"
                            ) {
                                vm.depoUserIndexes.push(index);
                                vm.departmentList.push(department.departmentID);
                            }
                        }

                        if (!vm.isAdmin && !vm.adminReadOnly) {
                            let userFind = vm.findProjectItem(vm.user_info.email, department.contactList, "email");
                            if (userFind || vm.departmentList.includes(department.departmentID)) {
                                vm.projectDepoIndexes.push(index);
                                vm.depoUserIndexes.push(index);
                            }
                            if (userFind && !vm.departmentList.includes(department.departmentID)) {
                                vm.departmentList.push(department.departmentID);
                            }
                        }

                        department.projects.forEach((project) => {
                            if (vm.groupAdmin) {
                                if (vm.departmentList.includes(department.departmentID)) {
                                    vm.account.activity = vm.account.activity.concat(project.activity);
                                }
                            } else {
                                vm.account.activity = vm.account.activity.concat(project.activity);
                            }

                            project.allowances = cloud.sortAllowancesByDate(project.allowances);

                            if (
                                department.budgetType != "Budgeting" &&
                                project.allowances &&
                                project.allowances.length > 0
                            ) {
                                let consumedBudget = project.allowances.find((allowance) => {
                                    return allowance.state === "Consumed";
                                });
                                let currentBudget = project.allowances.find((allowance) => {
                                    return allowance.state === "Active";
                                });
                                if (!currentBudget && consumedBudget && project.afterCredits === "Suspend") {
                                    project.suspended = true;
                                }
                            }
                            if (department.budgetType === "Budgeting" && department.suspended) {
                                project.suspended = true;
                            }

                            if (!vm.isAdmin && !vm.adminReadOnly) {
                                let userFind = vm.findProjectItem(vm.user_info.email, project.contactList, "email");
                                if (userFind || vm.departmentList.includes(department.departmentID)) {
                                    vm.projectDepoIndexes.push(index);
                                }
                                if (userFind && !vm.departmentList.includes(department.departmentID)) {
                                    vm.departmentList.push(department.departmentID);
                                }
                            }
                        });
                    });

                    vm.projectDepoIndexes.forEach((index) => {
                        let depoID = vm.account.departments[index].departmentID;
                        vm.account.groups.forEach((group, gIndex) => {
                            if (group.departments.includes(depoID)) {
                                vm.groupUserIndexes.push(gIndex);
                            }
                        });
                    });

                    if (!vm.burwoodManager && !vm.isAdmin && !vm.adminReadOnly) {
                        vm.mapGroupDepartments();
                    }

                    projectUserIndex = vm.findStartingProject();
                    
                    if (projectUserIndex[0] !== null && projectUserIndex[1] !== null && projectUserIndex[2] !== null) {
                        vm.chooseContent(projectUserIndex[0], projectUserIndex[1], projectUserIndex[2], "delayToggle");
                    } else {
                        vm.selectedProject = null;
                    }
                } else {
                    vm.account = {
                        company: user_info.company,
                        activity: [],
                        departments: [],
                        groups: [
                            {
                                groupName: user_info.company_name,
                                contactList: [],
                                billingContactEmail: [],
                                departments: []
                            }
                        ]
                    };
                    let projectDepartment = angular.copy(defaultDepartment);
                    projectDepartment.departmentName = "Projects";
                    projectDepartment.departmentID = cloud.createIDString(12);
                    vm.account.departments.push(projectDepartment);
                    vm.account.groups[0].departments.push(projectDepartment.departmentID);
                    vm.groupDepartments = angular.copy(vm.account.departments);
                    vm.needsAdminInit = true;
                }

                vm.applyUnaffiliatedDepartments(vm.company, vm.account);


                $log.info("FINAL ACCOUNT: ");
                $log.info(vm.account);

                // if (vm.invoiceGroup) {
                //     vm.matchProjectToInvoiceGroups(vm.account);
                // }

                vm.loading = false;
            });
        };

        vm.matchProjectToInvoiceGroups = (account) => {
            account.departments.forEach((depo) => {
                depo.tempProjects = [];
            });

            account.departments.forEach((depo) => {
                depo.projects.forEach((project) => {
                    if (!project.paidBillingAccounts) {
                        depo.tempProjects.push(project);
                        return;
                    }

                    let foundGroup = account.groups.find((group) =>
                        group.billingAccounts.includes(project.paidBillingAccounts)
                    );

                    if (foundGroup) {
                        let foundExistingDepartment = account.departments.find((department) =>
                            department.projects.find(
                                (prj) =>
                                    prj.projectID === project.projectID &&
                                    foundGroup.departments.includes(department.departmentID)
                            )
                        );

                        if (foundExistingDepartment) {
                            foundExistingDepartment.tempProjects.push(project);
                        } else {
                            let foundUnafilliatedDepartment = account.departments.find(
                                (department) =>
                                    foundGroup.departments.includes(department.departmentID) &&
                                    department.departmentName.includes("Unaffiliated")
                            );

                            foundUnafilliatedDepartment.tempProjects.push(project);
                        }
                    }
                });
            });

            account.departments.forEach((depo) => {
                depo.projects = depo.tempProjects;
            });

            account.departments.forEach((item, index) => {
                vm.sortProjects(index);
            });
        };

        vm.applyUnaffiliatedDepartments = (company, account) => {
            if (company.invoicingRole === "group") {
                account.groups.forEach((group) => {
                    const foundUnaffiliated = account.departments.find(
                        (depo) => depo.departmentName === `Unaffiliated ${group.groupName}`
                    );
                    if (!foundUnaffiliated && group.groupName !== user_info.company_name) {
                        let unaffiliatedDepartment = angular.copy(defaultDepartment);
                        unaffiliatedDepartment.unaffiliated = true;
                        unaffiliatedDepartment.departmentName = `Unaffiliated ${group.groupName}`;
                        unaffiliatedDepartment.departmentID = cloud.createIDString(12);
                        account.departments.push(unaffiliatedDepartment);
                        group.departments.push(unaffiliatedDepartment.departmentID);
                        vm.groupDepartments = angular.copy(account.departments);
                    }
                });
            }
        };

        // vm.organizeInvoicingProjects = () => {};

        // For project/depo/group users
        // Composes available departments based on their assignments/email contacts
        vm.mapGroupDepartments = () => {
            vm.account.departments.forEach((depo) => {
                if (depo && vm.departmentList.includes(depo.departmentID)) {
                    vm.groupDepartments.push(angular.copy(depo));
                }
            });
        };

        // Locates the first available group index, department index, and project index for Accordion
        vm.findStartingProject = () => {
            let groupIndexFound = false;
            let projectUserIndex = [null, null, null];
            vm.account.groups.forEach((group, gIndex) => {
                vm.account.departments.forEach((depo, dIndex) => {
                    if (group.departments.includes(depo.departmentID)) {
                        if (depo && depo.projects && depo.projects.length > 0 && vm.groupAdmin) {
                            let groupFind = vm.findProjectItem(vm.user_info.email, group.contactList, "email");
                            if (groupFind) {
                                if (!groupIndexFound) {
                                    projectUserIndex = [gIndex, dIndex, 0];
                                    groupIndexFound = true;
                                }
                            }
                        }
                        if (vm.depoAdmin) {
                            let depoFind = vm.findProjectItem(vm.user_info.email, depo.contactList, "email");
                            if (depoFind) {
                                if (!groupIndexFound) {
                                    projectUserIndex = [gIndex, dIndex, 0];
                                    groupIndexFound = true;
                                }
                            }
                        }
                        depo.projects.forEach((prj, pIndex) => {
                            if (vm.projectUser || vm.depoAdmin || vm.groupAdmin) {
                                let userFind = vm.findProjectItem(vm.user_info.email, prj.contactList, "email");
                                if (userFind) {
                                    if (!groupIndexFound) {
                                        projectUserIndex = [gIndex, dIndex, pIndex];
                                        groupIndexFound = true;
                                    }
                                }
                            } else {
                                if (prj && !groupIndexFound) {
                                    projectUserIndex = [gIndex, dIndex, pIndex];
                                    groupIndexFound = true;
                                }
                            }
                        });
                    }
                });
            });
            return projectUserIndex;
        };

        // Checks GCP Project permissions for a specified project
        vm.checkProjectIAM = (projectID, depo) => {
            if (
                projectID === "Unknown" ||
                projectID === "[Charges not specified to a project]" ||
                user_info.company_code === "UNIAME"
            ) {
                return;
            }
            BCSServer.postData(
                {
                    projectID: projectID
                },
                "/cloud_check_project_iam",
                (response) => {
                    if (response.error) {
                        vm.missingPermissionError = response.error;
                        vm.missingPermission = true;
                    } else {
                        if (!depo) {
                            vm.missingPermission = false;
                            vm.missingPermissionError = "";
                        }
                    }
                }
            );
        };

        vm.checkProjectsIAM = (projects) => {
            BCSServer.postData(
                {
                    projects: projects
                },
                "/cloud_check_projects_iam",
                (response) => {
                    if (response.error) {
                        vm.missingPermissionError = response.error;
                        vm.missingPermission = true;
                    } else {
                        response.msg.forEach((project) => {
                            let projectID = Object.keys(project)[0];
                            if (project[projectID].length === 0) {
                                vm.missingPermissionError += `${projectID} missing permissions: ${response.permissions.join(
                                    ", "
                                )}`;
                                vm.missingPermission = true;
                            }
                        });
                    }
                }
            );
        };

        vm.missingPermissionAccounts = [];

        // Checks GCP billing account permissions for a specified account
        vm.checkAccountIAM = (accounts) => {
            let queryAccounts = accounts.map((account) => {
                return account.account;
            });
            BCSServer.postData(
                {
                    accounts: queryAccounts
                },
                "/cloud_check_accounts_iam",
                (response) => {
                    if (response.error) {
                        vm.createAlertMessage({
                            type: "iamAlerts",
                            msg: `Failed to check permission on GCP billing account: ${angular.toString(
                                response.error
                            )}`,
                            status: "fail",
                            permanent: true
                        });
                    } else {
                        if (response && response.msg) {
                            response.msg.forEach((account) => {
                                let acountNum = Object.keys(account)[0];
                                if (account[acountNum].length === 0) {
                                    vm.missingPermissionAccounts.push(acountNum);
                                    vm.createAlertMessage({
                                        type: "iamAlerts",
                                        msg:
                                            "Missing GCP billing account permissions (" +
                                            acountNum +
                                            "): " +
                                            response.permissions.join(),
                                        status: "fail",
                                        permanent: true
                                    });
                                }
                            });
                        }
                    }
                }
            );
        };

        // Fetches a project list from Bigquery export table for past 30 days
        // Existing projects with no consumption for 30 days are labeled as 'Idle'
        vm.fetchProjectList = () => {
            if (user_info.gcpOrgID) {
                vm.fetchGCPProjectList(user_info.gcpOrgID);
            }
            vm.fetchBigQueryProjectsList();
        };

        // Fetchs project list from BQ if no access to GCP
        vm.fetchBigQueryProjectsList = () => {
            BCSServer.postData(
                {
                    view: "project_account_list_by_date",
                    parameters: {
                        dateRange: {
                            startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
                            endDate: moment(new Date()).format("YYYY-MM-DD")
                        }
                    }
                },
                "/big_query/get_query",
                (response) => {
                    let bqProjects;
                    if (response && response.length > 0) {
                        let recentProjectList = cloud.reduceRecentProjects(response);
                        bqProjects = cloud.removeExportProjects(recentProjectList, user_info.company_code);
                    } else {
                        bqProjects = [];
                    }
                    vm.bqProjects = bqProjects;
                    if (user_info.company_code === "UNIAME") {
                        vm.projectList = bqProjects.map((prj) => {
                            prj.billing_account_id = prj.accounts[0].billing_account_id;
                            return prj;
                        });
                    }
                }
            );
        };

        vm.batchedProjects = [];
        vm.batchCheckIndex = 0;

        vm.fetchAccountProjects = (accounts) => {
            vm.batchAccounts = [];
            accounts.forEach((acc, index) => {
                const batchIndex = Math.floor(index / 30);
                if (!vm.batchAccounts[batchIndex]) {
                    vm.batchAccounts[batchIndex] = [acc];
                } else {
                    vm.batchAccounts[batchIndex].push(acc);
                }
            });
            vm.accountBatchIndex = vm.batchAccounts.length;
            vm.fetchSingleBatch(vm.batchAccounts[0]);
        };

        vm.fetchSingleBatch = (accounts) => {
            BCSServer.postData(
                {
                    accounts: accounts
                },
                "/gcp_billing_projects",
                (response) => {
                    let projectList = [];
                    if (response && response.success) {
                        projectList = cloud.removeExportProjects(
                            response.accountProjects,
                            user_info.company_code,
                            "projectId"
                        );
                    }
                    let projectListMapped = projectList.map((project) => {
                        return {
                            project_id: project.projectId,
                            billing_account_id: project.billingAccountName.replace("billingAccounts/", "")
                        };
                    });

                    vm.batchedProjects = vm.batchedProjects.concat(projectListMapped);

                    vm.batchCheckIndex++;

                    if (vm.batchCheckIndex === vm.accountBatchIndex) {
                        vm.projectList = vm.batchedProjects;
                    } else {
                        vm.fetchSingleBatch(vm.batchAccounts[vm.batchCheckIndex]);
                    }
                }
            );
        };

        // Fetches project list from GCP
        vm.fetchGCPProjectList = (orgID) => {
            BCSServer.postData(
                {
                    orgID: orgID 
                },
                "/cloud_org_structure",
                (response) => {
                    vm.projectNames = {};
                    if (response && response.success) {
                        response.data.forEach((project) => {
                            vm.projectNames[project.projectId] = project.name;
                        });
                    }
                }
            );
        };

        // Fetches company account configration from the Account Mongo Schema
        vm.fetchAccountNumbers = () => {
            vm.company = {};
            BCSServer.postData(
                {
                    companyCode: user_info.company_code
                },
                "/cloud_accounts",
                (response) => {
                    vm.accountLoading = false;
                    vm.pos = [];
                    if (response) {
                        vm.invoiceGroup = response.invoicingRole === "group" ? true : false;
                        if (response.accounts && response.accounts.length > 0) {
                            vm.company = response;
                            // If undefined true else the value of automationEnabled
                            if (vm.company.automationEnabled === undefined) {
                                vm.automationEnabled = true;
                            } else {
                                $log.info(response.automationEnabled)
                                vm.automationEnabled = vm.company.automationEnabled;
                            }

                            // Stanford check 
                            if (vm.company.company == "b669d9cd1300a200bc3b50622244b013") {
                                vm.automationEnabled = false;
                            }
                            
                            $log.info('automationEnabled', vm.automationEnabled);
                            $log.info('!vm.automationEnabled', !vm.automationEnabled);
                            vm.company.accounts = util.sortItems(vm.company.accounts, "name", "ASC");
                            vm.allAccounts = vm.company.accounts;
                            if (user_info.company_code !== "UNIAME") {
                                vm.checkAccountIAM(response.accounts);
                            }
                            vm.availableAccounts = vm.company.accounts.map((account) => ({
                                accountNum: account.account,
                                accountName: `${account.account} - ${account.name}`
                            }));
                            vm.availableAccounts.push({
                                accountNum: "",
                                accountName: "Disabled Project"
                            });
                        } else {
                            vm.company.accounts = [];
                        }
                        if (response.pos && response.pos.length > 0) {
                            vm.pos = cloud.createPOList(response.pos);
                        }
                    }
                    vm.fetchProjectMap();
                    if (user_info.company_code !== "UNIAME") {
                        vm.fetchAccountProjects(vm.company.accounts);
                    }
                }
            );
        };

        vm.fetchFilteredAccounts = () => {
            vm.filteredAccounts = {};
            BCSServer.postData(
                {
                    companyCode: user_info.company_code
                },
                "/cloud_accounts_filtered",
                (response) => {
                    vm.accountLoading = false;
                    if (response && response.accounts && response.accounts.length > 0) {
                        vm.filteredAccounts = response;
                    } else {
                        vm.filteredAccounts.accounts = [];
                    }
                }
            );
        };

        vm.fetchKnownCredits = () => {
            vm.knownCredits = {};
            BCSServer.postData(
                {
                    companyCode: user_info.company_code
                },
                "/known_credits",
                (response) => {
                    vm.accountLoading = false;
                    if (response && response.credits && response.credits.length > 0) {
                        vm.knownCredits = response;
                    } else {
                        vm.knownCredits.credits = [];
                    }
                }
            );
        };

        vm.fetchProjectList();
        vm.fetchAccountNumbers();
        vm.fetchFilteredAccounts();
        vm.fetchKnownCredits();

        vm.switchDepartments = (department, bypass) => {
            let saveDepo = false;
            let groupIndex = 0;

            if (!bypass) {
                let selectedDepo = vm.account.departments.find((depo) => depo.departmentName === department);
                groupIndex = cloud.findGroupIndex(vm.account, selectedDepo.departmentID);

                // Added additional logic to the if statement
                // You should be able to move a project to the Disabled Projects department if the project does not have an active billing account
                if (vm.invoiceGroup && !(selectedDepo.departmentName === "Disabled Projects" && vm.selectedProject.paidBillingAccounts === "")) {
                    if (//if project is disabled allow reassign 
                        vm.account.departments[vm.departmentIndex].departmentName !== "Disabled Projects" &&( 
                        !vm.account.groups[groupIndex].billingAccounts.includes(
                            vm.account.departments[vm.departmentIndex].projects[vm.projectIndex].paidBillingAccounts
                        ) ||
                        !vm.account.groups[groupIndex].billingAccounts ||
                        vm.account.groups[groupIndex].billingAccounts.length == 0
                        )
                    ) {
                        vm.selectedDepartment = vm.account.departments[vm.departmentIndex].departmentName;
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Cannot move project into group without corresponding active billing account ID",
                            status: "fail",
                            permanent: false
                        });
                        return;
                    }
                } else {
                    let targetDepartment = vm.account.departments.find((depo) => {
                        return depo.departmentName === department;
                    });

                    if (targetDepartment && targetDepartment.budgetType === "Budgeting") {
                        let continueSwitch = vm.confirmSwitchToBudgetDepartment(targetDepartment);
                        if (!continueSwitch) {
                            return;
                        }
                        saveDepo = true;
                    }
                }
            }

            let depoIndexes = vm.mapDepartmentSwitch(department, vm.projectIndex);

            vm.chooseContent(
                groupIndex,
                depoIndexes.departmentIndex,
                depoIndexes.projectIndex,
                "delayToggle",
                null,
                null,
                saveDepo
            );
        };

        vm.reassignProjectAccount = (project, account, prevAccount) => {
            console.log(project);
            console.log(account, prevAccount);

            let switchType = "switch";
            let message = `The selected project will switch billing accounts from ${prevAccount} to ${account}.  Do you wish to continue?`;

            if (!account) {
                switchType = "suspend";
                message = `Disabling this project will remove the project from the account ${prevAccount}.  All budgets will be marked as consumed. Data retention will last 30 days unless a new billing account is connected. After 30 days all data will be permanently lost.  Do you wish to continue?`;
            }

            let prompt = confirm(message);

            if (prompt) {
                let accountSwitch = {
                    projectID: project.projectID,
                    primaryEmail: project.primaryContactEmail,
                    contactList: project.contactList,
                    company: user_info.company_name,
                    accountNum: account,
                    nextAccount: account,
                    previousAccount: prevAccount
                };

                BCSServer.postData(accountSwitch, `/cloud_account_${switchType}`, (response) => {
                    $log.info(response);

                    if (response && response.success) {
                        vm.switchAccountStates("Consumed");

                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Successfully ${switchType}ed project account -  ${project.projectID}`,
                            status: "success",
                            permanent: false
                        });

                        vm.updateUserDatabase();
                    } else {
                        project.paidBillingAccounts = prevAccount;
                        let error = response.error || "";
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Failed to ${switchType} project account - ${project.projectID}.  ${angular.toString(
                                error
                            )}`,
                            status: "fail",
                            permanent: false
                        });
                    }
                });
            } else {
                project.paidBillingAccounts = prevAccount;
            }
        };

        vm.batchSwitchDepartments = (department) => {
            let currentDepartment = vm.account.departments.find((depo) => {
                return depo.departmentName === vm.originalDepartment;
            });

            let depoIndexes;
            for (let i = currentDepartment.projects.length - 1; i >= 0; i--) {
                if (currentDepartment.projects[i].batchSelect) {
                    if (vm.invoiceGroup) {
                        let selectedDepo = vm.account.departments.find((depo) => depo.departmentName === department);
                        let invoiceGroupIndex = cloud.findGroupIndex(vm.account, selectedDepo.departmentID);
                        if (
                            !vm.account.groups[invoiceGroupIndex].billingAccounts.includes(
                                currentDepartment.projects[i].paidBillingAccounts
                            ) ||
                            !vm.account.groups[invoiceGroupIndex].billingAccounts ||
                            vm.account.groups[invoiceGroupIndex].billingAccounts.length == 0
                        ) {
                            vm.createAlertMessage({
                                type: "alerts",
                                msg: `${currentDepartment.projects[i].projectID} project was not able to move into group without corresponding active billing account ID`,
                                status: "fail",
                                permanent: false
                            });
                            depoIndexes = {
                                departmentIndex: vm.departmentIndex,
                                projectIndex: vm.projectIndex
                            };
                        } else {
                            depoIndexes = vm.mapDepartmentSwitch(department, i);
                        }
                    } else {
                        depoIndexes = vm.mapDepartmentSwitch(department, i);
                    }
                }
            }

            let groupIndex = cloud.findGroupIndex(vm.account, department);

            vm.chooseContent(groupIndex, depoIndexes.departmentIndex, 0, "delayToggle", null, null);
        };

        vm.mapDepartmentSwitch = (department, projectIndex) => {
            let departmentIndex = cloud.findDepartmentIndex(department, vm.account);
            let projectToMove = vm.account.departments[vm.departmentIndex].projects[projectIndex];
            vm.account.departments[vm.departmentIndex].projects.splice(projectIndex, 1);
            vm.account.departments[departmentIndex].projects.push(projectToMove);

            let newProjectIndex;

            vm.sortProjects(departmentIndex);

            vm.account.departments[departmentIndex].projects.forEach((project, index) => {
                project && project.projectID === vm.selectedProject.projectID && (newProjectIndex = index);
            });

            return {
                departmentIndex: departmentIndex,
                projectIndex: newProjectIndex
            };
        };

        vm.confirmSwitchToBudgetDepartment = (targetDepartment) => {
            let prompt = confirm(
                "You are about to move a project into a department where budget is defined at the department level.  This project will have any associated, active account switched to the active account of the department.  Do you wish to continue?"
            );

            if (!prompt) {
                vm.selectedDepartment = vm.originalDepartment;
                return false;
            } else {
                let currentBudget = false;
                let activeBudget = null;
                let leavingIndex = false;

                if (targetDepartment.allowances && targetDepartment.allowances.length > 0) {
                    currentBudget = targetDepartment.allowances.find((allowance) => {
                        return allowance.state === "Active";
                    });
                }

                // If there's no active budget but there's an after-credits account, use it as the current budget
                if (!currentBudget && targetDepartment.afterCreditsAccount && targetDepartment.afterCredits === "Bill") {
                    currentBudget = {"accountNum": targetDepartment.afterCreditsAccount};
                }

                if (vm.selectedProject.allowances && vm.selectedProject.allowances.length > 0) {
                    activeBudget = vm.selectedProject.allowances.find((allowance) => {
                        return allowance.state === "Active";
                    });
                    leavingIndex = vm.selectedProject.allowances.findIndex((allowance) => {
                        return allowance.state === "Active";
                    });
                }

                if (!currentBudget && (!targetDepartment.afterCreditsAccount || targetDepartment.afterCredits === "Suspend")) {
                    var prompt2 = confirm(
                        "Targeted department has no active budget.  Project will be moved to targeted department but suspended until budget is created. Do you wish to continue?"
                    );
                    if (!prompt2) {
                        vm.selectedDepartment = vm.originalDepartment;
                        return false;
                    } else {
                        vm.suspendProjectAccountToDepartment(activeBudget, "department");
                    }
                } else {
                    switchProjectAccountToDepartment(currentBudget, null, activeBudget, leavingIndex);
                }
            }
            return true;
        };

        vm.reassignProjectAccount = (project, account, prevAccount) => {
            console.log(project);
            console.log(account, prevAccount);

            let switchType = "switch";
            let message = `The selected project will switch billing accounts from ${prevAccount} to ${account}.  Do you wish to continue?`;

            if (!account) {
                switchType = "suspend";
                message = `Disabling this project will remove the project from the account ${prevAccount}.  All budgets will be marked as consumed. Data retention will last 30 days unless a new billing account is connected. After 30 days all data will be permanently lost.  Do you wish to continue?`;
            }

            let prompt = confirm(message);

            if (prompt) {
                let accountSwitch = {
                    projectID: project.projectID,
                    primaryEmail: project.primaryContactEmail,
                    contactList: project.contactList,
                    company: user_info.company_name,
                    accountNum: account,
                    nextAccount: account,
                    previousAccount: prevAccount
                };

                BCSServer.postData(accountSwitch, `/cloud_account_${switchType}`, (response) => {
                    $log.info(response);

                    if (response && response.success) {
                        vm.switchAccountStates("Consumed");

                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Successfully ${switchType}ed project account -  ${project.projectID}`,
                            status: "success",
                            permanent: false
                        });

                        vm.updateUserDatabase();
                    } else {
                        project.paidBillingAccounts = prevAccount;
                        let error = response.error || "";
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Failed to ${switchType} project account - ${project.projectID}.  ${angular.toString(
                                error
                            )}`,
                            status: "fail",
                            permanent: false
                        });
                    }
                });
            } else {
                project.paidBillingAccounts = prevAccount;
            }
        };

        let switchCount = 0;

        function switchProjectAccountToDepartment(
            currentBudget,
            type,
            activeBudget,
            index,
            prevValue,
            accountChange,
            project
        ) {
            let projectToUpdate = project || vm.selectedProject;

            // Skip the GCP switch if project == the "not" specified project.
            if (vm.selectedProject.projectID == "[Charges not specified to a project]") {
                return;
            }

            let accountSwitch = {
                currentBudget: currentBudget,
                activeBudget: activeBudget,
                projectID: projectToUpdate.projectID,
                primaryEmail: projectToUpdate.primaryContactEmail,
                contactList: projectToUpdate.contactList,
                accountNum: currentBudget.accountNum,
                company: user_info.company_name,
                afterCredits: projectToUpdate.afterCredits
            };

            BCSServer.postData(accountSwitch, "/cloud_account_switch", (response) => {
                $log.info(response);

                if (response && response.success) {
                    if (type === "project") {
                        currentBudget.dateActivated = moment();
                    }

                    vm.switchAccountStates("Consumed", index);
                    if (activeBudget) {
                        activeBudget.state = "Consumed";
                        activeBudget.dateSuspended = moment().utc();
                    }

                    if (!project) {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Successfully Switched Project Account - " + projectToUpdate.projectID,
                            status: "success",
                            permanent: false
                        });
                        vm.updateUserDatabase();
                    } else if (project && switchCount === vm.selectedProject.projects.length - 1) {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Successfully Switched Project Accounts",
                            status: "success",
                            permanent: false
                        });
                        vm.updateUserDatabase();
                        switchCount = 0;
                    } else if (project) {
                        switchCount++;
                    }
                } else {
                    if (type !== "project") {
                        vm.switchDepartments(vm.revertDepartment, "bypass");
                    } else {
                        if (accountChange) {
                            currentBudget.accountNum = prevValue;
                        } else {
                            currentBudget.state = prevValue;
                        }
                    }

                    switchCount++;

                    let error = response.error || "";

                    vm.createAlertMessage({
                        type: "alerts",
                        msg: `Failed To Switch Project Account in GCP - ${
                            projectToUpdate.projectID
                        }.  ${angular.toString(error)}`,
                        status: "fail",
                        permanent: false
                    });
                }
            });
        }

        vm.suspendProjectAccountToDepartment = (activeBudget, type, project) => {
            let projectToUpdate = project || vm.selectedProject;   
            if (projectToUpdate.projectID == "[Charges not specified to a project]") {
                $log.info("Default project is selected. No billing account to suspend.")
                return;
            }


            // There is a case where there is no active budget on the project.
            // Therefore, activeBudget may be null.
            let accountSuspend = {
                    activeBudget: activeBudget ? activeBudget : null,
                    accountNum: activeBudget ? activeBudget.accountNum : null,
                    primaryEmail: projectToUpdate.primaryContactEmail,
                    contactList: projectToUpdate.contactList,
                    projectID: projectToUpdate.projectID,
                    company: user_info.company_name
            };

      

            BCSServer.postData(accountSuspend, "/cloud_account_suspend", (response) => {
                $log.info(response);

                if (response && response.success) {
                    vm.createAlertMessage({
                        type: "alerts",
                        msg: "Successfully Suspended Project Account.",
                        status: "success",
                        permanent: false
                    });

                    if (activeBudget != null) {
                        activeBudget.state = "Consumed";
                        activeBudget.dateSuspended = moment().utc();
                    }

                    if (!project) {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Successfully Suspended Project Account - " + projectToUpdate.projectID,
                            status: "success",
                            permanent: false
                        });
                        vm.updateUserDatabase();
                    } else if (project && switchCount === vm.selectedProject.projects.length - 1) {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Successfully Switched Project Accounts",
                            status: "success",
                            permanent: false
                        });
                        vm.updateUserDatabase();
                        switchCount = 0;
                    } else if (project) {
                        switchCount++;
                    }
                } else {
                    if (type !== "project") {
                        vm.switchDepartments(vm.revertDepartment, "bypass");
                    } else {
                        if (activeBudget != null) {
                            activeBudget.state = "Active";
                        }
                    }

                    switchCount++;

                    let error = response.error || "";

                    vm.createAlertMessage({
                        type: "alerts",
                        msg: `Failed To Suspend Project Account - ${projectToUpdate.projectID}.  ${angular.toString(
                            error
                        )}`,
                        status: "fail",
                        permanent: false
                    });
                }
            });
        };

        vm.checkActiveChange = (account, index, prevValue, accountChange) => {
            if (accountChange && account.state !== "Active") {
                return;
            }

                
            let activeBudget = vm.selectedProject.allowances.find((o, aIndex) => {
                return o.state === "Active" && aIndex !== index;
            });

            if (account.state === "Active") {
                var promptMesage =
                    "You are about to move a project to an active state.  This project will be suspended from the existing active account, marked as 'Consumed', and enabled for this account. Do you wish to continue?";

                if (accountChange) {
                    promptMesage =
                        "You are about to switch a project account.  This project will be suspended from the existing active account, marked as 'Consumed', and enabled for this account. Do you wish to continue?";
                }

                if (vm.selectedName === "Department" && vm.selectedProject.budgetType === "Budgeting") {
                    promptMesage =
                        "You are about to move a department to an active state.  Projects will be suspended from the existing active account, marked as 'Consumed', and enabled for this account. Do you wish to continue?";
                }

                if (
                    vm.selectedName === "Department" &&
                    vm.selectedProject.budgetType === "Budgeting" &&
                    accountChange
                ) {
                    promptMesage =
                        "You are about to switch a department account.  All asscoiated projects will be suspended from the existing active account, marked as 'Consumed', and enabled for this account. Do you wish to continue?";
                }

                let prompt = confirm(promptMesage);

                if (!prompt) {
                    if (accountChange) {
                        account.accountNum = prevValue;
                    } else {
                        account.state = prevValue;
                    }

                    return;
                } else {
                    if (vm.selectedName === "Department" && vm.selectedProject.budgetType === "Budgeting") {
                        vm.selectedProject.projects.forEach((project) => {
                            switchProjectAccountToDepartment(
                                account,
                                "project",
                                null,
                                index,
                                prevValue,
                                accountChange,
                                project
                            );
                        });
                    } else {
                        switchProjectAccountToDepartment(
                            account,
                            "project",
                            activeBudget,
                            index,
                            prevValue,
                            accountChange
                        );
                    }
                }
            } else if (prevValue !== "Active" && account.state === "Consumed") {
                let promptSuspend = confirm(
                    "You are about to mark this budget as consumed and will not be able to alter it afterward. Do you wish to continue?"
                )

                if (!promptSuspend) {
                    account.state = prevValue;
                    return;
                } 

            } else if (prevValue === "Active") {
                let promptSuspend = confirm(
                    "You are about to move a project to an non active state.  This project will be suspended from the current active account. You will not be able to alter this budget afterward. Do you wish to continue?"
                );

                if (vm.selectedName === "Department") {
                    promptMesage =
                        "You are about to move a department to a non active state.  All projects will be suspended from the current active account. You will not be able to alter this budget afterward. Do you wish to continue?";
                }

                if (!promptSuspend) {
                    account.state = prevValue;

                    return;
                } else {
                    if (vm.selectedName === "Department") {
                        vm.selectedProject.projects.forEach((project) => {
                            vm.suspendProjectAccountToDepartment(account, "project", project);
                        });
                    } else {
                        vm.suspendProjectAccountToDepartment(account, "project");
                    }
                }
            } else if (account.state === "Future" && vm.selectedProject.recurringBudget) {
                vm.createAlertMessage({
                    type: "alerts",
                    msg: "Future recurring budget not allowed",
                    status: "fail",
                    permanent: false
                });

                account.state = prevValue;

                return;
            }
        }; 

            
        vm.switchAccountStates = (state, activeIndex) => {
            vm.selectedProject.allowances.forEach((allowance, index) => {
                if (allowance && allowance.state === "Active" && index !== activeIndex) {
                    allowance.state = state;
                }
            });
        };

        vm.findUnspecifiedProject = (bqList) => {
            let foundBQ = bqList.find((project) => project.project_id === "[Charges not specified to a project]");
            if (foundBQ && foundBQ.accounts && foundBQ.accounts[0]) {
                return {
                    project_id: foundBQ.project_id,
                    billing_account_id: foundBQ.accounts[0].billing_account_id
                };
            }
            return;
        };

        vm.findNewProjects = (account) => {
            let newProjects = [];
            let databaseProjectList = cloud.composeProjectListFromDatabase(vm.account);

            databaseProjectList.forEach((project) => {
                let projectFound = vm.projectList.find((prj) => {
                    return prj.project_id === project.projectID;
                });
                if (projectFound) {
                    // !project.project && (project.project = projectFound.project_name);
                    project.paidBillingAccounts = projectFound.billing_account_id;
                } else {
                    // project.project = "";
                    project.paidBillingAccounts = "";
                }
            });

            let unspecifiedProject = vm.findUnspecifiedProject(vm.bqProjects);

            unspecifiedProject && vm.projectList.unshift(unspecifiedProject);

            vm.projectList.forEach((project) => {
                let projectFound = databaseProjectList.find((prj) => {
                    return prj.projectID === project.project_id;
                });
                let newDupe = newProjects.find((prj) => {
                    return prj.projectID === project.project_id;
                });
                if (!projectFound && !newDupe) {
                    newProjects.push({
                        projectID: project.project_id,
                        paidBillingAccounts: project.billing_account_id,
                        afterCredits: "Bill",
                        afterCreditsAccount: project.billing_account_id,
                        alerts: defaultAlerts,
                        activity: [],
                        allowances: []
                    });
                } else if (projectFound && projectFound.projectID === "[Charges not specified to a project]") {
                    projectFound.paidBillingAccounts = project.billing_account_id;
                    projectFound.afterCreditsAccount = project.billing_account_id;
                }
            });

            let unaffiliatedExists = _.findIndex(account.departments, {
                departmentName: "Unaffiliated Projects"
            });

            if (unaffiliatedExists != -1) {
                account.departments[unaffiliatedExists].projects =
                    account.departments[unaffiliatedExists].projects.concat(newProjects);
            } else {
                let unaffiliatedDepartment = angular.copy(defaultDepartment);
                unaffiliatedDepartment.departmentName = "Unaffiliated Projects";
                unaffiliatedDepartment.departmentID = cloud.createIDString(12);
                unaffiliatedDepartment.projects = newProjects;

                let unaffiliatedGroupExists = account.groups.find(
                    (group) => group.groupName === user_info.company_name
                );

                if (unaffiliatedGroupExists) {
                    unaffiliatedGroupExists.departments.push(unaffiliatedDepartment.departmentID);
                } else {
                    account.groups[account.groups.length - 1].departments.push(unaffiliatedDepartment.departmentID);
                }

                account.departments.push(unaffiliatedDepartment);
            }

            let disabledExists = _.findIndex(account.departments, {
                departmentName: "Disabled Projects"
            });

            if (disabledExists === -1) {
                let disabledDepartment = angular.copy(defaultDepartment);
                disabledDepartment.departmentName = "Disabled Projects";
                disabledDepartment.departmentID = cloud.createIDString(12);

                let unaffiliatedGroupExists2 = account.groups.find(
                    (group) => group.groupName === user_info.company_name
                );

                if (unaffiliatedGroupExists2) {
                    unaffiliatedGroupExists2.departments.push(disabledDepartment.departmentID);
                } else {
                    account.groups[account.groups.length - 1].departments.push(disabledDepartment.departmentID);
                }

                account.departments.push(disabledDepartment);
            }

            account.departments = cloud.sortDepartments(account.departments);

            vm.newProjectsLoading = false;
        };

        vm.sortProjects = (departmentIndex) => {
            vm.account.departments[departmentIndex] &&
                vm.account.departments[departmentIndex].projects.sort(util.compare("projectID"));
        };

        vm.composeTotalBudget = (selectedProject) => {
            selectedProject.totalBudget = "$" + util.numberWithCommas(cloud.getTotalBudget([selectedProject]));
        };

        vm.formatCurrency = (budget, formattedField) => {
            budget[formattedField] = "$" + util.numberWithCommas(util.formatCurrencyAsNumber(budget[formattedField]));
        };

        $scope.$watch("vm.projectList", (newValue, oldValue) => {
            if (newValue !== oldValue) {
                if (vm.account && vm.bqProjects) {
                    vm.findNewProjects(vm.account);

                    if (vm.invoiceGroup) {
                        vm.matchProjectToInvoiceGroups(vm.account);
                    }
                }
            }
        });

        $scope.$watch("vm.account", (newValue, oldValue) => {
            if (newValue !== oldValue) {
                if (vm.projectList && vm.bqProjects) {
                    vm.findNewProjects(vm.account);

                    if (vm.invoiceGroup) {
                        vm.matchProjectToInvoiceGroups(vm.account);
                    }
                }
            }
        });

        $scope.$watch("vm.bqProjects", (newValue, oldValue) => {
            if (newValue !== oldValue) {
                if (vm.projectList && vm.account) {
                    vm.findNewProjects(vm.account);

                    if (vm.invoiceGroup) {
                        vm.matchProjectToInvoiceGroups(vm.account);
                    }
                }
            }
        });

        vm.getCurrentConsumptions = (reportParameters, type, allowance, depo) => {
            BCSServer.postData(reportParameters, "/big_query/get_query", (response) => {
                vm.depoTotal = {
                    subtotal: 0,
                    budgetPercent: 0
                };
                if (response && response.length > 0) {
                    let budget = util.formatCurrencyAsNumber(reportParameters.currentBudget.amount);

                    response.forEach((item) => {
                        let subtotal = item.subtotal;
                        item.subtotal = "$" + util.numberWithCommas(subtotal);
                        let budgetPerc = (subtotal / budget) * 100;
                        if (budgetPerc === Infinity) {
                            item.budgetPercent = "N/A";
                        } else {
                            item.budgetPercent = util.numberWithCommas((subtotal / budget) * 100) + "%";
                        }
                        vm.depoTotal.subtotal += subtotal;

                        allowance.actualSpend = item.subtotal;

                        if (
                            moment(reportParameters.parameters.dateRange.endDate).diff(moment(), "days") > -2 &&
                            allowance.state !== "Active" &&
                            allowance.state !== "Future"
                        ) {
                            allowance.actualSpend = allowance.actualSpend;
                        }
                    });

                    vm.depoTotal.budgetPercent = util.numberWithCommas((vm.depoTotal.subtotal / budget) * 100) + "%";
                    vm.depoTotal.subtotal = util.numberWithCommas(vm.depoTotal.subtotal);
                    if (depo) {
                        allowance.actualSpend = vm.depoTotal.subtotal;
                    }
                    if (allowance.state === "Active") {
                        vm.consumptions = response;
                        vm.accountTotalBudgetPercent = vm.depoTotal.budgetPercent;
                        vm.accountTotalSubtotal = vm.depoTotal.subtotal;
                    }
                } else {
                    allowance.actualSpend = "$0.00";
                    vm.consumptions = [];
                }
                vm[type + "Loading"] = false;
            });
        };

        vm.prepConsumptionParameters = (selectedProject, depo) => {
            vm.afterCreditsShow = false;

            if (!selectedProject) {
                return;
            }

            if (depo && selectedProject.projects && selectedProject.projects.length === 0) {
                vm.consumptionsLoading = false;
                return;
            }

            var activeAllowance, consumedAllowance;

            if (selectedProject.allowances && selectedProject.allowances.length > 0) {
                activeAllowance = selectedProject.allowances.find((allowance) => {
                    return allowance.state === "Active";
                });
                consumedAllowance = selectedProject.allowances.find((allowance) => {
                    return allowance.state === "Consumed";
                });
            }

            if (activeAllowance || consumedAllowance) {
                selectedProject.allowances.forEach((allowance, index) => {
                    if (!allowance) {
                        return;
                    }

                    let projects;
                    if (vm.selectedName === "Department") {
                        projects = cloud.getRawProjectArray(selectedProject.projects, "projectID");
                    } else {
                        projects = [selectedProject.projectID];
                    }

                    if (allowance.state === "Active" && allowance.dateActivated) {
                        allowance.actualSpend = "Calculating...";

                        vm.getCurrentConsumptions(
                            {
                                view: "project_cost_total_by_account",
                                currentBudget: allowance,
                                account: allowance.accountNum,
                                parameters: {
                                    projects: projects,
                                    dateRange: {
                                        startDate: moment(allowance.dateActivated).format("YYYY-MM-DD"),
                                        endDate: moment(new Date()).format("YYYY-MM-DD")
                                    }
                                }
                            },
                            "consumptions",
                            allowance,
                            depo
                        );
                    } else if (allowance.state === "Consumed") {
                        allowance.actualSpend = "Calculating...";

                        let endDate;

                        if (allowance.dateSuspended) {
                            endDate = allowance.dateSuspended;
                        } else if (
                            selectedProject.allowances[index + 1] &&
                            selectedProject.allowances[index + 1].dateActivated
                        ) {
                            endDate = selectedProject.allowances[index + 1].dateActivated;
                        } else {
                            endDate = new Date();
                        }

                        vm.getCurrentConsumptions(
                            {
                                view: "project_cost_total_by_account",
                                currentBudget: allowance,
                                account: allowance.accountNum,
                                parameters: {
                                    projects: projects,
                                    dateRange: {
                                        startDate: moment(allowance.dateActivated).format("YYYY-MM-DD"),
                                        endDate: moment(endDate).format("YYYY-MM-DD")
                                    }
                                }
                            },
                            "consumptions",
                            allowance,
                            depo
                        );
                    } else {
                        allowance.actualSpend = "$0.00";
                        vm.consumptionsLoading = false;
                    }
                });
            } else {
                vm.consumptionsLoading = false;
            }

            if (selectedProject.afterCredits === "Bill" && !activeAllowance) {
                let projects;
                if (vm.selectedName === "Department") {
                    projects = cloud.getRawProjectArray(selectedProject.projects, "projectID");
                } else {
                    projects = [selectedProject.projectID];
                }

                let latestAllowanceDate;

                selectedProject.allowances.forEach((allowance) => {
                    if (allowance.state === "Consumed") {
                        let latestType = allowance.dateSuspended || allowance.dateActivated;
                        latestAllowanceDate = moment(latestType).format("YYYY-MM-DD");
                    }
                });

                !latestAllowanceDate && (latestAllowanceDate = moment("2019-01-01").format("YYYY-MM-DD"));

                vm.afterCreditsSpend = {
                    actualSpend: 0
                };

                vm.afterCreditsShow = true;

                vm.afterCreditsSpend.actualSpend = "...Calculating...";

                vm.getCurrentConsumptions(
                    {
                        view: "project_cost_total_by_account",
                        currentBudget: {
                            amount: "$0.00"
                        },
                        account: vm.selectedProject.afterCreditsAccount,
                        parameters: {
                            projects: projects,
                            dateRange: {
                                startDate: latestAllowanceDate,
                                endDate: moment().format("YYYY-MM-DD")
                            }
                        }
                    },
                    "consumptions",
                    vm.afterCreditsSpend,
                    depo
                );
            }
        };

        vm.resetBatchSelect = (departmentIndex) => {
            vm.account.departments[departmentIndex].projects.forEach((prj) => {
                if (prj) {
                    prj.batchSelect = false;
                }
            });
            vm.batchForm = false;
        };

        vm.checkBatchedSelect = (departmentIndex) => {
            $timeout(() => {
                let batchForm = false;
                vm.account.departments[departmentIndex].projects.forEach((prj) => {
                    if (prj && prj.batchSelect) {
                        batchForm = true;
                    }
                });
                vm.batchForm = batchForm;

                if (vm.batchForm) {
                    vm.selectedProject = {
                        departmentName: vm.account.departments[departmentIndex].departmentName,
                        primaryContactEmail: "",
                        billingContactEmail: "",
                        contactList: [],
                        alerts: [
                            {
                                alertThreshold: "50",
                                enabled: true,
                                expired: false,
                                velocity: false
                            },
                            {
                                alertThreshold: "75",
                                enabled: true,
                                expired: false,
                                velocity: false
                            },
                            {
                                alertThreshold: "90",
                                enabled: true,
                                expired: false,
                                velocity: false
                            },
                            {
                                alertThreshold: "95",
                                enabled: true,
                                expired: false,
                                velocity: false
                            }
                        ]
                    };
                }
                return;
            }, 0);
        };

        vm.checkValidForm = (departmentIndex, projectIndex) => {
            /* eslint-disable */
            let isValid = document.forms["accountForm"].reportValidity();
            /* eslint-enable */
            if (!isValid) {
                $timeout(() => {
                    if (vm.account.departments[departmentIndex].projects[projectIndex]) {
                        vm.account.departments[departmentIndex].projects[projectIndex].batchSelect = false;
                    }
                }, 0);

                return false;
            } else {
                return true;
            }
        };

        // accordion open/close controller
        vm.closeAccordion = () => {
            vm.account.groups.forEach((group) => {
                group.isOpen = false;
            });
            vm.account.departments.forEach((department) => {
                department.isOpen = false;
            });
        };

        vm.chooseContent = function (
            groupIndex,
            departmentIndex,
            projectIndex,
            delayToggle,
            editDepartment,
            event,
            depoSwitch
        ) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (vm.departmentIndex !== departmentIndex && vm.account.departments[departmentIndex]) {
                vm.resetBatchSelect(departmentIndex);
            }

            let isValid = vm.checkValidForm(departmentIndex, projectIndex);

            if (!isValid) {
                return;
            }

            vm.consumptions = [];
            vm.depoTotal = {
                subtotal: 0,
                budgetPercent: 0
            };

            vm.closeAccordion();

            if (!editDepartment) {
                vm.checkBatchedSelect(departmentIndex);
                vm.selectedName = "Project";
                vm.selectedID = "projectID";

                !groupIndex && (groupIndex = 0);
                !departmentIndex && (departmentIndex = 0);
                !projectIndex && (projectIndex = 0);

                vm.account.groups[groupIndex].isOpen = true;
                vm.account.departments[departmentIndex].isOpen = true;

                vm.departmentIndex = departmentIndex;
                vm.projectIndex = projectIndex;
                vm.groupIndex = groupIndex;

                if (!depoSwitch) {
                    vm.revertDepartment =
                        vm.account.departments[departmentIndex].departmentName || vm.selectedDepartment;
                }

                vm.selectedDepartment = vm.account.departments[departmentIndex].departmentName;
                vm.originalDepartment = vm.selectedDepartment;
                vm.selectedProject = vm.account.departments[departmentIndex].projects[projectIndex];

                vm.applyProjectNameFromGCP(vm.selectedProject);

                if (!vm.selectedProject) {
                    vm.loading = false;
                    return;
                }

                vm.selectedProject && !vm.selectedProject.projectID
                    ? (vm.projectNeedsID = true)
                    : (vm.projectNeedsID = false);
                vm.consumptionsLoading = true;

                if (
                    vm.account.departments[departmentIndex] &&
                    vm.account.departments[departmentIndex].budgetType &&
                    vm.account.departments[departmentIndex].budgetType === "Budgeting"
                ) {
                    vm.depoBudgetProject = true;
                } else {
                    vm.depoBudgetProject = false;
                }

                vm.prepConsumptionParameters(vm.selectedProject);
                vm.switchFeed("selectedProject");

                vm.checkProjectIAM(vm.selectedProject.projectID);
            } else {
                vm.selectedID = "departmentName";
                vm.selectedName = "Department";
                vm.selectedProject = editDepartment;

                // if (departmentIndex == vm.departmentIndex) {
                //     vm.account.departments[departmentIndex].isOpen = false;
                // }
                vm.convertBillingContactToArray(vm.selectedProject);

                vm.departmentIndex = departmentIndex;
                vm.groupIndex = groupIndex;
                vm.depoBudgetProject = false;
                if (!vm.selectedProject.budgetType) {
                    vm.selectedProject.budgetType = "Reporting";
                }
                if (vm.selectedProject.budgetType === "Budgeting") {
                    vm.consumptionsLoading = true;
                    vm.prepConsumptionParameters(vm.selectedProject, "depo");
                    if (vm.selectedProject.projects && vm.selectedProject.projects.length > 0) {
                        vm.missingPermission = false;
                        vm.missingPermissionError = "";

                        const projectIDs = vm.selectedProject.projects.map((prj) => prj.projectID);
                        vm.checkProjectsIAM(projectIDs);
                    }
                }
            }

            vm.selectedProject && !vm.selectedProject.recurringBudget && (vm.selectedProject.recurringBudget = false);

            if (!vm.selectedProject.allowances) {
                vm.selectedProject.allowances = [];
            }

            if (!vm.selectedProject.activity) {
                vm.selectedProject.activity = [];
            }

            if (!vm.selectedProject.afterCredits) {
                vm.selectedProject.afterCredits = "Bill";
                if (!vm.selectedProject.afterCreditsAccount) {
                    vm.selectedProject.afterCreditsAccount = vm.selectedProject.paidBillingAccounts;
                }
            }

            cloud.convertDates(vm.selectedProject.allowances);
            cloud.convertActivityDates(vm.selectedProject.activity);

            vm.budgetItemLength = vm.selectedProject.allowances.length;
            vm.dateToggle = new Array(vm.budgetItemLength).fill(false);
            vm.dateActiveToggle = new Array(vm.budgetItemLength).fill(false);

            vm.composeTotalBudget(vm.selectedProject);

            vm.activityFeed = vm.selectedProject.activity;

            vm.selectedProjectOriginal = angular.copy(vm.selectedProject);

            if (delayToggle) {
                $timeout(() => {
                    angular.element(".sku-title").removeClass("toggle-border");
                    angular
                        .element("#" + groupIndex.toString() + departmentIndex.toString() + projectIndex.toString())
                        .addClass("toggle-border");
                }, 100);
            } else if (!editDepartment) {
                angular.element(".sku-title").removeClass("toggle-border");
                angular
                    .element("#" + groupIndex.toString() + departmentIndex.toString() + projectIndex.toString())
                    .addClass("toggle-border");
            } else {
                angular.element(".sku-title").removeClass("toggle-border");
            }

            $timeout(() => {
                $scope.$broadcast("rzSliderForceRender");
            });
        };

        // conversion method from legacy billing contact type string to array
        vm.convertBillingContactToArray = (department) => {
            if (!department.billingContactEmail) {
                department.billingContactEmail = [];
            } else if (angular.isString(department.billingContactEmail)) {
                department.billingContactEmail = [department.billingContactEmail];
            }
            return;
        };

        // if project names from gcp are found, apply them to the database project
        vm.applyProjectNameFromGCP = (selectedProject) => {
            if (selectedProject && !selectedProject.project && vm.projectNames) {
                selectedProject.project = vm.projectNames[selectedProject.projectID];
            }
        };

        vm.batchApply = (projects) => {
            projects.forEach((project) => {
                if (project.batchSelect) {
                    project.aka = vm.selectedProject.aka;
                    project.primaryContactEmail = vm.selectedProject.primaryContactEmail;
                    project.billingContactEmail = vm.selectedProject.billingContactEmail;
                    project.contactList = vm.selectedProject.contactList;
                    project.alerts = vm.selectedProject.alerts;
                }
            });
        };

        vm.batchUpdate = () => {
            let targetDepartment = vm.account.departments.find((depo) => {
                return depo.departmentName === vm.selectedDepartment;
            });

            let currentDepartment = vm.account.departments.find((depo) => {
                return depo.departmentName === vm.originalDepartment;
            });

            if (
                (targetDepartment && targetDepartment.budgetType === "Budgeting") ||
                (currentDepartment && currentDepartment.budgetType === "Budgeting")
            ) {
                alert(
                    'Batch department switching is not allowed when the origin/target department is of type: "Budgeting"'
                );
                return;
            }
            let originalProjects = angular.copy(vm.account.departments[vm.departmentIndex].projects);
            vm.batchApply(vm.account.departments[vm.departmentIndex].projects);
            vm.updateBatchActivity(vm.account.departments[vm.departmentIndex].projects, originalProjects);
            vm.batchSwitchDepartments(vm.selectedDepartment);
            vm.resetBatchSelect(vm.departmentIndex);
            vm.update(vm.account);
        };

        vm.updateBatchActivity = (projects, originalProjects) => {
            projects.forEach((project, index) => {
                vm.composeActivity(project, originalProjects[index]);
            });
        };

        vm.checkUnaffiliatedName = (depo) => {
            if (!depo || !depo.departmentName) {
                return;
            }
            if (!depo.unaffiliated && depo.departmentName.includes("Unaffiliated")) {
                return true;
            }
        };

        vm.update = (account) => {
            vm.loading = true;

            const unaffiliatedNameOverwrite = vm.checkUnaffiliatedName(vm.selectedProject);

            if (unaffiliatedNameOverwrite) {
                vm.loading = false;
                vm.createAlertMessage({
                    type: "alerts",
                    msg: "Department/Project Name cannot contain reserved word - 'Unaffiliated'",
                    status: "fail",
                    permanent: false
                });
                return;
            }

            vm.updateUserDatabase();

            account.departments.forEach((item, index) => {
                vm.sortProjects(index);
            });
        };

        vm.openCalendar = (e, picker, type) => {
            e.preventDefault();
            e.stopPropagation();
            vm[type][picker] = true;
        };

        let defaultDepartment = {
            departmentName: "",
            contactList: [],
            alertThreshold: 90,
            alerts: [],
            allowances: [],
            totalBudget: 0,
            afterCredits: null,
            afterCreditsAccount: null,
            paidBillingAccounts: null,
            budgetType: "Reporting",
            activity: [],
            projects: []
        };

        vm.newDepartment = (event, groupIndex) => {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            let newDepartment = angular.copy(defaultDepartment);
            newDepartment.departmentID = cloud.createIDString(12);

            let insertIndex = vm.account.departments.length - 2;
            vm.account.departments.splice(insertIndex, 0, newDepartment);
            vm.groupDepartments.push(newDepartment);

            vm.newDepartmentGroup = {
                groupIndex: groupIndex
            };

            vm.chooseContent(
                groupIndex,
                vm.account.departments.length - 3,
                false,
                false,
                vm.account.departments[vm.account.departments.length - 3]
            );
        };

        vm.userPreferences = (user) => {
            let modalInst = $uibModal.open({
                resolve: {
                    user: () => {
                        return user;
                    },
                    disabled: () => {
                        return vm.disabled;
                    }
                },
                templateUrl: "app/cloudbilling/singleUser.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "UserAdminController",
                size: "lg",
                controllerAs: "vm"
            });
            modalInst.result.then((user) => {
                if (user.delete) {
                    let index = _.findIndex(vm.selectedProject.contactList, {
                        email: user.email
                    });
                    vm.selectedProject.contactList.splice(index, 1);
                }
                user.update && vm.update(vm.account);
                user.update = false;
                user.delete = false;
            });
        };

        let defaultAlerts = [
            {
                alertThreshold: "50",
                enabled: true,
                expired: false,
                velocity: false
            },
            {
                alertThreshold: "75",
                enabled: true,
                expired: false,
                velocity: false
            },
            {
                alertThreshold: "90",
                enabled: true,
                expired: false,
                velocity: false
            },
            {
                alertThreshold: "95",
                enabled: true,
                expired: false,
                velocity: false
            }
        ];

        vm.newProject = (event, departmentIndex, groupIndex) => {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            vm.account.departments[departmentIndex].projects.push({
                company: user_info.company,
                project: "",
                projectID: "",
                allowances: [],
                totalBudget: "",
                afterCredits: "",
                paidBillingAccounts: "",
                aka: "",
                primaryContactEmail: "",
                piEmail: "",
                billingContactEmail: "",
                contactList: [],
                alerts: defaultAlerts,
                activity: []
            });
            vm.chooseContent(groupIndex, departmentIndex, vm.account.departments[departmentIndex].projects.length - 1);
        };

        vm.applyNextBudget = (nextIndex) => {
            vm.selectedProject.allowances.forEach((allowance, index) => {
                if (index != nextIndex) {
                    allowance.next = "false";
                } else {
                    allowance.next = "true";
                }
            });
        };



        vm.defaultItems = {
            allowances: {
                type: "",
                poNumber: "",
                amount: "",
                dateActivated: "",
                dateIssued: "",
                dateSuspended: "",
                expirationDate: "",
                state: "",
                next: ""
            },
            alerts: {
                alertThreshold: "90",
                enabled: true,
                expired: false,
                triggered: ""
            },
            accounts: {
                account: "",
                type: ""
            }
        };

        vm.editGroups = (event, account, groupIndex) => {
            event.preventDefault();
            event.stopPropagation();
            let originalCompany = angular.copy(account);
            if (!vm.company.companyName) {
                vm.company.companyName = user_info.company_name;
            }
            let modalInst = $uibModal.open({
                resolve: {
                    account: () => {
                        return account;
                    },
                    company: () => {
                        return vm.company;
                    },
                    groupIndex: () => {
                        return groupIndex;
                    }
                },
                templateUrl: "app/cloudbilling/budget/groupConfig.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "GroupConfigController",
                controllerAs: "vm"
            });
            modalInst.result.then(
                () => {
                    vm.loading = true;
                    vm.utilizedDepartments = cloud.composeAvailableDepartments(vm.account.groups);
                    vm.applyUnaffiliatedDepartments(vm.company, vm.account);
                    vm.updateUserDatabase("reload");
                },
                () => {
                    //if user clicks outside to cancel modal, revert to original depo
                    angular.copy(originalCompany, vm.account);
                }
            );
        };

        vm.addItem = (level, itemType) => {
            let itemToAdd = angular.copy(vm.defaultItems[itemType]);
            if (vm.selectedProject.recurringBudget) {
                itemToAdd.recurring = true;
            }
            if (vm[level][itemType] && vm[level][itemType].length > 0) {
                vm[level][itemType].push(itemToAdd);
            } else {
                vm[level][itemType] = [itemToAdd];
            }
            vm.checkNext(vm.selectedProject);
        };

        vm.removeItem = (level, itemType, budgetIndex) => {
            let prompt = confirm("Are you sure you wish to delete this item?");
            if (!prompt) {
                return;
            }
            vm[level][itemType].splice(budgetIndex, 1);
            vm.checkNext(vm.selectedProject);
        };

        vm.batchDelete = () => {
            let prompt = confirm("Are you sure you wish to delete these projects?");
            if (!prompt) {
                return;
            }
            let batchDepartment = vm.account.departments[vm.departmentIndex];
            for (let i = batchDepartment.projects.length - 1; i >= 0; i--) {
                if (batchDepartment.projects[i].batchSelect) {
                    batchDepartment.projects.splice(i, 1);
                }
            }
            vm.update(vm.account);
        };

        vm.deleteProject = () => {
            let prompt = confirm("Are you sure you wish to delete this project?");
            if (!prompt) {
                return;
            }

            vm.account.departments[vm.departmentIndex].projects.splice(vm.projectIndex, 1);
            vm.update(vm.account);
            // vm.chooseContent(0, 0);
        };

        vm.deleteDepartment = () => {
            let prompt = confirm(
                'Are you sure you wish to delete this department?  If deleted, all nested projects will be moved to "Unaffiliated Projects" department.'
            );
            if (!prompt) {
                return;
            }

            vm.account.departments[vm.departmentIndex].projects = vm.account.departments[
                vm.departmentIndex
            ].projects.concat(vm.account.departments[vm.account.departments.length - 1].projects);

            vm.account.departments.splice(vm.departmentIndex, 1);

            let depoGroupIndex = vm.account.groups[vm.groupIndex].departments.indexOf(vm.selectedProject.departmentID);
            if (depoGroupIndex !== -1) {
                vm.account.groups[vm.groupIndex].departments.splice(depoGroupIndex, 1);
            }

            vm.update(vm.account);
            vm.chooseContent(vm.groupIndex, 0, 0);
        };

        vm.suspendWarning = () => {
            $uibModal.open({
                templateUrl: "app/shared/html/notice.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ConfirmationController",
                controllerAs: "vm",
                resolve: {
                    message: () => {
                        return {
                            heading: "Suspension Warning",
                            message:
                                "Setting this project to suspend after all budgets consumed. Data retention will last 30 days unless a new billing account is connected. After 30 days all data will be permanently lost."
                        };
                    }
                }
            });
        };

        vm.checkNext = (selectedProject) => {
            let futureIndexes = [];
            selectedProject.allowances.forEach((allowance, index) => {
                allowance.state === "Future" && futureIndexes.push(index);
            });
            futureIndexes.length === 1 && (selectedProject.allowances[futureIndexes[0]].next = "true");
        };

        vm.resetAlerts = () => {
            vm.selectedProject.alerts.forEach((alerts) => {
                alerts.expired = false;
            });
        };

        let deepDiffMapper = cloud.deepDiffMapper();

        let activityFormat = {
            company: "Company",
            project: "Project",
            projectID: "Project ID",
            departmentName: "Department",
            budgetType: "Department Type",
            afterCreditsAccount: "After Budget Account",
            groups: "Group",
            groupName: "Group Name",
            departments: "Departments",
            projects: "Projects",
            allowances: "Allowance",
            tag: "Tag",
            afterCredits: "After Budget",
            paidBillingAccounts: "Billing Accounts",
            totalBudget: "Total Budget",
            monthlyBudget: "Monthly Budget",
            aka: "Project Description",
            primaryContactEmail: "Primary Contact Email",
            billingContactEmail: "Billing Contact Email",
            contactList: "Project User",
            alertThreshold: "Alert Threshold",
            alerts: "Alert",
            afterCreditsPO: "After Budget PO",
            recurringBudget: "Recurring Monthly Budget"
        };

        vm.composeActivity = (selectedProject, selectedProjectOriginal) => {
            let hasChanged = false;

            if (!selectedProject) {
                return false;
            }

            if (!selectedProject.activity) {
                selectedProject.activity = [];
            }

            if (selectedProject.comments) {
                let commentActvity = {
                    user: user_info.u_name_id,
                    type: "Note",
                    value: selectedProject.comments,
                    date: moment().format("MMM DD YYYY h:mm A"),
                    project: selectedProject.projectID || "",
                    department: selectedProject.departmentName || ""
                };

                selectedProject.activity.push(commentActvity);
                vm.account.activity.push(commentActvity);
            }

            selectedProject.comments = "";

            let originalObject = angular.copy(selectedProjectOriginal);
            delete originalObject.projects;

            let currentObject = angular.copy(selectedProject);
            delete currentObject.projects;

            let changeMap = deepDiffMapper.map(currentObject, originalObject);
            let projectChanges = vm.checkProjectChanges(changeMap);

            hasChanged = vm.composeChangeActivity(projectChanges, selectedProject);

            return hasChanged;
        };

        vm.composeChangeActivity = (projectChanges, selectedProject) => {
            let sendChanges = [];
            projectChanges.forEach((change) => {
                let changeStatus = {
                    user: user_info.u_name_id,
                    type: "Change",
                    date: moment().format("MMM DD YYYY h:mm A"),
                    project: selectedProject.projectID || "",
                    department: selectedProject.departmentName || ""
                };

                let changeTo;

                if (angular.isObject(change.to)) {
                    changeTo = change.to.email || change.to.accountNum || change.to.alertThreshold;
                } else {
                    changeTo = change.to;
                }

                !changeTo && (changeTo = "false");
                !change.from && (change.from = "false");

                let activityFormatPrefix = activityFormat[change.parent];
                if(change.grandChildField) {
                    activityFormatPrefix += ` ${activityFormat[change.grandChildField]}`
                }

                switch (change.status) {
                    case "created":
                        changeStatus.value = activityFormatPrefix + " Created:   " + changeTo;
                        break;
                    case "updated":
                        changeStatus.value =
                            activityFormatPrefix + " Changed From:   " + change.from + ",   To:   " + changeTo;
                        break;
                    case "deleted":
                        changeStatus.value = activityFormatPrefix + " Deleted:   " + changeTo;
                        break;
                    default:
                        break;
                }
                if (!changeStatus.value.includes("Calculating")) {
                    selectedProject.activity.push(changeStatus);
                    vm.account.activity.push(changeStatus);
                    sendChanges.push(changeStatus);
                }
            });
            return sendChanges;
        };

        vm.checkProjectChanges = (changeMap) => {
            let projectChanges = [];
            for (var field in changeMap) {
                
                if (field !== "comments" && field !== "$$hashKey" && field !== "activity") {
                    
                    if (changeMap[field] && changeMap[field][0]) {
                        for (var childField in changeMap[field]) {
                            if (
                                childField !== "dateActivated" &&
                                childField !== "dateIssued" &&
                                childField !== "dateSuspended" &&
                                childField !== "expirationDate" 
                            ) {
                                let child = changeMap[field][childField];
                                if (!child.status) {
                                    for (var grandchildField in child) {
                                        if (
                                            grandchildField !== "dateActivated" &&
                                            grandchildField !== "dateIssued" &&
                                            childField !== "dateSuspended" &&
                                            childField !== "expirationDate"
                                        ) {
                                            
                                            let grandChild = child[grandchildField];
                                            if (grandChild.status && grandChild.status !== "unchanged") {
                                                grandChild.parent = field;
                                                grandChild.grandChildField = grandchildField;
                                                projectChanges.push(grandChild);
                                            }
                                        }
                                    }
                                } else {
                                    if (child.status && child.status !== "unchanged") {
                                        child.parent = field;
                                        projectChanges.push(child);
                                    }
                                }
                            }
                        }
                    } else {
                        if (changeMap[field] && changeMap[field].status && changeMap[field].status !== "unchanged") {
                            changeMap[field].parent = field;
                            projectChanges.push(changeMap[field]);
                        }
                    }
                }
            }
            return projectChanges;
        };

        vm.switchFeed = (feed) => {
            vm.tableLoading = true;
            $timeout(() => {
                vm.tableLoading = false;
                vm.selectedFeed = feed;
                vm[feed] ? (vm.activityFeed = vm[feed].activity) : (vm[feed] = []);
            }, 100);
        };

        vm.applyExpiration = (account, fundingType) => {
            let foundPO = vm.pos.find((po) => {
                return po.value === account[fundingType];
            });
            if (foundPO && foundPO.data && foundPO.data.type === "strides") {
                account.expirationDate = moment(foundPO.data.expirationDate).utc();
            }
        };

        vm.projectStatus = (project) => {
            let statusColor = "white";
            if (vm.user_info.company_code === "UNIAME") {
                statusColor = "white";
                return statusColor;
            }
            if (vm.projectList) {
                let projectFound = vm.projectList.find((prj) => {
                    return prj.project_id === project.projectID;
                });
                if (projectFound) {
                    statusColor = "white";
                } else {
                    return "rgb(255 95 95)";
                }
            }
            if (vm.bqProjects) {
                let bqProjectFound = vm.bqProjects.find((prj) => {
                    return prj.project_id === project.projectID;
                });
                if (!bqProjectFound) {
                    if (
                        vm.projectList &&
                        !vm.projectList.find((prj) => {
                            return prj.project_id === project.projectID;
                        })
                    ) {
                        statusColor = "rgb(255 95 95)";
                    } else {
                        statusColor = "rgb(255 197 66)";
                    }
                } else {
                    statusColor = "white";
                }
            }
            return statusColor;
        };

        vm.mapBudgetTypes = () => {
            vm.account.departments.forEach((depo) => {
                if (depo && depo.allowances && depo.allowances.length > 0) {
                    depo.allowances.forEach((depoAllow) => {
                        if (depoAllow && depoAllow.accountNum && (!depoAllow.type || depoAllow.type === "")) {
                            depoAllow.type = cloud.alignBudgetType(vm.company.accounts, depoAllow.accountNum);
                        }
                    });
                }
                if (depo && depo.projects && depo.projects.length > 0) {
                    depo.projects.forEach((prj) => {
                        if (prj && prj.allowances && prj.allowances.length > 0) {
                            prj.allowances.forEach((prjAllow) => {
                                if (prjAllow && prjAllow.accountNum && (!prjAllow.type || prjAllow.type === "")) {
                                    prjAllow.type = cloud.alignBudgetType(vm.company.accounts, prjAllow.accountNum);
                                }
                            });
                        }
                    });
                }
            });
        };

        vm.updateUserDatabase = (reload) => {
            delete vm.account._id;
            delete vm.account.__v;

            if (vm.selectedProject && vm.selectedProject.allowances && vm.selectedProject.allowances.length > 0) {
                vm.resetAlerts();
            }

            if (vm.newDepartmentGroup) {
                vm.account.groups[vm.newDepartmentGroup.groupIndex].departments.push(vm.selectedProject.departmentID);
                vm.newDepartmentGroup = false;
            }

            vm.account.departments = cloud.sortDepartments(vm.account.departments);

            vm.mapBudgetTypes();

            vm.selectedProject && vm.composeActivity(vm.selectedProject, vm.selectedProjectOriginal);

            let dumpData = angular.copy(vm.account);
            cloud.convertDatesUTC(dumpData);
            let accountQueryUpdate = {
                company: user_info.company,
                method: "post",
                account: dumpData
            };

            BCSServer.postData(accountQueryUpdate, "/cloud_budgets", (response) => {
                console.log(response);
                vm.loading = false;
                if(response.error) {
                    vm.createAlertMessage({
                        type: "alerts",
                        msg: `Failed To Update Project Mapping. ${angular.toString(response.message)}`,
                        status: "fail",
                        permanent: false
                    });
                    return;
                }

                if (response && response._id) {
                    vm.createAlertMessage({
                        type: "alerts",
                        msg: "Successfully Updated Project Mapping",
                        status: "success",
                        permanent: false
                    });

                    vm.structureGroups();

                    if (reload) {
                        vm.fetchProjectMap();
                        return;
                    }

                    if (vm.selectedName === "Project") {
                        vm.chooseContent(vm.groupIndex, vm.departmentIndex, vm.projectIndex);
                    } else {
                        vm.chooseContent(vm.groupIndex, vm.departmentIndex, false, false, vm.selectedProject);
                    }
                } else {
                    let error = response.error || "";
                    vm.createAlertMessage({
                        type: "alerts",
                        msg: `Failed To Update Project Mapping. ${angular.toString(error)}`,
                        status: "fail",
                        permanent: false
                    });
                }
            });
        };

        vm.openProjectUsers = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "CloudContactController",
                controllerAs: "vm"
            });
            modalInst.result.then((email) => {
                let foundUser = util.findItem(email, vm.selectedProject.contactList, "email");
                if (email && !foundUser) {
                    !vm.selectedProject.contactList && (vm.selectedProject.contactList = []);
                    vm.selectedProject.contactList.push({
                        email: email,
                        weeklySummary: true,
                        alerts: true
                    });
                }
            });
        };

        vm.openProjectUsers = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "CloudContactController",
                controllerAs: "vm"
            });
            modalInst.result.then((email) => {
                let foundUser = util.findItem(email, vm.selectedProject.contactList, "email");
                if (email && !foundUser) {
                    !vm.selectedProject.contactList && (vm.selectedProject.contactList = []);
                    vm.selectedProject.contactList.push({
                        email: email,
                        weeklySummary: true,
                        alerts: true
                    });
                }
            });
        };

        vm.close_notice = (type, index) => {
            vm[type].splice(index, 1);
        };

        vm.switch_watchlist = () => {
            vm.projectUsersShow = !vm.projectUsersShow;
        };

        vm.delete_watchlist = (index) => {
            angular.element(".watch-list-select option:focus").remove();
            vm.selectedProject.contactList.splice(index, 1);
        };

        vm.addProjectUserEmail = (userEmail) => {
            if (userEmail == null || userEmail == "") {
                return;
            }
            vm.addProjectUser(userEmail);
        };

        vm.addProjectUser = (userEmail) => {
            if (vm.selectedProject.contactList.length > 0) {
                vm.selectedProject.contactList.push({
                    email: userEmail,
                    weeklySummary: true,
                    alerts: true
                });
            } else {
                vm.selectedProject.contactList = [
                    {
                        email: userEmail,
                        weeklySummary: true,
                        alerts: true
                    }
                ];
            }
            vm.projectUsersEmail = null;
        };

        vm.addBillingContact = () => {
            if (!vm.selectedProject.billingContactEmail) {
                vm.selectedProject.billingContactEmail = [];
            }
            vm.selectedProject.billingContactEmail.push("");
        };

        vm.removeBillingContact = (index) => {
            vm.selectedProject.billingContactEmail.splice(index, 1);
        };

        let columnFilter = {
            aoColumns: [
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                }
            ]
        };

        vm.setupDatableButtons = () => {
            //button export configurations
            return [
                {
                    extend: "colvis",
                    text: "Toggle Columns"
                },
                {
                    extend: "collection",
                    text: "Export",
                    buttons: [
                        {
                            extend: "excel",
                            title: () => {
                                return "Activity";
                            },
                            filename: () => {
                                return "Activity";
                            },
                            exportOptions: {
                                columns: ":not(.nosort)"
                            }
                        },
                        {
                            extend: "pdf",
                            title: () => {
                                return "Activity";
                            },
                            filename: () => {
                                return "Activity";
                            },
                            customize: (doc) => {
                                doc.pageMargins = [5, 5, 5, 5];
                                doc.styles.tableHeader.fontSize = 10;
                                doc.defaultStyle.fontSize = 6;
                            },
                            exportOptions: {
                                columns: ":not(.nosort)"
                            }
                        },
                        {
                            extend: "csv",
                            title: () => {
                                return "Activity";
                            },
                            filename: () => {
                                return "Activity";
                            },
                            exportOptions: {
                                columns: ":not(.nosort)"
                            }
                        }
                    ]
                }
            ];
        };

        vm.dtActivityOptions = DTOptionsBuilder.newOptions()
            .withOption("order", [["3", "des"]])
            .withColumnFilter(columnFilter)
            .withButtons(vm.setupDatableButtons())
            .withOption("responsive", true);
        vm.dtColumnDefsActivity = [
            DTColumnDefBuilder.newColumnDef(3).withOption("type", "date"),
            DTColumnDefBuilder.newColumnDef([2]).withClass("max-size-activity"),
            DTColumnDefBuilder.newColumnDef([0, 1, 3]).withClass("vert-align-activity")
        ];
    }
})();

(function () {
    angular.module("burWood").controller("GroupConfigController", GroupConfigController);

    /** @ngInject */
    function GroupConfigController(
        _,
        user_info,
        $uibModalInstance,
        account,
        company,
        groupIndex,
        cloud,
        util,
        $uibModal,
        $timeout,
        Alerts,
        $state
    ) {
        let vm = this;
        vm.alerts = [];
        vm.user_info = user_info;

        // checking if user is admin
        if (vm.user_info.group) {
            if (vm.user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") != -1) {
                vm.burwoodAdmin = true;
            }
        }

        let originalAccount = angular.copy(account);

        vm.account = account;
        vm.company = company;

        vm.pos = vm.company.pos ? cloud.createPOList(vm.company.pos) : [];

        vm.groupInvoicing = vm.company.invoicingRole === "group";
        vm.groupIndexes = groupIndex || groupIndex === 0 ? [groupIndex] : vm.account.groups.map((i, index) => index);

        if (vm.groupInvoicing && vm.burwoodAdmin) {
            vm.disabled = false;
        } else if (vm.groupInvoicing && !vm.burwoodAdmin) {
            vm.disabled = true;
        } else {
            vm.disabled = false;
        }

        const composeGroupIndexes = (groupIndex, groups) => {
            return groupIndex || groupIndex === 0 ? [groupIndex] : groups.map((i, index) => index);
        };

        vm.groupIndexes = composeGroupIndexes(groupIndex, vm.account.groups);

        vm.removeDeletedDepartments = (groups, departments) => {
            groups.forEach((group) => {
                for (let i = group.departments.length - 1; i >= 0; i--) {
                    let foundDepartment = departments.find((depo) => {
                        return depo.departmentID === group.departments[i];
                    });
                    if (!foundDepartment) {
                        group.departments.splice(i, 1);
                    }
                }
            });
        };

        vm.removeDeletedDepartments(vm.account.groups, vm.account.departments);

        vm.departments = vm.account.departments
            .map((depo) => {
                if (depo.departmentName !== "Unaffiliated Projects" && depo.departmentName !== "Disabled Projects") {
                    return depo;
                }
            })
            .filter((depo) => {
                return depo;
            });

        let unaffiliatedGroup = vm.account.groups.find((group) => {
            return group.groupName === vm.company.companyName;
        });

        vm.checkDepartmentAllocation = (department, index, parentIndex, originalDepartment) => {
            if (unaffiliatedGroup && unaffiliatedGroup.departments) {
                let depoIndex = unaffiliatedGroup.departments.indexOf(department);
                if (depoIndex !== -1) {
                    vm.switchGroups(unaffiliatedGroup, department, parentIndex, depoIndex, index);
                } else {
                    let depoName = vm.departments.find((depo) => {
                        return depo.departmentID === department;
                    });
                    vm.account.groups[parentIndex].departments[index] = originalDepartment;
                    vm.createAlertMessage({
                        status: "fail",
                        msg:
                            depoName.departmentName +
                            " department is assigned to another group.  Departments may belong to only one group at a time."
                    });
                    return;
                }
            }
        };

        vm.checkAccountAllocation = (account, index, parentIndex, originalAccount) => {
            let foundAccount = vm.findUsedAccount(account, parentIndex);
            if (!foundAccount) {
                return;
            } else {
                vm.account.groups[parentIndex].billingAccounts[index] = originalAccount;
                vm.createAlertMessage({
                    status: "fail",
                    msg: "Billing Account is assigned to another group. Each billing account may be assigned to only one group at a time."
                });
                return;
            }
        };

        vm.findUsedAccount = (account, parentIndex) => {
            let foundAccount = false;
            vm.account.groups.forEach((group, index) => {
                if (index !== parentIndex && group.billingAccounts && group.billingAccounts.includes(account)) {
                    foundAccount = true;
                }
            });
            return foundAccount;
        };

        vm.customDepartment = (departmentID) => {
            if (departmentID === "") {
                return true; //new depo
            }
            let foundDepartment = vm.account.departments.find((depo) => {
                return depo.departmentID === departmentID;
            });
            if (
                foundDepartment &&
                foundDepartment.departmentName !== "Unaffiliated Projects" &&
                foundDepartment.departmentName !== "Disabled Projects"
            ) {
                return true;
            } else {
                return false;
            }
        };

        vm.switchGroups = (unaffiliatedGroup, department, parentIndex, depoIndex, index) => {
            unaffiliatedGroup.departments.splice(depoIndex, 1);
            vm.account.groups[parentIndex].departments[index] = department;
        };

        vm.addItem = (parentIndex, field) => {
            if (!vm.account.groups[parentIndex][field]) {
                vm.account.groups[parentIndex][field] = [""];
            } else {
                vm.account.groups[parentIndex][field].unshift("");
            }
        };

        vm.removeItem = (parentIndex, contactIndex, field) => {
            console.log("vm.account.groups[parentIndex][field].length",vm.account.groups[parentIndex][field].length)
            if(vm.account.groups[parentIndex][field].length === 1){
                return 
            }
            vm.account.groups[parentIndex][field].splice(contactIndex, 1);
                return 
        };

        let defaultItems = {
            groupName: "",
            contactList: [],
            billingContactEmail: [""],
            departments: []
        };

        vm.openProjectUsers = ($index) => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "CloudContactController",
                controllerAs: "vm"
            });
            modalInst.result.then((email) => {
                let foundUser = util.findItem(email, vm.account.groups[$index].contactList, "email");
                if (email && !foundUser) {
                    vm.account.groups[$index].contactList.push({
                        email: email,
                        weeklySummary: true,
                        alerts: true
                    });
                }
            });
        };

        vm.userPreferences = (user, $index) => {
            let modalInst = $uibModal.open({
                resolve: {
                    user: () => {
                        return user;
                    },
                    disabled: () => {
                        return vm.disabled;
                    }
                },
                templateUrl: "app/cloudbilling/singleUser.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "UserAdminController",
                size: "lg",
                controllerAs: "vm"
            });
            modalInst.result.then((user) => {
                if (user.delete) {
                    let index = _.findIndex(vm.account.groups[$index].contactList, {
                        email: user.email
                    });
                    vm.account.groups[$index].contactList.splice(index, 1);
                }
                user.update = false;
                user.delete = false;
            });
        };

        vm.delete_watchlist = (index, groupIndex) => {
            vm.account.groups[groupIndex].contactList.splice(index, 1);
        };

        vm.addGroup = () => {
            vm.account.groups.unshift(angular.copy(defaultItems));
            vm.groupIndexes = composeGroupIndexes(groupIndex, vm.account.groups);
            cloud.assignIDs(vm.account.groups, "groupID");
        };

        vm.removeGroup = (index) => {
            let removeDepartments = vm.account.groups[index].departments;
            vm.account.groups.splice(index, 1);
            vm.groupIndexes = composeGroupIndexes(groupIndex, vm.account.groups);
            unaffiliatedGroup.departments = unaffiliatedGroup.departments.concat(removeDepartments);
        };

        vm.addDepartment = ($index) => {
            vm.account.groups[$index].departments.push("");
        };

        vm.removeDepartment = ($index, groupIndex) => {
            vm.account.groups[groupIndex].departments.splice($index, 1);
        };

        vm.focusPOs = () => {
            angular.element(".budget-suggestions").removeClass("autocomplete-suggestions");
        };

        vm.allNewPOs = (currentPO, allPOs) => {
            if (!allPOs) {
                allPOs = [];
            }
            if (!allPOs.includes(currentPO)) {
                allPOs.push(currentPO);
            }
            return allPOs;
        };

        vm.applyHistoricalPOs = (groups) => {
            groups.forEach((group) => {
                group.invoicePOs = vm.allNewPOs(group.invoicePO, group.invoicePOs);
            });
            return groups;
        };

        vm.createAlertMessage = (alert) => {
            vm.alerts.push({
                status: alert.status,
                msg: alert.msg
            });
            Alerts.storeAlert({
                type: alert.status,
                message: alert.msg,
                user: user_info.email,
                company: user_info.company_name,
                location: $state.current.name,
                tags: ["Cloud Group Configuration"]
            });
            $timeout(() => {
                vm.alerts = [];
            }, 5000);
        };

        vm.close_notice = (index) => {
            vm.alerts.splice(index, 1);
        };

        vm.close = () => {
            if (vm.groupInvoicing) {
                vm.account.groups = vm.applyHistoricalPOs(vm.account.groups);
            }
            vm.company.budgets = vm.account;
            $uibModalInstance.close(vm.company);
        };

        vm.cancel = () => {
            angular.copy(originalAccount, vm.account);
            $uibModalInstance.dismiss("cancel");
        };
    }
})();

(function () {
    angular.module("burWood").controller("SessionController", SessionController);

    /** @ngInject */
    function SessionController($uibModalInstance, $state) {
        let vm = this;
        vm.heading = "Session Ending In 60 Seconds";
        vm.message = "Would you like to continue your active session?";
        vm.confirmMessage = "Yes";
        vm.denyMessage = "No";

        vm.confirm = () => {
            $uibModalInstance.close();
        };

        vm.deny = () => {
            $state.go("logout");
            $uibModalInstance.close();
        };
    }
})();

(function () {
    angular.module("burWood").controller("NotificationController", NotificationController);

    /** @ngInject */
    function NotificationController(user_info, DTOptionsBuilder, $uibModalInstance, Navbar, $log) {
        let vm = this;
        vm.loading = true;
        vm.tabView = "setting";
        //regex pattern for schedule hours input
        vm.pattern = /^(2[0-4]|1[0-9]|[6-9])$/;
        vm.errorArray = new Array(28);
        //table options
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption("responsive", true)
            .withOption("bLengthChange", false)
            .withOption("scrollY", "400px")
            .withOption("scrollCollapse", true)
            .withOption("searching", false)
            .withOption("paging", false);

        //get available service providers in SNOW
        Navbar.getServiceProviders((data) => {
            data = data.results;
            data.forEach((item) => {
                vm.service_providers.push(item.name);
            });
        });

        //setting up variables for handling notification management
        function Day(num) {
            this.active = false;
            this.id = num;
            this.begin1 = "";
            this.begin2 = "";
            this.end1 = "";
            this.end2 = "";
        }

        vm.day = {
            monday: new Day("1"),
            tuesday: new Day("2"),
            wednesday: new Day("3"),
            thursday: new Day("4"),
            friday: new Day("5"),
            saturday: new Day("6"),
            sunday: new Day("7")
        };

        vm.scheduleName = "";
        vm.service_providers = [];

        vm.filters = [
            {
                name: "All",
                id: " "
            },
            {
                name: "Critical issues",
                id: "Critical issues"
            },
            {
                name: "Unsubscribe",
                id: "Unsubscribe"
            }
        ];

        vm.schedule = {
            name: "",
            type: "Email",
            email_address: user_info.email,
            phone_number: "",
            service_provider: "",
            push_app: " ",
            user: user_info.sys_id
        };

        vm.scheduleTypes = ["Email", "SMS", "Push", "Voice"];

        vm.push_apps = ["ServiceNow Internal Mobile Application", "ServiceNow Mobile Application"];

        vm.deleteChannel = {
            email: false,
            sms: false,
            push: false,
            voice: false
        };

        vm.devices = {
            email: {
                name: "",
                exists: false,
                active: false,
                sys_id: ""
            },
            sms: {
                name: "",
                exists: false,
                active: false,
                sys_id: ""
            },
            push: {
                name: "",
                exists: false,
                active: false,
                sys_id: ""
            },
            voice: {
                name: "",
                exists: false,
                active: false,
                sys_id: ""
            }
        };

        function Notice(name, sys_id, domain) {
            this.name = name;
            this.sys_domain = domain;
            this.email = {
                notification: sys_id,
                active: true,
                device: " ",
                notification_filter: " ",
                schedule: " ",
                sys_id: ""
            };
            this.sms = {
                notification: sys_id,
                active: true,
                device: " ",
                notification_filter: " ",
                schedule: " ",
                sys_id: ""
            };
            this.push = {
                notification: sys_id,
                active: true,
                device: " ",
                notification_filter: " ",
                schedule: " ",
                sys_id: ""
            };
            this.voice = {
                notification: sys_id,
                active: true,
                device: " ",
                notification_filter: " ",
                schedule: " ",
                sys_id: ""
            };
        }

        vm.categories = {
            approval: {},
            incident: {},
            password: {},
            sla: {}
        };

        vm.allNotifications = true;

        vm.changeToggle = (toggle, category, key, type) => {
            if (!toggle) {
                vm.categories[category][key][type].notification_filter = "Unsubscribe";
            } else {
                vm.categories[category][key][type].notification_filter = " ";
            }
        };

        vm.toggleAll = () => {
            if (vm.allNotifications == true) {
                for (var item in vm.devices) {
                    vm.devices[item].active = true;
                }
            } else {
                for (var dev in vm.devices) {
                    vm.devices[dev].active = false;
                }
            }
        };

        vm.changeFilter = (filter, category, key, type) => {
            if (filter == "Unsubscribe") {
                vm.categories[category][key][type].active = false;
            } else {
                vm.categories[category][key][type].active = true;
            }
        };

        vm.getSchedule = () => {
            Navbar.getSchedule((data) => {
                data = data.results;
                vm.scheduleFilter = [
                    {
                        name: "None",
                        id: " "
                    }
                ];
                data.forEach((item) => {
                    if (
                        item.sys_created_by == user_info.email ||
                        item.u_user.value == user_info.sys_id ||
                        item.sys_created_by === "pat"
                    ) {
                        vm.scheduleFilter.push({
                            name: item.name,
                            id: item.name
                        });
                    }
                });
            });
        };
        vm.getSchedule();

        let count = 0;
        let activeCount = 0;
        vm.createSchedule = () => {
            Navbar.createSchedule(
                {
                    name: vm.scheduleName,
                    sys_name: vm.scheduleName,
                    u_user: user_info.sys_id
                },
                (data) => {
                    let scheduleSys = data.result.sys_id;

                    for (var day in vm.day) {
                        if (vm.day[day].active == true) {
                            activeCount++;
                            let dayStatus = {
                                parent_id: scheduleSys,
                                day_of_week: vm.day[day].id,
                                sys_name: vm.day[day].id
                            };
                            if (vm.day[day].begin1) {
                                dayStatus.start_time1 =
                                    "1970-01-01 " + ("00" + (Number(vm.day[day].begin1) - 6)).slice(-2) + ":00:00";
                            }
                            if (vm.day[day].begin2) {
                                dayStatus["start_time2"] =
                                    "1970-01-01 " + ("00" + (Number(vm.day[day].begin2) - 6)).slice(-2) + ":00:00";
                            }
                            if (vm.day[day].end1) {
                                dayStatus["end_time1"] =
                                    "1970-01-01 " + ("00" + (Number(vm.day[day].end1) - 6)).slice(-2) + ":00:00";
                            }
                            if (vm.day[day].end2) {
                                dayStatus["end_time2"] =
                                    "1970-01-01 " + ("00" + (Number(vm.day[day].end2) - 6)).slice(-2) + ":00:00";
                            }
                            vm.createDays(dayStatus);
                        }
                    }
                }
            );
        };

        vm.createDays = (status) => {
            Navbar.createDay(status, () => {
                count++;
                if (count == activeCount) {
                    count = 0;
                    activeCount = 0;
                    vm.tabView = "setting";
                    vm.getSchedule();
                    vm.day = {
                        monday: new Day("1"),
                        tuesday: new Day("2"),
                        wednesday: new Day("3"),
                        thursday: new Day("4"),
                        friday: new Day("5"),
                        saturday: new Day("6"),
                        sunday: new Day("7")
                    };
                }
            });
        };

        vm.getNotices = () => {
            Navbar.getUserNotices(
                (data) => {
                    data = data.results;
                    data.forEach((item) => {
                        for (var key in vm.categories) {
                            if (item.device && item.device.display_value && vm.categories[key][item.name]) {
                                let devType = item.device.display_value.toLowerCase();
                                let devID = item.device.link.split("/").slice(0, 8)[7];
                                vm.categories[key][item.name][devType].device = devID;
                                if (item.notification_filter && item.notification_filter.display_value) {
                                    if (
                                        item.notification_filter.display_value == "Critical issues" ||
                                        item.notification_filter.display_value == "Unsubscribe"
                                    ) {
                                        if (item.notification_filter.display_value == "Unsubscribe") {
                                            vm.categories[key][item.name][devType].active = false;
                                        }
                                        vm.categories[key][item.name][devType].notification_filter =
                                            item.notification_filter.display_value;
                                    } else {
                                        vm.categories[key][item.name][devType].notification_filter = " ";
                                    }
                                }
                                if (item.schedule && item.schedule.display_value) {
                                    vm.categories[key][item.name][devType].schedule = item.schedule.display_value;
                                }
                                vm.categories[key][item.name][devType].sys_id = item.sys_id;
                            }
                        }
                    });
                },
                {
                    user: user_info.sys_id
                }
            );
        };

        vm.getNoticeDevices = () => {
            Navbar.getNoticeDevices(
                (data) => {
                    data = data.results;
                    data.forEach((item) => {
                        let type = item.type.toLowerCase();
                        let active = item.active == "true";
                        vm.devices[type].exists = true;
                        vm.devices[type].active = active;
                        vm.devices[type].name = item.name;
                        vm.devices[type].sys_id = item.sys_id;
                    });
                    vm.loading = false;
                },
                {
                    user: user_info.sys_id
                }
            );
        };
        vm.getNoticeDevices();

        Navbar.getNoticeCategories((data) => {
            data = data.results;
            data.forEach((item) => {
                let type = item.name.substr(0, 3).toLowerCase();
                switch (type) {
                    case "app":
                        vm.categories.approval[item.name] = new Notice(
                            item.name,
                            item.sys_id,
                            item.sys_domain.display_value
                        );
                        break;
                    case "inc":
                        vm.categories.incident[item.name] = new Notice(
                            item.name,
                            item.sys_id,
                            item.sys_domain.display_value
                        );
                        break;
                    case "pas":
                        vm.categories.password[item.name] = new Notice(
                            item.name,
                            item.sys_id,
                            item.sys_domain.display_value
                        );
                        break;
                    case "sla":
                    case "ola":
                        vm.categories.sla[item.name] = new Notice(
                            item.name,
                            item.sys_id,
                            item.sys_domain.display_value
                        );
                        break;
                    default:
                        break;
                }
            });
            vm.getNotices();
        });

        vm.burUser = false;

        vm.matchDomain = (noticeDomain) => {
            if (user_info.sys_domain == "f111354213f38b00e11f57963244b0be") {
                vm.burUser = true;
                return true;
            } else {
                if (noticeDomain != "global") {
                    return false;
                } else {
                    return true;
                }
            }
        };

        vm.update = (id, status) => {
            Navbar.updateNotification(id, status, (data) => {
                if (!data.result) {
                    vm.error = true;
                    $log.info("update");
                    vm.alerts = [
                        {
                            type: "danger",
                            msg: data
                        }
                    ];
                }
            });
        };

        vm.updateDeviceChannel = (id, status) => {
            Navbar.updateDeviceChannel(id, status, (data) => {
                if (!data.result) {
                    vm.error = true;
                    $log.info("update");
                    vm.alerts = [
                        {
                            type: "danger",
                            msg: data
                        }
                    ];
                }
            });
        };

        vm.deleteDeviceChannel = (sys_id) => {
            Navbar.deleteDeviceChannel(sys_id, (data) => {
                if (!data.result) {
                    vm.error = true;
                    $log.info("delete");
                    vm.alerts = [
                        {
                            type: "danger",
                            msg: data
                        }
                    ];
                }
            });
        };

        vm.createDeviceChannel = (status) => {
            Navbar.createDeviceChannel(status, (data) => {
                if (!data.result) {
                    vm.error = true;
                    $log.info("create");
                    vm.alerts = [
                        {
                            type: "danger",
                            msg: data
                        }
                    ];
                } else {
                    vm.getNoticeDevices();
                    vm.tabView = "channels";
                    vm.schedule = {
                        name: "",
                        type: "Email",
                        email_address: user_info.email,
                        phone_number: "",
                        service_provider: "",
                        push_app: " ",
                        user: user_info.sys_id
                    };
                }
            });
        };

        vm.create = (status) => {
            Navbar.createNotification(status, (data) => {
                if (!data.result) {
                    vm.error = true;
                    $log.info("create");
                    vm.alerts = [
                        {
                            type: "danger",
                            msg: data
                        }
                    ];
                }
            });
        };

        vm.close = () => {
            for (var item in vm.categories) {
                for (var child in vm.categories[item]) {
                    for (var type in vm.categories[item][child]) {
                        if (vm.devices[type] && vm.devices[type].active == true) {
                            vm.categories[item][child][type].user = user_info.sys_id;
                            vm.categories[item][child][type].device = vm.devices[type].sys_id;
                            if (vm.categories[item][child][type].sys_id) {
                                delete vm.categories[item][child][type].active;
                                vm.update(vm.categories[item][child][type].sys_id, vm.categories[item][child][type]);
                            } else {
                                delete vm.categories[item][child][type].active;
                                delete vm.categories[item][child][type].sys_id;
                                vm.create(vm.categories[item][child][type]);
                            }
                        }
                    }
                }
            }
            for (var dev in vm.devices) {
                if (vm.deleteChannel[dev] == true) {
                    vm.deleteDeviceChannel(vm.devices[dev].sys_id);
                } else {
                    delete vm.devices[dev].exists;
                    vm.updateDeviceChannel(vm.devices[dev].sys_id, vm.devices[dev]);
                }
            }
            $uibModalInstance.close();
        };
    }
})();

(function () {
    angular.module("burWood").factory("Navbar", Navbar);

    function Navbar(ServiceNow) {
        return {
            changePassword: (sys_id, old_password, password, confirm_password, callback) => {
                ServiceNow.changePassword(sys_id, old_password, password, confirm_password, callback);
            },
            getCompanyList: (callback) => {
                ServiceNow.getTable("", "u_bms_contracts|companyList", callback, 10000, 0, {
                    active_contract: true,
                    bypassCompany: true
                });
            },
            getNoticeCategories: (callback) => {
                ServiceNow.getTable("", "sysevent_email_action", callback, 10000, 0, {
                    active_status: true
                });
            },
            getNoticeFilters: (callback) => {
                ServiceNow.getTable("", "notification_filter", callback, 10000, 0);
            },
            getNoticeDevices: (callback, query_obj) => {
                ServiceNow.getTable("", "cmn_notif_device", callback, 10000, 0, query_obj);
            },
            createDeviceChannel: (data, callback) => {
                ServiceNow.createItem("cmn_notif_device", data, callback);
            },
            updateDeviceChannel: (id, status, callback) => {
                ServiceNow.updateItem("cmn_notif_device", id, status, callback);
            },
            deleteDeviceChannel: (sys_id, callback) => {
                ServiceNow.deleteItem("cmn_notif_device", sys_id, callback);
            },
            getServiceProviders: (callback) => {
                ServiceNow.getTable("", "cmn_notif_service_provider", callback, 100000, 0, {
                    active_status: true
                });
            },
            getUserNotices: (callback, query_obj) => {
                ServiceNow.getTable("", "cmn_notif_message", callback, 100000, 0, query_obj);
            },
            getSchedule: (callback) => {
                ServiceNow.getTable("", "sys_calendar", callback, 100000, 0);
            },
            updateNotification: (id, status, callback) => {
                ServiceNow.updateItem("cmn_notif_message", id, status, callback);
            },
            createNotification: (status, callback) => {
                ServiceNow.createItem("cmn_notif_message", status, callback);
            },
            createSchedule: (status, callback) => {
                ServiceNow.createItem("sys_calendar", status, callback);
            },
            createDay: (status, callback) => {
                ServiceNow.createItem("sys_cal_day", status, callback);
            },
            getDays: (callback) => {
                ServiceNow.getTable("", "sys_cal_day", callback);
            }
        };
    }
})();

(function () {
    angular.module("burWood").directive("bwNavbar", bwNavbar);

    /** @ngInject */
    function bwNavbar() {
        let directive = {
            restrict: "E",
            templateUrl: "app/components/navbar/navbar.html",
            scope: {
                creationDate: "="
            },
            controller: NavbarController,
            controllerAs: "vm",
            bindToController: true,
            link: function () {}
        };
        return directive;
    }

    /** @ngInject */
    function NavbarController(
        user_info,
        $state,
        $uibModal,
        $window,
        $rootScope,
        BCSServer,
        Service,
        $timeout,
        apiBasePath,
        $scope,
        cloud,
        $log
    ) {
        let vm = this;

        vm.user_info = user_info;

        if (!user_info.first_name || !user_info.last_name) {
            vm.user_name = " ";
        } else {
            vm.user_name = user_info.first_name + " " + user_info.last_name;
        }

        let sessionWarning = false;

        let company = user_info.company;
        vm.company = user_info.company_name;
        var exceptions;
        vm.basePath = apiBasePath;

        var sessionModalInst;
        vm.sessionWarn = () => {
            sessionModalInst = $uibModal.open({
                templateUrl: "app/shared/html/confirmation.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "SessionController",
                controllerAs: "vm"
            });
            sessionModalInst.result.then(() => {
                sessionWarning = false;
                sessionModalInst = null;
            });
        };

        $scope.$on("IdleStart", () => {
            // the user appears to have gone idle
        });

        $scope.$on("IdleWarn", () => {
            $log.info("Idle Warn");

            if (!sessionWarning) {
                sessionWarning = true;
                vm.sessionWarn();
            }

            // follows after the IdleStart event, but includes a countdown until the user is considered timed out
            // the countdown arg is the number of seconds remaining until then.
            // you can change the title or display a warning dialog from here.
            // you can let them resume their session by calling Idle.watch()
        });

        $scope.$on("IdleTimeout", () => {
            $log.info("Idle Timeout");
            if (sessionModalInst) {
                sessionModalInst.dismiss();
            }
            $state.go("logout");
            // the user has timed out (meaning idleDuration + timeout has passed without any activity)
            // this is where you'd log them
        });

        //setting up permissions based on servicenow groups
        if (user_info.group) {
            if (user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") != -1) {
                vm.cloudBillingOnly = true;
                vm.cloudbillingAdmin = true;
                vm.cloudbillingAdminBurwood = true;
                vm.contactListsComp = true;
                vm.csvReport = true;
                if (user_info.group.indexOf("BCS Portal - Standard Override") === -1) {
                    vm.cloudAdminToggle = true;
                } else {
                    vm.cloudBillingOnly = false;
                    vm.cloudAdminToggle = false;
                }
            } else if (
                user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins Read Only") != -1
            ) {
                vm.cloudBillingOnly = true;
                vm.cloudbillingAdmin = true;
            } else if (
                user_info.group.indexOf("BCS Portal - Cloudbilling - Project Users") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Group Admins") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Department Admins") != -1
            ) {
                vm.cloudBillingOnly = true;
            } else {
                vm.cloudBillingOnly = false;
            }

            vm.groupAdmin = user_info.group.indexOf("BCS Portal - Cloudbilling - Group Admins") === -1 ? false : true;
            vm.departmentAdmin =
                user_info.group.indexOf("BCS Portal - Cloudbilling - Department Admins") === -1 ? false : true;
            vm.userAdmin = user_info.group.indexOf("BCS Portal - User Admin") === -1 ? false : true;
            vm.basicUser = user_info.group.indexOf("BCS Portal - Basic User") === -1 ? false : true;
            // allows access to read contracts if the user is in the appropriate group
            vm.readContract =
                user_info.group.indexOf("Customer - Executive") != -1 ||
                user_info.group.indexOf("BCS Manager") != -1 ||
                user_info.group.indexOf("BCS Contract Readers") != -1 ||
                user_info.group.indexOf("Burwood Account Executive") != -1
                    ? true
                    : false;
            // allows access to write contracts if the user is in the appropriate group
            vm.writeContract =
                user_info.group.indexOf("BCS Manager") != -1 ||
                user_info.group.indexOf("Burwood Account Executive") != -1
                    ? true
                    : false;
            // allows access to impersonate a company if the user is in the appropriate group
            vm.canImpersonate =
                user_info.group.indexOf("Impersonator") != -1 ||
                user_info.group.indexOf("BG Technical Architects") != -1 ||
                user_info.group.indexOf("BG Executive Directors") != -1
                    ? true
                    : false;

            vm.bcsDevOps = user_info.group.indexOf("BCS DevOps - Portal") != -1 ? true : false;
        }

        // for select companies that want this option available in the menu bar.  A quick for for P1 phone ticket
        vm.p1VoiceUser =
            company === "d89ea6a91352d6002d503262f244b050" || company === "5f8e66a91352d6002d503262f244b0f2"
                ? true
                : false;
        vm.bcsUser = company === "8d8073014f8d0300d227d48e5210c785" || company === "c94993314a362312005cfc20c1aa15d2";
        vm.domsUser = company === "1be1693d1bd250d0beaec9176e4bcb9a";

        vm.automationEnabled = true; // default until we get response

        vm.fetchAccounts = () => {
            BCSServer.postData(
                {
                    companyCode: user_info.company_code
                },
                "/cloud_accounts",
                (account) => {
                    if (account) {
                        // automationEnabled: undefined -> true, false -> false, true -> true
                        vm.automationEnabled = account.automationEnabled !== false;
                    }
                    if (
                        account &&
                        account.accounts &&
                        account.accounts.length > 0 &&
                        account.accounts[accountCheckIndex]
                    ) {
                        const accounts = account.accounts.map((account) => account.account);
                        $timeout(() => {
                            if (user_info.company_code !== "UNIAME") {
                                vm.checkAccountIAM(accounts);
                                vm.getProjectList(account.accounts);
                            }
                        }, 5000);
                        vm.applyLogo(account.logo);
                    }
                }
            );
        };

        if (vm.cloudBillingOnly) {
            vm.fetchAccounts();
        }

        vm.missingPermission = false;
        let projectCheckIndex = 0;
        let accountCheckIndex = 0;

        vm.getProjectList = (accounts) => {
            BCSServer.postData(
                {
                    accounts: accounts
                },
                "/gcp_billing_projects",
                (response) => {
                    let projectList = [];
                    if (response && response.success) {
                        projectList = cloud.removeExportProjects(
                            response.accountProjects,
                            user_info.company_code,
                            "projectId"
                        );
                    }
                    let projects = projectList.map((project) => {
                        return project.projectId;
                    });

                    projects = projects.slice(0, 30);
                    if (projects[projectCheckIndex]) {
                        vm.checkProjectIAM(projects);
                    }
                }
            );
        };

        vm.applyLogo = (logo) => {
            if (logo) {
                vm.logo =
                    "data:" + logo.contentType + ";base64," + btoa(String.fromCharCode.apply(null, logo.data.data));
            }
        };

        // Checks GCP Project permissions for a specified project
        vm.checkProjectIAM = (projects) => {
            BCSServer.postData(
                {
                    projects: projects
                },
                "/cloud_check_projects_iam",
                (response) => {
                    if (response.error) {
                        vm.missingPermission = true;
                        return;
                    } else {
                        response.msg.forEach(function (project) {
                            if (project[Object.keys(project)[0]].length === 0) {
                                vm.missingPermission = true;
                            }
                        });
                    }
                }
            );
        };

        // Checks GCP billing account permissions for a specified account
        vm.checkAccountIAM = (accounts) => {
            BCSServer.postData(
                {
                    accounts: accounts
                },
                "/cloud_check_accounts_iam",
                (response) => {
                    if (response.error) {
                        vm.missingPermission = true;
                        return;
                    } else {
                        response.msg.forEach(function (account) {
                            if (account[Object.keys(account)[0]].length === 0) {
                                vm.missingPermission = true;
                            }
                        });
                    }
                }
            );
        };

        // get device exceptions - devices monitored but not in contract
        Service.getExceptions((data) => {
            if (data.err || !data.results) {
                vm.error = true;
            } else {
                exceptions = data.results;
            }
        }, company);

        vm.cloudAdminView = $rootScope.cloudAdmin;

        vm.toggleAdmin = () => {
            $rootScope.cloudAdmin = vm.cloudAdminView;
            $state.reload();
        };

        vm.toggleAdminCloud = () => {
            BCSServer.postData(
                {
                    cloudView: vm.cloudAdminToggle
                },
                "/toggle_cloud_view",
                () => {
                    $window.location.reload();
                }
            );
        };

        // go to device page, but checks first if the device is an exception - if it is, it routes to the appropriate section on device page
        vm.goToDevice = (device) => {
            let except = false;
            for (let x = 0; x < exceptions.length; x++) {
                if (device.toLowerCase() === exceptions[x].name.toLowerCase()) {
                    except = true;
                }
            }
            if (except) {
                $state.current === "index.devices"
                    ? $state.reload()
                    : $state.go("index.devices", {
                          redirectedDevice: device,
                          exception: true
                      });
            } else {
                $state.current === "index.devices"
                    ? $state.reload()
                    : $state.go("index.devices", {
                          redirectedDevice: device
                      });
            }
        };

        //sets up autocomplate
        // hits route on server that handles fetching relevant results from keyword in servicenow
        angular.element("#searchbox").devbridgeAutocomplete({
            serviceUrl: apiBasePath + "/searcher/autocomplete",
            showNoSuggestionNotice: true,
            noSuggestionNotice: '<div class="autocomplete-suggestion">No Matching Results</div>',
            paramName: "keyword",
            deferRequestBy: 250,
            triggerSelectOnValidInput: false,
            width: "275px",
            appendTo: angular.element("#search-binder"),
            onSelect: (suggestion) => {
                vm.showSearch = false;
                vm.isNavCollapsed = true;
                angular.element("#searchbox").val("");
                if (suggestion.data.type_name == "request") {
                    $state.go("index.request_single", {
                        reqID: suggestion.data.id
                    });
                } else if (suggestion.data.type_name == "incident") {
                    $state.go("index.status_single", {
                        statusID: suggestion.data.id
                    });
                } else if (suggestion.data.type_name == "problem") {
                    $state.go("index.problem_single", {
                        problemID: suggestion.data.id
                    });
                } else if (suggestion.data.type_name == "customer_change") {
                    $state.go("index.uchange_single", {
                        requestID: suggestion.data.id
                    });
                } else if (suggestion.data.type_name == "device") {
                    vm.goToDevice(suggestion.data.display_name);
                } else if (suggestion.data.type_name == "event") {
                    $state.go("index.allevent", {});
                } else {
                    $state.go("index.search", {
                        query: suggestion.value
                    });
                }
            },
            groupBy: "type_name",
            formatGroup: (suggestion) => {
                let type = suggestion.data.type_name.toUpperCase();
                type = type.replace("_", " ");
                type = type + "S";
                return '<div class="autocomplete-group">' + type + "</div>";
            },
            formatResult: (suggestion) => {
                return suggestion.data.display_name.slice(0, 30);
            },
            onSearchStart: () => {
                angular.element(".fa.fa-search").addClass("blinking");
            },
            onSearchComplete: () => {
                angular.element(".fa.fa-search").removeClass("blinking");
            }
        });

        vm.escapeSearch = ($event) => {
            if ($event.keyCode === 27) {
                vm.showSearch = false;
            }
        };

        // handler for showing the search screen overlay
        vm.showSearch = false;
        vm.searchScreen = () => {
            vm.showSearch = true;
            angular.element("#searchbox").val("");
            $timeout(() => {
                angular.element("#searchbox").focus();
            }, 500);
        };

        //search keyword
        vm.search = () => {
            vm.showSearch = false;
            let keyword = angular.element("#searchbox").val();
            if (keyword === "") {
                angular.element("#searchbox").attr("placeholder", "Please Enter Something!");
            } else {
                angular.element("#searchbox").val("");
                vm.isNavCollapsed = true;
                $state.go("index.search", {
                    query: keyword
                });
            }
        };

        vm.changePlaceholder = () => {
            angular.element("#searchbox").attr("placeholder", "Global Search");
        };

        //check the user's browser to set browser-specific scrolling options
        let isChrome = $window.chrome;
        if (isChrome) {
            angular.element("body").addClass("body-scroll");
        } else {
            angular.element("body").addClass("no-webkit-scroll");
        }

        //handler for underline current route in menubar
        angular.element("a").removeClass("underline");

        let underlineNav = $rootScope.$on("$locationChangeSuccess", () => {
            let url = $window.location.href.split("/")[3];
            vm.underlineRoute(url);
        });

        $rootScope.$on("$destroy", underlineNav);

        angular.element(document).ready(() => {
            let initURL = $window.location.href.split("/")[3];
            vm.underlineRoute(initURL);
        });

        vm.underlineRoute = (route) => {
            angular.element("a").removeClass("underline");
            switch (route) {
                case "":
                    angular.element("#home-route").addClass("underline");
                    break;
                case "requests":
                case "incidents":
                case "uchange_request":
                case "problems":
                case "bohs":
                case "tickets":
                    angular.element("#tick-route").addClass("underline");
                    break;
                case "report":
                    angular.element("#repo-route").addClass("underline");
                    break;
                case "devices":
                    angular.element("#devi-route").addClass("underline");
                    break;
                case "company":
                    angular.element("#comp-route").addClass("underline");
                    break;
                case "allevent":
                case "clearevent":
                    angular.element("#even-route").addClass("underline");
                    break;
                case "contracts":
                case "quotes":
                case "contract_new":
                case "contract_exceptions":
                    angular.element("#contr-route").addClass("underline");
                    break;
                case "service_descriptions":
                    angular.element("#serd-route").addClass("underline");
                    break;
                case "contactus":
                case "release_notes":
                case "cloud_guide":
                case "cloud_user_guide":
                case "docs":
                    angular.element("#help-route").addClass("underline");
                    break;
                case "calendar":
                    angular.element("#cale-route").addClass("underline");
                    break;
                case "request_new":
                case "boh_new":
                case "request_new_internal":
                case "doms_new_user":
                case "status_new":
                case "uchange_new":
                    angular.element("#open-route").addClass("underline");
                    break;
                case "cloudbilling_dashboard":
                case "cloudbilling_dashboard_admin":
                    angular.element("#clou-dash").addClass("underline");
                    break;
                case "cloudbilling_reports":
                    angular.element("#clou-repo").addClass("underline");
                    break;
                case "cloudbilling_projects":
                case "cloudbilling_users":
                case "cloudbilling_pos":
                case "cloudbilling_config":
                case "cloudbilling_burwood_admin":
                    angular.element("#clou-acct").addClass("underline");
                    break;
                case "cloud_request":
                    angular.element("#clou-only-route").addClass("underline");
                    break;
                case "cloud_request_new":
                    angular.element("#clou-only-route-new").addClass("underline");
                    break;
                case "search":
                    break;
                default:
                    break;
            }
        };

        //opens modal for password reset
        vm.resetForm = () => {
            $uibModal.open({
                templateUrl: "app/components/navbar/passwordReset.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "PasswordController",
                controllerAs: "vm"
            });
        };

        //opens modal for client picker selection
        vm.selectClient = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/components/navbar/clientpicker.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ClientController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                data.sl_org = "/api/organization/" + data.sl_org;
                BCSServer.postData(
                    {
                        setCompany: data
                    },
                    "/user_info",
                    () => {
                        $window.location.reload();
                    }
                );
            });
        };

        //opens modal for client picker selection
        vm.selectCloudClient = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/components/navbar/clientpicker.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "CloudClientController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                data.sl_org = "/api/organization/" + data.sl_org;
                BCSServer.postData(
                    {
                        setCompany: data
                    },
                    "/user_info",
                    () => {
                        $window.location.reload();
                    }
                );
            });
        };

        //opens preferences for notification management
        vm.preferences = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/components/navbar/preferences.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "NotificationController",
                controllerAs: "vm"
            });
            modalInst.result.then(function () {});
        };
    }
})();

(function() {
    "use strict";

    angular.module("burWood").directive("enter", enter);

    /** @ngInject */
    function enter() {
        return function(scope, element, attrs) {
            element.bind("keydown keypress", function(event) {
                if (event.which === 13) {
                    scope.$apply(function() {
                        scope.$eval(attrs.enter);
                    });
                    event.preventDefault();
                }
            });
        };
    }
})();

(function () {
    angular.module("burWood").controller("CloudClientController", CloudClientController);

    /** @ngInject */
    function CloudClientController($uibModalInstance, BCSServer, Service, _) {
        let vm = this;
        vm.loading = true;
        vm.searchTerm = "";
        vm.options = {};
        vm.options.items = [];

        vm.select = (company) => {
            vm.searchTerm = company;
        };

        //get list of avaialable companies by querying accounts stored in mongo
        BCSServer.postData({}, "/cloud_companies", (response) => {
            if (response && response.length > 1) {
                Service.getQuery(
                    {
                        u_customer_codes: response
                    },
                    "core_company|cloudList",
                    (companies) => {
                        if (companies && companies.results && companies.results.length > 0) {
                            let companyArr = [];
                            let unsorted = [];
                            for (let x = 0; x < companies.results.length; x++) {
                                companyArr.push({
                                    company: companies.results[x]["name"],
                                    sys_id: companies.results[x]["sys_id"],
                                    sl_org: companies.results[x]["u_sciencelogic_id"],
                                    company_code: companies.results[x]["u_customer_code"]
                                });
                            }
                            unsorted = _.uniq(companyArr, (p) => {
                                return p.sys_id;
                            });
                            vm.options.items = _.sortBy(unsorted, (o) => {
                                return o.company.toLowerCase();
                            });
                        } else {
                            vm.clientAccounts = [];
                        }
                    }
                );
            } else {
                vm.clientAccounts = [];
            }
        });

        vm.close = () => {
            $uibModalInstance.close(vm.searchTerm);
        };
    }
})();

(function () {
    angular.module("burWood").controller("ClientController", ClientController);

    /** @ngInject */
    function ClientController($uibModalInstance, Navbar, _) {
        let vm = this;
        vm.loading = true;
        vm.searchTerm = "";
        vm.options = {};
        vm.options.items = [];

        vm.select = (company) => {
            vm.searchTerm = company;
        };

        //get list of avaialable companies by querying contracts - add Burwood and BCS after
        Navbar.getCompanyList((companies) => {
            let companyArr = [];
            let unsorted = [];
            for (let x = 0; x < companies.results.length; x++) {
                companyArr.push({
                    company: companies.results[x]["company.name"],
                    sys_id: companies.results[x]["company.sys_id"],
                    sl_org: companies.results[x]["company.u_sciencelogic_id"],
                    company_code: companies.results[x]["company.u_customer_code"],
                    sys_domain: companies.results[x]["company.sys_domain.sys_id"]
                });
            }
            companyArr.push(
                {
                    company: "Burwood Group",
                    sys_id: "c94993314a362312005cfc20c1aa15d2",
                    sl_org: "8",
                    sys_domain: "c90a2b444a3623120064ed56263be407",
                    company_code: "BURGRO"
                },
                {
                    company: "Burwood Cloud Services",
                    sys_id: "8d8073014f8d0300d227d48e5210c785",
                    sl_org: "1",
                    sys_domain: "f111354213f38b00e11f57963244b0be",
                    company_code: "BURGRO"
                }
            );
            unsorted = _.uniq(companyArr, (p) => {
                return p.sys_id;
            });
            vm.options.items = _.sortBy(unsorted, (o) => {
                return o.company.toLowerCase();
            });
            vm.options.items.unshift({
                company: "All",
                sys_id: "All",
                sl_org: "All",
                sys_domain: "All"
            });
        });

        vm.close = () => {
            $uibModalInstance.close(vm.searchTerm);
        };
    }
})();

(function () {
    "use strict";

    angular.module("burWood").controller("UserAdminController", UserAdminController);

    /** @ngInject */
    function UserAdminController(
        user_info,
        Service,
        util,
        $timeout,
        ServiceNow,
        BCSServer,
        user,
        disabled,
        $uibModal,
        Alerts,
        $state,
        $uibModalInstance,
        _
    ) {
        let vm = this;
        vm.loading = true;
        vm.accountLoading = true;
        vm.loadingUserList = true;
        vm.alerts = [];
        vm.disabled = disabled;

        let departmentAdminSys = "790be853db022450163905d2ca9619c4";
        let groupAdminSys = "d6b77b8ddb922490163905d2ca9619a2";
        let projectSys = "090e5c211b214050268dc8415b4bcb4e";

        if (
            user_info.company === "61a4a1401bdd8810beaec9176e4bcbef" ||
            user_info.company === "b32295ebdb388010f6ba00b5ca961985"
        ) {
            vm.mit = true;
        }

        if (user_info.group) {
            user_info.group.indexOf("BCS Portal - User Admin") != -1 && (vm.isUserAdmin = true);
            (user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Group Admins") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins Read Only") != -1) &&
                (vm.isAdmin = true);
            user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") != -1 && (vm.burwoodManager = true);
            user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins Read Only") != -1 &&
                (vm.disabled = true);
        }

        vm.groups = [
            {
                name: "Limited User",
                id: "38bba4531bc00890268dc8415b4bcbd3"
            },
            {
                name: "Standard User",
                id: "noSysID"
            }
        ];

        let standardSysIds = ["38bba4531bc00890268dc8415b4bcbd3"];
        let cloudSysIds = [
            "2eeae8df1b800890268dc8415b4bcb59",
            "090e5c211b214050268dc8415b4bcb4e",
            "aba8f15e1bd51c505c267591dd4bcb48",
            "790be853db022450163905d2ca9619c4",
            "d6b77b8ddb922490163905d2ca9619a2"
        ];

        let cloudGroupsProd = [
            {
                name: "Admin User",
                id: "2eeae8df1b800890268dc8415b4bcb59"
            },
            {
                name: "Project User",
                id: projectSys
            },
            {
                name: "Admin User - Read Only",
                id: "aba8f15e1bd51c505c267591dd4bcb48"
            },
            {
                name: "Department Admin",
                id: departmentAdminSys
            },
            {
                name: "Group Admin",
                id: groupAdminSys
            }
        ];

        vm.account = {
            name: "Users",
            users: []
        };

        let userGroups = vm.groups;
        let groupSysIDs = standardSysIds;

        vm.user = user;

        if (vm.user != "standard") {
            vm.originalSetting = vm.user;
            vm.cloudUser = true;
            vm.cloudGroups = cloudGroupsProd;
            userGroups = vm.cloudGroups;
            groupSysIDs = cloudSysIds;
        }

        vm.fetchUsers = (redirectUser, bypassPrompt) => {
            Service.getQuery(
                {
                    company: user_info.company
                },
                "sys_user|userList",
                (data) => {
                    vm.loadingUserList = false;
                    if (data.error || !data.results || (data.results && data.results.legnth === 0)) {
                        vm.account.users = [];
                    } else {
                        vm.account.users = vm.sortUsers(data.results);
                        vm.account.users = vm.removeSSOAccounts(vm.account.users);
                        var userIndex;
                        if (redirectUser) {
                            vm.account.users.forEach((item, index) => {
                                item.email === redirectUser && (userIndex = index);
                            });
                            if (!userIndex && userIndex !== 0) {
                                vm.userNotFound = true;
                            }
                        }
                        !userIndex && (userIndex = 0);
                        vm.selectedUser = angular.copy(vm.account.users[userIndex]);
                        vm.originalUserSetting = angular.copy(vm.account.users[userIndex]);
                        if (vm.selectedUser) {
                            vm.chooseUser(userIndex, bypassPrompt);
                        } else {
                            vm.loading = false;
                        }
                        angular.element("#device-accordion").find(".panel-body").addClass("webkit-scroll");
                        angular.element("#device-accordion").find(".panel-body").css("height", "700px");
                    }
                }
            );
        };
        vm.fetchUsers(user.email);

        vm.fetchGroups = (sys_id) => {
            Service.getQuery(
                {
                    user: sys_id
                },
                "sys_user_grmember",
                (data) => {
                    vm.loading = false;
                    if (data.error) {
                        vm.basicUser = false;
                    } else {
                        vm.selectedGroupSys = null;
                        data.results.forEach((item) => {
                            if (item.group && item.group.value && groupSysIDs.includes(item.group.value)) {
                                vm.selectedGroupSys = item.group.value;
                                vm.originalGroupSetting = item.group.value;
                                vm.userGroupID = item.sys_id;
                            }
                        });

                        vm.selectedGroup = userGroups.filter((group) => {
                            return group.id === vm.selectedGroupSys;
                        });

                        if (!vm.selectedGroupSys) {
                            vm.selectedGroup = userGroups[1];
                            vm.selectedGroupSys = userGroups[1].id;
                            vm.originalGroupSetting = userGroups[1].id;
                        }
                    }
                }
            );
        };

        vm.fetchBudget = () => {
            vm.budgetLoading = true;
            BCSServer.postData(
                {
                    method: "get",
                    company: user_info.company,
                    role: "IT"
                },
                "/cloud_budgets",
                (response) => {
                    if (response && angular.isArray(response) && response.length > 0 && response[0].departments) {
                        vm.departments = response[0].departments;
                        vm.adminGroups = response[0].groups || [];
                        // vm.adminGroups = vm.adminGroups.filter((group) => {
                        //     return group.groupName !== user_info.company_name;
                        // });
                    } else {
                        vm.departments = [];
                        vm.adminGroups = [];
                    }
                    vm.budgetLoading = false;
                }
            );
        };
        vm.fetchBudget();

        vm.updateBudget = () => {
            vm.budgetLoading = true;
            let depoIndex = _.findIndex(vm.departments, {
                departmentName: vm.selectedDepartment.departmentName
            });
            BCSServer.postData(
                {
                    company: user_info.company,
                    depoContacts: vm.selectedDepartment.contactList,
                    depoIndex: depoIndex
                },
                "/add_department_contact",
                (response) => {
                    vm.budgbudgetLoadingetUpdate = false;
                    if (response.error || !response) {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Failed To Add User As Department Contact. Please Contact Support For Further Assistance.",
                            status: "fail"
                        });
                    } else {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Successfully Added User As Department Contact",
                            status: "success"
                        });
                    }
                }
            );
        };

        vm.updateGroup = () => {
            vm.budgetLoading = true;
            let groupIndex = _.findIndex(vm.adminGroups, {
                groupName: vm.selectedAdminGroup.groupName
            });
            BCSServer.postData(
                {
                    company: user_info.company,
                    groupContacts: vm.selectedAdminGroup.contactList,
                    groupIndex: groupIndex
                },
                "/add_group_contact",
                (response) => {
                    vm.budgbudgetLoadingetUpdate = false;
                    if (response.error || !response) {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Failed To Add User As Group Contact. Please Contact Support For Further Assistance.",
                            status: "fail"
                        });
                    } else {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Successfully Added User As Group Contact",
                            status: "success"
                        });
                    }
                }
            );
        };

        vm.fetchAccount = () => {
            BCSServer.postData(
                {
                    companyCode: user_info.company_code
                },
                "/cloud_accounts",
                (response) => {
                    vm.accountLoading = false;
                    if (response) {
                        vm.cloudAccount = response;
                    } else {
                        vm.cloudAccount = {};
                    }
                }
            );
        };
        vm.fetchAccount();

        vm.updateAccount = () => {
            vm.accountLoading = true;
            delete vm.cloudAccount._id;
            delete vm.cloudAccount.__v;
            BCSServer.postData(
                {
                    companyCode: vm.cloudAccount.companyCode,
                    companyAccounts: vm.cloudAccount
                },
                "/update_cloud_accounts",
                (response) => {
                    vm.accountLoading = false;
                    if (response.error || !response) {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Failed To Update Notification Settings. Please Contact Support For Further Assistance.",
                            status: "fail"
                        });
                    } else {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Successfully Updated Notification Settings",
                            status: "success"
                        });
                    }
                }
            );
        };

        vm.newUser = (event) => {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            vm.selectedAdminGroup = null;
            vm.newUserSelected = true;
            vm.account.users.push({
                active: true
            });
            vm.projectIndex = vm.account.users.length - 1;
            vm.selectedUser = vm.account.users[vm.projectIndex];
            vm.originalUserSetting = vm.account.users[vm.projectIndex];
            if (vm.cloudUser) {
                vm.selectedGroup = vm.cloudGroups[1];
                vm.selectedGroupSys = projectSys;
            }
        };

        vm.chooseUser = (projectIndex, bypassPrompt) => {
            vm.loading = true;
            vm.projectIndex = projectIndex;
            vm.passwordReset = false;
            let prompt = true;

            if (
                !bypassPrompt &&
                (!angular.equals(vm.selectedUser, vm.originalUserSetting) ||
                    !angular.equals(vm.selectedGroupSys, vm.originalGroupSetting))
            ) {
                prompt = confirm("You have made changes to this user profile, do you wish to leave?");
                vm.loading = false;
            }

            if (prompt) {
                vm.selectedAdminGroup = null;
                vm.newUserSelected = false;
                vm.selectedUser = angular.copy(vm.account.users[projectIndex]);
                vm.originalUserSetting = angular.copy(vm.account.users[projectIndex]);

                $timeout(() => {
                    angular.element(".sku-title").removeClass("toggle-border");
                    angular.element("#" + projectIndex.toString()).addClass("toggle-border");
                }, 100);

                vm.fetchGroups(vm.selectedUser.sys_id);

                vm.findCloudContact(vm.selectedUser, "departments", "selectedDepartment");
                vm.findCloudContact(vm.selectedUser, "adminGroups", "selectedAdminGroup");
            }
        };

        vm.findCloudContact = (user, type, select) => {
            if (vm[type]) {
                vm[type].forEach((depo) => {
                    if (depo.contactList) {
                        depo.contactList.forEach((contact) => {
                            if (contact && contact.email === user.email) {
                                vm[select] = depo;
                            }
                        });
                    }
                });
            }
        };

        vm.close = () => {
            $uibModalInstance.close(vm.user);
        };

        vm.cancel = () => {
            vm.user = vm.originalSetting;
            $uibModalInstance.dismiss("cancel");
        };

        vm.update = () => {
            vm.loading = true;
            if (vm.newUserSelected) {
                vm.createUser(vm.selectedUser);
            } else {
                vm.updateUser(vm.selectedUser);
            }
        };

        vm.delete = () => {
            vm.loading = true;
            let prompt = confirm("Are you sure you wish to delete this user?");
            if (prompt) {
                vm.deleteUser(vm.selectedUser);
            } else {
                vm.loading = false;
            }
        };

        vm.updateUser = (user) => {
            ServiceNow.updateItem("sys_user", user.sys_id, user, (response) => {
                if (response.error) {
                    vm.createAlertMessage({
                        type: "alerts",
                        msg: `Failed to update user: ${user.first_name} ${user.last_name}.  Please contact support for assistance: ${response.error}`,
                        status: "fail"
                    });
                } else {
                    vm.passwordReset && vm.resetPassword(user);

                    if (vm.selectedGroupSys != vm.originalGroupSetting) {
                        vm.originalGroupSetting !== "noSysID" && vm.removeUserFromGroup(user);
                        vm.selectedGroupSys !== "noSysID" && vm.addUserToSNGroup(user);
                    } else {
                        vm.loading = false;

                        if (vm.cloudUser && vm.selectedGroupSys === "2eeae8df1b800890268dc8415b4bcb59") {
                            vm.addCloudAdminContact(user);
                        } else if (vm.cloudUser && vm.selectedGroupSys === departmentAdminSys) {
                            vm.addCloudContact("selectedDepartment", user);
                        } else if (vm.cloudUser && vm.selectedGroupSys === groupAdminSys) {
                            vm.addCloudContact("selectedAdminGroup", user);
                        }

                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Successfully updated user: ${user.first_name} ${user.last_name}.`,
                            status: "success"
                        });

                        vm.fetchUsers(user.email, "bypassPrompt");
                    }
                    if (vm.cloudUser && angular.isObject(vm.user)) {
                        if (vm.user != vm.originalSetting) {
                            $timeout(() => {
                                vm.user.update = true;
                                vm.close();
                            }, 500);
                        }
                    }
                }
            });
        };

        vm.deleteUser = (user) => {
            BCSServer.postData(
                {
                    email: user.email
                },
                "/cloud_account_delete_email_contact",
                (response) => {
                    if (response && !response.success) {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Error deleting email contact. ${user.email}`,
                            status: "fail"
                        });
                    }
                } 
            ); 
            BCSServer.postData(
                {
                    email: user.email
                },
                "/cloud_budgets_delete_email_contact",
                (response) => {
                    if (response && !response.success) {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Error deleting email contact. ${user.email}`,
                            status: "fail"
                        });
                    } 
                }
            );
            ServiceNow.deleteItem("sys_user", user.sys_id, (response) => {
                vm.loading = false;
                if (response.error) {
                    vm.createAlertMessage({
                        type: "alerts",
                        msg: `Failed to delete user: ${user.first_name} ${user.last_name}.  Please contact support for assistance.`,
                        status: "fail"
                    });
                } else {
                    vm.createAlertMessage({
                        type: "alerts",
                        msg: `Successfully deleted user: ${user.first_name} ${user.last_name}.`,
                        status: "success"
                    });
                    vm.account.users.splice(vm.projectIndex, 1);
                    vm.selectedUser = angular.copy(vm.account.users[0]);
                    vm.originalUserSetting = angular.copy(vm.account.users[0]);
                    vm.chooseUser(0);
                    if (vm.cloudUser && angular.isObject(vm.user)) {
                        $timeout(() => {
                            vm.user.delete = true;
                            vm.user.update = true;
                            vm.close();
                        }, 500);
                    }
                }
            });
        };

        //catalog item to create new user in devSNOW
        vm.createUser = (user) => {
            vm.loading = true;
            let requestItem = {
                sysparm_quantity: "1",
                variables: {
                    access_type: "add",
                    servicenow: true,
                    company: user_info.company,
                    user_id: user.user_name,
                    first_name: user.first_name,
                    last_name: user.last_name,
                    user_email: user.email,
                    title: user.title || "",
                    phone: user.phone || "",
                    mobile_phone: user.mobile_phone || ""
                }
            };

            
            

            Service.createItem(
                "sn_sc/servicecatalog/items/8f2e66f0db16a4105041aa2e13961909/order_now",
                requestItem,
                (response) => {
                    if (response.error || !response.result) {
                        console.log(response)
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Failed to create user: ${user.email}.  Please contact support for assistance.`,
                            status: "fail"
                        });
                        vm.loading = false;
                    } else {
                        vm.findUserByEmail(user.email);
                    }
                }
            );
        };

        vm.findUserByEmail = (email) => {
            Service.getQuery(
                {
                    company: user_info.company,
                    email: email
                },
                "sys_user",
                (response) => {
                    console.log(response);
                    if (response.error || !response.results || (response.results && response.results.length === 0)) {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Failed to add user: ${email} in company ${user_info.company_name}. Please contact support for assistance. Does the user exist in a different organization?`,
                            status: "fail"
                        });
                        vm.loading = false;
                        console.log(response);
                        vm.loading = false;
                    } else {
                        let user = response.results[0];
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Successfully added user: ${user.email}.`,
                            status: "success"
                        });
                        
                        if (vm.passwordReset) {
                            vm.resetPassword(user);
                        }

                        if (vm.selectedGroupSys !== "noSysID") {
                            vm.addUserToSNGroup(user);
                            vm.fetchUsers(user.email, "bypassPrompt");
                        } else {
                            vm.loading = false;
                            vm.fetchUsers(user.email, "bypassPrompt");
                        }
                    }
                }
            );
        };

        vm.addUserToSNGroup = (user) => {
            Service.createItem(
                "sys_user_grmember",
                {
                    user: user.sys_id,
                    group: vm.selectedGroupSys //dev group sys_id
                },
                (response) => {
                    vm.loading = false;
                    console.log(response);
                    if (response.error || !response.result) {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Failed to add user: ${user.first_name} ${user.last_name} to group in company ${user_info.company_name}. Please contact support for assistance.`,
                            status: "fail"
                        });
                        vm.loading = false;
                        console.log(response);
                    } else {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Successfully added user: ${user.first_name} ${user.last_name} to group in company ${user_info.company_name}.`,
                            status: "success"
                        });
                        vm.fetchGroups(user.sys_id);
                        if (vm.cloudUser && vm.selectedGroupSys === "2eeae8df1b800890268dc8415b4bcb59") {
                            // if admin group
                            vm.addCloudAdminContact(user);
                        } else if (vm.cloudUser && vm.selectedGroupSys === departmentAdminSys) {
                            vm.addCloudContact("selectedDepartment", user);
                        } else if (vm.cloudUser && vm.selectedGroupSys === groupAdminSys) {
                            vm.addCloudContact("selectedAdminGroup", user);
                        }
                    }
                }
            );
        };

        vm.addCloudContact = (type, user) => {
            !vm[type] || (!vm[type].contactList && (vm[type].contactList = []));

            let userExists = vm[type].contactList.find((contact) => {
                return contact.email === user.email;
            });

            if (!userExists) {
                vm[type].contactList.push({
                    email: user.email,
                    alerts: true,
                    weeklySummary: true
                });
                if (type === "selectedDepartment") {
                    vm.updateBudget();
                } else if (type == "selectedAdminGroup") {
                    vm.updateGroup();
                }
            }
        };

        vm.addCloudAdminContact = (user) => {
            !vm.cloudAccount.emailContacts && (vm.cloudAccount.emailContacts = []);

            let userExists = vm.cloudAccount.emailContacts.find((contact) => {
                return contact.email === user.email;
            });

            if (!userExists) {
                vm.cloudAccount.emailContacts.push({
                    email: user.email,
                    alerts: false,
                    weeklySummary: true
                });
                vm.updateAccount();
            }
        };

        vm.removeUserFromGroup = (user) => {
            ServiceNow.deleteItem("sys_user_grmember", vm.userGroupID, (response) => {
                vm.loading = false;
                if (response.error) {
                    vm.createAlertMessage({
                        type: "alerts",
                        msg: `Failed to remove ${user.first_name} ${user.last_name} from group in company ${user_info.company_name}.  Please contact support for assistance.`,
                        status: "fail"
                    });
                } else {
                    vm.createAlertMessage({
                        type: "alerts",
                        msg: `Successfully removed ${user.first_name} ${user.last_name} from group.`,
                        status: "success"
                    });
                }
            });
        };

        vm.resetPassword = (user) => {
            BCSServer.postData(
                {
                    email: user.email,
                    sys_id: user.sys_id
                },
                "/reset_key",
                (response) => {
                    if (response && response.success) {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: `Reset password sent to ${user.email}.`,
                            status: "success"
                        });
                    } else {
                        vm.createAlertMessage({
                            type: "alerts",
                            msg: "Password Reset request failed. Please Contact Support For Further Assistance.",
                            status: "fail"
                        });
                    }
                }
            );
        };

        vm.createAlertMessage = (alert) => {
            vm[alert.type].push({
                status: alert.status,
                msg: alert.msg
            });
            Alerts.storeAlert({
                type: alert.status,
                message: alert.msg,
                user: user_info.email,
                company: user_info.company_name,
                location: $state.current.name,
                tags: ["Cloud User Configuration"]
            });
            $timeout(() => {
                vm[alert.type] = [];
            }, 5000);
        };

        vm.close_notice = (alert, index) => {
            vm[alert.type].splice(index, 1);
        };

        vm.sortUsers = (users) => {
            return users.sort(util.compare("last_name"));
        };

        vm.removeSSOAccounts = (users) => {
            return users.filter((user) => {
                return (
                    user &&
                    !user.user_name.includes("serviceaccount") &&
                    user.first_name !== "Service" &&
                    user.last_name !== "Account"
                );
            });
        };
    }
})();

(function () {
    "use strict";

    angular.module("burWood").controller("DOMSUserController", DOMSUserController);

    /** @ngInject */
    function DOMSUserController(Service, _, $timeout, $uibModal) {
        var vm = this;
        vm.loading = false;
        vm.request = {};
        vm.alerts = [];

        //catalog item to create new user in devSNOW
        vm.createUser = function () {
            vm.loading = true;
            var requestItem = {
                sysparm_quantity: "1",
                variables: vm.request
            };
            Service.createItem(
                "sn_sc/servicecatalog/items/021fbbe4db039c500f4ed404ca9619c4/order_now",
                requestItem,
                function (response) {
                    if (response.error || !response.result) {
                        var errorMessage =
                            "Failed To Create User: " +
                            vm.request.first_name +
                            " " +
                            vm.request.last_name +
                            ". Please Contact Support For Further Assistance.";
                        createAlertMessage(errorMessage);
                        vm.loading = false;
                    } else {
                        $uibModal.open({
                            templateUrl: "app/userAdmin/confirmation.html",
                            ariaLabelledBy: "modal-title",
                            ariaDescribedBy: "modal-body",
                            controller: Confirmation,
                            controllerAs: "vm",
                            resolve: {
                                ticket: function () {
                                    return {
                                        number: response.result.number,
                                        sys_id: response.result.sys_id
                                    };
                                }
                            }
                        });
                        vm.request = {};
                        vm.loading = false;
                    }
                }
            );
        };

        function createAlertMessage(message) {
            vm.alerts.push({
                type: "danger",
                msg: message
            });
            $timeout(function () {
                vm.alerts = [];
            }, 4000);
        }

        vm.close_notice = function (index) {
            vm.alerts.splice(index, 1);
        };

        vm.contact = function () {
            var modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: ContactList,
                controllerAs: "vm"
            });
            modalInst.result.then(function (data) {
                if (data) {
                    vm.namager_name = data.name;
                    vm.request.manager = data.sys_id;
                }
            });
        };
    }

    function Confirmation($uibModalInstance, $state, ticket) {
        var vm = this;
        vm.number = ticket.number;
        vm.close = function () {
            $uibModalInstance.dismiss("cancel");
            $state.go("index.request_single", {
                reqID: ticket.sys_id
            });
        };
    }

    function ContactList($uibModalInstance, Service, DTOptionsBuilder) {
        var vm = this;

        vm.dtOptions = DTOptionsBuilder.newOptions().withOption("responsive", true);

        vm.loading = true;

        vm.addtolist = function (name, caller_id, email) {
            var data = {
                name: name,
                email: email,
                sys_id: caller_id
            };
            $uibModalInstance.close(data);
        };

        vm.close = function () {
            $uibModalInstance.dismiss("cancel");
        };

        Service.getQuery(
            {
                active_status: true
            },
            "sys_user",
            function (data) {
                vm.loading = false;
                if (data.error) {
                    vm.total_result = 0;
                    vm.users = [];
                } else {
                    vm.total_result = data.count;
                    vm.users = data.results;
                }
            }
        );
    }
})();

(function () {
    angular.module("burWood").factory("ChangeRequest", ChangeRequest);

    function ChangeRequest(ServiceNow) {
        return {
            getRequest: (state, callback, page_limit, offset, company) => {
                let query_obj = {
                    active_status: true,
                    type: "ticket",
                    company_sys: company
                };
                ServiceNow.getTable(state, "change_request|ticketsList", callback, page_limit, offset, query_obj);
            },
            getCalendar: (state, callback, page_limit, offset, company) => {
                let query_obj = {
                    active_status: true,
                    type: "calendar",
                    company_sys: company
                };
                ServiceNow.getTable(state, "change_request|ticketsList", callback, page_limit, offset, query_obj);
            },
            getSingle: (requestId, callback) => {
                ServiceNow.getItem(requestId, "change_request", callback);
            },
            createRequest: (request, callback, noCookie) => {
                ServiceNow.createItem("change_request", request, callback, noCookie);
            },
            deleteRequest: (requestId, callback) => {
                ServiceNow.deleteItem("change_request", requestId, callback);
            },
            updateRequest: (requestId, request, callback) => {
                ServiceNow.updateItem("change_request", requestId, request, callback);
            }
        };
    }
})();

(function () {
    angular
        .module("burWood")
        .controller("UChangereqController", UChangereqController)
        .filter("RemoveEmail", RemoveEmail);

    function RemoveEmail() {
        return (user) => {
            if (user) {
                let emailRemoved = user.replace(/\s*\(.*?\)\s*/g, "");
                return emailRemoved;
            }
        };
    }

    /** @ngInject */
    function UChangereqController(
        _,
        user_info,
        $log,
        $state,
        $stateParams,
        FileSaver,
        Service,
        $uibModal,
        ChangeRequest,
        Status,
        DTColumnDefBuilder,
        DTOptionsBuilder,
        $window,
        util,
        BCSServer,
        ServiceNow,
        Blob,
        Alerts,
        $timeout
    ) {
        let vm = this;

        if (
            user_info.company === "c94993314a362312005cfc20c1aa15d2" ||
            user_info.company === "8d8073014f8d0300d227d48e5210c785"
        ) {
            vm.internalUser = true;
        } else {
            vm.internalUser = false;
        }

        vm.alerts = [];

        vm.createAlertMessage = (alert) => {
            vm.alerts.push({
                status: alert.status,
                msg: alert.msg
            });

            Alerts.storeAlert({
                type: alert.status,
                message: alert.msg,
                user: user_info.email,
                company: user_info.company_name,
                location: $state.current.name,
                tags: ["Incidents"]
            });

            if (alert.status === "success") {
                $timeout(() => {
                    vm.alerts = [];
                }, 5000);
            }
        };

        /* event source that contains custom events on the scope */
        vm.eventSources = [[]];

        /* alert on eventClick */
        vm.alertOnEventClick = (date, jsEvent) => {
            jsEvent.preventDefault(); // don't let the browser navigate
            vm.goToTicket(date.url);
        };

        /* Render Tooltip */
        vm.mouseEnter = function (event) {
            let ticket = vm.maintenanceRequests[event.id];

            let tooltip =
                '<div class="calendarTooltip" style="border: 1px solid grey;padding:10px; text-align: center;font-size:12px;width:400px;height:auto;background:#434343; border-radius: 4px; color: white;position:absolute;z-index:10001;">' +
                '<span style="font-size:bold">' +
                event.title +
                "</span><br><br>" +
                (ticket.description || "") +
                "<br><br>" +
                '<span style="font-weight:bold">State:</span> ' +
                (ticket.state || "") +
                "<br>" +
                '<span style="font-weight:bold">Start Date:</span> ' +
                (ticket.start_date || "") +
                "<br>" +
                '<span style="font-weight:bold">End Date:</span> ' +
                (ticket.end_date || "") +
                "<br>" +
                '<span style="font-weight:bold">Location:</span> ' +
                (ticket.location || "") +
                "<br>" +
                '<span style="font-weight:bold">Vendor:</span> ' +
                (ticket.u_vendor_reference_to || "") +
                "<br>" +
                "</div>";

            var $tool = angular.element(tooltip).appendTo("body");
            angular
                .element(this)
                .mouseover(function () {
                    angular.element(this).css("z-index", 10000);
                    $tool.fadeIn("1000");
                    $tool.fadeTo("10", 1.9);
                })
                .mousemove((e) => {
                    $tool.css("top", e.pageY + 10);
                    $tool.css("left", e.pageX - 200);
                });
        };

        vm.mouseOut = function () {
            angular.element(this).css("z-index", 8);
            angular.element(".calendarTooltip").remove();
        };

        /* config object */
        vm.uiConfig = {
            calendar: {
                height: 450,
                allDaySlot: false,
                header: {
                    left: "month basicWeek basicDay",
                    center: "title",
                    right: "prevYear,prev,next,nextYear"
                },
                eventClick: vm.alertOnEventClick,
                eventMouseover: vm.mouseEnter,
                eventMouseout: vm.mouseOut
            }
        };

        vm.selectedChangeList = "All Change Tickets";

        vm.showUrgency = false;
        vm.dtApprovalInstance = {};
        vm.showApprovalFilters = false;
        vm.customTitle = "Change Request Tickets";
        let columnFilter = {
            aoColumns: [
                null,
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                }
            ]
        };
        vm.trueDate = {
            requested_by_date: null,
            start_date: null,
            end_date: null
        };
        vm.dateToggle = {
            requested_by_date: false,
            start_date: false,
            end_date: false
        };
        let buttonConfig = [
            {
                extend: "colvis",
                text: "Toggle Columns"
            },
            {
                text: "Search Closed Tickets",
                key: "2",
                action: () => {
                    angular.element("#global_search").triggerHandler("click");
                }
            },
            {
                extend: "collection",
                text: "Export",
                buttons: [
                    {
                        extend: "excel",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        }
                    },
                    {
                        extend: "pdf",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        customize: (doc) => {
                            doc.pageMargins = [5, 5, 5, 5];
                            doc.styles.tableHeader.fontSize = 10;
                            doc.defaultStyle.fontSize = 6;
                        }
                    },
                    {
                        extend: "csv",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        }
                    }
                ]
            }
        ];
        vm.dtActivityOptions = DTOptionsBuilder.newOptions()
            .withOption("order", [["4", "des"]])
            .withColumnFilter(columnFilter)
            .withOption("responsive", true);
        vm.dtColumnDefsActivity = [
            DTColumnDefBuilder.newColumnDef(4).withOption("type", "date"),
            DTColumnDefBuilder.newColumnDef([3]).withClass("max-size-activity"),
            DTColumnDefBuilder.newColumnDef([1, 2, 4]).withClass("vert-align-activity")
        ];
        vm.dtApprovalOptions = DTOptionsBuilder.newOptions()
            .withDOM("lfBrtip")
            .withOption("aoColumnDefs", [
                {
                    bSortable: false,
                    aTargets: ["nosort2"]
                }
            ])
            .withButtons(buttonConfig)
            .withColumnFilter(columnFilter)
            .withOption("order", [["3", "des"]])
            .withOption("iDisplayLength", 10)
            .withOption("responsive", true);
        vm.dtColumnDefsApproval = [DTColumnDefBuilder.newColumnDef(3).withOption("type", "date")];
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withDOM("lfBrtip")
            .withOption("aoColumnDefs", [
                {
                    bSortable: false,
                    aTargets: ["nosort"]
                }
            ])
            .withButtons(buttonConfig)
            .withColumnFilter(columnFilter)
            .withOption("order", [["7", "des"]])
            .withOption("iDisplayLength", 10)
            .withOption("responsive", true);
        vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef([7, 8]).withOption("type", "date")];

        var exceptions;

        Service.getExceptions((data) => {
            if (data.results) {
                exceptions = data.results;
            }
        }, user_info.company);

        vm.goToDevice = (device) => {
            let except = false;
            for (let x = 0; x < exceptions.length; x++) {
                if (device.toLowerCase() === exceptions[x].name.toLowerCase()) {
                    except = true;
                }
            }
            if (except) {
                $state.go("index.devices", {
                    redirectedDevice: device,
                    exception: true
                });
            } else {
                $state.go("index.devices", {
                    redirectedDevice: device
                });
            }
        };

        vm.goToTicket = (sys_id) => {
            $state.go("index.uchange_single", {
                requestID: sys_id
            });
        };

        vm.watch_lists = [];
        vm.watch_list_users = [];
        vm.dtInstance = {};
        vm.showFilters = false;
        vm.loading = false;
        vm.impact = ["1 - Critical", "2 - High", "3 - Moderate", "4 - Minimal", "5 - Informational"];

        vm.category = [
            {
                id: "8",
                name: "Telepresence"
            },
            {
                id: "4",
                name: "Network"
            },
            {
                id: "6",
                name: "Server"
            },
            {
                id: "2",
                name: "Citrix"
            },
            {
                id: "9",
                name: "Unified Communications"
            },
            {
                id: "1",
                name: "Application"
            },
            {
                id: "7",
                name: "Storage"
            },
            {
                id: "10",
                name: "Unified Computing Systems"
            },
            {
                id: "3",
                name: "environmental"
            },
            {
                id: "5",
                name: "Security"
            }
        ];
        vm.priority = [
            {
                id: "1",
                name: "1 - Critical"
            },
            {
                id: "2",
                name: "2 - High"
            },
            {
                id: "3",
                name: "3 - Moderate"
            },
            {
                id: "4",
                name: "4 - Minimal"
            },
            {
                id: "5",
                name: "5 - Informational"
            }
        ];
        vm.urgency = [
            {
                id: "1",
                name: "1 - Critical"
            },
            {
                id: "2",
                name: "2 - High"
            },
            {
                id: "3",
                name: "3 - Moderate"
            },
            {
                id: "4",
                name: "4 - Minimal"
            },
            {
                id: "5",
                name: "5 - Informational"
            }
        ];
        vm.risk = [
            {
                id: "1",
                name: "1 - Very High Risk"
            },
            {
                id: "2",
                name: "2 - High Risk"
            },
            {
                id: "3",
                name: "3 - Moderate Risk"
            },
            {
                id: "4",
                name: "4 - Low Risk"
            },
            {
                id: "5",
                name: "5 - None"
            }
        ];
        vm.states = [
            {
                id: "-5",
                name: "Draft"
            },
            {
                id: "-6",
                name: "Internal Approval"
            },
            {
                id: "-7",
                name: "External Approval"
            },
            {
                id: "-2",
                name: "Scheduled"
            },
            {
                id: "-1",
                name: "Implement"
            },
            {
                id: "0",
                name: "Review"
            },
            {
                id: "3",
                name: "Closed"
            },
            {
                id: "4",
                name: "Canceled"
            }
        ];
        vm.incident_state = {
            1: "New",
            3: "Assigned",
            10: "Waiting for Customer",
            12: "Waiting for Vendor",
            6: "Resolved",
            8: "Cancelled"
        };
        vm.approval = [
            {
                id: "not requested",
                name: "Not Requested"
            },
            {
                id: "requested",
                name: "Requested"
            },
            {
                id: "approved",
                name: "Approved"
            },
            {
                id: "rejected",
                name: "Rejected"
            }
        ];
        vm.type = [
            {
                id: "routine",
                name: "Routine"
            },
            {
                id: "comprehensive",
                name: "Comprehensive"
            },
            {
                id: "emergency",
                name: "Emergency"
            },
            {
                id: "manual",
                name: "Manual"
            },
            {
                id: "standard",
                name: "Standard"
            },
            {
                id: "normal",
                name: "Normal"
            }
        ];
        vm.service_type = [
            {
                name: "Add"
            },
            {
                name: "Change"
            },
            {
                name: "Delete"
            },
            {
                name: "Move"
            }
        ];
        vm.service_level = [
            {
                name: "Gold"
            },
            {
                name: "Port"
            },
            {
                name: "Silver"
            },
            {
                name: "Bronze"
            },
            {
                name: "Ping"
            }
        ];
        vm.status = [
            {
                id: "-5",
                name: "Pending"
            },
            {
                id: "1",
                name: "Open"
            },
            {
                id: "2",
                name: "Work in Progress"
            },
            {
                id: "3",
                name: "Closed Complete"
            },
            {
                id: "4",
                name: "Closed Incomplete"
            },
            {
                id: "7",
                name: "Closed Skipped"
            }
        ];
        vm.date_type = 0;
        vm.related_show = false;

        // let minDate = new Date();
        // minDate.setDate(minDate.getDate());
        // vm.dateOptions = {
        // 	formatYear: 'yy',
        // 	maxDate: new Date(2020, 5, 22),
        // 	minDate: minDate,
        // 	startingDay: 1
        // }

        vm.show_related = (update) => {
            if (vm.related_show == true && !update) {
                vm.related_show = false;
                return;
            }
            let uRequestId = $stateParams.requestID;
            vm.related_show = true;
            vm.related_loading = true;
            vm.getJournalEntries(uRequestId);
        };

        vm.getJournalEntries = (statusID) => {
            Status.getJournal(
                statusID,
                (data) => {
                    if (data.error) {
                        vm.related_loading = false;
                        $log.info(data.error);
                    } else {
                        vm.related_result = [];
                        let journals = data.results;
                        if (journals) {
                            journals.forEach((journal) => {
                                if (journal.element === "comments" || journal.element === "status") {
                                    if (journal.element.indexOf("_") != -1) {
                                        journal.element = journal.element.replace("_", " ");
                                        journal.element = util.capitalizeFirstLetter(journal.element);
                                    } else {
                                        journal.element = util.capitalizeFirstLetter(journal.element);
                                    }
                                    let addHistory = {
                                        sortDate: journal.sys_created_on.toString(),
                                        sys_created_on: journal.sys_created_on.toString(),
                                        value: journal.value,
                                        sys_created_by: journal.sys_created_by,
                                        element: journal.element
                                    };
                                    vm.related_result.push(addHistory);
                                }
                            });
                        }
                        vm.getHistoryLine(statusID);
                    }
                },
                300,
                0
            );
        };

        vm.getHistoryLine = (statusID) => {
            Status.getHistory(
                statusID,
                (data) => {
                    if (data.error) {
                        vm.related_loading = false;
                        $log.info(data.error);
                    } else {
                        let noDuplicate = [];
                        let histories = data.results;
                        if (histories) {
                            histories.forEach((history) => {
                                if (history.field === "state") {
                                    let addActivity = {
                                        sortDate: history.update_time,
                                        sys_created_on: history.update_time,
                                        value: history.new,
                                        sys_created_by: history.u_name_id,
                                        element: history.label
                                    };
                                    if (noDuplicate.indexOf(history.new) == -1) {
                                        noDuplicate.push(history.new);
                                        vm.related_result.push(addActivity);
                                    }
                                }
                            });
                        }
                        vm.getAttachedFiles(statusID);
                    }
                },
                300,
                0
            );
        };

        let attachmentLength = 0;
        let attachmentIndex = 0;

        vm.getAttachedFiles = (statusID) => {
            ServiceNow.getAllAttachment(statusID, "change_request", 10, 10, (data) => {
                if (data && data.result && data.result.length > 0) {
                    let attachments = data.result;
                    attachmentLength = data.result.length;
                    attachments.forEach((attachment) => {
                        vm.getSingleFileData(attachment);
                    });
                } else {
                    vm.related_result.sort((a, b) => {
                        return new Date(a.sortDate) - new Date(b.sortdate);
                    });
                    vm.related_loading = false;
                }
            });
        };

        vm.nonImageAttachments = {};

        vm.getSingleFileData = (attachment) => {
            ServiceNow.getAttachment(attachment.sys_id, (data) => {
                if (data) {
                    let blobData = new Blob([data], {
                        type: attachment.content_type
                    });

                    let activityItem = {
                        sortDate: attachment.sys_created_on,
                        sys_created_on: attachment.sys_created_on,
                        dataURL: "",
                        sys_created_by: attachment.sys_created_by,
                        element: "Attachment"
                    };

                    if (attachment && attachment.content_type.includes("image")) {
                        activityItem.dataURL = URL.createObjectURL(blobData);
                        activityItem.imageData = data;
                        activityItem.image = true;
                    } else {
                        vm.nonImageAttachments[attachment.file_name] = blobData;
                        activityItem.dataURL = attachment.file_name;
                        activityItem.image = false;
                    }

                    vm.related_result.push(activityItem);
                }
                attachmentIndex++;
                if (attachmentLength === attachmentIndex) {
                    vm.related_result.sort((a, b) => {
                        return new Date(a.sortDate) - new Date(b.sortdate);
                    });
                    attachmentLength = 0;
                    attachmentIndex = 0;
                    vm.related_loading = false;
                }
            });
        };

        vm.downloadFromActivity = (file) => {
            let blobData = vm.nonImageAttachments[file];
            FileSaver.saveAs(blobData, file);
        };

        vm.create_request = (request) => {
            vm.loading = true;
            if (vm.caller_id) {
                request.caller_id = vm.caller_id;
            }
            if (vm.device_id) {
                request.cmdb_ci = vm.device_id;
            }
            vm.request.company = user_info.company;
            vm.request.requested_by = user_info.sys_id;
            vm.request.risk = "5";
            vm.request.state = "-5";

            //BCS Tier 1 Assignment Group
            vm.request.assignment_group = "7fc641e94ffc5e4061fcc3fd0210c70c";
            // $log.info(vm.request);
            if (vm.request.start_date) {
                vm.request.start_date = new Date(vm.request.start_date).toISOString();
                vm.request.start_date = vm.request.start_date.replace("T", " ").substring(0, 19);
            }
            if (vm.request.end_date) {
                vm.request.end_date = new Date(vm.request.end_date).toISOString();
                vm.request.end_date = vm.request.end_date.replace("T", " ").substring(0, 19);
            }
            if (vm.request.requested_by_date) {
                vm.request.requested_by_date = new Date(vm.request.requested_by_date).toISOString();
                vm.request.requested_by_date = vm.request.requested_by_date.replace("T", " ").substring(0, 19);
            }
            ChangeRequest.createRequest(vm.request, (data) => {
                vm.loading = false;
                if (data.error) {
                    vm.status = [];
                    vm.createAlertMessage({
                        msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                            data.error.detail ? data.error.detail : ""
                        }`,
                        status: "fail"
                    });
                } else if (data.result) {
                    if (vm.attachmentList.length != 0) {
                        let count = 0;
                        for (let x = 0; x < vm.attachmentList.length; x++) {
                            ServiceNow.addAttachment(
                                data.result.sys_id,
                                "change_request",
                                [vm.attachmentList[x]],
                                () => {
                                    count++;
                                    if (count === vm.attachmentList.length) {
                                        $uibModal.open({
                                            templateUrl: "app/shared/html/ticketConfirmation.html",
                                            ariaLabelledBy: "modal-title",
                                            ariaDescribedBy: "modal-body",
                                            controller: "TicketRedirectController",
                                            controllerAs: "vm",
                                            resolve: {
                                                ticket: () => {
                                                    return {
                                                        number: data.result.number,
                                                        sys_id: data.result.sys_id
                                                    };
                                                },
                                                field: () => "requestID",
                                                route: () => "uchange_single"
                                            }
                                        });
                                    }
                                }
                            );
                        }
                    } else {
                        $uibModal.open({
                            templateUrl: "app/shared/html/ticketConfirmation.html",
                            ariaLabelledBy: "modal-title",
                            ariaDescribedBy: "modal-body",
                            controller: "TicketRedirectController",
                            controllerAs: "vm",
                            resolve: {
                                ticket: () => {
                                    return {
                                        number: data.result.number,
                                        sys_id: data.result.sys_id
                                    };
                                },
                                field: () => "requestID",
                                route: () => "uchange_single"
                            }
                        });
                    }
                } else {
                    vm.createAlertMessage({
                        msg: "Failed to create ticket",
                        status: "fail"
                    });
                }
            });
        };

        vm.updateApproval = (type) => {
            vm.loading = true;
            try {
                vm.change_approvals.forEach((item) => {
                    if (item.sysapproval.display_value === vm.request.number && item.state === "Requested") {
                        Service.updateItem(
                            "sysapproval_approver",
                            item.sys_id,
                            {
                                state: type
                            },
                            (data) => {
                                if (data.error) {
                                    vm.loading = false;
                                    vm.status = [];
                                    vm.createAlertMessage({
                                        msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                                            data.error.detail ? data.error.detail : ""
                                        }`,
                                        status: "fail"
                                    });
                                } else if (data.result) {
                                    var message;
                                    let remainingApprovers = [];
                                    vm.isApprover = false;
                                    Service.getQuery(
                                        {
                                            sysapproval: vm.ticket_sys
                                        },
                                        "sysapproval_approver",
                                        (response) => {
                                            vm.request.approvers = response.results;
                                            vm.request.approvers.forEach((item) => {
                                                if (item.state == "Requested") {
                                                    remainingApprovers.push(item.approver.display_value);
                                                }
                                            });
                                            if (remainingApprovers.length == 0) {
                                                message = "Ticket successfully " + type + ".";
                                            } else {
                                                let users = remainingApprovers.toString();
                                                users = users.replace(/,/g, ", ");
                                                message =
                                                    "Ticket " +
                                                    type +
                                                    " by you, but still awaiting approval by " +
                                                    users;
                                            }
                                            vm.getSingleRequest();
                                            vm.createAlertMessage({
                                                msg: message,
                                                status: "success"
                                            });
                                        }
                                    );
                                } else {
                                    vm.createAlertMessage({
                                        msg: "Failed to update ticket",
                                        status: "fail"
                                    });
                                }
                            }
                        );
                    } else {
                        vm.loading = false;
                    }
                });
            } catch (e) {
                $log.info(e);
                vm.loading = false;
                vm.status = [];
                vm.createAlertMessage({
                    msg: "Failed to approve change",
                    status: "fail"
                });
            }
        };

        vm.update_request = (requestId, request, compliance) => {
            vm.loading = true;
            var new_request = {
                requested_by_date: null,
                start_date: null,
                end_date: null
            };
            if (vm.trueDate.start_date) {
                new_request.start_date = new Date(vm.trueDate.start_date).toISOString();
                new_request.start_date = new_request.start_date.replace("T", " ").substring(0, 19);
            }
            if (vm.trueDate.end_date) {
                new_request.end_date = new Date(vm.trueDate.end_date).toISOString();
                new_request.end_date = new_request.end_date.replace("T", " ").substring(0, 19);
            }
            if (vm.trueDate.requested_by_date) {
                new_request.requested_by_date = new Date(vm.trueDate.requested_by_date).toISOString();
                new_request.requested_by_date = new_request.requested_by_date.replace("T", " ").substring(0, 19);
            }
            if (vm.device_id) {
                new_request.cmdb_ci = vm.device_id;
            } else {
                new_request.cmdb_ci = request.cmdb_ci.value;
            }
            new_request.state = request.state;
            new_request.test_plan = request.test_plan;
            new_request.implementation_plan = request.implementation_plan;
            new_request.backout_plan = request.backout_plan;
            new_request.u_category = request.u_category;
            new_request.short_description = request.short_description;
            new_request.description = request.description;
            new_request.comments = request.comments;

            var watch_list_arr = [];
            var temp_watch_list = Object.assign({}, vm.watch_list_users);
            for (var key in temp_watch_list) {
                watch_list_arr.push(temp_watch_list[key].sys_id);
            }
            var request_watch_list = watch_list_arr.join(",");
            new_request.watch_list = request_watch_list;
            // if (compliance) {
            //     new_request.state = '-6';
            //     new_request.compliance = true;
            // }

            ChangeRequest.updateRequest(requestId, new_request, (data) => {
                if (data.error) {
                    if (compliance) {
                        ChangeRequest.updateRequest(requestId, new_request, function (data2) {
                            vm.loading = false;
                            if (data2.error) {
                                vm.status = [];
                                vm.createAlertMessage({
                                    msg: `Failed: ${data2.error.message ? data2.error.message : ""} ${
                                        data2.error.detail ? data2.error.detail : ""
                                    }`,
                                    status: "fail"
                                });
                            } else if (data2.result) {
                                vm.createAlertMessage({
                                    msg: "Ticket successfully updated.",
                                    status: "success"
                                });
                                vm.getSingleRequest();
                            } else {
                                vm.createAlertMessage({
                                    msg: "Failed to update ticket",
                                    status: "fail"
                                });
                            }
                        });
                    } else {
                        vm.loading = false;
                        vm.status = [];
                        vm.createAlertMessage({
                            msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                                data.error.detail ? data.error.detail : ""
                            }`,
                            status: "fail"
                        });
                    }
                } else if (data.result) {
                    vm.loading = false;
                    vm.createAlertMessage({
                        msg: "Ticket successfully updated.",
                        status: "success"
                    });
                    vm.getSingleRequest();
                } else {
                    vm.createAlertMessage({
                        msg: "Failed to update ticket",
                        status: "fail"
                    });
                }
            });
        };
        vm.delete = (requestId) => {
            vm.loading = true;
            ChangeRequest.deleteRequest(requestId, () => {
                vm.loading = false;
            });
        };
        vm.go_back = () => {
            $window.history.back();
        };
        vm.close_notice = (index) => {
            vm.alerts.splice(index, 1);
        };
        vm.open_datepicker = (num) => {
            vm["datepicker_opened" + num] = true;
        };

        vm.device = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/device_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "DeviceListController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                vm.device_name = data.name;
                vm.device_id = data.device_id;
            });
        };

        vm.attachmentList = [];
        vm.attachment = () => {
            let modalInst = $uibModal.open({
                resolve: {
                    list: () => {
                        return vm.attachmentList;
                    },
                    params: () => {
                        return {
                            table: "change_request",
                            newTable: "uchange_new",
                            fieldID: "requestID"
                        };
                    }
                },
                templateUrl: "app/shared/html/attachment_form.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "AttachmentController",
                controllerAs: "vm"
            });
            modalInst.result.then(
                (data) => {
                    vm.attachmentList = data;
                    vm.related_show = false;
                    vm.show_related(true);
                },
                () => {
                    vm.related_show = false;
                    vm.show_related(true);
                }
            );
        };

        var requestId;
        vm.revertToDraft = () => {
            vm.loading = true;
            ChangeRequest.updateRequest(
                requestId,
                {
                    on_hold_reason: "Revert",
                    on_hold: false,
                    compliance: true
                },
                () => {
                    vm.getSingleRequest();
                }
            );
        };

        vm.openCalendar = (e, picker) => {
            e.preventDefault();
            e.stopPropagation();
            vm.dateToggle[picker] = true;
        };

        vm.parseSysID = (link) => {
            let n = link.lastIndexOf("/");
            return link.substring(n + 1);
        };

        vm.getSingleRequest = () => {
            Service.getQuery(
                {
                    assertDisplay: true,
                    sys_id: requestId
                },
                "change_request",
                (data) => {
                    if (data && data.results) {
                        vm.trueDate = {
                            requested_by_date: data.results.requested_by_date,
                            start_date: data.results.start_date,
                            end_date: data.results.end_date
                        };
                    }
                }
            );
            ChangeRequest.getSingle(requestId, (data) => {
                vm.loading = false;
                if (data.error) {
                    vm.request = [];
                } else {
                    vm.related_show = false;
                    vm.show_related();
                    vm.ticket_sys = data.results.sys_id;
                    vm.request = data.results;
                    vm.request.state === "-5" ? (vm.draft = true) : (vm.draft = false);
                    vm.request.state === "-5" ? (vm.request.approval = "not requested") : null;
                    vm.request.state === "3" || vm.request.state === "4 " ? (vm.draft = false) : null;
                    vm.request.requested_by.value === user_info.sys_id
                        ? (vm.ticketOwner = true)
                        : (vm.ticketOwner = false);
                    vm.request.short_description.slice(0, 19) === "Decommission Device"
                        ? (vm.decom = true)
                        : (vm.decom = false);

                    if (vm.request.number.substring(0, 3) == "CHG") {
                        vm.newChange = true;
                        vm.states = [
                            {
                                id: "-5",
                                name: "Draft"
                            },
                            {
                                id: "-6",
                                name: "Internal Approval"
                            },
                            {
                                id: "-7",
                                name: "External Approval"
                            },
                            {
                                id: "-2",
                                name: "Scheduled"
                            },
                            {
                                id: "-1",
                                name: "Implement"
                            },
                            {
                                id: "0",
                                name: "Review"
                            },
                            {
                                id: "3",
                                name: "Closed"
                            },
                            {
                                id: "4",
                                name: "Canceled"
                            }
                        ];
                    } else {
                        vm.newChange = false;
                        vm.states = [
                            {
                                id: "-5",
                                name: "Pending"
                            },
                            {
                                id: "1",
                                name: "Open"
                            },
                            {
                                id: "2",
                                name: "Work in Progress"
                            },
                            {
                                id: "3",
                                name: "Closed Complete"
                            },
                            {
                                id: "4",
                                name: "Closed Incomplete"
                            },
                            {
                                id: "7",
                                name: "Closed Skipped"
                            }
                        ];
                    }

                    vm.approvalNeeded = false;

                    Service.getQuery(
                        {
                            sysapproval: data.results.sys_id,
                            "state!": "Cancelled"
                        },
                        "sysapproval_approver",
                        (response) => {
                            vm.request.approvers = response.results;
                            vm.approverList = "";
                            vm.approverSysIDList = [];
                            for (let x = 0; x < vm.request.approvers.length; x++) {
                                vm.approverList +=
                                    vm.request.approvers[x].approver.display_value +
                                    " - " +
                                    vm.request.approvers[x].state +
                                    "\n";
                                let userSys = vm.parseSysID(vm.request.approvers[x].approver.link);
                                vm.approverSysIDList.push(userSys);
                                if (userSys === user_info.sys_id) {
                                    vm.isApprover = true;
                                    vm.ticketOwner = true;
                                    if (vm.request.approvers[x].state === "Requested") {
                                        vm.approvalNeeded = true;
                                    }
                                    if (vm.request.approvers[x].state === "Approved") {
                                        vm.approvalApprovedByYou = true;
                                    }
                                }
                            }
                        }
                    );

                    Service.getQuery(
                        {
                            approver: user_info.sys_id,
                            sysapproval: data.results.sys_id,
                            "state!": "Cancelled"
                        },
                        "sysapproval_approver",
                        (response) => {
                            vm.change_approvals = response.results;
                        }
                    );

                    var requester_id = data.results.requested_by.value;
                    var device_id = data.results.cmdb_ci.value;
                    var group_id = data.results.assignment_group.value;
                    var assigned_id = data.results.assigned_to.value;
                    var watch_lists_arr = data.results.watch_list;
                    if (group_id != "" || group_id != undefined) {
                        Status.getUserGroup(group_id, (data) => {
                            if (data.results) {
                                vm.request.group = data.results.name;
                            } else {
                                vm.request.group = "";
                            }
                        });
                    } else {
                        vm.request.group = new String("");
                    }
                    if (assigned_id != "" || assigned_id != undefined) {
                        Status.getUser(assigned_id, (data) => {
                            if (data.results && data.results.first_name && data.results.last_name) {
                                if (data.results.first_name && data.results.first_name) {
                                    vm.request.assigned = data.results.first_name + " " + data.results.last_name;
                                } else {
                                    vm.request.assigned = "";
                                }
                            } else {
                                vm.request.assigned = "";
                            }
                        });
                    } else {
                        vm.request.assigned = new String("");
                    }
                    if (requester_id != "" || requester_id != undefined) {
                        Status.getUser(requester_id, (data) => {
                            if (data.results) {
                                vm.request.requester_name = data.results.name;
                            } else {
                                vm.request.requester_name = "";
                            }
                        });
                    } else {
                        vm.request.requester_name = new String("");
                    }
                    if (device_id != "" && device_id != undefined) {
                        Status.getDevice(device_id, (data) => {
                            if (data.results) {
                                vm.device_name = data.results.name;
                            } else {
                                vm.device_name = "";
                            }
                            vm.loading = false;
                        });
                    } else {
                        vm.device_name = new String("");
                        vm.loading = false;
                    }
                    vm.watch_lists = [];
                    if (
                        watch_lists_arr != undefined &&
                        watch_lists_arr != null &&
                        watch_lists_arr != "" &&
                        watch_lists_arr != " "
                    ) {
                        vm.watch_lists = watch_lists_arr.split(",");
                    }
                    for (var key in vm.watch_lists) {
                        var user_id = vm.watch_lists[key];
                        if (user_id.indexOf("@") == -1) {
                            Status.getUser(user_id, (data) => {
                                var item;
                                if (data.results) {
                                    item = {
                                        sys_id: data.results.sys_id,
                                        name: data.results.name
                                    };
                                    let found = vm.watch_list_users.some((el) => {
                                        return el.name === data.results.name;
                                    });
                                    if (!found) {
                                        vm.watch_list_users.push(item);
                                    }
                                } else {
                                    if (user_id != null && user_id != "") {
                                        item = {
                                            sys_id: user_id,
                                            name: user_id
                                        };
                                        var found2 = vm.watch_list_users.some((el) => {
                                            return el.name === user_id;
                                        });
                                        if (!found2) {
                                            vm.watch_list_users.push(item);
                                        }
                                    }
                                }
                            });
                        } else {
                            vm.watch_list_users.push({
                                name: user_id,
                                sys_id: ""
                            });
                        }
                    }
                }
            });
        };

        var state_name = $state.current.name;
        switch (state_name) {
            case "index.uchange_new":
                vm.loading = false;
                vm.request = {};
                vm.caller_name = user_info.name;
                vm.caller_id = user_info.sys_id;
                vm.request.u_new_change_service = "Add";
                vm.request.u_service_level = "Gold";
                break;
            case "index.uchange_single":
                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withDOM('lfB<".table-scroll"rt>ip')
                    .withOption("aoColumnDefs", [
                        {
                            bSortable: false,
                            aTargets: ["nosort"]
                        }
                    ])
                    .withButtons(buttonConfig)
                    .withColumnFilter(columnFilter)
                    .withOption("order", [["4", "des"]])
                    .withOption("iDisplayLength", 10)
                    .withOption("responsive", true);
                vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef([7, 8]).withOption("type", "date")];
                vm.loading = true;
                requestId = $stateParams.requestID;
                vm.isApprover = false;
                vm.getSingleRequest();
                break;
            case "index.uchange_request":
                vm.loading = true;
                Service.getQuery(
                    {
                        approver: user_info.sys_id,
                        approvalState: "requested"
                    },
                    "sysapproval_approver",
                    (response) => {
                        vm.change_approvals = [];
                        if (response && response.results) {
                            for (let z = 0; z < response.results.length; z++) {
                                if (
                                    response.results[z]["document_id.state"] != "Closed" &&
                                    response.results[z]["document_id.state"] != "Canceled"
                                ) {
                                    vm.change_approvals.push(response.results[z]);
                                }
                            }
                        }
                    }
                );
                ChangeRequest.getRequest(
                    "",
                    (data) => {
                        vm.loading = false;
                        vm.requests = [];
                        if (!data.error) {
                            vm.requests = data.results;
                            vm.filterMaintenanceRequests(vm.requests);
                        }
                    },
                    5000,
                    0
                );
                break;
        }

        vm.filterMaintenanceRequests = (requests) => {
            vm.maintenanceRequests = [];
            let idCount = 0;

            requests.forEach((request) => {
                if (
                    request &&
                    request.type === "Standard" &&
                    request.short_description &&
                    request.short_description.includes("Maintenance notifications")
                ) {
                    vm.eventSources[0].push({
                        title:
                            request.number +
                            " - " +
                            request.short_description.replace("Maintenance notifications - ", ""),
                        start: request.start_date,
                        end: request.end_date,
                        url: request.sys_id,
                        allDay: false,
                        id: idCount
                    });
                    vm.maintenanceRequests.push(request);
                    idCount++;
                }
            });
        };

        //toggle minimizing of sections
        vm.minimizeSection = () => {
            vm.toggleConfig = !vm.toggleConfig;
            vm.toggleDatabase("post");
        };

        // controls handling and setting of pin setting in mogdb database
        vm.toggleDatabase = (type) => {
            BCSServer.postData(
                {
                    method: type,
                    user: user_info.email,
                    toggle: vm.toggleConfig
                },
                "/approval_toggle",
                (response) => {
                    if (type === "get") {
                        if (response.length === 0) {
                            //if user widget list doesnt exist in database - need to use predefined one
                            vm.toggleDatabase("post");
                        } else {
                            vm.toggleConfig = response[0].toggle;
                        }
                    }
                }
            );
        };

        vm.toggleDatabase("get");

        vm.switch_watchlist = () => {
            vm.watch_list_show = !vm.watch_list_show;
        };

        vm.findToRemoveById = (user_id) => {
            for (let i = 0; i < vm.watch_list_users.length; i++) {
                let user = vm.watch_list_users[i];
                if (user["sys_id"] == user_id) {
                    vm.watch_list_users.splice(i, 1);
                    return user_id;
                }
            }
        };

        vm.delete_watchlist = () => {
            angular.element(".watch-list-select option:selected").remove();
            if (vm.watch_list_selected != null) {
                angular.forEach(vm.watch_list_selected, (user_id) => {
                    vm.findToRemoveById(user_id);
                });
            }
        };

        vm.addEmail_watchlist = (user_email) => {
            if (user_email == null || user_email == "") {
                return;
            }
            let user = {
                sys_id: user_email,
                name: user_email
            };
            vm.add_watchlist(user);
        };
        vm.add_watchlist = (watch_list) => {
            if (vm.watch_list_users.length > 0) {
                vm.watch_list_users.push(watch_list);
            } else {
                vm.watch_list_users = [watch_list];
            }
            vm.watch_list_email = null;
            //       getUserWatchLists();
        };

        vm.getOptionName = (options, id) => {
            var name;
            options.forEach((item) => {
                item.id === id && (name = item.name);
            });
            return name;
        };

        vm.export = () => {
            let exportTicket = angular.copy(vm.request);
            exportTicket.commentActivity = [
                [
                    {
                        text: "USER",
                        style: "labelComment"
                    },
                    {
                        text: "TYPE",
                        style: "labelComment"
                    },
                    {
                        text: "VALUE",
                        style: "labelComment"
                    },
                    {
                        text: "DATE",
                        style: "labelComment"
                    }
                ]
            ];
            exportTicket.risk = vm.getOptionName(vm.risk, exportTicket.risk);
            exportTicket.u_category = vm.getOptionName(vm.category, exportTicket.u_category);
            exportTicket.state = vm.getOptionName(vm.states, exportTicket.state);
            exportTicket.type = util.capitalizeFirstLetter(exportTicket.type);
            exportTicket.approval = util.capitalizeFirstLetter(exportTicket.approval);
            vm.related_result.forEach((item) => {
                let createdBy = " ";
                let value = " ";
                if (item.dataURL && item.image) {
                    // value = 'data:' + item.element + ';base64,' + item.imageData;
                    // value = item.dataURL;
                } else if (!item.dataURL) {
                    value = item.value;
                }
                item.sys_created_by && (createdBy = item.sys_created_by);
                exportTicket.commentActivity.push([createdBy, item.element, value, item.sortDate]);
            });
            exportTicket.device = vm.device_name;
            exportTicket.watchList = vm.watch_list_users.map((item) => {
                return item.name;
            });
            exportTicket.approverList = vm.approverList;
            let dd = {
                content: [
                    {
                        layout: "lightHorizontalLines",
                        table: {
                            headerRows: 1,
                            widths: ["100%"],
                            body: [
                                [
                                    {
                                        text: "CHANGE REQUEST - " + exportTicket.number,
                                        style: "titleHeader"
                                    }
                                ]
                            ]
                        }
                    },
                    {
                        style: "tableStyle",
                        table: {
                            headerRows: 1,
                            widths: ["25%", "25%", "25%", "25%"],
                            body: [
                                [
                                    {
                                        text: "NUMBER",
                                        style: "label"
                                    },
                                    exportTicket.number,
                                    {
                                        text: "RISK",
                                        style: "label"
                                    },
                                    exportTicket.risk
                                ],
                                [
                                    {
                                        text: "REQUESTED BY",
                                        style: "label"
                                    },
                                    exportTicket.requester_name,
                                    {
                                        text: "APPROVAL",
                                        style: "label"
                                    },
                                    exportTicket.approval
                                ],
                                [
                                    {
                                        text: "DEVICE",
                                        style: "label"
                                    },
                                    exportTicket.device,
                                    {
                                        text: "TYPE",
                                        style: "label"
                                    },
                                    exportTicket.type
                                ],
                                [
                                    {
                                        text: "CATEGORY",
                                        style: "label"
                                    },
                                    exportTicket.u_category,
                                    {
                                        text: "STATUS",
                                        style: "label"
                                    },
                                    exportTicket.state
                                ],
                                [
                                    {
                                        text: "ASSIGNMENT GROUP :",
                                        style: "label"
                                    },
                                    exportTicket.group,
                                    {
                                        text: "ASSIGNED TO",
                                        style: "label"
                                    },
                                    exportTicket.assigned
                                ],
                                [
                                    {
                                        text: "WATCH LIST",
                                        style: "label"
                                    },
                                    exportTicket.watchList,
                                    {
                                        text: "APPROVERS",
                                        style: "label"
                                    },
                                    exportTicket.approverList
                                ]
                            ]
                        }
                    },
                    {
                        style: "tableStyle",
                        table: {
                            headerRows: 1,
                            widths: ["100%"],
                            body: [
                                [
                                    {
                                        text: "SHORT DESCRIPTION",
                                        style: "labelHeader"
                                    }
                                ],
                                [exportTicket.short_description]
                            ]
                        }
                    },
                    {
                        style: "tableStyle",
                        table: {
                            headerRows: 1,
                            widths: ["100%"],
                            body: [
                                [
                                    {
                                        text: "DESCRIPTION",
                                        style: "labelHeader"
                                    }
                                ],
                                [exportTicket.description]
                            ]
                        }
                    },
                    {
                        style: "tableStyle",
                        table: {
                            headerRows: 1,
                            widths: ["100%"],
                            body: [
                                [
                                    {
                                        text: "SCHEDULE",
                                        style: "labelHeader"
                                    }
                                ]
                            ]
                        }
                    },
                    {
                        style: "schedule",
                        table: {
                            headerRows: 1,
                            widths: ["25%", "25%", "25%", "25%"],
                            body: [
                                [
                                    {
                                        text: "REQUESTED BY DATE",
                                        style: "label"
                                    },
                                    exportTicket.requested_by_date,
                                    {
                                        text: "ACTUAL START",
                                        style: "label"
                                    },
                                    exportTicket.work_start
                                ],
                                [
                                    {
                                        text: "PLANNED START DATE",
                                        style: "label"
                                    },
                                    exportTicket.start_date,
                                    {
                                        text: "ACTUAL END",
                                        style: "label"
                                    },
                                    exportTicket.work_end
                                ],
                                [
                                    {
                                        text: "PLANNED END DATE",
                                        style: "label"
                                    },
                                    exportTicket.end_date,
                                    {
                                        text: "",
                                        style: "label"
                                    },
                                    " "
                                ]
                            ]
                        }
                    },
                    {
                        style: "tableStyle",
                        table: {
                            headerRows: 1,
                            widths: ["100%"],
                            body: [
                                [
                                    {
                                        text: "IMPLEMENTATION PLAN",
                                        style: "labelHeader"
                                    }
                                ],
                                [exportTicket.implementation_plan]
                            ]
                        }
                    },
                    {
                        style: "tableStyle",
                        table: {
                            headerRows: 1,
                            widths: ["100%"],
                            body: [
                                [
                                    {
                                        text: "BACKOUT PLAN",
                                        style: "labelHeader"
                                    }
                                ],
                                [exportTicket.backout_plan]
                            ]
                        }
                    },
                    {
                        style: "tableStyle",
                        table: {
                            headerRows: 1,
                            widths: ["100%"],
                            body: [
                                [
                                    {
                                        text: "TEST PLAN",
                                        style: "labelHeader"
                                    }
                                ],
                                [exportTicket.test_plan]
                            ]
                        }
                    },
                    {
                        style: "tableStyle",
                        table: {
                            headerRows: 1,
                            widths: ["100%"],
                            body: [
                                [
                                    {
                                        text: "COMMENTS/ACTIVTY",
                                        style: "labelHeader"
                                    }
                                ]
                            ]
                        }
                    },
                    {
                        style: "schedule",
                        table: {
                            headerRows: 1,
                            widths: ["25%", "25%", "25%", "25%"],
                            body: exportTicket.commentActivity
                        }
                    }
                ],
                styles: {
                    titleHeader: {
                        bold: true,
                        fontSize: 14,
                        color: "white",
                        alignment: "center",
                        fillColor: "#4c6a54",
                        margin: [0, 5, 0, 5]
                    },
                    label: {
                        fillColor: "grey",
                        color: "white"
                    },
                    labelHeader: {
                        fontSize: 12,
                        color: "white",
                        alignment: "center",
                        fillColor: "#4c6a54"
                    },
                    labelComment: {
                        fillColor: "grey",
                        color: "white",
                        alignment: "center"
                    },
                    tableStyle: {
                        margin: [0, 15, 0, 0],
                        fontSize: 10
                    },
                    schedule: {
                        fontSize: 10
                    }
                }
            };
            /* eslint-disable */
            pdfMake.createPdf(dd).download("Change_Request-" + exportTicket.number);
            /* eslint-enable */
            // }
            // });
        };

        vm.contact = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ContactController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                if (data) {
                    vm.caller_name = data.name;
                    vm.caller_id = data.caller_id;
                }
            });
        };

        vm.watch_list = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ContactController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                if (data) {
                    var insert_data = {
                        sys_id: data.caller_id,
                        name: data.name
                    };
                    vm.watch_list_users.push(insert_data);
                }
            });
        };

        vm.expandAlert = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/uchangerequest/alert.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: Alert,
                controllerAs: "vm"
            });
            modalInst.result.then(function () {});
        };
    }

    function Alert($uibModalInstance) {
        let vm = this;
        vm.close = () => {
            $uibModalInstance.dismiss("cancel");
        };
    }
})();

(function () {
    angular.module("burWood").factory("Ticket", Ticket);

    function Ticket(ServiceNow) {
        return {
            getTicket: (callback, company) => {
                let table_names = [
                    "incident|ticketsList",
                    "problem|ticketsList",
                    "change_request|ticketsList",
                    "sc_request|ticketsList"
                ];
                let query_obj = {
                    tableNames: table_names,
                    company_sys: company
                };
                ServiceNow.getMultipleTables(callback, query_obj);
            }
        };
    }
})();

(function () {
    "use strict";

    angular.module("burWood").controller("TicketController", TicketController).filter("RemoveEmail", RemoveEmail);

    function RemoveEmail() {
        return function (user) {
            if (user) {
                var emailRemoved = user.replace(/\s*\(.*?\)\s*/g, "");
                return emailRemoved;
            }
        };
    }

    /** @ngInject */
    function TicketController(Ticket, DTOptionsBuilder, DTColumnDefBuilder, $state, $stateParams, $document) {
        var vm = this;
        vm.loading = true;
        var sortDevice = $stateParams.device;
        var ticketsWaitingFilter = $stateParams.ticketsWaiting;

        Ticket.getTicket(function (data) {
            vm.loading = false;
            vm.tickets = [];
            if (!data.error || data.results) {
                vm.tickets = data.results;
            }
            angular.forEach(vm.tickets, function (ticket) {
                ticket["priority_number"] = 5;
                if (ticket["priority"] && ticket["priority"] != "") {
                    ticket["priority_number"] = ticket.priority[0];
                }
            });
            vm.customTitle = "All Tickets";

            function formatTable(data, row, column) {
                var pri;
                if (column === 1) {
                    if (data.indexOf("5 - Informational") != -1) {
                        pri = "5 - Informational";
                    } else if (data.indexOf("4 - Minimal") != -1) {
                        pri = "4 - Minimal";
                    } else if (data.indexOf("3 - Moderate") != -1) {
                        pri = "3 - Moderate";
                    } else if (data.indexOf("2 - High") != -1) {
                        pri = "2 - High";
                    } else if (data.indexOf("1 - Critical") != -1) {
                        pri = "1 - Critical";
                    }
                    return pri;
                } else if (column === 2 || column === 3) {
                    var start_pos = data.indexOf(">") + 1;
                    var end_pos = data.indexOf("<", start_pos);
                    var text_to_get = data.substring(start_pos, end_pos);
                    return text_to_get;
                }
                return data;
            }
            var buttonConfig = [
                {
                    extend: "excel",
                    title: function () {
                        return vm.customTitle;
                    },
                    filename: function () {
                        return vm.customTitle.replace(/ /g, "_");
                    },
                    exportOptions: {
                        format: {
                            body: function (data, row, column, node) {
                                return formatTable(data, row, column, node);
                            }
                        }
                    }
                },
                {
                    extend: "pdf",
                    title: function () {
                        return vm.customTitle;
                    },
                    filename: function () {
                        return vm.customTitle.replace(/ /g, "_");
                    },
                    customize: function (doc) {
                        doc.pageMargins = [5, 5, 5, 5];
                        doc.styles.tableHeader.fontSize = 10;
                        doc.defaultStyle.fontSize = 6;
                    },
                    exportOptions: {
                        format: {
                            body: function (data, row, column, node) {
                                return formatTable(data, row, column, node);
                            }
                        }
                    }
                },
                {
                    extend: "csv",
                    title: function () {
                        return vm.customTitle;
                    },
                    filename: function () {
                        return vm.customTitle.replace(/ /g, "_");
                    },
                    exportOptions: {
                        format: {
                            body: function (data, row, column, node) {
                                return formatTable(data, row, column, node);
                            }
                        }
                    }
                }
            ];
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('lf<".table-scroll"rt>ip')
                .withDOM('lBf<"#dt-title">rtip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withOption("order", [["8", "des"]])
                .withButtons(buttonConfig)
                .withOption("iDisplayLength", 10)
                .withOption("responsive", true)
                .withOption("initComplete", function () {
                    if (sortDevice) {
                        $document.querySelector("#dt-title").textContent = "Show All Tickets";
                        var table = angular.element(".table").DataTable();
                        table.column(3).search(sortDevice).draw();
                    } else if (ticketsWaitingFilter) {
                        $document.querySelector("#dt-title").textContent = "Show All Tickets";
                        var table2 = angular.element(".table").DataTable();
                        table2.column(7).search("Waiting for Customer").draw();
                    } else {
                        angular.element("#dt-title").remove();
                    }
                });
            vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef([8, 9]).withOption("type", "date")];

            angular.element("body").on("click", "#dt-title", function () {
                angular.element("#dt-title").remove();
                var table = angular.element(".table").DataTable();
                table.search("").columns().search("").draw();
            });

            vm.goToDevice = function (device) {
                $state.go("index.devices", {
                    redirectedDevice: device
                });
            };

            vm.goToTicket = function (number, sys_id) {
                switch (number.substring(0, 3)) {
                    case "INC":
                        $state.go("index.status_single", {
                            statusID: sys_id
                        });
                        break;
                    case "CUS":
                        $state.go("index.uchange_single", {
                            requestID: sys_id
                        });
                        break;
                    case "CHG":
                        $state.go("index.uchange_single", {
                            requestID: sys_id
                        });
                        break;
                    case "PRB":
                        $state.go("index.problem_single", {
                            problemID: sys_id
                        });
                        break;
                    case "REQ":
                        $state.go("index.request_single", {
                            reqID: sys_id
                        });
                        break;
                    default:
                        break;
                }
            };

            vm.dtInstance = {};
            vm.showFilters = false;
        });
    }
})();

(function () {
    angular.module("burWood").factory("Status", Status);

    function Status(ServiceNow) {
        return {
            getIncident: (state, callback, page_limit, offset, company) => {
                let query_obj = {
                    active_status: true,
                    type: "ticket",
                    company_sys: company
                };
                ServiceNow.getTable(state, "incident|ticketsList", callback, page_limit, offset, query_obj);
            },
            getSingle: (incId, callback) => {
                ServiceNow.getItem(incId, "incident|ticketsList", callback);
            },
            getSingleHistory: (incId, callback) => {
                ServiceNow.getItem(incId, "sys_history_line", callback);
            },
            getCompanyUser: (callback, company_id, page_limit, offset) => {
                ServiceNow.getCompanyUser(callback, company_id, page_limit, offset);
            },
            getUser: (userId, callback) => {
                ServiceNow.getItem(userId, "sys_user", callback);
            },
            getUserGroup: (userId, callback) => {
                ServiceNow.getItem(userId, "sys_user_group", callback);
            },
            getDevice: (devId, callback) => {
                ServiceNow.getItem(devId, "cmdb_ci", callback);
            },
            getHistory: (incId, callback, page_limit, offset) => {
                ServiceNow.getHistory(incId, callback, page_limit, offset);
            },
            getJournal: (incId, callback, page_limit, offset) => {
                ServiceNow.getJournal(incId, callback, page_limit, offset);
            },
            createStatus: (status, callback) => {
                ServiceNow.createItem("incident", status, callback);
            },
            createComment: (status, callback) => {
                ServiceNow.createItem("incident_task", status, callback);
            },
            deleteStatus: (incId, callback) => {
                ServiceNow.deleteItem("incident", incId, callback);
            },
            updateStatus: (incId, status, callback) => {
                ServiceNow.updateItem("incident", incId, status, callback);
            }
        };
    }
})();

(function () {
    "use strict";

    angular.module("burWood").controller("StatusController", StatusController).filter("RemoveEmail", RemoveEmail);

    function RemoveEmail() {
        return (user) => {
            if (user) {
                let emailRemoved = user.replace(/\s*\(.*?\)\s*/g, "");
                return emailRemoved;
            }
        };
    }

    /** @ngInject */
    function StatusController(
        _,
        user_info,
        $stateParams,
        $uibModal,
        $state,
        $cookies,
        Status,
        Service,
        DTColumnDefBuilder,
        DTOptionsBuilder,
        $window,
        ServiceNow,
        util,
        FileSaver,
        $log,
        Alerts,
        $timeout
    ) {
        let vm = this;
        let offset = 0,
            page = 10;
        vm.showImpact = false;
        vm.showUrgency = false;
        vm.sortStart = $stateParams.sort;
        vm.sortType = $stateParams.type;
        vm.sortState = $stateParams.state;
        vm.customTitle = "Incident Tickets";

        vm.priorities = {
            1: "Critical",
            2: "High",
            3: "Moderate",
            4: "Minimal",
            5: "Informational"
        };

        vm.stateNames = {
            1: "New",
            2: "Work In Progress",
            3: "Assigned",
            14: "Waiting for Customer",
            12: "Waiting for Vendor",
            15: "Waiting on Problem",
            6: "Resolved",
            8: "Cancelled",
            13: "Scheduled Work"
        };

        vm.priority = {
            1: "Critical",
            2: "High",
            3: "Moderate",
            4: "Minimal",
            5: "Informational"
        };

        vm.alerts = [];

        vm.createAlertMessage = (alert) => {
            vm.alerts.push({
                status: alert.status,
                msg: alert.msg
            });

            Alerts.storeAlert({
                type: alert.status,
                message: alert.msg,
                user: user_info.email,
                company: user_info.company_name,
                location: $state.current.name,
                tags: ["Incidents"]
            });

            if (alert.status === "success") {
                $timeout(() => {
                    vm.alerts = [];
                }, 5000);
            }
        };

        vm.formatTable = (data, row, column) => {
            var pri;
            if (column === 1) {
                if (data.indexOf("5 - Informational") != -1) {
                    pri = "5 - Informational";
                } else if (data.indexOf("4 - Minimal") != -1) {
                    pri = "4 - Minimal";
                } else if (data.indexOf("3 - Moderate") != -1) {
                    pri = "3 - Moderate";
                } else if (data.indexOf("2 - High") != -1) {
                    pri = "2 - High";
                } else if (data.indexOf("1 - Critical") != -1) {
                    pri = "1 - Critical";
                }
                return pri;
            } else if (column === 2 || column === 3) {
                var start_pos = data.indexOf(">") + 1;
                var end_pos = data.indexOf("<", start_pos);
                var text_to_get = data.substring(start_pos, end_pos);
                return text_to_get;
            }
            return data;
        };
        let columnFilter = {
            aoColumns: [
                null,
                null,
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                }
            ]
        };

        vm.showResolved = true;
        let buttonConfig = [
            {
                text: "Exclude Resolved",
                key: "1",
                action: (e, dt, node) => {
                    vm.showResolved = !vm.showResolved;
                    let table = angular.element(".table").DataTable();
                    if (vm.showResolved) {
                        node[0].innerText = "Exclude Resolved";
                        table.columns(8).search("").draw();
                    } else {
                        node[0].innerText = "Include Resolved";
                        table
                            .column(8)
                            .search(
                                "New|Work In Progress|Waiting for Customer|Waiting for Vendor|Scheduled Work",
                                true,
                                false
                            )
                            .draw();
                    }
                }
            },
            {
                text: "Search Closed Tickets",
                key: "2",
                action: () => {
                    angular.element("#global_search").triggerHandler("click");
                }
            },
            {
                extend: "colvis",
                text: "Toggle Columns"
            },
            {
                extend: "collection",
                text: "Export",
                buttons: [
                    {
                        extend: "excel",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.formatTable(data, row, column, node);
                                }
                            }
                        }
                    },
                    {
                        extend: "pdf",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        customize: (doc) => {
                            doc.pageMargins = [5, 5, 5, 5];
                            doc.styles.tableHeader.fontSize = 10;
                            doc.defaultStyle.fontSize = 6;
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.formatTable(data, row, column, node);
                                }
                            }
                        }
                    },
                    {
                        extend: "csv",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.formatTable(data, row, column, node);
                                }
                            }
                        }
                    }
                ]
            }
        ];

        if (vm.sortStart && vm.sortType === "Incident") {
            buttonConfig.unshift({
                text: "Show All Incidents",
                key: "1",
                action: (e, dt, node) => {
                    let table = angular.element(".table").DataTable();
                    table.search("").columns().search("").draw();
                    angular.element(node[0]).addClass("hidden");
                }
            });
        }

        let activityFilter = columnFilter;
        delete activityFilter.aoColumns.shift();

        vm.dtActivityOptions = DTOptionsBuilder.newOptions()
            .withOption("order", [["4", "des"]])
            .withColumnFilter(activityFilter)
            .withOption("responsive", true);
        vm.dtColumnDefsActivity = [
            DTColumnDefBuilder.newColumnDef(4).withOption("type", "date"),
            DTColumnDefBuilder.newColumnDef([3]).withClass("max-size-activity"),
            DTColumnDefBuilder.newColumnDef([1, 2, 4]).withClass("vert-align-activity")
        ];
        if (vm.sortStart && vm.sortType === "Incident") {
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('lfB<".table-scroll"rt>ip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withButtons(buttonConfig)
                .withColumnFilter(columnFilter)
                .withOption("responsive", true)
                .withOption("iDisplayLength", 10)
                .withOption("order", [["10", "des"]])
                .withOption("initComplete", () => {
                    let table = angular.element(".table").DataTable();
                    if (vm.sortState === "Resolved") {
                        table.column(8).search(vm.sortState).draw();
                    } else if (vm.sortState === "Active") {
                        table
                            .column(8)
                            .search(
                                "Open|Pending Change|Known Error|New|Assigned|Waiting for Customer|Waiting for Vendor|Work in Progress",
                                true,
                                false
                            )
                            .draw();
                    }
                    table.column(2).search(vm.sortStart).draw();
                });
            vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef([10, 11]).withOption("type", "date")];
        } else {
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('lfB<".table-scroll"rt>ip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withButtons(buttonConfig)
                .withColumnFilter(columnFilter)
                .withOption("order", [["10", "des"]])
                .withOption("iDisplayLength", 10)
                .withOption("responsive", true);
            vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef([10, 11]).withOption("type", "date")];
        }

        vm.dtInstance = {};
        vm.showFilters = false;
        vm.current_user_id = user_info.sys_id;
        vm.loading = true;
        vm.watch_list_selected = null;
        vm.watch_list_email = null;
        vm.action = "";
        vm.watch_lists = [];
        vm.watch_list_show = false;
        vm.related_show = false;

        vm.watch_list_users = [];

        var exceptions;

        Service.getExceptions((data) => {
            if (data.results) {
                exceptions = data.results;
            }
        }, user_info.company);

        vm.goToDevice = (device) => {
            let except = false;
            for (let x = 0; x < exceptions.length; x++) {
                if (device.toLowerCase() === exceptions[x].name.toLowerCase()) {
                    except = true;
                }
            }
            if (except) {
                $state.go("index.devices", {
                    redirectedDevice: device,
                    exception: true
                });
            } else {
                $state.go("index.devices", {
                    redirectedDevice: device
                });
            }
        };

        vm.goToTicket = (sys_id) => {
            $state.go("index.status_single", {
                statusID: sys_id
            });
        };

        vm.extractDisplayValue = (object, field) => {
            if (object[field]) {
                vm[field] = vm.extractSysID(object[field].link);
                return object[field].display_value;
            } else {
                return new String("");
            }
        };

        vm.extractSysID = (value) => {
            let stringSplit = value.split("/");
            var sys_id = stringSplit[stringSplit.length - 1];
            return sys_id;
        };

        let loadStatus = () => {
            let statusId = $stateParams.statusID;
            Status.getSingle(statusId, (data) => {
                vm.loading = false;
                if (data.error) {
                    vm.status = [];
                    vm.createAlertMessage({
                        msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                            data.error.detail ? data.error.detail : ""
                        }`,
                        status: "fail"
                    });
                } else {
                    vm.related_show = false;
                    vm.show_related();
                    vm.status = data.results;
                    vm.status.comments = null;
                    var watch_lists_arr = vm.status.watch_list;
                    vm.status.caller_id.value === user_info.sys_id ? (vm.ticketOwner = true) : (vm.ticketOwner = false);

                    let displayFields = ["assigned_to", "opened_by", "assignment_group", "cmdb_ci", "caller_id"];
                    displayFields.forEach((field) => {
                        vm.status[field] = vm.extractDisplayValue(vm.status, field);
                    });

                    vm.watch_lists = [];
                    if (
                        watch_lists_arr != undefined &&
                        watch_lists_arr != null &&
                        watch_lists_arr != "" &&
                        watch_lists_arr != " "
                    ) {
                        vm.watch_lists = watch_lists_arr.split(",");
                    }
                    for (var key in vm.watch_lists) {
                        var user_id = vm.watch_lists[key];
                        if (user_id.indexOf("@") == -1) {
                            Status.getUser(user_id, (data) => {
                                var item;
                                if (data.results) {
                                    item = {
                                        sys_id: data.results.sys_id,
                                        name: data.results.name
                                    };
                                    let found = vm.watch_list_users.some((el) => {
                                        return el.name === data.results.name;
                                    });
                                    if (!found) {
                                        vm.watch_list_users.push(item);
                                    }
                                } else {
                                    if (user_id != null && user_id != "") {
                                        item = {
                                            sys_id: user_id,
                                            name: user_id
                                        };
                                        var found2 = vm.watch_list_users.some((el) => {
                                            return el.name === user_id;
                                        });
                                        if (!found2) {
                                            vm.watch_list_users.push(item);
                                        }
                                    }
                                }
                            });
                        } else {
                            vm.watch_list_users.push({
                                name: user_id,
                                sys_id: ""
                            });
                        }
                    }
                }
            });
        };

        vm.create = (status, $valid) => {
            vm.loading = true;
            vm.alerts = [];
            status.opened_by = user_info.sys_id;
            if (vm.caller_id) {
                status.caller_id = vm.caller_id;
            }
            if (vm.device_id) {
                status.cmdb_ci = vm.device_id;
            }
            status.contact_type = "self-service";
            status.company = user_info.company;
            var p1Ticket = {};
            if ($state.current.name === "index.status_p1phone") {
                p1Ticket.short_description = "P1 Voice Issue";
                p1Ticket.caller_id = vm.caller_id;
                p1Ticket.priority = "1";
                p1Ticket.impact = "1";
                p1Ticket.urgency = "1";
                p1Ticket.u_category = "Unified Communications";
                p1Ticket.contact_type = "self-service";
                p1Ticket.company = user_info.company;
                p1Ticket.description =
                    "Description: " +
                    status.description +
                    "\n" +
                    "Location: " +
                    status.location +
                    "\n" +
                    "User: " +
                    vm.caller_id +
                    "\n" +
                    "Phone/Extenstion: " +
                    status.phone;
                status = p1Ticket;
            }

            if ($valid) {
                Status.createStatus(status, (data) => {
                    vm.loading = false;
                    if (data.error) {
                        vm.status = [];
                        vm.createAlertMessage({
                            msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                                data.error.detail ? data.error.detail : ""
                            }`,
                            status: "fail"
                        });
                    } else if (data.result) {
                        if (vm.attachmentList.length != 0) {
                            let count = 0;
                            for (let x = 0; x < vm.attachmentList.length; x++) {
                                ServiceNow.addAttachment(data.result.sys_id, "incident", [vm.attachmentList[x]], () => {
                                    count++;
                                    if (count === vm.attachmentList.length) {
                                        $uibModal.open({
                                            templateUrl: "app/shared/html/ticketConfirmation.html",
                                            ariaLabelledBy: "modal-title",
                                            ariaDescribedBy: "modal-body",
                                            controller: "TicketRedirectController",
                                            controllerAs: "vm",
                                            resolve: {
                                                ticket: () => {
                                                    return {
                                                        number: data.result.number,
                                                        sys_id: data.result.sys_id
                                                    };
                                                },
                                                field: () => "statusID",
                                                route: () => "status_single"
                                            }
                                        });
                                    }
                                });
                            }
                        } else {
                            $uibModal.open({
                                templateUrl: "app/shared/html/ticketConfirmation.html",
                                ariaLabelledBy: "modal-title",
                                ariaDescribedBy: "modal-body",
                                controller: "TicketRedirectController",
                                controllerAs: "vm",
                                resolve: {
                                    ticket: () => {
                                        return {
                                            number: data.result.number,
                                            sys_id: data.result.sys_id
                                        };
                                    },
                                    field: () => "statusID",
                                    route: () => "status_single"
                                }
                            });
                        }
                    } else {
                        vm.createAlertMessage({
                            msg: "Failed to update ticket",
                            status: "fail"
                        });
                    }
                });
            } else {
                vm.createAlertMessage({
                    msg: "Invalid Form",
                    status: "fail"
                });
            }
        };

        vm.update = (stateId, status) => {
            vm.loading = true;
            vm.alerts = [];
            var comment_status = {};
            var new_status = {};
            if (vm.action == "update") {
                var watch_list_arr = [];
                var temp_watch_list = Object.assign({}, vm.watch_list_users);
                for (var key in temp_watch_list) {
                    watch_list_arr.push(temp_watch_list[key].sys_id);
                }
                var request_watch_list = watch_list_arr.join(",");
                if (!vm.status.contact_type) {
                    vm.status.contact_type = "phone";
                }
                new_status.watch_list = request_watch_list;

                comment_status.short_description = vm.status.short_description;
                comment_status.description = vm.status.description;
                comment_status.incident = vm.status.sys_id;
                comment_status.assignment_group = vm.status.assignment_group;
                comment_status.assigned_to = vm.status.assigned_to;
                comment_status.company = user_info.company;

                // Status.createComment(comment_status, function () {});

                new_status.short_description = vm.status.short_description;
                new_status.comments = vm.status.comments;
                new_status.contact_type = vm.status.contact_type;
                console.log(new_status);
                Status.updateStatus(stateId, new_status, (data) => {
                    console.log(data);
                    vm.loading = false;
                    if (data.error) {
                        vm.loading = false;
                        vm.createAlertMessage({
                            msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                                data.error.detail ? data.error.detail : ""
                            }`,
                            status: "fail"
                        });
                    } else if (data.result) {
                        vm.createAlertMessage({
                            msg: "Ticket successfully updated.",
                            status: "success"
                        });
                        vm.show_related(true);
                    } else {
                        vm.createAlertMessage({
                            msg: "Failed to update ticket",
                            status: "fail"
                        });
                    }
                });
            } else if (vm.action == "resolve") {
                status.state = 6;
                new_status = {};
                new_status.state = 6;
                new_status.contact_type = status.contact_type;
                new_status.comments = status.comments;
                if (new_status.contact_type == "") {
                    new_status.contact_type = "self-service";
                }
                Status.updateStatus(stateId, new_status, (data) => {
                    vm.loading = false;
                    if (data.error) {
                        vm.loading = false;
                        vm.createAlertMessage({
                            msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                                data.error.detail ? data.error.detail : ""
                            }`,
                            status: "fail"
                        });
                    } else if (data.result) {
                        vm.status = data.result;
                        vm.createAlertMessage({
                            msg: "Ticket successfully updated.",
                            status: "success"
                        });
                        loadStatus();
                    } else {
                        vm.createAlertMessage({
                            msg: "Failed to update ticket",
                            status: "fail"
                        });
                    }
                });
            } else if (vm.action == "workInProgress") {
                if (!vm.status.comments) {
                    vm.loading = false;
                    vm.createAlertMessage({
                        msg: "Please add comment to revert incident to 'Work in Progress",
                        status: "fail"
                    });
                } else {
                    new_status = {};
                    new_status.state = 2;
                    new_status.comments = vm.status.comments;
                    Status.updateStatus(stateId, new_status, (data) => {
                        vm.loading = false;
                        if (data.error) {
                            vm.loading = false;
                            vm.createAlertMessage({
                                msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                                    data.error.detail ? data.error.detail : ""
                                }`,
                                status: "fail"
                            });
                        } else if (data.result) {
                            vm.status = data.result;
                            vm.createAlertMessage({
                                msg: "Ticket moved to Work in Progress.",
                                status: "success"
                            });
                            loadStatus();
                        } else {
                            vm.createAlertMessage({
                                msg: "Failed to update ticket",
                                status: "fail"
                            });
                        }
                    });
                }
            }
        };
        vm.delete = (stateId) => {
            Status.deleteStatus(stateId, (data) => {
                if (data.error) {
                    vm.createAlertMessage({
                        msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                            data.error.detail ? data.error.detail : ""
                        }`,
                        status: "fail"
                    });
                } else {
                    vm.createAlertMessage({
                        msg: `Successfully deleted`,
                        status: "success"
                    });
                }
            });
        };
        vm.switch_watchlist = () => {
            vm.watch_list_show = !vm.watch_list_show;
        };

        vm.findToRemoveById = (user_id) => {
            for (let i = 0; i < vm.watch_list_users.length; i++) {
                let user = vm.watch_list_users[i];
                if (user["sys_id"] == user_id) {
                    vm.watch_list_users.splice(i, 1);
                    return user_id;
                }
            }
        };

        vm.delete_watchlist = () => {
            angular.element(".watch-list-select option:selected").remove();
            if (vm.watch_list_selected != null) {
                angular.forEach(vm.watch_list_selected, (user_id) => {
                    vm.findToRemoveById(user_id);
                });
            }
        };

        vm.addEmail_watchlist = (user_email) => {
            if (user_email == null || user_email == "") {
                return;
            }
            let user = {
                sys_id: user_email,
                name: user_email
            };
            vm.add_watchlist(user);
        };
        vm.add_watchlist = (watch_list) => {
            if (vm.watch_list_users.length > 0) {
                vm.watch_list_users.push(watch_list);
            } else {
                vm.watch_list_users = [watch_list];
            }
            vm.watch_list_email = null;
        };
        vm.go_back = () => {
            $window.history.back();
        };

        vm.page_changed = () => {
            vm.offset = parseInt(vm.current_page - 1) * page;
            $state.go("index.incidents", {
                offset: vm.offset
            });
        };

        vm.close_notice = (index) => {
            vm.alerts.splice(index, 1);
        };

        vm.contact = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ContactController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                if (data) {
                    vm.caller_name = data.name;
                    vm.caller_id = data.caller_id;
                }
            });
        };

        vm.device = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/device_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "DeviceListController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                vm.device_name = data.name;
                vm.device_id = data.device_id;
            });
        };

        vm.watch_list = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ContactController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                if (data) {
                    var insert_data = {
                        sys_id: data.caller_id,
                        name: data.name
                    };
                    vm.watch_list_users.push(insert_data);
                }
            });
        };

        vm.show_related = (update) => {
            if (vm.related_show == true && !update) {
                vm.related_show = false;
                return;
            }
            let statusId = $stateParams.statusID;
            vm.related_show = true;
            vm.related_loading = true;
            vm.getJournalEntries(statusId);
        };

        vm.getJournalEntries = (statusID) => {
            Status.getJournal(
                statusID,
                (data) => {
                    if (data.error) {
                        vm.related_loading = false;
                        $log.info(data.error);
                    } else {
                        vm.related_result = [];
                        let journals = data.results;
                        if (journals) {
                            journals.forEach((journal) => {
                                if (journal.element === "comments" || journal.element === "status") {
                                    if (journal.element.indexOf("_") != -1) {
                                        journal.element = journal.element.replace("_", " ");
                                        journal.element = util.capitalizeFirstLetter(journal.element);
                                    } else {
                                        journal.element = util.capitalizeFirstLetter(journal.element);
                                    }
                                    let addHistory = {
                                        sortDate: journal.sys_created_on.toString(),
                                        sys_created_on: journal.sys_created_on.toString(),
                                        value: journal.value,
                                        sys_created_by: journal.sys_created_by,
                                        element: journal.element
                                    };
                                    vm.related_result.push(addHistory);
                                }
                            });
                        }
                        vm.getHistoryLine(statusID);
                    }
                },
                300,
                0
            );
        };

        vm.getHistoryLine = (statusID) => {
            Status.getHistory(
                statusID,
                (data) => {
                    if (data.error) {
                        vm.related_loading = false;
                        $log.info(data.error);
                    } else {
                        let noDuplicate = [];
                        let histories = data.results;
                        if (histories) {
                            histories.forEach((history) => {
                                if (history.field === "state") {
                                    let addActivity = {
                                        sortDate: history.update_time,
                                        sys_created_on: history.update_time,
                                        value: history.new,
                                        sys_created_by: history.u_name_id,
                                        element: history.label
                                    };
                                    if (noDuplicate.indexOf(history.new) == -1) {
                                        noDuplicate.push(history.new);
                                        vm.related_result.push(addActivity);
                                    }
                                }
                            });
                        }
                    }
                    vm.getFieldChanges(statusID);
                },
                300,
                0
            );
        };

        vm.getFieldChanges = (statusID) => {
            Service.getQuery(
                {
                    tablename: "incident",
                    fieldname: "priority",
                    documentkey: statusID
                },
                "sys_audit",
                (auditResponse) => {
                    if (auditResponse.error) {
                        vm.related_loading = false;
                        $log.info(auditResponse.error);
                    } else {
                        let audits = auditResponse.results;
                        if (audits) {
                            audits.forEach((audit) => {
                                let addActivity = {
                                    sortDate: audit.sys_created_on,
                                    sys_created_on: audit.sys_created_on,
                                    value: vm.priorities[audit.newvalue],
                                    sys_created_by: audit.sys_created_by,
                                    element: util.capitalizeFirstLetter(audit.fieldname)
                                };
                                vm.related_result.push(addActivity);
                            });
                        }
                    }
                    vm.getAttachedFiles(statusID);
                }
            );
        };

        let attachmentLength = 0;
        let attachmentIndex = 0;

        vm.getAttachedFiles = (statusID) => {
            ServiceNow.getAllAttachment(statusID, "incident", 10, 10, (data) => {
                if (data && data.result && data.result.length > 0) {
                    let attachments = data.result;
                    attachmentLength = data.result.length;
                    attachments.forEach((attachment) => {
                        vm.getSingleFileData(attachment);
                    });
                } else {
                    vm.related_result.sort((a, b) => {
                        return new Date(a.sortDate) - new Date(b.sortdate);
                    });
                    vm.related_loading = false;
                }
            });
        };

        vm.nonImageAttachments = {};

        vm.getSingleFileData = (attachment) => {
            ServiceNow.getAttachment(attachment.sys_id, (data) => {
                if (data) {
                    let blobData = new Blob([data], {
                        type: attachment.content_type
                    });

                    let activityItem = {
                        sortDate: attachment.sys_created_on,
                        sys_created_on: attachment.sys_created_on,
                        dataURL: "",
                        sys_created_by: attachment.sys_created_by,
                        element: "Attachment"
                        // element: attachment.content_type
                    };

                    if (attachment && attachment.content_type.includes("image")) {
                        activityItem.dataURL = URL.createObjectURL(blobData);
                        activityItem.image = true;
                    } else {
                        vm.nonImageAttachments[attachment.file_name] = blobData;
                        activityItem.dataURL = attachment.file_name;
                        activityItem.image = false;
                    }

                    vm.related_result.push(activityItem);
                }
                attachmentIndex++;
                if (attachmentLength === attachmentIndex) {
                    vm.related_result.sort((a, b) => {
                        return new Date(a.sortDate) - new Date(b.sortdate);
                    });
                    attachmentLength = 0;
                    attachmentIndex = 0;
                    vm.related_loading = false;
                }
            });
        };

        vm.downloadFromActivity = (file) => {
            let blobData = vm.nonImageAttachments[file];
            FileSaver.saveAs(blobData, file);
        };

        vm.detail_loading = {};
        vm.related_detail = {};

        vm.show_related_detail = (sys_id, key) => {
            vm.detail_loading[key] = true;
            Status.getSingleHistory(sys_id, (data) => {
                vm.detail_loading[key] = false;
                if (data.error) {
                    vm.related_detail[key] = [];
                } else {
                    vm.related_detail[key] = data.result;
                }
            });
        };

        vm.related_filter = (item) => {
            return (
                item.label == "Priority" ||
                item.label == "Short description" ||
                item.label == "Status" ||
                item.label == "Additional comments"
            );
        };

        vm.attachmentList = [];
        vm.attachment = () => {
            let modalInst = $uibModal.open({
                resolve: {
                    list: () => {
                        return vm.attachmentList;
                    },
                    params: () => {
                        return {
                            table: "incident",
                            newTable: "status_new",
                            fieldID: "statusID"
                        };
                    }
                },
                templateUrl: "app/shared/html/attachment_form.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "AttachmentController",
                controllerAs: "vm"
            });
            modalInst.result.then(
                (data) => {
                    vm.attachmentList = data;
                    vm.related_show = false;
                    vm.show_related(true);
                },
                () => {
                    vm.related_show = false;
                    vm.show_related(true);
                }
            );
        };

        var state_name = $state.current.name;
        switch (state_name) {
            case "index.status_new":
                vm.loading = false;
                vm.caller_name = user_info.name;
                vm.caller_id = user_info.sys_id;
                vm.opened_by_name = user_info.name;
                vm.opened_by_id = user_info.sys_id;
                break;
            case "index.status_p1phone":
                vm.loading = false;
                vm.caller_name = user_info.name;
                vm.caller_id = user_info.sys_id;
                break;
            case "index.status_single":
                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withDOM('lfB<".table-scroll"rt>ip')
                    .withOption("aoColumnDefs", [
                        {
                            bSortable: false,
                            aTargets: ["nosort"]
                        }
                    ])
                    .withButtons(buttonConfig)
                    .withColumnFilter(columnFilter)
                    .withOption("order", [["4", "des"]])
                    .withOption("iDisplayLength", 10)
                    .withOption("responsive", true);
                vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef(8).withOption("type", "date")];
                vm.loading = true;
                if ($cookies.get("user_role") == "itil") {
                    vm.resolve_button = true;
                } else {
                    vm.resolve_button = false;
                }
                if ($stateParams.statusID != undefined) {
                    loadStatus();
                } else {
                    $state.go("index.incidents");
                }
                break;
            case "index.incidents":
                vm.loading = true;
                Status.getIncident(
                    "",
                    (data) => {
                        vm.loading = false;
                        if (data.error || !data.results) {
                            $log.info(data.error);
                        } else {
                            vm.incidents = data.results;
                            vm.establishParents(vm.incidents);
                        }
                    },
                    5000,
                    offset
                );
                break;
        }

        vm.expandedParent = {};

        vm.establishParents = (rawIncidents) => {
            let incidents = angular.fromJson(angular.toJson(rawIncidents));
            vm.rawIncidents = angular.fromJson(angular.toJson(rawIncidents));
            vm.parents = {};
            vm.children = {};
            vm.parentList = [];
            vm.childrenList = [];
            let incidentsNoChildren = [];
            incidents.forEach((item) => {
                if (item.parent_incident) {
                    vm.children[item.number] = true;
                    let parentNumber = item.parent_incident.display_value;

                    if (vm.childrenList.indexOf(parentNumber) === -1) {
                        vm.childrenList.push(parentNumber);
                    }

                    if (!vm.parents[parentNumber]) {
                        vm.parents[parentNumber] = [item.number];
                    } else {
                        vm.parents[parentNumber].push(item.number);
                    }
                } else {
                    incidentsNoChildren.push(item);
                }
                if (item.child_incidents && item.child_incidents != "0") {
                    vm.parentList.push(item.number);
                }
            });
            vm.childlessParent = vm.findChildlessParent(vm.parentList, vm.childrenList);
            vm.incidents = incidentsNoChildren;
        };

        vm.findChildlessParent = (array, compare) => {
            return array.filter((i) => {
                return compare.indexOf(i) < 0;
            });
        };

        vm.expandParent = (incidentNumber) => {
            vm.expandedParent = incidentNumber;
        };

        angular.element("body").on("click", "div.expand-parent", () => {
            let tr = angular.element(this).closest("tr");
            let table = angular.element(".table").DataTable();
            let row = table.row(tr);
            let childArray = [];

            vm.rawIncidents.forEach((child) => {
                if (child.parent_incident && child.parent_incident.display_value === vm.expandedParent) {
                    childArray.push(child);
                }
            });

            let childNodes = vm.formatChildren(childArray);

            if (row.child.isShown()) {
                row.child.hide();
                tr.removeClass("shown");
            } else {
                row.child(childNodes, "child-parent-row").show();
                tr.addClass("shown");
            }
        });

        vm.getTableColumnWidths = () => {
            let widthArr = [];
            angular.element("#incidentTable thead tr th").each(() => {
                widthArr.push(angular.element(this).outerWidth() + "px");
            });
            return widthArr;
        };

        vm.formatChildren = (children) => {
            let childNodes = [];
            let columnWidths = vm.getTableColumnWidths();
            children.forEach((item) => {
                let device = item.cmdb_ci;
                !device ? (device = " ") : (device = device.display_value);
                let group = item.assignment_group;
                !group ? (group = " ") : (group = group.display_value);
                let assign = item.assigned_to;
                !assign ? (assign = " ") : (assign = assign.display_value);
                let openedBy = item.opened_by;
                !openedBy ? (openedBy = " ") : (openedBy = openedBy.display_value);
                childNodes.push(
                    '<table id="childTable">' +
                        "<tbody>" +
                        '<tr style="background-color:transparent">' +
                        '<td style="width:' +
                        columnWidths[0] +
                        '" class="childRow"></td>' +
                        '<td style="width:' +
                        columnWidths[1] +
                        '" class="childRow">CHILD</td>' +
                        '<td style="width:' +
                        columnWidths[2] +
                        '" class="text-center childRow">' +
                        item.priority +
                        "</td>" +
                        '<td style="width:' +
                        columnWidths[3] +
                        '" class="childRow"><a href="' +
                        $window.location.origin +
                        "/incident/" +
                        item.sys_id +
                        '">' +
                        item.number +
                        "</a></td>" +
                        '<td style="width:' +
                        columnWidths[4] +
                        '" class="childRow">' +
                        device +
                        "</td>" +
                        '<td style="width:' +
                        columnWidths[5] +
                        '" class="childRow">' +
                        item.short_description +
                        "</td>" +
                        '<td style="width:' +
                        columnWidths[6] +
                        '" class="childRow">' +
                        group +
                        "</td>" +
                        '<td style="width:' +
                        columnWidths[7] +
                        '" class="childRow">' +
                        assign +
                        "</td>" +
                        '<td style="width:' +
                        columnWidths[8] +
                        '" class="childRow">' +
                        item.state +
                        "</td>" +
                        '<td style="width:' +
                        columnWidths[9] +
                        '" class="childRow">' +
                        openedBy +
                        "</td>" +
                        '<td style="width:' +
                        columnWidths[10] +
                        '" class="childRow">' +
                        item.opened_at +
                        "</td>" +
                        '<td style="width:' +
                        columnWidths[11] +
                        '" class="childRow">' +
                        item.sys_updated_on +
                        "</td>" +
                        "</tr>" +
                        "</tbody>" +
                        "</table>"
                );
            });
            return childNodes;
        };

        angular.element("body").on("click", "#dt-title", () => {
            angular.element("#dt-title").remove();
            let table = angular.element(".table").DataTable();
            table.search("").columns().search("").draw();
        });
    }
})();

(function () {
    angular.module("burWood").factory("ssoService", ssoService);

    /** @ngInject */
    function ssoService() {
        let ssoSerives = {
            generatePassword: (length) => {
                let result = "";
                let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
                let charactersLength = characters.length;
                for (let i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return result;
            }
        };

        return ssoSerives;
    }
})();

(function () {
    "use strict";

    angular.module("burWood").controller("SSOController", SSOController);

    /** @ngInject */
    function SSOController(_, $log, BCSServer, $timeout, ServiceNow, Service, ssoService, util) {
        var vm = this;

        vm.loading = true;
        vm.ssoConfigs = [];
        vm.alerts = [];

        var init = true;

        // angular.element('.autocomplete-suggestions').css('margin-left', '0% !important');

        function getSSOConfigs() {
            BCSServer.postData({}, "/get_sso_config", function (response) {
                vm.loading = false;
                if (response) {
                    vm.ssoConfigs = response.sort(util.compare("name"));
                    vm.chooseContent(vm.ssoConfigs[0], 0);
                } else {
                    vm.ssoConfigs = [];
                }
            });
        }
        getSSOConfigs();

        vm.chooseContent = function (config, index, newConfig) {
            var prompt = true;

            if (!angular.equals(vm.selectedSSO, vm.selectedSSOSetting)) {
                prompt = confirm("You have made changes to this company, do you wish to leave?");
            }

            if (prompt) {
                vm.ssoIndex = index;
                vm.selectedSSO = config;
                vm.selectedSSOSetting = angular.copy(vm.selectedSSO);
                vm.newConfigSelected = newConfig;

                if (init) {
                    $timeout(function () {
                        angular.element(".sku-title").removeClass("toggle-border");
                        angular.element("#cloud-company-" + index.toString()).addClass("toggle-border");
                        init = false;
                    }, 100);
                } else {
                    angular.element(".sku-title").removeClass("toggle-border");
                    angular.element("#cloud-company-" + index.toString()).addClass("toggle-border");
                }
            }
        };

        vm.update = function () {
            vm.loading = true;

            if (vm.selectedSSO.certificates.length === 0) {
                createAlertMessage("alerts", "At least one certificate is required for SSO configuration", "fail");
            }

            var newUser = false;

            if (!vm.selectedSSO.service_account) {
                newUser = true;

                var companyCode;

                vm.activeCompanies.forEach(function (company) {
                    if (vm.selectedSSO.name === company.value) {
                        companyCode = company.data.company_code;
                        try {
                            companyCode = companyCode.toLowerCase();
                        } catch (e) {
                            $log.info(e);
                        }
                    }
                });

                if (!companyCode) {
                    vm.loading = false;
                    return createAlertMessage(
                        "alerts",
                        "Failed to create service account.  No corresponding company code.",
                        "fail"
                    );
                }

                var siblingExists = checkSiblingAccounts(vm.selectedSSO.name);

                if (!siblingExists) {
                    vm.selectedSSO.service_account = {
                        user: companyCode + ".sso.serviceaccount",
                        password: ssoService.generatePassword(16)
                    };
                } else {
                    createAlertMessage(
                        "alerts",
                        "Service Account Exists for another configuration.  Adding only to Portal database.",
                        "fail"
                    );
                    newUser = false;
                }
            }

            findCompanyInServiceNow(newUser);
        };

        function checkSiblingAccounts(name) {
            vm.ssoConfigs.forEach(function (ssoAccount) {
                if (ssoAccount.name === name && ssoAccount.service_account) {
                    vm.selectedSSO.service_account = ssoAccount.service_account;
                }
            });
            return vm.selectedSSO.service_account;
        }

        function findCompanyInServiceNow(newUser) {
            var encodedName = encodeURIComponent(vm.selectedSSO.name);
            ServiceNow.getQuery({ name: encodedName }, "core_company", function (results) {
                if (results && results.results && results.results.length > 0) {
                    vm.selectedSSO.sys_id = results.results[0].sys_id;
                    if (newUser) {
                        findUser();
                    }
                    updateSSOConfigs();
                } else {
                    vm.loading = false;
                    createAlertMessage(
                        "alerts",
                        "Failed to create/update company - no corresonding company in Servicenow.  Please contact support for assistance.",
                        "fail"
                    );
                }
            });
        }

        function findUser() {
            Service.getQuery(
                {
                    company: vm.selectedSSO.sys_id,
                    user_name: vm.selectedSSO.service_account.user,
                    bypassCompany: true
                },
                "sys_user",
                function (response) {
                    if (response.error || !response.results || (response.results && response.results.length === 0)) {
                        createServicAccount();
                    } else {
                        createAlertMessage(
                            "alerts",
                            "Service Account Exists in Servicenow.  Adding only to Portal database.",
                            "fail"
                        );
                        vm.loading = false;

                        //Renable after initial import of SSO configs

                        // updatePassword(response.results[0].sys_id);
                    }
                }
            );
        }

        // function updatePassword(user_sys) {
        //     Service.updateItem(
        //         "sys_user",
        //         user_sys,
        //         { user_password: vm.selectedSSO.service_account.password },
        //         function (response) {
        //             if (response.error || !response.result) {
        //                 createAlertMessage(
        //                     "alerts",
        //                     "Failed to create service account. Please Contact Support For Further Assistance.",
        //                     "fail"
        //                 );
        //                 vm.loading = false;
        //             }
        //         }
        //     );
        // }

        function createServicAccount() {
            var userToCreate = {
                user_password: vm.selectedSSO.service_account.password,
                user_name: vm.selectedSSO.service_account.user,
                first_name: "Service",
                last_name: "Account",
                company: vm.selectedSSO.sys_id,
                email: "psegura@burwood.com"
            };

            Service.createItem("sys_user", userToCreate, function (response) {
                vm.loading = false;
                if (response.error || !response.result || !response.result.sys_id) {
                    createAlertMessage(
                        "alerts",
                        "Failed to create service account. Please Contact Support For Further Assistance.",
                        "fail"
                    );
                } else {
                    createAlertMessage("alerts", "Successfully created service account in ServiceNow.", "success");
                }
            });
        }

        vm.delete = function () {
            var prompt = confirm("Are you sure you wish to delete this configuration?");
            if (!prompt) {
                return;
            }
            vm.loading = true;
            BCSServer.postData(vm.selectedSSO, "/delete_sso_config", function (response) {
                vm.loading = false;
                if (response && response === "Success") {
                    createAlertMessage("alerts", "Successfully Deleted Configuration.", "success");
                    vm.ssoConfigs.splice(vm.ssoIndex, 1);
                    vm.chooseContent(vm.ssoConfigs[0], 0);
                } else {
                    createAlertMessage(
                        "alerts",
                        "Failed to delete configuration. Please contact support for assistance.",
                        "fail"
                    );
                }
            });
        };

        function updateSSOConfigs() {
            vm.selectedSSO.domain = vm.selectedSSO.domain.replace(/@/g, "");

            BCSServer.postData(vm.selectedSSO, "/update_sso_config", function (response) {
                if (response.error || !response) {
                    createAlertMessage(
                        "alerts",
                        "Failed To Update Configuration. Please Contact Support For Further Assistance.",
                        "fail"
                    );
                } else {
                    createAlertMessage("alerts", "Successfully Updated SSO Configuration.", "success");
                    vm.selectedSSO = response;
                    vm.selectedSSOSetting = angular.copy(vm.selectedSSO);
                }

                vm.loading = false;
            });
        }

        vm.newConfig = function (event) {
            event.preventDefault();
            event.stopPropagation();
            vm.ssoConfigs.push({
                domain: "",
                name: "",
                attribute: "",
                sys_id: "",
                sso_login_url: "",
                sso_logout_url: "",
                certificates: [" "]
            });
            vm.chooseContent(vm.ssoConfigs[vm.ssoConfigs.length - 1], vm.ssoConfigs.length - 1, "new");
        };

        var defaultItems = {
            certificates: " "
        };

        vm.addItem = function (level, itemType) {
            if (vm[level][itemType] && vm[level][itemType].length > 0) {
                vm[level][itemType].push(angular.copy(defaultItems[itemType]));
            } else {
                vm[level][itemType] = [angular.copy(defaultItems[itemType])];
            }
        };

        vm.removeItem = function (level, itemType, budgetIndex) {
            var prompt = confirm("Are you sure you wish to delete this item?");
            if (!prompt) {
                return;
            }
            vm[level][itemType].splice(budgetIndex, 1);
        };

        vm.close_notice = function (type, index) {
            vm[type].splice(index, 1);
        };

        function createAlertMessage(errorType, message, status) {
            vm[errorType].push({
                status: status,
                msg: message
            });
            $timeout(function () {
                vm[errorType] = [];
            }, 5000);
        }

        function fetchActiveCompanies() {
            vm.activeCompanies = [];

            //get list of avaialable companies by querying contracts - add Burwood and BCS after
            // Navbar.getCompanyList(function (companies) {
            Service.getQuery(
                {
                    valid_company_code: true,
                    bypassCompany: true
                },
                "core_company|cloudList",
                function (companies) {
                    if (!companies || !companies.results || companies.results.length === 0) {
                        return;
                    }

                    companies.results.forEach(function (company) {
                        vm.activeCompanies.push({
                            value: company.name,
                            data: {
                                sys_id: company.sys_id,
                                company_code: company.u_customer_code
                            }
                        });
                    });
                }
            );
        }
        fetchActiveCompanies();

        angular.element("#sso-lookup").devbridgeAutocomplete({
            lookup: vm.activeCompanies,
            showNoSuggestionNotice: true,
            noSuggestionNotice: '<div class="autocomplete-suggestion">No Matching Results</div>',
            triggerSelectOnValidInput: true,
            width: "275px",
            appendTo: angular.element("#sso-container"),
            onSelect: function (suggestion) {
                vm.selectedSSO.name = suggestion.value;
            },
            onSearchStart: function () {
                angular.element(".fa.fa-search").addClass("blinking");
            },
            onSearchComplete: function () {
                angular.element(".fa.fa-search").removeClass("blinking");
            }
        });
    }
})();

(function () {
    angular.module("burWood").factory("ServiceNow", ServiceNow);

    function ServiceNow(_, $http, $q, apiBasePath, moment) {
        let deferred = $q.defer();

        let dateFields = [
            "opened_at",
            "closed_at",
            "resolved_at",
            "sys_created_on",
            "sys_updated_on",
            "update_time",
            "u_contract_start_date",
            "u_contract_end_date",
            "requested_by_date",
            "start_date",
            "end_date",
            "work_start",
            "work_end"
        ];

        const iOS = () => {
            let iDevices = ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"];
            /* eslint-disable */
            if (!!navigator.platform) {
                /* eslint-enable */
                while (iDevices.length) {
                    if (navigator.platform === iDevices.pop()) {
                        return true;
                    }
                }
            }
            return false;
        };

        const processTimeSingle = (item) => {
            dateFields.forEach((field) => {
                if (iOS()) {
                    if (!item[field]) {
                        item[field] = "";
                    } else {
                        item[field] = item[field].replace(/\//g, "-");
                        item[field] = item[field].replace(" ", "T");
                        item[field] = item[field] + "Z";
                        item[field] = new Date(item[field]);
                    }
                } else {
                    if (!item[field]) {
                        item[field] = "";
                    } else {
                        let arr = item[field].split(/[\-\+ :T]/);
                        let date = new Date();
                        date.setUTCFullYear(arr[0]);
                        date.setUTCMonth(arr[1] - 1);
                        date.setUTCDate(arr[2]);
                        date.setUTCHours(arr[3]);
                        date.setUTCMinutes(arr[4]);
                        date.setUTCSeconds(arr[5]);
                        item[field] = date;
                        item[field] = moment(date)
                            .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                            .format("ddd MMM DD YYYY hh:mm:ss A z");
                    }
                }
            });
            return item;
        };

        const processTimeMultiple = (item) => {
            dateFields.forEach((field) => {
                !item[field]
                    ? (item[field] = "")
                    : (item[field] = moment(item[field])
                          .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                          .format("ddd MMM DD YYYY hh:mm:mm A z"));
            });
            return item;
        };

        const convertTime = (object, journal) => {
            if (object) {
                if (angular.isUndefined(object.length)) {
                    var newDates;
                    journal ? (newDates = processTimeSingle(object)) : (newDates = processTimeMultiple(object));
                    // newDates = processTimeSingle(object)
                    return newDates;
                } else {
                    let objectArray = [];
                    object.forEach((item) => {
                        var newDates;
                        journal ? (newDates = processTimeSingle(item)) : (newDates = processTimeMultiple(item));
                        // newDates = processTimeSingle(item)
                        objectArray.push(newDates);
                    });
                    return objectArray;
                }
            }
        };

        return {
            getTable: (state, table_name, callback, page_limit, offset, query_obj) => {
                if (page_limit == undefined) {
                    page_limit = 10;
                }
                if (offset == undefined || offset == "") {
                    offset = 0;
                }
                if (query_obj == undefined) {
                    query_obj = {};
                }
                if (query_obj.sorting == undefined || query_obj.sorting == "") {
                    query_obj.sorting = 0;
                }
                let cb = callback || angular.noop;

                query_obj.page_limit = page_limit;
                query_obj.tableName = table_name;
                query_obj.offset = offset;

                $http.post(apiBasePath + "/servicenow/get_tables", query_obj).then(
                    (data) => {
                        data.data && (data.data.results = convertTime(data.data.results));
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            },
            getContracts: (table_name, company, callback, page_limit, offset, query_obj) => {
                if (page_limit == undefined) {
                    page_limit = 10;
                }
                if (offset == undefined || offset == "") {
                    offset = 0;
                }
                if (query_obj == undefined) {
                    query_obj = {};
                }
                if (query_obj.sorting == undefined || query_obj.sorting == "") {
                    query_obj.sorting = 0;
                }
                let cb = callback || angular.noop;

                query_obj.tableName = table_name;
                query_obj.company_sys = company;

                $http.post(apiBasePath + "/servicenow/get_tables", query_obj).then(
                    (data) => {
                        data.data && (data.data.results = convertTime(data.data.results));
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            },
            getDevice: (callback, page_limit, offset, monitor, report, company_id, state) => {
                if (page_limit == undefined) {
                    page_limit = 10;
                }
                if (offset == undefined || offset == "") {
                    offset = 0;
                }
                if (report == undefined) {
                    report = 0;
                }
                let cb = callback || angular.noop;
                $http
                    .post(apiBasePath + "/servicenow/get_tables", {
                        page_limit: page_limit,
                        tableName: "cmdb_ci|devicesList",
                        offset: offset,
                        monitor: monitor,
                        // All that isn't retired
                        u_state: state,
                        report: report,
                        company_sys: company_id
                    })
                    .then(
                        (data) => {
                            data.data && (data.data.results = convertTime(data.data.results));
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            getDeviceView: (callback, company, ciClass) => {
                let cb = callback || angular.noop;
                $http
                    .post(apiBasePath + "/servicenow/get_tables", {
                        tableName: "u_devicesbysku|devicebyskuList",
                        cmdb_company: company,
                        valid_device: true,
                        sys_class_name: ciClass
                    })
                    .then(
                        (data) => {
                            data.data && (data.data.results = convertTime(data.data.results));
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            getExceptions: (callback, exceptions, company) => {
                let cb = callback || angular.noop;
                $http
                    .post(apiBasePath + "/servicenow/get_tables", {
                        tableName: "cmdb_ci|devicesList",
                        exceptions: exceptions,
                        exCompany: company
                    })
                    .then(
                        (data) => {
                            data.data && (data.data.results = convertTime(data.data.results));
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            getMultipleTables: (callback, query_obj) => {
                let cb = callback || angular.noop;
                $http.post(apiBasePath + "/servicenow/get_multiple_tables", query_obj).then(
                    (data) => {
                        data.data && (data.data.results = convertTime(data.data.results));
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            },
            getCompanyUser: (callback, company_id, page_limit, offset, filter) => {
                if (page_limit == undefined) {
                    page_limit = 10;
                }
                if (offset == undefined || offset == "") {
                    offset = 0;
                }

                let tableName = filter ? filter : "sys_user|userList";

                let cb = callback || angular.noop;
                $http
                    .post(apiBasePath + "/servicenow/get_tables", {
                        page_limit: page_limit,
                        tableName: tableName,
                        offset: offset,
                        company_sys: company_id,
                        query_burwood_users: true,
                        active_status: true
                    })
                    .then(
                        (data) => {
                            data.data && (data.data.results = convertTime(data.data.results));
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            getQuery: (query_obj, table_name, callback) => {
                if (query_obj == undefined) {
                    query_obj = {};
                }
                let cb = callback || angular.noop;
                query_obj.tableName = table_name;
                $http.post(apiBasePath + "/servicenow/get_tables", query_obj).then(
                    (data) => {
                        data.data && (data.data.results = convertTime(data.data.results));
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            },
            getPerformanceAnalytics: (query_obj, callback) => {
                if (query_obj == undefined) {
                    query_obj = {};
                }
                let cb = callback || angular.noop;
                $http.post(apiBasePath + "/servicenow/performance_analytics", query_obj).then(
                    (data) => {
                        data.data && (data.data.results = convertTime(data.data.results));
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            },
            getItem: (id, table_name, callback) => {
                let cb = callback || angular.noop;
                $http
                    .post(apiBasePath + "/servicenow/get_tables", {
                        tableName: table_name,
                        sys_id: id
                    })
                    .then(
                        (data) => {
                            // let changeReqTime = false;
                            // table_name === 'change_request' ? changeReqTime = true : changeReqTime = false;
                            // data.results = convertTime(data.data.results, changeReqTime);
                            data.data && (data.data.results = convertTime(data.data.results));
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            getSearch: (queryString, callback, page_limit, offset) => {
                let cb = callback || angular.noop;
                if (page_limit == undefined) {
                    page_limit = 10;
                }
                if (offset == undefined || offset == "") {
                    offset = 0;
                }
                $http
                    .post(apiBasePath + "/searcher/search", {
                        query_string: queryString,
                        limit: page_limit,
                        offset: offset
                    })
                    .then(
                        (data) => {
                            data.data && (data.data.results = convertTime(data.data.results));
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            getHistory: (id, callback, page_limit, offset) => {
                let cb = callback || angular.noop;
                if (page_limit == undefined) {
                    page_limit = 10;
                }
                if (offset == undefined || offset == "") {
                    offset = 0;
                }
                $http
                    .post(apiBasePath + "/servicenow/sys_history_line", {
                        sys_id: id,
                        page_limit: page_limit,
                        offset: offset
                    })
                    .then(
                        (data) => {
                            data.data && (data.data.results = convertTime(data.data.results));
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            getJournal: (id, callback, page_limit, offset) => {
                let cb = callback || angular.noop;
                if (page_limit == undefined) {
                    page_limit = 10;
                }
                if (offset == undefined || offset == "") {
                    offset = 0;
                }
                $http
                    .post(apiBasePath + "/servicenow/journal_line", {
                        sys_id: id,
                        page_limit: page_limit,
                        offset: offset
                    })
                    .then(
                        (data) => {
                            // data.results = convertTime(data.data.results, true);
                            data.data && (data.data.results = convertTime(data.data.results, true));
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            getAllAttachment: (id, tableName, page_limit, offset, callback) => {
                let cb = callback || angular.noop;
                if (page_limit == undefined) {
                    page_limit = 10;
                }
                if (offset == undefined || offset == "") {
                    offset = 0;
                }
                $http
                    .post(apiBasePath + "/servicenow/get_all_attachment", {
                        table_sys_id: id,
                        tableName: tableName
                    })
                    .then(
                        (data) => {
                            // data.result = convertTime(data.result);
                            data.data && (data.data.results = convertTime(data.data.result));
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            getAttachment: (id, callback) => {
                let cb = callback || angular.noop;
                $http({
                    method: "POST",
                    cache: false,
                    url: apiBasePath + "/servicenow/get_attachment",
                    responseType: "arraybuffer",
                    data: {
                        sys_id: id
                    }
                }).then(
                    (data) => {
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            },
            addAttachment: (id, table_name, files, callback) => {
                let cb = callback || angular.noop;
                let formData = new FormData();
                formData.append("table_sys_id", id);
                formData.append("tableName", table_name);
                formData.append("image", files[0]);
                $http
                    .post(apiBasePath + "/servicenow/modify_attachment", formData, {
                        withCredentials: true,
                        headers: {
                            "Content-Type": undefined
                        },
                        transformRequest: angular.identity
                    })
                    .then(
                        (data) => {
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            getReport: (
                tableName,
                page_limit,
                offset,
                sorting,
                date_range,
                setRange,
                state,
                company_id,
                begin_date,
                end_date,
                getReport,
                fields,
                downloadType,
                multipleTables,
                devCategory,
                ciClass
            ) => {
                var table, tableProprty;
                multipleTables ? (table = "/servicenow/get_multiple_tables?") : "/servicenow/get_tables?";
                if (multipleTables) {
                    table = "/servicenow/get_multiple_tables?";
                    tableProprty = "tableNames=";
                } else {
                    table = "/servicenow/get_tables?";
                    tableProprty = "tableName=";
                }
                let url =
                    apiBasePath +
                    table +
                    tableProprty +
                    tableName +
                    "&page_limit=" +
                    page_limit +
                    "&offset=" +
                    offset +
                    "&sorting=" +
                    sorting +
                    "&date_range=" +
                    date_range +
                    "&setRange=" +
                    setRange +
                    "&state=" +
                    state +
                    "&company_sys=" +
                    company_id +
                    "&begin_date=" +
                    begin_date +
                    "&end_date=" +
                    end_date +
                    "&getReport=" +
                    getReport +
                    "&fields=" +
                    fields +
                    "&downloadType=" +
                    downloadType +
                    "&cmdb_ci.u_device_category=" +
                    devCategory +
                    "&ciClass=" +
                    ciClass;
                return url;
            },
            getDeviceReport: (tableName, page_limit, offset, sorting, company_id, getReport, fields, downloadType) => {
                let table = "/servicenow/get_tables?";
                let tableProprty = "tableName=";
                let url =
                    apiBasePath +
                    table +
                    tableProprty +
                    tableName +
                    "&page_limit=" +
                    page_limit +
                    "&offset=" +
                    offset +
                    "&sorting=" +
                    sorting +
                    "&cmdb_company=" +
                    company_id +
                    "&getReport=" +
                    getReport +
                    "&fields=" +
                    fields +
                    "&downloadType=" +
                    downloadType +
                    "&valid_device=true";
                return url;
            },
            deleteAttachment: (id, callback) => {
                let cb = callback || angular.noop;
                /* eslint-disable */
                let data = $.param({
                    sys_id: id
                });
                /* eslint-enable */
                $http.delete(apiBasePath + "/servicenow/modify_attachment?" + data).then(
                    (data) => {
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            },
            createItem: (table_name, data, callback, noCookie) => {
                let cb = callback || angular.noop;
                $http
                    .post(apiBasePath + "/servicenow/modify_tables", {
                        tableName: table_name,
                        data: data,
                        noCookie: noCookie
                    })
                    .then(
                        (data) => {
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            updateItem: (table_name, sys_id, data, callback) => {
                let cb = callback || angular.noop;
                $http
                    .put(apiBasePath + "/servicenow/modify_tables", {
                        sys_id: sys_id,
                        tableName: table_name,
                        data: data
                    })
                    .then(
                        (data) => {
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            deleteItem: (table_name, sys_id, callback) => {
                let cb = callback || angular.noop;
                $http
                    .put(apiBasePath + "/servicenow/delete_tables", {
                        sys_id: sys_id,
                        tableName: table_name
                    })
                    .then(
                        (data) => {
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            changePassword: (sys_id, old_password, password, confirm_password, callback) => {
                let cb = callback || angular.noop;
                $http
                    .post(apiBasePath + "/user_password", {
                        sys_id: sys_id,
                        old_password: old_password,
                        password: password,
                        confirmPassword: confirm_password
                    })
                    .then(
                        (data) => {
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            }
        };
    }
})();

(function () {
    "use strict";

    angular.module("burWood").factory("_", Underscore);

    /** @ngInject */
    function Underscore($window) {
        return $window._; // assumes underscore has already been loaded on the page
    }
})();

(function() {
	'use strict';

	angular
		.module('burWood')
		.factory('Trend', Trend);

	/** @ngInject */
	function Trend() {
		function regression(x, y, typ) {
			var type = (typ == null) ? 'linear' : typ;
			var N = x.length;
			var slope;
			var intercept;
			var SX = 0;
			var SY = 0;
			var SXX = 0;
			var SXY = 0;
			var SYY = 0;
			var Y = [];
			var X = [];

			if (type == 'linear') {
				X = x;
				Y = y;
			} else if (type == 'exp' || type == 'exponential') {
				for (var i = 0; i < y.length; i++) {
					// ignore points <= 0, log undefined.
					if (y[i] <= 0) {
						N--;
					} else {
						X.push(x[i]);
						Y.push(Math.log(y[i]));
					}
				}
			}

			for (var g = 0; g < N; g++) {
				SX = SX + X[g];
				SY = SY + Y[g];
				SXY = SXY + X[g] * Y[g];
				SXX = SXX + X[g] * X[g];
				SYY = SYY + Y[g] * Y[g];
			}

			slope = (N * SXY - SX * SY) / (N * SXX - SX * SX);
			intercept = (SY - slope * SX) / N;

			return [slope, intercept];
		}

		function linearRegression(X, Y) {
			var ret;
			ret = regression(X, Y, 'linear');
			return [ret[0], ret[1]];
		}

		function expRegression(X, Y) {
			var ret;
			var x = X;
			var y = Y;
			ret = regression(x, y, 'exp');
			var base = Math.exp(ret[0]);
			var coeff = Math.exp(ret[1]);
			return [base, coeff];
		}

		/*
		    TODO: this function is quite inefficient.
		    Refactor it if there is problem with speed.
		 */
		function fitData(data, typ, forecast, hourly) {
			var type = (typ == null) ? 'linear' : typ;
			var ret;
			var res;
			var x = [];
			var y = [];
			var ypred = [];

			for (i = 0; i < data.length; i++) {
				if (data[i] != null && angular.isArray(Object.prototype.toString.call(data[i]))) {
					if (data[i] != null && data[i][0] != null && data[i][1] != null) {
						x.push(data[i][0]);
						y.push(data[i][1]);
					}
				} else if (data[i] != null && angular.isNumber(data[i])) { //If type of X axis is category
					x.push(i);
					y.push(data[i]);
				} else if (data[i] != null && angular.isObject(Object.prototype.toString.call(data[i]))) {
					if (data[i] != null && data[i].x != null && data[i].y != null) {
						x.push(data[i].x);
						y.push(data[i].y);
					}
				}
			}

			if (type == 'linear') {

				ret = linearRegression(x, y);
				if (forecast) {
					var xLength;
					if (hourly) {
						xLength = x.length + 336;
					} else {
						xLength = x.length + 14;
					}
					for (var i = 0; i < xLength; i++) {
						res = ret[0] * i + ret[1];
						ypred.push([i, res]);
					}
				} else {
					for (var l = 0; l < x.length; l++) {
						res = ret[0] * x[l] + ret[1];
						ypred.push([x[l], res]);
					}
				}

				return {
					data: ypred,
					slope: ret[0],
					intercept: ret[1],
					y: function(x) {
						return (this.slope * x) + this.intercept;
					},
					x: function(y) {
						return (y - this.intercept) / this.slope;
					}
				};
			} else if (type == 'exp' || type == 'exponential') {

				ret = expRegression(x, y);
				for (var r = 0; r < x.length; r++) {
					res = ret[1] * Math.pow(ret[0], x[r]);
					ypred.push([x[r], res]);
				}
				ypred.sort();

				return {
					data: ypred,
					base: ret[0],
					coeff: ret[1]
				};
			}
		}
		return fitData;
	}
})();

(function() {
    "use strict";

    angular.module("burWood").factory("Timezone_SL", Timezone_SL);

    /** @ngInject */
    function Timezone_SL() {

        function returnTimezoneID(timezoneName) {
            var timezoneIndex = timezoneList.indexOf(timezoneName);
            var id = timezoneList[timezoneIndex-1];
            return id;
        }
        
        var timezoneList = [
            "1",
            "Africa/Abidjan",
            "0",
            "2",
            "Africa/Addis_Ababa",
            "0",
            "3",
            "Africa/Algiers",
            "0",
            "4",
            "Africa/Asmara",
            "0",
            "5",
            "Africa/Asmera",
            "0",
            "6",
            "Africa/Bamako",
            "0",
            "7",
            "Africa/Bangui",
            "0",
            "8",
            "Africa/Banjul",
            "0",
            "9",
            "Africa/Bissau",
            "0",
            "10",
            "Africa/Blantyre",
            "0",
            "11",
            "Africa/Brazzaville",
            "0",
            "12",
            "Africa/Bujumbura",
            "0",
            "13",
            "Africa/Cairo",
            "0",
            "14",
            "Africa/Casablanca",
            "0",
            "15",
            "Africa/Ceuta",
            "0",
            "16",
            "Africa/Conakry",
            "0",
            "17",
            "Africa/Dakar",
            "0",
            "18",
            "Africa/Dar_es_Salaam",
            "0",
            "19",
            "Africa/Djibouti",
            "0",
            "20",
            "Africa/Douala",
            "0",
            "21",
            "Africa/El_Aaiun",
            "0",
            "22",
            "Africa/Freetown",
            "0",
            "23",
            "Africa/Gaborone",
            "0",
            "24",
            "Africa/Harare",
            "0",
            "25",
            "Africa/Johannesburg",
            "0",
            "26",
            "Africa/Kampala",
            "0",
            "27",
            "Africa/Khartoum",
            "0",
            "28",
            "Africa/Kigali",
            "0",
            "29",
            "Africa/Kinshasa",
            "0",
            "30",
            "Africa/Lagos",
            "0",
            "31",
            "Africa/Libreville",
            "0",
            "32",
            "Africa/Lome",
            "0",
            "33",
            "Africa/Luanda",
            "0",
            "34",
            "Africa/Lubumbashi",
            "0",
            "35",
            "Africa/Lusaka",
            "0",
            "36",
            "Africa/Malabo",
            "0",
            "37",
            "Africa/Maputo",
            "0",
            "38",
            "Africa/Maseru",
            "0",
            "39",
            "Africa/Mbabane",
            "0",
            "40",
            "Africa/Mogadishu",
            "0",
            "41",
            "Africa/Monrovia",
            "0",
            "42",
            "Africa/Nairobi",
            "0",
            "43",
            "Africa/Ndjamena",
            "0",
            "44",
            "Africa/Niamey",
            "0",
            "45",
            "Africa/Nouakchott",
            "0",
            "46",
            "Africa/Ouagadougou",
            "0",
            "47",
            "Africa/Porto-Novo",
            "0",
            "48",
            "Africa/Sao_Tome",
            "0",
            "49",
            "Africa/Timbuktu",
            "0",
            "50",
            "Africa/Tripoli",
            "0",
            "51",
            "Africa/Tunis",
            "0",
            "52",
            "Africa/Windhoek",
            "0",
            "53",
            "America/Adak",
            "0",
            "54",
            "America/Anchorage",
            "0",
            "55",
            "America/Anguilla",
            "0",
            "56",
            "America/Antigua",
            "0",
            "57",
            "America/Araguaina",
            "0",
            "58",
            "America/Argentina/Buenos_Aires",
            "0",
            "59",
            "America/Argentina/Catamarca",
            "0",
            "60",
            "America/Argentina/ComodRivadavia",
            "0",
            "61",
            "America/Argentina/Cordoba",
            "0",
            "62",
            "America/Argentina/Jujuy",
            "0",
            "63",
            "America/Argentina/La_Rioja",
            "0",
            "64",
            "America/Argentina/Mendoza",
            "0",
            "65",
            "America/Argentina/Rio_Gallegos",
            "0",
            "66",
            "America/Argentina/San_Juan",
            "0",
            "67",
            "America/Argentina/Tucuman",
            "0",
            "68",
            "America/Argentina/Ushuaia",
            "0",
            "69",
            "America/Aruba",
            "0",
            "70",
            "America/Asuncion",
            "0",
            "71",
            "America/Atikokan",
            "0",
            "72",
            "America/Atka",
            "0",
            "73",
            "America/Bahia",
            "0",
            "74",
            "America/Barbados",
            "0",
            "75",
            "America/Belem",
            "0",
            "76",
            "America/Belize",
            "0",
            "77",
            "America/Blanc-Sablon",
            "0",
            "78",
            "America/Boa_Vista",
            "0",
            "79",
            "America/Bogota",
            "0",
            "80",
            "America/Boise",
            "0",
            "81",
            "America/Buenos_Aires",
            "0",
            "82",
            "America/Cambridge_Bay",
            "0",
            "83",
            "America/Campo_Grande",
            "0",
            "84",
            "America/Cancun",
            "0",
            "85",
            "America/Caracas",
            "0",
            "86",
            "America/Catamarca",
            "0",
            "87",
            "America/Cayenne",
            "0",
            "88",
            "America/Cayman",
            "0",
            "89",
            "America/Chicago",
            "0",
            "90",
            "America/Chihuahua",
            "0",
            "91",
            "America/Coral_Harbour",
            "0",
            "92",
            "America/Cordoba",
            "0",
            "93",
            "America/Costa_Rica",
            "0",
            "94",
            "America/Cuiaba",
            "0",
            "95",
            "America/Curacao",
            "0",
            "96",
            "America/Danmarkshavn",
            "0",
            "97",
            "America/Dawson",
            "0",
            "98",
            "America/Dawson_Creek",
            "0",
            "99",
            "America/Denver",
            "0",
            "100",
            "America/Detroit",
            "0",
            "101",
            "America/Dominica",
            "0",
            "102",
            "America/Edmonton",
            "0",
            "103",
            "America/Eirunepe",
            "0",
            "104",
            "America/El_Salvador",
            "0",
            "105",
            "America/Ensenada",
            "0",
            "106",
            "America/Fort_Wayne",
            "0",
            "107",
            "America/Fortaleza",
            "0",
            "108",
            "America/Glace_Bay",
            "0",
            "109",
            "America/Godthab",
            "0",
            "110",
            "America/Goose_Bay",
            "0",
            "111",
            "America/Grand_Turk",
            "0",
            "112",
            "America/Grenada",
            "0",
            "113",
            "America/Guadeloupe",
            "0",
            "114",
            "America/Guatemala",
            "0",
            "115",
            "America/Guayaquil",
            "0",
            "116",
            "America/Guyana",
            "0",
            "117",
            "America/Halifax",
            "0",
            "118",
            "America/Havana",
            "0",
            "119",
            "America/Hermosillo",
            "0",
            "120",
            "America/Indiana/Indianapolis",
            "0",
            "121",
            "America/Indiana/Knox",
            "0",
            "122",
            "America/Indiana/Marengo",
            "0",
            "123",
            "America/Indiana/Petersburg",
            "0",
            "124",
            "America/Indiana/Tell_City",
            "0",
            "125",
            "America/Indiana/Vevay",
            "0",
            "126",
            "America/Indiana/Vincennes",
            "0",
            "127",
            "America/Indiana/Winamac",
            "0",
            "128",
            "America/Indianapolis",
            "0",
            "129",
            "America/Inuvik",
            "0",
            "130",
            "America/Iqaluit",
            "0",
            "131",
            "America/Jamaica",
            "0",
            "132",
            "America/Jujuy",
            "0",
            "133",
            "America/Juneau",
            "0",
            "134",
            "America/Kentucky/Louisville",
            "0",
            "135",
            "America/Kentucky/Monticello",
            "0",
            "136",
            "America/Knox_IN",
            "0",
            "137",
            "America/La_Paz",
            "0",
            "138",
            "America/Lima",
            "0",
            "139",
            "America/Los_Angeles",
            "0",
            "140",
            "America/Louisville",
            "0",
            "141",
            "America/Maceio",
            "0",
            "142",
            "America/Managua",
            "0",
            "143",
            "America/Manaus",
            "0",
            "144",
            "America/Martinique",
            "0",
            "145",
            "America/Mazatlan",
            "0",
            "146",
            "America/Mendoza",
            "0",
            "147",
            "America/Menominee",
            "0",
            "148",
            "America/Merida",
            "0",
            "149",
            "America/Mexico_City",
            "0",
            "150",
            "America/Miquelon",
            "0",
            "151",
            "America/Moncton",
            "0",
            "152",
            "America/Monterrey",
            "0",
            "153",
            "America/Montevideo",
            "0",
            "154",
            "America/Montreal",
            "0",
            "155",
            "America/Montserrat",
            "0",
            "156",
            "America/Nassau",
            "0",
            "157",
            "America/New_York",
            "0",
            "158",
            "America/Nipigon",
            "0",
            "159",
            "America/Nome",
            "0",
            "160",
            "America/Noronha",
            "0",
            "161",
            "America/North_Dakota/Center",
            "0",
            "162",
            "America/North_Dakota/New_Salem",
            "0",
            "163",
            "America/Panama",
            "0",
            "164",
            "America/Pangnirtung",
            "0",
            "165",
            "America/Paramaribo",
            "0",
            "166",
            "America/Phoenix",
            "0",
            "167",
            "America/Port-au-Prince",
            "0",
            "168",
            "America/Port_of_Spain",
            "0",
            "169",
            "America/Porto_Acre",
            "0",
            "170",
            "America/Porto_Velho",
            "0",
            "171",
            "America/Puerto_Rico",
            "0",
            "172",
            "America/Rainy_River",
            "0",
            "173",
            "America/Rankin_Inlet",
            "0",
            "174",
            "America/Recife",
            "0",
            "175",
            "America/Regina",
            "0",
            "176",
            "America/Resolute",
            "0",
            "177",
            "America/Rio_Branco",
            "0",
            "178",
            "America/Rosario",
            "0",
            "179",
            "America/Santiago",
            "0",
            "180",
            "America/Santo_Domingo",
            "0",
            "181",
            "America/Sao_Paulo",
            "0",
            "182",
            "America/Scoresbysund",
            "0",
            "183",
            "America/Shiprock",
            "0",
            "184",
            "America/St_Johns",
            "0",
            "185",
            "America/St_Kitts",
            "0",
            "186",
            "America/St_Lucia",
            "0",
            "187",
            "America/St_Thomas",
            "0",
            "188",
            "America/St_Vincent",
            "0",
            "189",
            "America/Swift_Current",
            "0",
            "190",
            "America/Tegucigalpa",
            "0",
            "191",
            "America/Thule",
            "0",
            "192",
            "America/Thunder_Bay",
            "0",
            "193",
            "America/Tijuana",
            "0",
            "194",
            "America/Toronto",
            "0",
            "195",
            "America/Tortola",
            "0",
            "196",
            "America/Vancouver",
            "0",
            "197",
            "America/Virgin",
            "0",
            "198",
            "America/Whitehorse",
            "0",
            "199",
            "America/Winnipeg",
            "0",
            "200",
            "America/Yakutat",
            "0",
            "201",
            "America/Yellowknife",
            "0",
            "202",
            "Antarctica/Casey",
            "0",
            "203",
            "Antarctica/Davis",
            "0",
            "204",
            "Antarctica/DumontDUrville",
            "0",
            "205",
            "Antarctica/Mawson",
            "0",
            "206",
            "Antarctica/McMurdo",
            "0",
            "207",
            "Antarctica/Palmer",
            "0",
            "208",
            "Antarctica/Rothera",
            "0",
            "209",
            "Antarctica/South_Pole",
            "0",
            "210",
            "Antarctica/Syowa",
            "0",
            "211",
            "Antarctica/Vostok",
            "0",
            "212",
            "Arctic/Longyearbyen",
            "0",
            "213",
            "Asia/Aden",
            "0",
            "214",
            "Asia/Almaty",
            "0",
            "215",
            "Asia/Amman",
            "0",
            "216",
            "Asia/Anadyr",
            "0",
            "217",
            "Asia/Aqtau",
            "0",
            "218",
            "Asia/Aqtobe",
            "0",
            "219",
            "Asia/Ashgabat",
            "0",
            "220",
            "Asia/Ashkhabad",
            "0",
            "221",
            "Asia/Baghdad",
            "0",
            "222",
            "Asia/Bahrain",
            "0",
            "223",
            "Asia/Baku",
            "0",
            "224",
            "Asia/Bangkok",
            "0",
            "225",
            "Asia/Beirut",
            "0",
            "226",
            "Asia/Bishkek",
            "0",
            "227",
            "Asia/Brunei",
            "0",
            "228",
            "Asia/Calcutta",
            "0",
            "229",
            "Asia/Choibalsan",
            "0",
            "230",
            "Asia/Chongqing",
            "0",
            "231",
            "Asia/Chungking",
            "0",
            "232",
            "Asia/Colombo",
            "0",
            "233",
            "Asia/Dacca",
            "0",
            "234",
            "Asia/Damascus",
            "0",
            "235",
            "Asia/Dhaka",
            "0",
            "236",
            "Asia/Dili",
            "0",
            "237",
            "Asia/Dubai",
            "0",
            "238",
            "Asia/Dushanbe",
            "0",
            "239",
            "Asia/Gaza",
            "0",
            "240",
            "Asia/Harbin",
            "0",
            "241",
            "Asia/Hong_Kong",
            "0",
            "242",
            "Asia/Hovd",
            "0",
            "243",
            "Asia/Irkutsk",
            "0",
            "244",
            "Asia/Istanbul",
            "0",
            "245",
            "Asia/Jakarta",
            "0",
            "246",
            "Asia/Jayapura",
            "0",
            "247",
            "Asia/Jerusalem",
            "0",
            "248",
            "Asia/Kabul",
            "0",
            "249",
            "Asia/Kamchatka",
            "0",
            "250",
            "Asia/Karachi",
            "0",
            "251",
            "Asia/Kashgar",
            "0",
            "252",
            "Asia/Kathmandu",
            "0",
            "253",
            "Asia/Krasnoyarsk",
            "0",
            "254",
            "Asia/Kuala_Lumpur",
            "0",
            "255",
            "Asia/Kuching",
            "0",
            "256",
            "Asia/Kuwait",
            "0",
            "257",
            "Asia/Macao",
            "0",
            "258",
            "Asia/Macau",
            "0",
            "259",
            "Asia/Magadan",
            "0",
            "260",
            "Asia/Makassar",
            "0",
            "261",
            "Asia/Manila",
            "0",
            "262",
            "Asia/Muscat",
            "0",
            "263",
            "Asia/Nicosia",
            "0",
            "264",
            "Asia/Novosibirsk",
            "0",
            "265",
            "Asia/Omsk",
            "0",
            "266",
            "Asia/Oral",
            "0",
            "267",
            "Asia/Phnom_Penh",
            "0",
            "268",
            "Asia/Pontianak",
            "0",
            "269",
            "Asia/Pyongyang",
            "0",
            "270",
            "Asia/Qatar",
            "0",
            "271",
            "Asia/Qyzylorda",
            "0",
            "272",
            "Asia/Rangoon",
            "0",
            "273",
            "Asia/Riyadh",
            "0",
            "274",
            "Asia/Saigon",
            "0",
            "275",
            "Asia/Sakhalin",
            "0",
            "276",
            "Asia/Samarkand",
            "0",
            "277",
            "Asia/Seoul",
            "0",
            "278",
            "Asia/Shanghai",
            "0",
            "279",
            "Asia/Singapore",
            "0",
            "280",
            "Asia/Taipei",
            "0",
            "281",
            "Asia/Tashkent",
            "0",
            "282",
            "Asia/Tbilisi",
            "0",
            "283",
            "Asia/Tehran",
            "0",
            "284",
            "Asia/Tel_Aviv",
            "0",
            "285",
            "Asia/Thimbu",
            "0",
            "286",
            "Asia/Thimphu",
            "0",
            "287",
            "Asia/Tokyo",
            "0",
            "288",
            "Asia/Ujung_Pandang",
            "0",
            "289",
            "Asia/Ulaanbaatar",
            "0",
            "290",
            "Asia/Ulan_Bator",
            "0",
            "291",
            "Asia/Urumqi",
            "0",
            "292",
            "Asia/Vientiane",
            "0",
            "293",
            "Asia/Vladivostok",
            "0",
            "294",
            "Asia/Yakutsk",
            "0",
            "295",
            "Asia/Yekaterinburg",
            "0",
            "296",
            "Asia/Yerevan",
            "0",
            "297",
            "Atlantic/Azores",
            "0",
            "298",
            "Atlantic/Bermuda",
            "0",
            "299",
            "Atlantic/Canary",
            "0",
            "300",
            "Atlantic/Cape_Verde",
            "0",
            "301",
            "Atlantic/Faeroe",
            "0",
            "302",
            "Atlantic/Faroe",
            "0",
            "303",
            "Atlantic/Jan_Mayen",
            "0",
            "304",
            "Atlantic/Madeira",
            "0",
            "305",
            "Atlantic/Reykjavik",
            "0",
            "306",
            "Atlantic/South_Georgia",
            "0",
            "307",
            "Atlantic/St_Helena",
            "0",
            "308",
            "Atlantic/Stanley",
            "0",
            "309",
            "Australia/ACT",
            "0",
            "310",
            "Australia/Adelaide",
            "0",
            "311",
            "Australia/Brisbane",
            "0",
            "312",
            "Australia/Broken_Hill",
            "0",
            "313",
            "Australia/Canberra",
            "0",
            "314",
            "Australia/Currie",
            "0",
            "315",
            "Australia/Darwin",
            "0",
            "316",
            "Australia/Eucla",
            "0",
            "317",
            "Australia/Hobart",
            "0",
            "318",
            "Australia/LHI",
            "0",
            "319",
            "Australia/Lindeman",
            "0",
            "320",
            "Australia/Lord_Howe",
            "0",
            "321",
            "Australia/Melbourne",
            "0",
            "322",
            "Australia/North",
            "0",
            "323",
            "Australia/NSW",
            "0",
            "324",
            "Australia/Perth",
            "0",
            "325",
            "Australia/Queensland",
            "0",
            "326",
            "Australia/South",
            "0",
            "327",
            "Australia/Sydney",
            "0",
            "328",
            "Australia/Tasmania",
            "0",
            "329",
            "Australia/Victoria",
            "0",
            "330",
            "Australia/West",
            "0",
            "331",
            "Australia/Yancowinna",
            "0",
            "332",
            "Brazil/Acre",
            "0",
            "333",
            "Brazil/DeNoronha",
            "0",
            "334",
            "Brazil/East",
            "0",
            "335",
            "Brazil/West",
            "0",
            "336",
            "Canada/Atlantic",
            "0",
            "337",
            "Canada/Central",
            "0",
            "338",
            "Canada/East-Saskatchewan",
            "0",
            "339",
            "Canada/Eastern",
            "0",
            "340",
            "Canada/Mountain",
            "0",
            "341",
            "Canada/Newfoundland",
            "0",
            "342",
            "Canada/Pacific",
            "0",
            "343",
            "Canada/Saskatchewan",
            "0",
            "344",
            "Canada/Yukon",
            "0",
            "345",
            "CET",
            "0",
            "346",
            "Chile/Continental",
            "0",
            "347",
            "Chile/EasterIsland",
            "0",
            "350",
            "EET",
            "0",
            "353",
            "EST",
            "0",
            "355",
            "Etc/GMT",
            "0",
            "356",
            "Etc/GMT+0",
            "0",
            "357",
            "Etc/GMT+1",
            "0",
            "358",
            "Etc/GMT+10",
            "0",
            "359",
            "Etc/GMT+11",
            "0",
            "360",
            "Etc/GMT+12",
            "0",
            "361",
            "Etc/GMT+2",
            "0",
            "362",
            "Etc/GMT+3",
            "0",
            "363",
            "Etc/GMT+4",
            "0",
            "364",
            "Etc/GMT+5",
            "0",
            "365",
            "Etc/GMT+6",
            "0",
            "366",
            "Etc/GMT+7",
            "0",
            "367",
            "Etc/GMT+8",
            "0",
            "368",
            "Etc/GMT+9",
            "0",
            "369",
            "Etc/GMT-0",
            "0",
            "370",
            "Etc/GMT-1",
            "0",
            "371",
            "Etc/GMT-10",
            "0",
            "372",
            "Etc/GMT-11",
            "0",
            "373",
            "Etc/GMT-12",
            "0",
            "374",
            "Etc/GMT-13",
            "0",
            "375",
            "Etc/GMT-14",
            "0",
            "376",
            "Etc/GMT-2",
            "0",
            "377",
            "Etc/GMT-3",
            "0",
            "378",
            "Etc/GMT-4",
            "0",
            "379",
            "Etc/GMT-5",
            "0",
            "380",
            "Etc/GMT-6",
            "0",
            "381",
            "Etc/GMT-7",
            "0",
            "382",
            "Etc/GMT-8",
            "0",
            "383",
            "Etc/GMT-9",
            "0",
            "384",
            "Etc/GMT0",
            "0",
            "385",
            "Etc/Greenwich",
            "0",
            "386",
            "Etc/UCT",
            "0",
            "387",
            "Etc/Universal",
            "0",
            "388",
            "Etc/UTC",
            "0",
            "389",
            "Etc/Zulu",
            "0",
            "390",
            "Europe/Amsterdam",
            "0",
            "391",
            "Europe/Andorra",
            "0",
            "392",
            "Europe/Athens",
            "0",
            "393",
            "Europe/Belfast",
            "0",
            "394",
            "Europe/Belgrade",
            "0",
            "395",
            "Europe/Berlin",
            "0",
            "396",
            "Europe/Bratislava",
            "0",
            "397",
            "Europe/Brussels",
            "0",
            "398",
            "Europe/Bucharest",
            "0",
            "399",
            "Europe/Budapest",
            "0",
            "400",
            "Europe/Chisinau",
            "0",
            "401",
            "Europe/Copenhagen",
            "0",
            "402",
            "Europe/Dublin",
            "0",
            "403",
            "Europe/Gibraltar",
            "0",
            "404",
            "Europe/Guernsey",
            "0",
            "405",
            "Europe/Helsinki",
            "0",
            "406",
            "Europe/Isle_of_Man",
            "0",
            "407",
            "Europe/Istanbul",
            "0",
            "408",
            "Europe/Jersey",
            "0",
            "409",
            "Europe/Kaliningrad",
            "0",
            "410",
            "Europe/Kiev",
            "0",
            "411",
            "Europe/Lisbon",
            "0",
            "412",
            "Europe/Ljubljana",
            "0",
            "413",
            "Europe/London",
            "0",
            "414",
            "Europe/Luxembourg",
            "0",
            "415",
            "Europe/Madrid",
            "0",
            "416",
            "Europe/Malta",
            "0",
            "417",
            "Europe/Mariehamn",
            "0",
            "418",
            "Europe/Minsk",
            "0",
            "419",
            "Europe/Monaco",
            "0",
            "420",
            "Europe/Moscow",
            "0",
            "421",
            "Europe/Nicosia",
            "0",
            "422",
            "Europe/Oslo",
            "0",
            "423",
            "Europe/Paris",
            "0",
            "424",
            "Europe/Podgorica",
            "0",
            "425",
            "Europe/Prague",
            "0",
            "426",
            "Europe/Riga",
            "0",
            "427",
            "Europe/Rome",
            "0",
            "428",
            "Europe/Samara",
            "0",
            "429",
            "Europe/San_Marino",
            "0",
            "430",
            "Europe/Sarajevo",
            "0",
            "431",
            "Europe/Simferopol",
            "0",
            "432",
            "Europe/Skopje",
            "0",
            "433",
            "Europe/Sofia",
            "0",
            "434",
            "Europe/Stockholm",
            "0",
            "435",
            "Europe/Tallinn",
            "0",
            "436",
            "Europe/Tirane",
            "0",
            "437",
            "Europe/Tiraspol",
            "0",
            "438",
            "Europe/Uzhgorod",
            "0",
            "439",
            "Europe/Vaduz",
            "0",
            "440",
            "Europe/Vatican",
            "0",
            "441",
            "Europe/Vienna",
            "0",
            "442",
            "Europe/Vilnius",
            "0",
            "443",
            "Europe/Volgograd",
            "0",
            "444",
            "Europe/Warsaw",
            "0",
            "445",
            "Europe/Zagreb",
            "0",
            "446",
            "Europe/Zaporozhye",
            "0",
            "447",
            "Europe/Zurich",
            "0",
            "449",
            "GB",
            "0",
            "451",
            "GMT",
            "0",
            "452",
            "GMT+0",
            "0",
            "453",
            "GMT-0",
            "0",
            "457",
            "HST",
            "0",
            "459",
            "Indian/Antananarivo",
            "0",
            "460",
            "Indian/Chagos",
            "0",
            "461",
            "Indian/Christmas",
            "0",
            "462",
            "Indian/Cocos",
            "0",
            "463",
            "Indian/Comoro",
            "0",
            "464",
            "Indian/Kerguelen",
            "0",
            "465",
            "Indian/Mahe",
            "0",
            "466",
            "Indian/Maldives",
            "0",
            "467",
            "Indian/Mauritius",
            "0",
            "468",
            "Indian/Mayotte",
            "0",
            "469",
            "Indian/Reunion",
            "0",
            "476",
            "MET",
            "0",
            "477",
            "Mexico/BajaNorte",
            "0",
            "478",
            "Mexico/BajaSur",
            "0",
            "479",
            "Mexico/General",
            "0",
            "480",
            "MST",
            "0",
            "483",
            "NZ",
            "0",
            "485",
            "Pacific/Apia",
            "0",
            "486",
            "Pacific/Auckland",
            "0",
            "487",
            "Pacific/Chatham",
            "0",
            "488",
            "Pacific/Easter",
            "0",
            "489",
            "Pacific/Efate",
            "0",
            "490",
            "Pacific/Enderbury",
            "0",
            "491",
            "Pacific/Fakaofo",
            "0",
            "492",
            "Pacific/Fiji",
            "0",
            "493",
            "Pacific/Funafuti",
            "0",
            "494",
            "Pacific/Galapagos",
            "0",
            "495",
            "Pacific/Gambier",
            "0",
            "496",
            "Pacific/Guadalcanal",
            "0",
            "497",
            "Pacific/Guam",
            "0",
            "498",
            "Pacific/Honolulu",
            "0",
            "499",
            "Pacific/Johnston",
            "0",
            "500",
            "Pacific/Kiritimati",
            "0",
            "501",
            "Pacific/Kosrae",
            "0",
            "502",
            "Pacific/Kwajalein",
            "0",
            "503",
            "Pacific/Majuro",
            "0",
            "504",
            "Pacific/Marquesas",
            "0",
            "505",
            "Pacific/Midway",
            "0",
            "506",
            "Pacific/Nauru",
            "0",
            "507",
            "Pacific/Niue",
            "0",
            "508",
            "Pacific/Norfolk",
            "0",
            "509",
            "Pacific/Noumea",
            "0",
            "510",
            "Pacific/Pago_Pago",
            "0",
            "511",
            "Pacific/Palau",
            "0",
            "512",
            "Pacific/Pitcairn",
            "0",
            "513",
            "Pacific/Ponape",
            "0",
            "514",
            "Pacific/Port_Moresby",
            "0",
            "515",
            "Pacific/Rarotonga",
            "0",
            "516",
            "Pacific/Saipan",
            "0",
            "517",
            "Pacific/Samoa",
            "0",
            "518",
            "Pacific/Tahiti",
            "0",
            "519",
            "Pacific/Tarawa",
            "0",
            "520",
            "Pacific/Tongatapu",
            "0",
            "521",
            "Pacific/Truk",
            "0",
            "522",
            "Pacific/Wake",
            "0",
            "523",
            "Pacific/Wallis",
            "0",
            "524",
            "Pacific/Yap",
            "0",
            "527",
            "PRC",
            "0",
            "529",
            "ROC",
            "0",
            "530",
            "ROK",
            "0",
            "533",
            "UCT",
            "0",
            "548",
            "UTC",
            "0",
            "550",
            "WET",
            "0",
            "552",
            "Asia/Kolkata",
            "0"
        ];
        return returnTimezoneID;
    }
})();

(function () {
    angular.module("burWood").factory("Service", Service);

    /** @ngInject */
    function Service(ServiceNow, ScienceLogic) {
        return {
            getUser: (userId, callback) => {
                ServiceNow.getItem(userId, "sys_user", callback);
            },
            getQuery: (query_obj, tableName, callback) => {
                ServiceNow.getQuery(query_obj, tableName, callback);
            },
            getServices: (company, sysParmDisplayValue, callback) => {
                ServiceNow.getQuery({ company_sys: company, u_installed: true, sysparm_display_value: sysParmDisplayValue }, "u_provided_services", callback);
            },
            getCategory: (catId, callback) => {
                ServiceNow.getItem(catId, "u_category", callback);
            },
            getDomain: (domainId, callback) => {
                ServiceNow.getItem(domainId, "domain", callback);
            },
            getCompanies: (callback, page, offset, query_obj) => {
                ServiceNow.getTable(null, "core_company", callback, page, offset, query_obj);
            },
            getUsergroup: (groupId, callback) => {
                ServiceNow.getItem(groupId, "sys_user_group", callback);
            },
            getCompany: (companyId, callback) => {
                ServiceNow.getItem(companyId, "core_company", callback);
            },
            getAffectedDevice: (devId, callback) => {
                ServiceNow.getItem(devId, "cmdb_ci", callback);
            },
            getExceptions: (callback, company) => {
                ServiceNow.getExceptions(callback, true, company);
            },
            getSLTable: (table, callback, query_obj) => {
                ScienceLogic.getItems(table, callback, query_obj);
            },
            createItem: (route, data, callback) => {
                ServiceNow.createItem(route, data, callback);
            },
            createSLItem: (route, data, callback) => {
                ScienceLogic.createItem(route, data, callback);
            },
            getSLUser: (callback, account) => {
                ScienceLogic.getTable(account, callback);
            },
            updateItem: (table, requestId, request, callback) => {
                ServiceNow.updateItem(table, requestId, request, callback);
            }
        };
    }
})();

(function () {
    angular.module("burWood").factory("Server", Server);

    function Server($http, $q, apiBasePath) {
        let deferred = $q.defer();
        return {
            postData: (query_obj, route, callback) => {
                let cb = callback || angular.noop;
                $http.post(apiBasePath + route, query_obj).then(
                    (data) => {
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            },
            getData: (route, callback) => {
                let cb = callback || angular.noop;
                $http.get(apiBasePath + route).then(
                    (data) => {
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            },
            addAttachment: (queryObj, route, callback) => {
                let cb = callback || angular.noop;
                let formData = new FormData();
                for (let key in queryObj) {
                    formData.append(key, queryObj[key]);
                }
                $http
                    .post(apiBasePath + route, formData, {
                        withCredentials: true,
                        headers: {
                            "Content-Type": undefined
                        },
                        transformRequest: angular.identity
                    })
                    .then(
                        (data) => {
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                           deferred.reject(err);
                            return cb(err);
                        }
                    );
            }
        };
    }
})();

(function () {
    angular.module("burWood").factory("BCSServer", BCSServer);

    /** @ngInject */
    function BCSServer(Server) {
        return {
            getData: (route, callback) => {
                Server.getData(route, callback);
            },
            postData: (query_obj, route, callback) => {
                Server.postData(query_obj, route, callback);
            }
        };
    }
})();

(function () {
    angular.module("burWood").factory("Search", Search);

    function Search(ServiceNow) {
        return {
            search: (query, callback, page_limit, offset) => {
                ServiceNow.getSearch(query, callback, page_limit, offset);
            }
        };
    }
})();

(function () {
    angular.module("burWood").controller("SearchController", SearchController);

    /** @ngInject */
    function SearchController(user_info, $stateParams, Search, Service, $rootScope, $state) {
        let vm = this;
        let company = user_info.company;
        vm.searching = true;
        let query = $stateParams.query;
        $rootScope.keyword = "";
        if (query != "") {
            var page_limit = -1;
            let offset = 0;
            if ($stateParams.offset != undefined || $stateParams.offset != "") {
                offset = $stateParams.offset;
            }
            if (offset == "") offset = 0;
            Search.search(
                query,
                (data) => {
                    vm.searching = false;
                    vm.search_results = data.results;
                    angular.forEach(vm.search_results, (ticket) => {
                        ticket["priority_number"] = 6;
                        if (ticket["priority"] && ticket["priority"] != "") {
                            ticket["priority_number"] = ticket.priority[0];
                        }
                        // TODO: should refactor show heading title
                        var route_path = "/device/";
                        switch (ticket.type_name) {
                            case "incident":
                                route_path = "/incident/";
                                break;
                            case "problem":
                                route_path = "/problem/";
                                break;
                            case "customer_change":
                                route_path = "/u_customer_changes/";
                                break;
                            case "request":
                                route_path = "/requests/";
                                break;
                        }
                        route_path += ticket.id;
                        if (ticket.type_name == "event") {
                            route_path = "/allevent/";
                        }
                        ticket["route_path"] = route_path;
                    });
                },
                page_limit,
                offset
            );
        }

        let exceptions;

        Service.getExceptions((data) => {
            if (data.err || !data.results) {
                vm.error = true;
            } else {
                exceptions = data.results;
            }
        }, company);

        vm.goToDevice = (device) => {
            let except = false;
            for (let x = 0; x < exceptions.length; x++) {
                if (device.toLowerCase() === exceptions[x].name.toLowerCase()) {
                    except = true;
                }
            }
            if (except) {
                $state.go("index.devices", {
                    redirectedDevice: device,
                    exception: true
                });
            } else {
                $state.go("index.devices", {
                    redirectedDevice: device
                });
            }
        };
    }
})();

(function () {
    angular.module("burWood").factory("ScienceLogic", ScienceLogic);

    function ScienceLogic($http, $q, apiBasePath, apiScienceLogCred) {
        let deferred = $q.defer();
        return {
            getTable: (route, callback, order, filter, limit, offset, sku, skuExists) => {
                if (limit == undefined) {
                    limit = 10000;
                }
                if (offset == undefined) {
                    offset = 0;
                }
                if (order == undefined) {
                    order = {
                        date_first: "DESC"
                    };
                }
                if (filter == undefined) {
                    filter = {
                        severity: 1
                    };
                }
                let cb = callback || angular.noop;
                $http
                    .post(apiBasePath + "/science_logic/get_tables", {
                        user: {
                            user_name: apiScienceLogCred.user_name,
                            password: apiScienceLogCred.password
                        },
                        order: order,
                        filter: filter,
                        route: route,
                        limit: limit,
                        offset: offset,
                        sku: sku,
                        skuExists: skuExists
                    })
                    .then(
                        (data) => {
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            getItems: (route, callback, query_obj) => {
                let cb = callback || angular.noop;
                if (angular.isUndefined(query_obj)) {
                    query_obj = {};
                }
                query_obj.user = {
                    user_name: apiScienceLogCred.user_name,
                    password: apiScienceLogCred.password
                };
                query_obj.route = route;
                $http.post(apiBasePath + "/science_logic/get_tables", query_obj).then(
                    (data) => {
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            },
            getItem: (id, route, callback, query_obj) => {
                let cb = callback || angular.noop;
                query_obj.user = {
                    user_name: apiScienceLogCred.user_name,
                    password: apiScienceLogCred.password
                };
                query_obj.route = route;
                query_obj.table_id = id;
                $http.post(apiBasePath + "/science_logic/get_tables", query_obj).then(
                    (data) => {
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            },
            getOrganizations: (callback) => {
                let cb = callback || angular.noop;
                $http
                    .post(apiBasePath + "/science_logic/organizations", {
                        user: {
                            user_name: apiScienceLogCred.user_name,
                            password: apiScienceLogCred.password
                        }
                    })
                    .then(
                        (data) => {
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            createItem: (route, data, callback) => {
                let cb = callback || angular.noop;
                $http
                    .post(apiBasePath + "science_logic/modify_tables", {
                        user: {
                            user_name: apiScienceLogCred.user_name,
                            password: apiScienceLogCred.password
                        },
                        route: route,
                        data: data
                    })
                    .then(
                        (data) => {
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            updateItem: (route, id, data, callback) => {
                let cb = callback || angular.noop;
                $http
                    .put(apiBasePath + "science_logic/modify_tables", {
                        user: {
                            user_name: apiScienceLogCred.user_name,
                            password: apiScienceLogCred.password
                        },
                        table_id: id,
                        route: route,
                        data: data
                    })
                    .then(
                        (data) => {
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            deleteItem: (route, id, callback) => {
                let cb = callback || angular.noop;
                $http
                    .delete(apiBasePath + "science_logic/modify_tables", {
                        user: {
                            user_name: apiScienceLogCred.user_name,
                            password: apiScienceLogCred.password
                        },
                        table_id: id,
                        route: route
                    })
                    .then(
                        (data) => {
                            deferred.resolve(data.data);
                            return cb(data.data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
            },
            getDeviceReport: (fields, type) => {
                let url =
                    apiBasePath +
                    "/science_logic/get_tables?" +
                    "downloadType=" +
                    type +
                    "&route=event" +
                    "&fields=" +
                    fields +
                    "&eventReport=true" +
                    "&hide_filterinfo=1";
                return url;
            },
            getAssetReport: (assets, callback) => {
                let cb = callback || angular.noop;
                $http({
                    method: "POST",
                    cache: false,
                    url: apiBasePath + "/science_logic/asset_report",
                    responseType: "arraybuffer",
                    data: { deviceAssets: assets }
                }).then(
                    (data) => {
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            }
        };
    }
})();

(function () {
    angular.module("burWood").factory("ScienceLogicGQL", ScienceLogicGQL);

    function ScienceLogicGQL($http, $q, apiBasePath) {
        let deferred = $q.defer();
        return {
            getQuery: (queryObj, callback) => {
                let cb = callback || angular.noop;
                $http.post(apiBasePath + "/science_logic/gql", queryObj).then(
                    (data) => {
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        deferred.reject(err);
                        return cb(err);
                    }
                );
            }
        };
    }
})();

(function () {
    angular.module("burWood").controller("SLDashboardController", SLDashboardController);

    /** @ngInject */
    function SLDashboardController(ScienceLogicGQL, $timeout) {
        let vm = this;

    
        //sets width of charts based on dashbaords
        let dashWidth = angular.element(".dashboard-panel").width();
        let dashFullHeight = angular.element(".full-panel").height();
        let dashHalfHeight = angular.element(".half-panel").height();
        dashFullHeight = dashFullHeight * 0.975;
        dashHalfHeight = dashHalfHeight * 0.975;
        const width = dashWidth * 0.975;

        // Mapping of SL states to words
        vm.deviceStatus = {
            0: "Healthy",
            1: "Notice",
            2: "Minor",
            3: "Major",
            4: "Critical"
        };

        // Initialize widget configurations
        vm.widgets = {
            deviceLocations: {
                loading: true,
                name: "deviceLocations",
                title: "Device Locations",
                widgetGQLMethods: "harProviders",
                chart: {
                    height: dashFullHeight
                }
            },
            itServices: {
                loading: true,
                name: "itServices",
                title: "Individual Branch IT Services",
                widgetGQLMethods: "harProviders",
                chart: {
                    height: dashHalfHeight
                }
            },
            dataCenter: {
                loading: true,
                name: "dataCenter",
                title: "Data Center Health and Status",
                widgetGQLMethods: "harProviders",
                chart: {
                    height: dashHalfHeight
                }
            }
        };

        const queries = {
            standardQuery: {
                table: "devices",
                queryName: "siteMaps",
                edge: "devices"
            },
            relatedNodeQuery: {
                table: "devices",
                queryName: "relatedNodes",
                edge: "devices",
                search: {
                    dataProcessor: "processHarProviders",
                    multipleQuery: {
                        relatedNodes: vm.itServices
                    }
                }
            }
        };

        // Hover tooltip formatters for each widget
        vm.tooltipFormatters = {
            deviceLocations: (context) => {
                let parent = false;
                let tooltip;
                if (context.point.risk || context.point.risk === 0) parent = true;
                if (!parent) {
                    tooltip = `The state of <b>${context.point.name}</b> is <b>${
                        !context.point.health ? "Healthy" : context.point.health
                    }</b>`;
                } else {
                    tooltip = `${context.point.name}<br>
                <ul>
                <li>Health: ${context.point.health}</li><br>
                <li>Risk: ${context.point.risk}</li><br>
                <li>Availability: ${context.point.availability}</li>
                </ul>`;
                }

                return tooltip;
            },
            itServices: function (context) {
                return this.deviceLocations(context);
            },
            dataCenter: function (context) {
                return this.deviceLocations(context);
            }
        };

        // Default Highchart configurations
        vm.defaultCharts = {
            sunburst: (data, widget) => {
                return {
                    chart: {
                        type: "sunburst",
                        width: width,
                        height: vm.widgets[widget].chart.height
                    },
                    title: {
                        text: vm.widgets[widget].title.toUpperCase(),
                        style: {
                            fontSize: "30px",
                            color: "grey"
                        }
                    },
                    series: [
                        {
                            type: "sunburst",
                            data: data,
                            allowDrillToNode: true,
                            cursor: "pointer",
                            dataLabels: {
                                format: "{point.name}",
                                filter: {
                                    property: "innerArcLength",
                                    operator: ">",
                                    value: 9
                                },
                                rotationMode: "circular"
                            }
                        }
                    ],

                    tooltip: {
                        formatter: function () {
                            return vm.tooltipFormatters[widget](this);
                        }
                    }
                };
            }
        };

        vm.applyConfig = {
            deviceLocations: (data, widget) => {
                return vm.defaultCharts.sunburst(data, widget);
            },
            itServices: (data, widget) => {
                return vm.defaultCharts.sunburst(data, widget);
            },
            dataCenter: (data, widget) => {
                return vm.defaultCharts.sunburst(data, widget);
            }
        };

        // Main fetch controler for report data
        vm.runProcessor = (widget, query) => {
            ScienceLogicGQL.getQuery(query, (response) => {
                if (response && response.data) {
                    const data = vm.dataProcessors[widget](response.data);
                    if (data.length > 0) {
                        vm.widgets[widget].config = vm.applyConfig[widget](data, widget);
                    } else {
                        vm.widgets[widget].noData = true;
                    }
                } else {
                    vm.widgets[widget].noData = true;
                }
                vm.widgets[widget].loading = false;
            });
        };

        // Fetch device API data from GQL backend module
        vm.dataFetch = {
            deviceLocations: {
                prerequisite: false,
                run: (widget) => {
                    vm.runProcessor(widget, queries.standardQuery);
                }
            },
            itServices: {
                prerequisite: false,
                run: (widget) => {
                    vm.runProcessor(widget, queries.standardQuery);
                }
            },
            dataCenter: {
                prerequisite: true,
                run: (widget) => {
                    queries.relatedNodeQuery.search.multipleQuery.relatedNodes = vm.itServices;
                    vm.runProcessor(widget, queries.relatedNodeQuery);
                }
            }
        };

        vm.fetchBusinessServices = () => {
            ScienceLogicGQL.getQuery(
                {
                    table: "devices",
                    queryName: "businessServices",
                    edge: "devices"
                },
                (response) => {
                    vm.businessServices = [];
                    if (
                        response &&
                        response.data &&
                        response.data.harProviders &&
                        response.data.harProviders.edges.length > 0
                    ) {
                        vm.businessServices = response.data.harProviders.edges.map((edge) => edge.node);
                        vm.dataCenterService = vm.businessServices.find((service) => {
                            return service.name.includes("Datacenter");
                        });
                        if (vm.dataCenterService) {
                            vm.fetchITServices(vm.dataCenterService);
                        } else {
                            vm.cancelReportProcessing();
                        }
                    } else {
                        vm.cancelReportProcessing();
                    }
                }
            );
        };

        vm.fetchBusinessServices();

        vm.fetchITServices = (dataCenterService) => {
            ScienceLogicGQL.getQuery(
                {
                    table: "devices",
                    queryName: "relatedNodes",
                    edge: "devices",
                    search: {
                        service: dataCenterService.id
                    }
                },
                (response) => {
                    if (
                        response &&
                        response.data &&
                        response.data.relatedNodes &&
                        response.data.relatedNodes.edges.length > 0
                    ) {
                        try {
                            vm.itServices = response.data.relatedNodes.edges.map((edge) => edge.node.node2.harProvider);
                            vm.beginDataFetches(true);
                        } catch (e) {
                            vm.itServices = [];
                            vm.cancelReportProcessing();
                        }
                    }
                }
            );
        };

        vm.cancelReportProcessing = () => {
            for (let widget in vm.dataFetch) {
                if (vm.dataFetch[widget].prerequisite) {
                    vm.widgets[widget].noData = true;
                    vm.widgets[widget].loading = false;
                }
            }
        };

        // Cycles through GQL calls for Sciencelogic data
        vm.beginDataFetches = (prerequisite) => {
            for (let widget in vm.widgets) {
                // Check if report need prerequisite data fetch
                prerequisite === vm.dataFetch[widget].prerequisite && vm.dataFetch[widget].run(widget);
            }
        };

        vm.beginDataFetches(false);

        // Processors for each widget's data return
        vm.dataProcessors = {
            deviceLocations: (data) => {
                let processedData = [];
                let deviceIndex = 0;

                if (!data.harProviders || !data.harProviders.edges || data.harProviders.edges.length === 0) {
                    return processedData;
                }

                data.harProviders.edges.forEach((location, locationIndex) => {
                    if (!location.node.description.includes("Site Devices")) {
                        return;
                    }

                    if (
                        !location.node.constituents ||
                        !location.node.constituents.edges ||
                        location.node.constituents.edges.length === 0
                    ) {
                        return;
                    }

                    processedData.push({
                        id: `1.${locationIndex}`,
                        parent: "0.0",
                        health: location.node.health,
                        risk: location.node.risk,
                        availability: location.node.availability,
                        name: `${location.node.constituents.edges[0].node.asset.location} Site Devices`,
                        color: vm.healthColor(location.node.health)
                    });

                    location.node.constituents.edges.forEach((device) => {
                        processedData.push({
                            id: `2.${deviceIndex}`,
                            parent: `1.${locationIndex}`,
                            name: device.node.name,
                            health: vm.deviceStatus[device.node.state],
                            value: 1,
                            color: vm.stateColor(device.node.state)
                        });
                        deviceIndex++;
                    });
                });

                processedData.unshift({
                    id: "0.0",
                    parent: "",
                    color: "seagreen",
                    name: "Site Devices"
                });

                return processedData;
            },
            itServices: (data) => {
                let processedData = [];
                let locationIndex = 0;

                if (!data.harProviders || !data.harProviders.edges || data.harProviders.edges.length === 0) {
                    return processedData;
                }

                data.harProviders.edges.forEach((location) => {
                    if (!location.node.description.includes("IT Service for Branch")) {
                        return;
                    }

                    processedData.push({
                        id: `1.${locationIndex}`,
                        parent: "0.0",
                        health: location.node.health,
                        risk: location.node.risk,
                        availability: location.node.availability,
                        name: location.node.name,
                        color: vm.healthColor(location.node.health),
                        value: 1
                    });

                    locationIndex++;
                });

                processedData.unshift({
                    id: "0.0",
                    parent: "",
                    color: "seagreen",
                    name: `${locationIndex++} IT Services`
                });

                return processedData;
            },
            dataCenter: (data) => {
                let processedData = [];
                let locations = [];
                let parentIndex = 0;
                let childIndex = 0;
                let grandchildIndex = 0;

                data.forEach((parent) => {
                    if (!parent.children || parent.children.length === 0) {
                        return;
                    }

                    locations.push({
                        id: `1.${parentIndex}`,
                        parent: "0.0",
                        health: parent.parent.health,
                        risk: parent.parent.risk,
                        availability: parent.parent.availability,
                        name: parent.parent.name,
                        color: vm.healthColor(parent.parent.health)
                    });

                    parent.children.forEach((child) => {
                        if (!child.grandchildren || child.grandchildren.length === 0) {
                            return;
                        }

                        locations.push({
                            id: `2.${childIndex}`,
                            parent: `1.${parentIndex}`,
                            health: child.health,
                            risk: child.risk,
                            availability: child.availability,
                            name: child.name,
                            color: vm.healthColor(child.health)
                        });

                        child.grandchildren.forEach((grandchild) => {
                            processedData.push({
                                id: `3.${grandchildIndex}`,
                                parent: `2.${childIndex}`,
                                name: grandchild.name,
                                health: vm.deviceStatus[grandchild.state],
                                value: 1,
                                color: vm.stateColor(grandchild.state)
                            });
                            grandchildIndex++;
                        });

                        childIndex++;
                    });

                    parentIndex++;
                });

                processedData.unshift({
                    id: "0.0",
                    parent: "",
                    color: "seagreen",
                    name: "Data Center Services"
                });

                processedData = processedData.concat(locations);

                return processedData;
            }
        };

        // Individual chart colors based on health
        vm.healthColor = (health) => {
            let deviceHealthColor = "seagreen";
            if (health < 100) {
                deviceHealthColor = "goldenrod";
            } else if (health < 75) {
                deviceHealthColor = "orange";
            } else if (health < 50) {
                deviceHealthColor = "red;";
            }
            return deviceHealthColor;
        };

        // Individual chart colors based on state
        vm.stateColor = (health) => {
            let deviceStateColor = "seagreen";
            if (health === "1") {
                deviceStateColor = "goldenrod";
            } else if (health === "2") {
                deviceStateColor = "orange";
            } else if (health === "3") {
                deviceStateColor = "red;";
            }
            return deviceStateColor;
        };

        //resize charts to be responsive
        $timeout(() => {
            angular.element(window).resize(() => {
                angular.element(".highcharts").each(function () {
                    let chart = angular.element(this).highcharts();
                    let w = angular.element(this).closest(".dashboard-panel").width();
                    let h = angular.element(this).closest(".dashboard-panel").height();

                    chart.setSize(w * 0.975, h * 0.975, false);
                });
            });
        }, 1000);
    }
})();

(function () {
    angular.module("burWood").factory("Request", Request);

    function Request(ServiceNow) {
        return {
            getRequest: (state, callback, page_limit, offset, company) => {
                var query_obj = {
                    active_status: true,
                    type: "ticket",
                    company_sys: company
                };
                ServiceNow.getTable(state, "sc_request|ticketsList", callback, page_limit, offset, query_obj);
            },
            getSingle: (incId, callback) => {
                ServiceNow.getItem(incId, "sc_request|ticketsList", callback);
            },
            getSingleHistory: (incId, callback) => {
                ServiceNow.getItem(incId, "sys_history_line", callback);
            },
            getUsers: (state, callback, page_limit, offset, sorting) => {
                let query_obj = {
                    sorting: sorting
                };
                ServiceNow.getTable(state, "sys_user", callback, page_limit, offset, query_obj);
            },
            getCompanyUser: (callback, company_id, page_limit, offset) => {
                ServiceNow.getCompanyUser(callback, company_id, page_limit, offset);
            },
            getExceptions: (callback, company) => {
                ServiceNow.getExceptions(callback, true, company);
            },
            getUser: (userId, callback) => {
                ServiceNow.getItem(userId, "sys_user", callback);
            },
            getUserGroup: (userId, callback) => {
                ServiceNow.getItem(userId, "sys_user_group", callback);
            },
            getDevice: (devId, callback) => {
                ServiceNow.getItem(devId, "cmdb_ci", callback);
            },
            createRequest: (status, callback) => {
                ServiceNow.createItem("sc_request", status, callback);
            },
            deleteRequest: (incId, callback) => {
                ServiceNow.deleteItem("sc_request", incId, callback);
            },
            updateRequest: (incId, status, callback) => {
                ServiceNow.updateItem("sc_request", incId, status, callback);
            }
        };
    }
})();

(function () {
    angular.module("burWood").controller("RequestController", RequestController).filter("RemoveEmail", RemoveEmail);

    function RemoveEmail() {
        return (user) => {
            if (user) {
                let emailRemoved = user.replace(/\s*\(.*?\)\s*/g, "");
                return emailRemoved;
            }
        };
    }

    /** @ngInject */
    function RequestController(
        _,
        $log,
        user_info,
        $stateParams,
        $uibModal,
        FileSaver,
        BCSServer,
        $state,
        $cookies,
        Service,
        Request,
        Status,
        cloud,
        DTOptionsBuilder,
        DTColumnDefBuilder,
        $window,
        ServiceNow,
        reactEndpoint,
        Blob,
        mircoserviceUtil,
        util,
        Alerts,
        $timeout
    ) {
        let vm = this;

        let offset = 0,
            page = 10;

        vm.showImpact = false;
        vm.showUrgency = false;
        vm.sortStart = $stateParams.sort;
        vm.sortType = $stateParams.type;
        vm.sortState = $stateParams.state;
        vm.customTitle = "Request Tickets";
        vm.dtInstance = {};
        vm.showFilters = false;
        vm.current_user_id = user_info.sys_id;
        vm.loading = true;
        vm.accountLoading = true;

        vm.reactEndpoint = reactEndpoint + "/requests/open_cloud_ticket";

        vm.trustSRC = mircoserviceUtil.trustSRC;

        if ($state.current.name === "index.cloud_request_new") {
            mircoserviceUtil.initIframeConnection($state.current.name, (data) => {
                if (data && data.sys_id) {
                    vm.goToTicket(data.sys_id, true);
                }
            });
        }

        //checking if user is admin
        if (
            user_info.group &&
            (user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins Read Only") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins") != -1)
        ) {
            vm.isCloudAmin = true;
        }

        vm.priorities = {
            1: "Critical",
            2: "High",
            3: "Moderate",
            4: "Minimal",
            5: "Informational"
        };

        vm.stateNames = {
            "-5": "Pending",
            1: "Open",
            2: "Work in Progress",
            3: "Closed Complete",
            4: "Closed Incomplete",
            7: "Closed Skipped",
            12: "Waiting For Vendor",
            14: "Waiting For Customer"
        };

        vm.action = "";
        vm.watch_lists = [];
        vm.watch_list_show = false;

        vm.watch_list_users = [];
        vm.related_show = false;

        let exceptions;

        vm.start_date = false;

        vm.cloudCategories = [
            {
                name: "I have a general inquiry",
                id: "General Inquiry"
            },
            {
                name: "I have an idea for a Portal enhancement",
                id: "Portal Enhancement"
            }
        ];

        let adminServicesCategories = [
            {
                name: "I need to Request a New Project",
                id: "New Project Request"
            },
            {
                name: "I need access to a project",
                id: "Project Access"
            },
            {
                name: "I have a question related to a bill or invoice",
                id: "Billing Inquiry"
            },
            {
                name: "I need to add credit to a billing account",
                id: "Add Credit"
            },
            {
                name: "I need to add an NIH Grant",
                id: "Add NIH Grant"
            }
        ];

        let resellerServicesCategories = [
            {
                name: "I need access to a project",
                id: "Project Access"
            },
            {
                name: " have a question related to a bill or invoice",
                id: "Billing Inquiry"
            },
            {
                name: "I need to add credit to a billing account",
                id: "Add Credit"
            }
        ];

        vm.newRequestDescrFields = {
            businessJustification: null,
            risk: null,
            client: null,
            impact: null,
            scope: null,
            owner: null,
            preferredOwner: null,
            type: null,
            associatedTasks: null,
            needsFurtherScoping: null,
            mRR: null,
            notes: null
        };

        vm.newRequestDescrTitles = {
            businessJustification: "Business Justification",
            risk: "Risk",
            client: "Client",
            impact: "Impact",
            scope: "Scope",
            owner: "Owner",
            preferredOwner: "Preferred Owner",
            type: "Type",
            associatedTasks: "Associated Tasks",
            needsFurtherScoping: "Needs Further Scoping",
            mRR: "MRR",
            notes: "Notes"
        };

        vm.newCloudRequestDescrFields = {
            billingOwner: null,
            projectName: null,
            projectOwner: null,
            projectOwnerEmail: null,
            departmentName: null,
            fundNumber: null,
            fundingAmount: null,
            creditAmount: null,
            phiInfo: null,
            additionalUsers: null,
            email: null,
            accountName: null,
            accountNum: null,
            poNumber: null,
            relatedProject: null,
            relatedAccount: null,
            office: null,
            programName: null,
            officerName: null,
            officerEmail: null,
            contactName: null,
            contactEmail: null,
            billingName: null,
            billingEmail: null,
            expirationDate: null
        };

        vm.newCloudRequestDescrTitles = {
            billingOwner: "Billing Owner",
            projectName: "Project Name",
            projectOwner: "Project Owner",
            projectOwnerEmail: "Project Owner Email",
            departmentName: "Department Name",
            fundNumber: "Fund Number",
            fundingAmount: "Funding Amount",
            creditAmount: "Credit Amount",
            phiInfo: "PHI Information Will Be Stored?",
            additionalUsers: "Additional User Names and Emails",
            email: "Email",
            accountName: "Billing Account Name",
            accountNum: "Billing Account Number",
            poNumber: "PO Number",
            relatedProject: "Related Project",
            relatedAccount: "Related Account",
            office: "NIH Institute/Center/Office",
            programName: "Program/Project Name",
            officerName: "Program Officer Name",
            officerEmail: "Program Officer Email",
            contactName: "Primary Contact Name",
            contactEmail: "Primary Contact Email",
            billingName: "Billing Admin Name",
            billingEmail: "Billing Admin Email",
            expirationDate: "Expiration Date"
        };

        vm.priority = [
            {
                id: "1",
                name: "1 - Critical"
            },
            {
                id: "2",
                name: "2 - High"
            },
            {
                id: "3",
                name: "3 - Moderate"
            },
            {
                id: "4",
                name: "4 - Minimal"
            },
            {
                id: "5",
                name: "5 - Informational"
            }
        ];

        vm.states = [
            {
                id: "-5",
                name: "Pending"
            },
            {
                id: "1",
                name: "Open"
            },
            {
                id: "2",
                name: "Work in Progress"
            },
            {
                id: "3",
                name: "Closed Complete"
            },
            {
                id: "4",
                name: "Closed Incomplete"
            },
            {
                id: "7",
                name: "Closed Skipped"
            }
        ];

        vm.types = ["Onboarding", "Pre-Sales Pilot", "Professional Services", "Operaions"];

        vm.scoping = ["Yes", "No"];

        vm.alerts = [];

        vm.createAlertMessage = (alert) => {
            vm.alerts.push({
                status: alert.status,
                msg: alert.msg
            });

            Alerts.storeAlert({
                type: alert.status,
                message: alert.msg,
                user: user_info.email,
                company: user_info.company_name,
                location: $state.current.name,
                tags: ["Problem"]
            });

            if (alert.status === "success") {
                $timeout(() => {
                    vm.alerts = [];
                }, 5000);
            }
        };

        vm.formatTable = (data, row, column) => {
            var pri;
            if (column === 1) {
                if (data.indexOf("5 - Informational") != -1) {
                    pri = "5 - Informational";
                } else if (data.indexOf("4 - Minimal") != -1) {
                    pri = "4 - Minimal";
                } else if (data.indexOf("3 - Moderate") != -1) {
                    pri = "3 - Moderate";
                } else if (data.indexOf("2 - High") != -1) {
                    pri = "2 - High";
                } else if (data.indexOf("1 - Critical") != -1) {
                    pri = "1 - Critical";
                }
                return pri;
            } else if (column === 2 || column === 3) {
                var start_pos = data.indexOf(">") + 1;
                var end_pos = data.indexOf("<", start_pos);
                var text_to_get = data.substring(start_pos, end_pos);
                return text_to_get;
            }
            return data;
        };
        let buttonConfig = [
            {
                extend: "colvis",
                text: "Toggle Columns"
            },
            {
                text: "Search Closed Tickets",
                key: "2",
                action: () => {
                    angular.element("#global_search").triggerHandler("click");
                }
            },
            {
                extend: "collection",
                text: "Export",
                buttons: [
                    {
                        extend: "excel",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.formatTable(data, row, column, node);
                                }
                            }
                        }
                    },
                    {
                        extend: "pdf",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        customize: (doc) => {
                            doc.pageMargins = [5, 5, 5, 5];
                            doc.styles.tableHeader.fontSize = 10;
                            doc.defaultStyle.fontSize = 6;
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.formatTable(data, row, column, node);
                                }
                            }
                        }
                    },
                    {
                        extend: "csv",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.formatTable(data, row, column, node);
                                }
                            }
                        }
                    }
                ]
            }
        ];

        let columnFilter = {
            aoColumns: [
                null,
                null,
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                }
            ]
        };

        if ($state.current.name === "index.cloud_request") {
            buttonConfig.splice(1, 1);
            columnFilter.aoColumns.splice(3, 1);
        }

        if (vm.sortStart && vm.sortType === "Request") {
            buttonConfig.unshift({
                text: "Show All Requests",
                key: "1",
                action: (e, dt, node) => {
                    let table = angular.element(".table").DataTable();
                    table.search("").columns().search("").draw();
                    angular.element(node[0]).addClass("hidden");
                }
            });
        }

        let activityFilter = columnFilter;
        delete activityFilter.aoColumns.shift();

        vm.dtActivityOptions = DTOptionsBuilder.newOptions()
            .withOption("order", [["4", "des"]])
            .withColumnFilter(activityFilter)
            .withOption("responsive", true);
        vm.dtColumnDefsActivity = [
            DTColumnDefBuilder.newColumnDef(4).withOption("type", "date"),
            DTColumnDefBuilder.newColumnDef([3]).withClass("max-size-activity"),
            DTColumnDefBuilder.newColumnDef([1, 2, 4]).withClass("vert-align-activity")
        ];
        if (vm.sortStart && vm.sortType === "Request") {
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('lfB<".table-scroll"rt>ip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withButtons(buttonConfig)
                .withColumnFilter(columnFilter)
                .withOption("responsive", true)
                .withOption("iDisplayLength", 10)
                .withOption("order", [["9", "des"]])
                .withOption("initComplete", () => {
                    let table = angular.element(".table").DataTable();
                    table.column(1).search(vm.sortStart).draw();
                });
            vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef([9, 10]).withOption("type", "date")];
        } else {
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('lfB<".table-scroll"rt>ip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withButtons(buttonConfig)
                .withOption("order", [["9", "des"]])
                .withOption("iDisplayLength", 10)
                .withColumnFilter(columnFilter)
                .withOption("responsive", true);
            if ($state.current.name === "index.cloud_request") {
                vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef([8, 9]).withOption("type", "date")];
            } else {
                vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef([9, 10]).withOption("type", "date")];
            }
        }

        if ($state.current.name === "index.cloud_request_new") {
            BCSServer.postData(
                {
                    view: "project_list"
                },
                "/big_query/get_query",
                (response) => {
                    vm.cloudProjects = cloud.removeExportProjects(response, user_info.company_code);
                }
            );
        }

        vm.fetchAccountNumbers = () => {
            vm.billingAccounts = [];
            BCSServer.postData(
                {
                    companyCode: user_info.company_code
                },
                "/cloud_accounts",
                (response) => {
                    vm.accountLoading = false;
                    if (response && response.accounts && response.accounts.length > 0) {
                        vm.billingAccounts = response.accounts;
                    } else {
                        vm.billingAccounts = [];
                    }
                }
            );
        };
        vm.fetchAccountNumbers();

        Request.getExceptions((data) => {
            if (data.err || !data.results) {
                vm.error = true;
            } else {
                exceptions = data.results;
            }
        }, user_info.company);

        vm.goToDevice = (device) => {
            let except = false;
            for (let x = 0; x < exceptions.length; x++) {
                if (device.toLowerCase() === exceptions[x].name.toLowerCase()) {
                    except = true;
                }
            }
            if (except) {
                $state.go("index.devices", {
                    redirectedDevice: device,
                    exception: true
                });
            } else {
                $state.go("index.devices", {
                    redirectedDevice: device
                });
            }
        };

        vm.goToTicket = (sys_id, cloud) => {
            if (cloud) {
                $state.go("index.cloud_request_single", {
                    reqID: sys_id
                });
            } else {
                $state.go("index.request_single", {
                    reqID: sys_id
                });
            }
        };

        vm.extractDisplayValue = (object, field) => {
            if (object[field]) {
                vm[field] = vm.extractSysID(object[field].link);
                return object[field].display_value;
            } else {
                return new String("");
            }
        };

        vm.extractSysID = (value) => {
            let stringSplit = value.split("/");
            var sys_id = stringSplit[stringSplit.length - 1];
            return sys_id;
        };

        let loadRequest = () => {
            let reqID = $stateParams.reqID;
            Request.getSingle(reqID, (data) => {
                vm.loading = false;
                var watch_lists_arr = data.results.watch_list;
                if (data.error) {
                    vm.request = [];
                } else {
                    vm.request = data.results;
                    vm.request.comments = null;

                    vm.related_show = false;
                    vm.show_related();

                    let displayFields = ["assigned_to", "assignment_group", "cmdb_ci", "opened_by", "requested_for"];
                    displayFields.forEach((field) => {
                        vm.request[field] = vm.extractDisplayValue(vm.request, field);
                    });

                    vm.watch_lists = [];
                    if (
                        watch_lists_arr != undefined &&
                        watch_lists_arr != null &&
                        watch_lists_arr != "" &&
                        watch_lists_arr != " "
                    ) {
                        vm.watch_lists = watch_lists_arr.split(",");
                    }
                    for (var key in vm.watch_lists) {
                        var user_id = vm.watch_lists[key];
                        if (user_id.indexOf("@") == -1) {
                            Status.getUser(user_id, (data) => {
                                var item;
                                if (data.results) {
                                    item = {
                                        sys_id: data.results.sys_id,
                                        name: data.results.name
                                    };
                                    let found = vm.watch_list_users.some((el) => {
                                        return el.name === data.results.name;
                                    });
                                    if (!found) {
                                        vm.watch_list_users.push(item);
                                    }
                                } else {
                                    if (user_id != null && user_id != "") {
                                        item = {
                                            sys_id: user_id,
                                            name: user_id
                                        };
                                        var found2 = vm.watch_list_users.some((el) => {
                                            return el.name === user_id;
                                        });
                                        if (!found2) {
                                            vm.watch_list_users.push(item);
                                        }
                                    }
                                }
                            });
                        } else {
                            vm.watch_list_users.push({
                                name: user_id,
                                sys_id: ""
                            });
                        }
                    }
                }
            });
        };

        vm.combineInternalRequestFields = (cloud) => {
            var titleObj, fieldObj;
            cloud ? (titleObj = "newCloudRequestDescrTitles") : (titleObj = "newRequestDescrTitles");
            cloud ? (fieldObj = "newCloudRequestDescrFields") : (fieldObj = "newRequestDescrFields");
            !vm.request.description
                ? (vm.request.description = "ADDITIONAL INFORMATION: ")
                : (vm.request.description += "\n\n ADDITIONAL INFORMATION: ");
            for (var specialField in vm[fieldObj]) {
                if (vm[fieldObj][specialField]) {
                    vm.request.description += "\n" + vm[titleObj][specialField] + ": " + vm[fieldObj][specialField];
                }
            }
        };

        vm.formatDate = (requestDate) => {
            requestDate = new Date(requestDate).toISOString();
            requestDate = requestDate.replace("T", " ").substring(0, 19);
        };

        vm.create = (request, $valid) => {
            vm.loading = true;
            vm.alerts = [];
            request.approval = "Approved";
            request.opened_by = user_info.sys_id;
            request.requested_for = vm.caller_id;
            request.contact_type = "self-service";
            request.company = user_info.company;
            request.impact = request.priority;
            request.urgency = request.priority;
            request.special_instructions = "no_sc_request_item";
            request.assignment_group = "7fc641e94ffc5e4061fcc3fd0210c70c";

            if ($state.current.name === "index.request_new_internal") {
                request.requested_date && vm.formatDate(request.requested_date);
                request.assignment_group = "f02b87154f5f3f08b9c57fe24210c726";
                vm.combineInternalRequestFields();
            }

            if ($state.current.name === "index.cloud_request_new") {
                if (vm.adminServices) {
                    request.assignment_group = "7fc641e94ffc5e4061fcc3fd0210c70c";
                    if (vm.request.short_description === "New Project Request") {
                        !vm.newCloudRequestDescrFields.phiInfo && (vm.newCloudRequestDescrFields.phiInfo = "false");
                    }
                } else {
                    request.assignment_group = "9550b50213f38b00e11f57963244b009";
                }
                vm.newCloudRequestDescrFields.expirationDate &&
                    (vm.newCloudRequestDescrFields.expirationDate =
                        vm.newCloudRequestDescrFields.expirationDate.toString());
                request.priority = "3";
                vm.combineInternalRequestFields("cloud");
            }

            if ($valid) {
                Request.createRequest(request, (data) => {
                    vm.loading = false;
                    if (data.error) {
                        vm.request = [];
                        vm.error = true;
                        vm.createAlertMessage({
                            msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                                data.error.detail ? data.error.detail : ""
                            }`,
                            status: "fail"
                        });
                    } else if (data.result) {
                        if (vm.attachmentList.length != 0) {
                            let count = 0;
                            for (let x = 0; x < vm.attachmentList.length; x++) {
                                ServiceNow.addAttachment(
                                    data.result.sys_id,
                                    "sc_request",
                                    [vm.attachmentList[x]],
                                    () => {
                                        count++;
                                        if (count === vm.attachmentList.length) {
                                            $uibModal.open({
                                                templateUrl: "app/shared/html/ticketConfirmation.html",
                                                ariaLabelledBy: "modal-title",
                                                ariaDescribedBy: "modal-body",
                                                controller: "TicketRedirectController",
                                                controllerAs: "vm",
                                                resolve: {
                                                    ticket: () => {
                                                        return {
                                                            number: data.result.number,
                                                            sys_id: data.result.sys_id
                                                        };
                                                    },
                                                    field: () => "reqID",
                                                    route: () =>
                                                        $state.current.name === "index.cloud_request_new"
                                                            ? "cloud_request_single"
                                                            : "request_single"
                                                }
                                            });
                                        }
                                    }
                                );
                            }
                        } else {
                            $uibModal.open({
                                templateUrl: "app/shared/html/ticketConfirmation.html",
                                ariaLabelledBy: "modal-title",
                                ariaDescribedBy: "modal-body",
                                controller: "TicketRedirectController",
                                controllerAs: "vm",
                                resolve: {
                                    ticket: () => {
                                        return {
                                            number: data.result.number,
                                            sys_id: data.result.sys_id
                                        };
                                    },
                                    field: () => "reqID",
                                    route: () =>
                                        $state.current.name === "index.cloud_request_new"
                                            ? "cloud_request_single"
                                            : "request_single"
                                }
                            });
                        }
                    } else {
                        vm.createAlertMessage({
                            msg: "Failed to create ticket",
                            status: "fail"
                        });
                    }
                });
            } else {
                vm.createAlertMessage({
                    msg: "Invalid form",
                    status: "fail"
                });
            }
        };
        vm.update = (stateId, request) => {
            vm.loading = true;
            vm.alerts = [];
            var new_request = {};
            if (vm.action == "update") {
                //let values = $.map($('.watch-list-select option'), function(e){return e.value;});
                var watch_list_arr = [];
                var temp_watch_list = Object.assign({}, vm.watch_list_users);
                for (var key in temp_watch_list) {
                    watch_list_arr.push(temp_watch_list[key].sys_id);
                }

                var request_watch_list = watch_list_arr.join(",");

                if (!vm.request.contact_type) {
                    vm.request.contact_type = "phone";
                }

                new_request.watch_list = request_watch_list;
                new_request.short_description = vm.request.short_description;
                new_request.comments = vm.request.comments;
                new_request.contact_type = vm.request.contact_type;

                Request.updateRequest(stateId, new_request, (data) => {
                    vm.loading = false;
                    if (data.error) {
                        vm.createAlertMessage({
                            msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                                data.error.detail ? data.error.detail : ""
                            }`,
                            status: "fail"
                        });
                    } else if (data.result) {
                        vm.createAlertMessage({
                            msg: `Successfully updated ticket.`,
                            status: "success"
                        });
                        loadRequest();
                    } else {
                        vm.createAlertMessage({
                            msg: "Failed to update ticket",
                            status: "fail"
                        });
                    }
                });
            } else if (vm.action == "resolve") {
                request.state = 6;
                new_request = {};
                new_request.state = 6;
                new_request.contact_type = request.contact_type;
                new_request.comments = request.comments;
                if (new_request.contact_type == "") {
                    new_request.contact_type = "self-service";
                }
                Request.updateRequest(stateId, new_request, (data) => {
                    vm.loading = false;
                    if (data.error) {
                        vm.createAlertMessage({
                            msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                                data.error.detail ? data.error.detail : ""
                            }`,
                            status: "fail"
                        });
                    } else if (data.result) {
                        vm.request = data.result;
                        vm.createAlertMessage({
                            msg: `Successfully updated ticket.`,
                            status: "success"
                        });
                        loadRequest();
                    } else {
                        vm.createAlertMessage({
                            msg: "Failed to update ticket",
                            status: "fail"
                        });
                    }
                });
            }
        };
        vm.delete = (stateId) => {
            Request.deleteRequest(stateId, (data) => {
                if (data.error) {
                    vm.error = true;
                } else {
                    vm.error = false;
                }
            });
        };
        vm.switch_watchlist = () => {
            vm.watch_list_show = !vm.watch_list_show;
        };

        vm.findToRemoveById = (user_id) => {
            for (let i = 0; i < vm.watch_list_users.length; i++) {
                let user = vm.watch_list_users[i];
                if (user["sys_id"] == user_id) {
                    vm.watch_list_users.splice(i, 1);
                    return user_id;
                }
            }
        };

        vm.delete_watchlist = () => {
            angular.element(".watch-list-select option:selected").remove();
            if (vm.watch_list_selected != null) {
                angular.forEach(vm.watch_list_selected, (user_id) => {
                    vm.findToRemoveById(user_id);
                });
            }
        };

        vm.addEmail_watchlist = (user_email) => {
            if (user_email == null || user_email == "") {
                return;
            }
            let user = {
                sys_id: user_email,
                name: user_email
            };
            vm.add_watchlist(user);
        };
        vm.add_watchlist = (watch_list) => {
            if (vm.watch_list_users.length > 0) {
                vm.watch_list_users.push(watch_list);
            } else {
                vm.watch_list_users = [watch_list];
            }
            vm.watch_list_email = null;
            //       getUserWatchLists();
        };
        vm.go_back = () => {
            $window.history.back();
        };
        vm.page_changed = () => {
            vm.offset = parseInt(vm.current_page - 1) * page;
            $state.go("index.requests", {
                offset: vm.offset
            });
        };
        vm.close_notice = (index) => {
            vm.alerts.splice(index, 1);
        };

        vm.contact = (type) => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ContactController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                if (data) {
                    if (type == "opened_by") {
                        vm.caller_name = data.name;
                        vm.caller_id = data.caller_id;
                    } else if (type == "requested_for") {
                        vm.requested_for_name = data.name;
                        vm.requested_for_id = data.caller_id;
                    } else {
                        var insert_data = {
                            sys_id: data.caller_id,
                            name: data.name
                        };
                        vm.watch_list_users.push(insert_data);
                    }
                }
            });
        };

        vm.searchUser = (type) => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ContactController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                if (data) {
                    if (type == "preferred") {
                        vm.newRequestDescrFields.preferredOwner = data.name;
                    } else {
                        vm.newRequestDescrFields.owner = data.name;
                    }
                }
            });
        };

        vm.device = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/device_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "DeviceListController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                vm.device_name = data.name;
                vm.device_id = data.device_id;
            });
        };

        vm.show_related = (update) => {
            if (vm.related_show == true && !update) {
                vm.related_show = false;
                return;
            }
            let reqID = $stateParams.reqID;
            vm.related_show = true;
            vm.related_loading = true;
            vm.getJournalEntries(reqID);
        };

        vm.fetchProvidedServices = () => {
            vm.loading = true;
            Service.getQuery(
                {
                    u_company: user_info.company,
                    bypassCompany: true,
                    u_installed: true
                },
                "u_provided_services",
                (response) => {
                    vm.loading = false;
                    if (response.results && response.results.length > 0) {
                        var p_services = response.results;
                        p_services = p_services.map((service) => {
                            return service.u_service;
                        });

                        if (p_services.includes("GCP Admin Services") && p_services.includes("GCP Reseller")) {
                            vm.cloudCategories = vm.cloudCategories.concat(adminServicesCategories);
                        } else if (p_services.includes("GCP Admin Services")) {
                            vm.adminServices = true;
                            vm.cloudCategories = vm.cloudCategories.concat(adminServicesCategories);
                        } else if (p_services.includes("GCP Reseller")) {
                            vm.cloudCategories = vm.cloudCategories.concat(resellerServicesCategories);
                        }
                    }
                }
            );
        };

        vm.getJournalEntries = (statusID) => {
            Status.getJournal(
                statusID,
                (data) => {
                    if (data.error) {
                        vm.related_loading = false;
                        $log.info(data.error);
                    } else {
                        vm.related_result = [];
                        let journals = data.results;
                        if (journals) {
                            journals.forEach((journal) => {
                                if (journal.element === "comments" || journal.element === "status") {
                                    if (journal.element.indexOf("_") != -1) {
                                        journal.element = journal.element.replace("_", " ");
                                        journal.element = util.capitalizeFirstLetter(journal.element);
                                    } else {
                                        journal.element = util.capitalizeFirstLetter(journal.element);
                                    }
                                    let addHistory = {
                                        sortDate: journal.sys_created_on.toString(),
                                        sys_created_on: journal.sys_created_on.toString(),
                                        value: journal.value,
                                        sys_created_by: journal.sys_created_by,
                                        element: journal.element
                                    };
                                    vm.related_result.push(addHistory);
                                }
                            });
                        }
                        vm.getHistoryLine(statusID);
                    }
                },
                300,
                0
            );
        };

        vm.getHistoryLine = (statusID) => {
            Status.getHistory(
                statusID,
                (data) => {
                    if (data.error) {
                        vm.related_loading = false;
                        $log.info(data.error);
                    } else {
                        let noDuplicate = [];
                        let histories = data.results;
                        if (histories) {
                            histories.forEach((history) => {
                                if (history.field === "state") {
                                    let addActivity = {
                                        sortDate: history.update_time,
                                        sys_created_on: history.update_time,
                                        value: history.new,
                                        sys_created_by: history.u_name_id,
                                        element: history.label
                                    };
                                    if (noDuplicate.indexOf(history.new) == -1) {
                                        noDuplicate.push(history.new);
                                        vm.related_result.push(addActivity);
                                    }
                                }
                            });
                        }
                        vm.getFieldChanges(statusID);
                    }
                },
                300,
                0
            );
        };

        vm.getFieldChanges = (statusID) => {
            Service.getQuery(
                {
                    tablename: "sc_request",
                    fieldname: "priority",
                    documentkey: statusID
                },
                "sys_audit",
                (auditResponse) => {
                    if (auditResponse.error) {
                        vm.related_loading = false;
                        $log.info(auditResponse.error);
                    } else {
                        let audits = auditResponse.results;
                        if (audits) {
                            audits.forEach((audit) => {
                                let addActivity = {
                                    sortDate: audit.sys_created_on,
                                    sys_created_on: audit.sys_created_on,
                                    value: vm.priorities[audit.newvalue],
                                    sys_created_by: audit.sys_created_by,
                                    element: util.capitalizeFirstLetter(audit.fieldname)
                                };
                                vm.related_result.push(addActivity);
                            });
                        }
                    }
                    vm.getAttachedFiles(statusID);
                }
            );
        };

        let attachmentLength = 0;
        let attachmentIndex = 0;

        vm.getAttachedFiles = (statusID) => {
            ServiceNow.getAllAttachment(statusID, "sc_request", 10, 10, (data) => {
                if (data && data.result && data.result.length > 0) {
                    let attachments = data.result;
                    attachmentLength = data.result.length;
                    attachments.forEach((attachment) => {
                        vm.getSingleFileData(attachment);
                    });
                } else {
                    vm.related_result.sort((a, b) => {
                        return new Date(a.sortDate) - new Date(b.sortdate);
                    });
                    vm.related_loading = false;
                }
            });
        };

        vm.nonImageAttachments = {};

        vm.getSingleFileData = (attachment) => {
            ServiceNow.getAttachment(attachment.sys_id, (data) => {
                if (data) {
                    let blobData = new Blob([data], {
                        type: attachment.content_type
                    });

                    let activityItem = {
                        sortDate: attachment.sys_created_on,
                        sys_created_on: attachment.sys_created_on,
                        dataURL: "",
                        sys_created_by: attachment.sys_created_by,
                        element: "Attachment"
                    };

                    if (attachment && attachment.content_type.includes("image")) {
                        activityItem.dataURL = URL.createObjectURL(blobData);
                        activityItem.image = true;
                    } else {
                        vm.nonImageAttachments[attachment.file_name] = blobData;
                        activityItem.dataURL = attachment.file_name;
                        activityItem.image = false;
                    }

                    vm.related_result.push(activityItem);
                }
                attachmentIndex++;
                if (attachmentLength === attachmentIndex) {
                    vm.related_result.sort((a, b) => {
                        return new Date(a.sortDate) - new Date(b.sortdate);
                    });
                    attachmentLength = 0;
                    attachmentIndex = 0;
                    vm.related_loading = false;
                }
            });
        };

        vm.downloadFromActivity = (file) => {
            let blobData = vm.nonImageAttachments[file];
            FileSaver.saveAs(blobData, file);
        };

        vm.detail_loading = {};
        vm.related_detail = {};

        vm.show_related_detail = (sys_id, key) => {
            vm.detail_loading[key] = true;
            Request.getSingleHistory(sys_id, (data) => {
                vm.detail_loading[key] = false;
                if (data.error) {
                    vm.related_detail[key] = [];
                } else {
                    vm.related_detail[key] = data.result;
                }
            });
        };
        vm.related_filter = (item) => {
            return (
                item.label == "Priority" ||
                item.label == "Short description" ||
                item.label == "Request" ||
                item.label == "Additional comments"
            );
        };

        vm.attachmentList = [];
        vm.attachment = () => {
            let modalInst = $uibModal.open({
                resolve: {
                    list: () => {
                        return vm.attachmentList;
                    },
                    params: () => {
                        return {
                            table: "sc_request",
                            newTable: "request_new",
                            fieldID: "reqID"
                        };
                    }
                },
                templateUrl: "app/shared/html/attachment_form.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "AttachmentController",
                controllerAs: "vm"
            });
            modalInst.result.then(
                (data) => {
                    vm.attachmentList = data;
                    vm.related_show = false;
                    vm.show_related(true);
                },
                () => {
                    vm.related_show = false;
                    vm.show_related(true);
                }
            );
        };

        vm.company = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/components/navbar/clientpicker.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "CompanyListController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                vm.newRequestDescrFields.client = data.company;
            });
        };

        var state_name = $state.current.name;
        switch (state_name) {
            case "index.request_new":
                vm.loading = false;
                vm.caller_name = user_info.name;
                vm.caller_id = user_info.sys_id;
                vm.opened_by_name = user_info.name;
                break;
            case "index.cloud_request_new":
                vm.loading = false;
                vm.caller_name = user_info.name;
                vm.caller_id = user_info.sys_id;
                vm.fetchProvidedServices();
                break;
            case "index.cloud_request":
                vm.caller_name = user_info.name;
                vm.caller_id = user_info.sys_id;
                Request.getRequest(
                    "",
                    (data) => {
                        vm.loading = false;
                        vm.requests = [];
                        if (data.error || !data.results || data.results.length === 0) {
                            vm.requests = [];
                            // $state.go("index.cloud_request_new");
                        } else {
                            vm.requests = data.results;
                        }
                    },
                    5000,
                    offset
                );
                break;
            case "index.request_new_internal":
                // if (user_info.company === '8d8073014f8d0300d227d48e5210c785' || user_info.company === 'c94993314a362312005cfc20c1aa15d2') {
                // 	$state.go("index.index");
                // }
                vm.loading = false;
                vm.caller_name = user_info.name;
                vm.caller_id = user_info.sys_id;
                break;
            case "index.cloud_request_single":
            case "index.request_single":
                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withDOM('lfB<".table-scroll"rt>ip')
                    .withOption("aoColumnDefs", [
                        {
                            bSortable: false,
                            aTargets: ["nosort"]
                        }
                    ])
                    .withButtons(buttonConfig)
                    .withOption("order", [["4", "des"]])
                    .withOption("iDisplayLength", 25)
                    .withOption("responsive", true);
                vm.loading = true;
                if ($cookies.get("user_role") == "itil") {
                    vm.resolve_button = true;
                } else {
                    vm.resolve_button = false;
                }
                if ($stateParams.reqID != undefined) {
                    loadRequest();
                } else {
                    $state.go("index.requests");
                }
                break;
            case "index.requests":
                vm.loading = true;
                Request.getRequest(
                    "",
                    (data) => {
                        vm.loading = false;
                        vm.requests = [];
                        if (data.error || !data.results) {
                            $log.info(data.error);
                        } else {
                            vm.requests = data.results;
                        }
                    },
                    5000,
                    offset
                );
                break;
        }

        angular.element("body").on("click", "#dt-title", () => {
            angular.element("#dt-title").remove();
            let table = angular.element(".table").DataTable();
            table.search("").columns().search("").draw();
        });
    }
})();

(function () {
    angular.module("burWood").controller("ResetController", ResetController);

    /** @ngInject */
    function ResetController($stateParams, $state, BCSServer, $timeout, moment) {
        let vm = this;
        vm.login_error = false;
        let resetID = $stateParams.key;
        vm.invalid = true;
        vm.loading = true;
        vm.invalid_message = "";

        vm.user = {
            password: "",
            password2: ""
        };

        BCSServer.postData(
            {
                encode_sys_id: resetID
            },
            "/valid_user",
            (response) => {
                if (response.success === true) {
                    BCSServer.postData(
                        {
                            id: resetID
                        },
                        "/reset_expiration",
                        (response) => {
                            if (response && response.error) {
                                vm.invalid = true;
                                vm.invalid_message = "Failed to find reset key.";
                            }
                            if (response && response[0] && response[0].time) {
                                let now = moment();
                                let expiration = moment(response[0].time);
                                let difference = now.diff(expiration, "seconds");
                                if (difference < 3600) {
                                    //checking if link is expired
                                    vm.invalid = false;
                                } else {
                                    vm.invalid_message = "Expired Reset Link";
                                    vm.invalid = true;
                                }
                            } else {
                                vm.invalid = true;
                                vm.invalid_message = "Failed to find reset key.";
                            }
                            vm.loading = false;
                        }
                    );
                } else {
                    vm.loading = false;
                    vm.invalid = true;
                    vm.invalid_message = response.error || "Invalid Reset Link";
                }
            }
        );

        vm.resetPass = (user) => {
            if (user.password === user.password2) {
                if (user.password.length >= 8) {
                    BCSServer.postData(
                        {
                            encode_sys_id: resetID,
                            password: user.password,
                            confirmPassword: user.password2,
                            forgotPass: true
                        },
                        "/user_password",
                        (response) => {
                            if (response.success === true) {
                                vm.alert = {
                                    type: "danger",
                                    msg: "Password Set Successfully"
                                };
                                vm.login_error = true;
                                $timeout(() => {
                                    $state.go("login");
                                }, 1500);
                            } else {
                                vm.alert = {
                                    type: "danger",
                                    msg: "Password Set Not Successful. For assistance please contact support at 312-592-8387 or support@burwood.com"
                                };
                                vm.login_error = true;
                            }
                        }
                    );
                } else {
                    vm.alert = {
                        type: "danger",
                        msg: "Password must be at least 8 characters long."
                    };
                    vm.login_error = true;
                }
            } else {
                vm.alert = {
                    type: "danger",
                    msg: "Password do not match."
                };
                vm.login_error = true;
            }
        };
    }
})();

(function () {
    angular.module("burWood").controller("QuoteController", QuoteController);

    function QuoteController(_, $log, user_info, BCSServer, $window){
        
        let vm = this;
        const pdfMake = $window.pdfMake;
        vm.loading = false;
        // requestInfo is bound to gcp_quote.html
        vm.requestInfo = {
            amount: "",
            userName: user_info.name,
            userEmail: user_info.email,
            userCompany: user_info.company_name,
            quotedFor: '',
            quotedToIsDifferentThanQuotedFor: false,
            quoteDescription: ''
        };

        vm.requestPDF = () => {
            try {
                const backendRoute = '/quote_pdf';
                vm.loading = true;
                BCSServer.postData(vm.requestInfo, backendRoute, (res) => {
                    // if error, alert the user and log the error.
                    // message propogation could be used instead of alerting.
                    if (res.status === 500){
                        alert("An error occurred, please try again later.");
                        throw "Error from server when creating PDF quote.";
                    }

                    const today = new Date();
                    const dd = String(today.getDate()).padStart(2, '0');
                    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                    const yyyy = today.getFullYear();

                    const currentDate = mm + '/' + dd + '/' + yyyy;

                    const fileName = `${vm.requestInfo.userCompany}_${currentDate}_${res}`;

                    pdfMake.createPdf(constructPDF(vm.requestInfo, res, currentDate)).download(fileName);
                    vm.loading = false;
                });

            } catch (error) {
                console.log(error);
            }
        }

        const addCommas = (number) =>  {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        

        const constructPDF = (requestInfo, quoteNumber, currentDate) => {
            requestInfo.amount = addCommas(requestInfo.amount)

            return {
                content: [
                    {
                        columns: [
                            {
                                stack: [
                                    {
                                        image: "data:image/png;base64,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",
                                        width: 50
                                    },
                                    {
                                        text: "Burwood Group, Inc.\n125 S. Wacker Dr., Suite 2950\nChicago, IL 60606\n(312) 327-4600",
                                        alignment: "left",
                                        bold: true
                                    }
                                ]
                            },
                            [
                                {
                                    text: "QUOTATION",
                                    color: "#333333",
                                    width: "*",
                                    fontSize: 24,
                                    bold: true,
                                    alignment: "right",
                                    elision: true,
                                    margin: [0, 0, 20, 2],
                                    decoration: "underline"
                                },
                                {
                                    stack: [
                                        {
                                            columns: [
                                                {
                                                    text: "Quote #:",
                                                    style: "headerLeftDetail"
                                                },
                                                {
                                                    text: `${quoteNumber}`,
                                                    style: "headerRightDetail"
                                                }
                                            ]
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: "Date:",
                                                    style: "headerLeftDetail"
                                                },
                                                {
                                                    text: currentDate,
                                                    style: "headerRightDetail"
                                                }
                                            ]
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: "Payment Terms:",
                                                    style: "headerLeftDetail"
                                                },
                                                {
                                                    text: "Net 30",
                                                    style: "headerRightDetail"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        ]
                    },
                    "\n",
                    {
                        columns: [
                            {
                                text: "Quoted to:",
                                color: "#aaaaab",
                                bold: true,
                                fontSize: 14,
                                alignment: "left",
                                margin: [0, 20, 0, 5]
                            },
                            {
                                text: "Quoted for:",
                                color: "#aaaaab",
                                bold: true,
                                fontSize: 14,
                                alignment: "left",
                                margin: [0, 20, 0, 5]
                            },
                            {
                                text: "Quote Description:",
                                color: "#aaaaab",
                                bold: true,
                                fontSize: 14,
                                alignment: "left",
                                margin: [0, 20, 0, 5]
                            }
                        ]
                    },
                    {
                        columns: [
                            {
                                text: `${requestInfo.userName} \n ${requestInfo.userCompany}`,
                                bold: true,
                                color: "#333333",
                                alignment: "left"
                            },
                            {
                                text: `${requestInfo.quotedToIsDifferentThanQuotedFor 
                                            ? requestInfo.quotedFor 
                                            : requestInfo.userName} \n ${requestInfo.userCompany}`,
                                bold: true,
                                color: "#333333",
                                alignment: "left"
                            },
                            {
                                text: `${requestInfo.quoteDescription}`,
                                bold: true,
                                color: "#333333",
                                alignment: "left"
                            }
                        ]
                    },
                    "\n\n",
                    {
                        layout: "lightHorizontalLines",
                        table: {
                            headerRows: 1,
                            widths: [35, 80, 40, 40, "*", 80, 80],
                            body: [
                                [
                                    {
                                        text: "Line #",
                                        style: "tableHeader"
                                    },
                                    {
                                        text: "Qty",
                                        style: "tableHeader"
                                    },
                                    {
                                        text: "Item",
                                        style: "tableHeader"
                                    },
                                    {
                                        text: "Type",
                                        style: "tableHeader"
                                    },
                                    {
                                        text: "Description",
                                        style: "tableHeader"
                                    },
                                    {
                                        text: "Unit Price",
                                        style: "tableHeader"
                                    },
                                    {
                                        text: "Ext. Price",
                                        style: "tableHeader"
                                    }
                                ],
                                [
                                    {
                                        text: "1",
                                        style: "tableRowItem"
                                    },
                                    {
                                        text: `${requestInfo.amount}`,
                                        style: "tableRowItem"
                                    },
                                    {
                                        text: "GCP",
                                        style: "tableRowItem"
                                    },
                                    {
                                        text: "Cloud",
                                        style: "tableRowItem"
                                    },
                                    {
                                        text: "Google Cloud Platform",
                                        style: "tableRowItem"
                                    },
                                    {
                                        text: "$1.00",
                                        style: "tableRowItem"
                                    },
                                    {
                                        text: `$${requestInfo.amount}`,
                                        style: "tableRowItem",
                                        fillColor: "#f5f5f5"
                                    }
                                ]
                            ]
                        }
                    },
                    "\n",
                    "\n\n",
                    {
                        layout: {
                            defaultBorder: false,
                            hLineWidth: function () {
                                return 1;
                            },
                            vLineWidth: function () {
                                return 1;
                            },
                            hLineColor: function () {
                                return "#eaeaea";
                            },
                            vLineColor: function () {
                                return "#eaeaea";
                            },
                            hLineStyle: function () {
                                return null;
                            },

                            paddingLeft: function () {
                                return 10;
                            },
                            paddingRight: function () {
                                return 10;
                            },
                            paddingTop: function () {
                                return 3;
                            },
                            paddingBottom: function () {
                                return 3;
                            },
                            fillColor: function () {
                                return "#fff";
                            }
                        },
                        table: {
                            headerRows: 1,
                            widths: ["*", "auto"],
                            body: [
                                [
                                    {
                                        text: "Payment Subtotal",
                                        border: [false, true, false, true],
                                        alignment: "right",
                                        margin: [0, 5, 0, 5]
                                    },
                                    {
                                        border: [false, true, false, true],
                                        text: `$${requestInfo.amount}`,
                                        alignment: "right",
                                        fillColor: "#f5f5f5",
                                        margin: [0, 5, 0, 5]
                                    }
                                ],
                                [
                                    {
                                        text: "Sales Tax",
                                        border: [false, false, false, true],
                                        alignment: "right",
                                        margin: [0, 5, 0, 5]
                                    },
                                    {
                                        text: "$0.00",
                                        border: [false, false, false, true],
                                        fillColor: "#f5f5f5",
                                        alignment: "right",
                                        margin: [0, 5, 0, 5]
                                    }
                                ],
                                [
                                    {
                                        text: "Shipping",
                                        border: [false, false, false, true],
                                        alignment: "right",
                                        margin: [0, 5, 0, 5]
                                    },
                                    {
                                        text: "$0.00",
                                        border: [false, false, false, true],
                                        fillColor: "#f5f5f5",
                                        alignment: "right",
                                        margin: [0, 5, 0, 5]
                                    }
                                ],
                                [
                                    {
                                        text: "Total Amount",
                                        bold: true,
                                        fontSize: 20,
                                        alignment: "right",
                                        border: [false, false, false, true],
                                        margin: [0, 5, 0, 5]
                                    },
                                    {
                                        text: `USD $${requestInfo.amount}`,
                                        bold: true,
                                        fontSize: 20,
                                        alignment: "right",
                                        border: [false, false, false, true],
                                        fillColor: "#f5f5f5",
                                        margin: [0, 5, 0, 5]
                                    }
                                ]
                            ]
                        }
                    },
                    {
                        text:'This quote is valid with an active Google Cloud Platform Resale Agreement. Internet2 Net+GCP, NIH STRIDES or Direct Google Cloud Agreements with Burwood Group, Inc. all satisfy this requirement.',
                        style: 'notesTitle',
                        margin: [0,45,0,3]
                    },
                    {
                        text: "The Burwood Group, Inc. Standard Terms and Conditions of Sale document shall be a part of this quotation. Upon the purchase of the goods by Buyer, Buyer shall receive the warranty provided by the original manufacturer and Buyer shall rely on the original manufacturer’s warranty for any and all defects. To accept this quotation, please email your signed quote and purchase order to orders@burwood.com for processing. All invoice related questions should be directed to ar@burwood.com.",
                        style: "notesTitle"
                    },
                    "\n\n",
                    {
                        text: "Approved by: _________________________ Date: _________________________ Purchase Order Number: _________________________",
                        fontSize: 9,
                        alignment: "center"
                    }
                ],
                styles: {
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 5, 0, 3]
                    },
                    headerRightDetail: {
                        bold: true,
                        color: "#333333",
                        fontSize: 12,
                        alignment: "right",
                        width: 120,
                        margin: [0, 0, 20, 0]
                    },
                    headerLeftDetail: {
                        color: "#aaaaab",
                        bold: true,
                        width: "*",
                        fontSize: 12,
                        alignment: "right",
                        margin: [0, 0, 0, 2]
                    },
                    tableHeader: {
                        fillColor: "#eaf2f5",
                        border: [false, true, false, true],
                        margin: [0, 5, 0, 5],
                        textTransform: "uppercase",
                        font: "Roboto"
                    },
                    tableRowItem: {
                        border: [false, false, false, true],
                        margin: [0, 5, 0, 5],
                        alignment: "left"
                    },
                    notesText: {
                        fontSize: 10
                    }
                },
                defaultStyle: {
                    columnGap: 20
                }
            };
        }
    }
})();
(function () {
    angular.module("burWood").factory("Report", Report);

    function Report(ServiceNow, ScienceLogic, Server, apiBasePath) {
        return {
            getTable: (
                callback,
                type,
                page_limit,
                offset,
                sorting,
                date_range,
                setRange,
                state,
                company_id,
                begin_date,
                end_date,
                devCategory,
                ticketCategory,
                inc_sla
            ) => {
                let query_obj = {
                    sorting: sorting,
                    date_range: date_range,
                    setRange: setRange,
                    state: state,
                    begin_date: begin_date,
                    end_date: end_date,
                    "cmdb_ci.u_device_category": devCategory,
                    ticketCategory: ticketCategory,
                    inc_sla: inc_sla
                };
                if (company_id != "") {
                    query_obj.company_sys = company_id;
                }
                let reportList;
                type === "change" ? (type = "change_request") : type;
                type === "request" ? (type = "sc_request") : type;
                inc_sla === true ? (reportList = "|slaReportList") : (reportList = "|ticketsReportList");
                ServiceNow.getTable("", type + reportList, callback, page_limit, offset, query_obj);
            },
            getTickets: (
                callback,
                table_names,
                date_range,
                company_id,
                begin_date,
                end_date,
                state,
                devCategory,
                ticketCategory
            ) => {
                let query_obj = {
                    tableNames: table_names,
                    date_range: date_range,
                    begin_date: begin_date,
                    end_date: end_date,
                    state: state,
                    "cmdb_ci.u_device_category": devCategory,
                    ticketCategory: ticketCategory
                };
                if (company_id != "") {
                    query_obj.company_sys = company_id;
                }
                ServiceNow.getMultipleTables(callback, query_obj);
            },
            getReport: (
                tableName,
                page_limit,
                offset,
                sorting,
                date_range,
                setRange,
                state,
                company_id,
                begin_date,
                end_date,
                getReport,
                fields,
                downloadType,
                multipleTables,
                devCategory,
                ticketCategory
            ) => {
                tableName === "change|ticketsReportList" ? (tableName = "change_request|ticketsReportList") : tableName;
                return ServiceNow.getReport(
                    tableName,
                    page_limit,
                    offset,
                    sorting,
                    date_range,
                    setRange,
                    state,
                    company_id,
                    begin_date,
                    end_date,
                    getReport,
                    fields,
                    downloadType,
                    multipleTables,
                    devCategory,
                    ticketCategory
                );
            },
            getEventReport: (fields, downloadType) => {
                return ScienceLogic.getDeviceReport(fields, downloadType);
            },
            getUtilReport: (route, id, direction, category, fields, downloadType) => {
                let url =
                    apiBasePath +
                    route +
                    "?" +
                    "downloadType=" +
                    downloadType +
                    "&fields=" +
                    fields +
                    "&id=" +
                    id +
                    "&direction=" +
                    direction +
                    "&category=" +
                    category +
                    "&utilReport=true";
                return url;
            },
            getItem: (id, route, callback, query_obj) => {
                ScienceLogic.getItem(id, route, callback, query_obj);
            },
            getEM7Devices: (callback, order, filter, limit, offset, sku, skuExists) => {
                ScienceLogic.getTable("device", callback, order, filter, limit, offset, sku, skuExists);
            },
            getDevice: (callback, page_limit, offset, sorting, date_range, setRange, company_id) => {
                let query_obj = {
                    sorting: sorting,
                    date_range: date_range,
                    setRange: setRange
                };
                if (company_id != "") {
                    query_obj.company_sys = company_id;
                }
                ServiceNow.getTable("", "device", callback, page_limit, offset, query_obj);
            },
            getSKUs: (callback, order, filter, limit, offset, sku, skuExists) => {
                ScienceLogic.getTable("device", callback, order, filter, limit, offset, sku, skuExists);
            },
            getVitals: (
                devId,
                callback,
                interfaces,
                interfaceReport,
                interfaceId,
                noNull,
                vitals,
                vitalURL,
                getIndexes
            ) => {
                let query_obj = {
                    interface: interfaces,
                    interfaceReport: interfaceReport,
                    interfaceId: interfaceId,
                    noNull: noNull,
                    vitals: vitals,
                    vitalURL: vitalURL,
                    getIndexes: getIndexes
                };
                ScienceLogic.getItem(devId, "device", callback, query_obj);
            },
            getInterface: (devId, callback, getData, device, interfaceID, dataIn, dataOut) => {
                let query_obj = {
                    interfaceData: getData,
                    device: device,
                    interfaceID: interfaceID,
                    dataIn: dataIn,
                    dataOut: dataOut
                };
                ScienceLogic.getItem(devId, "getInterface", callback, query_obj);
            },
            getMonitoredDevice: (callback, page_limit, offset, monitor, report, company_id) => {
                ServiceNow.getDevice(callback, page_limit, offset, monitor, report, company_id);
            },
            getIncidentSla: (callback, page_limit, offset, date_range, company_id, begin_date, end_date) => {
                let query_obj = {
                    date_range: date_range,
                    begin_date: begin_date,
                    end_date: end_date,
                    sla: true
                };
                if (company_id != "") {
                    query_obj.company_sys = company_id;
                }
                ServiceNow.getTable("", "task_sla|incidentSlasReportList", callback, page_limit, offset, query_obj);
            },
            getSummaryReport: (query_obj, route, callback) => {
                Server.getData(query_obj, route, callback);
            }
        };
    }
})();

(function () {
    angular.module("burWood").controller("ReportController", ReportController).filter("RemoveEmail", RemoveEmail);

    function RemoveEmail() {
        return (user) => {
            if (user) {
                let emailRemoved = user.replace(/\s*\(.*?\)\s*/g, "");
                return emailRemoved;
            }
        };
    }

    /** @ngInject */
    function ReportController(
        _,
        util,
        user_info,
        $document,
        Report,
        Service,
        BCSServer,
        Devices,
        Events,
        Trend,
        DTOptionsBuilder,
        DTColumnBuilder,
        DTColumnDefBuilder,
        ScienceLogicGQL,
        $q,
        $scope,
        $timeout,
        $window,
        moment,
        $http,
        $state,
        $compile,
        $uibModal,
        apiBasePath,
        FileSaver,
        Blob,
        $log
    ) {
        let vm = this;
        let page = 2000;
        let offset = 0;
        let companyDomain = user_info.sys_domain;
        if (companyDomain === "global") {
            companyDomain = "c90a2b444a3623120064ed56263be407";
        }
        vm.date = {
            startDate: null,
            endDate: null
        };
        vm.apiBasePath = apiBasePath;
        vm.company_sys = user_info.company;
        vm.dateValue = 1;
        vm.trendline = false;
        vm.weekday = false;
        vm.forecast = false;
        vm.state = "closed";
        vm.timeRange = "This Month";
        vm.dtInstance = {};
        vm.dtInstanceMetric = {};
        vm.dtInstanceUtil = {};
        vm.dtInstanceCall = {};
        vm.selected_sys_id = false;
        vm.loading = false;
        vm.showFilters = false;
        vm.hourlyFilter = false;
        vm.ticketDeviceCategory = [];
        //default tab to open on navigation
        vm.tabView = "ticket";

        /* eslint-disable */
        $.fn.dataTable.ext.errMode = "none";
        /* eslint-enable */

        //check if user is TAM for downloading QBR Report
        if (user_info.group.indexOf("BCS - CSM") != -1 || user_info.group.indexOf("BCS DevOps - Portal") != -1) {
            vm.userTAM = true;
        } else {
            vm.userTAM = false;
        }

        //sets up alerts
        vm.alerts = [];
        vm.close_notice = (index) => {
            vm.alerts.splice(index, 1);
        };

        //default chart configs
        let width = angular.element(".well .panel-body").width();
        let height = 650;

        vm.style = {
            width: "0%"
        };

        vm.severityWord = {
            0: "Healthy",
            1: "Notice",
            2: "Minor",
            3: "Major",
            4: "Critical"
        };

        vm.severity = {
            0: "5",
            1: "4",
            2: "3",
            3: "2",
            4: "1"
        };

        vm.devCategories = [""];
        vm.devCategory = vm.devCategories[0];
        vm.metricTypes = ["Date", "Device"];
        vm.metricType = vm.metricTypes[0];

        vm.callTypes = ["All", "Video", "Audio"];
        vm.callType = vm.callTypes[0];

        let columnFilter = {
            aoColumns: [
                null,
                null,
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                }
            ]
        };

        //sets up export button options for all datatables
        let buttonOptions = [
            {
                extend: "colvis",
                text: "Toggle Columns"
            },
            {
                extend: "collection",
                text: "Export",
                buttons: [
                    {
                        extend: "excel",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        }
                    },
                    {
                        extend: "pdf",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        customize: (doc) => {
                            doc.pageMargins = [5, 5, 5, 5];
                            doc.styles.tableHeader.fontSize = 10;
                            doc.defaultStyle.fontSize = 6;
                        }
                    },
                    {
                        extend: "csv",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        }
                    }
                ]
            }
        ];

        vm.category = [
            "None",
            "Application",
            "Citrix",
            "Environmental",
            "Network",
            "Security",
            "Server",
            "Storage",
            "Telepresence",
            "Unified Communications",
            "Unified Computing System"
        ];

        let months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];

        vm.chosenQBRMonth = months[moment().month()];
        vm.chosenMonth = months[moment().month()];

        vm.months = months;

        vm.years = util.getYearList();

        vm.chosenYear = vm.years[vm.years.length - 1];
        vm.chosenQBRYear = vm.years[vm.years.length - 1];

        let lastMonthNum = new Date().getMonth();
        let lastYearNum = new Date().getFullYear();

        vm.updateMonths = (chosenYear, chosenMonth) => {
            if (vm[chosenYear] == lastYearNum) {
                vm.months = months.slice(0, lastMonthNum);
                vm[chosenMonth] = vm.months[vm.months.length - 1];
            } else {
                vm.months = months;
            }
        };

        vm.updateMonths();

        vm.filter = false;
        vm.emailFrequency = ["Daily", "Weekly", "Monthly"];
        vm.chosenEmailFrenquency = vm.emailFrequency[2];
        vm.reportStates = ["Open", "Closed"];
        vm.ticketTypes = ["Incident", "Change", "Problem", "Request"];
        vm.ticketCategories = ["Device", "Priority", "Location"];

        vm.chosenState = vm.reportStates[1];
        vm.chosenTicketType = vm.ticketTypes[0];
        vm.chosenTicketCategory = vm.ticketCategories[0];
        vm.showMainTable = true;

        vm.standard_reports = [
            {
                id: "resolveTime",
                name: "Time to Resolution"
            },
            {
                id: "mttr",
                name: "Mean Time to Resolution by Priority"
            },
            {
                id: "total",
                name: "Total Tickets Opened"
            },
            {
                id: "category",
                name: "Tickets Opened By Category"
            },
            {
                id: "contact",
                name: "Tickets Opened By Contact Type"
            },
            {
                id: "event",
                name: "Top Event Generators (Current)"
            },
            {
                id: "response",
                name: "Average Response Time (Incident)"
            },
            {
                id: "sla",
                name: "Percentage of Successful SLA"
            }
        ];

        // if (user_info.sys_id === '76be9cf54fb93600d227d48e5210c780' ||
        //     user_info.sys_id === '79a330ca4fd77a00d227d48e5210c7d7' ||
        //     user_info.sys_id === 'e8f12fa54fd4524061fcc3fd0210c757' ||
        //     user_info.sys_id === 'e8a582314f1c524061fcc3fd0210c748' ||
        //     user_info.sys_id === 'bc76ff734f965b0019d290918110c766' ||
        //     user_info.company === '2d0cf30d4f50524061fcc3fd0210c7f8' ||  //Advocate
        //     user_info.company === '9df3d05713666340e11f57963244b0b8' // Cone Health
        //     // || user_info.company === '6d76554813d80300bc3b50622244b0d2'
        // ) {
        //     vm.standard_reports.push({
        //         id: 'call',
        //         name: 'Call/Video Metrics'
        //     })
        //     vm.standard_reports.push({
        //         id: 'callDevice',
        //         name: 'Call/Video Metrics by Device'
        //     })
        // }
        vm.selected_standard = vm.standard_reports[0].id;

        vm.downloadSummary = () => {
            let slID = user_info.sl_org.split("/")[3];
            let beginMonth = months.indexOf(vm.chosenMonth) + 1;
            let beginYear = Number(vm.chosenYear);
            let route = apiBasePath + "/monthlyreport/";
            let filename = vm.company_name + "_" + vm.chosenMonth + vm.chosenYear + "_report_summary.pdf";
            let modalInst = $uibModal.open({
                resolve: {
                    message: () => {
                        return {
                            heading: "Processing Report",
                            message: "Your report is processing.",
                            loading: true
                        };
                    }
                },
                templateUrl: "app/shared/html/downloading.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ConfirmationController",
                controllerAs: "vm"
            });
            $scope.$emit("download-start");
            $http({
                method: "POST",
                cache: false,
                url: route,
                responseType: "arraybuffer",
                data: {
                    name: vm.company_name,
                    sys_id: user_info.company,
                    sl_id: slID,
                    beginMonth: beginMonth,
                    beginYear: beginYear
                }
            }).then(
                (response) => {
                    modalInst.close();
                    vm.qbrLoading = false;
                    FileSaver.saveAs(
                        new Blob([response.data], {
                            type: "application/pdf"
                        }),
                        filename
                    );
                },
                () => {
                    modalInst.close();
                    vm.qbrLoading = false;
                    $uibModal.open({
                        resolve: {
                            message: () => {
                                return {
                                    heading: "Report Error",
                                    message:
                                        "Failed To Download Report. Please Contact Support for Further Assistance.",
                                    loading: false
                                };
                            }
                        },
                        templateUrl: "app/shared/html/downloading.html",
                        ariaLabelledBy: "modal-title",
                        ariaDescribedBy: "modal-body",
                        controller: "ConfirmationController",
                        controllerAs: "vm"
                    });
                }
            );
        };

        vm.downloadQBRPPTX = () => {
            if (vm.company_name == "R.J._O’Brien") {
                vm.company_name = "R_J_Obrien";
            }
            let slID = user_info.sl_org.split("/")[3];
            let route = apiBasePath + "/pptreport";
            let filename = vm.company_name + "_QBR.pptx";
            vm.qbrLoading = true;
            let beginMonth = months.indexOf(vm.chosenQBRMonth) + 1;
            let beginYear = Number(vm.chosenQBRYear);

            let modalInst = $uibModal.open({
                resolve: {
                    message: () => {
                        return {
                            heading: "Processing Report",
                            message: "Your report is processing.",
                            loading: true
                        };
                    }
                },
                templateUrl: "app/shared/html/downloading.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ConfirmationController",
                controllerAs: "vm"
            });
            $scope.$emit("download-start");
            $http({
                method: "POST",
                cache: false,
                url: route,
                data: {
                    name: vm.company_name,
                    qbr: true,
                    sys_id: user_info.company,
                    sl_id: slID,
                    download: true,
                    beginMonth: beginMonth,
                    beginYear: beginYear
                },
                responseType: "arraybuffer"
            }).then(
                (response) => {
                    modalInst.close();
                    vm.qbrLoading = false;
                    FileSaver.saveAs(
                        new Blob([response.data], {
                            type: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
                        }),
                        filename
                    );
                },
                () => {
                    modalInst.close();
                    vm.qbrLoading = false;
                    $uibModal.open({
                        resolve: {
                            message: () => {
                                return {
                                    heading: "Report Error",
                                    message: "Failed To Download QBR. Please Contact Support for Further Assistance.",
                                    loading: false
                                };
                            }
                        },
                        templateUrl: "app/shared/html/downloading.html",
                        ariaLabelledBy: "modal-title",
                        ariaDescribedBy: "modal-body",
                        controller: "ConfirmationController",
                        controllerAs: "vm"
                    });
                }
            );
        };

        //toggle minimizing of sections
        vm.minimizeSection = (section) => {
            vm.toggleConfig[section] = !vm.toggleConfig[section];
            let toggleReport = sessionStorage.getItem("toggleReport");
            if (toggleReport) {
                toggleReport = angular.fromJson(toggleReport);
                toggleReport.toggleConfig = vm.toggleConfig;
            } else {
                toggleReport = {
                    toggleConfig: vm.toggleConfig
                };
            }
            sessionStorage.setItem("toggleReport", angular.toJson(toggleReport));
        };

        vm.getSelectedReportName = () => {
            let index = _.findIndex(vm.standard_reports, (item) => {
                return item.id == vm.selected_standard;
            });
            vm.selected_standard_name = vm.standard_reports[index].name;
        };
        vm.getSelectedReportName();

        let defaultConfig = {
            chart: {
                zoomType: "x",
                type: "column",
                width: width,
                height: 650
            },
            exporting: {
                enabled: true
            },
            title: {
                text: "Reports"
            },
            subtitle: {
                text: "Click and drag to zoom in. Click legend items to toggle."
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: "pointer",
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            yAxis: {
                min: 0
            }
        };

        // intial config for all highcharts
        vm.config = Object.assign({}, defaultConfig);

        vm.unselectedSchedule = [];

        let scheduleItemArray = [
            "Incidents Closed By Device",
            "Incidents Closed By Priority",
            "Requests Closed By Priority",
            "Changes Closed By Device",
            "Problems Closed By Device",
            "Problems Closed By Priority",
            "Time to Resolution",
            "Total Tickets Opened",
            "Tickets Opened By Contact Type",
            "Tickets Opened By Category",
            "Top Event Generators (Current)",
            "All Utilization Inbound",
            "All Utilization Outbound",
            "All CPU Utilization",
            "All Memory Utilization",
            "All Availabilty"
        ];

        function ScheduleItem(id, route, name) {
            this.id = id;
            this.route = route;
            this.name = name;
        }

        // fetches and sort the available classes of device for each company - Device Tab of navigation.
        // addavailable class reports to available schedule items
        vm.getCategories = () => {
            var n;
            if (user_info.sl_org) {
                n = user_info.sl_org.lastIndexOf("/");
                vm.em7Org = user_info.sl_org.substring(n + 1);
            }
            if (user_info.company_name) {
                vm.company_name = user_info.company_name.replace(/ /g, "_");
            }

            scheduleItemArray.forEach((item, index) => {
                var newItem;
                switch (item) {
                    case "All Utilization Inbound":
                        newItem = new ScheduleItem(index, vm.em7Org + "inAll", item);
                        break;
                    case "All Utilization Outbound":
                        newItem = new ScheduleItem(index, vm.em7Org + "outAll", item);
                        break;
                    case "All CPU Utilization":
                        newItem = new ScheduleItem(index, vm.em7Org + "AllCPU", item);
                        break;
                    case "All Memory Utilization":
                        newItem = new ScheduleItem(index, vm.em7Org + "AllMemory", item);
                        break;
                    case "All Availability":
                        newItem = new ScheduleItem(index, vm.em7Org + "AllAvailability", item);
                        break;
                    default:
                        newItem = new ScheduleItem(index, item, item);
                        break;
                }
                vm.unselectedSchedule.push(newItem);
            });
        };

        // stores the schedule preference data in mongoDB instance - also retrieves
        vm.setSchedule = (method) => {
            BCSServer.postData(
                {
                    method: method,
                    user: user_info.email,
                    name: user_info.user_name,
                    orgId: vm.em7Org,
                    company: user_info.company_name,
                    company_sys: user_info.company,
                    frequency: vm.chosenEmailFrenquency,
                    reports: vm.selectedSchedule
                },
                "/emailschedule",
                (response) => {
                    if (method === "get") {
                        if (response && response[0]) {
                            vm.chosenEmailFrenquency = response[0].frequency;
                            vm.selectedSchedule = response[0].reports;
                            for (let x = 0; x < vm.selectedSchedule.length; x++) {
                                for (let y = 0; y < vm.unselectedSchedule.length; y++) {
                                    if (vm.unselectedSchedule[y].route === vm.selectedSchedule[x].route) {
                                        vm.unselectedSchedule.splice(y, 1);
                                    }
                                }
                            }
                        }
                        vm.dualListOptions = {
                            filterPlaceHolder: "Start typing to filter the lists below.",
                            labelAll: "Unselected Reports",
                            labelSelected: "Selected Reports",
                            helpMessage: "Select Reports for Download or Schedule",
                            orderProperty: "name",
                            items: vm.unselectedSchedule,
                            selectedItems: vm.selectedSchedule
                        };
                        vm.reassignAllClass();
                    } else {
                        $uibModal.open({
                            resolve: {
                                message: () => {
                                    return {
                                        heading: "Set Schedule",
                                        message: "Schedule has been updated.",
                                        loading: false
                                    };
                                }
                            },
                            templateUrl: "app/shared/html/confirmation.html",
                            ariaLabelledBy: "modal-title",
                            ariaDescribedBy: "modal-body",
                            controller: "ConfirmationController",
                            controllerAs: "vm"
                        });
                    }
                }
            );
        };
        vm.setSchedule("get");

        vm.getCategories();

        vm.selectedSchedule = [];
        vm.toggleClassVars = {};
        vm.toggle = false;

        vm.reassignClass = (selectedItem) => {
            if (!vm.toggleClassVars[selectedItem]) {
                vm.toggleClassVars[selectedItem] = true;
            } else {
                vm.toggleClassVars[selectedItem] = false;
            }
        };

        vm.reassignAllClass = () => {
            vm.toggleClassVars = {};
            for (let x = 0; x < vm.selectedSchedule.length; x++) {
                vm.reassignClass(vm.selectedSchedule[x].name);
            }
        };

        $scope.$watch("vm.toggle", () => {
            vm.reassignAllClass();
        });

        vm.toggleScheduleItem = (scheduleItem) => {
            vm.toggle = !vm.toggle;
            let shift = false;
            for (let x = 0; x < vm.unselectedSchedule.length; x++) {
                if (vm.unselectedSchedule[x].name === scheduleItem) {
                    vm.selectedSchedule.push(vm.unselectedSchedule[x]);
                    vm.unselectedSchedule.splice(x, 1);
                    shift = true;
                }
            }
            if (!shift) {
                for (let y = 0; y < vm.selectedSchedule.length; y++) {
                    if (vm.selectedSchedule[y].name === scheduleItem) {
                        vm.unselectedSchedule.push(vm.selectedSchedule[y]);
                        vm.selectedSchedule.splice(y, 1);
                    }
                }
            }
        };

        vm.formatDeviceSchedule = (type, category, direction, toggle) => {
            if (category === "Utilization") {
                let dir = direction.charAt(0).toUpperCase() + direction.slice(1);
                let tempName = type + " " + category + " " + dir + "bound";
                if (toggle) {
                    vm.toggleScheduleItem(tempName);
                } else {
                    return vm.toggleClassVars[tempName];
                }
            } else {
                let vitalName = type + " " + category + " Utilization";
                if (toggle) {
                    vm.toggleScheduleItem(vitalName);
                } else {
                    return vm.toggleClassVars[vitalName];
                }
            }
        };

        //chekcs if change is selected because we dont want to display priority option for change
        vm.checkChange = () => {
            if (vm.chosenTicketType === "Change") {
                vm.ticketCategories = ["Category"];
                vm.chosenTicketCategory = vm.ticketCategories[0];
            } else if (vm.chosenTicketType === "Request") {
                vm.ticketCategories = ["Priority"];
                vm.chosenTicketCategory = vm.ticketCategories[0];
            } else {
                vm.ticketCategories = ["Device", "Priority", "Location"];
                if (vm.chosenTicketCategory == "Category") {
                    vm.chosenTicketCategory = vm.ticketCategories[0];
                }
            }
        };

        // set all report preferences in cookie in preparation for mandatory page reload
        vm.refreshReport = (reportType, customType, uri, vitalName, appName) => {
            switch (customType) {
                case "event":
                    reportType = "eventGeneratorReport";
                    customType = false;
                    break;
                case "sla":
                    reportType = "slaReport";
                    customType = false;
                    break;
                case "mttr":
                    reportType = "mttrReport";
                    customType = false;
                    break;
                case "call":
                    reportType = "callReport";
                    customType = false;
                    break;
                case "callDevice":
                    reportType = "callReport";
                    customType = true;
                    break;
                case "response":
                    reportType = "responseTimeReport";
                    customType = false;
                    break;
            }
            let sessionObj = {
                selected_standard: vm.selected_standard,
                reportType: reportType,
                customType: customType,
                ticketType: vm.chosenTicketType,
                ticketCat: vm.chosenTicketCategory,
                dateType: vm.dateValue,
                range: vm.timeRange,
                chosenDate: vm.date,
                devType: vm.chosenDeviceType,
                // devCat: vm.chosenDeviceCategory,
                devDir: vm.chosenDeviceDirection,
                devCategory: vm.devCategory,
                ciClass: vm.ticketDeviceCategory,
                tabView: vm.tabView,
                deviceCIClass: vm.deviceCIClass,
                metricType: vm.metricType,
                hourlyFilter: vm.hourlyFilter,
                weekdayFilter: vm.weekdayFilter,
                trendline: vm.trendline,
                forecast: vm.forecast,
                dateValue: vm.dateValue,
                toggleConfig: vm.toggleConfig
            };
            if (uri) {
                sessionObj.metricReport = [uri, vitalName, appName];
            }
            sessionStorage.removeItem("reportData");
            sessionStorage.setItem("reportData", angular.toJson(sessionObj));
            if (reportType != "metricReport") {
                $window.location.reload();
            }
        };

        // main function for fetching, setting up graph and table data for all standard reports
        vm.standardReport = () => {
            vm.filter =
                vm.contactType =
                vm.eventTable =
                vm.deviceTable =
                vm.deviceMetricTable =
                vm.dateSelected =
                vm.callTable =
                    false;
            vm.loading = true;
            vm.loadingTable = true;
            vm.showMainTable = true;
            let type = vm.chosenTicketType.toLowerCase();
            vm.dtColumns = [
                DTColumnBuilder.newColumn("priority")
                    .withTitle("Priority")
                    .renderWith((data, type, row) => {
                        if (row.number.substring(0, 3) != "CUS" && row.number.substring(0, 3) != "CHG") {
                            data == null ? (data = "") : data;
                            let pri = data.substring(4);
                            data = data.substring(0, 1);
                            let icon =
                                '<span style="position:absolute;margin-left:26px;margin-top:1.5px;">' +
                                data +
                                '</span><img src="assets/img/icon/network_' +
                                data +
                                '.png" width="20" style="height:auto;margin-left:20px"/>';
                            icon +=
                                '<div style="position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px" tooltips tooltip-template="' +
                                pri +
                                '" tooltip-side="right" tooltip-class="priority-tooltip"></div>';
                            return icon;
                        } else {
                            return "";
                        }
                    }),
                DTColumnBuilder.newColumn("number")
                    .withTitle("Number")
                    .renderWith((data, type, row) => {
                        data == null ? (data = "") : data;
                        return (
                            "<a ng-click=\"vm.goToTicket('" +
                            row.number +
                            "', '" +
                            row.sys_id +
                            "');\">" +
                            row.number +
                            "</a>"
                        );
                    }),
                DTColumnBuilder.newColumn("short_description")
                    .withTitle("Short Description")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    })
            ];
            if (vm.chosenTicketCategory === "Location") {
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn("location.display_value")
                        .withTitle("Location")
                        .renderWith((data) => {
                            return data == null ? "" : data;
                        })
                );
            }
            if (vm.chosenTicketType != "Request") {
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn("cmdb_ci.display_value")
                        .withTitle("Device")
                        .renderWith((data) => {
                            data == null ? (data = "") : data;
                            return "<a ng-click=\"vm.goToDevice('" + data + "');\">" + data + "</a>";
                        })
                );
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn("u_category")
                        .withTitle("Ticket Category")
                        .renderWith((data) => {
                            return data == null ? "" : data;
                        })
                );
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn("sys_class_name")
                        .withTitle("CI Class")
                        .renderWith((data) => {
                            return data == null ? "" : data;
                        })
                );
            }
            if (vm.chosenTicketType == "Change") {
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn("requested_by")
                        .withTitle("Requested By")
                        .renderWith((data) => {
                            if (!data) {
                                return "";
                            } else {
                                if (data.display_value) {
                                    let emailRemoved = data.display_value.replace(/\s*\(.*?\)\s*/g, "");
                                    return emailRemoved;
                                } else {
                                    return "";
                                }
                            }
                        })
                );
            } else if (vm.chosenTicketType == "Request") {
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn("opened_by")
                        .withTitle("Opened By")
                        .renderWith((data) => {
                            if (!data) {
                                return "";
                            } else {
                                if (data.display_value) {
                                    let emailRemoved = data.display_value.replace(/\s*\(.*?\)\s*/g, "");
                                    return emailRemoved;
                                } else {
                                    return "";
                                }
                            }
                        })
                );
            } else {
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn("caller_id")
                        .withTitle("Contact")
                        .renderWith((data) => {
                            if (!data) {
                                return "";
                            } else {
                                if (data.display_value) {
                                    let emailRemoved = data.display_value.replace(/\s*\(.*?\)\s*/g, "");
                                    return emailRemoved;
                                } else {
                                    return "";
                                }
                            }
                        })
                );
            }
            vm.dtColumns.push(
                DTColumnBuilder.newColumn("opened_at")
                    .withTitle("Opened")
                    .withOption("type", "date")
                    .renderWith((data) => {
                        return data == null ? "" : moment(data).format("MMM D, YYYY h:mm:ss A");
                    })
            );
            if (
                vm.chosenTicketType == "Change" ||
                vm.chosenTicketType == "Problem" ||
                vm.chosenTicketType == "Request"
            ) {
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn("closed_at")
                        .withTitle("Closed")
                        .withOption("type", "date")
                        .renderWith((data) => {
                            return data == null ? "" : moment(data).format("MMM D, YYYY h:mm:ss A");
                        })
                );
            } else {
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn("resolved_at")
                        .withTitle("Resolved")
                        .withOption("type", "date")
                        .renderWith((data) => {
                            return data == null ? "" : moment(data).format("MMM D, YYYY h:mm:ss A");
                        })
                );
            }
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(() => {
                let defer = $q.defer();
                Report.getTable(
                    (data) => {
                        if (data && data.results) {
                            data = data.results;
                            vm.loading = false;
                            vm.loadingTable = false;
                            var statistics;
                            var category;
                            var values;
                            if (vm.chosenTicketCategory === "Priority") {
                                statistics = parse_incident_result(data);
                            } else if (vm.chosenTicketCategory === "Device") {
                                let sortedData = vm.sortDevices(data, "cmdb_ci");
                                statistics = parse_changes_by_device(sortedData);
                                category = statistics.category;
                                values = statistics.values;
                            } else if (vm.chosenTicketCategory === "Category") {
                                statistics = parse_change_result(data);
                            } else if (vm.chosenTicketCategory === "Location") {
                                var sortedData2 = vm.sortDevices(data, "location");
                                statistics = parse_location_result(sortedData2);
                                category = statistics.category;
                                values = statistics.values;
                            }
                            vm.table_title = vm.timeRange;
                            let title = vm.chosenTicketType + "s " + vm.chosenState;
                            vm.customTitle = title + " by Priority";
                            if (vm.chosenTicketCategory === "Priority") {
                                vm.config = {
                                    chart: {
                                        type: "column",
                                        width: width,
                                        height: height,
                                        zoomType: "x",
                                        panning: true,
                                        panKey: "shift"
                                    },
                                    legend: {
                                        enabled: false
                                    },
                                    title: {
                                        text: title + " by Priority"
                                    },
                                    subtitle: {
                                        text: "Click and drag to zoom in."
                                    },
                                    xAxis: {
                                        categories: ["Informational", "Minimal", "Moderate", "High", "Critical"],
                                        crosshair: true
                                    },
                                    yAxis: {
                                        min: 0,
                                        title: {
                                            text: "Number of " + vm.chosenTicketType + "s"
                                        }
                                    },
                                    plotOptions: {
                                        series: {
                                            cursor: "pointer",
                                            point: {
                                                events: {
                                                    click: function () {
                                                        vm.seriesSelected(this.category, "Priority");
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    tooltip: {
                                        formatter: function () {
                                            return (
                                                "<div><p>" +
                                                this.x +
                                                "</p><br><p>" +
                                                vm.customTitle +
                                                ": </p><p>" +
                                                this.y +
                                                "</p><br><p>Click for Details</p></div>"
                                            );
                                        }
                                    },
                                    series: [
                                        {
                                            name: vm.chosenTicketType + "s " + vm.chosenState,
                                            data: [
                                                {
                                                    name: "Informational",
                                                    color: "#64AD61",
                                                    y: statistics[0]
                                                },
                                                {
                                                    name: "Minimal",
                                                    color: "#467E8A",
                                                    y: statistics[1]
                                                },
                                                {
                                                    name: "Moderate",
                                                    color: "#DBAC39",
                                                    y: statistics[2]
                                                },
                                                {
                                                    name: "High",
                                                    color: "#D37C0F",
                                                    y: statistics[3]
                                                },
                                                {
                                                    name: "Critical",
                                                    color: "#A51820",
                                                    y: statistics[4]
                                                }
                                            ]
                                        }
                                    ]
                                };
                            } else if (vm.chosenTicketCategory === "Category") {
                                let catColors = [
                                    "#64AD61",
                                    "#467E8A",
                                    "#DBAC39",
                                    "#D37C0F",
                                    "#A51820",
                                    "#64AD61",
                                    "#467E8A",
                                    "#DBAC39",
                                    "#D37C0F",
                                    "#A51820"
                                ];
                                let seriesData = [];
                                for (let x = 0; x < vm.category.length; x++) {
                                    seriesData.push({
                                        name: vm.category[x],
                                        color: catColors[x],
                                        y: statistics[x]
                                    });
                                }
                                vm.customTitle = title + " by Category";
                                vm.config = {
                                    chart: {
                                        type: "column",
                                        width: width,
                                        height: height,
                                        zoomType: "x",
                                        panning: true,
                                        panKey: "shift"
                                    },
                                    legend: {
                                        enabled: false
                                    },
                                    title: {
                                        text: title + " by Category"
                                    },
                                    subtitle: {
                                        text: "Click and drag to zoom in."
                                    },
                                    xAxis: {
                                        categories: vm.category,
                                        crosshair: true
                                    },
                                    yAxis: {
                                        min: 0,
                                        title: {
                                            text: "Number of " + vm.chosenTicketType + "s"
                                        }
                                    },
                                    plotOptions: {
                                        series: {
                                            cursor: "pointer",
                                            point: {
                                                events: {
                                                    click: function () {
                                                        vm.seriesSelected(this.name, "change");
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    tooltip: {
                                        formatter: function () {
                                            return (
                                                "<div><p>" +
                                                this.x +
                                                "</p><br><p>" +
                                                vm.customTitle +
                                                ": </p><p>" +
                                                this.y +
                                                "</p><br><p>Click for Details</p></div>"
                                            );
                                        }
                                    },
                                    series: [
                                        {
                                            name: vm.chosenTicketType + "s " + vm.chosenState,
                                            data: seriesData
                                        }
                                    ]
                                };
                            } else if (vm.chosenTicketCategory === "Device") {
                                var title2 = vm.chosenTicketType + "s " + vm.chosenState;
                                vm.customTitle = title2 + " by Device";
                                vm.config = {
                                    colors: ["#47b756"],
                                    chart: {
                                        type: "column",
                                        width: width,
                                        height: height,
                                        zoomType: "x",
                                        panning: true,
                                        panKey: "shift"
                                    },
                                    legend: {
                                        enabled: false
                                    },
                                    title: {
                                        text: title2 + " by Device (Top 10)"
                                    },
                                    subtitle: {
                                        text: "Click and drag to zoom in."
                                    },
                                    yAxis: {
                                        min: 0,
                                        title: {
                                            text: "Number of " + vm.chosenTicketType + "s"
                                        }
                                    },
                                    xAxis: {
                                        categories: category,
                                        crosshair: true
                                    },
                                    plotOptions: {
                                        series: {
                                            cursor: "pointer",
                                            point: {
                                                events: {
                                                    click: function () {
                                                        vm.seriesSelected(this.category, "Device");
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    tooltip: {
                                        formatter: function () {
                                            return (
                                                "<div><p>" +
                                                this.x +
                                                "</p><br><p>" +
                                                vm.customTitle +
                                                ": </p><p>" +
                                                this.y +
                                                "</p><br><p>Click for Details</p></div>"
                                            );
                                        }
                                    },
                                    series: [
                                        {
                                            name: vm.chosenTicketType + "s " + vm.chosenState + " by Device",
                                            data: values
                                        }
                                    ]
                                };
                            } else if (vm.chosenTicketCategory === "Location") {
                                var title3 = vm.chosenTicketType + "s " + vm.chosenState;
                                vm.customTitle = title3 + " by Location";
                                vm.config = {
                                    chart: {
                                        type: "column",
                                        width: width,
                                        height: height,
                                        zoomType: "x",
                                        panning: true,
                                        panKey: "shift"
                                    },
                                    legend: {
                                        enabled: true
                                    },
                                    title: {
                                        text: title3 + " by Location (Top 10)"
                                    },
                                    subtitle: {
                                        text: "Click and drag to zoom in. Click legend items to toggle."
                                    },
                                    xAxis: {
                                        categories: category
                                    },
                                    yAxis: {
                                        min: 0,
                                        title: {
                                            text: "Number of Tickets"
                                        }
                                    },
                                    plotOptions: {
                                        column: {
                                            stacking: "normal"
                                        },
                                        series: {
                                            cursor: "pointer",
                                            point: {
                                                events: {
                                                    click: function () {
                                                        vm.seriesSelected(
                                                            this.series.name + "#" + this.category,
                                                            "Location"
                                                        );
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    tooltip: {
                                        formatter: function () {
                                            return (
                                                "<div><p>" +
                                                this.x +
                                                "</p><br><p>" +
                                                vm.customTitle +
                                                ": </p><p>" +
                                                this.total +
                                                "</p><br><p>Click for Details</p></div>"
                                            );
                                        }
                                    },
                                    series: values
                                };
                            }
                        } else {
                            vm.loading = false;
                            vm.loadingTable = false;
                            // config for no data
                            vm.config = {
                                chart: {
                                    type: "line",
                                    width: width,
                                    height: height,
                                    zoomType: "x",
                                    panning: true,
                                    panKey: "shift"
                                },
                                title: {
                                    text: "No Data"
                                },
                                subtitle: {
                                    text: ""
                                },
                                xAxis: {
                                    categories: [],
                                    crosshair: true
                                },
                                yAxis: {
                                    min: 0,
                                    title: {
                                        text: ""
                                    }
                                },
                                plotOptions: {
                                    series: {
                                        color: "#64AD61"
                                    }
                                },
                                series: [
                                    {
                                        name: "",
                                        type: "line",
                                        data: []
                                    }
                                ]
                            };
                        }
                        defer.resolve(data);
                    },
                    type,
                    5000,
                    0,
                    1,
                    vm.dateValue,
                    1,
                    vm.chosenState.toLowerCase(),
                    vm.selected_sys_id,
                    angular.toJson(vm.date.startDate).substring(1, 11),
                    angular.toJson(vm.date.endDate).substring(1, 11),
                    vm.devCategory,
                    vm.getSelectedCategories()
                );
                return defer.promise;
            })
                .withDOM("lfBrtip")
                .withColumnFilter(columnFilter)
                .withButtons([
                    {
                        extend: "colvis",
                        text: "Toggle Columns"
                    },
                    {
                        extend: "collection",
                        text: "Export",
                        buttons: [
                            {
                                extend: "excel",
                                title: () => {
                                    return (
                                        vm.chosenTicketType + "s " + vm.chosenState + " by " + vm.chosenTicketCategory
                                    );
                                },
                                filename: () => {
                                    return vm.chosenTicketType + "s" + vm.chosenState + "by" + vm.chosenTicketCategory;
                                }
                            },
                            {
                                extend: "pdf",
                                title: () => {
                                    return (
                                        vm.chosenTicketType + "s " + vm.chosenState + " by " + vm.chosenTicketCategory
                                    );
                                },
                                filename: () => {
                                    return vm.chosenTicketType + "s" + vm.chosenState + "by" + vm.chosenTicketCategory;
                                },
                                // orientation: 'landscape',
                                customize: (doc) => {
                                    doc.pageMargins = [5, 5, 5, 5];
                                    doc.styles.tableHeader.fontSize = 10;
                                    doc.defaultStyle.fontSize = 6;
                                }
                            },
                            {
                                extend: "csv",
                                title: () => {
                                    return (
                                        vm.chosenTicketType + "s " + vm.chosenState + " by " + vm.chosenTicketCategory
                                    );
                                },
                                filename: () => {
                                    return vm.chosenTicketType + "s" + vm.chosenState + "by" + vm.chosenTicketCategory;
                                }
                            }
                        ]
                    }
                ])
                .withOption("responsive", true)
                .withPaginationType("full_numbers")
                .withOption("retrieve", true)
                .withOption("createdRow", (row) => {
                    $compile(angular.element(row).contents())($scope);
                });
        };

        vm.getDuration = (time) => {
            let timeArray = time.split(" ");
            timeArray.reverse();
            let minutes = 0;
            if (timeArray[1]) {
                minutes += Number(timeArray[1]);
            }
            if (timeArray[3]) {
                minutes += Number(timeArray[3]) * 60;
            }
            if (timeArray[5]) {
                minutes += Number(timeArray[5]) * 60 * 24;
            }
            return minutes;
        };

        vm.changeCallReport = () => {
            let table = angular.element("#reportTable").DataTable();
            switch (vm.callType) {
                case "Audio":
                    vm.config.series[0].data = vm.audioDataSet;
                    table.column(6).search("Audio").draw();
                    break;
                case "Video":
                    vm.config.series[0].data = vm.videoDataSet;
                    table.column(6).search("Video").draw();
                    break;
                case "All":
                    vm.config.series[0].data = vm.dataSet;
                    table.search("").columns().search("").draw();
                    break;
                default:
                    break;
            }
        };

        vm.toggleAggregate = () => {
            vm.callAggregate = !vm.callAggregate;
            vm.config.series[0].data = vm.dataSet;
            if (!vm.callAggregate) {
                vm.changeCallReport();
            } else {
                vm.clearFilter();
            }
        };

        vm.callReport = (byDevice) => {
            vm.filter =
                vm.contactType =
                vm.eventTable =
                vm.deviceTable =
                vm.deviceMetricTable =
                vm.dateSelected =
                    false;
            vm.callTable = true;
            vm.loading = true;
            vm.loadingTable = true;
            vm.showMainTable = true;
            vm.callAggregate = true;

            vm.dtOptionsCall = DTOptionsBuilder.newOptions()
                .withDOM('lf<".table-scroll"rt>ip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withDOM("lfBrtip")
                .withColumnFilter(columnFilter)
                .withButtons(buttonOptions)
                .withOption("paging", true)
                .withOption("order", [["8", "des"]])
                .withOption("iDisplayLength", 10)
                .withOption("responsive", true)
                .withOption("retrieve", true);

            vm.dtColumns = [
                DTColumnBuilder.newColumn("device_name")
                    .withTitle("Device Name")
                    .renderWith((data) => {
                        if (data.indexOf("METRIC") !== -1) {
                            return data == null ? (data = "") : data;
                        } else {
                            data == null ? (data = "") : data;
                            return "<a ng-click=\"vm.goToDevice('" + data + "');\">" + data + "</a>";
                        }
                    }),
                DTColumnBuilder.newColumn("device_class")
                    .withTitle("Device Class")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("app_name")
                    .withTitle("Application Name")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("call_start_time")
                    .withTitle("Start Time")
                    .withOption("type", "date")
                    .renderWith((data) => {
                        return data == null ? "" : moment(data).format("ddd MMM DD YYYY hh:mm:mm A");
                    }),
                DTColumnBuilder.newColumn("call_duration")
                    .withTitle("Duration")
                    .renderWith((data) => {
                        return data == null ? "" : moment().startOf("day").seconds(data).format("HH:mm:ss");
                    }),
                DTColumnBuilder.newColumn("call_target")
                    .withTitle("Call Target")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("call_type")
                    .withTitle("Call Type")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("call_direction")
                    .withTitle("Direction")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("device_ip")
                    .withTitle("IP Address")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("call_bandwidth")
                    .withTitle("Call Bandwidth")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("call_encryption")
                    .withTitle("Encryption")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    })
            ];

            vm.dtOptions = DTOptionsBuilder.fromFnPromise(() => {
                let defer = $q.defer();
                var queryDates;
                if (vm.dateValue === 0) {
                    queryDates = vm.getLastMonth(true);
                } else if (vm.dateValue === 1) {
                    queryDates = vm.getThisMonth(true);
                } else {
                    queryDates = [new Date(vm.date.startDate), new Date(vm.date.endDate)];
                }
                BCSServer.postData(
                    {
                        company: user_info.company,
                        start_date: queryDates[0],
                        end_date: queryDates[1]
                    },
                    "/callReport",
                    (data) => {
                        vm.loading = false;
                        vm.loadingTable = false;
                        vm.audioDataSet = vm.videoDatatSet = [];
                        let dateArray = [];
                        vm.static_table = [];
                        if (byDevice) {
                            vm.callDataByDate = false;
                            vm.dataSet = [];
                            vm.audioDataSet = [];
                            vm.videoDataSet = [];
                            vm.dataSetAgg = [];
                            vm.customTitle = "Call/Video Metrics by Device";
                            let devData = vm.processCallData(data, "dataSet", "All");
                            vm.processCallData(data, "audioDataSet", "Audio");
                            vm.processCallData(data, "videoDataSet", "Video");
                            dateArray = devData[0];
                            let classNames = devData[1];
                            let appNames = devData[2];
                            let callNumber = devData[3];
                            let audioCalls = devData[4];
                            let videoCalls = devData[5];
                            let audioDur = devData[6];
                            let videoDur = devData[7];

                            vm.hoursTotal = vm.dataSet.reduce((total, num) => {
                                return total + num;
                            });
                            vm.hoursTotal = Number(vm.hoursTotal.toFixed(2));
                            vm.callsTotal = callNumber.reduce((total, num) => {
                                return total + num;
                            });

                            let totalMetric = {
                                device_name: null,
                                calls: null,
                                hours: null
                            };
                            //create array for aggregated table data
                            angular.forEach(data, (value) => {
                                if (value.device_name === "METRICS TOTAL") {
                                    totalMetric.device_name = value.device_name;
                                    totalMetric.calls = value.app_name.replace("TOTAL CALLS: ", "");
                                    totalMetric.hours = value.device_class.replace("TOTAL HOURS: ", "");
                                }
                                if (value.device_name === "AUDIO METRICS TOTAL") {
                                    totalMetric.audioCalls = value.app_name.replace("TOTAL CALLS: ", "");
                                    totalMetric.audioHours = value.device_class.replace("TOTAL HOURS: ", "");
                                }
                                if (value.device_name === "VIDEO METRICS TOTAL") {
                                    totalMetric.videoCalls = value.app_name.replace("TOTAL CALLS: ", "");
                                    totalMetric.videoHours = value.device_class.replace("TOTAL HOURS: ", "");
                                }
                            });

                            vm.static_table.push(totalMetric);

                            //create array for aggregated table data
                            angular.forEach(vm.dataSet, (value, key) => {
                                if (dateArray[key].indexOf("METRIC") == -1) {
                                    vm.static_table.push({
                                        device_name: dateArray[key],
                                        device_class: classNames[key],
                                        app_name: appNames[key],
                                        audioCalls: audioCalls[key],
                                        audioHours: audioDur[key],
                                        videoCalls: videoCalls[key],
                                        videoHours: videoDur[key],
                                        calls: callNumber[key],
                                        hours: value
                                    });
                                }
                            });
                        } else {
                            vm.callDataByDate = true;
                            dateArray = vm.processDateArray();
                            var callNumber2 = Array.apply(null, Array(dateArray.length)).map(
                                Number.prototype.valueOf,
                                0
                            );
                            vm.dataSet = Array.apply(null, Array(dateArray.length)).map(Number.prototype.valueOf, 0);
                            vm.audioDataSet = Array.apply(null, Array(dateArray.length)).map(
                                Number.prototype.valueOf,
                                0
                            );
                            vm.videoDataSet = Array.apply(null, Array(dateArray.length)).map(
                                Number.prototype.valueOf,
                                0
                            );
                            for (let x = 0; x < data.length; x++) {
                                let date = moment(data[x].call_start_time).format("YYYY-MM-DD");
                                let index = dateArray.indexOf(date);
                                if (index != -1 && data[x].call_duration) {
                                    callNumber2[index]++;
                                    let dur = data[x].call_duration;
                                    vm.dataSet[index] += dur;
                                    if (data[x].call_type === "Video") {
                                        vm.videoDataSet[index] += dur;
                                    } else if (data[x].call_type === "Audio") {
                                        vm.audioDataSet[index] += dur;
                                    }
                                }
                            }

                            angular.forEach(vm.dataSet, (value, key) => {
                                vm.dataSet[key] = Number((value / 60 / 60).toFixed(2));
                                vm.audioDataSet[key] = Number((vm.audioDataSet[key] / 60 / 60).toFixed(2));
                                vm.videoDataSet[key] = Number((vm.videoDataSet[key] / 60 / 60).toFixed(2));
                            });

                            vm.hoursTotal = vm.dataSet.reduce((total, num) => {
                                return total + num;
                            });
                            vm.hoursTotal = Number(vm.hoursTotal.toFixed(2));
                            vm.callsTotal = callNumber2.reduce((total, num) => {
                                return total + num;
                            });

                            //create array for aggregated table data
                            angular.forEach(data, (value) => {
                                if (value.device_name === "METRICS TOTAL") {
                                    vm.static_table.push({
                                        date: value.device_name,
                                        calls: value.app_name.replace("TOTAL CALLS: ", ""),
                                        hours: value.device_class.replace("TOTAL HOURS: ", "")
                                    });
                                }
                            });

                            //create array for aggregated table data
                            angular.forEach(vm.dataSet, (value, key) => {
                                vm.static_table.push({
                                    date: dateArray[key],
                                    calls: callNumber2[key],
                                    hours: value
                                });
                            });

                            vm.customTitle = "Call/Video Metrics";
                        }
                        vm.table_title = vm.timeRange;
                        vm.config = {
                            chart: {
                                type: "column",
                                width: width,
                                height: height,
                                zoomType: "x",
                                panning: true,
                                panKey: "shift"
                            },
                            legend: {
                                enabled: false
                            },
                            title: {
                                text: vm.customTitle
                            },
                            subtitle: {
                                text: "Click and drag to zoom in."
                            },
                            xAxis: {
                                categories: dateArray,
                                crosshair: true
                            },
                            yAxis: {
                                min: 0,
                                title: {
                                    text: "Hours"
                                }
                            },
                            plotOptions: {
                                series: {
                                    cursor: "pointer",
                                    point: {
                                        events: {
                                            click: function () {
                                                if (!byDevice) {
                                                    vm.seriesSelected(this.category, "Call");
                                                } else {
                                                    vm.seriesSelected(this.category, "CallDevice");
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            tooltip: {
                                formatter: function () {
                                    return (
                                        "<div><p>" +
                                        this.x +
                                        "</p><br><p>" +
                                        "Hours" +
                                        ": </p><p>" +
                                        this.y +
                                        "</p><br><p>Click for Details</p></div>"
                                    );
                                }
                            },
                            series: [
                                {
                                    name: vm.customTitle,
                                    color: "#567dff",
                                    data: vm.dataSet
                                }
                            ]
                        };
                        defer.resolve(data);
                    }
                );
                return defer.promise;
            })
                .withDOM('l<"#dt-title">fBrtip')
                .withButtons(buttonOptions)
                .withColumnFilter(columnFilter)
                .withPaginationType("full_numbers")
                .withOption("retrieve", true)
                .withOption("responsive", true)
                .withOption("order", [["8", "asc"]])
                .withOption("createdRow", (row, data) => {
                    if (data.device_name.indexOf("METRIC") !== -1) {
                        angular.element(row).addClass("total-bg");
                    }
                    $compile(angular.element(row).contents())($scope);
                });
        };

        vm.processCallData = (data, type) => {
            let dateArray = [];
            let devClass = [];
            let devApp = [];
            let callNum = [];

            for (var x = 0; x < data.length; x++) {
                if (data[x].device_name.indexOf("METRICS") == -1) {
                    let devIndex = dateArray.indexOf(data[x].device_name);
                    let dur = 0;
                    if (data[x].call_duration) {
                        dur = data[x].call_duration;
                    }
                    if (devIndex != -1) {
                        vm[type][devIndex] += dur;
                        callNum[devIndex]++;
                    } else {
                        dateArray.push(data[x].device_name);
                        devClass.push(data[x].device_class);
                        devApp.push(data[x].app_name);
                        vm[type].push(dur);
                        callNum.push(1);
                    }
                }
            }

            let audCall = Array.apply(null, Array(dateArray.length)).map(Number.prototype.valueOf, 0);
            let vidCall = Array.apply(null, Array(dateArray.length)).map(Number.prototype.valueOf, 0);
            let audDur = Array.apply(null, Array(dateArray.length)).map(Number.prototype.valueOf, 0);
            let vidDur = Array.apply(null, Array(dateArray.length)).map(Number.prototype.valueOf, 0);

            for (let y = 0; y < data.length; y++) {
                if (data[x].device_name.indexOf("METRICS") == -1) {
                    var devIndex2 = dateArray.indexOf(data[y].device_name);
                    if (data[y].call_type === "Audio") {
                        audCall[devIndex2]++;
                        if (data[y].call_duration) {
                            audDur[devIndex2] += data[y].call_duration;
                        }
                    } else if (data[y].call_type === "Video") {
                        vidCall[devIndex2]++;
                        if (data[y].call_duration) {
                            vidDur[devIndex2] += data[y].call_duration;
                        }
                    }
                }
            }

            for (let z = 0; z < vm[type].length; z++) {
                vm[type][z] = Number((vm[type][z] / 60 / 60).toFixed(2));
                vidDur[z] = Number((vidDur[z] / 60 / 60).toFixed(2));
                audDur[z] = Number((audDur[z] / 60 / 60).toFixed(2));
            }
            //sort device data and category data
            let list = [];
            for (let j = 0; j < vm[type].length; j++)
                list.push({
                    hours: vm[type][j],
                    device: dateArray[j],
                    class: devClass[j],
                    app: devApp[j],
                    calls: callNum[j],
                    audioCalls: audCall[j],
                    videoCalls: vidCall[j],
                    audioDur: audDur[j],
                    videoDur: vidDur[j]
                });
            list.sort((a, b) => {
                return a.hours > b.hours ? -1 : a.hours == b.hours ? 0 : 1;
            });
            for (let k = 0; k < list.length; k++) {
                vm[type][k] = list[k].hours;
                dateArray[k] = list[k].device;
                devClass[k] = list[k].class;
                devApp[k] = list[k].app;
                callNum[k] = list[k].calls;
                audCall[k] = list[k].audioCalls;
                vidCall[k] = list[k].videoCalls;
                audDur[k] = list[k].audioDur;
                vidDur[k] = list[k].videoDur;
            }
            return [dateArray, devClass, devApp, callNum, audCall, vidCall, audDur, vidDur];
        };

        vm.responseTimeReport = () => {
            vm.filter =
                vm.contactType =
                vm.eventTable =
                vm.deviceTable =
                vm.deviceMetricTable =
                vm.dateSelected =
                vm.callTable =
                    false;
            vm.loading = true;
            vm.loadingTable = true;
            vm.showMainTable = true;
            vm.dtColumns = [
                DTColumnBuilder.newColumn("inc_priority")
                    .withTitle("Priority")
                    .renderWith((data) => {
                        data == null ? (data = "") : data;
                        let pri = data.substring(4);
                        data = data.substring(0, 1);
                        let icon =
                            '<span style="position:absolute;margin-left:26px;margin-top:1.5px;">' +
                            data +
                            '</span><img src="assets/img/icon/network_' +
                            data +
                            '.png" width="20" style="height:auto;margin-left:20px"/>';
                        icon +=
                            '<div style="position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px" tooltips tooltip-template="' +
                            pri +
                            '" tooltip-side="right" tooltip-class="priority-tooltip"></div>';
                        return icon;
                    }),
                DTColumnBuilder.newColumn("inc_number")
                    .withTitle("Number")
                    .renderWith((data, type, row) => {
                        data == null ? (data = "") : data;
                        return (
                            "<a ng-click=\"vm.goToTicket('" +
                            row.inc_number +
                            "', '" +
                            row.inc_sys_id +
                            "');\">" +
                            row.inc_number +
                            "</a>"
                        );
                    }),
                DTColumnBuilder.newColumn("inc_cmdb_ci.display_value")
                    .withTitle("Device")
                    .renderWith((data) => {
                        data == null ? (data = "") : data;
                        return "<a ng-click=\"vm.goToDevice('" + data + "');\">" + data + "</a>";
                    }),
                DTColumnBuilder.newColumn("inc_short_description")
                    .withTitle("Short Description")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("inc_caller_id")
                    .withTitle("Contact")
                    .renderWith((data) => {
                        if (!data) {
                            return "";
                        } else {
                            if (data.display_value) {
                                let emailRemoved = data.display_value.replace(/\s*\(.*?\)\s*/g, "");
                                return emailRemoved;
                            } else {
                                return "";
                            }
                        }
                    }),
                DTColumnBuilder.newColumn("inc_u_category")
                    .withTitle("Ticket Category")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("inc_opened_at")
                    .withTitle("Opened")
                    .withOption("type", "date")
                    .renderWith((data) => {
                        return data == null ? "" : moment(data).format("MMM D, YYYY h:mm:ss A");
                    }),
                DTColumnBuilder.newColumn("mi_end")
                    .withTitle("First Response")
                    .withOption("type", "date")
                    .renderWith((data) => {
                        return data == null ? "" : moment(data).format("MMM D, YYYY h:mm:ss A");
                    }),
                DTColumnBuilder.newColumn("mi_duration")
                    .withTitle("Duration")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("rawTime")
                    .withTitle("Duration in Minutes")
                    .renderWith((data) => {
                        return data == null ? "" : data + " Minutes";
                    })
            ];

            vm.dtOptions = DTOptionsBuilder.fromFnPromise(() => {
                let defer = $q.defer();
                Service.getQuery(
                    {
                        company_sys: user_info.company,
                        date_range: vm.dateValue,
                        begin_date: angular.toJson(vm.date.startDate).substring(1, 11),
                        end_date: angular.toJson(vm.date.endDate).substring(1, 11),
                        inc_metric: true,
                        ticketCategory: vm.getSelectedCategories()
                    },
                    "u_incidentresponse|metricList",
                    (data) => {
                        data = data.results;
                        vm.static_table = data;
                        vm.loading = false;
                        vm.loadingTable = false;
                        let critical = 0,
                            high = 0,
                            moderate = 0,
                            minimal = 0,
                            informational = 0,
                            criticalCount = 0,
                            highCount = 0,
                            moderateCount = 0,
                            minimalCount = 0,
                            informationalCount = 0;

                        for (var key in data) {
                            let priority = data[key].inc_priority.substring(0, 1);
                            let duration = vm.getDuration(data[key].mi_duration);
                            switch (priority) {
                                case "1": // Critical
                                    critical += duration;
                                    criticalCount++;
                                    break;
                                case "2": // High
                                    high += duration;
                                    highCount++;
                                    break;
                                case "3": // Moderate
                                    moderate += duration;
                                    moderateCount++;
                                    break;
                                case "4": // Minimal
                                    minimal += duration;
                                    minimalCount++;
                                    break;
                                case "5": //Informational
                                    informational += duration;
                                    informationalCount++;
                                    break;
                            }
                        }

                        critical = Number(Number(critical / 60 / criticalCount).toFixed(2));
                        high = Number(Number(high / 60 / highCount).toFixed(2));
                        moderate = Number(Number(moderate / 60 / moderateCount).toFixed(2));
                        minimal = Number(Number(minimal / 60 / minimalCount).toFixed(2));
                        informational = Number(Number(informational / 60 / informationalCount).toFixed(2));

                        vm.table_title = vm.timeRange;
                        vm.customTitle = "Average Response Time (Incident)";
                        vm.config = {
                            chart: {
                                type: "column",
                                width: width,
                                height: height,
                                zoomType: "x",
                                panning: true,
                                panKey: "shift"
                            },
                            legend: {
                                enabled: false
                            },
                            title: {
                                text: vm.customTitle
                            },
                            subtitle: {
                                text: "Click and drag to zoom in."
                            },
                            xAxis: {
                                categories: ["Informational", "Minimal", "Moderate", "High", "Critical"],
                                crosshair: true
                            },
                            yAxis: {
                                min: 0,
                                title: {
                                    text: "Hours"
                                }
                            },
                            plotOptions: {
                                series: {
                                    cursor: "pointer",
                                    point: {
                                        events: {
                                            click: function () {
                                                vm.seriesSelected(this.category, "Priority");
                                            }
                                        }
                                    }
                                }
                            },
                            tooltip: {
                                formatter: function () {
                                    return (
                                        "<div><p>" +
                                        this.x +
                                        "</p><br><p>" +
                                        "Hours" +
                                        ": </p><p>" +
                                        this.y +
                                        "</p><br><p>Click for Details</p></div>"
                                    );
                                }
                            },
                            series: [
                                {
                                    data: [
                                        {
                                            name: "Informational",
                                            color: "#64AD61",
                                            y: informational
                                        },
                                        {
                                            name: "Minimal",
                                            color: "#467E8A",
                                            y: minimal
                                        },
                                        {
                                            name: "Moderate",
                                            color: "#DBAC39",
                                            y: moderate
                                        },
                                        {
                                            name: "High",
                                            color: "#D37C0F",
                                            y: high
                                        },
                                        {
                                            name: "Critical",
                                            color: "#A51820",
                                            y: critical
                                        }
                                    ]
                                }
                            ]
                        };
                        defer.resolve(data);
                    }
                );
                return defer.promise;
            })
                .withDOM('l<"#dt-title">fBrtip')
                .withButtons(buttonOptions)
                .withColumnFilter(columnFilter)
                .withPaginationType("full_numbers")
                .withOption("retrieve", true)
                .withOption("responsive", true)
                .withOption("order", [["5", "des"]])
                .withOption("createdRow", (row) => {
                    $compile(angular.element(row).contents())($scope);
                });
        };

        vm.mttrReport = () => {
            vm.filter =
                vm.contactType =
                vm.eventTable =
                vm.deviceTable =
                vm.deviceMetricTable =
                vm.dateSelected =
                vm.callTable =
                    false;
            vm.loading = true;
            vm.loadingTable = true;
            vm.showMainTable = true;
            vm.dtColumns = [
                DTColumnBuilder.newColumn("inc_priority")
                    .withTitle("Priority")
                    .renderWith((data) => {
                        data == null ? (data = "") : data;
                        let pri = data.substring(4);
                        data = data.substring(0, 1);
                        let icon =
                            '<span style="position:absolute;margin-left:26px;margin-top:1.5px;">' +
                            data +
                            '</span><img src="assets/img/icon/network_' +
                            data +
                            '.png" width="20" style="height:auto;margin-left:20px"/>';
                        icon +=
                            '<div style="position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px" tooltips tooltip-template="' +
                            pri +
                            '" tooltip-side="right" tooltip-class="priority-tooltip"></div>';
                        return icon;
                    }),
                DTColumnBuilder.newColumn("inc_number")
                    .withTitle("Number")
                    .renderWith((data, type, row) => {
                        data == null ? (data = "") : data;
                        return (
                            "<a ng-click=\"vm.goToTicket('" +
                            row.inc_number +
                            "', '" +
                            row.inc_sys_id +
                            "');\">" +
                            row.inc_number +
                            "</a>"
                        );
                    }),
                DTColumnBuilder.newColumn("inc_short_description")
                    .withTitle("Short Description")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("inc_cmdb_ci.display_value")
                    .withTitle("Device")
                    .renderWith((data) => {
                        data == null ? (data = "") : data;
                        return "<a ng-click=\"vm.goToDevice('" + data + "');\">" + data + "</a>";
                    }),
                DTColumnBuilder.newColumn("inc_caller_id")
                    .withTitle("Contact")
                    .renderWith((data) => {
                        if (!data) {
                            return "";
                        } else {
                            if (data.display_value) {
                                let emailRemoved = data.display_value.replace(/\s*\(.*?\)\s*/g, "");
                                return emailRemoved;
                            } else {
                                return "";
                            }
                        }
                    }),
                DTColumnBuilder.newColumn("inc_opened_at")
                    .withTitle("Opened")
                    .withOption("type", "date")
                    .renderWith((data) => {
                        return data == null ? "" : moment(data).format("MMM D, YYYY h:mm:ss A");
                    }),
                DTColumnBuilder.newColumn("inc_resolved_at")
                    .withTitle("Resolved")
                    .withOption("type", "date")
                    .renderWith((data) => {
                        return data == null ? "" : moment(data).format("MMM D, YYYY h:mm:ss A");
                    }),
                DTColumnBuilder.newColumn("taskslatable_business_duration")
                    .withTitle("Business Duration")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("rawSLA")
                    .withTitle("Minute Duration")
                    .notVisible()
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    })
            ];

            vm.dtOptions = DTOptionsBuilder.fromFnPromise(() => {
                let defer = $q.defer();
                Report.getTable(
                    (data) => {
                        data = data.results;
                        vm.loading = false;
                        vm.loadingTable = false;

                        let critical = 0,
                            high = 0,
                            moderate = 0,
                            minimal = 0,
                            informational = 0,
                            criticalCount = 0,
                            highCount = 0,
                            moderateCount = 0,
                            minimalCount = 0,
                            informationalCount = 0;

                        for (var key in data) {
                            let priority = data[key].inc_priority.substring(0, 1);
                            let duration = vm.getDuration(data[key].taskslatable_business_duration);
                            switch (priority) {
                                case "1": // Critical
                                    critical += duration;
                                    criticalCount++;
                                    break;
                                case "2": // High
                                    high += duration;
                                    highCount++;
                                    break;
                                case "3": // Moderate
                                    moderate += duration;
                                    moderateCount++;
                                    break;
                                case "4": // Minimal
                                    minimal += duration;
                                    minimalCount++;
                                    break;
                                case "5": //Informational
                                    informational += duration;
                                    informationalCount++;
                                    break;
                            }
                        }

                        critical = Number(Number(critical / 60 / criticalCount).toFixed(2));
                        high = Number(Number(high / 60 / highCount).toFixed(2));
                        moderate = Number(Number(moderate / 60 / moderateCount).toFixed(2));
                        minimal = Number(Number(minimal / 60 / minimalCount).toFixed(2));
                        informational = Number(Number(informational / 60 / informationalCount).toFixed(2));

                        vm.table_title = vm.timeRange;
                        vm.customTitle = "Mean Time to Resolution by Priority";
                        vm.config = {
                            chart: {
                                type: "column",
                                width: width,
                                height: height,
                                zoomType: "x",
                                panning: true,
                                panKey: "shift"
                            },
                            legend: {
                                enabled: false
                            },
                            title: {
                                text: vm.customTitle
                            },
                            subtitle: {
                                text: "Click and drag to zoom in."
                            },
                            xAxis: {
                                categories: ["Informational", "Minimal", "Moderate", "High", "Critical"],
                                crosshair: true
                            },
                            yAxis: {
                                min: 0,
                                title: {
                                    text: "Hours"
                                }
                            },
                            plotOptions: {
                                series: {
                                    cursor: "pointer",
                                    point: {
                                        events: {
                                            click: function () {
                                                vm.seriesSelected(this.category, "Priority");
                                            }
                                        }
                                    }
                                }
                            },
                            tooltip: {
                                formatter: function () {
                                    return (
                                        "<div><p>" +
                                        this.x +
                                        "</p><br><p>" +
                                        "Hours" +
                                        ": </p><p>" +
                                        this.y +
                                        "</p><br><p>Click for Details</p></div>"
                                    );
                                }
                            },
                            series: [
                                {
                                    data: [
                                        {
                                            name: "Informational",
                                            color: "#64AD61",
                                            y: informational
                                        },
                                        {
                                            name: "Minimal",
                                            color: "#467E8A",
                                            y: minimal
                                        },
                                        {
                                            name: "Moderate",
                                            color: "#DBAC39",
                                            y: moderate
                                        },
                                        {
                                            name: "High",
                                            color: "#D37C0F",
                                            y: high
                                        },
                                        {
                                            name: "Critical",
                                            color: "#A51820",
                                            y: critical
                                        }
                                    ]
                                }
                            ]
                        };
                        defer.resolve(data);
                    },
                    "incident_sla",
                    5000,
                    0,
                    1,
                    vm.dateValue,
                    1,
                    vm.chosenState.toLowerCase(),
                    vm.selected_sys_id,
                    angular.toJson(vm.date.startDate).substring(1, 11),
                    angular.toJson(vm.date.endDate).substring(1, 11),
                    null,
                    null,
                    true
                );
                return defer.promise;
            })
                .withDOM('l<"#dt-title">fBrtip')
                .withButtons(buttonOptions)
                .withColumnFilter(columnFilter)
                .withPaginationType("full_numbers")
                .withOption("retrieve", true)
                .withOption("responsive", true)
                .withOption("order", [["8", "des"]])
                .withOption("initComplete", () => {
                    // angular.element('#dt-title')
                    $document[0].querySelector("#dt-title").textContent = "Red = Breached";
                })
                .withOption("createdRow", (row, data) => {
                    if (data.taskslatable_has_breached === "true") {
                        angular.element(row).addClass("breached-background");
                    } else {
                        angular.element(row).addClass("even-background");
                    }
                    $compile(angular.element(row).contents())($scope);
                });
        };

        vm.contactType = false;
        vm.customTicketReport = (type) => {
            vm.filter = vm.eventTable = vm.deviceTable = vm.deviceMetricTable = vm.dateSelected = vm.callTable = false;
            vm.loading = true;
            vm.loadingTable = true;
            vm.showMainTable = true;
            let tableNames = [
                "incident|ticketsReportList",
                "problem|ticketsReportList",
                "change_request|ticketsReportList",
                "sc_request|ticketsReportList"
            ];
            let ticketObj = [
                {
                    name: "Informational",
                    color: "#64AD61",
                    data: [],
                    count: []
                },
                {
                    name: "Minimal",
                    color: "#467E8A",
                    data: [],
                    count: []
                },
                {
                    name: "Moderate",
                    color: "#DBAC39",
                    data: [],
                    count: []
                },
                {
                    name: "High",
                    color: "#D37C0F",
                    data: [],
                    count: []
                },
                {
                    name: "Critical",
                    color: "#A51820",
                    data: [],
                    count: []
                }
            ];

            if (type === "resolveTime") {
                vm.state = "resolved";
            } else {
                vm.state = "closed";
            }

            vm.dtColumns = [
                DTColumnBuilder.newColumn("priority")
                    .withTitle("Priority")
                    .renderWith((data, type, row) => {
                        if (row.number.substring(0, 3) != "CUS" && row.number.substring(0, 3) != "CHG") {
                            data == null ? (data = "") : data;
                            let pri = data.substring(4);
                            data = data.substring(0, 1);
                            let icon =
                                '<span style="position:absolute;margin-left:26px;margin-top:1.5px;">' +
                                data +
                                '</span><img src="assets/img/icon/network_' +
                                data +
                                '.png" width="20" style="height:auto;margin-left:20px"/>';
                            icon +=
                                '<div style="position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px" tooltips tooltip-template="' +
                                pri +
                                '" tooltip-side="right" tooltip-class="priority-tooltip"></div>';
                            return icon;
                        } else {
                            return "";
                        }
                    }),
                DTColumnBuilder.newColumn("number")
                    .withTitle("Number")
                    .renderWith((data, type, row) => {
                        data == null ? (data = "") : data;
                        return (
                            "<a ng-click=\"vm.goToTicket('" +
                            row.number +
                            "', '" +
                            row.sys_id +
                            "');\">" +
                            row.number +
                            "</a>"
                        );
                    }),
                DTColumnBuilder.newColumn("cmdb_ci.display_value")
                    .withTitle("Device")
                    .renderWith((data) => {
                        data == null ? (data = "") : data;
                        return "<a ng-click=\"vm.goToDevice('" + data + "');\">" + data + "</a>";
                    }),
                DTColumnBuilder.newColumn("short_description")
                    .withTitle("Short Description")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("caller_id")
                    .withTitle("Contact")
                    .renderWith((data) => {
                        if (!data) {
                            return "";
                        } else {
                            if (data.display_value) {
                                let emailRemoved = data.display_value.replace(/\s*\(.*?\)\s*/g, "");
                                return emailRemoved;
                            } else {
                                return "";
                            }
                        }
                    })
            ];
            vm.dtColumns.push(
                DTColumnBuilder.newColumn("u_category")
                    .withTitle("Ticket Category")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    })
            );

            vm.dtColumns.push(
                DTColumnBuilder.newColumn("sys_class_name")
                    .withTitle("CI Class")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    })
            );
            vm.dtColumns.push(
                DTColumnBuilder.newColumn("opened_at")
                    .withTitle("Opened")
                    .withOption("type", "date")
                    .renderWith((data) => {
                        return data == null ? "" : moment(data).format("MMM D, YYYY h:mm:ss A");
                    })
            );
            if (type === "resolveTime") {
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn("resolved_at")
                        .withTitle("Resolved")
                        .withOption("type", "date")
                        .renderWith((data) => {
                            return data == null ? "" : moment(data).format("MMM D, YYYY h:mm:ss A");
                        })
                );
            }
            if (type === "contact") {
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn("contact_type")
                        .withTitle("Contact Type")
                        .renderWith((data) => {
                            return data == null ? "" : data;
                        })
                );
            }
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(() => {
                let defer = $q.defer();
                Report.getTickets(
                    (data) => {
                        data = data.results;
                        data.forEach((item) => {
                            item.sys_class_name = item["cmdb_ci.sys_class_name"];
                        });
                        vm.loading = false;
                        vm.loadingTable = false;
                        vm.static_table = data;
                        let statistics = parse_service_result(data);
                        vm.table_title = vm.timeRange;
                        vm.customTitle = "Tickets Opened by Contact Type";
                        if (type === "contact") {
                            vm.contactType = true;
                            vm.config = {
                                chart: {
                                    type: "pie",
                                    width: width,
                                    height: height,
                                    zoomType: "x",
                                    panning: true,
                                    panKey: "shift"
                                },
                                legend: {
                                    enabled: true
                                },
                                title: {
                                    text: vm.customTitle
                                },
                                subtitle: {
                                    text: "Click legend items to toggle."
                                },
                                xAxis: {
                                    categories: ["Phone", "Email", "Monitoring"],
                                    crosshair: true
                                },
                                yAxis: {
                                    min: 0,
                                    title: {
                                        text: "Number of Tickets"
                                    }
                                },
                                plotOptions: {
                                    series: {
                                        cursor: "pointer",
                                        point: {
                                            events: {
                                                click: function () {
                                                    vm.seriesSelected(this.name, "contactType");
                                                }
                                            }
                                        }
                                    }
                                },
                                tooltip: {
                                    formatter: function () {
                                        return (
                                            "<div><p>" +
                                            vm.customTitle +
                                            ": " +
                                            this.y +
                                            "</p><br><p>Click for Details</p></div>"
                                        );
                                    }
                                },
                                series: [
                                    {
                                        name: "Services",
                                        data: [
                                            {
                                                name: "Phone",
                                                color: "#64AD61",
                                                y: statistics[0]
                                            },
                                            {
                                                name: "Email",
                                                color: "#467E8A",
                                                y: statistics[1]
                                            },
                                            {
                                                name: "Monitoring",
                                                color: "#DBAC39",
                                                y: statistics[2]
                                            }
                                        ]
                                    }
                                ]
                            };
                        } else if (type === "total") {
                            ticketObj = [
                                {
                                    name: "Informational",
                                    color: "#64AD61",
                                    dataGrouping: {
                                        enabled: false
                                    },
                                    data: []
                                },
                                {
                                    name: "Minimal",
                                    color: "#467E8A",
                                    dataGrouping: {
                                        enabled: false
                                    },
                                    data: []
                                },
                                {
                                    name: "Moderate",
                                    color: "#DBAC39",
                                    dataGrouping: {
                                        enabled: false
                                    },
                                    data: []
                                },
                                {
                                    name: "High",
                                    color: "#D37C0F",
                                    dataGrouping: {
                                        enabled: false
                                    },
                                    data: []
                                },
                                {
                                    name: "Critical",
                                    color: "#A51820",
                                    dataGrouping: {
                                        enabled: false
                                    },
                                    data: []
                                },
                                {
                                    name: "Change",
                                    color: "#ddd",
                                    dataGrouping: {
                                        enabled: false
                                    },
                                    data: []
                                }
                            ];
                            vm.contactType = false;
                            let dateArray = vm.processDateArray();
                            for (let y = 0; y < dateArray.length; y++) {
                                ticketObj[0].data[y] = 0;
                                ticketObj[1].data[y] = 0;
                                ticketObj[2].data[y] = 0;
                                ticketObj[3].data[y] = 0;
                                ticketObj[4].data[y] = 0;
                                ticketObj[5].data[y] = 0;
                            }
                            for (let x = 0; x < data.length; x++) {
                                let date = data[x].opened_at;
                                let dateIndex = dateArray.indexOf(moment(new Date(date)).format().substring(0, 10));
                                if (
                                    data[x].number.substring(0, 3) != "CUS" &&
                                    data[x].number.substring(0, 3) != "CHG"
                                ) {
                                    switch (data[x].priority) {
                                        case "5 - Informational":
                                            ticketObj[0].data[dateIndex]++;
                                            break;
                                        case "4 - Minimal":
                                            ticketObj[1].data[dateIndex]++;
                                            break;
                                        case "3 - Moderate":
                                            ticketObj[2].data[dateIndex]++;
                                            break;
                                        case "2 - High":
                                            ticketObj[3].data[dateIndex]++;
                                            break;
                                        case "1 - Critical":
                                            ticketObj[4].data[dateIndex]++;
                                            break;
                                    }
                                } else {
                                    ticketObj[5].data[dateIndex]++;
                                }
                            }
                            vm.customTitle = "Total Tickets Opened";
                            vm.config = {
                                chart: {
                                    type: "column",
                                    width: width,
                                    height: height,
                                    zoomType: "x",
                                    panning: true,
                                    panKey: "shift"
                                },
                                legend: {
                                    enabled: true
                                },
                                title: {
                                    text: vm.customTitle
                                },
                                subtitle: {
                                    text: "Click and drag to zoom in. Click legend items to toggle."
                                },
                                xAxis: {
                                    categories: dateArray
                                },
                                yAxis: {
                                    min: 0,
                                    title: {
                                        text: "Number of Tickets"
                                    }
                                },
                                plotOptions: {
                                    column: {
                                        stacking: "normal"
                                    },
                                    series: {
                                        cursor: "pointer",
                                        point: {
                                            events: {
                                                click: function () {
                                                    vm.seriesSelected(
                                                        this.series.userOptions.name +
                                                            " " +
                                                            moment(this.category).format("MMM D, YYYY h:mm:ss A"),
                                                        "totalTickets"
                                                    );
                                                }
                                            }
                                        }
                                    }
                                },
                                tooltip: {
                                    formatter: function () {
                                        return (
                                            "<div><p>" +
                                            this.x +
                                            "</p><br><p>" +
                                            vm.customTitle +
                                            ": </p><p>" +
                                            this.total +
                                            "</p><br><p>Click for Details</p></div>"
                                        );
                                    }
                                },
                                series: ticketObj
                            };
                        } else if (type === "category") {
                            let catObj = [
                                {
                                    name: "Tickets by Category",
                                    data: [
                                        {
                                            name: "Incident",
                                            color: "#64AD61",
                                            y: 0
                                        },
                                        {
                                            name: "Change Request",
                                            color: "#467E8A",
                                            y: 0
                                        },
                                        {
                                            name: "Problem",
                                            color: "#DBAC39",
                                            y: 0
                                        },
                                        {
                                            name: "Request",
                                            color: "#D37C0F",
                                            y: 0
                                        }
                                    ]
                                }
                            ];
                            for (let r = 0; r < data.length; r++) {
                                var class_num = data[r].number.substring(0, 3);
                                switch (class_num) {
                                    case "INC":
                                        catObj[0].data[0].y++;
                                        break;
                                    case "PRB":
                                        catObj[0].data[1].y++;
                                        break;
                                    case "CUS":
                                        catObj[0].data[2].y++;
                                        break;
                                    case "CHG":
                                        catObj[0].data[2].y++;
                                        break;
                                    case "REQ":
                                        catObj[0].data[3].y++;
                                        break;
                                }
                            }
                            vm.contactType = false;
                            vm.customTitle = "Tickets by Category";
                            vm.config = {
                                chart: {
                                    type: "column",
                                    width: width,
                                    height: height,
                                    zoomType: "x",
                                    panning: true,
                                    panKey: "shift"
                                },
                                title: {
                                    text: vm.customTitle
                                },
                                subtitle: {
                                    text: "Click and drag to zoom in. Click legend items to toggle."
                                },
                                xAxis: {
                                    // categories: ['Incident', 'Problem', 'Customer Changes']
                                    categories: ["Incident", "Problem", "Customer Changes", "Request"]
                                },
                                yAxis: {
                                    min: 0,
                                    title: {
                                        text: "Number of Tickets"
                                    }
                                },
                                plotOptions: {
                                    column: {
                                        stacking: "normal"
                                    },
                                    series: {
                                        cursor: "pointer",
                                        point: {
                                            events: {
                                                click: function () {
                                                    vm.seriesSelected(this.category, "category");
                                                }
                                            }
                                        }
                                    }
                                },
                                tooltip: {
                                    formatter: function () {
                                        return (
                                            "<div><p>" +
                                            this.x +
                                            "</p><br><p>" +
                                            vm.customTitle +
                                            ": </p><p>" +
                                            this.total +
                                            "</p><br><p>Click for Details</p></div>"
                                        );
                                    }
                                },
                                series: catObj
                            };
                        } else if (type === "resolveTime") {
                            var dateArray2 = vm.processDateArray();
                            for (let g = 0; g < dateArray2.length; g++) {
                                ticketObj[0].data[g] = 0;
                                ticketObj[1].data[g] = 0;
                                ticketObj[2].data[g] = 0;
                                ticketObj[3].data[g] = 0;
                                ticketObj[4].data[g] = 0;
                                ticketObj[0].count[g] = 0;
                                ticketObj[1].count[g] = 0;
                                ticketObj[2].count[g] = 0;
                                ticketObj[3].count[g] = 0;
                                ticketObj[4].count[g] = 0;
                            }

                            for (let s = 0; s < data.length; s++) {
                                if (data[s].resolved_at) {
                                    let opened = data[s].opened_at;
                                    var date2 = data[s].resolved_at;
                                    //differnce between open and resolved in hours
                                    let diff = Number(new Date(date2) - new Date(opened)) / 3600000;
                                    var dateIndex2 = dateArray2.indexOf(
                                        moment(new Date(date2)).format().substring(0, 10)
                                    );
                                    switch (data[s].priority) {
                                        case "5 - Informational":
                                            ticketObj[0].count[dateIndex2]++;
                                            ticketObj[0].data[dateIndex2] += diff;
                                            break;
                                        case "4 - Minimal":
                                            ticketObj[1].count[dateIndex2]++;
                                            ticketObj[1].data[dateIndex2] += diff;
                                            break;
                                        case "3 - Moderate":
                                            ticketObj[2].count[dateIndex2]++;
                                            ticketObj[2].data[dateIndex2] += diff;
                                            break;
                                        case "2 - High":
                                            ticketObj[3].count[dateIndex2]++;
                                            ticketObj[3].data[dateIndex2] += diff;
                                            break;
                                        case "1 - Critical":
                                            ticketObj[4].count[dateIndex2]++;
                                            ticketObj[4].data[dateIndex2] += diff;
                                            break;
                                    }
                                }
                            }

                            //replace nulls with zero values in ticketObj
                            for (let a = 0; a < ticketObj.length; a++) {
                                for (let z = 0; z < dateArray2.length; z++) {
                                    if (ticketObj[a].data[z] != 0 || ticketObj[a].count[z] != 0) {
                                        ticketObj[a].data[z] = ticketObj[a].data[z] / ticketObj[a].count[z];
                                        ticketObj[a].data[z] = Number(ticketObj[a].data[z].toFixed(2));
                                    } else if (ticketObj[a].data[z] === null || ticketObj[a].count[z] === null) {
                                        ticketObj[a].data[z] = 0;
                                    }
                                }
                            }
                            vm.customTitle = "Time to Resolution";
                            vm.config = {
                                chart: {
                                    type: "line",
                                    width: width,
                                    height: height,
                                    zoomType: "x",
                                    panning: true,
                                    panKey: "shift"
                                },
                                legend: {
                                    enabled: true
                                },
                                title: {
                                    text: vm.customTitle
                                },
                                subtitle: {
                                    text: "Click and drag to zoom in. Click legend items to toggle."
                                },
                                xAxis: {
                                    categories: dateArray2
                                },
                                yAxis: {
                                    min: 0,
                                    title: {
                                        text: "Hours"
                                    }
                                },
                                plotOptions: {
                                    column: {
                                        stacking: "normal"
                                    },
                                    series: {
                                        animationLimit: "Infinity",
                                        cursor: "pointer",
                                        point: {
                                            events: {
                                                click: function () {
                                                    vm.seriesSelected(
                                                        this.series.userOptions.name +
                                                            " " +
                                                            moment(this.category).format("MMM D, YYYY h:mm:ss A"),
                                                        "resolveTime"
                                                    );
                                                }
                                            }
                                        }
                                    }
                                },
                                tooltip: {
                                    formatter: function () {
                                        return (
                                            "<div><p>" +
                                            this.x +
                                            "</p><br><p>" +
                                            vm.customTitle +
                                            ": </p><p>" +
                                            this.y +
                                            "</p><br><p>Click for Details</p></div>"
                                        );
                                    }
                                },
                                series: ticketObj
                            };
                        }
                        defer.resolve(data);
                    },
                    tableNames,
                    vm.dateValue,
                    vm.selected_sys_id,
                    angular.toJson(vm.date.startDate).substring(1, 11),
                    angular.toJson(vm.date.endDate).substring(1, 11),
                    vm.state,
                    vm.devCategory,
                    vm.getSelectedCategories()
                );
                return defer.promise;
            })
                .withDOM("lfBrtip")
                .withButtons(buttonOptions)
                .withColumnFilter(columnFilter)
                .withPaginationType("full_numbers")
                .withOption("retrieve", true)
                .withOption("responsive", true)
                .withOption("createdRow", (row) => {
                    $compile(angular.element(row).contents())($scope);
                });
        };

        vm.slaReport = () => {
            vm.filter =
                vm.contactType =
                vm.eventTable =
                vm.deviceTable =
                vm.deviceMetricTable =
                vm.dateSelected =
                vm.callTable =
                    false;
            vm.loading = true;
            vm.loadingTable = true;
            vm.showMainTable = true;

            vm.dtColumns = [
                DTColumnBuilder.newColumn("priority")
                    .withTitle("Priority")
                    .renderWith((data, type, row) => {
                        if (
                            row["task.number"].substring(0, 3) != "CUS" &&
                            row["task.number"].substring(0, 3) != "CHG"
                        ) {
                            data == null ? (data = "") : data;
                            let pri = data.substring(4);
                            data = data.substring(0, 1);
                            let icon =
                                '<span style="position:absolute;margin-left:26px;margin-top:1.5px;">' +
                                data +
                                '</span><img src="assets/img/icon/network_' +
                                data +
                                '.png" width="20" style="height:auto;margin-left:20px"/>';
                            icon +=
                                '<div style="position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px" tooltips tooltip-template="' +
                                pri +
                                '" tooltip-side="right" tooltip-class="priority-tooltip"></div>';
                            return icon;
                        } else {
                            return "";
                        }
                    }),
                DTColumnBuilder.newColumn("number")
                    .withTitle("Number")
                    .renderWith((data, type, row) => {
                        data == null ? (data = "") : data;
                        return (
                            "<a ng-click=\"vm.goToTicket('" +
                            row.number +
                            "', '" +
                            row.sys_id +
                            "');\">" +
                            row.number +
                            "</a>"
                        );
                    }),
                DTColumnBuilder.newColumn("short_description")
                    .withTitle("Short Description")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("duration")
                    .withTitle("Duration")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("time_left")
                    .withTitle("Time Left")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("percentage")
                    .withTitle("Percentage")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("has_breached")
                    .withTitle("Has Breached")
                    .renderWith((data) => {
                        return data == null ? "" : data;
                    }),
                DTColumnBuilder.newColumn("opened_by")
                    .withTitle("Opened By")
                    .renderWith((data) => {
                        if (!data) {
                            return "";
                        } else {
                            if (data.display_value) {
                                let emailRemoved = data.display_value.replace(/\s*\(.*?\)\s*/g, "");
                                return emailRemoved;
                            } else {
                                return "";
                            }
                        }
                    })
            ];
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(() => {
                let defer = $q.defer();
                Report.getIncidentSla(
                    (data) => {
                        data = data.results;
                        vm.static_table = data;
                        let successful = [0, 0, 0, 0, 0];
                        let breached = [0, 0, 0, 0, 0];
                        for (let x = 0; x < data.length; x++) {
                            data[x].has_breached == "true" ? breached[4]++ : successful[4]++;
                            switch (data[x].priority) {
                                case "4 - Minimal":
                                    data[x].has_breached == "true" ? breached[0]++ : successful[0]++;
                                    break;
                                case "3 - Moderate":
                                    data[x].has_breached == "true" ? breached[1]++ : successful[1]++;
                                    break;
                                case "2 - High":
                                    data[x].has_breached == "true" ? breached[2]++ : successful[2]++;
                                    break;
                                case "1 - Critical":
                                    data[x].has_breached == "true" ? breached[3]++ : successful[3]++;
                                    break;
                            }
                        }
                        vm.loading = false;
                        vm.loadingTable = false;
                        vm.table_title = vm.timeRange;
                        vm.customTitle = "Percentage of Successful SLA";
                        vm.config = {
                            chart: {
                                type: "column",
                                width: width,
                                height: height,
                                zoomType: "x",
                                panning: true,
                                panKey: "shift"
                            },
                            legend: {
                                enabled: true
                            },
                            title: {
                                text: vm.customTitle
                            },
                            subtitle: {
                                text: "Click and drag to zoom in. Click legend items to toggle."
                            },
                            xAxis: {
                                categories: ["Minimal", "Moderate", "High", "Critical", "All Tickets"]
                            },
                            yAxis: {
                                min: 0,
                                title: {
                                    text: "Percentage of Successful SLA"
                                }
                            },
                            plotOptions: {
                                column: {
                                    stacking: "percent"
                                },
                                series: {
                                    cursor: "pointer",
                                    point: {
                                        events: {
                                            click: function () {
                                                vm.seriesSelected(this.category + " " + this.series.name, "sla");
                                            }
                                        }
                                    }
                                }
                            },
                            tooltip: {
                                formatter: function () {
                                    return (
                                        '<div style="color:' +
                                        this.series.color +
                                        '"><span>' +
                                        this.series.name +
                                        "</span>: <b>" +
                                        this.y +
                                        " (" +
                                        this.percentage.toFixed(2) +
                                        "%)</b><br><p>Click for Details</p></div>"
                                    );
                                }
                            },
                            series: [
                                {
                                    color: "#921A21",
                                    name: "Breached",
                                    data: breached
                                },
                                {
                                    color: "#41A14E",
                                    name: "Successful",
                                    data: successful
                                }
                            ]
                        };
                        defer.resolve(data);
                    },
                    5000,
                    0,
                    vm.dateValue,
                    user_info.company,
                    angular.toJson(vm.date.startDate).substring(1, 11),
                    angular.toJson(vm.date.endDate).substring(1, 11)
                );
                return defer.promise;
            })
                .withDOM("lfBrtip")
                .withButtons(buttonOptions)
                .withColumnFilter(columnFilter)
                .withPaginationType("full_numbers")
                .withOption("retrieve", true)
                .withOption("responsive", true)
                .withOption("createdRow", (row) => {
                    $compile(angular.element(row).contents())($scope);
                });
        };

        vm.sl_states = ["Healthy", "Notice", "Minor", "Major", "Critical"];

        vm.deviceTypes = ["All"];
        vm.deviceDirections = [
            {
                id: "in",
                name: "Inbound"
            },
            {
                id: "out",
                name: "Outbound"
            }
        ];
        vm.chosenDeviceType = vm.deviceTypes[0];
        vm.chosenDeviceDirection = vm.deviceDirections[0].id;
        vm.utilTypes = [
            {
                id: "device",
                name: "Device"
            },
            {
                id: "interface",
                name: "Interface"
            }
        ];

        vm.utilUnits = [
            {
                id: "perc",
                name: "Percent"
            },
            {
                id: "octets",
                name: "Mbps"
            }
        ];

        vm.interface = vm.utilTypes[0].id;
        vm.interfaceUnit = vm.utilUnits[0].id;
        vm.allAvailability = "under100";

        vm.deviceReportTypes = ["Interfaces", "Collections", "Availability"];
        vm.chosenDeviceReport = vm.deviceReportTypes[0];

        vm.chosenDeviceMetricType = "Availability";

        vm.availabilityTypes = [
            {
                id: "d_latency",
                name: "Latency"
            },
            {
                id: "d_check",
                name: "Check"
            }
        ];
        vm.chosenAvailabilityType = vm.availabilityTypes[0].id;
        vm.filesystemTypes = [
            {
                id: "d_used",
                name: "Usage"
            },
            {
                id: "d_used_percent",
                name: "Percent"
            }
        ];
        vm.chosenFilesystemType = vm.filesystemTypes[0].id;

        vm.getDeviceCategories = () => {
            ScienceLogicGQL.getQuery(
                {
                    table: "devices",
                    queryName: "activeDevices",
                    edge: "devices"
                },
                (response) => {
                    response.results.forEach((item) => {
                        if (!vm.deviceTypes.includes(item.deviceClass.deviceCategory.name)) {
                            vm.deviceTypes.push(item.deviceClass.deviceCategory.name);
                        }
                    });
                }
            );
        };
        vm.getDeviceCategories();

        vm.getCollectionLabels = () => {
            ScienceLogicGQL.getQuery(
                {
                    table: "metrics",
                    queryName: "collectionLabels",
                    edge: "collectionLabels"
                },
                (response) => {
                    if (response.results && response.results.length > 0) {
                        vm.deviceCategories = vm.sortCommonMetrics(response.results);
                        vm.chosenDeviceCategory = vm.deviceCategories[0].id;
                    }
                }
            );
        };
        vm.getCollectionLabels();

        vm.sortCommonMetrics = (collections) => {
            collections = collections.sort(vm.compare);
            let sortFirst = ["Swap", "Memory", "CPU"];
            return collections.sort((x, y) => {
                return sortFirst.indexOf(x.name) != -1 ? -1 : sortFirst.indexOf(y.name) != -1 ? 1 : 0;
            });
        };

        vm.compare = (a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        };

        vm.prepareSearchQuery = (reportType) => {
            let searchObj = {};
            let searchDeviceCategory = vm.chosenDeviceType;
            switch (reportType) {
                case "Interfaces":
                    searchObj = {
                        table: "metrics",
                        queryName: "interfaces",
                        edge: "topNInterfaceMetrics",
                        search: {
                            utilUnit: vm.interfaceUnit,
                            utilDirection: vm.chosenDeviceDirection
                        }
                    };
                    break;
                case "Availability":
                    // var metricUnit;
                    // vm.chosenDeviceMetricType === 'Availability' ? metricUnit = vm.chosenAvailabilityType : metricUnit = vm.chosenFilesystemType;
                    searchObj = {
                        table: "metrics",
                        queryName: "metrics",
                        edge: "topNDeviceMetrics",
                        search: {
                            metricUnit: vm.chosenAvailabilityType,
                            metricCategory: vm.chosenDeviceMetricType
                        }
                    };
                    break;
                case "Collections":
                    searchObj = {
                        table: "metrics",
                        queryName: "metrics",
                        edge: "topNDeviceMetrics",
                        search: {
                            metricUnit: vm.chosenDeviceCategory,
                            metricCategory: "CollectionLabel"
                        }
                    };
                    break;
                case "Dynamic Apps":
                    searchObj = {
                        table: "metrics",
                        queryName: "metrics",
                        edge: "topNDeviceMetrics",
                        search: {
                            metricUnit: vm.chosenDynamicApp,
                            metricCategory: "DynamicApp"
                        }
                    };
                    break;
            }
            searchDeviceCategory != "All" ? (searchObj.search.category = searchDeviceCategory) : "";
            searchObj.search.beginDate = vm.date.startDate;
            searchObj.search.endDate = vm.date.endDate;
            return searchObj;
        };

        vm.getDataUtil = () => {
            vm.filter =
                vm.showMainTable =
                vm.eventTable =
                vm.deviceMetricTable =
                vm.dateSelected =
                vm.callTable =
                    false;
            vm.loading = true;
            vm.loadingTable = true;
            vm.deviceTable = true;
            vm.table_title = "";
            vm.static_table = [];
            vm.interfaceUnit === "octets" ? (vm.utilUnit = "Mbps") : (vm.utilUnit = "Percent");
            vm.sortType = vm.interface;
            vm.chosenDeviceReport != "Interfaces" ? (vm.sortType = "device") : "";
            var sortNum;

            let subtitleText = "Click and drag to zoom in. Click legend items to toggle.";

            vm.sortType === "device" ? (sortNum = "6") : (sortNum = "7");

            vm.dtOptionsUtil = DTOptionsBuilder.newOptions()
                .withDOM('lf<".table-scroll"rt>ip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withDOM("lfBrtip")
                .withButtons(buttonOptions)
                .withColumnFilter(columnFilter)
                .withOption("paging", true)
                .withOption("order", [[sortNum, "des"]])
                .withOption("responsive", true)
                .withOption("retrieve", true);

            if (!vm.date.startDate || !vm.date.endDate) {
                vm.toggleTime(vm.timeRange);
            }

            let search = vm.prepareSearchQuery(vm.chosenDeviceReport);

            ScienceLogicGQL.getQuery(search, (response) => {
                if (response.results && response.results.length === 0) {
                    subtitleText = "No Data";
                    vm.setNoDataChart();
                } else {
                    vm.setUtiltitle();
                    vm.setCollectionUnits(response.labels);
                    let processedData = vm.processUtilResponse(response.results);
                    vm.static_table = processedData.table;
                    vm.config = {
                        chart: {
                            type: "column",
                            width: width,
                            height: height,
                            zoomType: "x",
                            panning: true,
                            panKey: "shift"
                        },
                        legend: {
                            enabled: true
                        },
                        title: {
                            text: vm.customTitle
                        },
                        subtitle: {
                            text: subtitleText
                        },
                        xAxis: {
                            categories: processedData.categories,
                            crosshair: true
                        },
                        yAxis: {
                            min: 0,
                            title: {
                                text: vm.yTitle
                            }
                        },
                        plotOptions: {
                            series: {
                                cursor: "pointer",
                                point: {
                                    events: {
                                        click: function () {
                                            vm.seriesSelected(this.category, "EM7Device");
                                        }
                                    }
                                }
                            }
                        },
                        tooltip: {
                            formatter: function () {
                                return (
                                    "<div><p>" +
                                    this.x +
                                    "</p><br><p>" +
                                    vm.yTitle +
                                    ": </p><p>" +
                                    this.y +
                                    "</p><br><p>Click for Details</p></div>"
                                );
                            }
                        },
                        series: [
                            {
                                name: vm.customTitle,
                                color: "#64AD61",
                                data: processedData.data
                            }
                        ]
                    };
                    vm.loading = false;
                    vm.loadingTable = false;
                }
            });
        };

        vm.setCollectionUnits = (data) => {
            if (data && data[0] && data[0].info) {
                let info = data[0].info;
                vm.customTitle = info.label;
                info.units ? (vm.utilUnit = info.units.label) : (vm.utilUnit = "Value");
                vm.yTitle = vm.utilUnit;
            }
        };

        vm.processUtilResponse = (data) => {
            let categoryArray = [];
            let intCountArray = [];
            let dataArray = [];
            let dataAvgArray = [];
            let tableArray = [];
            if (vm.chosenDeviceReport === "Interfaces") {
                if (vm.interface === "device") {
                    data.forEach((item) => {
                        if (categoryArray.includes(item.device.name)) {
                            let categoryIndex = categoryArray.indexOf(item.device.name);
                            dataArray[categoryIndex] += item.values[0].value;
                            intCountArray[categoryIndex]++;
                        } else {
                            categoryArray.push(item.device.name);
                            intCountArray.push(1);
                            dataArray.push(item.values[0].value);
                            tableArray.push(item.device);
                        }
                    });
                    dataArray.forEach((item, index) => {
                        let avgItem = item / intCountArray[index];
                        vm.interfaceUnit === "octets" ? (avgItem = vm.toMegabits(avgItem)) : "";
                        avgItem = Number(avgItem.toFixed(2));
                        dataAvgArray.push(avgItem);
                        tableArray[index].value = avgItem;
                    });
                    let groupSort = groupSortDevice(categoryArray, dataAvgArray);
                    return {
                        categories: groupSort.category,
                        data: groupSort.value,
                        table: tableArray
                    };
                } else {
                    return vm.sortUtilData(data);
                }
            } else {
                return vm.sortUtilData(data);
            }
        };

        function groupSortDevice(array1, array2) {
            let list = [];
            array1.forEach((item, index) => {
                list.push({
                    category: item,
                    value: array2[index]
                });
            });
            list.sort((a, b) => {
                return a.value > b.value ? -1 : a.value == b.value ? 0 : 1;
            });
            list.forEach((item, index) => {
                array1[index] = list[index].category;
                array2[index] = list[index].value;
            });
            return {
                category: array1,
                value: array2
            };
        }

        vm.sortUtilData = (data) => {
            let seriesObj = {
                categories: [],
                data: [],
                table: []
            };
            data.forEach((item) => {
                let tableItem = item.device;
                let itemValue = item.values[0].value;
                if (vm.chosenDeviceReport === "Interfaces") {
                    vm.interfaceUnit === "octets" ? (itemValue = vm.toMegabits(itemValue)) : "";
                    item.interface && item.interface.name ? (tableItem.interface = item.interface.name) : "";
                    item.interface && item.interface.name ? seriesObj.categories.push(item.interface.name) : "";
                } else {
                    seriesObj.categories.push(item.device.name);
                }
                tableItem.value = Number(itemValue.toFixed(2));
                seriesObj.data.push(Number(itemValue.toFixed(2)));
                seriesObj.table.push(tableItem);
            });
            return seriesObj;
        };

        vm.setNoDataChart = () => {
            vm.customTitle = "No Metric Data";
            vm.loading = false;
            vm.loadingTable = false;
            vm.config = {
                chart: {
                    type: "line",
                    width: width,
                    height: height,
                    zoomType: "x",
                    panning: true,
                    panKey: "shift"
                },
                title: {
                    text: "No Data"
                },
                subtitle: {
                    text: ""
                },
                xAxis: {
                    categories: [],
                    crosshair: true
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: ""
                    }
                },
                plotOptions: {
                    series: {
                        color: "#64AD61"
                    }
                },
                series: [
                    {
                        name: "",
                        type: "line",
                        data: []
                    }
                ]
            };
        };

        vm.getLabelName = (obj, id) => {
            var foundName;
            obj.forEach((item) => {
                if (item.id === id) {
                    foundName = item.name;
                }
            });
            return foundName;
        };

        vm.setUtiltitle = () => {
            switch (vm.chosenDeviceReport) {
                case "Interfaces":
                    vm.customTitle =
                        vm.chosenDeviceType +
                        " " +
                        vm.chosenDeviceDirection.charAt(0).toUpperCase() +
                        vm.chosenDeviceDirection.slice(1) +
                        "bound Utilization";
                    vm.yTitle = "Utilization" + vm.utilUnit;
                    break;
                case "Availability":
                    vm.customTitle = vm.chosenDeviceMetricType + " Report";
                    switch (vm.chosenDeviceMetricType) {
                        case "Availability":
                            vm.yTitle = vm.getLabelName(vm.availabilityTypes, vm.chosenAvailabilityType);
                            break;
                        case "Filesystem":
                            vm.yTitle = vm.getLabelName(vm.filesystemTypes, vm.chosenFilesystemType);
                            break;
                        default:
                            break;
                    }
                    break;
                case "Collections":
                case "Dynamic Apps":
                    vm.customTitle = vm.chosenDeviceCategoryUnit + " Report";
                    vm.yTitle = null;
                    break;
                default:
                    break;
            }
        };

        vm.ticketDeviceCategories =  [];
        //get choice list for filtering by ticket categories

        Service.getServices(user_info.company, true, (dataWithServiceName) => {
            Service.getServices(user_info.company, false, (dataNoServiceName) => {
                $log.info(dataWithServiceName);
                dataWithServiceName.results.forEach(serviceObject => {
                    vm.ticketDeviceCategories.push({
                        "name": serviceObject["u_service"]
                    });
                });
                for(let i = 0; i < dataNoServiceName.results.length; i++) {
                    vm.ticketDeviceCategories[i]["id"] = dataNoServiceName.results[i]["u_service"];
                }

                vm.ticketDeviceCategories = _.sortBy(vm.ticketDeviceCategories, (o) => {
                    return o.name;
                });
                vm.ticketDeviceCategories = vm.ticketDeviceCategories.filter((category, index) => {
                    return index === vm.ticketDeviceCategories.findIndex(obj => {
                      return obj.name === category.name;
                    });
                  });
                
                  vm.ticketDeviceCategories = vm.ticketDeviceCategories.filter(category => {
                    return !vm.ticketDeviceCategory.find(searchCategory => {
                        return searchCategory.name === category.name;
                    })
                  });

                $log.info(vm.ticketDeviceCategories);
                vm.dualListOptionsDevice = {
                    filterPlaceHolder: "Start typing to filter the lists below.",
                    labelAll: "Available",
                    labelSelected: "Selected",
                    helpMessage: "Choose Device Classes to Filter Report",
                    orderProperty: "name",
                    items: vm.ticketDeviceCategories,
                    selectedItems: vm.ticketDeviceCategory
                };
            });
        });

        vm.getSelectedCategories = () => {
            $log.info("SELECTED CATEGORIES")
            if(vm.ticketDeviceCategory.length > 0) {
                $log.info(vm.ticketDeviceCategory);
                return vm.ticketDeviceCategory;
            } else {
                $log.info(vm.ticketDeviceCategories);
                return vm.ticketDeviceCategories;
            }
        }

        //main selection function for choosing a EM7 MetricVital report; resets variables etc.
        vm.cycleDevices = (uri, vitalName, appName) => {
            vm.filter =
                vm.showMainTable =
                vm.eventTable =
                vm.metricsLoaded =
                vm.deviceTable =
                vm.dateSelected =
                vm.callTable =
                    false;
            vm.loading = true;
            vm.loadingTable = true;
            vm.deviceMetricTable = true;
            vm.totalMetricArray = [];
            vm.metricIndex = 0;
            vm.metricDeviceLength = vm.metricDevices.length;
            vm.vitalName = vitalName;
            vm.appName = appName;
            vm.dateMetric = {};
            vm.singleDeviceMetric = {};
            vm.refreshReport("metricReport", false, uri, vitalName, appName);
            for (let x = 0; x < vm.metricDeviceLength; x++) {
                let url = uri.split("/");
                url[3] = vm.metricDevices[x].u_sciencelogic_id.replace(",", "");
                var url2 = url.join("/");
                vm.getMetricReport(url2, vitalName, appName, vm.metricDevices[x].name);
            }
        };

        //watches for different sources of metric data gathering, once all finished, build the config for the highchart
        $scope.$watch("vm.metricsLoaded", (newValue, oldValue) => {
            if (newValue !== oldValue) {
                if (vm.metricsLoaded === true) {
                    vm.buildMetricReport();
                }
            }
        });

        vm.toMegabytes = (octets) => {
            return ((octets * 8) / 1024 / 1024).toFixed(2);
        };

        vm.toMegabits = (bits) => {
            return bits / 1000 / 1000;
        };

        //general function for querying EM7 to get any metric data needed for report
        vm.frequency = 30;
        vm.getMetricReport = (uri, vitalName, appName, devName) => {
            vm.loadingReport = true;
            vm.stats = [];
            let vitalURL = uri.slice(11);
            vitalURL = vitalURL.replace("duration=30d", "beginstamp=" + vm.start + "&endstamp=" + vm.end);
            if (vm.hourlyFilter) {
                vitalURL = vitalURL.replace("daily", "hourly");
            }
            Devices.getReport(
                "",
                (vital) => {
                    vm.loadingReport = false;
                    if (
                        vital.data &&
                        vital.data[Object.keys(vital.data)[0]] &&
                        vital.data[Object.keys(vital.data)[0]].avg
                    ) {
                        let tempArray = [];
                        let vitalData = vital.data[Object.keys(vital.data)[0]].avg;

                        tempArray = Object.keys(vitalData).map((key) => {
                            let dataPoint = vitalData[key];
                            if (
                                dataPoint > 1010 &&
                                vitalName.indexOf("Byte") == -1 &&
                                vitalName.indexOf("byte") == -1
                            ) {
                                dataPoint = vm.toMegabytes(dataPoint);
                            }
                            if (vm.hourlyFilter) {
                                return [
                                    moment(new Date(key * 1000)).format("ddd MMM DD YYYY hh:mm:ss A"),
                                    Number(Number(dataPoint).toFixed(2))
                                ];
                            } else {
                                return [
                                    new Date(key * 1000).toString().substring(0, 15),
                                    Number(Number(dataPoint).toFixed(2))
                                ];
                            }
                        });
                        if (vm.weekdayFilter) {
                            tempArray = vm.removeWeekends(tempArray);
                        }
                        //adds forecast
                        if (vm.forecast && vm.metricType === "Date") {
                            tempArray = vm.addForecastDates(tempArray);
                        }
                        if (vm.metricType === "Date") {
                            for (let x = 0; x < tempArray.length; x++) {
                                if (!vm.dateMetric[tempArray[x][0]]) {
                                    vm.dateMetric[tempArray[x][0]] = [];
                                }
                                vm.dateMetric[tempArray[x][0]].push([devName, tempArray[x][1]]);
                            }
                        }
                        let statAverage = 0;
                        for (let j = 0; j < tempArray.length; j++) {
                            statAverage += tempArray[j][1];
                        }
                        statAverage = Number((statAverage / tempArray.length).toFixed(2));
                        vm.totalMetricArray.push([devName, statAverage]);
                        vm.singleDeviceMetric[devName] = tempArray;
                    }
                    vm.metricIndex++;
                    if (vm.metricIndex == vm.metricDeviceLength) {
                        vm.metricsLoaded = true;
                    }
                },
                false,
                false,
                false,
                false,
                false,
                vitalURL,
                false,
                vm.frequency
            );
        };

        // function that build the chart config from the metric data
        vm.buildMetricReport = () => {
            let categoryArray = [];
            let values = [];
            let devicesByDate = [];
            let noData = true;
            let orderedDateObj = {};

            let chartType = "line";
            if (vm.metricType === "Date") {
                Object.keys(vm.dateMetric)
                    .sort((a, b) => {
                        return new Date(a) - new Date(b);
                    })
                    .forEach((key) => {
                        orderedDateObj[key] = vm.dateMetric[key];
                    });
                let valueCount = 0;
                for (var key in orderedDateObj) {
                    categoryArray.push(key);
                    values[valueCount] = 0;
                    for (let x = 0; x < orderedDateObj[key].length; x++) {
                        if (orderedDateObj[key][x][1] != null) {
                            values[valueCount] += orderedDateObj[key][x][1];
                            if (devicesByDate.indexOf(orderedDateObj[key][x][0]) == -1) {
                                devicesByDate.push(orderedDateObj[key][x][0]);
                            }
                        } else {
                            values[valueCount] = orderedDateObj[key][x][1];
                        }
                    }

                    if (values[valueCount] != null) {
                        values[valueCount] = Number((values[valueCount] / orderedDateObj[key].length).toFixed(2));
                    }
                    valueCount++;
                }
                vm.totalMetricArray = _.sortBy(vm.totalMetricArray, (obj) => {
                    return -obj[1];
                });
                for (let m = 0; m < vm.totalMetricArray.length; m++) {
                    if (vm.totalMetricArray[m][1] != 0) {
                        noData = false;
                    }
                }
            } else if (vm.metricType === "Device") {
                chartType = "column";
                vm.totalMetricArray = _.sortBy(vm.totalMetricArray, (obj) => {
                    return -obj[1];
                });
                for (let p = 0; p < vm.totalMetricArray.length; p++) {
                    categoryArray.push(vm.totalMetricArray[p][0]);
                    values.push(vm.totalMetricArray[p][1]);
                    if (vm.totalMetricArray[p][1] != 0) {
                        noData = false;
                    }
                }
            }
            for (let e = 0; e < vm.metricDevices.length; e++) {
                for (let y = 0; y < vm.totalMetricArray.length; y++) {
                    if (vm.metricDevices[e].name == vm.totalMetricArray[y][0]) {
                        vm.metricDevices[e][vm.vitalName] = vm.totalMetricArray[y][1];
                    }
                }
            }
            vm.loading = false;
            vm.loadingTable = false;
            vm.static_table = angular.copy(vm.metricDevices);
            vm.dtOptionsMetric = DTOptionsBuilder.newOptions()
                .withDOM('lfB<".table-scroll"rt>ip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withButtons(buttonOptions)
                .withColumnFilter(columnFilter)
                .withOption("responsive", true)
                .withOption("retrieve", true);
            vm.customTitle = vm.vitalName;
            //highchart config
            if (!noData) {
                vm.config = {
                    chart: {
                        type: chartType,
                        width: width,
                        height: height,
                        zoomType: "x",
                        panning: true,
                        panKey: "shift"
                    },
                    legend: {
                        enabled: false
                    },
                    title: {
                        text: vm.vitalName
                    },
                    subtitle: {
                        text: "Click and drag to zoom in."
                    },
                    xAxis: {
                        categories: categoryArray,
                        crosshair: true
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: "Average Usage"
                        }
                    },
                    plotOptions: {
                        series: {
                            cursor: "pointer",
                            point: {
                                events: {
                                    click: function () {
                                        if (this.series.name != "Trend") {
                                            if (vm.metricType === "Date") {
                                                vm.selectedMetricData(
                                                    vm.dateMetric[this.category],
                                                    this.category,
                                                    "Date"
                                                );
                                            } else if (vm.metricType === "Device") {
                                                vm.selectedMetricData(
                                                    vm.singleDeviceMetric[this.category],
                                                    this.category,
                                                    "Device"
                                                );
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    tooltip: {
                        formatter: function () {
                            return (
                                "<div><p>" +
                                this.x +
                                "</p><br><p>" +
                                vm.vitalName +
                                ": </p><p>" +
                                this.y +
                                "</p><br><p>Click for Details</p></div>"
                            );
                        }
                    },
                    series: [
                        {
                            name: vm.vitalName,
                            color: "#567dff",
                            data: values
                        }
                    ]
                };
                // if trendline setting is selected
                if (vm.trendline && vm.metricType === "Date") {
                    let trendSeries = {
                        type: "line",
                        name: "Trend",
                        color: "#14c968",
                        marker: {
                            enabled: false
                        },
                        data: (() => {
                            return Trend(values, null, vm.forecast, vm.hourlyFilter).data;
                        })()
                    };
                    vm.config.series.push(trendSeries);
                }
            } else {
                // config for no data
                vm.config = {
                    chart: {
                        type: "line",
                        width: width,
                        height: height,
                        zoomType: "x",
                        panning: true,
                        panKey: "shift"
                    },
                    title: {
                        text: "No Data"
                    },
                    subtitle: {
                        text: ""
                    },
                    xAxis: {
                        categories: [],
                        crosshair: true
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: ""
                        }
                    },
                    plotOptions: {
                        series: {
                            color: "#64AD61"
                        }
                    },
                    series: [
                        {
                            name: "",
                            type: chartType,
                            data: []
                        }
                    ]
                };
            }
        };

        vm.selectedMetricData = (obj, name, type) => {
            vm.filter = true;
            vm.dateSelected = true;
            if (type === "Date") {
                for (let x = 0; x < vm.static_table.length; x++) {
                    for (let y = 0; y < obj.length; y++) {
                        if (vm.static_table[x].name == obj[y][0]) {
                            vm.static_table[x][vm.vitalName] = obj[y][1];
                            vm.static_table[x].date = name;
                        }
                    }
                }
            } else if (type === "Device") {
                var temp_static = angular.copy(vm.metricDevices);
                for (let d = 0; d < temp_static.length; d++) {
                    if (temp_static[d].name == name) {
                        var temp_static_2 = [];
                        for (let v = 0; v < obj.length; v++) {
                            let temp = angular.copy(temp_static[d]);
                            temp[vm.vitalName] = obj[v][1];
                            temp.date = obj[v][0];
                            temp_static_2.push(temp);
                        }
                        vm.static_table = angular.copy(temp_static_2);
                    }
                }
            }
            $scope.$apply();
            $document.scrollToElement(angular.element("#activity-table"), 0, 1000);
        };

        vm.toggleForecast = () => {
            vm.forecast = !vm.forecast;
            if (!vm.trendline) {
                vm.trendline = true;
            }
        };

        vm.toggleTrendline = () => {
            vm.trendline = !vm.trendline;
            if (!vm.trendline) {
                vm.forecast = false;
            }
        };

        vm.removeWeekends = (array) => {
            let newArray = [];
            for (let x = 0; x < array.length; x++) {
                if (array[x][0].substring(0, 3) != "Sun" && array[x][0].substring(0, 3) != "Sat") {
                    newArray.push(array[x]);
                }
            }
            return newArray;
        };

        vm.addForecastDates = (array) => {
            if (vm.hourlyFilter) {
                for (let x = 0; x < 336; x++) {
                    let temp = array[array.length - 1];
                    let newDate = new Date(temp[0]);
                    newDate = newDate.setHours(newDate.getHours() + 1);
                    newDate = new Date(newDate);
                    let newForecast = [moment(newDate).format("ddd MMM DD YYYY hh:mm:ss A"), null];
                    array.push(newForecast);
                }
            } else {
                for (let b = 0; b < 14; b++) {
                    var temp2 = array[array.length - 1];
                    var newDate2 = new Date(temp2[0]);
                    newDate2 = newDate2.setDate(newDate2.getDate() + 1);
                    newDate2 = new Date(newDate2);
                    var newForecast2 = [newDate2.toString().substring(0, 15), null];
                    array.push(newForecast2);
                }
            }
            return array;
        };

        vm.getUser = (key, user) => {
            Service.getSLUser((data) => {
                vm.event_table[key].user_acknowledged = data.contact_fname + " " + data.contact_lname;
            }, user);
        };

        vm.eventGeneratorReport = () => {
            vm.filter =
                vm.showMainTable =
                vm.deviceTable =
                vm.deviceMetricTable =
                vm.dateSelected =
                vm.callTable =
                    false;
            vm.loading = true;
            vm.loadingTable = true;
            vm.eventTable = true;
            vm.table_title = "";
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('lf<".table-scroll"rt>ip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withDOM("lfBrtip")
                .withButtons(buttonOptions)
                .withColumnFilter(columnFilter)
                .withOption("responsive", true)
                .withOption("retrieve", true);
            vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef(6).withOption("type", "date")];

            Events.getEvent(
                (data) => {
                    vm.loading = false;
                    vm.event_table = data.result_set;
                    let deviceObj = {};
                    let deviceArray = [];
                    let categoryArray = [];
                    let suppressArray = [];
                    for (var x in vm.event_table) {
                        if (
                            vm.event_table[x].suppress_group != "0" &&
                            suppressArray.indexOf(vm.event_table[x].suppress_group) > -1
                        ) {
                            delete vm.event_table[x];
                        } else if (
                            vm.event_table[x].suppress_group != "0" &&
                            suppressArray.indexOf(vm.event_table[x].suppress_group) == -1
                        ) {
                            suppressArray.push(vm.event_table[x].suppress_group);
                        }
                    }
                    for (var y in vm.event_table) {
                        if (!deviceObj[vm.event_table[y].aligned_resource_name]) {
                            deviceObj[vm.event_table[y].aligned_resource_name] = 1;
                        } else {
                            deviceObj[vm.event_table[y].aligned_resource_name]++;
                        }
                    }
                    for (var q in deviceObj) {
                        deviceArray.push([q, deviceObj[q]]);
                    }
                    var top10 = deviceArray
                        .sort((a, b) => {
                            return a[1] < b[1] ? 1 : -1;
                        })
                        .slice(0, 10);
                    top10.forEach((item) => {
                        categoryArray.push(item[0]);
                    });

                    for (var f in vm.event_table) {
                        if (categoryArray.indexOf(vm.event_table[f].aligned_resource_name) === -1) {
                            delete vm.event_table[f];
                        }
                    }

                    for (var key in vm.event_table) {
                        if (vm.event_table[key].user_ack) {
                            vm.getUser(key, vm.event_table[key].user_ack);
                        }
                    }

                    vm.static_table = [];
                    for (var t in vm.event_table) {
                        vm.static_table.push(vm.event_table[t]);
                    }
                    vm.loadingTable = false;

                    let eventObj = [
                        {
                            name: "Healthy",
                            color: "#64AD61",
                            data: []
                        },
                        {
                            name: "Notice",
                            color: "#467E8A",
                            data: []
                        },
                        {
                            name: "Minor",
                            color: "#DBAC39",
                            data: []
                        },
                        {
                            name: "Major",
                            color: "#D37C0F",
                            data: []
                        },
                        {
                            name: "Critical",
                            color: "#A51820",
                            data: []
                        }
                    ];

                    for (let a = 0; a < categoryArray.length; a++) {
                        eventObj[0].data[a] = 0;
                        eventObj[1].data[a] = 0;
                        eventObj[2].data[a] = 0;
                        eventObj[3].data[a] = 0;
                        eventObj[4].data[a] = 0;
                    }

                    for (var h in vm.event_table) {
                        let name = vm.event_table[h].aligned_resource_name;
                        let nameIndex = categoryArray.indexOf(name);
                        switch (vm.event_table[h].severity) {
                            case "0":
                                eventObj[0].data[nameIndex]++;
                                break;
                            case "1":
                                eventObj[1].data[nameIndex]++;
                                break;
                            case "2":
                                eventObj[2].data[nameIndex]++;
                                break;
                            case "3":
                                eventObj[3].data[nameIndex]++;
                                break;
                            case "4":
                                eventObj[4].data[nameIndex]++;
                                break;
                        }
                    }

                    vm.customTitle = "Top Event Generators";
                    vm.config = {
                        chart: {
                            type: "column",
                            width: width,
                            height: height,
                            zoomType: "x",
                            panning: true,
                            panKey: "shift"
                        },
                        legend: {
                            enabled: true
                        },
                        title: {
                            text: vm.customTitle
                        },
                        subtitle: {
                            text: "Click and drag to zoom in. Click legend items to toggle."
                        },
                        xAxis: {
                            categories: categoryArray,
                            crosshair: true
                        },
                        yAxis: {
                            min: 0,
                            title: {
                                text: "Events"
                            }
                        },
                        plotOptions: {
                            column: {
                                stacking: "normal"
                            },
                            series: {
                                cursor: "pointer",
                                point: {
                                    events: {
                                        click: function () {
                                            vm.seriesSelected(
                                                this.series.userOptions.name + " " + this.category,
                                                "Event"
                                            );
                                        }
                                    }
                                }
                            }
                        },
                        tooltip: {
                            formatter: function () {
                                return (
                                    "<div><p>" +
                                    this.x +
                                    "</p><br><p>Events Generated: </p><p>" +
                                    this.total +
                                    "</p><br><p>Click for Details</p></div>"
                                );
                            }
                        },
                        series: eventObj
                    };
                },
                {
                    date_first: "DESC"
                },
                {},
                page,
                offset,
                false
            );
        };

        // Returns an array of dates between the two dates
        let getDates = (startDate, endDate) => {
            let dates = [],
                currentDate = startDate,
                addDays = function (days) {
                    let date = new Date(this.valueOf());
                    date.setDate(date.getDate() + days);
                    return date;
                };
            while (currentDate <= endDate) {
                dates.push(angular.toJson(currentDate).substring(1, 11));
                currentDate = addDays.call(currentDate, 1);
            }
            return dates;
        };

        vm.getLastMonth = (callQuery) => {
            var beginning_date;
            var ending_date = new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-01";
            if (new Date().getMonth() === 0) {
                //if it is january
                beginning_date = new Date().getFullYear() - 1 + "-" + 12 + "-01";
            } else {
                beginning_date = new Date().getFullYear() + "-" + ("0" + new Date().getMonth()).slice(-2) + "-01";
            }
            if (callQuery) {
                return [new Date(beginning_date), new Date(ending_date)];
            } else {
                return [beginning_date, ending_date];
            }
        };

        vm.getThisMonth = (callQuery) => {
            let today = ("0" + new Date().getDate()).slice(-2);
            var beginning_date = new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-01";
            var ending_date =
                new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + today;
            if (callQuery) {
                return [new Date(beginning_date), new Date(ending_date)];
            } else {
                return [beginning_date, ending_date];
            }
        };

        vm.processDateArray = () => {
            var tempDateArray;
            if (vm.dateValue === 0) {
                let lastM = vm.getLastMonth();
                tempDateArray = getDates(
                    new Date(angular.toJson(lastM[0]).substring(1, 11)),
                    new Date(angular.toJson(lastM[1]).substring(1, 11))
                );
                tempDateArray.pop();
            } else if (vm.dateValue === 1) {
                let thisM = vm.getThisMonth();
                tempDateArray = getDates(
                    new Date(angular.toJson(thisM[0]).substring(1, 11)),
                    new Date(angular.toJson(thisM[1]).substring(1, 11))
                );
            } else {
                tempDateArray = getDates(
                    new Date(angular.toJson(vm.date.startDate).substring(1, 11)),
                    new Date(angular.toJson(vm.date.endDate).substring(1, 11))
                );
                tempDateArray.pop();
            }
            return tempDateArray;
        };

        vm.change_type = (type) => {
            vm.config.chart.type = type;
        };

        var exceptions;

        Service.getExceptions((data) => {
            if (data.err || !data.results) {
                vm.error = true;
            } else {
                exceptions = data.results;
            }
        }, user_info.company);

        // reroutes to selected device on device page
        vm.goToDevice = (device) => {
            let except = false;
            for (let x = 0; x < exceptions.length; x++) {
                if (device.toLowerCase() === exceptions[x].name.toLowerCase()) {
                    except = true;
                }
            }
            if (except) {
                $state.go("index.devices", {
                    redirectedDevice: device,
                    exception: true
                });
            } else {
                $state.go("index.devices", {
                    redirectedDevice: device
                });
            }
        };

        //reroutes to selected ticket
        vm.goToTicket = (number, sys_id) => {
            switch (number.substring(0, 3)) {
                case "INC":
                    $state.go("index.status_single", {
                        statusID: sys_id
                    });
                    break;
                case "CUS":
                    $state.go("index.uchange_single", {
                        requestID: sys_id
                    });
                    break;
                case "CHG":
                    $state.go("index.uchange_single", {
                        requestID: sys_id
                    });
                    break;
                case "PRB":
                    $state.go("index.problem_single", {
                        problemID: sys_id
                    });
                    break;
                case "REQ":
                    $state.go("index.request_single", {
                        reqID: sys_id
                    });
                    break;
                default:
                    break;
            }
        };

        //main function for handling the selection of data points on highcharts.  Then filters datatable based on selection
        vm.seriesSelected = (item, type) => {
            vm.clearFilter();
            if ((vm.callType == "Audio" || vm.callType == "Video") && !vm.callAggregate) {
                vm.changeCallReport();
            }
            vm.filter = true;
            $scope.$apply();
            $document.scrollToElement(angular.element("#activity-table"), 0, 1000);
            let table = angular.element(".table").DataTable();
            var tableEM7 = angular.element("#device-EM7-table").DataTable();
            let tableEvent = angular.element("#eventTable").DataTable();
            let callAggTable = angular.element("#call-table").DataTable();
            var searchArray, pri, date;
            switch (type) {
                case "Call":
                    let callDate = moment(item).format("ddd MMM DD YYYY");
                    if (vm.callAggregate) {
                        callAggTable.column(0).search(item).draw();
                    } else {
                        table.column(3).search(callDate).draw();
                    }
                    break;
                case "CallDevice":
                    if (vm.callAggregate) {
                        callAggTable.column(0).search(item).draw();
                    } else {
                        table.column(0).search(item).draw();
                    }
                    break;
                case "Device":
                    table.column(3).search(item).draw();
                    break;
                case "totalTickets":
                    searchArray = item.split(" ");
                    pri = vm.getPriority(searchArray[0]);
                    date = searchArray.slice(1, 4);
                    date = date.join(" ");
                    if (!pri) {
                        table.column(0).search("^$", true, false).draw();
                    } else {
                        table.column(0).search(pri).draw();
                    }
                    table.column(7).search(date).draw();
                    break;
                case "responseTime":
                case "resolveTime":
                    searchArray = item.split(" ");
                    pri = vm.getPriority(searchArray[0]);
                    date = searchArray.slice(1, 4);
                    date = date.join(" ");
                    table.column(0).search(pri);
                    if (type === "resolveTime") {
                        table.column(8).search(date).draw();
                    } else if (type === "responseTime") {
                        table.column(6).search(date).draw();
                    }
                    break;
                case "contactType":
                    table.column(9).search(item).draw();
                    break;
                case "Priority":
                    table.column(0).search(vm.getPriority(item)).draw();
                    break;
                case "EM7Device":
                    tableEM7.column(1).search(item).draw();
                    break;
                case "Event":
                    searchArray = item.split(" ");
                    tableEvent.column(1).search(searchArray[0]).draw();
                    tableEvent.column(2).search(searchArray[1]).draw();
                    break;
                case "Location":
                    searchArray = item.split("#");
                    pri = vm.getPriority(searchArray[0]);
                    table.column(0).search(pri).draw();
                    table.column(3).search(searchArray[1]).draw();
                    break;
                case "sla":
                    searchArray = item.split(" ");
                    var breached;
                    if (searchArray[0] == "All") {
                        searchArray[2] == "Successful" ? (breached = "false") : (breached = "true");
                        table.column(6).search(breached).draw();
                    } else {
                        pri = vm.getPriority(searchArray[0]);
                        searchArray[1] == "Successful" ? (breached = "false") : (breached = "true");
                        table.column(0).search(pri);
                        table.column(6).search(breached).draw();
                    }

                    break;
                case "category":
                    if (item == "Customer Changes") {
                        table.column(1).search("CUS|CHG", true, false).draw();
                    } else {
                        table.column(1).search(item.substr(0, 2)).draw();
                    }
                    break;
                case "change":
                    if (item === "None") {
                        table.column(4).search("^$", true, false).draw();
                    } else {
                        table.column(4).search(item).draw();
                    }
                    break;
                case "pa":
                    searchArray = item.split("&");
                    table.column(3).search(searchArray[0]).draw();
                    table.column(1).search(searchArray[1]).draw();
                    break;
                default:
                    break;
            }
        };

        vm.getPriority = (value) => {
            var priVal;
            switch (value) {
                case "Informational":
                    priVal = "5";
                    break;
                case "Minimal":
                    priVal = "4";
                    break;
                case "Moderate":
                    priVal = "3";
                    break;
                case "High":
                    priVal = "2";
                    break;
                case "Critical":
                    priVal = "1";
                    break;
                default:
                    break;
            }
            return priVal;
        };

        // clears any filtering applied to the datatable
        vm.clearFilter = () => {
            vm.filter = false;
            if (vm.dateSelected) {
                vm.static_table = angular.copy(vm.metricDevices);
            }
            vm.dateSelected = false;
            let table = angular.element(".table").DataTable();
            table.search("").columns().search("").draw();
        };

        vm.sortDevices = (deviceArray, field) => {
            let i = deviceArray.length;
            while (i--) {
                if (deviceArray[i][field] === "") {
                    deviceArray.splice(i, 1);
                }
            }
            deviceArray.sort((a, b) => {
                if (a[field] == "") {
                    a[field] = {
                        display_value: "1-NoName"
                    };
                }
                if (b[field] == "") {
                    b[field] = {
                        display_value: "1-NoName"
                    };
                }
                if (a[field].display_value.toLowerCase() < b[field].display_value.toLowerCase()) {
                    return -1;
                }
                if (a[field].display_value.toLowerCase() > b[field].display_value.toLowerCase()) {
                    return 1;
                }
                return 0;
            });
            return deviceArray;
        };

        var parse_change_result = (results) => {
            let indexArray = Array.apply(null, Array(vm.category.length)).map(Number.prototype.valueOf, 0);
            for (var key in results) {
                let tempCategory = "";
                if (results[key].u_category) {
                    tempCategory = results[key].u_category.charAt(0).toUpperCase() + results[key].u_category.slice(1);
                } else {
                    tempCategory = "None";
                }
                indexArray[vm.category.indexOf(tempCategory)]++;
            }
            return indexArray;
        };

        var parse_location_result = (data) => {
            let categories = ["No Location"];
            for (let x = 0; x < data.length; x++) {
                if (data[x].location && data[x].location.display_value) {
                    if (categories.indexOf(data[x].location.display_value) == -1) {
                        categories.push(data[x].location.display_value);
                    }
                }
            }
            let ticketObj = [
                {
                    name: "Informational",
                    color: "#64AD61",
                    dataGrouping: {
                        enabled: false
                    },
                    data: []
                },
                {
                    name: "Minimal",
                    color: "#467E8A",
                    dataGrouping: {
                        enabled: false
                    },
                    data: []
                },
                {
                    name: "Moderate",
                    color: "#DBAC39",
                    dataGrouping: {
                        enabled: false
                    },
                    data: []
                },
                {
                    name: "High",
                    color: "#D37C0F",
                    dataGrouping: {
                        enabled: false
                    },
                    data: []
                },
                {
                    name: "Critical",
                    color: "#A51820",
                    dataGrouping: {
                        enabled: false
                    },
                    data: []
                }
            ];
            for (let y = 0; y < categories.length; y++) {
                ticketObj[0].data[y] = 0;
                ticketObj[1].data[y] = 0;
                ticketObj[2].data[y] = 0;
                ticketObj[3].data[y] = 0;
                ticketObj[4].data[y] = 0;
            }

            for (let e = 0; e < data.length; e++) {
                var location;
                if (data[e].location && data[e].location.display_value) {
                    location = data[e].location.display_value;
                } else {
                    location = "No Location";
                }
                let locationIndex = categories.indexOf(location);
                switch (data[e].priority) {
                    case "5 - Informational":
                        ticketObj[0].data[locationIndex]++;
                        break;
                    case "4 - Minimal":
                        ticketObj[1].data[locationIndex]++;
                        break;
                    case "3 - Moderate":
                        ticketObj[2].data[locationIndex]++;
                        break;
                    case "2 - High":
                        ticketObj[3].data[locationIndex]++;
                        break;
                    case "1 - Critical":
                        ticketObj[4].data[locationIndex]++;
                        break;
                }
            }
            //top 10 calculations
            let tempArray = [];
            for (let k = 0; k < ticketObj[0].data.length; k++) {
                tempArray.push([
                    ticketObj[0].data[k] +
                        ticketObj[1].data[k] +
                        ticketObj[2].data[k] +
                        ticketObj[3].data[k] +
                        ticketObj[4].data[k],
                    categories[k],
                    ticketObj[0].data[k],
                    ticketObj[1].data[k],
                    ticketObj[2].data[k],
                    ticketObj[3].data[k],
                    ticketObj[4].data[k]
                ]);
            }
            var top10 = tempArray
                .sort((a, b) => {
                    return a[0] > b[0] ? -1 : a[0] == b[0] ? 0 : 1;
                })
                .slice(0, 10);
            var top10Cat = [];
            ticketObj[0].data = [];
            ticketObj[1].data = [];
            ticketObj[2].data = [];
            ticketObj[3].data = [];
            ticketObj[4].data = [];
            for (let d = 0; d < top10.length; d++) {
                top10Cat.push(top10[d][1]);
                ticketObj[0].data.push(top10[d][2]);
                ticketObj[1].data.push(top10[d][3]);
                ticketObj[2].data.push(top10[d][4]);
                ticketObj[3].data.push(top10[d][5]);
                ticketObj[4].data.push(top10[d][6]);
            }

            return {
                values: ticketObj,
                category: top10Cat
            };
        };

        var parse_incident_result = (results) => {
            let critical = 0,
                high = 0,
                moderate = 0,
                minimal = 0,
                informational = 0;
            for (var key in results) {
                var priority;
                if (reportStorage.reportType === "mttrReport") {
                    priority = results[key].inc_priority.substring(0, 1);
                } else {
                    priority = results[key].priority.substring(0, 1);
                }
                switch (priority) {
                    case "1": // Critical
                        critical++;
                        break;
                    case "2": // High
                        high++;
                        break;
                    case "3": // Moderate
                        moderate++;
                        break;
                    case "4": // Minimal
                        minimal++;
                        break;
                    case "5": //Informational
                        informational++;
                        break;
                }
            }
            return [informational, minimal, moderate, high, critical];
        };

        var parse_service_result = (results) => {
            let serviceObj = {
                Phone: 0,
                Email: 0,
                Monitoring: 0
            };
            for (var key in results) {
                serviceObj[results[key].contact_type]++;
            }
            return [serviceObj.Phone, serviceObj.Email, serviceObj.Monitoring];
        };

        var parse_changes_by_device = (results) => {
            let category = [];
            let values = [];
            let temp = {};
            for (var key in results) {
                temp = {};
                var device;
                if (results[key].cmdb_ci == "") {
                    device = "Other";
                } else {
                    device = results[key].cmdb_ci.display_value;
                }
                if (category.indexOf(device) === -1) {
                    category.push(device);
                }
                let index = category.indexOf(device);
                if (values[index]) {
                    values[index].y++;
                } else {
                    temp.name = device;
                    temp.y = 1;
                    values.push(temp);
                }
            }
            //top 10
            let tempArray = [];
            for (let x = 0; x < values.length; x++) {
                tempArray.push([values[x].name, values[x].y]);
            }
            var top10 = tempArray
                .sort((a, b) => {
                    return a[1] < b[1] ? 1 : -1;
                })
                .slice(0, 10);
            let categoryArray = [];
            top10.forEach((item) => {
                categoryArray.push(item[0]);
            });
            return {
                category: categoryArray,
                values: top10
            };
        };

        // main handler for time method selection
        vm.toggleTime = (range) => {
            vm.timeRange = range;
            if (range === "This Month") {
                vm.dateValue = 1;
                angular.element(".thisMonth").addClass("btn-clicked");
                angular.element(".lastMonth").removeClass("btn-clicked");
                angular.element(".date-picker").removeClass("btn-clicked");
                vm.start = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-01'";
                vm.date.startDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-01'";
                vm.start = new Date(vm.start).getTime() / 1000;
                if (new Date().getMonth() === 11) {
                    vm.date.endDate = new Date().getFullYear() + 1 + "-" + 1 + "-01";
                    vm.end = new Date().getFullYear() + 1 + "-" + 1 + "-01";
                    vm.end = new Date(vm.end).getTime() / 1000;
                } else {
                    vm.date.endDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 2) + "-01";
                    vm.end = new Date().getFullYear() + "-" + (new Date().getMonth() + 2) + "-01";
                    vm.end = new Date(vm.end).getTime() / 1000;
                }
            } else if (range === "Last Month") {
                vm.dateValue = 0;
                angular.element(".lastMonth").addClass("btn-clicked");
                angular.element(".thisMonth").removeClass("btn-clicked");
                angular.element(".date-picker").removeClass("btn-clicked");
                vm.date.endDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-01";
                vm.end = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-01";
                vm.end = new Date(vm.end).getTime() / 1000;
                if (new Date().getMonth() === 0) {
                    vm.date.startDate = new Date().getFullYear() - 1 + "-" + 12 + "-01";
                    vm.start = new Date().getFullYear() - 1 + "-" + 12 + "-01";
                    vm.start = new Date(vm.start).getTime() / 1000;
                } else {
                    vm.date.startDate = new Date().getFullYear() + "-" + new Date().getMonth() + "-01";
                    vm.start = new Date().getFullYear() + "-" + new Date().getMonth() + "-01";
                    vm.start = new Date(vm.start).getTime() / 1000;
                }
            } else {
                vm.dateValue = 2;
                if (!reportStorage) {
                    $scope.$apply();
                }
                angular.element(".thisMonth").removeClass("btn-clicked");
                angular.element(".lastMonth").removeClass("btn-clicked");
                angular.element(".date-picker").addClass("btn-clicked");
                vm.start = new Date(vm.date.startDate).getTime() / 1000;
                vm.end = new Date(vm.date.endDate).getTime() / 1000;
            }
        };

        // jquery handlers for UI table resizing
        angular.element("body").on("click", "button.applyBtn", () => {
            let formatStart = new Date(vm.date.startDate);
            formatStart = formatStart.toString().substring(0, 11);
            let formatEnd = new Date(vm.date.endDate);
            formatEnd = formatEnd.toString().substring(0, 11);
            vm.toggleTime(formatStart + " - " + formatEnd);
        });

        let events = [];
        angular.element("body").on("mousedown", "div.handle", () => {
            angular.element("th").off("click.DT");
        });
        angular.element("body").on("mouseup", "div.handle", () => {
            if (angular.element(".handle").hasClass("active")) {
                $timeout(() => {
                    for (var name in events) {
                        angular.element("th").bind(name, events[name]);
                    }
                    angular.element(".nosort, .ng-isolate-scope").off("click.DT");
                }, 100);
            }
        });

        // reloaded all cookie setting of reportStates
        // necessary for tables to have a fresh reload.  a limitation of using angular version and datables serverside rendering
        vm.metricReport = false;
        let toggleReport = sessionStorage.getItem("toggleReport");
        if (toggleReport) {
            toggleReport = angular.fromJson(toggleReport);
            vm.toggleConfig = toggleReport.toggleConfig;
        } else {
            vm.toggleConfig = {
                devCategoryShow: true,
                dateRangeShow: true,
                customTicketShow: true,
                standardTicketShow: true,
                customDeviceShow: true,
                selectedReportsShow: true,
                emailReportsShow: true,
                scheduleReportsShow: true,
                dateSummaryShow: true,
                summaryShow: true,
                qbrShow: true
            };
        }
        let reportStorage = sessionStorage.getItem("reportData");
        if (reportStorage) {
            reportStorage = angular.fromJson(reportStorage);
            vm.chosenTicketType = reportStorage.ticketType;
            vm.selected_standard = reportStorage.selected_standard;
            vm.devCategory = reportStorage.devCategory;
            vm.ticketDeviceCategory = reportStorage.ciClass;
            if (vm.chosenTicketType === "Change") {
                vm.ticketCategories = ["Category"];
                vm.chosenTicketCategory = vm.ticketCategories[0];
            } else if (vm.chosenTicketType === "Request") {
                vm.ticketCategories = ["Priority"];
                vm.chosenTicketCategory = vm.ticketCategories[0];
            } else {
                vm.ticketCategories = ["Device", "Priority", "Location"];
                vm.chosenTicketCategory = reportStorage.ticketCat;
            }
            vm.tabView = reportStorage.tabView;
            vm.deviceCIClass = reportStorage.deviceCIClass;
            vm.metricType = reportStorage.metricType;
            vm.hourlyFilter = reportStorage.hourlyFilter;
            vm.weekdayFilter = reportStorage.weekdayFilter;
            vm.trendline = reportStorage.trendline;
            vm.forecast = reportStorage.forecast;
            vm.dateValue = reportStorage.dateType;
            vm.metricReport = reportStorage.metricReport;
            let getRange = reportStorage.range;
            vm.toggleTime(getRange);
            vm.date = reportStorage.chosenDate;
            reportStorage.devType
                ? (vm.chosenDeviceType = reportStorage.devType)
                : (vm.chosenDeviceType = vm.deviceTypes[0]);
            // reportStorage.devCat ? vm.chosenDeviceCategory = reportStorage.devCat : vm.chosenDeviceCategory = vm.deviceCategories[0];
            reportStorage.devDir
                ? (vm.chosenDeviceDirection = reportStorage.devDir)
                : (vm.chosenDeviceDirection = vm.deviceDirections[0].id);
            if (reportStorage.customType) {
                vm[reportStorage.reportType](reportStorage.customType);
            } else {
                if (vm.metricReport) {
                    $scope.$watch("vm.metricDevices", (newValue, oldValue) => {
                        if (newValue !== oldValue) {
                            vm.cycleDevices(vm.metricReport[0], vm.metricReport[1], vm.metricReport[2]);
                        }
                    });
                } else {
                    vm[reportStorage.reportType]();
                }
            }
        } else {
            vm.standardReport();
        }
    }
})();

(function () {
    angular.module("burWood").factory("Problem", Problem);

    function Problem($http, $log, $q, ServiceNow) {
        return {
            getProblem: (state, callback, page_limit, offset, company) => {
                var query_obj = {
                    type: "problem",
                    company_sys: company
                };
                ServiceNow.getTable(state, "problem|ticketsList", callback, page_limit, offset, query_obj);
            },
            getSingle: (probId, callback) => {
                ServiceNow.getItem(probId, "problem|ticketsList", callback);
            },
            createProblem: (problem, callback) => {
                ServiceNow.createItem("problem", problem, callback);
            },
            deleteProblem: (probId, callback) => {
                ServiceNow.deleteItem("problem", probId, callback);
            },
            updateProblem: (probId, problem, callback) => {
                ServiceNow.updateItem("problem", probId, problem, callback);
            }
        };
    }
})();

(function () {
    angular.module("burWood").controller("ProblemController", ProblemController).filter("RemoveEmail", RemoveEmail);

    function RemoveEmail() {
        return (user) => {
            if (user) {
                let emailRemoved = user.replace(/\s*\(.*?\)\s*/g, "");
                return emailRemoved;
            }
        };
    }

    /** @ngInject */
    function ProblemController(
        _,
        $log,
        user_info,
        $stateParams,
        $uibModal,
        $state,
        Problem,
        FileSaver,
        Service,
        Status,
        DTOptionsBuilder,
        DTColumnDefBuilder,
        $window,
        BCSServer,
        ServiceNow,
        Blob,
        util,
        Alerts,
        $timeout
    ) {
        let vm = this;

        let offset = 0,
            page = 10;

        vm.loading = true;

        vm.priorities = {
            1: "Critical",
            2: "High",
            3: "Moderate",
            4: "Minimal",
            5: "Informational"
        };

        vm.stateNames = {
            1: "New",
            "-5": "Under Investigation",
            3: "Pending Change",
            2: "Known Error"
        };

        vm.action = "";
        vm.watch_lists = [];
        vm.watch_list_users = [];
        vm.watch_list_show = false;
        vm.related_show = false;
        vm.customTitle = "Problem Tickets";
        vm.sortStart = $stateParams.sort;
        vm.sortType = $stateParams.type;
        vm.sortState = $stateParams.state;

        vm.alerts = [];

        vm.createAlertMessage = (alert) => {
            vm.alerts.push({
                status: alert.status,
                msg: alert.msg
            });

            Alerts.storeAlert({
                type: alert.status,
                message: alert.msg,
                user: user_info.email,
                company: user_info.company_name,
                location: $state.current.name,
                tags: ["Problem"]
            });

            if (alert.status === "success") {
                $timeout(() => {
                    vm.alerts = [];
                }, 5000);
            }
        };

        vm.formatTable = (data, row, column) => {
            var pri;
            if (column === 1) {
                if (data.indexOf("5 - Informational") != -1) {
                    pri = "5 - Informational";
                } else if (data.indexOf("4 - Minimal") != -1) {
                    pri = "4 - Minimal";
                } else if (data.indexOf("3 - Moderate") != -1) {
                    pri = "3 - Moderate";
                } else if (data.indexOf("2 - High") != -1) {
                    pri = "2 - High";
                } else if (data.indexOf("1 - Critical") != -1) {
                    pri = "1 - Critical";
                }
                return pri;
            } else if (column === 2 || column === 3) {
                var start_pos = data.indexOf(">") + 1;
                var end_pos = data.indexOf("<", start_pos);
                var text_to_get = data.substring(start_pos, end_pos);
                return text_to_get;
            }
            return data;
        };

        let columnFilter = {
            aoColumns: [
                null,
                null,
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                }
            ]
        };
        vm.showResolved = true;
        let buttonConfig = [
            {
                text: "Exclude Resolved",
                key: "1",
                action: (e, dt, node) => {
                    vm.showResolved = !vm.showResolved;
                    let table = angular.element("#problemTable").DataTable();
                    if (vm.showResolved) {
                        node[0].innerText = "Exclude Resolved";
                        table.columns(7).search("").draw();
                    } else {
                        node[0].innerText = "Include Resolved";
                        table.column(7).search("Open|Pending Change|Known Error", true, false).draw();
                    }
                }
            },
            {
                extend: "colvis",
                text: "Toggle Columns"
            },
            {
                text: "Search Closed Tickets",
                key: "2",
                action: () => {
                    angular.element("#global_search").triggerHandler("click");
                }
            },
            {
                extend: "collection",
                text: "Export",
                buttons: [
                    {
                        extend: "excel",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.formatTable(data, row, column, node);
                                }
                            }
                        }
                    },
                    {
                        extend: "pdf",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        customize: (doc) => {
                            doc.pageMargins = [5, 5, 5, 5];
                            doc.styles.tableHeader.fontSize = 10;
                            doc.defaultStyle.fontSize = 6;
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.formatTable(data, row, column, node);
                                }
                            }
                        }
                    },
                    {
                        extend: "csv",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.formatTable(data, row, column, node);
                                }
                            }
                        }
                    }
                ]
            }
        ];

        if (vm.sortStart && vm.sortType === "Problem") {
            buttonConfig.unshift({
                text: "Show All Problems",
                key: "1",
                action: (e, dt, node) => {
                    let table = angular.element("#problemTable").DataTable();
                    table.search("").columns().search("").draw();
                    angular.element(node[0]).addClass("hidden");
                }
            });
        }

        let activityFilter = columnFilter;
        delete activityFilter.aoColumns.shift();

        vm.dtActivityOptions = DTOptionsBuilder.newOptions()
            .withOption("order", [["4", "des"]])
            .withColumnFilter(activityFilter)
            .withOption("responsive", true);
        vm.dtColumnDefsActivity = [
            DTColumnDefBuilder.newColumnDef(4).withOption("type", "date"),
            DTColumnDefBuilder.newColumnDef([3]).withClass("max-size-activity"),
            DTColumnDefBuilder.newColumnDef([1, 2, 4]).withClass("vert-align-activity")
        ];

        if (vm.sortStart && vm.sortType === "Problem") {
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('lfB<".table-scroll"rt>ip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withColumnFilter(columnFilter)
                .withButtons(buttonConfig)
                .withOption("responsive", true)
                .withOption("iDisplayLength", 10)
                .withOption("order", [["8", "des"]])
                .withOption("initComplete", () => {
                    let table = angular.element("#problemTable").DataTable();
                    if (vm.sortState === "Resolved") {
                        table.column(7).search(vm.sortState).draw();
                    } else if (vm.sortState === "Active") {
                        table.column(7).search("Open|Pending Change|Known Error", true, false).draw();
                    }
                    table.column(1).search(vm.sortStart).draw();
                });
            vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef([8, 9]).withOption("type", "date")];
        } else {
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('lfB<".table-scroll"rt>ip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withColumnFilter(columnFilter)
                .withOption("order", [["8", "des"]])
                .withButtons(buttonConfig)
                .withOption("iDisplayLength", 10)
                .withOption("responsive", true);
            vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef([8, 9]).withOption("type", "date")];
        }

        vm.extractDisplayValue = (object, field) => {
            if (object[field]) {
                vm[field] = vm.extractSysID(object[field].link);
                return object[field].display_value;
            } else {
                return new String("");
            }
        };

        vm.extractSysID = (value) => {
            let stringSplit = value.split("/");
            var sys_id = stringSplit[stringSplit.length - 1];
            return sys_id;
        };

        vm.loadStatus = () => {
            let problemId = $stateParams.problemID;
            Problem.getSingle(problemId, (data) => {
                vm.loading = false;
                if (data.error) {
                    vm.problem = [];
                } else {
                    vm.problem = data.results;
                    vm.problem.comments = null;
                    vm.related_show = false;
                    vm.show_related();
                    var watch_lists_arr = vm.problem.watch_list;
                    let displayFields = ["assigned_to", "assignment_group", "cmdb_ci", "opened_by"];
                    displayFields.forEach((field) => {
                        vm.problem[field] = vm.extractDisplayValue(vm.problem, field);
                    });
                    vm.watch_lists = [];
                    if (
                        watch_lists_arr != undefined &&
                        watch_lists_arr != null &&
                        watch_lists_arr != "" &&
                        watch_lists_arr != " "
                    ) {
                        vm.watch_lists = watch_lists_arr.split(",");
                    }
                    for (var key in vm.watch_lists) {
                        var user_id = vm.watch_lists[key];
                        if (user_id.indexOf("@") == -1) {
                            Status.getUser(user_id, (data) => {
                                var item;
                                if (data.results) {
                                    item = {
                                        sys_id: data.results.sys_id,
                                        name: data.results.name
                                    };
                                    let found = vm.watch_list_users.some((el) => {
                                        return el.name === data.results.name;
                                    });
                                    if (!found) {
                                        vm.watch_list_users.push(item);
                                    }
                                } else {
                                    if (user_id != null && user_id != "") {
                                        item = {
                                            sys_id: user_id,
                                            name: user_id
                                        };
                                        var found2 = vm.watch_list_users.some((el) => {
                                            return el.name === user_id;
                                        });
                                        if (!found2) {
                                            vm.watch_list_users.push(item);
                                        }
                                    }
                                }
                            });
                        } else {
                            vm.watch_list_users.push({
                                name: user_id,
                                sys_id: ""
                            });
                        }
                    }
                }
            });
        };

        var exceptions;

        Service.getExceptions((data) => {
            if (data.results) {
                exceptions = data.results;
            }
        }, user_info.company);

        vm.goToDevice = (device) => {
            let except = false;
            for (let x = 0; x < exceptions.length; x++) {
                if (device.toLowerCase() === exceptions[x].name.toLowerCase()) {
                    except = true;
                }
            }
            if (except) {
                $state.go("index.devices", { redirectedDevice: device, exception: true });
            } else {
                $state.go("index.devices", { redirectedDevice: device });
            }
        };

        vm.goToTicket = (sys_id) => {
            $state.go("index.problem_single", {
                problemID: sys_id
            });
        };

        //toggle minimizing of sections
        vm.minimizeSection = () => {
            vm.toggleConfig = !vm.toggleConfig;
            vm.toggleDatabase("post");
        };

        // controls handling and setting of pin setting in mogdb database
        vm.toggleDatabase = (type) => {
            BCSServer.postData(
                {
                    method: type,
                    user: user_info.email,
                    toggle: vm.toggleConfig
                },
                "/knownerror_toggle",
                (response) => {
                    if (type === "get") {
                        if (response.length === 0) {
                            //if user widget list doesnt exist in database - need to use predefined one
                            vm.toggleDatabase("post");
                        } else {
                            vm.toggleConfig = response[0].toggle;
                        }
                    }
                }
            );
        };

        vm.toggleDatabase("get");

        vm.dtInstance = {};
        vm.dtInstance2 = {};
        vm.showFilters = false;

        vm.create = (problem, $valid) => {
            vm.loading = true;
            if (vm.caller_id) {
                problem.caller_id = vm.caller_id;
            }
            if (vm.device_id) {
                problem.cmdb_ci = vm.device_id;
            }
            if ($valid) {
                Problem.createProblem(problem, (data) => {
                    vm.loading = false;
                    if (data.error) {
                        vm.problem = [];
                        vm.createAlertMessage({
                            msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                                data.error.detail ? data.error.detail : ""
                            }`,
                            status: "fail"
                        });
                    } else if (data.result) {
                        var new_sys_id = data.result.sys_id;
                        $state.go("index.problem_single", {
                            problemID: new_sys_id
                        });
                    } else {
                        vm.createAlertMessage({
                            msg: "Failed to update ticket",
                            status: "fail"
                        });
                    }
                });
            } else {
                vm.createAlertMessage({
                    msg: "Invalid form",
                    status: "fail"
                });
            }
        };
        vm.update = (devId, problem) => {
            vm.loading = true;
            vm.alerts = [];
            var new_prob = {};
            var watch_list_arr = [];
            var temp_watch_list = Object.assign({}, vm.watch_list_users);
            for (var key in temp_watch_list) {
                watch_list_arr.push(temp_watch_list[key].sys_id);
            }
            var request_watch_list = watch_list_arr.join(",");
            new_prob.watch_list = request_watch_list;
            new_prob.caller_id = problem.caller_id;
            new_prob.short_description = problem.short_description;
            new_prob.comments = problem.comments;

            Problem.updateProblem(devId, new_prob, (data) => {
                vm.loading = false;
                if (data.error) {
                    vm.createAlertMessage({
                        msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                            data.error.detail ? data.error.detail : ""
                        }`,
                        status: "fail"
                    });
                } else if (data.result) {
                    vm.createAlertMessage({
                        msg: "Ticket successfully updated.",
                        status: "success"
                    });
                    vm.problem.comments = "";
                    // loadStatus();
                    vm.show_related(true);
                } else {
                    vm.createAlertMessage({
                        msg: "Failed to update ticket",
                        status: "fail"
                    });
                }
            });
        };

        vm.delete = (stateId) => {
            Problem.deleteProblem(stateId, (data) => {
                if (data.error) {
                    vm.createAlertMessage({
                        msg: `Failed: ${data.error.message ? data.error.message : ""} ${
                            data.error.detail ? data.error.detail : ""
                        }`,
                        status: "fail"
                    });
                } else {
                    vm.createAlertMessage({
                        msg: `Successfully deleted`,
                        status: "success"
                    });
                }
            });
        };

        vm.switch_watchlist = () => {
            vm.watch_list_show = !vm.watch_list_show;
        };

        vm.findToRemoveById = (user_id) => {
            for (let i = 0; i < vm.watch_list_users.length; i++) {
                let user = vm.watch_list_users[i];
                if (user["sys_id"] == user_id) {
                    vm.watch_list_users.splice(i, 1);
                    return user_id;
                }
            }
        };

        vm.delete_watchlist = () => {
            angular.element(".watch-list-select option:selected").remove();
            if (vm.watch_list_selected != null) {
                angular.forEach(vm.watch_list_selected, (user_id) => {
                    vm.findToRemoveById(user_id);
                });
            }
        };

        vm.addEmail_watchlist = (user_email) => {
            if (user_email == null || user_email == "") {
                return;
            }
            let user = {
                sys_id: user_email,
                name: user_email
            };
            vm.add_watchlist(user);
        };
        vm.add_watchlist = (watch_list) => {
            if (vm.watch_list_users.length > 0) {
                vm.watch_list_users.push(watch_list);
            } else {
                vm.watch_list_users = [watch_list];
            }
            vm.watch_list_email = null;
            //       getUserWatchLists();
        };
        vm.go_back = () => {
            $window.history.back();
        };
        vm.page_changed = () => {
            vm.offset = parseInt(vm.current_page - 1) * page;
            $state.go("index.problems", {
                offset: vm.offset
            });
        };
        vm.close_notice = (index) => {
            vm.alerts.splice(index, 1);
        };

        vm.contact = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ContactController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                if (data) {
                    vm.caller_name = data.name;
                    vm.caller_id = data.caller_id;
                }
            });
        };

        vm.device = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/device_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "DeviceListController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                vm.device_name = data.name;
                vm.device_id = data.device_id;
            });
        };

        vm.watch_list = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ContactController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                if (data) {
                    var insert_data = {
                        sys_id: data.caller_id,
                        name: data.name
                    };
                    vm.watch_list_users.push(insert_data);
                }
            });
        };

        vm.show_related = (update) => {
            if (vm.related_show == true && !update) {
                vm.related_show = false;
                return;
            }
            let problemId = $stateParams.problemID;
            vm.related_show = true;
            vm.related_loading = true;
            vm.getJournalEntries(problemId);
        };

        vm.getJournalEntries = (statusID) => {
            Status.getJournal(
                statusID,
                (data) => {
                    if (data.error) {
                        vm.related_loading = false;
                        $log.info(data.error);
                    } else {
                        vm.related_result = [];
                        let journals = data.results;
                        if (journals) {
                            journals.forEach((journal) => {
                                if (journal.element === "comments" || journal.element === "status") {
                                    if (journal.element.indexOf("_") != -1) {
                                        journal.element = journal.element.replace("_", " ");
                                        journal.element = util.capitalizeFirstLetter(journal.element);
                                    } else {
                                        journal.element = util.capitalizeFirstLetter(journal.element);
                                    }
                                    let addHistory = {
                                        sortDate: journal.sys_created_on.toString(),
                                        sys_created_on: journal.sys_created_on.toString(),
                                        value: journal.value,
                                        sys_created_by: journal.sys_created_by,
                                        element: journal.element
                                    };
                                    vm.related_result.push(addHistory);
                                }
                            });
                        }
                        vm.getHistoryLine(statusID);
                    }
                },
                300,
                0
            );
        };

        vm.getHistoryLine = (statusID) => {
            Status.getHistory(
                statusID,
                (data) => {
                    if (data.error) {
                        vm.related_loading = false;
                        $log.info(data.error);
                    } else {
                        let noDuplicate = [];
                        let histories = data.results;
                        if (histories) {
                            histories.forEach((history) => {
                                if (history.field === "state") {
                                    let addActivity = {
                                        sortDate: history.update_time,
                                        sys_created_on: history.update_time,
                                        value: history.new,
                                        sys_created_by: history.u_name_id,
                                        element: history.label
                                    };
                                    if (noDuplicate.indexOf(history.new) == -1) {
                                        noDuplicate.push(history.new);
                                        vm.related_result.push(addActivity);
                                    }
                                }
                            });
                        }
                        vm.getFieldChanges(statusID);
                    }
                },
                300,
                0
            );
        };

        vm.getFieldChanges = (statusID) => {
            Service.getQuery(
                {
                    tablename: "problem",
                    fieldname: "priority",
                    documentkey: statusID
                },
                "sys_audit",
                (auditResponse) => {
                    if (auditResponse.error) {
                        vm.related_loading = false;
                        $log.info(auditResponse.error);
                    } else {
                        let audits = auditResponse.results;
                        if (audits) {
                            audits.forEach((audit) => {
                                let addActivity = {
                                    sortDate: audit.sys_created_on,
                                    sys_created_on: audit.sys_created_on,
                                    value: vm.priorities[audit.newvalue],
                                    sys_created_by: audit.sys_created_by,
                                    element: util.capitalizeFirstLetter(audit.fieldname)
                                };
                                vm.related_result.push(addActivity);
                            });
                        }
                    }
                    vm.getAttachedFiles(statusID);
                }
            );
        };

        let attachmentLength = 0;
        let attachmentIndex = 0;

        vm.getAttachedFiles = (statusID) => {
            ServiceNow.getAllAttachment(statusID, "problem", 10, 10, (data) => {
                if (data && data.result && data.result.length > 0) {
                    let attachments = data.result;
                    attachmentLength = data.result.length;
                    attachments.forEach((attachment) => {
                        vm.getSingleFileData(attachment);
                    });
                } else {
                    vm.related_result.sort((a, b) => {
                        return new Date(a.sortDate) - new Date(b.sortdate);
                    });
                    vm.related_loading = false;
                }
            });
        };

        vm.nonImageAttachments = {};

        vm.nonImageAttachments = {};

        vm.getSingleFileData = (attachment) => {
            ServiceNow.getAttachment(attachment.sys_id, (data) => {
                if (data) {
                    let blobData = new Blob([data], {
                        type: attachment.content_type
                    });

                    let activityItem = {
                        sortDate: attachment.sys_created_on,
                        sys_created_on: attachment.sys_created_on,
                        dataURL: "",
                        sys_created_by: attachment.sys_created_by,
                        element: "Attachment"
                    };

                    if (attachment && attachment.content_type.includes("image")) {
                        activityItem.dataURL = URL.createObjectURL(blobData);
                        activityItem.image = true;
                    } else {
                        vm.nonImageAttachments[attachment.file_name] = blobData;
                        activityItem.dataURL = attachment.file_name;
                        activityItem.image = false;
                    }

                    vm.related_result.push(activityItem);
                }
                attachmentIndex++;
                if (attachmentLength === attachmentIndex) {
                    vm.related_result.sort((a, b) => {
                        return new Date(a.sortDate) - new Date(b.sortdate);
                    });
                    attachmentLength = 0;
                    attachmentIndex = 0;
                    vm.related_loading = false;
                }
            });
        };

        vm.downloadFromActivity = (file) => {
            let blobData = vm.nonImageAttachments[file];
            FileSaver.saveAs(blobData, file);
        };

        vm.downloadFromActivity = (file) => {
            let blobData = vm.nonImageAttachments[file];
            FileSaver.saveAs(blobData, file);
        };

        vm.show_related_detail = (sys_id, key) => {
            vm.detail_loading[key] = true;
            Problem.getSingle(sys_id, (data) => {
                vm.detail_loading[key] = false;
                if (data.error) {
                    vm.related_detail[key] = [];
                } else {
                    vm.related_detail[key] = data.results;
                }
            });
        };

        vm.related_filter = (item) => {
            return (
                item.label == "Priority" ||
                item.label == "Short description" ||
                item.label == "Status" ||
                item.label == "Additional comments"
            );
        };

        vm.attachment = () => {
            let modalInst = $uibModal.open({
                resolve: {
                    list: () => {
                        return [];
                    },
                    params: () => {
                        return {
                            table: "problem",
                            newTable: "problem_new",
                            fieldID: "problemID"
                        };
                    }
                },
                templateUrl: "app/shared/html/attachment_form.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "AttachmentController",
                controllerAs: "vm"
            });
            modalInst.result.then(
                (data) => {
                    vm.caller_name = data.name;
                    vm.caller_id = data.caller_id;
                    vm.related_show = false;
                    vm.show_related(true);
                },
                () => {
                    vm.related_show = false;
                    vm.show_related(true);
                }
            );
        };

        var state_name = $state.current.name;
        switch (state_name) {
            case "index.problem_new":
                vm.loading = false;
                break;
            case "index.problem_single":
                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withDOM('lfB<".table-scroll"rt>ip')
                    .withOption("aoColumnDefs", [
                        {
                            bSortable: false,
                            aTargets: ["nosort"]
                        }
                    ])
                    .withButtons(buttonConfig)
                    .withColumnFilter(columnFilter)
                    .withOption("order", [["4", "des"]])
                    .withOption("iDisplayLength", 10)
                    .withOption("responsive", true);
                vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef(8).withOption("type", "date")];
                vm.loading = true;
                if ($stateParams.problemID != undefined) {
                    vm.loadStatus();
                } else {
                    $state.go("index.problems");
                }
                break;
            case "index.problems":
                vm.loading = true;
                Problem.getProblem(
                    "",
                    (data) => {
                        vm.loading = false;
                        vm.problems = [];
                        if (data.error || !data.results) {
                            $log.info(data.error);
                        } else {
                            let x = data.results.length;
                            vm.problems = [];
                            vm.knownProblems = [];
                            while (x--) {
                                if (data.results[x].state == "Known Error") {
                                    vm.knownProblems.push(data.results[x]);
                                } else {
                                    vm.problems.push(data.results[x]);
                                }
                            }
                            // vm.problems = data.results;
                        }
                    },
                    5000,
                    offset
                );
                break;
        }
    }
})();

(function () {
    angular.module("burWood").controller("WidgetController", WidgetController);

    /** @ngInject */
    function WidgetController($uibModalInstance, list) {
        let vm = this;
        vm.loading = true;

        vm.dualListOptions = {
            title: "Widgets",
            filterPlaceHolder: "Start typing to filter the lists below.",
            labelAll: "All Items",
            labelSelected: "Selected Items",
            helpMessage: " Click items to transfer them between fields.",
            /* angular will use this to filter your lists */
            orderProperty: "name",
            /* this contains the initial list of all items (i.e. the left side) */
            items: list.unselected,
            /* this list should be initialized as empty or with any pre-selected items */
            selectedItems: list.selected
        };

        vm.close = () => {
            $uibModalInstance.close(vm.dualListOptions.selectedItems);
        };
    }
})();

(function() {
	'use strict';

	angular
		.module('burWood')
		.factory('Home', Home);

	/** @ngInject */
	function Home() {
		return {

		}
	}
})();

(function () {
    "use strict";

    angular.module("burWood").controller("MainController", MainController);

    /** @ngInject */
    function MainController(
        _,
        user_info,
        $log,
        ScienceLogicGQL,
        Ticket,
        Service,
        BCSServer,
        DTColumnDefBuilder,
        $window,
        $timeout,
        $interval,
        $uibModal,
        $scope,
        $state,
        DTOptionsBuilder,
        moment
    ) {

        let vm = this;
        vm.loading = true;


        
        // checks user's broswer for scroll compatibility
        let isChrome = $window.chrome;
        if (isChrome) {
            angular.element(".feed-container").addClass("webkit-scroll");
        } else {
            angular.element(".feed-container").addClass("no-webkit-scroll");
        }

        vm.severityWord = {
            0: "Healthy",
            1: "Notice",
            2: "Minor",
            3: "Major",
            4: "Critical"
        };

        vm.severity = {
            0: "5",
            1: "4",
            2: "3",
            3: "2",
            4: "1"
        };

        // sets up initial table configurations
        vm.dtInstance = {};
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption("bPaginate", false)
            .withOption("bFilter", false)
            .withOption("bInfo", false)
            .withOption("deferRender", true)
            .withOption("responsive", true);
        vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef(2).withOption("type", "date")];

        // General initial configuration for all highcharts reports in dashboards
        let width = angular.element(".dash-temp").width() - 80;
        vm.configTicket =
            vm.configResolvedTicket =
            vm.configEvent =
            vm.configTopEvent =
            vm.memoryConfig =
            vm.availabilityConfig =
            vm.CPUConfig =
            vm.utilInConfig =
            vm.utilOutConfig =
            vm.configRequest =
            vm.configTicDevice =
                {
                    chart: {
                        type: "column",
                        zoomType: "x",
                        height: 220,
                        width: width
                    },
                    boost: {
                        useGPUTranslations: true
                    },
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    yAxis: {
                        min: 0
                    },
                    legend: {
                        enabled: false
                    }
                };
        vm.configHealth = {
            chart: {
                zoomType: "x",
                height: 180,
                width: width
            },
            boost: {
                useGPUTranslations: true
            },
            exporting: {
                enabled: false
            },
            title: {
                text: null
            },
            yAxis: {
                min: 0
            },
            legend: {
                enabled: false
            }
        };

        var n;
        if (user_info.sl_org) {
            n = user_info.sl_org.lastIndexOf("/");
            vm.em7Org = user_info.sl_org.substring(n + 1);
        }

        // if user is Western Digital, phone number changes for operations
        vm.operations;
        if (user_info.company === "019ea6a91352d6002d503262f244b090") {
            vm.operations = "408-717-6611";
        } else {
            vm.operations = "312-592-8387";
        }

        $log.info(user_info);
        vm.showSLDashboard = false;
        // Bad client specific bandaid
        if(user_info.company_code === "CIBC") {
            vm.showSLDashboard = true;
        } 


        $timeout(() => {
            //resize charts to be responsive
            angular.element(window).resize(() => {
                angular.element(".highcharts").each(function () {
                    let chart = angular.element(this).highcharts();
                    let w = angular.element(this).closest(".dashboard-panel").width();
                    chart.setSize(w * 0.9, 220, false);
                });
            });
        }, 1000);

        vm.contract = {};
        vm.item = {
            application: 0,
            citrix: 0,
            network: 0,
            server: 0,
            storage: 0,
            telepresence: 0,
            uc: 0,
            ucs: 0
        };

        // gets all news data that for left home panel
        BCSServer.getData("/news", (response) => {
            if (response) {
                vm.newsObj = {
                    titleArray: response.titleArray,
                    dateArray: response.dateArray,
                    linkArray: response.linkArray,
                    imgArray: response.imgArray
                };
            }
            angular.element("hr").css("opacity", "1");
            vm.newsLoaded = true;
        });

        // gets all twitter data that for left home panel
        BCSServer.getData("/twitter", (response) => {
            if (response) {
                vm.twitterObj = {
                    textArray: response.textArray,
                    linkArray: response.linkArray
                };
            }
            vm.tweetLoaded = true;
        });

        vm.tweetRender = () => {
            vm.tweetsRendered = true;
        };

        vm.eventData = {
            notice: 0,
            minor: 0,
            major: 0,
            critical: 0
        };

        vm.health = {
            ticketScore: 0,
            eventScore: 0,
            ticketPercent: 0,
            eventPercent: 0,
            total: 0
        };

        let ticketObj = [
            {
                name: "Problem",
                data: [0, 0, 0, 0]
            },
            {
                name: "Incident",
                data: [0, 0, 0, 0]
            }
        ];

        let requestObj = [
            {
                name: "Request",
                colorByPoint: true,
                data: [0, 0, 0, 0]
            }
        ];

        let ticketObjResolved = [
            {
                name: "Problem",
                data: [0, 0, 0, 0]
            },
            {
                name: "Incident",
                data: [0, 0, 0, 0]
            }
        ];

        // widget constructor
        function Widget(header, name, value, count) {
            this.header = header;
            this.name = name;
            this.value = value;
            this.count = count;
        }

        //setting up widgets for right panel of home page
        let highestDevice = new Widget("Top Event Generator");
        let ticketsWaiting = new Widget("Tickets set to Waiting for Customer", "", 0);
        let oldestTicket = new Widget("Oldest Open Ticket", "", 0, 0);
        var tier1Tickets = new Widget("Currently Open Tickets for Tier 1", "", 0);
        var tier2Tickets = new Widget("Currently Open Tickets for Tier 2", "", 0);

        vm.widgetTicketPushed = false;
        vm.widgetEventPushed = false;

        let averageTicketAge = {
            header: "Average Age of Tickets",
            name: "",
            count: 0,
            total: 0,
            days: 0,
            hours: 0,
            minutes: 0
        };

        // gets single month day year for calendar
        vm.getDayMonthYear = (date) => {
            let day = moment(date).format("D");
            let month = moment(date).format("M");
            let year = moment(date).format("YYYY");
            return [year, month, day];
        };

        vm.parseDate = (date, number, sys_id) => {
            let today = new Date();
            let opened = new Date(date);
            let diffMs = today - opened;
            averageTicketAge.count++;
            averageTicketAge.total += diffMs;
            if (oldestTicket.count < diffMs) {
                oldestTicket.count = diffMs;
                oldestTicket.name = number;
                oldestTicket.sys_id = sys_id;
            }
        };

        vm.averageDate = () => {
            let avg = averageTicketAge.total / averageTicketAge.count;
            averageTicketAge.value =
                Math.floor(avg / 86400000) +
                " Days, " +
                Math.floor(avg / 86400000 / 3600000) +
                " Hours, " +
                Math.floor(((avg / 86400000) % 3600000) / 60000) +
                " Minutes";
        };

        vm.oldestTicketCalc = () => {
            oldestTicket.value =
                Math.floor(oldestTicket.count / 86400000) +
                " Days, " +
                Math.floor(oldestTicket.count / 86400000 / 3600000) +
                " Hours, " +
                Math.floor(((oldestTicket.count / 86400000) % 3600000) / 60000) +
                " Minutes";
            switch (oldestTicket.name.substring(0, 3)) {
                case "INC":
                    oldestTicket.href = $window.location.origin + "/incident/" + oldestTicket.sys_id;
                    break;
                case "PRB":
                    oldestTicket.href = $window.location.origin + "/problem/" + oldestTicket.sys_id;
                    break;
                case "CUS":
                    oldestTicket.href = $window.location.origin + "/u_customer_changes/" + oldestTicket.sys_id;
                    break;
                case "CHG":
                    oldestTicket.href = $window.location.origin + "/u_customer_changes/" + oldestTicket.sys_id;
                    break;
                case "REQ":
                    oldestTicket.href = $window.location.origin + "/requests/" + oldestTicket.sys_id;
                    break;
                default:
                    break;
            }
        };

        // pushes all widgets into the the final panel array
        vm.pushTicketWidgets = () => {
            widgetArray.push(averageTicketAge);
            widgetArray.push(oldestTicket);
            widgetArray.push(ticketsWaiting);
            widgetArray.push(tier1Tickets);
            widgetArray.push(tier2Tickets);
            vm.widgetTicketPushed = true;
        };

        // gets any tickets that are awaiting your approval
        vm.approvalLoading = true;
        Service.getQuery(
            {
                approver: user_info.sys_id,
                approvalState: "requested"
            },
            "sysapproval_approver",
            (response) => {
                vm.change_approvals = [];
                if (response && response.results) {
                    for (let z = 0; z < response.results.length; z++) {
                        if (
                            response.results[z]["document_id.state"] != "Closed" &&
                            response.results[z]["document_id.state"] != "Canceled"
                        ) {
                            vm.change_approvals.push(response.results[z]);
                        }
                    }
                }
                vm.approvalLoading = false;
            }
        );

        function buildCalendar(requests) {
            vm.requests = requests;
            vm.calendarLoading = true;
            // vm.timeline = $scope.timeline;
            //calendar options
            vm.options = {
                start_at_end: true,
                // start_at_slide
                timenav_position: "top",
                scale_factor: 30.0,
                language: "en",
                duration: 500,
                height: 250
            };
            vm.states = ["All", "Draft", "Assess", "Authorize", "Scheduled", "Implement", "Review"];
            vm.chosenState = vm.states[0];
            // initial calendar pane
            let data = {
                title: {
                    media: {
                        // 'url': '../assets/img/white_logo.png',
                        caption: "Smarter Solutions, Better Outcomes."
                    },
                    text: {
                        headline: "Change Request Calendar",
                        text: "<p>View and navigate through the history of change requests</p>"
                    }
                },
                events: []
            };
            if (vm.requests && vm.requests.length != 0) {
                vm.requests.reverse();
                //looping through changes, setting up calendar panes
                for (let x = 0; x < vm.requests.length; x++) {
                    var openedDate, requestedDate, endDate, startDate, actual_start, actual_end;
                    var availDateVar, displayDateVar;
                    if (vm.requests[x].start_date) {
                        startDate = vm.getDayMonthYear(vm.requests[x].start_date);
                        availDateVar = "start_date";
                        displayDateVar = "Start Date";
                    } else if (vm.requests[x].requested_by_date) {
                        requestedDate = vm.getDayMonthYear(vm.requests[x].requested_by_date);
                        availDateVar = "requested_by_date";
                        displayDateVar = "Requested By Date";
                    } else if (vm.requests[x].end_date) {
                        endDate = vm.getDayMonthYear(vm.requests[x].end_date);
                        availDateVar = "end_date";
                        displayDateVar = "End Date";
                    } else if (vm.requests[x].work_start) {
                        actual_start = vm.getDayMonthYear(vm.requests[x].work_start);
                        availDateVar = "actual_start";
                        displayDateVar = "Actual Start Date";
                    } else if (vm.requests[x].work_end) {
                        actual_end = vm.getDayMonthYear(vm.requests[x].work_end);
                        availDateVar = "actual_end";
                        displayDateVar = "Actual End Date";
                    } else {
                        openedDate = vm.getDayMonthYear(vm.requests[x].opened_at);
                        availDateVar = "opened_at";
                        displayDateVar = "Opened At";
                    }
                    let changeDate = startDate || requestedDate || actual_start || endDate || actual_end || openedDate;

                    let eventObj = {
                        // 'state': vm.requests[x].state,
                        start_date: {
                            year: changeDate[0],
                            month: changeDate[1],
                            day: changeDate[2]
                        },
                        text: {
                            headline:
                                '<a class="compile-click" href="/u_customer_changes/' +
                                vm.requests[x].sys_id +
                                '" style="font-size:16px; cursor:pointer;border-bottom: 1px solid white;">' +
                                vm.requests[x].number +
                                ' - <span style="font-weight:400">' +
                                vm.requests[x].state +
                                "</span></a>",
                            text:
                                '<p style="font-size:14px; color:#fff;margin-bottom:5px">' +
                                vm.requests[x].short_description +
                                '</p><p style="font-size:12px; color:#fff;margin-bottom:0px">' +
                                displayDateVar +
                                ": &nbsp;&nbsp;&nbsp;&nbsp;" +
                                vm.requests[x][availDateVar] +
                                "</p>"
                        }
                    };
                    data.events.push(eventObj);
                }
                //set temp data holder
                vm.tempData = data.events;
                //setting the data
                vm.timeline.setData(data);
                // let markerHeight = 45;
                let markerHeight = 90;
                $timeout(() => {
                    angular.element(".tl-timemarker").each(function () {
                        if (markerHeight < 10) {
                            markerHeight = 90;
                        }
                        angular.element(this).css({
                            top: markerHeight
                        });
                        markerHeight -= 16;
                    });
                }, 1000);
            } else {
                //if no changes exist
                var eventObj2 = {
                    start_date: {
                        year: new Date().getFullYear().toString(),
                        month: (parseInt(new Date().getMonth()) + 1).toString(),
                        day: new Date().getDate().toString()
                    },
                    text: {
                        headline: "No results for Change Request",
                        text: ""
                    }
                };
                data.events.push(eventObj2);
                vm.timeline.setData(data);
                vm.timeline.goTo(1);
            }
            $timeout(() => {
                vm.calendarLoading = false;
                vm.timeline.setOptions(vm.options);
                angular.element(".tl-slide-text-only").addClass("webkit-scroll");
            }, 500);
        }

        // general function that fetches all ticket/type from SNOW
        Ticket.getTicket((data) => {
            vm.loading = false;
            vm.relatedTickets = [];
            vm.myApprovals = [];
            if (data.success == true) {
                vm.tickets = data.results;
                vm.totalTickets = data.results.length;
            } else {
                vm.tickets = [];
            }
            vm.totalIncidents = 0;
            let user = user_info.first_name + " " + user_info.last_name + " (" + user_info.email + ")";
            let ticDevices = {};
            let ticDevArray = [];
            vm.ticketsWaiting = [];
            vm.changeRequests = [];
            vm.ticketsActive = [];
            vm.ticketsResolved = [];
            vm.ticketsRequest = [];

            //sets widget data for rigt panel and some sorting
            angular.forEach(vm.tickets, (ticket) => {
                vm.parseDate(ticket.opened_at, ticket.number, ticket.sys_id);
                if (ticket.sys_class_name === "Incident") {
                    vm.totalIncidents++;
                }
                // if (ticket.sys_class_name === 'Change Request') {
                if (
                    ticket.sys_class_name === "Change Request" &&
                    (ticket.state === "Implement" || ticket.state === "Scheduled")
                ) {
                    vm.changeRequests.push(ticket);
                }
                if (ticket.state === "Waiting for Customer") {
                    ticketsWaiting.value++;
                    vm.ticketsWaiting.push(ticket);
                }
                if (ticket.assignment_group.display_value === "BMS - Tier 1") {
                    tier1Tickets.value++;
                }
                if (ticket.assignment_group.display_value) {
                    if (ticket.assignment_group.display_value.substring(0, 12) === "BMS - Tier 2") {
                        tier2Tickets.value++;
                    }
                }
                ticket["priority_number"] = 0;
                if (ticket["priority"] && ticket["priority"] != "") {
                    ticket["priority_number"] = ticket.priority[0];
                }
                if (ticket.assigned_to.display_value === user) {
                    vm.relatedTickets.push(ticket);
                } else if (ticket.watch_list) {
                    let watchList = ticket.watch_list.split(",");
                    if (watchList.indexOf(user) == -1) {
                        // vm.relatedTickets.push(ticket);
                    } else {
                        vm.relatedTickets.push(ticket);
                    }
                }

                if (ticket.state === "Waiting for Approval") {
                    if (ticket.caller_id === user || ticket.requested_by === user || ticket.u_requester === user) {
                        vm.myApprovals.push(ticket);
                    }
                }
                //sort for highchart Incidents by Device
                if (ticket.cmdb_ci && ticket.cmdb_ci.display_value) {
                    if (ticDevices[ticket.cmdb_ci.display_value]) {
                        ticDevices[ticket.cmdb_ci.display_value]++;
                    } else {
                        ticDevices[ticket.cmdb_ci.display_value] = 1;
                    }
                }
            });
            //reorder for highchart Incidents by Device
            for (var dev in ticDevices) {
                ticDevArray.push({
                    name: dev,
                    y: ticDevices[dev]
                });
            }

            ticDevArray.sort((a, b) => {
                return a.y > b.y ? 1 : b.y > a.y ? -1 : 0;
            });
            ticDevArray = ticDevArray.splice(0, 20);

            vm.averageDate();
            vm.oldestTicketCalc();
            vm.pushTicketWidgets();

            angular.forEach(vm.tickets, function (ticket2) {
                let priority = parseInt(ticket2.priority_number) - 1;
                switch (priority) {
                    case 3:
                        priority = 0;
                        break;
                    case 2:
                        priority = 1;
                        break;
                    case 1:
                        priority = 2;
                        break;
                    case 0:
                        priority = 3;
                        break;
                    default:
                        break;
                }
                if (priority <= 3) {
                    switch (ticket2.sys_class_name) {
                        case "Problem":
                            if (ticket2.state != "Resolved") {
                                ticketObj[0].data[priority]++;
                                vm.ticketsActive.push(ticket2);
                            } else {
                                ticketObjResolved[0].data[priority]++;
                                vm.ticketsResolved.push(ticket2);
                            }
                            break;
                        case "Incident":
                            if (ticket2.state != "Resolved") {
                                ticketObj[1].data[priority]++;
                                vm.ticketsActive.push(ticket2);
                            } else {
                                ticketObjResolved[1].data[priority]++;
                                vm.ticketsResolved.push(ticket2);
                            }
                            break;
                        case "Request":
                            requestObj[0].data[priority]++;
                            vm.ticketsRequest.push(ticket2);
                            break;
                        default:
                            break;
                    }
                }
            });

            vm.ticketsDevice = ticDevArray;

            vm.createTicketChart("configTicket", ticketObj);
            vm.createTicketChart("configResolvedTicket", ticketObjResolved);
            vm.createTicketChart("configRequest", requestObj);
            vm.createTicketsByDeviceChart(ticDevArray);
            buildCalendar(vm.changeRequests);

            vm.ticketLoading = false;
        });

        vm.createTicketsByDeviceChart = (devArr) => {
            vm.configTicDevice = {
                chart: {
                    type: "pie",
                    zoomType: "x",
                    width: width,
                    height: 240
                },
                exporting: {
                    enabled: false
                },
                boost: {
                    useGPUTranslations: true
                },
                legend: {
                    enabled: true
                },
                title: {
                    text: null
                },
                plotOptions: {
                    pie: {
                        size: "70%",
                        center: ["50%", "50%"]
                    },
                    series: {
                        cursor: "pointer",
                        point: {
                            events: {
                                click: function () {
                                    vm.seriesSelected(null, "ticketByDevice", this.name);
                                }
                            }
                        }
                    }
                },
                tooltip: {
                    formatter: function () {
                        return (
                            "<div><p>Device: " +
                            this.key +
                            "<br>Tickets: " +
                            this.y +
                            "</p><br><p>Click for Details</p></div>"
                        );
                    }
                },
                series: [
                    {
                        name: "Devices",
                        data: devArr
                    }
                ]
            };
        };

        vm.createTicketChart = (configName, configObj) => {
            vm[configName] = {
                colors: ["#fff", "#fff", "#fff"],
                chart: {
                    type: "column",
                    zoomType: "x",
                    width: width,
                    height: 240
                },
                boost: {
                    useGPUTranslations: true
                },
                title: {
                    text: null
                },
                xAxis: {
                    categories: ["Minimal", "Moderate", "High", "Critical"]
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: ""
                    },
                    allowDecimals: false
                },
                legend: {
                    enabled: true
                },
                tooltip: {
                    formatter: function () {
                        return (
                            "<div><p>" +
                            this.x +
                            "</p><br><p>Total Tickets: </p><p>" +
                            this.total +
                            "</p><br><p>" +
                            this.series.name +
                            ": </p><p>" +
                            this.y +
                            "</p><br><p>Click for Details</p></div>"
                        );
                    }
                },
                plotOptions: {
                    column: {
                        stacking: "normal"
                    },
                    series: {
                        cursor: "pointer",
                        point: {
                            events: {
                                click: function () {
                                    vm.seriesSelected(this.category, this.series.userOptions.name, null, configName);
                                }
                            }
                        }
                    }
                },
                series: configObj
            };
        };

        let deviceArray = [];
        let deviceCount = {};

        // calculates health history score
        vm.calcTotal = () => {
            vm.health.eventScore =
                vm.getScore(vm.eventData.minor, vm.totalDevices, 0.25) +
                vm.getScore(vm.eventData.major, vm.totalDevices, 0.5) +
                vm.getScore(vm.eventData.critical, vm.totalDevices, 1);
            vm.health.eventPercent = 100 - vm.health.eventScore;
        };

        vm.getScore = (quantity, typeTotal, factor) => {
            return parseFloat(((quantity / typeTotal) * 100 * factor).toFixed(2));
        };

        //watches for event and devices data to return, then calculates values
        $scope.$watch("vm.deviceTotal", (newValue, oldValue) => {
            if (newValue !== oldValue) {
                if (vm.eventTotal) {
                    vm.calcTotal();
                }
            }
        });
        $scope.$watch("vm.eventTotal", (newValue, oldValue) => {
            if (newValue !== oldValue) {
                if (vm.deviceTotal) {
                    vm.calcTotal();
                }
            }
        });

        vm.goToTicketsWaiting = (header) => {
            if (header === "Tickets set to Waiting for Customer") {
                $state.go("index.ticket", {
                    ticketsWaiting: true
                });
            }
        };

        vm.pushEventWidgets = () => {
            widgetArray.push(highestDevice);
            vm.widgetEventPushed = true;
        };

        // sets any cookie data that may need to persist between pages
        vm.setStorage = (device) => {
            if (device === highestDevice.name) {
                let except = false;
                for (let x = 0; x < exceptions.length; x++) {
                    if (device.toLowerCase() === exceptions[x].name.toLowerCase()) {
                        except = true;
                    }
                }
                if (except) {
                    $state.go("index.devices", {
                        redirectedDevice: device,
                        exception: true
                    });
                } else {
                    $state.go("index.devices", {
                        redirectedDevice: device
                    });
                }
            }
        };

        vm.deviceTotal = false;

        vm.getEvents = () => {
            ScienceLogicGQL.getQuery(
                {
                    table: "events",
                    queryName: "eventTable",
                    edge: "events"
                },
                (response) => {
                    vm.loading = false;
                    if (response.results) {
                        vm.events = response.results;
                        vm.totalEvents = vm.events.length;
                        highestDevice.href = $window.location.origin + "/devices/";
                        vm.pushEventWidgets();
                        vm.createEventChart();
                        vm.createTopEventChart();
                        vm.eventLoading = false;
                    } else {
                        vm.total_result = 0;
                        vm.events = [];
                    }
                }
            );
        };
        vm.getEvents();

        vm.getDevices = () => {
            Service.getQuery(
                {
                    cmdb_company: user_info.company,
                    valid_device: true
                },
                "u_devicesbysku|minimalList",
                (data) => {
                    vm.totalDevices = parseInt(data.count);
                    Service.getQuery(
                        {
                            exceptions: true,
                            exCompany: user_info.company
                        },
                        "cmdb_ci|minimalList",
                        function (data2) {
                            vm.totalDevices += parseInt(data2.count);
                            vm.deviceTotal = true;
                        }
                    );
                }
            );
        };
        vm.getDevices();

        vm.createTopEventChart = () => {
            let deviceObj = {};
            let topDeviceArray = [];
            let categoryArray = [];

            vm.events.forEach((item) => {
                if (!deviceObj[item.alignedResourceName]) {
                    deviceObj[item.alignedResourceName] = 1;
                } else {
                    deviceObj[item.alignedResourceName]++;
                }
            });

            for (var y in deviceObj) {
                topDeviceArray.push([y, deviceObj[y]]);
            }

            var top10 = topDeviceArray
                .sort((a, b) => {
                    return a[1] < b[1] ? 1 : -1;
                })
                .slice(0, 10);

            top10.forEach((item) => {
                categoryArray.push(item[0]);
            });

            let eventData = [
                {
                    name: "Healthy",
                    color: "#64AD61",
                    data: []
                },
                {
                    name: "Notice",
                    color: "#467E8A",
                    data: []
                },
                {
                    name: "Minor",
                    color: "#DBAC39",
                    data: []
                },
                {
                    name: "Major",
                    color: "#D37C0F",
                    data: []
                },
                {
                    name: "Critical",
                    color: "#A51820",
                    data: []
                }
            ];

            for (let f = 0; f < categoryArray.length; f++) {
                eventData[0].data[f] = 0;
                eventData[1].data[f] = 0;
                eventData[2].data[f] = 0;
                eventData[3].data[f] = 0;
                eventData[4].data[f] = 0;
            }

            vm.events.forEach((item) => {
                let name = item.alignedResourceName;
                let nameIndex = categoryArray.indexOf(name);
                if (nameIndex != -1) {
                    switch (item.severity) {
                        case "0":
                            eventData[0].data[nameIndex]++;
                            break;
                        case "1":
                            eventData[1].data[nameIndex]++;
                            break;
                        case "2":
                            eventData[2].data[nameIndex]++;
                            break;
                        case "3":
                            eventData[3].data[nameIndex]++;
                            break;
                        case "4":
                            eventData[4].data[nameIndex]++;
                            break;
                    }
                }
            });

            vm.configTopEvent = {
                chart: {
                    type: "column",
                    width: width,
                    height: 240,
                    zoomType: "x",
                    panning: true,
                    panKey: "shift"
                },
                boost: {
                    useGPUTranslations: true
                },
                title: {
                    text: null
                },
                legend: {
                    enabled: true
                },
                xAxis: {
                    categories: categoryArray,
                    crosshair: true
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "Events"
                    }
                },
                plotOptions: {
                    column: {
                        stacking: "normal"
                    },
                    series: {
                        cursor: "pointer",
                        point: {
                            events: {
                                click: function () {
                                    vm.seriesSelected(this.series.userOptions.name, "Event", this.category);
                                }
                            }
                        }
                    }
                },
                tooltip: {
                    formatter: function () {
                        return (
                            "<div><p>" +
                            this.x +
                            "</p><br><p>Events Generated: </p><p>" +
                            this.total +
                            "</p><br><p>Click for Details</p></div>"
                        );
                    }
                },
                series: eventData
            };
        };

        vm.eventTotal = false;

        vm.createEventChart = () => {
            vm.events.forEach((item) => {
                switch (item.severity) {
                    case "0": //healthy
                        // vm.eventData.healthy++;
                        break;
                    case "1": // notice
                        vm.eventData.notice++;
                        break;
                    case "2": // minor
                        vm.eventData.minor++;
                        break;
                    case "3": // major
                        vm.eventData.major++;
                        break;
                    case "4": // Critical
                        vm.eventData.critical++;
                        break;
                }

                //sort for highest device causeing events
                if (deviceCount[item.alignedResourceName]) {
                    deviceCount[item.alignedResourceName].count++;
                } else {
                    deviceCount[item.alignedResourceName] = {
                        name: item.alignedResourceName,
                        count: 1
                    };
                }
            });

            //another sort for highest device causing events
            let tempCounter = 0;
            for (var dev in deviceCount) {
                if (deviceCount[dev].count > tempCounter) {
                    highestDevice.value = deviceCount[dev].count;
                    highestDevice.name = deviceCount[dev].name;
                    tempCounter = deviceCount[dev].count;
                }
            }

            for (var item in vm.eventData) {
                deviceArray.push([item.charAt(0).toUpperCase() + item.slice(1), vm.eventData[item]]);
            }

            vm.eventTotal = true;

            vm.configEvent = {
                colors: ["#467E8A", "#DBAC39", "#D37C0F", "#A51820"],
                chart: {
                    type: "column",
                    zoomType: "x",
                    width: width,
                    height: 240
                },
                boost: {
                    useGPUTranslations: true
                },
                title: {
                    text: null
                },
                xAxis: {
                    type: "category"
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: ""
                    },
                    allowDecimals: false
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        cursor: "pointer",
                        point: {
                            events: {
                                click: function () {
                                    vm.seriesSelected(this.category, "Event");
                                }
                            }
                        }
                    }
                },
                turboThreshold: 0,
                tooltip: {
                    formatter: function () {
                        return (
                            "<div><p>" +
                            this.key +
                            "</p><br><p>Events: </p><p>" +
                            this.y +
                            "</p><br><p>Click for Details</p></div>"
                        );
                    }
                },
                series: [
                    {
                        name: "Severity",
                        colorByPoint: true,
                        data: deviceArray
                    }
                ]
            };
        };

        BCSServer.postData(
            {
                healthCompany: user_info.company_name
            },
            "/health",
            (response) => {
                let dateArray = [];
                let dataArray = [];
                response.forEach((item) => {
                    dataArray.push({
                        name: item.date.substr(5, 10),
                        y: item.eventHealth
                    });
                    dateArray.push(item.date.substr(5, 5));
                });
                vm.createHealthChart(dataArray, dateArray);
            }
        );

        vm.createHealthChart = (healthData, dateData) => {
            vm.historyLoading = false;
            vm.configHealth = {
                chart: {
                    zoomType: "x",
                    width: width,
                    height: 180
                },
                boost: {
                    useGPUTranslations: true
                },
                title: {
                    text: null
                },
                yAxis: {
                    min: 50,
                    max: 100,
                    alignTicks: false,
                    endOnTick: false,
                    title: {
                        text: "Health Score"
                    }
                },
                xAxis: {
                    min: 0,
                    categories: dateData
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    area: {
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, "rgba(72, 145, 95, .7)"],
                                [1, "rgba(88, 196, 122, 0)"]
                            ]
                        },
                        marker: {
                            radius: 2
                        },
                        lineWidth: 1,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        threshold: null
                    },
                    series: {
                        animation: false
                    }
                },
                series: [
                    {
                        type: "area",
                        name: "Health Score",
                        data: healthData
                    }
                ]
            };
        };

        // angular jquery configuration for handling button click, hovers, ui stuff, etc that occurs on side panels
        let open = true;
        let buttons = angular.element("#news-btn, #twitter-btn");
        let buttonContainers = angular.element("#news-container, #left-tab");

        buttonContainers.on("mouseenter", () => {
            if (!vm.leftPin) {
                angular.element("#news-container").addClass("toggle-left");
                angular.element("#left-tab").addClass("toggle-bar");
                open = true;
            }
        });
        angular.element("#news-container").on("mouseleave", () => {
            if (!vm.leftPin) {
                angular.element("#news-container").removeClass("toggle-left");
                angular.element("#left-tab").removeClass("toggle-bar");
                angular.element(".single-tweet").css("display", "initial");
                angular.element(".single-news").css("display", "initial");
                open = false;
            }
        });

        buttons.on("click", function () {
            if (!open) {
                open = true;
                angular.element("#news-container").toggleClass("toggle-left");
                angular.element("#left-tab").toggleClass("toggle-bar");
                switch (angular.element(this).attr("id")) {
                    case "news-btn":
                        angular.element(".single-tweet").css("display", "none");
                        angular.element(".single-news").css("display", "initial");
                        break;
                    case "twitter-btn":
                        angular.element(".single-tweet").css("display", "inline");
                        angular.element(".single-news").css("display", "none");
                        break;
                    default:
                        break;
                }
            } else {
                switch (angular.element(this).attr("id")) {
                    case "news-btn":
                        angular.element(".single-tweet").css("display", "none");
                        angular.element(".single-news").css("display", "initial");
                        break;
                    case "twitter-btn":
                        angular.element(".single-tweet").css("display", "inline");
                        angular.element(".single-news").css("display", "none");
                        break;
                    default:
                        break;
                }
            }
        });

        vm.closeLeft = () => {
            angular.element("#news-container").toggleClass("toggle-left");
            angular.element("#left-tab").toggleClass("toggle-bar");
            angular.element(".single-tweet").css("display", "initial");
            angular.element(".single-news").css("display", "initial");
            open = false;
        };

        vm.closeRight = () => {
            angular.element("#right-container").toggleClass("toggle-right");
            angular.element("#right-tab").toggleClass("toggle-bar");
        };

        angular.element("#right-container, #right-tab").on("mouseenter", () => {
            if (!vm.rightPin) {
                angular.element("#right-container").addClass("toggle-right");
                angular.element("#right-tab").addClass("toggle-bar");
            }
        });
        angular.element("#right-container").on("mouseleave", () => {
            if (!vm.rightPin) {
                angular.element("#right-container").removeClass("toggle-right");
                angular.element("#right-tab").removeClass("toggle-bar");
            }
        });

        let checkLoad = $interval(() => {
            if (!vm.ticketLoading && !vm.eventLoading && !vm.historyLoading) {
                $timeout(() => {
                    !vm.leftPin ? vm.closeLeft() : vm.leftPin;
                    !vm.rightPin ? vm.closeRight() : vm.rightPin;
                    angular.element("#news-container, #left-tab").css("pointer-events", "auto");
                    angular.element(".side-info").css("height", "auto");
                }, 1000);
                $interval.cancel(checkLoad);
            }
        }, 300);

        var exceptions;

        // get devices not in contract
        Service.getExceptions((data) => {
            if (data.err || !data.results) {
                vm.error = true;
            } else {
                exceptions = data.results;
            }
        }, user_info.company);

        vm.goToDevice = (device) => {
            let except = false;
            for (let x = 0; x < exceptions.length; x++) {
                if (device.toLowerCase() === exceptions[x].name.toLowerCase()) {
                    except = true;
                }
            }
            if (except) {
                $state.go("index.devices", {
                    redirectedDevice: device,
                    exception: true
                });
            } else {
                $state.go("index.devices", {
                    redirectedDevice: device
                });
            }
        };

        vm.goToTicket = (number, sys_id) => {
            switch (number.substring(0, 3)) {
                case "INC":
                    $state.go("index.status_single", {
                        statusID: sys_id
                    });
                    break;
                case "CUS":
                    $state.go("index.uchange_single", {
                        requestID: sys_id
                    });
                    break;
                case "CHG":
                    $state.go("index.uchange_single", {
                        requestID: sys_id
                    });
                    break;
                case "PRB":
                    $state.go("index.problem_single", {
                        problemID: sys_id
                    });
                    break;
                case "REQ":
                    $state.go("index.request_single", {
                        reqID: sys_id
                    });
                    break;
                default:
                    break;
            }
        };

        // controls and handling of clicking into any Highcharts report
        vm.seriesSelected = (item, type, device, state) => {
            if (state === "configResolvedTicket") {
                state = "Resolved";
            } else if (state === "configTicket") {
                state = "Active";
            }
            if (type === "Incident" || type === "Problem" || type === "Change Request" || type === "Request") {
                switch (item) {
                    case "Minimal":
                        item = "4 - Minimal";
                        break;
                    case "Moderate":
                        item = "3 - Moderate";
                        break;
                    case "High":
                        item = "2 - High";
                        break;
                    case "Critical":
                        item = "1 - Critical";
                        break;
                    default:
                        break;
                }
                switch (type) {
                    case "Incident":
                        $state.go("index.incidents", {
                            sort: item,
                            type: type,
                            state: state
                        });
                        break;
                    case "Problem":
                        $state.go("index.problems", {
                            sort: item,
                            type: type,
                            state: state
                        });
                        break;
                    case "Change Request":
                        $state.go("index.uchange_request", {
                            sort: item,
                            type: type,
                            state: state
                        });
                        break;
                    case "Request":
                        $state.go("index.requests", {
                            sort: item,
                            type: type,
                            state: state
                        });
                        break;
                    default:
                        break;
                }
            } else if (type === "ticketByDevice") {
                $state.go("index.ticket", {
                    device: device
                });
            } else if (type === "Health") {
                item = item.replace("-", "/");
                $state.go("index.clearevent", {
                    health: item
                });
            } else if (type === "EM7Device") {
                $state.go("index.devices", {
                    redirectedDevice: item
                });
            } else {
                $state.go("index.allevent", {
                    sort: item,
                    device: device
                });
            }
        };

        vm.leftPin = true;
        vm.rightPin = true;

        vm.togglePin = (direction) => {
            vm[direction] = !vm[direction];
            vm.pinDatabase("post");
        };

        // controls handling and setting of pin setting in mogdb database
        vm.pinDatabase = (type) => {
            BCSServer.postData(
                {
                    method: type,
                    user: user_info.email,
                    leftPin: vm.leftPin,
                    rightPin: vm.rightPin
                },
                "/pin",
                (response) => {
                    if (type === "get") {
                        if (response.length === 0) {
                            //if user widget list doesnt exist in database - need to use predefined one
                            vm.pinDatabase("post");
                        } else {
                            vm.leftPin = response[0].leftPin;
                            vm.rightPin = response[0].rightPin;
                        }
                    }
                }
            );
        };

        vm.pinDatabase("get");

        vm.dash = {};
        vm.calendarSelected = false;

        vm.dashboardDatabase = (type) => {
            vm.calendarLoading = true;
            BCSServer.postData(
                {
                    method: type,
                    user: user_info.email,
                    dashboardList: vm.chosenDashboards
                },
                "/dashboard",
                (response) => {
                    if (type === "get") {
                        if (response.length === 0) {
                            //if user dashboard list doesnt exist in database - need to use predefined one
                            vm.chosenDashboards = storedDashboards.slice(0, 6);
                            dashboardList = storedDashboards.slice(6);
                        } else {
                            vm.chosenDashboards = response[0].dashboardList;
                            dashboardList = storedDashboards;
                            for (let x = 0; x < vm.chosenDashboards.length; x++) {
                                if (vm.chosenDashboards[x].name === "Tickets") {
                                    vm.chosenDashboards[x].name = "Active Tickets";
                                }
                                for (let y = 0; y < dashboardList.length; y++) {
                                    if (vm.chosenDashboards[x].name === dashboardList[y].name) {
                                        dashboardList.splice(y, 1);
                                    }
                                }
                            }
                            vm.sortDashboards(vm.chosenDashboards);
                        }
                    } else {
                        for (let k = 0; k < vm.chosenDashboards.length; k++) {
                            if (vm.chosenDashboards[k].name === "Change Calendar") {
                                vm.calendarSelected = true;
                                buildCalendar(vm.changeRequests);
                            }
                        }
                    }
                }
            );
        };

        vm.fadeInDash = () => {
            let dashCount = 0;
            angular
                .element(".all-dashboards")
                .children()
                .each((index, element) => {
                    dashCount += 50;
                    $timeout(() => {
                        angular.element(element).addClass("opaque");
                    }, dashCount);
                });
        };

        vm.dashboardDatabase("get");

        let widgetArray = [];
        vm.chosenWidgets = [];
        let storedWidgets = [];
        let defaultWidgets = [
            "Top Event Generator",
            "Tickets set to Waiting for Customer",
            "Oldest Open Ticket",
            "Currently Open Tickets for Tier 1",
            "Currently Open Tickets for Tier 2"
        ];

        vm.widgetDatabase = (type) => {
            BCSServer.postData(
                {
                    method: type,
                    user: user_info.email,
                    widgetList: storedWidgets
                },
                "/widget",
                (response) => {
                    if (type === "get") {
                        if (response.length === 0) {
                            //if user widget list doesnt exist in database - need to use predefined one
                            storedWidgets = defaultWidgets;
                            vm.watchForLoadedWidgets();
                        } else {
                            storedWidgets = response[0].widgetList;
                            vm.watchForLoadedWidgets();
                        }
                    }
                }
            );
        };

        vm.watchForLoadedWidgets = () => {
            if (vm.widgetTicketPushed && vm.widgetEventPushed) {
                vm.updateDomWidgets();
            } else {
                $scope.$watch("vm.widgetTicketPushed", (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        if (vm.widgetEventPushed) {
                            vm.updateDomWidgets();
                        }
                    }
                });
                $scope.$watch("vm.widgetEventPushed", (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        if (vm.widgetTicketPushed) {
                            vm.updateDomWidgets();
                        }
                    }
                });
            }
        };

        vm.updateDomWidgets = () => {
            for (let x = 0; x < storedWidgets.length; x++) {
                for (let y = 0; y < widgetChoices.length; y++) {
                    if (storedWidgets[x] === widgetChoices[y].name) {
                        chosenWidgetList.push(widgetChoices[y]);
                        widgetChoices.splice(y, 1);
                    }
                }
            }
            vm.finalizeWidgets("DOM");
        };

        vm.createStoredWidgets = () => {
            storedWidgets = [];
            for (let x = 0; x < vm.chosenWidgets.length; x++) {
                storedWidgets.push(vm.chosenWidgets[x].header);
            }
            vm.widgetDatabase("post");
        };

        vm.widgetDatabase("get");

        vm.finalizeWidgets = (type) => {
            for (let x = 0; x < chosenWidgetList.length; x++) {
                for (let y = 0; y < widgetArray.length; y++) {
                    if (widgetArray[y].header === chosenWidgetList[x].name) {
                        vm.chosenWidgets.push(widgetArray[y]);
                    }
                }
            }
            if (type != "DOM") {
                vm.createStoredWidgets();
            }
        };

        let widgetChoices = [
            {
                name: "Top Event Generator",
                id: 1
            },
            {
                name: "Average Age of Tickets",
                id: 2
            },
            {
                name: "Oldest Open Ticket",
                id: 3
            },
            {
                name: "Tickets set to Waiting for Customer",
                id: 4
            },
            {
                name: "Currently Open Tickets for Tier 1",
                id: 5
            },
            {
                name: "Currently Open Tickets for Tier 2",
                id: 6
            }
        ];

        let chosenWidgetList = [];

        vm.selectWidgets = () => {
            let modalInst = $uibModal.open({
                resolve: {
                    list: () => {
                        let options = {
                            unselected: widgetChoices,
                            selected: chosenWidgetList
                        };
                        return options;
                    }
                },
                templateUrl: "app/main/widget_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "WidgetController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                vm.chosenWidgets = [];
                chosenWidgetList = data;
                vm.finalizeWidgets();
            });
        };

        let storedDashboards = [
            {
                id: 1,
                name: "Active Tickets"
            },
            {
                id: 2,
                name: "Health History"
            },
            {
                id: 3,
                name: "Events"
            },
            {
                id: 4,
                name: "Top Event Generators"
            },
            {
                id: 5,
                name: "Tickets Open By Device"
            },
            {
                id: 6,
                name: "Tickets Waiting for Customer"
            },
            {
                id: 7,
                name: "Your Associated Tickets"
            },
            {
                id: 8,
                name: "My Approvals"
            },
            {
                id: 9,
                name: "Events List"
            },
            {
                id: 10,
                name: "Top Memory Utilization"
            },
            {
                id: 11,
                name: "Top CPU Utilization"
            },
            {
                id: 12,
                name: "Top Utilization In"
            },
            {
                id: 13,
                name: "Top Utilization Out"
            },
            {
                id: 14,
                name: "Resolved Tickets"
            },
            {
                id: 15,
                name: "Requests"
            },
            {
                id: 16,
                name: "Change Calendar"
            },
            {
                id: 17,
                name: "Device Availability (Lowest Available)"
            }
        ];

        let dashboardList = [];

        vm.chosenDashboards = [];

        vm.isDashboard = (type) => {
            if (vm.chosenDashboards) {
                if (
                    vm.chosenDashboards.filter((dashboard) => {
                        return dashboard.name === type;
                    }).length > 0
                ) {
                    return true;
                } else {
                    return false;
                }
            }
        };

        vm.sortDashboards = (chosenSort) => {
            let newArray = [];
            chosenSort.forEach((item) => {
                newArray.push(item.name);
            });
            let parent = angular.element(".all-dashboards");
            let dashes = parent.children();
            dashes.sort((a, b) => {
                return (
                    newArray.indexOf(angular.element(a).data("dash")) -
                    newArray.indexOf(angular.element(b).data("dash"))
                );
            });
            parent.append(dashes);
        };

        $scope.$watch(
            "vm.chosenDashboards",
            (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    for (let x = 0; x < vm.chosenDashboards.length; x++) {
                        vm.dash[vm.chosenDashboards[x].name] = true;
                    }
                    for (let y = 0; y < dashboardList.length; y++) {
                        vm.dash[dashboardList[y].name] = false;
                    }
                    vm.fadeInDash();
                }
            },
            true
        );

        vm.selectDashboards = () => {
            let modalInst = $uibModal.open({
                resolve: {
                    list: () => {
                        let options = {
                            unselected: dashboardList,
                            selected: vm.chosenDashboards
                        };
                        return options;
                    }
                },
                templateUrl: "app/main/dashboard_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "MainDashboardController",
                controllerAs: "vm"
            });
            modalInst.result.then(() => {
                vm.sortDashboards(vm.chosenDashboards);
                vm.dashboardDatabase("post");
            });
        };

        let utilReports = [
            {
                title: "Top Utilization In",
                identifier: "in",
                category: "Interface",
                config: "utilInConfig"
            },
            {
                title: "Top Utilization Out",
                identifier: "out",
                category: "Interface",
                config: "utilOutConfig"
            },
            {
                title: "Device Availability (Lowest Available)",
                identifier: null,
                category: "Availability",
                config: "availabilityConfig"
            },
            {
                title: "Top Memory Utilization",
                identifier: "C36F10744B4BCA7C91CD1C405BC568C0",
                category: "Collections",
                config: "memoryConfig"
            },
            {
                title: "Top CPU Utilization",
                identifier: "AFF64E74C73D96244F7DB426158A359F",
                category: "Collections",
                config: "CPUConfig"
            }
        ];

        vm.getWeekDurationDates = () => {
            let dateObj = {
                end: new Date(),
                start: new Date()
            };
            dateObj.start.setDate(dateObj.end.getDate() - 7);
            return dateObj;
        };

        vm.returnQuery = (report) => {
            var searchObj;
            switch (report.category) {
                case "Interface":
                    searchObj = {
                        table: "metrics",
                        queryName: "interfaces",
                        edge: "topNInterfaceMetrics",
                        search: {
                            utilUnit: "perc",
                            utilDirection: report.identifier
                        }
                    };
                    break;
                case "Availability":
                    searchObj = {
                        table: "metrics",
                        queryName: "metrics",
                        edge: "topNDeviceMetrics",
                        search: {
                            metricUnit: "d_check",
                            metricCategory: "Availability"
                        }
                    };
                    break;
                case "Collections":
                    searchObj = {
                        table: "metrics",
                        queryName: "metrics",
                        edge: "topNDeviceMetrics",
                        search: {
                            metricUnit: report.identifier,
                            metricCategory: "CollectionLabel"
                        }
                    };
                    break;
                default:
                    break;
            }

            if (!searchObj) {
                return null;
            }

            let searchDates = vm.getWeekDurationDates();
            searchObj.search.beginDate = searchDates.start;
            searchObj.search.endDate = searchDates.end;
            return searchObj;
        };

        // returns and cofigures stores EM7 util/vital data from storage in mongodb to display in dashboard
        vm.getDataUtil = (query, options) => {
            vm[options.config + "loading"] = true;

            if (!query) {
                vm.setNoDataChart(options);
                return;
            }

            ScienceLogicGQL.getQuery(query, (response) => {
                vm[options.config + "loading"] = false;
                if (response.results && response.results.length > 0) {
                    let categories = [];
                    let series = [
                        {
                            color: "#64AD61",
                            name: options.title,
                            data: []
                        }
                    ];

                    response.results.forEach((item) => {
                        if (item.interface) {
                            var categoryTitle;
                            if (item.interface.alias) {
                                categoryTitle = item.interface.alias;
                            } else if (item.interface.name) {
                                categoryTitle = item.interface.name;
                            } else {
                                categoryTitle = "No Name";
                            }
                            if (item.device && item.device.name) {
                                categoryTitle += " - " + item.device.name;
                            }
                            categories.push(categoryTitle);
                            if (item.values && item.values[0] && item.values[0].value) {
                                series[0].data.push(Number(item.values[0].value.toFixed(2)));
                            } else {
                                series[0].data.push(0);
                            }
                        } else {
                            categories.push(item.device.name);
                            if (item.values && item.values[0] && item.values[0].value) {
                                options.category === "Availability"
                                    ? series[0].data.push(Number((item.values[0].value * 100).toFixed(2)))
                                    : series[0].data.push(Number(item.values[0].value.toFixed(2)));
                            } else {
                                series[0].data.push(0);
                            }
                        }
                    });

                    if (options.category === "Availability") {
                        categories.reverse();
                        series[0].data.reverse();
                    }

                    categories = categories.slice(0, 10);
                    series[0].data = series[0].data.slice(0, 10);

                    vm[options.config] = {
                        chart: {
                            type: "column",
                            width: width,
                            zoomType: "x",
                            panning: true,
                            panKey: "shift",
                            height: 220
                        },
                        boost: {
                            useGPUTranslations: true
                        },
                        legend: {
                            enabled: true
                        },
                        title: {
                            text: null
                        },
                        xAxis: {
                            categories: categories,
                            crosshair: true
                        },
                        yAxis: {
                            min: 0,
                            title: {
                                text: "Utilization Percent"
                            }
                        },
                        plotOptions: {
                            series: {
                                cursor: "pointer",
                                point: {
                                    events: {
                                        click: function () {
                                            vm.seriesSelected(this.category, "EM7Device");
                                        }
                                    }
                                }
                            }
                        },
                        tooltip: {
                            formatter: function () {
                                return (
                                    "<div><p>" +
                                    this.x +
                                    "</p><br><p>Utilization Percent: </p><p>" +
                                    this.y +
                                    "</p><br><p>Click for Details</p></div>"
                                );
                            }
                        },
                        series: series
                    };
                    vm[options.config + "NoData"] = false;
                } else {
                    vm.setNoDataChart(options);
                }
            });
        };

        utilReports.forEach((report) => {
            vm.getDataUtil(vm.returnQuery(report), report);
        });

        vm.setNoDataChart = (options) => {
            vm[options.config + "NoData"] = true;
            vm[options.config + "loading"] = false;
            vm.customTitle = "No Metric Data";
            vm[options.config] = {
                chart: {
                    type: "line",
                    width: width,
                    height: 220,
                    zoomType: "x",
                    panning: true,
                    panKey: "shift"
                },
                title: {
                    text: "Sorry, no results for metrics."
                },
                legend: {
                    enabled: false
                },
                subtitle: {
                    text: ""
                },
                xAxis: {
                    categories: [],
                    crosshair: true
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: ""
                    }
                },
                plotOptions: {
                    series: {
                        color: "#64AD61"
                    }
                },
                series: [
                    {
                        name: "",
                        type: "line",
                        data: []
                    }
                ]
            };
        };
    }
})();

// --------------------------------------------------
// easing.js v0.5.4
// Generic set of easing functions with AMD support
// https://github.com/danro/easing-js
// This code may be freely distributed under the MIT license
// http://danro.mit-license.org/
// --------------------------------------------------
// All functions adapted from Thomas Fuchs & Jeremy Kahn
// Easing Equations (c) 2003 Robert Penner, BSD license
// https://raw.github.com/danro/easing-js/master/LICENSE
// --------------------------------------------------
(function(name, definition) {
	/*global define module*/
	if (typeof define == 'function') define(definition);
	else if (typeof module != 'undefined') module.exports = definition;
	else this[name] = definition;
}('easing', {
	easeInQuad: function(pos) {
		return Math.pow(pos, 2);
	},

	easeOutQuad: function(pos) {
		return -(Math.pow((pos - 1), 2) - 1);
	},

	easeInOutQuad: function(pos) {
		if ((pos /= 0.5) < 1) return 0.5 * Math.pow(pos, 2);
		return -0.5 * ((pos -= 2) * pos - 2);
	},

	easeInCubic: function(pos) {
		return Math.pow(pos, 3);
	},

	easeOutCubic: function(pos) {
		return (Math.pow((pos - 1), 3) + 1);
	},

	easeInOutCubic: function(pos) {
		if ((pos /= 0.5) < 1) return 0.5 * Math.pow(pos, 3);
		return 0.5 * (Math.pow((pos - 2), 3) + 2);
	},

	easeInQuart: function(pos) {
		return Math.pow(pos, 4);
	},

	easeOutQuart: function(pos) {
		return -(Math.pow((pos - 1), 4) - 1);
	},

	easeInOutQuart: function(pos) {
		if ((pos /= 0.5) < 1) return 0.5 * Math.pow(pos, 4);
		return -0.5 * ((pos -= 2) * Math.pow(pos, 3) - 2);
	},

	easeInQuint: function(pos) {
		return Math.pow(pos, 5);
	},

	easeOutQuint: function(pos) {
		return (Math.pow((pos - 1), 5) + 1);
	},

	easeInOutQuint: function(pos) {
		if ((pos /= 0.5) < 1) return 0.5 * Math.pow(pos, 5);
		return 0.5 * (Math.pow((pos - 2), 5) + 2);
	},

	easeInSine: function(pos) {
		return -Math.cos(pos * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(pos) {
		return Math.sin(pos * (Math.PI / 2));
	},

	easeInOutSine: function(pos) {
		return (-0.5 * (Math.cos(Math.PI * pos) - 1));
	},

	easeInExpo: function(pos) {
		return (pos === 0) ? 0 : Math.pow(2, 10 * (pos - 1));
	},

	easeOutExpo: function(pos) {
		return (pos === 1) ? 1 : -Math.pow(2, -10 * pos) + 1;
	},

	easeInOutExpo: function(pos) {
		if (pos === 0) return 0;
		if (pos === 1) return 1;
		if ((pos /= 0.5) < 1) return 0.5 * Math.pow(2, 10 * (pos - 1));
		return 0.5 * (-Math.pow(2, -10 * --pos) + 2);
	},

	easeInCirc: function(pos) {
		return -(Math.sqrt(1 - (pos * pos)) - 1);
	},

	easeOutCirc: function(pos) {
		return Math.sqrt(1 - Math.pow((pos - 1), 2));
	},

	easeInOutCirc: function(pos) {
		if ((pos /= 0.5) < 1) return -0.5 * (Math.sqrt(1 - pos * pos) - 1);
		return 0.5 * (Math.sqrt(1 - (pos -= 2) * pos) + 1);
	},

	easeOutBounce: function(pos) {
		if ((pos) < (1 / 2.75)) {
			return (7.5625 * pos * pos);
		} else if (pos < (2 / 2.75)) {
			return (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
		} else if (pos < (2.5 / 2.75)) {
			return (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
		} else {
			return (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
		}
	},

	easeInBack: function(pos) {
		var s = 1.70158;
		return (pos) * pos * ((s + 1) * pos - s);
	},

	easeOutBack: function(pos) {
		var s = 1.70158;
		return (pos = pos - 1) * pos * ((s + 1) * pos + s) + 1;
	},

	easeInOutBack: function(pos) {
		var s = 1.70158;
		if ((pos /= 0.5) < 1) return 0.5 * (pos * pos * (((s *= (1.525)) + 1) * pos - s));
		return 0.5 * ((pos -= 2) * pos * (((s *= (1.525)) + 1) * pos + s) + 2);
	},

	elastic: function(pos) {
		return -1 * Math.pow(4, -8 * pos) * Math.sin((pos * 6 - 1) * (2 * Math.PI) / 2) + 1;
	},

	swingFromTo: function(pos) {
		var s = 1.70158;
		return ((pos /= 0.5) < 1) ? 0.5 * (pos * pos * (((s *= (1.525)) + 1) * pos - s)) :
			0.5 * ((pos -= 2) * pos * (((s *= (1.525)) + 1) * pos + s) + 2);
	},

	swingFrom: function(pos) {
		var s = 1.70158;
		return pos * pos * ((s + 1) * pos - s);
	},

	swingTo: function(pos) {
		var s = 1.70158;
		return (pos -= 1) * pos * ((s + 1) * pos + s) + 1;
	},

	bounce: function(pos) {
		if (pos < (1 / 2.75)) {
			return (7.5625 * pos * pos);
		} else if (pos < (2 / 2.75)) {
			return (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
		} else if (pos < (2.5 / 2.75)) {
			return (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
		} else {
			return (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
		}
	},

	bouncePast: function(pos) {
		if (pos < (1 / 2.75)) {
			return (7.5625 * pos * pos);
		} else if (pos < (2 / 2.75)) {
			return 2 - (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
		} else if (pos < (2.5 / 2.75)) {
			return 2 - (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
		} else {
			return 2 - (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
		}
	},

	easeFromTo: function(pos) {
		if ((pos /= 0.5) < 1) return 0.5 * Math.pow(pos, 4);
		return -0.5 * ((pos -= 2) * Math.pow(pos, 3) - 2);
	},

	easeFrom: function(pos) {
		return Math.pow(pos, 4);
	},

	easeTo: function(pos) {
		return Math.pow(pos, 0.25);
	}
}));

(function () {
    angular.module("burWood").controller("MainDashboardController", MainDashboardController);

    /** @ngInject */
    function MainDashboardController($uibModalInstance, list, $scope) {
        let vm = this;
        vm.loading = true;
        vm.error = false;

        vm.dualListOptions = {
            // title: 'Dashboards',
            filterPlaceHolder: "Start typing to filter the lists below.",
            labelAll: "All Dashboards",
            labelSelected: "Selected Dashboards",
            helpMessage:
                "Choose up to 6 Dashboards.  Click items to transfer them between fields.  Drag selected items to reorder.",
            /* angular will use this to filter your lists */
            orderProperty: "name",
            /* this contains the initial list of all items (i.e. the left side) */
            items: list.unselected,
            /* this list should be initialized as empty or with any pre-selected items */
            selectedItems: list.selected
        };

        vm.toggleDash = false;
        $scope.$watch("vm.toggleDash", (newValue, oldValue) => {
            if (newValue !== oldValue) {
                let newArray = [];
                vm.dualListOptions.selectedItems.forEach((item) => {
                    newArray.push(item.name);
                });
                let parent = angular.element(".all-dashboards");
                let dashes = parent.children();
                dashes.each((index, element) => {
                    angular.element(element).addClass("opaque dash-contain");
                });
                dashes.sort((a, b) => {
                    return (
                        newArray.indexOf(angular.element(a).data("dash")) -
                        newArray.indexOf(angular.element(b).data("dash"))
                    );
                });
                parent.append(dashes);
            }
        });

        vm.close = () => {
            $uibModalInstance.close(vm.dualListOptions.selectedItems);
        };
    }
})();

(function () {
    "use strict";

    angular.module("burWood").factory("Auth", Login);

    function Login($log, $http, $cookies, $q, apiBasePath, BCSServer) {
        let deferred = $q.defer();

        const getDomain = () => {
            if (!apiBasePath) {
                return { one: "localhost", two: "localhost" };
            }
            let domainArray = apiBasePath.split(".");
            let domain = {};
            if (domainArray.length > 1) {
                domain.one = domainArray[domainArray.length - 2] + "." + domainArray[domainArray.length - 1];
            }
            if (domainArray.length > 2) {
                domain.two =
                    domainArray[domainArray.length - 3] +
                    "." +
                    domainArray[domainArray.length - 2] +
                    "." +
                    domainArray[domainArray.length - 1];
            }
            return domain;
        };

        return {
            login: (user, callback) => {
                let cb = callback || angular.noop;
                let account = {
                    username: user.username,
                    password: user.password
                };
                $http.post(apiBasePath + "/login", account).then(
                    (data) => {
                        if (data && data.data.user) {
                            let domain = getDomain();
                            $cookies.put("user_name", data.data.user, { path: "/", domain: domain.one });
                            $cookies.put("company_name", data.data.company_name, { path: "/", domain: domain.one });
                        }
                        deferred.resolve(data.data);
                        return cb(data.data);
                    },
                    (err) => {
                        $log.info("Error Login");
                        $log.info(err);
                        deferred.reject(err);
                        return cb(err);
                    }
                );
                return deferred.promise;
            },
            logout: (callback) => {
                let domain = getDomain();

                let cookies = $cookies.getAll();
                angular.forEach(cookies, (v, k) => {
                    $cookies.remove(k, { path: "/", domain: domain.one });
                    $cookies.remove(k, { path: "/", domain: domain.two });
                });

                BCSServer.getData("/setcookie", () => {
                    // $log.info('Token Set')
                });

                return callback;
            },
            isITIL: (callback) => {
                let user_info = angular.fromJson($cookies.get("user_info"));
                let sys_id = user_info.sys_id;
                let cb = callback || angular.noop;
                $http
                    .post(apiBasePath + "/servicenow/is_itil", {
                        sys_id: sys_id
                    })
                    .then(
                        (data) => {
                            deferred.resolve(data);
                            if (data.is_itil == true) {
                                $cookies.put("user_role", "itil");
                            } else {
                                $cookies.put("user_role", "");
                            }
                            return cb(data);
                        },
                        (err) => {
                            deferred.reject(err);
                            return cb(err);
                        }
                    );
                return deferred.promise;
            },
            isAuthenticated: () => {
                return typeof $cookies.get("user_name") !== "undefined";
            },
            defaultState: () => {
                return "index.index";
            }
        };
    }
})();

(function () {
    angular.module("burWood").controller("LoginController", LoginController);

    /** @ngInject */
    function LoginController(Auth, BCSServer, $cookies, $window, $rootScope, $uibModal, apiBasePath, $document) {
        let vm = this;
        vm.loading = false;
        vm.login_error = false;
        vm.arrayLoaded = false;
        vm.forgot = false;
        vm.apiBasePath = apiBasePath;

        if ($cookies.get("auth_error")) {
            vm.login_error = true;
            vm.error_message = $cookies.get("auth_error");
        }

        //logs out if directly hitting the logout/login page
        Auth.logout(() => {});

        vm.initSSO = () => {
            BCSServer.getData("/checkidp/" + vm.user.emailReset, (response) => {
                vm.loading = false;
                if (response) {
                    $window.location = vm.apiBasePath + "/sso/" + vm.user.emailReset;
                } else {
                    vm.login_error = true;
                    vm.error_message =
                        "The Burwood Management Portal does not contain configurations for your Identity Provider";
                    angular.element(".login-button").removeClass("loading-animation");
                }
            });
        };

        // toggle variable showing UI if pressed forgot link button
        vm.forgotLink = () => {
            vm.forgot = !vm.forgot;
        };

        //UI control for focusing on username after load
        let focusUsername = $rootScope.$on("$stateChangeSuccess", () => {
            $document.getElementById("lg_username").focus();
        });

        $rootScope.$on("$destroy", focusUsername);

        // general log in function
        vm.login = (user, sso) => {
            angular.element(".login-button").addClass("loading-animation");
            vm.login_error = false;
            vm.loading = true;
            if (sso) {
                vm.initSSO();
                return;
            }
            if (!vm.forgot) {
                Auth.login(user, (data) => {
                    vm.loading = false;
                    if (data && data.user) {
                        //login success
                        vm.login_error = false;
                        angular.element(".filter-bg").css({
                            "background-color": "rgba(0,0,0,0)"
                        });
                        angular.element(".login-group").css({
                            "box-shadow": "0px 0px 5000px 0px hsla(135, 100%, 81%, 0.4)",
                            opacity: "0"
                        });
                        angular.element(".security-message").css({
                            opacity: "0"
                        });
                        angular.element(".login-button").css({
                            opacity: "0"
                        });
                        $window.location.href = $window.location.hostname;
                    } else {
                        vm.login_error = true;
                        vm.loading = false;
                        vm.error_message =
                            "There was an error with your Username/Password combination. Please try again.";
                        angular.element(".login-button").removeClass("loading-animation");
                    }
                })
                    .then(() => {
                        // $state.go(Auth.defaultState());
                    })
                    .catch(() => {
                        // vm.login_error = true;
                        // angular.element('.login-button').removeClass('loading-animation');
                        // vm.loading = false;
                        // vm.error_message = "There was an error with your Username/Password combination. Please try again.";
                    });
            } else {
                // finds user email if forgot password and prompt to email a reset key
                BCSServer.postData(
                    {
                        email: vm.user.emailReset
                    },
                    "/find_user",
                    (response) => {
                        if (response && response.success == true) {
                            var sys_id = response.sys_id;
                            BCSServer.postData(
                                {
                                    email: vm.user.emailReset,
                                    sys_id: sys_id
                                },
                                "/reset_key",
                                (response) => {
                                    vm.forgot = false;
                                    vm.loading = false;
                                    if (response && response.error) {
                                        vm.login_error = true;
                                        vm.error_message =
                                            "Error sending reset email.  Please contact support for assistance.";
                                        angular.element(".login-button").removeClass("loading-animation");
                                    } else {
                                        angular.element(".login-button").removeClass("loading-animation");
                                        $uibModal.open({
                                            templateUrl: "app/login/confirmation.html",
                                            ariaLabelledBy: "modal-title",
                                            ariaDescribedBy: "modal-body",
                                            controller: "ConfirmationController",
                                            controllerAs: "vm",
                                            resolve: {
                                                message: () => {
                                                    return {
                                                        heading: "Password Reset Sent",
                                                        message:
                                                            "A reset link has been sent to youe email.  Please follow the link to reset password."
                                                    };
                                                }
                                            }
                                        });
                                    }
                                }
                            );
                        } else {
                            vm.loading = false;
                            vm.login_error = true;
                            vm.error_message = "User Email Does Not Exist";
                            angular.element(".login-button").removeClass("loading-animation");
                        }
                    }
                );
            }
        };
    }
})();

(function () {
    "use strict";

    angular.module("burWood").directive("highchart", highchart);

    /** @ngInject */
    function highchart($window) {
        return {
            restrict: "E",
            template: "<div></div>",
            scope: {
                config: "="
            },
            link: function (scope, element) {
                /* eslint-disable */
                Highcharts.chart(element[0], scope.config);
                scope.$watch(
                    "config",
                    function (newVal) {
                        if (newVal) {
                            Highcharts.chart(element[0], scope.config);
                        }
                    },
                    true
                );
                /* eslint-enable */
                angular.element($window).bind("resize", function () {
                    angular.element(element).highcharts().reflow();
                });
            }
        };
    }
})();

(function () {
    "use strict";

    angular.module("burWood").controller("SingleEventController", SingleEventController);

    /** @ngInject */
    function SingleEventController(_, eventNumber, ScienceLogic, ScienceLogicGQL) {
        let vm = this;
        vm.loading = true;
        vm.alerts = [];
        var updatedEvent;

        let dateFields = ["dateAcknowledged", "dateFirst", "dateLast"];

        vm.sources = [
            {
                id: 2,
                name: "Internal"
            },
            {
                id: 6,
                name: "API"
            }
        ];

        vm.severities = [
            {
                id: "0",
                name: "Healthy"
            },
            {
                id: "1",
                name: "Notice"
            },
            {
                id: "2",
                name: "Minor"
            },
            {
                id: "3",
                name: "Major"
            },
            {
                id: "4",
                name: "Critical"
            }
        ];

        ScienceLogicGQL.getQuery(
            {
                table: "events",
                queryName: "fullEvent",
                edge: "events",
                search: {
                    id: eventNumber
                }
            },
            (response) => {
                vm.loading = false;
                if (!response.graphQLErrors) {
                    vm.error = false;
                    if (response && response.data && response.data.event) {
                        vm.event = response.data.event;
                        updatedEvent = Object.assign({}, response.data.event);
                        dateFields.forEach((field) => {
                            vm.parseDates(field);
                        });
                    } else {
                        vm.event = null;
                    }
                } else {
                    vm.error = true;
                    vm.alerts = response.graphQLErrors;
                }
            }
        );

        vm.close_notice = (index) => {
            vm.alerts.splice(index, 1);
        };

        vm.parseDates = (field) => {
            vm.event[field] && Number(vm.event[field]) > 0
                ? (vm.event[field] = new Date(Number(vm.event[field]) * 1000))
                : "";
        }

        vm.editEvent = () => {
            updatedEvent.user_note = vm.event.user_note;
            ScienceLogic.updateItem("event", eventNumber, updatedEvent, function () {});
        };
    }

})();
(function () {
    angular.module("burWood").factory("Events", Events);

    function Events(ScienceLogic, ServiceNow) {
        return {
            getEvent: (callback, order, filter, limit, offset) => {
                ScienceLogic.getTable("event", callback, order, filter, limit, offset);
            },
            getUser: (callback, account) => {
                ScienceLogic.getTable(account, callback);
            },
            getOrganizations: (callback) => {
                ScienceLogic.getOrganizations(callback);
            },
            getSingle: (queryObj, callback) => {
                ServiceNow.getQuery(queryObj, "incident", callback);
            },
            getClearedEvents: (callback, order, filter, limit, offset) => {
                ScienceLogic.getTable("cleared_event", callback, order, filter, limit, offset);
            }
        };
    }
})();

(function () {
    angular.module("burWood").controller("EventController", EventController);

    /** @ngInject */
    function EventController(
        _,
        user_info,
        $state,
        Events,
        Service,
        $stateParams,
        DTOptionsBuilder,
        DTColumnBuilder,
        DTColumnDefBuilder,
        $window,
        $q,
        $compile,
        $scope,
        $uibModal,
        ScienceLogicGQL
    ) {
        let vm = this;
        let page = 2000;
        let offset = 0;
        vm.loading = true;
        vm.events = [];
        let company = user_info.company;
        vm.ticket_uri = $window.location.origin + "/incident/";
        vm.customTitle = "Active Events";
        vm.sortStart = $stateParams.sort;
        vm.sortDevice = $stateParams.device;

        vm.severityWord = {
            0: "Healthy",
            1: "Notice",
            2: "Minor",
            3: "Major",
            4: "Critical"
        };

        vm.severity = {
            0: "5",
            1: "4",
            2: "3",
            3: "2",
            4: "1"
        };

        let columnFilter = {
            aoColumns: [
                null,
                null,
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                }
            ]
        };

        // configures all table data/config
        let buttonConfig = [
            {
                extend: "colvis",
                text: "Toggle Columns"
            },
            {
                extend: "collection",
                text: "Export",
                buttons: [
                    {
                        extend: "excel",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        }
                    },
                    {
                        extend: "pdf",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        customize: (doc) => {
                            doc.pageMargins = [5, 5, 5, 5];
                            doc.styles.tableHeader.fontSize = 10;
                            doc.defaultStyle.fontSize = 6;
                        }
                    },
                    {
                        extend: "csv",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        }
                    }
                ]
            }
        ];

        vm.dtInstance = {};
        if (vm.sortStart || vm.sortStart === 0) {
            vm.sortStart = vm.sortStart.toString();
            // conditional to correctly sort severity
            switch (vm.sortStart) {
                case "0":
                    vm.sortStart = "4";
                    break;
                case "1":
                    vm.sortStart = "3";
                    break;
                case "2":
                    vm.sortStart = "2";
                    break;
                case "3":
                    vm.sortStart = "1";
                    break;
            }

            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('lfB<"#dt-title">rtip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withColumnFilter(columnFilter)
                .withButtons(buttonConfig)
                .withOption("responsive", true)
                .withOption("iDisplayLength", 10)
                .withOption("order", [["5", "des"]])
                .withOption("initComplete", () => {
                    angular.element("#dt-title").html("Show All Events");
                    let table = angular.element(".table").DataTable();
                    table.column(1).search(vm.sortStart).draw();
                    if (vm.sortDevice) {
                        table.column(2).search(vm.sortDevice).draw();
                    }
                });
            vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef(6).withOption("type", "date")];
        } else {
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('lfB<".table-scroll"rt>ip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withColumnFilter(columnFilter)
                .withButtons(buttonConfig)
                .withOption("responsive", true)
                .withOption("iDisplayLength", 10)
                .withOption("order", [["5", "des"]]);
            vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef(6).withOption("type", "date")];
        }

        vm.goToTicket = (number, sys_id) => {
            $state.go("index.status_single", {
                statusID: sys_id
            });
        };

        //gets exceptions
        var exceptions;
        Service.getExceptions((data) => {
            if (data.err || !data.results) {
                vm.error = true;
            } else {
                exceptions = data.results;
            }
        }, company);

        switch ($state.current.name) {
            case "index.allevent":
                ScienceLogicGQL.getQuery(
                    {
                        table: "events",
                        queryName: "eventTable",
                        edge: "events"
                    },
                    (response) => {
                        vm.loading = false;
                        if (response.results) {
                            vm.events = response.results;
                            vm.total_result = vm.events.length;
                        } else {
                            vm.total_result = 0;
                            vm.events = [];
                        }
                    }
                );
                break;

            //cleared events have much more data than normal, serverside rendering is necessary
            case "index.clearevent":
                vm.customTitle = "Cleared Events";
                vm.dtColumns = [
                    DTColumnBuilder.newColumn("severity")
                        .withTitle("Severity")
                        .renderWith((data) => {
                            data == null ? (data = "") : data;
                            let icon =
                                '<span style="position:absolute;margin-left:26px;margin-top:1.5px;">' +
                                vm.severity[data] +
                                '</span><img src="assets/img/icon/network_' +
                                vm.severity[data] +
                                '.png" width="20" style="height:auto;margin-left:20px"/>';
                            icon +=
                                '<div style="position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px" tooltips tooltip-template="' +
                                vm.severityWord[data] +
                                '" tooltip-side="right" tooltip-class="priority-tooltip"></div>';
                            return icon;
                        }),
                    DTColumnBuilder.newColumn("aligned_resource_name")
                        .withTitle("Device")
                        .renderWith((data) => {
                            if (data == null) {
                                return "";
                            } else {
                                return "<a ng-click=\"vm.goToDevice('" + data + "')\">" + data + "</a>";
                            }
                        }),
                    DTColumnBuilder.newColumn("message")
                        .withTitle("Event Mesage")
                        .renderWith((data) => {
                            return data == null ? "" : data;
                        }),
                    DTColumnBuilder.newColumn("ext_ticket_ref")
                        .withTitle("Ticket")
                        .renderWith((data, type, row) => {
                            if (data == null) {
                                return "";
                            } else {
                                return (
                                    "<a ng-click=\"vm.goToTicket('" +
                                    data +
                                    "', '" +
                                    row.force_ticket_uri.split("=").slice(2).join("=") +
                                    "');\">" +
                                    data +
                                    "</a>"
                                );
                            }
                        }),
                    DTColumnBuilder.newColumn("date_active")
                        .withTitle("Date Active")
                        .withOption("type", "date")
                        .renderWith((data) => {
                            return data == null ? "" : data;
                        })
                ];
                vm.dtOptions = DTOptionsBuilder.fromFnPromise(() => {
                    let defer = $q.defer();
                    Events.getClearedEvents(
                        (data) => {
                            vm.loading = false;
                            if (data.result_set) {
                                vm.filtered = data.result_set;
                                let suppressArray = [];
                                vm.clearedEvents = [];
                                for (var id in vm.filtered) {
                                    vm.filtered[id].aligned_resource = vm.filtered[id].aligned_resource.replace(
                                        /^.*\/(?=[^\/]*$)/,
                                        ""
                                    );
                                    if (
                                        vm.filtered[id].suppress_group != "0" &&
                                        suppressArray.indexOf(vm.filtered[id].suppress_group) > -1
                                    ) {
                                        delete vm.filtered[id];
                                    } else if (
                                        vm.filtered[id].suppress_group != "0" &&
                                        suppressArray.indexOf(vm.filtered[id].suppress_group) == -1
                                    ) {
                                        suppressArray.push(vm.filtered[id].suppress_group);
                                    }
                                }

                                vm.total_result = Object.keys(data).length;
                                for (var key in vm.filtered) {
                                    vm.filtered[key].date_active = new Date(vm.filtered[key].date_active * 1000)
                                        .toString()
                                        .substr(0, 15);
                                    vm.clearedEvents.push(vm.filtered[key]);
                                }
                                defer.resolve(vm.clearedEvents);
                            } else {
                                vm.total_result = 0;
                                vm.clearedEvents = [];
                                defer.resolve(vm.clearedEvents);
                            }
                        },
                        {
                            date_first: "DESC"
                        },
                        {},
                        page,
                        offset,
                        false
                    );
                    return defer.promise;
                })
                    .withPaginationType("full_numbers")
                    .withOption("retrieve", true)
                    .withButtons(buttonConfig)
                    .withColumnFilter(columnFilter)
                    .withOption("createdRow", (row) => {
                        $compile(angular.element(row).contents())($scope);
                    })
                    .withOption("responsive", true)
                    .withOption("iDisplayLength", 10);
                break;
        }

        vm.toggleSearch = () => {
            vm.showFilters = !vm.showFilters;
        };

        vm.goToDevice = (device) => {
            let except = false;
            for (let x = 0; x < exceptions.length; x++) {
                if (device.toLowerCase() === exceptions[x].name.toLowerCase()) {
                    except = true;
                }
            }
            if (except) {
                $state.go("index.devices", {
                    redirectedDevice: device,
                    exception: true
                });
            } else {
                $state.go("index.devices", {
                    redirectedDevice: device
                });
            }
        };

        vm.openEventProperties = (eventNumber) => {
            let modalInst = $uibModal.open({
                resolve: {
                    eventNumber: () => {
                        return eventNumber;
                    }
                },
                templateUrl: "app/events/singleevent.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "SingleEventController",
                controllerAs: "vm"
            });
            modalInst.result.then(function () {});
        };

        // some jquery handles for sliding the column width on tables
        angular.element("body").on("click", "#dt-title", () => {
            angular.element("#dt-title").remove();
            let table = angular.element(".table").DataTable();
            table.search("").columns().search("").draw();
        });

        vm.showFilters = false;
    }
})();

(function() {
    "use strict";

    angular.module("burWood").controller("ReleaseNotesController", ReleaseNotesController);

    /** @ngInject */
    function ReleaseNotesController (_, util, Service, BCSServer, $timeout) {
        let vm = this;
        vm.releaseNotes = [];
        vm.loading = true;
        let init = true;

        Service.getQuery(
            {
                releaseNote: "BCS Portal - Release",
                u_publish: "true",
                bypassCompany: true
            },
            "rm_story|releaseList",
            (response) => {
                if (response && response.results && response.results.length > 0) {
                    vm.releaseNotes = vm.compileStories(response.results);
                }
                // Chaining the query to avoid a race condition between the SNOW and backend queries
                BCSServer.getData(
                    "/release_notes_files",
                    (response) => {
                        response.filenames.forEach(fileName => {
                            vm.releaseNotes.push({
                                release: fileName.substring(0, fileName.lastIndexOf('.')),
                                fullFileName: fileName,
                                markdown: true,
                                closed: fileName.match(/\d{1,2}\.\d{1,2}\.\d{1,4}/g)[0].replaceAll('.', '/')
                            })
                        })
                        vm.releaseNotes = util.sortItems(vm.releaseNotes, "closed", "DESC", true);
                        vm.viewRelease(vm.releaseNotes[0], 0);
                        vm.loading = false;
                    }
                )
            }
        );


        vm.compileStories = (stories) => {
            let compileList = [];
            let releaseObj = {};

            stories.forEach((story) => {
                if (story["release.closed_at"] && new Date(story["release.closed_at"]) > new Date("2020-09-21")) {
                    if (!releaseObj[story["release.short_description"]]) {
                        releaseObj[story["release.short_description"]] = [story];
                    } else {
                        releaseObj[story["release.short_description"]].push(story);
                    }
                }
            });

            for (var obj in releaseObj) {
                compileList.push({
                    release: obj,
                    closed: releaseObj[obj][0]["release.closed_at"],
                    stories: releaseObj[obj]
                });
            }

            return compileList;
        }

        vm.viewRelease = (release, index) => {
            vm.selectedRelease = release;
            if(vm.selectedRelease.markdown) {
                BCSServer.getData(
                    `/release_notes_content/${vm.selectedRelease.fullFileName}`,
                    (response) => {
                        vm.selectedRelease.markdownContent = response.body;
                    }
                )
            }
            if (init) {
                $timeout(() => {
                    angular.element(".sku-title").removeClass("toggle-border");
                    angular.element("#release-" + index.toString()).addClass("toggle-border");
                    init = false;
                }, 100);
            } else {
                angular.element(".sku-title").removeClass("toggle-border");
                angular.element("#release-" + index.toString()).addClass("toggle-border");
            }
        };
    }
})();

(function () {
    "use strict";

    angular.module("burWood").controller("DocsController", DocsController);

    /** @ngInject */
    function DocsController(
        _,
        apiBasePath,
        $http,
        $scope,
        BCSServer,
        $state,
        $sce,
        $uibModal,
        FileSaver,
        Blob,
        $location,
        $anchorScroll
    ) {
        let vm = this;
        vm.hideInitPDF = false;
        vm.loading = false;
        vm.pdf = {};
        vm.tableOfContents = {};
        var bucket;

        vm.scrollTo = (id) => {
            $location.hash(id);
            $anchorScroll();
        };

        vm.trustSrc = (src) => {
            return $sce.trustAsResourceUrl(src);
        };

        vm.getPDF = (endpoint) => {
            vm.hideInitPDF = true;
            vm.loading = true;

            let route = apiBasePath + endpoint;

            let modalInst = $uibModal.open({
                resolve: {
                    message: () => {
                        return {
                            header: "Document",
                            message: "Your file is downloading.",
                            loading: true
                        };
                    }
                },
                templateUrl: "app/shared/html/downloading.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ConfirmationController",
                controllerAs: "vm"
            });

            $scope.$emit("download-start");

            $http({
                method: "GET",
                cache: false,
                url: route,
                responseType: "arraybuffer"
            }).then(
                (response) => {
                    modalInst.close();
                    vm.summaryLoading = false;
                    FileSaver.saveAs(
                        new Blob([response.data], {
                            type: "application/pdf"
                        }),
                        "Burwood Management Portal.pdf"
                    );
                },
                () => {
                    modalInst.close();
                    vm.summaryLoading = false;
                    $uibModal.open({
                        resolve: {
                            message: () => {
                                return {
                                    header: "Report Error",
                                    message:
                                        "Failed To Download Invoice. Please Contact Support for Further Assistance.",
                                    loading: false
                                };
                            }
                        },
                        templateUrl: "app/shared/html/downloading.html",
                        ariaLabelledBy: "modal-title",
                        ariaDescribedBy: "modal-body",
                        controller: "ConfirmationController",
                        controllerAs: "vm"
                    });
                }
            );
            // .then((response) => {
            //     vm.pdf.data = new Uint8Array(response.data);
            //     vm.loading = false;
            //     $timeout(function() {
            //         $window.document.title = "Burwood Management Portal";
            //     }, 100)
            // });
        };

        vm.getPDFList = () => {
            BCSServer.getData("/bcs_docs_list" + "?bucket=" + bucket, (response) => {
                if (response) {
                    vm.composeFolders(response);
                }
            });
        };

        vm.getGithubDoc = (route) => {
            vm.loading = true;

            BCSServer.getData(route, (response) => {
                if (response && response.statusCode === 200 && response.body) {
                    vm.githubDoc = response.body;
                } else {
                    vm.githubDoc = "DOCUMENT NOT FOUND";
                }
                // vm.githubDoc = 'data:text/html;base64,' + encodeURIComponent(response['content']);
                vm.loading = false;
            });
        };

        switch ($state.current.name) {
            case "index.docs":
                vm.title = "BCS Operations Guide";
                bucket = "bcs-docs";

                vm.getPDFList();

                break;
            case "index.cloud_guide":
                vm.title = "BCS Cloud Portal Guide";
                bucket = "bcs-cloud-guide";

                // vm.adminGuide = '/bcs_docs/Admin Users BCS Portal Overview.pdf?bucket=bcs-cloud-guide';

                vm.getGithubDoc("/github_admin_guide");

                // vm.getPDF(
                //     "/bcs_docs/Admin Users BCS Portal Overview.pdf?bucket=bcs-cloud-guide"
                // );

                break;
            case "index.cloud_user_guide":
                vm.title = "BCS Cloud Portal Guide";
                bucket = "bcs-cloud-guide";

                // vm.adminGuide = '/bcs_docs/Project users BCS Portal Overview.pdf?bucket=bcs-cloud-guide';

                // vm.getPDF(
                //     "/bcs_docs/Project users BCS Portal Overview.pdf?bucket=bcs-cloud-guide"
                // );

                vm.getGithubDoc("/github_user_guide");

                break;
            default:
                break;
        }

        vm.formatURI = (string) => {
            return encodeURI(string.replace(/\//g, "_"));
        };

        vm.composeFolders = (files) => {
            files.forEach((file) => {
                let folderName = file.split("/")[1];

                if (folderName) {
                    let fileName = file.split("/")[2];

                    if (!vm.tableOfContents[folderName]) {
                        vm.tableOfContents[folderName] = {
                            name: folderName,
                            files: [
                                {
                                    name: fileName,
                                    href: "/bcs_docs/" + vm.formatURI(file) + "?bucket=" + bucket
                                }
                            ]
                        };
                    } else {
                        vm.tableOfContents[folderName].files.push({
                            name: fileName,
                            href: "/bcs_docs/" + vm.formatURI(file) + "?bucket=" + bucket
                        });
                    }
                }
            });
        };
    }
})();

(function () {
    angular.module("burWood").factory("Devices", Devices);

    function Devices(ServiceNow, ScienceLogic) {
        return {
            getDevices: (callback, page_limit, offset, company, state) => {
                ServiceNow.getDevice(callback, page_limit, offset, "true", null, company, state);
            },
            getDeviceView: (callback, company, ciClass) => {
                ServiceNow.getDeviceView(callback, company, ciClass);
            },
            getItem: (id, route, callback, query_obj) => {
                ScienceLogic.getItem(id, route, callback, query_obj);
            },
            getQuery: (query_obj, table, callback) => {
                ServiceNow.getQuery(query_obj, table, callback);
            },
            getSingle: (devId, callback) => {
                ServiceNow.getItem(devId, "cmdb_ci", callback);
            },
            getDeviceReport: (tableName, page_limit, offset, sorting, company_id, getReport, fields, downloadType) => {
                return ServiceNow.getDeviceReport(
                    tableName,
                    page_limit,
                    offset,
                    sorting,
                    company_id,
                    getReport,
                    fields,
                    downloadType
                );
            },
            getReport: (
                devId,
                callback,
                interfaces,
                interfaceReport,
                interfaceId,
                noNull,
                vitals,
                vitalURL,
                getIndexes,
                frequency
            ) => {
                var query_obj = {
                    interface: interfaces,
                    interfaceReport: interfaceReport,
                    interfaceId: interfaceId,
                    noNull: noNull,
                    vitals: vitals,
                    vitalURL: vitalURL,
                    getIndexes: getIndexes,
                    frequency: frequency
                };
                ScienceLogic.getItem(devId, "device", callback, query_obj);
            },
            getInterface: (
                devId,
                callback,
                getData,
                device,
                interfaceID,
                dataIn,
                dataOut,
                beginning_date,
                ending_date,
                hourly,
                octet
            ) => {
                var query_obj = {
                    interfaceData: getData,
                    device: device,
                    interfaceID: interfaceID,
                    dataIn: dataIn,
                    dataOut: dataOut,
                    beginning_date: beginning_date,
                    ending_date: ending_date,
                    hourlyFilter: hourly,
                    octet: octet
                };
                ScienceLogic.getItem(devId, "getInterface", callback, query_obj);
            },
            createDevice: (data, callback) => {
                ServiceNow.createItem("cmdb_ci", data, callback);
            },
            updateDevice: (devId, data, callback) => {
                ServiceNow.updateItem("cmdb_ci", devId, data, callback);
            },
            deleteDevice: (devId, callback) => {
                ServiceNow.deleteItem("cmdb_ci", devId, callback);
            }
        };
    }
})();

(function () {
    angular.module("burWood").controller("DevicesController", DevicesController);

    /** @ngInject */
    function DevicesController(
        _,
        user_info,
        Devices,
        ScienceLogicGQL,
        Service,
        $stateParams,
        $window,
        $uibModal,
        $compile,
        DTOptionsBuilder,
        DTDefaultOptions,
        $timeout,
        $scope,
        $document,
        Trend,
        apiBasePath,
        moment
    ) {
        let vm = this;
        vm.loading = true;
        vm.basePath = apiBasePath;
        vm.dtInstanceDeviceList = {};
        vm.dtInstanceDeviceNotList = {};
        vm.dtInstanceStats = {};
        vm.showFilters = false;
        vm.frequency = 30;
        vm.noMonitoringData = false;
        vm.loadingSKU = true;
        vm.loadingDevices = true;
        vm.loadingBatch = true;
        vm.loadingReport = true;
        vm.showVitals = false;
        vm.showDetails = false;
        vm.finishedSKUs = false;
        vm.chosenContent = false;
        vm.chosenTable = false;
        vm.deviceList = {};
        vm.deviceList["ALL-DEVICES-IN-CONTRACT"] = [];
        vm.deviceList["DEVICES-NOT-IN-CONTRACT"] = [];
        vm.deviceByClass = [];
        vm.deviceBySKU = [];
        vm.deviceByCategory = [];
        vm.weekdayFilter = false;
        vm.hourlyFilter = false;
        vm.trendline = false;
        vm.forecast = false;
        vm.date = {
            startDate: null,
            endDate: null
        };

        if (
            user_info.company === "8d8073014f8d0300d227d48e5210c785" ||
            user_info.company === "c94993314a362312005cfc20c1aa15d2"
        ) {
            vm.burwoodUser = true;
        }

        let width = angular.element(".quarter-width").width() - 50;
        let tempDeviceHolder = [];
        var redirectedDevice;
        let redirectedInit = 0;
        let redirected = $stateParams.redirectedDevice;
        let redirectedSKU = $stateParams.redirectedSKU;
        let exception = $stateParams.exception;
        let toggleConfig = sessionStorage.getItem("toggleDeviceReport");

        if (!toggleConfig) {
            vm.toggleConfig = true;
        } else if (toggleConfig === "false") {
            vm.toggleConfig = false;
        } else {
            vm.toggleConfig = true;
        }

        vm.tableOfContents = {
            allDevices: {
                name: "All Devices",
                count: 0,
                "ALL-DEVICES-IN-CONTRACT": {
                    name: "All Devices In Contract",
                    count: 0
                },
                "DEVICES-NOT-IN-CONTRACT": {
                    name: "Devices Not In Contract",
                    count: 0
                }
            },
            deviceByClass: {
                name: "Devices By Class",
                count: 0
            },
            deviceBySKU: {
                name: "Devices By SKU",
                count: 0
            },
            deviceByLocation: {
                name: "Devices By Location",
                count: 0
            }
        };

        let defaultConfig = {
            chart: {
                type: "line",
                width: width,
                zoomType: "x",
                panning: true,
                panKey: "shift",
                height: 300
            },
            title: {
                text: "No  Info"
            },
            subtitle: {
                text: ""
            },
            xAxis: {
                categories: [],
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: ""
                }
            },
            plotOptions: {
                series: {
                    color: "#64AD61"
                }
            },
            series: [
                {
                    name: "",
                    type: "line",
                    data: []
                }
            ]
        };

        vm.config = Object.assign({}, defaultConfig);

        //resize charts to be responsive
        $timeout(() => {
            angular.element(window).resize(() => {
                angular.element(".highcharts").each(() => {
                    let chart = angular.element(this).highcharts();
                    let w = angular.element(this).closest(".device-dashboard").width();
                    chart.setSize(w * 0.925, 300, false);
                });
            });
        }, 1000);

        //toggle minimizing of sections
        vm.minimizeSection = () => {
            vm.toggleConfig = !vm.toggleConfig;
            var savetoggleON;
            if (vm.toggleConfig) {
                savetoggleON = "true";
            } else {
                savetoggleON = "false";
            }
            sessionStorage.setItem("toggleDeviceReport", savetoggleON);
        };

        vm.title = "";

        // before device table can be exported properly, the data needs to be mutated
        vm.inContractExport = (data, row, column) => {
            if (column === 0) {
                var start_pos = data.lastIndexOf(">") + 1;
                var text_to_get = data.slice(start_pos);
                return text_to_get;
            } else {
                return data;
            }
        };

        vm.toggleForecast = () => {
            vm.forecast = !vm.forecast;
            if (!vm.trendline) {
                vm.trendline = true;
            }
        };

        vm.toggleTrendline = () => {
            vm.trendline = !vm.trendline;
            if (!vm.trendline) {
                vm.forecast = false;
            }
        };

        vm.toggleBorder = ($event) => {
            let element = angular.element($event.currentTarget);
            element.siblings().removeClass("toggle-device-border");
            element.siblings().removeClass("toggle-border");
            angular.element(".child-node-row").removeClass("toggle-device-border");
            angular.element(".child-node-row").removeClass("toggle-border");
            element.addClass("toggle-device-border");
        };

        vm.replaceSpace = (name) => {
            if (name) {
                name = name.toLowerCase();
                return name.replace(/ /g, "-");
            } else {
                return name;
            }
        };

        vm.table_field_names = [
            {
                id: "cmdb_name",
                name: "Name"
            },
            {
                id: "sku_u_name",
                name: "SKU"
            },
            {
                id: "cmdb_sys_class_name",
                name: "Class"
            },
            {
                id: "cmdb_ip_address",
                name: "IP Address"
            },
            {
                id: "itemmaster_u_description",
                name: "Description"
            }
        ];

        vm.sl_states = ["Healthy", "Notice", "Minor", "Major", "Critical"];

        vm.sl_fetched, vm.sn_fetched, vm.not_contract_fetched;
        vm.sl_devices, vm.sn_devices, vm.not_contract_devices;

        //watches for event and devices data to return, then calculates values
        $scope.$watch("vm.sl_fetched", (newValue, oldValue) => {
            if (newValue !== oldValue) {
                if (vm.sn_fetched) {
                    // vm.sn_devices = mergeSLHealthData(vm.sn_fetched, vm.sl_fetched);
                    let snDevices = vm.mergeSLHealthData(vm.sn_fetched, vm.sl_fetched);
                    vm.sn_devices = vm.assignChildRelationship(snDevices, "cmdb_u_sciencelogic_id");
                    vm.processDeviceData();
                }
                if (vm.not_contract_fetched) {
                    let noContractDevices = vm.mergeSLHealthData(vm.not_contract_fetched, vm.sl_fetched);
                    vm.noContractDevices = vm.assignChildRelationship(noContractDevices, "u_sciencelogic_id");
                    vm.processNotContracted();
                }
            }
        });
        $scope.$watch("vm.sn_fetched", (newValue, oldValue) => {
            if (newValue !== oldValue) {
                if (vm.sl_fetched) {
                    // vm.sn_devices = mergeSLHealthData(vm.sn_fetched, vm.sl_fetched);
                    let snDevices = vm.mergeSLHealthData(vm.sn_fetched, vm.sl_fetched);
                    vm.sn_devices = vm.assignChildRelationship(snDevices, "cmdb_u_sciencelogic_id");
                    vm.processDeviceData();
                }
            }
        });
        $scope.$watch("vm.not_contract_fetched", (newValue, oldValue) => {
            if (newValue !== oldValue) {
                if (vm.sl_fetched) {
                    let noContractDevices = vm.mergeSLHealthData(vm.not_contract_fetched, vm.sl_fetched);
                    vm.noContractDevices = vm.assignChildRelationship(noContractDevices, "u_sciencelogic_id");
                    vm.processNotContracted();
                }
            }
        });

        vm.mergeSLHealthData = (dataset, slData) => {
            //maps the state and available status from ScienceLogic device table with SN
            if (slData.length > 0) {
                dataset.forEach((device) => {
                    slData.forEach((slDevice) => {
                        if (device.cmdb_ip_address == slDevice.ip || device.ip_address == slDevice.ip) {
                            device.sl_state = slDevice.state;
                            if (slDevice.active) {
                                device.sl_availability = "Active";
                                for (var act in slDevice.active) {
                                    if (slDevice.active[act] && act != "__typename") {
                                        device.sl_availability = act.charAt(0).toUpperCase() + act.slice(1);
                                    }
                                }
                            }
                        }
                    });
                });
            }
            return dataset;
        };

        ScienceLogicGQL.getQuery(
            {
                table: "devices",
                queryName: "allDevices",
                edge: "devices"
            },
            (response) => {
                vm.sl_fetched = response.results;
                vm.childrenDevices = vm.getChildrenDevicesList(vm.sl_fetched);
                vm.parentChildMap = vm.getChildrenDevicesMap(vm.sl_fetched);
            }
        );

        vm.processNotContracted = () => {
            vm.deviceList["DEVICES-NOT-IN-CONTRACT"] = vm.noContractDevices;
            vm.noContractDevices
                ? (vm.tableOfContents.allDevices["DEVICES-NOT-IN-CONTRACT"].count = vm.noContractDevices.length)
                : (vm.tableOfContents.allDevices["DEVICES-NOT-IN-CONTRACT"].count = 0);
            if (exception) {
                tempDeviceHolder = vm.deviceList["DEVICES-NOT-IN-CONTRACT"];
                vm.not_contract_devices.forEach((noContractDevice, index) => {
                    if (noContractDevice.name && noContractDevice.name.toUpperCase() === redirected.toUpperCase()) {
                        vm.deviceList["DEVICES-NOT-IN-CONTRACT"] = [vm.not_contract_devices[index]];
                    }
                });
                vm.chooseContent("allDevices", "DEVICES-NOT-IN-CONTRACT");
            }
        };

        vm.assignChildRelationship = (devicesToMap, prefix) => {
            let notContractedMap = angular.copy(devicesToMap);

            if (user_info.company !== "1be1693d1bd250d0beaec9176e4bcb9a") {
                devicesToMap = devicesToMap.filter((device) => {
                    if (device[prefix]) {
                        return !vm.childrenDevices.includes(device[prefix].replace(",", ""));
                    } else {
                        return false;
                    }
                });
            }

            devicesToMap.forEach((device) => {
                if (device[prefix]) {
                    let parentDev = _.findWhere(vm.parentChildMap, { device: device[prefix].replace(",", "") });
                    if (parentDev) {
                        notContractedMap.forEach((dev) => {
                            if (parentDev.children.includes(dev[prefix].replace(",", ""))) {
                                if (device.children) {
                                    device.children.push(dev);
                                } else {
                                    device.children = [dev];
                                }
                            }
                        });
                    }
                }
            });

            return devicesToMap;
        };

        vm.getChildrenDevicesList = (devices) => {
            let childrenDevices = devices
                .map((device) => {
                    if (
                        device &&
                        device.componentChildren &&
                        device.componentChildren.edges &&
                        device.componentChildren.edges.length > 0
                    ) {
                        return device.componentChildren.edges; //flatten array to remove edges
                    }
                })
                .filter((device) => {
                    return device; //remove null returns
                })
                .reduce((a, b) => {
                    return a.concat(b); // merge array of arrays
                }, [])
                .map((childDevice) => {
                    if (childDevice && childDevice.node && childDevice.node.id && childDevice.node.id != "") {
                        return childDevice.node.id; //return just name of child device
                    } else {
                        return null;
                    }
                })
                .filter((device) => {
                    return device; //remove null returns
                })
                .filter((v, i, a) => {
                    return a.indexOf(v) === i; // remove duplicated
                });
            return childrenDevices;
        };

        vm.getChildrenDevicesMap = (devices) => {
            let childrenDevices = devices
                .map((device) => {
                    if (
                        device &&
                        device.componentChildren &&
                        device.componentChildren.edges &&
                        device.componentChildren.edges.length > 0
                    ) {
                        return {
                            device: device.id,
                            children: device.componentChildren.edges
                                .map((childDevice) => {
                                    if (childDevice && childDevice.node) {
                                        return childDevice.node.id; //return just name of child device
                                    } else {
                                        return null;
                                    }
                                })
                                .filter((device) => {
                                    return device;
                                })
                        };
                    }
                })
                .filter((device) => {
                    return device && device.children && device.children.length > 0;
                });
            return childrenDevices;
        };

        vm.expandedParent = {};

        vm.expandParent = (parentDevice, prefix) => {
            vm.expandedParent = parentDevice;
            vm.expandedParent.prefix = prefix;
        };

        angular.element("body").on("click", "div.expand-parent", function () {
            let tr = angular.element(this).closest("tr");
            let table = angular.element("#device-table").DataTable();
            let row = table.row(tr);
            let childArray = vm.expandedParent.children;

            let childNodes = vm.formatChildren(childArray, vm.expandedParent.prefix);

            if (row.child.isShown()) {
                row.child.hide();
                tr.removeClass("shown");
            } else {
                row.child(childNodes, "child-parent-row").show();
                tr.addClass("shown");
            }
        });

        vm.getTableColumnWidths = () => {
            let widthArr = [];
            angular.element("#device-table thead tr th").each(function () {
                widthArr.push(angular.element(this).outerWidth() + "px");
            });
            return widthArr;
        };

        vm.params = {};

        vm.formatChildren = (children, prefix) => {
            let childNodes = [];
            let columnWidths = vm.getTableColumnWidths();
            children.forEach((item) => {
                let location = item[prefix + "location"];
                !location ? (location = " ") : (location = location.display_value);

                var param0 = item[prefix + "sys_id"];
                var param1 = item[prefix + "u_sciencelogic_id"];
                var param2 = item[prefix + "name"];
                var param3 = item;

                vm[param0] = param0;
                vm[param1] = param1;
                vm[param2] = param2;
                vm[param3[prefix + "ip_address"]] = item;

                let singleNode =
                    '<table id="childTable">' +
                    "<tbody>" +
                    '<tr class="child-node-row" style="background-color:transparent" ng-click="vm.chooseDevice(vm[' +
                    "'" +
                    param1 +
                    "'" +
                    "], vm[" +
                    "'" +
                    param2 +
                    "'" +
                    ']);vm.toggleBorder($event)">' +
                    '<td style="width:' +
                    columnWidths[0] +
                    '" class="childRow"></td>' +
                    '<td style="width:' +
                    columnWidths[1] +
                    '" class="childRow"><input type="checkbox" class="form-control" style="z-index:1000;width: 16px;margin: -4px;margin-left: 4px;" ng-model="vm.checkedDevice[' +
                    "'" +
                    param2 +
                    "'" +
                    ']" ng-click="$event.stopPropagation()" ng-change="vm.checkDevice(vm[' +
                    "'" +
                    param2 +
                    "'" +
                    "], vm[" +
                    "'" +
                    param1 +
                    "'" +
                    "], vm[" +
                    "'" +
                    param0 +
                    "'" +
                    '])"></td>' +
                    '<td style="width:' +
                    columnWidths[2] +
                    '" class="childRow">CHILD</td>' +
                    '<td style="width:' +
                    columnWidths[3] +
                    '" class="childRow">' +
                    item[prefix + "name"] +
                    "</td>" +
                    '<td style="width:' +
                    columnWidths[4] +
                    '" class="childRow">' +
                    item[prefix + "sys_class_name"] +
                    "</td>" +
                    '<td style="width:' +
                    columnWidths[5] +
                    '" class="childRow">' +
                    location +
                    "</td>" +
                    '<td style="width:' +
                    columnWidths[6] +
                    '" class="childRow">' +
                    item[prefix + "ip_address"] +
                    "</td>" +
                    '<td style="width:' +
                    columnWidths[7] +
                    '" class="childRow">' +
                    vm.sl_states[item.sl_state] +
                    "</td>" +
                    '<td style="width:' +
                    columnWidths[8] +
                    '" class="childRow">' +
                    item.sl_availability +
                    "</td>" +
                    '<td style="width:' +
                    columnWidths[9] +
                    '" class="childRow">' +
                    '<i class="fas fa-wrench" ng-click="vm.openDeviceProperties(vm[' +
                    "'" +
                    param3[prefix + "ip_address"] +
                    "'" +
                    '])"></i>' +
                    "</td>" +
                    "</tr>" +
                    "</tbody>" +
                    "</table>";

                singleNode = $compile(singleNode)($scope);
                childNodes.push(singleNode);
            });
            return childNodes;
        };

        //gets devices monitored but not in contract
        Service.getExceptions((data) => {
            if (data.err || !data.results) {
                vm.error = true;
            } else {
                vm.not_contract_fetched = data.results;
                // vm.tableOfContents.allDevices['DEVICES-NOT-IN-CONTRACT'].count = parseInt(data.count);
            }
        }, user_info.company);

        //get all the devices from the u_devicebysku table in SNOW.  Sets up the device object sorted by In-Contract and Not-In-Contract
        Devices.getDeviceView((data) => {
            vm.loading = false;
            if (data.err || !data.results) {
                vm.error = true;
                vm.devices = [];
            } else {
                vm.sn_fetched = data.results;
                vm.tableOfContents.allDevices["ALL-DEVICES-IN-CONTRACT"].count = data.count;
            }
        }, user_info.company);

        vm.selectRedirectedDevice = () => {
            vm.devices.forEach((device) => {
                if (device.cmdb_name && device.cmdb_name.toUpperCase() === redirected.toUpperCase()) {
                    redirectedDevice = device;
                }
            });
        };

        vm.processRedirectedDevice = () => {
            vm.chosenContent = "ALL-DEVICES-IN-CONTRACT";
            if (redirectedSKU) {
                vm.loadingDevices = true;
                vm.loadingSKU = true;
            } else if (redirected) {
                vm.selectRedirectedDevice();
                if (redirectedDevice) {
                    tempDeviceHolder = vm.deviceList["ALL-DEVICES-IN-CONTRACT"];
                    vm.deviceList["ALL-DEVICES-IN-CONTRACT"] = [redirectedDevice];
                    vm.chooseContent("allDevices", vm.chosenContent);
                } else {
                    vm.loadingDevices = false;
                    vm.noMonitoringData = true;
                }
            } else {
                vm.chooseContent("allDevices", vm.chosenContent);
            }
        };

        vm.processDeviceData = () => {
            vm.devices = vm.sn_devices;
            vm.deviceList["ALL-DEVICES-IN-CONTRACT"] = vm.devices;
            vm.chosenTable = "allDevices";
            let deviceCount = 0;
            if (!exception) {
                vm.processRedirectedDevice();
            }
            for (let x = 0; x < vm.devices.length; x++) {
                let dCount = x;
                let sku = vm.devices[dCount].sku_u_name;
                let devClass = vm.devices[dCount].cmdb_sys_class_name;
                var location;
                devClass === null ? (devClass = "No Category") : devClass;
                sku === null ? (sku = "No SKU") : sku;
                if (!vm.devices[dCount].cmdb_location) {
                    location = "No Location";
                } else {
                    location = vm.devices[dCount].cmdb_location.display_value.replace(/\//g, ".").replace(/\(|\)/g, "");
                }
                if (!vm.tableOfContents.deviceByClass[devClass]) {
                    vm.tableOfContents.deviceByClass[devClass] = {
                        name: devClass,
                        count: 1
                    };
                    vm.tableOfContents.deviceByClass.count++;
                    vm.deviceList[devClass] = [];
                    vm.deviceList[devClass].push(vm.devices[dCount]);
                } else {
                    vm.tableOfContents.deviceByClass.count++;
                    vm.tableOfContents.deviceByClass[devClass].count++;
                    vm.deviceList[devClass].push(vm.devices[dCount]);
                }
                if (!vm.tableOfContents.deviceBySKU[sku]) {
                    vm.tableOfContents.deviceBySKU[sku] = {
                        name: sku,
                        count: 1
                    };
                    vm.tableOfContents.deviceBySKU.count++;
                    vm.deviceList[sku] = [];
                    vm.deviceList[sku].push(vm.devices[dCount]);
                } else {
                    vm.tableOfContents.deviceBySKU.count++;
                    vm.tableOfContents.deviceBySKU[sku].count++;
                    vm.deviceList[sku].push(vm.devices[dCount]);
                }
                if (!vm.tableOfContents.deviceByLocation[location]) {
                    vm.tableOfContents.deviceByLocation[location] = {
                        name: location,
                        count: 1
                    };
                    vm.tableOfContents.deviceByLocation.count++;
                    vm.deviceList[location] = [];
                    vm.deviceList[location].push(vm.devices[dCount]);
                } else {
                    vm.tableOfContents.deviceByLocation.count++;
                    vm.tableOfContents.deviceByLocation[location].count++;
                    vm.deviceList[location].push(vm.devices[dCount]);
                }
                deviceCount++;
                if (deviceCount === vm.devices.length) {
                    vm.loadingSKU = false;
                    vm.orderKeys(vm.tableOfContents.deviceByClass);
                    vm.orderKeys(vm.tableOfContents.deviceBySKU);
                    if (!exception && redirectedSKU) {
                        vm.chooseContent("deviceBySKU", redirectedSKU);
                        redirectedSKU = false;
                    }
                }
            }
            if (vm.devices.length === 0) {
                vm.loadingSKU = false;
                vm.loadingDevices = false;
            } else {
                let ordered = {};
                Object.keys(vm.tableOfContents.deviceByLocation)
                    .sort()
                    .forEach((key) => {
                        ordered[key] = vm.tableOfContents.deviceByLocation[key];
                    });
                vm.tableOfContents.deviceByLocation = ordered;
            }
        };

        vm.orderKeys = (obj) => {
            let keys = Object.keys(obj).sort(function keyOrder(k1, k2) {
                if (k1 < k2) return -1;
                else if (k1 > k2) return +1;
                else return 0;
            });
            var i,
                after = {};
            for (i = 0; i < keys.length; i++) {
                after[keys[i]] = obj[keys[i]];
                delete obj[keys[i]];
            }
            for (i = 0; i < keys.length; i++) {
                obj[keys[i]] = after[keys[i]];
            }
            return obj;
        };

        //function that run when content from the left panel is selected - SKU, CLASS, Location, etc
        vm.chooseContent = (table, key) => {
            vm.noMonitoringData = false;
            vm.interfaces = {};
            vm.loadingBatch = true;
            vm.loadingDevices = true;
            angular.element(".sku-title").removeClass("toggle-border");
            angular.element("#" + vm.replaceSpace(key)).addClass("toggle-border");
            let noSKU = !(key in vm.deviceList);
            if (noSKU) {
                vm.chosenTable = "allDevices";
                vm.chosenContent = "ALL-DEVICES-IN-CONTRACT";
            } else {
                vm.chosenTable = table;
                vm.chosenContent = key;
            }
            let chosenList = Object.keys(vm.deviceList[vm.chosenContent])[0];
            let chosenListItem = vm.deviceList[vm.chosenContent][chosenList];
            if (redirected && redirectedInit > 0 && !vm.noMonitoringData) {
                if (exception) {
                    vm.deviceList["DEVICES-NOT-IN-CONTRACT"] = tempDeviceHolder;
                    exception = false;
                } else {
                    if (redirectedDevice) {
                        vm.deviceList["ALL-DEVICES-IN-CONTRACT"] = tempDeviceHolder;
                    } else {
                        vm.deviceList["ALL-DEVICES-IN-CONTRACT"] = vm.devices;
                    }
                }
                redirected = false;
                vm.title = vm.chosenContent;
                if (vm.chosenContent === "DEVICES-NOT-IN-CONTRACT") {
                    if (chosenList && chosenListItem && chosenListItem.u_sciencelogic_id) {
                        vm.chooseDevice(chosenListItem.u_sciencelogic_id, chosenListItem.name);
                    } else {
                        vm.loadingBatch = false;
                        vm.loadingReport = false;
                    }
                } else {
                    if (chosenList && chosenListItem && chosenListItem.cmdb_u_sciencelogic_id) {
                        vm.chooseDevice(chosenListItem.cmdb_u_sciencelogic_id, chosenListItem.cmdb_name);
                    } else {
                        vm.loadingBatch = false;
                        vm.loadingReport = false;
                    }
                }
            } else if (redirected) {
                redirectedInit++;
                if (exception) {
                    vm.chosenContent = "DEVICES-NOT-IN-CONTRACT";
                    vm.title = redirected;
                } else {
                    vm.chosenContent = "ALL-DEVICES-IN-CONTRACT";
                    vm.title = vm.chosenContent;
                }
                if (vm.chosenContent === "DEVICES-NOT-IN-CONTRACT") {
                    if (chosenList && chosenListItem && chosenListItem.u_sciencelogic_id) {
                        vm.chooseDevice(chosenListItem.u_sciencelogic_id, chosenListItem.name);
                    } else {
                        vm.loadingBatch = false;
                        vm.loadingReport = false;
                    }
                } else {
                    if (chosenList && chosenListItem && chosenListItem.cmdb_u_sciencelogic_id) {
                        vm.chooseDevice(chosenListItem.cmdb_u_sciencelogic_id, chosenListItem.cmdb_name);
                    } else {
                        vm.loadingBatch = false;
                        vm.loadingReport = false;
                    }
                }
            } else {
                vm.title = vm.chosenContent;
                if (vm.chosenContent === "DEVICES-NOT-IN-CONTRACT") {
                    if (chosenList && chosenListItem && chosenListItem.u_sciencelogic_id) {
                        vm.chooseDevice(chosenListItem.u_sciencelogic_id, chosenListItem.name);
                    } else {
                        vm.loadingBatch = false;
                        vm.loadingReport = false;
                    }
                } else {
                    if (chosenList && chosenListItem && chosenListItem.cmdb_u_sciencelogic_id) {
                        vm.chooseDevice(chosenListItem.cmdb_u_sciencelogic_id, chosenListItem.cmdb_name);
                    } else {
                        vm.loadingBatch = false;
                        vm.loadingReport = false;
                    }
                }
            }
            $timeout(() => {
                vm.loadingDevices = false;
            }, 1500);
        };

        vm.selectedDevices = {};
        vm.selectedSysIDs = {};
        vm.showSelectedDevices = false;
        vm.selectedVitals = {
            // 'Availability': true,
            // 'Latency': true,
            Filesys: false,
            CPU: true,
            Memory: true,
            Swap: true
        };

        vm.multipleSelectedDevices = false;
        vm.selectMessage = "Select All";
        vm.selectKey = "selectAll";

        vm.checkDevice = (device, id, sys_id) => {
            if (!vm.selectedDevices[device]) {
                vm.selectedSysIDs[device] = sys_id;
                vm.selectedDevices[device] = id.replace(",", "");
            } else {
                delete vm.selectedDevices[device];
                delete vm.selectedSysIDs[device];
            }
            if (!angular.equals({}, vm.selectedDevices)) {
                vm.runSelectedDevices();
            } else {
                vm.runSelectedDevices("clear");
            }
            if (Object.keys(vm.selectedDevices).length === 0 || Object.keys(vm.selectedDevices).length === 1) {
                vm.multipleSelectedDevices = false;
                vm.selectMessage = "Select All";
                vm.selectKey = "selectAll";
            } else {
                vm.multipleSelectedDevices = true;
                vm.selectMessage = "Deselect All";
                vm.selectKey = "clear";
            }
        };

        vm.alerts = [];
        vm.close_notice = (index) => {
            vm.alerts.splice(index, 1);
        };

        // runs when devices from the device selected and button pushed
        vm.runSelectedDevices = (method) => {
            if (method === "clear") {
                vm.selectedDevices = {};
                vm.checkedDevice = {};
                vm.showInterfaces = true;
                vm.showSelectedDevices = false;
                vm.multipleSelectedDevices = false;
                vm.selectMessage = "Select All";
                vm.selectKey = "selectAll";
            } else if (method === "selectAll") {
                vm.selectedDevices = {};
                vm.checkedDevice = {};
                vm.showSelectedDevices = true;
                vm.multipleSelectedDevices = true;
                vm.showInterfaces = false;
                vm.selectMessage = "Deselect All";
                vm.selectKey = "clear";
                if (vm.chosenContent === "DEVICES-NOT-IN-CONTRACT") {
                    vm.setSelectedDeviceSLID("");
                } else {
                    vm.setSelectedDeviceSLID("cmdb_");
                }
            } else {
                if (Object.keys(vm.selectedDevices).length === 0) {
                    vm.showSelectedDevices = false;
                    vm.selectMessage = "Select All";
                    vm.selectKey = "selectAll";
                    vm.alerts = [
                        {
                            type: "danger",
                            msg: "No Devices Selected"
                        }
                    ];
                } else if (Object.keys(vm.selectedDevices).length > 1) {
                    vm.showSelectedDevices = true;
                    vm.showInterfaces = false;
                    vm.selectMessage = "Deselect All";
                    vm.selectKey = "clear";
                    angular.element(".interface-row").removeClass("toggle-device-border");
                    angular.element(".interface-row").removeClass("toggle-border");
                } else {
                    vm.showSelectedDevices = false;
                }
            }
        };

        vm.setSelectedDeviceSLID = (sl_identifier) => {
            vm.deviceList[vm.chosenContent].forEach((device) => {
                vm.selectedDevices[device[sl_identifier + "name"]] = device[
                    sl_identifier + "u_sciencelogic_id"
                ].replace(",", "");
                vm.checkedDevice[device[sl_identifier + "name"]] = true;
            });
        };

        vm.setVitalsInit = (type) => {
            vm[type] = {};
            vm[type].averageText = "Show Average";
            vm[type].peakText = "Show Peak Data";
            vm[type].legendText = "Hide Legend";
            vm[type].monthToggle = false;
            vm[type].individualMetrics = {};
            vm[type].individualMetricsPeaks = {};
            vm[type].vitalCategories = [];
            vm[type].vitalStats = [];
            vm[type].vitalStatsPeaks = [];
            vm[type].vitalDevCount = 0;
            vm[type].hasData = false;
            vm[type].title = type;
            vm[type].loadingReport = true;
            vm.reportType = "Selected Devices";
            vm.loadingBatch = false;
            switch (type) {
                case "CPU":
                    vm.metricDetails.push({
                        id: "AFF64E74C73D96244F7DB426158A359F",
                        name: type,
                        label: "CollectionLabel"
                    });
                    break;
                case "Memory":
                    vm.metricDetails.push({
                        id: "C36F10744B4BCA7C91CD1C405BC568C0",
                        name: type,
                        label: "CollectionLabel"
                    });
                    break;
                case "Swap":
                    vm.metricDetails.push({
                        id: "BAC2484664F897DDBC2FECB0BD798E04",
                        name: type,
                        label: "CollectionLabel"
                    });
                    break;
                case "Availability":
                    vm.metricDetails.push({
                        id: "d_check",
                        name: type,
                        label: "Availability"
                    });
                    break;
                case "Latency":
                    vm.metricDetails.push({
                        id: "d_latency",
                        name: type,
                        label: "Availability"
                    });
                    break;
                case "Filesys":
                    vm.metricDetails.push({
                        id: "d_percent",
                        name: type,
                        label: "FileSystem"
                    });
                    break;
                default:
                    break;
            }
        };

        vm.composeSelectedVitalArray = () => {
            let vitalArray = [];
            let rowIndex = 0;
            for (var type in vm.selectedVitals) {
                if (vm.selectedVitals[type]) {
                    let chartIndex = rowIndex % 4;
                    vm.chartRows[chartIndex][type] = true;
                    rowIndex++;
                    vitalArray.push(type);
                }
            }
            return vitalArray;
        };

        function convertEM7ArraytoObject(array) {
            let returnObj = {};
            array.forEach((item) => {
                returnObj[item.timestamp] = item.value;
            });
            return returnObj;
        }

        // contructs the uri endpoint for EM7 stats
        vm.getSelectedDeviceReport = (expandConfig, singleMetric) => {
            vm.metricDetails = [];
            var metricsToRun;
            singleMetric
                ? (metricsToRun = [singleMetric])
                : (metricsToRun = vm.composeSelectedVitalArray(vm.selectedVitals));
            metricsToRun.forEach((type) => {
                vm.setVitalsInit(type);
            });
            vm.runSelectedVitals(expandConfig);
        };

        // build available report type for selected devices
        vm.runSelectedVitals = (expandConfig, type) => {
            expandConfig && vm.setVitalsInit(type);
            let selectedDevices = vm.selectedDevices;
            if (
                (vm.multipleSelectedDevices && !vm.showSelectedDevices) ||
                Object.keys(vm.selectedDevices).length === 0
            ) {
                selectedDevices = {};
                selectedDevices[vm.chosenDeviceName] = vm.chosenDevice;
            }
            let selectedDeviceIDs = [];
            let selectedDeviceNames = [];
            for (var dev in selectedDevices) {
                selectedDeviceNames.push(dev);
                selectedDeviceIDs.push(selectedDevices[dev]);
            }
            var rollupFreq;
            vm.hourlyFilter ? (rollupFreq = "hourly") : (rollupFreq = "daily");
            ScienceLogicGQL.getQuery(
                {
                    table: "metrics",
                    queryName: "metricsMultivalues",
                    edge: "deviceMetrics",
                    search: {
                        devices: selectedDeviceIDs,
                        beginDate: vm.start * 1000,
                        endDate: vm.end * 1000,
                        rollupFrequency: rollupFreq,
                        metricDetails: vm.metricDetails
                    }
                },
                (response) => {
                    var vitalsToProcess;
                    type
                        ? (vitalsToProcess = [type])
                        : (vitalsToProcess = vm.composeSelectedVitalArray(vm.selectedVitals));
                    vitalsToProcess.forEach((type) => {
                        vm[type].devLength = selectedDeviceNames.length;
                        selectedDeviceNames.forEach((dev, index) => {
                            let devID = selectedDeviceIDs[index];
                            if (
                                response.data &&
                                response.data["device" + devID] &&
                                response.data["device" + devID]["deviceAVG" + type] &&
                                response.data["device" + devID]["deviceAVG" + type][0] &&
                                response.data["device" + devID]["deviceAVG" + type][0].multiValues &&
                                response.data["device" + devID]["deviceAVG" + type][0].multiValues[0] &&
                                response.data["device" + devID]["deviceAVG" + type][0].multiValues[0].edges &&
                                response.data["device" + devID]["deviceAVG" + type][0].multiValues[0].edges.length > 0
                            ) {
                                let rawEdge =
                                    response.data["device" + devID]["deviceAVG" + type][0].multiValues[0].edges;
                                let rawEdgePeak =
                                    response.data["device" + devID]["deviceMAX" + type][0].multiValues[0].edges;
                                let dataObj = convertEM7ArraytoObject(rawEdge);
                                let peakObj = convertEM7ArraytoObject(rawEdgePeak);
                                let tempCount = 0;
                                vm[type].individualMetrics[dev] = [];
                                vm[type].individualMetricsPeaks[dev] = [];
                                for (var time in dataObj) {
                                    if (vm[type].vitalDevCount == 0 || vm[type].vitalCategories.length === 0) {
                                        if (vm.hourlyFilter) {
                                            vm[type].vitalCategories.push(
                                                moment(time * 1000).format("ddd MMM DD YYYY hh:mm:ss A")
                                            );
                                        } else {
                                            vm[type].vitalCategories.push(
                                                moment(time * 1000).format("ddd MMM DD YYYY")
                                            );
                                        }
                                        vm[type].vitalStats.push(Number(dataObj[time]));
                                        vm[type].vitalStatsPeaks.push(Number(peakObj[time]));
                                    } else {
                                        vm[type].vitalStats[tempCount] += Number(dataObj[time]);
                                        vm[type].vitalStatsPeaks[tempCount] += Number(peakObj[time]);
                                    }
                                    if (vm.hourlyFilter) {
                                        vm[type].individualMetrics[dev].push([
                                            moment(new Date(time * 1000)).format("ddd MMM DD YYYY hh:mm:ss A"),
                                            Number(Number(dataObj[time]).toFixed(2))
                                        ]);
                                        vm[type].individualMetricsPeaks[dev].push([
                                            moment(new Date(time * 1000)).format("ddd MMM DD YYYY hh:mm:ss A"),
                                            Number(Number(peakObj[time]).toFixed(2))
                                        ]);
                                    } else {
                                        vm[type].individualMetrics[dev].push([
                                            moment(new Date(time * 1000)).format("ddd MMM DD YYYY"),
                                            Number(Number(dataObj[time]).toFixed(2))
                                        ]);
                                        vm[type].individualMetricsPeaks[dev].push([
                                            moment(new Date(time * 1000)).format("ddd MMM DD YYYY"),
                                            Number(Number(peakObj[time]).toFixed(2))
                                        ]);
                                    }
                                    tempCount++;
                                }
                                vm[type].vitalDevCount++;
                            } else {
                                //if no data
                                vm[type].loadingReport = false;
                                vm[type].stats = [];
                                vm[type].config = Object.assign({}, defaultConfig);
                            }
                        });
                        vm.processSelectedMetrics(type, expandConfig);
                    });
                }
            );
        };

        // build config reports, and table for selected device report
        vm.processSelectedMetrics = (type, expandConfig) => {
            vm.firstColumnName = "Date";
            vm.secondColumnName = "Value";
            vm[type].individualMetricStats = {};
            vm[type].individualMetricStatsPeaks = {};
            let tempArray = [];
            let tempArrayPeaks = [];
            let availabilityTableData = [];
            for (let x = 0; x < vm[type].vitalStats.length; x++) {
                vm[type].vitalStats[x] = Number((vm[type].vitalStats[x] / vm[type].devLength).toFixed(2));
                vm[type].vitalStatsPeaks[x] = Number((vm[type].vitalStatsPeaks[x] / vm[type].devLength).toFixed(2));
                tempArray.push([vm[type].vitalCategories[x], vm[type].vitalStats[x]]);
                tempArrayPeaks.push([vm[type].vitalCategories[x], vm[type].vitalStatsPeaks[x]]);
            }
            if (type === "Availability") {
                availabilityTableData = vm.processAvailabilityTableData(type);
                vm.firstColumnName = "Device";
                vm.secondColumnName = "Average Availability";
            }
            //add weekday filter
            if (vm.weekdayFilter) {
                tempArray = vm.removeWeekends(tempArray);
                for (var dev in vm[type].individualMetrics) {
                    vm[type].individualMetrics[dev] = vm.removeWeekends(vm[type].individualMetrics[dev]);
                    vm[type].individualMetricsPeaks[dev] = vm.removeWeekends(vm[type].individualMetricsPeaks[dev]);
                }
            }
            //adds forecast
            if (vm.forecast) {
                tempArray = vm.addForecastDates(tempArray);
                for (var dev2 in vm[type].individualMetrics) {
                    vm[type].individualMetrics[dev2] = vm.addForecastDates(vm[type].individualMetrics[dev2]);
                    vm[type].individualMetricsPeaks[dev2] = vm.addForecastDates(vm[type].individualMetricsPeaks[dev2]);
                }
            }
            let categories = [];
            let finalStats = [];
            let finalStatsPeaks = [];
            tempArray.forEach((item) => {
                categories.push(item[0]);
                finalStats.push(item[1]);
            });
            tempArrayPeaks.forEach((item) => {
                finalStatsPeaks.push(item[1]);
            });
            for (var dev3 in vm[type].individualMetrics) {
                vm[type].individualMetricStats[dev3] = [];
                vm[type].individualMetricStatsPeaks[dev3] = [];
                vm[type].individualMetrics[dev3].forEach((device) => {
                    if (type === "Availability") {
                        vm[type].individualMetricStats[dev3].push(device[1] * 100);
                    } else {
                        vm[type].individualMetricStats[dev3].push(device[1]);
                    }
                });
                vm[type].individualMetricsPeaks[dev3].forEach((device) => {
                    if (type === "Availability") {
                        vm[type].individualMetricStatsPeaks[dev3].push(device[1] * 100);
                    } else {
                        vm[type].individualMetricStatsPeaks[dev3].push(device[1]);
                    }
                });
            }
            if (type === "Availability") {
                vm[type].stats = availabilityTableData;
            } else {
                vm[type].stats = tempArray;
            }
            vm[type].loadingReport = false;
            let colors = [
                "#31b4e8",
                "#FFB399",
                "#FF33FF",
                "#FFFF99",
                "#00B3E6",
                "#E6B333",
                "#3366E6",
                "#999966",
                "#99FF99",
                "#B34D4D",
                "#80B300",
                "#809900",
                "#E6B3B3",
                "#6680B3",
                "#66991A",
                "#FF99E6",
                "#CCFF1A",
                "#FF1A66",
                "#E6331A",
                "#33FFCC",
                "#66994D",
                "#B366CC",
                "#4D8000",
                "#B33300",
                "#CC80CC",
                "#66664D",
                "#991AFF",
                "#E666FF",
                "#4DB3FF",
                "#1AB399",
                "#E666B3",
                "#33991A",
                "#CC9999",
                "#B3B31A",
                "#00E680",
                "#4D8066",
                "#809980",
                "#E6FF80",
                "#1AFF33",
                "#999933",
                "#FF3380",
                "#CCCC00",
                "#66E64D",
                "#4D80CC",
                "#9900B3",
                "#E64D66",
                "#4DB380",
                "#FF4D4D",
                "#99E6E6",
                "#6666FF"
            ];
            let yLabel = type === "Latency" ? "Milliseconds" : "Utilization %";
            vm[type].config = {};
            vm[type].config = {
                chart: {
                    type: "line",
                    width: width,
                    zoomType: "x",
                    panning: true,
                    panKey: "shift",
                    height: 300
                },
                title: {
                    text: type
                },
                subtitle: {
                    text: "Click and drag to zoom in."
                },
                legend: {
                    maxHeight: 60
                },
                xAxis: {
                    categories: categories,
                    crosshair: true
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: yLabel
                    }
                },
                series: []
            };
            if (vm.multipleSelectedDevices && !vm.showInterfaces && vm.showSelectedDevices) {
                vm[type].config.series.push({
                    name: "Average",
                    color: "#46B267",
                    lineWidth: 5,
                    data: finalStats
                });
            }
            let colorCount = 0;
            for (var dev4 in vm[type].individualMetricStats) {
                vm[type].config.series.push({
                    name: dev4,
                    color: colors[colorCount],
                    data: vm[type].individualMetricStats[dev4]
                });
                colorCount++;
            }
            for (var dev5 in vm[type].individualMetricStatsPeaks) {
                vm[type].config.series.push({
                    name: dev5 + " = Peak",
                    color: colors[colorCount],
                    data: vm[type].individualMetricStatsPeaks[dev5],
                    visible: false
                });
                colorCount++;
            }
            //add trendline to report if selected
            if (vm.trendline) {
                let trendSeries = {
                    type: "line",
                    name: "Trend",
                    color: "#567dff",
                    marker: {
                        enabled: false
                    },
                    data: (() => {
                        return Trend(finalStats, null, vm.forecast, vm.hourlyFilter).data;
                    })()
                };
                vm[type].config.series.push(trendSeries);
                let trendSeriesPeak = {
                    type: "line",
                    name: "Trend - Peak",
                    color: "#567dff",
                    visible: false,
                    marker: {
                        enabled: false
                    },
                    data: (() => {
                        return Trend(finalStatsPeaks, null, vm.forecast, vm.hourlyFilter).data;
                    })()
                };
                vm[type].config.series.push(trendSeriesPeak);
            }
            if (expandConfig) {
                if (expandConfig.type === "expanded") {
                    vm.modalInst.close();
                    vm.resetReport = true;
                    vm[type].averageText = expandConfig.averageText;
                    vm[type].peakText = expandConfig.peakText;
                    vm.expandReport(vm[type], {
                        reportType: vm.reportType,
                        dataType: vm.dataType,
                        unit: vm.tableUnit,
                        header1: vm.firstColumnName,
                        header2: vm.secondColumnName
                    });
                } else if (expandConfig.type === "collapsed") {
                    vm.modalInst.close();
                    vm.resetReport = false;
                    vm[type].averageText = expandConfig.averageText;
                    vm[type].peakText = expandConfig.peakText;
                    vm.expandReport(
                        vm[type],
                        {
                            reportType: vm.reportType,
                            dataType: vm.dataType,
                            unit: vm.tableUnit,
                            header1: vm.firstColumnName,
                            header2: vm.secondColumnName
                        },
                        true
                    );
                } else if (expandConfig.type === "exit") {
                    vm.modalInst.close();
                    $timeout(() => {
                        expandConfig.averageText === "Show All" ? vm.showSeries(type) : null;
                        expandConfig.peakText === "Show Averaged Data" ? vm.showPeaks(type) : null;
                    }, 250);
                    vm.resetReport = false;
                }
            }
        };

        vm.processAvailabilityTableData = (type) => {
            let tempAvailabilityData = {};
            let returnData = [];
            for (var dev in vm[type].individualMetrics) {
                tempAvailabilityData[dev] = [];
                vm[type].individualMetrics[dev].forEach((device) => {
                    tempAvailabilityData[dev].push(device[1]);
                });
            }
            for (var item in tempAvailabilityData) {
                let tempData = 0;
                tempAvailabilityData[item].forEach((device) => {
                    tempData += device;
                });
                tempData = tempData / tempAvailabilityData[item].length;
                tempData = tempData.toFixed(2);
                returnData.push([item, tempData]);
            }
            return returnData;
        };

        vm.showSeries = (chartID) => {
            let chart = angular.element("#" + chartID).highcharts();
            let series = chart.series[1];
            if (vm[chartID].peakText === "Show Averaged Data") {
                vm.showPeaks(chartID);
            }
            if (series.visible) {
                angular.element(chart.series).each(function (index, item) {
                    if (item.name != "Average") {
                        this.setVisible(false, false);
                    }
                });
                chart.redraw();
                chartID ? (vm[chartID].averageText = "Show All") : "";
            } else {
                angular.element(chart.series).each(function (index, item) {
                    if (item.name != "Average") {
                        this.setVisible(true, false);
                    }
                });
                chart.redraw();
                chartID ? (vm[chartID].averageText = "Show Average") : "";
            }
        };

        vm.showPeaks = (chartID, single) => {
            let chart = angular.element("#" + chartID).highcharts();
            single ? (chart = angular.element("#single-device-chart").highcharts()) : null;
            if (vm[chartID].peakText === "Show Peak Data") {
                angular.element(chart.series).each(function (index, item) {
                    if (!item.name.includes("Peak")) {
                        this.setVisible(false, false);
                    } else {
                        this.setVisible(true, false);
                    }
                });
                chart.redraw();
                chartID ? (vm[chartID].peakText = "Show Averaged Data") : "";
            } else {
                angular.element(chart.series).each(function (index, item) {
                    if (item.name.includes("Peak")) {
                        this.setVisible(false, false);
                    } else {
                        this.setVisible(true, false);
                    }
                });
                chart.redraw();
                chartID ? (vm[chartID].peakText = "Show Peak Data") : "";
            }
        };

        vm.showLegend = (chartID, single) => {
            let chart = angular.element("#" + chartID).highcharts();
            var config;
            if (single) {
                angular.element("#single-device-chart").highcharts();
                config = vm.chart;
            } else {
                config = vm[chartID];
            }
            if (config.legendText === "Hide Legend") {
                config.config.legend.enabled = false;
                config.legendText = "Show Legend";
                chart.redraw();
            } else {
                config.config.legend.enabled = true;
                config.legendText = "Hide Legend";
                chart.redraw();
            }
        };

        vm.chooseDevice = (device, name) => {
            if (device.indexOf(",") != -1) {
                device = device.replace(/,/g, "");
            }
            vm.chosenDevice = device;
            vm.chosenDeviceName = name;
            vm.getInterface(device);
            vm.getDetails(device);
            vm.loadingReport = true;
            vm.showSelectedDevices = false;
        };

        //populates the details paine for each device
        vm.getDetails = (id) => {
            Devices.getItem(
                id,
                "device",
                (data) => {
                    data = data.result_set;
                    if (data && data.snmp_data) {
                        vm.details = data.snmp_data;
                        let index = vm.details.sysdescr.indexOf("Technical Support");
                        index != -1
                            ? (vm.details.sysdescr = vm.details.sysdescr.substr(0, index))
                            : vm.details.sysdescr;
                        vm.details.sysuptime = (vm.details.sysuptime / 1000 / 60 / 60 / 24).toFixed(2) + " Days";
                        vm.details.last_poll = moment(vm.details.last_poll * 1000).format("MMMM DD, YYYY");
                    }
                },
                {
                    detail: true
                }
            );
        };

        vm.toMegabits = (bits) => {
            return (bits / 1000 / 1000 / 100).toFixed(2);
        };

        vm.displayDetails = () => {
            vm.showInterfaces = false;
            vm.showVitals = false;
            vm.showDetails = true;
        };

        vm.getInterface = () => {
            vm.loadingBatch = true;
            vm.error = false;
            vm.showInterfaces = true;
            vm.noInterface = true;
            vm.interfaces = {};
            vm.showDetails = false;
            vm.interfaceData = {};
            vm.chartRows = [{}, {}, {}, {}];

            ScienceLogicGQL.getQuery(
                {
                    table: "metrics",
                    queryName: "interfaceList",
                    edge: "interfaces",
                    search: {
                        id: vm.chosenDevice
                    }
                },
                (data) => {
                    if (data.errors || (data.results && data.results.length == 0)) {
                        vm.error = true;
                    } else {
                        vm.interfaces = {};
                        data.results.forEach((item) => {
                            !item.name.includes("tunnel") && (vm.interfaces[item.id] = item);
                        });
                    }

                    if (vm.error) {
                        vm.noInterface = true;
                        vm.interfaceData = {};
                        vm.interfaces = {};
                        vm.loadingReport = false;
                        vm.connectionSpeed = vm.collectionRate = vm.hardwareDescription = "";
                        vm.table_title = "";
                        vm.stats = [];
                        vm.config = Object.assign({}, defaultConfig);
                        vm.config.title.text = "No Interface";
                        vm.config.series[0].name = vm.hardwareDescription;
                        let chart = angular.element("#highchart").highcharts();
                        if (chart && chart.series) {
                            let seriesLength = chart.series.length;
                            for (let i = seriesLength - 1; i > -1; i--) {
                                chart.series[i].remove();
                            }
                        }
                    } else {
                        angular.element(".interface-row").removeClass("toggle-device-border");
                        angular.element(".interface-row:first").addClass("toggle-border");
                        vm.interfaceSelectAll = "Deselect All Interfaces";
                        vm.noInterface = false;
                        for (var int in vm.interfaces) {
                            let singleInt = vm.interfaces[int];
                            let singleIntID = int.substring(int.lastIndexOf("/") + 1);
                            singleInt.selected = true;
                            vm.interfaceData[singleIntID] = singleInt;
                        }
                    }

                    vm.loadingBatch = false;

                    vm.runAllReports();
                },
                true,
                false,
                false,
                true,
                false,
                false,
                false
            );
        };

        vm.showReportRow = () => {
            vm.rowControl.push(true);
        };

        vm.interfaceSelectAll = "Deselect All Interfaces";
        vm.interfaceSelect = () => {
            if (vm.interfaceSelectAll === "Deselect All Interfaces") {
                vm.interfaceSelectAll = "Select All Interfaces";
                for (var int in vm.interfaceData) {
                    vm.interfaceData[int].selected = false;
                }
            } else {
                vm.interfaceSelectAll = "Deselect All Interfaces";
                for (var int2 in vm.interfaceData) {
                    vm.interfaceData[int2].selected = true;
                }
            }
        };

        vm.runAllReports = () => {
            vm.chartRows = [{}, {}, {}, {}];
            vm.rowControl = [true];
            if (vm.showInterfaces) {
                vm.getInterfaceReport();
            } else {
                vm.loadingBatch = true;
                vm.getSelectedDeviceReport();
            }
        };

        vm.calculateInterfaceData = (array, intID) => {
            array.forEach((interfaceItem) => {
                if (vm.hourlyFilter) {
                    interfaceItem[0] = moment(new Date(interfaceItem[0] * 1000)).format("ddd MMM DD YYYY hh:mm:ss A");
                } else {
                    interfaceItem[0] = new Date(interfaceItem[0] * 1000).toString().substring(0, 15);
                }
                if (vm[intID].octet === "perc") {
                    interfaceItem[1] = Number(Number(interfaceItem[1]).toFixed(4));
                    interfaceItem[1] > 100 ? (interfaceItem[1] = 100) : "";
                } else {
                    interfaceItem[1] = Number(vm.toMegabits(interfaceItem[1]));
                }
            });
            return array;
        };

        vm.removeWeekends = (array) => {
            let newArray = [];
            for (let x = 0; x < array.length; x++) {
                if (
                    array[x][0].toString().substring(0, 3) != "Sun" &&
                    array[x][0].toString().substring(0, 3) != "Sat"
                ) {
                    newArray.push(array[x]);
                }
            }
            return newArray;
        };

        vm.selectUnit = (interfaceId) => {
            let unitT = _.findWhere(vm.intUnits, {
                id: vm[interfaceId].octet
            });
            vm[interfaceId].tableUnit = unitT.unit;
            vm.getInterfaceReport(interfaceId);
        };

        vm.intUnits = [
            {
                name: "Mbps",
                unit: "Mbps",
                id: "octets"
            },
            {
                name: "Percent",
                unit: "%",
                id: "perc"
            }
        ];

        vm.initializeInterfaceReport = (interfaceId, single) => {
            vm[interfaceId].loadingReport = true;
            vm.loadingBatch = false;
            vm.showInterfaces = true;
            vm.showVitals = false;
            vm.showDetails = false;
            vm[interfaceId].peakText = "Show Peak Data";
            vm[interfaceId].chosenInterface = interfaceId;
            vm[interfaceId].title = vm.interfaceData[interfaceId].alias || vm.interfaceData[interfaceId].name;
            vm.reportType = "Interface";
            vm[interfaceId].averageText = "Show Average";
            vm[interfaceId].monthToggle = false;
            if (!single) {
                vm[interfaceId].octet = vm.intUnits[0].id;
                vm[interfaceId].tableUnit = vm.intUnits[0].unit;
            }
        };

        vm.getInterfaceReport = (interfaceId, expandConfig) => {
            var rollupFreq, unitType;
            let selectedInterfaces = vm.interfaceData;
            let singleIntObj = {};
            let single = interfaceId;
            if (interfaceId) {
                singleIntObj[interfaceId] = vm[interfaceId];
                selectedInterfaces = singleIntObj;
                unitType = vm[interfaceId].octet;
            } else {
                unitType = "octets";
            }

            let rowIndex = 0;
            for (var int in selectedInterfaces) {
                if (!interfaceId && selectedInterfaces[int].selected) {
                    let intIndex = rowIndex % 4;
                    let singleInt = selectedInterfaces[int];
                    vm.chartRows[intIndex][int] = singleInt;
                    vm[int] = angular.copy(singleInt);
                    rowIndex++;
                }
                vm.initializeInterfaceReport(int, single);
            }

            vm.chartRows.length > 0 ? (vm.rowLength = Object.keys(vm.chartRows[0]).length) : (vm.rowLength = 0);

            vm.hourlyFilter ? (rollupFreq = "hourly") : (rollupFreq = "daily");

            let searchQuery = {
                id: vm.chosenDevice,
                beginDate: vm.start * 1000,
                endDate: vm.end * 1000,
                rollupFrequency: rollupFreq,
                metricUnit: unitType
            };

            ScienceLogicGQL.getQuery(
                {
                    table: "metrics",
                    queryName: "interfaceMultivalues",
                    edge: "interfaces",
                    search: searchQuery
                },
                (response) => {
                    if (response.results && response.results.length > 0) {
                        for (var int in selectedInterfaces) {
                            if (selectedInterfaces[int].selected) {
                                vm.processInterfaceReport(response.results, int, expandConfig);
                            }
                        }
                    }
                }
            );
        };

        vm.processInterfaceReport = (interfaceData, interfaceId, expandConfig) => {
            var restructuredInterfaces;

            interfaceData.forEach((item) => {
                if (item.id == interfaceId) {
                    if (
                        item.in &&
                        item.in[0] &&
                        item.in[0].multiValues &&
                        item.in[0].multiValues[0] &&
                        item.in[0].multiValues[0].edges &&
                        item.in[0].multiValues[0].edges.length > 0
                    ) {
                        restructuredInterfaces = vm.restructureInterfaceResponse(item);
                    } else {
                        restructuredInterfaces = vm.restructureInterfaceResponse(null);
                    }
                }
            });

            if (restructuredInterfaces && restructuredInterfaces.in) {
                restructuredInterfaces.in.data = vm.calculateInterfaceData(restructuredInterfaces.in.data, interfaceId);
                restructuredInterfaces.out.data = vm.calculateInterfaceData(
                    restructuredInterfaces.out.data,
                    interfaceId
                );
                restructuredInterfaces.inMax.data = vm.calculateInterfaceData(
                    restructuredInterfaces.inMax.data,
                    interfaceId
                );
                restructuredInterfaces.outMax.data = vm.calculateInterfaceData(
                    restructuredInterfaces.outMax.data,
                    interfaceId
                );

                if (vm.weekdayFilter) {
                    restructuredInterfaces.in.data = vm.removeWeekends(restructuredInterfaces.in.data);
                    restructuredInterfaces.out.data = vm.removeWeekends(restructuredInterfaces.out.data);
                }
                //adds forecast
                if (vm.forecast) {
                    restructuredInterfaces.in.data = vm.addForecastDates(restructuredInterfaces.in.data);
                    restructuredInterfaces.out.data = vm.addForecastDates(restructuredInterfaces.out.data);
                }

                var categoryArray = [];
                vm[interfaceId].stats = restructuredInterfaces.in.data;

                for (let x = 0; x < restructuredInterfaces.in.data.length; x++) {
                    vm[interfaceId].stats[x][2] = restructuredInterfaces.out.data[x][1];
                    categoryArray.push(restructuredInterfaces.in.data[x][0]);
                }

                for (let a = 0; a < restructuredInterfaces.out.data.length; a++) {
                    if (vm[interfaceId].stats[a]) {
                        vm[interfaceId].stats[a].push(restructuredInterfaces.out.data[a][2]);
                    }
                }
            }

            vm.table_title = "Device ID: " + vm.chosenDevice;
            let interfaceSeries = [];
            for (var data in restructuredInterfaces) {
                interfaceSeries.push({
                    name: restructuredInterfaces[data].name,
                    type: "line",
                    color: restructuredInterfaces[data].color,
                    data: restructuredInterfaces[data].data,
                    visible: restructuredInterfaces[data].visible
                });
            }
            vm[interfaceId].config = {
                chart: {
                    type: "line",
                    width: width,
                    zoomType: "x",
                    panning: true,
                    panKey: "shift",
                    height: 300
                },
                title: {
                    text: vm[interfaceId].title
                },
                subtitle: {
                    text: "Click and drag to zoom in."
                },
                xAxis: {
                    categories: categoryArray,
                    crosshair: true
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "Usage - " + vm[interfaceId].tableUnit
                    }
                },
                plotOptions: {
                    series: {
                        color: "#64AD61"
                    }
                },
                options: {
                    legend: {
                        enabled: true,
                        align: "bottom"
                    }
                },
                series: interfaceSeries
            };
            if (vm.trendline) {
                let trendDataIn = [];
                let trendDataOut = [];
                let trendDataInPeaks = [];
                let trendDataOutPeaks = [];
                restructuredInterfaces.in.data.forEach((item, index) => {
                    item && trendDataIn.push(item[1]);
                    restructuredInterfaces.out.data[index] &&
                        trendDataOut.push(restructuredInterfaces.out.data[index][1]);
                    restructuredInterfaces.inMax.data[index] &&
                        trendDataInPeaks.push(restructuredInterfaces.inMax.data[index][1]);
                    restructuredInterfaces.outMax.data[index] &&
                        trendDataOutPeaks.push(restructuredInterfaces.outMax.data[index][1]);
                });
                let trendSeriesIn = {
                    type: "line",
                    name: "Trend In",
                    color: "#14c968",
                    marker: {
                        enabled: false
                    },
                    data: (() => {
                        return Trend(trendDataIn, null, vm.forecast, vm.hourlyFilter).data;
                    })()
                };
                let trendSeriesOut = {
                    type: "line",
                    name: "Trend Out",
                    color: "#fc6f6f",
                    marker: {
                        enabled: false
                    },
                    data: (() => {
                        return Trend(trendDataOut, null, vm.forecast, vm.hourlyFilter).data;
                    })()
                };
                let trendSeriesInPeaks = {
                    type: "line",
                    name: "Trend In - Peak",
                    color: "#14c968",
                    visible: false,
                    marker: {
                        enabled: false
                    },
                    data: (() => {
                        return Trend(trendDataInPeaks, null, vm.forecast, vm.hourlyFilter).data;
                    })()
                };
                let trendSeriesOutPeaks = {
                    type: "line",
                    name: "Trend Out - Peak",
                    color: "#fc6f6f",
                    visible: false,
                    marker: {
                        enabled: false
                    },
                    data: (() => {
                        return Trend(trendDataOutPeaks, null, vm.forecast, vm.hourlyFilter).data;
                    })()
                };
                vm[interfaceId].config.series.push(trendSeriesIn);
                vm[interfaceId].config.series.push(trendSeriesOut);
                vm[interfaceId].config.series.push(trendSeriesInPeaks);
                vm[interfaceId].config.series.push(trendSeriesOutPeaks);
            }

            vm[interfaceId].loadingReport = false;

            if (expandConfig) {
                if (expandConfig.type === "expanded") {
                    vm.resetReport = true;
                    vm.modalInst.close();
                    vm[interfaceId].averageText = expandConfig.averageText;
                    vm[interfaceId].peakText = expandConfig.peakText;
                    vm.expandReport(vm[interfaceId], {
                        reportType: vm.reportType,
                        dataType: vm.dataType,
                        unit: vm.tableUnit,
                        header1: vm.firstColumnName,
                        header2: vm.secondColumnName
                    });
                } else if (expandConfig.type === "collapsed") {
                    vm.modalInst.close();
                    vm.resetReport = false;
                    vm[interfaceId].averageText = expandConfig.averageText;
                    vm[interfaceId].peakText = expandConfig.peakText;
                    vm.expandReport(
                        vm[interfaceId],
                        {
                            reportType: vm.reportType,
                            dataType: vm.dataType,
                            unit: vm.tableUnit,
                            header1: vm.firstColumnName,
                            header2: vm.secondColumnName
                        },
                        true
                    );
                } else if (expandConfig.type === "exit") {
                    vm.modalInst.close();
                    $timeout(() => {
                        expandConfig.averageText === "Show All" ? vm.showSeries(interfaceId) : null;
                        expandConfig.peakText === "Show Averaged Data" ? vm.showPeaks(interfaceId) : null;
                    }, 250);
                    vm.resetReport = false;
                }
            }
        };

        vm.restructureInterfaceResponse = (data) => {
            let restructuredInterfaces = {
                in: {
                    data: [],
                    name: "In",
                    color: "#567dff",
                    visible: true
                },
                out: {
                    data: [],
                    name: "Out",
                    color: "#e560d8",
                    visible: true
                },
                inMax: {
                    data: [],
                    name: "In - Peak",
                    color: "#567dff",
                    visible: false
                },
                outMax: {
                    data: [],
                    name: "Out - Peak",
                    color: "#e560d8",
                    visible: false
                }
            };

            if (data) {
                let sourceIn = data.in[0].multiValues[0].edges;
                let sourceInMax = data.inMax[0].multiValues[0].edges;
                let sourceOut = data.out[0].multiValues[0].edges;
                let sourceOutMax = data.outMax[0].multiValues[0].edges;

                sourceIn.forEach((item, index) => {
                    restructuredInterfaces.in.data.push([item.timestamp, sourceIn[index].value]);
                    restructuredInterfaces.inMax.data.push([item.timestamp, sourceInMax[index].value]);
                    restructuredInterfaces.out.data.push([item.timestamp, sourceOut[index].value]);
                    restructuredInterfaces.outMax.data.push([item.timestamp, sourceOutMax[index].value]);
                });
            }
            return restructuredInterfaces;
        };

        // some jquery handles for formatting date after it has been selected through the datepicker
        angular.element("body").on("click", "button.applyBtn", () => {
            let formatStart = new Date(vm.date.startDate);
            formatStart = formatStart.toString().substring(0, 11);
            let formatEnd = new Date(vm.date.endDate);
            formatEnd = formatEnd.toString().substring(0, 11);
            vm.formate_date = formatStart + " - " + formatEnd;
            vm.toggleTime("Custom");
        });

        // toggles the time and makes all necessary conversions and variables for configuring date on server
        // start and date variables are plugged into SNOW URI
        vm.toggleTime = (range) => {
            vm.dateRange = range;
            if (range === "This Month") {
                vm.start = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-01'";
                vm.start = new Date(vm.start).getTime() / 1000;
                if (new Date().getMonth() === 11) {
                    vm.end = new Date().getFullYear() + 1 + "-" + 1 + "-01";
                    vm.end = new Date(vm.end).getTime() / 1000;
                } else {
                    vm.end = new Date().getFullYear() + "-" + (new Date().getMonth() + 2) + "-01";
                    vm.end = new Date(vm.end).getTime() / 1000;
                }
            } else if (range === "Last Month") {
                vm.end = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-01";
                vm.end = new Date(vm.end).getTime() / 1000;
                if (new Date().getMonth() === 0) {
                    vm.start = new Date().getFullYear() - 1 + "-" + 12 + "-01";
                    vm.start = new Date(vm.start).getTime() / 1000;
                } else {
                    vm.start = new Date().getFullYear() + "-" + new Date().getMonth() + "-01";
                    vm.start = new Date(vm.start).getTime() / 1000;
                }
            } else {
                $scope.$apply();
                vm.start = new Date(vm.date.startDate).getTime() / 1000;
                vm.end = new Date(vm.date.endDate).getTime() / 1000;
            }
        };
        vm.toggleTime("This Month");

        // add date to report config when forecast is selected
        vm.addForecastDates = (array) => {
            if (vm.hourlyFilter) {
                for (let x = 0; x < 336; x++) {
                    let temp = array[array.length - 1];
                    let newDate = new Date(temp[0]);
                    newDate = newDate.setHours(newDate.getHours() + 1);
                    newDate = new Date(newDate);
                    let newForecast = [moment(newDate).format("ddd MMM DD YYYY hh:mm:mm A z"), null];
                    array.push(newForecast);
                }
            } else {
                for (let y = 0; y < 14; y++) {
                    var temp2 = array[array.length - 1];
                    var newDate2 = new Date(temp2[0]);
                    newDate2 = newDate2.setDate(newDate2.getDate() + 1);
                    newDate2 = new Date(newDate2);
                    var newForecast2 = [newDate2.toString().substring(0, 15), null];
                    array.push(newForecast2);
                }
            }
            return array;
        };

        // UI trigger for confirmation of device decommission
        vm.decommissionDevice = () => {
            if (angular.equals({}, vm.selectedDevices)) {
                vm.alerts = [
                    {
                        type: "danger",
                        msg: "No Devices Selected"
                    }
                ];
            } else if (Object.keys(vm.selectedDevices).length === 1) {
                var device_sys;
                let cmdbPrefix = "cmdb_";
                if (vm.chosenContent === "DEVICES-NOT-IN-CONTRACT") {
                    cmdbPrefix = "";
                }
                vm.deviceList[vm.chosenContent].forEach((device) => {
                    if (
                        device[cmdbPrefix + "u_sciencelogic_id"].replace(",", "") ==
                        vm.selectedDevices[Object.keys(vm.selectedDevices)[0]]
                    ) {
                        device_sys = device[cmdbPrefix + "sys_id"];
                    }
                });
                vm.decommissionLoading = true;
                // check if device is parent device
                Service.getQuery(
                    {
                        parent: device_sys
                    },
                    "cmdb_rel_ci",
                    (response) => {
                        vm.decommissionLoading = false;
                        if (response.count == "0") {
                            vm.sendDecommission(false, cmdbPrefix);
                        } else {
                            let data = response.results;
                            let children = [];
                            data.forEach((childDevice) => {
                                if (childDevice.child) {
                                    children.push(childDevice.child.display_value);
                                }
                            });
                            let modalInst = $uibModal.open({
                                resolve: {
                                    list: () => {
                                        return children;
                                    }
                                },
                                templateUrl: "app/devices/confirmparentdecommission.html",
                                ariaLabelledBy: "modal-title",
                                ariaDescribedBy: "modal-body",
                                controller: ConfirmDecommisson,
                                controllerAs: "vm"
                            });
                            modalInst.result.then((data) => {
                                if (data === "YES") {
                                    vm.sendDecommission(true, cmdbPrefix);
                                } else if (data === "NO") {
                                    vm.alerts = [
                                        {
                                            type: "danger",
                                            msg: "Selected Device Not Decommissioned"
                                        }
                                    ];
                                }
                            });
                        }
                    }
                );
            } else {
                vm.alerts = [
                    {
                        type: "danger",
                        msg: "Only one device allowed at a time for decommission."
                    }
                ];
            }
        };

        // send rest call to SNOW with selected device to decommisson.  Creates a change request.
        vm.sendDecommission = (parent, prefix) => {
            let modalInst = $uibModal.open({
                templateUrl: "app/devices/getRequestedByDate.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: RequestedByDate,
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                if (data) {
                    let requestItem = {
                        u_cmdb_ci: "",
                        u_requested_by_date: data.requested_by_date,
                        u_requested_by: data.requested_for,
                        u_opened_by: user_info.sys_id,
                        u_short_description: "Portal Device Decommission",
                        u_company: user_info.company
                    };
                    vm.deviceList[vm.chosenContent].forEach((device) => {
                        if (
                            device[prefix + "u_sciencelogic_id"].replace(",", "") ==
                            vm.selectedDevices[Object.keys(vm.selectedDevices)[0]]
                        ) {
                            requestItem.u_cmdb_ci = device[prefix + "sys_id"];
                        }
                    });
                    Service.createItem("u_imp_silo_requests", requestItem, (response) => {
                        if (response.error) {
                            vm.status = [];
                            vm.error = true;
                            vm.alerts = [
                                {
                                    type: "danger",
                                    msg: response
                                }
                            ];
                        } else {
                            $uibModal.open({
                                templateUrl: "app/shared/html/ticketConfirmation.html",
                                ariaLabelledBy: "modal-title",
                                ariaDescribedBy: "modal-body",
                                controller: ConfirmChangeRequest,
                                controllerAs: "vm",
                                resolve: {
                                    ticket: () => {
                                        if (response.result) {
                                            return {
                                                number: response.result.number,
                                                sys_id: response.result.sys_id
                                            };
                                        } else {
                                            return null;
                                        }
                                    },
                                    decommission: true
                                }
                            });
                        }
                    });
                } else {
                    vm.alerts = [
                        {
                            type: "danger",
                            msg: "No Request By Date Selected"
                        }
                    ];
                }
            });
        };

        vm.setToMaintenance = () => {
            if (angular.equals({}, vm.selectedDevices)) {
                vm.alerts = [
                    {
                        type: "danger",
                        msg: "No Devices Selected"
                    }
                ];
            } else {
                let modalInst = $uibModal.open({
                    resolve: {
                        devices: () => {
                            return vm.selectedDevices;
                        },
                        sys_ids: () => {
                            return vm.selectedSysIDs;
                        }
                    },
                    templateUrl: "app/devices/maintenance.html",
                    ariaLabelledBy: "modal-title",
                    ariaDescribedBy: "modal-body",
                    controller: SetToMaintenance,
                    controllerAs: "vm"
                });
                modalInst.result.then((data) => {
                    $uibModal.open({
                        templateUrl: "app/shared/html/ticketConfirmation.html",
                        ariaLabelledBy: "modal-title",
                        ariaDescribedBy: "modal-body",
                        controller: ConfirmChangeRequest,
                        controllerAs: "vm",
                        resolve: {
                            ticket: () => {
                                return {
                                    number: data.number,
                                    sys_id: data.sys_id
                                };
                            },
                            decommission: false
                        }
                    });
                });
            }
        };

        function SetToMaintenance(
            devices,
            user_info,
            sys_ids,
            $uibModalInstance,
            ScienceLogic,
            amMoment,
            Timezone_SL,
            apiBasePath
        ) {
            let vm = this;
            vm.loading = false;
            vm.request = {};
            vm.dateToggle = {
                requested_by_date: false,
                start_date: false,
                end_date: false
            };
            vm.openCalendar = (e, picker) => {
                vm.dateToggle[picker] = true;
            };

            vm.username = user_info.name;
            vm.company = user_info.company_name;
            vm.request.caller_id = user_info.sys_id;
            vm.request.company = user_info.company;
            vm.request.requested_by = user_info.sys_id;
            vm.request.risk = "5";
            vm.request.state = "-5";
            vm.request.test_plan = "Place selected devices into Maintenance for selected period";
            vm.request.implementation_plan = "Verify devices have been shut down.";
            vm.request.backout_plan = "N/A";

            //BCS Tier 1 Assignment Group
            vm.request.assignment_group = "7fc641e94ffc5e4061fcc3fd0210c70c";

            vm.maintenanceDevices = devices;

            vm.request.description = "DEVICES TO BE SET INTO MAINTENANCE: ";
            for (var device in vm.maintenanceDevices) {
                vm.request.description += device + ", ";
            }

            vm.create_request = () => {
                let startTime = new Date(vm.request.start_date).getTime();
                let duration = moment.duration(moment(vm.request.end_date).diff(moment(vm.request.start_date)));
                let minutes = duration.asMinutes();
                let timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
                let timezoneID = Timezone_SL(timeZoneName);

                vm.request.start_date = new Date(vm.request.start_date).toISOString();
                vm.request.start_date = vm.request.start_date.replace("T", " ").substring(0, 19);
                vm.request.end_date = new Date(vm.request.end_date).toISOString();
                vm.request.end_date = vm.request.end_date.replace("T", " ").substring(0, 19);
                vm.loading = true;
                vm.alerts = [];

                let selectedDeviceSysIDs = "";
                for (var sys_id in sys_ids) {
                    selectedDeviceSysIDs += sys_ids[sys_id] + ", ";
                }

                vm.taskItem = function (deviceID, schedule) {
                    this.name = "Device to Maintenance";
                    this.description = "Device to Maintenance via BCS Portal";
                    this.enabled = "1";
                    this.details = '{"active":12,"patch_window":0}';
                    this.last_run = null;
                    this.organization = user_info.sl_org;
                    this.visibility = "Organization";
                    this.schedules = {
                        0: schedule
                    };
                    this.aligned_resource = deviceID;
                };

                let schedule = {
                    dtstart: startTime.toString(),
                    timezone: timezoneID,
                    duration: minutes.toString(),
                    description: "BCS Portal Initiated Maintenance Period",
                    recur_expr: "0",
                    recur_unit: null,
                    recur_until: "0",
                    organization: user_info.sl_org,
                    visibility: "Organization"
                };

                //dev only
                if (!apiBasePath) {
                    schedule.organization = "/api/organization/0";
                }

                let requestItem = {
                    variables: {
                        start_date: vm.request.start_date,
                        end_date: vm.request.end_date,
                        description: selectedDeviceSysIDs,
                        requested_by: user_info.sys_id,
                        company: user_info.company
                    }
                };

                let createdTaskIDs = [],
                    createdScheduleIds = [],
                    createdSchedules = [];
                var scheduleID, createdSchedule;
                let taskIndex = 0;

                vm.prepareToCreateSchedules();

                vm.prepareToCreateSchedules = () => {
                    vm.maintenanceDevices.forEach((device) => {
                        vm.createSchedules(device);
                    });
                };

                vm.createSchedules = (device) => {
                    ScienceLogic.createItem("schedule", schedule, (slResponse) => {
                        if (slResponse && slResponse.errors) {
                            vm.errorMessageSL(slResponse.errors);
                        } else {
                            if (slResponse && slResponse.tasks && slResponse.tasks["URI"]) {
                                vm.prepareToCreateTasks(slResponse, device);
                            } else {
                                vm.loading = false;
                                vm.error = true;
                                vm.alerts = [
                                    {
                                        type: "danger",
                                        msg: "Failed to create schedule."
                                    }
                                ];
                            }
                        }
                    });
                };

                vm.prepareToCreateTasks = (scheduleResponse, device) => {
                    createdSchedule = scheduleResponse;
                    createdSchedules.push(createdSchedule);
                    let scheduleURI = scheduleResponse.tasks["URI"].split("/");
                    scheduleID = scheduleURI[3];
                    createdScheduleIds.push(scheduleID);
                    var newTask;
                    //local dev purpose
                    if (apiBasePath) {
                        var aligned_resource = "/api/device/" + device;
                        newTask = new vm.taskItem(aligned_resource, scheduleID);
                    } else {
                        newTask = new vm.taskItem("/api/device/8", scheduleID);
                        newTask.organization = "/api/organization/0";
                    }
                    vm.createTasks(newTask);
                };

                vm.createTasks = (newTask) => {
                    ScienceLogic.createItem("task", newTask, (task) => {
                        if (task && task.errors) {
                            vm.errorMessageSL(task.errors);
                        } else {
                            if (task && task.schedules && task.schedules["URI"]) {
                                let taskURI = task.schedules["URI"].split("/");
                                createdTaskIDs.push(taskURI[3]);
                                taskIndex++;
                                if (taskIndex === Object.keys(vm.maintenanceDevices).length) {
                                    vm.loopAndUpdateSchedules();
                                }
                            } else {
                                vm.loading = false;
                                vm.error = true;
                                vm.alerts = [
                                    {
                                        type: "danger",
                                        msg: "Failed to create task."
                                    }
                                ];
                            }
                        }
                    });
                };

                vm.loopAndUpdateSchedules = () => {
                    createdScheduleIds.forEach((scheduleURI, index) => {
                        vm.updateSchedule(scheduleURI, index);
                    });
                };

                vm.updateSchedule = (scheduleURI, index) => {
                    let scheduleToUpdate = createdSchedules[index];
                    scheduleToUpdate.tasks = {};
                    scheduleToUpdate.tasks = {
                        0: createdTaskIDs[index]
                    };
                    ScienceLogic.updateItem("schedule", scheduleURI, scheduleToUpdate, (updateResponse) => {
                        if (updateResponse && updateResponse.errors) {
                            vm.errorMessageSL(updateResponse.errors);
                        } else {
                            if (index === createdScheduleIds.length - 1) {
                                vm.createStandardChange();
                            }
                        }
                    });
                };

                vm.createStandardChange = () => {
                    Service.createItem(
                        "sn_sc/servicecatalog/items/2127da35db95fb80f6ba00b5ca96198d/submit_producer",
                        requestItem,
                        (response) => {
                            vm.loading = false;
                            if (response.error) {
                                vm.status = [];
                                vm.error = true;
                                vm.alerts = [
                                    {
                                        type: "danger",
                                        msg: response
                                    }
                                ];
                            } else {
                                var ticketInfo;
                                if (response && response.result) {
                                    ticketInfo = {
                                        number: response.result.number,
                                        sys_id: response.result.sys_id
                                    };
                                }
                                $uibModalInstance.close(ticketInfo);
                            }
                        }
                    );
                };
            };

            vm.errorMessageSL = (errors) => {
                vm.error = true;
                errors.forEach((error) => {
                    vm.alerts.push({
                        type: "danger",
                        msg: error.message
                    });
                });
                vm.loading = false;
            };

            vm.close_notice = (index) => {
                vm.alerts.splice(index, 1);
            };
        }

        let devTableButtons = [
            {
                extend: "colvis",
                autoClose: true,
                dropup: true,
                text: "Toggle Columns"
            },
            {
                extend: "collection",
                text: "Export",
                dropup: true,
                autoClose: true,
                buttons: [
                    {
                        extend: "excel",
                        autoClose: true,
                        title: () => {
                            return "Device Report";
                        },
                        filename: () => {
                            return "Device Report";
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.inContractExport(data, row, column, node);
                                }
                            },
                            columns: ":not(.notexport)"
                        }
                    },
                    {
                        extend: "pdf",
                        autoClose: true,
                        title: () => {
                            return "Device Report";
                        },
                        filename: () => {
                            return "Device Report";
                        },
                        customize: (doc) => {
                            doc.pageMargins = [5, 5, 5, 5];
                            doc.styles.tableHeader.fontSize = 10;
                            doc.defaultStyle.fontSize = 6;
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.inContractExport(data, row, column, node);
                                }
                            },
                            columns: ":not(.notexport)"
                        }
                    },
                    {
                        extend: "csv",
                        autoClose: true,
                        title: () => {
                            return "Device Report";
                        },
                        filename: () => {
                            return "Device Report";
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.inContractExport(data, row, column, node);
                                }
                            },
                            columns: ":not(.notexport)"
                        }
                    }
                    // {
                    //     text: "Asset Report",
                    //     autoClose: true,
                    //     action: () => {
                    //         $scope.$emit("download-start");
                    //         vm.assetLoading = true;
                    //         ScienceLogic.getAssetReport(vm.sl_fetched, (response) => {
                    //             vm.assetLoading = false;
                    //             FileSaver.saveAs(
                    //                 new Blob([response], {
                    //                     type: "application/pdf"
                    //                 }),
                    //                 "asset_report.pdf"
                    //             );
                    //         });
                    //     }
                    // }
                ]
            }
            // , {
            //     text: 'Decommission Device',
            //     autoClose: true,
            //     action: (e, dt, node, config) => {
            //         vm.decommissionDevice()
            //         $scope.$apply()
            //     }
            // }
        ];

        DTDefaultOptions.setLoadingTemplate("<div></div>");
        //sets up all table configurations and download options for tables
        vm.dtOptionsDeviceList = DTOptionsBuilder.newOptions()
            .withDOM("lfrtBip")
            .withOption("aoColumnDefs", [
                {
                    bSortable: false,
                    aTargets: ["nosort"]
                }
            ])
            .withColumnFilter(columnFilter)
            .withButtons(devTableButtons)
            // .withOption('order', [
            //     ['2', 'des']
            // ])
            .withOption("retrieve", true)
            .withOption("responsive", true);

        vm.dtOptionsStats = DTOptionsBuilder.newOptions()
            .withDOM("lfBrtip")
            .withOption("aoColumnDefs", [
                {
                    bSortable: false,
                    aTargets: ["nosort"]
                }
            ])
            .withColumnFilter(columnFilter)
            .withButtons([
                {
                    extend: "colvis",
                    text: "Toggle Columns"
                },
                {
                    extend: "collection",
                    text: "Export",
                    buttons: [
                        {
                            extend: "excel",
                            title: () => {
                                return vm.reportType + "Utilization Report";
                            },
                            filename: () => {
                                return vm.reportType + "Utilization Report";
                            },
                            exportOptions: {
                                format: {
                                    body: (data) => {
                                        return data.replace("%", "").replace(" MB", "");
                                    }
                                }
                            }
                        },
                        {
                            extend: "pdf",
                            title: () => {
                                return vm.reportType + "Utilization Report";
                            },
                            filename: () => {
                                return vm.reportType + "Utilization Report";
                            },
                            exportOptions: {
                                format: {
                                    body: (data) => {
                                        return data.replace("%", "").replace(" MB", "");
                                    }
                                }
                            }
                        },
                        {
                            extend: "csv",
                            title: () => {
                                return vm.reportType + " Utilization Report";
                            },
                            filename: () => {
                                return vm.reportType + "UtilizationReport";
                            },
                            exportOptions: {
                                format: {
                                    body: (data) => {
                                        return data.replace("%", "").replace(" MB", "");
                                    }
                                }
                            }
                        }
                    ]
                }
            ])
            .withOption("order", [])
            .withOption("retrieve", true)
            .withOption("responsive", true);

        vm.openDeviceProperties = (device) => {
            let modalInst = $uibModal.open({
                resolve: {
                    device: () => {
                        return device;
                    }
                },
                templateUrl: "app/devices/singledevice.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: DeviceProperties,
                controllerAs: "vm"
            });
            modalInst.result.then(() => {
                // $log.info(data);
            });
        };

        vm.carryChartOptionsToModal = (chart) => {
            var indentifier;
            vm.showInterfaces ? (indentifier = chart.chosenInterface) : (indentifier = chart.config.title.text);
            if (vm[indentifier].peakText === "Show Averaged Data") {
                chart.config.series.forEach((item) => {
                    if (item.name.includes("Peak")) {
                        item.visible = true;
                    } else {
                        item.visible = false;
                    }
                });
            }
            if (vm[indentifier].peakText != "Show Averaged Data") {
                chart.config.series.forEach((item) => {
                    if (!item.name.includes("Peak")) {
                        item.visible = true;
                    } else {
                        item.visible = false;
                    }
                });
            }
            if (vm[indentifier].averageText === "Show All") {
                chart.config.series.forEach((item) => {
                    if (item.name === "Average") {
                        item.visible = true;
                    } else {
                        item.visible = false;
                    }
                });
            }
        };

        vm.getHourlyReport = (interfaceId, metricType, hourlyDates, config) => {
            vm.modalLoading = true;
            vm.startOrigiin = vm.start;
            vm.endOrigin = vm.end;
            vm.hourlyFilterOrigin = vm.hourlyFilter;
            vm.hourlyFilter = true;
            vm.start = new Date(hourlyDates[0]).getTime() / 1000;
            vm.end = new Date(hourlyDates[1]).getTime() / 1000;
            if (vm.modalReportType === "Interface") {
                vm.getInterfaceReport(interfaceId, config);
            } else {
                vm.runSelectedVitals(config, metricType);
            }
        };

        vm.expandReport = (chart, tableConfig, newChart) => {
            vm.modalLoading = false;
            vm.carryChartOptionsToModal(chart);
            vm.dtInstanceStatsModal = {};
            vm.tableConfig = angular.copy(tableConfig);
            vm.modalReportType = vm.tableConfig.reportType;
            vm.stats = chart.stats;
            vm.chart = chart;
            vm.expandConfig = {
                type: "expanded",
                averageText: chart.averageText,
                peakText: chart.peakText
            };
            vm.singleChosenInterface = chart.chosenInterface;
            vm.singleMetricType = chart.title;
            vm.singleChartID = vm.singleChosenInterface || vm.singleMetricType;
            vm.configModal = angular.copy(chart.config);
            vm.configModal.chart.width = $window.innerWidth * 0.86;
            vm.configModal.chart.height = $window.innerHeight * 0.82;
            vm.configModal.xAxis.minRange = 1;
            vm.chartHeight = {
                height: vm.configModal.chart.height * 1.025 + "px"
            };
            vm.destroyChart = true;
            !newChart ? (vm.hideZoom = false) : (vm.hideZoom = true);
            $timeout(() => {
                vm.destroyChart = false;
                vm.modalLoading = false;
                vm.configModal.chart.events = {
                    load: function () {
                        let chart = this,
                            xAxis = chart.xAxis[0],
                            chartContainer = $document.getElementById("single-device-chart"),
                            isMouseDown = false,
                            min,
                            max;

                        chartContainer.onmousedown = (e) => {
                            if (e.target.nodeName === "rect") {
                                isMouseDown = true;
                                min = Math.round(xAxis.toValue(e.chartX));
                            }
                        };
                        chartContainer.onmousemove = (e) => {
                            if (isMouseDown) {
                                max = Math.round(xAxis.toValue(e.chartX));
                            }
                        };
                        chartContainer.onmouseup = () => {
                            isMouseDown = false;
                            if (!vm.hourlyFilter && newChart && min && max) {
                                let dateRangeHours = [vm.stats[min][0], vm.stats[max][0]];
                                vm.getHourlyReport(
                                    vm.singleChosenInterface,
                                    vm.singleMetricType,
                                    dateRangeHours,
                                    vm.expandConfig
                                );
                            }
                            xAxis.setExtremes(min, max);
                        };
                    },
                    selection: () => {
                        return false;
                    }
                };
            }, 100);

            vm.modalInst = $uibModal.open({
                templateUrl: "app/devices/device_report.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                windowClass: "device-report-modal",
                scope: $scope
            });
            vm.modalInst.result
                .then(() => {
                    vm.start = vm.startOrigiin;
                    vm.end = vm.endOrigin;
                    vm.hourlyFilter = vm.hourlyFilterOrigin;
                })
                .catch(() => {
                    vm.resetReportConfig("exit");
                });

            vm.resetReportConfig = (exit) => {
                if (exit && vm.resetReport) {
                    vm.expandConfig.type = "exit";
                    if (vm.modalReportType === "Interface") {
                        vm.getInterfaceReport(vm.singleChosenInterface, vm.expandConfig);
                    } else {
                        vm.runSelectedVitals(vm.expandConfig, vm.singleMetricType);
                    }
                } else if (vm.resetReport) {
                    vm.expandConfig.type = "collapsed";
                    vm.modalLoading = true;
                    if (vm.modalReportType === "Interface") {
                        vm.getInterfaceReport(vm.singleChosenInterface, vm.expandConfig);
                    } else {
                        vm.runSelectedVitals(vm.expandConfig, vm.singleMetricType);
                    }
                }
                vm.resetReport = false;
            };

            vm.close = () => {
                vm.modalInst.dismiss("cancel");
                vm.resetReportConfig("exit");
            };

            vm.dtOptionsStatsModal = DTOptionsBuilder.newOptions()
                .withDOM("lfBrtip")
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withColumnFilter(columnFilter)
                .withButtons([
                    {
                        extend: "colvis",
                        text: "Toggle Columns"
                    },
                    {
                        extend: "collection",
                        text: "Export",
                        buttons: [
                            {
                                extend: "excel",
                                title: () => {
                                    return vm.tableConfig.reportType + "Utilization Report";
                                },
                                filename: () => {
                                    return vm.tableConfig.reportType + "Utilization Report";
                                },
                                exportOptions: {
                                    format: {
                                        body: (data) => {
                                            return data.replace("%", "").replace(" MB", "");
                                        }
                                    }
                                }
                            },
                            {
                                extend: "pdf",
                                title: () => {
                                    return vm.tableConfig.reportType + "Utilization Report";
                                },
                                filename: () => {
                                    return vm.tableConfig.reportType + "Utilization Report";
                                },
                                exportOptions: {
                                    format: {
                                        body: (data) => {
                                            return data.replace("%", "").replace(" MB", "");
                                        }
                                    }
                                }
                            },
                            {
                                extend: "csv",
                                title: () => {
                                    return vm.tableConfig.reportType + " Utilization Report";
                                },
                                filename: () => {
                                    return vm.tableConfig.reportType + "UtilizationReport";
                                },
                                exportOptions: {
                                    format: {
                                        body: (data) => {
                                            return data.replace("%", "").replace(" MB", "");
                                        }
                                    }
                                }
                            }
                        ]
                    }
                ])
                .withOption("order", [])
                .withOption("retrieve", true)
                .withOption("responsive", true);
        };
    }

    let columnFilter = {
        aoColumns: [
            null,
            null,
            {
                type: "text",
                bRegex: true,
                bSmart: true
            },
            {
                type: "text",
                bRegex: true,
                bSmart: true
            },
            {
                type: "text",
                bRegex: true,
                bSmart: true
            },
            {
                type: "text",
                bRegex: true,
                bSmart: true
            },
            {
                type: "text",
                bRegex: true,
                bSmart: true
            },
            {
                type: "text",
                bRegex: true,
                bSmart: true
            },
            null
        ]
    };

    function DeviceProperties(
        _,
        user_info,
        device,
        ScienceLogic,
        DTOptionsBuilder,
        DTColumnDefBuilder,
        Events,
        moment,
        $state,
        $uibModalInstance,
        BCSServer,
        $scope,
        $timeout,
        Devices
    ) {
        let vm = this;
        vm.customTitle = "Associated Events for Device - " + device.name;
        //default tab to open on navigation
        vm.tabView = "general";

        if (
            user_info.company === "8d8073014f8d0300d227d48e5210c785" ||
            user_info.company === "c94993314a362312005cfc20c1aa15d2"
        ) {
            vm.burwoodUser = true;
        } else {
            vm.burwoodUser = false;
        }

        let slDeviceID = device.u_sciencelogic_id || device.cmdb_u_sciencelogic_id;
        slDeviceID = slDeviceID.replace(",", "");

        vm.alerts = [];

        vm.severityWord = {
            0: "Healthy",
            1: "Notice",
            2: "Minor",
            3: "Major",
            4: "Critical"
        };

        vm.severity = {
            0: "5",
            1: "4",
            2: "3",
            3: "2",
            4: "1"
        };

        vm.prioritiesAll = [
            {
                id: "P4",
                name: "Minimal"
            },
            {
                id: "P3",
                name: "Moderate"
            },
            {
                id: "P2",
                name: "High"
            },
            {
                id: "P1",
                name: "Critical"
            }
        ];

        vm.priorities = [
            {
                id: "P4",
                name: "Minimal"
            },
            {
                id: "P3",
                name: "Moderate"
            },
            {
                id: "P2",
                name: "High"
            }
            // {
            //     id: 'P1',
            //     name: 'Critical'
            // }
        ];

        vm.priorityConfig1 = [
            // "c-AVAILABILITY",
            "c-BATTERY",
            "c-CPU",
            "c-DEVOPS",
            "c-DISK",
            "c-FAN",
            "c-FILESYSTEM",
            "c-HARDWARE"
        ];
        vm.priorityConfig2 = [
            "c-INTERFACE",
            "c-MEMORY",
            "c-POWER",
            "c-PSU",
            "c-ROUTING",
            "c-SWAP",
            "c-VOIP",
            "c-TEMPERATURE"
        ];
        vm.priorityConfig3 = [
            "c-PROCESSES",
            "c-SECURITY",
            "c-STORAGE",
            "c-SERVICES",
            "c-CERTIFICATES",
            "c-DATASTORE",
            // "c-EVENT_REDIRECT",
            "c-BACKUP"
        ];

        vm.opStatus = [null, "Up", "Down", null, "Unknown", "Dormant", "Not Present"];

        let dateFields = ["edit_date", "date_added", "last_poll"];

        vm.editDevice = () => {
            switch (vm.tabView) {
                case "general":
                    vm.addNote();
                    vm.deviceUpdate.name !== vm.deviceName ? vm.updateDevice("name", "device/", slDeviceID) : "";
                    break;
                case "interface":
                    vm.updateInterfaces();
                    break;
                case "severity":
                    vm.updateDevice("severity", "device/", slDeviceID);
                    break;
                case "threshold":
                    vm.updateThresholds();
                    break;
                default:
                    break;
            }
        };

        vm.updateDevice = (field, route, id, obj) => {
            vm.alerts = [];
            let updateObject = {};
            if (field === "severity") {
                for (var field2 in vm.deviceUpdate) {
                    if (field2.substring(0, 2) === "c-") {
                        updateObject[field2] = vm.deviceUpdate[field2];
                    }
                }
            } else if (field === "name") {
                updateObject.name = vm.deviceUpdate.name;
            } else if (field === "interface") {
                updateObject = obj;
            }
            ScienceLogic.createItem(route + id, updateObject, (updateResponse) => {
                if (updateResponse && !updateResponse.errors) {
                    vm.error = true;
                    let msg = "Device Successfully Updated";
                    field === "name"
                        ? (msg += ". Please allow time for name change in ScienceLogic to sync with Servicenow.")
                        : "";
                    vm.alerts.push({
                        type: "danger",
                        msg: msg
                    });
                } else {
                    vm.error = true;
                    vm.alerts.push({
                        type: "danger",
                        msg: "Failed To Update Device"
                    });
                }
            });
        };

        vm.updateInterfaces = () => {
            for (var int in vm.interfaces) {
                vm.interfaces[int].connectionSpeed = vm.fromMegabits(vm.interfaces[int].connectionSpeed);
                let intID = int.split("/");
                intID = intID[intID.length - 1];
                vm.updateDevice("interface", "interface/", intID, vm.interfaces[int]);
            }
        };

        vm.convertToBoolean = (device, field) => {
            if (device[field] === "0") {
                device[field] = "False";
            } else if (device[field] === "1") {
                device[field] = "True";
            }
        };

        vm.parseDates = (device, field) => {
            device[field] && Number(device[field]) > 0 ? (device[field] = new Date(Number(device[field]) * 1000)) : "";
        };

        ScienceLogic.getItem(
            slDeviceID,
            "device",
            (deviceResponse) => {
                vm.loading = false;
                vm.deviceName = deviceResponse.result_set.name;
                vm.deviceUpdate = Object.assign({}, deviceResponse.result_set);
                vm.device = Object.assign({}, deviceResponse.result_set);
                if (vm.device && !vm.device.errors) {
                    vm.getAssociatedEvents();
                    vm.getThresholds();
                    dateFields.forEach((field) => {
                        vm.parseDates(vm.device, field);
                    });
                    for (var key2 in vm.device) {
                        vm.convertToBoolean(vm.device, key2);
                    }
                    for (var key in vm.device.active) {
                        vm.device.active[key] ? (vm.active = key) : "";
                    }
                    !vm.active ? (vm.active = "Active") : "";
                    vm.device.applications ? (vm.device.applications = vm.device.applications.description) : "";
                    vm.device.child_devices ? (vm.device.child_devices = vm.device.child_devices.toString()) : "";
                    vm.getUser(vm.device.updated_by, "updated_by");
                    vm.getDetails();
                    vm.getNotes();
                } else {
                    vm.error = true;
                    vm.alerts = [
                        {
                            type: "danger",
                            msg: "Cannot find ScienceLogic Data for Selected Device"
                        }
                    ];
                }
            },
            {}
        );

        vm.close_notice = (index) => {
            vm.error = false;
            vm.alerts.splice(index, 1);
        };

        vm.getDetails = () => {
            ScienceLogic.getItem(
                slDeviceID + "/detail",
                "device",
                (detailResponse) => {
                    let detail = detailResponse.result_set;
                    if (detail && detail.snmp_data) {
                        detail = detail.snmp_data;
                        let index = detail.sysdescr.indexOf("Technical Support");
                        var sysDescr, uptime, lastPoll;
                        index != -1 ? (sysDescr = detail.sysdescr.substr(0, index)) : (sysDescr = detail.sysdescr);
                        uptime = "Uptime: " + (detail.sysuptime / 1000 / 60 / 60 / 24).toFixed(2) + " Days";
                        lastPoll = "Last Poll" + moment(detail.last_poll * 1000).format("MMMM DD, YYYY");
                        let detailString = sysDescr + "\n" + uptime + "\n" + lastPoll + "\n";
                        for (var item in detail) {
                            if (item !== "sysdescr" && item !== "sysuptime" && item !== "last_poll") {
                                detailString += detail[item] + "\n";
                            }
                        }
                        vm.detail = detailString;
                    } else {
                        return null;
                    }
                },
                {}
            );
        };

        vm.addNote = () => {
            if (vm.note) {
                ScienceLogic.createItem(
                    "device/" + slDeviceID + "/note",
                    {
                        note_text: vm.note
                    },
                    (updateResponse) => {
                        if (updateResponse && !updateResponse.errors) {
                            vm.error = true;
                            vm.alerts.push({
                                type: "danger",
                                msg: "Note Successfully Updated"
                            });
                            vm.note = "";
                            vm.getNotes();
                        } else {
                            vm.error = true;
                            vm.alerts.push({
                                type: "danger",
                                msg: "Failed To Update Note"
                            });
                        }
                    }
                );
            }
        };

        vm.getNotes = () => {
            ScienceLogic.getItem(
                slDeviceID + "/note",
                "device",
                (noteResponse) => {
                    let notes = noteResponse.result_set;
                    vm.notes = "";
                    for (var note in notes) {
                        vm.notes += notes[note].note_text + "\n";
                    }
                },
                {}
            );
        };

        vm.getAssociatedEvents = () => {
            Events.getEvent(
                (data) => {
                    vm.loading = false;
                    if (data.result_set) {
                        vm.filtered = data.result_set;
                        let suppressArray = [];
                        vm.events = [];
                        for (var id in vm.filtered) {
                            vm.filtered[id].aligned_resource = vm.filtered[id].aligned_resource.replace(
                                /^.*\/(?=[^\/]*$)/,
                                ""
                            );
                            if (
                                vm.filtered[id].suppress_group != "0" &&
                                suppressArray.indexOf(vm.filtered[id].suppress_group) > -1
                            ) {
                                delete vm.filtered[id];
                            } else if (
                                vm.filtered[id].suppress_group != "0" &&
                                suppressArray.indexOf(vm.filtered[id].suppress_group) == -1
                            ) {
                                suppressArray.push(vm.filtered[id].suppress_group);
                            }
                        }
                        vm.total_result = Object.keys(data).length;
                        vm.events = vm.filtered;
                        for (var key in vm.events) {
                            if (vm.events[key].user_ack) {
                                vm.getUser(vm.events[key].user_ack, "user_ack", vm.events[key]);
                            }
                        }
                    } else {
                        vm.total_result = 0;
                        vm.events = [];
                    }
                },
                {
                    date_first: "DESC"
                },
                {
                    "aligned_resource/device": slDeviceID
                },
                null,
                null,
                false
            );
        };

        vm.getThresholds = () => {
            ScienceLogic.getItem(
                slDeviceID + "/device_thresholds",
                "device",
                (threshResponse) => {
                    let threshold = threshResponse.result_set;
                    vm.threshold = {};
                    if (threshold) {
                        threshold.common ? (vm.threshold.common = threshold.common) : "";
                        vm.threshold.dynapp = Object.assign({}, threshold.dynapp);
                        vm.getThresholdUnits();
                    } else {
                        return null;
                    }
                },
                {}
            );
        };

        vm.getThresholdUnits = () => {
            BCSServer.getData("/thresholds", (unitData) => {
                vm.applyThresholdUnits(unitData);
            });
        };

        vm.applyThresholdUnits = (unitData) => {
            for (var threshes in vm.threshold.dynapp) {
                let app = vm.threshold.dynapp[threshes];
                for (var thresh in app.thresholds) {
                    let threshName = app.thresholds[thresh].name;
                    let units = vm.findMatchingUnit(unitData, threshName);
                    if (units) {
                        app.thresholds[thresh].units = {
                            floor: units.min,
                            ceil: units.max,
                            step: 1
                        };
                    }
                }
            }
        };

        vm.refreshSliders = () => {
            $timeout(() => {
                $scope.$broadcast("rzSliderForceRender");
            });
        };

        vm.findMatchingUnit = (arr, name) => {
            let unitObj = _.findWhere(arr, {
                name: name
            });
            return unitObj;
        };

        vm.updateThresholds = () => {
            ScienceLogic.createItem("device/" + slDeviceID + "/device_thresholds", vm.threshold, (threshResponse) => {
                if (threshResponse && !threshResponse.errors) {
                    vm.error = true;
                    vm.alerts.push({
                        type: "danger",
                        msg: "Thresholds Successfully Updated"
                    });
                } else {
                    vm.error = true;
                    vm.alerts.push({
                        type: "danger",
                        msg: "Failed To Update Thresholds"
                    });
                }
            });
        };

        vm.getUser = (id, field, scopeObj) => {
            id = id.split("/")[3];
            ScienceLogic.getItem(
                id,
                "account",
                (userResponse) => {
                    let user = userResponse.result_set;
                    if (user) {
                        scopeObj
                            ? (scopeObj[field] = user.contact_fname + " " + user.contact_lname)
                            : (vm[field] = user.contact_fname + " " + user.contact_lname);
                    } else {
                        return null;
                    }
                },
                {}
            );
        };

        vm.toggleSearch = () => {
            vm.showFilters = !vm.showFilters;
        };

        vm.getInterface = (deviceId) => {
            vm.loadingBatch = true;
            Devices.getReport(
                deviceId,
                (data) => {
                    vm.loadingBatch = false;
                    if (data.errors || angular.equals(data.result_set, {})) {
                        vm.error = true;
                    } else {
                        vm.interfaces = data.result_set;
                        for (var key in vm.interfaces) {
                            if (vm.interfaces[key]) {
                                vm.interfaces[key].connectionSpeed = vm.toMegabits(vm.interfaces[key].connectionSpeed);
                                if (
                                    vm.interfaces[key].hardwareDescriptionr === "Null0" ||
                                    vm.interfaces[key].hardwareDescriptionr === "VoIP-Null0"
                                ) {
                                    delete vm.interfaces[key];
                                }
                            }
                        }
                        $timeout(vm.setInterfaceHeaders, 500);
                    }
                },
                true,
                false,
                false,
                false,
                false,
                false,
                false
            );
        };
        vm.getInterface(slDeviceID);

        vm.setInterfaceHeaders = () => {
            angular.element(".accordion-toggle").each(function () {
                for (var key in vm.interfaces) {
                    let header = vm.interfaces[key].name + " - " + vm.interfaces[key].alias;
                    let headerText = angular.element(this).text();
                    if (header === headerText) {
                        let intSpeed = vm.interfaces[key].ifSpeed + " Mbps";
                        var enabledIcon;
                        vm.interfaces[key].state === "1" ? (enabledIcon = "green") : (enabledIcon = "red");
                        angular.element(this).append('<span class="dot ' + enabledIcon + ' right"></span>');
                        angular.element(this).append('<span class="right">' + intSpeed + "</span>");
                    }
                }
            });
        };

        vm.toMegabits = (bits) => {
            return (bits / 1000 / 1000).toFixed(2);
        };

        vm.fromMegabits = (mbit) => {
            return (mbit * 1000 * 1000).toFixed(2);
        };

        vm.enabled = [
            {
                name: "Enabled",
                id: "1"
            },
            {
                name: "Disabled",
                id: "0"
            }
        ];

        let columnFilter = {
            aoColumns: [
                null,
                null,
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                }
            ]
        };

        let buttonConfig = [
            {
                extend: "colvis",
                text: "Toggle Columns"
            },
            {
                extend: "collection",
                text: "Export",
                buttons: [
                    {
                        extend: "excel",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        }
                    },
                    {
                        extend: "pdf",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        customize: (doc) => {
                            doc.pageMargins = [5, 5, 5, 5];
                            doc.styles.tableHeader.fontSize = 10;
                            doc.defaultStyle.fontSize = 6;
                        }
                    },
                    {
                        extend: "csv",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        }
                    }
                ]
            }
        ];

        vm.dtInstanceSingle = {};
        vm.dtInstanceInterface = {};
        vm.dtOptionsSingle = DTOptionsBuilder.newOptions()
            .withDOM('lfB<".table-scroll"rt>ip')
            .withOption("aoColumnDefs", [
                {
                    bSortable: false,
                    aTargets: ["nosort"]
                }
            ])
            .withButtons(buttonConfig)
            .withColumnFilter(columnFilter)
            .withOption("responsive", true)
            .withOption("iDisplayLength", 10)
            .withOption("order", [["5", "des"]]);
        vm.dtOptionsInterface = DTOptionsBuilder.newOptions()
            .withDOM('lfB<".table-scroll"rt>ip')
            .withOption("aoColumnDefs", [
                {
                    bSortable: false,
                    aTargets: ["nosort"]
                }
            ])
            .withButtons(buttonConfig)
            .withColumnFilter(columnFilter)
            .withOption("responsive", true)
            .withOption("iDisplayLength", 10)
            .withOption("order", [["1", "des"]]);
        vm.dtColumnDefsSingle = [DTColumnDefBuilder.newColumnDef(6).withOption("type", "date")];

        vm.goToTicket = (number, sys_id) => {
            $state.go("index.status_single", {
                statusID: sys_id
            });
            $uibModalInstance.close();
        };
    }

    function RequestedByDate($uibModalInstance, $uibModal) {
        let vm = this;
        vm.dateToggle = {
            requested_by_date: false
        };
        vm.contact = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ContactController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                if (data) {
                    vm.caller_name = data.name;
                    vm.caller_id = data.caller_id;
                }
            });
        };
        vm.openCalendar = (e, picker) => {
            vm.dateToggle[picker] = true;
        };
        vm.close = () => {
            $uibModalInstance.close({
                requested_by_date: vm.requested_by_date,
                requested_for: vm.caller_id
            });
        };
    }

    function ConfirmChangeRequest($uibModalInstance, $state, ticket, decommission) {
        let vm = this;
        vm.number = ticket.number;
        vm.additionalMessage = "Your device/s have been scheduled for maintenance.";
        decommission ? (vm.additionalMessage = "Your device is awaiting approval for decommission.") : "";
        vm.close = () => {
            $uibModalInstance.dismiss("cancel");
            if (ticket && !decommission) {
                $state.go("index.uchange_single", {
                    requestID: ticket.sys_id
                });
            } else {
                $state.go("index.requests");
            }
        };
    }

    function ConfirmDecommisson($uibModalInstance, list) {
        let vm = this;
        vm.children = list;
        vm.close = (status) => {
            $uibModalInstance.close(status);
        };
    }
})();

(function() {
	'use strict';

	angular
		.module('burWood')
		.controller('DashboardController', DashboardController);

	/** @ngInject */
	function DashboardController($window) {
		var vm = this;
		var agent = $window.navigator.userAgent.toLowerCase();
		if (agent.indexOf('firefox') != -1) {
			vm.isChrome = true;
		} else if ($window.chrome) {
			vm.isChrome = true;
		} else {
			vm.isChrome = false;
		}
	}
})();

(function () {
    angular.module('burWood').controller("CSVInvoiceDashboardController", CSVInvoiceDashboardController);

    /** @ngInject */
    function CSVInvoiceDashboardController(
        $scope,
        $document,
        BCSServer,
        Navbar
    ) {
        let vm = this;
        vm.cardToggle = false;
        vm.fullscreen = false;
        vm.hiddenCards = {};
        vm.cardFocus = (id) => {
            if (vm.hiddenCards.hasOwnProperty(id)) {
                vm.hiddenCards[id] = !vm.hiddenCards[id];
            } else {
                vm.hiddenCards = {}
                vm.hiddenCards[id] = !vm.hiddenCards[id];
            }
        }

        vm.fetchCSVTotals = (year, month) => {
            vm.totalInvoicesSum = 0;
            vm.requestFlag = true;
            vm.csvFetches = [];
            BCSServer.getData(`/csv_report_all?date=${year}-${month}-01`,
                (response) => {
                    if (response) {
                        vm.csvFetches = response.data;
                        vm.csvFetches.forEach(data => {
                            vm.totalInvoicesSum += parseFloat(data.total)
                        })
                        vm.totalInvoicesSum = vm.totalInvoicesSum.toFixed(2)
                        let ts = new Date(response.timeStamp)
                        vm.csvTimeStamp = `${ts.getFullYear()} / ${ts.getMonth() + 1} / ${ts.getDate()}`
                        vm.queryDate = `${year}-${month}`;
                        vm.requestFlag = false;
                    }
                })
        };

        vm.enterKeyPress = function (keyEvent) {
            if (keyEvent.which === 13)
                vm.searchFunc(vm.queryWord)
        }

        vm.applyLogo = (logo) => {
            try {
                const s = `data:${logo.contentType};base64,${btoa(String.fromCharCode.apply(null, logo.data.data))}`
                // const s = `data:${logo.contentType};base64,${Buffer.from(String.fromCharCode.apply(null, logo.data.data)).toString('base64')}`
                // return str
                return {'background-image': `url(${s})`};
            } catch (e) {
                console.log(e)
            }
        };

        vm.totalInvoicesSum = 0;

        vm.yearRange = []
        vm.currentY = parseInt(new Date().getFullYear());
        vm.selectedYear = vm.currentY
        vm.currentM = parseInt(new Date().getMonth() + 1);
        while (vm.currentY >= 2019) {
            vm.yearRange.push(vm.currentY)
            vm.currentY--;
        }
        vm.filterMonth = new Date().getMonth() + 1;
        vm.monthRange = [
            { Value: '01', Text: 'Jan' },
            { Value: '02', Text: 'Feb' },
            { Value: '03', Text: 'Mar' },
            { Value: '04', Text: 'Apr' },
            { Value: '05', Text: 'May' },
            { Value: '06', Text: 'June' },
            { Value: '07', Text: 'July' },
            { Value: '08', Text: 'Aug' },
            { Value: '09', Text: 'Sep' },
            { Value: '10', Text: 'Oct' },
            { Value: '11', Text: 'Nov' },
            { Value: '12', Text: 'Dec' }
        ];
        vm.yearSliderPos = 0;
        vm.yearSliderSet = (dir) => {
            let newPos = vm.yearSliderPos
            if (dir == "left") {
                newPos += 1
            } else {
                newPos -= 1
            }
            if (newPos > vm.yearRange.length - 1) {
                vm.yearSliderPos = newPos % (vm.yearRange.length - 1);
            } else if (newPos < 0) {
                vm.yearSliderPos = vm.yearRange.length - 1
            } else {
                vm.yearSliderPos = newPos
            }
            vm.selectedYear = vm.yearRange[vm.yearSliderPos];
        }

        Navbar.getCompanyList((companies) => {
            vm.companyNameMap = {};
            for (let x = 0; x < companies.results.length; x++) {
                vm.companyNameMap[companies.results[x]["company.u_customer_code"]] = companies.results[x]["company.name"]
            }
            vm.companyNameMap['BURGRO'] = "Burwood Group"
            vm.companyNameMap['BURCLO'] = "Burwood Cloud Service"
        })

        vm.searchFunc = (word) => {
            let res = $document[0].querySelectorAll('.card-companyCode-text')
            res.forEach(ele => {
                if (ele.innerText.includes(word.toUpperCase())) {
                    ele.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
                    vm.selectedData = vm.csvFetches.find(data => data.companyCode.includes(word.toUpperCase()))
                    vm.cardFocus(vm.selectedData.companyCode);
                }
            })
        }

        vm.dollarfy = (num) => {
            let result = '';
            if (num && num.length > 0) {
                let v = num.split(".")
                let numV = v[0]
                let decimalV = v[1];
                while (numV.length > 3) {
                    result = "," + numV.slice(-3) + result
                    numV = numV.slice(0, -3)
                }
                result = numV + result + "." + decimalV
            }
            return result
        }
    }
})();
(function () {
    "use strict";

    angular.module("burWood").directive("downloadContract", downloadContract);

    /** @ngInject */
    function downloadContract() {
        return {
            restrict: "E",
            templateUrl: "app/contracts/downloadcontract.html",
            scope: true,
            controller: function ($scope, $http, $window, FileSaver, Blob, $log, apiBasePath) {
                var vm = this;
                vm.download = function () {
                    var contractObj = $window.sessionStorage.getItem("jsonData");
                    $scope.$emit("download-start");
                    $http({
                        method: "POST",
                        cache: false,
                        url: apiBasePath + "/download",
                        responseType: "arraybuffer",
                        data: contractObj
                    }).then(function (response) {
                        $log("Success: " + response.data);
                        FileSaver.saveAs(
                            new Blob([response.data], {
                                type:
                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8"
                            }),
                            "report.docx"
                        );
                    });
                };
            },
            controllerAs: "vm",
            bindToController: true
        };
    }
})();

(function() {
	'use strict';

	angular
		.module('burWood')
		.factory('Contracts', Contracts);

	function Contracts(ServiceNow) {
		return {
			getContracts: function(company, callback, page_limit, offset, query_obj) {
				ServiceNow.getContracts('u_bms_contracts', company, callback, page_limit, offset, query_obj);
			},
			getSingle: function(id, table, callback) {
				ServiceNow.getItem(id, table, callback);
			},
			getItems: function(state, callback, page_limit, offset, query_obj) {
				ServiceNow.getTable(state, 'u_item_master', callback, 10000, offset, query_obj);
			},
			getQuery: function(query_obj, table, callback) {
				ServiceNow.getQuery(query_obj, table, callback);
			},
			createItem: function(table, data, callback) {
				ServiceNow.createItem(table, data, callback);
			},
			updateItem: function(table_name, contractId, data, callback) {
				ServiceNow.updateItem(table_name, contractId, data, callback);
			},
			deleteItem: function(sysId, callback) {
				ServiceNow.deleteItem('u_contract_items', sysId, callback);
			},
			getDevices: function(callback, page_limit, offset, report, company) {
				ServiceNow.getDevice(callback, page_limit, offset, 'true', report, company);
			}
		}
	}
})();

(function () {
    "use strict";

    angular.module("burWood").controller("ContractsController", ContractsController);

    /** @ngInject */
    function ContractsController(
        _,
        $log,
        user_info,
        $state,
        $stateParams,
        Contracts,
        Service,
        DTColumnDefBuilder,
        DTOptionsBuilder,
        $uibModal,
        ServiceNow,
        $timeout,
        moment
    ) {
        var vm = this;

        //check to see if user is in group have access to contracts
        if (
            user_info.group.indexOf("BCS Manager") != -1 ||
            user_info.group.indexOf("Burwood Account Executive") != -1
        ) {
            vm.disabled = false;
        } else {
            vm.disabled = true;
        }
        //temp
        // vm.disabled = true;

        //allow higher discount for selected person
        if (
            user_info.sys_id === "d640d2224fe45a4061fcc3fd0210c72a" ||
            user_info.sys_id === "e8a582314f1c524061fcc3fd0210c748"
        ) {
            vm.discountMax = 100;
        } else {
            vm.discountMax = 20;
        }

        vm.durations = [
            {
                id: 1,
                name: "1 Year"
            },
            {
                id: 2,
                name: "2 Years"
            },
            {
                id: 3,
                name: "3 Years"
            },
            {
                id: 4,
                name: "4 Years"
            },
            {
                id: 5,
                name: "5 Years"
            }
        ];

        vm.service = [
            {
                id: "application",
                name: "Application Management Services"
            },
            {
                id: "citrix",
                name: "Citrix Management Services"
            },
            {
                id: "network",
                name: "Network Management Services"
            },
            {
                id: "server",
                name: "Server Management Services"
            },
            {
                id: "storage",
                name: "Storage Management Services"
            },
            {
                id: "telepresence",
                name: "Telepresence Management Services"
            },
            {
                id: "uc",
                name: "Unified Communications Management Services"
            },
            {
                id: "ucs",
                name: "Unified Computing System Management Services"
            }
        ];

        vm.billing_period = ["Monthly", "Quarterly", "Semi Annulally", "Annually"];

        vm.billing_cycle_date = ["5", "20"];

        vm.status = ["Activated", "Draft", "In Approval", "Terminated", "Expired"];

        //get all attachments associated with contract
        function getAttachments() {
            ServiceNow.getAllAttachment(vm.contractID, "u_bms_contracts", 100, 100, function (data) {
                if (data && data.result) {
                    vm.attachments = data.result;
                }
            });
        }

        //routes to device page with selected device filtered
        vm.goToDevice = function (device) {
            $state.go("index.devices", {
                redirectedDevice: device,
                exception: true
            });
        };

        //routes to device page with slected SKU filtered on the device page
        vm.goToSKU = function (device) {
            $state.go("index.devices", {
                redirectedSKU: device
            });
        };

        // caluclates the end date for the contract based on the contract start date and duration
        vm.calcEndDate = function () {
            if (vm.contract.u_contract_start_date && vm.contract.duration) {
                var startYear = vm.contract.u_contract_start_date.toString().substring(11, 15);
                var endYear = (Number(startYear) + vm.contract.duration).toString();
                vm.contract.u_contract_end_date = new Date(
                    vm.contract.u_contract_start_date.toString().replace(startYear, endYear)
                );
            }
        };

        vm.update = function () {
            if (vm.disabled) {
                return;
            }

            vm.modal = $uibModal.open({
                templateUrl: "app/contracts/processing.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: Processing,
                controllerAs: "vm"
            });

            var data = {
                company: vm.contract.company,
                u_bill_to_company: vm.contract.u_bill_to_company,
                u_customer_code: vm.contract.u_customer_code,
                u_contact_name: vm.contract.u_contact_name,
                u_contact_email: vm.contract.u_contact_email,
                u_contract_start_date: vm.contract.u_contract_start_date,
                u_contract_end_date: vm.contract.u_contract_end_date,
                u_contract_startup_fees: vm.contract.u_contract_startup_fees,
                u_startup_fees_description: vm.contract.u_startup_fees_description,
                u_startup_fee_billed: vm.contract.u_startup_fee_billed.toString(),
                u_price_escalation_rate: vm.contract.u_price_escalation_rate,
                u_price_escalation_period: parseInt(vm.contract.u_price_escalation_period),
                u_billing_period: vm.contract.u_billing_period,
                u_billing_cycle_date: vm.contract.u_billing_cycle_date,
                u_status: vm.contract.u_status
            };
            Contracts.updateItem("u_bms_contracts", vm.contractID, data, function () {
                vm.modifyItems("update");
            });
        };

        function populateContractItems(sys_id) {
            Contracts.getQuery(
                {
                    con_u_contract_id: sys_id
                },
                "u_contract_details",
                function (res) {
                    vm.loadingCI = false;
                    var conItems = res.results;
                    if (res.err || !conItems || conItems.length === 0) {
                        vm.error = true;
                        // vm.contract = {};
                    } else {
                        addContractItemRows(conItems);
                        calculateTotals();
                        fetchAssociatedCIs();
                    }
                }
            );
        }

        function fetchAssociatedCIs() {
            for (var item in vm.contractItems) {
                fetchSingleCIDevices(vm.contractItems[item].sys_id, vm.contractItems[item].contractItem);
            }
        }

        function fetchSingleCIDevices(contractItemSysID, contractItemNumber) {
            Contracts.getQuery(
                {
                    u_sku: contractItemSysID
                },
                "cmdb_ci|devicesList",
                function (res) {
                    vm.loadingDevices = false;
                    var devices = res.results;
                    if (res.err || !devices || devices.length === 0) {
                        vm.contractItems[contractItemNumber].devices = [];
                    } else {
                        res.results.forEach(function (item) {
                            batchModelDisplayValues(item);
                            !item.model_id ? (item.model_id = "Unknown") : null;
                        });
                        vm.contractItems[contractItemNumber].devices = res.results;
                    }
                }
            );
        }

        function batchModelDisplayValues(obj) {
            for (var item in obj) {
                if (angular.isObject(obj[item])) {
                    obj[item] = returnDisplayValue(obj[item]);
                }
            }
        }

        function addContractItemRows(conItems) {
            vm.contractItems = {};
            conItems.forEach(function (item) {
                vm.contractItems[item.con_u_number] = {
                    contractItem: item.con_u_number,
                    quotedDevices: Number(item.con_u_estimated_devices_to_quote),
                    deviceType: item.ma_u_description,
                    sku: returnDisplayValue(item.ma_u_sku),
                    discount: Number(item.con_u_discount),
                    priceDisplay: item.pr_u_price,
                    checked: false,
                    sys_id: item.con_sys_id
                };
                vm.contractItems[item.con_u_number].price = formatRawPrice(item.pr_u_price);
                vm.contractItems[item.con_u_number].serviceLevel = formatServiceLevel(
                    vm.contractItems[item.con_u_number].sku
                );
            });
        }

        function formatServiceLevel(sku) {
            if (sku) {
                return sku.split("-")[2];
            } else {
                return null;
            }
        }

        function formatRawPrice(price) {
            if (price) {
                return Number(price.replace("$", "").replace(",", ""));
            } else {
                return 0;
            }
        }

        function calculateTotals() {
            vm.totalCost = 0;
            for (var item in vm.contractItems) {
                var singleItem = vm.contractItems[item];
                var discountPrice = singleItem.price - singleItem.price * Number(singleItem.discount);
                singleItem.total = discountPrice * Number(singleItem.quotedDevices);
                singleItem.totalDisplay = "$" + singleItem.total.toFixed(2);
                vm.totalCost += singleItem.total;
            }
            vm.totalCost = vm.totalCost;
            vm.totalCostDisplay = "$" + vm.totalCost.toFixed(2);
        }

        function returnDisplayValue(obj) {
            if (obj && obj.display_value) {
                return obj.display_value;
            } else {
                return null;
            }
        }

        vm.tableData = [];

        function calcDuration() {
            var start = moment(vm.contract.u_contract_start_date);
            var end = moment(vm.contract.u_contract_end_date);
            vm.contract.duration = end.diff(start, "years");
            vm.contract.u_contract_start_date = new Date(vm.contract.u_contract_start_date);
        }

        function fetchSelectedDevices() {
            var selectedDevices = [];
            for (var item in vm.contractItems) {
                vm.contractItems[item].devices.forEach(function (item) {
                    if (item.checked) {
                        selectedDevices.push(item.sys_id);
                    }
                });
            }
            return selectedDevices;
        }

        // UI trigger for confirmation of device decommission
        vm.decommissionDevices = function () {
            //get array of selected device sysids
            var selectedDevices = fetchSelectedDevices();
            if (selectedDevices.length === 0) {
                vm.alerts = [
                    {
                        type: "danger",
                        msg: "No Devices Selected"
                    }
                ];
            } else {
                sendDecommission(selectedDevices);
            }
        };

        // send rest call to SNOW with selected device to decommisson.  Creates a change request.
        function sendDecommission(selectedDevices) {
            var modalInst = $uibModal.open({
                templateUrl: "app/devices/getRequestedByDate.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: RequestedByDate,
                controllerAs: "vm"
            });
            modalInst.result.then(function (data) {
                if (data) {
                    $log.info(selectedDevices);
                    // var requestItem = {
                    //     "u_cmdb_ci": selectedDevices,
                    //     "u_requested_by_date": data.requested_by_date,
                    //     "u_requested_by": data.requested_for,
                    //     "u_opened_by": user_info.sys_id,
                    //     "u_short_description": "Portal Device Decommission",
                    //     "u_company": user_info.company
                    // }
                    // Service.createItem('u_imp_silo_requests', requestItem, function (response) {
                    //     if (response.error) {
                    //         vm.status = [];
                    //         vm.error = true;
                    //         vm.alerts = [{
                    //             type: 'danger',
                    //             msg: response
                    //         }];
                    //     } else {
                    //         $uibModal.open({
                    //             templateUrl: 'app/status/confirmation.html',
                    //             ariaLabelledBy: 'modal-title',
                    //             ariaDescribedBy: 'modal-body',
                    //             controller: ConfirmChangeRequest,
                    //             controllerAs: 'vm',
                    //             resolve: {
                    //                 ticket: function () {
                    //                     if (response.result) {
                    //                         return {
                    //                             number: response.result.number,
                    //                             sys_id: response.result.sys_id
                    //                         }
                    //                     } else {
                    //                         return null;
                    //                     }
                    //                 },
                    //                 decommission: true
                    //             }
                    //         });
                    //     }
                    // })
                } else {
                    vm.alerts = [
                        {
                            type: "danger",
                            msg: "No Request By Date Selected"
                        }
                    ];
                }
            });
        }

        vm.go_back = function () {
            $state.go("index.contracts");
        };

        vm.go_back_quote = function () {
            $state.go("index.quotes");
        };

        var page = 0;

        vm.page_changed = function () {
            vm.offset = parseInt(vm.current_page - 1) * page;
            $state.go("index.contracts", {
                offset: vm.offset
            });
        };

        //sets up table options for the table view of available contracts
        // var stateTitle;
        // $state.current.name === "index.contracts" ||
        // $state.current.name === "index.contract_single" ||
        // $state.current.name === "index.quotes"
        //     ? (stateTitle = "")
        //     : (stateTitle = "Monitored Devices Not In Contract");
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withDOM('lf<".table-scroll"rt>ip')
            .withDOM('lf<".dt-sku">rtip')
            .withOption("aoColumnDefs", [
                {
                    bSortable: false,
                    aTargets: ["nosort"]
                }
            ])
            .withOption("iDisplayLength", 10)
            .withOption("responsive", true);
        vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef([4, 5]).withOption("type", "date")];
        //route handling conditional statement
        if ($stateParams.quoteID != undefined || $stateParams.contractID != undefined) {
            vm.contractID = $stateParams.quoteID || $stateParams.contractID;
            vm.loading = true;
            vm.loadingCI = true;
            Contracts.getSingle(vm.contractID, "u_bms_contracts", function (data) {
                vm.loading = false;
                if (data.error) {
                    vm.error = true;
                    vm.contract = [];
                } else {
                    vm.contract = data.results;
                    if (vm.contract && vm.contract.u_contract_start_date && vm.contract.u_contract_end_date) {
                        calcDuration();
                    }
                    vm.contract.u_startup_fee_billed = vm.contract.u_startup_fee_billed == "true";
                    if (
                        user_info.group.indexOf("Customer - Executive") != -1 ||
                        user_info.group.indexOf("BCS Manager") != -1 ||
                        user_info.group.indexOf("BMS Contract Readers") != -1 ||
                        user_info.group.indexOf("Burwood Account Executive") != -1
                    ) {
                        vm.authorized = true;
                        if (vm.contract.opened_by.value == user_info.sys_id && vm.contract.u_status == "Draft") {
                            vm.disabled = false;
                        }
                        if (vm.contract.u_bill_to_company && vm.contract.u_bill_to_company.value) {
                            Service.getCompany(vm.contract.u_bill_to_company.value, function (data2) {
                                if (data2 && data2.results) {
                                    vm.contract.u_bill_to_company_display = data2.results.name;
                                }
                            });
                            vm.contract.u_bill_to_company = data.results.u_bill_to_company.value;
                        }
                        Service.getCompany(vm.contract.company.value, function (response) {
                            vm.companyLoading = false;
                            if (response && response.results) {
                                vm.contract.company_display = response.results.name;
                                vm.contract.company = response.results.name;
                                vm.contract.address =
                                    response.results.street +
                                    " " +
                                    response.results.city +
                                    " " +
                                    response.results.state +
                                    " " +
                                    response.results.country;
                                vm.contract.account_executive = user_info.name;
                                vm.contract.phone = user_info.mobile_phone;
                            }
                            getAttachments();
                            populateContractItems(vm.contract.sys_id);
                        });
                    } else {
                        vm.authorized = false;
                    }
                }
            });
        } else {
            if (
                user_info.group.indexOf("Customer - Executive") != -1 ||
                user_info.group.indexOf("BCS Manager") != -1 ||
                user_info.group.indexOf("BCS Contract Readers") != -1 ||
                user_info.group.indexOf("Burwood Account Executive") != -1
            ) {
                vm.authorized = true;
                if ($state.current.name === "index.contract_exceptions") {
                    Service.getExceptions(function (data) {
                        vm.loading = false;
                        if (data.err || !data.results) {
                            vm.error = true;
                        } else {
                            vm.exceptionsList = data.results;
                        }
                    }, user_info.company);
                } else {
                    var allContracts = user_info.company;
                    if (
                        user_info.group.indexOf("BG Technical Architects") != -1 ||
                        user_info.group.indexOf("BG Executive Directors") != -1
                    ) {
                        allContracts = false;
                    }
                    Contracts.getContracts(
                        allContracts,
                        function (data) {
                            vm.loading = false;
                            if (data.err || !data.results) {
                                vm.error = true;
                                vm.Contracts = [];
                            } else {
                                vm.total_result = data.count;
                                vm.contracts = data.results;
                            }
                        },
                        5000,
                        0
                    );
                }
            } else {
                vm.authorized = false;
            }
        }

        vm.close_notice = function (index) {
            vm.alerts.splice(index, 1);
        };

        vm.contact = function () {
            var modalInst = $uibModal.open({
                resolve: {
                    list: function () {
                        return vm.contract.company;
                    }
                },
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: ContactList,
                controllerAs: "vm"
            });
            modalInst.result.then(function (data) {
                if (data) {
                    vm.contract.u_contact_name = data.name;
                    vm.contract.u_contact_email = data.email;
                }
            });
        };

        vm.company = function (type) {
            var modalInst = $uibModal.open({
                templateUrl: "app/contracts/company_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: CompanyList,
                controllerAs: "vm"
            });
            modalInst.result.then(function (data) {
                if (data) {
                    if (type === "bill") {
                        vm.contract.u_bill_to_company_display = data.company;
                        vm.contract.u_bill_to_company = data.sys_id;
                    } else if (type === "company") {
                        Contracts.getContracts(data.sys_id, function (response) {
                            if (response.count == "0") {
                                vm.contract.company_display = data.company;
                                vm.contract.company = data.sys_id;
                                vm.contract.u_bill_to_company_display = data.company;
                                vm.contract.u_bill_to_company = data.sys_id;
                                vm.getCustomerCode();
                            } else {
                                vm.alerts = [
                                    {
                                        type: "danger",
                                        msg: "Contacts Already Exists For This Company."
                                    }
                                ];
                            }
                        });
                    }
                }
            });
        };

        vm.attachment = function () {
            var modalInst = $uibModal.open({
                templateUrl: "app/shared/html/attachment_form.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: AttachController,
                controllerAs: "vm"
            });
            modalInst.result.then(function (data) {
                vm.caller_name = data.name;
                vm.caller_id = data.caller_id;
            });
        };

        vm.open_datepicker = function () {
            vm.datepicker_opened = true;
        };

        vm.open_datepicker2 = function () {
            vm.datepicker_opened2 = true;
        };

        var events = [];
        angular.element("body").on("mousedown", "div.handle", function () {
            angular.element("th").off("click.DT");
        });
        angular.element("body").on("mouseup", "th", function () {
            if (angular.element(".handle").hasClass("active")) {
                $timeout(function () {
                    for (var name in events) {
                        angular.element("th").bind(name, events[name]);
                    }
                    angular.element(".nosort, .ng-isolate-scope").off("click.DT");
                }, 100);
            }
        });
    }

    function AttachController($uibModalInstance, ServiceNow, $stateParams) {
        var vm = this;

        var contractID = $stateParams.contractID || $stateParams.quoteID;
        var page_size = 10;

        vm.attachments = [];
        vm.uploading = false;
        vm.loading = false;

        var reloadData = function () {
            vm.loading = true;
            ServiceNow.getAllAttachment(contractID, "u_bms_contracts", page_size, page_size, function (data) {
                if (data && data.result) {
                    vm.attachments = data.result;
                }
                vm.loading = false;
            });
        };

        vm.addAttachment = function () {
            vm.uploading = true;
            if (vm.upload_file != undefined && vm.upload_file != null) {
                ServiceNow.addAttachment(contractID, "u_bms_contracts", [vm.upload_file], function () {
                    vm.upload_file = null;
                    vm.uploading = false;
                    reloadData();
                });
            }
        };

        vm.deleteAttachment = function (attachment) {
            if (confirm("Are you sure want to delete " + attachment.file_name + " ?")) {
                if (attachment && attachment["sys_id"]) {
                    ServiceNow.deleteAttachment(attachment.sys_id, function () {
                        reloadData();
                    });
                }
            }
        };

        vm.close = function () {
            $uibModalInstance.dismiss("cancel");
        };

        reloadData();
    }

    function ContactList(user_info, $uibModalInstance, Status, list, DTOptionsBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions().withOption("responsive", true);
        vm.loading = true;
        vm.current_page = parseInt(offset) / 10 + 1;

        var offset = 0,
            page = 500;

        var companyChosen = list || user_info.company;

        vm.addtolist = function (name, caller_id, email) {
            var data = {
                name: name,
                caller_id: caller_id,
                email: email
            };
            $uibModalInstance.close(data);
        };

        vm.page_changed = function () {
            vm.loading = true;
            vm.offset = parseInt(vm.current_page - 1) * page;
            Status.getCompanyUser(
                function (data) {
                    vm.loading = false;
                    if (data.error) {
                        vm.total_result = 0;
                        vm.users = [];
                    } else {
                        vm.total_result = data.count;
                        vm.users = data.results;
                    }
                },
                companyChosen,
                page,
                offset
            );
        };

        vm.close = function () {
            $uibModalInstance.dismiss("cancel");
        };

        Status.getCompanyUser(
            function (data) {
                vm.loading = false;
                if (data.error) {
                    vm.total_result = 0;
                    vm.users = [];
                } else {
                    vm.total_result = data.count;
                    vm.users = data.results;
                }
            },
            companyChosen,
            page,
            offset
        );
    }

    function CompanyList(user_info, $uibModalInstance, Service, DTOptionsBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions().withOption("responsive", true);
        vm.loading = false;
        vm.current_page = parseInt(offset) / 10 + 1;
        vm.searchComplete = false;
        vm.companies = false;

        var offset = 0,
            page = 1500;

        vm.addtolist = function (company, sys_id) {
            var data = {
                company: company,
                sys_id: sys_id
            };
            $uibModalInstance.close(data);
        };

        vm.page_changed = function () {
            vm.loading = true;
            vm.offset = parseInt(vm.current_page - 1) * page;
            Service.getCompanies(
                function (data) {
                    vm.loading = false;
                    if (data.error) {
                        vm.total_result = 0;
                        vm.companies = [];
                    } else {
                        vm.total_result = data.count;
                        vm.companies = data.results;
                    }
                },
                page,
                vm.offset,
                {
                    cus_code: true
                }
            );
        };

        vm.searchCompany = function () {
            vm.loading = true;
            Service.getQuery(
                {
                    containsCompany: vm.companyTerm
                },
                "core_company",
                function (data) {
                    vm.loading = false;
                    if (data && data.results && data.results.length > 0) {
                        vm.companies = data.results;
                        vm.dataExists = true;
                    } else {
                        vm.companies = [];
                        vm.dataExists = false;
                    }
                    vm.searchComplete = true;
                }
            );
        };

        vm.close = function () {
            $uibModalInstance.dismiss("cancel");
        };
    }

    function Processing($uibModalInstance) {
        var vm = this;
        vm.loading = true;
        vm.close = function () {
            $uibModalInstance.dismiss("cancel");
        };
    }

    function RequestedByDate($uibModalInstance, $uibModal) {
        var vm = this;
        vm.dateToggle = {
            requested_by_date: false
        };
        vm.contact = function () {
            var modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: ContactList,
                controllerAs: "vm"
            });
            modalInst.result.then(function (data) {
                if (data) {
                    vm.caller_name = data.name;
                    vm.caller_id = data.caller_id;
                }
            });
        };
        vm.openCalendar = function (e, picker) {
            vm.dateToggle[picker] = true;
        };
        vm.close = function () {
            $uibModalInstance.close({
                requested_by_date: vm.requested_by_date,
                requested_for: vm.caller_id
            });
        };
    }

    // function ConfirmChangeRequest($uibModalInstance, $state, ticket, decommission) {
    //     var vm = this;
    //     vm.number = ticket.number;
    //     vm.additionalMessage = 'Your device/s have been scheduled for maintenance.'
    //     decommission ? vm.additionalMessage = 'Your device is awaiting approval for decommission.' : '';
    //     vm.close = function () {
    //         $uibModalInstance.dismiss('cancel');
    //         if (ticket && !decommission) {
    //             $state.go('dashboard.uchange_single', {
    //                 requestID: ticket.sys_id
    //             });
    //         } else {
    //             $state.go('dashboard.requests');
    //         }
    //     }
    // }
})();

(function () {
    angular.module('burWood').controller("ContactListsController", ContactListsController);

    /** @ngInject */
    function ContactListsController(
        $scope,
        BCSServer
    ) {
        let vm = this;
        vm.companySelected;
        vm.groupSelected;
        vm.deptSelected;
        vm.searchWord;
        vm.searchfilterToggle = 'filter';
        vm.toggleCBox = 'on';
        vm.toggleGBox = 'on';
        vm.toggleDBox = 'on';

        vm.fetContactLists = () => {
            BCSServer.getData("/client_contacts",
                (response) => {
                    if (response) {
                        vm.data = response;
                        vm.searchList = Object.values(response);
                    }
                })
        };

        vm.fetContactLists();

        vm.searchRecord = (word) => {
            vm.searchLog = {};
            let searchWord = word.toLowerCase()

            for (let i = 0; i < vm.searchList.length; i++) {
                let company = vm.searchList[i];
                if (searchWord == company.company.companyCode.toLowerCase()) {
                    vm.companySelected = company;
                    vm.groupSelected = null;
                    vm.deptSelected = null;
                    vm.searchLog['company'] = company.company.companyCode;
                    return
                }
                for (let j = 0; j < company.groups.length; j++) {
                    let group = company.groups[j]
                    if (searchWord == group.groupName.toLowerCase() || group.groupName.toLowerCase().includes(searchWord) || word == group.groupID) {
                        vm.companySelected = company;
                        vm.groupSelected = group;
                        vm.deptSelected = null;
                        vm.searchLog['company'] = company.company.companyCode;
                        vm.searchLog['group'] = group.groupName;
                        return
                    }
                    for (let k = 0; k < group.groupDeparts.length; k++) {
                        let dept = group.groupDeparts[k];
                        for (let l = 0; l < dept.departmentProjects.length; l++) {
                            let projectID = dept.departmentProjects[l].projectID
                            if (projectID.includes(word)) {
                                vm.companySelected = company;
                                vm.groupSelected = group;
                                vm.deptSelected = dept;
                                vm.searchLog['company'] = company.company.companyCode;
                                vm.searchLog['group'] = group.groupName;
                                vm.searchLog['department'] = dept.departmentName;
                                vm.searchLog['project'] = { 'softMatch': projectID };
                            } else if (word == projectID) {
                                vm.companySelected = company;
                                vm.groupSelected = group;
                                vm.deptSelected = dept;
                                vm.searchLog['company'] = company.company.companyCode;
                                vm.searchLog['group'] = group.groupName;
                                vm.searchLog['department'] = dept.departmentName;
                                vm.searchLog['project'] = { 'hardMatch': projectID };
                                return
                            }
                        }
                    }
                }
            }
            if (Object.keys(vm.searchLog).length == 0) {
                vm.searchLog['error'] = 'No record found'
            }
            return
        }

        vm.componentTitleStyle = {
            'text-transform': 'uppercase',
            'font-weight': 100,
            'letter-spacing': '1px'
        }

        vm.componentBoxStyle = {
            'background-color': 'rgba(0,0,0,.6)',
            'margin-bottom': '20px'
        }
        vm.contactViewBoxStyle = {
            'background-color': '#1D1C1C',
            'border': '1px solid #3d3d3d',
            'border-radius': '5px',
            'padding': '10px 20px'
        }
        vm.contactSelectBoxStyle = {
            'padding': '0 10px'
        }

        vm.contactListStyle = {
            'list-style-type': 'none',
            'max-height': '110px',
            'overflow-y': 'auto',
            'background-color': '#333',
            'border-radius': '5px',
            'color': 'white'
        }
    }
})();
(function() {
	'use strict';

	angular
		.module('burWood')
		.controller('ContactusController', ContactusController);

	/** @ngInject */
	function ContactusController(user_info) {
		var vm = this;
		vm.loading = false;

		//set specific phone number for western digital
		vm.operations;
		if (user_info.company === '019ea6a91352d6002d503262f244b090') {
			vm.operations = '408-717-6611';
		} else {
			vm.operations = '312-592-8387';
		}

	}
})();

(function () {
    angular.module("burWood").controller("PasswordController", PasswordController);

    /** @ngInject */
    function PasswordController(user_info, Navbar, $uibModalInstance) {
        let vm = this;
        vm.loading = false;
        vm.close = () => {
            $uibModalInstance.dismiss("cancel");
        };
        vm.updatePass = (data) => {
            if (data.new_pass.length < 8) {
                vm.alerts = [
                    {
                        type: "danger",
                        msg: "Password must be at least 8 characters long."
                    }
                ];
            } else {
                vm.loading = true;
                var sys_id = user_info.sys_id;
                let password = data.new_pass;
                var confirm_password = data.new_pass_confirm;
                var old_password = data.old_password;
                vm.alerts = [];
                Navbar.changePassword(sys_id, old_password, password, confirm_password, (data) => {
                    vm.loading = false;
                    if (data == null || data == {}) {
                        return vm.alerts.push({
                            type: "danger",
                            msg: "Something went wrong. Please try again!"
                        });
                    }
                    if (data["success"] == true) {
                        vm.pass = {};
                        vm.alerts = [
                            {
                                type: "success",
                                msg: "Password Successfully Changed!"
                            }
                        ];
                    } else {
                        if (data["message"]) {
                            vm.alerts.push({
                                type: "danger",
                                msg: data.message
                            });
                        } else {
                            vm.alerts.push({
                                type: "danger",
                                msg: "Something went wrong. Please try again later!"
                            });
                        }
                    }
                });
            }
        };
    }
})();

(function () {
    angular.module("burWood").controller("CompanyController", CompanyController);

    /** @ngInject */
    function CompanyController(_, user_info, DTOptionsBuilder, DTColumnDefBuilder, ServiceNow) {
        let vm = this;

        vm.tabView = "circuit";

        let columnFilter = {
            aoColumns: [
                null,
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                }
            ]
        };

        vm.dtInstance = {};
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withDOM('lfB<".table-scroll"rt>ip')
            .withOption("aoColumnDefs", [
                {
                    bSortable: false,
                    aTargets: ["nosort"]
                }
            ])
            .withColumnFilter(columnFilter)
            .withOption("iDisplayLength", 10)
            .withOption("responsive", true);
        vm.dtColumnDefsUser = [DTColumnDefBuilder.newColumnDef(5).withOption("type", "date")];

        vm.circuitLoading = true;
        vm.vendorLoading = true;
        vm.locationLoading = true;
        vm.userLoading = true;

        const fetchCircuits = () => {
            vm.circuits = [];

            ServiceNow.getQuery({}, "u_circuit_id|circuits", (response) => {
                if (response.error) {
                    return;
                } else {
                    vm.circuits = response.results;
                }
                vm.circuitLoading = false;
            });
        };

        const fetchVendors = () => {
            vm.vendors = [];

            if (!user_info.sys_domain) {
                vm.vendorLoading = false;
                return;
            }

            ServiceNow.getQuery(
                {
                    sys_domain: user_info.sys_domain,
                    vendor: true,
                    bypassCompany: true
                },
                "core_company",
                (response) => {
                    if (response.error) {
                        return;
                    } else {
                        vm.vendors = response.results;
                    }
                    vm.vendorLoading = false;
                }
            );
        };

        const fetchLocations = () => {
            vm.locations = [];

            ServiceNow.getQuery({}, "cmn_location|locationList", (response) => {
                if (response.error) {
                    return;
                } else {
                    vm.locations = response.results;
                }
                vm.locationLoading = false;
            });
        };

        const fetchUsers = () => {
            vm.users = [];

            ServiceNow.getQuery({}, "sys_user|userList", (response) => {
                if (response.error) {
                    return;
                } else {
                    vm.users = response.results;
                }
                vm.userLoading = false;
            });
        };

        fetchCircuits();
        fetchVendors();
        fetchLocations();
        fetchUsers();
    }
})();

(function() {
    "use strict";

    angular.module("burWood").factory("Calendar", Calendar);

    function Calendar() {
        return {};
    }
})();

(function () {
    angular.module("burWood").controller("CalendarController", CalendarController);

    /** @ngInject */
    function CalendarController($state, ChangeRequest, $scope, moment) {
        let vm = this;
        vm.requests = [];
        vm.loadingCalendar = true;

        vm.timeline = $scope.timeline;

        //calendar options
        vm.options = {
            start_at_end: true,
            timenav_position: "top",
            scale_factor: 0.5,
            language: "en",
            duration: 500
        };

        vm.states = ["All", "Scheduled", "Implement"];
        vm.chosenState = vm.states[0];

        //function to filter by state
        vm.switchStateFilter = () => {
            let tempState = [];
            let noData;
            if (vm.chosenState != "All") {
                for (let x = 0; x < vm.tempData.length; x++) {
                    if (vm.tempData[x].state === vm.chosenState) {
                        tempState.push(vm.tempData[x]);
                    }
                }
                if (tempState.length === 0) {
                    //if no changes exist
                    noData = true;
                    tempState = [
                        {
                            start_date: {
                                year: new Date().getFullYear().toString(),
                                month: (parseInt(new Date().getMonth()) + 1).toString(),
                                day: new Date().getDate().toString()
                            },
                            text: {
                                headline: "No results for Change Request",
                                text: ""
                            }
                        }
                    ];
                }
                data.events = tempState;
            } else {
                data.events = vm.tempData;
            }
            vm.timeline.setData(data);
            if (noData) {
                vm.timeline.goTo(1);
            }
            vm.colorCodePanes();
        };

        // initial calendar pane
        let data = {
            title: {
                media: {
                    url: "../assets/img/white_logo.png",
                    caption: "Smarter Solutions, Better Outcomes."
                },
                text: {
                    headline: "Change Request Calendar",
                    text: "<p>View and navigate through the history of change requests</p>"
                }
            },
            events: []
        };

        vm.getDayMonthYear = function (date) {
            let day = moment(date).format("D");
            let month = moment(date).format("M");
            let year = moment(date).format("YYYY");
            return [year, month, day];
        };

        //gets all the change request tickets
        ChangeRequest.getCalendar(
            "",
            (res) => {
                vm.loadingCalendar = false;
                if (res.error) {
                    return;
                } else {
                    vm.requests = res.results;
                    if (vm.requests.length != 0) {
                        vm.requests.reverse();
                        //looping through changes, setting up calendar panes
                        for (let x = 0; x < vm.requests.length; x++) {
                            var openedDate, startDate, requestedDate, endDate;
                            if (vm.requests[x].start_date) {
                                startDate = vm.getDayMonthYear(vm.requests[x].start_date);
                            } else if (vm.requests[x].requested_by_date) {
                                requestedDate = vm.getDayMonthYear(vm.requests[x].requested_by_date);
                            } else if (vm.requests[x].end_date) {
                                endDate = vm.getDayMonthYear(vm.requests[x].end_date);
                            } else {
                                openedDate = vm.getDayMonthYear(vm.requests[x].opened_at);
                            }
                            let changeDate = startDate || requestedDate || endDate || openedDate;
                            var assigned_to = "";
                            var requested_by = "";
                            var assignment_group = "";
                            let device = "";
                            if (vm.requests[x].requested_by) {
                                requested_by = vm.requests[x].requested_by.display_value;
                            }
                            if (vm.requests[x].assigned_to) {
                                assigned_to = vm.requests[x].assigned_to.display_value;
                            }
                            if (vm.requests[x].assignment_group) {
                                assignment_group = vm.requests[x].assignment_group.display_value;
                            }
                            if (vm.requests[x].cmdb_ci) {
                                device = vm.requests[x].cmdb_ci.display_value;
                            } else {
                                device = "No Associated Device";
                            }

                            let eventObj = {
                                state: vm.requests[x].state,
                                start_date: {
                                    year: changeDate[0],
                                    month: changeDate[1],
                                    day: changeDate[2]
                                },
                                text: {
                                    headline:
                                        '<a class="compile-click" href="/u_customer_changes/' +
                                        vm.requests[x].sys_id +
                                        '" style="font-weight:400; cursor:pointer">' +
                                        vm.requests[x].number +
                                        " - " +
                                        vm.requests[x].state +
                                        "</a>",
                                    text:
                                        '<p style="font-size:14px; color:#b3b3b3;font-weight: 400;">' +
                                        "Requested By Date: &nbsp;&nbsp;&nbsp;&nbsp;" +
                                        vm.requests[x].requested_by_date +
                                        "<br>" +
                                        "Start Date: &nbsp;&nbsp;&nbsp;&nbsp;" +
                                        vm.requests[x].start_date +
                                        "<br>" +
                                        "End Date: &nbsp;&nbsp;&nbsp;&nbsp;" +
                                        vm.requests[x].end_date +
                                        "</p>" +
                                        vm.requests[x].short_description +
                                        '<div class="tl-request-details">' +
                                        '<div><p class="details-title">State:</p><p class="details-data">' +
                                        vm.requests[x].state +
                                        "</p></div>" +
                                        '<div><p class="details-title">Active:</p><p class="details-data">' +
                                        vm.requests[x].active +
                                        "</p></div>" +
                                        '<div><p class="details-title">Device:</p><p class="details-data">' +
                                        device +
                                        "</p></div>" +
                                        '<div><p class="details-title">Requested By:</p><p class="details-data">' +
                                        requested_by +
                                        "</p></div>" +
                                        '<div><p class="details-title">Assigned To: </p><p class="details-data">' +
                                        assigned_to +
                                        "</p></div>" +
                                        '<div><p class="details-title">Assignment Group:</p><p class="details-data">' +
                                        assignment_group +
                                        "</p></div>" +
                                        '<div><p class="details-title">Opened:</p><p class="details-data">' +
                                        vm.requests[x].opened_at +
                                        "</p></div>" +
                                        "</div>"
                                }
                            };
                            data.events.push(eventObj);
                        }
                        //set temp data holder
                        vm.tempData = data.events;
                        //setting the data
                        vm.timeline.setData(data);
                        vm.colorCodePanes();
                    } else {
                        //if no changes exist
                        var eventObj2 = {
                            start_date: {
                                year: new Date().getFullYear().toString(),
                                month: (parseInt(new Date().getMonth()) + 1).toString(),
                                day: new Date().getDate().toString()
                            },
                            text: {
                                headline: "No results for Change Request",
                                text: ""
                            }
                        };
                        data.events.push(eventObj2);
                        vm.timeline.setData(data);
                        vm.timeline.goTo(1);
                    }
                }
            },
            5000,
            0
        );

        let stateColors = ["#7a7a7a", "#5d7caf", "#5eafb1", "#60b382", "#71b461", "#a5b663", "#b89764", "#ba6666"];
        let states = ["Draft", "Assess", "Authorize", "Scheduled", "Implement", "Review", "Closed", "Canceled"];

        vm.colorCodePanes = () => {
            angular.element(".tl-timemarker .tl-timemarker-content-container").each(() => {
                let ticketNum = angular.element(this).find("h2").text();
                let tickState = ticketNum.slice(13);
                let colorIndex = states.indexOf(tickState);
                let tabColor = stateColors[colorIndex];
                angular.element(this).css({ "background-color": tabColor });
            });
        };

        //watching for the options to change to set to the timeline
        $scope.$watch(
            "vm.options",
            (newOptions) => {
                if (vm.timeline) {
                    vm.timeline.setOptions(newOptions);
                }
            },
            true
        );

        //route to ticket on click
        vm.goToTicket = (sys_id) => {
            $state.go("index.uchange_single", {
                requestID: sys_id
            });
        };
    }
})();

(function () {
    angular.module("burWood").factory("BoH", BoH);

    function BoH(ServiceNow) {
        return {
            getBoH: (state, callback, page_limit, offset, company) => {
                var query_obj = {
                    active_status: true,
                    bypassCompany: true,
                    u_company: company
                };
                ServiceNow.getTable(state, "u_boh_request", callback, page_limit, offset, query_obj);
            },
            getSingle: (bohId, callback) => {
                ServiceNow.getItem(bohId, "u_boh_request", callback);
            },
            getSingleHistory: (incId, callback) => {
                ServiceNow.getItem(incId, "sys_history_line", callback);
            },
            getUsers: (state, callback, page_limit, offset, sorting) => {
                var query_obj = {
                    sorting: sorting
                };
                ServiceNow.getTable(state, "sys_user", callback, page_limit, offset, query_obj);
            },
            getCompanyUser: (callback, company_id, page_limit, offset, filter) => {
                ServiceNow.getCompanyUser(callback, company_id, page_limit, offset, filter);
            },
            getUser: (userId, callback) => {
                ServiceNow.getItem(userId, "sys_user", callback);
            },
            getUserGroup: (callback) => {
                ServiceNow.getTable(null, "sys_user_group|groupListSlim", callback, 500, 0);
            },
            createBoH: (status, callback) => {
                ServiceNow.createItem("u_boh_request", status, callback);
            },
            updateBoH: (status, callback) => {
                ServiceNow.createItem("u_boh_request", status, callback);
            }
        };
    }
})();

(function () {
    angular.module("burWood").controller("BoHController", BoHController).filter("RemoveEmail", RemoveEmail);

    function RemoveEmail() {
        return (user) => {
            if (user) {
                let emailRemoved = user.replace(/\s*\(.*?\)\s*/g, "");
                return emailRemoved;
            }
        };
    }

    /** @ngInject */
    function BoHController(
        _,
        $log,
        user_info,
        $stateParams,
        $uibModal,
        FileSaver,
        $state,
        Service,
        BoH,
        Status,
        DTOptionsBuilder,
        DTColumnDefBuilder,
        $window,
        ServiceNow,
        Blob,
        util,
        $timeout
    ) {
        let vm = this;
        let offset = 0,
            page = 10;
        vm.showImpact = false;
        vm.showUrgency = false;
        vm.sortStart = $stateParams.sort;
        vm.sortType = $stateParams.type;
        vm.sortState = $stateParams.state;
        vm.customTitle = "BoH Tickets";

        vm.dtInstance = {};
        vm.showFilters = false;
        vm.current_user_id = user_info.sys_id;
        vm.loading = true;
        vm.accountLoading = true;
        vm.error = false;

        //checking if user is admin
        if (
            user_info.group &&
            (user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins Read Only") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins") != -1)
        ) {
            vm.isCloudAmin = true;
        }

        if (
            user_info.company === "c94993314a362312005cfc20c1aa15d2" ||
            user_info.company === "8d8073014f8d0300d227d48e5210c785"
        ) {
            vm.isBurwood = true;
        } else {
            vm.isBurwood = false;
        }

        vm.priorities = {
            1: "Critical",
            2: "High",
            3: "Moderate",
            4: "Minimal",
            5: "Informational"
        };

        vm.watch_lists = [];
        vm.watch_list_show = false;

        vm.watch_list_users = [];
        vm.related_show = false;

        vm.priority = [
            {
                id: "1",
                name: "1 - Critical"
            },
            {
                id: "2",
                name: "2 - High"
            },
            {
                id: "3",
                name: "3 - Moderate"
            },
            {
                id: "4",
                name: "4 - Minimal"
            },
            {
                id: "5",
                name: "5 - Informational"
            }
        ];

        vm.states = [
            {
                id: "1",
                name: "New"
            },
            {
                id: "3",
                name: "Pending Resource"
            },
            {
                id: "5",
                name: "Estimation Review"
            },
            {
                id: "7",
                name: "Pending Approval"
            },
            {
                id: "9",
                name: "Scheduled"
            },
            {
                id: "11",
                name: "Work in Progress"
            },
            {
                id: "12",
                name: "Complete"
            },
            {
                id: "13",
                name: "Cancelled"
            }
        ];

        vm.number = function (num) {
            return Number(num);
        };

        vm.findStateName = function (stateID) {
            let stateName = vm.states.find((state) => {
                return state.id === stateID;
            });
            return stateName ? stateName.name : "";
        };

        vm.availableStates = [];

        vm.formatTable = function (data, row, column) {
            let pri;
            if (column === 1) {
                if (data.indexOf("5 - Informational") != -1) {
                    pri = "5 - Informational";
                } else if (data.indexOf("4 - Minimal") != -1) {
                    pri = "4 - Minimal";
                } else if (data.indexOf("3 - Moderate") != -1) {
                    pri = "3 - Moderate";
                } else if (data.indexOf("2 - High") != -1) {
                    pri = "2 - High";
                } else if (data.indexOf("1 - Critical") != -1) {
                    pri = "1 - Critical";
                }
                return pri;
            } else if (column === 2 || column === 3) {
                var start_pos = data.indexOf(">") + 1;
                var end_pos = data.indexOf("<", start_pos);
                var text_to_get = data.substring(start_pos, end_pos);
                return text_to_get;
            }
            return data;
        };
        let buttonConfig = [
            {
                extend: "colvis",
                text: "Toggle Columns"
            },
            {
                text: "Search Closed Tickets",
                key: "2",
                action: () => {
                    angular.element("#global_search").triggerHandler("click");
                }
            },
            {
                text: "Show All BoHs",
                key: "1",
                action: (e, dt, node) => {
                    let table = angular.element(".table").DataTable();
                    table.search("").columns().search("").draw();
                    angular.element(node[0]).addClass("hidden");
                }
            },
            {
                extend: "collection",
                text: "Export",
                buttons: [
                    {
                        extend: "excel",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.formatTable(data, row, column, node);
                                }
                            }
                        }
                    },
                    {
                        extend: "pdf",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        customize: (doc) => {
                            doc.pageMargins = [5, 5, 5, 5];
                            doc.styles.tableHeader.fontSize = 10;
                            doc.defaultStyle.fontSize = 6;
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.formatTable(data, row, column, node);
                                }
                            }
                        }
                    },
                    {
                        extend: "csv",
                        title: () => {
                            return vm.customTitle;
                        },
                        filename: () => {
                            return vm.customTitle.replace(/ /g, "_");
                        },
                        exportOptions: {
                            format: {
                                body: (data, row, column, node) => {
                                    return vm.formatTable(data, row, column, node);
                                }
                            }
                        }
                    }
                ]
            }
        ];

        let columnFilter = {
            aoColumns: [
                null,
                null,
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                },
                {
                    type: "text",
                    bRegex: true,
                    bSmart: true
                }
            ]
        };

        let activityFilter = columnFilter;
        delete activityFilter.aoColumns.shift();

        vm.dtActivityOptions = DTOptionsBuilder.newOptions()
            .withOption("order", [["4", "des"]])
            .withColumnFilter(activityFilter)
            .withOption("responsive", true);
        vm.dtColumnDefsActivity = [
            DTColumnDefBuilder.newColumnDef(4).withOption("type", "date"),
            DTColumnDefBuilder.newColumnDef([3]).withClass("max-size-activity"),
            DTColumnDefBuilder.newColumnDef([1, 2, 4]).withClass("vert-align-activity")
        ];
        if (vm.sortStart && vm.sortType === "BoH") {
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('lfB<".table-scroll"rt>ip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withButtons(buttonConfig)
                .withColumnFilter(columnFilter)
                .withOption("responsive", true)
                .withOption("iDisplayLength", 10)
                .withOption("order", [["9", "des"]])
                .withOption("initComplete", () => {
                    let table = angular.element(".table").DataTable();
                    table.column(1).search(vm.sortStart).draw();
                });
            vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef([9, 10]).withOption("type", "date")];
        } else {
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('lfB<".table-scroll"rt>ip')
                .withOption("aoColumnDefs", [
                    {
                        bSortable: false,
                        aTargets: ["nosort"]
                    }
                ])
                .withButtons(buttonConfig)
                .withOption("order", [["9", "des"]])
                .withOption("iDisplayLength", 10)
                .withColumnFilter(columnFilter)
                .withOption("responsive", true);

            vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef([9, 10]).withOption("type", "date")];
        }

        vm.updateApproval = (approval) => {
            if (approval === "approved") {
                vm.boh.u_state = "9";
                vm.boh.u_work_notes = "Ticket Approved";
                vm.update();
            } else if (approval === "rejected") {
                vm.boh.u_state = "5";
                vm.boh.u_work_notes = "Ticket Rejected";
                vm.update();
            } else if (approval === "cancelled") {
                let prompt = confirm("Are you sure you would like to cancel this request?");
                if (!prompt) {
                    return false;
                }
                vm.boh.u_work_notes = "Ticket Cancelled";
                vm.boh.u_state = "13";
                vm.update();
            }
        };

        vm.goToTicket = (sys_id) => {
            $state.go("index.boh_single", {
                bohID: sys_id
            });
        };

        vm.composeAvailableStates = function (currentState) {
            let selectedStateIndex = _.findIndex(vm.states, {
                id: currentState
            });
            let availableStates = [
                vm.states[selectedStateIndex],
                vm.states[selectedStateIndex + 1],
                vm.states[vm.states.length - 1]
            ];
            if (currentState === "7") {
                availableStates.unshift(vm.states[selectedStateIndex - 1]);
            } else if (currentState === "12" || currentState === "13") {
                availableStates = [vm.states[selectedStateIndex]];
            }
            return availableStates;
        };

        vm.disabled = true;

        let loadBoH = () => {
            let bohID = $stateParams.bohID;
            BoH.getSingle(bohID, (data) => {
                Service.getQuery(
                    {
                        sys_id: bohID,
                        assertDisplay: true
                    },
                    "u_boh_request",
                    (displayData) => {
                        vm.loading = false;

                        if (data.error) {
                            vm.boh = {};
                            vm.createAlertMessage("Error loading ticket information", "danger");
                        } else {
                            vm.boh = data.results;
                            vm.boh.comments = null;

                            vm.initState = vm.boh.u_state;

                            if (vm.initState === "13" || vm.initState === "12") {
                                vm.disabled = true;
                            } else {
                                vm.disabled = false;
                            }

                            vm.availableStates = vm.composeAvailableStates(data.results.u_state);
                            var watch_lists_arr = displayData.results.u_watch_list;
                            var watch_lists_arr_raw = data.results.u_watch_list;

                            vm.assignedToId = data.results.u_assigned_to.value;
                            vm.assignedToName = displayData.results.u_assigned_to.display_value;

                            vm.userGroupId = data.results.u_assignment_group.value;
                            vm.userGroupName = displayData.results.u_assignment_group.display_value;

                            vm.companyName = displayData.results.u_company.display_value;

                            if (vm.boh.u_contact_email === user_info.email) {
                                vm.isApprover = true;
                            } else {
                                vm.isApprover = false;
                            }

                            if (
                                user_info.company === "c94993314a362312005cfc20c1aa15d2" ||
                                user_info.company === "8d8073014f8d0300d227d48e5210c785"
                            ) {
                                vm.isBurwood = true;
                            } else {
                                vm.isBurwood = false;
                            }

                            vm.boh.u_planned_start_date = new Date(vm.boh.u_planned_start_date);

                            vm.related_show = false;
                            vm.show_related();

                            vm.watch_list_users = [];
                            if (
                                watch_lists_arr != undefined &&
                                watch_lists_arr != null &&
                                watch_lists_arr != "" &&
                                watch_lists_arr != " "
                            ) {
                                var watch_lists = watch_lists_arr.split(",");
                                var watch_lists_raw = watch_lists_arr_raw.split(",");
                                watch_lists.forEach((user, index) => {
                                    vm.watch_list_users.push({
                                        name: user,
                                        sys_id: watch_lists_raw[index]
                                    });
                                });
                            }
                        }
                    }
                );
            });
        };

        vm.createAlertMessage = (msg, type) => {
            vm.alerts.push({
                type: type,
                msg: msg
            });

            $timeout(() => {
                vm.alerts = [];
            }, 5000);
        };

        vm.create = (boh, $valid) => {
            vm.loading = true;
            vm.alerts = [];

            vm.boh.u_assignment_group = "7fc641e94ffc5e4061fcc3fd0210c70c";
            if (vm.boh.u_planned_start_date) {
                vm.boh.u_planned_start_date = vm.boh.u_planned_start_date.toISOString();
                vm.boh.u_planned_start_date = vm.boh.u_planned_start_date.replace("T", " ").substring(0, 19);
            }
            if (vm.preferredEngineer) {
                vm.boh.u_description += "\n\n Preferred Engineer: \n " + vm.preferredEngineer;
            }

            if ($valid) {
                BoH.createBoH(vm.boh, (data) => {
                    console.log(data);
                    vm.loading = false;
                    if (!data.result) {
                        vm.boh = [];
                        vm.error = true;
                        vm.createAlertMessage(data, "danger");
                    } else {
                        if (vm.attachmentList.length != 0) {
                            let count = 0;
                            for (let x = 0; x < vm.attachmentList.length; x++) {
                                ServiceNow.addAttachment(
                                    data.result.sys_id,
                                    "u_boh_request",
                                    [vm.attachmentList[x]],
                                    () => {
                                        count++;
                                        if (count === vm.attachmentList.length) {
                                            $uibModal.open({
                                                templateUrl: "app/shared/html/ticketConfirmation.html",
                                                ariaLabelledBy: "modal-title",
                                                ariaDescribedBy: "modal-body",
                                                controller: "TicketRedirectController",
                                                controllerAs: "vm",
                                                resolve: {
                                                    ticket: () => {
                                                        return {
                                                            number: data.result[0].display_value,
                                                            sys_id: data.result[0].sys_id
                                                        };
                                                    },
                                                    field: () => "bohID",
                                                    route: () => "boh_single"
                                                }
                                            });
                                        }
                                    }
                                );
                            }
                        } else {
                            $uibModal.open({
                                templateUrl: "app/shared/html/ticketConfirmation.html",
                                ariaLabelledBy: "modal-title",
                                ariaDescribedBy: "modal-body",
                                controller: "TicketRedirectController",
                                controllerAs: "vm",
                                resolve: {
                                    ticket: () => {
                                        return {
                                            number: data.result[0].display_value,
                                            sys_id: data.result[0].sys_id
                                        };
                                    },
                                    field: () => "bohID",
                                    route: () => "boh_single"
                                }
                            });
                        }
                    }
                });
            } else {
                vm.error = true;
            }
        };

        vm.update = () => {
            vm.loading = true;
            vm.alerts = [];
            let newBoh = {};
            var watch_list_arr = [];
            var temp_watch_list = Object.assign({}, vm.watch_list_users);
            for (var key in temp_watch_list) {
                watch_list_arr.push(temp_watch_list[key].sys_id);
            }
            var request_watch_list = watch_list_arr.join(",");

            newBoh.u_watchlist = request_watch_list;
            newBoh.u_comments = vm.boh.u_comments;

            if (vm.boh.u_planned_start_date) {
                newBoh.u_planned_start_date = vm.boh.u_planned_start_date.toISOString();
                newBoh.u_planned_start_date = newBoh.u_planned_start_date.replace("T", " ").substring(0, 19);
            }

            newBoh.u_contact_name = vm.boh.u_contact_name;
            newBoh.u_contact_email = vm.boh.u_contact_email;
            newBoh.u_contact_phone = vm.boh.u_contact_phone;
            newBoh.u_added_to_psa = vm.boh.u_added_to_psa;
            newBoh.u_priority = vm.boh.u_priority;
            newBoh.u_state = vm.boh.u_state;
            newBoh.u_cust_remaining_hours = vm.boh.u_cust_remaining_hours;
            newBoh.u_estimated_hours = vm.boh.u_estimated_hours;
            newBoh.u_actual_hours = vm.boh.u_actual_hours;
            newBoh.u_hours_completed = vm.boh.u_hours_completed;
            newBoh.u_assigned_to = vm.assignedToId;
            newBoh.u_assignment_group = vm.userGroupId;
            newBoh.u_description = vm.boh.u_description;
            newBoh.u_updated_by = user_info.email;
            newBoh.u_company = vm.boh.u_company;
            newBoh.u_work_notes = vm.boh.u_work_notes;
            newBoh.u_sys_id = vm.boh.sys_id;

            BoH.updateBoH(newBoh, (data) => {
                vm.loading = false;
                if (!data.result) {
                    vm.error = true;
                    $log.info("error");
                    vm.createAlertMessage(data, "danger");
                } else {
                    vm.error = false;
                    vm.createAlertMessage("Ticket successfully updated.", "success");
                    loadBoH();
                }
            });
        };
        vm.delete = (stateId) => {
            BoH.deleteBoH(stateId, (data) => {
                if (data.error) {
                    vm.error = true;
                } else {
                    vm.error = false;
                }
            });
        };
        vm.switch_watchlist = () => {
            vm.watch_list_show = !vm.watch_list_show;
        };

        vm.findToRemoveById = (user_id) => {
            for (let i = 0; i < vm.watch_list_users.length; i++) {
                let user = vm.watch_list_users[i];
                if (user["sys_id"] == user_id) {
                    vm.watch_list_users.splice(i, 1);
                    return user_id;
                }
            }
        };

        vm.delete_watchlist = () => {
            angular.element(".watch-list-select option:selected").remove();
            if (vm.watch_list_selected != null) {
                angular.forEach(vm.watch_list_selected, (user_id) => {
                    vm.findToRemoveById(user_id);
                });
            }
        };

        vm.addEmail_watchlist = (user_email) => {
            if (user_email == null || user_email == "") {
                return;
            }
            let user = {
                sys_id: user_email,
                name: user_email
            };
            vm.add_watchlist(user);
        };
        vm.add_watchlist = (watch_list) => {
            if (vm.watch_list_users.length > 0) {
                vm.watch_list_users.push(watch_list);
            } else {
                vm.watch_list_users = [watch_list];
            }
            vm.watch_list_email = null;
            //       getUserWatchLists();
        };
        vm.go_back = () => {
            $window.history.back();
        };
        vm.page_changed = () => {
            vm.offset = parseInt(vm.current_page - 1) * page;
            $state.go("index.bohs", {
                offset: vm.offset
            });
        };
        vm.close_notice = (index) => {
            vm.alerts.splice(index, 1);
        };

        vm.contact = (type) => {
            let modalInst = $uibModal.open({
                templateUrl: "app/shared/html/contact_list.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "ContactController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                if (data) {
                    if (type == "opened_by") {
                        vm.assignedToName = data.name;
                        vm.assignedToId = data.caller_id;
                    } else if (type == "contact") {
                        vm.boh.u_contact_name = data.name;
                        vm.boh.u_contact_email = data.email;
                    } else {
                        var insert_data = {
                            sys_id: data.caller_id,
                            name: data.name
                        };
                        vm.watch_list_users.push(insert_data);
                    }
                }
            });
        };

        vm.userGroup = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/boh/groups.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "AssignmentGroupController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                if (data) {
                    vm.userGroupName = data.name;
                    vm.userGroupID = data.id;
                }
            });
        };

        vm.show_related = (update) => {
            if (vm.related_show == true && !update) {
                vm.related_show = false;
                return;
            }
            let bohID = $stateParams.bohID;
            vm.related_show = true;
            vm.related_loading = true;
            vm.getJournalEntries(bohID);
        };

        vm.getJournalEntries = (statusID) => {
            Status.getJournal(
                statusID,
                (data) => {
                    if (data.error) {
                        vm.related_loading = false;
                        $log.info(data.error);
                    } else {
                        vm.related_result = [];
                        let journals = data.results;
                        if (journals) {
                            journals.forEach((journal) => {
                                if (journal.element === "u_comments" || journal.element === "u_status") {
                                    if (journal.element.indexOf("u_") != -1) {
                                        journal.element = journal.element.replace("u_", "");
                                        journal.element = util.capitalizeFirstLetter(journal.element);
                                    } else {
                                        journal.element = util.capitalizeFirstLetter(journal.element);
                                    }
                                    let addHistory = {
                                        sortDate: journal.sys_created_on.toString(),
                                        sys_created_on: journal.sys_created_on.toString(),
                                        value: journal.value,
                                        sys_created_by: journal.sys_created_by,
                                        element: journal.element
                                    };
                                    vm.related_result.push(addHistory);
                                }
                            });
                        }
                        vm.getHistoryLine(statusID);
                    }
                },
                300,
                0
            );
        };

        vm.getHistoryLine = (statusID) => {
            Status.getHistory(
                statusID,
                (data) => {
                    if (data.error) {
                        vm.related_loading = false;
                        $log.info(data.error);
                    } else {
                        let noDuplicate = [];
                        let histories = data.results;
                        if (histories) {
                            histories.forEach((history) => {
                                if (history.field === "u_state") {
                                    let addActivity = {
                                        sortDate: history.update_time,
                                        sys_created_on: history.update_time,
                                        value: history.new,
                                        sys_created_by: history.u_name_id,
                                        element: history.label
                                    };
                                    if (noDuplicate.indexOf(history.new) == -1) {
                                        noDuplicate.push(history.new);
                                        vm.related_result.push(addActivity);
                                    }
                                }
                            });
                        }
                        vm.getAttachedFiles(statusID);
                    }
                },
                300,
                0
            );
        };

        let attachmentLength = 0;
        let attachmentIndex = 0;

        vm.getAttachedFiles = (statusID) => {
            ServiceNow.getAllAttachment(statusID, "u_boh_request", 10, 10, (data) => {
                if (data && data.result && data.result.length > 0) {
                    let attachments = data.result;
                    attachmentLength = data.result.length;
                    attachments.forEach((attachment) => {
                        vm.getSingleFileData(attachment);
                    });
                } else {
                    vm.related_result.sort((a, b) => {
                        return new Date(a.sortDate) - new Date(b.sortdate);
                    });
                    vm.related_loading = false;
                }
            });
        };

        vm.nonImageAttachments = {};

        vm.getSingleFileData = (attachment) => {
            ServiceNow.getAttachment(attachment.sys_id, (data) => {
                if (data) {
                    let blobData = new Blob([data], {
                        type: attachment.content_type
                    });

                    let activityItem = {
                        sortDate: attachment.sys_created_on,
                        sys_created_on: attachment.sys_created_on,
                        dataURL: "",
                        sys_created_by: attachment.sys_created_by,
                        element: "Attachment"
                    };

                    if (attachment && attachment.content_type.includes("image")) {
                        activityItem.dataURL = URL.createObjectURL(blobData);
                        activityItem.image = true;
                    } else {
                        vm.nonImageAttachments[attachment.file_name] = blobData;
                        activityItem.dataURL = attachment.file_name;
                        activityItem.image = false;
                    }

                    vm.related_result.push(activityItem);
                }
                attachmentIndex++;
                if (attachmentLength === attachmentIndex) {
                    vm.related_result.sort((a, b) => {
                        return new Date(a.sortDate) - new Date(b.sortdate);
                    });
                    attachmentLength = 0;
                    attachmentIndex = 0;
                    vm.related_loading = false;
                }
            });
        };

        vm.downloadFromActivity = (file) => {
            let blobData = vm.nonImageAttachments[file];
            FileSaver.saveAs(blobData, file);
        };

        vm.detail_loading = {};
        vm.related_detail = {};

        vm.show_related_detail = (sys_id, key) => {
            vm.detail_loading[key] = true;
            BoH.getSingleHistory(sys_id, (data) => {
                vm.detail_loading[key] = false;
                if (data.error) {
                    vm.related_detail[key] = [];
                } else {
                    vm.related_detail[key] = data.result;
                }
            });
        };
        vm.related_filter = (item) => {
            return (
                item.label == "Priority" ||
                item.label == "Short description" ||
                item.label == "BoH" ||
                item.label == "Additional comments"
            );
        };

        vm.attachmentList = [];
        vm.attachment = () => {
            let modalInst = $uibModal.open({
                resolve: {
                    list: () => {
                        return vm.attachmentList;
                    },
                    params: () => {
                        return {
                            table: "u_boh_request",
                            newTable: "boh_new",
                            fieldID: "bohID"
                        };
                    }
                },
                templateUrl: "app/shared/html/attachment_form.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "AttachmentController",
                controllerAs: "vm"
            });
            modalInst.result.then(
                (data) => {
                    vm.attachmentList = data;
                    vm.related_show = false;
                    vm.show_related(true);
                },
                () => {
                    vm.related_show = false;
                    vm.show_related(true);
                }
            );
        };

        var state_name = $state.current.name;
        switch (state_name) {
            case "index.boh_new":
                vm.loading = false;
                vm.boh = {};
                if (
                    user_info.company !== "c94993314a362312005cfc20c1aa15d2" &&
                    user_info.company !== "8d8073014f8d0300d227d48e5210c785"
                ) {
                    vm.companyName = user_info.company_name;
                    vm.boh.u_company = user_info.company;
                }
                break;
            case "index.boh_single":
                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withDOM('lfB<".table-scroll"rt>ip')
                    .withOption("aoColumnDefs", [
                        {
                            bSortable: false,
                            aTargets: ["nosort"]
                        }
                    ])
                    .withButtons(buttonConfig)
                    .withOption("order", [["4", "des"]])
                    .withOption("iDisplayLength", 25)
                    .withOption("responsive", true);
                vm.loading = true;
                if ($stateParams.bohID != undefined) {
                    loadBoH();
                } else {
                    $state.go("index.bohs");
                }
                break;
            case "index.bohs":
                vm.loading = true;
                let companyFilter = vm.isBurwood ? null : user_info.company;
                BoH.getBoH(
                    "",
                    (data) => {
                        vm.loading = false;
                        vm.bohs = [];
                        if (data.error || !data.results) {
                            $log.info(data.error);
                        } else {
                            vm.bohs = data.results;
                        }
                    },
                    5000,
                    offset,
                    companyFilter
                );
                break;
        }

        //opens modal for client picker selection
        vm.selectClient = () => {
            let modalInst = $uibModal.open({
                templateUrl: "app/components/navbar/clientpicker.html",
                ariaLabelledBy: "modal-title",
                ariaDescribedBy: "modal-body",
                controller: "CompanyListController",
                controllerAs: "vm"
            });
            modalInst.result.then((data) => {
                if (data) {
                    vm.boh.u_company = data.sys_id;
                    vm.companyName = data.company;
                }
            });
        };

        angular.element("body").on("click", "#dt-title", () => {
            angular.element("#dt-title").remove();
            let table = angular.element(".table").DataTable();
            table.search("").columns().search("").draw();
        });
    }
})();

(function () {
    angular.module("burWood").run(runBlock);

    /** @ngInject */
    function runBlock(user_info, Auth, amMoment, $location, $window, $cookies, $transitions, _, Idle) {
        let cloudbillOnly;
        let cloudbillAdmin;

        if (
            user_info &&
            user_info.group &&
            (user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Project Users") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Department Admins") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Group Admins") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins Read Only") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") != -1) &&
            user_info.group.indexOf("BCS Portal - Standard Override") === -1
        ) {
            cloudbillOnly = true;
        }

        if (
            user_info &&
            user_info.group &&
            (user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") != -1 ||
                user_info.group.indexOf("BCS Portal - Cloudbilling - Customer Admins Read Only") != -1) &&
            user_info.group.indexOf("BCS Portal - Standard Override") === -1
        ) {
            cloudbillAdmin = true;
        }

        let basicUser = user_info && user_info.group && user_info.group.indexOf("BCS Portal - Basic User") != -1;
        let bcsUser =
            user_info.company === "8d8073014f8d0300d227d48e5210c785" ||
            user_info.company === "c94993314a362312005cfc20c1aa15d2";
        let userAdmin = user_info && user_info.group && user_info.group.indexOf("BCS Portal - User Admin") != -1;
        let bcsDevOps = user_info && user_info.group && user_info.group.indexOf("BCS DevOps - Portal") != -1;
        let burwoodCloudAdmin =
            user_info && user_info.group && user_info.group.indexOf("BCS Portal - Cloudbilling - Burwood Admins") != -1;
        let domsUser = user_info.company === "1be1693d1bd250d0beaec9176e4bcb9a";

        amMoment.changeLocale("de");
        let host = $location.host();
        if (host == "bms-preview.burwood.com") {
            $cookies.remove("X-XSRF-TOKEN");
            $window.location = "https://bcs.burwood.com";
        }

        Idle.watch();

        $transitions.onBefore({}, (trans) => {
            let transTo = trans.$to().name;
            let transParams = trans.$to().self;

            if (
                user_info === "OK" &&
                transTo != "login" &&
                transTo != "logout" &&
                transTo != "sso_login" &&
                transTo != "reset_password"
            ) {
                if (transTo == "login") {
                    return false;
                }

                return trans.router.stateService.target("login");
            } else if (
                (transTo != "reset_password" && !user_info && transParams.authenticate) ||
                (transParams.authenticate && !Auth.isAuthenticated())
            ) {
                let cookies = $cookies.getAll();
                angular.forEach(cookies, (v, k) => {
                    $cookies.remove(k);
                });

                if (transTo == "login") {
                    return true;
                }

                return trans.router.stateService.target("login");
            } else if (!bcsDevOps && transParams.bcsDevOps) {
                if (transTo == "index.index") {
                    return true;
                }

                return trans.router.stateService.target("index.index");
            } else if (!userAdmin && transParams.userAdmin) {
                if (transTo == "index.index") {
                    return true;
                }

                return trans.router.stateService.target("index.index");
            } else if (!burwoodCloudAdmin && transParams.cloudAdmin) {
                if (transTo == "index.index") {
                    return true;
                }

                return trans.router.stateService.target("index.index");
            } else if (!bcsUser && transParams.bcsOnly) {
                if (transTo == "index.index") {
                    return true;
                }

                return trans.router.stateService.target("index.index");
            } else if (!domsUser && transParams.doms) {
                if (transTo == "index.index") {
                    return true;
                }

                return trans.router.stateService.target("index.index");
            } else if (!cloudbillOnly && transParams.cloud) {
                if (transTo == "index.index") {
                    return true;
                }

                return trans.router.stateService.target("index.index");
            } else if (
                cloudbillOnly &&
                !transParams.cloud &&
                !transParams.bcsDevOps &&
                transTo != "login" &&
                transTo != "logout" &&
                transTo != "sso_login" &&
                transTo != "reset_password"
            ) {
                if (cloudbillAdmin) {
                    if (transTo == "index.cloudbilling_dashboard_admin") {
                        return true;
                    }

                    return trans.router.stateService.target("index.cloudbilling_dashboard_admin");
                } else {
                    if (transTo == "index.cloudbilling_dashboard_admin") {
                        return true;
                    }

                    return trans.router.stateService.target("index.cloudbilling_dashboard");
                }
            } else if (
                basicUser &&
                !transParams.basic &&
                transTo != "login" &&
                transTo != "logout" &&
                transTo != "sso_login" &&
                transTo != "reset_password"
            ) {
                if (transTo == "index.index") {
                    return true;
                }

                return trans.router.stateService.target("index.index");
            } else {
                return true;
            }
        });

        _.get = (obj, key) => {
            return key.split(".").reduce((o, x) => {
                return typeof o == "undefined" || o === null ? o : o[x];
            }, obj);
        };
    }
})();

(function () {
    "use strict";

    angular.module("burWood").config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state("welcome", {
                url: "/welcome",
                templateUrl: "app/welcome/welcome.html",
                controller: "WelcomeController",
                controllerAs: "vm",
                hidenavbar: true
            })
            .state("login", {
                url: "/login",
                templateUrl: "app/login/login.html",
                controller: "LoginController",
                controllerAs: "vm",
                hidenavbar: true
            })
            .state("logout", {
                url: "/logout",
                templateUrl: "app/login/login.html",
                controller: "LoginController",
                controllerAs: "vm",
                hidenavbar: true
            })
            .state("sso_login", {
                url: "/sso_login",
                templateUrl: "app/login/sso_login.html",
                controller: "LoginController",
                controllerAs: "vm",
                hidenavbar: true
            })
            .state("reset_password", {
                url: "/reset_password/:key",
                templateUrl: "app/reset/reset_password.html",
                controller: "ResetController",
                controllerAs: "vm",
                hidenavbar: true
            })
            .state("index", {
                templateUrl: "app/dashboard/dashboard.html",
                controller: "DashboardController",
                controllerAs: "vm",
                basic: true
            })
            .state("index.main", {
                url: "/dashboard",
                templateUrl: "app/dashboard2/dashboard2.html",
                controller: "DashboardController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.index", {
                url: "/",
                templateUrl: "app/main/main.html",
                controller: "MainController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.user_admin", {
                url: "/user_admin",
                templateUrl: "app/userAdmin/userAdmin.html",
                controller: "UserAdminController",
                controllerAs: "vm",
                authenticate: true,
                userAdmin: true,
                basic: false,
                resolve: {
                    user: function () {
                        return "standard";
                    },
                    disabled: function () {
                        return false;
                    },
                    $uibModalInstance: function () {
                        return "uib";
                    }
                }
            })
            .state("index.sso_config", {
                url: "/sso_config",
                templateUrl: "app/sso/sso.html",
                controller: "SSOController",
                controllerAs: "vm",
                authenticate: true,
                bcsDevOps: true,
                basic: false
            })
            .state("index.callus", {
                url: "/callus",
                templateUrl: "app/callus/callus.html",
                controller: "CallusController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.contactus", {
                url: "/contactus",
                templateUrl: "app/contactus/contactus.html",
                controller: "ContactusController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.chatus", {
                url: "/chatus",
                templateUrl: "app/chatus/chatus.html",
                controller: "ChatusController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.myservice", {
                url: "/myservice",
                templateUrl: "app/myservice/myservice.html",
                controller: "MyserviceController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.ticket", {
                url: "/tickets/",
                params: {
                    device: null,
                    ticketsWaiting: null
                },
                templateUrl: "app/ticket/ticket.html",
                controller: "TicketController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.ticket_single", {
                url: "/ticket/:ticketID",
                templateUrl: "app/ticket/singleticket.html",
                controller: "TicketController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.ticket_new", {
                url: "/ticket_new/",
                templateUrl: "app/ticket/newticket.html",
                controller: "TicketController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.company", {
                url: "/company/",
                templateUrl: "app/company/company.html",
                controller: "CompanyController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.devices", {
                url: "/devices/",
                params: {
                    redirectedDevice: null,
                    redirectedSKU: null,
                    exception: null
                },
                templateUrl: "app/devices/devices.html",
                controller: "DevicesController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.device_single", {
                url: "/device/:deviceID",
                templateUrl: "app/devices/singledevice.html",
                controller: "DevicesController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.sl_dashboard", {
                url: "/sl_dashboard/",
                templateUrl: "app/sciencelogic/dashboard.html",
                controller: "SLDashboardController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.request_single", {
                url: "/requests/:reqID",
                params: {
                    reqID: null
                },
                templateUrl: "app/requests/singlerequest.html",
                controller: "RequestController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.request_new", {
                url: "/request_new",
                templateUrl: "app/requests/newrequest.html",
                controller: "RequestController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.doms_new_user", {
                url: "/doms_new_user",
                templateUrl: "app/userAdmin/domsNewUser.html",
                controller: "DOMSUserController",
                controllerAs: "vm",
                authenticate: true,
                basic: true,
                doms: true
            })
            .state("index.cloud_request", {
                url: "/requests",
                templateUrl: "app/requests/request_cloudbilling.html",
                controller: "RequestController",
                controllerAs: "vm",
                cloud: true,
                authenticate: true,
                basic: true
            })
            .state("index.cloud_request_single", {
                url: "/cloud_request/:reqID",
                templateUrl: "app/requests/singlerequest.html",
                controller: "RequestController",
                controllerAs: "vm",
                cloud: true,
                authenticate: true,
                basic: true
            })
            .state("index.cloud_request_new", {
                url: "/cloud_request_new",
                templateUrl: "app/requests/request_cloudbilling_new.html",
                controller: "RequestController",
                controllerAs: "vm",
                cloud: true,
                authenticate: true,
                basic: true
            })
            .state("index.request_new_internal", {
                url: "/request_new_internal",
                templateUrl: "app/requests/newinternalrequest.html",
                controller: "RequestController",
                controllerAs: "vm",
                authenticate: true,
                basic: true,
                bcsOnly: true
            })
            .state("index.requests", {
                url: "/requests",
                params: {
                    sort: null,
                    type: null,
                    state: null
                },
                templateUrl: "app/requests/request.html",
                controller: "RequestController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.status_single", {
                url: "/incident/:statusID",
                templateUrl: "app/status/singleincident.html",
                controller: "StatusController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.status_new", {
                url: "/status_new",
                templateUrl: "app/status/newincident.html",
                controller: "StatusController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.status_p1phone", {
                url: "/status_p1phone",
                templateUrl: "app/status/p1phone.html",
                controller: "StatusController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.incidents", {
                url: "/incidents",
                params: {
                    sort: null,
                    type: null,
                    state: null
                },
                templateUrl: "app/status/incident.html",
                controller: "StatusController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.problem_single", {
                url: "/problem/:problemID",
                templateUrl: "app/problem/singleproblem.html",
                controller: "ProblemController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.problem_new", {
                url: "/problem_new",
                templateUrl: "app/problem/newproblem.html",
                controller: "ProblemController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.problems", {
                url: "/problems/",
                params: {
                    sort: null,
                    type: null,
                    state: null
                },
                templateUrl: "app/problem/problem.html",
                controller: "ProblemController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            // .state("index.boh_single", {
            //     url: "/boh/:bohID",
            //     templateUrl: "app/boh/singleboh.html",
            //     controller: "BoHController",
            //     controllerAs: "vm",
            //     authenticate: true,
            //     basic: true
            // })
            // .state("index.boh_new", {
            //     url: "/boh_new",
            //     templateUrl: "app/boh/newboh.html",
            //     controller: "BoHController",
            //     controllerAs: "vm",
            //     authenticate: true,
            //     basic: true
            // })
            // .state("index.bohs", {
            //     url: "/bohs/",
            //     params: {
            //         sort: null,
            //         type: null,
            //         state: null
            //     },
            //     templateUrl: "app/boh/boh.html",
            //     controller: "BoHController",
            //     controllerAs: "vm",
            //     authenticate: true,
            //     basic: true
            // })
            .state("index.uchange_request", {
                url: "/uchange_request",
                params: {
                    sort: null,
                    type: null,
                    state: null
                },
                templateUrl: "app/uchangerequest/request.html",
                controller: "UChangereqController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.uchange_new", {
                url: "/uchange_new",
                templateUrl: "app/uchangerequest/newrequest.html",
                controller: "UChangereqController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.uchange_single", {
                url: "/u_customer_changes/:requestID",
                templateUrl: "app/uchangerequest/singlerequest.html",
                controller: "UChangereqController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            // For Version 2 we will implement contracts
            .state("index.contracts", {
                url: "/contracts",
                templateUrl: "app/contracts/contracts.html",
                controller: "ContractsController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.quotes", {
                url: "/quotes",
                templateUrl: "app/contracts/quotes.html",
                controller: "ContractsController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.quote_single", {
                url: "/quotes/:quoteID",
                templateUrl: "app/contracts/singlequote.html",
                controller: "ContractsController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.contract_single", {
                url: "/contracts/:contractID",
                templateUrl: "app/contracts/singlecontract.html",
                controller: "ContractsController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.contract_new", {
                url: "/contract_new",
                templateUrl: "app/contracts/contract_new.html",
                controller: "ContractsController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.contract_exceptions", {
                url: "/contract_exceptions",
                templateUrl: "app/contracts/contract_exceptions.html",
                controller: "ContractsController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.calendar", {
                url: "/calendar",
                templateUrl: "app/calendar/calendar.html",
                controller: "CalendarController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.netmap", {
                url: "/netmap",
                templateUrl: "app/netmap/netmap.html",
                controller: "NetmapController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.report", {
                url: "/report/:report",
                templateUrl: "app/report/report.html",
                controller: "ReportController",
                controllerAs: "vm",
                authenticate: true,
                params: { report: null }
            })
            .state("index.allevent", {
                url: "/allevent/",
                params: {
                    sort: null,
                    device: null
                },
                templateUrl: "app/events/events.html",
                controller: "EventController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.clearevent", {
                url: "/clearevent/",
                params: {
                    health: null
                },
                templateUrl: "app/events/clearevents.html",
                controller: "EventController",
                controllerAs: "vm",
                authenticate: true,
                basic: true
            })
            .state("index.healthyevent", {
                url: "/healthyevent/",
                templateUrl: "app/events/events.html",
                controller: "EventController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.noticeevent", {
                url: "/noticeevent/:offset",
                templateUrl: "app/events/events.html",
                controller: "EventController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.minorevent", {
                url: "/minorevent/:offset",
                templateUrl: "app/events/events.html",
                controller: "EventController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.majorevent", {
                url: "/majorevent/:offset",
                templateUrl: "app/events/events.html",
                controller: "EventController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.criticalevent", {
                url: "/criticalevent/:offset",
                templateUrl: "app/events/events.html",
                controller: "EventController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.search", {
                url: "/search/:query/:offset",
                templateUrl: "app/search/search.html",
                controller: "SearchController",
                controllerAs: "vm",
                params: {
                    query: null,
                    offset: null
                },
                // cloud: true,
                authenticate: true,
                basic: true
            })
            .state("index.docs", {
                url: "/docs",
                templateUrl: "app/docs/docs.html",
                controller: "DocsController",
                controllerAs: "vm",
                authenticate: true
            })
            .state("index.release_notes", {
                url: "/release_notes",
                templateUrl: "app/docs/releaseNotes.html",
                controller: "ReleaseNotesController",
                controllerAs: "vm",
                cloud: true,
                authenticate: true
            })
            .state("index.cloudbilling_config", {
                url: "/cloudbilling_config",
                templateUrl: "app/cloudbilling/company/cloudConfig.html",
                controller: "CloudConfigController",
                controllerAs: "vm",
                cloud: true,
                authenticate: true
            })
            .state("index.cloud_guide", {
                url: "/cloud_guide",
                templateUrl: "app/docs/cloudGuideAdmin.html",
                controller: "DocsController",
                controllerAs: "vm",
                cloud: true,
                authenticate: true
            })
            .state("index.cloud_user_guide", {
                url: "/cloud_user_guide",
                templateUrl: "app/docs/cloudGuide.html",
                controller: "DocsController",
                controllerAs: "vm",
                cloud: true,
                authenticate: true
            })
            .state("index.cloudbilling_projects", {
                url: "/cloudbilling_projects",
                templateUrl: "app/cloudbilling/budget/projectMapping.html",
                controller: "ProjectMappingController",
                controllerAs: "vm",
                cloud: true,
                authenticate: true
            })
            .state("index.cloudbilling_users", {
                url: "/cloudbilling_users",
                templateUrl: "app/userAdmin/userAdmin.html",
                controller: "UserAdminController",
                controllerAs: "vm",
                authenticate: true,
                cloud: true,
                resolve: {
                    user: function () {
                        return "cloud";
                    },
                    disabled: function () {
                        return false;
                    },
                    $uibModalInstance: function () {
                        return "uib";
                    }
                }
            })
            .state("index.cloudbilling_pos", {
                url: "/cloudbilling_po",
                templateUrl: "app/cloudbilling/funding/cloudbillingPO.html",
                controller: "CloudbillingPOController",
                controllerAs: "vm",
                cloud: true,
                authenticate: true
            })
            .state("index.cloudbilling_burwood_admin", {
                url: "/cloudbilling_burwood_admin",
                templateUrl: "app/cloudbilling/burwoodAdmin/burwoodAdmin.html",
                controller: "BurwoodAdminController",
                controllerAs: "vm",
                cloud: true,
                cloudAdmin: true,
                authenticate: true
            })
            .state("index.cloudbilling_dashboard", {
                url: "/cloudbilling_dashboard",
                templateUrl: "app/cloudbilling/dashboard/cloudbilling_dashboard.html",
                controller: "CloudBillingDashboardController",
                controllerAs: "vm",
                cloud: true,
                authenticate: true
            })
            .state("index.cloudbilling_dashboard_admin", {
                url: "/cloudbilling_dashboard_admin",
                templateUrl: "app/cloudbilling/dashboard/cloudbilling_dashboard_admin.html",
                controller: "CloudBillingDashboardController",
                controllerAs: "vm",
                cloud: true,
                authenticate: true
            })
            .state("index.cloudbilling_dashboard_burwood_admin", {
                url: "/cloudbilling_dashboard_burwood_admin",
                templateUrl: "app/cloudbilling/burwoodAdmin/cloudbilling_dashboard_burwood.html",
                controller: "AdminDashboardController",
                controllerAs: "vm",
                cloud: true,
                cloudAdmin: true,
                authenticate: true
            })
            .state("index.cloudbilling_reports", {
                url: "/cloudbilling_reports",
                templateUrl: "app/cloudbilling/report/cloudbilling_reports.html",
                controller: "CloudBillingReportController",
                controllerAs: "vm",
                cloud: true,
                authenticate: true
            })
            .state("index.gcpQuote", {
                url: "/gcp_quote",
                templateUrl: "app/quote/gcp_quote.html",
                controller: "QuoteController",
                controllerAs: "vm",
                cloud: true,
                authenticate: true,
                basic: true
            })
            .state("index.contact_lists", {
                url: "/contact_lists",
                templateUrl: "app/contactlists/contactlists.html",
                controller: "ContactListsController",
                controllerAs: "vm",
                cloud: true,
                cloudAdmin: true,
                authenticate: true
            })
            .state("index.csv_report", {
                url: "/csv_report",
                templateUrl: "app/csvInvoiceDashboard/csvInvoiceDashboard.html",
                controller: "CSVInvoiceDashboardController",
                controllerAs: "vm",
                cloud: true,
                cloudAdmin: true,
                authenticate: true
            });
        $urlRouterProvider.otherwise("/");
    }
})();

(function () {
    "use strict";
    /* eslint-disable */
    angular.module("burWood").factory("PathInterceptor", [
        "$cookies",
        function ($cookies) {
            var path = {
                request: function (config) {
                    var token = $cookies.get("XSRF-TOKEN");
                    if (token) {
                        config.headers["X-XSRF-TOKEN"] = token;
                    }
                    
                    //config.cache = false;
                    return config;
                    
                },
                response: function (response) {
                    return response;
                }
            };
            return path;
        }
    ]);

    angular.module("burWood").config([
        "$httpProvider",
        function ($httpProvider) {
            $httpProvider.interceptors.push("PathInterceptor");
        }
    ]);

    // angular.module('burWood').config(['$urlRouterProvider', function ($urlRouterProvider) {
    //     $urlRouterProvider.otherwise(function ($injector) {
    //         $injector.invoke(['$state', function ($state) {
    //             $state.go('dashboard.index');
    //         }]);
    //     });
    // }]);
    /* eslint-enable */
})();

angular.module("envConfig", [])

.constant("apiBasePath", "https://api.bcs.burwood.com")

.constant("reactEndpoint", "https://v2.bcs.burwood.com")

;
(function () {
    "use strict";

    angular
        .module("burWood")
        .constant("apiServiceNowCred", {
            email: "soap.guest@example.com",
            password: "BG65%12"
        })
        .constant("apiScienceLogCred", {
            user_name: "bmsportal",
            password: "iamthenewpassword"
        });
})();

(function () {
    "use strict";

    angular.module("burWood").config(config);

    /** @ngInject */
    function config($logProvider, $httpProvider, $locationProvider, IdleProvider, KeepaliveProvider) {
        // Enable log
        $logProvider.debugEnabled(true);

        $httpProvider.defaults.withCredentials = true;
        delete $httpProvider.defaults.headers.common["X-Requested-With"];

        $locationProvider.html5Mode({ enabled: true, requireBase: true });

        // configure Idle settings
        IdleProvider.idle(1740); // in seconds
        IdleProvider.timeout(60); // in seconds
        KeepaliveProvider.interval(5); // in seconds
    }
})();

angular.module('burWood').run(['$templateCache', function($templateCache) {$templateCache.put('app/boh/boh.html','<div class="container container-top-ticket col-lg-12 col-md-12 col-sm-12 col-xs-12" style=width:96%><div class="well pd-top" style=min-height:583.4px><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.bohs.length == 0"><p>Sorry, no results for tickets.</p></div><div class=table-responsive ng-if="!vm.loading && vm.bohs.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=screquestTable><!-- bs-table-control="vm.bsctrl" --><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Priority</th><th>Number</th><th>Company</th><th>Contact</th><th>Description</th><th>Assignment Group</th><th>Assigned To</th><th>State</th><th>Opened</th><th>Updated</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.bohs"><td></td><td class=text-center><span style=position:absolute;margin-left:6px;margin-top:1.5px>{{item.u_priority | limitTo:1}}{{(item.u_priority == \'\')?\'5\':\'\'}}</span> <img ng-src="assets/img/icon/network_{{item.u_priority | limitTo:1}}{{(item.u_priority == \'\')?\'5\':\'\'}}.png" alt="{{item.u_priority | limitTo:1}}{{(item.u_priority == \'\')?\'5\':\'\'}}" width=20 height="" style=height:auto><div style=position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px tooltips tooltip-template="<span style=\'font-weight:400\'>Priority</span>: {{item.u_priority}}" tooltip-side=right tooltip-class=priority-tooltip></div></td><td><a ng-click=vm.goToTicket(item.sys_id)>{{item.u_number}}</a></td><td>{{item.u_company.display_value}}</td><td>{{item.u_contact_name}}</td><td>{{item.u_description}}</td><td>{{item.u_assignment_group.display_value}}</td><td>{{item.u_assigned_to.display_value | RemoveEmail}}</td><td>{{vm.findStateName(item.u_state)}}</td><td style=width:100px>{{item.sys_created_on}}</td><td style=width:100px>{{item.sys_updated_on}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/boh/groups.html','<div class="row contact-list-form"><div class=modal-header><h4>Select Group</h4></div><div class="modal-body well" id=modal-body><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.groups.length == 0"><p>Sorry No Groups found.</p></div><div class=table-responsive><table class="table row-border hover" datatable=ng dt-options=vm.dtOptions width=100% cellspacing=0><!-- bs-table-control="vm.bsctrl" --><thead><tr><th>No</th><th>Name</th></tr></thead><tbody><tr ng-repeat="group in vm.groups track by $index"><td>{{$index + 1}}</td><td><a ng-click="vm.addtolist(group.name, group.sys_id)">{{group.name}}</a></td></tr></tbody></table></div></div><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-4"><input type=button class="btn btn-success btn-block" value=Cancel name=cancel ng-click=vm.close()></div></div></div></div>');
$templateCache.put('app/boh/newboh.html','<div class="container container-top no-padding new-ticket"><div class=row><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-content no-padding" style=margin-bottom:50px><div class="well well-padding open-contain no-padding" style="background-color:transparent; border: none"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class="row open-row"><form name=boh_new ng-submit="vm.create(vm.boh, boh_new.$valid)"><div class=col-xs-12 ng-show=vm.error><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=vm.close_notice($index)>{{alert.msg}}</div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><h4 class="title open-title" style="font-weight: 400 !important;margin-top: 23px">New BoH</h4></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" id=request-info><div class=description-box style=margin-top:0px><p>Use this form to request Burwood Services that will be billed against a current block of hour (BoH) contract . For BMS customers, this is any non incident related work, over 4 hours.</p></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="padding-right: 35px"><div class=form-group><div class=col-xs-3><label for=assignment-group>Company *</label></div><div class=col-xs-8><p class=input-group><input type=text class=form-control id=companyName ng-model=vm.companyName ng-click=vm.selectClient() ng-disabled=!vm.isBurwood placeholder=""> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.selectClient() style="padding-top: 6px;padding-bottom: 6px" ng-disabled=!vm.isBurwood><i class="fa fa-search"></i></button></span></p><input type=hidden class=form-control id=companyID ng-model=vm.boh.u_company placeholder="" ng-disabled=!vm.isBurwood></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class=form-group><div class=col-xs-3><label for=start_date>Planned Start Date</label></div><div class=col-xs-8><p class=input-group style="width: 100%"><input class=form-control type=date required ng-model=vm.boh.u_planned_start_date id=chg-start></p></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="padding-right: 35px"><div class=form-group><div class=col-xs-3><label for=start_date>Contact</label></div><div class=col-xs-8><p class=input-group><input type=text class=form-control id=contact ng-model=vm.boh.u_contact_name placeholder="" required> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.contact(\'contact\')" style="padding-top: 6px;padding-bottom: 6px;width:37px"><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=caller_id ng-model=vm.boh.u_contact_email placeholder=""></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class=form-group><div class=col-xs-3><label for=start_date>Preferred Engineer</label></div><div class=col-xs-8><input class=form-control type=text ng-model=vm.preferredEngineer id=engineer></div><div class=clearfix></div></div></div><div class=form-group><div class=col-xs-12><label for=more_info>Description</label></div><div class=clearfix></div><div class=col-xs-12><textarea style="height: 150px" class=form-control ng-model=vm.boh.u_description placeholder="" rows=5 required></textarea></div><div class=clearfix></div></div><div class=form-group style=text-align:center><div class=col-xs-12><button class="btn btn-primary btn-block" type=submit ng-disabled=vm.loading>CREATE</button></div><div class=clearfix></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/boh/singleboh.html','<div class="container container-top-ticket shadow-strong" id=ticket-form><form ng-submit="vm.update(vm.boh.sys_id, vm.boh)" name=bohForm id=boh-form><div class=menu-top><ul class="list-unstyled list-inline pull-left" style="padding: 15px"><li><a ng-click=vm.go_back()><img src=assets/img/icon/back-arrow.png width=15 height="" style=height:auto></a></li><li><strong>BoH - {{vm.boh.u_number}}</strong></li></ul><ul class="list-unstyled list-inline pull-right list-menu"><li ng-if="vm.isApprover === true && vm.boh.u_state === \'7\'"><button class=menu_btn ng-click="vm.updateApproval(\'approved\')" ng-disabled=vm.loading type=button>Approve</button></li><li style=margin-left:3px ng-if="vm.isApprover === true && vm.boh.u_state === \'7\'"><button class=menu_btn ng-click="vm.updateApproval(\'rejected\')" type=button ng-disabled=vm.loading style="background-color: #b05151!important">Reject</button></li><li style=margin-left:3px><button class=menu_btn type=submit ng-disabled=vm.loading>Update</button></li><li ng-if="vm.isApprover === true && !vm.disabled" style=margin-left:3px><button class=menu_btn ng-click="vm.updateApproval(\'cancelled\')" type=button ng-disabled=vm.loading style="background-color: #b05151!important">Cancel</button></li></ul><ul class="list-unstyled list-inline pull-right" style="padding: 15px"><li><a ng-click=vm.attachment()><img src=assets/img/icon/attach.png width=15 height="" style=height:auto></a></li></ul></div><div class=menu-top style="margin-top: -5px;height: 50px;background-color: rgba(73, 117, 85, 0.68);border-bottom:none; border-radius:0px;overflow:hidden"><div class=chevron style=width:13.5% id=first-chev ng-class="{ \'active-status\': vm.boh.u_state === \'1\'}"><p class=chevron-text style="margin-left: 47%">New</p></div><div class=chevron style=width:13.5% ng-class="{ \'active-status\': vm.boh.u_state === \'3\'}"><p class=chevron-text style="margin-left: 27%">Pending Resource</p></div><div class=chevron style=width:13.5% ng-class="{ \'active-status\': vm.boh.u_state === \'5\'}"><p class=chevron-text style="margin-left: 30%">Estimation Review</p></div><div class=chevron style=width:13.5% ng-class="{ \'active-status\': vm.boh.u_state === \'7\'}"><p class=chevron-text style="margin-left: 28%">Pending Approval</p></div><div class=chevron style=width:13.5% ng-class="{ \'active-status\': vm.boh.u_state === \'9\'}"><p class=chevron-text>Scheduled</p></div><div class=chevron style=width:13.5% ng-class="{ \'active-status\': vm.boh.u_state === \'11\'}"><p class=chevron-text style="margin-left: 28%">Work In Progress</p></div><div class=chevron style=width:13.5% ng-class="{ \'active-status\': vm.boh.u_state === \'12\'}"><p class=chevron-text>Complete</p></div><!-- <div class="chevron" ng-class="{ \'active-status\': vm.boh.u_state == \'8\'}">\n                <p class="chevron-text">Canceled</p>\n            </div> --></div><div class="well incident-wrapper"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=row><div class="col-xs-12 alert-contain"><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=vm.close_notice($index)>{{alert.msg}}</div></div><div class=basic-info-contain><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel first-panel"><div class=form-group><div class=col-xs-3><label for=exampleInputEmail1>Number</label></div><div class=col-xs-8><input type=text class=form-control id=req-num ng-model=vm.boh.u_number placeholder="" ng-disabled=true></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=assignment-group>Company *</label></div><div class=col-xs-8><p class=input-group><input type=text class=form-control id=companyName ng-model=vm.companyName ng-click=vm.selectClient() ng-disabled="!vm.isBurwood || vm.disabled" placeholder=""> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.selectClient() style="padding-top: 6px;padding-bottom: 6px" ng-disabled=!vm.isBurwood><i class="fa fa-search"></i></button></span></p><input type=hidden class=form-control id=companyID ng-model=vm.boh.u_company placeholder="" ng-disabled="!vm.isBurwood || vm.disabled"></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=contact-name>Contact Name *</label></div><div class=col-xs-8><input type=text class=form-control id=contact-name required ng-model=vm.boh.u_contact_name placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=contact-email>Contact Email *</label></div><div class=col-xs-8><input type=text class=form-control id=contact-email required ng-model=vm.boh.u_contact_email placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=contact-phone>Contact Phone</label></div><div class=col-xs-8><input type=text class=form-control id=contact-phone ng-model=vm.boh.u_contact_phone placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=start_date>Planned Start Date</label></div><div class=col-xs-8><p class=input-group style="width: 100%"><input class=form-control type=datetime-local ng-disabled="(vm.boh.u_state !== \'1\' && !vm.isBurwood) || vm.disabled" ng-required="vm.number(vm.boh.u_state) >= 1 && vm.boh.u_state !== \'13\'" ng-model=vm.boh.u_planned_start_date id=chg-start></p></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=priority>Priority *</label></div><div class=col-xs-8><select id=category class=form-control ng-model=vm.boh.u_priority required ng-disabled="!vm.isBurwood || vm.disabled" ng-options="option.id as option.name for option in vm.priority"></select></div><div class=clearfix></div></div><div class=form-group><div class="col-xs-3 col-md-3 col-sm-3"><label for=watch_list>Watch List</label></div><div class="col-xs-8 col-md-8 col-sm-8"><a class="box-icon watch-list" ng-show=!vm.watch_list_show ng-click=vm.switch_watchlist()><i class="fa fa-user-plus" aria-hidden=true></i></a><ul class=watch_list_static ng-show=!vm.watch_list_show><li ng-repeat="user in vm.watch_list_users">{{user.name}}</li></ul><div class=row ng-show=vm.watch_list_show><div class="col-xs-12 watch-list-container"><select class=watch-list-select ng-model=vm.watch_list_selected multiple><option value={{user.sys_id}} ng-repeat="user in vm.watch_list_users" ng-if=user.name class=watch-list-selected>{{user.name}}</option></select><div class=watch-list-btns><button type=button class="btn btn-default" ng-click=vm.delete_watchlist() ng-disabled="vm.watch_list_selected.length==0"><i class="fa fa-times"></i></button> <button type=button class="btn btn-default" ng-click=vm.switch_watchlist()><i class="fa fa-unlock"></i></button></div></div><div class=clearfix></div><div class=col-xs-12><p class=input-group><input type=text name=lookup class="lookup form-control"> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.contact() style="padding-top: 6px;padding-bottom: 6px"><i class="fa fa-search"></i></button></span></p><p class=input-group><input type=email name=watch_list_email class="email form-control" ng-model=vm.watch_list_email> <span class=input-group-btn><button type=button class="btn btn-default" style="padding-top: 6px;padding-bottom: 6px" ng-click=vm.addEmail_watchlist(vm.watch_list_email) ng-disabled="bohForm.watch_list_email.$invalid || vm.watch_list_email==null || vm.watch_list_email==\'\'"><i class="fa fa-envelope-o"></i></button></span></p></div></div><div class=clearfix></div></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel"><div class=form-group><div class=col-xs-3><label for=boh-state>State</label></div><div class=col-xs-8><select id=boh-state class=form-control ng-model=vm.boh.u_state ng-disabled="!vm.isBurwood || vm.disabled" ng-options="option.id as option.name for option in vm.availableStates"></select></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=boh-hours>Customer\'s Remaining BoH {{vm.number(vm.boh.u_state) >= 5 && vm.boh.u_state !== \'13\' ? \'*\' : \'\'}}</label></div><div class=col-xs-8><input type=text class=form-control id=boh-hours ng-required="vm.number(vm.boh.u_state) >= 5 && vm.boh.u_state !== \'13\'" ng-model=vm.boh.u_cust_remaining_hours placeholder="" ng-disabled="!vm.isBurwood || vm.disabled"></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=boh-est>Estimated # of Hours {{vm.number(vm.boh.u_state) >= 7 && vm.boh.u_state !== \'13\' ? \'*\' : \'\'}}</label></div><div class=col-xs-8><input type=text class=form-control id=boh-est ng-model=vm.boh.u_estimated_hours ng-required="vm.number(vm.boh.u_state) >= 7 && vm.boh.u_state !== \'13\'" placeholder="" ng-disabled="!vm.isBurwood || vm.disabled"></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=boh-act>Actual # of Hours {{vm.number(vm.boh.u_state) >= 12 && vm.boh.u_state !== \'13\' ? \'*\' : \'\'}}</label></div><div class=col-xs-8><input type=text class=form-control id=boh-act ng-model=vm.boh.u_actual_hours ng-required="vm.number(vm.boh.u_state) >= 12 && vm.boh.u_state !== \'13\'" placeholder="" ng-disabled="!vm.isBurwood || vm.disabled"></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=boh-cur>Current # of Hours Completed {{vm.number(vm.boh.u_state) >= 12 && vm.boh.u_state !== \'13\' ? \'*\' : \'\'}}</label></div><div class=col-xs-8><input type=text class=form-control id=boh-cur ng-model=vm.boh.u_hours_completed ng-required="vm.number(vm.boh.u_state) >= 12 && vm.boh.u_state !== \'13\'" placeholder="" ng-disabled="!vm.isBurwood || vm.disabled"></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=assignment-group>Assignment Group *</label></div><div class=col-xs-8><p class=input-group><input type=text class=form-control id=usergroup ng-model=vm.userGroupName ng-click=vm.userGroup() ng-disabled="!vm.isBurwood || vm.disabled" placeholder=""> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.userGroup() style="padding-top: 6px;padding-bottom: 6px" ng-disabled="!vm.isBurwood || vm.disabled"><i class="fa fa-search"></i></button></span></p><input type=hidden class=form-control id=ass_gr ng-model=vm.userGroupId placeholder="" ng-disabled="!vm.isBurwood || vm.disabled"></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=assigned-to>Assigned To {{vm.number(vm.boh.u_state) >= 5 && vm.boh.u_state !== \'13\' ? \'*\' : \'\'}}</label></div><div class=col-xs-8><p class=input-group><input type=text class=form-control id=contact ng-model=vm.assignedToName ng-required="vm.number(vm.boh.u_state) >= 5 && vm.boh.u_state !== \'13\'" ng-click="vm.contact(\'opened_by\')" ng-disabled="!vm.isBurwood || vm.disabled" placeholder=""> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.contact(\'opened_by\')" style="padding-top: 6px;padding-bottom: 6px" ng-disabled="!vm.isBurwood || vm.disabled"><i class="fa fa-search"></i></button></span></p><input type=hidden class=form-control id=ass_to ng-model=vm.assignedToId ng-required="vm.number(vm.boh.u_state) >= 5 && vm.boh.u_state !== \'13\'" placeholder="" ng-disabled="!vm.isBurwood || vm.disabled"></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label>Added to PSA</label></div><div class=col-xs-8><input class=form-control style="width:25px;float: left" placeholder="" data-ng-model=vm.boh.u_added_to_psa data-ng-true-value="\'true\'" ng-disabled="!vm.isBurwood || vm.disabled" ng-required="vm.boh.u_state === \'12\'"></div><div class=clearfix></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div class=form-group><div class=col-xs-12><label for=exampleInputEmail1>Description *</label></div><div class=col-xs-12><textarea type=text class="form-control webkit-scroll" id=description placeholder="" required ng-model=vm.boh.u_description ng-disabled="(vm.boh.u_state !== \'1\' && !vm.isBurwood) || vm.disabled">\n                    </textarea></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=comment>Additional Comments</label></div><div class=col-xs-12><textarea type=text class=form-control id=additional_comment placeholder="" ng-model=vm.boh.u_comments ng-required="vm.boh.u_state !== vm.initState"></textarea></div><div class=clearfix></div></div><div class="col-xs-12 alert-contain"><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=vm.close_notice($index)>{{alert.msg}}</div></div><div class="form-group text-center"><button class="btn btn-primary btn-md" type=submit ng-disabled="bohForm.$invalid || vm.loading">UPDATE</button> <button class="btn btn-primary btn-md" type=submit ng-show=false ng-disabled="bohForm.$invalid || vm.loading || !vm.boh.comments">RESOLVE INCIDENT</button><div class=clearfix></div></div><div class=form-group><div ng-include="\'app/shared/html/_activity.html\'"></div><div class=clearfix></div></div></div></div></div></form></div>');
$templateCache.put('app/calendar/calendar.html','<div class="container container-top-ticket col-lg-12 col-md-12 col-sm-12 col-xs-12" style=margin-top:40px;width:96%><div class=state-select><div class=form-group><div class=col-xs-12><label for=exampleInputEmail1>Filter By Change State</label></div><div class=col-xs-12><select id=state-select class=form-control ng-model=vm.chosenState ng-options="option for option in vm.states" ng-change=vm.switchStateFilter()></select></div><div class=clearfix></div></div></div><timeline control=vm.timeline height=80vh options=vm.options></timeline></div>');
$templateCache.put('app/cloudbilling/expandReport.html','<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" id=cloudbilling><div class="container container-top-ticket shadow-strong" style="background-color: #2f2f2f;padding: 3px;padding-top: 8px;padding-right: 2px;width:100%;border: 1px solid #606060" id=single-device><div class=loader ng-show=vm.modalLoading><div class="css-loading css-loading--double"></div></div><div class=exit-x ng-click=vm.close()>X</div><div ng-if=vm.destroyChart ng-style=vm.chartHeight></div><div class=panel-body ng-if=!vm.destroyChart style="margin-top: 27px"><highchart id=single-device-chart config=vm.configModal></highchart></div></div></div>');
$templateCache.put('app/cloudbilling/singleUser.html','<div class="container container-top col-lg-12 col-md-12 col-sm-12 col-xs-12" id=cloudbill-accounts style="background-color: #414141;padding:30px;border-radius: 10px;border: 1px solid grey"><div class="well pd-top" ng-if=vm.userNotFound><div class=no-results><p>Sorry, user informaton not found. Please contact support for further assistance.</p></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" ng-if=!vm.userNotFound><!-- <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 no-padding"> --><div class=container style=width:100%;padding:0 id=account-form><form ng-submit=vm.update(vm.selectedUser) name=userForm style=border-radius:3px><div class=menu-top style="text-align: center"><ul class="list-unstyled list-inline pull-left" style="padding: 15px"><li><strong>User - {{vm.selectedUser.first_name}} {{vm.selectedUser.last_name}}</strong></li></ul><ul class="list-unstyled list-inline header-alerts"><li><div ng-repeat="alert in vm.alerts" close=vm.close_notice($index)>{{alert.msg}}</div></li></ul><ul class="list-unstyled list-inline pull-right list-menu"><li><button class=menu_btn ng-click="vm.action=\'update\'" type=submit ng-disabled="vm.loading || userForm.$invalid">Update</button></li><li style="margin-left: 5px"><button class="menu_btn menu_btn_red" ng-click=vm.delete() type=button ng-disabled="vm.loading || vm.disabled">Delete</button></li></ul></div><div class="well incident-wrapper"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=row style="margin-top: 5px;padding-top: 30px"><div><div class=basic-info-contain><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-panel first-panel" style=flex:none><div class=form-group ng-if=!vm.newUserSelected><div class=col-xs-4><label for=exampleInputEmail1>User ID *</label></div><div class=col-xs-8><input type=text class=form-control id=user-name ng-model=vm.selectedUser.user_name placeholder="" ng-disabled=vm.disabled required></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-4><label for=exampleInputEmail1>First Name *</label></div><div class=col-xs-8><input type=text class=form-control id=first-name ng-model=vm.selectedUser.first_name placeholder="" ng-disabled=vm.disabled required></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-4><label for=exampleInputEmail1>Last Name *</label></div><div class=col-xs-8><input type=text class=form-control id=last-name ng-model=vm.selectedUser.last_name placeholder="" ng-disabled=vm.disabled required></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-4><label for=exampleInputEmail1>Email *</label></div><div class=col-xs-8><input type=text class=form-control id=user-email ng-model=vm.selectedUser.email placeholder="" ng-disabled=vm.disabled required></div><div class=clearfix></div></div><div class=form-group ng-if=!vm.cloudUser><div class=col-xs-4><label for=exampleInputEmail1>Role</label></div><div class=col-xs-8><select class=form-control ng-model=vm.selectedGroup ng-options="option.id as option.name for option in vm.groups" ng-disabled=vm.disabled></select></div><div class=clearfix></div></div><div class=form-group ng-if=vm.cloudUser><div class=col-xs-4><label for=exampleInputEmail1>Role</label></div><div class=col-xs-8><select class=form-control ng-model=vm.selectedGroupSys ng-options="option.id as option.name for option in vm.cloudGroups" ng-disabled=vm.disabled required></select></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-panel" style=flex:none><div class=form-group ng-if=!vm.newUserSelected><div class=col-xs-4><label for=exampleInputEmail1>Title</label></div><div class=col-xs-8><input type=text class=form-control id=user-title ng-model=vm.selectedUser.title placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-4><label for=exampleInputEmail1>Business Phone</label></div><div class=col-xs-8><input type=text class=form-control id=user-phone ng-model=vm.selectedUser.phone placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-4><label for=exampleInputEmail1>Mobile Phone</label></div><div class=col-xs-8><input type=text class=form-control id=user-phone-mobile ng-model=vm.selectedUser.mobile_phone placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group ng-if=!vm.newUserSelected><div class=col-xs-4><label>Active</label></div><div class=col-xs-8><input type=checkbox class=form-control style="width:25px;float: left" placeholder="" data-ng-model=vm.selectedUser.active data-ng-true-value="\'true\'" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group ng-if="!vm.newUserSelected && !vm.mit"><div class=col-xs-4><label>Password Reset</label></div><div class=col-xs-8><input type=checkbox class=form-control style="width:25px;float: left" placeholder="" ng-model=vm.passwordReset ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group ng-if=vm.cloudUser><div class=col-xs-4><label for=user-cb-email>Weekly Email Summary</label></div><div class=col-xs-8><input type=checkbox id=weekly-cb-sum class=form-control style="width:25px;margin-top: -5px;float: left" ng-model=vm.user.weeklySummary placeholder=""></div><div class=clearfix></div></div><div class=form-group ng-if=vm.cloudUser><div class=col-xs-4><label for=user-cb-email>Alerts</label></div><div class=col-xs-8><input type=checkbox id=alerts-cb-sum class=form-control style="width:25px;margin-top: -5px;float: left" ng-model=vm.user.alerts placeholder=""></div><div class=clearfix></div></div></div></div></div><div class="form-group text-center"><button class="btn btn-primary btn-md" type=submit ng-click="vm.action=\'update\'" ng-disabled="userForm.$invalid || vm.loading">UPDATE</button> <button class="btn cancel-btn btn-md" type=submit ng-click=vm.cancel()>CANCEL</button><div class=clearfix></div></div></div></div></form></div><!-- </div>\n        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-padding">\n        </div> --></div></div>');
$templateCache.put('app/company/company.html','<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 container container-top" style="margin-top:0px; padding:30px" id=report-page><div class=row><div class="col-lg-12 col-md-3 col-sm-12 col-xs-12 no-padding"><div id=exTab3 style="width:100%; padding:0"><ul class="nav nav-pills"><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'circuit\']"><a ng-click="vm.tabView = \'circuit\'" data-toggle=tab>Circuits</a></li><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'vendor\']"><a ng-click="vm.tabView = \'vendor\'" data-toggle=tab>Vendors</a></li><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'user\']"><a ng-click="vm.tabView = \'user\'" data-toggle=tab>Users</a></li><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'location\']"><a ng-click="vm.tabView = \'location\'" data-toggle=tab>Locations</a></li></ul><div class="tab-content clearfix"><div class="well tab-pane active report-shadow" id=1b ng-show="vm.tabView === \'circuit\'" style="min-height: 200px;box-shadow: 0 8px 6px 0 #000000cc"><div class=panel-loader ng-show=vm.circuitLoading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.circuitLoading && vm.circuits.length == 0"><p>No Circuit Information</p></div><div class=table-responsive ng-if="!vm.circuitLoading && vm.circuits.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions datatable=ng width=100% cellspacing=0 scrollx=true id=circuitTable><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Carrier</th><th>Circuit ID</th><th>Circuit Type</th><th>Speed</th><th>Device</th><th>Location</th><th>Data Service</th><th>Smartjack Location</th><th>Notes</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.circuits"><td></td><td>{{item[\'u_carrier.name\']}}</td><td>{{item.u_circuit_id}}</td><td>{{item.u_circuit_type}}</td><td>{{item.u_speed}}</td><td>{{item[\'u_device_name.name\']}}</td><td>{{item[\'u_site_name.name\']}}</td><td>{{item.u_data_service}}</td><td>{{item.u_smartjack_location}}</td><td>{{item.u_notes}}</td></tr></tbody></table></div></div><div class="well tab-pane active report-shadow" id=2b ng-show="vm.tabView === \'vendor\'" style="min-height: 200px;box-shadow: 0 8px 6px 0 #000000cc"><div class=panel-loader ng-show=vm.vendorLoading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.vendorLoading && vm.vendors.length == 0"><p>No Vendor Information</p></div><div class=table-responsive ng-if="!vm.vendorLoading && vm.vendors.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions datatable=ng width=100% cellspacing=0 scrollx=true id=vendorTable><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Name</th><th>Street</th><th>City</th><th>Zip</th><th>Phone</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.vendors"><td></td><td>{{item.name}}</td><td>{{item.street}}</td><td>{{item.city}}</td><td>{{item.zip}}</td><td>{{item.phone}}</td></tr></tbody></table></div></div><div class="well tab-pane active report-shadow" id=3 ng-show="vm.tabView === \'user\'" style="min-height: 200px;box-shadow: 0 8px 6px 0 #000000cc"><div class=panel-loader ng-show=vm.userLoading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.userLoading && vm.users.length == 0"><p>No User Information</p></div><div class=table-responsive ng-if="!vm.userLoading && vm.users.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefsUser datatable=ng width=100% cellspacing=0 scrollx=true id=userTable><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>User ID</th><th>Name</th><th>Email</th><th>Active</th><th>Created</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.users"><td></td><td>{{item.user_name}}</td><td>{{item.name}}</td><td>{{item.email}}</td><td>{{item.active}}</td><td>{{item.sys_created_on}}</td></tr></tbody></table></div></div><div class="well tab-pane active report-shadow" id=4 ng-show="vm.tabView === \'location\'" style="min-height: 200px;box-shadow: 0 8px 6px 0 #000000cc"><div class=panel-loader ng-show=vm.locationLoading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.locationLoading && vm.locations.length == 0"><p>No Location Information</p></div><div class=table-responsive ng-if="!vm.locationLoading && vm.locations.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions datatable=ng width=100% cellspacing=0 scrollx=true id=locationTable><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Name</th><th>Contact</th><th>Street</th><th>City</th><th>Zip</th><th>Phone</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.locations"><td></td><td>{{item.name}}</td><td>{{item[\'contact.name\']}}</td><td>{{item.street}}</td><td>{{item.city}}</td><td>{{item.zip}}</td><td>{{item.phone}}</td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/contactlists/contactlists.html','<div ng-controller=ContactListsController id=cl-wrapper><div><div id=cl-controller-wrapper class="col-4 col-xl-4 col-lg-4 col-md-4 col-sm-1 col-xs-1"><div id=cl-container><div id=cl-controller-tab-wrapper ng-switch=vm.searchfilterToggle><h5 class=cl-controller-tab ng-switch-when=search id=cl-title-txt>search</h5><h5 class="cl-controller-tab inactive" ng-switch-when=filter ng-click="vm.searchfilterToggle = \'search\'" id=cl-title-txt><small>search</small></h5><h5 class=cl-controller-tab ng-switch-when=filter id=cl-title-txt>filter</h5><h5 class="cl-controller-tab inactive" ng-switch-when=search ng-click="vm.searchfilterToggle = \'filter\'" id=cl-title-txt><small>filter</small></h5></div><div id=cl-controller-container ng-switch=vm.searchfilterToggle><div id=cl-controller-loader-box ng-show=!vm.data><div class=panel-loader><loading></loading></div></div><div ng-show=vm.data><div id=cl-filter-box class=cl-filter-box ng-switch-when=filter><div id=cl-filter-tab><label class=text-left>COMPANY</label><select class=form-control ng-options="comp as comp.company.companyCode for comp in vm.searchList| orderBy:\'-company.companyCode\':true" id=cl-200width ng-model=vm.companySelected></select></div><div id=cl-filter-tab><label class=text-left>GROUPS</label><select id=cl-200width class=form-control ng-model=vm.groupSelected><option ng-show=!vm.companySelected value={{}} disabled>Select a Company...</option><option ng-repeat="group in vm.companySelected.groups" value={{group.groupName}} ng-value=group ng-show=vm.companySelected>{{group.groupName}}</option></select></div><div id=cl-filter-tab><label class=text-left>DEPARTMENTS</label><select id=cl-200width class=form-control ng-model=vm.deptSelected><option ng-show=!vm.groupSelected value={{}} disabled>Select a Group...</option><option ng-repeat="dept in vm.groupSelected.groupDeparts" value={{dept.departmentName}} ng-value=dept ng-show=vm.groupSelected>{{dept.departmentName}}</option></select></div></div><div id=cl-search-wrapper class=cl-search-wrapper ng-switch-when=search><div id=cl-search-box><input type=text class=form-control ng-model=vm.searchWord required> <button id=cl-submit-btn class=btn ng-click=vm.searchRecord(vm.searchWord) type=submit>SEARCH</button></div><div id=cl-search-result-box><div id=cl-flex-box ng-show="vm.searchLog.error.length > 0"><p class=m-0>Error&nbsp;&nbsp;</p><p id=cl-search-err-txt>{{vm.searchLog.error}}</p></div><div id=cl-flex-box><p class=m-0>C&nbsp;&nbsp;</p><p class="m-0 font-weight-bold">{{vm.searchLog.company}}</p></div><div id=cl-flex-box><p class=m-0>G&nbsp;&nbsp;</p><p class="m-0 font-weight-bold">{{vm.searchLog.group}}</p></div><div id=cl-flex-box><p class=m-0>D&nbsp;&nbsp;</p><p class="m-0 font-weight-bold">{{vm.searchLog.department}}</p></div><div id=cl-flex-box><p class=m-0>P&nbsp;&nbsp;</p><p ng-show="vm.searchLog.project.hasOwnProperty(\'hardMatch\')" class="m-0 font-weight-bold">{{vm.searchLog.project.hardMatch}}</p><p ng-show="vm.searchLog.project.hasOwnProperty(\'softMatch\') && !vm.searchLog.project.hasOwnProperty(\'hardMatch\')" class="m-0 font-weight-bold">{{vm.searchLog.project.softMatch}}</p></div></div></div></div></div></div></div><div id=cl-result-container class="col-7 col-xl-7 col-lg-7 col-md-7 col-sm-1 col-xs-1"><h4 id=cl-result-title-txt id=cl-title-txt>CLIENT CONTACTS & BILLING CONTACTS</h4><div ng-show=vm.companySelected><div><div id=cl-result-subtitle-box ng-switch=vm.toggleCBox ng-click="vm.toggleCBox == \'on\' ? vm.toggleCBox = \'off\' : vm.toggleCBox = \'on\'"><h4 id=cl-result-subtitle-txt><small>COMPANY&nbsp;&nbsp;</small>{{vm.companySelected.company.companyCode}} <small>Invoicing Role - {{vm.companySelected.invoicingRole}}</small></h4><span id=cl-dropdown-icon class="glyphicon glyphicon-chevron-down" aria-hidden=true ng-switch-when=off></span> <span id=cl-dropdown-icon class="glyphicon glyphicon-chevron-up" aria-hidden=true ng-switch-when=on></span></div><div id=cl-20pad ng-switch=vm.toggleCBox><div class=cl-res-collapsible ng-style=vm.contactViewBoxStyle ng-switch-when=on><div><h5>E-MAIL CONTACTS</h5><ul id=cl-result-email-list><li ng-repeat="company_c_email in vm.companySelected.company.companyContacts">{{company_c_email}}</li></ul></div><div><h5>BILLING CONTACTS</h5><ul id=cl-result-email-list><li ng-show="vm.companySelected.company.companyBillingContacts.length === 0" class=text-danger>No E-mail Address Found in System.</li><li ng-show="vm.companySelected.company.companyBillingContacts.length > 0" ng-repeat="company_b_email in vm.companySelected.company.companyBillingContacts">{{company_b_email}}</li></ul></div></div><div id=cl-off-box ng-switch-when=off><span id=cl-expand-icon class="glyphicon glyphicon-option-horizontal" aria-hidden=true ng-click="vm.toggleCBox == \'on\' ? vm.toggleCBox = \'off\' : vm.toggleCBox = \'on\'"></span></div></div></div></div><div><div ng-show=vm.groupSelected><div id=cl-result-subtitle-box ng-switch=vm.toggleGBox ng-click="vm.toggleGBox == \'on\' ? vm.toggleGBox = \'off\' : vm.toggleGBox = \'on\'"><h4 id=cl-result-subtitle-txt><small>GROUPS&nbsp;&nbsp;</small>{{vm.groupSelected.groupName}}</h4><span id=cl-dropdown-icon class="glyphicon glyphicon-chevron-down" aria-hidden=true ng-switch-when=off></span> <span id=cl-dropdown-icon class="glyphicon glyphicon-chevron-up" aria-hidden=true ng-switch-when=on></span></div><div id=cl-20pad ng-switch=vm.toggleGBox><div class=cl-res-collapsible ng-style=vm.contactViewBoxStyle ng-switch-when=on><div><h5>GROUP CONTACTS</h5><ul id=cl-result-email-list><li class=text-danger ng-show="vm.groupSelected.groupContacts.length === 0">No E-mail Address Found in System.</li><li ng-show="vm.groupSelected.groupContacts.length > 0" ng-repeat="group_c_email in vm.groupSelected.groupContacts">{{group_c_email}}</li></ul></div><div><h5>GROUP BILLING CONTACTS</h5><ul id=cl-result-email-list><li class=text-danger ng-show="vm.groupSelected.groupBillingContacts.length === 0">No E-mail Address Found in System.</li><li ng-show="vm.groupSelected.groupBillingContacts.length > 0" ng-repeat="group_b_email in vm.groupSelected.groupBillingContacts">{{group_b_email}}</li></ul></div></div><div id=cl-off-box ng-switch-when=off><span id=cl-expand-icon class="glyphicon glyphicon-option-horizontal" aria-hidden=true ng-click="vm.toggleGBox == \'on\' ? vm.toggleGBox = \'off\' : vm.toggleGBox = \'on\'"></span></div></div></div></div><div><div ng-show=vm.deptSelected><div id=cl-result-subtitle-box ng-switch=vm.toggleDBox ng-click="vm.toggleDBox == \'on\' ? vm.toggleDBox = \'off\' : vm.toggleDBox = \'on\'"><h4 id=cl-result-subtitle-txt><small>DEPARTMENTS&nbsp;&nbsp;</small>{{vm.deptSelected.departmentName}}</h4><span id=cl-dropdown-icon class="glyphicon glyphicon-chevron-down" aria-hidden=true ng-switch-when=off></span> <span id=cl-dropdown-icon class="glyphicon glyphicon-chevron-up" aria-hidden=true ng-switch-when=on></span></div><div id=cl-20pad ng-switch=vm.toggleDBox><div class=cl-res-collapsible ng-style=vm.contactViewBoxStyle ng-switch-when=on><div><h5>DEPT. CONTACTS</h5><ul id=cl-result-email-list><li class=text-danger ng-show="vm.deptSelected.departmentContacts.length === 0">No E-mail Address Found in System.</li><li ng-show="vm.deptSelected.departmentContacts.length > 0" ng-repeat="dept_c_email in vm.deptSelected.departmentContacts">{{dept_c_email}}</li></ul></div><div><h5>DEPT. BILLING CONTACTS</h5><ul id=cl-result-email-list><li class=text-danger ng-show="vm.deptSelected.departmentBillingContacts.length === 0">No E-mail Address Found in System.</li><li ng-show="vm.deptSelected.departmentBillingContacts.length > 0" ng-repeat="dept_b_email in vm.deptSelected.departmentBillingContacts">{{dept_b_email}}</li></ul><h5>PROJECT LIST</h5><ul id=cl-result-email-list><li class=text-danger ng-show="vm.deptSelected.departmentProjects.length === 0">No Projects Found in {{vm.deptSelected.departmentName.toUpperCase()}}.</li><li ng-show="vm.deptSelected.departmentProjects.length > 0" ng-repeat="project in vm.deptSelected.departmentProjects">{{project.projectID}}<ul id=cl-result-email-list><li ng-repeat="project_c_email in project.projectContactList">{{project_c_email}}</li></ul></li></ul></div></div><div id=cl-off-box ng-switch-when=off><span id=cl-expand-icon class="glyphicon glyphicon-option-horizontal" aria-hidden=true ng-click="vm.toggleDBox == \'on\' ? vm.toggleDBox = \'off\' : vm.toggleDBox = \'on\'"></span></div></div></div></div></div></div></div>');
$templateCache.put('app/contactus/contactus.html','<div class="container container-top-ticket"><div class="well well-padding-2"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=row><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pd-col" style="padding: 10px 10px 0px"><div class=row><div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pd-col"></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pd-col"><h4 id=noc-number style="position: absolute">Operations Center: {{vm.operations}}</h4></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pd-col"></div></div><div class=row><div class="col-lg-4 col-md-4 col-sm-0 col-xs-0 pd-col" style="padding: 0px; padding-left: 30px; line-height:1.8; padding-bottom: 30px"></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 pd-col"><div id=center-info style="margin-top: 115px"><img id=contact-image src=assets/img/contactusFADE5.png><h4 class=title id=help-title>We\'re Here To Help.</h4></div><div class=center-text><b class=header-text>Burwood Operations Center <img src=./assets/img/icon/burwood_icon2.png class=contact-img style="margin-left:10px; margin-right: 10px"> San Diego</b> <small class=header-text>Business Phone: (858) 275-6950<br>10680 Treena Street Suite 530<br>San Diego, CA 92131<br></small></div></div><div class="col-lg-4 col-md-4 col-sm-0 col-xs-0 pd-col" style="padding: 0px; padding-right: 30px; line-height:1.8; text-align: center"></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pd-col" style="padding: 10px 10px 0px"><div class=row><div class="col-lg-1 col-md-1 col-sm-0 col-xs-0 pd-col" style=margin-top:-25px></div><div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 pd-col" style="margin-top:-25px; text-align: center"><img src=./assets/img/icon/burwood_icon2.png class=contact-img style=margin-right:10px> <b>Peoria</b><br><small>4450 N. Prospect Road<br>Suite S-9<br>Peoria Heights, IL 61616<br>phone: (309) 272-2300</small></div><div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 pd-col" style="margin-top:-25px; text-align: center"><img src=./assets/img/icon/burwood_icon2.png class=contact-img style=margin-right:10px> <b>Bloomington / Normal</b><br><small>200 West College Avenue Suite 403<br>Normal, IL 61761<br>phone: (309) 834-3100</small></div><div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 pd-col" style=margin-top:-25px><b class=header-text>Illinois <img src=./assets/img/icon/burwood_icon2.png class=contact-img style="margin-right:10px; margin-left: 10px"> Chicago (Headquarters)</b><br><small class=header-text style=margin-top:-10px>125 South Wacker Drive Suite 2950<br>Chicago, IL 60606<br>phone: (312) 327-4600</small></div><div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 pd-col" style="margin-top:-25px; text-align: center"><img src=./assets/img/icon/burwood_icon2.png class=contact-img style=margin-left:10px> <b>Iowa</b><br><small>400 N. Main St. Suite 204<br>Davenport, IA 52801<br>phone: (563) 424-4172</small></div><div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 pd-col" style="margin-top:-25px; text-align: left"><img src=./assets/img/icon/burwood_icon2.png class=contact-img style=margin-left:10px> <b>California - Irvine</b><br><small>2020 Main Street Suite 150<br>Irvine, CA 92614<br>phone: (949) 430-7680</small></div><div class="col-lg-1 col-md-1 col-sm-0 col-xs-0 pd-col" style=margin-top:-25px></div></div></div></div></div></div></div>');
$templateCache.put('app/contracts/company_list.html','<div class="row contact-list-form" style=margin-top:100px><div class=modal-header><h4>Select Company</h4></div><div class="modal-body well" id=modal-body><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.companies.length == 0 && vm.searchComplete == true && vm.dataExists == false"><p>Sorry No Companies found.</p></div><form class=search-company ng-submit=vm.searchCompany()><input type=text class=form-control id=search-company ng-model=vm.companyTerm placeholder="Search Company Name"> <button class="btn btn-primary btn-block" type=submit style=margin-top:10px>Search</button></form><div class=table-responsive ng-show="vm.searchComplete == true && vm.dataExists == true"><table class="table row-border hover" datatable=ng dt-options=vm.dtOptions width=100% cellspacing=0><!-- bs-table-control="vm.bsctrl" --><thead><tr><th>No</th><th>Company</th></tr></thead><tbody><tr ng-repeat="company in vm.companies track by $index"><td>{{$index + 1}}</td><td><a ng-click="vm.addtolist(company.name, company.sys_id, company.cus_code)">{{company.name}}</a></td></tr></tbody></table></div></div><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-4"><input type=button class="btn btn-success btn-block" value=Cancel name=cancel ng-click=vm.close()></div></div></div></div>');
$templateCache.put('app/contracts/contract_exceptions.html','<div class="container container-top-ticket col-lg-12 col-md-12 col-sm-12 col-xs-12" style=width:96%><div class="well pd-top" ng-show=!vm.authorized><div class=no-results><p>Sorry, no access to this result.</p></div></div><div class="well pd-top" ng-show=vm.authorized style=min-height:583.4px><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.exceptionsList.length == 0"><p>Sorry, no results for contracts.</p></div><div class="panel-heading brd-bottom"><h3 class=panel-title></h3></div><div class=table-responsive ng-hide="vm.loading || vm.exceptionsList.length == 0"><table class="table table-striped" datatable=ng dt-instance=vm.dtInstance dt-column-defs=vm.dtColumnDefs dt-options=vm.dtOptions width=100% cellspacing=0 scrollx=true id=exceptionsTable><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th></th><th>Name</th><th>Type</th><th>IP Address</th><th>Company</th><th>Science Logic Correlation</th><th>State</th><th>Created</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.exceptionsList track by $index"><td></td><td class=text-center><span style=display:none>{{item.active ? item.priority = 1 : item.priority = 5}}</span><img ng-src=assets/img/icon/network_5.png width=20 height="" style=height:auto></td><td><a ng-click=vm.goToDevice(item.name)>{{item.name}}</a></td><td>{{item.sys_class_name}}</td><td>{{item.ip_address}}</td><td>{{item.company.display_value}}</td><td>{{item.u_sciencelogic_correlation}}</td><td>{{item.u_state}}</td><td>{{item.sys_created_on| date:\'medium\'}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/contracts/contract_new.html','<div class="container container-top-ticket" id=bs-override><div class="well pd-top" ng-show=vm.disabled><div class=no-results><p>Sorry, no access to this page.</p></div></div><div class=row ng-show=!vm.disabled><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-content no-padding"><div class=menu-top style=background-color:#171717><ul class="list-unstyled list-inline pull-left"><li><a ng-click=vm.go_back()><img src=assets/img/icon/back-arrow.png width=15 height="" style=height:auto></a></li><li><strong style="font-size: 16px">Contract {{vm.contractNumber}}</strong></li></ul></div><div class="well well-padding" style="border-radius: 0px 0px 5px 5px"><!-- <div class="bms-header"></div> --><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=row><div class="col-xs-12 alert-contain"><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=vm.close_notice($index) style="margin-top: -37px">{{alert.msg}}</div></div><!-- <form name="contract_new" ng-submit="vm.create(vm.contract, contract_new.$valid)" novalidate> --><form name=contract_new ng-submit=vm.create(); novalidate><div class=col-xs-12 ng-show=vm.error><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=vm.close_notice($index)>{{alert.msg}}</div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-contain" style=margin-left:-5px;margin-right:5px><div class=form-group><div class=col-xs-3><label for=contract-number style=font-size:12px>Contract Number</label></div><div class=col-xs-9><input type=text class=form-control id=contract-number ng-model=vm.contractNumber placeholder=Auto-Generated disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=company style=font-size:12px>Company *</label></div><div class=col-xs-9><p class=input-group style=margin:0px><input type=text class=form-control id=company ng-model=vm.contract.company_display ng-required=true required ng-disabled=vm.disabled> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.company(\'company\')"><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=company-sys ng-model=vm.contract.company placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>Customer Code</label></div><div class=col-xs-9><input type=text class=form-control id=customer-code ng-model=vm.contract.u_customer_code placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=bill-company style=font-size:12px>Bill to Company *</label></div><div class=col-xs-9><p class=input-group style=margin:0px><input type=text class=form-control id=bill-company ng-model=vm.contract.u_bill_to_company_display placeholder="" ng-required=true required ng-disabled=vm.disabled> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.company(\'bill\')"><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=bill-company-sys ng-model=vm.contract.u_bill_to_company placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=contact-name style=font-size:12px>Contact Name</label></div><div class=col-xs-9><p class=input-group style=margin:0px><input type=text class=form-control id=contact-name ng-model=vm.contract.u_contact_name placeholder="" ng-disabled=vm.disabled> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.contact()><i class="fa fa-user-plus"></i></button></span></p></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=contact-email style=font-size:12px>Contact Email</label></div><div class=col-xs-9><input type=email class=form-control id=contact-email ng-model=vm.contract.u_contact_email placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=request_by_date style=font-size:12px>Contract Start Date</label></div><div class=col-xs-9><p class=input-group style=margin-bottom:0px><input type=text class=form-control id=contact ng-change=vm.calcEndDate() ng-model=vm.contract.u_contract_start_date uib-datepicker-popup=yyyy-MM-dd datepicker-options=vm.dateOptions is-open=vm.datepicker_opened close-text=Close> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.open_datepicker()><i class="fa fa-calendar"></i></button></span></p></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=duration style=font-size:12px>Contract Duration</label></div><div class=col-xs-9><select id=duration class=form-control ng-model=vm.contract.duration ng-change=vm.calcEndDate() ng-options="option.id as option.name for option in vm.durations" ng-required=required required ng-disabled=vm.disabled></select></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-contain"><div class=form-group><div class=col-xs-3><label for=startup-fees style=font-size:12px>Contract Startup Fees</label></div><div class=col-xs-9><input type=text class=form-control id=startup-fees ng-model=vm.contract.u_contract_startup_fees placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=status style=font-size:12px>Status</label></div><div class=col-xs-9><select id=state class=form-control ng-model=vm.contract.u_status ng-options="option for option in vm.status" ng-disabled=true></select></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=startup-fees-description style=font-size:12px>Startup Fees Description</label></div><div class=col-xs-9><input type=text class=form-control id=startup-fees-description ng-model=vm.contract.u_startup_fees_description placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=startup-fee-billed style=font-size:12px>Startup Fee Billed</label></div><div class=col-xs-1><input type=checkbox class=form-control style=width:25px id=startup-fee-billed ng-model=vm.contract.u_startup_fee_billed placeholder=""></div><div class=col-xs-8></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=price-escalation-rate style=font-size:12px>Price Escalation Rate</label></div><div class=col-xs-9><input type=text class=form-control id=price-escalation-rate ng-model=vm.contract.u_price_escalation_rate placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=price-escalation-period style=font-size:12px>Price Escalation Period</label></div><div class=col-xs-9><input type=text class=form-control id=price-escalation-Period ng-model=vm.contract.u_price_escalation_period placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=billing-period style=font-size:12px>Billing Period</label></div><div class=col-xs-9><select id=billing-Period class=form-control ng-model=vm.contract.u_billing_period ng-options="option for option in vm.billing_period"></select></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=billing-cycle-date style=font-size:12px>Billing Cycle Date</label></div><div class=col-xs-9><select id=billing-cycle-date class=form-control ng-model=vm.contract.u_billing_cycle_date ng-options="option for option in vm.billing_cycle_date"></select></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=col-xs-5></div><div class=col-xs-4><button class="btn btn-primary btn-block bms-button" type=button ng-click=vm.addService() style="margin-left: 20px">+ Add Service</button></div><div class=col-xs-3></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 service-style" id=service-contain style="margin-bottom: 30px" ng-repeat="service in vm.chosenServices"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 5px" ng-show=!vm.disabled><div class=col-xs-1></div><div class=col-xs-2 style="font-size:12px; margin-top: 20px; color: white; font-weight:300; text-align:right"><div ng-show=!vm.disabled style="display: inline-block;margin-right: 5px"><p ng-show="vm[service].service != null">Add Device</p></div><button class="btn btn-primary btn-block bms-button" type=button ng-click=vm.addRow(service) ng-show="vm[service].service != null && !vm.disabled">+</button></div><div class=col-xs-6 style=margin-bottom:0px><div class=form-group style=text-align:center><label for=service style=font-size:12px>Service Category</label><label class=select-box><select id=service style="margin-bottom: 10px" class=form-control ng-model=vm[service].service ng-change="vm.selectDevices(service, vm[service].service); vm.reset(service)" ng-options="option.id as option.name for option in vm.service" ng-required=required required ng-disabled=vm.disabled></select></label></div></div><div class=col-xs-2 style="margin-top: 3px"><button class="btn btn-primary btn-block bms-button" type=button ng-click=vm.removeService(service) ng-show=!vm.disabled>-</button><div style="font-size:12px; margin-top: 20px; color: white; font-weight:300; display: inline-block;margin-left: 5px" ng-show=!vm.disabled><p>Remove Service</p></div></div><div class=col-xs-1></div><div class=clearfix></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 bms-rows device-header-title" style=height:12px ng-show="vm[service].service != null"><div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-2 no-padding"></div><div class="col-xs-4 bms-rows"><p class=device-header style="margin-left: -25px">Quantity</p></div><div class="col-xs-6 bms-rows"><p class=device-header style="margin-left: -25px">SKU</p></div><div class=clearfix></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-7 bms-rows"><p class=device-header>Device</p></div><div class="col-xs-5 bms-rows"><p class=device-header>Service Level</p></div><div class=clearfix></div></div></div><div class="col-lg-5 col-md-5 col-sm-5 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-4 bms-rows"><p class=device-header>Discount Percent</p></div><div class="col-xs-4 bms-rows"><p class=device-header>Unit Price</p></div><div class="col-xs-4 bms-rows"><p class=device-header>Total</p></div><div class=clearfix></div></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 bms-rows" ng-show="vm[service].service != null" ng-repeat="item in vm[service].itemCount"><div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-2 no-padding"><button class="btn btn-primary btn-block bms-button" type=button ng-click="vm.removeRow(service, item);" ng-show=!vm.disabled>-</button></div><div class="col-xs-4 bms-rows"><input type=number oninput="this.value = Math.abs(this.value)" min=0 class=form-control id=quantity ng-model=vm[service].quantity[item] ng-change="vm.calcPrice(service, item)" placeholder="" ng-required=true required ng-disabled=vm.disabled></div><div class="col-xs-6 bms-rows"><input type=text class="form-control cursor" id=sku ng-model=vm[service].sku[item] placeholder="" disabled></div><div class=clearfix></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-7 bms-rows"><label class=select-box><select id=devices class=form-control ng-model=vm[service].devices[item] ng-change="vm.calcServiceLevel(service, vm[service].devices[item], item); vm.calcPrice(service, item)" ng-options="option for option in vm[service].deviceNames" ng-required=required required ng-disabled=vm.disabled></select></label></div><div class="col-xs-5 bms-rows"><label class=select-box><select id=service-level class=form-control ng-model=vm[service].service_level[item] ng-change="vm.calcPrice(service, item)" ng-options="option for option in vm[service].availableLevels[item]" ng-required=required required ng-disabled=vm.disabled></select></label></div><div class=clearfix></div></div></div><div class="col-lg-5 col-md-5 col-sm-5 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-4 bms-rows"><input type=number oninput="if(this.value > 100){this.value=100}" min=0 max=100 class=form-control id=discount ng-model=vm[service].discount[item] ng-change="vm.calcPrice(service, item)" placeholder="" ng-required=true required ng-disabled=vm.disabled style="padding:0px; padding-left: 8px"></div><div class="col-xs-4 bms-rows"><input type=text class=form-control id=price ng-model=vm[service].price[item] ng-change="vm.inputPrice(service, item)" ng-blur="vm.formatCurrency(service, item)" placeholder="" ng-required=true required ng-disabled=vm.disablePrice></div><div class="col-xs-4 bms-rows"><input type=text class=form-control id=price ng-model=vm[service].singleTotal[item] ng-change="vm.inputPrice(service, item)" ng-blur="vm.formatCurrency(service, item)" placeholder="" ng-required=true required ng-disabled=vm.disablePrice></div><div class=clearfix></div></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 total-contain" ng-show="vm.chosenServices.length > 0"><div class=col-xs-3></div><div class=col-xs-6><div class=form-group><div class=col-xs-3 style="text-align: right;padding-top: 10px"><label for=total-price style=font-size:12px>Total Price</label></div><div class=col-xs-9><input type=text class=form-control style="width: 250px" id=total-price ng-model=vm.total_price placeholder="" ng-disabled=vm.disablePrice></div><div class=clearfix></div></div></div><div class=col-xs-3></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12 style="text-align:center;margin-bottom: 0;margin-top: 10px"><button class="btn btn-primary btn-block" type=submit ng-disabled="contract_new.$invalid || vm.loading">CREATE</button></div><div class=clearfix></div></div><!-- </div> --></form></div></div></div></div></div>');
$templateCache.put('app/contracts/contracts.html','<div class="container container-top-ticket col-lg-12 col-md-12 col-sm-12 col-xs-12" style=width:96%><div class="well pd-top" ng-show=!vm.authorized><div class=no-results><p>Sorry, no access to this result.</p></div></div><div class="well pd-top" ng-show=vm.authorized style=min-height:200px><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.contracts.length == 0"><p>Sorry, no results for contracts.</p></div><div class=table-responsive ng-hide="vm.loading || vm.contracts.length == 0"><table class="table table-striped" dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true><!-- bs-table-control="vm.bsctrl" --><thead><tr><th></th><th>Contract</th><th>Company</th><th>Client Contact</th><th>Start Date</th><th>End Date</th></tr></thead><tbody><tr ng-repeat="item in vm.contracts"><td class=text-center><span style=display:none>{{item.active ? item.priority = 1 : item.priority = 5}}</span><img ng-src=assets/img/icon/network_5.png width=20 height="" style=height:auto></td><td><a href=contracts/{{item.sys_id}}>{{item.u_contract_number}}</a></td><td>{{item.company.display_value}}</td><td>{{item.u_contact_name}}</td><td>{{item.u_contract_start_date| date:\'medium\'}}</td><td>{{item.u_contract_end_date| date:\'medium\'}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/contracts/creating.html','<div class="row reset-form"><div class=modal-header><h4>Creating Contract</h4></div><div class=modal-body id=modal-body style=color:white;font-weight:300>Your contract is processing.<div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double" style="margin-top: -15px"></div></div></div><div class=modal-footer><button class="btn btn-primary" type=button ng-click=vm.close()>OK</button></div></div>');
$templateCache.put('app/contracts/downloadcontract.html','<a class="btn btn-primary" style="background-color: #0C713D" ng-click=vm.download()><i class="fa fa-download" aria-hidden=true data-toggle=tooltip title="Download Contract"></i></a>');
$templateCache.put('app/contracts/processing.html','<div class="row reset-form"><div class=modal-header><h4>Processing Update</h4></div><div class=modal-body id=modal-body style=color:white;font-weight:300>Your update is processing.<div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double" style="margin-top: -15px"></div></div></div><div class=modal-footer><button class="btn btn-primary" type=button ng-click=vm.close()>OK</button></div></div>');
$templateCache.put('app/contracts/quotes.html','<div class="container container-top-ticket col-lg-12 col-md-12 col-sm-12 col-xs-12" style=width:96%><div class="well pd-top" ng-show=!vm.authorized><div class=no-results><p>Sorry, no access to this result.</p></div></div><div class="well pd-top" ng-show=vm.authorized style=min-height:200px><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.quotes.length == 0"><p>Sorry, no results for Quotes.</p></div><div class=table-responsive ng-hide="vm.loading || vm.quotes.length == 0"><table class="table table-striped" dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true><!-- bs-table-control="vm.bsctrl" --><thead><tr><th></th><th>Quote</th><th>Company</th><th>Client Contact</th><th>Start Date</th><th>End Date</th></tr></thead><tbody><tr ng-repeat="item in vm.quotes"><td class=text-center><span style=display:none>{{item.active ? item.priority = 1 : item.priority = 5}}</span><img ng-src=assets/img/icon/network_5.png width=20 height="" style=height:auto></td><td><a href=quotes/{{item.sys_id}}>{{item.u_contract_number}}</a></td><td>{{item.company.display_value}}</td><td>{{item.u_contact_name}}</td><td>{{item.u_contract_start_date| date:\'medium\'}}</td><td>{{item.u_contract_end_date| date:\'medium\'}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/contracts/singlecontract.html','<div class="container container-top-ticket" id=bs-override><div class="well pd-top" ng-show="!vm.authorized && !vm.loading"><div class=no-results><p>Sorry, no access to this page.</p></div></div><div class=row ng-show="!vm.loading && vm.authorized"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-content no-padding"><div class=menu-top style=background-color:#171717><ul class="list-unstyled list-inline pull-left"><li><a ng-click=vm.go_back()><img src=assets/img/icon/back-arrow.png width=15 height="" style=height:auto></a></li><li><strong>Contracts</strong></li></ul><ul class="list-unstyled list-inline pull-right"><li><a ng-click=vm.attachment()><img src=assets/img/icon/attach.png width=15 height="" style=height:auto></a></li></ul></div><div class="well well-padding" style="border-radius: 0px 0px 5px 5px"><div class=bms-header-contain><p class=bms-header ng-show=!vm.companyLoading>{{vm.contract.company_display}} - {{vm.contract.u_contract_number}}</p></div><div class=row><form name=contract_new ng-submit=vm.update(); novalidate><div class=col-xs-12 ng-show=vm.error><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=vm.close_notice($index)>{{alert.msg}}</div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-contain" style=margin-left:-5px;margin-right:5px><div class=form-group><div class=col-xs-3><label for=contract-number style=font-size:12px>Contract Number</label></div><div class=col-xs-9><input type=text class=form-control id=contract-number ng-model=vm.contract.u_contract_number placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=company style=font-size:12px>Company *</label></div><div class=col-xs-9><p class=input-group style=margin:0px><input type=text class=form-control id=company ng-model=vm.contract.company_display ng-required=true required ng-disabled=vm.disabled> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.company(\'company\')" ng-disabled=vm.disabled><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=company-sys ng-model=vm.contract.company placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>Customer Code</label></div><div class=col-xs-9><input type=text class=form-control id=customer-code ng-model=vm.contract.u_customer_code placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=bill-company style=font-size:12px>Bill to Company *</label></div><div class=col-xs-9><p class=input-group style=margin:0px><input type=text class=form-control id=bill-company ng-model=vm.contract.u_bill_to_company_display placeholder="" ng-required=true required ng-disabled=vm.disabled> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.company(\'bill\')" ng-disabled=vm.disabled><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=bill-company-sys ng-model=vm.contract.u_bill_to_company placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=contact-name style=font-size:12px>Contact Name</label></div><div class=col-xs-9><p class=input-group style=margin:0px><input type=text class=form-control id=contact-name ng-model=vm.contract.u_contact_name placeholder="" ng-disabled=vm.disabled> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.contact() ng-disabled=vm.disabled><i class="fa fa-user-plus"></i></button></span></p></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=contact-email style=font-size:12px>Contact Email</label></div><div class=col-xs-9><input type=email class=form-control id=contact-email ng-model=vm.contract.u_contact_email placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=request_by_date style=font-size:12px>Contract Start Date</label></div><div class=col-xs-9><p class=input-group style=margin-bottom:0px><input type=text class=form-control id=contact ng-change=vm.calcEndDate() ng-model=vm.contract.u_contract_start_date uib-datepicker-popup=yyyy-MM-dd datepicker-options=vm.dateOptions is-open=vm.datepicker_opened close-text=Close ng-disabled=vm.disabled> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.open_datepicker() ng-disabled=vm.disabled><i class="fa fa-calendar"></i></button></span></p></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=duration style=font-size:12px>Contract Duration</label></div><div class=col-xs-9><select id=duration class=form-control ng-model=vm.contract.duration ng-change=vm.calcEndDate() ng-options="option.id as option.name for option in vm.durations" ng-required=required required ng-disabled=vm.disabled></select></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-contain"><div class=form-group><div class=col-xs-3><label for=startup-fees style=font-size:12px>Contract Startup Fees</label></div><div class=col-xs-9><input type=text class=form-control id=startup-fees ng-model=vm.contract.u_contract_startup_fees placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=status style=font-size:12px>Status</label></div><div class=col-xs-9><select id=state class=form-control ng-model=vm.contract.u_status ng-options="option for option in vm.status" ng-disabled=vm.disabled></select></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=startup-fees-description style=font-size:12px>Startup Fees Description</label></div><div class=col-xs-9><input type=text class=form-control id=startup-fees-description ng-model=vm.contract.u_startup_fees_description placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=startup-fee-billed style=font-size:12px>Startup Fee Billed</label></div><div class=col-xs-1><input type=checkbox class=form-control id=startup-fee-billed style=width:25px ng-model=vm.contract.u_startup_fee_billed placeholder="" ng-disabled=vm.disabled></div><div class=col-xs-8></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=price-escalation-rate style=font-size:12px>Price Escalation Rate</label></div><div class=col-xs-9><input type=text class=form-control id=price-escalation-rate ng-model=vm.contract.u_price_escalation_rate placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=price-escalation-period style=font-size:12px>Price Escalation Period</label></div><div class=col-xs-9><input type=text class=form-control id=price-escalation-Period ng-model=vm.contract.u_price_escalation_period placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=billing-period style=font-size:12px>Billing Period</label></div><div class=col-xs-9><select id=billing-Period class=form-control ng-model=vm.contract.u_billing_period ng-options="option for option in vm.billing_period" ng-disabled=vm.disabled></select></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=billing-cycle-date style=font-size:12px>Billing Cycle Date</label></div><div class=col-xs-9><select id=billing-cycle-date class=form-control ng-model=vm.contract.u_billing_cycle_date ng-options="option for option in vm.billing_cycle_date" ng-disabled=vm.disabled></select></div><div class=clearfix></div></div></div><div class=panel-loader ng-show=vm.loadingCI style="left: 48%"><div class="css-loading css-loading--double" style="top:240px;margin-left: 5px"></div></div><!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" ng-show="!vm.loadingCI && !vm.disabled">\n                            <div class="col-xs-5"></div>\n                            <div class="col-xs-4">\n                                <button class="btn btn-primary btn-block bms-button" type="button"\n                                    ng-click="vm.addService()" style="margin-left: 20px">+ Add Service</button>\n                            </div>\n                            <div class="col-xs-3"></div>\n                        </div> --><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 service-style" id=service-contain style="margin-bottom: 30px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 bms-rows device-header-title" style=height:12px><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-4 no-padding"><p class=device-header style="margin-left: -39px;margin-top: -11px">Show<br>Devices</p></div><div class="col-xs-4 bms-rows"><p class=device-header style="margin-left: -12px;margin-top: -11px">Monitored<br>Devices</p></div><div class="col-xs-4 bms-rows"><p class=device-header style="margin-top: -11px">Quoted<br>Devices</p></div><!-- <div class="col-xs-6 bms-rows">\n                                            <p class="device-header" style="margin-left: -25px;">Number</p>\n                                        </div> --><div class=clearfix></div></div></div><div class="col-lg-5 col-md-5 col-sm-5 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-8 bms-rows"><p class=device-header>Device</p></div><div class="col-xs-4 bms-rows"><p class=device-header>Service Level</p></div><div class=clearfix></div></div></div><div class="col-lg-5 col-md-5 col-sm-5 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-4 bms-rows"><p class=device-header>Discount Percent</p></div><div class="col-xs-4 bms-rows"><p class=device-header>Unit Price</p></div><div class="col-xs-4 bms-rows"><p class=device-header>Total</p></div><div class=clearfix></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 bms-rows" ng-repeat="contractItem in vm.contractItems"><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-4 no-padding"><div ng-click=vm.expandContractItem(contractItem.contractItem) style="margin-top: 6px" ng-if="contractItem.devices.length > 0" class=expand-parent><i class="fas fa-angle-double-right fa-lg no-focus" ng-class="{\'turn-down\': contractItem.checked}" ng-click="contractItem.checked = !contractItem.checked" style="color: #949494"></i></div></div><div class="col-xs-4 bms-rows" style=padding-left:5px><input type=number oninput="this.value = Math.abs(this.value)" min=0 class=form-control id=monitored_devices ng-model=contractItem.devices.length placeholder="" ng-required=true required ng-disabled=true></div><div class="col-xs-4 bms-rows" style=padding-right:5px><input type=number oninput="this.value = Math.abs(this.value)" min=0 class=form-control id=quantity ng-model=contractItem.quotedDevices placeholder="" ng-required=true required ng-disabled=vm.disabled></div><div class=clearfix></div></div></div><div class="col-lg-5 col-md-5 col-sm-5 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-8 bms-rows"><label class=select-box><input type=text class="form-control cursor" id=contractItem ng-model=contractItem.deviceType placeholder="" disabled></label></div><div class="col-xs-4 bms-rows"><label class=select-box><input type=text class="form-control cursor" id=serviceLevel ng-model=contractItem.serviceLevel placeholder="" disabled></label></div><div class=clearfix></div></div></div><div class="col-lg-5 col-md-5 col-sm-5 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-4 bms-rows"><input type=number oninput="if(this.value > 100){this.value=100}" min=0 max=100 class=form-control id=discount ng-model=contractItem.discount placeholder="" ng-required=true required ng-disabled=vm.disabled style="padding:0px; padding-left: 8px"></div><div class="col-xs-4 bms-rows"><input type=text class=form-control id=price ng-model=contractItem.priceDisplay placeholder="" ng-required=true required ng-disabled=true></div><div class="col-xs-4 bms-rows"><input type=text class=form-control id=price ng-model=contractItem.totalDisplay placeholder="" ng-required=true disabled required></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" ng-if=contractItem.checked style="border: 1px solid #6b6b6b;\n                                    border-radius: 5px;\n                                    padding: 10px;\n                                    margin-top: 10px;\n                                    margin-bottom: 25px;\n                                    background-color: #252525"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 bms-rows device-header-title" style="margin-top: 0px!important"><div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 bms-rows no-padding"><div class=form-group><!-- <div class="col-xs-4 no-padding">\n                                                    <p class="device-header" style="margin-left: -25px;">Select</p>\n                                                </div> --><div class="col-xs-12 bms-rows"><p class=device-header>Device Name</p></div><div class=clearfix></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-6 bms-rows"><p class=device-header style="margin-left: -12px">IP</p></div><div class="col-xs-6 bms-rows"><p class=device-header>Class</p></div><div class=clearfix></div></div></div><div class="col-lg-5 col-md-5 col-sm-5 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-4 bms-rows"><p class=device-header>Category</p></div><div class="col-xs-4 bms-rows"><p class=device-header>Model</p></div><div class="col-xs-4 bms-rows"><p class=device-header>Status</p></div><div class=clearfix></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-6 bms-rows no-padding" ng-repeat="device in contractItem.devices" style="margin-bottom: 3px"><div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 bms-rows no-padding"><div class=form-group><!-- <div class="col-xs-4 bms-rows" style="margin-top: 5px;">\n                                                    <input type="checkbox" class="form-control"\n                                                        style="z-index:1000;width: 16px;margin: -4px;margin-left: 10px;"\n                                                        ng-model="device.checked" ng-click="$event.stopPropagation()">\n                                                </div> --><div class="col-xs-12 bms-rows"><input type=text ng-model=device.name placeholder="" class=form-control readonly style="padding:0px; padding-left: 8px; cursor:pointer" ng-click=vm.goToDevice(device.name)></div><div class=clearfix></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-6 bms-rows no-padding"><input type=text ng-model=device.ip_address placeholder="" class=form-control ng-disabled=vm.disabled style="padding:0px; padding-left: 8px"></div><div class="col-xs-6 bms-rows"><input type=text ng-model=device.sys_class_name placeholder="" class=form-control ng-disabled=vm.disabled style="padding:0px; padding-left: 8px"></div><div class=clearfix></div></div></div><div class="col-lg-5 col-md-5 col-sm-5 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-4 bms-rows"><input type=text ng-model=device.u_device_category placeholder="" class=form-control ng-disabled=vm.disabled style="padding:0px; padding-left: 8px"></div><div class="col-xs-4 bms-rows"><input type=text ng-model=device.model_id placeholder="" class=form-control ng-disabled=vm.disabled style="padding:0px; padding-left: 8px"></div><div class="col-xs-4 bms-rows"><input type=text ng-model=device.operational_status placeholder="" class=form-control ng-disabled=vm.disabled style="padding:0px; padding-left: 8px"></div><div class=clearfix></div></div></div></div></div></div></div><!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 total-contain" ng-show="!vm.loadingCI">\n                            <div uib-alert ng-repeat="alert in vm.alerts" class="alert-{{alert.type}}"\n                                style="height: 35px;position: absolute;width: 50%;left: 25%;padding-top: 8px;"\n                                close="vm.close_notice($index)">{{alert.msg}}</div>\n                            <button id="run-device-button" class="report-category title-format" type="button"\n                                ng-click="vm.decommissionDevices()" style="background-color: #383838;">Decommission\n                                Selected</button>\n                        </div> --><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 total-contain" ng-show=!vm.loadingCI><div class=col-xs-3></div><div class=col-xs-6><div class=form-group><div class=col-xs-3 style="text-align: right;padding-top: 10px"><label for=total-price style=font-size:12px>Total Price</label></div><div class=col-xs-9><input type=text class=form-control style="width: 250px" id=total-price ng-model=vm.totalCostDisplay placeholder="" ng-disabled=true></div><div class=clearfix></div></div></div><div class=col-xs-3></div><div class=clearfix></div></div><div class=form-group ng-show=!vm.disabled><div class=col-xs-12 style="text-align:center;margin-bottom: 0;margin-top: 10px"><button class="btn btn-primary btn-block" type=submit ng-disabled="contract_new.$invalid || vm.loading || vm.disabled">UPDATE</button></div><div class=clearfix></div></div></form></div></div></div></div></div>');
$templateCache.put('app/contracts/singlequote.html','<div class="container container-top-ticket" id=bs-override><div class="well pd-top" ng-show="!vm.authorized && !vm.loading"><div class=no-results><p>Sorry, no access to this page.</p></div></div><div class=row ng-show="!vm.loading && vm.authorized"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-content no-padding"><div class=menu-top style=background-color:#171717>s<ul class="list-unstyled list-inline pull-left"><li><a ng-click=vm.go_back_quote()><img src=assets/img/icon/back-arrow.png width=15 height="" style=height:auto></a></li><li><strong>Quotes</strong></li></ul><ul class="list-unstyled list-inline pull-right" ng-if="vm.quoteStatus === \'Draft\' && vm.disabled === false" style=padding:5px><li><button class="btn btn-primary btn-block" type=button ng-click=vm.requestApproval(contract_new) ng-disabled="contract_new.$invalid || vm.loading || vm.disabled">REQUEST APPROVAL</button></li></ul><ul class="list-unstyled list-inline pull-right" ng-if="vm.quoteStatus === \'In Approval\' && vm.disabled === false" style=padding:5px><li><button class="btn btn-primary btn-block" type=button ng-click=vm.activateContract(contract_new) ng-disabled="contract_new.$invalid || vm.loading || vm.disabled">ACTIVATE CONTRACT</button></li></ul><ul class="list-unstyled list-inline pull-right" ng-if="vm.quoteStatus === \'In Approval\' && vm.disabled === false" style=padding:5px><li><button class="btn btn-primary btn-block" type=button ng-click=vm.requestRevision(contract_new) ng-disabled="contract_new.$invalid || vm.loading || vm.disabled">REQUEST REVISION</button></li></ul><ul class="list-unstyled list-inline pull-right"><li><a ng-click=vm.attachment()><img src=assets/img/icon/attach.png width=15 height="" style=height:auto></a></li></ul></div><div class="well well-padding" style="border-radius: 0px 0px 5px 5px; margin-top:0px"><div class=bms-header-contain><p class=bms-header ng-show=!vm.companyLoading>{{vm.contract.company_display}} - {{vm.contract.u_contract_number}}</p></div><div class=row><form id=quote-form name=contract_new ng-submit=vm.update(contract_new);><div class=col-xs-12 ng-show=vm.error><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=vm.close_notice($index)>{{alert.msg}}</div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-contain" style=margin-left:-5px;margin-right:5px><div class=form-group><div class=col-xs-3><label for=contract-number style=font-size:12px>Contract Number</label></div><div class=col-xs-9><input type=text class=form-control id=contract-number ng-model=vm.contract.u_contract_number placeholder="" ng-disabled=vm.disabledContractNum></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=company style=font-size:12px>Company</label></div><div class=col-xs-9><p class=input-group style=margin:0px><input type=text class=form-control id=company ng-model=vm.contract.company_display ng-required=true required ng-disabled=vm.disabled> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.company(\'company\')" ng-disabled=vm.disabled><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=company-sys ng-model=vm.contract.company placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>Customer Code *</label></div><div class=col-xs-9><input type=text class=form-control id=customer-code ng-model=vm.contract.u_customer_code placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=bill-company style=font-size:12px>Bill to Company *</label></div><div class=col-xs-9><p class=input-group style=margin:0px><input type=text class=form-control id=bill-company ng-model=vm.contract.u_bill_to_company_display placeholder="" ng-required=true required ng-disabled=vm.disabled> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.company(\'bill\')" ng-disabled=vm.disabled><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=bill-company-sys ng-model=vm.contract.u_bill_to_company placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=contact-name style=font-size:12px>Contact Name</label></div><div class=col-xs-9><p class=input-group style=margin:0px><input type=text class=form-control id=contact-name ng-model=vm.contract.u_contact_name placeholder="" ng-disabled=vm.disabled> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.contact() ng-disabled=vm.disabled><i class="fa fa-user-plus"></i></button></span></p></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=contact-email style=font-size:12px>Contact Email</label></div><div class=col-xs-9><input type=email class=form-control id=contact-email ng-model=vm.contract.u_contact_email placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=start_date style=font-size:12px>Contract Start Date</label></div><div class=col-xs-9><p class=input-group style=margin-bottom:0px><input type=text class=form-control id=start_date ng-change=vm.calcEndDate() ng-model=vm.contract.u_contract_start_date uib-datepicker-popup=yyyy-MM-dd datepicker-options=vm.dateOptions is-open=vm.datepicker_opened close-text=Close ng-disabled=vm.disabled> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.open_datepicker() ng-disabled=vm.disabled><i class="fa fa-calendar"></i></button></span></p></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=duration style=font-size:12px>Contract Duration</label></div><div class=col-xs-9><select id=duration class=form-control ng-model=vm.contract.duration ng-change=vm.calcEndDate() ng-options="option.id as option.name for option in vm.durations" ng-required=required required ng-disabled=vm.disabled></select></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-contain"><div class=form-group><div class=col-xs-3><label for=startup-fees style=font-size:12px>Contract Startup Fees</label></div><div class=col-xs-9><input type=text class=form-control id=startup-fees ng-model=vm.contract.u_contract_startup_fees placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=status style=font-size:12px>Status</label></div><div class=col-xs-9><select id=state class=form-control ng-model=vm.contract.u_status ng-options="option for option in vm.status" ng-disabled=true></select></div><div class=clearfix></div></div><!-- <div class="form-group">\n                            <div class="col-xs-3">\n                                <label for="logo-url" style="font-size:12px">Logo URL</label>\n                            </div>\n                            <div class="col-xs-9">\n                                <input type="text" class="form-control" id="logo-url" ng-model="vm.contract.u_logo_url" ng-blur="vm.changeLogo(vm.form.logo_url)" placeholder="">\n                            </div>\n                            <div class="clearfix"></div>\n                        </div> --><div class=form-group><div class=col-xs-3><label for=startup-fees-description style=font-size:12px>Startup Fees Description</label></div><div class=col-xs-9><input type=text class=form-control id=startup-fees-description ng-model=vm.contract.u_startup_fees_description placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=startup-fee-billed style=font-size:12px>Startup Fee Billed</label></div><div class=col-xs-1><input type=checkbox class=form-control id=startup-fee-billed style=width:25px ng-model=vm.contract.u_startup_fee_billed placeholder="" ng-disabled=vm.disabled></div><div class=col-xs-8></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=price-escalation-rate style=font-size:12px>Price Escalation Rate</label></div><div class=col-xs-9><input type=text class=form-control id=price-escalation-rate ng-model=vm.contract.u_price_escalation_rate placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=price-escalation-period style=font-size:12px>Price Escalation Period</label></div><div class=col-xs-9><input type=text class=form-control id=price-escalation-Period ng-model=vm.contract.u_price_escalation_period placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=billing-period style=font-size:12px>Billing Period</label></div><div class=col-xs-9><select id=billing-Period class=form-control ng-model=vm.contract.u_billing_period ng-options="option for option in vm.billing_period" ng-disabled=vm.disabled></select></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=billing-cycle-date style=font-size:12px>Billing Cycle Date</label></div><div class=col-xs-9><select id=billing-cycle-date class=form-control ng-model=vm.contract.u_billing_cycle_date ng-options="option for option in vm.billing_cycle_date" ng-disabled=vm.disabled></select></div><div class=clearfix></div></div></div><div class=panel-loader ng-show=vm.loadingCI><div class="css-loading css-loading--double" style="top:240px;margin-left: 5px"></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" ng-show="!vm.loadingCI && !vm.disabled"><div class=col-xs-5></div><div class=col-xs-4><button class="btn btn-primary btn-block bms-button" type=button ng-click=vm.addService() style="margin-left: 20px">+ Add Service</button></div><div class=col-xs-3></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 service-style" id=service-contain style="margin-bottom: 30px" ng-repeat="service in vm.chosenServices"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 5px"><div ng-show=!vm.disabled><div class=col-xs-1></div><div class=col-xs-2 style="font-size:12px; margin-top: 20px; color: white; font-weight:300; text-align:right"><div ng-show=!vm.disabled style="display: inline-block;margin-right: 5px"><p ng-show="vm[service].service != null">Add Device</p></div><button class="btn btn-primary btn-block bms-button" type=button ng-click=vm.addRow(service) ng-show="vm[service].service != null && !vm.disabled">+</button></div><div class=col-xs-6 style=margin-bottom:0px><div class=form-group style=text-align:center><label for=service style=font-size:12px>Service Category</label><label class=select-box><select id=service style="margin-bottom: 10px" class=form-control ng-model=vm[service].service ng-change="vm.selectDevices(service, vm[service].service); vm.reset(service)" ng-options="option.id as option.name for option in vm.service" ng-required=required required ng-disabled=vm.disabled></select></label></div></div><div class=col-xs-2 style="margin-top: 3px"><button class="btn btn-primary btn-block bms-button" type=button ng-click=vm.removeService(service) ng-show=!vm.disabled>-</button><div style="font-size:12px; margin-top: 20px; color: white; font-weight:300; display: inline-block;margin-left: 5px" ng-show=!vm.disabled><p>Remove Service</p></div></div><div class=col-xs-1></div><div class=clearfix></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 bms-rows device-header-title" style=height:12px ng-show="vm[service].service != null"><div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-2 no-padding"></div><div class="col-xs-4 bms-rows"><p class=device-header style="margin-left: -25px">Quantity</p></div><div class="col-xs-6 bms-rows"><p class=device-header style="margin-left: -25px">SKU</p></div><div class=clearfix></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-7 bms-rows"><p class=device-header>Device</p></div><div class="col-xs-5 bms-rows"><p class=device-header>Service Level</p></div><div class=clearfix></div></div></div><div class="col-lg-5 col-md-5 col-sm-5 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-4 bms-rows"><p class=device-header>Discount Percent</p></div><div class="col-xs-4 bms-rows"><p class=device-header>Unit Price</p></div><div class="col-xs-4 bms-rows"><p class=device-header>Total</p></div><div class=clearfix></div></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 bms-rows" ng-show="vm[service].service != null" ng-repeat="item in vm[service].itemCount"><div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-2 no-padding"><button class="btn btn-primary btn-block bms-button" type=button ng-click="vm.removeRow(service, item);" ng-show=!vm.disabled>-</button></div><div class="col-xs-4 bms-rows"><input type=number oninput="this.value = Math.abs(this.value)" min=0 class=form-control id=quantity ng-model=vm[service].quantity[item] ng-change="vm.calcPrice(service, item)" placeholder="" ng-required=true required ng-disabled=vm.disabled></div><div class="col-xs-6 bms-rows"><input type=text class="form-control cursor" id=sku ng-model=vm[service].sku[item] placeholder="" disabled></div><div class=clearfix></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-7 bms-rows"><label class=select-box><select id=devices class=form-control ng-model=vm[service].devices[item] ng-change="vm.calcServiceLevel(service, vm[service].devices[item], item); vm.calcPrice(service, item)" ng-options="option for option in vm[service].deviceNames" ng-required=required required ng-disabled=vm.disabled></select></label></div><div class="col-xs-5 bms-rows"><label class=select-box><select id=service-level class=form-control ng-model=vm[service].service_level[item] ng-change="vm.calcPrice(service, item)" ng-options="option for option in vm[service].availableLevels[item]" ng-required=required required ng-disabled=vm.disabled></select></label></div><div class=clearfix></div></div></div><div class="col-lg-5 col-md-5 col-sm-5 col-xs-6 bms-rows no-padding"><div class=form-group><div class="col-xs-4 bms-rows"><input type=number oninput="if(this.value > 100){this.value=100}" min=0 max=100 class=form-control id=discount ng-model=vm[service].discount[item] ng-change="vm.calcPrice(service, item)" placeholder="" ng-required=true required ng-disabled=vm.disabled style="padding:0px; padding-left: 8px"></div><div class="col-xs-4 bms-rows"><input type=text class=form-control id=price ng-model=vm[service].price[item] ng-change="vm.inputPrice(service, item)" ng-blur="vm.formatCurrency(service, item)" placeholder="" ng-required=true required ng-disabled=vm.disablePrice></div><div class="col-xs-4 bms-rows"><input type=text class=form-control id=price ng-model=vm[service].singleTotal[item] ng-change="vm.inputPrice(service, item)" ng-blur="vm.formatCurrency(service, item)" placeholder="" ng-required=true required ng-disabled=vm.disablePrice></div><div class=clearfix></div></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 total-contain" ng-show="vm.chosenServices.length > 0"><div class=col-xs-3></div><div class=col-xs-6><div class=form-group><div class=col-xs-3 style="text-align: right;padding-top: 10px"><label for=total-price style=font-size:12px>Total Price</label></div><div class=col-xs-9><input type=text class=form-control style="width: 250px" id=total-price ng-model=vm.total_price placeholder="" ng-disabled=vm.disablePrice></div><div class=clearfix></div></div></div><div class=col-xs-3></div><div class=clearfix></div></div><div class=form-group ng-show=!vm.disabled><div class=col-xs-12 style="text-align:center;margin-bottom: 0;margin-top: 10px"><button class="btn btn-primary btn-block" type=submit ng-disabled="contract_new.$invalid || vm.loading || vm.disabled">UPDATE</button></div><div class=clearfix></div></div></form></div></div></div></div></div>');
$templateCache.put('app/csvInvoiceDashboard/csvInvoiceDashboard.html','<div ng-controller=CSVInvoiceDashboardController class=csv-total-dashboard-wrapper><div class=left-panel-csv-dashboard><div class=csv-db-navbar><div class=csv-db-navbar-bw-box><img src=./assets/img/icon/burwood_icon2.png id=mini-logo width=30><h4 class=nav-bar-title-text>Burwood</h4></div><div class=csv-db-navbar-sub-box><span id=csv-db-nav-icon class="glyphicon glyphicon-modal-window" aria-hidden=true></span><h5 class=nav-bar-subtitle-text>CSV Dashboard</h5></div><div class=csv-db-nav-button-box ng-class="{navButtonPressed : vm.expandDatePicker}" ng-click="vm.expandDatePicker = !vm.expandDatePicker"><span id=csv-db-nav-icon class="glyphicon glyphicon-search" aria-hidden=true></span><p class=csv-db-nav-txt>csv search</p></div><div ng-show=vm.expandDatePicker class=date-picker-box><div class=date-picker-year-box><span id=csv-db-nav-icon class="glyphicon glyphicon-chevron-left" aria-hidden=true ng-click="vm.yearSliderSet(\'left\')"></span><p class=date-picker-year-txt ng-repeat="year in vm.yearRange" ng-click="vm.selectedYear = year" ng-show="$index == vm.yearSliderPos">{{year}}</p><span id=csv-db-nav-icon class="glyphicon glyphicon-chevron-right" aria-hidden=true ng-click="vm.yearSliderSet(\'right\')"></span></div><div class=date-picker-month-box><p class=month-dp-text ng-class="{dpSelected : month.Value == vm.selectedMonth}" ng-repeat="month in vm.monthRange" ng-click="vm.selectedMonth = month.Value">{{month.Text}}</p></div><button class=date-picker-search-btn ng-click="vm.fetchCSVTotals(vm.selectedYear,vm.selectedMonth); vm.expandDatePicker = !vm.expandDatePicker">search</button></div></div></div><div class=right-panel-csv-dashboard ng-class="{minimized : !vm.fullscreen}"><div class=r-p-top><div id=csv-report-loading-box ng-show="vm.requestFlag && vm.csvFetches.length == 0"><div class=csv-report-loader><h4 class=loader-txt>Downloading and Processing Data...</h4><loading></loading></div></div><div class=card-container-wrapper ng-show=vm.csvFetches><div class=card-box-header><h4 class=widget-title-text>CSV Report</h4><div style="display:flex; align-items: center"><div class=search-input-box><input id=cc-search-input class=cc-search-input type=text placeholder="Search for company" ng-model=vm.queryWord ng-keypress=vm.enterKeyPress($event)> <span id=search-box-icon class="glyphicon glyphicon-search" aria-hidden=true></span></div><span id=search-box-icon ng-show=vm.fullscreen ng-click="vm.fullscreen = false" class="glyphicon glyphicon-menu-left" aria-hidden=true></span> <span id=search-box-icon ng-show=!vm.fullscreen ng-click="vm.fullscreen = true" class="glyphicon glyphicon-menu-right" aria-hidden=true></span></div></div><div class=card-container ng-show=vm.csvFetches><div class=csv-total-card ng-repeat="data in vm.csvFetches | orderBy : \'companyCode\'" ng-click="vm.cardFocus(data.companyCode); vm.selectedData = data"><div class=csv-small-card ng-class="{cardFocused : vm.hiddenCards[data.companyCode]}"><div ng-if="data.logo && data.logo.hasOwnProperty(\'data\')" class=csv-cc-icon-box>logo</div><div ng-if="!data.logo.hasOwnProperty(\'data\')" class=csv-cc-icon-box></div><div class=csv-small-card-detail-box><h4 class=card-companyCode-text ng-class="{cardFocused : vm.hiddenCards[data.companyCode]}">{{data.companyCode}}</h4><h3 class=card-total-text ng-class="{cardFocused : vm.hiddenCards[data.companyCode]}">{{vm.dollarfy(data.total)}}</h3></div></div></div></div></div></div><div class=r-p-main ng-show=!vm.fullscreen><div class=csv-report-summary-board ng-show=vm.csvFetches><div class=sm-widget-box><p class=sm-widget-title-txt>Invoice Period</p><p class=sm-widget-content-txt>{{vm.queryDate}}</p></div><div class=sm-widget-box><p class=sm-widget-title-txt>Invoice Count</p><p class=sm-widget-content-txt>{{vm.csvFetches.length}}</p></div><div class=sm-widget-box><p class=sm-widget-title-txt>Invoice Total</p><p class=sm-widget-content-txt>${{vm.dollarfy(vm.totalInvoicesSum)}}</p></div><div class=sm-widget-box><p class=sm-widget-title-txt>Create Date</p><p class=sm-widget-content-txt>{{vm.csvTimeStamp}}</p></div></div><div class=detailed-info-container ng-show=vm.csvFetches><div class=detail-box-head><div ng-if="vm.selectedData.logo && vm.selectedData.logo.hasOwnProperty(\'data\')" ng-style="vm.selectedData.logo.hasOwnProperty(\'data\') && vm.applyLogo(vm.selectedData.logo)" class=csv-cc-icon-box></div><div ng-if="!vm.selectedData.logo.hasOwnProperty(\'data\')" class=csv-cc-icon-box>logo</div><div class=detailed-header-box ng-show=vm.selectedData><h4 class=detailed-cc-text>{{ vm.companyNameMap[vm.selectedData.companyCode] ? vm.companyNameMap[vm.selectedData.companyCode] : vm.selectedData.companyCode}}</h4><h3 ng-show=vm.selectedData class=detailed-total-text>${{vm.dollarfy(vm.selectedData.total)}}</h3></div></div><div class=detail-box-main><div class=billingID-box><div class=billingID-detail-box ng-repeat="billingAccount in vm.selectedData.billingIDs"><p class=billingID-text>{{billingAccount.billingID}}</p><p class=billingID-subtotal>${{vm.dollarfy(billingAccount.total)}}</p></div></div></div></div></div></div></div>');
$templateCache.put('app/dashboard/dashboard.html','<!-- <bw-topnavbar></bw-topnavbar> --><bw-navbar></bw-navbar><div ui-view class="anim-in-out anim-fade" id=fade-route data-anim-speed=500 ng-if=vm.isChrome></div><div ui-view class=anim-out-setup data-anim-speed=500 ng-if=!vm.isChrome></div><!-- <div ui-view class="anim-in-out anim-fade" data-anim-speed="100"></div> -->');
$templateCache.put('app/devices/confirmparentdecommission.html','<div class="row reset-form"><div class=modal-header><h4>Parent Device</h4></div><div class=modal-body id=modal-body style=color:white;font-weight:300><span>This device is a parent to the children:</span><br><br><div ng-repeat="item in vm.children track by $index">{{item}}</div><br><span>Would you like to proceed with decommission?</span></div><div class=modal-footer><button class="btn btn-primary" type=button ng-click="vm.close(\'YES\')">YES</button> <button class="btn btn-primary" type=button ng-click="vm.close(\'NO\')">NO</button></div></div>');
$templateCache.put('app/devices/decommissionconfirmation.html','<div class="row reset-form"><div class=modal-header><h4>Your change request is being approved.</h4></div><div class=modal-body id=modal-body style=color:white;font-weight:300>An email will be sent with the status of your request.</div><div class=modal-footer><button class="btn btn-primary" type=button ng-click=vm.close()>OK</button></div></div>');
$templateCache.put('app/devices/device_report.html','<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" id=cloudbilling><div class="container container-top-ticket shadow-strong" style="background-color: #2f2f2f;padding: 3px;padding-top: 8px;padding-right: 2px;width:100%;border: 1px solid #606060" id=single-device><div class=loader ng-show=vm.modalLoading><div class="css-loading css-loading--double"></div></div><button id=show_peak class=report-category type=button ng-click="vm.showPeaks(vm.singleChartID, \'single\')" style="padding: 3px;background-color: #4e4e4e;border: 1px solid #999;margin: 0px;float: right;margin-left: 10px !important;margin-right: 20px !important">{{vm.chart.peakText}}</button><h3 class=panel-title style="float:right;margin-top: 4px" ng-show="vm.reportType == \'Interface\'">Interface Speed - {{vm.chart.connectionSpeed}} Mbps</h3><!-- <button id="show_series" class="report-category" type="button" ng-click="vm.showSeries(vm.singleChartID, \'single\')"\n            style="padding: 3px;background-color: #4e4e4e;border: 1px solid #999;margin: 0px !important;float: right;margin-left: 10px !important;"\n            ng-show="vm.reportType == \'Selected Devices\' && vm.multipleSelectedDevices && !vm.showInterfaces && vm.showSelectedDevices">{{vm.chart.averageText}}</button> --><!-- <button id="show_legend" class="report-category" type="button" ng-click="vm.showLegend(vm.singleChartID, \'single\')"\n            style="padding: 3px;background-color: #4e4e4e;border: 1px solid #999;float:right;"\n            ng-show="vm.reportType == \'Selected Devices\'">{{vm.chart.legendText}}</button> --><div class=reset-hourlychart-contain ng-if="vm.resetReport && !vm.hideZoom" ng-click=vm.resetReportConfig()><div class=reset-hourlychart>Reset Zoom</div></div><div class=exit-x ng-click=vm.close()>X</div><div ng-if=vm.destroyChart ng-style=vm.chartHeight></div><div class=panel-body ng-if=!vm.destroyChart style="margin-top: 27px"><highchart id=single-device-chart config=vm.configModal></highchart></div><div class=toggle-billing style="margin-bottom: 0px;padding-top: 0px"><p class=billing-details ng-click="vm.tableConfig.monthToggle = !vm.tableConfig.monthToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm[chartID].monthToggle}"></i></p></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" id=device-report-stats><div class="panel-body well cloudbill-datatable-contain" style=min-height:0px><div class="table-responsive device-datatable-inner-contain" ng-class="{\'toggle-device-table-on\' : vm.tableConfig.monthToggle}" ng-if="vm.tableConfig.reportType != \'Interface\'"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.dtInstanceStatsModal dt-options=vm.dtOptionsStatsModal id=device-not-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>{{vm.tableConfig.header1}}</th><th>{{vm.tableConfig.header2}}</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstanceStats filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceStats filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.stats track by $index"><td></td><td>{{item[0]}}</td><td>{{item[1]}} {{vm.tableConfig.dataType}}</td></tr></tbody></table></div><div class="table-responsive device-datatable-inner-contain" ng-class="{\'toggle-device-table-on\' : vm.tableConfig.monthToggle}" ng-if="vm.tableConfig.reportType == \'Interface\'"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.dtInstanceStats dt-options=vm.dtOptionsStats id=device-not-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Date</th><th>Average Usage In</th><th>Average Usage Out</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstanceStats filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceStats filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceStats filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.stats"><td></td><td>{{item[0]}}</td><td>{{item[1]}}{{vm.tableConfig.unit}}</td><td>{{item[2]}}{{vm.tableConfig.unit}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/devices/devices.html','<div class="container container-top col-lg-12 col-md-12 col-sm-12 col-xs-12" id=device-page style=padding-left:50px;padding-right:50px><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding sku-list"><div class="panel panel-default left-report-panel interface-panel webkit-scroll device-shadow" style=height:600px><div class="panel-heading brd-bottom" style="background-color:rgba(0,0,0,.2) !important; text-align:center"><h3 class=panel-title>Device Navigator</h3></div><div class="panel-body list-container"><div class=panel-loader ng-show=vm.loadingSKU style=text-align:center><div class="css-loading css-loading--double" style=top:240px></div></div><uib-accordion close-others=true id=device-accordion><div uib-accordion-group class=panel-default heading="All Devices" is-open=true><div class=device-tables ng-repeat="(key, value) in vm.tableOfContents.allDevices" ng-click="vm.chooseContent(\'allDevices\', key)" style=color:white><div class=sku-title id={{vm.replaceSpace(key)}}><p class=device-contents style="width: 100%; margin: 0px">{{value.name}} <span style="float: right">{{value.count}}</span></p></div></div></div><div uib-accordion-group class=panel-default heading="Devices By SKU"><div class=device-tables ng-repeat="(key, value) in vm.tableOfContents.deviceBySKU" ng-click="vm.chooseContent(\'deviceBySKU\', key)" style=color:white><div class=sku-title id={{vm.replaceSpace(key)}}><p class=device-contents style="width: 100%; margin: 0px">{{value.name}} <span style="float: right">{{value.count}}</span></p></div></div></div><div uib-accordion-group class=panel-default heading="Devices By Class"><div class=device-tables ng-repeat="(key, value) in vm.tableOfContents.deviceByClass" ng-click="vm.chooseContent(\'deviceByClass\', key)" style=color:white><div class=sku-title id={{vm.replaceSpace(key)}}><p class=device-contents style="width: 100%; margin: 0px">{{value.name}} <span style="float: right">{{value.count}}</span></p></div></div></div><div uib-accordion-group class=panel-default heading="Devices By Location"><div class=device-tables ng-repeat="(key, value) in vm.tableOfContents.deviceByLocation" ng-click="vm.chooseContent(\'deviceByLocation\', key)" style=color:white><div class=sku-title id={{vm.replaceSpace(key)}}><p class=device-contents style="width: 100%; margin: 0px">{{value.name}} <span style="float: right">{{value.count}}</span></p></div></div></div></uib-accordion></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 device-table" style="padding-right: 0px !important;height: auto"><div class="well pd-top device-shadow" id=dev-table style="min-height: 600px"><div class=loader ng-show="vm.loadingDevices || vm.decommissionLoading || vm.loadingSKU || vm.assetLoading" style=margin-top:200px;position:absolute;margin-left:45%><div class="css-loading css-loading--double"></div></div><div class="col-xs-12 alert-contain" ng-if="vm.alerts.length != 0" style="position: absolute;z-index: 1001"><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=vm.close_notice($index) style="background-color: rgb(47, 93, 52)">{{alert.msg}}</div></div><!-- <button id="run-device-button" class="report-category title-format" type="button" ng-if="vm.burwoodUser === true" ng-click="vm.setToMaintenance()">Set To Maintenance Mode</button> --><div class=no-results ng-show="vm.tableOfContents[vm.chosenTable][vm.chosenContent].count == 0 && !vm.noMonitoringData"><p>Sorry, no results.</p></div><div class=no-results ng-show=vm.noMonitoringData><p>No monitoring data available for this device or component.</p></div><div class=table-responsive style="padding-bottom: 5px;overflow: visible" ng-if="vm.chosenContent && !vm.loadingDevices && vm.tableOfContents[vm.chosenTable][vm.chosenContent].count != 0 && vm.tableOfContents[vm.chosenTable][vm.chosenContent].name === \'Devices Not In Contract\' && !vm.noMonitoringData"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.dtInstanceDeviceList dt-options=vm.dtOptionsDeviceList id=device-table><thead><tr><th class="nosort notexport" style=width:22px><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th class=notexport style=width:50px ng-click=vm.runSelectedDevices(vm.selectKey)>{{vm.selectMessage}}</th><th style=width:50px>Expand Parent</th><th>Device Name</th><th>Class</th><th>IP Address</th><th>State</th><th>Location</th><th>Availability</th><th class=notexport>Properties</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstanceDeviceList filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceDeviceList filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceDeviceList filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceDeviceList filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceDeviceList filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceDeviceList filter-type=text></th><th></th></tr></tfoot><tbody><tr class=device-row ng-class=\'{"toggle-device-border":$first}\' ng-repeat="item in vm.deviceList[vm.chosenContent]" ng-click="vm.chooseDevice(item.u_sciencelogic_id, item.name); vm.toggleBorder($event)"><td></td><td style=width:27px><input type=checkbox class=form-control style="z-index:1000;width: 16px;margin: -4px;margin-left: 10px" ng-model=vm.checkedDevice[item.name] ng-click=$event.stopPropagation() ng-change="vm.checkDevice(item.name, item.u_sciencelogic_id, item.sys_id)"></td><td ng-if=item.children ng-click="vm.expandParent(item, \'\');click = !click" ng-init="click = false"><div ng-class="{\'expand-parent\': item.children}"><i class="fas fa-angle-double-right fa-lg no-focus" ng-class="{\'turn-down\': click}" ng-click="click = !click"></i></div></td><td ng-if=!item.children></td><td><a style="z-index: 100" ng-href="{{\'https://bms.burwood.com/em7/index.em7?exec=device_summary&did=\' + item.u_sciencelogic_id.replace(\',\', \'\')}}" target=_blank class=em7-icon>EM7</a>{{item.name}}</td><td>{{item.sys_class_name}}</td><td>{{item.ip_address}}</td><td>{{vm.sl_states[item.sl_state]}}</td><td>{{item.location.display_value}}</td><td>{{item.sl_availability}}</td><td><i class="fas fa-wrench" ng-click=vm.openDeviceProperties(item)></i></td></tr></tbody></table></div><div class="table-responsive webkit-scroll" style="padding-bottom: 5px;overflow: visible" ng-if="vm.chosenContent && !vm.loadingDevices && vm.tableOfContents[vm.chosenTable][vm.chosenContent].count != 0 && vm.tableOfContents[vm.chosenTable][vm.chosenContent].name != \'Devices Not In Contract\' && !vm.noMonitoringData"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.dtInstanceDeviceList dt-options=vm.dtOptionsDeviceList id=device-table><thead><tr><th class="nosort notexport" style=width:22px><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th class=notexport style=width:50px ng-click=vm.runSelectedDevices(vm.selectKey)>{{vm.selectMessage}}</th><th style=width:50px>Expand Parent</th><th>Device Name</th><th>Class</th><th>Location</th><th>IP Address</th><th>State</th><th>Availability</th><th class=notexport>Properties</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstanceDeviceList filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceDeviceList filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceDeviceList filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceDeviceList filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceDeviceList filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceDeviceList filter-type=text></th><th></th></tr></tfoot><tbody><tr class=device-row ng-class=\'{"toggle-device-border":$first}\' ng-repeat="item in vm.deviceList[vm.chosenContent]" ng-click="vm.chooseDevice(item.cmdb_u_sciencelogic_id, item.cmdb_name); vm.toggleBorder($event)"><td></td><td style=width:60px><input type=checkbox class=form-control style="z-index:1000;width: 16px;margin: -4px;margin-left: 10px" ng-model=vm.checkedDevice[item.cmdb_name] ng-click=$event.stopPropagation() ng-change="vm.checkDevice(item.cmdb_name, item.cmdb_u_sciencelogic_id, item.sys_id)"></td><td ng-if=item.children ng-click="vm.expandParent(item, \'cmdb_\');click = !click" ng-init="click = false"><div ng-class="{\'expand-parent\': item.children}"><i class="fas fa-angle-double-right fa-lg no-focus" ng-class="{\'turn-down\': click}"></i></div></td><td ng-if=!item.children></td><td><a style="z-index: 100" ng-href="{{\'https://bms.burwood.com/em7/index.em7?exec=device_summary&did=\' + item.cmdb_u_sciencelogic_id.replace(\',\', \'\')}}" target=_blank class=em7-icon>EM7</a>{{item.cmdb_name}}</td><td>{{item.cmdb_sys_class_name}}</td><td>{{item.cmdb_location.display_value}}</td><td>{{item.cmdb_ip_address}}</td><td>{{vm.sl_states[item.sl_state]}}</td><td>{{item.sl_availability}}</td><td><i class="fas fa-wrench" ng-click=vm.openDeviceProperties(item)></i></td></tr></tbody></table></div></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 vital-list" style="padding-right: 0px"><div class="panel panel-default left-report-panel interface-panel device-shadow webkit-scroll" id=vital-panel style=height:600px><div class="panel-heading brd-bottom"><h3 class=panel-title ng-if=!vm.showSelectedDevices style="width:200px;word-break: break-word">Device - {{vm.chosenDeviceName}}</h3><h3 class=panel-title ng-if="vm.multipleSelectedDevices && vm.showSelectedDevices">SELECTED DEVICES</h3><button class="report-category rep-cat-source" type=button ng-click="vm.showSelectedDevices = true;vm.showInterfaces = false" ng-if="vm.multipleSelectedDevices && !vm.showSelectedDevices" style="padding: 0px;padding-top: 1px;padding-bottom: 1px;letter-spacing: 0px;width: 115px">SELECTED DEVICES</button></div><div class="panel-heading brd-bottom" style="background-color: #3b4f46!important;padding: 7px;padding-left: 5%;border: none;border-bottom: 1px solid #b6b6b6 !important;height:67px" ng-if=!vm.showSelectedDevices><div style="text-align:left;display: inline-block"><div class=device-filter-title>SOURCE</div></div><div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding"><button class="report-category rep-cat-source" ng-class="{true: \'btn-clicked\', false: \'\'}[vm.showInterfaces == true]" type=button ng-click=vm.getInterface(vm.chosenDevice) style="height: 25px;font-size: 12px">Interface</button></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding"><button class="report-category rep-cat-source" ng-class="{true: \'btn-clicked\', false: \'\'}[vm.showInterfaces == false]" type=button ng-click="vm.showInterfaces = false" style="height: 25px;font-size: 12px">Metrics</button></div></div></div><div class="panel-body list-container webkit-scroll detail-pane" ng-class=\'{"env-height": !vm.hideEnv, "toggle-height": !vm.toggleConfig}\' style=height:auto;padding:0px><div class=panel-loader ng-show="vm.loadingBatch && !vm.noMonitoringData && !vm.showSelectedDevices" style="left: 45%; position:absolute; margin-top:95px"><div class="css-loading css-loading--double"></div></div><table class="table table-striped interface-list" width=35% cellspacing=0 ng-if="(vm.showSelectedDevices && vm.multipleSelectedDevices) || vm.showInterfaces === false"><tr class=interface-row ng-repeat="(key, value) in vm.selectedVitals" ng-click=vm.toggleBorder($event) style=color:white><td style=width:27px><input type=checkbox class=form-control style="z-index:1000;width: 16px;margin: -4px;margin-left: 10px" ng-model=vm.selectedVitals[key] ng-click=$event.stopPropagation()></td><td class=report-title style=text-align:center><strong style=margin-left:-23%>{{key}}</strong></td></tr></table><button ng-if="!vm.noInterface && vm.showInterfaces && !vm.showSelectedDevices" class="report-category rep-cat-source" ng-click=vm.interfaceSelect() style="height: 25px;font-size: 12px;color: white;width: 50%;margin-left: 25%;margin-top: 10px !important;margin-bottom: 10px !important;background-color: #3f3f3f">{{vm.interfaceSelectAll}}</button><table class="table table-striped interface-list" width=35% cellspacing=0 ng-if="vm.showInterfaces && !vm.showSelectedDevices"><tr class=interface-row ng-class=\'{"toggle-device-border":$first}\' ng-repeat="(key,val) in vm.interfaceData" ng-click=vm.toggleBorder($event) style=color:white><td style=width:27px><input type=checkbox class=form-control style="z-index:1000;width: 16px;margin: -4px;margin-left: 10px" ng-model=vm.interfaceData[key].selected ng-click=$event.stopPropagation()></td><td></td><td class=report-title ng-click="vm.getInterfaceReport(key.substring(key.lastIndexOf(\'/\') + 1))"><strong>{{val.alias || val.name}}</strong><br><p>{{val.hardwareDescription}}</p></td></tr></table></div></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 vital-list" style="padding-right: 0px"><div class="panel panel-default left-report-panel interface-panel device-shadow" id=vital-panel style="height: auto;min-height: 318px"><div class="panel-heading brd-bottom" style="text-align: center"><h3 class=panel-title>FILTERS</h3></div><div class=dev-report-category ng-class="{\'toggle-devfilter-min\': !vm.toggleConfig}" style="height: 206px;border-top: none;border-right: none;border-left: none;border-image: initial;border-bottom: 1px solid #b6b6b6 !important;;border-radius: 0px"><div class="panel-heading brd-bottom" style="background-color: #2c353f !important;padding: 0;border-bottom: 1px solid #b6b6b6 !important;padding: 7px;padding-left: 5%"><div style="text-align: left;display: inline-block;width: 100%;padding: 0px;margin-bottom:5px"><div class=device-filter-title>DATE</div></div><div style=height:65px><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"><input date-range-picker class="form-control date-picker" ng-class="{true: \'btn-clicked\', false: \'\'}[vm.dateRange == \'Custom\']" type=text placeholder="Custom Range" ng-model=vm.date style="height: 25px;width: 95%;display: inline-block;padding-left: 5px;padding-right: 0px;margin-bottom:10px"></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding"><button class="button-month rep-cat-date" ng-class="{true: \'btn-clicked\', false: \'\'}[vm.dateRange == \'This Month\']" id=thisMonth style="margin-left:-1px;height: 25px;font-size: 12px" type=button ng-click="vm.toggleTime(\'This Month\')">This Month</button></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding"><button class="button-month rep-cat-date" ng-class="{true: \'btn-clicked\', false: \'\'}[vm.dateRange == \'Last Month\']" id=lastMonth type=button ng-click="vm.toggleTime(\'Last Month\')" style="height: 25px;font-size: 12px">Last Month</button></div></div></div><div class="panel-heading brd-bottom" style="background-color: #3d2b2d !important;padding: 7px;padding-left: 5%;border-bottom:none;height:101px"><div style="display: inline-block"><div class=device-filter-title>TIME</div></div><div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding"><button class="report-category rep-cat-time" ng-class="{\'btn-clicked\': vm.hourlyFilter}" type=button ng-click="vm.hourlyFilter = !vm.hourlyFilter" style="margin-bottom: 2px;height: 25px;font-size: 12px">Hourly</button></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding"><button class="report-category rep-cat-time" ng-class="{\'btn-clicked\': vm.weekdayFilter}" type=button ng-click="vm.weekdayFilter = !vm.weekdayFilter" style="margin-left:2px;height: 25px;font-size: 12px">Weekday</button></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding"><button class="report-category rep-cat-time" ng-class="{\'btn-clicked\': vm.trendline}" type=button ng-click=vm.toggleTrendline() style="height: 25px;font-size: 12px">Trendline</button></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding"><button class="report-category rep-cat-time" ng-class="{\'btn-clicked\': vm.forecast}" type=button ng-click=vm.toggleForecast() style="margin-left:2px;height: 25px;font-size: 12px">Forecast</button></div></div></div></div><div style="text-align: center;padding-top: 12px"><button class="report-category rep-cat-time" type=button ng-click=vm.runAllReports() style="width: 20%;color: white;padding: 10px;background-color: #4a4a4a">RUN</button></div></div></div></div><!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">\n        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding vital-list" style="\n                background-color: #212121;\n                padding: 0px;\n                border-radius: 3px;\n                box-shadow: 0 4px 10px 0 #000;\n                color: white;\n                margin-bottom: 20px;\n                " ng-show="vm.chosenDevice" id="device-filters">\n            <div>\n                <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12" style="padding:1px">\n                    <div class="panel-heading brd-bottom" style="text-align: center;">\n                        <h3 class="panel-title" style="color: white;font-size: 14px;">METRIC<br>REPORT</h3>\n                    </div>\n                </div>\n                <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12"\n                    style="padding: 16px;background-color: #2c353f !important;">\n                    <div style="text-align: center;display: inline-block;width: 100%;margin-bottom:1px;">\n                        <div class="device-filter-title" style="color: white">DATE</div>\n                    </div>\n                </div>\n                <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"\n                    style="padding: 14px;background-color: #2c353f !important;"><input date-range-picker=""\n                        class="form-control date-picker ng-pristine ng-valid ng-isolate-scope ng-empty ng-touched"\n                        ng-class="{true: \'btn-clicked\', false: \'\'}[vm.dateRange == \'Custom\']" type="text"\n                        placeholder="Custom Range" ng-model="vm.date"\n                        style="height: 25px; width: 95%; display: inline-block; padding: 10px;" aria-invalid="false">\n                </div>\n                <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12"\n                    style="padding: 14px;background-color: #2c353f !important;"><button\n                        class="button-month rep-cat-date btn-clicked"\n                        ng-class="{true: \'btn-clicked\', false: \'\'}[vm.dateRange == \'This Month\']" id="thisMonth"\n                        style="margin-left: -1px; height: 25px; font-size: 12px" type="button"\n                        ng-click="vm.toggleTime(\'This Month\')">This Month</button></div>\n                <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12"\n                    style="padding: 14px;background-color: #2c353f !important;"><button\n                        class="button-month rep-cat-date"\n                        ng-class="{true: \'btn-clicked\', false: \'\'}[vm.dateRange == \'Last Month\']" id="lastMonth"\n                        type="button" ng-click="vm.toggleTime(\'Last Month\')" style="height: 25px; font-size: 12px">Last\n                        Month</button></div>\n                <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12" style="\n    padding: 14px;\n    color: white;\n    text-align: center;\n    background-color: #3d2b2d !important;\n    ">\n                    <div style="display: inline-block;text-align: right;padding: 3px">\n                        <div class="device-filter-title">FILTERS</div>\n                    </div>\n                </div>\n                <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12"\n                    style="padding: 14px;background-color: #3d2b2d !important;"><button\n                        class="report-category rep-cat-time" ng-class="{\'btn-clicked\': vm.hourlyFilter}" type="button"\n                        ng-click="vm.hourlyFilter = !vm.hourlyFilter"\n                        style="height: 25px; font-size: 12px; margin: 0px !important">Hourly</button></div>\n                <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12"\n                    style="padding: 14px;background-color: #3d2b2d !important;"><button\n                        class="report-category rep-cat-time" ng-class="{\'btn-clicked\': vm.weekdayFilter}" type="button"\n                        ng-click="vm.weekdayFilter = !vm.weekdayFilter"\n                        style="height: 25px; font-size: 12px; margin: 0px !important">Weekday</button></div>\n                <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12"\n                    style="padding: 14px;background-color: #3d2b2d !important;"><button\n                        class="report-category rep-cat-time" ng-class="{\'btn-clicked\': vm.trendline}" type="button"\n                        ng-click="vm.toggleTrendline()"\n                        style="height: 25px; font-size: 12px; margin: 0px !important">Trendline</button></div>\n                <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12"\n                    style="padding: 14px;background-color: #3d2b2d !important;"><button\n                        class="report-category rep-cat-time" ng-class="{\'btn-clicked\': vm.forecast}" type="button"\n                        ng-click="vm.toggleForecast()"\n                        style="margin-left:2px;height: 25px;font-size: 12px;margin: 0px !important">Forecast</button>\n                </div>\n                <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12"\n                    style="padding: 4px;padding-right: 7px;/* margin-left: 0px; */text-align: right;"><button\n                        class="report-category rep-cat-time" type="button" ng-click="vm.runAllReports()"\n                        style="/* width: 20%; */color: white;padding: 10px;background-color: #3b4f46;">RUN</button>\n                </div>\n            </div>\n        </div>\n    </div> --><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" ng-if=!vm.loadingBatch style="width: 101.2%;margin-left: -.55%"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 report-chart" id=cloudbilling ng-if=!vm.loadingBatch ng-repeat="rowID in [0,1,2,3]"><div class="row device-dashboard device-shadow" ng-repeat="(chartID, interface) in vm.chartRows[rowID]" ng-if=vm.rowControl[$index]><div class="well panel panel-default" style="min-height:400px;background-color: rgba(0,0,0,0) !important"><div class=no-results ng-if="(!vm[chartID].stats && !vm[chartID].loadingReport) || (vm[chartID].stats.length == 0 && !vm[chartID].loadingReport) || vm.noMonitoringData && !vm.loadingBatch"><h3 class=no-data-title>{{vm[chartID].title}}</h3><p>No monitoring data available for this device or component.</p></div><div class="panel-heading brd-bottom" style="text-align:center;min-height: 43px" ng-if="vm[chartID].stats && vm[chartID].stats.length != 0 && !vm[chartID].loadingReport && !vm.noMonitoringData && !vm.loadingBatch"><span class=expand-button ng-click="vm.expandReport(vm[chartID], {reportType: vm.reportType, dataType: vm.dataType, unit: vm.tableUnit, header1: vm.firstColumnName, header2: vm.secondColumnName}, true)"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span><span style="font-size: 12px;margin-top: 2px" ng-show="vm.reportType == \'Interface\'">UNIT</span><select id=int-unit class=form-control ng-show="vm.reportType == \'Interface\'" style="display: inline-block;\n                            margin-right: 10px;width:auto;height:20px;padding:0px;margin-left:10px" ng-model=vm[chartID].octet ng-change=vm.selectUnit(chartID) ng-options="option.id as option.name for option in vm.intUnits" required></select><button id=show_peak class=report-category type=button ng-click=vm.showPeaks(chartID) style="padding: 3px;background-color: #4e4e4e;border: 1px solid #999;margin: 0px !important;float: right;margin-left: 10px !important">{{vm[chartID].peakText}}</button><h3 class=panel-title style="margin-top: 4px" ng-show="vm.reportType == \'Interface\'">Interface Speed - {{vm[chartID].connectionSpeed}} Mbps</h3><!-- <button id="show_series" class="report-category" type="button" ng-click="vm.showSeries(chartID)"\n                            style="padding: 3px;background-color: #4e4e4e;border: 1px solid #999;margin: 0px !important;float: right;margin-left: 10px !important;"\n                            ng-show="vm.reportType == \'Selected Devices\' && vm.multipleSelectedDevices && !vm.showInterfaces && vm.showSelectedDevices">{{vm[chartID].averageText}}</button> --> <button id=show_legend class=report-category type=button ng-click=vm.showLegend(chartID) style="padding: 3px;background-color: #4e4e4e;border: 1px solid #999;margin: 0px !important;float:right" ng-show="vm.reportType == \'Selected Devices\'">{{vm[chartID].legendText}}</button></div><div class=panel-loader ng-show="vm[chartID].loadingReport && !vm.noMonitoringData && !vm.loadingBatch"><div class="css-loading css-loading--double"></div></div><div class=panel-body ng-if="vm[chartID].stats && vm[chartID].stats.length != 0 && !vm[chartID].loadingReport && !vm.noMonitoringData && !vm.loadingBatch"><highchart class=highcharts ng-attr-id={{chartID}} config=vm[chartID].config ng-if=!vm.showEnv></highchart><!-- <highchart id="highchart2" config="vm.envConfig" ng-if="vm.showEnv"></highchart> --></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" style="margin-bottom: 0px;padding-top: 10px" ng-if="vm[chartID].stats && vm[chartID].stats.length != 0 && !vm[chartID].loadingReport && !vm.noMonitoringData && !vm.loadingBatch"><p class=billing-details ng-click="vm[chartID].monthToggle = !vm[chartID].monthToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm[chartID].monthToggle}"></i></p></div></div><div class="panel-body well cloudbill-datatable-contain" ng-show="vm[chartID].stats && vm[chartID].stats.length != 0 && !vm[chartID].loadingReport && !vm.noMonitoringData" style=min-height:0px><div class="table-responsive device-datatable-inner-contain" ng-class="{\'toggle-device-table-on\' : vm[chartID].monthToggle}" ng-if="vm[chartID].stats && vm[chartID].stats.length > 0 && vm.reportType != \'Interface\' && !vm[chartID].loadingReport && !vm.noMonitoringData"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.dtInstanceStats dt-options=vm.dtOptionsStats id=device-not-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>{{vm.firstColumnName}}</th><th>{{vm.secondColumnName}}</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstanceStats filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceStats filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm[chartID].stats track by $index"><td></td><td>{{item[0]}}</td><td>{{item[1]}} {{vm.dataType}}</td></tr></tbody></table></div><div class="table-responsive device-datatable-inner-contain" ng-class="{\'toggle-device-table-on\' : vm[chartID].monthToggle}" ng-if="vm[chartID].stats && vm[chartID].stats.length > 0 && vm.reportType == \'Interface\' && !vm[chartID].loadingReport && !vm.noMonitoringData"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.dtInstanceStats dt-options=vm.dtOptionsStats id=device-not-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Date</th><th>Average Usage In</th><th>Average Usage Out</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstanceStats filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceStats filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceStats filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm[chartID].stats"><td></td><td>{{item[0]}}</td><td>{{item[1]}}{{vm.tableUnit}}</td><td>{{item[3]}}{{vm.tableUnit}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" style="text-align: center;margin-bottom: 30px"><div class=show-more ng-show="vm.rowLength > vm.rowControl.length && vm.showInterfaces" ng-click=vm.showReportRow()><i class="fas fa-chevron-down"></i></div></div></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 quarter-width"></div>');
$templateCache.put('app/devices/getRequestedByDate.html','<div class="container container-top-ticket shadow-strong"><form name=decomForm ng-submit=vm.close()><div class="well incident-wrapper" id=cloudbill-invoice><div class="dashboard-title cloudbill-title">SELECT REQUESTED BY DATE FOR DECOMMISSION</div><div class=row><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel first-panel"><div class=form-group><div class=col-xs-3><label for=end_date style=font-size:12px>REQUESTED BY DATE *</label></div><div class=col-xs-9><p class=input-group><input id=end_date class=form-control ng-model=vm.requested_by_date placeholder="" required> <input id=end_date2 class=form-control type=hidden datetime-picker="MM/dd/yyyy HH:mm" ng-model=vm.requested_by_date is-open=vm.dateToggle.requested_by_date> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.openCalendar($event, \'requested_by_date\')"><i class="fa fa-calendar"></i></button> </span></p></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=Contact>Contact</label></div><div class=col-xs-9><p class=input-group><input type=text class=form-control id=status-contact ng-model=vm.caller_name placeholder="" required> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.contact()><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=caller_id ng-model=vm.caller_id placeholder="" required></div><div class=clearfix></div></div></div></div></div></div><div class=row><div class=form-group style="margin-bottom: 30px;margin-top: 30px"><div class=col-xs-12 style="text-align: center"><button type=submit class="btn btn-primary btn-block" ng-disabled="maintenanceForm.$invalid || vm.loading">REQUEST DECOMMISSION</button></div><div class=clearfix></div></div></div></div></form></div>');
$templateCache.put('app/devices/interface_template.html','<span>TEST</span>');
$templateCache.put('app/devices/maintenance.html','<div class="container container-top-ticket shadow-strong"><form name=maintenanceForm ng-submit=vm.create_request()><div class=col-xs-12 ng-show=vm.error><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=vm.close_notice($index) style="background-color: rgb(116, 116, 116);left:0;right:0;position:absolute;margin-top:6px">{{alert.msg}}</div></div><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class="well incident-wrapper" id=cloudbill-invoice><div class="dashboard-title cloudbill-title">CHANGE REQUEST FOR DEVICES SET TO MAINTENANCE</div><div class=row><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel first-panel"><div class=form-group><div class=col-xs-3><label for=invoice-name style=font-size:12px>NAME</label></div><div class=col-xs-9><input type=text class=form-control id=invoice-name ng-model=vm.username placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=start_date style=font-size:12px>PLANNED START DATE *</label></div><div class=col-xs-9><p class=input-group><input id=start_date class=form-control ng-model=vm.request.start_date placeholder=""> <input id=start_date2 class=form-control type=hidden datetime-picker="MM/dd/yyyy HH:mm" ng-model=vm.request.start_date is-open=vm.dateToggle.start_date> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.openCalendar($event, \'start_date\')"><i class="fa fa-calendar"></i></button> </span></p></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel"><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>COMPANY</label></div><div class=col-xs-9><input type=text class=form-control id=invoice-total ng-model=vm.company placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=end_date style=font-size:12px>PLANNED END DATE *</label></div><div class=col-xs-9><p class=input-group><input id=end_date class=form-control ng-model=vm.request.end_date placeholder=""> <input id=end_date2 class=form-control type=hidden datetime-picker="MM/dd/yyyy HH:mm" ng-model=vm.request.end_date is-open=vm.dateToggle.end_date> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.openCalendar($event, \'end_date\')"><i class="fa fa-calendar"></i></button> </span></p></div><div class=clearfix></div></div></div></div></div></div><div class=row><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div class=form-group><div class=col-xs-12><label for=maintenance-description style=font-size:12px>DESCRIPTION *</label><textarea class=form-control style="height: 120px" id=maintenance-description ng-model=vm.request.short_description ng-required=true>\n                                                        </textarea></div><div class=clearfix></div></div></div></div></div><div class=row><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div class=form-group><div class=col-xs-12><div class=maintenance-header>DEVICES TO BE SET TO MAINTENANCE MODE</div><div ng-repeat="(key, device) in vm.maintenanceDevices" style=color:white;text-align:center;font-size:12px><div>{{key}}</div></div></div><div class=clearfix></div></div></div></div></div><div class=row><div class=form-group style="margin-bottom: 30px;margin-top: 30px"><div class=col-xs-12 style="text-align: center"><button type=submit class="btn btn-primary btn-block" ng-disabled="maintenanceForm.$invalid || vm.loading">CREATE CHANGE REQUEST</button></div><div class=clearfix></div></div></div></div></form></div>');
$templateCache.put('app/devices/singledevice.html','<div class="container container-top-ticket shadow-strong" style="background-color: #838383;padding: 3px;padding-top: 8px;padding-right: 2px" id=single-device><form name=singledeviceForm ng-submit=vm.editDevice() style="background-color: #6b6b6b"><!-- <div class="col-xs-12" ng-show="vm.error">\n            <div uib-alert ng-repeat="alert in vm.alerts" class="alert-{{alert.type}}" close="vm.close_notice($index)"\n                style="background-color: rgb(116, 116, 116);left:0;right:0;position:absolute;margin-top:6px">\n                {{alert.msg}}</div>\n        </div> --><!-- <div class="panel-loader" ng-show="vm.loading">\n            <div class="css-loading css-loading--double"></div>\n        </div> --><div class="well incident-wrapper" id=exTab3 ng-show=!vm.loading style="padding-top: 10px;border-radius: 3px"><div class="dashboard-title cloudbill-title" style="margin-top: -12px">PROPERTIES</div><ul class="nav nav-pills" style="margin-left: 25px"><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'general\']"><a ng-click="vm.tabView = \'general\'" data-toggle=tab>GENERAL</a></li><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'interface\']" ng-if="vm.burwoodUser === true"><a ng-click="vm.tabView = \'interface\'" data-toggle=tab>INTERFACE</a></li><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'severity\']" ng-if="vm.burwoodUser === true"><a ng-click="vm.tabView = \'severity\'" data-toggle=tab>SEVERITY</a></li><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'threshold\']"><a ng-click="(vm.tabView = \'threshold\'); vm.refreshSliders()" data-toggle=tab>THRESHOLD</a></li></ul><div class="tab-content clearfix"><div class="tab-pane active report-shadow" id=1b ng-show="vm.tabView === \'general\'"><div class=row><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel first-panel"><div class=form-group><div class=col-xs-3><label for=device-name style=font-size:12px>DEVICE NAME</label></div><div class=col-xs-9><input type=text class=form-control id=device-name ng-model=vm.deviceUpdate.name placeholder="" ng-disabled="vm.burwoodUser === false"></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=device-name style=font-size:12px>AVAILABILITY</label></div><div class=col-xs-9><input type=text class=form-control id=device-active ng-model=vm.active placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=device-name style=font-size:12px>APPLICATIONS</label></div><div class=col-xs-9><input type=text class=form-control id=device-applications ng-model=vm.device.applications placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=device-name style=font-size:12px>AUTO CLEAR</label></div><div class=col-xs-9><input type=text class=form-control id=device-auto_clear ng-model=vm.device.auto_clear placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=device-name style=font-size:12px>AUTO UPDATE</label></div><div class=col-xs-9><input type=text class=form-control id=device-auto_update ng-model=vm.device.auto_update placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=device-name style=font-size:12px>CHILD DEVICES</label></div><div class=col-xs-9><input type=text class=form-control id=device-child_devices ng-model=vm.device.child_devices placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=device-name style=font-size:12px>CRITICAL PING</label></div><div class=col-xs-9><input type=text class=form-control id=device-critical_ping ng-model=vm.device.critical_ping placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=device-name style=font-size:12px>DAILY PORT SCAN</label></div><div class=col-xs-9><input type=text class=form-control id=device-daily_port_scan ng-model=vm.device.daily_port_scan placeholder="" disabled></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel"><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>DATE ADDED</label></div><div class=col-xs-9><input type=text class=form-control id=device-date_added ng-model=vm.device.date_added placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>EDIT DATE</label></div><div class=col-xs-9><input type=text class=form-control id=device-edit_date ng-model=vm.device.edit_date placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>DISABLE ASSET UPDATE</label></div><div class=col-xs-9><input id=disable_asset_update class=form-control ng-model=vm.device.disable_asset_update placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>IP ADDRESS</label></div><div class=col-xs-9><input id=device-ip class=form-control ng-model=vm.device.ip placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>LAST POLL</label></div><div class=col-xs-9><input id=last_poll class=form-control ng-model=vm.device.last_poll placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>PARENT DEVICE</label></div><div class=col-xs-9><input id=parent_device class=form-control ng-model=vm.device.parent_device placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>STATE</label></div><div class=col-xs-9><input id=device-state class=form-control ng-model=vm.device.state placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>UPDATED BY</label></div><div class=col-xs-9><input id=updated_by class=form-control ng-model=vm.updated_by placeholder="" disabled></div><div class=clearfix></div></div></div></div></div></div><div class=row><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div class=form-group><div class=col-xs-12><label for=singledevice-description style=font-size:12px>ASSOCIATED EVENTS</label><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.total_result == 0"><p>No Associated Events For This Device</p></div><div class=table-responsive ng-if="!vm.loading && vm.total_result > 0"><table class="table table-striped" datatable=ng dt-instance=vm.dtInstanceSingle dt-options=vm.dtOptionsSingle dt-column-defs=vm.dtColumnDefsSingle width=100% cellspacing=0 id=singleEventTable><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Priority</th><th>Device Name</th><th>Event Message</th><th>Acknowledged</th><th>Ticket</th><th>Last Detected</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstanceSingle filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceSingle filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceSingle filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceSingle filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceSingle filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="event in vm.events track by $index"><td></td><td><span style=position:absolute;margin-left:7px;margin-top:1.5px>{{vm.severity[event.severity] | limitTo:1}}{{(vm.severity[event.severity] == \'\')?\'0\':\'\'}}</span> <img ng-src="assets/img/icon/network_{{vm.severity[event.severity] | limitTo:1}}.png" width=20 height="" style=height:auto><div style=position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px tooltips tooltip-template={{vm.severityWord[event.severity]}} tooltip-side=right></div></td><td>{{event.aligned_resource_name}}</td><td><a ng-href="{{\'https://bms.burwood.com/em7/index.em7?exec=device_summary&did=\' + event.aligned_resource}}" target=_blank>{{ event.message | limitTo: 100 }}{{event.message.length > 100 ? \'...\' : \'\'}}</a></td><td>{{ event.user_ack}}</td><td><div ng-click="vm.goToTicket(null, event.force_ticket_uri.split(\'=\').slice(2).join(\'=\'))">{{ event.ext_ticket_ref}}</div></td><td>{{ (event.date_active > 0 ? event.date_active : event.date_first)*1000 | date:\'medium\'}}</td></tr></tbody></table></div></div><div class=clearfix></div></div></div></div></div><div class=row><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div class=form-group><div class=col-xs-12><label for=singledevice-description style=font-size:12px>DETAILS</label><textarea class="form-control webkit-scroll" style="padding: 0;height: 135px;text-align: center;padding-top: 10px" id=singledevice-detail ng-model=vm.detail disabled>\n                                        </textarea></div><div class=clearfix></div></div></div></div></div><div class=row><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div class=form-group><div class=col-xs-12><label for=singledevice-description style=font-size:12px>EXISTING NOTES</label><textarea class="form-control webkit-scroll" style="padding: 0;height: 135px;text-align: center;padding-top: 10px" id=singledevice-notes ng-model=vm.notes disabled>\n                                        </textarea></div><div class=clearfix></div></div></div></div></div><div class=row><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div class=form-group><div class=col-xs-12><label for=singledevice-description style=font-size:12px>ADD NOTES</label><textarea class="form-control webkit-scroll" style="padding: 0;height: 135px;;padding-top: 10px;padding-left:20px" id=singledevice-note ng-model=vm.note>\n                                            </textarea></div><div class=clearfix></div></div></div></div></div></div><div class="tab-pane active report-shadow" id=5b ng-show="vm.tabView === \'interface\'" ng-if="vm.burwoodUser === true"><div class=row><div class=basic-info-contain ng-class="{\'three-quarter-width\' : vm.tabView === \'interface\'}"><!-- <div class="basic-info-contain"> --><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><uib-accordion close-others=true id=device-accordion-interface><div ng-repeat="interface in vm.interfaces"><div uib-accordion-group class=panel-default heading="{{interface.name}} - {{interface.alias}}" style="margin-bottom: 3px"><p class=int-title>Interface Name: <span class=int-value>{{ interface.name}}</span></p><p class=int-title>Alias: <span class=int-value>{{ interface.alias}}</span></p><p class=int-title>MAC Address: <span class=int-value>{{ interface.ifPhysAddress}}</span></p><p class=int-title>Description: <span class=int-value>{{ interface.ifDescr}}</span></p><p class=int-title>Operational/Admin Status: <span class=int-value>{{ vm.opStatus[interface.ifOperStatus]}}/{{ vm.opStatus[interface.ifAdminStatus]}}</span></p><p class=int-title>Connection Speed: <span class=int-value><input class=int-input ng-model=interface.ifSpeed> Mbps</span></p><p class=int-title>Collect State: <span class=int-value><select class="form-control int-select" ng-model=interface.state ng-options="option.id as option.name for option in vm.enabled"></select></span></p><p class=int-title>Collect Frequency: <span class=int-value><input class=int-input ng-model=interface.poll_rate> Minutes</span></p><p class=int-title>Index: <span class=int-value>{{ interface.ifIndex}}</span></p><p class=int-title>Port: <span class=int-value>{{ interface.ifport}}</span></p><p class=int-title>Rollover: <span class=int-value><select class="form-control int-select" ng-model=interface.rollover_alert ng-options="option.id as option.name for option in vm.enabled"></select></span></p><p class=int-title>Alerts: <span class=int-value><select class="form-control int-select" ng-model=interface.alerts ng-options="option.id as option.name for option in vm.enabled"></select></span></p><p class=int-title>Discards: <span class=int-value><select class="form-control int-select" ng-model=interface.collect_discards ng-options="option.id as option.name for option in vm.enabled"></select></span></p><p class=int-title>Packets: <span class=int-value><select class="form-control int-select" ng-model=interface.collect_packet_metrics ng-options="option.id as option.name for option in vm.enabled"></select></span></p></div></div></uib-accordion></div></div></div></div><div class="tab-pane active report-shadow" id=2b ng-show="vm.tabView === \'severity\'" ng-if="vm.burwoodUser === true"><div class=row><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="text-align: center"><div for=singledevice-description style="font-size:14px;margin-bottom:25px;color:white;letter-spacing: 2px">EVENT SEVERITY CONFIGURATION</div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-4"><div class=form-group><div class=col-xs-5><label for=event-name style=font-size:12px>AVAILABILITY</label></div><div class=col-xs-7><select class=form-control ng-model="vm.deviceUpdate[\'c-AVAILABILITY\']" ng-options="option.id as option.name for option in vm.prioritiesAll"></select></div><div class=clearfix></div></div><div ng-repeat="category in vm.priorityConfig1"><div class=form-group><div class=col-xs-5><label for=event-name style=font-size:12px>{{category.replace("c-", "")}}</label></div><div class=col-xs-7><select class=form-control ng-model=vm.deviceUpdate[category] ng-options="option.id as option.name for option in vm.priorities"></select></div><div class=clearfix></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-4"><div ng-repeat="category in vm.priorityConfig2"><div class=form-group><div class=col-xs-5><label for=event-name style=font-size:12px>{{category.replace("c-", "")}}</label></div><div class=col-xs-7><select class=form-control ng-model=vm.deviceUpdate[category] ng-options="option.id as option.name for option in vm.priorities"></select></div><div class=clearfix></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-4"><div ng-repeat="category in vm.priorityConfig3"><div class=form-group><div class=col-xs-5><label for=event-name style=font-size:12px>{{category.replace("c-", "")}}</label></div><div class=col-xs-7><select class=form-control ng-model=vm.deviceUpdate[category] ng-options="option.id as option.name for option in vm.priorities"></select></div><div class=clearfix></div></div></div></div></div></div></div></div><div class="tab-pane active report-shadow" id=3b ng-show="vm.tabView === \'threshold\'"><div class=row id=threshold-row><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel first-panel"><div class=form-group><div class=col-xs-6><label for=threshold-name style=font-size:12px>AVAILABILITY</label></div><div class=col-xs-6><input type=text class=form-control id=threshold-avail ng-model=vm.threshold.common.avail placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=threshold-name style=font-size:12px>AVAILABLE PING COUNT</label></div><div class=col-xs-6><input type=text class=form-control id=threshold-avail_ping_count ng-model=vm.threshold.common.avail_ping_count placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=threshold-name style=font-size:12px>AVAILABLE PING COUNT PERCENT</label></div><div class=col-xs-6><input type=text class=form-control id=threshold-avail_ping_req_pct ng-model=vm.threshold.common.avail_ping_req_pct placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=threshold-name style=font-size:12px>BANDWIDTH</label></div><div class=col-xs-6><input type=text class=form-control id=threshold-bandw ng-model=vm.threshold.common.bandw placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=threshold-name style=font-size:12px>BANDWIDTH DAILY</label></div><div class=col-xs-6><input type=text class=form-control id=threshold-bandw_daily ng-model=vm.threshold.common.bandw_daily placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=threshold-name style=font-size:12px>BANDWIDTH HOURLY</label></div><div class=col-xs-6><input type=text class=form-control id=threshold-bandw_hourly ng-model=vm.threshold.common.bandw_hourly placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=threshold-name style=font-size:12px>COMPONENT PURGE TIMEOUT</label></div><div class=col-xs-6><input type=text class=form-control id=threshold-component_purge_timeout ng-model=vm.threshold.common.component_purge_timeout placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=threshold-name style=font-size:12px>COMPONENT VANISH TIMEOUT (MIN)</label></div><div class=col-xs-6><input type=text class=form-control id=threshold-component_vanish_timeout_mins ng-model=vm.threshold.common.component_vanish_timeout_mins placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=threshold-name style=font-size:12px>INTERFACE INVENTORY TIMEOUT</label></div><div class=col-xs-6><input type=text class=form-control id=threshold-interface_inventory_timeout ng-model=vm.threshold.common.interface_inventory_timeout placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=customer-code style=font-size:12px>LATENCY</label></div><div class=col-xs-6><input type=text class=form-control id=threshold-latency ng-model=vm.threshold.common.latency placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=customer-code style=font-size:12px>LOGAGE</label></div><div class=col-xs-6><input type=text class=form-control id=threshold-logage ng-model=vm.threshold.common.logage placeholder="" disabled></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel"><div class=form-group><div class=col-xs-6><label for=customer-code style=font-size:12px>MAX INTERFACE INVENTORY COUNT</label></div><div class=col-xs-6><input id=max_interface_inventory_count class=form-control ng-model=vm.threshold.common.max_interface_inventory_count placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=customer-code style=font-size:12px>MAX LOG</label></div><div class=col-xs-6><input id=threshold-maxlog class=form-control ng-model=vm.threshold.common.maxlog placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=customer-code style=font-size:12px>PERFORMACE</label></div><div class=col-xs-6><input id=perf class=form-control ng-model=vm.threshold.common.perf placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=customer-code style=font-size:12px>PING PACKET SIZE</label></div><div class=col-xs-6><input id=ping_packet_size class=form-control ng-model=vm.threshold.common.ping_packet_size placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=customer-code style=font-size:12px>PROCESS RUN THRESHOLD HIGH</label></div><div class=col-xs-6><input id=threshold-process_run_thresh_high class=form-control ng-model=vm.threshold.common.process_run_thresh_high placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=customer-code style=font-size:12px>PROCESS RUN THRESHOLD LOW</label></div><div class=col-xs-6><input id=threshold-process_run_thresh_low class=form-control ng-model=vm.threshold.common.process_run_thresh_low placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=customer-code style=font-size:12px>RECORDS CONFIGURATION</label></div><div class=col-xs-6><input id=threshold-records_config class=form-control ng-model=vm.threshold.common.records_config placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=customer-code style=font-size:12px>RECORDS JOURNAL</label></div><div class=col-xs-6><input id=threshold-records_journal class=form-control ng-model=vm.threshold.common.records_journal placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=customer-code style=font-size:12px>RECORDS PERFORMANCE HOURLY</label></div><div class=col-xs-6><input id=threshold-records_perf_hourly class=form-control ng-model=vm.threshold.common.records_perf_hourly placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=customer-code style=font-size:12px>ROLLOVER MAX</label></div><div class=col-xs-6><input id=threshold-rollover_max class=form-control ng-model=vm.threshold.common.rollover_max placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-6><label for=customer-code style=font-size:12px>ROLLOVER ORDER</label></div><div class=col-xs-6><input id=threshold-rollover_order class=form-control ng-model=vm.threshold.common.rollover_order placeholder="" disabled></div><div class=clearfix></div></div></div></div></div></div><div class=row id=threshold-row><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel first-panel"><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" ng-repeat="app in vm.threshold.dynapp" ng-if="vm.threshold.dynapp !== {}"><div class=form-group style="color:white; border-bottom: 1px solid white">{{app.app_name}}</div><div ng-repeat="thresh in app.thresholds" ng-if="app.thresholds !== {}"><div class=form-group><div class=col-xs-5><label for=event-name style=font-size:12px>{{thresh.name}}</label></div><div class=col-xs-7 ng-if=thresh.units><rzslider rz-slider-model=thresh.setting rz-slider-options=thresh.units></rzslider></div><div class=col-xs-7 ng-if=!thresh.units><input type=text class=form-control ng-model=thresh.setting disabled></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div><div class=row><div class=form-group style="margin-bottom: 30px;margin-top: 30px"><div class=col-xs-12 style="text-align: center"><div class=col-xs-12 ng-show=vm.error><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=vm.close_notice($index) style="background-color: rgb(116, 116, 116);left:0;right:0;position:absolute;margin-top:-40px;width: 100%">{{alert.msg}}</div></div><button type=submit class="btn btn-primary btn-block" ng-disabled="singledeviceForm.$invalid || vm.loading">EDIT DEVICE</button></div><div class=clearfix></div></div></div></div></form></div>');
$templateCache.put('app/docs/cloudGuide.html','<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="position: absolute;padding: 30px" id=cloud-user-guide><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12"></div><div class="col-lg-8 col-md-12 col-sm-12 col-xs-12 markdown-container panel-shadow"><div class="panel-loader loading dashboard-loader" ng-show=vm.loading><loading></loading></div><div ng-if=!vm.loading marked=vm.githubDoc></div></div><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12"></div></div>');
$templateCache.put('app/docs/cloudGuideAdmin.html','<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="position: absolute;padding: 30px" id=cloud-user-guide><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12"></div><div class="col-lg-8 col-md-12 col-sm-12 col-xs-12 markdown-container panel-shadow"><div class="panel-loader loading dashboard-loader" ng-show=vm.loading><loading></loading></div><div ng-if=!vm.loading marked=vm.githubDoc compile=true></div></div><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12"></div></div>');
$templateCache.put('app/docs/docs.html','<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 doc-nav no-padding"><div class="panel panel-default left-report-panel interface-panel webkit-scroll device-shadow" style=height:auto><div class="panel-heading brd-bottom" style="background-color:rgba(0,0,0,.2) !important; text-align:center"><h3 class=panel-title>{{vm.title}}</h3></div><div class="panel-body list-container"><uib-accordion close-others=true id=device-accordion><div ng-repeat="folder in vm.tableOfContents"><div uib-accordion-group class=panel-default heading={{folder.name}} style="margin-bottom: 3px"><div class=device-tables ng-repeat="(key, value) in folder.files" style=color:white><div class=sku-title><!-- <a ng-click="vm.openDocument(value.href)" target="_blank" class="device-contents"\n                                        style="width: 100%; margin: 0px;cursor:pointer">{{value.name}}</a> --> <a ng-click=vm.getPDF(value.href) target=_blank class=device-contents style="width: 100%; margin: 0px;cursor:pointer">{{value.name}}</a></div></div></div></div></uib-accordion></div></div></div><div class="col-lg-1 col-md-1 col-sm-0 col-xs-0 no-padding"></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-padding"><!-- <div class="loader pdf-init" ng-show="vm.loading">\n            <div class="css-loading css-loading--double"></div>\n        </div>\n        <div class="pdf-init" ng-hide="vm.hideInitPDF">SELECT PDF DOCUMENT</div>\n        <pdfjs-viewer class="pdf-view-portal" data="vm.pdf.data" onPageLoad="vm.loading = false"></pdfjs-viewer> --></div></div>');
$templateCache.put('app/docs/releaseNotes.html','<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" style=position:absolute><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 doc-nav no-padding"><div class="panel panel-default left-report-panel interface-panel webkit-scroll device-shadow" style=height:auto><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class="panel-heading brd-bottom" style="background-color:rgba(0,0,0,.2) !important; text-align:center"><h3 class=panel-title>Release Notes</h3></div><div class="panel-body list-container" style="padding-top: 30px;padding-bottom: 30px"><div class=device-tables ng-repeat="release in vm.releaseNotes track by $index" style=color:white><div class=sku-title ng-click="vm.viewRelease(release, $index)" style=cursor:pointer id="{{\'release-\'+ $index.toString()}}"><a target=_blank class=device-contents style="width: 100%; margin: 0px;cursor:pointer">{{release.release}}</a></div></div></div></div></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 doc-nav no-padding"><div class="panel panel-default left-report-panel interface-panel webkit-scroll device-shadow" style=height:auto><div class="panel-heading brd-bottom" style="background-color:rgba(0,0,0,.2) !important"><h3 class=panel-title>{{vm.selectedRelease.release}}</h3></div><div class="panel-body list-container" style="padding: 30px;font-weight:300"><div class=release-notes ng-if="vm.selectedRelease && !vm.selectedRelease.markdown" ng-repeat="story in vm.selectedRelease.stories"><p>Number: {{story.number}}</p><p>Short Description: {{story.short_description}}</p><p>Description: {{story.description}}</p><p>Impact: {{story.impact}}</p><p>Closed: {{story.closed_at}}</p></div><div class=release-notes ng-if="vm.selectedRelease && vm.selectedRelease.markdown"><div marked=vm.selectedRelease.markdownContent></div></div></div></div></div></div>');
$templateCache.put('app/events/clearevents.html','<div class="container container-top-ticket col-lg-12 col-md-12 col-sm-12 col-xs-12" style=width:96%><div class="well pd-top" style=min-height:583.4px><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.total_result == 0"><p>Sorry, no results for that event type.</p></div><div class=table-responsive><table class="table table-striped" datatable="" dt-options=vm.dtOptions dt-columns=vm.dtColumns dt-instance=vm.dtInstance class="row-border hover" id=cleareventTable></table></div></div></div>');
$templateCache.put('app/events/events.html','<div class="container container-top-ticket col-lg-12 col-md-12 col-sm-12 col-xs-12" style=width:96%><div class="well pd-top" style=min-height:583.4px><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.total_result == 0"><p>Sorry, no results for that event type.</p></div><div class=table-responsive ng-if="!vm.loading && vm.total_result > 0"><table class="table table-striped" datatable=ng dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs width=100% cellspacing=0 id=eventTable><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Priority</th><th>Device Name</th><th>Event Message</th><th>Acknowledged</th><th>Ticket</th><th>Last Detected</th><th>Properties</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th></th></tr></tfoot><tbody><!-- <tr ng-repeat="event in vm.events track by $index">\n            <td></td>\n            <td>\n              <span style="position:absolute;margin-left:7px;margin-top:1.5px;">{{vm.severity[event.severity] | limitTo:1}}{{(vm.severity[event.severity] == \'\')?\'0\':\'\'}}</span>\n              <img ng-src="assets/img/icon/network_{{vm.severity[event.severity] | limitTo:1}}.png" width="20" height="" style="height:auto;" />\n              <div style="position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px" tooltips tooltip-template="{{vm.severityWord[event.severity]}}" tooltip-side="right"></div>\n            </td>\n            <td><a ng-click="vm.goToDevice(event.aligned_resource_name)">{{event.aligned_resource_name}}</a></td>\n            <td><a ng-href="{{\'https://bms.burwood.com/em7/index.em7?exec=device_summary&did=\' + event.aligned_resource}}" target="_blank">{{ event.message | limitTo: 100 }}{{event.message.length > 100 ? \'...\' : \'\'}}</a></td>\n            <td>{{ event.user_ack}}</td>\n            <td><a ng-href="{{vm.ticket_uri + event.force_ticket_uri.split(\'=\').slice(2).join(\'=\')}}">{{ event.ext_ticket_ref}}</a></td>\n            <td>{{ (event.date_active > 0 ? event.date_active : event.date_first)*1000 | date:\'medium\'}}</td>\n            <td><i class="fas fa-wrench" ng-click="vm.openEventProperties(event, $index)"></i></td>\n          </tr> --><tr ng-repeat="event in vm.events track by $index"><td></td><td><span style=position:absolute;margin-left:7px;margin-top:1.5px>{{vm.severity[event.severity] | limitTo:1}}{{(vm.severity[event.severity] == \'\')?\'0\':\'\'}}</span> <img ng-src="assets/img/icon/network_{{vm.severity[event.severity] | limitTo:1}}.png" width=20 height="" style=height:auto><div style=position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px tooltips tooltip-template={{vm.severityWord[event.severity]}} tooltip-side=right></div></td><td><a ng-click=vm.goToDevice(event.alignedResourceName)>{{event.alignedResourceName}}</a></td><td><a ng-href="{{\'https://bms.burwood.com/em7/index.em7?exec=device_summary&did=\' + event.alignedEntity.id}}" target=_blank>{{ event.message | limitTo: 100 }}{{event.message.length > 100 ? \'...\' : \'\'}}</a></td><td>{{ event.acknowledgedUser.contact.firstName }} {{ event.acknowledgedUser.contact.lastName }}</td><td><a ng-href="{{vm.ticket_uri + event.forceTicketUri.split(\'=\').slice(2).join(\'=\')}}">{{ event.extTicketRef}}</a></td><td>{{ (event.date_active > 0 ? event.date_active : event.dateLast)*1000 | date:\'medium\'}}</td><td><i class="fas fa-wrench" ng-click=vm.openEventProperties(event.id)></i></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/events/singleevent.html','<div class="container container-top-ticket shadow-strong"><form name=singleEventForm ng-submit=vm.editEvent()><div class=col-xs-12 ng-show=vm.error><div uib-alert ng-repeat="alert in vm.alerts" class=single-alert close=vm.close_notice($index) style="background-color: rgb(116, 116, 116);left:0;right:0;position:absolute;margin-top:6px">{{alert.message}}</div></div><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class="well incident-wrapper" id=cloudbill-invoice><div class="dashboard-title cloudbill-title">EVENT</div><div class=row><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel first-panel"><div class=form-group><div class=col-xs-3><label for=event-name style=font-size:12px>DEVICE NAME</label></div><div class=col-xs-9><input type=text class=form-control id=device-name ng-model=vm.event.alignedResourceName placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=event-name style=font-size:12px>SEVERITY</label></div><div class=col-xs-9><select id=device-type class=form-control ng-model=vm.event.severity ng-options="option.id as option.name for option in vm.severities" disabled></select></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=event-name style=font-size:12px>ASSOCIATED TICKET</label></div><div class=col-xs-9><input type=text class=form-control id=device-name ng-model=vm.event.extTicketRef placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=event-name style=font-size:12px>EVENT POLICY</label></div><div class=col-xs-9><input type=text class=form-control id=device-name ng-model=vm.event.eventPolicy.name placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=event-name style=font-size:12px>COUNTER</label></div><div class=col-xs-9><input type=text class=form-control id=device-name ng-model=vm.event.counter placeholder="" disabled></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel"><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>MESSAGE</label></div><div class=col-xs-9><input type=text class=form-control id=event-total ng-model=vm.event.message placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>DATE ACKNOWLEDGED</label></div><div class=col-xs-9><input id=date_active_event class=form-control ng-model=vm.event.dateAcknowledged placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>FIRST OCCURENCE</label></div><div class=col-xs-9><input id=date_active_event class=form-control ng-model=vm.event.dateFirst placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=customer-code style=font-size:12px>LAST OCCURENCE</label></div><div class=col-xs-9><input id=date_active_event class=form-control ng-model=vm.event.dateLast placeholder="" disabled></div><div class=clearfix></div></div></div></div></div></div><!-- <div class="row">\n                <div class="basic-info-contain">\n                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel">\n                        <div class="form-group">\n                            <div class="col-xs-12">\n                                <label for="singleEvent-description" style="font-size:12px">NOTES</label>\n                                <textarea class="form-control" style="height: 120px" id="singleEvent-description"\n                                    ng-model="vm.event.user_note">\n                                                            </textarea>\n                            </div>\n                            <div class="clearfix"></div>\n                        </div>\n                    </div>\n                </div>\n            </div> --><!-- <div class="row">\n                <div class="form-group" style="margin-bottom: 30px;margin-top: 30px;">\n                    <div class="col-xs-12" style="text-align: center">\n                        <button type="submit" class="btn btn-primary btn-block"\n                            ng-disabled="singleEventForm.$invalid || vm.loading">EDIT EVENT</button>\n                    </div>\n                    <div class="clearfix"></div>\n                </div>\n            </div> --></div></form></div>');
$templateCache.put('app/login/confirmation.html','<div class="row reset-form"><div class=modal-header><h4>Password Reset Email Confirmation</h4></div><div class=modal-body id=modal-body style=color:white;font-weight:300>A password reset link has be emailed to the specified address.</div><div class=modal-footer><button class="btn btn-primary" type=button ng-click=vm.close()>OK</button></div></div>');
$templateCache.put('app/login/login.html','<div class=filter-bg></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" id=log-contain style="height: 100vh;padding: 10px;display:flex;position:absolute"><form id=login-form class="new-log login-form-1" ng-submit=vm.login(vm.user) autocomplete=off><div class=main-login-form><div class=login-group><div style="width: 35px;margin: auto;margin-top: 15px"><img class=logo-icon id=burwood-icon-title width=35px src=./assets/img/icon/burwood_icon2.png></div><p class=sign-in-title>Burwood<br>Cloud Services Portal</p><p class=sign-in-text ng-if="vm.forgot === false">Please Sign in With Service-Now Credentials</p><p class=sign-in-text ng-if="vm.forgot === true">Please Enter Email for Password Reset Link</p><div class=form-group style="margin-top:30px;margin-bottom: 30px" ng-if="vm.forgot === true"><label for=lg_username class=sr-only>Please Enter Email Address</label><input type=text class=form-control id=lg_emailReset name=lg_emailReset placeholder=Email ng-init="vm.user.emailReset = vm.user.username" ng-model=vm.user.emailReset ng-disabled=vm.loading autofocus></div><div class=form-group style=margin-top:30px ng-if="vm.forgot === false"><label for=lg_username class=sr-only>Username</label><input type=text class=form-control id=lg_username name=lg_username placeholder=Email ng-model=vm.user.username ng-disabled=vm.loading required autofocus></div><div class=form-group ng-if="vm.forgot == false"><label for=lg_password class=sr-only>Password</label><input type=password class=form-control id=lg_password name=lg_password ng-model=vm.user.password ng-disabled=vm.loading placeholder=Password required></div><div class="form-group login-group-checkbox" ng-show="vm.forgot === false"><a style="cursor: pointer; text-decoration: underline" ng-click=vm.forgotLink()>Reset Password?</a></div><div style=margin-bottom:18px><p class=contact-data>Having Trouble Signing In?<br>Contact Support<br>312-592-8387</p><button type=submit ng-disabled="form-signin.$invalid || vm.loading" class=switch-login-type style="background-color: #475d47">Submit</button><br><br><a ui-sref=sso_login class=switch-login-type ng-if="vm.forgot === false">Sign In With SSO</a><br></div><button type=submit class=login-button style=margin-top:-26px ng-disabled="form-signin.$invalid || vm.loading"><img class=logo-icon id=burwood-icon width=25px src=./assets/img/icon/burwood_icon2.png> <img class=logo-icon style="width:13px; margin-top:4px; margin-left:3px" src=./assets/img/icon/login_arrow_white.png></button></div><div class="alert alert-danger" ng-show=vm.login_error style="position: absolute;width: 100%;bottom: -28%;border-color: #6a6a6a;background-color: rgba(0, 0, 0, 0.5)">{{vm.error_message}}</div></div></form></div>');
$templateCache.put('app/login/register.html','<div class="row reset-form" style="margin-top: 115px;border-radius:10px"><div class=modal-header style="text-align:center; background-color:#4c4c4c"><h4 class=register-header>Burwood Management Portal Registration</h4></div><div class=modal-body id=modal-body style=color:white;font-weight:300><div class="well well-padding" style="border-radius: 0px 0px 5px 5px"><div class=row><form name=register_new ng-submit=vm.registerUser();><div class=col-xs-12 ng-show=vm.error><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=vm.close_notice($index)>{{alert.msg}}</div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-contain" style=margin-left:-5px;margin-right:5px><div class=form-group><div class=col-xs-3><label for=first-name style=font-size:12px>First Name *</label></div><div class=col-xs-9><input type=text class=form-control id=first-name ng-model=vm.register.firstName placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=last-name style=font-size:12px>Last Name *</label></div><div class=col-xs-9><input type=text class=form-control id=last-name ng-model=vm.register.lastName placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=contact-email style=font-size:12px>Contact Email *</label></div><div class=col-xs-9><input type=email class=form-control id=contact-email ng-model=vm.register.email placeholder="" ng-required=true required></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=register-company style=font-size:12px>Company *</label></div><div class=col-xs-9><input type=text class=form-control id=register-company ng-model=vm.register.company placeholder="" ng-required=true required></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=register-title style=font-size:12px>Title</label></div><div class=col-xs-9><input type=text class=form-control id=register-title ng-model=vm.register.title placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=business-phone style=font-size:12px>Business Phone</label></div><div class=col-xs-9><input type=text class=form-control id=business-phone ng-model=vm.register.businessPhone placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=mobile-phone style=font-size:12px>Mobile Phone</label></div><div class=col-xs-9><input type=text class=form-control id=mobile-phone ng-model=vm.register.mobilePhone placeholder=""></div><div class=clearfix></div></div></div></form></div><div class=modal-footer style=background-color:#4c4c4c><div class=form-group><div class=col-xs-12 style="text-align:center;margin-bottom: 0;margin-top: 10px"><button class="btn btn-primary btn-block" type=button ng-click=vm.registerUser() ng-disabled=register_new.$invalid>REGISTER</button></div><div class=clearfix></div></div></div></div></div></div>');
$templateCache.put('app/login/registercomplete.html','<div class="row reset-form"><div class=modal-header><h4>Your Registration is being approved.</h4></div><div class=modal-body id=modal-body style=color:white;font-weight:300>An email with be sent with the status of your registration.</div><div class=modal-footer><button class="btn btn-primary" type=button ng-click=vm.close()>OK</button></div></div>');
$templateCache.put('app/login/sso_login.html','<div class=filter-bg></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" id=log-contain style="height: 100vh;padding: 10px;display:flex;position:absolute"><form id=login-form class="new-log login-form-1" ng-submit="vm.login(vm.user, \'sso\')" autocomplete=off><div class=main-login-form><div class=login-group><div style="width: 35px;margin: auto;margin-top: 15px"><img class=logo-icon id=burwood-icon-title width=35px src=./assets/img/icon/burwood_icon2.png></div><p class=sign-in-title>Burwood<br>Cloud Services Portal<br>Single Sign On</p><div class=form-group style="margin-top:30px;margin-bottom: 30px"><label for=lg_username class=sr-only>Please Enter Email Address</label><input type=text class=form-control id=lg_username name=lg_emailReset placeholder="Single Sign On ID" ng-init="vm.user.emailReset = vm.user.username" ng-model=vm.user.emailReset ng-disabled=vm.loading required autofocus pattern=^\\S+@\\S+\\.\\S+$ title="Invalid email address. Maybe you put a comma instead of a period?"></div><div class=form-group ng-show=false><label for=lg_password class=sr-only>Password</label><input type=password class=form-control id=lg_password name=lg_password ng-model=vm.user.password_sso ng-disabled=vm.loading placeholder=Password></div><div style=margin-bottom:15px><p class=contact-data>Having Trouble Signing In?<br>Contact Support<br>312-592-8387</p><button type=submit ng-disabled="form-signin.$invalid || vm.loading" class=switch-login-type style="background-color: #475d47">Submit</button><br><br><a ui-sref=login class=switch-login-type>Sign In With Credentials</a><br></div><button type=submit class=login-button style=margin-top:-25px;right:-29px ng-disabled="form-signin.$invalid || vm.loading"><img class=logo-icon id=burwood-icon width=25px src=./assets/img/icon/burwood_icon2.png> <img class=logo-icon style="width:13px; margin-top:4px; margin-left:3px" src=./assets/img/icon/login_arrow_white.png></button></div><div class="alert alert-danger" ng-show=vm.login_error style="position: absolute;width: 100%;bottom: -28%;border-color: #6a6a6a;background-color: rgba(0, 0, 0, 0.5)">{{vm.error_message}}</div></div></form></div>');
$templateCache.put('app/main/dashboard_list.html','<div class=attachment-list-form><div class=modal-header style=text-align:center><h4>Dashboard Controls</h4></div><div class=modal-body id=modal-body><div ng-show=vm.error id=dashboard-error>Only 6 Dashboards Allowed</div><dualmultiselect options=vm.dualListOptions error=vm.error type="\'dashboard-no-limit\'" toggle=vm.toggleDash></dualmultiselect></div><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-4"><input type=button class="btn btn-success btn-block" value=Ok name=cancel ng-click=vm.close()></div></div></div></div>');
$templateCache.put('app/main/main.html','<div class=container2 id=override style="position:absolute; width: 100%;margin-bottom: 50px"><!-- <iframe src="https://bms.burwood.com/dashboards/cibc-business-services" style="width:100%;height: 95.8vh"></iframe> --><div class=row><div id=status-container><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"><div class="col-lg-3 col-md-0 col-sm-0 col-xs-0 no-padding"></div><div class="col-lg-1 col-md-2 col-sm-2 col-xs-2 no-padding"><div class=bar-status ng-class="{\'opaque\' : vm.totalTickets }" id=ticket-count>Tickets: {{vm.totalTickets}}</div></div><div class="col-lg-1 col-md-2 col-sm-2 col-xs-2 no-padding"><div class=bar-status ng-class="{\'opaque\' : vm.totalIncidents }" id=ticket-status>Incidents: {{vm.totalIncidents}}</div></div><div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 no-padding"><div class=bar-status ng-class="{\'opaque\' : vm.health.eventPercent }" id=health-status><img src=./assets/img/icon/health_heart.png width=30px style="margin-right: 10px">Health: {{vm.health.eventPercent.toFixed(2)}}%</div></div><div class="col-lg-1 col-md-2 col-sm-2 col-xs-2 no-padding"><div class=bar-status ng-class="{\'opaque\' : vm.totalEvents }" id=event-status>Events: {{vm.totalEvents}}</div></div><div class="col-lg-1 col-md-2 col-sm-2 col-xs-2 no-padding"><div class=bar-status ng-class="{\'opaque\' : vm.totalDevices }" id=device-count>Devices: {{vm.totalDevices}}</div></div><div class="col-lg-3 col-md-0 col-sm-0 col-xs-0 no-padding"></div></div></div></div><div class=row><div id=noc ng-init="ngLoaded = true" class=operations ng-class="{ opaque: ngLoaded }">Operations Center: {{vm.operations}}</div></div><div class="alert alert-danger" ng-if=vm.login_error>{{vm.error_message}}</div><div class=row><div class="col-lg-1 col-md-1 col-sm-1 col-xs-2 widget-pad left-container toggle-left side-bars" id=news-container><div class=pin-news style=margin-left:10px id=left-pin ng-click="vm.togglePin(\'leftPin\')"><img class="logo-icon operations" ng-init="ngLoaded = true" ng-class="{ opaque: ngLoaded }" width=20px src=./assets/img/icon/pin3.png></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding feed-container transparent" id=news-wrapper ng-class="{\'fade-dashboard\' : vm.newsLoaded}"><div class="col-lg-12 col-md-12 col-sm-11 col-xs-11 widget-pad single single-news"><img class=logo-icon width=30px src=./assets/img/icon/burwood_icon2.png> <a class=side-info ng-href={{vm.newsObj.linkArray[0]}} target=_blank><img class=news-img ng-src={{vm.newsObj.imgArray[0]}}><p class=side-text>{{vm.newsObj.dateArray[0]}}</p><hr>{{vm.newsObj.titleArray[0]}}<p></p></a></div><div class="col-lg-12 col-md-12 col-sm-11 col-xs-11 widget-pad single single-news"><img class=logo-icon width=30px src=./assets/img/icon/burwood_icon2.png> <a class=side-info ng-href={{vm.newsObj.linkArray[1]}} target=_blank><img class=news-img ng-src={{vm.newsObj.imgArray[1]}}><p class=side-text>{{vm.newsObj.dateArray[1]}}</p><hr>{{vm.newsObj.titleArray[1]}}<p></p></a></div><div class="col-lg-12 col-md-12 col-sm-11 col-xs-11 widget-pad single single-news"><img class=logo-icon width=30px src=./assets/img/icon/burwood_icon2.png> <a class=side-info ng-href={{vm.newsObj.linkArray[2]}} target=_blank><img class=news-img ng-src={{vm.newsObj.imgArray[2]}}><p class=side-text>{{vm.newsObj.dateArray[2]}}</p><hr>{{vm.newsObj.titleArray[2]}}<p></p></a></div><div class="col-lg-12 col-md-12 col-sm-11 col-xs-11 widget-pad single single-news"><img class=logo-icon width=30px src=./assets/img/icon/burwood_icon2.png> <a class=side-info ng-href={{vm.newsObj.linkArray[3]}} target=_blank><img class=news-img ng-src={{vm.newsObj.imgArray[3]}}><p class=side-text>{{vm.newsObj.dateArray[3]}}</p><hr>{{vm.newsObj.titleArray[3]}}<p></p></a></div><div class="col-lg-12 col-md-12 col-sm-11 col-xs-11 widget-pad single single-news"><img class=logo-icon width=30px src=./assets/img/icon/burwood_icon2.png> <a class=side-info ng-href={{vm.newsObj.linkArray[4]}} target=_blank><img class=news-img ng-src={{vm.newsObj.imgArray[4]}}><p class=side-text>{{vm.newsObj.dateArray[4]}}</p><hr>{{vm.newsObj.titleArray[4]}}<p></p></a></div><div class="col-lg-12 col-md-12 col-sm-11 col-xs-11 widget-pad single single-tweet" ng-repeat="twitter in vm.twitterObj.textArray track by $index"><img class=logo-icon width=30px src=./assets/img/icon/twitter2.png> <a class=side-info ng-href=https://twitter.com/burwoodgroup/status/{{vm.twitterObj.linkArray[$index]}} target=_blank><p class=side-text>{{twitter}}</p></a></div></div><div class="feed-tab toggle-bar" id=left-tab><p class=tab-text>Burwood Feeds</p></div></div><img class="feed-btn operations" ng-init="ngLoaded = true" ng-class="{ opaque: ngLoaded }" id=news-btn src=./assets/img/icon/burwood_icon2.png style="margin-left: 5px; width: 30px"> <img class="feed-btn operations" ng-init="ngLoaded = true" ng-class="{ opaque: ngLoaded }" id=twitter-btn src=./assets/img/icon/twitter2.png style="margin-left: 40px; width: 27px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"><div class="col-lg-1 col-md-1 col-sm-1 col-xs-0 no-padding"></div><div class="col-lg-10 col-md-10 col-sm-10 col-xs-12 no-padding main-body"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"><div class="row panel-row all-dashboards"><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="Actve Tickets" ng-class="{\'show-dash\' : vm.dash[\'Active Tickets\']}"><div class=dashboard-panel id=tick-width><div class=dashboard-title>Active Tickets</div><div class=high-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.ticketLoading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.ticketLoading && vm.ticketsActive.length == 0" style=text-align:center><p>Sorry, no results for your tickets.</p></div><div class=dash ng-class="{\'fade-dashboard\' : !vm.ticketLoading}" ng-if="!vm.ticketLoading && vm.ticketsActive.length > 0"><highchart class=highcharts id=ticketchart config=vm.configTicket></highchart></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="Resolved Tickets" ng-class="{\'show-dash\' : vm.dash[\'Resolved Tickets\']}"><div class=dashboard-panel id=tick-width><div class=dashboard-title>Resolved Tickets</div><div class=high-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.ticketLoading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.ticketLoading && vm.ticketsResolved.length == 0" style=text-align:center><p>Sorry, no results for your tickets.</p></div><div class=dash ng-class="{\'fade-dashboard\' : !vm.ticketLoading}" ng-if="!vm.ticketLoading && vm.ticketsResolved.length > 0"><highchart class=highcharts id=resolvedticketchart config=vm.configResolvedTicket></highchart></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash=Requests ng-class="{\'show-dash\' : vm.dash[\'Requests\']}"><div class=dashboard-panel><div class=dashboard-title>Requests</div><div class=high-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.ticketLoading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.ticketLoading && vm.ticketsRequest.length == 0" style=text-align:center><p>Sorry, no results for your tickets.</p></div><div class=dash ng-class="{\'fade-dashboard\' : !vm.ticketLoading}" ng-if="!vm.ticketLoading && vm.ticketsRequest.length > 0"><highchart class=highcharts id=requestchart config=vm.configRequest></highchart></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="Health History" ng-class="{\'show-dash\' : vm.dash[\'Health History\']}"><div class=dashboard-panel><div class=dashboard-title style=margin-bottom:5px>Health History</div><div class=high-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.historyLoading><div class="css-loading css-loading--double"></div></div><div style=text-align:center;font-size:10px;margin-bottom:10px><strong>Health Formula: </strong><br>100% - (# of Events / Total Devices) * Severity Weight<br><strong>Weights:</strong> Minor: .25 | Major: .5 Critical: 1<br><strong>Score:</strong> -{{vm.health.eventScore.toFixed(2)}} <strong>Health:</strong> {{vm.health.eventPercent.toFixed(2)}}%</div><div class=dash ng-class="{\'fade-dashboard\' : !vm.historyLoading}"><highchart class=highcharts id=historychart config=vm.configHealth></highchart></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash=Events ng-class="{\'show-dash\' : vm.dash[\'Events\']}"><div class=dashboard-panel><div class=dashboard-title>Events</div><div class=high-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.eventLoading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.eventLoading && vm.events.length == 0" style=text-align:center><p>Sorry, no results for events.</p></div><div class=dash ng-class="{\'fade-dashboard\' : !vm.eventLoading}" ng-if="!vm.eventLoading && vm.events.length > 0"><highchart class=highcharts id=eventchart config=vm.configEvent></highchart></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="Your Associated Tickets" ng-class="{\'show-dash\' : vm.dash[\'Your Associated Tickets\']}"><div class=dashboard-panel style="overflow: hidden"><div class=dashboard-title>Your Associated Tickets</div><div class=table-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.ticketLoading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.ticketLoading && vm.relatedTickets.length == 0" style=text-align:center><p>Sorry, no results for related tickets.</p></div><div class="table-responsive webkit-scroll dash" ng-class="{\'fade-dashboard\' : !vm.ticketLoading}" ng-if="!vm.ticketLoading && vm.relatedTickets.length > 0" style="height:220px; overflow-y: scroll !important"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions datatable=ng width=100% cellspacing=0 scrollx=true id=relatedTicketsTable><!-- bs-table-control="vm.bsctrl" --><thead><tr><th></th><th>Ticket #</th><th>Status</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th></tr></tfoot><tbody><tr ng-repeat="item in vm.relatedTickets"><td class=text-center><span style=position:absolute;margin-left:6px;margin-top:1.5px>{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}</span> <img ng-src="assets/img/icon/network_{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}.png" alt="{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}" width=20 height="" style=height:auto><div style=position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px tooltips tooltip-template="<span style=\'font-weight:400\'>Priority</span>: {{item.priority}}<br>Impact: {{item.impact[0]}}<br>Urgency: {{item.urgency[0]}}" tooltip-side=right tooltip-class=priority-tooltip></div></td><td style=width:32%><a style="word-break: break-all; cursor:pointer" ng-click="vm.goToTicket(item.number, item.sys_id)">{{item.number}}</a></td><td style="word-break: break-all">{{item.state}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="Tickets Waiting for Customer" ng-class="{\'show-dash\' : vm.dash[\'Tickets Waiting for Customer\']}"><div class=dashboard-panel><div class=dashboard-title>Tickets Waiting for Customer</div><div class=table-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.ticketLoading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.ticketLoading && vm.ticketsWaiting.length == 0" style=text-align:center><p>Sorry, no results for your tickets.</p></div><div class="table-responsive webkit-scroll dash" ng-class="{\'fade-dashboard\' : !vm.ticketLoading}" ng-if="!vm.ticketLoading && vm.ticketsWaiting.length > 0" style="height:220px; overflow-y: scroll !important; overflow-x:auto !important"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions datatable=ng width=100% cellspacing=0 scrollx=true id=ticketsWaitingTable><!-- bs-table-control="vm.bsctrl" --><thead><tr><th></th><th>Ticket #</th><th>Description</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th></tr></tfoot><tbody><tr ng-repeat="item in vm.ticketsWaiting"><td class=text-center><span style=position:absolute;margin-left:6px;margin-top:1.5px>{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}</span> <img ng-src="assets/img/icon/network_{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}.png" alt="{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}" width=20 height="" style=height:auto><div style=position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px tooltips tooltip-template="<span style=\'font-weight:400\'>Priority</span>: {{item.priority}}<br>Impact: {{item.impact[0]}}<br>Urgency: {{item.urgency[0]}}" tooltip-side=right tooltip-class=priority-tooltip></div></td><td style=width:32%><a style="word-break: break-all; cursor:pointer" ng-click="vm.goToTicket(item.number, item.sys_id)" style=cursor:pointer>{{item.number}}</a></td><td style="word-break: break-all">{{item.short_description}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="My Approvals" ng-class="{\'show-dash\' : vm.dash[\'My Approvals\']}"><div class=dashboard-panel><div class=dashboard-title>My Approvals</div><div class=table-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.approvalLoading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.approvalLoading && vm.change_approvals.length == 0" style=text-align:center><p>Sorry, no results for your Approvals.</p></div><div class="table-responsive webkit-scroll dash" ng-class="{\'fade-dashboard\' : !vm.approvalLoading}" ng-if="!vm.approvalLoading && vm.change_approvals.length > 0" style="height:220px; overflow-y: scroll !important"><table class="table table-striped" dt-options=vm.dtOptions datatable=ng width=100% cellspacing=0 dt-column-defs=vm.dtColumnDefs scrollx=true id=changeApprovalTable style="margin:0px !important"><thead><tr><th style="padding-left: 35px">Ticket #</th><th>State</th><th>Updated</th></tr></thead><tbody><tr ng-repeat="item in vm.change_approvals"><td style="padding-left: 42px; cursor: pointer"><a ng-click="vm.goToTicket(item.sysapproval.display_value, item.document_id.link.split(\'/\')[7])">{{item.sysapproval.display_value}}</a></td><td>{{item.state}}</td><td>{{item.sys_updated_on}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="Events List" ng-class="{\'show-dash\' : vm.dash[\'Events List\']}"><div class=dashboard-panel><div class=dashboard-title>Events List</div><div class=table-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.eventLoading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.eventLoading && vm.events.length == 0" style=text-align:center><p>Sorry, no results for events.</p></div><div class="table-responsive webkit-scroll dash" ng-class="{\'fade-dashboard\' : !vm.eventLoading}" ng-if="!vm.eventLoading && vm.events.length > 0" style="height:220px; overflow-y: scroll !important; overflow-x:auto !important"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions datatable=ng id=eventListTable><!-- bs-table-control="vm.bsctrl" --><thead><tr><th></th><th>Device Name</th><th>Event Message</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th></tr></tfoot><tbody><tr ng-repeat="item in vm.events"><td><span style=position:absolute;margin-left:7px;margin-top:1.5px>{{vm.severity[item.severity] | limitTo:1}}{{(vm.severity[item.severity] == \'\')?\'0\':\'\'}}</span> <img ng-src="assets/img/icon/network_{{vm.severity[item.severity] | limitTo:1}}.png" width=20 height="" style=height:auto><div style=position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px tooltips tooltip-template={{vm.severityWord[item.severity]}} tooltip-side=right></div></td><td style=width:31%><a style="word-break: break-all; cursor:pointer" ng-click=vm.goToDevice(item.aligned_resource_name)>{{item.alignedResourceName}}</a></td><td style="word-break: break-all">{{item.message}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="Top Event Generators" ng-class="{\'show-dash\' : vm.dash[\'Top Event Generators\']}"><div class=dashboard-panel><div class=dashboard-title>Top Event Generators</div><div class=high-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.eventLoading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.eventLoading && vm.events.length == 0" style=text-align:center><p>Sorry, no results for events.</p></div><div class=dash ng-class="{\'fade-dashboard\' : !vm.eventLoading}" ng-if="!vm.eventLoading && vm.events.length > 0"><highchart class=highcharts id=topEventchart config=vm.configTopEvent></highchart></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="Top Memory Utilization" ng-class="{\'show-dash\' : vm.dash[\'Top Memory Utilization\']}"><div class=dashboard-panel><div class=dashboard-title>Top Memory Utilization</div><div class=high-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.memoryConfigloading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.memoryConfigloading && vm.memoryConfigNoData" style=text-align:center><p>Sorry, no results for metrics.</p></div><div class=dash ng-class="{\'fade-dashboard\' : !vm.memoryConfigloading}" ng-if="!vm.memoryConfigloading && !vm.memoryConfigNoData"><highchart class=highcharts id=topMemorychart config=vm.memoryConfig></highchart></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="Top CPU Utilization" ng-class="{\'show-dash\' : vm.dash[\'Top CPU Utilization\']}"><div class=dashboard-panel><div class=dashboard-title>Top CPU Utilization</div><div class=high-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.CPUConfigloading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.CPUConfigloading && vm.CPUConfigNoData" style=text-align:center><p>Sorry, no results for metrics.</p></div><div class=dash ng-class="{\'fade-dashboard\' : !vm.CPUConfigloading}" ng-if="!vm.CPUConfigloading && !vm.CPUConfigNoData"><highchart class=highcharts id=topCPUchart config=vm.CPUConfig></highchart></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="Device Availability (Lowest Available)" ng-class="{\'show-dash\' : vm.dash[\'Device Availability (Lowest Available)\']}"><div class=dashboard-panel><div class=dashboard-title>Device Availability (Lowest Available)</div><div class=high-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.availabilityConfigloading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.availabilityConfigloading && vm.availabilityConfigNoData" style=text-align:center><p>Sorry, no results for metrics.</p></div><div class=dash ng-class="{\'fade-dashboard\' : !vm.availabilityConfigloading}" ng-if="!vm.availabilityConfigloading && !vm.availabilityConfigNoData"><highchart class=highcharts id=topavailabilitychart config=vm.availabilityConfig></highchart></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="Top Utilization In" ng-class="{\'show-dash\' : vm.dash[\'Top Utilization In\']}"><div class=dashboard-panel><div class=dashboard-title>Top Utilization In</div><div class=high-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.utilInConfigloading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.utilInConfigloading && vm.utilInConfigNoData" style=text-align:center><p>Sorry, no results for metrics.</p></div><div class=dash ng-class="{\'fade-dashboard\' : !vm.utilInConfigloading}" ng-if="!vm.utilInConfigloading && !vm.utilInConfigNoData"><highchart class=highcharts id=topUtilInchart config=vm.utilInConfig></highchart></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="Top Utilization Out" ng-class="{\'show-dash\' : vm.dash[\'Top Utilization Out\']}"><div class=dashboard-panel><div class=dashboard-title>Top Utilization Out</div><div class=high-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.utilOutConfigloading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.utilOutConfigloading && vm.utilOutConfigNoData" style=text-align:center><p>Sorry, no results for metrics.</p></div><div class=dash ng-class="{\'fade-dashboard\' : !vm.utilOutConfigloading}" ng-if="!vm.utilOutConfigloading && !vm.utilOutConfigNoData"><highchart class=highcharts id=topUtilOutchart config=vm.utilOutConfig></highchart></div></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="Tickets Open By Device" ng-class="{\'show-dash\' : vm.dash[\'Tickets Open By Device\']}"><div class=dashboard-panel><div class=dashboard-title style=margin-bottom:20px>Tickets Open By Device</div><div class=high-panel><div class="panel-loader loading dashboard-loader" ng-show=vm.ticketLoading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.ticketLoading && vm.ticketsDevice.length == 0" style=text-align:center><p>Sorry, no results for your tickets.</p></div><highchart class=highcharts id=ticByDevice config=vm.configTicDevice ng-if="!vm.ticketLoading && vm.ticketsDevice.length > 0"></highchart></div></div></div><div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 no-padding dash-temp" data-dash="Change Calendar" ng-class="{\'show-dash\' : vm.dash[\'Change Calendar\']}"><div class=dashboard-panel><div class=dashboard-title style=margin-bottom:10px>Change Calendar</div><div class="panel-loader loading dashboard-loader" ng-show=vm.ticketLoading><div class="css-loading css-loading--double"></div></div><div class="high-panel transparent" ng-class="{\'opaque\' : !vm.calendarLoading}"><timeline id=main-timeline control=vm.timeline ng-show=!vm.ticketLoading options=vm.options></timeline></div></div></div></div></div><div ng-if=vm.showSLDashboard ng-controller="SLDashboardController as vm" ng-include="\'app/sciencelogic/dashboard.html\'"></div></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-0 no-padding"></div></div><div id=right-container class="col-lg-1 col-md-1 col-sm-1 col-xs-2 widget-pad toggle-right side-bars"><div class=pin-news ng-click="vm.togglePin(\'rightPin\')"><img class="logo-icon operations" id=right-pin ng-init="ngLoaded = true" ng-class="{ opaque: ngLoaded }" width=20px src=./assets/img/icon/pin3.png></div><div class=dash ng-class="{\'fade-dashboard\' : vm.tweetsRendered}"><div class="col-lg-12 col-md-12 col-sm-11 col-xs-9 widget-pad feed-container" id=subscription-container ui-sortable ui-sortable-stop=vm.createStoredWidgets() ng-model=vm.chosenWidgets><div class="col-lg-12 col-md-12 col-sm-12 col-xs-2 widget-pad pa-holder" ng-repeat="item in vm.chosenWidgets" ng-init="$last && vm.tweetRender()" style=float:right ng-click=vm.goToTicketsWaiting(item.header)><p class="widget-text widget-header">{{item.header}}</p><br><p class="widget-text middle-widget-text" ng-show=item.name><a ng-click=vm.setStorage(item.name) ng-href={{item.href}} style="word-wrap: break-word">{{item.name}}</a></p><p class="widget-text widget-value">{{item.value}}</p></div></div></div><div class="feed-tab toggle-bar" id=right-tab><p class=tab-text id=twitter-tab>Performance Analytics</p></div></div><!-- <a href="/teapot">\n            <img class="teapot" src="./assets/img/teapot.png" width="25px">\n        </a> --><div><img class="gear operations" ng-init="ngLoaded = true" ng-class="{ opaque: ngLoaded }" src=./assets/img/gear.png ng-click=vm.selectWidgets() width=25px></div><div id=dashboard-control ng-click=vm.selectDashboards()>Dashboard Control</div><!-- <timeline control="vm.timeline" height="80vh" ng-if="!vm.ticketLoading" options="vm.options"></timeline> --></div></div>');
$templateCache.put('app/main/widget_list.html','<div class=attachment-list-form><div class=modal-header style=text-align:center><h4 style="padding:10px; border-radius:5px 5px 5px 5px">Performance Analytics</h4></div><div class=modal-body id=modal-body><dualmultiselect options=vm.dualListOptions></dualmultiselect></div><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-4"><input type=button class="btn btn-success btn-block" value=Ok name=cancel ng-click=vm.close()></div></div></div></div>');
$templateCache.put('app/problem/newproblem.html','<div class="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-1 main no-padding new-ticket"><div class=row><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-2"><div class="panel well status-wrapper"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class="panel-body row"><form name=incident_new ng-submit="vm.create(vm.incident, incident_new.$valid)"><ul class="list-unstyled list-inline header-alerts" style="padding: 10px !important;width: 100%;min-height: 40px"><li style="letter-spacing: 1px"><div ng-repeat="alert in vm.alerts" close=vm.close_notice($index)><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px;margin-top: -5px"> {{alert.msg}}<button type=button class="btn btn-default remove-alert" style="font-size: 10px;margin-left: 10px" ng-click=vm.close_notice($index)><i class="fa fa-times"></i></button></div></li></ul><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class=form-group><div class=col-xs-12><label for=contact>Contact *</label></div><div class=col-xs-10><p class=input-group><input type=text class=form-control id=contact ng-model=vm.caller_name placeholder="" ng-required=true required> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.contact()><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=caller_id ng-model=vm.caller_id placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=type_of_request>Urgency *</label></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=urgency>Urgency *</label><br><span class=more_info>More Information <i class="fa fa-sort" aria-hidden=true></i></span></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-10><label class=select-box><select id=urgency class=form-control ng-model=vm.incident.urgency ng-required=required required><option ng-repeat="(key, option) in vm.urgency" value={{key}}>{{option}}</option></select></label></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class=form-group><div class=col-xs-12><label for=cmdb_ci>Select Affected Device</label></div><div class=col-xs-10><p class=input-group><input type=text class=form-control id=select ng-model=vm.device_name placeholder="" required> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.device()><i class="fa fa-search"></i></button></span></p><input type=hidden class=form-control id=device_id ng-model=vm.device_id placeholder=""></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=form-group><div class=col-xs-11><label for=short_description>Short Description *</label><br><span class=more_info>More information <i class="fa fa-sort" aria-hidden=true></i></span></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-11><input type=text class=form-control id=short_description placeholder="" ng-model=vm.incident.short_description placeholder="" ng-required=true required></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-11><label for=more_info>Please describe your issue below *</label><br><span class=more_info>More information <i class="fa fa-sort" aria-hidden=true></i></span></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-11><textarea class=form-control ng-model=vm.incident.comments placeholder="" rows=5 ng-required=required required></textarea></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-11><button class="btn btn-success btn-block" type=submit ng-disabled="vm.$invalid || vm.loading">CREATE</button></div><div class=clearfix></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/problem/problem.html','<div class="container container-top-ticket col-lg-12 col-md-12 col-sm-12 col-xs-12" style=width:96%><div class="well pd-top" style=min-height:200px><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.problems.length == 0"><p>Sorry, no results for tickets.</p></div><div class=table-responsive ng-if="!vm.loading && vm.problems.length > 0"><div class=table-header ng-if="!vm.loading && vm.problems.length > 0" style="padding-top: 7px">Open Problems</div><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=problemTable><!-- bs-table-control="vm.bsctrl" --><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Priority</th><th>Ticket #</th><th>Device</th><th>Short Description</th><th>Assignment Group</th><th>Assigned To</th><th>Status</th><th>Opened</th><th>Updated</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.problems"><td></td><td class=text-center><span style=position:absolute;margin-left:6px;margin-top:1.5px>{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}</span> <img ng-src="assets/img/icon/network_{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}.png" alt="{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}" width=20 height="" style=height:auto><div style=position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px tooltips tooltip-template="<span style=\'font-weight:400\'>Priority</span>: {{item.priority}}<br>Impact: {{item.impact[0]}}<br>Urgency: {{item.urgency[0]}}" tooltip-side=right tooltip-class=priority-tooltip></div></td><td><a ng-click=vm.goToTicket(item.sys_id)>{{item.number}}</a></td><td><a ng-click=vm.goToDevice(item.cmdb_ci.display_value)>{{item.cmdb_ci.display_value}}</a></td><td>{{item.short_description}}</td><td>{{item.assignment_group.display_value}}</td><td>{{item.assigned_to.display_value | RemoveEmail}}</td><td>{{item.state}}</td><td style=width:100px>{{item.opened_at}}</td><td style=width:100px>{{item.sys_updated_on}}</td></tr></tbody></table></div><div class="table-responsive dev-report-category chgreq-toggle" ng-class="{\'toggle-chgreq-min\': vm.toggleConfig}" ng-if="!vm.loading && vm.problems.length > 0" style=border:none><div class=table-header id=chg-app-header style=margin-bottom:10px><span id=show-dev-cat ng-click=vm.minimizeSection() class=show-dev-cat style="margin-left: .5%;margin-top: 0px">></span> Problems - Known Error</div><table class="table table-striped" dt-instance=vm.dtInstance2 dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=knownProblemTable><!-- bs-table-control="vm.bsctrl" --><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters2 = !vm.showFilters2"><span class="fa fa-search"></span></a></th><th>Priority</th><th>Ticket #</th><th>Device</th><th>Short Description</th><th>Assignment Group</th><th>Assigned To</th><th>Status</th><th>Opened</th><th>Updated</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance2 filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance2 filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance2 filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance2 filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance2 filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance2 filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance2 filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance2 filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.knownProblems"><td></td><td class=text-center><span style=position:absolute;margin-left:6px;margin-top:1.5px>{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}</span> <img ng-src="assets/img/icon/network_{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}.png" alt="{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}" width=20 height="" style=height:auto><div style=position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px tooltips tooltip-template="<span style=\'font-weight:400\'>Priority</span>: {{item.priority}}<br>Impact: {{item.impact[0]}}<br>Urgency: {{item.urgency[0]}}" tooltip-side=right tooltip-class=priority-tooltip></div></td><td><a ng-click=vm.goToTicket(item.sys_id)>{{item.number}}</a></td><td><a ng-click=vm.goToDevice(item.cmdb_ci.display_value)>{{item.cmdb_ci.display_value}}</a></td><td>{{item.short_description}}</td><td>{{item.assignment_group.display_value}}</td><td>{{item.assigned_to.display_value | RemoveEmail}}</td><td>{{item.state}}</td><td style=width:100px>{{item.opened_at}}</td><td style=width:100px>{{item.sys_updated_on}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/problem/singleproblem.html','<div class="container container-top-ticket shadow-strong" id=ticket-form><div class=menu-top><ul class="list-unstyled list-inline pull-left" style="padding: 15px"><li><a ng-click=vm.go_back()><img src=assets/img/icon/back-arrow.png width=15 height="" style=height:auto></a></li><li><strong>Problem - {{vm.problem.number}}</strong></li></ul><ul class="list-unstyled list-inline pull-right list-menu"><li><button class=menu_btn type=submit ng-disabled="incidentForm.$invalid || vm.loading">Update</button></li></ul><ul class="list-unstyled list-inline pull-right"><li><a ng-click=vm.attachment()><img src=assets/img/icon/attach.png width=15 height="" style=height:auto></a></li></ul></div><div class="well incident-wrapper"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=row><form ng-submit="vm.update(vm.problem.sys_id, vm.problem)" name=problemForm><ul class="list-unstyled list-inline header-alerts" style="padding: 10px !important;width: 100%;min-height: 40px"><li style="letter-spacing: 1px"><div ng-repeat="alert in vm.alerts" close=vm.close_notice($index)><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px;margin-top: -5px"> {{alert.msg}}<button type=button class="btn btn-default remove-alert" style="font-size: 10px;margin-left: 10px" ng-click=vm.close_notice($index)><i class="fa fa-times"></i></button></div></li></ul><div class=basic-info-contain><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel first-panel"><div class=form-group><div class=col-xs-3><label for=exampleInputEmail1>Number</label></div><div class=col-xs-8><input type=text class=form-control id=contact ng-model=vm.problem.number placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=Contact>Opened By</label></div><div class=col-xs-8><p class=input-group><input type=text class=form-control id=contact ng-model="vm.problem[\'opened_by.name\']" placeholder="" disabled> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.contact()><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=caller_id ng-model=vm.opened_by placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class="col-xs-3 col-md-3 col-sm-3"><label for=watch_list>Watch List</label></div><div class="col-xs-8 col-md-8 col-sm-8"><a class="box-icon watch-list" ng-show=!vm.watch_list_show ng-click=vm.switch_watchlist()><i class="fa fa-user-plus" aria-hidden=true></i></a><ul class=watch_list_static ng-show=!vm.watch_list_show><li ng-repeat="user in vm.watch_list_users">{{user.name}}</li></ul><div class=row ng-show=vm.watch_list_show><div class="col-xs-12 watch-list-container"><select class=watch-list-select ng-model=vm.watch_list_selected multiple><option value={{user.sys_id}} ng-repeat="user in vm.watch_list_users" ng-if=user.name class=watch-list-selected>{{user.name}}</option></select><div class=watch-list-btns><button type=button class="btn btn-default" ng-click=vm.delete_watchlist() ng-disabled="vm.watch_list_selected.length==0"><i class="fa fa-times"></i></button> <button type=button class="btn btn-default" ng-click=vm.switch_watchlist()><i class="fa fa-unlock"></i></button></div></div><div class=clearfix></div><div class=col-xs-12><p class=input-group><input type=text name=lookup class="lookup form-control"> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.watch_list()><i class="fa fa-search"></i></button></span></p><p class=input-group><input type=email name=watch_list_email class="email form-control" ng-model=vm.watch_list_email> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.addEmail_watchlist(vm.watch_list_email) ng-disabled="incidentForm.watch_list_email.$invalid || vm.watch_list_email==null || vm.watch_list_email==\'\'"><i class="fa fa-envelope-o"></i></button></span></p></div></div><div class=clearfix></div></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=configuration-item>Device</label></div><div class=col-xs-8><input type=text class=form-control id=configuration-item ng-model="vm.problem[\'cmdb_ci.name\']" placeholder="" readonly ng-click=vm.goToDevice(vm.problem.cmdb_ci) style="cursor: pointer"></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=priority>Priority</label></div><div class=col-xs-8><input id=priority class=form-control ng-model=vm.priorities[vm.problem.priority] disabled></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel"><div class=form-group><div class=col-xs-3><label for=opened>Opened</label></div><div class=col-xs-8><input type=text class=form-control id=opened ng-model=vm.problem.opened_at placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=status>Status</label></div><div class=col-xs-8><input id=state class=form-control ng-model=vm.stateNames[vm.problem.state] disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=assignment-group>Assignment Group</label></div><div class=col-xs-8><input type=text class=form-control id=assignment-group ng-model="vm.problem[\'assignment_group.name\']" placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=assigned-to>Assigned To</label></div><div class=col-xs-8><input type=text class=form-control id=assigned-to ng-model="vm.problem[\'assigned_to.name\']" placeholder="" disabled></div><div class=clearfix></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div class=form-group><div class=col-xs-12><label for=exampleInputEmail1>Short Description</label></div><div class=col-xs-12><input type=text class=form-control id=short-description placeholder="" ng-model=vm.problem.short_description disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=exampleInputEmail1>Description</label></div><div class=col-xs-12><textarea type=text class="form-control webkit-scroll" id=description placeholder="" ng-model=vm.problem.description disabled>\n                  </textarea></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=comment>Additional Comments</label></div><div class=col-xs-12><textarea type=text class=form-control id=additional_comment placeholder="" placeholder="" ng-model=vm.problem.comments></textarea></div><div class=clearfix></div></div><ul class="list-unstyled list-inline header-alerts" style="padding: 10px !important;width: 100%;min-height: 40px"><li style="letter-spacing: 1px"><div ng-repeat="alert in vm.alerts" close=vm.close_notice($index)><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px;margin-top: -5px"> {{alert.msg}}<button type=button class="btn btn-default remove-alert" style="font-size: 10px;margin-left: 10px" ng-click=vm.close_notice($index)><i class="fa fa-times"></i></button></div></li></ul><div class="form-group text-center"><button class="btn btn-primary btn-block" type=submit ng-click="vm.action=\'update\'" ng-disabled="incidentForm.$invalid || vm.loading">UPDATE</button><div class=clearfix></div></div><div class=form-group><div ng-include="\'app/shared/html/_activity.html\'"></div><div class=clearfix></div></div></div></form></div></div></div>');
$templateCache.put('app/quote/gcp_quote.html','<center><h2>Request a Quote</h2></center><center><p class="text-secondary w-50">This self-service function is provided to enable the creation of quotes related to Google Cloud Platform consumption. Should a Burwood quote be required in order to create a GCP Purchase Order, please use this service to download the quote for the amount you desire. Please note that all cloud consumption will be invoiced based on actual usage, regardless of the amount quoted.</p></center><loading ng-show=vm.loading></loading><div class="well container" id=override-width><div class="center mx-5 my-5"><div class="mx-10 my-10"><form ng-submit=vm.requestPDF() class="mx-5 my-5 p-10"><div class=form-group><label for=quote_amount>Quantity Amount:</label><input name=quote_amount id=quote_amount class=form-control type=text placeholder=0 pattern=^[\\d]*$ ng-model=vm.requestInfo.amount title="Enter a positive amount with no commas or decimals." required></div><div class=form-group><label for=quoted_to>Quoted to:</label><input class=form-control type=text name=quoted_to id=quoted_to ng-model=vm.requestInfo.userName readonly></div><div class=form-check><label for=another_party class=form-check-label>Is this quote for someone else?</label><input type=checkbox class="form-control form-check-input" id=another_party name=another_party ng-model=vm.requestInfo.quotedToIsDifferentThanQuotedFor><br></div><div class=form-group><label for=quoted_for>Quote Description:</label><input class=form-control type=text name=quoted_for id=quoted_for ng-model=vm.requestInfo.quoteDescription></div><div class=form-group ng-if=vm.requestInfo.quotedToIsDifferentThanQuotedFor><label for=quoted_for>Quoted for:</label><input class=form-control type=text name=quoted_for id=quoted_for ng-model=vm.requestInfo.quotedFor></div><button type=submit class="btn btn-primary my-5">Create Quote</button></form></div></div></div>');
$templateCache.put('app/report/report.html','<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 container container-top" style="margin-top:0px; padding:30px" id=report-page><div class=row><div class=col-xs-12><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=vm.close_notice($index) style="background-color: rgb(34, 61, 38)">{{alert.msg}}</div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-padding"><div id=exTab3 style="width:100%; padding:0"><ul class="nav nav-pills"><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'ticket\']"><a ng-click="vm.tabView = \'ticket\'" data-toggle=tab>Tickets</a></li><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'device\']"><a ng-click="vm.tabView = \'device\'" data-toggle=tab>Devices</a></li><!-- <li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'schedule\']"><a\n                            ng-click="vm.tabView = \'schedule\'" data-toggle="tab">Compose</a>\n                    </li> --><li ng-if=vm.userTAM ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'summary\']"><a ng-click="vm.tabView = \'summary\'" data-toggle=tab>Summary</a></li><!-- <li ng-if="vm.apiBasePath != \'https://api.bcs.burwood.com\' && vm.apiBasePath != \'https://api.bcs.burwood.us\'"\n                        ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'pa\']"><a ng-click="vm.tabView = \'pa\'"\n                            data-toggle="tab">Performance Analytics</a>\n                    </li> --></ul><div class="tab-content clearfix"><div class="tab-pane active report-shadow" id=1b ng-show="vm.tabView === \'ticket\'"><div class="panel panel-default left-report-panel tick-rep" style="border-top-left-radius: 0px !important"><div id=rep-panel-1 class="panel-heading brd-bottom dev-report-category" style="text-align:center; padding-bottom: 0px; background-color:transparent !important" ng-class="{\'toggle-filter-min\': !vm.toggleConfig.dateRangeShow}"><span ng-click="vm.minimizeSection(\'dateRangeShow\')" class=show-dev-cat>></span><p style="text-align:center; font-weight:300; font-size:13px; letter-spacing:1px">DATE RANGE</p><input date-range-picker class="form-control date-picker" type=text placeholder="Select Custom Date Range" ng-model=vm.date style="height:24px; margin-top: 10px; width:49%; display:inline-block; margin-bottom: 20px"> <button class="button-month btn-clicked thisMonth" id=thisMonth style=margin-bottom:10px type=button ng-click="vm.toggleTime(\'This Month\')">This Month</button> <button class="button-month lastMonth" id=lastMonth type=button ng-click="vm.toggleTime(\'Last Month\')">Last Month</button></div><div id=rep-panel-2 class=dev-report-category ng-class="{\'toggle-filter-min\': !vm.toggleConfig.devCategoryShow}"><div class=panel-heading style="text-align:center; padding-bottom: 0px; background-color:transparent !important"><span ng-click="vm.minimizeSection(\'devCategoryShow\')" class=show-dev-cat>></span><p style="text-align:center; font-weight:300; font-size:13px; letter-spacing:1px;display: inline">TICKET CATEGORY OPTIONS</p><dualmultiselect options=vm.dualListOptionsDevice error=vm.error type="\'schedule\'" id=deviceClass-options toggle=vm.toggle></dualmultiselect><div>If no category is selected, report returns all categories.</div></div></div><div id=rep-panel-3 class="panel-heading brd-bottom dev-report-category" style="text-align:center;background-color:transparent !important; padding: 10px" ng-class="{\'toggle-filter-min\': !vm.toggleConfig.customTicketShow}"><span ng-click="vm.minimizeSection(\'customTicketShow\')" class=show-dev-cat style="margin-left: 0">></span><h3 class=panel-title style="display:inline-block; text-align: center;margin-bottom: 15px;font-weight:300">CUSTOM TICKET REPORTS</h3><div style=display:block><!-- <i class="fa fa-clock-o fa-lg"\n                                        ng-class="{\'toggle-schedule-on\' : vm.toggleClassVars[vm.chosenTicketType + \'s Closed By \' + vm.chosenTicketCategory]}"\n                                        aria-hidden="true" width="15" style="margin:0"\n                                        ng-click="vm.toggleScheduleItem(vm.chosenTicketType + \'s Closed By \' + vm.chosenTicketCategory)"></i> --><label class=select-box style="margin-left:11px; margin-bottom: 10px;margin-right: 3px"><select id=report-type style="width: 90px" class=form-control ng-model=vm.chosenTicketType ng-change=vm.checkChange() ng-options="option for option in vm.ticketTypes" required></select></label><p style="margin-right: 10px; display: inline-block; font-weight:300;font-size: 13px">Closed by</p><label class=select-box style="margin-right: 3px"><select id=report-category style="width: 82px" class=form-control ng-model=vm.chosenTicketCategory ng-options="option for option in vm.ticketCategories" required></select></label><button class="report-category report-select" id=standard-run type=button ng-click="vm.refreshReport(\'standardReport\')">RUN</button></div></div><!-- <div class="panel-body list-container" id="report-list" style="height: 220px;"> --><div id=rep-panel-4 class="panel-body list-container dev-report-category" id=report-list style="border-bottom: none" ng-class="{\'toggle-filter-min\': !vm.toggleConfig.standardTicketShow}"><span id=show-dev-cat-standard ng-click="vm.minimizeSection(\'standardTicketShow\')" class=show-dev-cat>></span><div class=custom-header style="text-align: center">STANDARD TICKET REPORTS</div><div id=standard-report-contain style="margin-bottom: 25px"><!-- <i class="fa fa-clock-o fa-lg"\n                                        ng-class="{\'toggle-schedule-on\' : vm.toggleClassVars[vm.selected_standard_name]}"\n                                        aria-hidden="true" width="15"\n                                        style="margin:0;font-size: 1.5em;margin-left: 25px;"\n                                        ng-click="vm.toggleScheduleItem(vm.selected_standard_name)"></i> --><select id=standard-report-select class=form-control ng-model=vm.selected_standard ng-change=vm.getSelectedReportName() ng-options="option.id as option.name for option in vm.standard_reports"></select><button class="report-category report-select" id=standard-run type=button ng-click="vm.refreshReport(\'customTicketReport\', vm.selected_standard)">RUN</button></div><!-- <div class="schedule-tip"\n                                    ng-class="{\'display-none\': !vm.toggleConfig.standardTicketShow}">Toggle Clock Icon\n                                    to Add to Scheduled Reports</div> --></div></div></div><div class="tab-pane active report-shadow" id=2b ng-show="vm.tabView === \'device\'"><div class="panel panel-default left-report-panel" style="border-top-left-radius: 0px !important;padding-bottom: 1px"><div id=rep-panel-1 class="panel-heading brd-bottom dev-report-category" style="text-align:center; padding-bottom: 0px; background-color:transparent !important" ng-class="{\'toggle-filter-min\': !vm.toggleConfig.dateRangeShow}"><span ng-click="vm.minimizeSection(\'dateRangeShow\')" class=show-dev-cat>></span><p style="text-align:center; font-weight:300; font-size:13px; letter-spacing:1px">DATE RANGE</p><input date-range-picker class="form-control date-picker" type=text placeholder="Select Custom Date Range" ng-model=vm.date style="height:24px; margin-top: 10px; width:49%; display:inline-block; margin-bottom: 20px"> <button class="button-month btn-clicked thisMonth" id=thisMonth style=margin-bottom:10px type=button ng-click="vm.toggleTime(\'This Month\')">This Month</button> <button class="button-month lastMonth" id=lastMonth type=button ng-click="vm.toggleTime(\'Last Month\')">Last Month</button></div><div class="panel-heading brd-bottom dev-rep dev-report-category" ng-class="{\'toggle-filter-min\': !vm.toggleConfig.customDeviceShow}" style="text-align:center;background-color:transparent !important;border: none"><span id=show-dev-cat ng-click="vm.minimizeSection(\'customDeviceShow\')" class=show-dev-cat style=margin-left:-5px;margin-top:-4px>></span><h3 class=panel-title style="display:block; text-align: center;margin-bottom: 20px;margin-top: 5px; font-weight:300">CUSTOM DEVICE REPORTS</h3><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="height: 196px"><div class=form-group style="margin-top: 15px"><span>Devices</span><select id=device-type class=form-control ng-model=vm.chosenDeviceType ng-options="option for option in vm.deviceTypes" required></select></div><div class=form-group style="margin-top: 15px" ng-show="vm.chosenDeviceReport === \'Availability\' && vm.chosenDeviceMetricType === \'Availability\'"><span>Availability By</span><select id=device-type class=form-control ng-model=vm.chosenAvailabilityType ng-options="option.id as option.name for option in vm.availabilityTypes" required></select></div><div class=form-group style="margin-top: 15px" ng-show="vm.chosenDeviceReport === \'Collections\'"><span>Collections</span><select id=device-category class=form-control ng-model=vm.chosenDeviceCategory ng-options="option.id as option.name for option in vm.deviceCategories" required></select></div><div class=form-group style="margin-top: 15px" ng-show="vm.chosenDeviceReport === \'Dynamic Apps\'"><span>Dynamic Apps</span><select id=dynamic-app class=form-control ng-model=vm.chosenDynamicApp ng-options="option.id as option.name for option in vm.dynamicApps" required></select></div><div class=form-group style="margin-top: 15px" ng-show="vm.chosenDeviceReport === \'Interfaces\'"><span>Direction</span><select id=device-direction class=form-control ng-model=vm.chosenDeviceDirection ng-options="option.id as option.name for option in vm.deviceDirections" required></select></div><div class=form-group ng-show="vm.chosenDeviceReport === \'Interfaces\'" style="margin-top: 15px"><span>Unit</span><select id=device-category class=form-control ng-model=vm.interfaceUnit ng-options="option.id as option.name for option in vm.utilUnits" required></select></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class=form-group style="margin-top: 15px"><span>Report Type</span><select id=device-type class=form-control ng-model=vm.chosenDeviceReport ng-options="option for option in vm.deviceReportTypes" required></select></div><div class=form-group ng-show="vm.chosenDeviceReport === \'Interfaces\'" style="margin-top: 15px"><span>Sort By</span><select id=device-category class=form-control ng-model=vm.interface ng-options="option.id as option.name for option in vm.utilTypes" required></select></div></div></div><div style="width:100%; text-align:center;padding-top: 15px;clear: both"><button class="report-category report-select" type=button ng-click="vm.getDataUtil(vm.chosenDeviceDirection, vm.chosenDeviceType, vm.chosenDeviceCategory)" style="text-align:center; font-size: 12px">RUN</button></div></div><!-- </div> --></div></div><!-- <div class="tab-pane active report-shadow" id="3b" ng-show="vm.tabView === \'schedule\'">\n                        <div class="panel panel-default left-report-panel schedule-rep"\n                            style="border-top-left-radius: 0px !important;">\n                            <div class="panel-heading brd-bottom dev-report-category"\n                                ng-class="{\'toggle-filter-min\': !vm.toggleConfig.selectedReportsShow}"\n                                style="text-align:center; border: none;border-bottom:1px solid white;background-color:transparent !important;padding-bottom:35px">\n                                <span id="show-dev-cat" ng-click="vm.minimizeSection(\'selectedReportsShow\')"\n                                    class="show-dev-cat" style="margin-left:-5px;margin-top:-4px">></span>\n                                <p\n                                    style="text-align:center; font-weight:300; font-size:13px; letter-spacing:1px; margin-bottom:0px">\n                                    SELECTED REPORTS</p>\n                                <dualmultiselect class="selected-report-dual" options="vm.dualListOptions"\n                                    error="vm.error" type="\'schedule\'" id="schedule-options" toggle="vm.toggle">\n                                </dualmultiselect>\n                            </div>\n                            <div class="panel-heading brd-bottom  dev-report-category"\n                                ng-class="{\'toggle-filter-min\': !vm.toggleConfig.emailReportsShow}"\n                                style="text-align:center; padding-bottom: 0px; background-color:transparent !important;">\n                                <span id="show-dev-cat" ng-click="vm.minimizeSection(\'emailReportsShow\')"\n                                    class="show-dev-cat" style="margin-left:-5px;margin-top:-4px">></span>\n                                <p style="text-align:center; font-weight:300; font-size:13px; letter-spacing:1px">EMAIL\n                                    SELECTED REPORTS</p>\n                                <input date-range-picker class="form-control date-picker" type="text"\n                                    placeholder="Select Custom Date Range" ng-model="vm.date"\n                                    style="height:24px; margin-top: 10px; width:49%; display:inline-block; margin-bottom: 20px" />\n                                <button class="button-month btn-clicked thisMonth" id="thisMonth"\n                                    style="margin-bottom:10px;" type="button"\n                                    ng-click="vm.toggleTime(\'This Month\')">This\n                                    Month</button>\n                                <button class="button-month lastMonth" id="lastMonth" type="button"\n                                    ng-click="vm.toggleTime(\'Last Month\')">Last Month</button>\n                                <div ng-click="vm.downloadCustomSummary(vm.selectedSchedule)"\n                                    class="download-cloud-summary" style="margin-bottom: 20px;">\n                                    Email Selected Reports <i class="fa fa-envelope" aria-hidden="true"\n                                        data-toggle="tooltip" title="Download Chart"></i></div>\n                            </div>\n                            <div class="panel-heading brd-bottom  dev-report-category"\n                                ng-class="{\'toggle-filter-min\': !vm.toggleConfig.scheduleReportsShow}"\n                                style="text-align:center; border: none;background-color:transparent !important; padding-top: 0px;">\n                                <span id="show-dev-cat" ng-click="vm.minimizeSection(\'scheduleReportsShow\')"\n                                    class="show-dev-cat" style="margin-left:-5px;margin-top:8px">></span>\n                                <p\n                                    style="text-align:center; font-weight:300; font-size:13px; letter-spacing:1px; margin-top:11px;margin-bottom:0px">\n                                    SCHEDULE SELECTED REPORTS</p>\n\n                                <div class="schedule-label">Schedule Email Frequency</div>\n                                <label class="select-box"\n                                    style="width: 75px; margin-bottom: 18px;margin-top:15px;margin-right:10px">\n                                    <select id="report-type" style="width: 75px" class="form-control"\n                                        ng-model="vm.chosenEmailFrenquency"\n                                        ng-options="option for option in vm.emailFrequency" required></select>\n                                </label>\n                                <button class="report-category report-select" type="button"\n                                    ng-click="vm.setSchedule(\'post\')"\n                                    style="text-align:center; font-size: 12px;">Schedule\n                                    Reports</button>\n                            </div>\n                        </div>\n                    </div> --><div class="tab-pane active report-shadow" id=4b ng-show="vm.tabView === \'summary\'"><div class="panel panel-default left-report-panel schedule-rep" style="border-top-left-radius: 0px !important"><div class="panel-heading brd-bottom dev-report-category" ng-class="{\'toggle-filter-min\': !vm.toggleConfig.summaryShow}" style="text-align:center; background-color:transparent !important; padding-top: 10px;border-bottom:none"><span id=show-dev-cat ng-click="vm.minimizeSection(\'summaryShow\')" class=show-dev-cat style=margin-left:-5px;margin-top:-4px>></span><div class=custom-header style="text-align: center;margin-top:0px">MONTHLY REPORT SUMMARY</div><div class=form-group style=margin-top:20px><div><label for=month style=margin-right:20px>Month</label><label class=select-box><select id=month class=form-control ng-model=vm.chosenMonth ng-options="month for month in vm.months" required></select></label></div><div class=clearfix></div></div><div class=form-group style=margin-bottom:25px><div><label for=year style="margin-right: 25px;margin-left: 11px">Year</label><label class=select-box><select id=year class=form-control ng-model=vm.chosenYear ng-change="vm.updateMonths(\'chosenMonth\', \'chosenYear\')" ng-options="year for year in vm.years" required></select></label></div><div class=clearfix></div></div><div ng-click=vm.downloadSummary() class=download-cloud-summary style="margin-bottom: 20px">Download Monthly Report Summary <i class="fa fa-download" aria-hidden=true data-toggle=tooltip title="Download Chart"></i></div><div style="margin-top: 25px;color: #bdbdbd"><p>Summary reports are the collection of every available report</p></div></div><div class="panel-heading brd-bottom dev-report-category" ng-if=vm.userTAM ng-class="{\'toggle-filter-min\': !vm.toggleConfig.qbrShow}" style="text-align:center; border: none;border-top:1px solid white;background-color:transparent !important; padding-top: 10px;padding-bottom: 25px"><span id=show-dev-cat ng-click="vm.minimizeSection(\'qbrShow\')" class=show-dev-cat style=margin-left:-5px;margin-top:-4px>></span><div class=custom-header style="text-align: center;margin-top:0px">QBR POWERPOINT</div><div style="margin-top: 25px;color: #bdbdbd"><p>QBR reports span three month periods. Please select a beginning month and year.</p></div><div class=form-group style=margin-top:20px><div style="margin-left: -38px"><label for=month style=margin-right:20px>Begin Month</label><label class=select-box><select id=month class=form-control ng-model=vm.chosenQBRMonth ng-options="month for month in vm.months" required></select></label></div><div class=clearfix></div></div><div class=form-group style=margin-bottom:25px><div><label for=year style="margin-right: 25px;margin-left: 11px">Year</label><label class=select-box><select id=year class=form-control ng-model=vm.chosenQBRYear ng-change="vm.updateMonths(\'chosenQBRMonth\', \'chosenQBRYear\')" ng-options="year for year in vm.years" required></select></label></div><div class=clearfix></div></div><div ng-click=vm.downloadQBRPPTX() class=download-cloud-summary style="margin-bottom: 20px"><div class=panel-loader ng-show=vm.qbrLoading><div class="css-loading-qbr css-loading--double" style="margin-top: 6px;right: 27%"></div></div>Download QBR PowerPoint<div class=panel-loader ng-show=vm.qbrLoading><div class="css-loading-qbr css-loading--double"></div></div><i class="fa fa-download" aria-hidden=true data-toggle=tooltip title="Download Chart"></i><p ng-show=vm.qbrLoading>Your report is processing and will begin downloading shortly.</p></div></div></div></div></div></div></div><div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 chart-contain"><div class="well panel panel-default report-container report-shadow" style=width:100%;height:738px><div class="panel-heading brd-bottom" style="background-color:rgba(0,0,0,.2) !important; text-align: center;height: 35px"><h3 class=panel-title style="font-weight: 300;position: absolute;left: 15px">{{vm.table_title}}</h3><button id=show_series class=report-category type=button ng-click=vm.toggleSeries() style="padding: 3px;background-color: #4e4e4e;border: 1px solid #999;margin-left: 20px" ng-show=vm.showTrendButton>{{vm.toggleTrendText}}</button><h3 class=panel-title style="font-weight: 300" ng-show=vm.paTable>{{vm.paTitle}}</h3><div id=filter-type style="float:right; margin-top:-5px" ng-if=vm.callTable><span style=margin-right:15px ng-if=!vm.callAggregate>Call Type</span><select id=call-type ng-if=!vm.callAggregate style="width: 90px;display:inline" class=form-control ng-model=vm.callType ng-change=vm.changeCallReport() ng-options="option for option in vm.callTypes"></select><button class=report-category type=button ng-click=vm.toggleAggregate() style="padding: 3px;background-color: #4e4e4e;border: 1px solid #999;margin-left: 20px">Toggle Aggregate</button></div></div><div class=panel-body><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><highchart id=highchart config=vm.config class=highcharts></highchart></div></div></div><div class=clearfix></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-content no-padding" style=margin-bottom:40px><div class="well panel panel-default report-shadow" id=activity-table style=min-height:500px><div class=panel-loader ng-show=vm.loadingTable><div class="css-loading css-loading--double"></div></div><div class="panel-heading brd-bottom"><h3 class=panel-title>{{vm.table_title}}</h3><h3 class=panel-title style=margin-left:35px ng-if="vm.callTable && vm.callAggregate">Aggregated Dataset</h3><h3 class=panel-title style=margin-left:35px ng-if="vm.callTable && !vm.callAggregate">Non-Aggregated Dataset</h3><button class=report-category type=button ng-click=vm.clearFilter() ng-show=vm.filter style=margin-left:5px>Clear Filter</button></div><div class=panel-body ng-if=vm.showMainTable ng-show=!vm.callAggregate><div class=table-responsive><table class="table table-striped" datatable="" dt-options=vm.dtOptions dt-columns=vm.dtColumns dt-instance=vm.dtInstance class="row-border hover" id=reportTable></table></div></div><!-- <div class="panel-body" ng-if="vm.callTable && vm.callAggregate">\n                    <div class="table-responsive" ng-if="!vm.loadingTable && vm.static_table.length > 0">\n                        <table class="table table-striped" datatable="ng" width="100%" cellspacing="0"\n                            dt-instance="vm.dtInstanceCall" dt-options="vm.dtOptionsCall" id="call-table">\n                            <thead>\n                                <tr ng-if="!vm.callDataByDate">\n                                    <th>Device Name</th>\n                                    <th>Device Class</th>\n                                    <th>Application Name</th>\n                                    <th>Audio Calls</th>\n                                    <th>Audio Hours</th>\n                                    <th>Video Calls</th>\n                                    <th>Video Hours</th>\n                                    <th>Total Calls</th>\n                                    <th>Total Hours</th>\n                                </tr>\n                                <tr ng-if="vm.callDataByDate">\n                                    <th>Date</th>\n                                    <th>Calls</th>\n                                    <th ng-show="false"></th>\n                                    <th ng-show="false"></th>\n                                    <th ng-show="false"></th>\n                                    <th ng-show="false"></th>\n                                    <th ng-show="false"></th>\n                                    <th ng-show="false"></th>\n                                    <th>Hours</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat="item in vm.static_table" ng-if="!vm.callDataByDate"\n                                    ng-class="{\'total-bg\': item.device_name == \'METRICS TOTAL\'}">\n                                    <td>\n                                        <a ng-if="item.device_name != \'METRICS TOTAL\'"\n                                            ng-click="vm.goToDevice(item.device_name)">{{item.device_name}}</a>\n                                        <div ng-if="item.device_name == \'METRICS TOTAL\'">{{item.device_name}}</div>\n                                    </td>\n                                    <td>{{item.device_class}}</td>\n                                    <td>{{item.app_name}}</td>\n                                    <td>{{item.audioCalls}}</td>\n                                    <td>{{item.audioHours}}</td>\n                                    <td>{{item.videoCalls}}</td>\n                                    <td>{{item.videoHours}}</td>\n                                    <td>{{item.calls}}</td>\n                                    <td>{{item.hours}}</td>\n                                </tr>\n                                <tr ng-repeat="item in vm.static_table" ng-if="vm.callDataByDate"\n                                    ng-class="{\'total-bg\': item.date == \'METRICS TOTAL\'}">\n                                    <td>{{item.date}}</td>\n                                    <td>{{item.calls}}</td>\n                                    <td ng-show="false"></td>\n                                    <td ng-show="false"></td>\n                                    <td ng-show="false"></td>\n                                    <td ng-show="false"></td>\n                                    <td ng-show="false"></td>\n                                    <td ng-show="false"></td>\n                                    <td>{{item.hours}}</td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div> --><div class=panel-body ng-if="!vm.showMainTable && vm.deviceMetricTable"><div class=table-responsive ng-if="!vm.loadingTable && vm.static_table.length > 0"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.dtInstanceMetric dt-options=vm.dtOptionsMetric id=device-metric><thead><tr ng-if=!vm.filter><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Device Name</th><th>Category</th><th>Class</th><th>Short Description</th><th>IP Address</th><th>{{vm.vitalName}}</th></tr><tr ng-if=vm.filter><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Device Name</th><th>Category</th><th>Class</th><th>Short Description</th><th>IP Address</th><th>{{vm.vitalName}}</th><th>Date</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr ng-if=!vm.filter><th></th><th bw-column-filter dt-instance=vm.dtInstanceMetric filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceMetric filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstanceMetric filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstanceMetric filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceMetric filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceMetric filter-type=text></th></tr><tr ng-if=vm.filter><th></th><th bw-column-filter dt-instance=vm.dtInstanceMetric filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceMetric filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstanceMetric filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstanceMetric filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceMetric filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceMetric filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceMetric filter-type=text></th></tr></tfoot><tbody><tr ng-if=!vm.filter ng-repeat="item in vm.static_table"><td></td><td><a ng-click=vm.goToDevice(item.name)>{{item.name}}</a></td><td>{{item.category}}</td><td>{{item.sys_class_name}}</td><td>{{item.short_description}}</td><td>{{item.ip_address}}</td><td>{{item[vm.vitalName]}}</td></tr><tr ng-if=vm.filter ng-repeat="item in vm.static_table track by $index"><td></td><td><a ng-click=vm.goToDevice(item.name)>{{item.name}}</a></td><td>{{item.category}}</td><td>{{item.sys_class_name}}</td><td>{{item.short_description}}</td><td>{{item.ip_address}}</td><td>{{item[vm.vitalName]}}</td><td>{{item.date}}</td></tr></tbody></table></div></div><div class=panel-body ng-if="!vm.showMainTable && vm.deviceTable"><h3 ng-if="!vm.loadingTable && vm.static_table.length === 0" class=panel-title style=color:white>No Data</h3><div class=table-responsive ng-if="!vm.loadingTable && vm.static_table.length > 0"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.dtInstanceUtil dt-options=vm.dtOptionsUtil id=device-EM7-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th ng-if="vm.sortType != \'device\'">Interface</th><th>Device Name</th><th>Status</th><th>Category</th><th>Class</th><th>IP Address</th><th ng-if="vm.chosenDeviceReport === \'Interfaces\'">Utilization {{vm.utilUnit}}</th><th ng-if="vm.chosenDeviceReport === \'Availability\'">{{vm.chosenDeviceMetricType}}</th><th ng-if="vm.chosenDeviceReport === \'Collections\'">{{vm.customTitle}} {{vm.utilUnit}}</th><th ng-if="vm.chosenDeviceReport === \'Dynamic Apps\'">{{vm.customTitle}} {{vm.utilUnit}}</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th ng-if="vm.sortType != \'device\'" bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.static_table"><td></td><td ng-if="vm.sortType != \'device\'">{{item.interface}}</td><td><a ng-click=vm.goToDevice(item.name)>{{item.name}}</a></td><td>{{vm.sl_states[item.state]}}</td><td>{{item.deviceClass.deviceCategory.name}}</td><td>{{item.deviceClass.class}}</td><td>{{item.ip}}</td><td>{{item.value}}</td></tr></tbody></table></div></div><div class=panel-body ng-if="!vm.showMainTable && vm.eventTable"><div class=table-responsive ng-if="!vm.loadingTable && vm.static_table.length > 0"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs id=eventTable><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th></th><th>Device Name</th><th>Event Message</th><th>Acknowledged</th><th>Ticket</th><th>Last Detected</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="event in vm.static_table"><td></td><td><span style=position:absolute;margin-left:7px;margin-top:1.5px>{{vm.severity[event.severity] | limitTo:1}}{{(vm.severity[event.severity] == \'\')?\'0\':\'\'}}</span> <img ng-src="assets/img/icon/network_{{vm.severity[event.severity] | limitTo:1}}.png" width=20 height="" style=height:auto><div style=position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px tooltips tooltip-template={{vm.severityWord[event.severity]}} tooltip-side=right></div></td><td><a ng-click=vm.goToDevice(event.aligned_resource_name)>{{event.aligned_resource_name}}</a></td><td>{{ event.message | limitTo: 100 }}{{event.message.length > 100 ? \'...\' : \'\'}}</td><td>{{ event.user_acknowledged}}</td><td>{{ event.ext_ticket_ref}}</td><td>{{ (event.date_active > 0 ? event.date_active : event.date_first)*1000 | date:\'medium\'}}</td></tr></tbody></table></div></div><div class=panel-body ng-if="!vm.showMainTable && vm.paTable"><div class=table-responsive ng-if="!vm.loadingTable && vm.static_table.length > 0"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.dtInstancePA dt-options=vm.dtOptionsPA dt-column-defs=vm.dtColumnDefsPA id=pa-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Period</th><th>Value</th><th ng-show=vm.chosenPABreakdown>Element</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstancePA filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstancePA filter-type=text></th><th ng-show=vm.chosenPABreakdown bw-column-filter dt-instance=vm.dtInstancePA filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.static_table"><td></td><td>{{item.period}}</td><td>{{item.value_formatted}}</td><td ng-show=vm.chosenPABreakdown>{{item.element}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/requests/newinternalrequest.html','<div class="container container-top no-padding new-ticket" id=int-req><div class=row><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-content no-padding" style=margin-bottom:50px><div class="well well-padding open-contain no-padding" style="background-color:transparent; border: none"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class="row open-row" style="margin-bottom: 50px"><form name=request_new ng-submit="vm.create(vm.request, request_new.$valid)"><div class=col-xs-12 ng-show=vm.error><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=vm.close_notice($index)>{{alert.msg}}</div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><h4 class="title open-title" style="font-weight: 400 !important;margin-top: 23px!important">Internal Request</h4></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" id=request-info><div class=description-box style="margin-top:0px;margin-bottom: 10px"><p>Use this ticket to request information or action related to a BCS service, e.g. request new user, request device decommissioning.</p></div></div><div class=req-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class=form-group><label for=short_description>Short Description * <small style=font-size:75%>Required<small></small></small></label><input type=text class=form-control id=short_description placeholder="" ng-model=vm.request.short_description placeholder="" ng-required=true required><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class=form-group><label for=start_date>Needed By * <small style=font-size:75%>Required<small></small></small></label><p class=input-group><input id=start_d name=start_d type=text class=form-control datetime-picker="MM/dd/yyyy HH:mm" ng-model=vm.request.due_date is-open=vm.start_date ng-required=true> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.start_date = !vm.start_date"><i class="fa fa-calendar"></i></button></span></p><div class=clearfix></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class=col-xs-12><div class=form-group><label for=short_description class=int-textarea-label>Description<br><small style=font-size:75%>* Required<small></small></small></label><textarea class=form-control ng-model=vm.request.description placeholder="Max 100 Words" rows=5 ng-required=required></textarea><div class=clearfix></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class=col-xs-12><div class=form-group><label for=justification class=int-textarea-label>Business Justification<br><small style=font-size:75%>* Required<small></small></small></label><textarea class=form-control ng-model=vm.newRequestDescrFields.businessJustification placeholder="Max 100 Words" rows=5 ng-required=required></textarea><div class=clearfix></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class=col-xs-12><div class=form-group><label for=impact class=int-textarea-label>Impact<br><small style=font-size:75%>* Required<small></small></small></label><textarea class=form-control ng-model=vm.newRequestDescrFields.impact placeholder="Max 100 Words" rows=5 ng-required=required></textarea><div class=clearfix></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class=col-xs-12><div class=form-group><label for=risk class=int-textarea-label>Risk</label><textarea class=form-control ng-model=vm.newRequestDescrFields.risk placeholder="Max 100 Words" rows=5></textarea><div class=clearfix></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class=col-xs-12><div class=form-group><label for=scope class=int-textarea-label>Scope</label><textarea class=form-control ng-model=vm.newRequestDescrFields.scope placeholder="Max 100 Words" rows=5></textarea><div class=clearfix></div></div></div></div></div><div class=basic-info-contain style="width: 94.3%;margin-left: 3%;margin-bottom:20px"><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel first-panel" style="border: 1px solid #525252;margin-right: 20px"><div class=form-group><div class=col-xs-3><label for=Contact>Client</label></div><div class=col-xs-8><p class=input-group><input type=text class=form-control id=req-client ng-model=vm.newRequestDescrFields.client placeholder=""> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.company()><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=caller_id ng-model=vm.newRequestDescrFields.client placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=Contact>Preferred Owner</label></div><div class=col-xs-8><p class=input-group><input type=text class=form-control id=status-contact ng-model=vm.newRequestDescrFields.preferredOwner placeholder=""> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.searchUser(\'preferred\')"><i class="fa fa-user-plus"></i></button></span></p></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=Contact>Owner</label></div><div class=col-xs-8><p class=input-group><input type=text class=form-control id=status-contact ng-model=vm.newRequestDescrFields.owner placeholder=""> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.searchUser()><i class="fa fa-user-plus"></i></button></span></p></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=category-request>Priority</label></div><div class=col-xs-8><label class=select-box><select id=approval class=form-control ng-model=vm.request.priority placeholder=Priority ng-options="option.id as option.name for option in vm.priority"></select></label></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=category-request>Type</label></div><div class=col-xs-8><label class=select-box><select id=approval class=form-control ng-model=vm.newRequestDescrFields.type placeholder=Type ng-options="option for option in vm.types"></select></label></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel" style="border: 1px solid #525252"><div class=form-group><div class=col-xs-3><label for=Status>Status</label></div><div class=col-xs-8><label class=select-box><select id=Status class=form-control ng-model=vm.request.request_state ng-options="option.id as option.name for option in vm.states"></select></label></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=Status>Needs Further Scoping</label></div><div class=col-xs-8><label class=select-box><select id=Status class=form-control ng-model=vm.newRequestDescrFields.needsFurtherScoping ng-options="option for option in vm.scoping"></select></label></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=Contact>MRR</label></div><div class=col-xs-8><input type=text class=form-control id=mrr ng-model=vm.newRequestDescrFields.mRR placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=risk>Associated Tasks</label></div><div class=col-xs-8><textarea class=form-control style="width: 100%;height: 100px" ng-model=vm.newRequestDescrFields.associatedTasks placeholder="Comma Separated List" rows=5></textarea></div><div class=clearfix></div></div></div></div><div class=req-contain style="width: 94.6%"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=form-group><label for=notes class=int-textarea-label>Notes</label><textarea class=form-control ng-model=vm.newRequestDescrFields.notes placeholder="No Text Limit" rows=5 ng-required=required></textarea><div class=clearfix></div></div></div></div><div class=form-group><div class=col-xs-12><a class=attach-contain ng-click=vm.attachment() style="margin-left: 17px">Attachment <img class=attach-icon src=assets/img/icon/attach.png></a></div><div class=clearfix></div></div><div class=form-group style=text-align:center><div class=col-xs-12><button class="btn btn-primary btn-block" type=submit ng-="request_new.$invalid || vm.loading">CREATE</button></div><div class=clearfix></div></div></form></div></div></div></div></div>');
$templateCache.put('app/requests/newrequest.html','<div class="container container-top no-padding new-ticket"><div class=row><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-content no-padding" style=margin-bottom:50px><div class="well well-padding open-contain no-padding" style="background-color:transparent; border: none"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class="row open-row"><form name=request_new ng-submit="vm.create(vm.request, request_new.$valid)"><ul class="list-unstyled list-inline header-alerts" style="padding: 10px !important;width: 100%;min-height: 40px"><li style="letter-spacing: 1px"><div ng-repeat="alert in vm.alerts" close=vm.close_notice($index)><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px;margin-top: -5px"> {{alert.msg}}<button type=button class="btn btn-default remove-alert" style="font-size: 10px;margin-left: 10px" ng-click=vm.close_notice($index)><i class="fa fa-times"></i></button></div></li></ul><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><h4 class="title open-title" style="font-weight: 400 !important;margin-top: 23px">New Request</h4></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" id=request-info><div class=description-box style=margin-top:0px><p>Use this ticket to request information or action related to a BCS service, e.g. request new user, request device decommissioning.</p></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="padding-right: 35px"><div class=form-group><label for=openedBy>Opened By</label><input type=text class=form-control id=opened_by_name ng-model=vm.opened_by_name placeholder="" disabled><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class=form-group><div class=col-xs-12><label for=contact>Requested For</label><p class=input-group><input type=text class=form-control id=contact ng-model=vm.caller_name placeholder="" ng-required=true required> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.contact(\'opened_by\')"><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=caller_id ng-model=vm.caller_id placeholder=""></div><div class=clearfix></div></div></div><div class=form-group style="text-align: center"><div class=col-xs-12><label for=type_of_request>Priority</label></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3></div><div class=col-xs-6><div style="width: 105px;margin: 0 auto"><label><input type=radio name=req_type[] value=5 ng-model=vm.request.priority><span>Informational</span></label><br><label><input type=radio name=req_type[] value=4 ng-model=vm.request.priority><span>Minimal</span></label><br><label><input type=radio name=req_type[] value=3 ng-model=vm.request.priority><span>Moderate</span></label><br><label><input type=radio name=req_type[] value=2 ng-model=vm.request.priority><span>High</span></label><br><label><input type=radio name=req_type[] value=1 ng-model=vm.request.priority><span>Critical</span></label></div></div><div class=col-xs-3></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=short_description>Short Description * <small style=font-size:75%>Required<small></small></small></label></div><div class=clearfix></div><div class=col-xs-12><input type=text class=form-control id=short_description placeholder="" ng-model=vm.request.short_description placeholder="" ng-required=true required></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=more_info>Please describe your issue below</label></div><div class=clearfix></div><div class=col-xs-12><textarea style="height: 150px" class=form-control ng-model=vm.request.description placeholder="" rows=5 ng-required=required></textarea></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><a class=attach-contain ng-click=vm.attachment()>Attachment <img class=attach-icon src=assets/img/icon/attach.png></a></div><div class=clearfix></div></div><div class=form-group style=text-align:center><div class=col-xs-12><button class="btn btn-primary btn-block" type=submit ng-disabled="request_new.$invalid || vm.loading">CREATE</button></div><div class=clearfix></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/requests/request.html','<div class="container container-top-ticket col-lg-12 col-md-12 col-sm-12 col-xs-12" style=width:96%><div class="well pd-top" style=min-height:583.4px><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.requests.length == 0"><p>Sorry, no results for tickets.</p></div><div class=table-responsive ng-if="!vm.loading && vm.requests.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=screquestTable><!-- bs-table-control="vm.bsctrl" --><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Priority</th><th>Ticket #</th><th>Device</th><th>Short Description</th><th>Assignment Group</th><th>Assigned To</th><th>Status</th><th>Opened By</th><th>Opened</th><th>Updated</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.requests"><td></td><td class=text-center><span style=position:absolute;margin-left:6px;margin-top:1.5px>{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}</span> <img ng-src="assets/img/icon/network_{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}.png" alt="{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}" width=20 height="" style=height:auto><div style=position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px tooltips tooltip-template="<span style=\'font-weight:400\'>Priority</span>: {{item.priority}}<br>Impact: {{item.impact[0]}}<br>Urgency: {{item.urgency[0]}}" tooltip-side=right tooltip-class=priority-tooltip></div></td><td><a ng-click=vm.goToTicket(item.sys_id)>{{item.number}}</a></td><td><a ng-click=vm.goToDevice(item.cmdb_ci.display_value)>{{item.cmdb_ci.display_value}}</a></td><td>{{item.short_description}}</td><td>{{item.assignment_group.display_value}}</td><td>{{item.assigned_to.display_value | RemoveEmail}}</td><td>{{item.state}}</td><td>{{item.opened_by.display_value | RemoveEmail}}</td><td style=width:100px>{{item.opened_at}}</td><td style=width:100px>{{item.sys_updated_on}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/requests/request_cloudbilling.html','<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 new-ticket" style=position:absolute><div class=row><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-content no-padding" style=margin-bottom:50px><div class="well well-padding open-contain no-padding" style="background-color:transparent; border: none"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><!-- <div class="no-results open-row" ng-show="!vm.loading && vm.requests.length == 0" style="height: 275px;">\n                    <p>Sorry, no results for tickets.</p>\n                </div> --><div class="row open-row" style="min-height: 275px"><div class=no-results ng-show="!vm.loading && vm.requests.length == 0" style="height: 275px"><p>Sorry, no results for tickets.</p></div><div class=table-responsive style="min-height: 200px" ng-if="!vm.loading && vm.requests.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=screquestTable><!-- bs-table-control="vm.bsctrl" --><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Priority</th><th>Ticket #</th><th>Short Description</th><th>Assignment Group</th><th>Assigned To</th><th>Status</th><th>Opened By</th><th>Opened</th><th>Updated</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.requests"><td></td><td class=text-center><span style=position:absolute;margin-left:6px;margin-top:1.5px>{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}</span> <img ng-src="assets/img/icon/network_{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}.png" alt="{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}" width=20 height="" style=height:auto><div style=position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px tooltips tooltip-template="<span style=\'font-weight:400\'>Priority</span>: {{item.priority}}<br>Impact: {{item.impact[0]}}<br>Urgency: {{item.urgency[0]}}" tooltip-side=right tooltip-class=priority-tooltip></div></td><td><a ng-click="vm.goToTicket(item.sys_id, \'cloud\')">{{item.number}}</a></td><td>{{item.short_description}}</td><td>{{item.assignment_group.display_value}}</td><td>{{item.assigned_to.display_value | RemoveEmail}}</td><td>{{item.state}}</td><td>{{item.opened_by.display_value | RemoveEmail}}</td><td style=width:100px>{{item.opened_at}}</td><td style=width:100px>{{item.sys_updated_on}}</td></tr></tbody></table></div></div></div></div></div></div><!-- <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">\n    <div style="    width: 50%;\n    text-align: center;\n    margin-left: 25%;\n    color: white;\n    margin-top: 40vh;\n    border: 1px solid #8b8b8b;\n    padding: 30px;\n    background-color: #333333;\n    border-radius: 3px;">\n        <div>\n            NEW REQUEST\n        </div>\n    </div>\n</div> -->');
$templateCache.put('app/requests/request_cloudbilling_new.html','<iframe class=react-iframe id=micro-frontend-container ng-src={{vm.trustSRC(vm.reactEndpoint)}}></iframe>');
$templateCache.put('app/requests/searchUser.html','<div class="row contact-list-form" style=margin-top:100px><div class=modal-header><h4>Search User</h4></div><div class="modal-body well" id=modal-body><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.users.length == 0 && vm.searchComplete == true && vm.dataExists == false"><p>Sorry No Users found.</p></div><form class=search-company ng-submit=vm.searchUser()><input type=text class=form-control id=search-company ng-model=vm.userTerm placeholder="Search User Name"> <button class="btn btn-primary btn-block" type=submit style=margin-top:10px>Search</button></form><div class=table-responsive ng-show="vm.searchComplete == true && vm.dataExists == true"><table class="table row-border hover" datatable=ng dt-options=vm.dtOptions width=100% cellspacing=0><!-- bs-table-control="vm.bsctrl" --><thead><tr><th>Name</th><th>Company</th></tr></thead><tbody><tr ng-repeat="user in vm.users track by $index"><td><a ng-click=vm.addtolist(user.name)>{{user.name}}</a></td><td><a ng-click=vm.addtolist(user.name)>{{user.company.display_value}}</a></td></tr></tbody></table></div></div><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-4"><input type=button class="btn btn-success btn-block" value=Cancel name=cancel ng-click=vm.close()></div></div></div></div>');
$templateCache.put('app/requests/singlerequest.html','<div class="container container-top-ticket shadow-strong" id=ticket-form><form ng-submit="vm.update(vm.request.sys_id, vm.request)" name=incidentForm><div class=menu-top><ul class="list-unstyled list-inline pull-left" style="padding: 15px"><li><a ng-click=vm.go_back()><img src=assets/img/icon/back-arrow.png width=15 height="" style=height:auto></a></li><li><strong>Request - {{vm.request.number}}</strong></li></ul><ul class="list-unstyled list-inline pull-right list-menu"><li><button class=menu_btn ng-click="vm.action=\'update\'" type=submit ng-disabled="incidentForm.$invalid || vm.loading">Update</button></li><li><button class=menu_btn type=submit ng-show=false ng-disabled="incidentForm.$invalid || vm.loading || !vm.request.comments">Resolve Incident</button></li></ul><ul class="list-unstyled list-inline pull-right"><li><a ng-click=vm.attachment()><img src=assets/img/icon/attach.png width=15 height="" style=height:auto></a></li></ul></div><div class="well incident-wrapper"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=row><ul class="list-unstyled list-inline header-alerts" style="padding: 10px !important;width: 100%;min-height: 40px"><li style="letter-spacing: 1px"><div ng-repeat="alert in vm.alerts" close=vm.close_notice($index)><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px;margin-top: -5px"> {{alert.msg}}<button type=button class="btn btn-default remove-alert" style="font-size: 10px;margin-left: 10px" ng-click=vm.close_notice($index)><i class="fa fa-times"></i></button></div></li></ul><div class=basic-info-contain><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel first-panel"><div class=form-group><div class=col-xs-3><label for=exampleInputEmail1>Number</label></div><div class=col-xs-8><input type=text class=form-control id=req-num ng-model=vm.request.number placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=Contact>Requested For</label></div><div class=col-xs-8><p class=input-group><input type=text class=form-control id=req-for ng-model="vm.request[\'requested_for.name\']" placeholder="" readonly disabled> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.contact(\'requested-for\')" disabled><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=requested_for ng-model=vm.requested_for placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=Contact>Opened By</label></div><div class=col-xs-8><!-- <p class="input-group"> --> <input type=text class=form-control id=req-open ng-model="vm.request[\'opened_by.name\']" placeholder="" readonly disabled><!-- <span class="input-group-btn">\n                                    <button type="button" class="btn btn-default" ng-click="vm.contact(\'opened_by\')" disabled="disabled"><i class="fa fa-user-plus"></i></button>\n                                </span> --><!-- </p> --> <input type=hidden class=form-control id=caller_id ng-model=vm.opened_by placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class="col-xs-3 col-md-3 col-sm-3"><label for=watch_list>Watch List</label></div><div class="col-xs-8 col-md-8 col-sm-8"><a class="box-icon watch-list" ng-show=!vm.watch_list_show ng-click=vm.switch_watchlist()><i class="fa fa-user-plus" aria-hidden=true></i></a><ul class=watch_list_static ng-show=!vm.watch_list_show><li ng-repeat="user in vm.watch_list_users">{{user.name}}</li></ul><div class=row ng-show=vm.watch_list_show><div class="col-xs-12 watch-list-container"><select class=watch-list-select ng-model=vm.watch_list_selected multiple><option value={{user.sys_id}} ng-repeat="user in vm.watch_list_users" ng-if=user.name class=watch-list-selected>{{user.name}}</option></select><div class=watch-list-btns><button type=button class="btn btn-default" ng-click=vm.delete_watchlist() ng-disabled="vm.watch_list_selected.length==0"><i class="fa fa-times"></i></button> <button type=button class="btn btn-default" ng-click=vm.switch_watchlist()><i class="fa fa-unlock"></i></button></div></div><div class=clearfix></div><div class=col-xs-12><p class=input-group><input type=text name=lookup class="lookup form-control"> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.contact()><i class="fa fa-search"></i></button></span></p><p class=input-group><input type=email name=watch_list_email class="email form-control" ng-model=vm.watch_list_email> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.addEmail_watchlist(vm.watch_list_email) ng-disabled="incidentForm.watch_list_email.$invalid || vm.watch_list_email==null || vm.watch_list_email==\'\'"><i class="fa fa-envelope-o"></i></button></span></p></div></div><div class=clearfix></div></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=opened>Opened</label></div><div class=col-xs-8><input type=text class=form-control id=opened ng-model=vm.request.opened_at placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=closed>Closed</label></div><div class=col-xs-8><input type=text class=form-control id=closed ng-model=vm.request.closed_at placeholder="" disabled></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel"><div class=form-group><div class=col-xs-3><label for=Contact>Contact Type</label></div><div class=col-xs-8><input type=text class=form-control id=contact-type ng-model=vm.request.contact_type placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=assignment-group>Assignment Group</label></div><div class=col-xs-8><input type=text class=form-control id=assignment-group ng-model="vm.request[\'assignment_group.name\']" placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=assigned-to>Assigned To</label></div><div class=col-xs-8><input type=text class=form-control id=assigned-to ng-model="vm.request[\'assigned_to.name\']" placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=priority>Priority</label></div><div class=col-xs-8><input id=impact class=form-control ng-model=vm.priorities[vm.request.priority] disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=status>Status</label></div><div class=col-xs-8><input id=state class=form-control ng-model=vm.stateNames[vm.request.state] disabled></div><div class=clearfix></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div class=form-group><div class=col-xs-12><label for=exampleInputEmail1>Short Description</label></div><div class=col-xs-12><input type=text class=form-control id=short-description placeholder="" ng-model=vm.request.short_description disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=exampleInputEmail1>Description</label></div><div class=col-xs-12><textarea type=text class="form-control webkit-scroll" id=description placeholder="" ng-model=vm.request.description disabled>\n                    </textarea></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=comment>Additional Comments</label></div><div class=col-xs-12><textarea type=text class=form-control id=additional_comment placeholder="" placeholder="" ng-model=vm.request.comments></textarea></div><div class=clearfix></div></div><ul class="list-unstyled list-inline header-alerts" style="padding: 10px !important;width: 100%;min-height: 40px"><li style="letter-spacing: 1px"><div ng-repeat="alert in vm.alerts" close=vm.close_notice($index)><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px;margin-top: -5px"> {{alert.msg}}<button type=button class="btn btn-default remove-alert" style="font-size: 10px;margin-left: 10px" ng-click=vm.close_notice($index)><i class="fa fa-times"></i></button></div></li></ul><div class="form-group text-center"><button class="btn btn-primary btn-md" type=submit ng-click="vm.action=\'update\'" ng-disabled="incidentForm.$invalid || vm.loading">UPDATE</button> <button class="btn btn-primary btn-md" type=submit ng-click="vm.action=\'resolve\'" ng-show=false ng-disabled="incidentForm.$invalid || vm.loading || !vm.request.comments">RESOLVE INCIDENT</button><div class=clearfix></div></div><div class=form-group><div ng-include="\'app/shared/html/_activity.html\'"></div><div class=clearfix></div></div></div></div></div></form></div>');
$templateCache.put('app/reset/reset_password.html','<div class=filter-bg></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" id=log-contain style="height: 100vh;padding: 10px;display:flex"><form id=login-form class="new-log login-form-1" ng-submit=vm.resetPass(vm.user) autocomplete=off><div class=main-login-form><div class=login-group><div style="width: 35px;margin: auto;margin-top: 15px"><img class=logo-icon id=burwood-icon-title width=35px src=./assets/img/icon/burwood_icon2.png></div><p class=sign-in-title>Cloud Services Portal</p><p class=sign-in-title style="font-size: 16px;margin: 0;color: #c4c4c4">Password Reset</p><p class=sign-in-title style="font-size: 16px;margin: 0;color: #c4c4c4;margin-top: 80px;margin-bottom: 75px" ng-if="vm.invalid == true">{{vm.invalid_message}}</p><p class=sign-in-text ng-if="vm.invalid == false">Please Enter New Password</p><div class=form-group style="margin-top: 23px" ng-if="vm.invalid == false"><label for=lg_password class=sr-only>New Password</label><input type=password class=form-control id=lg_password name=lg_password ng-model=vm.user.password ng-disabled=vm.loading placeholder=Password required></div><div class=form-group style="border-bottom: 1px solid;margin-bottom: 24px;margin-top:10px" ng-if="vm.invalid == false"><label for=lg_password2 class=sr-only>Confirm Password</label><input type=password class=form-control id=lg_password2 name=lg_password2 ng-model=vm.user.password2 ng-disabled=vm.loading placeholder="Password Confirm" required></div><div class=form-group style=border-bottom:0><p class=contact-data>Having Trouble Signing In?<br>Contact Support<br>312-592-8387</p></div><button type=submit class=login-button style="margin-top: 34px" ng-disabled="form-signin.$invalid || vm.loading" ng-if="vm.invalid == false"><img class=logo-icon id=burwood-icon width=25px src=./assets/img/icon/burwood_icon2.png> <img class=logo-icon style="width:13px; margin-top:4px; margin-left:3px" src=./assets/img/icon/login_arrow_white.png></button></div><div class="alert alert-danger" ng-show=vm.login_error style="position: absolute;width: 100%;bottom: -28%;border-color: #6a6a6a;background-color: rgba(0, 0, 0, 0.5)">{{vm.alert.msg}}</div></div></form></div>');
$templateCache.put('app/sciencelogic/dashboard.html','<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style=padding:30px><div class="container col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 50px" id=cloudbilling><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding cloud-backpanel no-padding" id=cloudbilling-dashboard><div class="col-lg-6 col-md-6 col-sm-12" style="height: 90vh;border-right: 1px solid #4c4c4c;padding-top: 45px"><div class="dashboard-panel full-panel" style=border:none;background-color:transparent;height:97%><div class=bill-no-data ng-show="vm.widgets.deviceLocations.noData && !vm.widgets.deviceLocations.loading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.widgets.deviceLocations.loading><loading></loading></div><highchart class=highcharts ng-if="!vm.widgets.deviceLocations.loading && !vm.widgets.deviceLocations.noData" config=vm.widgets.deviceLocations.config></highchart></div></div><div class="col-lg-6 col-md-6 col-sm-12" style="height: 45vh;border-bottom: 1px solid #4c4c4c;padding-top: 25px"><div class="dashboard-panel half-panel" style=border:none;background-color:transparent;height:97%><div class=bill-no-data ng-show="vm.widgets.itServices.noData && !vm.widgets.itServices.loading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.widgets.itServices.loading><loading></loading></div><highchart class=highcharts ng-if="!vm.widgets.itServices.loading && !vm.widgets.itServices.noData" config=vm.widgets.itServices.config></highchart></div></div><div class="col-lg-6 col-md-6 col-sm-12" style="height: 45vh;padding-top: 25px"><div class="dashboard-panel half-panel" style=border:none;background-color:transparent;height:97%><div class=bill-no-data ng-show="vm.widgets.dataCenter.noData && !vm.widgets.dataCenter.loading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.widgets.dataCenter.loading><loading></loading></div><highchart class=highcharts ng-if="!vm.widgets.dataCenter.loading && !vm.widgets.dataCenter.noData" config=vm.widgets.dataCenter.config></highchart></div></div></div></div></div>');
$templateCache.put('app/search/search.html','<div class="container container-top"><div class=row><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-content" style="margin-bottom: 15px"><div class="well well-padding"><h5 class=search-result ng-hide="vm.searching || vm.search_results.length == 0">{{vm.search_results.length}} RESULTS</h5><div class=loader ng-show=vm.searching><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.searching && vm.search_results.length == 0"><p>Sorry No Results Found.</p></div><div class="row network-event-list" ng-repeat="result in vm.search_results" ng-hide="vm.searching || vm.search_results.length == 0"><div class="col-lg-1 col-md-1 col-sm-1 col-xs-2"><!-- <a href="#{{result.route_path}}"> --><div><img ng-hide="result.u_device_contact !== undefined" ng-src=assets/img/icon/network_{{result.priority_number}}.png width=50 height="" style=height:auto class=search-priority> <img ng-show="result.u_device_contact !== undefined" ng-src=assets/img/icon/network_3.png width=50 height="" style=height:auto class=search-priority></div></div><div class="col-lg-9 col-md-9 col-sm-8 col-xs-10"><h4 class=media-heading ng-show="result.type_name == \'incident\'">INCIDENT - <span style=font-weight:300>{{result.display_name | limitTo:100}}</span></h4><h4 class=media-heading ng-show="result.type_name == \'problem\'">PROBLEM - <span style=font-weight:300>{{result.display_name | limitTo:100}}</span></h4><h4 class=media-heading ng-show="result.type_name == \'customer_change\'">CUSTOMER CHANGE - <span style=font-weight:300>{{result.display_name | limitTo:100}}</span></h4><h4 class=media-heading ng-show="result.type_name == \'request\'">REQUEST - <span style=font-weight:300>{{result.display_name | limitTo:100}}</span></h4><h4 class=media-heading ng-show="result.type_name == \'device\'">DEVICE - <span style=font-weight:300>{{result.display_name | limitTo:100}}</span></h4><h4 class=media-heading ng-show="result.type_name == \'event\'">EVENT - <span style=font-weight:300>{{result.display_name | limitTo:100}}</span></h4><ul class="list-unstyled list-inline"><li>{{result.search_preview | limitTo:100}}</li><li>&#x25cf;</li><li>{{result.created_on| date:\'medium\'}}</li></ul></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-12"><a ng-show="result.type_name != \'device\'" href={{result.route_path}} class="btn btn-block btn-success btn-sm">View Detail</a> <a ng-show="result.type_name == \'device\'" ng-click=vm.goToDevice(result.display_name) class="btn btn-block btn-success btn-sm">View Detail</a></div></div></div></div></div></div>');
$templateCache.put('app/sso/sso.html','<div class="container container-top col-lg-12 col-md-12 col-sm-12 col-xs-12" id=sso-manager style=padding-left:50px;padding-right:50px><div class=row style="margin-bottom: 15px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding sku-list"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"><div class="panel panel-default left-report-panel interface-panel device-shadow" style="min-height: 500px;height: auto"><div class="panel-heading brd-bottom" style="background-color:rgba(0,0,0,.2) !important; text-align:center"><h3 class=panel-title>SSO Configuration</h3></div><div class="panel-body list-container"><div class=panel-loader ng-show=vm.loading style=text-align:center><div class="css-loading css-loading--double" style=top:240px></div></div><uib-accordion close-others=true id=device-accordion><div uib-accordion-group class=panel-default heading={{Company}} is-open=true id=company-accordion><div uib-accordion-heading><strong style="pointer-events: none">COMPANIES</strong><div class=edit-hover ng-click=vm.newConfig($event) style=float:right><img src=assets/img/icon/plus.png width=" 15" height="" style="float: right;cursor:pointer;margin-top: 2px"> <span class=accordion-subheader>Add SSO Configuration</span></div></div><div class=device-tables ng-repeat="ssoConfig in vm.ssoConfigs track by $index" ng-click="vm.chooseContent(ssoConfig, $index)" style=color:white><div class=sku-title id="{{\'ssoConfigs-company-\'+ $index.toString()}}"><p class=device-contents style="width: 100%; margin: 0px;cursor: pointer">{{ssoConfig.name}} ({{ssoConfig.domain}})</p></div></div></div></uib-accordion></div></div></div></div><div class="col-lg-10 col-md-10 col-sm-12 col-xs-12 no-padding"><div class=container style=width:100% id=account-form-admin><form ng-submit=vm.update() name=ssoForm><div class=menu-top style="text-align: left"><ul class="list-unstyled list-inline" style="padding: 15px;float:left"><li><strong>Company - {{vm.selectedCompany.companyName}}</strong></li></ul><ul class="list-unstyled list-inline header-alerts"><li><div ng-repeat="alert in vm.alerts" close="vm.close_notice(\'alerts\', $index)"><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px"> {{alert.msg}}</div></li></ul><ul class="list-unstyled list-inline pull-right list-menu"><li><button class="btn btn-primary menu_btn btn-md" type=submit ng-disabled="vm.disabled || vm.loading" style="border-radius: 0px 5px 0px 0px;height:51px">UPDATE</button> <button class="menu_btn change-action-button btn btn-delete" type=button ng-click=vm.delete() ng-disabled="vm.disabled || vm.loading" style="margin-left:0px;border-radius: 0px 5px 0px 0px;height:51px;background-color: #b05151!important">DELETE</button></li></ul></div><div class="well incident-wrapper"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=row style="margin-top: 5px;padding-top: 30px"><div class=basic-info-contain style="margin-bottom: 10px"><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="The name of the SSO company.  This needs to be an *exact* match with the ServiceNow record.\n\n                                                        " tooltip-side=down>Company Name</label></div><div class=col-xs-8 id=sso-container><input type=text class=form-control placeholder="" required id=sso-lookup data-ng-model=vm.selectedSSO.name ng-disabled=vm.disabled></div><div class=clearfix></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="The domain of the company.\n\n                                                        Example: burwood.com\n\n                                                        " tooltip-side=down>Domain</label></div><div class=col-xs-8><input type=text class=form-control placeholder="" required data-ng-model=vm.selectedSSO.domain ng-disabled=vm.disabled></div><div class=clearfix></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="A SAML (Security Assertion Markup Language) attribute assertion contains information about a user in the form of a series of attributes. The portal service provider will recognize these formats to extract user information needed for authentication.  \n\n                                                            Example Attribute Formats:\n                                                            \n                                                            Email: urn:oid:0.9.2342.19200300.100.1.3\n                                                            UPN: urn:oid:1.3.6.1.4.1.5923.1.1.1.6\n                                                            Unspecified (generic): name_id\n                                                            " tooltip-side=down>Attribute</label></div><div class=col-xs-8><input type=text class=form-control placeholder="" data-ng-model=vm.selectedSSO.attribute required ng-disabled=vm.disabled></div><div class=clearfix></div></div></div></div></div></div><div class=row style="margin-top: 5px"><div class=basic-info-contain style="margin-bottom: 10px"><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-3><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="Login url for SSO intiation and authentication.  This can be found in the company\'s identity provider metadata.\n                                                                    \n                                                        The BCS Portal uses *Redirect* method of transfer, so be sure to extract the login url labeled \'REDIRECT\'.\n\n                                                        " tooltip-side=down>SSO Login URL</label></div><div class=col-xs-9><input type=text class=form-control placeholder="" ng-model=vm.selectedSSO.sso_login_url required ng-disabled=vm.disabled></div><div class=clearfix></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-3><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="Logout url for SSO intiation and authentication.  This can be found in the company\'s identity provider metadata.\n                                                                    \n                                                        " tooltip-side=down>SSO Logout URL</label></div><div class=col-xs-9><input type=text class=form-control placeholder="" ng-model=vm.selectedSSO.sso_logout_url required ng-disabled=vm.disabled></div><div class=clearfix></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="The URL of the assertion sent from IdP. Only fill this field if you know the asserion domain/URL is different than the main domain of the IdP.\n\n                                                        Example: https://bg.login.burwood.com\n\n                                                        " tooltip-side=down>Assertion URL</label></div><div class=col-xs-8><input type=text class=form-control placeholder="" data-ng-model=vm.selectedSSO.assertionDomain ng-disabled=vm.disabled></div><div class=clearfix></div></div></div></div></div></div><div class=row style="margin-top: 5px"><div class=basic-info-contain style="margin-bottom: 10px"><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-3><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="Signs the redirect request to the client IDP\n\n                                                        " tooltip-side=down>Sign Request</label></div><div class=col-xs-9><input type=checkbox class=form-control style="width:25px;float: left" placeholder="" data-ng-model=vm.selectedSSO.sign_get_request></div><div class=clearfix></div></div></div></div></div></div><div class=row><div><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=webkit-scroll style="height:auto;margin-bottom: 20px;border-radius: 10px"><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div class=form-group><div class=col-xs-12 style="text-align:center;border-bottom: 1px solid #898989"><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="Public certificates of the company\'s identiy provider.  These can be delivered directly or extracted from the IdP\'s metadata or certificate file.\n                                                                    \n                                                                    Formatting of certificates is handled by the Portal.  Direct copy and paste will automatically format correctly upon update.\n\n                                                                    " tooltip-side=down>Certificates</label><img src=assets/img/icon/plus.png width=15 height="" ng-click="vm.addItem(\'selectedSSO\', \'certificates\')" style=margin-left:10px;cursor:pointer class=add-img></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-padding" ng-repeat="cert in vm.selectedSSO.certificates track by $index"><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 no-padding" style="padding-top: 13px"><div ng-attr-id="{{ \'sso-remove-\' + $index }}" class=minus-acct style=height:39px><img src=assets/img/icon/minus.png width=15 height="" ng-click="vm.removeItem(\'selectedSSO\', \'certificates\', $index)" style=margin-left:10px;cursor:pointer class=add-img></div></div><div class="col-lg-11 col-md-11 col-sm-11 col-xs-11 no-padding"><div class=form-group><div class=col-xs-12><textarea type=text class="form-control webkit-scroll" placeholder="" style="height:500px;width: 100%" required ng-model=vm.selectedSSO.certificates[$index]></textarea></div><div class=clearfix></div></div></div></div></div><div class=clearfix></div></div></div></div></div></div></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/status/incident.html','<div class="container container-top-ticket col-lg-12 col-md-12 col-sm-12 col-xs-12" style=width:96%><div class="well pd-top" style=min-height:583.4px><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.incidents.length == 0"><p>Sorry, no results for tickets.</p></div><div class=table-responsive ng-if="!vm.loading && vm.incidents.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=incidentTable><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Expand Parent</th><th>Priority</th><th>Ticket #</th><th>Device</th><th>Short Description</th><th>Assignment Group</th><th>Assigned To</th><th>Status</th><th>Opened By</th><th>Opened</th><th>Updated</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.incidents"><td></td><td><div ng-if="item.child_incidents != \'0\' && vm.childlessParent.indexOf(item.number) === -1" ng-click=vm.expandParent(item.number) ng-class="{\'expand-parent\': item.child_incidents != \'0\'}"><i class="fas fa-angle-double-right fa-lg no-focus" style=cursor:pointer ng-init="click = false" ng-class="{\'turn-down\': click}" ng-click="click = !click"></i></div></td><td class=text-center><span style=position:absolute;margin-left:6px;margin-top:1.5px>{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}</span> <img ng-src="assets/img/icon/network_{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}.png" alt="{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}" width=20 height="" style=height:auto><div style=position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px tooltips tooltip-template="<span style=\'font-weight:400\'>Priority</span>: {{item.priority}}<br>Impact: {{item.impact[0]}}<br>Urgency: {{item.urgency[0]}}" tooltip-side=right tooltip-class=priority-tooltip></div></td><td><a ng-click=vm.goToTicket(item.sys_id)>{{item.number}}</a></td><td><a ng-click=vm.goToDevice(item.cmdb_ci.display_value)>{{item.cmdb_ci.display_value}}</a></td><td>{{item.short_description}}</td><td>{{item.assignment_group.display_value}}</td><td>{{item.assigned_to.display_value | RemoveEmail}}</td><td>{{item.state}}</td><td>{{item.opened_by.display_value | RemoveEmail}}</td><td style=width:100px>{{item.opened_at}}</td><td style=width:100px>{{item.sys_updated_on}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/status/newincident.html','<div class="container container-top no-padding new-ticket"><div class=row><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-content no-padding" style=margin-bottom:50px><div class="well well-padding open-contain no-padding" style="background-color:transparent; border: none"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class="row open-row"><form name=incident_new ng-submit="vm.create(vm.incident, incident_new.$valid)"><ul class="list-unstyled list-inline header-alerts" style="padding: 10px !important;width: 100%;min-height: 40px"><li style="letter-spacing: 1px"><div ng-repeat="alert in vm.alerts" close=vm.close_notice($index)><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px;margin-top: -5px"> {{alert.msg}}<button type=button class="btn btn-default remove-alert" style="font-size: 10px;margin-left: 10px" ng-click=vm.close_notice($index)><i class="fa fa-times"></i></button></div></li></ul><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><h4 class="title open-title" style="font-weight: 400 !important">New Incident</h4></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class=description-box style="margin-bottom: 40px;margin-top:23px"><p>Use this ticket type to identify and track work on unplanned interruptions (or significant degradation) of Services supported by Burwood.</p></div></div><div class="col-lg-12 col-md-12 col-sm-6 col-xs-12"><div class=form-group><div class=col-xs-12><label for=openedBy>Opened By</label></div><div class=col-xs-6 style="padding-right: 35px"><input type=text class=form-control id=opened_by_name ng-model=vm.opened_by_name placeholder="" disabled></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class=form-group><div class=col-xs-12><label for=contact>Contact *</label><p class=input-group><input type=text class=form-control id=contact ng-model=vm.caller_name placeholder="" ng-required=true required> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.contact()><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=caller_id ng-model=vm.caller_id placeholder=""></div><div class=clearfix></div></div><div class=form-group style="text-align: center"><div class=col-xs-12><label for=type_of_request>Urgency * <small style=font-size:75%>Required<small></small></small></label><div class=impact-description><button type=button ng-click="vm.showUrgency = !vm.showUrgency" style="border:1px solid white">More Info</button></div><div ng-show=vm.showUrgency class=urgency-info><br>- A measure of the effect that the Incident is having on the business. Often equal to the extent to which agreed or expected levels of service may be distorted. Together with impact, it is the major means of assigning priority for dealing with Incidents.</div></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3></div><div class=col-xs-6><!-- <label>\n                                        <input type="radio" name="req_type[]" value="5" ng-model="vm.incident.urgency"\n                                            ng-required="!vm.incident.urgency" /><span>Informational</span>\n                                    </label><br> --><label><input type=radio name=req_type[] value=4 ng-model=vm.incident.urgency ng-required=!vm.incident.urgency><span>Minimal</span></label><br><label><input type=radio name=req_type[] value=3 ng-model=vm.incident.urgency ng-required=!vm.incident.urgency><span>Moderate</span></label><br><label><input type=radio name=req_type[] value=2 ng-model=vm.incident.urgency ng-required=!vm.incident.urgency><span>High</span></label><br><label><input type=radio name=req_type[] value=1 ng-model=vm.incident.urgency ng-required=!vm.incident.urgency><span>Critical</span></label></div><div class=col-xs-3></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class=form-group><div class=col-xs-12><label for=cmdb_ci>Select Affected Device</label><p class=input-group><input type=text class=form-control id=select ng-model=vm.device_name placeholder=""> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.device()><i class="fa fa-search"></i></button></span></p><input type=hidden class=form-control id=device_id ng-model=vm.device_id placeholder=""></div><div class=clearfix></div></div><div class=form-group style="text-align: center"><div class=col-xs-12><label for=type_of_request>Impact * <small style=font-size:75%>Required<small></small></small></label><div class=impact-description><button type=button ng-click="vm.showImpact = !vm.showImpact" style="border:1px solid white">More Info</button></div><div ng-show=vm.showImpact style=font-weight:300;font-size:12px;color:white><br>Measure of the business criticality of the affected service<br><br><strong>Minimal</strong> = Service degradation affecting a few users without service interruption, or affecting Burwood\'s ability to deliver service<br><strong>Moderate</strong> = Service Interruption affecting a single user, or service; degradation affecting a few users<br><strong>High</strong> = Service Interruption affecting small number of users, or service degradation affecting many users (large office or multiple small offices)<br><strong>Critical</strong> = Service Interruption affecting whole site or network, mission critical server or service, or critical application on a managed server.<br></div></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3></div><div class=col-xs-6><label><input type=radio name=req_type2[] value=5 ng-model=vm.incident.impact ng-required=!vm.incident.impact><span>Informational</span></label><br><label><input type=radio name=req_type2[] value=4 ng-model=vm.incident.impact ng-required=!vm.incident.impact><span>Minimal</span></label><br><label><input type=radio name=req_type2[] value=3 ng-model=vm.incident.impact ng-required=!vm.incident.impact><span>Moderate</span></label><br><label><input type=radio name=req_type2[] value=2 ng-model=vm.incident.impact ng-required=!vm.incident.impact><span>High</span></label><br><label><input type=radio name=req_type2[] value=1 ng-model=vm.incident.impact ng-required=!vm.incident.impact><span>Critical</span></label></div><div class=col-xs-3></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=form-group><div class=col-xs-12><label for=short_description>Short Description * <small style=font-size:75%>Required<small></small></small></label></div><div class=clearfix></div><div class=col-xs-12><input type=text class=form-control id=short_description placeholder="" ng-model=vm.incident.short_description placeholder="" ng-required=true required></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=more_info>Please describe your issue below</label></div><div class=clearfix></div><div class=col-xs-12><textarea style="height: 150px" class=form-control ng-model=vm.incident.description placeholder="" rows=5 ng-required=required></textarea></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><a class=attach-contain ng-click=vm.attachment()>Attachment <img class=attach-icon src=assets/img/icon/attach.png></a></div><div class=clearfix></div></div><div class=form-group style=text-align:center><div class=col-xs-12><button class="btn btn-primary btn-block" type=submit ng-disabled="incident_new.$invalid || vm.loading">CREATE</button></div><div class=clearfix></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/status/p1phone.html','<div class="container container-top"><div class=row><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-content" style=margin-bottom:50px><div class="well well-padding open-contain" style="background-color:transparent; border: none"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class="row open-row"><form name=incident_new ng-submit="vm.create(vm.incident, incident_new.$valid)"><div class=col-xs-12 ng-show=vm.error><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=vm.close_notice($index)>{{alert.msg}}</div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><h4 class="title open-title" style="font-weight: 400 !important;margin-top: 125px">P1 Voice Ticket<ul class="list-unstyled list-inline"><li><a ng-click=vm.attachment()><img src=assets/img/icon/attach.png width=15 height="" style=height:auto></a></li></ul></h4></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="margin-left: -50px;margin-top: 30px"><div class=form-group><div class=col-xs-12><label for=contact>Contact *</label><p class=input-group><input type=text class=form-control id=contact ng-model=vm.caller_name placeholder="" ng-required=true required> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.contact()><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=caller_id ng-model=vm.caller_id placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=phone>Phone Number/Extenstion *</label></div><div class=clearfix></div><div class=col-xs-12><input type=text class=form-control id=phone placeholder="" ng-model=vm.incident.phone placeholder="" ng-required=true required></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=location>Location *</label></div><div class=clearfix></div><div class=col-xs-12><input type=text class=form-control id=location placeholder="" ng-model=vm.incident.location placeholder="" ng-required=true required></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=form-group><div class=col-xs-12><label for=more_info>Please describe your issue below</label></div><div class=clearfix></div><div class=col-xs-12><textarea style="height: 150px" class=form-control ng-model=vm.incident.description placeholder="" rows=5 ng-required=required></textarea></div><div class=clearfix></div></div><div class=form-group style=text-align:center><div class=col-xs-12><button class="btn btn-primary btn-block" type=submit ng-disabled="incident_new.$invalid || vm.loading">CREATE</button></div><div class=clearfix></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/status/singleincident.html','<div class="container container-top-ticket shadow-strong" id=ticket-form><form ng-submit="vm.update(vm.status.sys_id, vm.status)" name=incidentForm><div class=menu-top><ul class="list-unstyled list-inline pull-left" style="padding: 15px"><li><a ng-click=vm.go_back()><img src=assets/img/icon/back-arrow.png width=15 height="" style=height:auto></a></li><li><strong>Incident - {{vm.status.number}}</strong></li><!-- <li>\n                <a class="servicenow-incident" ng-href="https://burwood.service-now.com/nav_to.do?uri=incident.do?sysparm_query=number%3D{{vm.status.number}}" target="_blank"><img src="assets/img/icon/servicenow-icon.png" width="32" height="" style="height:auto;" data-toggle="tooltip" title="Redirect to Service Now Incident"/></a>\n            </li> --></ul><ul class="list-unstyled list-inline pull-right list-menu"><li><button class=menu_btn ng-click="vm.action=\'update\'" type=submit ng-disabled="incidentForm.$invalid || vm.loading">Update</button></li><li><button class=menu_btn ng-click="vm.action=\'workInProgress\'" style=margin-left:5px type=submit ng-show="vm.ticketOwner === true && vm.status.state == 6" ng-disabled="incidentForm.$invalid || vm.loading">Revert to Work in Progress</button></li><!-- <li>\n          <button class="menu_btn" type="submit" ng-show="false" ng-disabled="incidentForm.$invalid || vm.loading || !vm.status.comments">Resolve Incident</button>\n        </li> --></ul><ul class="list-unstyled list-inline pull-right"><li><a ng-click=vm.attachment()><img src=assets/img/icon/attach.png width=15 height="" style=height:auto></a></li></ul></div><div class="well incident-wrapper"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=row><ul class="list-unstyled list-inline header-alerts" style="padding: 10px !important;width: 100%;min-height: 40px"><li style="letter-spacing: 1px"><div ng-repeat="alert in vm.alerts"><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px;margin-top: -5px"> {{alert.msg}}<button type=button class="btn btn-default remove-alert" style="font-size: 10px;margin-left: 10px" ng-click=vm.close_notice($index)><i class="fa fa-times"></i></button></div></li></ul><div class=basic-info-contain><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel first-panel"><div class=form-group><div class=col-xs-3><label for=exampleInputEmail1>Number</label></div><div class=col-xs-8><input type=text class=form-control id=status-number ng-model=vm.status.number placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=Contact>Contact</label></div><div class=col-xs-8><p class=input-group><input type=text class=form-control id=status-contact ng-model="vm.status[\'caller_id.name\']" placeholder="" readonly disabled> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.contact() disabled><i class="fa fa-user-plus"></i></button></span></p><input type=hidden class=form-control id=caller_id ng-model=vm.caller_id placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=openedBy>Opened By</label></div><div class=col-xs-8><input type=text class=form-control id=openedBy ng-model="vm.status[\'opened_by.name\']" placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class="col-xs-3 col-md-3 col-sm-3"><label for=watch_list>Watch List</label></div><div class="col-xs-8 col-md-8 col-sm-8"><a class="box-icon watch-list" ng-show=!vm.watch_list_show ng-click=vm.switch_watchlist()><i class="fa fa-user-plus" aria-hidden=true></i></a><ul class=watch_list_static ng-show=!vm.watch_list_show><li ng-repeat="user in vm.watch_list_users">{{user.name}}</li></ul><div class=row ng-show=vm.watch_list_show><div class="col-xs-12 watch-list-container"><select class=watch-list-select ng-model=vm.watch_list_selected multiple><option value={{user.sys_id}} ng-repeat="user in vm.watch_list_users" ng-if=user.name class=watch-list-selected>{{user.name}}</option></select><div class=watch-list-btns><button type=button class="btn btn-default" ng-click=vm.delete_watchlist() ng-disabled="vm.watch_list_selected.length==0"><i class="fa fa-times"></i></button> <button type=button class="btn btn-default" ng-click=vm.switch_watchlist()><i class="fa fa-unlock"></i></button></div></div><div class=clearfix></div><div class=col-xs-12><p class=input-group><input type=text name=lookup class="lookup form-control"> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.watch_list()><i class="fa fa-search"></i></button></span></p><p class=input-group><input type=email name=watch_list_email class="email form-control" ng-model=vm.watch_list_email> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.addEmail_watchlist(vm.watch_list_email) ng-disabled="incidentForm.watch_list_email.$invalid || vm.watch_list_email==null || vm.watch_list_email==\'\'"><i class="fa fa-envelope-o"></i></button></span></p></div></div><div class=clearfix></div></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=Contact>Category</label></div><div class=col-xs-8><input type=text class=form-control id=category ng-model=vm.status.category placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=opened>Opened</label></div><div class=col-xs-8><input type=text class=form-control id=opened ng-model=vm.status.opened_at placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=closed>Closed</label></div><div class=col-xs-8><input type=text class=form-control id=closed ng-model=vm.status.closed_at placeholder="" disabled></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel"><div class=form-group><div class=col-xs-3><label for=configuration-item>Device</label></div><div class=col-xs-8><input type=text class=form-control id=configuration-item ng-model="vm.status[\'cmdb_ci.name\']" placeholder="" readonly ng-click=vm.goToDevice(vm.status.cmdb_ci) style="cursor: pointer"></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=Contact>Contact Type</label></div><div class=col-xs-8><input type=text class=form-control id=contact-type ng-model=vm.status.contact_type placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=assignment-group>Assignment Group</label></div><div class=col-xs-8><input type=text class=form-control id=assignment-group ng-model="vm.status[\'assignment_group.name\']" placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=assigned-to>Assigned To</label></div><div class=col-xs-8><input type=text class=form-control id=assigned-to ng-model="vm.status[\'assigned_to.name\']" placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=priority>Priority</label></div><div class=col-xs-8><input type=text class=form-control id=priority ng-model=vm.priority[vm.status.priority] placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=status>Status</label></div><div class=col-xs-8><input type=text class=form-control id=state ng-model=vm.stateNames[vm.status.state] placeholder="" disabled></div><div class=clearfix></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div class=form-group><div class=col-xs-12><label for=exampleInputEmail1>Short Description</label></div><div class=col-xs-12><input type=text class=form-control id=short-description placeholder="" ng-model=vm.status.short_description disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=exampleInputEmail1>Description</label></div><div class=col-xs-12><textarea type=text class="form-control webkit-scroll" id=description placeholder="" ng-model=vm.status.description disabled></textarea><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=comment>Additional Comments</label></div><div class=col-xs-12><textarea type=text class=form-control id=additional_comment placeholder="" ng-model=vm.status.comments></textarea></div><div class=clearfix></div></div></div><ul class="list-unstyled list-inline header-alerts" style="padding: 10px !important;width: 100%;min-height: 40px"><li style="letter-spacing: 1px"><div ng-repeat="alert in vm.alerts" close=vm.close_notice($index)><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px;margin-top: -5px"> {{alert.msg}}<button type=button class="btn btn-default remove-alert" style="font-size: 10px;margin-left: 10px" ng-click=vm.close_notice($index)><i class="fa fa-times"></i></button></div></li></ul><div class="form-group text-center"><button class="btn btn-primary btn-md" type=submit ng-click="vm.action=\'update\'" ng-disabled="incidentForm.$invalid || vm.loading">UPDATE</button> <button class="btn btn-primary btn-md" type=submit ng-click="vm.action=\'resolve\'" ng-show=false ng-disabled="incidentForm.$invalid || vm.loading || !vm.status.comments">RESOLVE INCIDENT</button><div class=clearfix></div></div><div class=form-group><div ng-include="\'app/shared/html/_activity.html\'"></div><div class=clearfix></div></div></div></div></div></form></div>');
$templateCache.put('app/ticket/ticket.html','<div class="container container-top-ticket col-lg-12 col-md-12 col-sm-12 col-xs-12" style=width:96%><div class="well pd-top" style=min-height:583.4px><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.tickets.length == 0"><p>Sorry, no results for tickets.</p></div><div class=table-responsive ng-if="!vm.loading && vm.tickets.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=ticketTable><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th></th><th>Ticket #</th><th>Device</th><th>Short Description</th><th>Assignment Group</th><th>Assigned To</th><th>Status</th><th>Opened</th><th>Updated</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tickets"><td></td><td class=text-center><span ng-show="item.sys_class_name != \'Customer Changes\' && item.sys_class_name != \'Change Request\'" style=position:absolute;margin-left:6px;margin-top:1.5px>{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}</span> <img ng-show="item.sys_class_name != \'Customer Changes\' && item.sys_class_name != \'Change Request\'" ng-src="assets/img/icon/network_{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}.png" alt="{{item.priority | limitTo:1}}{{(item.priority == \'\')?\'5\':\'\'}}" width=20 height="" style=height:auto><div ng-show="item.sys_class_name != \'Customer Changes\' && item.sys_class_name != \'Change Request\'" style=position:absolute;width:20px;height:20px;margin-left:-20px;margin-top:-12.5px tooltips tooltip-template="<span style=\'font-weight:400\'>Priority</span>: {{item.priority}}<br>Impact: {{item.impact}}<br>Urgency: {{item.urgency}}" tooltip-side=right tooltip-class=priority-tooltip></div></td><td><a ng-click="vm.goToTicket(item.number, item.sys_id)">{{item.number}}</a></td><td><a ng-click=vm.goToDevice(item.cmdb_ci.display_value)>{{item.cmdb_ci.display_value}}</a></td><td>{{item.short_description}}</td><td>{{item.assignment_group.display_value}}</td><td>{{item.assigned_to.display_value | RemoveEmail}}</td><td>{{item.state}}</td><td style=width:100px>{{item.opened_at| date:\'medium\'}}</td><td style=width:100px>{{item.sys_updated_on| date:\'medium\'}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/uchangerequest/alert.html','<div class="row reset-form" style=margin-top:30vh><div class=modal-header style="text-align: center"><h4>Burwood Management Portal Notice</h4></div><div class=modal-body id=modal-body style="color:white;font-weight:300; padding: 25px;text-align: center">New Change tickets numbers will start with CHG instead of CUS, users can enter Draft Changes in the Portal with minimal information to start the process or as placeholders, BCS client sign-off will be part of a Change Review step in the new process and Client Change Reviewers can now be technology specific. Reach out to your BCS representative for more information.</div><div class=modal-footer style="text-align: center"><button class="btn btn-primary" type=button ng-click=vm.close()>OK</button></div></div>');
$templateCache.put('app/uchangerequest/newrequest.html','<div class="container container-top no-padding new-ticket" id=new_req><div class=row><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-content no-padding" style=margin-bottom:50px><div class="well well-padding open-contain no-padding" style="background-color:transparent; border: none;padding-top: 0px"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><br><div class="row open-row"><form ng-submit=vm.create_request(vm.request) name=requestForm><ul class="list-unstyled list-inline header-alerts" style="padding: 10px !important;width: 100%;min-height: 40px"><li style="letter-spacing: 1px"><div ng-repeat="alert in vm.alerts" close=vm.close_notice($index)><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px;margin-top: -5px"> {{alert.msg}}<button type=button class="btn btn-default remove-alert" style="font-size: 10px;margin-left: 10px" ng-click=vm.close_notice($index)><i class="fa fa-times"></i></button></div></li></ul><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><h4 class="title open-title" style="font-weight: 400 !important;margin-top: 10px;margin-bottom: 0px !important">New Change</h4></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding-left: 50px;padding-right: 50px"><div class=description-box-change><p>Use this ticket type to formally propose a Change to a Burwood supported or monitored system. CHG record supports standard processes and procedures by providing adequate information for Review and Authorization of proposed changes to systems and services. Initial author/proposer of the CHG is not required to enter all technical information but must assign the CHG ticket to a group with the capacity to provide the required information for Review and Authorization.</p></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12"><div class=form-group style=margin-top:50px><div><label for=requester>Requester *</label><p class=input-group><input type=text class=form-control id=contact ng-model=vm.caller_name placeholder="" ng-required="true\n                                        "> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.contact()><i class="fa fa-search"></i></button></span></p><input type=hidden class=form-control id=caller_id ng-model=vm.caller_id placeholder="" ng-required=true></div><div class=clearfix></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12"><div class=form-group style="margin-bottom: 30px; text-align:center; margin-top:50px"><div><label for=category>Category</label><label class=select-box><select id=category class=form-control ng-model=vm.request.u_category ng-options="option.id as option.name for option in vm.category"></select></label></div><div class=clearfix></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12"><div class=form-group style="margin-bottom: 30px; text-align:center; margin-top:50px"><div><label for=cmdb_ci>Select Device Or Service</label><p class=input-group><input type=text class=form-control id=device_name ng-model=vm.device_name placeholder=""> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.device()><i class="fa fa-search"></i></button></span></p><input type=hidden class=form-control id=device_id ng-model=vm.device_id placeholder=""></div><div class=clearfix></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=form-group style="text-align:center;color: white;font-size: 12px;text-decoration: underline">One Required *<div class=col-xs-12><label><input type=radio name=date_type[] value=0 ng-model=vm.date_type><span>Planned Start Date / Planned End Date</span></label><br><label><input type=radio name=date_type[] value=1 ng-model=vm.date_type><span>Request By Date</span></label><br></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" ng-if="vm.date_type == 0"><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class=form-group><label for=start_date>Start Date *</label><p class=input-group style="width: 100%"><input class=form-control type=datetime-local ng-model=vm.request.start_date id=chg-start ng-required="vm.date_type == 0"></p><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class=form-group><label for=end_date>End Date *</label><p class=input-group style="width: 100%"><input class=form-control type=datetime-local ng-model=vm.request.end_date id=chg-end ng-required="vm.date_type == 0"></p><div class=clearfix></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" ng-if="vm.date_type == 1"><div class="col-lg-3 col-md-3 col-sm-3 col-xs-3"></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-6"><div class=form-group style=margin-bottom:0px><div class=col-xs-12><label for=requested_by_date>Request By Date *</label><p class=input-group style="width: 100%"><input class=form-control type=datetime-local ng-model=vm.request.requested_by_date id=chg-req-by ng-required="vm.date_type == 1"></p></div><div class=clearfix></div></div></div><div class="col-lg-3 col-md-3 col-sm-3 col-xs-3"></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=form-group><div class=col-xs-12><label for=short_description>Short Description *</label><input type=text class=form-control id=short_description ng-model=vm.request.short_description ng-required=true></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=comments>Description *</label><textarea class=form-control style="height: 120px" id=comments ng-model=vm.request.description ng-required=true>\n                                </textarea></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=implementation>Implementation Plan</label><textarea class=form-control style="height: 120px" id=implementation ng-model=vm.request.implementation_plan>\n                                </textarea></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=backout>Backout Plan</label><textarea class=form-control style="height: 120px" id=backout ng-model=vm.request.backout_plan>\n                                </textarea></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=test>Test Plan</label><textarea class=form-control style="height: 120px" id=test ng-model=vm.request.test_plan>\n                                </textarea></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><a class=attach-contain ng-click=vm.attachment()>Attachment <img class=attach-icon src=assets/img/icon/attach.png></a></div><div class=clearfix></div></div><div class=form-group style="margin-bottom: 30px;margin-top: 30px"><div class=col-xs-12 style="text-align: center"><button type=submit class="btn btn-primary btn-block" ng-disabled="requestForm.$invalid || vm.loading">CREATE</button></div><div class=clearfix></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/uchangerequest/request.html','<div class="container container-top-ticket col-lg-12 col-md-12 col-sm-12 col-xs-12" style=width:96%><div class="well pd-top" style=min-height:583.4px><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class="table-responsive dev-report-category chgreq-toggle" ng-class="{\'toggle-chgreq-min\': vm.toggleConfig}" ng-if=!vm.loading><div class=table-header id=chg-app-header style=margin-bottom:10px><span id=show-dev-cat ng-click=vm.minimizeSection() class=show-dev-cat style="margin-left: .5%;margin-top: 0px">></span> Changes Awaiting Your Approval</div><table class="table table-striped" dt-instance=vm.dtApprovalInstance dt-column-defs=vm.dtColumnDefsApproval dt-options=vm.dtApprovalOptions datatable=ng width=100% cellspacing=0 scrollx=true id=changeApprovalTable style="margin:0px !important"><thead><tr><th style="width: 14px" class=nosort2><a class=table-filters-toggle ng-click="vm.showApprovalFilters = !vm.showApprovalFilters"><span class="fa fa-search"></span></a></th><th>Ticket #</th><th>State</th><th>Short Description</th><th>Updated</th></tr></thead><tfoot class=table-filters ng-show=vm.showApprovalFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtApprovalInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtApprovalInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtApprovalInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtApprovalInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.change_approvals"><td></td><td><a ng-click="vm.goToTicket(item[\'document_id.sys_id\'])">{{item[\'document_id.number\']}}</a></td><td>{{item.state}}</td><td>{{item[\'document_id.short_description\']}}</td><td>{{item.sys_updated_on}}</td></tr></tbody></table></div><div class=no-results ng-show="!vm.loading && vm.requests.length == 0"><p>Sorry, no results for tickets.</p></div><div class=table-header style=height:50px ng-if="!vm.loading && vm.requests.length > 0"><div class=chg-select><ul class="nav navbar-nav" id=chg-contain><li class=dropdown uib-dropdown><a aria-haspopup=true uib-dropdown-toggle id=chg-ticks>{{vm.selectedChangeList}} <span class=caret></span></a><ul class=dropdown-menu aria-labelledby=dLabel uib-dropdown-menu style="width: 250px;text-align: center"><li><a ng-click="vm.isNavCollapsed = true;vm.selectedChangeList = \'All Change Tickets\'" class=chg-select-link>All Change Tickets</a></li><li><a ng-click="vm.isNavCollapsed = true;vm.selectedChangeList = \'Maintenance Changes\'" class=chg-select-link>Maintenance Changes</a></li></ul></li></ul></div></div><div class=table-responsive ng-if="!vm.loading && vm.requests.length > 0 && vm.selectedChangeList === \'All Change Tickets\'"><!-- <div class="table-header" style="padding-top: 7px;">All Change Tickets\n            </div> --><table class="table table-striped" dt-instance=vm.dtInstance dt-column-defs=vm.dtColumnDefs dt-options=vm.dtOptions datatable=ng width=100% cellspacing=0 scrollx=true id=changeTable><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Ticket #</th><th>Device</th><th>Short Description</th><th>Assignment Group</th><th>Assigned To</th><th>Status</th><th>Planned Start Date</th><th>Planned End Date</th><th>Opened</th><th>Updated</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.requests"><td></td><td><a ng-click=vm.goToTicket(item.sys_id)>{{item.number}}</a></td><td><a ng-click=vm.goToDevice(item.cmdb_ci.display_value)>{{item.cmdb_ci.display_value}}</a></td><td>{{item.short_description}}</td><td>{{item.assignment_group.display_value}}</td><td>{{item.assigned_to.display_value | RemoveEmail}}</td><td>{{item.state}}</td><td style=width:100px>{{item.start_date}}</td><td style=width:100px>{{item.end_date}}</td><td style=width:100px>{{item.opened_at}}</td><td style=width:100px>{{item.sys_updated_on}}</td></tr></tbody></table></div><div id=popoverContent class=hide>This <em>rich</em><pre>html</pre>content goes inside popover</div><div class=table-responsive ng-if="!vm.loading && vm.requests.length > 0 && vm.selectedChangeList === \'Maintenance Changes\'" style="padding: 10px"><div id=chg-clndr ui-calendar=vm.uiConfig.calendar class="span8 calendar" ng-model=vm.eventSources></div><!-- <table class="table table-striped" dt-instance="vm.dtInstance" dt-column-defs="vm.dtColumnDefs"\n                dt-options="vm.dtOptions" datatable="ng" width="100%" cellspacing="0" scrollx="true" id="changeMaintTable">\n                <thead>\n                    <tr>\n                        <th class="nosort">\n                            <a class="table-filters-toggle" ng-click="vm.showFilters = !vm.showFilters"><span\n                                    class="fa fa-search"></span></a>\n                        </th>\n                        <th>Ticket #</th>\n                        <th>Device</th>\n                        <th>Short Description</th>\n                        <th>Assignment Group</th>\n                        <th>Assigned To</th>\n                        <th>Status</th>\n                        <th>Opened</th>\n                        <th>Updated</th>\n                    </tr>\n                </thead>\n                <tfoot class="table-filters" ng-show="vm.showFilters">\n                    <tr>\n                        <th></th>\n                        <th bw-column-filter dt-instance="vm.dtInstance" filter-type="text"></th>\n                        <th bw-column-filter dt-instance="vm.dtInstance" filter-type="text"></th>\n                        <th bw-column-filter dt-instance="vm.dtInstance" filter-type="text"></th>\n                        <th bw-column-filter dt-instance="vm.dtInstance" filter-type="select"></th>\n                        <th bw-column-filter dt-instance="vm.dtInstance" filter-type="text"></th>\n                        <th bw-column-filter dt-instance="vm.dtInstance" filter-type="select"></th>\n                        <th bw-column-filter dt-instance="vm.dtInstance" filter-type="text"></th>\n                        <th bw-column-filter dt-instance="vm.dtInstance" filter-type="text"></th>\n                    </tr>\n                </tfoot>\n                <tbody>\n                    <tr ng-repeat="item in vm.maintenanceRequests">\n                        <td></td>\n                        <td><a ng-click="vm.goToTicket(item.sys_id)">{{item.number}}</a></td>\n                        <td><a ng-click="vm.goToDevice(item.cmdb_ci.display_value)">{{item.cmdb_ci.display_value}}</a>\n                        </td>\n                        <td>{{item.short_description}}</td>\n                        <td>{{item.assignment_group.display_value}}</td>\n                        <td>{{item.assigned_to.display_value | RemoveEmail}}</td>\n                        <td>{{item.state}}</td>\n                        <td style="width:100px">{{item.opened_at}}</td>\n                        <td style="width:100px">{{item.sys_updated_on}}</td>\n                    </tr>\n                </tbody>\n            </table> --></div></div></div>');
$templateCache.put('app/uchangerequest/singlerequest.html','<div class="container container-top-ticket shadow-strong" id=ticket-form><form ng-submit="vm.update_request(vm.request.sys_id, vm.request)" name=requestForm id=ticket-export><div class=menu-top ng-class="{\'new-change\':vm.newChange}"><ul class="list-unstyled list-inline pull-left"><li><a ng-click=vm.go_back()><img src=assets/img/icon/back-arrow.png width=15 height="" style=height:auto></a></li><li><strong>Change Request - {{vm.request.number}}</strong></li><li ng-if="vm.internalUser == true"><a class=servicenow-incident ng-href="https://burwood.service-now.com/nav_to.do?uri=change_request.do?sysparm_query=number%3D{{vm.request.number}}" target=_blank><img src=assets/img/icon/servicenow-icon.png width=32 height="" style=height:auto data-toggle=tooltip title="Redirect to Service Now Incident"></a></li></ul><ul class="list-unstyled list-inline pull-right list-menu"><li ng-if="vm.draft === false && vm.ticketOwner === true && (vm.request.state === \'-6\' || vm.request.state === \'-7\' || vm.request.state === \'-2\') && vm.request.type !== \'standard\'"><button class="menu_btn change-action-button" ng-click=vm.revertToDraft() type=button style=background-color:#5382a7>Revert To Draft</button></li><li ng-if="vm.isApprover === true && vm.change_approvals && (vm.request.state === \'-6\' || vm.request.state === \'-7\') && vm.approvalNeeded"><button class="menu_btn change-action-button" ng-click="vm.updateApproval(\'approved\')" type=button style=background-color:#448255>Approve</button></li><li ng-if="vm.isApprover === true && vm.change_approvals && (vm.request.state === \'-6\' || vm.request.state === \'-7\')  && vm.approvalNeeded"><button class="menu_btn change-action-button" ng-click="vm.updateApproval(\'rejected\')" type=button style="background-color: rgb(181, 46, 78)">Reject</button></li></ul><ul class="list-unstyled list-inline pull-right" style="margin-top: 4px"><li><a ng-click=vm.export()><img src=assets/img/icon/download.png width=15 height="" style=height:auto></a></li><li><a ng-click=vm.attachment()><img src=assets/img/icon/attach.png width=15 height="" style=height:auto></a></li></ul></div><div class=menu-top style="margin-top: -5px;height: 50px;background-color: rgba(73, 117, 85, 0.68);border-bottom:none; border-radius:0px;overflow:hidden" ng-if="vm.newChange == true"><div class=chevron id=first-chev ng-class="{ \'active-status\': vm.request.state == \'-5\'}"><p class=chevron-text>Draft</p></div><div class=chevron ng-class="{ \'active-status\': vm.request.state == \'-6\'}"><p class=chevron-text style="margin-left: 27%">Internal Approval</p></div><div class=chevron ng-class="{ \'active-status\': vm.request.state == \'-7\'}"><p class=chevron-text style="margin-left: 27%">External Approval</p></div><div class=chevron ng-class="{ \'active-status\': vm.request.state == \'-2\'}"><p class=chevron-text>Scheduled</p></div><div class=chevron ng-class="{ \'active-status\': vm.request.state == \'-1\'}"><p class=chevron-text>Implement</p></div><div class=chevron ng-class="{ \'active-status\': vm.request.state == \'0\'}"><p class=chevron-text>Review</p></div><div class=chevron ng-class="{ \'active-status\': vm.request.state == \'3\'}"><p class=chevron-text>Closed</p></div><div class=chevron ng-class="{ \'active-status\': vm.request.state == \'4\'}"><p class=chevron-text>Canceled</p></div></div><div class="well incident-wrapper"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double" style=top:180px></div></div><div class=row><ul class="list-unstyled list-inline header-alerts" style="padding: 10px !important;width: 100%;min-height: 40px"><li style="letter-spacing: 1px"><div ng-repeat="alert in vm.alerts" close=vm.close_notice($index)><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px;margin-top: -5px"> {{alert.msg}}<button type=button class="btn btn-default remove-alert" style="font-size: 10px;margin-left: 10px" ng-click=vm.close_notice($index)><i class="fa fa-times"></i></button></div></li></ul><div class=basic-info-contain><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel first-panel"><div class=form-group><div class=col-xs-3><label for=number>Number</label></div><div class=col-xs-8><input type=text class=form-control id=number ng-model=vm.request.number placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=requested_by>Requested By</label></div><div class=col-xs-8><input type=text class=form-control id=requested_by ng-model=vm.request.requester_name placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class="col-xs-3 col-md-3 col-sm-3"><label for=watch_list>Watch List</label></div><div class="col-xs-8 col-md-8 col-sm-8"><a class="box-icon watch-list" ng-show=!vm.watch_list_show ng-click=vm.switch_watchlist()><i class="fa fa-user-plus" aria-hidden=true></i></a><ul class=watch_list_static ng-show=!vm.watch_list_show><li ng-repeat="user in vm.watch_list_users">{{user.name}}</li></ul><div class=row ng-show=vm.watch_list_show><div class="col-xs-12 watch-list-container"><select class=watch-list-select ng-model=vm.watch_list_selected multiple><option value={{user.sys_id}} ng-repeat="user in vm.watch_list_users" ng-if=user.name class=watch-list-selected>{{user.name}}</option></select><div class=watch-list-btns><button type=button class="btn btn-default" ng-click=vm.delete_watchlist() ng-disabled="vm.watch_list_selected.length==0"><i class="fa fa-times"></i></button> <button type=button class="btn btn-default" ng-click=vm.switch_watchlist()><i class="fa fa-unlock"></i></button></div></div><div class=clearfix></div><div class=col-xs-12><p class=input-group><input type=text name=lookup class="lookup form-control"> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.watch_list()><i class="fa fa-search"></i></button></span></p><p class=input-group><input type=email name=watch_list_email class="email form-control" ng-model=vm.watch_list_email> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.addEmail_watchlist(vm.watch_list_email) ng-disabled="incidentForm.watch_list_email.$invalid || vm.watch_list_email==null || vm.watch_list_email==\'\'"><i class="fa fa-envelope-o"></i></button></span></p></div></div><div class=clearfix></div></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=cmdb_ci>Device</label></div><div class=col-xs-8><p class=input-group><input type=text class=form-control id=cmdb_ci ng-model=vm.device_name placeholder="" ng-disabled="!vm.ticketOwner || !vm.draft" style="cursor: pointer"> <span class=input-group-btn><button type=button class="btn btn-default" ng-click=vm.device() ng-disabled="!vm.ticketOwner || !vm.draft"><i class="fa fa-search"></i></button></span></p><input type=hidden class=form-control id=device_id ng-model=vm.device_id placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=category-request>Category *</label></div><div class=col-xs-8><label class=select-box><select id=chg-cat class=form-control ng-model=vm.request.u_category placeholder=Category ng-options="option.id as option.name for option in vm.category" ng-disabled="!vm.ticketOwner || !vm.draft"></select></label></div><!-- <div class="col-xs-8">\n                <input type="text" class="form-control" id="category-request" ng-model="vm.request.u_category" ng-disabled="!vm.ticketOwner || !vm.draft" placeholder="">\n              </div> --><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 form-panel"><div class=form-group><div class=col-xs-3><label for=risk>Risk</label></div><div class=col-xs-8><select type=text class=form-control id=risk ng-model=vm.request.risk disabled placeholder="" ng-options="option.id as option.name for option in vm.risk"></select></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=risk>Impact</label></div><div class=col-xs-8><select type=text class=form-control id=risk ng-model=vm.request.impact disabled placeholder="" ng-options="option.id as option.name for option in vm.risk"></select></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=approval>Approval</label></div><div class=col-xs-8><label class=select-box><select id=approval class=form-control ng-model=vm.request.approval placeholder=Approval ng-options="option.id as option.name for option in vm.approval" disabled></select></label></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=type>Type</label></div><div class=col-xs-8><label class=select-box><select id=type class=form-control ng-model=vm.request.type placeholder=Type ng-options="option.id as option.name for option in vm.type" disabled></select></label></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=Status>Status</label></div><div class=col-xs-8><label class=select-box><select id=Status class=form-control ng-model=vm.request.state placeholder=Status ng-options="option.id as option.name for option in vm.states" disabled></select></label></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=Contact>Assignment Group</label></div><div class=col-xs-8><input type=text class=form-control id=assignment-group ng-model=vm.request.group placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-3><label for=Contact>Assigned To</label></div><div class=col-xs-8><input type=text class=form-control id=assigned-to ng-model=vm.request.assigned placeholder="" disabled></div><div class=clearfix></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div class=form-group><div class="col-lg-2 col-md-2 col-sm-3 col-xs-3"><label for=approvers>Approvers</label></div><div class="col-lg-10 col-md-10 col-sm-9 col-xs-9"><textarea class="form-control webkit-scroll" style=height:100px type=text ng-model=vm.approverList placeholder="" disabled></textarea></div><div class=clearfix></div></div><div class=form-group><div class="col-lg-2 col-md-2 col-sm-3 col-xs-3"><label for=approvers>Risk and Impact Analysis</label></div><div class="col-lg-10 col-md-10 col-sm-9 col-xs-9"><textarea class="form-control webkit-scroll" style=height:100px type=text ng-model=vm.request.risk_impact_analysis placeholder="" disabled></textarea></div><div class=clearfix></div></div><div class=form-group><div class="col-lg-2 col-md-2 col-sm-3 col-xs-3"><label for=short_description>Short Description *</label></div><div class="col-lg-10 col-md-10 col-sm-9 col-xs-9"><input type=text class=form-control id=short_description ng-model=vm.request.short_description placeholder="" ng-disabled="!vm.ticketOwner || !vm.draft || vm.decom"></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=exampleInputEmail1>Description *</label></div><div class=col-xs-12><textarea type=text class="form-control webkit-scroll" id=description placeholder="" ng-model=vm.request.description ng-disabled="!vm.ticketOwner || !vm.draft">\n                    </textarea></div><div class=clearfix></div></div><div class="col-xs-12 change-subheader">Schedule</div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class=form-group><div class="col-lg-3 col-md-3 col-sm-5 col-xs-5 no-padding"><label for=requested_by_date>Request By Date *</label></div><div class="col-lg-8 col-md-8 col-sm-7 col-xs-7 no-padding"><label class=select-box><p class=input-group style=width:100%><!-- <input class="form-control" type="datetime-local" value="vm.trueDate.requested_by_date" ng-model="vm.trueDate.requested_by_date" id="requested_by_date"  ng-disabled="!vm.ticketOwner || !vm.draft" /> --> <input id=requested_by_date class=form-control ng-model=vm.trueDate.requested_by_date placeholder="" ng-disabled="!vm.ticketOwner || !vm.draft"> <input id=requested_by_date2 class=form-control type=hidden datetime-picker="MM/dd/yyyy HH:mm" ng-model=vm.request.requested_by_date is-open=vm.dateToggle.requested_by_date ng-disabled="!vm.ticketOwner || !vm.draft"> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.openCalendar($event, \'requested_by_date\')" ng-disabled="!vm.ticketOwner || !vm.draft"><i class="fa fa-calendar"></i></button></span></p></label></div><div class=clearfix></div></div><div class=form-group><div class="col-lg-3 col-md-3 col-sm-5 col-xs-5 no-padding"><label for=start_date>Planned Start Date *</label></div><div class="col-lg-8 col-md-8 col-sm-7 col-xs-7 no-padding"><label class=select-box><p class=input-group style=width:100%><!-- <input class="form-control" type="datetime-local" value="vm.trueDate.start_date" ng-model="vm.trueDate.start_date" id="start_date"  ng-disabled="!vm.ticketOwner || !vm.draft" /> --> <input id=start_date class=form-control ng-model=vm.trueDate.start_date placeholder="" ng-disabled="!vm.ticketOwner || !vm.draft"> <input id=start_date2 class=form-control type=hidden datetime-picker="MM/dd/yyyy HH:mm" ng-model=vm.request.start_date is-open=vm.dateToggle.start_date ng-disabled="!vm.ticketOwner || !vm.draft"> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.openCalendar($event, \'start_date\')" ng-disabled="!vm.ticketOwner || !vm.draft"><i class="fa fa-calendar"></i></button></span></p></label></div><div class=clearfix></div></div><div class=form-group><div class="col-lg-3 col-md-3 col-sm-5 col-xs-5 no-padding"><label for=end_date>Planned End Date *</label></div><div class="col-lg-8 col-md-8 col-sm-7 col-xs-7 no-padding"><label class=select-box><p class=input-group style=width:100%><!-- <input class="form-control" type="datetime-local" value="vm.trueDate.end_date" ng-model="vm.trueDate.end_date" id="end_date"  ng-disabled="!vm.ticketOwner || !vm.draft" /> --> <input id=end_date class=form-control ng-model=vm.trueDate.end_date placeholder="" ng-disabled="!vm.ticketOwner || !vm.draft"> <input id=end_date2 class=form-control type=hidden datetime-picker="MM/dd/yyyy HH:mm" ng-model=vm.request.end_date is-open=vm.dateToggle.end_date ng-disabled="!vm.ticketOwner || !vm.draft"> <span class=input-group-btn><button type=button class="btn btn-default" ng-click="vm.openCalendar($event, \'end_date\')" ng-disabled="!vm.ticketOwner || !vm.draft"><i class="fa fa-calendar"></i></button></span></p></label></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class=form-group><div class="col-lg-3 col-md-3 col-sm-5 col-xs-5 no-padding"><label for=work_start>Actual Start</label></div><div class="col-lg-8 col-md-8 col-sm-7 col-xs-7 no-padding"><label class=select-box><input id=work_start class=form-control ng-model=vm.request.work_start ng-disabled=true></label></div><div class=clearfix></div></div><div class=form-group><div class="col-lg-3 col-md-3 col-sm-5 col-xs-5 no-padding"><label for=work_end>Actual End</label></div><div class="col-lg-8 col-md-8 col-sm-7 col-xs-7 no-padding"><label class=select-box><input id=work_end class=form-control ng-model=vm.request.work_end ng-disabled=true></label></div><div class=clearfix></div></div></div><div class="col-xs-12 change-subheader">Planning</div><div class=form-group><div class="col-lg-2 col-md-2 col-sm-3 col-xs-3"><label for=change_plan>Implementation Plan *</label></div><div class="col-lg-10 col-md-10 col-sm-9 col-xs-9"><textarea type=text class="form-control webkit-scroll" id=change_plan ng-model=vm.request.implementation_plan style=height:110px placeholder="" ng-disabled="!vm.ticketOwner || !vm.draft"></textarea></div><div class=clearfix></div></div><div class=form-group><div class="col-lg-2 col-md-2 col-sm-3 col-xs-3"><label for=backout_plan>Backout Plan *</label></div><div class="col-lg-10 col-md-10 col-sm-9 col-xs-9"><textarea type=text class="form-control webkit-scroll" id=backout_plan ng-model=vm.request.backout_plan style=height:110px placeholder="" ng-disabled="!vm.ticketOwner || !vm.draft"></textarea></div><div class=clearfix></div></div><div class=form-group><div class="col-lg-2 col-md-2 col-sm-3 col-xs-3"><label for=test_plan>Test Plan *</label></div><div class="col-lg-10 col-md-10 col-sm-9 col-xs-9"><textarea type=text class="form-control webkit-scroll" id=test_plan ng-model=vm.request.test_plan style=height:110px placeholder="" ng-disabled="!vm.ticketOwner || !vm.draft"></textarea></div><div class=clearfix></div></div><div class="col-xs-12 change-subheader">Comments</div><div class=form-group><div class="col-lg-2 col-md-2 col-sm-3 col-xs-3"><label for=description>Additional Comments</label></div><div class="col-lg-10 col-md-10 col-sm-9 col-xs-9"><textarea class=form-control id=contact ng-model=vm.request.comments style="height: 150px">\n                        </textarea></div><div class=clearfix></div></div><ul class="list-unstyled list-inline header-alerts" style="padding: 10px !important;width: 100%;min-height: 40px"><li style="letter-spacing: 1px"><div ng-repeat="alert in vm.alerts" close=vm.close_notice($index)><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px;margin-top: -5px"> {{alert.msg}}<button type=button class="btn btn-default remove-alert" style="font-size: 10px;margin-left: 10px" ng-click=vm.close_notice($index)><i class="fa fa-times"></i></button></div></li></ul><div class="form-group text-center"><!-- <div class="col-xs-6"> --> <button class="btn btn-primary btn-block" type=submit ng-disabled="requestForm.$invalid || vm.loading">UPDATE</button><!-- </div> --><div class=clearfix></div></div><div class=form-group><div ng-include="\'app/shared/html/_activity.html\'"></div><div class=clearfix></div></div></div></div></div></form></div>');
$templateCache.put('app/userAdmin/confirmation.html','<div class="row reset-form"><div class=modal-header><h4>User Confirmation</h4></div><div class=modal-body id=modal-body style=color:white;font-weight:300>Successfully Created User: {{vm.request.first_name}} {{vm.request.last_name}} Ticket: {{vm.number}} {{vm.additionalMessage}}</div><div class=modal-footer><button class="btn btn-primary" type=button ng-click=vm.close()>OK</button></div></div>');
$templateCache.put('app/userAdmin/domsNewUser.html','<div class="container container-top no-padding new-ticket" id=new_req><div class=row><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-content no-padding" style=margin-bottom:50px><div class="well well-padding open-contain no-padding" style="background-color:transparent; border: none;padding-top: 0px"><div class=panel-loader ng-show=vm.loading style="margin-top: -90px"><div class="css-loading css-loading--double"></div></div><br><div class="row open-row"><form ng-submit=vm.createUser() name=requestForm><!-- <div class="col-xs-12" ng-show="vm.error">\n                            <div uib-alert ng-repeat="alert in vm.alerts" class="alert-{{alert.type}}"\n                                close="vm.close_notice($index)">{{alert.msg}}</div>\n                        </div> --><ul class="list-unstyled list-inline header-alerts" style="margin-top: -20px;width: 100%;text-align:center;padding-top: 33px !important;padding-bottom: 0px !important"><li><div ng-repeat="alert in vm.alerts" close=vm.close_notice($index)>{{alert.msg}}</div></li></ul><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 35px"><h4 class="title open-title" style="font-weight: 400 !important;margin-top: 10px;margin-bottom: 0px !important">User Onboarding</h4></div><!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"\n                            style="padding-left: 50px;padding-right: 50px;">\n                            <div class="description-box-change">\n                                <p>Use this ticket type to formally propose a Change to a Burwood supported or monitored\n                                    system. CHG record supports standard processes and procedures by providing adequate\n                                    information for Review and Authorization of proposed changes to systems\n                                    and services. Initial author/proposer of the CHG is not required to enter all\n                                    technical information but must assign the CHG ticket to a group with the capacity to\n                                    provide the required information for Review and Authorization.</p>\n                            </div>\n                        </div> --><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12"></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=form-group><div class=col-xs-12><label for=first_name>First Name *</label><input type=text class=form-control id=first_name ng-model=vm.request.first_name ng-required=true required></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=form-group><div class=col-xs-12><label for=last_name>Last Name *</label><input type=text class=form-control id=last_name ng-model=vm.request.last_name ng-required=true required></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=form-group><div class=col-xs-12><label for=email>Email *</label><input type=text class=form-control id=email ng-model=vm.request.email ng-required=true required></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=form-group style=padding:10px><div class=col-xs-8><label style="margin-top: 8px">Hardware Needed</label></div><div class=col-xs-4><input type=checkbox class=form-control style="width:25px;float: right" placeholder="" data-ng-model=vm.request.hardware data-ng-true-value="\'true\'"></div><div class=clearfix></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=form-group><div class=col-xs-12><label for=phone_number>Phone</label><input type=text class=form-control id=phone_number ng-model=vm.request.phone_number ng-required=false></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=form-group><div class=col-xs-12><label for=dom_department>Department</label><input type=text class=form-control id=dom_department ng-model=vm.request.department ng-required=true required></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=form-group><div class=col-xs-12><label for=requester>Manager</label><p class=input-group><input type=text class=form-control id=dom_manager ng-model=vm.namager_name placeholder="" ng-required=false> <span class=input-group-btn><button type=button class="btn btn-default" style="height: 34px" ng-click=vm.contact()><i class="fa fa-search"></i></button></span></p><input type=hidden class=form-control id=manager_id ng-model=vm.request.manager placeholder="" ng-required=false></div><div class=clearfix></div></div></div></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12"></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 65px"><div class=form-group style="margin-bottom: 30px;margin-top: 30px"><div class=col-xs-12 style="text-align: center"><button type=submit class="btn btn-primary btn-block" ng-disabled=vm.loading>CREATE</button></div><div class=clearfix></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/userAdmin/logoAttachment.html','<div class=attachment-list-form><div class=modal-header><h4>Logo</h4></div><div class=modal-body id=modal-body><div class=table-responsive style="text-align: center"><div style="color:white;margin-bottom: 10px" ng-if=!vm.logo>No Logo Found</div><div style="color:white;margin-bottom: 10px" ng-if=vm.uploadFail>Failed up upload image. Please ensure logo follows guidelines.</div><p style="color:white;margin-bottom: 30px">Applied to header of monthly invoices.<br>Size: 5mb Max<br>Formats: jpeg, png<br>Dimensions: Square</p><div style=color:white ng-if=vm.logo><!-- <a ng-if="vm.logo" ng-click="vm.downloadAttachment(vm.logo)" style="cursor: pointer;"\n                    target="_blank">{{vm.logo.fileName}}</a> --><div ng-if=vm.logo><img ng-src={{vm.downloadFile}} style="margin-bottom:10px; width:300px;background-color: white"></div><div style=margin-bottom:10px>{{vm.logo.fileName}}</div><button style=margin-bottom:10px ng-if=vm.logo ng-click=vm.deleteAttachment(vm.logo) class="btn btn-danger"><i class="fa fa-trash" aria-hidden=true></i></button></div></div><div class=incident-attachment ng-if=!vm.logo id=logo-upload><form name=attachmentForm class=form-inline><label for=file-upload class=custom-file-upload><i class="fa fa-cloud-upload"></i> Logo Upload</label><input id=file-upload ng-model=vm.upload_file ngf-select=vm.addAttachment() type=" file" name=file></form></div></div><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-4"><input type=button class="btn btn-success btn-block" value=Ok name=cancel ng-click=vm.close()></div></div></div></div>');
$templateCache.put('app/userAdmin/userAdmin.html','<div class="container container-top col-lg-12 col-md-12 col-sm-12 col-xs-12" id=cloudbill-accounts style=padding-left:50px;padding-right:50px><div class="well pd-top" ng-if="!vm.isAdmin && !vm.burwoodManager && !vm.isUserAdmin"><div class=no-results><p>Sorry, you do not have access to this page.</p></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" ng-if="vm.isAdmin || vm.burwoodManager || vm.isUserAdmin"><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 no-padding sku-list"><div class="panel panel-default left-report-panel interface-panel device-shadow" style="min-height: 500px;height: auto"><div class="panel-heading brd-bottom" style="background-color:rgba(0,0,0,.2) !important; text-align:center;padding:15px"><h3 class=panel-title>User Admin</h3></div><div class="panel-body list-container"><div class=panel-loader ng-show=vm.loadingUserList style=text-align:center><div class="css-loading css-loading--double" style=top:240px></div></div><uib-accordion close-others=true id=device-accordion><div uib-accordion-group class=panel-default heading={{Users}} is-open=true><div uib-accordion-heading><strong>Users</strong><div class=edit-hover ng-click=vm.newUser($event) style=float:right ng-if=!vm.disabled><img src=assets/img/icon/plus.png width=" 15" height="" style="float: right;cursor:pointer;margin-top: 2px"> <span class=accordion-subheader>Add User</span></div></div><div class=device-tables ng-repeat="(key, value) in vm.account.users" ng-click=vm.chooseUser(key) style=color:white><div class=sku-title id={{key.toString()}}><p class=device-contents style="width: 100%; margin: 0px" ng-style="{ \'color\' : (value.active == \'true\') ? \'white\' : \'grey\' }">{{value.last_name + \', \' + value.first_name || value.email || value.u_name_id}}</p></div></div></div></uib-accordion></div></div></div><div class="col-lg-7 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 20px"><div class=container style=width:100% id=account-form ng-if="!vm.loadingUserList && vm.account.users.length > 0"><form ng-submit=vm.update(vm.selectedUser) name=userForm><div class=menu-top style="text-align: center"><ul class="list-unstyled list-inline pull-left" style="padding: 15px"><li><strong>User - {{vm.selectedUser.first_name}} {{vm.selectedUser.last_name}}</strong></li></ul><ul class="list-unstyled list-inline header-alerts"><li><div ng-repeat="alert in vm.alerts" close=vm.close_notice(alert,$index)>{{alert.msg}}</div></li></ul><ul class="list-unstyled list-inline pull-right list-menu"><li><button class=menu_btn type=submit ng-disabled="vm.disabled || vm.loading">Update</button></li><li style="margin-left: 5px"><button class="menu_btn menu_btn_red" ng-click=vm.delete() type=button ng-disabled="vm.loading || vm.disabled">Delete</button></li></ul></div><div class="well incident-wrapper"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=row style="margin-top: 5px;padding-top: 30px"><div><div class=basic-info-contain><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-panel first-panel" style=flex:none><div class=form-group><div class=col-xs-4><label for=exampleInputEmail1 tooltips tooltip-class=depo-tooltip tooltip-template="Login ID Used for SSO.  Default to email address if not SSO user." tooltip-side=down>User ID *</label></div><div class=col-xs-8><input type=text class=form-control id=user-name ng-model=vm.selectedUser.user_name placeholder="" ng-disabled=vm.disabled required></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-4><label for=exampleInputEmail1>First Name *</label></div><div class=col-xs-8><input type=text class=form-control id=first-name ng-model=vm.selectedUser.first_name placeholder="" ng-disabled=vm.disabled required></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-4><label for=exampleInputEmail1>Last Name *</label></div><div class=col-xs-8><input type=text class=form-control id=last-name ng-model=vm.selectedUser.last_name placeholder="" ng-disabled=vm.disabled required></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-4><label for=exampleInputEmail1>Email *</label></div><div class=col-xs-8><input type=text class=form-control id=user-email ng-model=vm.selectedUser.email placeholder="" ng-disabled=vm.disabled required></div><div class=clearfix></div></div><div class=form-group ng-if=!vm.cloudUser><div class=col-xs-4><label for=exampleInputEmail1>Role</label></div><div class=col-xs-8><select class=form-control ng-model=vm.selectedGroupSys ng-options="option.id as option.name for option in vm.groups" ng-disabled=vm.disabled required></select></div><div class=clearfix></div></div><div class=form-group ng-if=vm.cloudUser><div class=col-xs-4><label for=exampleInputEmail1>Role</label></div><div class=col-xs-8><select class=form-control ng-model=vm.selectedGroupSys ng-options="option.id as option.name for option in vm.cloudGroups" ng-disabled=vm.disabled required></select></div><div class=clearfix></div></div><div class=form-group ng-if="vm.cloudUser && (vm.selectedGroupSys === \'790be853db022450163905d2ca9619c4\' || vm.selectedGroupSys === \'a560b49fdb0ee810927acf0913961903\')"><div class=col-xs-4><label for=exampleInputEmail1>Department</label></div><div class=col-xs-8><select class=form-control ng-model=vm.selectedDepartment ng-options="option as option.departmentName for option in vm.departments" ng-disabled=vm.disabled required></select></div><div class=clearfix></div></div><div class=form-group ng-if="vm.cloudUser && (vm.selectedGroupSys === \'d6b77b8ddb922490163905d2ca9619a2\' || vm.selectedGroupSys === \'1487f78ddb9ea410927acf0913961964\')"><div class=col-xs-4><label for=exampleInputEmail1>Group</label></div><div class=col-xs-8><select class=form-control ng-model=vm.selectedAdminGroup ng-options="option as option.groupName for option in vm.adminGroups" ng-disabled=vm.disabled required></select></div><div class=clearfix></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-panel" style=flex:none><div class=form-group><div class=col-xs-4><label for=exampleInputEmail1>Title</label></div><div class=col-xs-8><input type=text class=form-control id=user-title ng-model=vm.selectedUser.title placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-4><label for=exampleInputEmail1>Business Phone</label></div><div class=col-xs-8><input type=text class=form-control id=user-phone ng-model=vm.selectedUser.phone placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-4><label for=exampleInputEmail1>Mobile Phone</label></div><div class=col-xs-8><input type=text class=form-control id=user-phone-mobile ng-model=vm.selectedUser.mobile_phone placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group ng-if=!vm.newUserSelected><div class=col-xs-4><label>Active</label></div><div class=col-xs-8><input type=checkbox class=form-control style="width:25px;float: left" placeholder="" data-ng-model=vm.selectedUser.active data-ng-true-value="\'true\'" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-4><label>Send Password Reset Email</label></div><div class=col-xs-8><input type=checkbox class=form-control style="width:25px;float: left" placeholder="" ng-model=vm.passwordReset ng-disabled=vm.disabled tooltips tooltip-class=depo-tooltip tooltip-template="If non-sso (email/password) login is desired, check this box send the user an email with a link to set their password." tooltip-side=right></div><div class=clearfix></div></div></div></div></div><div class="form-group text-center"><button class="btn btn-primary btn-md" type=submit ng-disabled="vm.disabled || vm.loading">UPDATE</button><div class=clearfix></div></div></div></div></form></div></div></div></div>');
$templateCache.put('app/cloudbilling/budget/groupConfig.html','<form class="row contact-list-form" style=margin-top:100px id=group-config ng-submit=vm.close(vm.account)><div class=modal-header><h4 style="display: inline-block">Group Configuration</h4></div><div class="modal-body well" id=modal-body style="height: auto;overflow: auto"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel first-panel" style=flex:none><div ng-repeat="alert in vm.alerts" close=vm.close_notice($index) style=margin-bottom:10px;color:white><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px"> {{alert.msg}}</div><label ng-if=!vm.disabled style="margin-top: 8px;margin-bottom: 20px" tooltips tooltip-class=depo-tooltip tooltip-template="Groups are collections of departments used for reporting and invoicing purposes.\n                                                " tooltip-side=down>Add Group <img src=assets/img/icon/plus.png width=" 15" height="" ng-click=vm.addGroup() style="float: right;cursor:pointer;margin-top: 2px;margin-left: 5px"></label><div ng-repeat="group in vm.account.groups track by $index" ng-init="parentIndex = $index" ng-if=vm.groupIndexes.includes($index) style="border: 1px solid grey;overflow: hidden;padding-top: 20px;border-radius: 5px;margin-bottom: 15px"><div class="col-xs-1 col-md-1 col-sm-1"><img src=assets/img/icon/minus.png width=" 15" height="" ng-if="vm.company.companyName && group.groupName !== vm.company.companyName && !vm.disabled" ng-click=vm.removeGroup($index) style="cursor:pointer;margin-top: 11px"></div><div class="col-xs-11 col-md-11 col-sm-11" style="padding-left: 0px"><div class=form-group style="margin-bottom: 20px"><div class="col-xs-4 col-md-4 col-sm-4"><label for=watch_list style="margin-top: 8px">Group Name</label></div><div class="col-xs-8 col-md-8 col-sm-8"><input type=text class=form-control ng-model=group.groupName ng-disabled="(group.groupName === vm.company.companyName || vm.disabled)" placeholder="" required></div><div class=clearfix></div></div><div class=form-group style="margin-bottom: 20px"><div class="col-xs-4 col-md-4 col-sm-4"><label for=watch_list style="margin-top: 8px">Departments <img src=assets/img/icon/plus.png width=" 15" height="" ng-click=vm.addDepartment($index) ng-if="group.groupName !== vm.company.companyName && !vm.groupInvoicing" style="float: right;cursor:pointer;margin-top: 3px;margin-left: 5px"></label></div><div class="col-xs-8 col-md-8 col-sm-8"><div ng-repeat="department in group.departments track by $index" ng-if=vm.customDepartment(department)><div class="col-xs-10 col-md-10 col-sm-10 no-padding" style="padding-bottom: 5px"><select ng-options="option.departmentID as option.departmentName for option in vm.departments" class=form-control ng-model=vm.account.groups[parentIndex].departments[$index] ng-change="vm.checkDepartmentAllocation(vm.account.groups[parentIndex].departments[$index], $index, parentIndex, \'{{vm.account.groups[parentIndex].departments[$index]}}\')" ng-disabled="\n                                        group.groupName===vm.company.companyName || vm.groupInvoicing" placeholder=""></select></div><div class="col-xs-2 col-md-2 col-sm-2" style="padding-bottom: 5px"><img src=assets/img/icon/minus.png width=" 15" height="" ng-click="vm.removeDepartment($index, parentIndex)" ng-if="group.groupName !== vm.company.companyName && !vm.groupInvoicing" style="cursor:pointer;margin-top: 11px"></div></div></div><div class=clearfix></div></div><div class=form-group style="margin-bottom: 20px"><div class="col-xs-4 col-md-4 col-sm-4"><label for=watch_list style="margin-top: 18px">Users</label></div><div class="col-xs-8 col-md-8 col-sm-8"><ul class=watch_list_static><li ng-repeat="user in group.contactList track by $index" ng-attr-id="{{ \'project-user-\' + $index }}"><img ng-src=assets/img/icon/info.png width=20 height="" ng-click="vm.userPreferences(user, $index)" style="height:auto;margin-right: 10%"> {{user.email}} <button type=button class="btn btn-default" style="float: right;font-size: 12px" ng-click="vm.delete_watchlist($index, parentIndex)"><i class="fa fa-times"></i></button></li></ul><div class=clearfix></div></div><div class=clearfix></div></div><div class=form-group><div class="col-xs-4 col-md-4 col-sm-4"><label for=find-user style="margin-top: 8px">Find User In Database</label></div><div class="col-xs-8 col-md-8 col-sm-8"><div class=row><div class=col-xs-12 style="padding-left: 5px;padding-right: 5px"><p class=input-group id=find-user><span class=input-group-btn><button type=button class="btn btn-default" style="border-radius: 3px;margin-top: 10px" ng-click=vm.openProjectUsers($index)><i class="fa fa-search"></i></button></span></p></div></div><div class=clearfix></div></div><div class=clearfix></div></div><div class=form-group ng-if=!vm.groupInvoicing><div class=col-lg-4><label for=primary-contact-field>Receive Invoice</label></div><div class=col-lg-8><input type=checkbox ng-attr-id="{{ \'alert-check-\' + $index }}" class=form-control style=width:25px ng-model=vm.account.groups[parentIndex].invoiceGroup placeholder=""></div><div class=clearfix></div></div><div class=form-group style="margin-bottom: 15px" ng-if="vm.account.groups[parentIndex].invoiceGroup && !vm.groupInvoicing"><div class=col-xs-4><label style="margin-top: 8px">Billing Email <img src=assets/img/icon/plus.png width=" 15" height="" ng-click="vm.addItem(parentIndex, \'billingContactEmail\')" style="float: right;cursor:pointer;margin-top: 2px;margin-left: 5px"></label></div><div class=col-xs-8><div ng-repeat="billingEmail in vm.account.groups[parentIndex].billingContactEmail track by $index" ng-init="contactIndex = $index"><img src=assets/img/icon/minus.png width=" 15" height="" ng-click="vm.removeItem(parentIndex, contactIndex, \'billingContactEmail\')" style="float: right;cursor:pointer;margin-top: 8px;margin-right: 6.5%"> <input type=text class=form-control placeholder="" ng-model=vm.account.groups[parentIndex].billingContactEmail[contactIndex] style="width: 82.5%;margin-bottom: 5px" ng-disabled=vm.disabled required></div></div><div class=clearfix></div></div><div class=form-group style="margin-bottom: 15px" ng-if=vm.groupInvoicing><div class=col-xs-4><label style="margin-top: 8px">Billing Email *<img src=assets/img/icon/plus.png width=" 15" height="" ng-click="vm.addItem(parentIndex, \'billingContactEmail\')" style="float: right;cursor:pointer;margin-top: 2px;margin-left: 5px" ng-if=!vm.disabled></label></div><div class=col-xs-8><div ng-repeat="billingEmail in vm.account.groups[parentIndex].billingContactEmail track by $index" ng-init="contactIndex = $index"><img src=assets/img/icon/minus.png width=" 15" height="" ng-click="vm.removeItem(parentIndex, contactIndex, \'billingContactEmail\')" ng-if=!vm.disabled style="float: right;cursor:pointer;margin-top: 8px;margin-right: 6.5%"> <input type=text class=form-control placeholder="" required ng-model=vm.account.groups[parentIndex].billingContactEmail[contactIndex] style="width: 82.5%;margin-bottom: 5px" ng-disabled=vm.disabled></div></div><div class=clearfix></div></div><div class=form-group style="margin-bottom: 15px" ng-if=vm.groupInvoicing><div class=col-xs-4><label for=account-number-field style="margin-top: 8px">Purchase Order *</label></div><div class=col-xs-8><input type=text class=form-control autocompleter suggestions=vm.pos ng-focus=vm.focusPOs() notice="\'No PO registered.\'" suggestionclass="\'budget-suggestion\'" suggestionsclass="\'budget-suggestions\'" ng-model=vm.account.groups[parentIndex].invoicePO placeholder="" ng-disabled=vm.disabled required></div><div class=clearfix></div></div><div class=form-group style="margin-bottom: 20px" ng-if=vm.groupInvoicing><div class="col-xs-4 col-md-4 col-sm-4"><label for=watch_list style="margin-top: 8px">Billing Accounts *</label></div><div class="col-xs-8 col-md-8 col-sm-8"><div ng-repeat="billingAccount in vm.account.groups[parentIndex].billingAccounts track by $index"><div class="col-xs-10 col-md-10 col-sm-10 no-padding" style="padding-bottom: 5px"><select ng-options="option.account as option.name for option in vm.company.accounts" class=form-control required ng-change="vm.checkAccountAllocation(vm.account.groups[parentIndex].billingAccounts[$index], $index, parentIndex, \'{{vm.account.groups[parentIndex].billingAccounts[$index]}}\')" ng-model=" vm.account.groups[parentIndex].billingAccounts[$index]" placeholder="" ng-disabled=true></select></div><div class="col-xs-2 col-md-2 col-sm-2" style="padding-bottom: 5px"></div></div></div><div class=clearfix></div></div><!-- <div class="form-group" style="margin-bottom: 15px;" ng-if="vm.groupInvoicing">\n                        <div class="col-xs-4">\n                            <label for="service-fee-field" style="margin-top: 8px;">Service Fee %\n                                *</label>\n                        </div>\n                        <div class="col-xs-8">\n                            <input type="number" class="form-control" placeholder="" min="0" max="100"\n                                ng-model="vm.account.groups[parentIndex].centralTax" required ng-disabled="vm.disabled">\n                        </div>\n                        <div class="clearfix">\n                        </div>\n                    </div> --></div></div></div></div><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-2"><input type=submit class="btn btn-success btn-block" value=Submit name=Submit ng-disabled=vm.disabled></div><div class=col-xs-4><input type=button class="btn btn-success btn-block" value=Cancel name=Cancel ng-click=vm.cancel()></div></div></div></form>');
$templateCache.put('app/cloudbilling/budget/projectMapping.html','<div class="container container-top col-lg-12 col-md-12 col-sm-12 col-xs-12" id=cloudbill-accounts style=padding-left:50px;padding-right:50px><div class=overlay-automation-disabled ng-if=!vm.automationEnabled><div class=overlay-content-automation-disabled><p>Your configuration data has been moved to the new portal and is no longer managed here. Please manage your project configuration at: <a target=_blank href=https://cloudbilling.burwood.com>https://cloudbilling.burwood.com.</a></p><p>If you have any questions, please contact <a href=mailto:portalsupport@burwood.com>portalsupport@burwood.com</a>.</p><p></p></div></div><div class=row style="margin-bottom: 15px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 100px"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding sku-list webkit-scroll" style=height:90vh><div class="panel panel-default left-report-panel interface-panel device-shadow" style="min-height: 338px;height: auto; text-align:center;background-color: rgb(39, 39, 39) !important"><div class="company-heading form-panel first-panel"><h4 style="text-transform: uppercase;font-weight: 100;letter-spacing: 1px">{{vm.companyName}}</h4><span ng-if="(vm.isAdmin || vm.burwoodManager) && !vm.loading" class=preference-btn ng-click="vm.editGroups($event, vm.account)">Group Configuration</span></div><div class="panel-heading brd-bottom" ng-show=!vm.loading style="text-align: left;border-bottom: 1px solid #ffffff29;background-color: rgb(39, 39, 39) !important;text-align: center"><span><div class=panel-loader ng-show="!vm.projectList || !vm.bqProjects"><div class="css-loading-relative css-loading--double" style="width: 10px;height: 10px;margin-left: -1%;margin-top: 4px"></div></div></span><span style="color:rgb(255 197 66); margin-right: 25px" tooltips tooltip-class=state-tooltip tooltip-template="Projects showing no consumption for at least 30 days." tooltip-side=down>Idle Projects</span> <span style="color:rgb(255 95 95)" tooltips tooltip-class=state-tooltip tooltip-template="Projects that have be removed from any billing account and no longer consume." tooltip-side=down>Disabled Projects</span></div><div class="panel-heading brd-bottom text-center"><div class=text-center><input type=checkbox class=mr-1 data-ng-model=vm.hideDisabled> <span>Hide Disabled Projects</span></div><div class=text-center><input type=checkbox class=mr-1 data-ng-model=vm.hideIdle> <span>Hide Idle Projects</span></div></div><div class="panel-heading brd-bottom" style="text-align: left;border-bottom: 1px solid #ffffff29;background-color: rgb(39, 39, 39) !important;text-align: right;min-height: 40px"><h3 class=panel-title style="margin-top: 4px;float:left">GROUPS</h3><div ng-click="vm.editGroups($event, vm.account)" ng-if="!vm.disabled && vm.isAdmin"><div class=edit-hover style="display: inline-block"><span class=accordion-subheader style="margin-top: -1px;float:none">Add Group</span> <img src=assets/img/icon/plus.png width=15 height="" style="cursor:pointer;margin-top: 2px"></div></div></div><div class="panel-body list-container" style="padding: 15px !important"><div id=device-accordion class=cloud-accordion style="text-align: left" ng-if=!vm.loading><div class=panel-default style="padding: 0px" ng-repeat="(gIndex, group) in vm.account.groups" ng-if="vm.isAdmin || vm.adminReadOnly || vm.groupUserIndexes.includes(gIndex)"><div style="background-color: #3b4f46!important"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding accordion-header-btn" style="padding-top: 4px;margin-bottom: 5px;background-color: #3b4f46" ng-class="{\'accordion-selected\': isOpen}"><strong style="font-weight: 100">{{group.groupName}}</strong><p ng-if=vm.invoiceGroup style="color: #bbbbbb;margin-bottom: 0px">{{"Purchase Order: " + group.invoicePO}}</p></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" style="padding-left: 6px !important;padding-right: 6px !important" ng-if="vm.isAdmin || vm.groupAdmin"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding"><div class=edit-hover ng-if="!vm.disabled && vm.isAdmin"><span style="font-size: 12px;color:gainsboro;float:none;font-weight: 100" ng-click="vm.editGroups($event, vm.account, gIndex)">Edit Group</span></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding"><div class=edit-hover ng-click="vm.newDepartment($event, gIndex)" ng-if="!vm.disabled && !vm.projectUser && !vm.depoAdmin" style=float:right><img src=assets/img/icon/plus.png width=" 15" height="" style="float: right;cursor:pointer;margin-top: 2px"> <span class=accordion-subheader>Add Department</span></div></div></div></div><uib-accordion close-others=true id=device-accordion class=cloud-accordion style="text-align: left"><div uib-accordion-group class=panel-default style="padding: 6px;border: 1px solid #3d3d3d;margin-bottom: 15px; background-color: #1d1c1c" heading={{department.departmentName}} is-open=department.isOpen ng-repeat="(index, department) in vm.account.departments" ng-if="group.departments.includes(department.departmentID) && ((!vm.projectUser && !vm.depoAdmin) || vm.projectDepoIndexes.includes(index))"><div uib-accordion-heading><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding accordion-header-btn" style="padding-top: 4px;margin-bottom: 5px" ng-class="{\'accordion-selected\': isOpen}" ng-click="vm.chooseContent(gIndex, index, false, false, department, false)"><strong style="font-weight: 100">{{department.departmentName}} <span class=depo-type>({{department.budgetType}})</span></strong></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" ng-if="department.departmentName !== \'Unaffiliated Projects\' && !department.unaffiliated && department.departmentName != \'Disabled Projects\' && ((!vm.projectUser && !vm.depoAdmin) || vm.depoUserIndexes.includes(index))"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding"><div class=edit-hover><span style="font-size: 12px;color:gainsboro;float:none" ng-click="vm.chooseContent(gIndex, index, false, false, department, $event)">Edit Department</span></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding"></div></div></div><!-- </div> --><multi-checkbox-container><div class=project-toggle-box><div class=slider-pill-text-box><p class=pill-slider-text ng-class={pillSliderTextOn:!vm.projectNameToggle}>ID</p><p class=pill-slider-text>/</p><p class=pill-slider-text ng-class={pillSliderTextOn:vm.projectNameToggle}>Name</p></div><div class=slider-pill-box ng-click="vm.projectNameToggle=!vm.projectNameToggle"><div class=slider-pill ng-class={slidePosition:vm.projectNameToggle}></div></div></div><div class=device-tables ng-repeat="(key, value) in department.projects" ng-click="vm.chooseContent(gIndex, index, key)" style=color:white ng-if="(vm.groupAdmin || (!vm.projectUser && !vm.depoAdmin) || vm.findProjectItem(vm.user_info.email, value.contactList, \'email\') || vm.findProjectItem(vm.user_info.email, department.contactList, \'email\'))"><div class=sku-title ng-style="{\'display\': (vm.hideDisabled && vm.projectStatus(value) == \'rgb(255 95 95)\') || (vm.hideIdle && vm.projectStatus(value) == \'rgb(255 197 66)\') ? \'none\' : \'block\' }" id="{{gIndex.toString() + index.toString() + key.toString()}}"><input class=project-checkbox type=checkbox multi-checkbox ng-model=value.batchSelect ng-disabled=vm.disabled><p class=device-contents style="width: 100%; margin: 0px;cursor: pointer" ng-if=!vm.projectNameToggle ` ng-style="{ \'color\' : vm.projectStatus(value)}">{{value.projectID ? value.projectID : "No Project ID"}}</p><p class=device-contents style="width: 100%; margin: 0px;cursor: pointer" ng-if=vm.projectNameToggle ng-style="{ \'color\' : vm.projectStatus(value)}">{{value.project ? value.project : "No Project Name"}}</p></div></div></multi-checkbox-container></div></uib-accordion></div></div><div class=panel-loader ng-show="vm.loading || vm.newProjectsLoading" style=text-align:center><div class="css-loading css-loading--double" style="position: relative"></div></div></div></div></div><div class="col-lg-10 col-md-10 col-sm-12 col-xs-12 no-padding"><div class=container style=width:100% id=account-form><form ng-submit=vm.update(vm.account) name=accountForm id=budget-form><div class=menu-top style="text-align: left"><ul style=height:52px></ul><ul class="list-unstyled list-inline" style="padding: 15px;display: inline-block;position: absolute;top: 0;left: 0"><li><strong ng-if="!vm.selectedProject && !vm.loading">No Project Information</strong> <strong class=general-button ng-if="vm.batchForm && !vm.loading" ng-click=vm.resetBatchSelect(vm.departmentIndex)>Deselect Batch</strong> <strong ng-if="!vm.batchForm && vm.selectedProject && vm.selectedName === \'Project\'">Project - {{vm.selectedProject.project || vm.selectedProject.projectID}}</strong> <strong ng-if="vm.selectedProject && vm.selectedName === \'Department\'">Department - {{vm.selectedProject.departmentName}}</strong></li></ul><ul class="list-unstyled list-inline header-alerts" style="margin-left: 1px;border-top: 1px solid #aaa; padding: 9px !important;width: 100%;background-color: #1d1c1c;min-height: 40px"><li style="letter-spacing: 1px"><div ng-repeat="alert in vm.occupiedAlert" close="vm.close_notice(\'occupiedAlert\', $index)"><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px"> {{alert.msg}}</div><div ng-repeat="alert in vm.iamAlerts" close="vm.close_notice(\'iamAlerts\', $index)"><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px"> {{alert.msg}}<button type=button class="btn btn-default remove-alert" style="font-size: 10px" ng-click="vm.close_notice(\'iamAlerts\', $index)"><i class="fa fa-times"></i></button></div><div ng-repeat="alert in vm.alerts" close="vm.close_notice(\'alerts\', $index)"><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px"> {{alert.msg}}</div></li></ul><ul class="list-unstyled list-inline pull-right list-menu" ng-if=vm.selectedProject style="position: absolute;top: 0;right: 0"><li><button class=menu_btn type=button ng-if=vm.batchForm ng-click=vm.batchUpdate() ng-disabled="vm.loading || (vm.disabled && !vm.projectUser) || (vm.projectUser && vm.mapOccupied)">BATCH UPDATE</button> <button ng-if=!vm.batchForm class=menu_btn type=submit ng-click="vm.action=\'update\'" ng-disabled="vm.loading || (vm.disabled && !vm.projectUser) || (vm.projectUser && vm.mapOccupied)">UPDATE</button> <button class="menu_btn menu_btn_red" type=button ng-if="!vm.batchForm && vm.selectedName === \'Department\' && vm.selectedProject.departmentName !== \'Unaffiliated Projects\' && !vm.selectedProject.unaffiliated && vm.selectedProject.departmentName !== \'Disabled Projects\' && (vm.isAdmin || vm.burwoodManager)" ng-click=vm.deleteDepartment() ng-disabled="vm.disabled || vm.loading">DELETE</button> <button class="menu_btn menu_btn_red" type=button ng-if="!vm.batchForm && vm.selectedName === \'Project\' && vm.selectedProject && vm.selectedProject.departmentName !== \'Unaffiliated Projects\' && !vm.selectedProject.unaffiliated && (vm.isAdmin || vm.burwoodManager)" ng-click=vm.deleteProject() ng-disabled="vm.disabled || vm.loading">DELETE</button><!-- <button class="menu_btn menu_btn_red" type="button"\n                                        ng-if="vm.batchForm && (vm.isAdmin || vm.burwoodManager)"\n                                        ng-click="vm.batchDelete()" ng-disabled="vm.disabled || vm.loading">BATCH\n                                        DELETE</button> --></li></ul></div><div class="well incident-wrapper" style="min-height: 150px"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=row ng-if=vm.selectedProject style="margin-top: 5px;padding-top: 30px"><div><div class=basic-info-contain><div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 no-padding"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel first-panel" ng-if="vm.selectedName === \'Project\'" style=flex:none><div class=form-group ng-if="!vm.batchForm && vm.depoBudgetProject"><div class=col-lg-12 style="text-align: center;\n                                                    letter-spacing: 1px;border-bottom: 1px solid grey"><label for=depo-budget-label>Budgets for this project are managed at the Department</label></div><div class=clearfix></div></div><div class=form-group ng-if=!vm.batchForm><div class=col-lg-4><label for=project>Project</label></div><div class=col-lg-8><input type=text class=form-control id=status-number ng-disabled=vm.disabled ng-model=vm.selectedProject.project placeholder=""></div><div class=clearfix></div></div><div class=form-group ng-if=!vm.batchForm><div class=col-lg-4><label for=projectID>Project ID *</label></div><div class=col-lg-8><input type=text class=form-control id=project-id-account ng-model=vm.selectedProject.projectID placeholder="" ng-disabled="(!vm.newProjectSelected && !vm.projectNeedsID) || vm.disabled" required></div><div class=clearfix></div></div><div class=form-group><div class=col-lg-4><label for=exampleInputEmail1>Project Description</label></div><div class=col-lg-8><input type=text class=form-control id=status-desc ng-model=vm.selectedProject.aka placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group ng-if=!vm.batchForm><div class=col-lg-4><label for=departmenr-account>Department</label></div><div class=col-lg-8><select class=form-control ng-model=vm.selectedDepartment ng-change=vm.switchDepartments(vm.selectedDepartment) ng-options="option.departmentName as option.departmentName for option in vm.groupDepartments" ng-disabled=vm.disabled></select></div><div class=clearfix></div></div><div class=form-group ng-if=vm.batchForm><div class=col-lg-4><label for=departmenr-account>Department</label></div><div class=col-lg-8><select class=form-control ng-model=vm.selectedDepartment ng-options="option.departmentName as option.departmentName for option in vm.groupDepartments" ng-disabled=vm.disabled></select></div><div class=clearfix></div></div><div class=form-group><div class=col-lg-4><label for=primary-contact-field>Primary Contact Email</label></div><div class=col-lg-8><input type=text class=form-control id=primary-contact-field ng-model=vm.selectedProject.primaryContactEmail placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group><div class=col-lg-4><label for=primary-contact-field>Billing Contact Email</label></div><div class=col-lg-8><input type=text class=form-control id=billing-contact-field ng-model=vm.selectedProject.billingContactEmail placeholder="" ng-disabled=vm.disabled></div><div class=clearfix></div></div><div class=form-group ng-if=!vm.batchForm><div class=col-lg-4><label for=account-number-field>Active Billing Account</label></div><div class=col-lg-8><select type=text class=form-control ng-disabled="vm.disabled || !vm.isAdmin" ng-change="vm.reassignProjectAccount(vm.selectedProject, vm.selectedProject.paidBillingAccounts, \'{{vm.selectedProject.paidBillingAccounts}}\')" ng-options="option.accountNum as option.accountName for option in vm.availableAccounts" ng-model=vm.selectedProject.paidBillingAccounts></select></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel first-panel" ng-if="vm.selectedName === \'Department\'" style=flex:none><div class=form-group><div class=col-lg-4><label for=exampleInputEmail1>Department *</label></div><div class=col-lg-8><input type=text class=form-control id=status-number ng-disabled="vm.disabled || vm.selectedProject.departmentName === \'Unaffiliated Projects\' || vm.selectedProject.unaffiliated || vm.selectedProject.departmentName === \'Disabled Projects\'" required ng-model=vm.selectedProject.departmentName placeholder=""></div><div class=clearfix></div></div><div class=form-group><div class=col-lg-4><label for=exampleInputEmail1 tooltips tooltip-class=depo-tooltip tooltip-template="Reporting: Department is established to group projects into view, available in the Reports tab. Budgets are maintained at the Project level.  \n\n                                                            Budgeting: Department is established to manage the group of projects under one budget.  That single shared budget is defined at the department level, with no project-specific budgets. " tooltip-side=right>Department Type *</label></div><div class=col-lg-8><select type=text class=form-control id=budget-type ng-disabled="vm.disabled || vm.selectedProject.departmentName === \'Unaffiliated Projects\' || vm.selectedProject.unaffiliated || vm.selectedProject.departmentName === \'Disabled Projects\'" ng-change="vm.chooseContent(null, null, null, null, vm.selectedProject)" ng-options="option.id as option.name for option in vm.departmentTypes" ng-model=vm.selectedProject.budgetType placeholder="" required><option hidden value="">Select one</option></select></div><div class=clearfix></div></div><div class=form-group><div class=col-lg-4><label for=primary-contact-field>Receive Report</label></div><div class=col-lg-8><input type=checkbox ng-attr-id="{{ \'alert-check-\' + $index }}" class=form-control ng-click="vm.disabled && $event.preventDefault()" style=width:25px ng-model=vm.selectedProject.invoiceDepartment placeholder=""></div><div class=clearfix></div></div><div class=form-group ng-if=vm.selectedProject.invoiceDepartment><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="Department billing contact and recipient of cloud consumption invoices.\n                                                                        " tooltip-side=down>Billing Email <img src=assets/img/icon/plus.png width=" 15" height="" ng-click=vm.addBillingContact() style="float: right;cursor:pointer;margin-top: 2px;margin-left: 5px"></label></div><div class=col-xs-8><div ng-repeat="billingEmail in vm.selectedProject.billingContactEmail track by $index"><img src=assets/img/icon/minus.png width=" 15" height="" ng-click=vm.removeBillingContact($index) style="float: right;cursor:pointer;margin-top: 8px"> <input type=text class=form-control placeholder="" required ng-model=vm.selectedProject.billingContactEmail[$index] style="width: 90%;margin-bottom: 5px" ng-disabled=vm.disabled></div></div><div class=clearfix></div></div><!-- <div class="col-lg-4">\n                                                        <label for="primary-contact-field">Billing Contact Email</label>\n                                                    </div>\n                                                    <div class="col-lg-8">\n\n                                                        <input type="text" class="form-control"\n                                                            id="billing-contact-field"\n                                                            ng-model="vm.selectedProject.billingContactEmail"\n                                                            placeholder="" ng-disabled="vm.disabled" />\n                                                    </div>\n                                                    <div class="clearfix"></div> --></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel first-panel" style=flex:none><div class=form-group><div class="col-xs-12 col-md-12 col-sm-12"><label for=watch_list style="margin-top: 18px">{{vm.selectedName}} Users</label></div><div class="col-xs-12 col-md-12 col-sm-12"><ul class=watch_list_static ng-show=!vm.projectUsersShow><li ng-repeat="user in vm.selectedProject.contactList track by $index" ng-attr-id="{{ \'project-user-\' + $index }}" style=padding-left:6px><img ng-src=assets/img/icon/info.png width=20 height="" ng-click=vm.userPreferences(user) style="height:auto;margin-right: 10%;cursor:pointer"> {{user.email}} <button type=button class="btn btn-default" ng-disabled=vm.disabled style="float: right;font-size: 12px" ng-click=vm.delete_watchlist($index)><i class="fa fa-times"></i></button></li></ul><div class=clearfix></div></div><div class=clearfix></div></div><div class=form-group><div class=col-lg-4><label for=find-user style="margin-top: 8px">Find User</label></div><div class=col-lg-8><div class=row><div class=col-xs-12 style="padding-left: 5px;padding-right: 5px"><p class=input-group id=find-user><span class=input-group-btn><button type=button class="btn btn-default" style="border-radius: 3px" ng-disabled=vm.disabled ng-click=vm.openProjectUsers()><i class="fa fa-search"></i></button></span></p></div></div><div class=clearfix></div></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel first-panel" style=flex:none ng-if="(vm.selectedName === \'Project\' && !vm.depoBudgetProject) || (vm.selectedName === \'Department\' && vm.selectedProject.budgetType === \'Budgeting\')"><div class=col-xs-12 style="text-align:center;border-bottom: 1px solid #898989;margin-bottom: 25px"><label for=account-number-field style="font-weight: bolder !important">Alerts</label><img src=assets/img/icon/plus.png width=15 height="" ng-if="!vm.disabled || vm.projectUser || vm.depoBudgetProject" ng-click="vm.addItem(\'selectedProject\', \'alerts\')" style=margin-left:10px;cursor:pointer></div><div class=row><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 no-padding" style="padding-top: 30px"><div ng-repeat="alert in vm.selectedProject.alerts track by $index" ng-attr-id="{{ \'alert-remove-\' + $index }}" class=minus-budget style="height: 54px;text-align: center"><img src=assets/img/icon/minus.png width=15 height="" ng-if="!vm.disabled || vm.projectUser || vm.depoBudgetProject" ng-click="vm.removeItem(\'selectedProject\', \'alerts\', $index)" style=cursor:pointer></div></div><div class="col-lg-7 col-md-7 col-sm-7 col-xs-7 form-group" style=text-align:center><label>Alert Threshold</label><div ng-repeat="alert in vm.selectedProject.alerts track by $index"><rzslider ng-if=!alert.velocity ng-attr-id="{{ \'alert-thresh-\' + $index }}" rz-slider-model=alert.alertThreshold rz-slider-options="alert.velocity && vm.thresh.unitsVelocity || vm.thresh.units"></rzslider><div ng-if=alert.velocity style=padding-top:20px><div style="display: inline;color: white;padding-right: 3px">$</div><input type=number class=form-control style="display: inline;width: 55%;padding: 3px" ng-model=alert.alertThreshold placeholder=0 ng-disabled="vm.disabled || vm.depoBudgetProject"><div style="display: inline;color: white;padding: 0px;padding-left:3px">Per Day</div></div></div><div class=clearfix></div></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 form-group" style=text-align:center><label style="margin-bottom: 0px">Alert Enabled</label><div ng-repeat="alert in vm.selectedProject.alerts track by $index" class=check-contain-alert><input type=checkbox ng-if="alert.lastTriggered && !alert.velocity" tooltips tooltip-class=depo-tooltip tooltip-template="Threshold alerts are automatically disabled when they are triggered. This alert was last triggered on: {{ alert.lastTriggered }}" tooltip-side=right ng-attr-id="{{ \'alert-check-\' + $index }}" class=form-control ng-disabled="vm.disabled && !vm.projectUser || vm.depoBudgetProject" style="width:25px;margin: 0 auto;margin-top: 13px" ng-model=alert.enabled placeholder=""> <input type=checkbox ng-if="!alert.lastTriggered && !alert.velocity" tooltips tooltip-class=depo-tooltip tooltip-template="Threshold alerts are automatically disabled when they are triggered." tooltip-side=right ng-attr-id="{{ \'alert-check-\' + $index }}" class=form-control ng-disabled="vm.disabled && !vm.projectUser || vm.depoBudgetProject" style="width:25px;margin: 0 auto;margin-top: 13px" ng-model=alert.enabled placeholder=""> <input type=checkbox ng-if=alert.velocity ng-attr-id="{{ \'alert-check-\' + $index }}" class=form-control ng-disabled="vm.disabled && !vm.projectUser || vm.depoBudgetProject" style="width:25px;margin: 0 auto;margin-top: 13px" ng-model=alert.enabled placeholder=""></div><div class=clearfix></div></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 form-group" style=text-align:center><label style="margin-bottom: 0px">Velocity Alert</label><div ng-repeat="alert in vm.selectedProject.alerts track by $index" class=check-contain-alert><input type=checkbox ng-attr-id="{{ \'alert-velocity-\' + $index }}" class=form-control ng-disabled="vm.disabled && !vm.projectUser || vm.depoBudgetProject" style="width:25px;margin: 0 auto;margin-top: 13px" ng-model=alert.velocity placeholder=""></div><div class=clearfix></div></div></div></div></div><div class="col-lg-9 col-md-12 col-sm-12 col-xs-12 no-padding" ng-if=!vm.batchForm><!-- monthly budget feature --><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="flex:none;padding-left: 25px;padding-bottom: 25px" ng-if="(vm.selectedName === \'Project\' && !vm.depoBudgetProject) || (vm.selectedName === \'Department\' && vm.selectedProject.budgetType === \'Budgeting\')"><div class="btn-group btn-group-toggle" data-toggle=buttons ng-if="!vm.depoBudgetProject && vm.selectedProject.budgetType != \'Reporting\'" id=button-radio><label class="btn btn-secondary" ng-style="{ \'background-color\' : vm.selectedProject.recurringBudget ? \'#515151\' : \'#3b4f46\', \'box-shadow\': vm.selectedProject.recurringBudget ? \'inset -5px 0 10px #3c3c3c\' : \'none\' }"><input type=radio data-ng-model=vm.selectedProject.recurringBudget data-ng-value=false checked name=recurringBudget ng-disabled="vm.disabled || vm.missingPermission"> Standard</label><label class="btn btn-secondary" ng-style="{ \'background-color\' : vm.selectedProject.recurringBudget ? \'#3b4f46\' : \'#515151\', \'box-shadow\': vm.selectedProject.recurringBudget ? \'none\' : \'inset 5px 0 10px #3c3c3c\' }"><input type=radio data-ng-model=vm.selectedProject.recurringBudget data-ng-value=true name=recurringBudget ng-disabled="vm.disabled || vm.missingPermission"> Recurring (Monthly)</label></div><div class=newline-font ng-if=vm.missingPermission style="margin-top: 15px;margin-bottom: 15px"><div><img ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px">Budget configuration disabled due to missing GCP project permissions.</div><div><img ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px">{{vm.missingPermissionError}}</div></div><div class=form-group id=budget-lines><div class=col-lg-12 style="text-align:center;border-bottom: 1px solid #898989"><label for=account-number-field ng-if=!vm.selectedProject.recurringBudget style="font-weight: bolder !important">Budget Items</label><label for=account-number-field ng-if=vm.selectedProject.recurringBudget style="font-weight: bolder !important">Monthly Recurring Budget</label><img src=assets/img/icon/plus.png width=15 height="" ng-if="!vm.disabled && !vm.depoBudgetProject && !vm.missingPermission && vm.selectedProject.projectID !== \'[Charges not specified to a project]\'" ng-click="vm.addItem(\'selectedProject\', \'allowances\')" style="margin-left:10px;cursor:pointer;margin-top: -15px"></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding"><div class="col-lg-1 col-md-1 col-sm-1 col-xs-12 no-padding" style="text-align: center;padding-top: 18px"><div ng-repeat="account in vm.selectedProject.allowances track by $index" ng-attr-id="{{ \'budget-remove-budget-\' + $index }}" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" class=minus-budget><img src=assets/img/icon/minus.png width=15 height="" ng-click="vm.removeItem(\'selectedProject\', \'allowances\', $index)" ng-if="!vm.disabled && !vm.depoBudgetProject" style="cursor:pointer;margin-left: -15px"></div></div><div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 no-padding" style="text-align: center"><label for=account-number-field>Type</label><ul class=watch_list_static style=margin-top:0px><li ng-repeat="account in vm.selectedProject.allowances track by $index" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" ng-attr-id="{{ \'budget-type-\' + $index }}" style=padding:0px><select class=form-control ng-model=account.accountNum ng-options="option.account as option.type for option in vm.allAccounts" ng-disabled=true required></select></li></ul></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 no-padding" style="text-align: center"><label for=account-number-field>{{vm.company.purchaseOrderTerm || \'Purchase Order\'}}</label><ul class=watch_list_static style=margin-top:0px><li ng-repeat="account in vm.selectedProject.allowances track by $index" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" ng-attr-id="{{ \'budget-obj-\' + $index }}" style=padding:0px><input type=text class=form-control autocompleter suggestions=vm.pos notice="\'No PO registered.\'" suggestionclass="\'budget-suggestion\'" suggestionsclass="\'budget-suggestions\'" ng-model=account.poNumber placeholder=Empty ng-change="vm.applyExpiration(account, \'poNumber\')" ng-disabled="account.state === \'Consumed\' || vm.disabled || vm.depoBudgetProject || vm.missingPermission"></li></ul></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 no-padding" style="text-align: center"><label for=account-number-field>Grant</label><ul class=watch_list_static style=margin-top:0px><li ng-repeat="account in vm.selectedProject.allowances track by $index" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" ng-attr-id="{{ \'budget-obj-\' + $index }}" style=padding:0px><input type=text class=form-control autocompleter suggestions=vm.pos notice="\'No PO registered.\'" suggestionclass="\'budget-suggestion\'" suggestionsclass="\'budget-suggestions\'" ng-model=account.grant placeholder=Empty ng-change="vm.applyExpiration(account, \'grant\')" ng-disabled="account.state === \'Consumed\' || vm.disabled || vm.depoBudgetProject || vm.missingPermission"></li></ul></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 no-padding"><div ng-if=vm.company.useBudgetTags class="col-lg-3 col-md-3 col-sm-3 col-xs-12 no-padding" style="text-align: center"><label for=account-number-field>Tag</label><ul class=watch_list_static style=margin-top:0px><li ng-repeat="account in vm.selectedProject.allowances track by $index" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" ng-attr-id="{{ \'budget-obj-\' + $index }}" style=padding:0px><input type=text class=form-control ng-model=account.tag placeholder=Empty ng-trim=true ng-disabled="vm.disabled || vm.depoBudgetProject || vm.missingPermission"></li></ul></div><div ng-class="(vm.company.useBudgetTags) ? \'col-lg-3 col-md-3 col-sm-3\' : \'col-lg-4 col-md-4 col-sm-4\'" class="col-xs-12 no-padding" style="text-align: center"><label for=account-number-field>Amount</label><ul class=watch_list_static style=margin-top:0px><li ng-repeat="account in vm.selectedProject.allowances track by $index" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" ng-attr-id="{{ \'budget-amount-\' + $index }}" style=padding:0px><input type=text class=form-control ng-model=account.amount placeholder=Empty ng-blur="vm.formatCurrency(account, \'amount\')" ng-disabled="account.state === \'Consumed\' || vm.disabled || vm.depoBudgetProject || vm.missingPermission" ng-change=vm.composeTotalBudget(vm.selectedProject)></li></ul></div><div ng-class="(vm.company.useBudgetTags) ? \'col-lg-3 col-md-3 col-sm-3\' : \'col-lg-4 col-md-4 col-sm-4\'" class="col-xs-12 no-padding" style="text-align: center"><label for=account-spend-field>Actual Spend</label><ul class=watch_list_static style=margin-top:0px><li ng-repeat="account in vm.selectedProject.allowances track by $index" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" ng-attr-id="{{ \'budget-spend-\' + $index }}" style=padding:0px><input type=text class=form-control ng-model=account.actualSpend placeholder=Empty ng-disabled=true></li></ul></div><div ng-class="(vm.company.useBudgetTags) ? \'col-lg-3 col-md-3 col-sm-3\' : \'col-lg-4 col-md-4 col-sm-4\'" class="col-xs-12 no-padding" style="text-align: center"><label for=account-activate-field style=margin-bottom:4px><select class=form-control style="height: 18px;margin-top: 1px;border: none;background-color: transparent;font-size: 13px" ng-model=vm.dateSelection ng-options="option for option in vm.dateSelections"></select></label><!-- <label for="account-activate-field">Date\n                                                                    Activated</label> --><ul class=watch_list_static style=margin-top:0px ng-if="vm.dateSelection === \'Date Activated\'"><li ng-repeat="account in vm.selectedProject.allowances track by $index" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" ng-attr-id="{{ \'budget-date-active\' + $index }}" style="padding:0px; display:inherit" class=input-group><input ng-model=account.dateActivated class=form-control style="float:none;border-radius: 3px" ng-model-options="{ updateOn: \'blur\' }" placeholder="" format=MM/DD/YYYY today=true start-view=month ng-disabled="account.state === \'Consumed\' || vm.disabled || vm.depoBudgetProject || vm.missingPermission" moment-picker=account.dateActivated></li></ul><ul class=watch_list_static style=margin-top:0px ng-if="vm.dateSelection === \'Date Issued\'"><li ng-repeat="account in vm.selectedProject.allowances track by $index" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" ng-attr-id="{{ \'budget-date-\' + $index }}" style="padding:0px; display:inherit" class=input-group><input ng-model=account.dateIssued class="form-control moment-picker" style="float:none;border-radius: 3px" ng-model-options="{ updateOn: \'blur\' }" placeholder="" format=MM/DD/YYYY today=true start-view=month ng-disabled="vm.disabled || vm.depoBudgetProject || vm.missingPermission" moment-picker=account.dateIssued></li></ul><ul class=watch_list_static style=margin-top:0px ng-if="vm.dateSelection === \'Date Suspended\'"><li ng-repeat="account in vm.selectedProject.allowances track by $index" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" ng-attr-id="{{ \'budget-date-\' + $index }}" style="padding:0px; display:inherit" class=input-group><input ng-model=account.dateSuspended class="form-control moment-picker" style="float:none;border-radius: 3px" ng-model-options="{ updateOn: \'blur\' }" placeholder="" format=MM/DD/YYYY today=true start-view=month ng-disabled="vm.disabled || vm.depoBudgetProject || vm.missingPermission" moment-picker=account.dateSuspended></li></ul><ul class=watch_list_static style=margin-top:0px ng-if="vm.dateSelection === \'Expiration Date\'"><li ng-repeat="account in vm.selectedProject.allowances track by $index" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" ng-attr-id="{{ \'budget-date-\' + $index }}" style="padding:0px; display:inherit" class=input-group><input ng-model=account.expirationDate class="form-control moment-picker" style="float:none;border-radius: 3px" ng-model-options="{ updateOn: \'blur\' }" placeholder="" format=MM/DD/YYYY today=true start-view=month ng-disabled="vm.disabled || vm.depoBudgetProject || vm.missingPermission" moment-picker=account.expirationDate></li></ul></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding"><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 no-padding" style="text-align: center"><label for=account-number-field>Account #</label><ul class=watch_list_static style=margin-top:0px><li ng-repeat="account in vm.selectedProject.allowances track by $index" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" ng-attr-id="{{ \'budget-acct-\' + $index }}" style=padding:0px><select class=form-control ng-model=account.accountNum ng-options="option.account as option.account disable when vm.missingPermissionAccounts.includes(option.account) for option in vm.allAccounts" ng-change="vm.checkActiveChange(account, $index, \'{{account.accountNum}}\', true)" ng-disabled="account.state === \'Consumed\' || vm.disabled || vm.depoBudgetProject || account.state === \'Active\' || vm.missingPermission" required><option hidden value="">Select one</option></select></li></ul></div><div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 no-padding" style="text-align: center"><label for=account-name-field>Account Name</label><ul class=watch_list_static style=margin-top:0px><li ng-repeat="account in vm.selectedProject.allowances track by $index" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" ng-attr-id="{{ \'budget-acctName-\' + $index }}" style=padding:0px><select class=form-control ng-model=account.accountNum ng-options="option.account as option.name disable when vm.missingPermissionAccounts.includes(option.account) for option in vm.allAccounts" ng-change="vm.checkActiveChange(account, $index, \'{{account.accountNum}}\', true)" ng-disabled="account.state === \'Consumed\' || vm.disabled || vm.depoBudgetProject || account.state === \'Active\' || vm.missingPermission" required><option hidden value="">Select one</option></select></li></ul></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="text-align: center"><label for=account-state-field>State</label><ul class=watch_list_static style=margin-top:0px><li ng-repeat="account in vm.selectedProject.allowances track by $index" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" ng-attr-id="{{ \'budget-state-\' + $index }}" style=padding:0px><select class=form-control ng-model=account.state ng-options="option for option in vm.budgetStates" ng-disabled="account.state === \'Consumed\' || vm.disabled || vm.depoBudgetProject || !account.accountNum || vm.missingPermission" ng-change="vm.checkNext(vm.selectedProject);vm.checkActiveChange(account, $index, \'{{account.state}}\')" required><option hidden value="">Select one</option></select></li></ul></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-12 no-padding" style="text-align: center"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" ng-show="!vm.enterprise && !vm.selectedProject.recurringBudget" style="text-align: center"><label for=account-next-field>Next</label><ul class=watch_list_static style=margin-top:0px id=radio-next-group><li ng-repeat="account in vm.selectedProject.allowances track by $index" ng-if="(vm.selectedProject.recurringBudget && account.recurring) || (!vm.selectedProject.recurringBudget && !account.recurring)" ng-attr-id="{{ \'budget-next-\' + $index }}" class=radio-next-budget><input type=radio name=next[] value=true ng-model=account.next ng-disabled="account.state != \'Future\' || vm.disabled || vm.depoBudgetProject || vm.missingPermission" ng-change=vm.applyNextBudget($index)></li></ul></div></div></div></div><div class=clearfix></div></div><div class="btn-group btn-group-toggle" data-toggle=buttons ng-if="!vm.depoBudgetProject && vm.selectedProject.budgetType != \'Reporting\'" id=button-radio><div class="col-xs-12 col-md-12 col-sm-12 no-padding"><label for=afterCredits>After Consumption: Bill / Suspend</label></div><label class="btn btn-secondary" ng-style="{ \'background-color\' : vm.selectedProject.afterCredits === \'Suspend\' ? \'#515151\' : \'#3b4f46\', \'box-shadow\': vm.selectedProject.afterCredits === \'Suspend\' ? \'inset -5px 0 10px #3c3c3c\' : \'none\' }"><input type=radio ng-model=vm.selectedProject.afterCredits value=Bill name=afterCredits ng-disabled=vm.disabled> Bill</label><label class="btn btn-secondary" ng-style="{ \'background-color\' : vm.selectedProject.afterCredits === \'Suspend\' ? \'#3b4f46\' : \'#515151\', \'box-shadow\': vm.selectedProject.afterCredits === \'Suspend\' ? \'none\' : \'inset 5px 0 10px #3c3c3c\' }"><input type=radio ng-model=vm.selectedProject.afterCredits value=Suspend name=afterCredits ng-click=vm.suspendWarning() ng-disabled=vm.disabled> Suspend</label></div><div class="col-lg-10 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-top: 20px;margin-bottom: 0px" ng-if="vm.selectedProject.afterCredits === \'Bill\'"><div class="col-lg-2 col-md-2 col-sm-1 col-xs-12 no-padding" style="text-align: center"><label for=account-number-field>Type</label><ul class=watch_list_static style="margin-top:0px;padding-left:5px;list-style-type: none;padding-left: 5px"><li style=padding:0px><input type=text class=form-control value="Pay As You Go" placeholder=Empty ng-disabled=true></li></ul></div><div class="col-lg-2 col-md-2 col-sm-1 col-xs-12 no-padding" style="text-align: center"><label for=account-number-field>{{vm.company.purchaseOrderTerm || \'Purchase Order\'}}</label><ul class=watch_list_static style="margin-top:0px;padding-left:5px;list-style-type: none;padding-left: 5px"><li style=padding:0px><input type=text class=form-control autocompleter suggestions=vm.pos notice="\'No PO registered.\'" suggestionclass="\'budget-suggestion\'" suggestionsclass="\'budget-suggestions\'" ng-model=vm.selectedProject.afterCreditsPO placeholder=Empty ng-disabled="vm.disabled || vm.depoBudgetProject"></li></ul></div><div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 no-padding" style="text-align: center"><label for=account-number-field>Account #</label><ul class=watch_list_static style="margin-top:0px;padding-left: 5px"><div style=padding:0px><select class=form-control ng-model=vm.selectedProject.afterCreditsAccount ng-init="originalAccountNum = vm.selectedProject.afterCreditsAccount" ng-focus="originalAccountNum = vm.selectedProject.afterCreditsAccount" ng-options="option.account as option.account disable when vm.missingPermissionAccounts.includes(option.account) for option in vm.allAccounts" ng-disabled=vm.disabled ng-required=vm.selectedProject.paidBillingAccounts><option hidden value="">Select one</option></select></div></ul></div><div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 no-padding" style="text-align: center"><label for=account-name-field>Account Name</label><ul class=watch_list_static style="margin-top:0px;padding-left: 5px"><div style=padding:0px><select class=form-control ng-model=vm.selectedProject.afterCreditsAccount ng-init="originalAccountNum = vm.selectedProject.afterCreditsAccount" ng-focus="originalAccountNum = vm.selectedProject.afterCreditsAccount" ng-options="option.account as option.name disable when vm.missingPermissionAccounts.includes(option.account) for option in vm.allAccounts" ng-disabled=vm.disabled ng-required=vm.selectedProject.paidBillingAccounts><option hidden value="">Select one</option></select></div></ul></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" ng-show="!vm.consumptionsLoading && vm.afterCreditsShow" style="text-align: center"><label for=account-number-field>Actual Spend</label><ul class=watch_list_static style="margin-top:0px;list-style-type: none;padding-left: 5px"><li style=padding:0px><input type=text class=form-control ng-model=vm.afterCreditsSpend.actualSpend placeholder=Empty ng-disabled=true></li></ul></div></div></div><div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 20px;min-height:150px;display: flex" ng-if="(vm.selectedName === \'Project\' && !vm.depoBudgetProject) || (vm.selectedName === \'Department\' && vm.selectedProject.budgetType === \'Budgeting\')"><div class=panel-loader ng-show=vm.consumptionsLoading style=text-align:center><div class="css-loading css-loading--double" style="position: relative"></div></div><div class="form-group form-panel" style="padding: 15px"><div style="text-align:center;margin-bottom: 15px;border-bottom: 1px solid grey"><label for=account-number-field style="font-weight: bolder !important">Active Budget Consumption</label></div><div style="text-align:center;margin-top: 30px" ng-if="vm.consumptions.length === 0 && !vm.consumptionsLoading"><label for=account-number-field>No Budget Consumption</label></div><div class=col-xs-12 ng-if=!vm.consumptionsLoading><div class=form-group ng-repeat="project in vm.consumptions"><div class=col-lg-4><label for=prj-consumptions>{{project.project_id}}</label></div><div class=col-lg-4><input type=text class=form-control ng-model=project.subtotal placeholder="" disabled></div><div class=col-lg-4><input type=text class=form-control ng-model=project.budgetPercent placeholder="" disabled></div><div class=clearfix></div></div><div class=form-group style="border-top: 1px solid grey;padding-top: 20px;margin-bottom: 0px" ng-if="vm.selectedProject.budgetType === \'Budgeting\' && !vm.departmentConsumptionsLoading"><div class=col-lg-4><label for=prj-consumptions>Account Total</label></div><div class=col-lg-4><input type=text class=form-control ng-model=vm.accountTotalSubtotal placeholder="" disabled></div><div class=col-lg-4><input type=text class=form-control ng-model=vm.accountTotalBudgetPercent placeholder="" disabled></div><div class=clearfix></div></div></div></div></div><div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 20px;display: flex;\n                                                padding-left: 5px !important"><div class="form-group form-panel" style="padding: 15px"><div style="text-align:center;margin-bottom: 15px"><label for=account-number-field style="font-weight: bolder !important">{{vm.selectedName}} Notes</label></div><div class=col-lg-12><textarea type=text class=form-control ng-disabled=vm.disabled id=additional_comment placeholder="" style=height:100px ng-model=vm.selectedProject.comments></textarea></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding basic-info-contain" style="margin-bottom: 20px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style=flex:none><div style="text-align:center;border-bottom: 1px solid #898989"><label for=account-number-field style="font-weight: bolder !important">Activity Feed</label><div class=button-tab-act ng-click="vm.switchFeed(\'selectedProject\')" ng-class="{\'activity-selected\': vm.selectedFeed === \'selectedProject\'}">{{vm.selectedName}}</div><div class=button-tab-act ng-click="vm.switchFeed(\'account\')" ng-if="!vm.projectUser && !vm.depoAdmin" ng-class="{\'activity-selected\': vm.selectedFeed === \'account\'}" ng-style="{ \'margin-left\' : (vm.selectedName == \'Project\') ? \'67px\' : \'98px\' }">Company</div></div><div class="related_search_result webkit-scroll" style="max-height: 500px"><div class=table-responsive ng-if=!vm.tableLoading><table class="table table-striped table-bordered hover" datatable=ng dt-column-defs=vm.dtColumnDefsActivity dt-options=vm.dtActivityOptions style="width:100%; border:none" width=100% id=activityTable><thead><tr><th style="width: 150px">User</th><th style="width: 100px">Type</th><th>Activity</th><th>Date</th><th style="width: 150px" ng-if="vm.selectedFeed === \'account\'">Project/Department</th></tr></thead><tbody><tr ng-repeat="activity in vm.activityFeed track by $index" class=activityRows><td>{{activity.user}}</td><td>{{activity.type}}</td><td style="white-space: pre-wrap">{{activity.value}}</td><td style="width: 20%">{{activity.date}}</td><td ng-if="vm.selectedFeed === \'account\'">{{activity.project || activity.department}}</td></tr></tbody></table></div></div></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group text-center"><button class="btn btn-primary btn-md" type=submit ng-if=!vm.batchForm ng-click="vm.action=\'update\'" ng-disabled="vm.loading || (vm.disabled && !vm.projectUser) || (vm.projectUser && vm.mapOccupied)">UPDATE</button> <button class="btn btn-primary btn-md" type=button ng-if=vm.batchForm ng-click=vm.batchUpdate() ng-disabled="vm.loading || (vm.disabled && !vm.projectUser) || (vm.projectUser && vm.mapOccupied)">BATCH UPDATE</button><div class=clearfix></div></div></div></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/cloudbilling/burwoodAdmin/burwoodAdmin.html','<div class="container container-top col-lg-12 col-md-12 col-sm-12 col-xs-12" id=cloudbill-accounts style=padding-left:50px;padding-right:50px><div class="well pd-top" ng-if=!vm.burwoodManager><div class=no-results><p>Sorry, you do not have access to this page.</p></div></div><div class=row style="margin-bottom: 15px" ng-if=vm.burwoodManager><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 no-padding sku-list"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"><div class="panel panel-default left-report-panel interface-panel device-shadow" style="min-height: 500px;height: auto"><div class="panel-heading brd-bottom" style="background-color:rgba(0,0,0,.2) !important; text-align:center"><h3 class=panel-title>CLOUD ACCOUNTS</h3></div><div class="panel-body list-container"><div class=panel-loader ng-show=vm.loading style=text-align:center><div class="css-loading css-loading--double" style=top:240px></div></div><uib-accordion close-others=true id=device-accordion ng-show=!vm.loading><div uib-accordion-group class=panel-default heading={{Company}} is-open=true id=company-accordion><div uib-accordion-heading><strong style="pointer-events: none">COMPANIES</strong></div><div class=device-tables ng-repeat="company in vm.companies track by $index" ng-click="vm.chooseContent(company, $index)" style=color:white><div class=sku-title id="{{\'cloud-company-\'+ $index.toString()}}"><p class=device-contents style="width: 100%; margin: 0px;cursor: pointer">{{company.companyName || company.companyCode}}</p></div></div></div></uib-accordion></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" ng-if=vm.confirmUser><div class="panel panel-default left-report-panel interface-panel device-shadow" style="min-height: 90px;height: auto"><div class="panel-heading brd-bottom" style="background-color:rgba(0,0,0,.2) !important; text-align:center"><h3 class=panel-title>CONFIRM MONTHLY INVOICE</h3></div><div class="panel-body list-container" style="text-align: center;padding: 10px !important"><button class="report-category report-select" id=invoice-confirm type=button ng-click=vm.confirmInvoices()>Confirm</button></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" ng-if=vm.confirmUser><div class="panel panel-default left-report-panel interface-panel device-shadow" style="min-height: 90px;height: auto"><div class="panel-heading brd-bottom" style="background-color:rgba(0,0,0,.2) !important; text-align:center"><h3 class=panel-title>VALIDATE MONTHLY INVOICE</h3></div><div class="panel-body list-container" style="text-align: center;padding: 10px !important"><button class="report-category report-select" id=invoice-validate type=button ng-click=vm.confirmInvoices(true)>Validate</button></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" ng-if=vm.confirmUser><div class="panel panel-default left-report-panel interface-panel device-shadow" style="min-height: 90px;height: auto;text-align:center"><div class="panel-heading brd-bottom" style="background-color:rgba(0,0,0,.2) !important; text-align:center; margin-bottom: 20px"><h3 class=panel-title>Batch Download Invoice</h3></div><div style=width:100%;padding:20px><select class=form-control ng-model=vm.selectedMonth style="margin-bottom: 10px" ng-options="option for option in vm.months"></select><select class=form-control ng-model=vm.selectedYear style="margin-bottom: 10px" ng-options="option for option in vm.years"></select></div><button class="report-category report-select" id=standard-run type=button style="margin-bottom: 20px !important" ng-click="vm.batchDownloadInvoice(vm.selectedMonth, vm.selectedYear)">Download</button></div></div></div><div class="col-lg-10 col-md-12 col-sm-12 col-xs-12 no-padding"><div class=container style=width:100% id=account-form-admin><form ng-submit=vm.update(vm.account) name=accountForm><div class=menu-top style="text-align: left"><ul class="list-unstyled list-inline" style="padding: 15px;float:left"><li><strong>Company - {{vm.selectedCompany.companyName}}</strong></li></ul><ul class="list-unstyled list-inline header-alerts"><li><div ng-repeat="alert in vm.alerts" close="vm.close_notice(\'alerts\', $index)"><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px"> {{alert.msg}}</div></li></ul><ul class="list-unstyled list-inline pull-right list-menu"><li><button class=menu_btn type=submit ng-disabled="vm.disabled || vm.loading">UPDATE</button> <button class="menu_btn menu_btn_red" type=button ng-click="vm.delete(vm.selectedCompany, vm.companyIndex)" ng-disabled="vm.disabled || vm.loading">DELETE</button></li></ul></div><div class="well incident-wrapper"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=row style="margin-top: 5px;padding-top: 30px"><div class=basic-info-contain style="margin-bottom: 10px"><div class="col-lg-5 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-lg-4><label style="margin-top: 8px">Company Name</label></div><div class=col-lg-8><input type=text class=form-control placeholder="" data-ng-model=vm.selectedCompany.companyName ng-disabled=vm.disabled></div><div class=clearfix></div></div></div></div><div class="col-lg-3 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-lg-4><label style="margin-top: 8px">Company Code</label></div><div class=col-lg-8><input type=text class=form-control placeholder="" data-ng-model=vm.selectedCompany.companyCode required ng-disabled=vm.disabled></div><div class=clearfix></div></div></div></div><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-lg-8><label style="margin-top: 8px" for=exampleInputEmail1 tooltips tooltip-class=depo-tooltip tooltip-template="Designates a contracted client as Internet2 or Direct" tooltip-side=down>Direct</label></div><div class=col-lg-4><input type=checkbox class=form-control style="width:25px;float: left" placeholder="" data-ng-model=vm.selectedCompany.enterprise data-ng-true-value="\'true\'" ng-disabled=vm.disabled></div><div class=clearfix></div></div></div></div><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-lg-4><label style="margin-top: 8px" for=exampleInputEmail1 tooltips tooltip-class=state-tooltip tooltip-template="GCP Domain of the Organization (ex. \'burwood.com)" tooltip-side=down>GCP Domain</label></div><div class=col-lg-8><input type=text class=form-control placeholder="" data-ng-model=vm.selectedCompany.cloudDomain ng-disabled=vm.disabled></div><div class=clearfix></div></div></div></div></div></div><div class=row style="margin-top: 5px"><div class=basic-info-contain style="margin-bottom: 10px"><div class="col-lg-3 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-lg-8><label style="margin-top: 8px">Burwood Provided Discount %</label></div><div class=col-lg-4><input type=number step=0.01 class=form-control placeholder="" ng-model=vm.selectedCompany.providedDiscount required ng-disabled=true></div><div class=clearfix></div></div></div></div><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-lg-7 style="padding-right: 0px"><label style="margin-top: 8px">Service Fee %</label></div><div class=col-lg-5 style="padding-right: 0px"><input type=number step=0.01 class=form-control placeholder="" ng-model=vm.selectedCompany.centralTax required ng-disabled=vm.disabled></div><div class=clearfix></div></div></div></div><div class="col-lg-4 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-lg-3 style="margin-bottom: 0px"><label style="margin-top: 8px" for=exampleInputEmail1 tooltips tooltip-class=depo-tooltip tooltip-template="Note attached to company-level invoices." tooltip-side=down>Invoice Notes</label></div><div class=col-lg-9><textarea type=text class=form-control placeholder="" ng-model=vm.selectedCompany.burwoodInvoiceNote style=height:33px ng-disabled=vm.disabled></textarea></div><div class=clearfix></div></div></div></div></div></div><div class=row style="margin-top: 5px"><div class=basic-info-contain style="margin-bottom: 20px"><div class="col-lg-3 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-lg-5><label style="margin-top: 8px">Invoicing Role</label></div><div class=col-lg-7><select class=select-grey-first style="margin-bottom: 5px;color:white;padding:9px" ng-model=vm.selectedCompany.invoicingRole ng-options="option.id as option.name for option in vm.invoicingRoles" ng-change="vm.revertServiceFees(vm.selectedCompany.accounts, vm.selectedCompany.invoicingRole)" ng-disabled=vm.disabled required></select></div><div class=clearfix></div></div></div></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12" style="margin-bottom: 0px" ng-if="vm.selectedCompany.invoicingRole === \'group\'"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 17px"><div class=form-group style="margin-bottom: 0px;text-align: center"><div class=col-lg-12><label for=account-number-field class=preference-btn ng-click="vm.editGroups($event, vm.selectedCompany.budgets)" style="font-weight: bolder !important; border: 1px solid white; padding: 5px; border-radius: 5px; cursor: pointer">Group Configuration</label></div><div class=clearfix></div></div></div></div><div class="col-lg-3 col-md-3 col-sm-3 col-xs-12" style="margin-bottom: 0px" ng-if="vm.selectedCompany.invoicingRole !== \'group\'"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-lg-7><label style="margin-top: 8px">Company Purchase Order</label></div><div class=col-lg-5><input type=text class=form-control placeholder="" ng-model=vm.selectedCompany.companyPO ng-disabled=vm.disabled></div><div class=clearfix></div></div></div></div><div class="col-lg-3 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px; padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-lg-5><label style="margin-top: 8px">Department Invoice Template</label></div><div class=col-lg-7><select class=select-grey-first style="margin-bottom: 5px;color:white;padding:9px" data-ng-model=vm.selectedCompany.departmentInvoiceTemplate required ng-options="option.id as option.name for option in vm.departmentInvoiceTemplate" ng-disabled=vm.disabled required></select></div><div class=clearfix></div></div></div></div></div></div><div class=row><div class=basic-info-contain style="margin-bottom: 20px"><div class="col-lg-3 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 0px; padding: 15px"><div class=col-lg-5><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="This will enable a \'tags\' column on this client\'s budget configurations, which will allow tags to be input on each budget item. Consumption on these tags will be gathered up and shown as extra columns in the weekly consumption report received by the client." tooltip-side=down>Use Weekly Consumption Budget Tags</label></div><div class=col-lg-7><input type=checkbox class=form-control style="width:25px;float: left" placeholder="" data-ng-model=vm.selectedCompany.useBudgetTags data-ng-true-value="\'true\'" ng-disabled=vm.disabled></div></div></div></div></div><div class=row><div id=exTab3 style="width:100%; padding:0"><ul class="nav nav-pills" style="margin-left: 25px"><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'account\']"><a ng-click="vm.tabView = \'account\'" data-toggle=tab>BILLING ACCOUNTS</a></li></ul><div class="basic-info-contain tab-content" id=1b ng-if="vm.tabView === \'account\'"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=webkit-scroll style="height:auto;margin-bottom: 20px;border-radius: 10px"><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div class=form-group><div class=col-lg-12 style="text-align:center;border-bottom: 1px solid #898989"><div class=col-lg-1><span ng-click="vm.switchPage(\'previous\')" class=show-dev-cat style="color:white;transform: rotate(180deg)" ng-class="{\'no-events\': vm.accountPageIndex === 0}">></span></div><div class=col-lg-10><label for=account-number-field style="font-weight: bolder !important">Account</label><img src=assets/img/icon/plus.png width=15 height="" ng-click=vm.addAccount() style=margin-left:10px;cursor:pointer class=add-img></div><div class=col-lg-1><span ng-click="vm.switchPage(\'next\')" class=show-dev-cat style=float:right;color:white ng-class="{\'no-events\': vm.accountPages === undefined || vm.accountPageIndex >= vm.accountPages}">></span></div></div><div class=col-lg-12><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 0px"><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 no-padding" style="padding-top: 1px"></div><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 0px"><label for=account-number-field>Account Name</label></div><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px"><label for=account-number-field>Account Number</label></div><div class="col-lg-5 col-md-12 col-sm-12 col-xs-12 no-padding" style=margin-bottom:5px><div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 5px;padding-left:5px !important"><label for=account-number-field>Type</label></div><div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 5px;padding-left:5px !important"><label for=account-number-field>Source</label></div><div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 5px;padding-left:5px !important"><label for=account-number-field>Pricebook</label></div><div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 5px;padding-left:5px !important"><label for=account-number-field>Margin</label></div></div><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px"><label for=account-number-field ng-if="vm.selectedCompany.invoicingRole === \'group\'">Assigned Group</label></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"><ul class=watch_list_static style=margin-top:0px><li ng-repeat="account in vm.selectedCompany.accounts track by $index" ng-attr-id="{{ \'acct-num-\' + $index }}" ng-if="$index >= vm.accountPageIndex*10 && $index < vm.accountPageIndex*10+10" style="padding:0px;margin-bottom: 15px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 0px"><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 no-padding" style="padding-top: 1px"><div ng-attr-id="{{ \'budget-remove-acct-\' + $index }}" class=minus-acct><img src=assets/img/icon/minus.png width=15 height="" ng-click=vm.removeAccount($index) style=margin-left:10px;cursor:pointer class=add-img></div></div><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 0px"><div class="col-lg-11 col-md-12 col-sm-11 col-xs-12 no-padding"><input type=text name=accounts class=form-control ng-disabled=vm.disabled placeholder="Account Name" ng-model=vm.selectedCompany.accounts[$index].name></div><div class="col-lg-1 col-md-12 col-sm-1 col-xs-12 no-padding"><select class=select-grey-first style="margin-bottom: 5px;color:white;padding:9px" ng-model=vm.selectedCompany.accounts[$index].account ng-options="option.account as option.name for option in vm.formattedAccounts" ng-disabled=vm.disabled ng-change=vm.matchCompanyName(vm.selectedCompany.accounts[$index]) required><option value="" disabled selected hidden></option></select></div></div><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px"><div class="col-lg-11 col-md-11 col-sm-11 col-xs-12 no-padding"><input type=text name=accounts class=form-control ng-disabled=vm.disabled placeholder="Account Number" ng-model=vm.selectedCompany.accounts[$index].account></div><div class="col-lg-1 col-md-12 col-sm-12 col-xs-12 no-padding"><select class=select-grey-first style="margin-bottom: 5px;color:white;padding:9px" ng-model=vm.selectedCompany.accounts[$index].account ng-options="option.account as option.account for option in vm.formattedAccounts" ng-disabled=vm.disabled ng-change=vm.matchCompanyName(vm.selectedCompany.accounts[$index]) required><option value="" disabled selected hidden></option></select></div></div><div class="col-lg-5 col-md-12 col-sm-12 col-xs-12 no-padding" style=margin-bottom:5px><div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 5px;padding-left:5px !important"><select class=select-grey-first style="margin-bottom: 5px;color:white" ng-model=vm.selectedCompany.accounts[$index].levelType ng-options="option.id as option.name for option in vm.budgetTypes" ng-change=vm.checkSubaccounts(vm.selectedCompany.accounts[$index]) ng-disabled=vm.disabled></select></div><div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 5px;padding-left:5px !important"><select class=select-grey-first style=color:white ng-model=vm.selectedCompany.accounts[$index].type ng-options="option.id as option.name for option in vm.sourceTypes" ng-disabled=vm.disabled ng-change=vm.changeSelect(this) required><option value="" disabled selected hidden></option></select></div><div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 5px;padding-left:5px !important"><select class=select-grey-first style="margin-bottom: 5px;color:white" ng-model=vm.selectedCompany.accounts[$index].pricebook ng-options="option.id as option.name for option in vm.pricebooks" ng-disabled=vm.disabled ng-change=vm.changeSelect(this)></select></div><div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 5px;padding-left:5px !important"><input type=text class=form-control ng-model=vm.selectedCompany.accounts[$index].margin placeholder="Margin %" ng-disabled=vm.disabled></div></div><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px" ng-if="vm.selectedCompany.invoicingRole === \'group\'"><select class=select-grey-first style="margin-bottom: 5px;color:white;padding:9px" ng-model=vm.selectedCompany.accounts[$index].group ng-options="option.groupID as option.groupName for option in vm.selectedCompany.budgets.groups" ng-disabled=vm.disabled required><option value="" disabled selected hidden></option></select></div></div></li></ul><div ng-if="vm.selectedCompany && vm.accountPages > 0" style="text-align: center; color:rgb(171, 171, 171); margin-top: 10px;font-size: 13px">Page {{vm.accountPageIndex + 1}} of {{vm.accountPages + 1}}</div></div></div><div class=clearfix></div></div></div></div></div></div></div></div></div></form></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 well" style="margin-top: 15px;padding:25px"><div class=webkit-scroll style="height:auto;margin-bottom: 20px;border-radius: 10px"><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div style="text-align:center;border-bottom: 1px solid #898989"><label for=account-number-field style="font-weight: bolder !important">Activity Feed</label><div class=button-tab-act ng-click="vm.switchFeed(\'selectedCompany\')" ng-class="{\'activity-selected\': vm.selectedFeed === \'selectedCompany\'}">Company</div><div class=button-tab-act ng-click="vm.switchFeed(\'account\')" ng-class="{\'activity-selected\': vm.selectedFeed === \'account\'}" style=margin-left:82px>All Companies</div></div><div class="related_search_result webkit-scroll" style="max-height: 1000px"><div class=table-responsive ng-if=!vm.tableLoading><table class="table table-striped table-bordered hover" datatable=ng dt-column-defs=vm.dtColumnDefsActivity dt-options=vm.dtActivityOptions style="width:100%; border:none" width=100% id=activityTable><thead><tr><th style="width: 150px">User</th><th style="width: 100px">Type</th><th>Activity</th><th>Date</th><th style="width: 150px" ng-if="vm.selectedFeed === \'account\'">Client</th></tr></thead><tbody><tr ng-repeat="activity in vm.activityFeed" class=activityRows><td>{{activity.user}}</td><td>{{activity.type}}</td><td style="white-space: pre-wrap">{{activity.value}}</td><td style="width: 20%">{{activity.date}}</td><td ng-if="vm.selectedFeed === \'account\'">{{activity.company}}</td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/cloudbilling/burwoodAdmin/cloudbilling_dashboard_burwood.html','<div class="container col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding-left:0px;padding-right:0px;padding-bottom: 50px; position: absolute" id=cloudbilling><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" id=cloudbilling-dashboard><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="padding-left: 0px"><div class="cloudbill-dashboard no-padding" style="min-height: 100px"><div id=rep-panel-1 class="panel-heading brd-bottom dev-report-category" style="text-align:center; padding-bottom: 0px; background-color:transparent !important;cursor:auto"><p style="text-align:center; font-weight:300; font-size:13px; letter-spacing:1px">DATE RANGE</p><input date-range-picker class="form-control date-picker" type=text placeholder={{vm.datePlaceholder}} ng-model=vm.datePicker style="height:24px; margin-top: 10px; width:49%; display:inline-block; margin-bottom: 20px"> <button class="button-month btn-clicked thisMonth" id=thisMonth style=margin-bottom:10px type=button ng-click="vm.prepReports(false, \'thisMonth\')">This Month</button> <button class="button-month lastMonth" id=lastMonth type=button ng-click="vm.prepReports(false, \'lastMonth\')">Last Month</button> <button class="button-month to-date" id=to-date type=button style="margin-bottom: 10px" ng-click="vm.prepReports(false, \'toDate\')">To Date</button></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="padding-right: 0px"><div class="cloudbill-dashboard no-padding" style="min-height: 100px"><div id=standard-report-contain style=margin-left:0px><div class=form-group style="margin-bottom: 0px;text-align: center;padding-top: 20px"><label style=padding:20px><input type=radio name=source_type[] value=All ng-model=vm.sourceType ng-change="vm.prepReports(false, vm.timeSelect, true)"><span>All Funding Sources</span></label><label style=padding:20px><input type=radio name=source_type[] value=PO ng-change="vm.prepReports(false, vm.timeSelect, true)" ng-model=vm.sourceType><span>Paid</span></label><label style=padding:20px><input type=radio name=source_type[] value=Credit ng-change="vm.prepReports(false, vm.timeSelect, true)" ng-model=vm.sourceType><span>Credit</span></label></div></div></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 main-body"><div class="row panel-row all-dashboards cloudbill-dashboard hideCloudDash" ng-if="vm.dash[\'totalConsumption\']"><div class="panel-body well cloudbill-datatable-contain"><div class="dashboard-title cloudbill-title" style="font-weight: 300;margin-bottom: 0px !important;width: 95%;margin: auto;margin-left: 2.5%"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding" style="text-align: left"><select class=bill-chart-select ng-model=vm.serviceSelect ng-options="option.id as option.name for option in vm.providedServices" ng-change=vm.changeServices()></select></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12"><span class=bold-first-letter>S</span>PEND SUMMARY</div></div><div class="panel-loader loading dashboard-loader" ng-show=vm.totalConsumptionLoading style=margin-top:100px><loading></loading></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding show-dash" style="margin-bottom:0px;margin-top: 15px;height:300px" ng-show=!vm.totalConsumptionLoading><div class=dashboard-panel ng-if=!vm.enterprise style="border:none;background-color:transparent;height: 100% !important"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="text-align: center;padding:10px"><p class=report-widget style="background-color: #526f68;height: 130px;padding-top: 40px;font-size: 16px">TOTAL CONSUMPTION YTD<br>$ {{vm.totalConsumptionTotals.consumptionYTD}}</p><p class=report-widget style="background-color: #525b6f;height: 130px;padding-top: 40px;font-size: 16px">TOTAL PAID YTD<br>$ {{vm.totalConsumptionTotals.paidYTD}}</p></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="text-align: center;padding:10px"><p class=report-widget style="background-color: #526f68;height: 130px;padding-top: 40px;font-size: 16px">TOTAL MARGIN YTD<br>$ {{vm.totalConsumptionTotals.marginYTD}}</p><p class=report-widget style="background-color: #525b6f;height: 130px;padding-top: 40px;font-size: 16px">TOTAL PAID LAST 12 MONTHS<br>$ {{vm.month12ConsumptionTotals.paid12Month}}</p></div></div></div></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 main-body"><div class="row panel-row all-dashboards cloudbill-dashboard hideCloudDash" ng-show="vm.dash[\'consumptionOverTime\']"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding show-dash"><div class="dashboard-panel show-dash" style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><!-- <select class="bill-chart-select" ng-model="vm.timeSelect"\n                                    ng-options="option.id as option.name for option in vm.chartTimes"\n                                    ng-change="vm.prepReports(false, true)"></select> --></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12"><span class=bold-first-letter>C</span>ONSUMPTION OVER TIME TOTAL</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select class=bill-chart-select ng-model=vm.consumptionOverTimeChartSelect ng-options="option.id as option.name for option in vm.chartTypesTime" ng-change="vm.selectChartChange(\'consumptionOverTime\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.consumptionOverTimeLoading}"></div><div class=bill-no-data ng-show="vm.consumptionOverTimeTable.length === 0 && !vm.consumptionOverTimeLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.consumptionOverTimeLoading><loading></loading></div><div class=high-panel ng-show="vm.consumptionOverTimeTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.consumptionOverTimeLoading}"><highchart class=highcharts id=monthChart config=vm.consumptionOverTimeConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.consumptionOverTimeLoading && vm.consumptionOverTimeTable.length > 0"><p class=billing-details ng-click="vm.consumptionOverTimeToggle = !vm.consumptionOverTimeToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.consumptionOverTimeToggle}"></i></p></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.consumptionOverTimeLoading && vm.consumptionOverTimeTable.length > 0 && vm.consumptionOverTimeToggle" ng-class="{\'toggle-billing-table-on\' : vm.consumptionOverTimeToggle}"><table class="table table-striped" dt-instance=vm.consumptionOverTimeDTInstance dt-options=vm.consumptionOverTimeDTOptions datatable=ng width=100% cellspacing=0 scrollx=true id=consumptionOverTime-table><thead><tr><th>Date</th><th style=text-align:right>Consumption</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersconsumptionOverTime><tr><th bw-column-filter dt-instance=vm.consumptionOverTimeDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionOverTimeDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.consumptionOverTimeTable"><td>{{item.date}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash" ng-if="vm.dash[\'consumptionOverTimeAll\'] && (vm.consumptionOverTimeAllLoading || vm.consumptionOverTimeAllTable.length > 0)"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding cloud-backpanel show-dash"><div class="dashboard-panel show-dash" style="border:none;background-color:transparent;height: auto"><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><!-- <select class="bill-chart-select" ng-model="vm.timeSelect"\n                                ng-options="option.id as option.name for option in vm.chartTimes"\n                                ng-change="vm.prepReports(false, true)"></select> --></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12"><span class=bold-first-letter>C</span>ONSUMPTION OVER TIME BREAKDOWN</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select class=bill-chart-select ng-model=vm.consumptionOverTimeAllChartSelect ng-options="option.id as option.name for option in vm.chartTypesTime" ng-change="vm.selectChartChange(\'consumptionOverTimeAll\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.consumptionOverTimeAllLoading}"></div><div class=bill-no-data ng-show="vm.consumptionOverTimeAllTable.length === 0 && !vm.consumptionOverTimeAllLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.consumptionOverTimeAllLoading><loading></loading></div><div class=high-panel ng-if=vm.consumptionOverTimeAllConfig><div class=dash ng-class="{\'fade-dashboard\' : !vm.consumptionOverTimeAllLoading}"><highchart class=highcharts id=monthChart config=vm.consumptionOverTimeAllConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.consumptionOverTimeAllLoading && vm.consumptionOverTimeAllTable.length > 0"><p class=billing-details ng-click="vm.consumptionOverTimeAllToggle = !vm.consumptionOverTimeAllToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.consumptionOverTimeAllToggle}"></i></p></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.consumptionOverTimeAllLoading && vm.consumptionOverTimeAllTable.length > 0 && vm.consumptionOverTimeAllToggle" ng-class="{\'toggle-billing-table-on\' : vm.consumptionOverTimeAllToggle}"><table class="table table-striped" dt-instance=vm.consumptionOverTimeAllDTInstance dt-options=vm.consumptionOverTimeAllDTOptions datatable=ng width=100% cellspacing=0 scrollx=true id=consumptionOverTimeAll-table><thead><tr><th>Company</th><th style=text-align:right>Total</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersconsumptionOverTimeAll><tr><th bw-column-filter dt-instance=vm.consumptionOverTimeAllDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionOverTimeAllDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.consumptionOverTimeAllTable"><td>{{item.company}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash" ng-if="vm.dash[\'consumptionByCompanyType\'] && (vm.consumptionByCompanyTypeLoading || vm.consumptionTypeTable.length > 0)"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding cloud-backpanel show-dash"><div class="dashboard-panel show-dash" style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><select class=bill-chart-select ng-model=vm.consumptionType ng-options="option for option in vm.consumptionTypes" ng-change=vm.switchConsumptionType()></select></div><div ng-show="vm.consumptionType === \'Consumption\'" class="col-lg-8 col-md-8 col-sm-12 col-xs-12"><span class=bold-first-letter>C</span>ONSUMPTION BY CLIENT TYPE</div><div ng-show="vm.consumptionType === \'Margin\'" class="col-lg-8 col-md-8 col-sm-12 col-xs-12"><span class=bold-first-letter>M</span>ARGIN BY CLIENT TYPE</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select class=bill-chart-select ng-model=vm.consumptionByCompanyTypeChartSelect ng-options="option.id as option.name for option in vm.chartTypesTime" ng-change="vm.selectChartChange(\'consumptionByCompanyType\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.consumptionByCompanyTypeLoading}"></div><div class=bill-no-data ng-show="vm.consumptionByCompanyTypeTable.length === 0 && !vm.consumptionByCompanyTypeLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.consumptionByCompanyTypeLoading><loading></loading></div><div class=high-panel ng-if=vm.consumptionTypeConfig><div class=dash ng-class="{\'fade-dashboard\' : !vm.consumptionByCompanyTypeLoading}"><highchart class=highcharts id=monthChart config=vm.consumptionTypeConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.consumptionByCompanyTypeLoading && vm.consumptionByCompanyTypeTable.length > 0"><p class=billing-details ng-click="vm.consumptionByCompanyTypeToggle = !vm.consumptionByCompanyTypeToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.consumptionByCompanyTypeToggle}"></i></p></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.consumptionByCompanyTypeLoading && vm.consumptionByCompanyTypeTable.length > 0 && vm.consumptionByCompanyTypeToggle" ng-class="{\'toggle-billing-table-on\' : vm.consumptionByCompanyTypeToggle}"><table class="table table-striped" dt-instance=vm.consumptionByCompanyTypeDTInstance dt-options=vm.consumptionByCompanyTypeDTOptions datatable=ng width=100% cellspacing=0 scrollx=true id=consumptionByCompanyType-table><thead><tr><th>Month</th><th style=text-align:right>Enterprise Credit</th><th style=text-align:right>Enterprise Paid</th><th style=text-align:right>Enterprise Total</th><th style=text-align:right>Internet 2 Credit</th><th style=text-align:right>Internet 2 Paid</th><th style=text-align:right>Internet 2 Total</th><th style=text-align:right>Total</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersconsumptionByCompanyType><tr><th bw-column-filter dt-instance=vm.consumptionByCompanyTypeDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByCompanyTypeDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByCompanyTypeDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByCompanyTypeDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByCompanyTypeDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByCompanyTypeDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByCompanyTypeDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByCompanyTypeDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.consumptionTypeTable"><td>{{item.month}}</td><td class=dt-body-right>${{item.enterpriseCredit.toFixed(2)}}</td><td class=dt-body-right>${{item.enterprisePaid.toFixed(2)}}</td><td class=dt-body-right>${{item.enterpriseTotal.toFixed(2)}}</td><td class=dt-body-right>${{item.i2Credit.toFixed(2)}}</td><td class=dt-body-right>${{item.i2Paid.toFixed(2)}}</td><td class=dt-body-right>${{item.i2Total.toFixed(2)}}</td><td class=dt-body-right>${{item.total.toFixed(2)}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash" ng-if="vm.dash[\'consumptionByCompany\'] && (vm.consumptionByCompanyLoading || vm.consumptionByCompanyTable.length > 0)"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><!-- <select class="bill-chart-select" ng-model="vm.timeSelect"\n                                ng-options="option.id as option.name for option in vm.chartTimes"\n                                ng-change="vm.prepReports(false, true)"></select> --></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>C</span>ONSUMPTION BY CLIENT</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.consumptionByCompanyLoading}"></div><div class=bill-no-data ng-show="vm.consumptionByCompanyTable.length === 0 && !vm.consumptionByCompanyLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.consumptionByCompanyLoading><loading></loading></div><div class=high-panel ng-show="vm.consumptionByCompanyTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.consumptionByCompanyLoading}"><highchart class=highcharts id=budget-Chart config=vm.consumptionByCompanyConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.consumptionByCompanyLoading && vm.consumptionByCompanyTable.length > 0"><p class=billing-details ng-click="vm.consumptionByCompanyToggle = !vm.consumptionByCompanyToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.consumptionByCompanyToggle}"></i></p></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.consumptionByCompanyLoading && vm.consumptionByCompanyTable.length > 0 && vm.consumptionByCompanyToggle" ng-class="{\'toggle-billing-table-on\' : vm.consumptionByCompanyToggle}"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.consumptionByCompanyDTInstance dt-options=vm.consumptionByCompanyDTOptions id=consumptionByCompany-table><thead><tr><th>Client</th><th style=text-align:right>Consumption</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersconsumptionByCompany><tr><th bw-column-filter dt-instance=vm.consumptionByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByCompanyDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.consumptionByCompanyTable"><td>{{item.client}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash" ng-if="vm.dash[\'stridesByCompany\'] && (vm.stridesByCompanyLoading || vm.stridesByCompanyTable.length > 0)"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding cloud-backpanel show-dash"><div class="dashboard-panel show-dash" style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12"><span class=bold-first-letter>S</span>TRIDES CONSUMPTION BY CLIENT</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select class=bill-chart-select ng-model=vm.stridesByCompanyChartSelect ng-options="option.id as option.name for option in vm.chartTypesTime" ng-change="vm.selectChartChange(\'stridesByCompany\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.stridesByCompanyLoading}"></div><div class=bill-no-data ng-show="vm.stridesByCompanyTable.length === 0 && !vm.stridesByCompanyLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.stridesByCompanyLoading><loading></loading></div><div class=high-panel ng-if=vm.stridesByCompanyConfig><div class=dash ng-class="{\'fade-dashboard\' : !vm.stridesByCompanyLoading}"><highchart class=highcharts id=monthChart config=vm.stridesByCompanyConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.stridesByCompanyLoading && vm.stridesByCompanyTable.length > 0"><p class=billing-details ng-click="vm.stridesByCompanyToggle = !vm.stridesByCompanyToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.stridesByCompanyToggle}"></i></p></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain webkit-scroll" style="overflow: scroll" ng-if="!vm.stridesByCompanyLoading && vm.stridesByCompanyTable.length > 0 && vm.stridesByCompanyToggle" ng-class="{\'toggle-billing-table-on\' : vm.stridesByCompanyToggle}"><table class="table table-striped" dt-instance=vm.stridesByCompanyDTInstance dt-options=vm.stridesByCompanyDTOptions datatable=ng width=100% cellspacing=0 scrollx=true id=stridesByCompany-table><thead><tr><th>Client</th><th>Project ID</th><th>Grant Number</th><th>Grant Amount</th><th>Billing Account</th><th>NIH Institute/Center/Office</th><th>Program/Project Name</th><th>Program Officer Nam</th><th>Program Officer Email</th><th>Primary Contact Name</th><th>Primary Contact Email</th><th>Billing Admin Name</th><th>Billing Admin Email</th><th>Expiration Date</th><th>Description</th><th style=text-align:right>Subtotal</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersstridesByCompany><tr><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.stridesByCompanyDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.stridesByCompanyTable"><td>{{item.client}}</td><td>{{item.project_id}}</td><td>{{item.number}}</td><td>{{item.amount}}</td><td>{{item.billing_account_id}}</td><td>{{item.office}}</td><td>{{item.programName}}</td><td>{{item.officerName}}</td><td>{{item.officerEmail}}</td><td>{{item.contactName}}</td><td>{{item.contactEmail}}</td><td>{{item.billingName}}</td><td>{{item.billingEmail}}</td><td>{{item.expirationDate}}</td><td>{{item.description}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash" ng-if="vm.dash[\'accountReport\']"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash" style="height: 450px"><div class=dashboard-panel style=border:none;background-color:transparent><div class="panel-loader loading dashboard-loader" ng-show=vm.accountReportLoading><loading></loading></div><div class="panel-body well cloudbill-datatable-contain" ng-if=!vm.accountReportLoading><div class="dashboard-title cloudbill-title" style="font-weight: 300;margin-bottom: 0px !important;width: 95%;margin: auto;margin-left: 2.5%"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding" style="text-align: left"></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12"><span class=bold-first-letter>U</span>NASSIGNED GCP ACCOUNTS</div></div><div class="table-responsive cloudbill-datatable-inner-contain toggle-billing-table-on"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.accountReportDTInstance dt-options=vm.accountReportDTOptions id=accountReport-table><thead><tr><th>Account Name</th><th style=text-align:right>Account Number</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersaccountReport><tr><th bw-column-filter dt-instance=vm.accountReportDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.accountReportDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.accountReportTable"><td>{{item.name}}</td><td>{{item.account}}</td></tr></tbody></table></div></div></div></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash" ng-if="vm.dash[\'noAccountClients\']"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash" style="height: 450px"><div class=dashboard-panel style=border:none;background-color:transparent><div class="panel-loader loading dashboard-loader" ng-show=vm.noAccountClientsLoading><loading></loading></div><div class="panel-body well cloudbill-datatable-contain" ng-if=!vm.noAccountClientsLoading><div class="dashboard-title cloudbill-title" style="font-weight: 300;margin-bottom: 0px !important;width: 95%;margin: auto;margin-left: 2.5%"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding" style="text-align: left"></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12"><span class=bold-first-letter>C</span>LIENTS WITH NO ASSIGNED ACCOUNTS</div></div><div class="table-responsive cloudbill-datatable-inner-contain toggle-billing-table-on"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.noAccountClientsDTInstance dt-options=vm.noAccountClientsDTOptions id=noAccountClients-table><thead><tr><th>Client</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersnoAccountClients><tr><th bw-column-filter dt-instance=vm.noAccountClientsDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.noAccountClientsTable"><td>{{item.client}}</td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/cloudbilling/company/adminContacts.html','<div class="row contact-list-form" style=margin-top:100px><div class=modal-header><h4 style="display: inline-block">Alert/Summary Email List</h4></div><form name=companyUsers class="modal-body well" id=modal-body style="height: auto;overflow: auto"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel first-panel" style=flex:none><div class=form-group><div class="col-xs-2 col-md-2 col-sm-2"></div><div class="col-xs-6 col-md-6 col-sm-6"><label for=watch_list style="margin-top: 8px">Email</label></div><div class="col-xs-2 col-md-2 col-sm-2"><label for=watch_list style="margin-top: 8px">Alert</label></div><div class="col-xs-2 col-md-2 col-sm-2"><label for=watch_list style="margin-top: 8px">Summary</label></div><div class=clearfix></div></div><div class=form-group><div class="col-xs-12 col-md-12 col-sm-12 no-padding" ng-repeat="user in vm.emailContacts track by $index" style="margin:0px;margin-top: 3px"><div class="col-xs-2 col-md-2 col-sm-2"><div ng-attr-id="{{ \'alert-remove-\' + $index }}" class=minus-budget style="height: 34px;text-align: center;padding-top: 6px"><img src=assets/img/icon/minus.png width=15 height="" ng-click=vm.delete_user($index) style=cursor:pointer></div></div><div class="col-xs-6 col-md-6 col-sm-6" style="margin: 0px"><div style=clear:both><input type=text class=form-control ng-model=user.email placeholder="" required></div></div><div class="col-xs-2 col-md-2 col-sm-2"><div style=clear:both><input type=checkbox class=form-control style="width:25px;float: left" placeholder="" ng-model=user.alerts></div></div><div class="col-xs-2 col-md-2 col-sm-2"><div style=clear:both><input type=checkbox class=form-control style="width:25px;float: left" placeholder="" ng-model=user.weeklySummary></div></div><div class=clearfix></div></div></div><div class=form-group><div class="col-xs-4 col-md-4 col-sm-4" style=margin-top:30px><label for=find-user style="margin-top: 8px">Find User In Database</label></div><div class="col-xs-8 col-md-8 col-sm-8" style=margin-top:30px><div class=row><div class=col-xs-12 style="padding-left: 5px;padding-right: 5px"><p class=input-group id=find-user><span class=input-group-btn><button type=button class="btn btn-default" style="border-radius: 3px" ; ng-click=vm.openProjectUsers()><i class="fa fa-search"></i></button></span></p></div></div><div class=clearfix></div></div><div class=clearfix></div></div><div class=form-group><div class="col-xs-4 col-md-4 col-sm-4"><label for=find-user style="margin-top: 8px">Add Email Address</label></div><div class="col-xs-8 col-md-8 col-sm-8"><div class=edit-hover ng-click=vm.add_user() style="padding-left: 15px;width: 30px"><img src=assets/img/icon/plus.png width=" 15" height="" style="cursor:pointer;margin-top: 10px"></div><div class=clearfix></div></div></div></div></form><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-2"><input type=button class="btn btn-success btn-block" value=Submit name=Submit ng-click=vm.close()></div><div class=col-xs-4><input type=button class="btn btn-success btn-block" value=Cancel name=Cancel ng-click=vm.cancel()></div></div></div></div>');
$templateCache.put('app/cloudbilling/company/cloudConfig.html','<div class=row><div class="container container-top col-lg-12 col-md-12 col-sm-12 col-xs-12" id=cloudbill-accounts style=padding-left:50px;padding-right:50px><div class="col-lg-4 col-md-12 col-sm-12 col-xs-12"><div class="panel panel-default left-report-panel device-shadow"><div class="panel-heading brd-bottom menu-top" style="background-color:rgba(0,0,0,.2) !important; text-align:left;padding:0px"><h3 class=panel-title style=padding:19px>Company Notification Settings</h3><ul class="list-unstyled list-inline pull-right list-menu"><li><button class=menu_btn type=button ng-click=vm.updateAccount() ng-disabled="vm.disabled || vm.accountLoading">Update</button></li></ul><ul class="list-unstyled list-inline header-alerts"><li><div ng-repeat="alert in vm.alerts" close="vm.close_notice($index, \'alerts\')">{{alert.msg}}</div></li></ul></div><div class="panel-body list-container"><div ng-show=vm.accountLoading class=panel-loader style=text-align:center><div class="css-loading css-loading--double" style=top:72px></div></div><div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 10px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="Email address referenced by by automated reports and alerts sent by the BCS portal.\n                                                " tooltip-side=down>Internal Support Email</label></div><div class=col-xs-8><input type=text class=form-control placeholder="" ng-model=vm.cloudAccount.supportEmail ng-disabled=vm.disabled></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 10px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="Terminology used on all reporting, correspondences, and invoices.  Default: \'Purchase Order\'\n                                                " tooltip-side=down>Purchase Order Terminology</label></div><div class=col-xs-8><input type=text class=form-control placeholder="" ng-model=vm.cloudAccount.purchaseOrderTerm ng-disabled=vm.disabled></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 10px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="Terminology used on all reporting, correspondences, and invoices.  Default: \'Service Fee\'\n                                                " tooltip-side=down>Service Fee Terminology</label></div><div class=col-xs-8><input type=text class=form-control placeholder="" ng-model=vm.cloudAccount.adjustmentTerm ng-disabled=vm.disabled></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 10px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="Company billing contact and recipient of cloud consumption invoices.\n                                                " tooltip-side=down>Billing Contact Email <img src=assets/img/icon/plus.png width=" 15" height="" ng-click=vm.addBillingContact() style="float: right;cursor:pointer;margin-top: 2px;margin-left: 5px"></label></div><div class=col-xs-8><div ng-repeat="billingEmail in vm.cloudAccount.billingContactEmail track by $index"><img src=assets/img/icon/minus.png width=" 15" height="" ng-click=vm.removeBillingContact($index) style="float: right;cursor:pointer;margin-top: 8px"> <input type=text class=form-control placeholder="" ng-model=vm.cloudAccount.billingContactEmail[$index] style="width: 90%;margin-bottom: 5px" ng-disabled=vm.disabled></div></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 10px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="Note attached to departmental monthly generated invoices\n                                                " tooltip-side=down>Invoice Note</label></div><div class=col-xs-8><textarea type=text class=form-control placeholder="" ng-model=vm.cloudAccount.invoiceNote style=height:100px ng-disabled=vm.disabled></textarea></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 10px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="Admin emails settings for alerts and summary reports\n                                                " tooltip-side=down>Company Notification Email List</label></div><div class=col-xs-8><i class="far fa-address-card" style="font-size: 48px;color: white;cursor: pointer" ng-click=vm.openEmailContacts()></i></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 10px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="Applied to header of monthly invoices\n                                                " tooltip-side=down>Company Logo</label></div><div class=col-xs-8 style="padding-top: 5px"><a ng-click=vm.attachment()><img src=assets/img/icon/attach.png width=15 height="" style="height:auto;cursor: pointer"></a><div ng-if=vm.cloudAccount.logo style=float:right><img ng-src={{vm.downloadFile}} style="margin-bottom:10px; width:200px;background-color: white"></div></div><div class=clearfix></div></div></div></div></div></div></div><div class="col-lg-4 col-md-12 col-sm-12 col-xs-12"><div class="panel panel-default left-report-panel device-shadow"><div class="panel-heading brd-bottom menu-top" style="background-color:rgba(0,0,0,.2) !important; text-align:left;padding:0px"><h3 class=panel-title style=padding:19px>Company Budget Settings</h3><ul class="list-unstyled list-inline pull-right list-menu"><li><button class=menu_btn type=button ng-click=vm.updateBudget() ng-disabled="vm.disabled || vm.budgetLoading">Update</button></li></ul><ul class="list-unstyled list-inline header-alerts"><li><div ng-repeat="alert in vm.budgetAlerts" close="vm.close_notice($index, \'budgetAlerts\')">{{alert.msg}}</div></li></ul></div><div class="panel-body list-container"><div ng-show=vm.budgetLoading class=panel-loader style=text-align:center><div class="css-loading css-loading--double" style=top:72px></div></div><div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 10px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="Company-wide consumption budget.  Used for alerting and reporting.\n                                                " tooltip-side=down>Budget</label></div><div class=col-xs-8><input type=text class=form-control id=depo-budget ng-model=vm.account.budget ng-blur="vm.formatCurrency(vm.account, \'budget\')" ng-disabled=vm.disabled placeholder=""></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 10px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px">Date Activated</label></div><div class=col-xs-8><input ng-model=vm.account.dateActivated class=form-control style="float:none;border-radius: 3px" ng-model-options="{ updateOn: \'blur\' }" placeholder="" format=MM/DD/YYYY today=true start-view=month ng-disabled=vm.disabled moment-picker=vm.account.dateActivated></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" ng-if=vm.account.dateActivated style="margin-bottom: 10px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-4><label style="margin-top: 8px" tooltips tooltip-class=depo-tooltip tooltip-template="Current consumption against budget.\n                                                " tooltip-side=down>Consumption</label></div><div class=col-xs-8><input type=text class=form-control id=depo-budget ng-model=vm.companyConsumption ng-disabled=vm.disabled placeholder=""></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 10px;padding: 15px"><div class=form-group><div class="col-xs-4 col-md-4 col-sm-4"><label for=watch_list style="margin-top: 18px">Users</label></div><div class="col-xs-8 col-md-8 col-sm-8"><ul class=watch_list_static ng-show=!vm.projectUsersShow><li ng-repeat="user in vm.account.contactList track by $index" ng-attr-id="{{ \'project-user-\' + $index }}"><img ng-src=assets/img/icon/info.png width=20 height="" ng-click=vm.userPreferences(user) style="height:auto;margin-right: 10%"> {{user.email}} <button type=button class="btn btn-default" style="float: right;font-size: 12px" ng-disabled=vm.disabled ng-click=vm.delete_watchlist($index)><i class="fa fa-times"></i></button></li></ul><div class=clearfix></div></div><div class=clearfix></div></div><div class=form-group><div class="col-xs-4 col-md-4 col-sm-4"><label for=find-user style="margin-top: 8px">Find User In Database</label></div><div class="col-xs-8 col-md-8 col-sm-8"><div class=row><div class=col-xs-12 style="padding-left: 5px;padding-right: 5px"><p class=input-group id=find-user><span class=input-group-btn><button type=button class="btn btn-default" style="border-radius: 3px" ng-disabled=vm.disabled ng-click=vm.openProjectUsers()><i class="fa fa-search"></i></button></span></p></div></div><div class=clearfix></div></div><div class=clearfix></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 10px;padding: 15px"><div class=col-xs-12 style="text-align:center;border-bottom: 1px solid #898989;margin-bottom: 25px"><label for=account-number-field style="font-weight: bolder !important">Alerts</label><img src=assets/img/icon/plus.png width=15 height="" ng-click="vm.addItem(\'account\', \'alerts\')" ng-if=!vm.disabled style=margin-left:10px;cursor:pointer class=add-img></div><div class=row><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 no-padding" style="padding-top: 30px"><div ng-repeat="alert in vm.account.alerts track by $index" ng-attr-id="{{ \'alert-remove-\' + $index }}" class=minus-budget style="height: 55px;text-align: center"><img src=assets/img/icon/minus.png width=15 height="" class=add-img ng-if=!vm.disabled ng-click="vm.removeItem(\'account\', \'alerts\', $index)" style=cursor:pointer></div></div><div class="col-lg-7 col-md-7 col-sm-7 col-xs-7 form-group" style=text-align:center><label>Alert Threshold</label><div ng-repeat="alert in vm.account.alerts track by $index"><rzslider ng-if=!alert.velocity ng-attr-id="{{ \'alert-thresh-\' + $index }}" rz-slider-model=alert.alertThreshold rz-slider-options="alert.velocity && vm.thresh.unitsVelocity || vm.thresh.units"></rzslider><div ng-if=alert.velocity style=padding-top:20px><div style="display: inline;color: white;padding: 10px">$</div><input type=number class=form-control style="display: inline;width: 40%" ng-model=alert.alertThreshold placeholder=0><div style="display: inline;color: white;padding: 10px">Per Day</div></div></div></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 form-group" style=text-align:center><label style="margin-bottom: 0px">Alert Enabled</label><div ng-repeat="alert in vm.account.alerts track by $index" class=check-contain-alert><input type=checkbox ng-attr-id="{{ \'alert-check-\' + $index }}" class=form-control ng-disabled=vm.disabled style="width:25px;margin: 0 auto;margin-top: 13px" ng-model=alert.enabled placeholder=""></div><div class=clearfix></div></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 form-group" style=text-align:center><label style="margin-bottom: 0px">Velocity Alert</label><div ng-repeat="alert in vm.account.alerts track by $index" class=check-contain-alert><input type=checkbox ng-attr-id="{{ \'alert-velocity-\' + $index }}" class=form-control ng-disabled=vm.disabled style="width:25px;margin: 0 auto;margin-top: 13px" ng-model=alert.velocity placeholder=""></div><div class=clearfix></div></div></div></div></div></div></div></div><div class="col-lg-4 col-md-12 col-sm-12 col-xs-12"><div class="panel panel-default left-report-panel device-shadow"><div class="panel-heading brd-bottom menu-top" style="background-color:rgba(0,0,0,.2) !important; text-align:left;padding:0px"><h3 class=panel-title style=padding:19px>V2 Migration</h3><ul class="list-unstyled list-inline header-alerts"><li><div ng-repeat="alert in vm.v2Alerts" close="vm.close_notice($index, \'v2Alerts\')">{{alert.msg}}</div></li></ul></div><div class="panel-body list-container"><div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel" style="margin-bottom: 10px;padding: 15px"><div class=form-group style="margin-bottom: 0px"><div class=col-xs-6><div class=col-xs-12 style="padding-left: 5px;padding-right: 5px"><p class=input-group id=find-user><span class=input-group-btn><button type=button class="btn btn-default btn-primary" style="border-radius: 3px" ng-disabled=true ng-click=vm.initiateV2Migration()>Migrate My Data to V2</button></span></p></div><div class=clearfix></div></div><div class=col-xs-6><div class="col-xs-12 px-1"><div class="d-flex flex-column align-items-start"><label for=user-cb-email class=mb-2>Automation Enabled:</label><input type=checkbox class=form-check-input style="width: 25px" ng-disabled=true ng-model=vm.cloudAccount.automationEnabled ng-click=vm.toggleV1Automation()></div></div></div><div class=col-xs-12 ng-if=vm.burwoodManager style="margin-top: 15px; padding: 0 5px"><div class="d-flex flex-column align-items-start"><label class=mb-2 tooltips tooltip-class=depo-tooltip tooltip-template="Only syncs project users from contact lists. Assumes org, users, and projects already exist from a prior full migration." tooltip-side=down>Fix project users only:</label><div class="d-flex align-items-center"><input type=checkbox class=form-check-input style="width: 25px" ng-model=vm.fixUsersOnly> <button type=button class="btn btn-default btn-primary" style="border-radius: 3px; margin-left: 10px" ng-disabled="!vm.fixUsersOnly || vm.accountLoading || vm.fixUsersOnlyLoading" ng-click=vm.initiateFixProjectUsersOnly()>Run Fix</button></div></div></div><div class=clearfix></div></div><div id=chart-1-container></div><div id=chart-2-container></div></div></div></div></div></div></div></div>');
$templateCache.put('app/cloudbilling/dashboard/cloudbilling_dashboard.html','<div class="container col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 50px" id=cloudbilling><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" id=cloudbilling-dashboard><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding main-body dash-contain"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="row panel-row all-dashboards cloudbill-dashboard grey-round-border"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding show-dash"><div class=dashboard-panel style="border:none;background-color:transparent;height: auto !important"><div class="dashboard-title cloudbill-title" style="height: auto !important;padding-bottom: 5px"><span class=bold-first-letter>P</span>ROJECT <span class=bold-first-letter>D</span>ETAILS</div><div class="invoice-contain webkit-scroll" style="padding:20px;height: auto"><div class=account-detail style="text-align: center;margin-top: -12px"><span class=account-label style="float:none;font-size: 14px">Project:</span><br><select class=project-select ng-model=vm.selectedProject ng-change=vm.changeProject(vm.availableDashboards) ng-options="option.project_id as option.project_id for option in vm.projectSelectList" style="width: 100%;margin-bottom: 20px;text-align-last:center"></select></div><div class=account-detail ng-show=vm.accountDetails.group><span class=account-label>Group:</span> <span style="white-space: nowrap">{{vm.accountDetails.group}}</span></div><div class=account-detail ng-show=vm.accountDetails.department><span class=account-label>Department:</span> <span style="white-space: nowrap">{{vm.accountDetails.department}}</span></div><div class=account-detail ng-show="!vm.enterprise && vm.accountDetails.paidBillingAccount"><span class=account-label>Paid Billing Account:</span> <span style="white-space: nowrap">{{vm.accountDetails.paidBillingAccount}}</span></div><div class=account-detail ng-show="vm.enterprise && vm.accountDetails.paidBillingAccount"><span class=account-label>Billing Account:</span> <span style="white-space: nowrap">{{vm.accountDetails.paidBillingAccount}}</span></div><div class=account-detail ng-show=vm.accountDetails.primaryContactEmail><span class=account-label>Primary Contact Email:</span> <span style="white-space: nowrap">{{vm.accountDetails.primaryContactEmail}}</span></div><div class=account-detail ng-show="!vm.enterprise && vm.accountDetails.afterCredits"><span class=account-label>After Budget:</span> <span>{{vm.accountDetails.afterCredits}}</span></div><div ng-repeat="allowances in vm.accountDetails.allowances" class=allowance-contain ng-show=!vm.enterprise><label>Allowance {{$index+1}}</label><div class=account-detail ng-if=allowances.type><span class=account-label>Type</span> <span>{{allowances.type}}</span></div><div class=account-detail ng-if=allowances.state><span class=account-label>State</span> <span>{{allowances.state}}</span></div><div class=account-detail ng-if=allowances.poNumber><span class=account-label>Cost Object</span> <span>{{allowances.poNumber}}</span></div><div class=account-detail ng-if=allowances.amount><span class=account-label ng-if=allowances.amount>Amount</span> <span>{{allowances.amount}}</span></div><div class=account-detail ng-if=allowances.dateIssued style=border-bottom:none><span class=account-label>Issued</span> <span>{{vm.moment(allowances.dateIssued).format(\'ddd MMM DD YYYY\')}}</span></div><div class=account-detail ng-if=allowances.dateActivated style=border-bottom:none><span class=account-label>Activated</span> <span>{{vm.moment(allowances.dateActivated).format(\'ddd MMM DD YYYY\')}}</span></div></div><div class=account-detail ng-show="vm.projectHasBudget && vm.currentConsumption" style="margin-top: 10px"><span class=account-label>Current Budget Consumption:</span> <span>${{vm.currentConsumption}}</span></div><div class=account-detail ng-show="vm.projectHasBudget && vm.currentConsumptionRemaining && vm.currentConsumptionBudget.type !== \'Pay As You Go\'" style="margin-top: 10px"><span class=account-label>Current Budget Remaining:</span> <span>${{vm.currentConsumptionRemaining}}</span></div><!-- <div class="account-detail" ng-show="!vm.enterprise && vm.accountDetails.totalBudget">\n                                    <span class="account-label">Total Budget:</span>\n                                    <span>{{vm.accountDetails.totalBudget}}</span></div> --><div class=account-detail ng-show="vm.enterprise && vm.accountDetails.monthlyBudget"><span class=account-label>Monthly Budget:</span> <span>{{vm.accountDetails.monthlyBudget}}</span></div></div></div></div></div><!-- <div class="row panel-row all-dashboards cloudbill-dashboard grey-round-border"\n                    style="min-height: 1px;overflow: hidden;">\n                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding show-dash"\n                        ng-class="{\'toggle-filter-min2\': !vm.toggleControl}">\n                        <div class="dashboard-panel"\n                            style="border:none;background-color:transparent;height: auto !important;">\n                            <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 np-padding">\n                                <span style="margin-top: 12px;background-color:#ffffff6b;"\n                                    ng-click="vm.toggleControl = !vm.toggleControl" class="show-dev-cat">></span>\n                            </div>\n                            <div class="dashboard-title cloudbill-title col-lg-10 col-md-10 col-sm-12 col-xs-12 np-padding"\n                                style="height: auto !important;padding-bottom: 7px;padding-left: 0px;border-bottom: 0px !important;margin-bottom: 0px !important;">\n                                <span class="bold-first-letter">C</span>ONTROL\n                                <span class="bold-first-letter"> P</span>ANEL\n                            </div>\n                        </div>\n                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">\n                            <div class="invoice-contain webkit-scroll col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"\n                                style="max-height: 85vh;border-top: 1px solid white;">\n                                <div ng-repeat="dash in vm.availableDashboards" ng-if="dash.showControl">\n                                    <label style="margin: 10px">\n                                        <input type="checkbox" name="dash[]" value="true" ng-model="vm.dash[dash.id]"\n                                            style="margin-right: 20px; margin-left:\n                                                    10px;" /><span>{{dash.name}}</span>\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div> --></div><div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 show-dash dash-contain sample-width all-dashboards"><div class="row panel-row all-dashboards cloudbill-dashboard hideCloudDash dash dash-temp" ng-if="vm.dash[\'yearConsumptionByMonth\'] && (vm.yearConsumptionByMonthLoading || vm.yearConsumptionByMonthTable.length > 0)" data-dash="Consumption By Month" ng-class="{\'show-dash\' : vm.dashControl[\'Consumption By Month\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px" ng-click="vm.expandReport(\'yearConsumptionByMonth\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>C</span>ONSUMPTION BY MONTH</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select class=bill-chart-select ng-model=vm.yearConsumptionByMonthChartSelect ng-options="option.id as option.name for option in vm.chartTypesTotals" ng-change="vm.selectChartChange(\'yearConsumptionByMonth\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.yearConsumptionByMonthLoading}"></div><div class=bill-no-data ng-show="vm.yearConsumptionByMonthTable.length === 0 && !vm.yearConsumptionByMonthLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.yearConsumptionByMonthLoading><loading></loading></div><div ng-show="vm.yearConsumptionByMonthTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.yearConsumptionByMonthLoading}"><highchart class=highcharts id=monthChart config=vm.yearConsumptionByMonthConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.yearConsumptionByMonthLoading && vm.yearConsumptionByMonthTable.length > 0"><p class=billing-details ng-click="vm.yearConsumptionByMonthToggle = !vm.yearConsumptionByMonthToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.yearConsumptionByMonthToggle}"></i></p></div></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.yearConsumptionByMonthLoading && vm.yearConsumptionByMonthTable.length > 0 && vm.yearConsumptionByMonthToggle" ng-class="{\'toggle-billing-table-on\' : vm.yearConsumptionByMonthToggle}"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.yearConsumptionByMonthDTInstance dt-options=vm.yearConsumptionByMonthDTOptions id=yearConsumptionByMonth-table><thead><tr><th>Month</th><th style=text-align:right>Consumption</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersyearConsumptionByMonth><tr><th bw-column-filter dt-instance=vm.yearConsumptionByMonthDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.yearConsumptionByMonthDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.yearConsumptionByMonthTable"><td>{{vm.months[item.month-1]}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div><div class="row panel-row all-dashboards cloudbill-dashboard hideCloudDash dash dash-temp" ng-if="vm.dash[\'consumptionByProduct\'] && (vm.consumptionByProductLoading || vm.consumptionByProductTable.length > 0)" data-dash="Consumption By Service" ng-class="{\'show-dash\' : vm.dashControl[\'Consumption By Service\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px" ng-click="vm.expandReport(\'consumptionByProduct\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span><select class=bill-chart-select ng-model=vm.timeSelect ng-options="option.id as option.name for option in vm.chartTimes" ng-change=vm.changeProject(vm.alterTimeReports)></select></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>C</span>ONSUMPTION BY SERVICE</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding" style="text-align: right"><select class=bill-chart-select ng-model=vm.consumptionByProductChartSelect ng-options="option.id as option.name for option in vm.chartTypesTotals" ng-change="vm.selectChartChange(\'consumptionByProduct\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.consumptionByProductLoading}"></div><div class=bill-no-data ng-show="vm.consumptionByProductTable.length === 0 && !vm.consumptionByProductLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.consumptionByProductLoading><loading></loading></div><div ng-show="vm.consumptionByProductTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.consumptionByProductLoading}"><highchart class=highcharts id=monthChart config=vm.consumptionByProductConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.consumptionByProductLoading && vm.consumptionByProductTable.length > 0"><p class=billing-details ng-click="vm.consumptionByProductToggle = !vm.consumptionByProductToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.consumptionByProductToggle}"></i></p></div></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.consumptionByProductLoading && vm.consumptionByProductTable.length > 0 && vm.consumptionByProductToggle" ng-class="{\'toggle-billing-table-on\' : vm.consumptionByProductToggle}"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.consumptionByProductDTInstance dt-options=vm.consumptionByProductDTOptions id=consumptionByProduct-table><thead><tr><th>Service</th><th style=text-align:right>Consumption</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersconsumptionByProduct><tr><th bw-column-filter dt-instance=vm.consumptionByProductDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByProductDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.consumptionByProductTable"><td>{{item.service_desc}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div><div class="row panel-row all-dashboards cloudbill-dashboard hideCloudDash dash dash-temp" ng-if="vm.dash[\'serviceConsumptionOverTime\'] && (vm.serviceConsumptionOverTimeLoading || vm.serviceConsumptionOverTimeTable.length > 0)" data-dash="Service Consumption Over Time" ng-class="{\'show-dash\' : vm.dashControl[\'Service Consumption Over Time\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px" ng-click="vm.expandReport(\'serviceConsumptionOverTime\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span><select class=bill-chart-select ng-model=vm.timeSelect ng-options="option.id as option.name for option in vm.chartTimes" ng-change=vm.changeProject(vm.alterTimeReports)></select></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>S</span>ERVICE CONSUMPTION OVER TIME</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select class=bill-chart-select ng-model=vm.serviceConsumptionOverTimeChartSelect ng-options="option.id as option.name for option in vm.chartTypesTime" ng-change="vm.selectChartChange(\'serviceConsumptionOverTime\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.serviceConsumptionOverTimeLoading}"></div><div class=bill-no-data ng-show="vm.serviceConsumptionOverTimeTable.length === 0 && !vm.serviceConsumptionOverTimeLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.serviceConsumptionOverTimeLoading><loading></loading></div><div ng-show="vm.serviceConsumptionOverTimeTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.serviceConsumptionOverTimeLoading}"><highchart class=highcharts id=monthChart config=vm.serviceConsumptionOverTimeConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.serviceConsumptionOverTimeLoading && vm.serviceConsumptionOverTimeTable.length > 0"><p class=billing-details ng-click="vm.serviceConsumptionOverTimeToggle = !vm.serviceConsumptionOverTimeToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.serviceConsumptionOverTimeToggle}"></i></p></div></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.serviceConsumptionOverTimeLoading && vm.serviceConsumptionOverTimeTable.length > 0 && vm.serviceConsumptionOverTimeToggle" ng-class="{\'toggle-billing-table-on\' : vm.serviceConsumptionOverTimeToggle}"><table class="table table-striped" dt-instance=vm.serviceConsumptionOverTimeDTInstance dt-options=vm.serviceConsumptionOverTimeDTOptions datatable=ng width=100% cellspacing=0 scrollx=true id=serviceConsumptionOverTime-table><thead><tr><!-- <th>Date</th> --><th>Service</th><th style=text-align:right>Consumption</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersserviceConsumptionOverTime><tr><!-- <th></th> --><!-- <th bw-column-filter dt-instance="vm.serviceConsumptionOverTimeDTInstance"\n                                            filter-type="text"></th> --><th bw-column-filter dt-instance=vm.serviceConsumptionOverTimeDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.serviceConsumptionOverTimeDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.serviceConsumptionOverTimeTable"><!-- <td></td> --><!-- <td>{{item.date}}</td> --><td>{{item.service_desc}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 dash-contain all-dashboards"><div class="row panel-row all-dashboards cloudbill-dashboard hideCloudDash dash dash-temp" ng-if="vm.dash[\'consumptionOverTime\'] && (vm.consumptionOverTimeLoading || vm.consumptionOverTimeTable.length > 0)" data-dash="Consumption Over Time" ng-class="{\'show-dash\' : vm.dashControl[\'Consumption Over Time\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px" ng-click="vm.expandReport(\'consumptionOverTime\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span><select class=bill-chart-select ng-model=vm.timeSelect ng-options="option.id as option.name for option in vm.chartTimes" ng-change=vm.changeProject(vm.alterTimeReports)></select></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>C</span>ONSUMPTION OVER TIME</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select class=bill-chart-select ng-model=vm.consumptionOverTimeChartSelect ng-options="option.id as option.name for option in vm.chartTypesTime" ng-change="vm.selectChartChange(\'consumptionOverTime\')"></select><!-- <select id="chart-cummulative-select" class="bill-chart-select"\n                                        ng-model="vm.consumptionOverTimeCummulative"\n                                        ng-options="option for option in vm.cummulativeSelect"\n                                        ng-change="vm.changeCummulativeChart(\'consumptionOverTime\')"></select> --></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.consumptionOverTimeLoading}"></div><div class=bill-no-data ng-show="vm.consumptionOverTimeTable.length === 0 && !vm.consumptionOverTimeLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.consumptionOverTimeLoading><loading></loading></div><div ng-show="vm.consumptionOverTimeTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.consumptionOverTimeLoading}"><highchart class=highcharts id=monthChart config=vm.consumptionOverTimeConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.consumptionOverTimeLoading && vm.consumptionOverTimeTable.length > 0"><p class=billing-details ng-click="vm.consumptionOverTimeToggle = !vm.consumptionOverTimeToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.consumptionOverTimeToggle}"></i></p></div></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.consumptionOverTimeLoading && vm.consumptionOverTimeTable.length > 0 && vm.consumptionOverTimeToggle" ng-class="{\'toggle-billing-table-on\' : vm.consumptionOverTimeToggle}"><table class="table table-striped" dt-instance=vm.consumptionOverTimeDTInstance dt-options=vm.consumptionOverTimeDTOptions datatable=ng width=100% cellspacing=0 scrollx=true id=consumptionOverTime-table><thead><tr><th>Date</th><th style=text-align:right>Consumption (Daily)</th><th style=text-align:right>Consumption (Cumulative)</th><th style=text-align:right ng-if=vm.singleBudgetExists>Remaining Budget</th><th style=text-align:right ng-if=vm.singleBudgetExists>Percentage Consumed</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersconsumptionOverTime><tr><th bw-column-filter dt-instance=vm.consumptionOverTimeDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionOverTimeDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionOverTimeDTInstance filter-type=text ng-if=vm.singleBudgetExists></th><th bw-column-filter dt-instance=vm.consumptionOverTimeDTInstance filter-type=text ng-if=vm.singleBudgetExists></th><th bw-column-filter dt-instance=vm.consumptionOverTimeDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.consumptionOverTimeTable"><td>{{item.date}}</td><td class=dt-body-right>${{item.subtotal}}</td><td class=dt-body-right>${{item.cummulative}}</td><td class=dt-body-right ng-if=vm.singleBudgetExists>${{item.remaining.toFixed(2)}}</td><td class=dt-body-right ng-if=vm.singleBudgetExists>{{item.percentage.toFixed(2)}}%</td></tr></tbody></table></div></div></div><div class="row panel-row all-dashboards cloudbill-dashboard hideCloudDash dash dash-temp" ng-if="vm.dash[\'consumptionByEntity\'] && (vm.consumptionByEntityLoading || vm.consumptionByEntityTable.length > 0)" data-dash="Consumption By Entity" ng-class="{\'show-dash\' : vm.dashControl[\'Consumption By Entity\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px" ng-click="vm.expandReport(\'consumptionByEntity\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span><select class=bill-chart-select ng-model=vm.timeSelect ng-options="option.id as option.name for option in vm.chartTimes" ng-change=vm.changeProject(vm.alterTimeReports)></select></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>C</span>ONSUMPTION BY ENTITY</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select class=bill-chart-select ng-model=vm.consumptionByEntityChartSelect ng-options="option.id as option.name for option in vm.chartTypesTotals" ng-change="vm.selectChartChange(\'consumptionByEntity\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.consumptionByEntityLoading}"></div><div class=bill-no-data ng-show="vm.consumptionByEntityTable.length === 0 && !vm.consumptionByEntityLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.consumptionByEntityLoading><loading></loading></div><div ng-show="vm.consumptionByEntityTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.consumptionByEntityLoading}"><highchart class=highcharts id=monthChart config=vm.consumptionByEntityConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.consumptionByEntityLoading && vm.consumptionByEntityTable.length > 0"><p class=billing-details ng-click="vm.consumptionByEntityToggle = !vm.consumptionByEntityToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.consumptionByEntityToggle}"></i></p></div></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.consumptionByEntityLoading && vm.consumptionByEntityTable.length > 0 && vm.consumptionByEntityToggle" ng-class="{\'toggle-billing-table-on\' : vm.consumptionByEntityToggle}"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.consumptionByEntityDTInstance dt-options=vm.consumptionByEntityDTOptions id=consumptionByEntity-table><thead><tr><!-- <th>Product</th> --><th>Entity</th><th style=text-align:right>Consumption</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersconsumptionByEntity><tr><!-- <th bw-column-filter dt-instance="vm.consumptionByEntityDTInstance"\n                                            filter-type="text"></th> --><th bw-column-filter dt-instance=vm.consumptionByEntityDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByEntityDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.consumptionByEntityTable"><!-- <td>{{item.service_desc}}</td> --><td>{{item.entity}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div><div class="row panel-row all-dashboards cloudbill-dashboard hideCloudDash dash dash-temp" ng-if="vm.dash[\'entityConsumptionOverTime\'] && (vm.entityConsumptionOverTimeLoading || vm.entityConsumptionOverTimeTable.length > 0)" data-dash="Entity Consumption Over Time" ng-class="{\'show-dash\' : vm.dashControl[\'Entity Consumption Over Time\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px" ng-click="vm.expandReport(\'entityConsumptionOverTime\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span><select class=bill-chart-select ng-model=vm.timeSelect ng-options="option.id as option.name for option in vm.chartTimes" ng-change=vm.changeProject(vm.alterTimeReports)></select></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>E</span>NTITY CONSUMPTION OVER TIME</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select class=bill-chart-select ng-model=vm.entityConsumptionOverTimeChartSelect ng-options="option.id as option.name for option in vm.chartTypesTime" ng-change="vm.selectChartChange(\'entityConsumptionOverTime\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.entityConsumptionOverTimeLoading}"></div><div class=bill-no-data ng-show="vm.entityConsumptionOverTimeTable.length === 0 && !vm.entityConsumptionOverTimeLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.entityConsumptionOverTimeLoading><loading></loading></div><div ng-show="vm.entityConsumptionOverTimeTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.entityConsumptionOverTimeLoading}"><highchart class=highcharts id=monthChart config=vm.entityConsumptionOverTimeConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.entityConsumptionOverTimeLoading && vm.entityConsumptionOverTimeTable.length > 0"><p class=billing-details ng-click="vm.entityConsumptionOverTimeToggle = !vm.entityConsumptionOverTimeToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.entityConsumptionOverTimeToggle}"></i></p></div></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.entityConsumptionOverTimeLoading && vm.entityConsumptionOverTimeTable.length > 0 && vm.entityConsumptionOverTimeToggle" ng-class="{\'toggle-billing-table-on\' : vm.entityConsumptionOverTimeToggle}"><table class="table table-striped" dt-instance=vm.entityConsumptionOverTimeDTInstance dt-options=vm.entityConsumptionOverTimeDTOptions datatable=ng width=100% cellspacing=0 scrollx=true id=entityConsumptionOverTime-table><thead><tr><!-- <th>Date</th> --><th>Entity</th><th style=text-align:right>Consumption</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersentityConsumptionOverTime><tr><!-- <th bw-column-filter dt-instance="vm.entityConsumptionOverTimeDTInstance"\n                                            filter-type="text"></th> --><th bw-column-filter dt-instance=vm.entityConsumptionOverTimeDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.entityConsumptionOverTimeDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.entityConsumptionOverTimeTable"><!-- <td>{{item.date}}</td> --><td>{{item.service_desc}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div></div></div><div><img class="gear operations" ng-init="ngLoaded = true" ng-class="{ opaque: ngLoaded }" src=./assets/img/gear.png ng-click=vm.selectDashboards() width=25px style="cursor: pointer"></div></div></div>');
$templateCache.put('app/cloudbilling/dashboard/cloudbilling_dashboard_admin.html','<div class="container col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 50px" id=cloudbilling><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" id=cloudbilling-dashboard><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding main-body all-dashboards" id=admin-dash-contain><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 sample-width" ng-show=false></div><!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 dash-contain"> --><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash dash dash-temp" ng-if="vm.dash[\'yearConsumptionByMonthAll\'] && (vm.yearConsumptionByMonthAllLoading || vm.yearConsumptionByMonthAllTable.length > 0)" data-dash="Consumption By Month (All Projects)" ng-class="{\'show-dash\' : vm.dashControl[\'Consumption By Month (All Projects)\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px;margin-left: -12px" ng-click="vm.expandReport(\'yearConsumptionByMonthAll\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span><!-- <select class="bill-chart-select" ng-model="vm.yearConsumptionByMonthAllTimeSelect"\n                                        ng-options="option.id as option.name for option in vm.chartMonthTimes"\n                                        ng-change="vm.changeProjectDates(\'yearConsumptionByMonthAll\')"></select> --></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>M</span>ONTHLY CONSUMPTION</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select id=chart-month-select class=bill-chart-select ng-model=vm.yearConsumptionByMonthAllChartSelect ng-options="option.id as option.name for option in vm.chartTypesTotals" ng-change="vm.selectChartChange(\'yearConsumptionByMonthAll\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.yearConsumptionByMonthAllLoading}"></div><div class=bill-no-data ng-show="vm.yearConsumptionByMonthAllTable.length === 0 && !vm.yearConsumptionByMonthAllLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.yearConsumptionByMonthAllLoading><loading></loading></div><div class=high-panel ng-show="vm.yearConsumptionByMonthAllTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.yearConsumptionByMonthAllLoading}"><highchart class=highcharts id=monthChart config=vm.yearConsumptionByMonthAllConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.yearConsumptionByMonthAllLoading && vm.yearConsumptionByMonthAllTable.length > 0"><p class=billing-details ng-click="vm.yearConsumptionByMonthAllToggle = !vm.yearConsumptionByMonthAllToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.yearConsumptionByMonthAllToggle}"></i></p></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.yearConsumptionByMonthAllLoading && vm.yearConsumptionByMonthAllTable.length > 0 && vm.yearConsumptionByMonthAllToggle" ng-class="{\'toggle-billing-table-on\' : vm.yearConsumptionByMonthAllToggle}"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.yearConsumptionByMonthAllDTInstance dt-options=vm.yearConsumptionByMonthAllDTOptions id=yearConsumptionByMonthAll-table><thead><tr><!-- <th class="nosort">\n                                                <a class="table-filters-toggle"\n                                                    ng-click="vm.showFiltersyearConsumptionByMonth = !vm.showFiltersyearConsumptionByMonth"><span\n                                                        class="fa fa-search"></span></a>\n                                            </th> --><th>Month</th><th style=text-align:right>Consumption</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersyearConsumptionByMonthAll><tr><!-- <th></th> --><th bw-column-filter dt-instance=vm.yearConsumptionByMonthAllDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.yearConsumptionByMonthAllDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.yearConsumptionByMonthAllTable"><!-- <td></td> --><td>{{vm.months[item.month-1]}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash dash dash-temp" ng-if="vm.dash[\'trendStats\']" data-dash="Trend Summary" ng-class="{\'show-dash\' : vm.dashControl[\'Trend Summary\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash"><!-- <div class="panel-body well cloudbill-datatable-contain"> --><div class="dashboard-title cloudbill-title" style="font-weight: 300;margin-bottom: 0px !important;width: 95%;margin: auto;margin-left: 2.5%"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding" style="text-align: left"></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12"><span class=bold-first-letter>I</span>NSIGHTS</div></div><div class="panel-loader loading dashboard-loader" ng-show=vm.trendStatsLoading style=margin-top:100px><loading></loading></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding show-dash" style=margin-bottom:0px ng-show=!vm.trendStatsLoading><div class=dashboard-panel style="border:none;background-color:transparent;height: 297px"><!-- <div class="bill-no-data"\n                                    ng-show="!vm.creditStatusTotalConsumption && !vm.creditStatusLoading">\n                                    NO DATA AVAILABLE FOR THIS REPORT\n                                </div> --><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="text-align: center;padding:10px;height:100%" ng-if=!vm.trendStatsLoading><div class="trend-widget report-widget crop-text" style="background-color: #526f68; margin-bottom: 8px"><span class=trend-letters>DAILY<br>AVERAGE<br>$ {{vm.trendStats.daily.today}}</span><span><img ng-src=assets/img/icon/up_arrow.png width=50 height="" class=trend-arrow ng-class="{\'trend-down\' : !vm.trendStats.daily.gain }"></span><span class=sub-trend-letters>PREV.<br>AVG.<br>$ {{vm.trendStats.daily.yesterday}}</span></div><div class="trend-widget report-widget crop-text" style="background-color: #526f68; margin-bottom: 8px"><span class=trend-letters>7 DAY<br>AVERAGE<br>$ {{vm.trendStats.weekly.this}}</span><span><img ng-src=assets/img/icon/up_arrow.png width=50 height="" class=trend-arrow ng-class="{\'trend-down\' : !vm.trendStats.weekly.gain }"></span><span class=sub-trend-letters>PREV.<br>AVG.<br>$ {{vm.trendStats.weekly.last}}</span></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="text-align: center;padding:10px;height:100%" ng-if=!vm.trendStatsLoading><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding report-widget average-widget crop-text" style="background-color: #525b6f;padding: 28px;margin-bottom: 8px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: center;margin-bottom: 5px"><span class=trend-letters>LOWEST PROJECT AVERAGE</span></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: center;margin-bottom: 10px"><span class=trend-letters>$ {{vm.trendStats.lowProject.rate}}</span></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: center;margin-bottom: 5px"><span class=trend-letters>{{vm.trendStats.lowProject.name}}</span></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: center"><span class=sub-trend-letters>TWO WEEK AVERAGE</span></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding report-widget average-widget crop-text" style="background-color: #525b6f;padding: 28px;margin-bottom: 8px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: center;margin-bottom: 5px"><span class=trend-letters>HIGHEST PROJECT AVERAGE</span></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: center;margin-bottom: 10px"><span class=trend-letters>$ {{vm.trendStats.highProject.rate}}</span></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: center;margin-bottom: 5px"><span class=trend-letters>{{vm.trendStats.highProject.name}}</span></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: center"><span class=sub-trend-letters>TWO WEEK AVERAGE</span></div></div></div></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash dash dash-temp" ng-if="vm.dash[\'consumptionByProject\'] && (vm.consumptionByProjectLoading || vm.consumptionByProjectTable.length > 0)" data-dash="Consumption By Project" ng-class="{\'show-dash\' : vm.dashControl[\'Consumption By Project\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px;margin-left: -12px" ng-click="vm.expandReport(\'consumptionByProject\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span><select class=bill-chart-select ng-model=vm.timeSelect ng-options="option.id as option.name for option in vm.chartTimes" ng-change=vm.changeProject(vm.alterTimeReports)></select></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>C</span>ONSUMPTION BY PROJECT</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><!-- <label class="bill-select-label" for="chart-month-select">CHART TYPE</label> --><!-- <select id="chart-month-select" class="bill-chart-select"\n                                            ng-model="vm.consumptionByProjectChartSelect"\n                                            ng-options="option.id as option.name for option in vm.chartTypesStacked"\n                                            ng-change="vm.selectChartChange(\'consumptionByProject\')"></select> --></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.consumptionByProjectLoading}"></div><div class=bill-no-data ng-show="vm.consumptionByProjectTable.length === 0 && !vm.consumptionByProjectLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.consumptionByProjectLoading><loading></loading></div><div class=high-panel ng-show="vm.consumptionByProjectTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.consumptionByProjectLoading}"><highchart class=highcharts id=budget-Chart config=vm.consumptionByProjectConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.consumptionByProjectLoading && vm.consumptionByProjectTable.length > 0"><p class=billing-details ng-click="vm.consumptionByProjectToggle = !vm.consumptionByProjectToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.consumptionByProjectToggle}"></i></p></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.consumptionByProjectLoading && vm.consumptionByProjectTable.length > 0 && vm.consumptionByProjectToggle" ng-class="{\'toggle-billing-table-on\' : vm.consumptionByProjectToggle}"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.consumptionByProjectDTInstance dt-options=vm.consumptionByProjectDTOptions id=consumptionByProject-table><thead><tr><th>Project</th><th style=text-align:right>Consumption</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersconsumptionByProject><tr><th bw-column-filter dt-instance=vm.consumptionByProjectDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByProjectDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.consumptionByProjectTable"><td>{{item.project_id}} {{vm.projectNames[item.project_id] ? "(" + vm.projectNames[item.project_id] + ")" : ""}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash dash dash-temp" ng-if="vm.dash[\'currentBudgetStatus\'] && (vm.currentBudgetStatusLoading || vm.currentBudgetStatusTable.length > 0)" data-dash="Current Budget Status" ng-class="{\'show-dash\' : vm.dashControl[\'Current Budget Status\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px;margin-left: -12px" ng-click="vm.expandReport(\'currentBudgetStatus\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>C</span>URRENT BUDGET STATUS</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.currentBudgetStatusLoading}"></div><div class=bill-no-data ng-show="vm.currentBudgetStatusTable.length === 0 && !vm.currentBudgetStatusLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.currentBudgetStatusLoading><loading></loading></div><div class=high-panel ng-show="vm.currentBudgetStatusTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.currentBudgetStatusLoading}"><highchart class=highcharts id=budget-Chart config=vm.currentBudgetStatusConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.currentBudgetStatusLoading && vm.currentBudgetStatusTable.length > 0"><p class=billing-details ng-click="vm.currentBudgetStatusToggle = !vm.currentBudgetStatusToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.currentBudgetStatusToggle}"></i></p></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.currentBudgetStatusLoading && vm.currentBudgetStatusTable.length > 0 && vm.currentBudgetStatusToggle" ng-class="{\'toggle-billing-table-on\' : vm.currentBudgetStatusToggle}"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.currentBudgetStatusDTInstance dt-options=vm.currentBudgetStatusDTOptions id=currentBudgetStatus-table><thead><tr><th>Project</th><th style=text-align:right>Consumption</th><th style=text-align:right>Budget</th><th style=text-align:right>Remaining Budget</th><th style=text-align:right>Percentage Consumed</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilterscurrentBudgetStatus><tr><th bw-column-filter dt-instance=vm.currentBudgetStatusDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.currentBudgetStatusDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.currentBudgetStatusDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.currentBudgetStatusDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.currentBudgetStatusDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.currentBudgetStatusTable"><td>{{item.projectID}} {{vm.projectNames[item.projectID] ? "(" + vm.projectNames[item.projectID] + ")" : ""}}</td><td class=dt-body-right>${{item.currentAllowanceConsumption}}</td><td class=dt-body-right>${{item.currentAllowanceAmount}}</td><td class=dt-body-right>${{item.currentAllowanceRemaining}}</td><td class=dt-body-right>{{item.currentPercentage}}%</td></tr></tbody></table></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash dash dash-temp" ng-if="vm.dash[\'consumptionByPO\'] && (vm.consumptionByPOLoading || vm.consumptionByPOTable.length > 0)" data-dash="Purchase Order Consumption" ng-class="{\'show-dash\' : vm.dashControl[\'Purchase Order Consumption\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px;margin-left: -12px" ng-click="vm.expandReport(\'consumptionByPO\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>P</span>URCHASE ORDER CONSUMPTION</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.consumptionByPOLoading}"></div><div class=bill-no-data ng-show="vm.consumptionByPOTable.length === 0 && !vm.consumptionByPOLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.consumptionByPOLoading><loading></loading></div><div class=high-panel ng-show="vm.consumptionByPOTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.consumptionByPOLoading}"><highchart class=highcharts id=po-Chart config=vm.consumptionByPOConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.consumptionByPOLoading && vm.consumptionByPOTable.length > 0"><p class=billing-details ng-click="vm.consumptionByPOToggle = !vm.consumptionByPOToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.consumptionByPOToggle}"></i></p></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.consumptionByPOLoading && vm.consumptionByPOTable.length > 0 && vm.consumptionByPOToggle" ng-class="{\'toggle-billing-table-on\' : vm.consumptionByPOToggle}"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.consumptionByPODTInstance dt-options=vm.consumptionByPODTOptions id=consumptionByPO-table><thead><tr><th>Purchase Order</th><th style=text-align:right>Consumption</th><th style=text-align:right>PO Amount</th><th style=text-align:right>Remaining Amount</th><th style=text-align:right>Percentage Consumed</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilterscurrentBudgetStatus><tr><th bw-column-filter dt-instance=vm.consumptionByPODTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByPODTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByPODTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByPODTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByPODTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.consumptionByPOTable"><td>{{item.po}}</td><td class=dt-body-right>${{item.currentAllowanceConsumption.toFixed(2)}}</td><td class=dt-body-right>${{item.currentAllowanceAmount.toFixed(2)}}</td><td class=dt-body-right>${{item.currentAllowanceRemaining.toFixed(2)}}</td><td class=dt-body-right>{{item.currentPercentage}}%</td></tr></tbody></table></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash dash dash-temp" ng-if="vm.dash[\'creditStatus\'] && !vm.enterprise" data-dash="Credit Status" ng-class="{\'show-dash\' : vm.dashControl[\'Credit Status\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash"><!-- <div class="panel-body well cloudbill-datatable-contain"> --><div class="dashboard-title cloudbill-title" style="font-weight: 300;margin-bottom: 0px !important;width: 95%;margin: auto;margin-left: 2.5%"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding" style="text-align: left"></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12"><span class=bold-first-letter>S</span>PEND SUMMARY</div></div><div class="panel-loader loading dashboard-loader" ng-show=vm.creditStatusLoading style=margin-top:100px><loading></loading></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding show-dash" ng-if=vm.mit style=margin-bottom:0px ng-show=!vm.creditStatusLoading><div class=dashboard-panel ng-if=!vm.enterprise style="border:none;background-color:transparent;height: 100% !important"><div class=bill-no-data ng-show="!vm.creditStatusTotalConsumption && !vm.creditStatusLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 crop-text" style="text-align: center;padding:10px" ng-if="vm.creditStatusTotalConsumption && !vm.creditStatusLoading"><p class=report-widget style="background-color: #526f68">MAIN<br>CREDIT<br>CONSUMPTION<br>$ {{vm.creditStatusMasterCreditTotalConsumption}}</p><p class=report-widget ng-if=!vm.noBudgetData style="background-color: #525b6f">MAIN<br>ALLOCATED<br>CREDIT BUDGET<br>$ {{vm.allocatedMasterCreditBudget}}</p><p class=report-widget ng-if="!vm.noBudgetData && vm.isAdmin && vm.mit" style="background-color: #6f526e">MAIN<br>TOTAL<br>CREDIT BUDGET<br>$ {{vm.totalMasterCreditBudget}}</p></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 crop-text" style="text-align: center;padding:10px" ng-if="vm.creditStatusTotalConsumption && !vm.creditStatusLoading"><p class=report-widget style="background-color: #526f68">CREDIT<br>CONSUMPTION<br>$ {{vm.creditStatusCreditTotalConsumption}}</p><p class=report-widget ng-if=!vm.noBudgetData style="background-color: #525b6f">ALLOCATED<br>CREDIT<br>BUDGET<br>$ {{vm.allocatedCreditBudget}}</p><p class=report-widget ng-if="!vm.noBudgetData && vm.isAdmin && vm.mit" style="background-color: #6f526e">TOTAL<br>CREDITS<br>BUDGET<br>$ {{vm.allocatedCreditBudget}}</p></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 crop-text" style="text-align: center;padding:10px" ng-if="vm.creditStatusTotalConsumption && !vm.creditStatusLoading"><p class=report-widget style="background-color: #526f68">PAID<br>CONSUMPTION<br>$ {{vm.creditStatusPOTotalConsumption}}</p><p class=report-widget ng-if=!vm.noBudgetData style="background-color: #525b6f">ALLOCATED<br>PAID<br>BUDGET<br>$ {{vm.allocatedPOBudget}}</p><p class=report-widget ng-if="!vm.noBudgetData && vm.isAdmin && vm.mit" style="background-color: #6f526e">TOTAL PAID<br>BUDGET<br>$ {{vm.totalPOBudget}}</p></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 crop-text" style="text-align: center;padding:10px" ng-if="vm.creditStatusTotalConsumption && !vm.creditStatusLoading"><p class=report-widget style="background-color: #526f68">TOTAL<br>CONSUMPTION<br>$ {{vm.creditStatusTotalConsumption}}</p><p class=report-widget ng-if=!vm.noBudgetData style="background-color: #525b6f">TOTAL<br>ALLOCATED<br>BUDGET<br>$ {{vm.allocatedFundingBudget}}</p><p class=report-widget ng-if="!vm.noBudgetData && vm.isAdmin && vm.mit" style="background-color: #6f526e">TOTAL<br>FUNDING<br>BUDGET<br>$ {{vm.totalFundingBudget}}</p></div></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding show-dash" ng-if=!vm.mit style="margin-bottom:0px;margin-top: 15px;height:300px" ng-show=!vm.creditStatusLoading><div class=dashboard-panel ng-if=!vm.enterprise style="border:none;background-color:transparent;height: 100% !important"><div class=bill-no-data ng-show="!vm.creditStatusTotalConsumption && !vm.creditStatusLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 crop-text" style="text-align: center;padding:10px" ng-if="vm.creditStatusTotalConsumption && !vm.creditStatusLoading"><p class=report-widget style="background-color: #526f68">CREDIT<br>CONSUMPTION<br>$ {{vm.creditStatusCreditTotalConsumption}}</p><p class=report-widget ng-if=!vm.noBudgetData style="background-color: #525b6f">ALLOCATED CREDIT BUDGET<br>$ {{vm.allocatedCreditBudget}}</p><p class=report-widget ng-if="!vm.noBudgetData && vm.isAdmin && vm.mit" style="background-color: #6f526e">TOTAL CREDITS<br>BUDGET<br>$ {{vm.totalCreditBudget}}</p></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 crop-text" style="text-align: center;padding:10px" ng-if="vm.creditStatusTotalConsumption && !vm.creditStatusLoading"><p class=report-widget style="background-color: #526f68">PAID<br>CONSUMPTION<br>$ {{vm.creditStatusPOTotalConsumption}}</p><p class=report-widget ng-if=!vm.noBudgetData style="background-color: #525b6f">ALLOCATED PAID BUDGET<br>$ {{vm.allocatedPOBudget}}</p><p class=report-widget ng-if="!vm.noBudgetData && vm.isAdmin && vm.mit" style="background-color: #6f526e">TOTAL PAID<br>BUDGET<br>$ {{vm.totalPOBudget}}</p></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 crop-text" style="text-align: center;padding:10px" ng-if="vm.creditStatusTotalConsumption && !vm.creditStatusLoading"><p class=report-widget style="background-color: #526f68">TOTAL<br>CONSUMPTION<br>$ {{vm.creditStatusTotalConsumption}}</p><p class=report-widget ng-if=!vm.noBudgetData style="background-color: #525b6f">TOTAL ALLOCATED BUDGET<br>$ {{vm.allocatedFundingBudget}}</p><p class=report-widget ng-if="!vm.noBudgetData && vm.isAdmin && vm.mit" style="background-color: #6f526e">TOTAL FUNDING<br>BUDGET<br>$ {{vm.totalFundingBudget}}</p></div></div><div class=dashboard-panel ng-if=vm.enterprise style="border:none;background-color:transparent;height: auto !important"><div class=bill-no-data ng-show="!vm.creditStatusTotalConsumption && !vm.creditStatusLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 crop-text" style="text-align: center;margin-top:17px;padding:10px" ng-if="vm.creditStatusTotalConsumption && !vm.creditStatusLoading"><p class=report-widget style="background-color: #526f68;padding:12px;font-weight: 300; font-size: 15px">TOTAL<br>CONSUMPTION<br>$ {{vm.creditStatusTotalConsumption}}</p><p class=report-widget ng-if="!vm.noBudgetData && vm.isAdmin" style="background-color: #6f526e;padding:12px;font-weight: 300; font-size: 15px">TOTAL FUNDING<br>BUDGET<br>$ {{vm.totalFundingBudget}}</p></div></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash dash dash-temp" ng-if="vm.dash[\'consumptionByDepartment\'] && (vm.consumptionByDepartmentLoading || vm.consumptionByDepartmentTable.length > 0)" data-dash="Consumption By Department" ng-class="{\'show-dash\' : vm.dashControl[\'Consumption By Department\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px;margin-left: -12px" ng-click="vm.expandReport(\'consumptionByDepartment\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span><select class=bill-chart-select ng-model=vm.timeSelect ng-options="option.id as option.name for option in vm.chartTimes" ng-change=vm.changeProject(vm.alterTimeReports)></select></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>C</span>ONSUMPTION BY DEPARTMENT</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select class=bill-chart-select ng-model=vm.consumptionByDepartmentChartSelect ng-options="option.id as option.name for option in vm.chartTypesTotals" ng-change="vm.selectChartChange(\'consumptionByDepartment\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.consumptionByDepartmentLoading}"></div><div class=bill-no-data ng-show="vm.consumptionByDepartmentTable.length === 0 && !vm.consumptionByDepartmentLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.consumptionByDepartmentLoading><loading></loading></div><div class=high-panel ng-show="vm.consumptionByDepartmentTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.consumptionByDepartmentLoading}"><highchart class=highcharts id=depoChart config=vm.consumptionByDepartmentConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.consumptionByDepartmentLoading && vm.consumptionByDepartmentTable.length > 0"><p class=billing-details ng-click="vm.consumptionByDepartmentToggle = !vm.consumptionByDepartmentToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.consumptionByDepartmentToggle}"></i></p></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.consumptionByDepartmentLoading && vm.consumptionByDepartmentTable.length > 0 && vm.consumptionByDepartmentToggle" ng-class="{\'toggle-billing-table-on\' : vm.consumptionByDepartmentToggle}"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.consumptionByDepartmentDTInstance dt-options=vm.consumptionByDepartmentDTOptions id=consumptionByDepartment-table><thead><tr><th>Department</th><th style=text-align:right>Consumption</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersconsumptionByDepartment><tr><th bw-column-filter dt-instance=vm.consumptionByDepartmentDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByDepartmentDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.consumptionByDepartmentTable"><td>{{item.department}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash dash dash-temp" ng-if="vm.dash[\'yearConsumptionByMonthAccount\'] && (vm.yearConsumptionByMonthAccountLoading || vm.yearConsumptionByMonthAccountTable.length > 0)" data-dash="Account Consumption" ng-class="{\'show-dash\' : vm.dashControl[\'Account Consumption\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px;margin-left: -12px" ng-click="vm.expandReport(\'yearConsumptionByMonthAccount\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span><select class=bill-chart-select ng-model=vm.timeSelect ng-options="option.id as option.name for option in vm.chartTimes" ng-change=vm.changeProject(vm.alterTimeReports)></select></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>C</span>ONSUMPTION BY ACCOUNT</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select id=chart-month-select-account class=bill-chart-select ng-model=vm.yearConsumptionByMonthAccountChartSelect ng-options="option.id as option.name for option in vm.chartTypesStacked" ng-change="vm.selectChartChange(\'yearConsumptionByMonthAccount\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.yearConsumptionByMonthAccountLoading}"></div><div class=bill-no-data ng-show="vm.yearConsumptionByMonthAccountTable.length === 0 && !vm.yearConsumptionByMonthAccountLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.yearConsumptionByMonthAccountLoading><loading></loading></div><div class=high-panel ng-show="vm.yearConsumptionByMonthAccountTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.yearConsumptionByMonthAccountLoading}"><highchart class=highcharts id=monthChart config=vm.yearConsumptionByMonthAccountConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.yearConsumptionByMonthAccountLoading && vm.yearConsumptionByMonthAccountTable.length > 0"><p class=billing-details ng-click="vm.yearConsumptionByMonthAccountToggle = !vm.yearConsumptionByMonthAccountToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.yearConsumptionByMonthAccountToggle}"></i></p></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.yearConsumptionByMonthAccountLoading && vm.yearConsumptionByMonthAccountTable.length > 0" ng-class="{\'toggle-billing-table-on\' : vm.yearConsumptionByMonthAccountToggle}"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.yearConsumptionByMonthAccountDTInstance dt-options=vm.yearConsumptionByMonthAccountDTOptions id=yearConsumptionByMonthAccount-table><thead><tr><th>Account Name</th><th>Account Number</th><th style=text-align:right>Consumption</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersyearConsumptionByMonthAccount><tr><th bw-column-filter dt-instance=vm.yearConsumptionByMonthAccountDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.yearConsumptionByMonthAccountDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.yearConsumptionByMonthAccountDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.yearConsumptionByMonthAccountTable"><td>{{item.accountName}}</td><td>{{item.billing_account_id}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div></div><!-- </div>\n\n\n\n            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 dash-contain"> --><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash dash dash-temp" ng-if="vm.dash[\'consumptionByProduct\'] && (vm.consumptionByProductLoading || vm.consumptionByProductTable.length > 0)" data-dash="Consumption By Service" ng-class="{\'show-dash\' : vm.dashControl[\'Consumption By Service\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px;margin-left: -12px" ng-click="vm.expandReport(\'consumptionByProduct\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span><select class=bill-chart-select ng-model=vm.timeSelect ng-options="option.id as option.name for option in vm.chartTimes" ng-change=vm.changeProject(vm.alterTimeReports)></select></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>C</span>ONSUMPTION BY SERVICE</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select class=bill-chart-select ng-model=vm.consumptionByProductChartSelect ng-options="option.id as option.name for option in vm.chartTypesTotals" ng-change="vm.selectChartChange(\'consumptionByProduct\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.consumptionByProductLoading}"></div><div class=bill-no-data ng-show="vm.consumptionByProductTable.length === 0 && !vm.consumptionByProductLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.consumptionByProductLoading><loading></loading></div><div class=high-panel ng-show="vm.consumptionByProductTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.consumptionByProductLoading}"><highchart class=highcharts id=serviceChart config=vm.consumptionByProductConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.consumptionByProductLoading && vm.consumptionByProductTable.length > 0"><p class=billing-details ng-click="vm.consumptionByProductToggle = !vm.consumptionByProductToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.consumptionByProductToggle}"></i></p></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.consumptionByProductLoading && vm.consumptionByProductTable.length > 0 && vm.consumptionByProductToggle" ng-class="{\'toggle-billing-table-on\' : vm.consumptionByProductToggle}"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.consumptionByProductDTInstance dt-options=vm.consumptionByProductDTOptions id=consumptionByProduct-table><thead><tr><th>Service</th><th style=text-align:right>Consumption</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersconsumptionByProduct><tr><th bw-column-filter dt-instance=vm.consumptionByProductDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByProductDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.consumptionByProductTable"><td>{{item.service_desc}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash dash dash-temp" ng-if="vm.dash[\'thresholdAlerts75\'] && (vm.thresholdAlerts75Loading || vm.thresholdAlerts75Table.length > 0)" data-dash="Projects Threshold Alerts" ng-class="{\'show-dash\' : vm.dashControl[\'Projects Threshold Alerts\']}"><div class="well row panel-row all-dashboards cloudbill-dashboard hideCloudDash webkit-scroll" style="margin-top: 0px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 show-dash" style="padding: 0px;min-height: 375px!important"><!-- <div class="panel-body well cloudbill-datatable-contain"> --><div class="dashboard-title cloudbill-title" style="font-weight: 300;margin-bottom: 0px !important;width: 95%;margin: auto;margin-left: 2.5%"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding" style="text-align: left"></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12"><span class=bold-first-letter>P</span>ROJECTS ABOVE 75% BUDGET</div></div><div class=no-results style="padding: 115px" ng-show="!vm.thresholdAlerts75Loading && vm.thresholdAlerts75Table.length == 0 && !vm.noBudget"><p style="letter-spacing: 2px">NO PROJECTS ABOVE 75% OF BUDGET</p></div><div class="panel-loader loading dashboard-loader" ng-show=vm.thresholdAlerts75Loading style=margin-top:100px><loading></loading></div><div class=table-responsive ng-if="!vm.thresholdAlerts75Loading && vm.thresholdAlerts75Table.length > 0 && !vm.noBudgetData" style="position: absolute;width:100%;min-height: 330px" id=thresholdAlerts75><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.thresholdAlerts75DTInstance dt-options=vm.dtOptionsAlerts id=thresholdAlerts75-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFiltersthresholdAlerts75 = !vm.showFiltersthresholdAlerts75"><span class="fa fa-search"></span></a></th><th>Project</th><th ng-show=!vm.enterprise style=text-align:right>Budget Types</th><th style=text-align:right>Budget</th><th style=text-align:right>Consumption</th><th style=text-align:right>Remaining</th><th style=text-align:right>Percentage Used</th><th style=text-align:right>Days Left (Est.)</th><th ng-show=!vm.enterprise>After Credit</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersthresholdAlerts75><tr><th></th><th bw-column-filter dt-instance=vm.thresholdAlerts75DTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.thresholdAlerts75DTInstance ng-show=!vm.enterprise filter-type=text></th><th bw-column-filter dt-instance=vm.thresholdAlerts75DTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.thresholdAlerts75DTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.thresholdAlerts75DTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.thresholdAlerts75DTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.thresholdAlerts75DTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.thresholdAlerts75DTInstance ng-show=!vm.enterprise filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.thresholdAlerts75Table"><td></td><td>{{item.project_id}} {{vm.projectNames[item.project_id] ? "(" + vm.projectNames[item.project_id] + ")" : ""}}</td><td class=dt-body-right ng-show=!vm.enterprise>{{item.budgetTypes}}</td><td class=dt-body-right>${{item.budget.toFixed(2)}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td><td class=dt-body-right>${{item.remaining.toFixed(2)}}</td><td class=dt-body-right>{{item.percentage.toFixed(2)}}%</td><td class=dt-body-right>{{item.daysLeft.toFixed(2)}} Days</td><td class=dt-body-right ng-show=!vm.enterprise>{{item.afterCredits}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash dash dash-temp" ng-if="vm.dash[\'consumptionByEntity\'] && (vm.consumptionByEntityLoading || vm.consumptionByEntityTable.length > 0)" data-dash="Consumption By Entity" ng-class="{\'show-dash\' : vm.dashControl[\'Consumption By Entity\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px;margin-left: -12px" ng-click="vm.expandReport(\'consumptionByEntity\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span><select class=bill-chart-select ng-model=vm.timeSelect ng-options="option.id as option.name for option in vm.chartTimes" ng-change=vm.changeProject(vm.alterTimeReports)></select></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>C</span>ONSUMPTION BY ENTITY</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select class=bill-chart-select ng-model=vm.consumptionByEntityChartSelect ng-options="option.id as option.name for option in vm.chartTypesTotals" ng-change="vm.selectChartChange(\'consumptionByEntity\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.consumptionByEntityLoading}"></div><div class=bill-no-data ng-show="vm.consumptionByEntityTable.length === 0 && !vm.consumptionByEntityLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.consumptionByEntityLoading><loading></loading></div><div class=high-panel ng-show="vm.consumptionByEntityTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.consumptionByEntityLoading}"><highchart class=highcharts id=entityChart config=vm.consumptionByEntityConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.consumptionByEntityLoading && vm.consumptionByEntityTable.length > 0"><p class=billing-details ng-click="vm.consumptionByEntityToggle = !vm.consumptionByEntityToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.consumptionByEntityToggle}"></i></p></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.consumptionByEntityLoading && vm.consumptionByEntityTable.length > 0 && vm.consumptionByEntityToggle" ng-class="{\'toggle-billing-table-on\' : vm.consumptionByEntityToggle}"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.consumptionByEntityDTInstance dt-options=vm.consumptionByEntityDTOptions id=consumptionByEntity-table><thead><tr><th>Entity</th><th style=text-align:right>Consumption</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersconsumptionByEntity><tr><th bw-column-filter dt-instance=vm.consumptionByEntityDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByEntityDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.consumptionByEntityTable"><td>{{item.entity}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash dash dash-temp" ng-if="vm.dash[\'consumptionByLabel\'] && (vm.consumptionByLabelLoading || vm.consumptionByLabelTable.length > 0)" data-dash="Consumption By Label" ng-class="{\'show-dash\' : vm.dashControl[\'Consumption By Label\']}"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash"><div class=dashboard-panel style=border:none;background-color:transparent><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"><span class=expand-button style="margin-top: 2px;margin-right: 10px;margin-left: -12px" ng-click="vm.expandReport(\'consumptionByLabel\')"><img ng-src=assets/img/expand-512.png width=20 height="" style=height:auto></span><select class=bill-chart-select ng-model=vm.timeSelect ng-options="option.id as option.name for option in vm.chartTimes" ng-change=vm.changeProject(vm.alterTimeReports)></select></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>C</span>ONSUMPTION BY LABEL</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select class=bill-chart-select ng-model=vm.consumptionByLabelChartSelect ng-options="option.id as option.name for option in vm.chartTypesTotals" ng-change="vm.selectChartChange(\'consumptionByLabel\')"></select></div></div><div class=bill-chart-select-contain ng-class="{\'hide-while-loading\' : vm.consumptionByLabelLoading}"></div><div class=bill-no-data ng-show="vm.consumptionByLabelTable.length === 0 && !vm.consumptionByLabelLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.consumptionByLabelLoading><loading></loading></div><div class=high-panel ng-show="vm.consumptionByLabelTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.consumptionByLabelLoading}"><highchart class=highcharts id=labelChart config=vm.consumptionByLabelConfig></highchart></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding toggle-billing" ng-if="!vm.consumptionByLabelLoading && vm.consumptionByLabelTable.length > 0"><p class=billing-details ng-click="vm.consumptionByLabelToggle = !vm.consumptionByLabelToggle">DETAILS: <i class="arrow down" ng-class="{\'up\' : vm.consumptionByLabelToggle}"></i></p></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class="table-responsive cloudbill-datatable-inner-contain" ng-if="!vm.consumptionByLabelLoading && vm.consumptionByLabelTable.length > 0 && vm.consumptionByLabelToggle" ng-class="{\'toggle-billing-table-on\' : vm.consumptionByLabelToggle}"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.consumptionByLabelDTInstance dt-options=vm.consumptionByLabelDTOptions id=consumptionByLabel-table><thead><tr><th>Label</th><th style=text-align:right>Consumption</th></tr></thead><tfoot class=table-filters ng-show=vm.showFiltersconsumptionByLabel><tr><th bw-column-filter dt-instance=vm.consumptionByLabelDTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByLabelDTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.consumptionByLabelTable"><td>{{item.billing_label}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div></div></div></div></div><!-- </div> --><div><img class="gear operations" ng-init="ngLoaded = true" ng-class="{ opaque: ngLoaded }" src=./assets/img/gear.png ng-click=vm.selectDashboards() width=25px style="cursor: pointer"></div><!-- <div id="dashboard-control" ng-click="vm.selectDashboards()">Dashboard Control</div> --></div></div>');
$templateCache.put('app/cloudbilling/report/cloudbilling_reports.html','<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 container-top" style="margin-top:0px; padding:30px" id=cloudbill-report-contain><div class="row col-lg-3 col-md-12 col-sm-12 col-xs-12 no-padding"><div><div id=exTab3 style="width:100%; padding:0"><ul class="nav nav-pills"><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'report\']"><a ng-click="vm.tabView = \'report\'" data-toggle=tab>REPORTS</a></li><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'invoice\']"><a ng-click="vm.tabView = \'invoice\'" data-toggle=tab>INVOICES</a></li><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'summary\']" ng-if=vm.isAdmin><a ng-click="vm.tabView = \'summary\'" data-toggle=tab>SUMMARY</a></li></ul><div class="tab-content clearfix" ng-if=vm.isAdmin><div class="tab-pane active report-shadow panel-shadow" id=3b ng-show="vm.tabView === \'summary\'"><div class="panel panel-default left-report-panel tick-rep" style="border-top-left-radius: 0px !important;padding: 30px"><div ng-click=vm.downloadSummary() class=download-cloud-summary><div class=panel-loader ng-show=vm.summaryLoading><div class="css-loading-qbr css-loading--double" style="margin-top: 6px;right: 27%"></div></div>Weekly Summary Report<div class=panel-loader ng-show=vm.summaryLoading><div class="css-loading-qbr css-loading--double"></div></div><i class="fa fa-download" aria-hidden=true data-toggle=tooltip title="Download Summary"></i><p ng-show=vm.summaryLoading>Your summary is processing and will begin downloading shortly.</p></div><!-- <div ng-if="vm.isAdmin" ng-click="vm.downloadBudgetReport()" class="download-cloud-summary"\n                                style="margin-top: 10px;">\n                                <div class="panel-loader" ng-show="vm.adminReportLoading">\n                                    <div class="css-loading-qbr css-loading--double"\n                                        style="margin-top: 6px;right: 27%;"></div>\n                                </div>\n                                Budgeting Report <div class="panel-loader" ng-show="vm.adminReportLoading">\n                                    <div class="css-loading-qbr css-loading--double"></div>\n                                </div><i class="fa fa-download" aria-hidden="true" data-toggle="tooltip"\n                                    title="Download Budget"></i>\n                                <p ng-show="vm.adminReportLoading">Your budget report is processing and will begin\n                                    downloading\n                                    shortly.</p>\n                            </div> --></div></div></div><div class="tab-content clearfix"><div class="tab-pane active report-shadow panel-shadow" id=1b ng-show="vm.tabView === \'report\'"><div class="panel panel-default left-report-panel tick-rep" style="border-top-left-radius: 0px !important"><div id=rep-panel-1 class="panel-heading brd-bottom dev-report-category" style="text-align:center; padding-bottom: 0px; background-color:transparent !important;cursor:auto" ng-class="{\'toggle-filter-min\': !vm.toggleConfig.dateRangeShow, \'fourth-opacity\': vm.selectedReport.noDate}"><span ng-click="vm.minimizeSection(\'dateRangeShow\')" class=show-dev-cat>></span><p style="text-align:center; font-weight:300; font-size:13px; letter-spacing:1px">DATE RANGE</p><input date-range-picker class="form-control date-picker" type=text placeholder={{vm.datePlaceholder}} ng-model=vm.datePicker ng-disabled=vm.selectedReport.noDate style="height:24px; margin-top: 10px; width:49%; display:inline-block; margin-bottom: 20px"> <button class="button-month btn-clicked thisMonth" id=thisMonth style=margin-bottom:10px type=button ng-disabled=vm.selectedReport.noDate ng-click="vm.toggleTime(\'This Month\')">This Month</button> <button class="button-month lastMonth" id=lastMonth type=button ng-disabled=vm.selectedReport.noDate ng-click="vm.toggleTime(\'Last Month\')">Last Month</button> <button class="button-month to-date" id=to-date type=button style="margin-bottom: 10px" ng-disabled=vm.selectedReport.noDate ng-click="vm.toggleTime(\'To Date\')">To Date</button></div><div id=rep-panel-2 class="panel-body brd-bottom dev-report-category" style="text-align: center;padding: 10px 10px 10px 15px;cursor:auto" ng-class="{\'toggle-filter-min\': !vm.toggleConfig.reportOptions}"><span id=show-dev-cat-options ng-click="vm.minimizeSection(\'reportOptions\')" class=show-dev-cat style="font-weight: 300">></span><div class=custom-header style="text-align: center;margin-top:0px">REPORT OPTIONS</div><div id=standard-report-contain style=margin-left:0px><div class=form-group style="margin-bottom: 0px"><label style=padding:20px><input type=radio name=source_type[] value=All ng-model=vm.sourceType><span>All Funding Sources</span></label><label style=padding:20px><input type=radio name=source_type[] value=PO ng-model=vm.sourceType><span>Paid</span></label><label style=padding:20px><input type=radio name=source_type[] value=Credit ng-model=vm.sourceType><span>Credit</span></label></div></div></div><div id=rep-panel-4 class="panel-body list-container dev-report-category" id=report-list style="border-bottom: none;text-align: center;cursor:auto" ng-class="{\'toggle-filter-min\': !vm.toggleConfig.reportStandard}"><span id=show-dev-cat-standard ng-click="vm.minimizeSection(\'reportStandard\')" style="margin-left: -5px;margin-top: -8px" class=show-dev-cat>></span><div class=custom-header style="text-align: center;margin-top:-5px;margin-bottom: 20px">STANDARD REPORTS</div><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 no-padding"></div><div class="col-lg-8 col-md-12 col-sm-12 col-xs-12 no-padding"><div id=standard-report-contain style="margin-left:0px;padding-bottom: 20px"><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 no-padding" style="text-align: left"><label>Report</label></div><div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 no-padding"><select class=form-control style="margin-bottom: 10px" ng-model=vm.selectedReport ng-change=vm.changeReport(vm.selectedReport.id) ng-options="option.name for option in vm.standardReports" ng-diabled=vm.chartLoading></select></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-12" style="padding: 6px;padding-left: 10px"><span ng-show="vm.selectedReport.id === \'permissionReport\' && vm.projectsLoading"><div class=panel-loader><div class="css-loading-relative css-loading--double" style="width: 10px;height: 10px;margin-left: -1%;margin-top: 4px"></div></div></span></div><div ng-if="vm.selectedReport.id === \'consumptionRateByProject\'"><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 no-padding" style="text-align: left"><label>Rate Period</label></div><div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 no-padding"><select class=form-control ng-model=vm.selectedRate ng-change=vm.changeRate(vm.selectedRate) style="margin-bottom: 10px" ng-options="option.id as option.name for option in vm.rates"></select></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-12 no-padding"></div></div><div ng-if="vm.selectedReport.id === \'invoiceCostByAccount\' || vm.selectedReport.id === \'invoiceExport\'"><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 no-padding" style="text-align: left"><label>Month</label></div><div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 no-padding"><select class=form-control ng-model=vm.selectedMonth ng-change=vm.changeReport(vm.selectedReport.id) style="margin-bottom: 10px" ng-options="option for option in vm.months"></select></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-12 no-padding"></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 no-padding" style="text-align: left"><label>Year</label></div><div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 no-padding"><select class=form-control ng-model=vm.selectedYear ng-change=vm.changeReport(vm.selectedReport.id) style="margin-bottom: 10px" ng-options="option for option in vm.years"></select></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-12 no-padding"></div></div><div ng-if="vm.selectedReport.id !== \'permissionReport\' && vm.selectedReport.id !== \'userReport\'  && vm.selectedReport.id !== \'alertReport\'"><div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 no-padding" style="text-align: left"><label>Scope</label></div><div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 no-padding"><select class=select-grey-first style="margin-bottom: 10px;color:white;padding:9px" ng-model=vm.selectedReportLevel ng-options="option.id as option.name for option in vm.reportLevels | filter: vm.hideReportPOScope" ng-disabled=vm.disabled required></select></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-12 no-padding"></div></div><div ng-if="vm.selectedReportLevel !== \'company\'"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-padding" style="text-align: left"><label>{{vm.capitalizeFirstLetter(vm.selectedReportLevel)}}</label></div><div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 no-padding"><select class=select-grey-first style="margin-bottom: 10px;color:white;padding:9px" ng-model=vm.selectedReportName ng-options="option for option in vm.flatCompany[vm.selectedReportLevel]" ng-disabled=vm.disabled required></select></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-12 no-padding"></div></div></div><div ng-if="vm.selectedReport.id === \'alertReport\'"><div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 no-padding" style="text-align: left"><label>Company</label></div><div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 no-padding"><select class=select-grey-first style="margin-bottom: 10px;color:white;padding:9px" ng-model=vm.selectedAlertLevel ng-options="option for option in vm.companySelect" ng-disabled=vm.disabled required></select></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-12 no-padding"></div></div></div><!-- <span ng-show="vm.selectedReport.id === \'permissionReport\' && vm.projectsLoading">\n                                            <div class="panel-loader">\n                                                <div class="css-loading-relative css-loading--double"\n                                                    style="width: 10px;height: 10px;margin-left: -1%;margin-top: 4px;">\n                                                </div>\n                                            </div>\n                                        </span> --> <button class="report-category report-select" id=standard-run type=button style="margin-top: 20px !important" ng-disabled="vm.selectedReport.id === \'permissionReport\' && vm.projectsLoading" ng-click=vm.runReport(vm.selectedReport.id)>RUN</button></div></div><div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 no-padding"></div></div></div></div><div class="tab-pane active report-shadow" id=2b ng-show="vm.tabView === \'invoice\'"><div class="panel panel-default left-report-panel" style="border-top-left-radius: 0px !important;padding-bottom: 16px;min-height: 250px"><div class="dashboard-title cloudbill-title"><span class=bold-first-letter>I</span>NVOICES</div><div class="panel-loader loading dashboard-loader" ng-show=!vm.invoiceReady style="margin-top: 50px"><loading style=width:100%></loading></div><div class="invoice-contain webkit-scroll" ng-show=vm.invoiceReady style="max-height: 619px;padding: 20px;padding-top: 15px;padding-bottom: 100px"><div ng-if=vm.isAdmin style="padding: 20px;padding-bottom: 10px;padding-top: 0px"><div><label>Invoice Type</label><select class=select-grey-first style="margin-bottom: 5px;color:white;padding:9px" ng-model=vm.selectedInvoiceLevel ng-options="option.id as option.name for option in vm.invoiceLevels" ng-disabled=vm.disabled required></select></div><div ng-if="vm.selectedInvoiceLevel !== \'company\'"><label>{{vm.selectedInvoiceLevel !== \'po\' ? vm.capitalizeFirstLetter(vm.selectedInvoiceLevel) : vm.company.purchaseOrderTerm || \'Purchase Order\'}}</label><select class=select-grey-first style="margin-bottom: 5px;color:white;padding:9px" ng-model=vm.selectedInvoiceName ng-options="option for option in vm.flatCompany[vm.selectedInvoiceLevel]" ng-disabled=vm.disabled required></select></div></div><div style="padding: 20px;padding-bottom: 10px;padding-top: 0px"><label>Invoice Year</label><select class=select-grey-first style="margin-bottom: 5px;color:white;padding:9px" ng-model=vm.selectedInvoiceYear ng-options="option for option in vm.invoiceYears" ng-disabled=vm.disabled required></select></div><div ng-repeat="invoice in vm.invoices track by $index" ng-if=invoice.name.includes(vm.selectedInvoiceYear)><div class=single-invoice-contain><div dropdown-menu=vm.invoiceSelectOptions dropdown-model=invoice.type class=button-persist dropdown-item-label=text dropdown-onchange=vm.downloadGCSInvoice(invoice)>{{invoice.name}}</div></div></div></div><div></div><div ng-if="vm.invoices.length === 0">NO INVOICES</div></div></div></div></div><div class=col-xs-12><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.class}} style="background-color: rgb(117 59 62);border: 1px solid #7d7d7d" close="vm.close_notice(alert, $index)">{{alert.msg}}</div></div><div class="panel panel-default left-report-panel tick-rep report-widget-panel panel-shadow" style="min-height: 140px" ng-show="vm.tabView === \'report\'" ng-if=vm.sourceReport.widgets><div class="panel-loader loading dashboard-loader" ng-show=vm.chartLoading style="margin-top: -4px"><loading></loading></div><div ng-show=!vm.chartLoading><p class=report-widget style="background-color: #526f68;padding:13px;font-weight: 300;padding-top: 20px;margin-bottom: 4px">{{vm.widget1.title}}<br>{{vm.widget1.value}}</p></div></div></div></div><div class="col-lg-9 col-md-12 col-sm-12 col-xs-12 chart-contain" id=cloudbill-report><div class="report-height panel panel-default report-container report-shadow panel-shadow" style=width:100%;height:738px><div class="panel-heading brd-bottom" style="background-color:rgba(0,0,0,.2) !important; text-align: center;height: 35px"><select id=chart-monthTrend-select class=bill-chart-select ng-model=vm.chartType style="margin:0;float:right;padding:0;margin-top: -2px;width:80px" ng-options="option.id as option.name for option in vm.chartTypes" ng-change=vm.selectChartChange()></select><select id=chart-cummulative-select class=bill-chart-select ng-model=vm.cummulative style="margin:0;float:right;padding:0;margin-top: -2px;margin-right: 5px;width:80px" ng-if="vm.selectedReport.id === \'entityConsumptionOverTime\' || vm.selectedReport.id === \'consumptionOverTimeAll\' || vm.selectedReport.id === \'serviceConsumptionOverTime\'" ng-options="option for option in vm.cummulativeSelect" ng-change=vm.changeCummulativeChart()></select></div><div class="panel-loader loading dashboard-loader" ng-show=vm.chartLoading style="margin-top: 260px;left: 1%"><loading style=width:100%></loading></div><div class=panel-body><div ng-if=!vm.chartLoading><highchart id=highchart config=vm.chartConfig class=highcharts></highchart></div></div></div></div><div class=clearfix></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-content no-padding panel-shadow" style=margin-bottom:40px id=cloudbill-report-table><div class="well panel panel-default report-shadow" id=activity-table style=min-height:500px><div class="panel-loader loading dashboard-loader" ng-show=vm.chartLoading><loading style="width: 100%"></loading></div><div class="panel-heading brd-bottom"><h3 class=panel-title>{{vm.chartTitle}}</h3><button class=report-category type=button ng-click=vm.clearFilter() ng-show=vm.filter style=margin-left:5px>Clear Filter</button> <span ng-if="!vm.chartLoading && vm.stridesAccountExists" style="margin-left: 25px">Strides list prices and discounts are unavailable at this time. Only contract prices shown</span></div><div class=no-results ng-if="!vm.loading && !vm.chartLoading && (!vm.tableData || vm.tableData.length === 0)"><h3 class=no-data-title>NO REPORT DATA</h3></div><div class=panel-body><div class=table-responsive ng-if="(vm.selectedReportRun === \'consumptionByProject\') && !vm.chartLoading && vm.tableData.length > 0"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.dtInstance dt-options=vm.dtOptions id=cloud-total-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th class=nosort>Details</th><th>Project</th><th ng-if=!vm.slimTable>Service</th><th ng-if=!vm.slimTable>Entity</th><th style=text-align:right>List Price</th><th style=text-align:right ng-if=vm.isAdmin>Strides Discount</th><th style=text-align:right ng-if=vm.isAdmin>I2 Discount</th><th style=text-align:right>Contract Price</th><th style=text-align:right>Discount</th><th style=text-align:right>Consumption</th><th style=text-align:right>GCP Invoice Cost</th><th style=text-align:right ng-if="vm.isAdmin && vm.providedDiscount">Burwood Discount</th><th style=text-align:right ng-if=vm.isAdmin>{{vm.company.adjustmentTerm || \'Service Fee\'}}</th><th style=text-align:right ng-if=!vm.isAdmin>Pricebook Adjustments</th><th style=text-align:right>Subtotal</th><th style=text-align:right ng-if="(vm.singleBudgetExists && vm.toDate)">Budget</th><th style=text-align:right ng-if="(vm.singleBudgetExists && vm.toDate)">Remaining Budget</th><th style=text-align:right ng-if="(vm.singleBudgetExists && vm.toDate)">Percentage Consumed</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th ng-if=!vm.slimTable bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th ng-if=!vm.slimTable bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text ng-if="vm.isAdmin && vm.providedDiscount"></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text ng-if=!vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text ng-if="(vm.singleBudgetExists && vm.toDate)"></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text ng-if="(vm.singleBudgetExists && vm.toDate)"></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text ng-if="(vm.singleBudgetExists && vm.toDate)"></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tableData" ng-show=item.show ng-class="{\'parent-bg\': item.parent, \'child-bg\': item.child, \'grandchild-bg\': item.grandchild}"><td></td><td><div ng-if="item.breakdown.length > 0 && !vm.slimTable" ng-class="{\'fa fa-plus fa-fw\': item.breakdown.length > 0,\'fa fa-minus fa-fw\': item.click, \'indent-left\': item.child}" ng-init="click = false" ng-click="vm.expandParent(item.breakdown);item.click = !item.click"></div><div ng-if="!item.breakdown || item.breakdown.length === 0" class="fas fa-circle indent-left-more"></div></td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]">{{item.project_id}} {{vm.projectNames[item.project_id] ? "(" + vm.projectNames[item.project_id] + ")" : ""}}</td><td ng-if=!vm.slimTable ng-class="{true: \'opacity-none\', false: \'\'}[item.grandchild]">{{item.service_desc}}</td><td ng-if=!vm.slimTable ng-class="{true: \'opacity-none\', false: \'\'}[item.child]">{{item.entity}}</td><td class=dt-body-right data-sort={{item.parent_cost_total}}>${{item.cost_total.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_stride_discount}} ng-if=vm.isAdmin>${{item.stride_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_i2_discount}} ng-if=vm.isAdmin>${{item.i2_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_contract_cost}}>${{item.contract_cost.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_discount_total}}>${{item.discount_total.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_consumption}}>${{item.consumption.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_gcp_invoice_cost}}>${{item.gcp_invoice_cost.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_general_discount}} ng-if="vm.isAdmin && vm.providedDiscount">${{item.general_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_markup}} ng-if=vm.isAdmin>${{item.markup.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_adjustments}} ng-if=!vm.isAdmin>${{item.adjustments.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_subtotal}}>${{item.subtotal.toFixed(2)}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]" class=dt-body-right ng-if="(vm.singleBudgetExists && vm.toDate)">{{item.budget}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]" class=dt-body-right ng-if="(vm.singleBudgetExists && vm.toDate)">{{item.remaining}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]" class=dt-body-right ng-if="(vm.singleBudgetExists && vm.toDate)">{{item.percentage}}</td></tr></tbody></table></div><div class=table-responsive ng-if="(vm.selectedReportRun === \'consumptionOverTimeAll\' || vm.selectedReportRun === \'serviceConsumptionOverTime\' || vm.selectedReportRun === \'entityConsumptionOverTime\') && !vm.chartLoading && vm.tableData.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=cloud-day-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th class=nosort>Details</th><th ng-if="vm.selectedReportRun === \'consumptionOverTimeAll\'">Project</th><th ng-if="vm.selectedReportRun === \'serviceConsumptionOverTime\'">Service</th><th ng-if="vm.selectedReportRun === \'entityConsumptionOverTime\'">Entity</th><th>Date</th><th style=text-align:right>List Price</th><th style=text-align:right ng-if=vm.isAdmin>Strides Discount</th><th style=text-align:right ng-if=vm.isAdmin>I2 Discount</th><th style=text-align:right>Contract Price</th><th style=text-align:right>Discount</th><th style=text-align:right>Consumption</th><th style=text-align:right>GCP Invoice Cost</th><th style=text-align:right ng-if="vm.isAdmin && vm.providedDiscount">Burwood Discount</th><th style=text-align:right ng-if=vm.isAdmin>{{vm.company.adjustmentTerm || \'Service Fee\'}}</th><th style=text-align:right ng-if=!vm.isAdmin>Pricebook Adjustments</th><th style=text-align:right>Subtotal</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if="vm.isAdmin && vm.providedDiscount"></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=!vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tableData" ng-show=item.show ng-class="{\'parent-bg\': item.parent, \'child-bg\': item.child, \'grandchild-bg\': item.grandchild}"><td></td><td><div ng-if="item.breakdown.length > 0 && !vm.slimTable" ng-class="{\'fa fa-plus fa-fw\': item.breakdown.length > 0,\'fa fa-minus fa-fw\': item.click, \'indent-left\': item.child}" ng-init="click = false" ng-click="vm.expandParent(item.breakdown);item.click = !item.click"></div><div ng-if="!item.breakdown || item.breakdown.length === 0" class="fas fa-circle indent-left-more"></div></td><td ng-if="vm.selectedReportRun === \'consumptionOverTimeAll\'" ng-class="{true: \'opacity-none\', false: \'\'}[item.child]">{{item.project_id}} {{vm.projectNames[item.project_id] ? "(" + vm.projectNames[item.project_id] + ")" : ""}}</td><td ng-if="vm.selectedReportRun === \'serviceConsumptionOverTime\'" ng-class="{true: \'opacity-none\', false: \'\'}[item.child]">{{item.service_description}}</td><td ng-if="vm.selectedReportRun === \'entityConsumptionOverTime\'" ng-class="{true: \'opacity-none\', false: \'\'}[item.child]">{{item.sku_description}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.parent]">{{item.date}}</td><td class=dt-body-right data-sort={{item.parent_cost_total}}>${{item.cost_total.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_stride_discount}} ng-if=vm.isAdmin>${{item.stride_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_i2_discount}} ng-if=vm.isAdmin>${{item.i2_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_contract_cost}}>${{item.contract_cost.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_discount_total}}>${{item.discount_total.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_consumption}}>${{item.consumption.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_gcp_invoice_cost}}>${{item.gcp_invoice_cost.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_general_discount}} ng-if="vm.isAdmin && vm.providedDiscount">${{item.general_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_markup}} ng-if=vm.isAdmin>${{item.markup.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_adjustments}} ng-if=!vm.isAdmin>${{item.adjustments.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_subtotal}}>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div><div class=table-responsive ng-if="(vm.selectedReportRun === \'consumptionByLabel\') && !vm.chartLoading && vm.tableData.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=cloud-day-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th class=nosort>Details</th><th>Label</th><th>Service</th><th>Entity</th><th style=text-align:right>List Price</th><th style=text-align:right ng-if=vm.isAdmin>Strides Discount</th><th style=text-align:right ng-if=vm.isAdmin>I2 Discount</th><th style=text-align:right>Contract Price</th><th style=text-align:right>Discount</th><th style=text-align:right>Consumption</th><th style=text-align:right>GCP Invoice Cost</th><th style=text-align:right ng-if="vm.isAdmin && vm.providedDiscount">Burwood Discount</th><th style=text-align:right ng-if=vm.isAdmin>{{vm.company.adjustmentTerm || \'Service Fee\'}}</th><th style=text-align:right ng-if=!vm.isAdmin>Pricebook Adjustments</th><th style=text-align:right>Subtotal</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if="vm.isAdmin && vm.providedDiscount"></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=!vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tableData" ng-show=item.show ng-class="{\'parent-bg\': item.parent, \'child-bg\': item.child, \'grandchild-bg\': item.grandchild}"><td></td><td><div ng-if="item.breakdown.length > 0 && !vm.slimTable" ng-class="{\'fa fa-plus fa-fw\': item.breakdown.length > 0,\'fa fa-minus fa-fw\': item.click, \'indent-left\': item.child}" ng-init="click = false" ng-click="vm.expandParent(item.breakdown);item.click = !item.click"></div><div ng-if="!item.breakdown || item.breakdown.length === 0" class="fas fa-circle indent-left-more"></div></td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]">{{item.billing_label}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.grandchild]">{{item.service_desc}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child]">{{item.entity}}</td><td class=dt-body-right data-sort={{item.parent_cost_total}}>${{item.cost_total.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_stride_discount}} ng-if=vm.isAdmin>${{item.stride_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_i2_discount}} ng-if=vm.isAdmin>${{item.i2_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_contract_cost}}>${{item.contract_cost.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_discount_total}}>${{item.discount_total.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_consumption}}>${{item.consumption.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_gcp_invoice_cost}}>${{item.gcp_invoice_cost.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_general_discount}} ng-if="vm.isAdmin && vm.providedDiscount">${{item.general_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_markup}} ng-if=vm.isAdmin>${{item.markup.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_adjustments}} ng-if=!vm.isAdmin>${{item.adjustments.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_subtotal}}>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div><div class=table-responsive ng-if="(vm.selectedReportRun === \'consumptionByProduct\') && !vm.chartLoading && vm.tableData.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=cloud-day-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th class=nosort>Details</th><th>Service</th><th>Entity</th><th style=text-align:right>List Price</th><th style=text-align:right ng-if=vm.isAdmin>Strides Discount</th><th style=text-align:right ng-if=vm.isAdmin>I2 Discount</th><th style=text-align:right>Contract Price</th><th style=text-align:right>Discount</th><th style=text-align:right>Consumption</th><th style=text-align:right>GCP Invoice Cost</th><th style=text-align:right ng-if="vm.isAdmin && vm.providedDiscount">Burwood Discount</th><th style=text-align:right ng-if=vm.isAdmin>{{vm.company.adjustmentTerm || \'Service Fee\'}}</th><th style=text-align:right ng-if=!vm.isAdmin>Pricebook Adjustments</th><th style=text-align:right>Subtotal</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if="vm.isAdmin && vm.providedDiscount"></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=!vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tableData" ng-show=item.show ng-class="{\'parent-bg\': item.parent, \'child-bg\': item.child, \'grandchild-bg\': item.grandchild}"><td></td><td><div ng-if="item.breakdown.length > 0 && !vm.slimTable" ng-class="{\'fa fa-plus fa-fw\': item.breakdown.length > 0,\'fa fa-minus fa-fw\': item.click, \'indent-left\': item.child}" ng-init="click = false" ng-click="vm.expandParent(item.breakdown);item.click = !item.click"></div><div ng-if="!item.breakdown || item.breakdown.length === 0" class="fas fa-circle indent-left-more"></div></td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]">{{item.service_desc}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.grandchild]">{{item.entity}}</td><td class=dt-body-right data-sort={{item.parent_cost_total}}>${{item.cost_total.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_stride_discount}} ng-if=vm.isAdmin>${{item.stride_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_i2_discount}} ng-if=vm.isAdmin>${{item.i2_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_contract_cost}}>${{item.contract_cost.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_discount_total}}>${{item.discount_total.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_consumption}}>${{item.consumption.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_gcp_invoice_cost}}>${{item.gcp_invoice_cost.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_general_discount}} ng-if="vm.isAdmin && vm.providedDiscount">${{item.general_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_markup}} ng-if=vm.isAdmin>${{item.markup.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_adjustments}} ng-if=!vm.isAdmin>${{item.adjustments.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_subtotal}}>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div><div class=table-responsive ng-if="(vm.selectedReportRun === \'consumptionByEntity\') && !vm.chartLoading && vm.tableData.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=cloud-day-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th class=nosort>Details</th><th>Entity</th><th>Service</th><th style=text-align:right>List Price</th><th style=text-align:right ng-if=vm.isAdmin>Strides Discount</th><th style=text-align:right ng-if=vm.isAdmin>I2 Discount</th><th style=text-align:right>Contract Price</th><th style=text-align:right>Discount</th><th style=text-align:right>Consumption</th><th style=text-align:right>GCP Invoice Cost</th><th style=text-align:right ng-if="vm.isAdmin && vm.providedDiscount">Burwood Discount</th><th style=text-align:right ng-if=vm.isAdmin>{{vm.company.adjustmentTerm || \'Service Fee\'}}</th><th style=text-align:right ng-if=!vm.isAdmin>Pricebook Adjustments</th><th style=text-align:right>Subtotal</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if="vm.isAdmin && vm.providedDiscount"></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=!vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tableData" ng-show=item.show ng-class="{\'parent-bg\': item.parent, \'child-bg\': item.child, \'grandchild-bg\': item.grandchild}"><td></td><td><div ng-if="item.breakdown.length > 0 && !vm.slimTable" ng-class="{\'fa fa-plus fa-fw\': item.breakdown.length > 0,\'fa fa-minus fa-fw\': item.click, \'indent-left\': item.child}" ng-init="click = false" ng-click="vm.expandParent(item.breakdown);item.click = !item.click"></div><div ng-if="!item.breakdown || item.breakdown.length === 0" class="fas fa-circle indent-left-more"></div></td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]">{{item.entity}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.grandchild]">{{item.service_desc}}</td><td class=dt-body-right data-sort={{item.parent_cost_total}}>${{item.cost_total.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_stride_discount}} ng-if=vm.isAdmin>${{item.stride_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_i2_discount}} ng-if=vm.isAdmin>${{item.i2_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_contract_cost}}>${{item.contract_cost.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_discount_total}}>${{item.discount_total.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_consumption}}>${{item.consumption.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_gcp_invoice_cost}}>${{item.gcp_invoice_cost.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_general_discount}} ng-if="vm.isAdmin && vm.providedDiscount">${{item.general_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_markup}} ng-if=vm.isAdmin>${{item.markup.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_adjustments}} ng-if=!vm.isAdmin>${{item.adjustments.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_subtotal}}>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div><div class=table-responsive ng-if="(vm.selectedReportRun === \'consumptionByDepartment\') && !vm.chartLoading && vm.tableData.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=cloud-day-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th class=nosort>Details</th><th>Department</th><th>Type</th><th>Project</th><th style=text-align:right>Consumption</th><th style=text-align:right>Budget</th><th style=text-align:right>Remaining</th><th style=text-align:right>Percentage</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tableData" ng-show=item.show ng-class="{\'parent-bg\': item.parent, \'child-bg\': item.child, \'grandchild-bg\': item.grandchild}"><td></td><td><div ng-if="item.breakdown.length > 0 && !vm.slimTable" ng-class="{\'fa fa-plus fa-fw\': item.breakdown.length > 0,\'fa fa-minus fa-fw\': item.click, \'indent-left\': item.child}" ng-init="click = false" ng-click="vm.expandParent(item.breakdown);item.click = !item.click"></div><div ng-if="!item.breakdown || item.breakdown.length === 0" class="fas fa-circle indent-left-more"></div></td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]">{{item.departmentName}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]">{{item.type}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.grandchild]">{{item.project_id}} {{vm.projectNames[item.project_id] ? "(" + vm.projectNames[item.project_id] + ")" : ""}}</td><td class=dt-body-right data-sort={{item.parent_subtotal}}>${{item.subtotal}}</td><td class=dt-body-right data-sort={{item.parent_budget}}><span ng-if="item.type !== \'Budgeting\'">$</span>{{item.budget}}</td><td class=dt-body-right data-sort={{item.parent_remaining}}><span ng-if="item.type !== \'Budgeting\'">$</span>{{item.remaining}}</td><td class=dt-body-right data-sort={{item.parent_percentage}}>{{item.percentage}}<span ng-if="item.type !== \'Budgeting\'">%</span></td></tr></tbody></table></div><div class=table-responsive ng-if="(vm.selectedReportRun === \'currentBudgetStatus\') && !vm.chartLoading && vm.tableData.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=cloud-day-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Project</th><th style=text-align:right>Current Budget Type</th><th style=text-align:right>Current Budget Amount</th><th style=text-align:right>Current Budget Consumption</th><th style=text-align:right>Current Budget Percentage</th><th style=text-align:right>Current Budget Remaining</th><th style=text-align:right>Total Budget</th><th style=text-align:right>Total Consumption</th><th style=text-align:right>Total Consumption Percentage</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tableData" class=parent-bg><td></td><td>{{item.projectID}} {{vm.projectNames[item.projectID] ? "(" + vm.projectNames[item.projectID] + ")" : ""}}</td><td style=text-align:right>{{item.currentAllowance === \'Credit\' ? item.currentAllowance : vm.company.purchaseOrderTerm}}</td><td style=text-align:right>${{item.currentAllowanceAmount}}</td><td style=text-align:right>${{item.currentAllowanceConsumption}}</td><td style=text-align:right>{{item.currentPercentage}}</td><td style=text-align:right>${{item.currentAllowanceRemaining}}</td><td style=text-align:right>${{item.totalBudget}}</td><td style=text-align:right>${{item.consumption}}</td><td style=text-align:right>{{item.percentage}}</td></tr></tbody></table></div><div class=table-responsive ng-if="(vm.selectedReportRun === \'consumptionRateByProject\') && !vm.chartLoading && vm.tableData.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=cloud-day-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Project</th><th style=text-align:right>Available Budget Amount</th><th style=text-align:right>Current Consumption</th><th style=text-align:right>Available Budget Percentage</th><th style=text-align:right>Available Budget Remaining</th><th style=text-align:right>Daily Average Spend</th><th style=text-align:right>Days Remaining At Rate</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tableData" class=parent-bg><td></td><td>{{item.projectID}} {{vm.projectNames[item.projectID] ? "(" + vm.projectNames[item.projectID] + ")" : ""}}</td><td style=text-align:right>{{item.totalBudget}}</td><td style=text-align:right>${{item.consumption}}</td><td style=text-align:right>{{item.percentage}}</td><td style=text-align:right>{{item.budgetRemaining}}</td><td style=text-align:right>{{item.rate}}</td><td style=text-align:right>{{item.daysRemaining}}</td></tr></tbody></table></div><div class=table-responsive ng-if="(vm.selectedReportRun === \'invoiceCostByAccount\' || vm.selectedReportRun === \'consumptionByAccount\') && !vm.chartLoading && vm.tableData.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=cloud-day-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th class=nosort>Details</th><th>Billing Account</th><th>Project</th><th>{{vm.company.purchaseOrderTerm || \'Purchase Order\'}} / Grant</th><th style=text-align:right>List Price</th><th style=text-align:right ng-if=vm.isAdmin>Strides Discount</th><th style=text-align:right ng-if=vm.isAdmin>I2 Discount</th><th style=text-align:right>Contract Price</th><th style=text-align:right>Discount</th><th style=text-align:right>Consumption</th><th style=text-align:right>GCP Invoice Cost</th><th style=text-align:right ng-if="vm.isAdmin && vm.providedDiscount">Burwood Discount</th><th style=text-align:right ng-if=vm.isAdmin>{{vm.company.adjustmentTerm || \'Service Fee\'}}</th><th style=text-align:right ng-if=!vm.isAdmin>Pricebook Adjustments</th><th ng-if="vm.selectedReportRun === \'consumptionByAccount\'" style=text-align:right>Subtotal</th><th ng-if="vm.selectedReportRun === \'invoiceCostByAccount\'" style=text-align:right>Invoice From Burwood</th><th ng-if="vm.selectedReportRun === \'invoiceCostByAccount\'" style=text-align:right>Invoice To User</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if="vm.isAdmin && vm.providedDiscount"></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=!vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th ng-if="vm.selectedReportRun === \'invoiceCostByAccount\'" bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tableData" ng-show=item.show ng-class="{\'parent-bg\': item.parent, \'child-bg\': item.child, \'grandchild-bg\': item.grandchild}"><td></td><td><div ng-if="item.breakdown.length > 0 && !vm.slimTable" ng-class="{\'fa fa-plus fa-fw\': item.breakdown.length > 0,\'fa fa-minus fa-fw\': item.click, \'indent-left\': item.child}" ng-init="click = false" ng-click="vm.expandParent(item.breakdown);item.click = !item.click"></div><div ng-if="!item.breakdown || item.breakdown.length === 0" class="fas fa-circle indent-left-more"></div></td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]">{{item.billing_account_id}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.grandchild]">{{item.project_id}} {{vm.projectNames[item.project_id] ? "(" + vm.projectNames[item.project_id] + ")" : ""}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child]">{{item.po}}</td><td class=dt-body-right data-sort={{item.parent_cost_total}}>${{item.cost_total.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_stride_discount}} ng-if=vm.isAdmin>${{item.stride_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_i2_discount}} ng-if=vm.isAdmin>${{item.i2_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_contract_cost}}>${{item.contract_cost.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_discount_total}}>${{item.discount_total.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_consumption}}>${{item.consumption.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_gcp_invoice_cost}}>${{item.gcp_invoice_cost.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_general_discount}} ng-if="vm.isAdmin && vm.providedDiscount">${{item.general_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_markup}} ng-if=vm.isAdmin>${{item.markup.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_adjustments}} ng-if=!vm.isAdmin>${{item.adjustments.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_subtotal}}>${{item.subtotal.toFixed(2)}}</td><td ng-if="vm.selectedReportRun === \'invoiceCostByAccount\'" class=dt-body-right data-sort={{item.parent_subtotal}}>${{item.user_subtotal.toFixed(2)}}</td></tr></tbody></table></div><div class=table-responsive ng-if="(vm.selectedReportRun === \'invoiceExport\') && !vm.chartLoading && vm.tableData.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=cloud-exprot-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Project</th><th>{{vm.company.purchaseOrderTerm || "Purchase Order"}}</th><th>Service</th><th>Entity</th><th style=text-align:right>List Price</th><th style=text-align:right ng-if=vm.isAdmin>Strides Discount</th><th style=text-align:right ng-if=vm.isAdmin>I2 Discount</th><th style=text-align:right>Contract Price</th><th style=text-align:right>Discount</th><th style=text-align:right>Consumption</th><th style=text-align:right>GCP Invoice Cost</th><th style=text-align:right ng-if="vm.isAdmin && vm.providedDiscount">Burwood Discount</th><th style=text-align:right ng-if=vm.isAdmin>{{vm.company.adjustmentTerm || \'Service Fee\'}}</th><th style=text-align:right ng-if=!vm.isAdmin>Pricebook Adjustments</th><th style=text-align:right>Invoice From Burwood</th><th style=text-align:right>Invoice To User</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if="vm.isAdmin && vm.providedDiscount"></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text ng-if=!vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tableData"><td></td><td>{{item.project_id}} {{vm.projectNames[item.project_id] ? "(" + vm.projectNames[item.project_id] + ")" : ""}}</td><td>{{item.po}}</td><td>{{item.service_desc}}</td><td>{{item.entity}}</td><td class=dt-body-right>${{item.cost_total.toFixed(2)}}</td><td class=dt-body-right ng-if=vm.isAdmin>${{item.stride_discount.toFixed(2)}}</td><td class=dt-body-right ng-if=vm.isAdmin>${{item.i2_discount.toFixed(2)}}</td><td class=dt-body-right>${{item.contract_cost.toFixed(2)}}</td><td class=dt-body-right>${{item.discount_total.toFixed(2)}}</td><td class=dt-body-right>${{item.consumption.toFixed(2)}}</td><td class=dt-body-right>${{item.gcp_invoice_cost.toFixed(2)}}</td><td class=dt-body-right ng-if="vm.isAdmin && vm.providedDiscount">${{item.general_discount.toFixed(2)}}</td><td class=dt-body-right ng-if=vm.isAdmin>${{item.markup.toFixed(2)}}</td><td class=dt-body-right ng-if=!vm.isAdmin>${{item.adjustments.toFixed(2)}}</td><td class=dt-body-right>${{item.subtotal.toFixed(2)}}</td><td class=dt-body-right>${{item.user_subtotal.toFixed(2)}}</td></tr></tbody></table></div><div class=table-responsive ng-if="vm.selectedReportRun === \'yearConsumptionByMonthAll\' && !vm.chartLoading && vm.tableData.length > 0"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.dtInstance dt-options=vm.dtOptions id=cloud-month-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th class=nosort>Details</th><th>Month</th><th ng-if=!vm.slimTable>Project</th><th ng-if=!vm.slimTable>Service</th><th style=text-align:right>List Price</th><th style=text-align:right ng-if=vm.isAdmin>Strides Discount</th><th style=text-align:right ng-if=vm.isAdmin>I2 Discount</th><th style=text-align:right>Contract Price</th><th style=text-align:right>Discount</th><th style=text-align:right>Consumption</th><th style=text-align:right>GCP Invoice Cost</th><th style=text-align:right ng-if="vm.isAdmin && vm.providedDiscount">Burwood Discount</th><th style=text-align:right ng-if=vm.isAdmin>{{vm.company.adjustmentTerm || \'Service Fee\'}}</th><th style=text-align:right ng-if=!vm.isAdmin>Pricebook Adjustments</th><th style=text-align:right>Subtotal</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th ng-if=!vm.slimTable bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th ng-if=!vm.slimTable bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text ng-if="vm.isAdmin && vm.providedDiscount"></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text ng-if=vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text ng-if=!vm.isAdmin></th><th bw-column-filter dt-instance=vm.dtInstanceUtil filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tableData" ng-show=item.show ng-class="{\'parent-bg\': item.parent, \'child-bg\': item.child, \'grandchild-bg\': item.grandchild}"><td></td><td><div ng-if="item.breakdown.length > 0 && !vm.slimTable" ng-class="{\'fa fa-plus fa-fw\': item.breakdown.length > 0,\'fa fa-minus fa-fw\': item.click, \'indent-left\': item.child}" ng-init="click = false" ng-click="vm.expandParent(item.breakdown);item.click = !item.click"></div><div ng-if="!item.breakdown || item.breakdown.length === 0" class="fas fa-circle indent-left-more"></div></td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]">{{item.month}}</td><td ng-if=!vm.slimTable ng-class="{true: \'opacity-none\', false: \'\'}[item.grandchild]">{{item.project_id}} {{vm.projectNames[item.project_id] ? "(" + vm.projectNames[item.project_id] + ")" : ""}}</td><td ng-if=!vm.slimTable ng-class="{true: \'opacity-none\', false: \'\'}[item.child]">{{item.service_desc}}</td><td class=dt-body-right data-sort={{item.parent_cost_total}}>${{item.cost_total.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_stride_discount}} ng-if=vm.isAdmin>${{item.stride_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_i2_discount}} ng-if=vm.isAdmin>${{item.i2_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_contract_cost}}>${{item.contract_cost.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_discount_total}}>${{item.discount_total.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_consumption}}>${{item.consumption.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_gcp_invoice_cost}}>${{item.gcp_invoice_cost.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_general_discount}} ng-if="vm.isAdmin && vm.providedDiscount">${{item.general_discount.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_markup}} ng-if=vm.isAdmin>${{item.markup.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_adjustments}} ng-if=!vm.isAdmin>${{item.adjustments.toFixed(2)}}</td><td class=dt-body-right data-sort={{item.parent_subtotal}}>${{item.subtotal.toFixed(2)}}</td></tr></tbody></table></div><div class=table-responsive ng-if="(vm.selectedReportRun === \'userReport\') && !vm.chartLoading && vm.tableData.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=user-report-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th>Project ID</th><th>User</th><th>Weekly Summary</th><th>Alerts</th><th>Sessions</th><th>Invoice Downloads</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tableData"><td></td><td>{{item.project_id}} {{vm.projectNames[item.project_id] ? "(" + vm.projectNames[item.project_id] + ")" : ""}}</td><td>{{item.email}}</td><td>{{item.weeklySummary}}</td><td>{{item.alerts}}</td><td>{{item.sessions}}</td><td>{{item.invoices}}</td></tr></tbody></table></div><div class=table-responsive ng-if="(vm.selectedReportRun === \'permissionReport\') && !vm.chartLoading && vm.tableData.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=permission-report-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th class=nosort>Details</th><th>Company</th><th>Project/Account</th><th>Missing Project Permission</th><th>Missing Account Permission</th><th>Disabled</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tableData" ng-show=item.show ng-class="{\'parent-bg\': item.parent, \'child-bg\': item.child, \'grandchild-bg\': item.grandchild}"><td></td><td><div ng-if="item.breakdown.length > 0 && !vm.slimTable" ng-class="{\'fa fa-plus fa-fw\': item.breakdown.length > 0,\'fa fa-minus fa-fw\': item.click, \'indent-left\': item.child}" ng-init="click = false" ng-click="vm.expandParent(item.breakdown);item.click = !item.click"></div><div ng-if="!item.breakdown || item.breakdown.length === 0" class="fas fa-circle indent-left-more"></div></td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]">{{item.companyName}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.grandchild]">{{item.projectID}} {{vm.projectNames[item.projectID] ? "(" + vm.projectNames[item.projectID] + ")" : ""}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.grandchild]">{{item.missingProjectPermissions}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]">{{item.missingAccountPermissions}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.grandchild]">{{item.disabled}}</td></tr></tbody></table></div><div class=table-responsive ng-if="(vm.selectedReportRun === \'alertReport\') && !vm.chartLoading && vm.tableData.length > 0"><table class="table table-striped" dt-instance=vm.dtInstance dt-options=vm.dtOptions dt-column-defs=vm.dtColumnDefs datatable=ng width=100% cellspacing=0 scrollx=true id=permission-report-table><thead><tr><th class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th class=nosort>Details</th><th>Company</th><th>Alerts</th><th>Message</th><th>User</th><th>Location</th><th>Tags</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.tableData" ng-show=item.show ng-class="{\'parent-bg\': item.parent, \'child-bg\': item.child, \'grandchild-bg\': item.grandchild}"><td></td><td><div ng-if="item.breakdown.length > 0 && !vm.slimTable" ng-class="{\'fa fa-plus fa-fw\': item.breakdown.length > 0,\'fa fa-minus fa-fw\': item.click, \'indent-left\': item.child}" ng-init="click = false" ng-click="vm.expandParent(item.breakdown);item.click = !item.click"></div><div ng-if="!item.breakdown || item.breakdown.length === 0" class="fas fa-circle indent-left-more"></div></td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]">{{item.company}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.child || item.grandchild]">{{item.alerts}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.grandchild]">{{item.message}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.grandchild]">{{item.user}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.grandchild]">{{item.location}}</td><td ng-class="{true: \'opacity-none\', false: \'\'}[item.grandchild]">{{item.tags}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/cloudbilling/funding/cloudbillingPO.html','<div class="container col-lg-12 col-md-12 col-sm-12 col-xs-12" id=cloudbill-accounts style=padding-left:50px;padding-right:50px;margin-top:30px><div class=row style="margin-bottom: 15px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" id=poPage><div class=container style=width:100% id=account-form-admin><form ng-submit=vm.update(vm.account) name=poForm><div class=menu-top style="text-align: left"><ul class="list-unstyled list-inline" style="padding: 15px;float:left"><li><strong>Company - {{vm.selectedCompany.companyName}}</strong></li></ul><ul class="list-unstyled list-inline header-alerts"><li><div ng-repeat="alert in vm.alerts" close="vm.close_notice(\'alerts\', $index)"><img ng-if="alert.status === \'success\'" ng-src=assets/img/icon/network_5.png width=20 height="" style="height:auto;margin-right: 10px"> <img ng-if="alert.status === \'fail\'" ng-src=assets/img/icon/network_1.png width=20 height="" style="height:auto;margin-right: 10px"> {{alert.msg}}</div></li></ul><ul class="list-unstyled list-inline pull-right list-menu"><li><button class="btn btn-primary menu_btn btn-md" type=submit ng-disabled="vm.disabled || vm.loading" style="border-radius: 0px 5px 0px 0px;height:51px">UPDATE</button></li></ul></div><div class="well incident-wrapper" style="padding-top: 30px;margin-top: 0px"><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=row><div><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class=webkit-scroll style="height:auto;margin-bottom: 20px;border-radius: 10px"><div class=basic-info-contain><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-panel"><div class=form-group><div class=col-xs-12 style=text-align:center><label for=account-number-field style="font-weight: bolder !important">Funding Sources</label><img src=assets/img/icon/plus.png width=15 height="" ng-click="vm.addItem(\'selectedCompany\', \'pos\')" style=margin-left:10px;cursor:pointer class=add-img></div><div class=col-xs-12 style="border-bottom: 1px solid #898989"></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" id=poContain><ul class=watch_list_static style=margin-top:0px><li ng-repeat="po in vm.selectedCompany.pos track by $index" ng-init="parentIndex = $index" ng-attr-id=" {{ \'acct-num-\' + $index }}" style=padding:0px><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 0px"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding"><div class="col-lg-3 col-md-3 col-sm-1 col-xs-1 no-padding" style="padding-top: 35px"><div ng-attr-id="{{ \'budget-remove-acct-\' + $index }}" class=minus-acct><img src=assets/img/icon/minus.png ng-if="!(vm.disabledGroup && vm.selectedCompany.pos[$index].type === \'burwoodPO\')" width=15 height="" ng-click="vm.removeItem(\'selectedCompany\', \'pos\', $index)" style=margin-left:10px;cursor:pointer class=add-img></div></div><div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 5px;padding-left:5px !important"><label for=account-number-field>Type</label><select class=select-grey-first style="margin-bottom: 5px" ng-style="{ \'color\' : !vm.selectedCompany.pos[$index].type ? \'grey\' : \'white\' }" ng-model=vm.selectedCompany.pos[$index].type ng-options="option.id as option.name disable when option.disabled for option in vm.poTypes" ng-disabled="vm.disabled || (vm.disabledGroup && vm.selectedCompany.pos[$index].type === \'burwoodPO\')" required><option value="" disabled selected hidden>Type</option></select></div></div><div class="col-lg-10 col-md-10 col-sm-10 col-xs-12 no-padding" ng-if="vm.selectedCompany.pos[$index].type && vm.selectedCompany.pos[$index].type !== \'strides\'"><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="margin-bottom: 0px;padding-left: 5px !important"><div class="col-lg-11 col-md-11 col-sm-11 col-xs-12 no-padding" style="width: 100%"><label for=account-number-field>Number/ID</label><input type=text name=poNumber class=form-control ng-disabled="vm.disabled || (vm.disabledGroup && vm.selectedCompany.pos[$index].type === \'burwoodPO\')" required placeholder={{vm.selectedCompany.purchaseOrderTerm}} ng-model=vm.selectedCompany.pos[$index].number></div></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="margin-bottom: 5px;padding-left:5px !important" ng-if="vm.selectedCompany.pos[$index].type !== \'burwoodPO\'"><label for=account-number-field>Amount</label><input type=number class=form-control ng-model=vm.selectedCompany.pos[$index].amount placeholder=Amount ng-disabled=vm.disabled></div><div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:0px"><label for=fund-desc>Description</label><input type=text name=fund-desc class=form-control ng-disabled="vm.disabled || (vm.disabledGroup && vm.selectedCompany.pos[$index].type === \'burwoodPO\')" placeholder=Description ng-model=vm.selectedCompany.pos[$index].description></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="padding-left:5px !important"><label>State</label><ul class=watch_list_static style=margin-top:0px><li style="padding:0px; display:inherit;margin:0" class=input-group><select class=select-grey-first style="color: white" ng-model=vm.selectedCompany.pos[$index].state ng-options="option for option in vm.poStates" ng-disabled=vm.disabled></select></li></ul></div><div class="col-lg-1 col-md-1 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 0px;padding-left: 5px !important"><div ng-if="vm.selectedCompany.pos[$index].type !== \'burwoodPO\'"><label for=primary-contact-field>Receive Invoice</label><input type=checkbox ng-attr-id="{{ \'alert-check-\' + $index }}" class=form-control ng-disabled=vm.disabled style=width:25px ng-model=vm.selectedCompany.pos[$index].invoicePO placeholder=""></div></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px"><div ng-if=vm.selectedCompany.pos[$index].invoicePO><label>Billing Contact Email <img src=assets/img/icon/plus.png width=" 15" height="" ng-click=vm.addBillingContact(parentIndex) style="float: right;cursor:pointer;margin-top: 7px;margin-left: 5px"></label><div ng-repeat="billingEmail in vm.selectedCompany.pos[parentIndex].billingContactEmail track by $index" ng-init="contactIndex = $index"><img src=assets/img/icon/minus.png width=" 15" height="" ng-click="vm.removeBillingContact(parentIndex, contactIndex)" style="float: right;cursor:pointer;margin-top: 8px"> <input type=text class=form-control placeholder="" ng-model=vm.selectedCompany.pos[parentIndex].billingContactEmail[contactIndex] style="width: 90%;margin-bottom: 5px" ng-disabled=vm.disabled></div></div></div></div><div class="col-lg-10 col-md-10 col-sm-10 col-xs-12 no-padding" ng-if="vm.selectedCompany.pos[$index].type && vm.selectedCompany.pos[$index].type === \'strides\'"><div class="col-lg-12 col-md-12 col-sm-10 col-xs-12 no-padding"><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="margin-bottom: 0px;padding-left: 5px !important"><div class="col-lg-11 col-md-11 col-sm-11 col-xs-12 no-padding" style="width: 100%"><label for=account-number-field>Number/ID</label><input type=text name=poNumber class=form-control ng-disabled=vm.disabled required placeholder={{vm.selectedCompany.purchaseOrderTerm}} ng-model=vm.selectedCompany.pos[$index].number></div></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="margin-bottom: 5px;padding-left:5px !important"><label for=account-number-field>Amount</label><input type=number class=form-control ng-model=vm.selectedCompany.pos[$index].amount placeholder=Amount ng-disabled=vm.disabled></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="margin-bottom: 0px;padding-left: 5px !important" ng-if="vm.selectedCompany.pos[$index].type === \'strides\'"><label for=account-number-field>Account Name</label><select class=select-grey-first style="margin-bottom: 5px;color:white;padding:9px" ng-model=vm.selectedCompany.pos[$index].account ng-options="option.account as option.name for option in vm.stridesAccounts" ng-disabled=vm.disabled required><option value="" disabled selected hidden>Account Name</option></select></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="padding-left:5px !important" ng-if="vm.selectedCompany.pos[$index].type === \'strides\'"><label for=account-number-field>Account Number</label><select class=select-grey-first style="margin-bottom: 5px;color:white;padding:9px" ng-model=vm.selectedCompany.pos[$index].account ng-options="option.account as option.account for option in vm.stridesAccounts" ng-disabled=vm.disabled required><option value="" disabled selected hidden>Account Number</option></select></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px" ng-if="vm.selectedCompany.pos[$index].type === \'strides\'"><label for=account-number-field>NIH Institute/Center/Office</label><input type=text name=office class=form-control ng-disabled=vm.disabled placeholder="NIH Institute/Center/Office" required ng-model=vm.selectedCompany.pos[$index].details.office></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px" ng-if="vm.selectedCompany.pos[$index].type === \'strides\'"><label for=account-number-field>Program/Project Name</label><input type=text name=programName class=form-control ng-disabled=vm.disabled placeholder="Program/Project Name" required ng-model=vm.selectedCompany.pos[$index].details.programName></div></div><div class="col-lg-12 col-md-12 col-sm-10 col-xs-12 no-padding"><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px" ng-if="vm.selectedCompany.pos[$index].type === \'strides\'"><label for=account-number-field>Program Officer Name</label><input type=text name=officerName class=form-control ng-disabled=vm.disabled placeholder="Program Officer Name" required ng-model=vm.selectedCompany.pos[$index].details.officerName></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px" ng-if="vm.selectedCompany.pos[$index].type === \'strides\'"><label for=account-number-field>Program Officer Email</label><input type=text name=officerEmail class=form-control ng-disabled=vm.disabled placeholder="Program Officer Email" required ng-model=vm.selectedCompany.pos[$index].details.officerEmail></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px" ng-if="vm.selectedCompany.pos[$index].type === \'strides\'"><label for=account-number-field>Primary Contact Name</label><input type=text name=contactName class=form-control ng-disabled=vm.disabled placeholder="Primary Contact Name" required ng-model=vm.selectedCompany.pos[$index].details.contactName></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px" ng-if="vm.selectedCompany.pos[$index].type === \'strides\'"><label for=account-number-field>Primary Contact Email</label><input type=text name=contactEmail class=form-control ng-disabled=vm.disabled placeholder="Primary Contact Email" required ng-model=vm.selectedCompany.pos[$index].details.contactEmail></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px" ng-if="vm.selectedCompany.pos[$index].type === \'strides\'"><label for=account-number-field>Billing Admin Name</label><input type=text name=billingName class=form-control ng-disabled=vm.disabled placeholder="Billing Admin Name" required ng-model=vm.selectedCompany.pos[$index].details.billingName></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px" ng-if="vm.selectedCompany.pos[$index].type === \'strides\'"><label for=account-number-field>Billing Admin Email</label><input type=text name=billingEmail class=form-control ng-disabled=vm.disabled placeholder="Billing Admin Email" required ng-model=vm.selectedCompany.pos[$index].details.billingEmail></div></div><div class="col-lg-12 col-md-12 col-sm-10 col-xs-12 no-padding"><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px"><label for=account-number-field>Expiration Date</label><ul class=watch_list_static style=margin-top:0px><li style="padding:0px; display:inherit;margin:0" class=input-group><input ng-model=vm.selectedCompany.pos[$index].expirationDate class=form-control style="float:none;border-radius: 3px" ng-model-options="{ updateOn: \'blur\' }" placeholder="" format=MM/DD/YYYY today=true start-view=month moment-picker=vm.selectedCompany.pos[$index].expirationDate></li></ul></div><div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:0px" ng-if="vm.selectedCompany.pos[$index].type === \'strides\'"><label for=fund-desc>Description</label><input type=text name=fund-desc class=form-control ng-disabled=vm.disabled placeholder=Description ng-model=vm.selectedCompany.pos[$index].details.description></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="padding-left:5px !important"><label>State</label><ul class=watch_list_static style=margin-top:0px><li style="padding:0px; display:inherit;margin:0" class=input-group><select class=select-grey-first style=color:white ng-model=vm.selectedCompany.pos[$index].state ng-options="option for option in vm.poStates" ng-disabled=vm.disabled></select></li></ul></div><div class="col-lg-1 col-md-1 col-sm-12 col-xs-12 no-padding" style="margin-bottom: 0px;padding-left: 5px !important"><label for=primary-contact-field>Receive Invoice</label><input type=checkbox ng-attr-id="{{ \'alert-check-\' + $index }}" class=form-control ng-disabled=vm.disabled style=width:25px ng-model=vm.selectedCompany.pos[$index].invoicePO placeholder=""></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 no-padding" style="padding-left:5px !important;margin-bottom:5px"><div ng-if=vm.selectedCompany.pos[$index].invoicePO><label>Billing Contact Email <img src=assets/img/icon/plus.png width=" 15" height="" ng-click=vm.addBillingContact(parentIndex) style="float: right;cursor:pointer;margin-top: 7px;margin-left: 5px"></label><div ng-repeat="billingEmail in vm.selectedCompany.pos[parentIndex].billingContactEmail track by $index" ng-init="contactIndex = $index"><img src=assets/img/icon/minus.png width=" 15" height="" ng-click="vm.removeBillingContact(parentIndex, contactIndex)" style="float: right;cursor:pointer;margin-top: 8px"> <input type=text class=form-control placeholder="" ng-model=vm.selectedCompany.pos[parentIndex].billingContactEmail[contactIndex] style="width: 90%;margin-bottom: 5px" ng-disabled=vm.disabled></div></div></div><div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 no-padding"></div></div></div></div></li></ul></div></div></div></div></div></div><div class=clearfix></div></div></div></div></div></form></div></div></div><div class=row style="margin-bottom: 15px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 row panel-row all-dashboards cloud-column hideCloudDash" ng-if="vm.dash[\'consumptionByPO\']"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cloud-backpanel show-dash"><div class=dashboard-panel style="border:none;background-color:transparent;box-shadow: none;height: 500px"><div class="dashboard-title cloudbill-title"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: left"></div><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-clip"><span class=bold-first-letter>R</span>ESERVED FUNDING CONSUMPTION</div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding cloud-select-contain" style="text-align: right"><select id=chart-cummulative-select class=bill-chart-select ng-model=vm.selectedReportFilter style="margin:0;float:right;padding:0;margin-top: -2px;margin-right: 5px;width:80px" ng-options="option for option in vm.reportFilter" ng-disabled="!vm.reportData || vm.reportData.length === 0" ng-change=vm.changeReportFilter(vm.selectedReportFilter)></select></div></div><div class=bill-no-data ng-show="vm.consumptionByPOTable.length === 0 && !vm.consumptionByPOLoading">NO DATA AVAILABLE FOR THIS REPORT</div><div class="panel-loader loading dashboard-loader" ng-show=vm.consumptionByPOLoading style="margin-top: 150px"><loading></loading></div><div class=high-panel ng-show="vm.consumptionByPOTable.length > 0"><div class=dash ng-class="{\'fade-dashboard\' : !vm.consumptionByPOLoading}"><highchart class=highcharts id=po-Chart config=vm.consumptionByPOConfig></highchart></div></div></div><div class="panel-body well cloudbill-datatable-contain"><div class=table-responsive ng-if="!vm.consumptionByPOLoading && vm.consumptionByPOTable.length > 0" style="margin-bottom: 15px"><table class="table table-striped" datatable=ng width=100% cellspacing=0 dt-instance=vm.consumptionByPODTInstance dt-options=vm.consumptionByPODTOptions id=consumptionByPO-table><thead><tr><th>{{vm.selectedCompany.purchaseOrderTerm || \'Purchase Order\'}}/Grant</th><th style=text-align:right>Consumption</th><th style=text-align:right>Reserved Amount</th><th style=text-align:right>Remaining Amount</th><th style=text-align:right>Percentage Consumed</th></tr></thead><tfoot class=table-filters ng-show=vm.showFilterscurrentBudgetStatus><tr><th bw-column-filter dt-instance=vm.consumptionByPODTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByPODTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByPODTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByPODTInstance filter-type=text></th><th bw-column-filter dt-instance=vm.consumptionByPODTInstance filter-type=text></th></tr></tfoot><tbody><tr ng-repeat="item in vm.consumptionByPOTable"><td>{{item.po}}</td><td class=dt-body-right>${{item.currentAllowanceConsumption.toFixed(2)}}</td><td class=dt-body-right>${{item.currentAllowanceAmount.toFixed(2)}}</td><td class=dt-body-right>${{item.currentAllowanceRemaining.toFixed(2)}}</td><td class=dt-body-right>{{item.currentPercentage}}%</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/components/navbar/clientpicker.html','<div class=attachment-list-form><div class=modal-header style=text-align:center><h4>Client Accounts</h4></div><div class=modal-body id=modal-body><div class=dualmultiselect><div class=row><div class="col-lg-12 col-md-12 col-sm-12"><input class=form-control placeholder="Search Companies" ng-model=vm.searchTerm.company></div></div><div class=row><div class="col-lg-12 col-md-12 col-sm-12"><div class=pool style=height:450px><ul><li ng-repeat="item in vm.options.items | filter: vm.searchTerm"><a href="" ng-click=vm.select(item)>{{item.company}}</a></li></ul></div></div></div></div></div><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-4"><input type=button class="btn btn-success btn-block" value=Ok name=cancel ng-click=vm.close()></div></div></div></div>');
$templateCache.put('app/components/navbar/impersonation.html','<div class=attachment-list-form><div class=modal-header style=text-align:center><h4>Service Accounts</h4></div><div class=modal-body id=modal-body><div class=dualmultiselect><div class=row><div class="col-lg-12 col-md-12 col-sm-12"><input class=form-control placeholder="Search Companies" ng-model=vm.searchTerm></div></div><div class=row><div class="col-lg-12 col-md-12 col-sm-12"><div class=pool style=height:450px><ul><li ng-repeat="item in vm.options.items | filter: vm.searchTerm"><a href="" ng-click=vm.select(item.company)>{{item.company}}</a></li></ul></div></div></div></div></div><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-4"><input type=button class="btn btn-success btn-block" value=Ok name=cancel ng-click=vm.close()></div></div></div></div>');
$templateCache.put('app/components/navbar/navbar.html','<div class=upgrade-banner ng-if="vm.cloudBillingOnly && !vm.automationEnabled"><div class=upgrade-banner-content>The Burwood Cloud Billing Portal has been upgraded! Your organization has been migrated to Version 2 of the Burwood Cloud Billing Portal. Please update your bookmark to access the new version of the portal at <a href=https://cloudbilling.burwood.com target=_blank rel="noopener noreferrer">https://cloudbilling.burwood.com</a>. If your organization is not configured for SSO, you\'ll need to use the "Recover Password" link for your first login.</div></div><nav class="navbar navbar-inverse" id=override-nav><div class=navbar-header><button type=button class="navbar-toggle collapsed" ng-init="vm.isNavCollapsed=true;" ng-click="vm.isNavCollapsed = !vm.isNavCollapsed"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand href=#><img src=./assets/img/icon/burwood_icon2.png id=mini-logo width=30 style="margin-right: 8px;float: left;margin-top: 8px"> <span style="display: inline-block;font-size: 12px;margin-right: 10px;color: #b5b5b5;letter-spacing: 1px">Practical Innovation.<br>Accelerated Results.</span></a></div><div id=navbar class="navbar-collapse collapse" uib-collapse=vm.isNavCollapsed><ul class="nav navbar-nav" ng-if=vm.cloudBillingOnly><li ng-if=!vm.cloudbillingAdmin><a ng-click="vm.isNavCollapsed = true" ui-sref=index.cloudbilling_dashboard id=clou-dash>Dashboards</a></li><li ng-if=vm.cloudbillingAdmin class=dropdown uib-dropdown><a aria-haspopup=true uib-dropdown-toggle id=clou-dash>Dashboards <span class=caret></span></a><ul class=dropdown-menu aria-labelledby=dLabel uib-dropdown-menu><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.cloudbilling_dashboard_admin>Admin</a></li><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.cloudbilling_dashboard>Project</a></li><li ng-if=vm.cloudbillingAdminBurwood><a ng-click="vm.isNavCollapsed = true" ui-sref=index.cloudbilling_dashboard_burwood_admin>Burwood Admin</a></li></ul></li><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.cloudbilling_reports id=clou-repo>Reports</a></li><li class=dropdown uib-dropdown><a aria-haspopup=true uib-dropdown-toggle id=clou-acct>Administration <span class=caret></span></a><ul class=dropdown-menu aria-labelledby=dLabel uib-dropdown-menu><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.cloudbilling_projects>Projects</a></li><li ng-if="vm.cloudbillingAdmin || vm.groupAdmin"><a ng-click="vm.isNavCollapsed = true" ui-sref=index.cloudbilling_users>Users</a></li><li ng-if=vm.cloudbillingAdmin><a ng-click="vm.isNavCollapsed = true" ui-sref=index.cloudbilling_pos>Funding</a></li><li ng-if=vm.cloudbillingAdmin><a ng-click="vm.isNavCollapsed = true" ui-sref=index.cloudbilling_config>Company</a></li><li ng-if=vm.cloudbillingAdminBurwood><a ng-click="vm.isNavCollapsed = true" ui-sref=index.cloudbilling_burwood_admin>Burwood Admin</a></li><li ng-if=vm.contactListsComp><a ng-click="vm.isNavCollapsed = true" ui-sref=index.contact_lists>Contact Lists</a></li><li ng-if=vm.csvReport><a ng-click="vm.isNavCollapsed = true" ui-sref=index.csv_report>CSV Report</a></li></ul></li><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.cloud_request id=clou-only-route>Cloud Requests</a></li><li><a ng-click="vm.isNavCollapsed = true" id=clou-only-route-new ui-sref=index.cloud_request_new>New Request</a></li><li class=dropdown uib-dropdown><a aria-haspopup=true uib-dropdown-toggle id=help-route>Resources<span class=caret></span></a><ul class=dropdown-menu aria-labelledby=dLabel uib-dropdown-menu><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.release_notes id=rele-route>Release Notes </a></li><li ng-if="vm.cloudbillingAdmin || vm.departmentAdmin || vm.groupAdmin"><a ng-click="vm.isNavCollapsed = true" ui-sref=index.cloud_guide id=clad-route>Cloud Admin Guide </a></li><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.cloud_user_guide id=clus-route>Cloud User Guide </a></li><li><a ng-click="vm.isNavCollapsed = true" id=gcp_quote ui-sref=index.gcpQuote>Get a Quote</a></li></ul></li><li class=banner-note ng-if="vm.cloudbillingAdmin && vm.missingPermission"><div><img ng-src=assets/img/icon/network_1.png width=15 height="" style="height:auto;margin-right: 10px">There are missing GCP permissions that may affect budget<br>automation. Please visit Reports for more information.</div></li></ul><ul class="nav navbar-nav" ng-if=!vm.cloudBillingOnly><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.index ui-sref-active=active class="home underline" id=home-route>Home</a></li><li class=dropdown uib-dropdown><a aria-haspopup=true uib-dropdown-toggle id=tick-route>Tickets <span class=caret></span></a><ul class=dropdown-menu aria-labelledby=dLabel uib-dropdown-menu><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.requests>Request</a></li><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.incidents>Incident</a></li><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.uchange_request>Change</a></li><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.problems>Problem</a></li><!-- <li><a ng-click="vm.isNavCollapsed = true" ui-sref="index.bohs">BoH</a></li> --></ul></li><li ng-if=!vm.basicUser><a ng-click="vm.isNavCollapsed = true" ui-sref=index.report id=repo-route>Reports</a></li><li ng-if=!vm.basicUser><a ng-click="vm.isNavCollapsed = true" ui-sref=index.devices id=devi-route>Devices</a></li><!-- <li class="dropdown" uib-dropdown>\n                <a aria-haspopup="true" uib-dropdown-toggle id="tick-route">Devices <span class="caret"></span></a>\n                <ul class="dropdown-menu" aria-labelledby="dLabel" uib-dropdown-menu>\n                    <li><a ng-click="vm.isNavCollapsed = true" ui-sref="index.devices">Metrics</a></li>\n                    <li><a ng-click="vm.isNavCollapsed = true" ui-sref="index.sl_dashboard">Dashboard</a></li>\n                </ul>\n            </li> --><!-- <li ng-if="!vm.basicUser"><a ng-click="vm.isNavCollapsed = true" ui-sref="index.devices"\n                    id="devi-route">Devices</a></li> --><li class=dropdown uib-dropdown><a aria-haspopup=true uib-dropdown-toggle id=even-route>Events<span class=caret></span></a><ul class=dropdown-menu aria-labelledby=dLabel uib-dropdown-menu><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.allevent>Active Events</a></li><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.clearevent>Cleared Events</a></li></ul></li><li ng-if="!vm.basicUser && vm.bcsUser"><a ng-click="vm.isNavCollapsed = true" ui-sref=index.company id=comp-route>Company</a></li><li class=dropdown uib-dropdown ng-show=vm.readContract ng-if=!vm.basicUser><a aria-haspopup=true uib-dropdown-toggle id=contr-route>Contract <span class=caret></span></a><ul class=dropdown-menu aria-labelledby=dLabel uib-dropdown-menu><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.contracts>Contracts</a></li></ul></li><li ng-if=!vm.basicUser><a ng-click="vm.isNavCollapsed = true" ui-sref=index.calendar id=cale-route>Calendar</a></li><li class=dropdown uib-dropdown><a aria-haspopup=true uib-dropdown-toggle id=help-route>Resources<span class=caret></span></a><ul class=dropdown-menu aria-labelledby=dLabel uib-dropdown-menu><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.contactus>Contact Us</a></li><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.docs id=docs-route>BCS Operations Guide</a></li></ul></li><li id=create-menu-tab class=dropdown uib-dropdown style=margin-left:10px><a aria-haspopup=true class=nav-button uib-dropdown-toggle id=open-route>Create New<span class=caret></span></a><ul class=dropdown-menu aria-labelledby=dLabel uib-dropdown-menu><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.status_new>Incident</a></li><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.uchange_new>Change</a></li><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.request_new>Request</a></li><!-- <li><a ng-click="vm.isNavCollapsed = true" ui-sref="index.boh_new">BoH</a></li> --><li ng-if=vm.domsUser><a ng-click="vm.isNavCollapsed = true" ui-sref=index.doms_new_user>User Onboarding</a></li><li ng-if=vm.bcsUser><a ng-click="vm.isNavCollapsed = true" ui-sref=index.request_new_internal>Internal Request</a></li></ul></li><li><a ng-click="vm.isNavCollapsed = true" ui-sref=index.status_p1phone class=nav-button ng-if=vm.p1VoiceUser style="margin-left :10px">Create P1 Voice Issue</a></li></ul><ul class="nav navbar-nav navbar-right hidden-sm"><li class=dropdown uib-dropdown style="height: 50px"><a class=user-profile aria-haspopup=true uib-dropdown-toggle>{{vm.user_name}} Logged in <span class=caret></span><br><p style="text-align: center;margin: 0">{{vm.company}}</p></a><ul class=dropdown-menu aria-labelledby=dLabel><li><a ng-click=vm.preferences() ng-if="!vm.cloudBillingOnly && !vm.cloudRequest">Notifications</a></li><li><a ng-click=vm.resetForm()>Change Password</a></li><li ng-if="vm.userAdmin && !vm.cloudBillingOnly && vm.basePath != \'https://api.bcs.burwood.com\'"><a ui-sref=index.user_admin>User Admin</a></li><li><a ng-if="vm.canImpersonate && !vm.cloudBillingOnly" ng-click=vm.selectClient()>Client Filter</a></li><li><a ng-if="vm.canImpersonate && vm.cloudBillingOnly" ng-click=vm.selectCloudClient()>Client Filter</a></li><li ng-if=vm.cloudbillingAdminBurwood><a ng-if=!vm.cloudAdminToggle style="padding: 3px 20px" ng-click=vm.toggleAdminCloud()>Cloud View</a> <a ng-if=vm.cloudAdminToggle style="padding: 3px 20px" ng-click=vm.toggleAdminCloud()>Standard View</a></li><li><a ng-if="vm.bcsDevOps || vm.cloudbillingAdminBurwood" ui-sref=index.sso_config>SSO Config</a></li><li><a ui-sref=logout>Logout</a></li></ul></li><li ng-if=vm.logo style="float: right;pointer-events: none"><img ng-src={{vm.logo}} style="height:51px;background-color: white"></li></ul><div class=search-contain ng-show="!vm.cloudBillingOnly && !vm.cloudRequest"><img src=./assets/img/icon/searchicon.png class=search-icon id=global_search height=30 width=30 ng-click=vm.searchScreen()></div></div><div class=full-search ng-show="vm.showSearch === true" ng-class="{\'fade-search\' : vm.showSearch}"><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div><div class="col-lg-10 col-md-10 col-sm-10 col-xs-10"><div id=exit-search ng-click="vm.showSearch = false">X</div><img src=./assets/img/icon/searchicon.png class=search-icon id=search-icon-input height=30 width=30 ng-click=vm.search(vm.keyword) style="z-index: 10000000"> <input type=text class=form-control enter=vm.search(vm.keyword) ng-model=vm.keyword id=searchbox><div id=search-binder></div></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div></div></nav>');
$templateCache.put('app/components/navbar/passwordReset.html','<div class="row reset-form"><form ng-submit=vm.updatePass(vm.pass) name=updateForm><div class=modal-header><h4 style=float:left>Change Password</h4><p style=float:right;margin-top:10px;color:white>Must be at least 8 characters</p></div><div class=modal-body id=modal-body><div uib-alert ng-repeat="alert in vm.alerts" class=alert-{{alert.type}} close=closeAlert($index)>{{alert.msg}}</div><div class=form-group><div class="col-xs-4 col-md-offset-2"><label for=old_pass>Old Password</label></div><div class=col-xs-4><input type=password class=form-control name=old_pass ng-model=vm.pass.old_password ng-disabled=vm.loading required></div><div class=clearfix></div></div><div class=form-group><div class="col-xs-4 col-md-offset-2"><label for=old_pass>New Password</label></div><div class=col-xs-4><input type=password class=form-control name=new_pass ng-model=vm.pass.new_pass ng-disabled=vm.loading required></div><div class=clearfix></div></div><div class=form-group><div class="col-xs-4 col-md-offset-2"><label for=old_pass>Confirm Password</label></div><div class=col-xs-4><input type=password class=form-control name=new_pass_confirm ng-model=vm.pass.new_pass_confirm ng-disabled=vm.loading required></div><div class=clearfix></div></div></div><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-4"><input type=submit class="btn btn-success btn-block" value=Update name=submit ng-disabled="updateForm.$invalid || vm.pass.new_pass != vm.pass.new_pass_confirm || vm.loading"> <input type=button class="btn btn-success btn-block" ng-click=vm.close() value=Cancel name=submit ng-disabled=vm.loading> <span ng-show=vm.loading><div class="css-loading css-loading--double"></div></span></div></div></div></form></div>');
$templateCache.put('app/components/navbar/preferences.html','<div class=attachment-list-form><div class=modal-header style=text-align:center><h4>Notifications</h4></div><div class=modal-body id=modal-body style=padding:35px><div id=exTab3 class=container style="width:100%; padding:0"><ul class="nav nav-pills"><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'setting\']"><a ng-click="vm.tabView = \'setting\'" data-toggle=tab>Notification Settings</a></li><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'channels\']"><a ng-click="vm.tabView = \'channels\'" data-toggle=tab>Channel Settings</a></li><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'create\']"><a ng-click="vm.tabView = \'create\'" data-toggle=tab>Create Notification Channel</a></li><li ng-class="{true: \'active\', false: \'\'}[vm.tabView == \'schedule\']"><a ng-click="vm.tabView = \'schedule\'" data-toggle=tab>Custom Schedule</a></li></ul><div class="tab-content clearfix" ng-class="{true: \'tab-body\', false: \'\'}[vm.tabView != \'setting\']"><div class=active id=1b ng-show="vm.tabView === \'setting\'"><div class="panel panel-default left-report-panel tick-rep" style="border-top-left-radius: 0px !important; background-color:transparent !important"><uib-accordion close-others=true id=device-accordion><div uib-accordion-group class=panel-default heading=Approval is-open=true><div class="loader notice-loader" ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class="table-responsive overflow-hide" ng-if="vm.loading == false"><table class="table table-striped notice-table" datatable=ng width=100% cellspacing=0 dt-options=vm.dtOptions id=approval-table><thead><tr><th style=width:100px>Type</th><th style=width:87px class=toggle-center>Method</th><th style=width:44px class=toggle-center>Filter</th><th style=width:87px class=toggle-center>Schedule</th></tr></thead><tbody><tr ng-repeat="(key, item) in vm.categories.approval" ng-if=vm.matchDomain(item.sys_domain)><td>{{key}}</td><td><div ng-if="vm.devices.email.exists == true"><div class=toggle-title>Email</div><toggle class=pull-right ng-disabled="vm.devices.email.active == false" ng-model=item.email.active ng-change="vm.changeToggle(item.email.active, \'approval\', key, \'email\')"></toggle></div><div ng-if="vm.devices.sms.exists == true"><div class=toggle-title>SMS</div><toggle class=pull-right ng-disabled="vm.devices.sms.active == false" ng-model=item.sms.active ng-change="vm.changeToggle(item.sms.active, \'approval\', key, \'sms\')"></toggle></div><div ng-if="vm.devices.push.exists == true"><div class=toggle-title>Push</div><toggle class=pull-right ng-disabled="vm.devices.push.active == false" ng-model=item.push.active ng-change="vm.changeToggle(item.push.active, \'approval\', key, \'push\')"></toggle></div><div ng-if="vm.devices.voice.exists == true"><div class=toggle-title>Voice</div><toggle class=pull-right ng-disabled="vm.devices.voice.active == false" ng-model=item.voice.active ng-change="vm.changeToggle(item.voice.active, \'approval\', key, \'voice\')"></toggle></div></td><td><div ng-if="vm.devices.email.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.email.active == false" ng-model=item.email.notification_filter ng-change="vm.changeFilter(item.email.notification_filter, \'approval\', key, \'email\')" ng-options="option.id as option.name for option in vm.filters" required></select></div><div ng-if="vm.devices.sms.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.sms.active == false" ng-model=item.sms.notification_filter ng-change="vm.changeFilter(item.sms.notification_filter, \'approval\', key, \'sms\')" ng-options="option.id as option.name for option in vm.filters" required></select></div><div ng-if="vm.devices.push.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.push.active == false" ng-model=item.push.notification_filter ng-change="vm.changeFilter(item.push.notification_filter, \'approval\', key, \'push\')" ng-options="option.id as option.name for option in vm.filters" required></select></div><div ng-if="vm.devices.voice.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.voice.active == false" ng-model=item.voice.notification_filter ng-change="vm.changeFilter(item.voice.notification_filter, \'approval\', key, \'voice\')" ng-options="option.id as option.name for option in vm.filters" required></select></div></td><td><div ng-if="vm.devices.email.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.email.active == false" ng-model=item.email.schedule ng-change="vm.changeFilter(item.email.schedule, \'approval\', key, \'email\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div><div ng-if="vm.devices.sms.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.sms.active == false" ng-model=item.sms.schedule ng-change="vm.changeFilter(item.sms.schedule, \'approval\', key, \'sms\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div><div ng-if="vm.devices.push.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.push.active == false" ng-model=item.push.schedule ng-change="vm.changeFilter(item.push.schedule, \'approval\', key, \'push\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div><div ng-if="vm.devices.voice.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.voice.active == false" ng-model=item.voice.schedule ng-change="vm.changeFilter(item.voice.schedule, \'approval\', key, \'voice\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div></td></tr></tbody></table></div></div><div uib-accordion-group class=panel-default heading=Incident><div class="table-responsive overflow-hide" ng-if="vm.loading == false"><table class="table table-striped notice-table" datatable=ng width=100% cellspacing=0 dt-options=vm.dtOptions id=incident-table><thead><tr><th style=width:100px>Type</th><th style=width:87px class=toggle-center>Method</th><th style=width:44px class=toggle-center>Filter</th><th style=width:87px class=toggle-center>Schedule</th></tr></thead><tbody><tr ng-repeat="(key, item) in vm.categories.incident" ng-if=vm.matchDomain(item.sys_domain)><td>{{key}}</td><td><div ng-if="vm.devices.email.exists == true"><div class=toggle-title>Email</div><toggle class=pull-right ng-disabled="vm.devices.email.active == false" ng-model=item.email.active ng-change="vm.changeToggle(item.email.active, \'incident\', key, \'email\')"></toggle></div><div ng-if="vm.devices.sms.exists == true"><div class=toggle-title>SMS</div><toggle class=pull-right ng-disabled="vm.devices.sms.active == false" ng-model=item.sms.active ng-change="vm.changeToggle(item.sms.active, \'incident\', key, \'sms\')"></toggle></div><div ng-if="vm.devices.push.exists == true"><div class=toggle-title>Push</div><toggle class=pull-right ng-disabled="vm.devices.push.active == false" ng-model=item.push.active ng-change="vm.changeToggle(item.push.active, \'incident\', key, \'push\')"></toggle></div><div ng-if="vm.devices.voice.exists == true"><div class=toggle-title>Voice</div><toggle class=pull-right ng-disabled="vm.devices.voice.active == false" ng-model=item.voice.active ng-change="vm.changeToggle(item.voice.active, \'incident\', key, \'voice\')"></toggle></div></td><td><div ng-if="vm.devices.email.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.email.active == false" ng-model=item.email.notification_filter ng-change="vm.changeFilter(item.email.notification_filter, \'incident\', key, \'email\')" ng-options="option.id as option.name for option in vm.filters" required></select></div><div ng-if="vm.devices.sms.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.sms.active == false" ng-model=item.sms.notification_filter ng-change="vm.changeFilter(item.sms.notification_filter, \'incident\', key, \'sms\')" ng-options="option.id as option.name for option in vm.filters" required></select></div><div ng-if="vm.devices.push.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.push.active == false" ng-model=item.push.notification_filter ng-change="vm.changeFilter(item.push.notification_filter, \'incident\', key, \'push\')" ng-options="option.id as option.name for option in vm.filters" required></select></div><div ng-if="vm.devices.voice.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.voice.active == false" ng-model=item.voice.notification_filter ng-change="vm.changeFilter(item.voice.notification_filter, \'incident\', key, \'voice\')" ng-options="option.id as option.name for option in vm.filters" required></select></div></td><td><div ng-if="vm.devices.email.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.email.active == false" ng-model=item.email.schedule ng-change="vm.changeFilter(item.email.schedule, \'incident\', key, \'email\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div><div ng-if="vm.devices.sms.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.sms.active == false" ng-model=item.sms.schedule ng-change="vm.changeFilter(item.sms.schedule, \'incident\', key, \'sms\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div><div ng-if="vm.devices.push.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.push.active == false" ng-model=item.push.schedule ng-change="vm.changeFilter(item.push.schedule, \'incident\', key, \'push\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div><div ng-if="vm.devices.voice.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.voice.active == false" ng-model=item.voice.schedule ng-change="vm.changeFilter(item.voice.schedule, \'incident\', key, \'voice\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div></td></tr></tbody></table></div></div><div uib-accordion-group class=panel-default heading=Password><div class="table-responsive overflow-hide" ng-if="vm.loading == false"><table class="table table-striped notice-table" datatable=ng width=100% cellspacing=0 dt-options=vm.dtOptions id=password-table><thead><tr><th style=width:100px>Type</th><th style=width:87px class=toggle-center>Method</th><th style=width:44px class=toggle-center>Filter</th><th style=width:87px class=toggle-center>Schedule</th></tr></thead><tbody><tr ng-repeat="(key, item) in vm.categories.password" ng-if=vm.matchDomain(item.sys_domain)><td>{{key}}</td><td><div ng-if="vm.devices.email.exists == true"><div class=toggle-title>Email</div><toggle class=pull-right ng-disabled="vm.devices.email.active == false" ng-model=item.email.active ng-change="vm.changeToggle(item.email.active, \'password\', key, \'email\')"></toggle></div><div ng-if="vm.devices.sms.exists == true"><div class=toggle-title>SMS</div><toggle class=pull-right ng-disabled="vm.devices.sms.active == false" ng-model=item.sms.active ng-change="vm.changeToggle(item.sms.active, \'password\', key, \'sms\')"></toggle></div><div ng-if="vm.devices.push.exists == true"><div class=toggle-title>Push</div><toggle class=pull-right ng-disabled="vm.devices.push.active == false" ng-model=item.push.active ng-change="vm.changeToggle(item.push.active, \'password\', key, \'push\')"></toggle></div><div ng-if="vm.devices.voice.exists == true"><div class=toggle-title>Voice</div><toggle class=pull-right ng-disabled="vm.devices.voice.active == false" ng-model=item.voice.active ng-change="vm.changeToggle(item.voice.active, \'password\', key, \'voice\')"></toggle></div></td><td><div ng-if="vm.devices.email.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.email.active == false" ng-model=item.email.notification_filter ng-change="vm.changeFilter(item.email.notification_filter, \'password\', key, \'email\')" ng-options="option.id as option.name for option in vm.filters" required></select></div><div ng-if="vm.devices.sms.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.sms.active == false" ng-model=item.sms.notification_filter ng-change="vm.changeFilter(item.sms.notification_filter, \'password\', key, \'sms\')" ng-options="option.id as option.name for option in vm.filters" required></select></div><div ng-if="vm.devices.push.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.push.active == false" ng-model=item.push.notification_filter ng-change="vm.changeFilter(item.push.notification_filter, \'password\', key, \'push\')" ng-options="option.id as option.name for option in vm.filters" required></select></div><div ng-if="vm.devices.voice.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.voice.active == false" ng-model=item.voice.notification_filter ng-change="vm.changeFilter(item.voice.notification_filter, \'password\', key, \'voice\')" ng-options="option.id as option.name for option in vm.filters" required></select></div></td><td><div ng-if="vm.devices.email.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.email.active == false" ng-model=item.email.schedule ng-change="vm.changeFilter(item.email.schedule, \'password\', key, \'email\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div><div ng-if="vm.devices.sms.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.sms.active == false" ng-model=item.sms.schedule ng-change="vm.changeFilter(item.sms.schedule, \'password\', key, \'sms\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div><div ng-if="vm.devices.push.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.push.active == false" ng-model=item.push.schedule ng-change="vm.changeFilter(item.push.schedule, \'password\', key, \'push\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div><div ng-if="vm.devices.voice.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.voice.active == false" ng-model=item.voice.schedule ng-change="vm.changeFilter(item.voice.schedule, \'password\', key, \'voice\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div></td></tr></tbody></table></div></div><div uib-accordion-group class=panel-default heading=SLA ng-if="vm.burUser == true"><div class="table-responsive overflow-hide" ng-if="vm.loading == false"><table class="table table-striped notice-table" datatable=ng width=100% cellspacing=0 dt-options=vm.dtOptions id=sla-table><thead><tr><th style=width:100px>Type</th><th style=width:87px class=toggle-center>Method</th><th style=width:44px class=toggle-center>Filter</th><th style=width:87px class=toggle-center>Schedule</th></tr></thead><tbody><tr ng-repeat="(key, item) in vm.categories.sla" ng-if=vm.matchDomain(item.sys_domain)><td>{{key}}</td><td><div ng-if="vm.devices.email.exists == true"><div class=toggle-title>Email</div><toggle class=pull-right ng-disabled="vm.devices.email.active == false" ng-model=item.email.active ng-change="vm.changeToggle(item.email.active, \'sla\', key, \'email\')"></toggle></div><div ng-if="vm.devices.sms.exists == true"><div class=toggle-title>SMS</div><toggle class=pull-right ng-disabled="vm.devices.sms.active == false" ng-model=item.sms.active ng-change="vm.changeToggle(item.sms.active, \'sla\', key, \'sms\')"></toggle></div><div ng-if="vm.devices.push.exists == true"><div class=toggle-title>Push</div><toggle class=pull-right ng-disabled="vm.devices.push.active == false" ng-model=item.push.active ng-change="vm.changeToggle(item.push.active, \'sla\', key, \'push\')"></toggle></div><div ng-if="vm.devices.voice.exists == true"><div class=toggle-title>Voice</div><toggle class=pull-right ng-disabled="vm.devices.voice.active == false" ng-model=item.voice.active ng-change="vm.changeToggle(item.voice.active, \'sla\', key, \'voice\')"></toggle></div></td><td><div ng-if="vm.devices.email.exists == true" class=center><select class="form-control category" ng-model=item.email.notification_filter ng-change="vm.changeFilter(item.email.notification_filter, \'sla\', key, \'email\')" ng-options="option.id as option.name for option in vm.filters" required></select></div><div ng-if="vm.devices.sms.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.email.active == false" ng-disabled="vm.devices.sms.active == false" ng-model=item.sms.notification_filter ng-change="vm.changeFilter(item.sms.notification_filter, \'sla\', key, \'sms\')" ng-options="option.id as option.name for option in vm.filters" required></select></div><div ng-if="vm.devices.push.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.push.active == false" ng-model=item.push.notification_filter ng-change="vm.changeFilter(item.push.notification_filter, \'sla\', key, \'push\')" ng-options="option.id as option.name for option in vm.filters" required></select></div><div ng-if="vm.devices.voice.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.voice.active == false" ng-model=item.voice.notification_filter ng-change="vm.changeFilter(item.voice.notification_filter, \'sla\', key, \'voice\')" ng-options="option.id as option.name for option in vm.filters" required></select></div></td><td><div ng-if="vm.devices.email.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.email.active == false" ng-model=item.email.schedule ng-change="vm.changeFilter(item.email.schedule, \'sla\', key, \'email\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div><div ng-if="vm.devices.sms.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.sms.active == false" ng-model=item.sms.schedule ng-change="vm.changeFilter(item.sms.schedule, \'sla\', key, \'sms\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div><div ng-if="vm.devices.push.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.push.active == false" ng-model=item.push.schedule ng-change="vm.changeFilter(item.push.schedule, \'sla\', key, \'push\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div><div ng-if="vm.devices.voice.exists == true" class=center><select class="form-control category" ng-disabled="vm.devices.voice.active == false" ng-model=item.voice.schedule ng-change="vm.changeFilter(item.voice.schedule, \'sla\', key, \'voice\')" ng-options="option.id as option.name for option in vm.scheduleFilter" required></select></div></td></tr></tbody></table></div></div></uib-accordion></div></div><div class=active id=2b ng-show="vm.tabView === \'channels\'"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-top:30px; margin-bottom: 20px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 channel-device"><div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 vert-center">All Channels</div><toggle class="col-lg-2 col-md-2 col-sm-2 col-xs-2" ng-model=vm.allNotifications ng-change=vm.toggleAll()></toggle><div class="col-lg-7 col-md-7 col-sm-7 col-xs-7"></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 channel-device" ng-if="vm.devices.email.exists == true"><div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 vert-center">{{vm.devices.email.name}}</div><toggle class="col-lg-2 col-md-2 col-sm-2 col-xs-2" ng-model=vm.devices.email.active></toggle><div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 vert-center">Delete Channel</div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-2"><input type=checkbox class=form-control ng-model=vm.deleteChannel.email placeholder=""></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 channel-device" ng-if="vm.devices.sms.exists == true"><div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 vert-center">{{vm.devices.sms.name}}</div><toggle class="col-lg-2 col-md-2 col-sm-2 col-xs-2" ng-model=vm.devices.sms.active></toggle><div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 vert-center">Delete Channel</div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-2"><input type=checkbox class=form-control ng-model=vm.deleteChannel.sms placeholder=""></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 channel-device" ng-if="vm.devices.push.exists == true"><div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 vert-center">{{vm.devices.push.name}}</div><toggle class="col-lg-2 col-md-2 col-sm-2 col-xs-2" ng-model=vm.devices.push.active></toggle><div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 vert-center">Delete Channel</div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-2"><input type=checkbox class=form-control ng-model=vm.deleteChannel.push placeholder=""></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 channel-device" ng-if="vm.devices.voice.exists == true"><div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 vert-center">{{vm.devices.voice.name}}</div><toggle class="col-lg-2 col-md-2 col-sm-2 col-xs-2" ng-model=vm.devices.voice.active></toggle><div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 vert-center">Delete Channel</div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-2"><input type=checkbox class=form-control ng-model=vm.deleteChannel.voice placeholder=""></div></div></div></div><div class=active id=3b ng-show="vm.tabView === \'create\'"><div class="panel panel-default left-report-panel" style="border-top-left-radius: 0px !important"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 20px"><form name=channel_new ng-submit="vm.createDeviceChannel(vm.schedule, channel_new.$valid)"><div class=form-group><div class=col-xs-12><label for=schedule-name>Channel Name*</label><input type=text class=form-control id=schedule-name ng-model=vm.schedule.name ng-required=true required></div><div class=clearfix></div></div><div class=form-group><div class=col-xs-12><label for=schedule-type>Type*</label><label style=display:block><select id=schedule-type class=form-control ng-model=vm.schedule.type ng-options="option for option in vm.scheduleTypes" required></select></label></div><div class=clearfix></div></div><div class=form-group ng-if="vm.schedule.type == \'SMS\' || vm.schedule.type == \'Voice\'"><div class=col-xs-12><label for=schedule-phone>Phone Number*</label><input type=text class=form-control id=schedule-phone ng-model=vm.schedule.phone_number ng-required=true required></div><div class=clearfix></div></div><div class=form-group ng-if="vm.schedule.type == \'Push\'"><div class=col-xs-12><label for=schedule-push>Push Application*</label><label style=display:block><select id=schedule-push class=form-control ng-model=vm.schedule.push_app ng-options="option for option in vm.push_apps" required></select></label></div><div class=clearfix></div></div><div class=form-group ng-if="vm.schedule.type == \'Email\'"><div class=col-xs-12><label for=schedule-email>Email*</label><input type=text class=form-control id=schedule-email ng-model=vm.schedule.email_address ng-required=true required></div><div class=clearfix></div></div><div class=form-group ng-if="vm.schedule.type == \'SMS\'"><div class=col-xs-12><label for=schedule-provider>Service Provider*</label><label style=display:block><select id=schedule-provider class=form-control ng-model=vm.schedule.service_provider ng-options="option for option in vm.service_providers" required></select></label></div><div class=clearfix></div></div><div class=form-group style=text-align:center><div class=col-xs-12><button class="btn btn-primary btn-block" type=submit ng-disabled="channel_new.$invalid || vm.loading">CREATE</button></div><div class=clearfix></div></div></form></div></div></div><div class=active id=4b ng-show="vm.tabView === \'schedule\'"><div class="panel panel-default left-report-panel" style="border-top-left-radius: 0px !important"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 20px"><form name=schedule_new ng-submit=vm.createSchedule(schedule_new.$valid)><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 20px"><span style=color:white>Schedule Name </span><input type=text class="form-control schedule-name" placeholder="" ng-model=vm.scheduleName placeholder="" required></div><div class="col-lg-3 col-md-3 col-sm-3 col-xs-3" style=margin-top:20px><span class=day-time-header style="margin-left: 33%">Day</span><div class=form-group style="margin-top: 10px"><label class=day-label><input type=checkbox class=day-check ng-model=vm.day.monday.active><span>Monday</span></label><br><label class=day-label><input type=checkbox class=day-check ng-model=vm.day.tuesday.active><span>Tuesday</span></label><br><label class=day-label><input type=checkbox class=day-check ng-model=vm.day.wednesday.active><span>Wednesday</span></label><br><label class=day-label><input type=checkbox class=day-check ng-model=vm.day.thursday.active><span>Thursday</span></label><br><label class=day-label><input type=checkbox class=day-check ng-model=vm.day.friday.active><span>Friday</span></label><br><label class=day-label><input type=checkbox class=day-check ng-model=vm.day.saturday.active><span>Saturday</span></label><br><label class=day-label><input type=checkbox class=day-check ng-model=vm.day.sunday.active><span>Sunday</span></label><br></div></div><div class="col-lg-9 col-md-9 col-sm-9 col-xs-9"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style=text-align:center><span class=day-time-header style=font-weight:300>Valid Hours (6 - 24)</span></div><span class=day-time-header style="margin-left: 8px">Begin Hour 1</span> <span class=day-time-header>End Hour 1</span> <span class=day-time-header>Begin Hour 2</span> <span class=day-time-header>End Hour 2</span><div class=col-xs-12 style="margin-top: 10px"><input type=text class="form-control day-input" name=hour0 placeholder="" ng-model=vm.day.monday.begin1 placeholder="" ng-disabled="vm.day.monday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour1 placeholder="" ng-model=vm.day.monday.end1 placeholder="" ng-disabled="vm.day.monday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour2 placeholder="" ng-model=vm.day.monday.begin2 placeholder="" ng-disabled="vm.day.monday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour3 placeholder="" ng-model=vm.day.monday.end2 placeholder="" ng-disabled="vm.day.monday.active == false" ng-pattern=vm.pattern></div><div class=col-xs-12><input type=text class="form-control day-input" name=hour4 placeholder="" ng-model=vm.day.tuesday.begin1 placeholder="" ng-disabled="vm.day.tuesday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour5 placeholder="" ng-model=vm.day.tuesday.end1 placeholder="" ng-disabled="vm.day.tuesday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour6 placeholder="" ng-model=vm.day.tuesday.begin2 placeholder="" ng-disabled="vm.day.tuesday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour7 placeholder="" ng-model=vm.day.tuesday.end2 placeholder="" ng-disabled="vm.day.tuesday.active == false" ng-pattern=vm.pattern></div><div class=col-xs-12><input type=text class="form-control day-input" name=hour8 placeholder="" ng-model=vm.day.wednesday.begin1 placeholder="" ng-disabled="vm.day.wednesday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour9 placeholder="" ng-model=vm.day.wednesday.end1 placeholder="" ng-disabled="vm.day.wednesday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour10 placeholder="" ng-model=vm.day.wednesday.begin2 placeholder="" ng-disabled="vm.day.wednesday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour11 placeholder="" ng-model=vm.day.wednesday.end2 placeholder="" ng-disabled="vm.day.wednesday.active == false" ng-pattern=vm.pattern></div><div class=col-xs-12><input type=text class="form-control day-input" name=hour12 placeholder="" ng-model=vm.day.thursday.begin1 placeholder="" ng-disabled="vm.day.thursday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour13 placeholder="" ng-model=vm.day.thursday.end1 placeholder="" ng-disabled="vm.day.thursday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour14 placeholder="" ng-model=vm.day.thursday.begin2 placeholder="" ng-disabled="vm.day.thursday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour15 placeholder="" ng-model=vm.day.thursday.end2 placeholder="" ng-disabled="vm.day.thursday.active == false" ng-pattern=vm.pattern></div><div class=col-xs-12><input type=text class="form-control day-input" name=hour16 placeholder="" ng-model=vm.day.friday.begin1 placeholder="" ng-disabled="vm.day.friday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour17 placeholder="" ng-model=vm.day.friday.end1 placeholder="" ng-disabled="vm.day.friday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour18 placeholder="" ng-model=vm.day.friday.begin2 placeholder="" ng-disabled="vm.day.friday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour19 placeholder="" ng-model=vm.day.friday.end2 placeholder="" ng-disabled="vm.day.friday.active == false" ng-pattern=vm.pattern></div><div class=col-xs-12><input type=text class="form-control day-input" name=hour20 placeholder="" ng-model=vm.day.saturday.begin1 placeholder="" ng-disabled="vm.day.saturday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour21 placeholder="" ng-model=vm.day.saturday.end1 placeholder="" ng-disabled="vm.day.saturday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour22 placeholder="" ng-model=vm.day.saturday.begin2 placeholder="" ng-disabled="vm.day.saturday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour23 placeholder="" ng-model=vm.day.saturday.end2 placeholder="" ng-disabled="vm.day.saturday.active == false" ng-pattern=vm.pattern></div><div class=col-xs-12><input type=text class="form-control day-input" name=hour24 placeholder="" ng-model=vm.day.sunday.begin1 placeholder="" ng-disabled="vm.day.sunday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour25 placeholder="" ng-model=vm.day.sunday.end1 placeholder="" ng-disabled="vm.day.sunday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour26 placeholder="" ng-model=vm.day.sunday.begin2 placeholder="" ng-disabled="vm.day.sunday.active == false" ng-pattern=vm.pattern> <input type=text class="form-control day-input" name=hour27 placeholder="" ng-model=vm.day.sunday.end2 placeholder="" ng-disabled="vm.day.sunday.active == false" ng-pattern=vm.pattern></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: center;margin-bottom: 10px"><span ng-repeat="item in vm.errorArray track by $index" class=invalid-hour ng-show="schedule_new[\'hour\' + {{$index}}].$error.pattern">Not a valid hour!</span></div><div class=form-group style=text-align:center><div class=col-xs-12><button class="btn btn-primary btn-block" type=submit ng-disabled="schedule_new.$invalid || vm.loading">CREATE</button></div><div class=clearfix></div></div></form></div></div></div></div></div></div><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-4"><input type=button class="btn btn-success btn-block" value=Ok name=cancel ng-click=vm.close()></div></div></div></div>');
$templateCache.put('app/shared/html/_activity.html','<div class=col-xs-12><label>Activity <button type=button class="btn btn-default activity-btn" ng-click=vm.show_related()><i ng-class="{\'fa fa-caret-right\':!vm.related_show, \'fa fa-caret-down\':vm.related_show}"></i></button></label></div><div class=col-xs-12><div class=related_loader ng-show=vm.related_loading><div class="css-loading css-loading--double"></div></div><div class=related_search_result ng-if="vm.related_show && !vm.related_loading"><div class=table-responsive><table class="table table-striped table-bordered hover" datatable=ng dt-column-defs=vm.dtColumnDefsActivity dt-options=vm.dtActivityOptions style="width:100%; border:none" width=100% id=activityTable><thead><tr><th style="width: 20px" class=nosort><a class=table-filters-toggle ng-click="vm.showFilters = !vm.showFilters"><span class="fa fa-search"></span></a></th><th style="width: 100px">Person</th><th style=width:70px>Type</th><th>Value</th><th>Created</th><!-- <th>Updated</th> --></tr></thead><tfoot class=table-filters ng-show=vm.showFilters><tr><th></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=text></th><th bw-column-filter dt-instance=vm.dtInstance filter-type=select></th></tr></tfoot><tbody><tr ng-repeat="result in vm.related_result" class=activityRows><td></td><td>{{result.sys_created_by}}</td><td>{{result.element}}</td><td ng-if=!result.dataURL style="white-space: pre-wrap">{{result.value}}</td><td ng-if="result.dataURL && result.image" style="white-space: pre-wrap"><img style=width:100% ng-src={{result.dataURL}}></td><td ng-if="result.dataURL && !result.image" style="white-space: pre-wrap"><a style=width:100% ng-click=vm.downloadFromActivity(result.dataURL)>{{result.dataURL}}</a></td><td style="width: 20%">{{result.sortDate}}</td><!-- <td>{{result.update_time}}</td> --></tr></tbody></table></div></div></div>');
$templateCache.put('app/shared/html/attachment_form.html','<div class=attachment-list-form><div class=modal-header><h4>Attachment</h4></div><div class=modal-body id=modal-body><div class=table-responsive><table class="table row-border hover"><thead><tr><th>No</th><th>Name</th><th>Delete</th></tr></thead><tbody><tr ng-show="vm.loading || vm.uploading"><td colspan=4><div class=table-cell><div class="css-loading css-loading--double"></div></div></td></tr><tr ng-show="vm.error || vm.attachments.length == 0"><td colspan=4>No Results Found</td></tr><tr ng-repeat="attachment in vm.attachments track by $index" ng-if=!vm.newTicket><td>{{$index + 1}}</td><!-- <td><a ng-href="{{attachment.download_link}}" target="_blank">{{attachment.file_name}}</a></td> --><td><a ng-click=vm.downloadAttachment(attachment) target=_blank>{{attachment.file_name}}</a></td><td><button ng-click=vm.deleteAttachment(attachment) class="btn btn-danger"><i class="fa fa-trash" aria-hidden=true></i></button></td></tr><tr ng-repeat="attachment in vm.attachments track by $index" ng-if=vm.newTicket><td>{{$index + 1}}</td><td>>{{attachment.name}}</td><td><button ng-click=vm.deleteAttachment(attachment) class="btn btn-danger"><i class="fa fa-trash" aria-hidden=true></i></button></td></tr></tbody></table></div><div class=incident-attachment id=logo-upload><form name=attachmentForm class=form-inline><label for=file-upload class=custom-file-upload><i class="fa fa-cloud-upload"></i> Upload</label><input id=file-upload ng-model=vm.upload_file ngf-select=vm.addAttachment() type=" file" name=file></form></div></div><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-4"><input type=button class="btn btn-success btn-block" value=Ok name=cancel ng-click=vm.close()></div></div></div></div>');
$templateCache.put('app/shared/html/confirmation.html','<div class="row reset-form"><div class=modal-header><h4>{{vm.heading}}</h4></div><div class=modal-body id=modal-body style=color:white;font-weight:300>{{vm.message}}</div><div class=modal-footer><button class="btn btn-primary" type=button ng-click=vm.confirm()>{{vm.confirmMessage}}</button> <button class="btn btn-primary" type=button ng-click=vm.deny()>{{vm.denyMessage}}</button></div></div>');
$templateCache.put('app/shared/html/contact_list.html','<div class="row contact-list-form"><div class=modal-header><h4>Select Contact</h4></div><div class="modal-body well" id=modal-body><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.users.length == 0"><p>Sorry No Users found.</p></div><div class=table-responsive><table ng-if="vm.users.length > 0" class="contact table row-border hover" datatable=ng dt-options=vm.dtOptions width=100% cellspacing=0><!-- bs-table-control="vm.bsctrl" --><thead><tr><th>No</th><th>Email</th><th>Name</th></tr></thead><tbody><tr ng-repeat="user in vm.users track by $index"><td>{{$index + 1}}</td><td><a ng-click="vm.addtolist(user.name, user.sys_id, user.email)">{{user.email}}</a></td><td><a ng-click="vm.addtolist(user.name, user.sys_id, user.email)">{{user.name}}</a></td></tr></tbody></table></div></div><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-4"><input type=button class="btn btn-success btn-block" value=Cancel name=cancel ng-click=vm.close()></div></div></div></div>');
$templateCache.put('app/shared/html/device_list.html','<div class="row contact-list-form"><div class=modal-header><h4>Select Device</h4></div><div class="modal-body well" id=modal-body><div class=panel-loader ng-show=vm.loading><div class="css-loading css-loading--double"></div></div><div class=no-results ng-show="!vm.loading && vm.devices.length == 0"><p>Sorry No Devices found.</p></div><div class=table-responsive><table class="table row-border hover" datatable=ng dt-options=vm.dtOptions><!-- bs-table-control="vm.bsctrl" --><thead><tr><th>No</th><th>Device Name</th><th>Class</th></tr></thead><tbody><tr ng-repeat="device in vm.devices track by $index"><td>{{$index + 1}}</td><td><a ng-click="vm.addtolist(device.cmdb_name, device.cmdb_sys_id)">{{device.cmdb_name}}</a></td><td><a ng-click="vm.addtolist(device.cmdb_name, device.cmdb_sys_id)">{{device.cmdb_sys_class_name}}</a></td></tr></tbody></table></div></div><div class=modal-footer><div class=form-group><div class="col-xs-4 col-md-offset-4"><input type=button class="btn btn-success btn-block" value=Cancel name=cancel ng-click=vm.close()></div></div></div></div>');
$templateCache.put('app/shared/html/downloadfile.html','<a class="btn btn-primary" ng-click=vm.download()><i class="fa fa-download" aria-hidden=true data-toggle=tooltip title="Download Incident Report"></i></a>');
$templateCache.put('app/shared/html/downloading.html','<div class="row reset-form"><div class=modal-header><h4>{{vm.heading}}</h4></div><div class=modal-body id=modal-body style=color:white;font-weight:300>{{vm.message}}<div class=panel-loader ng-if=vm.loading><div class="css-loading css-loading--double" style="margin-top: -15px"></div></div></div><div class=modal-footer><button class="btn btn-primary" type=button ng-click=vm.close()>OK</button></div></div>');
$templateCache.put('app/shared/html/loading.html','<div class="loading-panel first"><div class=icon-wrapper><svg class=icon-wrapper-child version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink viewBox="0 0 33.271 22.313" enable-background="new 0 0 33.271 22.313" xml:space=preserve><path class=cloud d="M27.244,8.64c0.04-0.319,0.068-0.643,0.068-0.973C27.312,3.432,23.88,0,19.646,0\n        c-3.069,0-6.047,2.208-7.047,5.208c-1.625-0.922-3.341-1.195-4.595-0.104c-0.012,0.01-0.019,0.022-0.031,0.033\n        c-0.02,0.014-0.042,0.02-0.062,0.034c-1.236,0.875-1.686,2.49-1.336,4.123C6.543,9.292,6.51,9.292,6.51,9.292\n        c-3.596,0-6.51,2.914-6.51,6.51c0,3.596,2.914,6.511,6.51,6.511h19.896c3.791,0,6.864-3.073,6.864-6.864\n        C33.271,11.941,30.639,9.054,27.244,8.64z"/></svg><div class=icon><svg class=icon-child version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink viewBox="0 0 9.652 9.207" enable-background="new 0 0 9.652 9.207" xml:space=preserve><path fill=#D0E2AA d="M1.898,4.375c0.117-0.545,0.388-1.03,0.773-1.419l0.862,0.91c0.03,0.032,0.069,0.052,0.11,0.061\n        c0.033,0.007,0.067,0.006,0.1-0.002c0.075-0.02,0.132-0.08,0.146-0.154l0.666-3.526C4.567,0.18,4.548,0.113,4.502,0.066\n        C4.457,0.018,4.39-0.007,4.323,0.001L0.578,0.312C0.5,0.321,0.435,0.373,0.409,0.444c-0.027,0.071-0.01,0.151,0.044,0.208\n        l0.958,0.981c-0.658,0.638-1.116,1.449-1.31,2.358C-0.217,5.479,0.224,7.043,1.28,8.178c0.135,0.145,0.307,0.237,0.488,0.276\n        c0.279,0.06,0.582-0.008,0.808-0.208C2.949,7.917,2.519,7.641,2.32,7.269C1.87,6.422,1.7,5.302,1.898,4.375z"/><path fill=#D0E2AA d="M7.754,4.831C7.638,5.376,7.367,5.861,6.981,6.25L6.119,5.34C6.09,5.309,6.051,5.289,6.009,5.28\n        c-0.033-0.007-0.067-0.007-0.1,0.002c-0.075,0.02-0.132,0.08-0.146,0.154L5.097,8.961C5.084,9.027,5.104,9.092,5.15,9.14\n        c0.044,0.048,0.112,0.072,0.178,0.064l3.745-0.311c0.077-0.009,0.144-0.06,0.17-0.132c0.026-0.07,0.008-0.151-0.045-0.207\n        L8.24,7.573C8.898,6.936,9.356,6.125,9.55,5.215c0.318-1.487-0.123-3.053-1.178-4.188C8.237,0.884,8.065,0.791,7.884,0.752\n        C7.605,0.692,7.302,0.76,7.076,0.959c-0.373,0.33,0.059,0.605,0.257,0.979C7.783,2.784,7.953,3.904,7.754,4.831z"/></svg></div></div></div>');
$templateCache.put('app/shared/html/notice.html','<div class="row reset-form"><div class=modal-header><h4>{{vm.heading}}</h4></div><div class=modal-body id=modal-body style=color:white;font-weight:300>{{vm.message}}</div><div class=modal-footer><button class="btn btn-primary" type=button ng-click=vm.close()>Close</button></div></div>');
$templateCache.put('app/shared/html/ticketConfirmation.html','<div class="row reset-form"><div class=modal-header><h4>Ticket Confirmation</h4></div><div class=modal-body id=modal-body style=color:white;font-weight:300>Your ticket {{vm.number}} has been accepted.</div><div class=modal-footer><button class="btn btn-primary" type=button ng-click=vm.close()>OK</button></div></div>');}]);